import { SD } from "../../SD/js/SD";
const ko = require('knockout');
require('knockout.mapping');
const proj4 = require('proj4').default;
const sanitizeHtml = require('sanitize-html');
/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Bookmarks = {};
TrimbleMap.Bookmarks.Shared = {};
TrimbleMap.Bookmarks.Shared.MENU_ITEM_NAME = 'BOOKMARKS';
TrimbleMap.Bookmarks.Shared.BookmarkHandler = null;

// **************************************************************************
// ENUM: enumBookmarkSaveType
// **************************************************************************
var enumBookmarkSaveType = {
    AddOrEdit: 1,
    Delete: 2
};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Bookmarks.CreateInstance = function CreateInstance(objMapController, objMenuInstance, intMenuItemOrder, blnVisible) {

    // Create the object that will hold the instance properties
    var objBookmarks = {
        MapController: objMapController,
        MenuInstance: objMenuInstance,

        Visible: false,
        SubMenuDiv: null,
        BookmarksTable: null,
        BookmarksContentTable: null,
        NewBookmarkDiv: null,
        NewBookmarkTextBox: null,
        NewBookmarkButton: null,
        NewBookmarkButtonAndTextBoxDiv: null,
        BookmarksMenuItem: null,
        NiceScroll: null,

        ActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objBookmarks.ActivateSubMenu(objMenuItem, objSubMenuDiv) },
        DeActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objBookmarks.DeActivateSubMenu(objMenuItem, objSubMenuDiv) },

        BookmarkTableClickedProxy: function (e) { objBookmarks.BookmarkTableClicked(e); },
        NewBookmarkButtonClickedProxy: function (e) { objBookmarks.NewBookmarkButtonClicked(e); },
        NewBookmarkTextBoxKeypressProxy: function (e) { objBookmarks.NewBookmarkTextBoxKeypress(e); },
        BookmarksSaveSuccessProxy: function (data, textStatus, jqXHR) { objBookmarks.BookmarksSaveSuccess(data, textStatus, jqXHR); },
        BookmarksSaveErrorProxy: function (data, textStatus, jqXHR) { objBookmarks.BookmarksSaveError(data, textStatus, jqXHR); },
        SubMenuOpenedProxy: function (strSubMenuName) { objBookmarks.SubMenuOpened(strSubMenuName) },

        BookmarkTableClicked: TrimbleMap.Bookmarks.BookmarkTableClicked,
        NewBookmarkButtonClicked: TrimbleMap.Bookmarks.NewBookmarkButtonClicked,
        NewBookmarkTextBoxKeypress: TrimbleMap.Bookmarks.NewBookmarkTextBoxKeypress,

        BookmarksSaveSuccess: TrimbleMap.Bookmarks.BookmarksSaveSuccess,
        BookmarksSaveError: TrimbleMap.Bookmarks.BookmarksSaveError,

        ActivateSubMenu: TrimbleMap.Bookmarks.ActivateSubMenu,
        DeActivateSubMenu: TrimbleMap.Bookmarks.DeActivateSubMenu,

        AttachEventHandlers: TrimbleMap.Bookmarks.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Bookmarks.DetachEventHandlers,

        UsedForUserInitialExtentOfMap: TrimbleMap.Bookmarks.UsedForUserInitialExtentOfMap,
        SubMenuOpened: TrimbleMap.Bookmarks.SubMenuOpened,
        CreateBookmarks: TrimbleMap.Bookmarks.CreateBookmarks,
        CreateBookmarksTable: TrimbleMap.Bookmarks.CreateBookmarksTable,
        GoToBookMarkExtent: TrimbleMap.Bookmarks.GoToBookMarkExtent,
        DeleteBookmark: TrimbleMap.Bookmarks.DeleteBookmark,
        AddBookmark: TrimbleMap.Bookmarks.AddBookmark,
        CreateNewBookmark: TrimbleMap.Bookmarks.CreateNewBookmark,
        Show: TrimbleMap.Bookmarks.Show,
        Hide: TrimbleMap.Bookmarks.Hide
    };

    // Create the menu item ...
    objBookmarks.BookmarksMenuItem = TrimbleMap.Menu.Shared.CreateMenuItem(TrimbleMap.Bookmarks.Shared.MENU_ITEM_NAME, SD.Translation.Shared.GetTranslation('Map.Bookmarks.js', 'MenuItemName'), intMenuItemOrder, true, null, objBookmarks.ActivateSubMenuProxy, objBookmarks.DeActivateSubMenuProxy);

    // Add the on sub menu opened callback ...
    objMenuInstance.AddOnSubMenuOpenedCallback(objBookmarks.SubMenuOpenedProxy);

    // Show the menu button when its to be visible at startup ...
    if (blnVisible) { objBookmarks.Show(false); }

    return objBookmarks;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Bookmarks.Show = function Show(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objBookmarks = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objBookmarks.Visible) {

        // Add the menu item ...
        objBookmarks.MenuInstance.AddMenuItem(objBookmarks.BookmarksMenuItem);

        // Set to be visible ...
        objBookmarks.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objBookmarks.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Bookmarks, true); }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Bookmarks.Hide = function Hide(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objBookmarks = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objBookmarks.Visible) {

        // Remove the menu item ...
        objBookmarks.MenuInstance.RemoveMenuItem(objBookmarks.BookmarksMenuItem);

        // Set to not be visible ...
        objBookmarks.Visible = false;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objBookmarks.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Bookmarks, false); }
    }
}

// **************************************************************************
// FUNCTION: ActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.Bookmarks.ActivateSubMenu = function ActivateSubMenu(objMenuItem, objSubMenuDiv) {

    var objBookmarks = this;

    objBookmarks.SubMenuDiv = objSubMenuDiv;

    objBookmarks.CreateBookmarks();
}

// **************************************************************************
// FUNCTION: CreateMeasure
// USAGE:    
// **************************************************************************
TrimbleMap.Bookmarks.CreateBookmarks = function CreateBookmarks() {

    // Get the map bookmark instance
    var objBookmarks = this;

    objBookmarks.NewBookmarkDiv = $('<div class="bookmark-save"></div>');
    objBookmarks.SubMenuDiv.append(objBookmarks.NewBookmarkDiv);

    //get translation
    var strSaveCurrentView = SD.Translation.Shared.GetTranslation('Map.Bookmarks.js', 'SaveCurrentView');

    objBookmarks.NewBookmarkDiv.append($('<span>' + strSaveCurrentView + ':</span>'));

    objBookmarks.NewBookmarkButtonAndTextBoxDiv = $('<div></div>');
    objBookmarks.NewBookmarkDiv.append(objBookmarks.NewBookmarkButtonAndTextBoxDiv);

    objBookmarks.NewBookmarkTextBox = $('<input type="text">')
    objBookmarks.NewBookmarkButtonAndTextBoxDiv.append(objBookmarks.NewBookmarkTextBox);

    //get translation
    var strButtonTextOK = SD.Translation.Shared.GetTranslation('Map.Bookmarks.js', 'ButtonTextOK');

    objBookmarks.NewBookmarkButton = $('<button class="Button">' + strButtonTextOK + '</button>');
    objBookmarks.NewBookmarkButtonAndTextBoxDiv.append(objBookmarks.NewBookmarkButton);

    // Create the bookmarks table
    objBookmarks.CreateBookmarksTable();
}

// **************************************************************************
// FUNCTION: CreateBookmarksTable
// USAGE:    
// **************************************************************************
TrimbleMap.Bookmarks.CreateBookmarksTable = function CreateBookmarksTable() {

    // Get the map bookmark instance
    var objBookmarks = this;

    // Remove the bookmarks table when we have one ...
    if (objBookmarks.BookmarksTable) { objBookmarks.BookmarksTable.remove(); }

    // Create the bookmarks table
    objBookmarks.BookmarksTable = $('<div class="bookmarks"></div>');
    objBookmarks.SubMenuDiv.append(objBookmarks.BookmarksTable);

    // Create and add a div for the bookmarks content ...
    objBookmarks.BookmarksContentTable = $('<div></div>');
    objBookmarks.BookmarksTable.append(objBookmarks.BookmarksContentTable);

    for (var intBookmark = 0; intBookmark < objBookmarks.MapController.State.Bookmarks.length; intBookmark++) {

        var objBookmark = objBookmarks.MapController.State.Bookmarks[intBookmark];

        if ((objBookmark.UserID != SD.Guid.Shared.DefaultUserID) && (objBookmark.UserID == objBookmarks.MapController.State.LoggedInUserID)) {
            objBookmarks.BookmarksContentTable.append($('<div class="bookmark-row" bookmarkID="' + objBookmark.BookmarkID + '"><span>' + objBookmark.BookmarkName + '</span><div class="delete-icon"></div></div>'));
        }
    }
}

// **************************************************************************
// FUNCTION: DeActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.Bookmarks.DeActivateSubMenu = function DeActivateSubMenu(objMenuItem, objSubMenuDiv) {

    // Get the map bookmark instance ...
    var objBookmarks = this;

    // Detach the event handlers ...
    objBookmarks.DetachEventHandlers();
}

// **************************************************************************
// FUNCTION: SubMenuOpened
// USAGE:    
// **************************************************************************
TrimbleMap.Bookmarks.SubMenuOpened = function SubMenuOpened(strSubMenuName) {

    // Get the map bookmark instance ...
    var objBookmarks = this;

    // When the menu were opened ...
    if (strSubMenuName == TrimbleMap.Bookmarks.Shared.MENU_ITEM_NAME) {

        // Attach the event handlers ...
        objBookmarks.AttachEventHandlers();

        // Focus on the text box ...
        objBookmarks.NewBookmarkTextBox.focus();
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Bookmarks.AttachEventHandlers = function AttachEventHandlers() {

    // Get the bookmarks instance 
    var objBookmarks = this;

    // Attach a click event handler 
    objBookmarks.BookmarksTable.click(objBookmarks.BookmarkTableClickedProxy);
    objBookmarks.NewBookmarkButton.click(objBookmarks.NewBookmarkButtonClickedProxy);
    objBookmarks.NewBookmarkTextBox.keypress(objBookmarks.NewBookmarkTextBoxKeypressProxy);

    // Activate the nice scroll bar ...
    objBookmarks.NiceScroll = objBookmarks.BookmarksTable.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Bookmarks.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map Bookmarks instance 
    var objBookmarks = this;

    // Dettach a click event handler
    objBookmarks.BookmarksTable.off('click', objBookmarks.BookmarkTableClickedProxy);
    objBookmarks.NewBookmarkButton.off('click', objBookmarks.NewBookmarkButtonClickedProxy);
    objBookmarks.NewBookmarkTextBox.off('keypress', objBookmarks.NewBookmarkTextBoxKeypressProxy);

    // When we have a nice scrollbar ...
    if (objBookmarks.NiceScroll) {

        // De-activate the nice-scrollbar on the list ...
        objBookmarks.NiceScroll.hide();
        objBookmarks.NiceScroll.remove();
        objBookmarks.NiceScroll = null;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// NewBookmarkTextBoxKeypress: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.NewBookmarkTextBoxKeypress = function NewBookmarkTextBoxKeypress(e) {

    // Get the map Bookmarks instance 
    var objBookmarks = this;

    // When the enter key has been pressed ...
    if (e.which == 13) {

        // Create the bookmark ...
        objBookmarks.CreateNewBookmark();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// BookmarkTableClicked: Identifies whether the user has opted to go to a bookmark, or delete one
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.BookmarkTableClicked = function BookmarkTableClicked(e) {

    // Get the map Bookmarks instance
    var objBookmarks = this;

    // Get the target element
    var objTarget = $(e.target);

    // Get the bookmark table row in which the target is if any
    var objBookmarksRowClicked = objTarget.hasClass('bookmark-row') ? objTarget : objTarget.closest('.bookmark-row');

    // Get the bookmark id ...
    var strBookmarkID = objBookmarksRowClicked.attr('bookmarkID');

    // When we clicked on a row ...
    if (objBookmarksRowClicked.length > 0) {

        // When the delete icon ...
        if (objTarget.hasClass('delete-icon')) {
            // Delete the bookmark ...
            objBookmarks.DeleteBookmark(strBookmarkID);
        }
        else {
            // Go to the bookmark ...
            objBookmarks.GoToBookMarkExtent(strBookmarkID);
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// UsedForUserInitialExtentOfMap: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.UsedForUserInitialExtentOfMap = function UsedForUserInitialExtentOfMap(guidBookmark) {

    // Get the map Bookmarks instance 
    var objBookmarks = this;

    // Start with not being used ...
    var blnUsed = false;

    switch (objBookmarks.MapController.Preferences.InitialExtentType) {
        case TrimbleMap.Preferences.enumUserInitialExtentType.ApplyToAllMaps:

            // Set to return true when set as teh initial extent for all maps ...
            blnUsed = (objBookmarks.MapController.Preferences.InitialExtentIDForAllMaps.toLowerCase() == guidBookmark.toLowerCase());
            break;

        case TrimbleMap.Preferences.enumUserInitialExtentType.EachMapHaveOwnInitialExtent:

            // Loop through all the bookmarks used as initial extents ... 
            $.each(objBookmarks.MapController.Preferences.InitialExtentBookmarkIDByMapID, function (guidMap, guidInitialExtentID) {

                // When the id matches ...
                if (guidInitialExtentID.toLowerCase() == guidBookmark.toLowerCase()) {

                    // Set to be used ...
                    blnUsed = true;

                    // Stop checking ...
                    return false;
                }
            });

            break;
    }

    return blnUsed;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// DeleteBookMark: Removes the bookmark from the user's list
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.DeleteBookmark = function DeleteBookmark(strBookmarkID) {

    // Get the map Bookmarks instance 
    var objBookmarks = this;

    // When not the user's initial extent bookmark for the map
    if (!objBookmarks.UsedForUserInitialExtentOfMap(strBookmarkID)) {

        // remove the deleted bookmark from the state
        var arrUpdatedBookmarks = $.grep(objBookmarks.MapController.State.Bookmarks, function (objItem) { return (objItem.BookmarkID != strBookmarkID); });
        objBookmarks.MapController.State.Bookmarks = arrUpdatedBookmarks;

        // Rebuild the lookup table ...
        objBookmarks.MapController.BuildBookmarkLookupTable();

        var objBookmarksSaveData = TrimbleMap.Bookmarks.Shared.CreateBookmarkSaving(enumBookmarkSaveType.Delete, null, strBookmarkID);
        TrimbleMap.Bookmarks.Shared.SaveBookmarks(objBookmarksSaveData, objBookmarks.BookmarksSaveSuccessProxy, objBookmarks.BookmarksSaveErrorProxy);

        // Notify the menu instance that the height changed ...
        objBookmarks.MenuInstance.SubMenuHeightChanged();

    } else {

        // Cannot delete bookmark
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Bookmarks.js', 'CannotDeleteBookmarkTitle');

        // This bookmark is currently set to be used as the initial extent for this map. You need to first set another initial extent in your preferences.
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Bookmarks.js', 'CannotDeleteBookmarkMessage');

        // Notify the user of the problem ...
        TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// NewBookmarkButtonClicked: Invokes a call to a web service that will update the bookmarks on the server
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.NewBookmarkButtonClicked = function NewBookmarkButtonClicked(e) {

    // Get the map Bookmarks instance
    var objBookmarks = this;

    // Prevent the default action (submit) ...
    e.preventDefault();

    // Create the bookmark ...
    objBookmarks.CreateNewBookmark();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateNewBookmark
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.CreateNewBookmark = function CreateNewBookmark() {

    // Get the map Bookmarks instance
    var objBookmarks = this;

    // Get the name to be used for the new bookmark ...
    var strNewBookmark = (objBookmarks.NewBookmarkTextBox.val()).trim();

    // When we have a bookmark name ...
    if ((strNewBookmark).trim() != '') {

        // Test if bookmark witrh the name already exist ...
        var blnBookmarkNameExists = $.grep(objBookmarks.MapController.State.Bookmarks, function (objBookmark, intBookmark) { return (objBookmark.BookmarkName.toLowerCase() == strNewBookmark.toLowerCase()) }).length > 0;

        // When another bookmark with the same name does not already exist ...
        if (!blnBookmarkNameExists) {

            // Get the extent of the esri map 
            var objEsriExtent = objBookmarks.MapController.GetMapExtent();
            var objMapSpatialReferenceInformation = objBookmarks.MapController.GetSpatialReference(objBookmarks.MapController.CurrentMap.SpatialReferenceID);

            // Get the bookmark ...
            var objBookmark = SD.Bookmark.Shared.CreateFromEsriMapExtent(objEsriExtent,
                strNewBookmark,
                objBookmarks.MapController.State.LoggedInUserID,
                objMapSpatialReferenceInformation.SpatialReferenceID);

            // Add the bookmark to the map controller
            objBookmarks.AddBookmark(objBookmark);

            // clear the new bookmark textbox
            objBookmarks.NewBookmarkTextBox.val('');

        } else {

            // Remove the focus from the text box ...
            objBookmarks.NewBookmarkTextBox.blur();

            // Notify the user of the problem ...
            TrimbleMap.MessageBox.Shared.ShowMessage('Invalid bookmark name', 'Another bookmark with the same name already exist.', function () {

                // Focus on the text box ...
                objBookmarks.NewBookmarkTextBox.focus();
            });
        }

    } else {

        // Remove the focus from the text box ...
        objBookmarks.NewBookmarkTextBox.blur();

        // Notify the user of the problem ...
        TrimbleMap.MessageBox.Shared.ShowMessage('Bookmark name required', 'Enter the bookmark name.', function () {

            // Focus on the text box ...
            objBookmarks.NewBookmarkTextBox.focus();
        });
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddBookmark
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.AddBookmark = function AddBookmark(objBookmark) {

    // Get the map controller instance ...
    var objBookmarks = this;

    // Add the bookmark to the map controller state ...
    objBookmarks.MapController.AddBookmark(objBookmark);

    var objBookmarksSaving = TrimbleMap.Bookmarks.Shared.CreateBookmarkSaving(enumBookmarkSaveType.AddOrEdit, objBookmark, objBookmark.BookmarkID);
    TrimbleMap.Bookmarks.Shared.SaveBookmarks(objBookmarksSaving, objBookmarks.BookmarksSaveSuccessProxy, objBookmarks.BookmarksSaveErrorProxy);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// SaveBookmarks: Invokes a call to a web service that will update the bookmarks on the server
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.Shared.SaveBookmarks = function SaveBookmarks(objBookmarksSaveData, fnSuccess, fnError) {
    //Call the bookmark Updater
    TrimbleMap.BookmarkUpdater.Shared.SaveBookmark(objBookmarksSaveData, fnSuccess, fnError);

}


// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// CreateBookmarkSaving: Creates an object that will be used to save the bookmarks on the server side
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.Shared.CreateBookmarkSaving = function CreateBookmarkSaving(enSaveType, objBookmark, guidBookmark) {

    var objBookmarksSaveData = {
        Bookmark: objBookmark,
        SaveType: enSaveType,
        BookmarkID: guidBookmark
    };

    return objBookmarksSaveData;
}


// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// EVENT HANDLER BookmarksSaveSuccess: Handles the results of the bookmarks saving  ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.BookmarksSaveSuccess = function BookmarksSaveSuccess(data, textStatus, jqXHR) {

    var objBookmarks = this;

    objBookmarks.DetachEventHandlers();
    objBookmarks.CreateBookmarksTable();
    objBookmarks.AttachEventHandlers();

    // Notify the menu instance that the height changed ...
    objBookmarks.MenuInstance.SubMenuHeightChanged();

    // clear the edit/add and delete lists
    objBookmarks.MapController.State.BookmarksEditedAndAdded = null;
    objBookmarks.MapController.State.BookmarksDeleted = null;
}


// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// EVENT HANDLER BookmarksSaveError: Handles when the bookmarks saving fails ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.BookmarksSaveError = function BookmarksSaveError(data, textStatus, jqXHR) {
    //data.responseText contains the error html ...
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// GoToBookMarkExtent: Navigates to the bookmark passed in as ID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Bookmarks.GoToBookMarkExtent = function GoToBookMarkExtent(BookmarkID) {

    // Get the instance ...
    var objBookmarks = this;

    // Get the bookmark ...
    var objBookmark = objBookmarks.MapController.GetBookmark(BookmarkID);

    // Get the bookmark extent ...
    var objEsriBookmarkExtendDeferred = objBookmarks.MapController.GetBookmarkExtentInSpatialReferenceOfCurrentMap(objBookmark);

    // When the bookmark extend is returned ...
    objEsriBookmarkExtendDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objEsriBookmarkExtend) {

        // Set the extent of the map    
        objBookmarks.MapController.SetMapExtent(objEsriBookmarkExtend);

        // Hide the menu ...
        objBookmarks.MenuInstance.Hide();

    }), TrimbleMap.Controller.Shared.TrapException(function (strError) {

        // Get the spatial reference of the shape ...
        var objSpatialReference = objBookmarks.MapController.GetSpatialReference(objBookmarks.MapController.CurrentMap.SpatialReferenceID);

        // Set the translations ...

        // Not valid in the coordinate system of the map
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Bookmarks.js', 'NotValidInCoordinateSystemTitle');

        // The selected bookmark is not valid in
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Bookmarks.js', 'NotValidInCoordinateSystemMessage') + ' ' + objSpatialReference.Name;

        // Notify the user ...
        TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
    }));
}



// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.BookmarkUpdater = {};
TrimbleMap.BookmarkUpdater.Shared = {};
TrimbleMap.BookmarkUpdater.Shared.Handler = null;

// **************************************************************************
// FUNCTION: SetHandler
// USAGE:    
// **************************************************************************
TrimbleMap.BookmarkUpdater.Shared.SetHandler = function SetHandler(fnBookmarkUpdaterHandler) {

    // Set the handler ...
    TrimbleMap.BookmarkUpdater.Shared.Handler = fnBookmarkUpdaterHandler;
}

// **************************************************************************
// FUNCTION: SaveBookmark
// USAGE:    
// **************************************************************************
TrimbleMap.BookmarkUpdater.Shared.SaveBookmark = function SaveBookmark(objBookmarkChange, fnSuccess, fnError) {

   // Save the bookmark
    TrimbleMap.BookmarkUpdater.Shared.Handler(objBookmarkChange, fnSuccess, fnError);
   
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Callout = {};
TrimbleMap.Callout.Shared = {};
TrimbleMap.Callout.Shared.CALLOUT_WIDTH = 290 + 2;
TrimbleMap.Callout.Shared.CALLOUT_MAX_HEIGHT = 400;

// **************************************************************************
// ENUM:  enumExtentChange
// USAGE: Enum for Map.Callout.Show
// **************************************************************************
TrimbleMap.Callout.enumExtentChange = {};
TrimbleMap.Callout.enumExtentChange.KeepCurrentExtent = 'KeepCurrentExtent';
TrimbleMap.Callout.enumExtentChange.Zoom = 'Zoom';
TrimbleMap.Callout.enumExtentChange.PanAndZoomOut = 'PanAndZoomOut';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.CreateInstance = function CreateInstance(objMapController) {

    // Create the object that will hold the instance properties ...
    var objMapCallout = {
        HideCallbacks: [],
        Results: null,
        OnShowAttached: false,
        MapController: objMapController,
        Color: '#FF0000',
        PointSymbol: null,
        PolygonSymbol: null,
        PolylineSymbol: null,
        CalloutContent: null,
        ContentScrollbar: null,
        MapPanEndHandlerDojoHandle: null,
        InfoWindowShowHandlerDojoHandle: null,
        IsVisible: false,

        InfoWindowShowHandlerProxy: function () { objMapCallout.InfoWindowShowHandler() },
        MapPanEndHandlerProxy: function () { objMapCallout.MapPanEndHandler() },
        ContainerClickedProxy: function (e) { objMapCallout.ContainerClicked(e) },

        AttachCloseClickHandler: TrimbleMap.Callout.AttachCloseClickHandler,
        Show: TrimbleMap.Callout.Show,
        ShowNoResults: TrimbleMap.Callout.ShowNoResults,
        Hide: TrimbleMap.Callout.Hide,
        AddHideCallback: TrimbleMap.Callout.AddHideCallback,
        RemoveHideCallback: TrimbleMap.Callout.RemoveHideCallback,
        ShowInfoWindow: TrimbleMap.Callout.ShowInfoWindow,
        BuildContent: TrimbleMap.Callout.BuildContent,
        ContainerClicked: TrimbleMap.Callout.ContainerClicked,
        ZoomToIconClicked: TrimbleMap.Callout.ZoomToIconClicked,
        DrawSelectedGraphic: TrimbleMap.Callout.DrawSelectedGraphic,
        RemoveCurrentlySelectedGraphic: TrimbleMap.Callout.RemoveCurrentlySelectedGraphic,
        GetCalloutItemForElement: TrimbleMap.Callout.GetCalloutItemForElement,
        CreateSymbology: TrimbleMap.Callout.CreateSymbology,
        GetSymbolForGeometryType: TrimbleMap.Callout.GetSymbolForGeometryType,

        InfoWindowShowHandler: TrimbleMap.Callout.InfoWindowShowHandler,
        MapPanEndHandler: TrimbleMap.Callout.MapPanEndHandler
    };

    // Attach event handlers to close the info windows when cross is clicked ...
    objMapCallout.AttachCloseClickHandler();

    // Create the symbology to use to draw the layer ...
    objMapCallout.CreateSymbology();

    return objMapCallout;
}

// **************************************************************************
// FUNCTION: CreateSymbology
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.CreateSymbology = function CreateSymbology() {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Create a dojo color instance ...
    var objColor = new dojo.Color(objMapCallout.Color);

    // *** Polygon symbol ...

    // Create a symbol for drawing the lines ...
    var objLineSymbol = new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, objColor, 2);

    // Create a fill symbol for drawing the geometries ...
    objMapCallout.PolygonSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID, objLineSymbol,
        new dojo.Color([objColor[0], objColor[1], objColor[2], 0.25]));

    // Create a fill symbol for drawing the geometries ...
    objMapCallout.PolylineSymbol = new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, objColor, 2);


    // *** Point symbol ...

    // Create a marker symbol for drawing the geometries ...
    objMapCallout.PointSymbol = new esri.symbol.SimpleMarkerSymbol(esri.symbol.SimpleMarkerSymbol.STYLE_CIRCLE, 5, objLineSymbol,
        new dojo.Color([255, 255, 255, 1]));

}

// **************************************************************************
// FUNCTION: GetSymbolForGeometryType
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.GetSymbolForGeometryType = function GetSymbolForGeometryType(enEsriGeometryType) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Return the symbol for the geometry type ...
    switch (enEsriGeometryType) {
        case 'polygon': return objMapCallout.PolygonSymbol; break;
        case 'point': return objMapCallout.PointSymbol; break;
        case 'multipoint': return objMapCallout.PointSymbol; break;
        case 'polyline': return objMapCallout.PolylineSymbol; break;
    }

    // Geometry type not supported ...
    return null;
}

// **************************************************************************
// FUNCTION: AttachCloseClickHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.AttachCloseClickHandler = function AttachCloseClickHandler() {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Attach a click event handler to the map ...
    objMapCallout.MapController.MapElement.on('click', (function (e) {

        // Get the element clicked on ...
        var objElement = $(e.target);

        // When its the identify or search result popup close button ...
        if (objElement.hasClass('titleButton') && objElement.hasClass('close')) {

            // Hide the callout ...
            objMapCallout.Hide();
        }
    }));
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    Use Map.Callout.enumExtentChange for enExtentChange parameter ...
// **************************************************************************
TrimbleMap.Callout.Show = function Show(arrCalloutItems, objZoomToMapPoint, enExtentChange) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Build the content to display and show the info window when done ...
    objMapCallout.BuildContent(arrCalloutItems, function (objCalloutContent) {

        // When the current extent is to be kept ...
        if (enExtentChange == TrimbleMap.Callout.enumExtentChange.KeepCurrentExtent) {

            // Convert the map point to screen coordinates ...
            let objScreenPoint = objMapCallout.MapController.EsriMap.toScreen(objZoomToMapPoint);

            // Open the info window with the content that we've built ...
            objMapCallout.ShowInfoWindow(arrCalloutItems, objScreenPoint, objCalloutContent);

        } else {

            // Declare variable for zooming ...
            let objExtentToZoomTo;
            var blnFitInView = false;

            // When we are to only zoom when the geometry is not in view ...
            if (enExtentChange == TrimbleMap.Callout.enumExtentChange.PanAndZoomOut) {

                // Get the current map extent ...
                var objMapExtent = objMapCallout.MapController.EsriMap.extent;

                // When the geomtry type is polygon or polyline...
                if (objMapCallout.CurrentlySelectedGraphic.geometry.type == 'polygon' || objMapCallout.CurrentlySelectedGraphic.geometry.type == 'polyline') {

                    // Get the extent of the geometry ...
                    var objGeometryExtent = objMapCallout.CurrentlySelectedGraphic.geometry.getExtent();

                    // Set to be not in view when the width or height of the geometry is bigger than the current map extent ...
                    blnFitInView = ((objGeometryExtent.getWidth() <= objMapExtent.getWidth()) && (objGeometryExtent.getHeight() <= objMapExtent.getHeight()));

                } else {

                    // Points will always fit in the view ...
                    blnFitInView = true;
                }

                // When the geometry will fit into any extent on the current zoom level ...
                if (blnFitInView) {

                    // Compute the distance in screen units to correct the center point to center in the visible area of the map ...
                    var dblDistance = parseInt(objMapCallout.MapController.MapElement.innerWidth(), 10) - objMapCallout.MapController.GetVisibleMapExtentInScreenCoordinates().width + 150;

                    // Compute the search panel width in map units on the current extent ...
                    var dblOffsetInMapUnits = TrimbleMap.MapToScreenConversions.Shared.ComputeDistanceInMapUnits(objMapCallout.MapController.EsriMap.extent, dblDistance, objMapCallout.MapController.MapElement);

                    // Center the extent on the center of the geometry ...
                    objExtentToZoomTo = objMapExtent.centerAt(new esri.geometry.Point(objZoomToMapPoint.x + dblOffsetInMapUnits, objZoomToMapPoint.y));

                    // Add the area that the search panel occupies to the centered extent ...
                    objExtentToZoomTo.xmax = (objExtentToZoomTo.xmax - dblOffsetInMapUnits);
                }
            }

            // Create function that will show the callout ...
            var fnShowCalloutAt = function (objExtentToShowAt) {

                // Suspend drawing of the tile layers ...
                objMapCallout.MapController.SuspendAllLayers();

                // Pan to the extent of the selected graphic ...
                var objDeferred = objMapCallout.MapController.EsriMap.setExtent(objExtentToShowAt);

                // When panning is complete ...
                objDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

                    // Convert the map point to screen coordinates ...
                    let objScreenPoint = objMapCallout.MapController.EsriMap.toScreen(objZoomToMapPoint);

                    // Open the info window with the content that we've built ...
                    objMapCallout.ShowInfoWindow(arrCalloutItems, objScreenPoint, objCalloutContent);

                    // Resume drawing of the tile layers ...
                    objMapCallout.MapController.ResumeAllLayers();
                }));
            }

            // When we are to always zoom or only to zoom out  
            // and the geometry is to big for the current view ...
            if ((enExtentChange == TrimbleMap.Callout.enumExtentChange.Zoom) || (!blnFitInView)) {

                // Compute the zoom to extent for the geometry ...
                objMapCallout.MapController.ComputeZoomToExtent(objMapCallout.CurrentlySelectedGraphic.geometry, 3, 150).then(TrimbleMap.Controller.Shared.TrapException(function (objComputedExtent) {

                    // Show the callout at the extent ...
                    fnShowCalloutAt(objComputedExtent);
                }));

            } else {

                // Show the callout at the extent ...
                fnShowCalloutAt(objExtentToZoomTo);
            }
        }
    });
}

// **************************************************************************
// FUNCTION: ShowNoResults
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.ShowNoResults = function ShowNoResults(objScreenPoint) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Create the no results span ...
    var objContent = $('<span class="no-results">' + SD.Translation.Shared.GetTranslation('Map.Callout.js', 'NoResults') + '</span>');

    // Show the info window ...
    objMapCallout.MapController.EsriMap.infoWindow.setTitle('');
    objMapCallout.MapController.EsriMap.infoWindow.setContent(objContent.get(0));

    // Convert to map units ...
    var objMapPoint = objMapCallout.MapController.EsriMap.toMap(objScreenPoint);

    // Show the callout ...
    objMapCallout.MapController.EsriMap.infoWindow.show(objMapPoint);

    // Set to be visible ...
    objMapCallout.IsVisible = true;
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.Hide = function Hide() {

    // Get the map callout instance ...
    var objMapCallout = this;

    // When the callout is visible ...
    if (objMapCallout.IsVisible) {

        // When we have a nice scrollbar, remove it ...
        if (objMapCallout.ContentScrollbar) {
            objMapCallout.ContentScrollbar.remove();
            objMapCallout.ContentScrollbar = null;
        }

        // When the on show event has been attached ...
        if (objMapCallout.OnShowAttached) {

            // Attach an event handler for the show ...
            dojo.disconnect(objMapCallout.InfoWindowShowHandlerDojoHandle);

            // Attach a pan-end event handler to the map ...
            dojo.disconnect(objMapCallout.MapPanEndHandlerDojoHandle);

            // Attach a click event handler to the content div ...
            objMapCallout.CalloutContent.ContainerDiv.off('click', objMapCallout.ContainerClickedProxy);

            // Set to have detached the onshow event handler ... 
            objMapCallout.OnShowAttached = false;
        }

        // Hide the info window ...
        objMapCallout.MapController.EsriMap.infoWindow.hide();

        // Remove the currently selected identify graphic ...
        objMapCallout.RemoveCurrentlySelectedGraphic();

        // Loop through all the hide callbacks ...
        for (var intHideCallback = 0; intHideCallback < objMapCallout.HideCallbacks.length; intHideCallback++) {

            // Get the hide callback ...
            var fnHideCallback = objMapCallout.HideCallbacks[intHideCallback];

            // Call the callback ...
            fnHideCallback(objMapCallout);
        }

        // Set to be not visible ...
        objMapCallout.IsVisible = false;
    }
}

// **************************************************************************
// FUNCTION: AddHideEventHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.AddHideCallback = function AddHideCallback(fnHideCallback) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Add to the list of hide callbacks ...
    objMapCallout.HideCallbacks.push(fnHideCallback);
}

// **************************************************************************
// FUNCTION: RemoveHideCallback 
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.RemoveHideCallback = function RemoveHideCallback(fnHideCallback) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Get the index into the array ...
    var intHideCallback = $.inArray(fnHideCallback, objMapCallout.HideCallbacks);

    // Remove when found ...
    if (intHideCallback > -1) { objMapCallout.HideCallbacks.slice(intHideCallback, 1); };
}

// **************************************************************************
// FUNCTION: ShowInfoWindow
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.ShowInfoWindow = function ShowInfoWindow(arrCalloutItems, objScreenPoint, objCalloutContent) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Get the info window from the map ...
    var objInfoWindow = objMapCallout.MapController.EsriMap.infoWindow;

    // Show the info window ...
    objInfoWindow.setTitle(objCalloutContent.Title);
    objInfoWindow.setContent(objCalloutContent.ContainerDiv.get(0));
    objInfoWindow.resize(TrimbleMap.Callout.Shared.CALLOUT_WIDTH, TrimbleMap.Callout.Shared.CALLOUT_MAX_HEIGHT);
    objInfoWindow.reposition();

    // When the on show event has not been attached yet ...
    if (!objMapCallout.OnShowAttached) {

        // Set to have attach the onshow event handler ... 
        objMapCallout.OnShowAttached = true;

        // Attach an event handler for the show ...
        objMapCallout.InfoWindowShowHandlerDojoHandle = dojo.connect(objMapCallout.MapController.EsriMap.infoWindow, "onShow", objMapCallout.InfoWindowShowHandlerProxy);

        // Attach a pan-end event handler to the map ...
        objMapCallout.MapPanEndHandlerDojoHandle = objMapCallout.MapController.EsriMap.on('pan-end', objMapCallout.MapPanEndHandlerProxy);

        // Attach a click event handler to the content div ...
        objMapCallout.CalloutContent.ContainerDiv.click(objMapCallout.ContainerClickedProxy);
    }

    // Convert to map units ...
    var objMapPoint = objMapCallout.MapController.EsriMap.toMap(objScreenPoint);

    // Show the callout ...
    objInfoWindow.show(objMapPoint);

    objMapCallout.MapController.IdentifyPopup = objMapCallout;

    // Set to be visible ...
    objMapCallout.IsVisible = true;
}

// **************************************************************************
// FUNCTION: InfoWindowShowHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.InfoWindowShowHandler = function InfoWindowShowHandler() {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Make the content div scrollable ...
    objMapCallout.ContentScrollbar = $(objMapCallout.CalloutContent.ContainerDiv.closest('.contentPane')).niceScroll({ cursorwidth: "7px" });
}

// **************************************************************************
// FUNCTION: MapPanEndHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.MapPanEndHandler = function MapPanEndHandler() {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Get the info window ...
    let objInfoWindow = objMapCallout.MapController.EsriMap.infoWindow;

    // Reposition the identify callout when visible ...
    if (objInfoWindow.isShowing) {

        // Reposition ...
        objInfoWindow.reposition();
    }
}

// **************************************************************************
// FUNCTION: BuildContent
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.BuildContent = function BuildContent(arrCalloutItems, fnComplete) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Set the callout items on the instance ...
    objMapCallout.CalloutItems = arrCalloutItems;

    // Create a new object to hold the dom elements for the results ...
    var objCalloutContent = {};

    // Start with the after render function called 0 times, with all the bindings has not been kicked off yet and 0 identifiable layers ...
    var intAfterRenderCount = 0;
    var blnAllBindingsKickedOff = false;
    var blnCompleteCalled = false;

    // Create an after render function to deal with when the binding for each feature has completed ...
    var fnAfterRender = function AfterRender() {

        // Incerment the number of times that the after render function were called ...
        intAfterRenderCount = intAfterRenderCount + 1;

        // When all the bindings has been kicked off, and all the after renders has been called and the complete function has not been called yet ...
        if (blnAllBindingsKickedOff && (intAfterRenderCount >= arrCalloutItems.length) && (!blnCompleteCalled)) {

            // Set the complete to not be called ...
            blnCompleteCalled = true;

            // Call the complete callback ...
            fnComplete(objCalloutContent);
        }
    }

    // Build the callout content ...
    var objCalloutContent = TrimbleMap.Callout.Shared.BuildContentHtml(arrCalloutItems, objMapCallout.MapController.State.DateFormat, fnAfterRender);

    // Set the callout content on the instance ...
    objMapCallout.CalloutContent = objCalloutContent;

    if (arrCalloutItems.length > 0) {

        // Draw the selected Identify graphic ...
        objMapCallout.DrawSelectedGraphic(arrCalloutItems[0]);
    }

    // Set to have kicked off all the identify bindings ...
    blnAllBindingsKickedOff = true;

    // Call the after render function to ensure that it gets called after all the sections has beeen bound ...
    fnAfterRender();

    return objCalloutContent;
}

// **************************************************************************
// FUNCTION: BuildContentHtml
// USAGE:    Build the Html Callout Content
// **************************************************************************
TrimbleMap.Callout.Shared.BuildContentHtml = function BuildContentHtml(arrCalloutItems, strDateFormat, fnAfterRender) {

    // Initialise the return object
    var objCalloutContent = {};

    // Create a new array to hold the heading dom elements ...
    objCalloutContent.Headings = [];

    // Start with multiple results ...
    objCalloutContent.Title = SD.Translation.Shared.GetTranslation('Map.Callout.js', 'MultipleResults');

    // Create the result container div ...
    objCalloutContent.ContainerDiv = $('<div id="divIdentifyResultContainer" class="identify-results"></div>');

    // Start with being the first item to add ...
    var blnIsFirst = true;

    // Start with no current identify heading ...
    objCalloutContent.CurrentHeading = null;

    // Loop through all the callout items ...
    for (var intCalloutItem = 0; intCalloutItem < arrCalloutItems.length; intCalloutItem++) {

        // Get the callout item ...
        var objCalloutItem = arrCalloutItems[intCalloutItem];

        // Create the content dom element ...
        var objContent = $('<div class="identify-result' + (((arrCalloutItems.length > 1) && (intCalloutItem < arrCalloutItems.length - 1)) ? '' : ' indentify-result-single') + '"><div>' + objCalloutItem.TemplateHtml + '</div></div>');

        var blnApplyHeadingKnockout = false;

        // When we have more than one result ...
        if (arrCalloutItems.length > 1) {

            // Start with using the GroupTemplateHeading css class ...
            var strGroupHeadingCssClass = 'identify-group-heading';

            // When the first feature ...
            if (blnIsFirst) {

                // Set to use the selected css class ...
                strGroupHeadingCssClass = 'identify-group-heading-selected';
            }

            // Set the heading property to be the value of attribute with name objCalloutItem.HeadingHtmlTemplate if defined ...
            var strHeadingProperty = "";

            if (objCalloutItem.HeadingHtmlTemplate) {
                strHeadingProperty = objCalloutItem.HeadingHtmlTemplate;
                blnApplyHeadingKnockout = true;
            }

            // Create the group by template heading ...
            var objHeading = $('<div class="' + strGroupHeadingCssClass + '"><span>' + objCalloutItem.Name + ": " + strHeadingProperty + '</span></div>');

            // When the first feature ...
            if (blnIsFirst) {

                // Set the heading as the current heading ...
                objCalloutContent.CurrentHeading = objHeading;
            }

            // Add the heading to the container div ...
            objCalloutContent.ContainerDiv.append(objHeading);

            // Push the dom element into the array for later use ...
            objCalloutContent.Headings.push(objHeading.get(0));


        } else {

            if (objCalloutItem.HeadingHtmlTemplate) {
                objHeading = $('<span>' + objCalloutItem.HeadingHtmlTemplate + '</span>');
                objCalloutContent.Title = objHeading.get(0);
                blnApplyHeadingKnockout = true;

            } else {
                objCalloutContent.Title = objCalloutItem.Name;
            }
        }

        // Attach the afterRender function to the inner div ...
        objContent.attr('data-bind', 'template: { afterRender: afterRender }');

        // Add to the container div ...
        objCalloutContent.ContainerDiv.append(objContent);

        // When not the first feature ...
        if (!blnIsFirst) {

            // Hide the content div ...
            objContent.hide();
        }

        // Bind the data to the content dom element ...
        ko.applyBindings({ Attributes: objCalloutItem.Attributes, DateFormat: strDateFormat, afterRender: fnAfterRender }, objContent.get(0));

        if (blnApplyHeadingKnockout) {
            ko.applyBindings({ Attributes: objCalloutItem.Attributes, DateFormat: strDateFormat }, objHeading.get(0));
        }

        // Set to not be the first feature ...
        blnIsFirst = false;
    }

    return objCalloutContent;
}

// **************************************************************************
// FUNCTION: ContainerClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.ContainerClicked = function ContainerClicked(e) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Wrap the target with jquery ...
    let objTarget = $(e.target);

    // Get the heading on which the user clicked (if any) ...
    var objHeading = objTarget.closest('.identify-group-heading');

    // Check if it is the zoom to icon ...
    var blnIsZoomToIcon = ((objTarget.hasClass('zoom_to_icon')) || (objTarget.find('.zoom_to_icon').length > 0));

    // When the user clicked on the zoom to icon ...
    if (blnIsZoomToIcon) {

        // Zoom to the feature ...
        objMapCallout.ZoomToIconClicked(e);

        // When the element on which the user clicked is a heading ...
    } else if (objHeading.length > 0) {

        // When we have a current heading ...
        if (objMapCallout.CalloutContent.CurrentHeading != null) {

            // Remove the selected class and add the normal class ...
            objMapCallout.CalloutContent.CurrentHeading.removeClass('identify-group-heading-selected');
            objMapCallout.CalloutContent.CurrentHeading.addClass('identify-group-heading');

            // Hide the item under the current heading ...
            objMapCallout.CalloutContent.CurrentHeading.next().slideUp();
        }

        // Remove the normal class and add the selected class ...
        objHeading.addClass('identify-group-heading-selected');
        objHeading.removeClass('identify-group-heading');

        // Slide the content div down ...
        objHeading.next().slideDown(function () {

            // Resize the scrollbar ...
            if (objMapCallout.ContentScrollbar) { objMapCallout.ContentScrollbar.resize(); }
        });

        // Set the current identify heading ...
        objMapCallout.CalloutContent.CurrentHeading = objHeading;

        // Find the index of the selected result ...
        var intResult = $.inArray(objHeading.get(0), objMapCallout.CalloutContent.Headings);

        // When found ...
        if (intResult > -1) {

            // Remove the currently selected identify graphic ...
            objMapCallout.RemoveCurrentlySelectedGraphic();

            // Draw the selected Identify graphic ...
            objMapCallout.DrawSelectedGraphic(objMapCallout.CalloutItems[intResult]);
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ZoomToIconClicked
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Callout.ZoomToIconClicked = function ZoomToIconClicked(e) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Get the callout item to which the zoom to icon belongs ...
    var objCalloutItem = objMapCallout.GetCalloutItemForElement(objTarget);

    // When found ...
    if (objCalloutItem != null) {

        // Compute the zoom to extent for the geometry ...
        objMapCallout.MapController.ComputeZoomToExtent(objCalloutItem.Graphic.geometry, 3, 150).then(TrimbleMap.Controller.Shared.TrapException(function (objExtentToZoomTo) {

            // Set the new extent ...
            objMapCallout.MapController.EsriMap.setExtent(objExtentToZoomTo);
        }));
    }
}

// **************************************************************************
// FUNCTION: DrawSelectedGraphic
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.DrawSelectedGraphic = function DrawSelectedGraphic(objCalloutItem) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Remove the currently selected graphic ...
    objMapCallout.RemoveCurrentlySelectedGraphic();

    // When we have a geometry to display ...
    if ((typeof objCalloutItem.Geometry != 'undefined') && (objCalloutItem.Geometry != null)) {

        // Project the geometry to the spatial reference of the map ...
        var objProjectGeometryDeferred = objMapCallout.MapController.ProjectGeometry(objCalloutItem.Geometry,
            objCalloutItem.SpatialReferenceID,
            objMapCallout.MapController.CurrentMap.SpatialReferenceID,
            true, TrimbleMap.enumProjectionLevel.RELAXED,
            false);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedGeometry) {

            // Update the callout item's geometry to be the projected geometry ...
            objCalloutItem.Geometry = objProjectedGeometry;
            objCalloutItem.SpatialReferenceID = objMapCallout.MapController.CurrentMap.SpatialReferenceID;

            // Create the graphic ...
            var objGraphic = new esri.Graphic(objProjectedGeometry, objMapCallout.GetSymbolForGeometryType(objProjectedGeometry.type));

            // Add the graphic to the map ...
            objMapCallout.MapController.AddGraphic(objGraphic);

            // Set the selected graphic ...
            objMapCallout.CurrentlySelectedGraphic = objGraphic;
        }));

    } else {

        // Get the title and message translations ...

        // 'Unable to highlight the  shape'
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Callout.js', 'UnableToHighlightShape');

        // 'The record has no shape. This is most likely because the map layer does not expose the shape field, ensure that the shape field is included in the list of fields returned by the map layer'
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Callout.js', 'UnableToHighlightShapeDiagnosticMessage');

        // 'Unable to highlight the shape. The record has no shape.'
        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Callout.js', 'UnableToHighlightShapeEndUserMessage');

        // Log the diagnostic message ...
        objMapCallout.MapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);
    }
}

// **************************************************************************
// FUNCTION: RemoveCurrentlySelectedGraphic
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.RemoveCurrentlySelectedGraphic = function RemoveCurrentlySelectedGraphic() {

    // Get the map callout instance ...
    var objMapCallout = this;

    // When we have a currently selected result ...
    if ((typeof objMapCallout.CurrentlySelectedGraphic != 'undefined') && (objMapCallout.CurrentlySelectedGraphic != null)) {

        // Remove the graphic from the map ...
        objMapCallout.MapController.RemoveGraphic(objMapCallout.CurrentlySelectedGraphic);

        // Set to null ...
        objMapCallout.CurrentlySelectedGraphic = null;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetCalloutItemForElement
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Callout.GetCalloutItemForElement = function GetCalloutItemForElement(objElement) {

    // Get the map callout instance ...
    var objMapCallout = this;

    // Find the callout result div in which the element is if any ...
    var objResultDiv = objElement.closest('.identify-result');

    // When found ...
    if (objResultDiv.length > 0) {

        // Get the result container div ...
        var objResultContainerDiv = objResultDiv.closest('.identify-results');

        // Find all the callout results in the container ...
        var arrResults = objResultContainerDiv.find('.identify-result');

        // Get the index of the identify result div in the container ...
        var intCalloutItem = $.inArray(objResultDiv.get(0), arrResults);

        // Return the callout item ...
        return objMapCallout.CalloutItems[intCalloutItem];
    }

    // Not found ...
    return null;
}

// **************************************************************************
// FUNCTION: CreateItem
// USAGE:    
// **************************************************************************
TrimbleMap.Callout.Shared.CreateItem = function CreateItem(strName, strTemplateHtml, strHeadingHtmlTemplate, objGeometry, guidSpatialReference, objAttributes) {

    // Build the callout item ...
    var objCalloutItem = {
        Name: strName,
        TemplateHtml: strTemplateHtml,
        HeadingHtmlTemplate: strHeadingHtmlTemplate,
        Geometry: objGeometry,
        SpatialReferenceID: guidSpatialReference,
        Attributes: objAttributes
    };

    return objCalloutItem;
}


/// <reference path="~/JavaScript/jquery.js" />

// Create the TrimbleMap.ConstructShapeFromCentroid namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ConstructShapeFromCentroid = {};
TrimbleMap.ConstructShapeFromCentroid.Shared = {};

// **************************************************************************
// Enums ...
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.enumShapeType = {};
TrimbleMap.ConstructShapeFromCentroid.enumShapeType.None = 'None';
TrimbleMap.ConstructShapeFromCentroid.enumShapeType.Circle = 'Circle';
TrimbleMap.ConstructShapeFromCentroid.enumShapeType.Square = 'Square';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.CreateInstance = function CreateInstance(objShapeEditor) {    

    // Create the instance ...
    let objConstructShapeFromCentroid = {
        ShapeEditor: objShapeEditor,

        DialogID: 0,
        EventHandlersAttached: false,
        ConstructShapeFromCentroidDiv: null,
        ReferencePointDropDown: null,             
        ShapeTypeDropDown: null,
        RadiusLengthOfSideLabel: null,
        RadiusLengthOfSideTextBox: null,
        RadiusLengthOfSideUnitDropDown: null,
        ValidationMessageDiv: null,

        ClickedHandlerProxy: function (e) { objConstructShapeFromCentroid.ClickedHandler(e); },

        OpenDialog: TrimbleMap.ConstructShapeFromCentroid.OpenDialog,
        CloseDialog: TrimbleMap.ConstructShapeFromCentroid.CloseDialog,
        BuildDialog: TrimbleMap.ConstructShapeFromCentroid.BuildDialog,
        BuildInterfaceRow: TrimbleMap.ConstructShapeFromCentroid.BuildInterfaceRow,
        Validate: TrimbleMap.ConstructShapeFromCentroid.Validate,
        ShowValidationMessages: TrimbleMap.ConstructShapeFromCentroid.ShowValidationMessages,
        ClearControls: TrimbleMap.ConstructShapeFromCentroid.ClearControls,
        ClearExistingShapeAndConstructNewShape: TrimbleMap.ConstructShapeFromCentroid.ClearExistingShapeAndConstructNewShape,

        AttachEventHandlers: TrimbleMap.ConstructShapeFromCentroid.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.ConstructShapeFromCentroid.DetachEventHandlers,
        ClickedHandler: TrimbleMap.ConstructShapeFromCentroid.ClickedHandler
    }

    return objConstructShapeFromCentroid;
}

// **************************************************************************
// FUNCTION: OpenDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.OpenDialog = function OpenDialog() {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // Build the dialog
    objConstructShapeFromCentroid.BuildDialog();

    // Get the next modal dialog id ...
    objConstructShapeFromCentroid.DialogID = TrimbleMap.ModalDialog.Shared.NextDialogID();  

    // Attach all event handlers
    objConstructShapeFromCentroid.AttachEventHandlers();

    // Construct a shape from centroid
    let strTitle = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ConstructShapeFromCentroidTitle');

    // Show the dialog ...
    TrimbleMap.ModalDialog.Shared.OpenDialog(objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv, strTitle, false, objConstructShapeFromCentroid.DialogID);
}

// **************************************************************************
// FUNCTION: OpenDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.CloseDialog = function CloseDialog() {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // Detach all event handlers
    objConstructShapeFromCentroid.DetachEventHandlers();

    // Clear the validation message div ...
    objConstructShapeFromCentroid.ValidationMessageDiv.empty();

    // Close the modal dialog ...
    TrimbleMap.ModalDialog.Shared.CloseDialog(objConstructShapeFromCentroid.DialogID);
}

// **************************************************************************
// FUNCTION: BuildDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.BuildDialog = function BuildDialog() {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // When not created yet ...
    if (!objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv) {
        // Create the dialog content div ...        
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv = $('<div id="constructshapefromcentroid"></div>');

        // Instructions
        let strInstructions = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ConstructShapeFromCentroidInstructions');

        // Add Instructions to parent div
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv.append('<div class="construct_shape_from_centrolid_instructions">' + strInstructions + '</div>');

        // Build a row for the label and dropdown of reference point
        objConstructShapeFromCentroid.ReferencePointElements = objConstructShapeFromCentroid.BuildInterfaceRow();

        // Reference Point
        let strReferencePointText = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ReferencePoint');

        // Add Reference Point label
        objConstructShapeFromCentroid.ReferencePointElements.FirstColumnDiv.append('<span>' + strReferencePointText + ':</span>');

        // Reference Point
        objConstructShapeFromCentroid.ReferencePointDropDown = $('<select class="construct_shape_from_centrolid_reference_point_dropdown" ></select>');

        // Get Reference Points
        let arrReferencePoints = objConstructShapeFromCentroid.ShapeEditor.Shape.ReferencePoints;

        //Add empty record to Reference Point dropdown
        objConstructShapeFromCentroid.ReferencePointDropDown.append('<option value="' + SD.Guid.Shared.Empty() + '"></option>');

        // Populate Reference Points dropdown
        for (let intIndex = 0; intIndex < arrReferencePoints.length; intIndex++) {
            let objReferencePoint = arrReferencePoints[intIndex];

            if (objReferencePoint.HasValues && objReferencePoint.CalculationMethod == SD.Number.NULL_NUMBER) {
                objConstructShapeFromCentroid.ReferencePointDropDown.append('<option value="' + arrReferencePoints[intIndex].ID + '">' + arrReferencePoints[intIndex].ReferencePointTypeName + '</option>');
            }
        }

        // Add Reference Points dropdown
        objConstructShapeFromCentroid.ReferencePointElements.SecondColumnDiv.append(objConstructShapeFromCentroid.ReferencePointDropDown);

        // Add Shape Type elements to parent div
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv.append(objConstructShapeFromCentroid.ReferencePointElements.RowDiv);

        // Build a row for the label and dropdown of Shape Type
        objConstructShapeFromCentroid.ShapeTypeElements = objConstructShapeFromCentroid.BuildInterfaceRow();

        // Shape Type
        let strShapeTypeText = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ShapeType');        

        // Add Shape Type label
        objConstructShapeFromCentroid.ShapeTypeElements.FirstColumnDiv.append('<span>' + strShapeTypeText + ':</span>');

        // Shape Type
        objConstructShapeFromCentroid.ShapeTypeDropDown = $('<select class="construct_shape_from_centrolid_shape_type_dropdown"></select>');

        // Populate Shape Type dropdown
        objConstructShapeFromCentroid.ShapeTypeDropDown.append('<option value="' + TrimbleMap.ConstructShapeFromCentroid.enumShapeType.None + '"></option>');

        // Get Circle translation
        let strCircleShapeType = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'Circle');
        // Append circle to Shape Type dropdown
        objConstructShapeFromCentroid.ShapeTypeDropDown.append('<option value="' + TrimbleMap.ConstructShapeFromCentroid.enumShapeType.Circle + '">' + strCircleShapeType + '</option>');

        // Get Square translation
        let strSquareShapeType = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'Square');
        // Append square to Shape Type dropdown
        objConstructShapeFromCentroid.ShapeTypeDropDown.append('<option value="' + TrimbleMap.ConstructShapeFromCentroid.enumShapeType.Square + '">' + strSquareShapeType + '</option>');

        // Add Shape Type dropdown
        objConstructShapeFromCentroid.ShapeTypeElements.SecondColumnDiv.append(objConstructShapeFromCentroid.ShapeTypeDropDown);

        // Add Shape Type elements to parent div
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv.append(objConstructShapeFromCentroid.ShapeTypeElements.RowDiv);

        // Build a row for the label and textbox of Radius/Length of side
        objConstructShapeFromCentroid.RadiusElements = objConstructShapeFromCentroid.BuildInterfaceRow();

        // Radius/Length of side
        let strRadiusText = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'Radius');

        // Create Radius/Length of side label
        objConstructShapeFromCentroid.RadiusLengthOfSideLabel = $('<span>' + strRadiusText + ':</span>');

        // Add Radius/Length of side label
        objConstructShapeFromCentroid.RadiusElements.FirstColumnDiv.append(objConstructShapeFromCentroid.RadiusLengthOfSideLabel);

        // Create the Radius/Length of side textbox
        objConstructShapeFromCentroid.RadiusLengthOfSideTextBox = $('<input type="text" class="construct_shape_from_centrolid_radius_textbox"></input>');

        // Add Radius/Length of side textbox
        objConstructShapeFromCentroid.RadiusElements.SecondColumnDiv.append(objConstructShapeFromCentroid.RadiusLengthOfSideTextBox);        

        // Radius/Length of side Unit
        objConstructShapeFromCentroid.RadiusLengthOfSideUnitDropDown = $('<select class= "construct_shape_from_centrolid_reference_point_dropdown"></select>');

        // Get Distance Units
        let arrDistanceUnits = objConstructShapeFromCentroid.ShapeEditor.MapController.State.DistanceUnits;

        objConstructShapeFromCentroid.RadiusLengthOfSideUnitDropDown.append('<option value="' + SD.Guid.Shared.Empty() + '"></option>');

        // Populate Distance Units dropdown
        for (let intIndex = 0; intIndex < arrDistanceUnits.length; intIndex++) {
            objConstructShapeFromCentroid.RadiusLengthOfSideUnitDropDown.append('<option value="' + arrDistanceUnits[intIndex].ID + '">' + arrDistanceUnits[intIndex].Unit + '</option>');
        }        

        // Add Radius/Length of side unit dropdown
        objConstructShapeFromCentroid.RadiusElements.ThirdColumnDiv.append(objConstructShapeFromCentroid.RadiusLengthOfSideUnitDropDown);

        // Add Radius/Length of side elements to parent div
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv.append(objConstructShapeFromCentroid.RadiusElements.RowDiv);

        // Create the validation message div ...
        objConstructShapeFromCentroid.ValidationMessageDiv = $('<div></div>');

        // Add it to the div ...
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv.append(objConstructShapeFromCentroid.ValidationMessageDiv);

        // Cancel Button
        let strCancelText = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'Cancel');
        objConstructShapeFromCentroid.CancelButton = $('<button CancelButton="true" type="button" class="Button construct_shape_from_centrolid_button">' + strCancelText + '</button>')

        // Add Cancel button to parent div
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv.append(objConstructShapeFromCentroid.CancelButton);

        // Ok Button
        let strOkText = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'Ok');
        objConstructShapeFromCentroid.OkButton = $('<button OKButton="true" type="button" class="Button construct_shape_from_centrolid_button">' + strOkText + '</button>')

        // Add Ok button to parent div
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv.append(objConstructShapeFromCentroid.OkButton);        
    } else {
        // Clear reference points, user could have created new or deleted the shape which a reference point is calculated from
        objConstructShapeFromCentroid.ReferencePointDropDown.empty();

		// Get Reference Points
        let arrReferencePoints = objConstructShapeFromCentroid.ShapeEditor.Shape.ReferencePoints;            

        //Add empty record to Reference Point dropdown
        objConstructShapeFromCentroid.ReferencePointDropDown.append('<option value="' + SD.Guid.Shared.Empty() + '"></option>');

        // Populate Reference Points dropdown
        for (let intIndex = 0; intIndex < arrReferencePoints.length; intIndex++) {
            let objReferencePoint = arrReferencePoints[intIndex];

            if (objReferencePoint.HasValues && objReferencePoint.CalculationMethod == SD.Number.NULL_NUMBER) {
                objConstructShapeFromCentroid.ReferencePointDropDown.append('<option value="' + arrReferencePoints[intIndex].ID + '">' + arrReferencePoints[intIndex].ReferencePointTypeName + '</option>');
            }
        }
    }

    // Return the modal div
    return objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv;
}

// **************************************************************************
// FUNCTION: BuildInterfaceRow
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.BuildInterfaceRow = function BuildInterfaceRow() {
    // Create an object for the controls ...
    let objControls = {};

    // Create a div for the row ...
    objControls.RowDiv = $('<div></div>');

    // Create divs for the columns ...
    objControls.FirstColumnDiv = $('<div class="construct_shape_from_centrolid_first_column"></div>');
    objControls.SecondColumnDiv = $('<div class="construct_shape_from_centrolid_second_column"></div>');
    objControls.ThirdColumnDiv = $('<div class="construct_shape_from_centrolid_third_column"><div></div></div>');

    // Add the columns to the row ...
    objControls.RowDiv.append(objControls.FirstColumnDiv);
    objControls.RowDiv.append(objControls.SecondColumnDiv);
    objControls.RowDiv.append(objControls.ThirdColumnDiv);

    return objControls;
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.AttachEventHandlers = function AttachEventHandlers() {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // When the event handlers are not attached ...
    if (!objConstructShapeFromCentroid.EventHandlersAttached) {
        // Attach the click event handler proxy ...
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv.click(objConstructShapeFromCentroid.ClickedHandlerProxy);

        // Set to have detached the event handlers ...
        objConstructShapeFromCentroid.EventHandlersAttached = true;
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.DetachEventHandlers = function DetachEventHandlers() {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // When the event handlers are attached ...
    if (objConstructShapeFromCentroid.EventHandlersAttached) {

        // Detach the click event handler proxy ...
        objConstructShapeFromCentroid.ConstructShapeFromCentroidDiv.off('click', objConstructShapeFromCentroid.ClickedHandlerProxy);

        // Set to have detached the event handlers ...
        objConstructShapeFromCentroid.EventHandlersAttached = false;
    }
}

// **************************************************************************
// FUNCTION: ClickedHandler
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.ClickedHandler = function ClickedHandler(e) {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // Get the target ...
    let objTarget = $(e.target);

    // Attempt to get the relevant elements up the dom tree from the clicked target ...
    let objShapeTypeDropDown = SD.DOM.GetElementOrParentWithClass(objTarget, 'construct_shape_from_centrolid_shape_type_dropdown');
    let objOKButton = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'OKButton');
    let objCancelButton = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'CancelButton');

    switch (true) {
        case (objShapeTypeDropDown != null):
            if (objShapeTypeDropDown.val()) {
                let strLabelText = '';

                // Check if shape type is a square
                if (objShapeTypeDropDown.val() == TrimbleMap.ConstructShapeFromCentroid.enumShapeType.Square) {
                    // Length of side
                    strLabelText = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'LengthOfSide');
                } else {
                    // Radius
                    strLabelText = SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'Radius');
                }

                // Set the radius/length of side label
                objConstructShapeFromCentroid.RadiusLengthOfSideLabel.text(strLabelText + ":");
            }                     
            break;
        case (objOKButton != null):

            // Validate the parameters
            let arrValidationMessages = objConstructShapeFromCentroid.Validate();

            if (arrValidationMessages.length == 0) {
                // Clear existing shape and construct new shape
                objConstructShapeFromCentroid.ClearExistingShapeAndConstructNewShape().then(TrimbleMap.Controller.Shared.TrapException(function () {
                    // Clear the controls selected values
                    objConstructShapeFromCentroid.ClearControls();

                    // Close the modal dialog
                    objConstructShapeFromCentroid.CloseDialog();
                }), TrimbleMap.Controller.Shared.TrapException(function (strError) {
                    // Display error
                    objConstructShapeFromCentroid.ShowValidationMessages([strError]);
                }));
            } else {
                // Display validation messages
                objConstructShapeFromCentroid.ShowValidationMessages(arrValidationMessages);
            }            
            break;
        case (objCancelButton != null):
            // Clear the controls selected values
            objConstructShapeFromCentroid.ClearControls();
            // Close the modal dialog
            objConstructShapeFromCentroid.CloseDialog();
            break;
    }
}

// **************************************************************************
// FUNCTION: Validate
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.Validate = function Validate() {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // Create a new array for the validation messages ...
    let arrValidationMessages = [];

    // Check if reference point is not set
    if (objConstructShapeFromCentroid.ReferencePointDropDown.val() == SD.Guid.Shared.Empty()) {
        // Add the validation message ...
        arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ParameterNotSpecified', SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ReferencePoint')));
    }

    // Check if shape type is not set
    if (objConstructShapeFromCentroid.ShapeTypeDropDown.val() == TrimbleMap.ConstructShapeFromCentroid.enumShapeType.None) {
        // Add the validation message ...
        arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ParameterNotSpecified', SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ShapeType')));
    }

    // Check if shape type is a square
    let blnShapeTypeSquare = objConstructShapeFromCentroid.ShapeTypeDropDown.val() == TrimbleMap.ConstructShapeFromCentroid.enumShapeType.Square;

    // Check if radius/length of side is not set
    if ((objConstructShapeFromCentroid.RadiusLengthOfSideTextBox.val()).trim() == '') {
        // Add the validation message ...        
        if (blnShapeTypeSquare) {
            arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ParameterNotSpecified', SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'LengthOfSide')));
        } else {            
            arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ParameterNotSpecified', SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'Radius')));
        }        
    } else if (!SD.Number.ValidateIsNumber(objConstructShapeFromCentroid.RadiusLengthOfSideTextBox.val(), objConstructShapeFromCentroid.ShapeEditor.MapController.State.GroupSeparator, objConstructShapeFromCentroid.ShapeEditor.MapController.State.DecimalSeparator, false)) {
        // Add the validation message ...
        if (blnShapeTypeSquare) {
            arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'InvalidParameter', SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'LengthOfSide')));
        } else {            
            arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'InvalidParameter', SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'Radius')));
        }
    }

    // Check if unit is not set
    if (objConstructShapeFromCentroid.RadiusLengthOfSideUnitDropDown.val() == SD.Guid.Shared.Empty()) {
        // Add the validation message ...
        arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ParameterNotSpecified', SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'Unit')));
    }

    return arrValidationMessages;
}

// **************************************************************************
// FUNCTION: ShowValidationMessages
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.ShowValidationMessages = function ShowValidationMessages(arrValidationMessages) {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // Clear the validation message div ...
    objConstructShapeFromCentroid.ValidationMessageDiv.empty();

    // Loop through all the validation messages ...
    $.each(arrValidationMessages, function (intValidationMessage, strValidationMessage) {

        // Create and add a span with the validation message ...
        objConstructShapeFromCentroid.ValidationMessageDiv.append('<span class="construct_shape_from_centrolid_validation_span">* ' + strValidationMessage + '</span><br />');
    });
}


// **************************************************************************
// FUNCTION: ClearControls
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.ClearControls = function ClearControls() {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // Reset the selected reference point
    objConstructShapeFromCentroid.ReferencePointDropDown.val(SD.Guid.Shared.Empty());

    // Reset the selected shape type
    objConstructShapeFromCentroid.ShapeTypeDropDown.val(TrimbleMap.ConstructShapeFromCentroid.enumShapeType.None);

    // Reset the radius/length of side
    objConstructShapeFromCentroid.RadiusLengthOfSideTextBox.val('');

    // Reset the unit
    objConstructShapeFromCentroid.RadiusLengthOfSideUnitDropDown.val(SD.Guid.Shared.Empty());
}

// **************************************************************************
// FUNCTION: ShowValidationMessages
// USAGE:    
// **************************************************************************
TrimbleMap.ConstructShapeFromCentroid.ClearExistingShapeAndConstructNewShape = function ClearExistingShapeAndConstructNewShape() {
    // Get the instance ...
    let objConstructShapeFromCentroid = this;

    // Get the shape type value
    let strShapeTypeValue = objConstructShapeFromCentroid.ShapeTypeDropDown.val();

    // Create a new deferred to return
    let objDeferred = new dojo.Deferred();

    // Get selected distance unit
    let objDistanceUnit = objConstructShapeFromCentroid.ShapeEditor.MapController.GetDistanceUnit(objConstructShapeFromCentroid.RadiusLengthOfSideUnitDropDown.val());

    // Get selected reference point
    let objReferencePoint = objConstructShapeFromCentroid.ShapeEditor.Shape.GetReferencePointByID(objConstructShapeFromCentroid.ReferencePointDropDown.val());

    // Get the FlexiCadastre spatial reference information ...
    let objLandfolioSpatialReference = objConstructShapeFromCentroid.ShapeEditor.MapController.GetSpatialReference(objConstructShapeFromCentroid.ShapeEditor.Shape.SpatialReferenceID);

    // esri spatial reference to be created
    let objEsriSpatialReference = null;

    // When we have a non-zero well known ID ...
    if (objLandfolioSpatialReference.WKID != 0) {
        // Create an esri spatial reference from the FlexiCadastre spatial reference well known id from ...
        objEsriSpatialReference = new esri.SpatialReference(objLandfolioSpatialReference.WKID);
    } else {
        // Create an esri spatial reference from the FlexiCadastre spatial reference well known text from ...
        objEsriSpatialReference = new esri.SpatialReference(objLandfolioSpatialReference.WKTDefinition);
    }

    // Get the distance
    let decDistance = (objConstructShapeFromCentroid.RadiusLengthOfSideTextBox.val()).trim();

    // Convert the distance to kilometers
    let decDistanceInKm = decDistance * objDistanceUnit.ConversionFactorToKm;

    // Create point from reference point
    let objPoint = new esri.geometry.Point(objReferencePoint.X, objReferencePoint.Y, objEsriSpatialReference);

    let objCircle = new esri.geometry.Circle({ "center": objPoint, "radius": decDistanceInKm, "radiusUnit": esri.Units.KILOMETERS });

    // Check if shape type is a circle
    if (strShapeTypeValue == TrimbleMap.ConstructShapeFromCentroid.enumShapeType.Circle) {
        //Don't call generalize if the maximumm deviation setting is set to 0
        if (objConstructShapeFromCentroid.ShapeEditor.MapController.State.DensifySettings.MaximumDeviationDegrees == 0) {

            objConstructShapeFromCentroid.ShapeEditor.RemoveShape(true);
            objConstructShapeFromCentroid.ShapeEditor.DrawToAdd(objCircle, objConstructShapeFromCentroid.ShapeEditor.Shape.SpatialReferenceID, null, false, false).then(TrimbleMap.Controller.Shared.TrapException(function () {
                // Zoom to the shape
                objConstructShapeFromCentroid.ShapeEditor.ZoomToShape(false).then(TrimbleMap.Controller.Shared.TrapException(function () {
                    // Resolve deferred
                    objDeferred.resolve();
                }), TrimbleMap.Controller.Shared.TrapException(function () {
                    // Reject deferred
                    objDeferred.reject();
                }));
            }), TrimbleMap.Controller.Shared.TrapException(function () {
                // Reject deferred
                objDeferred.reject();
            }));
        } else {
            objConstructShapeFromCentroid.ShapeEditor.MapController.GeneralizeShape(objCircle, objLandfolioSpatialReference).then(TrimbleMap.Controller.Shared.TrapException(function (arrGeometries) {

                objConstructShapeFromCentroid.ShapeEditor.RemoveShape(true);
                objConstructShapeFromCentroid.ShapeEditor.DrawToAdd(arrGeometries[0], objConstructShapeFromCentroid.ShapeEditor.Shape.SpatialReferenceID, null, false, false).then(TrimbleMap.Controller.Shared.TrapException(function () {
                    // Zoom to the shape
                    objConstructShapeFromCentroid.ShapeEditor.ZoomToShape(false).then(TrimbleMap.Controller.Shared.TrapException(function () {
                        // Resolve deferred
                        objDeferred.resolve();
                    }), TrimbleMap.Controller.Shared.TrapException(function () {
                        // Reject deferred
                        objDeferred.reject();
                    }));
                }), TrimbleMap.Controller.Shared.TrapException(function () {
                    // Reject deferred
                    objDeferred.reject();
                }));
            }), TrimbleMap.Controller.Shared.TrapException(function (strError) {
                // Reject deferred with error message
                objDeferred.reject(strError);
            }));
        }
    } else if (strShapeTypeValue == TrimbleMap.ConstructShapeFromCentroid.enumShapeType.Square) {
        objConstructShapeFromCentroid.ShapeEditor.MapController.CreateSquareFromPoint(objPoint, decDistance, objDistanceUnit).then(TrimbleMap.Controller.Shared.TrapException(function (objGeometry) {

            objConstructShapeFromCentroid.ShapeEditor.RemoveShape(true);

            objConstructShapeFromCentroid.ShapeEditor.DrawToAdd(objGeometry, objConstructShapeFromCentroid.ShapeEditor.Shape.SpatialReferenceID, null, false, false).then(TrimbleMap.Controller.Shared.TrapException(function () {
                // Zoom to shape
                objConstructShapeFromCentroid.ShapeEditor.ZoomToShape();
                // Resolve deferred
                objDeferred.resolve();
            }), TrimbleMap.Controller.Shared.TrapException(function () {
                // Reject deferred with error message
                objDeferred.reject();
            }));
        }), TrimbleMap.Controller.Shared.TrapException(function (strError) {
            // Reject deferred with error message
            objDeferred.reject(strError);
        }));
    }

    // Return deferred object
    return objDeferred;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Controller = {};
TrimbleMap.Controller.Shared = {};
TrimbleMap.Controller.Shared.FILTER_SELECTION = 'FILTER_SELECTION';
TrimbleMap.Controller.Shared.MAP_COMPONENT_NAME = 'Map';
TrimbleMap.Controller.Shared.MAX_POINTS_PER_PROJECTION_REQUEST = 20000;
TrimbleMap.Controller.Shared.POINT_SIDE_PADDING_DISTANCE_METERS = 10000;
TrimbleMap.Controller.Shared.MAX_DEVIATION = 0.1;
TrimbleMap.Controller.Shared.WFS_VERSION = "1.1.0";
TrimbleMap.Controller.Shared.ALL_NAMESPACES = "*";
TrimbleMap.Controller.Shared.TOPP_NAMESPACE = "http://www.openplans.org/topp";
TrimbleMap.Controller.Shared.WFS_NAMESPACE = "http://www.opengis.net/wfs";
TrimbleMap.Controller.Shared.OGC_NAMESPACE = "http://www.opengis.net/ogc";
TrimbleMap.Controller.Shared.GML_NAMESPACE = "http://www.opengis.net/gml";
TrimbleMap.Controller.Shared.XSD_NAMESPACE = "http://www.w3.org/2001/XMLSchema";
TrimbleMap.Controller.Shared.XSI_NAMESPACE = "http://www.w3.org/2001/XMLSchema-instance";
TrimbleMap.Controller.Shared.WFS_SCHEMA = "http://schemas.opengis.net/wfs/1.1.0/wfs.xsd";
TrimbleMap.Controller.Shared.MAX_WFS_FEATURES = 1000;
TrimbleMap.Controller.Shared.WFS_RESULT_TYPE_HITS = "Hits";
TrimbleMap.Controller.Shared.WFS_ID = "WfsID";
TrimbleMap.Controller.Shared.WFS_EPSG = "EPSG";
TrimbleMap.Controller.Shared.WFS_GEOMETRY_FIELD_SEARCH = "gml:";

// **************************************************************************
// Enums ...
// **************************************************************************
TrimbleMap.Controller.enumMapServiceType = {};
TrimbleMap.Controller.enumMapServiceType.Feature = 'Feature';
TrimbleMap.Controller.enumMapServiceType.Tile = 'Tile';
TrimbleMap.Controller.enumMapServiceType.Dynamic = 'Dynamic';
TrimbleMap.Controller.enumMapServiceType.Dual = 'Dual';
TrimbleMap.Controller.enumMapServiceType.WebMapService = 'WebMapService';

TrimbleMap.enumScaleRangeMethod = {};
TrimbleMap.enumScaleRangeMethod.None = 'None';
TrimbleMap.enumScaleRangeMethod.DisplayLevels = 'DisplayLevels';
TrimbleMap.enumScaleRangeMethod.MinMaxScale = 'MinMaxScale';

TrimbleMap.enumHtmlTemplate = {};
TrimbleMap.enumHtmlTemplate.Search = 'Search';
TrimbleMap.enumHtmlTemplate.Identify = 'Identify';

TrimbleMap.enumEsriCursorType = {};
TrimbleMap.enumEsriCursorType.Default = 'default';
TrimbleMap.enumEsriCursorType.Wait = 'wait';

TrimbleMap.enumSpatialReferenceType = {};
TrimbleMap.enumSpatialReferenceType.NONE = 'NONE';
TrimbleMap.enumSpatialReferenceType.PROJECTED = 'PROJECTED';
TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC = 'GEOGRAPHIC';

TrimbleMap.enumScalebarUnitSystem = {};
TrimbleMap.enumScalebarUnitSystem.Metric = 'Metric';
TrimbleMap.enumScalebarUnitSystem.Imperial = 'Imperial';

TrimbleMap.enumDiagnosticMessageLevel = {};
TrimbleMap.enumDiagnosticMessageLevel.CRITICAL = 'CRITICAL';
TrimbleMap.enumDiagnosticMessageLevel.INFORMATION = 'INFORMATION';

TrimbleMap.enumProjectionLevel = {};
TrimbleMap.enumProjectionLevel.CRITICAL = 'CRITICAL';
TrimbleMap.enumProjectionLevel.RELAXED = 'RELAXED';

TrimbleMap.enumIndividualItemNameType = {};
TrimbleMap.enumIndividualItemNameType.UseSpecifiedText = 'UseSpecifiedText';
TrimbleMap.enumIndividualItemNameType.GetFromAttributes = 'GetFromAttributes';

TrimbleMap.enumAuthenticationType = {};
TrimbleMap.enumAuthenticationType.NoAuthentication = 'NoAuthentication';
TrimbleMap.enumAuthenticationType.Token = 'Token';
TrimbleMap.enumAuthenticationType.Basic = 'Basic';

TrimbleMap.enumMapLayerTemplateFields = {};
TrimbleMap.enumMapLayerTemplateFields.AreaUnit = 'AreaUnit';
TrimbleMap.enumMapLayerTemplateFields.AreaValue = 'AreaValue';

TrimbleMap.enumMapServerType = {};
TrimbleMap.enumMapServerType.ESRI = 'ESRI';
TrimbleMap.enumMapServerType.GEOSERVER = 'GEOSERVER';

TrimbleMap.enumOgcMapService = {};
TrimbleMap.enumOgcMapService.WMS = 'WMS';
TrimbleMap.enumOgcMapService.WFS = 'WFS';

TrimbleMap.enumOgcMapServiceQueryParameterKey = {};
TrimbleMap.enumOgcMapServiceQueryParameterKey.Service = 'Service';
TrimbleMap.enumOgcMapServiceQueryParameterKey.Version = 'Version';
TrimbleMap.enumOgcMapServiceQueryParameterKey.Request = 'Request';

TrimbleMap.enumWebFeatureServiceQueryParameterKey = {};
TrimbleMap.enumWebFeatureServiceQueryParameterKey.TypeName = 'typeName';
TrimbleMap.enumWebFeatureServiceQueryParameterKey.Filter = 'Filter';
TrimbleMap.enumWebFeatureServiceQueryParameterKey.MaxFeatures = 'maxFeatures';
TrimbleMap.enumWebFeatureServiceQueryParameterKey.ResultType = 'ResultType';
TrimbleMap.enumWebFeatureServiceQueryParameterKey.PropertyName = 'PropertyName';
TrimbleMap.enumWebFeatureServiceQueryParameterKey.SrsName = 'srsName';

TrimbleMap.enumWebFeatureServiceRequest = {};
TrimbleMap.enumWebFeatureServiceRequest.GetCapabilities = 'GetCapabilities';
TrimbleMap.enumWebFeatureServiceRequest.DescribeFeatureType = 'DescribeFeatureType';
TrimbleMap.enumWebFeatureServiceRequest.GetFeature = 'GetFeature';

TrimbleMap.enumEsriGeometryType = {};
TrimbleMap.enumEsriGeometryType.Point = "esriGeometryPoint";
TrimbleMap.enumEsriGeometryType.Polyline = "esriGeometryPolyline";
TrimbleMap.enumEsriGeometryType.Polygon = "esriGeometryPolygon";

TrimbleMap.Controller.enumMapLayerVisibility = {};
TrimbleMap.Controller.enumMapLayerVisibility.Hidden = "Hidden";
TrimbleMap.Controller.enumMapLayerVisibility.VisibleByDefault = "VisibleByDefault";
TrimbleMap.Controller.enumMapLayerVisibility.NotVisibleByDefault = "NotVisibleByDefault";
TrimbleMap.Controller.enumMapLayerVisibility.InheritFromSource = "InheritFromSource";

// **************************************************************************
// Globals
TrimbleMap.Controller.Shared.MapServiceTokensLookupTable = {};
// **************************************************************************

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.CreateInstance = function CreateInstance(objMapControllerState, objPreferences, objCurrentMapIDHiddenElement, objMapElement, blnLoadMapContentsOption, fnOpenPopup, fnGetVisibleMapExtentInScreenCoordinates, objShapesToSelectExtent, fnMouseLeftMap, fnApplyUserMapSettings, objUserSettings) {

    // Create the object that will hold the instance properties ...
    var objMapController = {
        State: objMapControllerState,
        CurrentMap: objMapControllerState.Maps[objMapControllerState.CurrentMapIndex],
        MapElement: objMapElement,
        CurentMapIDElement: objCurrentMapIDHiddenElement,
        LoadMapContents: blnLoadMapContentsOption,
        LoadMapContentsOption: blnLoadMapContentsOption,
        GetVisibleMapExtentInScreenCoordinates: fnGetVisibleMapExtentInScreenCoordinates,
        AllowClientSideProjections: true,
        Scalebar: null,
        MapServices: null,
        MapServiceForLegend: null,
        GroupByTemplatesByMapServiceName: null,
        QueryableMapServices: null,
        SearchMapServiceName: null,
        EsriLayersByMapServiceDisplayIDLookupTable: {},
        LoadedMapComponents: [],
        MapComponentLoadedDependencies: [],
        FailedMapComponents: [],
        MapComponentFailedDependencies: [],
        LoadingFinalized: false,
        LoadingCompleted: false,
        MapLookupTable: {},
        MapServiceLookupTable: {},
        MapServiceDisplayLookupTable: {},
        MapLayerLookupTable: {},
        MapLayerNameLookupTable: {},
        AreaUnitLookupTable: {},
        DistanceUnitLookupTable: {},
        EsriMapLayerIDLookupTable: {},
        OgcMapLayerIDLookupTable: {},
        EsriMapLayerIDReverseLookupTable: {},
        MapLayerGroupBySectionLookupTable: {},
        MapLayerGroupBySectionByMapLayerIDLookupTable: {},
        SpatialReferenceLookupTable: {},
        BookmarkLookupTable: {},
        CurrentScales: null,
        EsriMap: null,
        OnScalesChangedFunctions: [],
        OnScaleChangedFunctions: [],
        OnSpatialReferenceChangedFunctions: [],
        OnLoadedFunctions: [],
        OnExtentChangedFunctions: [],
        PreReloadedFunctions: [],
        OnLegendDataLoadedFunctions: [],
        SelectionFeatureLayers: {},
        SelectionGraphicsLayers: {},
        SelectionFeatureLayerDeferreds: [],
        PolygonSelectionSymbol: null,
        PolylineSelectionSymbol: null,
        PointSelectionSymbol: null,
        SelectedGraphicsByMapLayerID: {},
        IsAdditionalSelectionEnabledOnMapLayerFunction: null,
        ObjectIDFieldNameByMapLayerID: {},
        MapLayerDataFromService: {},
        MapLoadedOnce: false,
        InitialExtent: null,
        ShapesToSelectExtent: objShapesToSelectExtent,
        EsriSpatialReferences: {},
        Proj4jsProjections: {},
        DiagnosticMessages: [],
        NotifyDiagnosticMessageLoggedFunctions: [],
        NotifyModuleVisiblityChangedFunctions: [],
        NotifyPreferenceChangedFunctions: [],
        LegendData: {},
        LoadingLegendDataForMap: {},
        HaveMapsToDisplay: true,
        InfoMessage: null,

        OpenPopup: fnOpenPopup,

        IdentifyPopup: null,

        FieldNamesToAliasesMapping: {},
        AliasesToFieldNamesMapping: {},
        LastEsriRequestIOArgs: null,
        FirstEsriRequestIOArgsSinceReset: null,
        GeometryService: new esri.tasks.GeometryService(objMapControllerState.GeometryServiceUrl),
        Preferences: objPreferences,
        MaxRecordCountByMapService: {},
        UseClientSideProjectionByFromSpatialReference: {},
        DummyMapForExtentDetermination: null,
        DummyMapElementForExtentDetermination: null,
        UserSettings: objUserSettings,
        EsriGraphicsByShapeID: {},
        HighlightedShapesWithSymbologyByShapeID: {},

        EsriRequestPreCallbackHandlerProxy: function (objIOArgs) { return objMapController.EsriRequestPreCallbackHandler(objIOArgs); },
        LayerReOrderedProxy: function () { objMapController.LayerReOrdered(); },
        ZoomEndProxy: function (e) { objMapController.ZoomEnd(e); },
        ExtentChangedProxy: function (e) { objMapController.ExtentChanged(e); },
        MouseLeftMapProxy: function (e) { if (fnMouseLeftMap) { fnMouseLeftMap(e); } },
        ApplyUserMapSettingsProxy: function (strMapID) { if (fnApplyUserMapSettings) { fnApplyUserMapSettings(strMapID); } },
        LoadMap: TrimbleMap.Controller.LoadMap,
        ReloadMap: TrimbleMap.Controller.ReloadMap,
        AddToEsriLayersLookupTable: TrimbleMap.Controller.AddToEsriLayersLookupTable,
        GetEsriLayersForMapServiceDisplay: TrimbleMap.Controller.GetEsriLayersForMapServiceDisplay,
        CreateScaleLevelDisplay: TrimbleMap.Controller.CreateScaleLevelDisplay,
        InstantiateMapService: TrimbleMap.Controller.InstantiateMapService,
        CreateMapLayers: TrimbleMap.Controller.CreateMapLayers,
        CreateMapLayersForMapService: TrimbleMap.Controller.CreateMapLayersForMapService,
        CreateSelectionFeatureLayersForDynamicMapService: TrimbleMap.Controller.CreateSelectionFeatureLayersForDynamicMapService,
        CreateSelectionFeatureLayersForWebFeatureService: TrimbleMap.Controller.CreateSelectionFeatureLayersForWebFeatureService,
        CreateSelectionFeatureLayer: TrimbleMap.Controller.CreateSelectionFeatureLayer,
        IsLayerToCreateSelectionFeatureLayerFor: TrimbleMap.Controller.IsLayerToCreateSelectionFeatureLayerFor,
        AddOnLayerLoad: TrimbleMap.Controller.AddOnLayerLoad,
        AddOnSelectionFeatureLayerOnLayerLoad: TrimbleMap.Controller.AddOnSelectionFeatureLayerOnLayerLoad,
        CreateEsriMap: TrimbleMap.Controller.CreateEsriMap,
        IsEsriMapLoaded: TrimbleMap.Controller.IsEsriMapLoaded,
        MapLoadCompleted: TrimbleMap.Controller.MapLoadCompleted,
        ZoomToInitialExtent: TrimbleMap.Controller.ZoomToInitialExtent,
        ZoomToInitialExtentOfCurrentMap: TrimbleMap.Controller.ZoomToInitialExtentOfCurrentMap,
        GetInitialExtentOfCurrentMap: TrimbleMap.Controller.GetInitialExtentOfCurrentMap,
        GetUserInitialExtentBookmarkIDForCurrentMap: TrimbleMap.Controller.GetUserInitialExtentBookmarkIDForCurrentMap,
        FindLayerTemplatesByID: TrimbleMap.Controller.FindLayerTemplatesByID,
        FindGroupByTemplateByName: TrimbleMap.Controller.FindGroupByTemplateByName,
        ComponentLoadCompleted: TrimbleMap.Controller.ComponentLoadCompleted,
        AllMapServicesLoadedOrFailed: TrimbleMap.Controller.AllMapServicesLoadedOrFailed,
        MapComponentFailedToLoad: TrimbleMap.Controller.MapComponentFailedToLoad,
        MapComponentDependenciesFailedToLoad: TrimbleMap.Controller.MapComponentDependenciesFailedToLoad,
        AllLayersFailedToLoad: TrimbleMap.Controller.AllLayersFailedToLoad,
        MapReady: TrimbleMap.Controller.MapReady,
        GetMapServiceDisplayLoadedStatus: TrimbleMap.Controller.GetMapServiceDisplayLoadedStatus,
        SuspendAllLayers: TrimbleMap.Controller.SuspendAllLayers,
        ResumeAllLayers: TrimbleMap.Controller.ResumeAllLayers,
        GetMap: TrimbleMap.Controller.GetMap,
        SetMapIndex: TrimbleMap.Controller.SetMapIndex,
        DestroyMap: TrimbleMap.Controller.DestroyMap,
        GetMapService: TrimbleMap.Controller.GetMapService,
        GetMapServiceToken: TrimbleMap.Controller.GetMapServiceToken,
        GetMapServiceDisplay: TrimbleMap.Controller.GetMapServiceDisplay,
        GetSpatialReference: TrimbleMap.Controller.GetSpatialReference,
        GetUnderlyingGeographicSpatialReferenceID: TrimbleMap.Controller.GetUnderlyingGeographicSpatialReferenceID,
        GetBookmark: TrimbleMap.Controller.GetBookmark,
        GetMapLayer: TrimbleMap.Controller.GetMapLayer,
        GetMapLayerByName: TrimbleMap.Controller.GetMapLayerByName,
        GetSelectedGraphicsByMapLayerID: TrimbleMap.Controller.GetSelectedGraphicsByMapLayerID,
        GetTotalSelectedFeatureCount: TrimbleMap.Controller.GetTotalSelectedFeatureCount,
        GetSelectedFeatureCountByMapLayerID: TrimbleMap.Controller.GetSelectedFeatureCountByMapLayerID,
        GetQueryableMapService: TrimbleMap.Controller.GetQueryableMapService,
        GetCurrentMapQueryableMapService: TrimbleMap.Controller.GetCurrentMapQueryableMapService,
        GetAreaUnit: TrimbleMap.Controller.GetAreaUnit,
        GetDistanceUnit: TrimbleMap.Controller.GetDistanceUnit,

        GetMapLayerIDForEsriLayerID: TrimbleMap.Controller.GetMapLayerIDForEsriLayerID,
        GetEsriLayerIDForMapLayerID: TrimbleMap.Controller.GetEsriLayerIDForMapLayerID,
        GetOgcLayerIDForMapLayerID: TrimbleMap.Controller.GetOgcLayerIDForMapLayerID,

        PreProcessMapControllerState: TrimbleMap.Controller.PreProcessMapControllerState,
        BuildBookmarkLookupTable: TrimbleMap.Controller.BuildBookmarkLookupTable,
        BuildSpatialReferenceLookupTable: TrimbleMap.Controller.BuildSpatialReferenceLookupTable,
        BuildMapServiceDisplaysLookupTable: TrimbleMap.Controller.BuildMapServiceDisplaysLookupTable,
        BuildMapServiceLookupTable: TrimbleMap.Controller.BuildMapServiceLookupTable,
        BuildMapLookupTable: TrimbleMap.Controller.BuildMapLookupTable,
        BuildMapLayerLookupTable: TrimbleMap.Controller.BuildMapLayerLookupTable,
        BuildMapLayerNameLookupTable: TrimbleMap.Controller.BuildMapLayerNameLookupTable,
        BuildAreaUnitLookupTable: TrimbleMap.Controller.BuildAreaUnitLookupTable,
        BuildDistanceUnitLookupTable: TrimbleMap.Controller.BuildDistanceUnitLookupTable,
        BuildMapLayerGroupBySectionLookupTable: TrimbleMap.Controller.BuildMapLayerGroupBySectionLookupTable,
        BuildMapServiceTokensLookupTable: TrimbleMap.Controller.BuildMapServiceTokensLookupTable,
        BuildQueryableMapServicesList: TrimbleMap.Controller.BuildQueryableMapServicesList,
        SetEsriMapLayerIDLookupTableValue: TrimbleMap.Controller.SetEsriMapLayerIDLookupTableValue,
        SetOgcMapLayerIDLookupTableValue: TrimbleMap.Controller.SetOgcMapLayerIDLookupTableValue,
        SetEsriMapLayerIDLookupTableValuesForDynamicMapService: TrimbleMap.Controller.SetEsriMapLayerIDLookupTableValuesForDynamicMapService,
        SetMapLayerIDLookupTableValuesForWebMapService: TrimbleMap.Controller.SetMapLayerIDLookupTableValuesForWebMapService,
        ConvertMapLayerIDsToEsriLayerIDs: TrimbleMap.Controller.ConvertMapLayerIDsToEsriLayerIDs,
        FinalizeLoading: TrimbleMap.Controller.FinalizeLoading,
        ConsiderFinalizingMap: TrimbleMap.Controller.ConsiderFinalizingMap,
        GetAllEsriLayers: TrimbleMap.Controller.GetAllEsriLayers,
        SetLayerVisibility: TrimbleMap.Controller.SetLayerVisibility,
        SetLayerVisibilityFromState: TrimbleMap.Controller.SetLayerVisibilityFromState,
        GetLayerVisibility: TrimbleMap.Controller.GetLayerVisibility,
        FilterLayerIDsForVisibleLayerIDs: TrimbleMap.Controller.FilterLayerIDsForVisibleLayerIDs,
        SetMapServiceDisplayVisibility: TrimbleMap.Controller.SetMapServiceDisplayVisibility,
        GetMapServiceDisplayVisibility: TrimbleMap.Controller.GetMapServiceDisplayVisibility,
        AddMapServiceToMap: TrimbleMap.Controller.AddMapServiceToMap,
        SetMapServiceDisplayTransparency: TrimbleMap.Controller.SetMapServiceDisplayTransparency,
        SetMapServiceDisplayScaleRange: TrimbleMap.Controller.SetMapServiceDisplayScaleRange,
        RemoveMapServiceDisplayFromMap: TrimbleMap.Controller.RemoveMapServiceDisplayFromMap,
        ReOrderMapServiceDisplays: TrimbleMap.Controller.ReOrderMapServiceDisplays,
        GetMapServiceDisplayLoadedComponents: TrimbleMap.Controller.GetMapServiceDisplayLoadedComponents,
        RemoveMapServiceDisplayFromLoadedComponentList: TrimbleMap.Controller.RemoveMapServiceDisplayFromLoadedComponentList,
        GetFirstEsriTileLayer: TrimbleMap.Controller.GetFirstEsriTileLayer,
        GetSpatialReferenceMapServiceName: TrimbleMap.Controller.GetSpatialReferenceMapServiceName,
        GetSpatialReferenceName: TrimbleMap.Controller.GetSpatialReferenceName,
        DetermineMapSpatialReferenceID: TrimbleMap.Controller.DetermineMapSpatialReferenceID,
        UpdateCurrentMapSpatialReferenceID: TrimbleMap.Controller.UpdateCurrentMapSpatialReferenceID,
        UpdateMapSpatialReferenceID: TrimbleMap.Controller.UpdateMapSpatialReferenceID,
        ZoomToScale: TrimbleMap.Controller.ZoomToScale,
        ZoomToShape: TrimbleMap.Controller.ZoomToShape,
        ZoomToShapes: TrimbleMap.Controller.ZoomToShapes,
        GetScale: TrimbleMap.Controller.GetScale,
        GetScales: TrimbleMap.Controller.GetScales,
        GetCurrentMapScales: TrimbleMap.Controller.GetCurrentMapScales,
        GetLODs: TrimbleMap.Controller.GetLODs,
        LayerReOrdered: TrimbleMap.Controller.LayerReOrdered,
        AddOnScalesChanged: TrimbleMap.Controller.AddOnScalesChanged,
        AddOnScaleChanged: TrimbleMap.Controller.AddOnScaleChanged,
        AddOnSpatialReferenceChanged: TrimbleMap.Controller.AddOnSpatialReferenceChanged,
        AddOnLoadedCallback: TrimbleMap.Controller.AddOnLoadedCallback,
        AddOnExtentChangedCallback: TrimbleMap.Controller.AddOnExtentChangedCallback,
        RemoveOnLoadedCallback: TrimbleMap.Controller.RemoveOnLoadedCallback,
        AddPreReloadedCallback: TrimbleMap.Controller.AddPreReloadedCallback,
        AddOnLegendDataLoaded: TrimbleMap.Controller.AddOnLegendDataLoaded,
        RemoveOnLegendDataLoaded: TrimbleMap.Controller.RemoveOnLegendDataLoaded,
        GetLevelScale: TrimbleMap.Controller.GetLevelScale,
        GetScaleLevel: TrimbleMap.Controller.GetScaleLevel,
        CreateScaleBar: TrimbleMap.Controller.CreateScaleBar,
        ZoomEnd: TrimbleMap.Controller.ZoomEnd,
        ExtentChanged: TrimbleMap.Controller.ExtentChanged,
        DiagnoseSpatialReferences: TrimbleMap.Controller.DiagnoseSpatialReferences,
        DiagnoseMapsToDisplay: TrimbleMap.Controller.DiagnoseMapsToDisplay,
        CreateEmptyMap: TrimbleMap.Controller.CreateEmptyMap,
        TriggerOnScaleChanged: TrimbleMap.Controller.TriggerOnScaleChanged,
        TriggerOnScalesChanged: TrimbleMap.Controller.TriggerOnScalesChanged,
        TriggerOnSpatialReferenceChanged: TrimbleMap.Controller.TriggerOnSpatialReferenceChanged,
        TriggerOnLoadedCallbacks: TrimbleMap.Controller.TriggerOnLoadedCallbacks,
        TriggerOnExtentChangedCallbacks: TrimbleMap.Controller.TriggerOnExtentChangedCallbacks,
        TriggerPreReloadedCallbacks: TrimbleMap.Controller.TriggerPreReloadedCallbacks,
        TriggerOnLegendDataLoaded: TrimbleMap.Controller.TriggerOnLegendDataLoaded,
        GetBookmarkExtentInSpatialReferenceOfCurrentMap: TrimbleMap.Controller.GetBookmarkExtentInSpatialReferenceOfCurrentMap,
        AddBookmark: TrimbleMap.Controller.AddBookmark,
        GetCurrentMapSpatialReference: TrimbleMap.Controller.GetCurrentMapSpatialReference,
        GetCurrentMapCoordinateDisplaySpatialReference: TrimbleMap.Controller.GetCurrentMapCoordinateDisplaySpatialReference,
        AddGraphic: TrimbleMap.Controller.AddGraphic,
        RemoveGraphic: TrimbleMap.Controller.RemoveGraphic,
        HighlightShapesWithSymbology: TrimbleMap.Controller.HighlightShapesWithSymbology,
        RemoveHighlightOnShapesWithSymbology: TrimbleMap.Controller.RemoveHighlightOnShapesWithSymbology,
        AddShapeWithSymbology: TrimbleMap.Controller.AddShapeWithSymbology,
        AddShapesWithSymbology: TrimbleMap.Controller.AddShapesWithSymbology,
        RemoveShapesWithSymbology: TrimbleMap.Controller.RemoveShapesWithSymbology,
        RemoveShapeWithSymbology: TrimbleMap.Controller.RemoveShapeWithSymbology,
        AddAndZoomToShapes: TrimbleMap.Controller.AddAndZoomToShapes,
        SetSpatialReferenceID: TrimbleMap.Controller.SetSpatialReferenceID,
        SetMapCursor: TrimbleMap.Controller.SetMapCursor,
        GetMapExtent: TrimbleMap.Controller.GetMapExtent,
        SetMapExtent: TrimbleMap.Controller.SetMapExtent,
        UpdateLastExtentViewed: TrimbleMap.Controller.UpdateLastExtentViewed,
        GetLastExtentViewedBookmark: TrimbleMap.Controller.GetLastExtentViewedBookmark,
        ForEachLayerInMap: TrimbleMap.Controller.ForEachLayerInMap,
        ForEachLayerInCurrentMap: TrimbleMap.Controller.ForEachLayerInCurrentMap,
        ForEachMapLayerGroupBySectionInCurrentMap: TrimbleMap.Controller.ForEachMapLayerGroupBySectionInCurrentMap,
        ForEachLayerInDynamicMapService: TrimbleMap.Controller.ForEachLayerInDynamicMapService,
        ForEachLayerInWebMapService: TrimbleMap.Controller.ForEachLayerInWebMapService,
        ForEachEsriLayerIDInMapServiceDisplay: TrimbleMap.Controller.ForEachEsriLayerIDInMapServiceDisplay,
        ForEachEsriLayerIDInWebMapServiceDisplay: TrimbleMap.Controller.ForEachEsriLayerIDInWebMapServiceDisplay,
        GetMapLayerGroupBySection: TrimbleMap.Controller.GetMapLayerGroupBySection,
        GetMapLayerGroupBySectionForMapLayer: TrimbleMap.Controller.GetMapLayerGroupBySectionForMapLayer,
        GetMapLayerGroupBySectionsForMap: TrimbleMap.Controller.GetMapLayerGroupBySectionsForMap,
        ForEachMapServiceDisplayInMap: TrimbleMap.Controller.ForEachMapServiceDisplayInMap,
        ForEachMapServiceDisplayInCurrentMap: TrimbleMap.Controller.ForEachMapServiceDisplayInCurrentMap,
        ForEachIdentifiableMapServiceInCurrentMap: TrimbleMap.Controller.ForEachIdentifiableMapServiceInCurrentMap,
        ForEachSearchableMapServiceInCurrentMap: TrimbleMap.Controller.ForEachSearchableMapServiceInCurrentMap,
        ForEachSelectableMapServiceInCurrentMap: TrimbleMap.Controller.ForEachSelectableMapServiceInCurrentMap,
        ForEachVisibleIdentifiableMapServiceInCurrentMap: TrimbleMap.Controller.ForEachVisibleIdentifiableMapServiceInCurrentMap,
        ForEachVisibleSearchableMapServiceInCurrentMap: TrimbleMap.Controller.ForEachVisibleSearchableMapServiceInCurrentMap,
        ForEachVisibleSelectableMapServiceInCurrentMap: TrimbleMap.Controller.ForEachVisibleSelectableMapServiceInCurrentMap,
        ForCurrentMapServiceInCurrentMap: TrimbleMap.Controller.ForCurrentMapServiceInCurrentMap,
        ForCurrentLayerInMap: TrimbleMap.Controller.ForCurrentLayerInMap,
        GetGeometriesFromMapServiceLayer: TrimbleMap.Controller.GetGeometriesFromMapServiceLayer,
        GetMapServiceMaxRecordCount: TrimbleMap.Controller.GetMapServiceMaxRecordCount,
        QueryMap: TrimbleMap.Controller.QueryMap,
        QueryCurrentMap: TrimbleMap.Controller.QueryCurrentMap,
        QueryMapService: TrimbleMap.Controller.QueryMapService,
        QueryWebFeatureService: TrimbleMap.Controller.QueryWebFeatureService,
        GetWebFeatureServiceFeatures: TrimbleMap.Controller.GetWebFeatureServiceFeatures,
        GetWebFeatureServiceFeatureCount: TrimbleMap.Controller.GetWebFeatureServiceFeatureCount,
        GetWebFeatureServiceLayerId: TrimbleMap.Controller.GetWebFeatureServiceLayerId,
        QueryMapServiceFromMapLayerUrls: TrimbleMap.Controller.QueryMapServiceFromMapLayerUrls,
        GetWebFeatureServiceUrlWithQueryParameters: TrimbleMap.Controller.GetWebFeatureServiceUrlWithQueryParameters,
        QueryMapLayer: TrimbleMap.Controller.QueryMapLayer,
        AddSelectionFeatureLayerToLookupTable: TrimbleMap.Controller.AddSelectionFeatureLayerToLookupTable,
        GetSelectionFeatureLayerByMapLayerID: TrimbleMap.Controller.GetSelectionFeatureLayerByMapLayerID,
        AddSelectionGraphicsLayerToLookupTable: TrimbleMap.Controller.AddSelectionGraphicsLayerToLookupTable,
        GetSelectionGraphicsLayerByMapLayerID: TrimbleMap.Controller.GetSelectionGraphicsLayerByMapLayerID,
        CreateSelectionSymbols: TrimbleMap.Controller.CreateSelectionSymbols,
        EnableAdditionalSelectionOnMapLayers: TrimbleMap.Controller.EnableAdditionalSelectionOnMapLayers,
        SelectInMap: TrimbleMap.Controller.SelectInMap,
        SelectInMapFromPreviousQueries: TrimbleMap.Controller.SelectInMapFromPreviousQueries,
        SelectInMapService: TrimbleMap.Controller.SelectInMapService,
        ClearSelection: TrimbleMap.Controller.ClearSelection,
        AddToSelection: TrimbleMap.Controller.AddToSelection,
        RemoveFromSelection: TrimbleMap.Controller.RemoveFromSelection,
        AddObjectIDFieldNameByMapLayerID: TrimbleMap.Controller.AddObjectIDFieldNameByMapLayerID,
        GetObjectIDFieldNameByMapLayerID: TrimbleMap.Controller.GetObjectIDFieldNameByMapLayerID,
        AddMapLayerDataFromService: TrimbleMap.Controller.AddMapLayerDataFromService,
        GetCachedMapLayerDataFromService: TrimbleMap.Controller.GetCachedMapLayerDataFromService,
        GetMapLayerDataFromService: TrimbleMap.Controller.GetMapLayerDataFromService,
        GetMapLayerDataFromWebFeatureService: TrimbleMap.Controller.GetMapLayerDataFromWebFeatureService,
        GetMapLayerIDFieldName: TrimbleMap.Controller.GetMapLayerIDFieldName,
        GetMapLayerTemplateFields: TrimbleMap.Controller.GetMapLayerTemplateFields,
        FilterAreaFieldsFromMapLayerTemplateFields: TrimbleMap.Controller.FilterAreaFieldsFromMapLayerTemplateFields,
        GetMapLayerRestServiceIDFieldName: TrimbleMap.Controller.GetMapLayerRestServiceIDFieldName,
        GetMapLayerIdentifyHtmlTemplate: TrimbleMap.Controller.GetMapLayerIdentifyHtmlTemplate,
        GetMapLayerSearchAndSelectHtmlTemplate: TrimbleMap.Controller.GetMapLayerSearchAndSelectHtmlTemplate,
        SelectionSymbolForGeometryType: TrimbleMap.Controller.SelectionSymbolForGeometryType,
        SetDefaultHTMLTemplatesForMapLayerFromFields: TrimbleMap.Controller.SetDefaultHTMLTemplatesForMapLayerFromFields,
        SetDefaultHTMLTemplatesForDynamicMapServiceFromFields: TrimbleMap.Controller.SetDefaultHTMLTemplatesForDynamicMapServiceFromFields,
        SetDefaultHTMLTemplatesForWebFeatureServiceFromFields: TrimbleMap.Controller.SetDefaultHTMLTemplatesForWebFeatureServiceFromFields,
        SetDefaultHTMLTemplatesForWebFeatureServiceMapLayerFromFields: TrimbleMap.Controller.SetDefaultHTMLTemplatesForWebFeatureServiceMapLayerFromFields,
        AddFieldNameToAliasMapping: TrimbleMap.Controller.AddFieldNameToAliasMapping,
        GetFieldNameForAlias: TrimbleMap.Controller.GetFieldNameForAlias,
        GetAliasForFieldName: TrimbleMap.Controller.GetAliasForFieldName,
        MapFieldNamesToAliases: TrimbleMap.Controller.MapFieldNamesToAliases,
        GetMissingTemplateFields: TrimbleMap.Controller.GetMissingTemplateFields,
        MapFieldNamesToUpperCaseFieldNames: TrimbleMap.Controller.MapFieldNamesToUpperCaseFieldNames,
        GetSelectedGeometries: TrimbleMap.Controller.GetSelectedGeometries,
        GetSelectedIDs: TrimbleMap.Controller.GetSelectedIDs,
        ZoomToGeometries: TrimbleMap.Controller.ZoomToGeometries,
        ZoomToSelection: TrimbleMap.Controller.ZoomToSelection,
        GetInitialExtentForMapServiceDisplay: TrimbleMap.Controller.GetInitialExtentForMapServiceDisplay,
        ProjectGeometry: TrimbleMap.Controller.ProjectGeometry,
        ProjectGeometries: TrimbleMap.Controller.ProjectGeometries,
        ProjectGeometriesClientSide: TrimbleMap.Controller.ProjectGeometriesClientSide,
        UseClientSideProjection: TrimbleMap.Controller.UseClientSideProjection,
        GetUseClientSideProjectionInfoFromCache: TrimbleMap.Controller.GetUseClientSideProjectionInfoFromCache,
        RemoveUseClientSideProjectionInfoFromCache: TrimbleMap.Controller.RemoveUseClientSideProjectionInfoFromCache,
        ProjectGeometriesByPoints: TrimbleMap.Controller.ProjectGeometriesByPoints,
        HaveValidGeotransformationConfigurationBetween: TrimbleMap.Controller.HaveValidGeotransformationConfigurationBetween,
        CreateEsriSpatialReference: TrimbleMap.Controller.CreateEsriSpatialReference,
        CreateProj4jsTransformer: TrimbleMap.Controller.CreateProj4jsTransformer,
        CreateProj4jsProjection: TrimbleMap.Controller.CreateProj4jsProjection,
        GetGeoTransformation: TrimbleMap.Controller.GetGeoTransformation,
        ComputeZoomToExtent: TrimbleMap.Controller.ComputeZoomToExtent,
        ExpandGeometryToExtent: TrimbleMap.Controller.ExpandGeometryToExtent,
        GetVisibleMapExtent: TrimbleMap.Controller.GetVisibleMapExtent,
        GetLegendDataForCurrentMap: TrimbleMap.Controller.GetLegendDataForCurrentMap,
        BuildDynamicMapServiceLegendData: TrimbleMap.Controller.BuildDynamicMapServiceLegendData,
        BuildWebMapServiceLegendData: TrimbleMap.Controller.BuildWebMapServiceLegendData,
        GetWebMapServiceLegendData: TrimbleMap.Controller.GetWebMapServiceLegendData,
        GetWebMapServiceLayerInfoByName: TrimbleMap.Controller.GetWebMapServiceLayerInfoByName,
        GetDummyMapForExtentDetermination: TrimbleMap.Controller.GetDummyMapForExtentDetermination,
        DetermineResultantExtent: TrimbleMap.Controller.DetermineResultantExtent,
        LogDiagnosticMessage: TrimbleMap.Controller.LogDiagnosticMessage,
        GetDiagnosticMessageByID: TrimbleMap.Controller.GetDiagnosticMessageByID,
        EsriRequestPreCallbackHandler: TrimbleMap.Controller.EsriRequestPreCallbackHandler,
        ResetFirstEsriRequestIOArgs: TrimbleMap.Controller.ResetFirstEsriRequestIOArgs,
        BuildLegendServiceUrl: TrimbleMap.Controller.BuildLegendServiceUrl,
        AddNotifyDiagnosticMessageLogged: TrimbleMap.Controller.AddNotifyDiagnosticMessageLogged,
        TriggerNotifyDiagnosticMessageLogged: TrimbleMap.Controller.TriggerNotifyDiagnosticMessageLogged,
        TriggerNotifyDiagnosticMessageLoggedForAllDiagnosticMessages: TrimbleMap.Controller.TriggerNotifyDiagnosticMessageLoggedForAllDiagnosticMessages,
        AddNotifyModuleVisibilityChanged: TrimbleMap.Controller.AddNotifyModuleVisibilityChanged,
        TriggerNotifyModuleVisibilityChanged: TrimbleMap.Controller.TriggerNotifyModuleVisibilityChanged,
        AddNotifyPreferenceChanged: TrimbleMap.Controller.AddNotifyPreferenceChanged,
        TriggerNotifyPreferenceChanged: TrimbleMap.Controller.TriggerNotifyPreferenceChanged,
        BufferShape: TrimbleMap.Controller.BufferShape,
        GeneralizeShape: TrimbleMap.Controller.GeneralizeShape,
        GeneralizeGeographicShape: TrimbleMap.Controller.GeneralizeGeographicShape,
        GeneralizeProjectedShape: TrimbleMap.Controller.GeneralizeProjectedShape,
        CreateSquareFromPoint: TrimbleMap.Controller.CreateSquareFromPoint,
        SetWMSLayersDescriptions: TrimbleMap.Controller.SetWMSLayersDescriptions,
        ConvertOgcGeometryTypeToEsriGeometryType: TrimbleMap.Controller.ConvertOgcGeometryTypeToEsriGeometryType,
        CreateMapLayerDataFromWebFeatureService: TrimbleMap.Controller.CreateMapLayerDataFromWebFeatureService
    };

    // Create the info message instance ...
    objMapController.InfoMessage = TrimbleMap.InfoMessage.CreateInstance(objMapController);

    // Diagnose the maps to display ...
    objMapController.DiagnoseMapsToDisplay();

    // Pre-process the map state ...
    objMapController.PreProcessMapControllerState();

    // Create the selection symbol ...
    objMapController.CreateSelectionSymbols();

    // Attach a call back for the esri request ...
    esri.request.setRequestPreCallback(objMapController.EsriRequestPreCallbackHandlerProxy);

    return objMapController;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateSelectionSymbols
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.CreateSelectionSymbols = function CreateSelectionSymbols() {

    // Get the instance ...
    var objMapController = this;

    // Create the selecton symbol ...
    objMapController.PolygonSelectionSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([0, 255, 255]), 2),
        new dojo.Color([0, 255, 255, 0.25]));

    // Create the selection symbol ...
    objMapController.PolylineSelectionSymbol = new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([0, 255, 255]), 2);

    // Create the selecton symbol ...
    objMapController.PointSelectionSymbol = new esri.symbol.SimpleMarkerSymbol(esri.symbol.SimpleMarkerSymbol.STYLE_CIRCLE, 3,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([0, 255, 255]), 2),
        new dojo.Color([0, 255, 255, 0.25]));
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachLayerInMap
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachLayerInMap = function ForEachLayerInMap(objMap, fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Loop through all the map service displays ...
    for (var intMapServiceDisplay = 0; intMapServiceDisplay < objMap.MapServiceDisplays.length; intMapServiceDisplay++) {

        // Get the map service display ...
        var objMapServiceDisplay = objMap.MapServiceDisplays[intMapServiceDisplay];

        // Get the map service ...
        var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

        // Loop through all the map layers ...
        for (var intMapLayer = 0; intMapLayer < objMapService.MapLayers.length; intMapLayer++) {

            // Get the map layer ...
            var objMapLayer = objMapService.MapLayers[intMapLayer];

            // Call the callback function with the map layer as argument ...
            fnCallback(objMapLayer, objMapServiceDisplay);
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachLayerInCurrentMap
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachLayerInCurrentMap = function ForEachLayerInCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Do a for each in the current map ...
    objMapController.ForEachLayerInMap(objMapController.CurrentMap, fnCallback);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachMapServiceDisplayInMap
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachMapServiceDisplayInMap = function ForEachMapServiceDisplayInMap(objMap, fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Loop through all the map service displays ...
    for (var intMapServiceDisplay = objMap.MapServiceDisplays.length - 1; intMapServiceDisplay >= 0; intMapServiceDisplay--) {

        // Get the map service display ...
        var objMapServiceDisplay = objMap.MapServiceDisplays[intMapServiceDisplay];

        // Get the map service ...
        var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

        // Call the callback function with the map servuce display and map service as arguments ...
        var blnContinue = fnCallback(objMapServiceDisplay, objMapService);

        // Stop when false returned ...
        if ((typeof blnContinue != 'undefined') && (blnContinue != null) && (!blnContinue)) { return; }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachMapServiceDisplayInCurrentMap
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachMapServiceDisplayInCurrentMap = function ForEachMapServiceDisplayInCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Do a for each in the current map ...
    objMapController.ForEachMapServiceDisplayInMap(objMapController.CurrentMap, fnCallback);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachMapLayerGroupBySectionInCurrentMap
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachMapLayerGroupBySectionInCurrentMap = function ForEachMapLayerGroupBySectionInCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Get all the map layer group by sections for the current map ...
    var arrMapLayerGroupBySections = objMapController.GetMapLayerGroupBySectionsForMap(objMapController.CurrentMap.MapID);

    // Loop through all the map service displays ...
    for (var intMapLayerGroupBySection = 0; intMapLayerGroupBySection < arrMapLayerGroupBySections.length; intMapLayerGroupBySection++) {

        // Get the map service display ...
        var objMapLayerGroupBySection = arrMapLayerGroupBySections[intMapLayerGroupBySection];

        // Call the callback function with the map layer as argument ...
        fnCallback(objMapLayerGroupBySection);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachIdentifiableMapServiceInCurrentMap
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachIdentifiableMapServiceInCurrentMap = function ForEachIdentifiableMapServiceInCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Get the queryable map services on the currenty map ...
    var objQueryableMapServices = objMapController.GetCurrentMapQueryableMapService();

    // Loop through all the identifyable map services ...
    $.each(objQueryableMapServices.Identifiable, function (intIndex, objIdentifiable) {

        // When the map service have any identifiable layer ids ...
        if (objIdentifiable.LayerIDs.length > 0) {

            // Call the callback passing in the map service and LayerIDs ...
            fnCallback(objIdentifiable.MapService, objIdentifiable.MapServiceDisplay, objIdentifiable.LayerIDs);
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachSearchableMapServiceInCurrentMap
// 			fnCallback will be called for each map service that contains searchable layers
//			fnCallback(objMapService, objMapServiceDisplay, arrLayerIDs)
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachSearchableMapServiceInCurrentMap = function ForEachSearchableMapServiceInCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Get the queryable map services on the currenty map ...
    var objQueryableMapServices = objMapController.GetCurrentMapQueryableMapService();

    // Loop through all the searchable map services ...
    $.each(objQueryableMapServices.Searchable, function (intIndex, objSearchable) {

        // When the map service have any searchable layer ids ...
        if (objSearchable.LayerIDs.length > 0) {

            // Call the callback passing in the map service and LayerIDs ...
            fnCallback(objSearchable.MapService, objSearchable.MapServiceDisplay, objSearchable.LayerIDs);
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachSelectableMapServiceInCurrentMap
// 			fnCallback will be called for each map service that contains selectable layers
//			fnCallback(objMapService, objMapServiceDisplay, arrLayerIDs)
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachSelectableMapServiceInCurrentMap = function ForEachSelectableMapServiceInCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Get the queryable map services on the currently map ...
    var objQueryableMapServices = objMapController.GetCurrentMapQueryableMapService();

    // Loop through all the selectable map services ...
    $.each(objQueryableMapServices.Selectable, function (intIndex, objSelectable) {

        // When the map service have any selectable layer ids ...
        if (objSelectable.LayerIDs.length > 0) {

            // Call the callback passing in the map service and LayerIDs ...
            fnCallback(objSelectable.MapService, objSelectable.MapServiceDisplay, objSelectable.LayerIDs);
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachVisibleIdentifiableMapServiceInCurrentMap
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachVisibleIdentifiableMapServiceInCurrentMap = function ForEachVisibleIdentifiableMapServiceInCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Get the queryable map services on the currenty map ...
    var objQueryableMapServices = objMapController.GetCurrentMapQueryableMapService();

    // Loop through all the identifyable map services ...
    objMapController.ForEachIdentifiableMapServiceInCurrentMap(function (objMapService, objMapServiceDisplay, arrMapLayerIDs) {
        if ($.grep(objMapController.MapComponentFailedDependencies, function (strMapServiceDisplayID) { return strMapServiceDisplayID === objMapServiceDisplay.MapServiceDisplayID }).length === 0) {
            // Filter to get the visible layer ids ...
            var arrVisibleLayerIDs = objMapController.FilterLayerIDsForVisibleLayerIDs(objMapServiceDisplay, arrMapLayerIDs);

            // When the map service have any visible identifiable layer ids ...
            if (arrVisibleLayerIDs.length > 0) {

                // Call the callback passing in the map service and LayerIDs ...
                fnCallback(objMapService, objMapServiceDisplay, arrVisibleLayerIDs);
            }
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachVisibleSearchableMapServiceInCurrentMap
// 			fnCallback will be called for each map service that contains searchable layers
//			fnCallback(objMapService, objMapServiceDisplay, arrLayerIDs)
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachVisibleSearchableMapServiceInCurrentMap = function ForEachVisibleSearchableMapServiceInCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Get the queryable map services on the currenty map ...
    var objQueryableMapServices = objMapController.GetCurrentMapQueryableMapService();

    // Loop through all the searchable map services ...
    objMapController.ForEachSearchableMapServiceInCurrentMap(function (objMapService, objMapServiceDisplay, arrMapLayerIDs) {
        if ($.grep(objMapController.MapComponentFailedDependencies, function (strMapServiceDisplayID) { return strMapServiceDisplayID === objMapServiceDisplay.MapServiceDisplayID }).length === 0) {
            // Filter to get the visible layer ids ...
            var arrVisibleLayerIDs = objMapController.FilterLayerIDsForVisibleLayerIDs(objMapServiceDisplay, arrMapLayerIDs);

            // When the map service have any visible identifiable layer ids ...
            if (arrVisibleLayerIDs.length > 0) {

                // Call the callback passing in the map service and LayerIDs ...
                fnCallback(objMapService, objMapServiceDisplay, arrVisibleLayerIDs);
            }
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachVisibleSelectableMapServiceInCurrentMap
// 			fnCallback will be called for each map service that contains selectable layers
//			fnCallback(objMapService, objMapServiceDisplay, arrLayerIDs)
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachVisibleSelectableMapServiceInCurrentMap = function ForEachVisibleSelectableMapServiceInCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Get the queryable map services on the currently map ...
    var objQueryableMapServices = objMapController.GetCurrentMapQueryableMapService();

    // Loop through all the selectable map services ...
    objMapController.ForEachSelectableMapServiceInCurrentMap(function (objMapService, objMapServiceDisplay, arrMapLayerIDs) {
        if ($.grep(objMapController.MapComponentFailedDependencies, function (strMapServiceDisplayID) { return strMapServiceDisplayID === objMapServiceDisplay.MapServiceDisplayID }).length === 0) {
            // Filter to get the visible layer ids ...
            var arrVisibleLayerIDs = objMapController.FilterLayerIDsForVisibleLayerIDs(objMapServiceDisplay, arrMapLayerIDs);

            // When the map service have any visible identifiable layer ids ...
            if (arrVisibleLayerIDs.length > 0) {

                // Call the callback passing in the map service and LayerIDs ...
                fnCallback(objMapService, objMapServiceDisplay, arrVisibleLayerIDs);
            }
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForCurrentMapServiceInCurrentMap
// 			fnCallback will be called for each map service that contains selectable layers
//			fnCallback(objMapService, objMapServiceDisplay, arrLayerIDs)
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForCurrentMapServiceInCurrentMap = function ForCurrentMapServiceInCurrentMap(fnCallback, strMapLayerID) {

    // Get the instance ...
    var objMapController = this;

    // Do a for each in the current map ...
    objMapController.ForCurrentLayerInMap(objMapController.CurrentMap, fnCallback, strMapLayerID);
}


// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForCurrentLayerInMap
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForCurrentLayerInMap = function ForCurrentLayerInMap(objMap, fnCallback, strMapLayerID) {

    // Get the instance ...
    var objMapController = this;

    // Loop through all the map service displays ...
    for (var intMapServiceDisplay = 0; intMapServiceDisplay < objMap.MapServiceDisplays.length; intMapServiceDisplay++) {

        // Get the map service display ...
        var objMapServiceDisplay = objMap.MapServiceDisplays[intMapServiceDisplay];

        // Get the map service ...
        var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

        // Loop through all the map layers ...
        for (var intMapLayer = 0; intMapLayer < objMapService.MapLayers.length; intMapLayer++) {

            // Get the map layer ...
            var objMapLayer = objMapService.MapLayers[intMapLayer];

            if (objMapLayer.MapLayerID == strMapLayerID) {

                // Call the callback function with the map layer as argument ...
                fnCallback(objMapService, objMapServiceDisplay);
            }

        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachLayerInDynamicMapService
//			fnCallback(objMapLayer, objDynamicLayerInfo)
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachLayerInDynamicMapService = function ForEachLayerInDynamicMapService(objMapService, objEsriDynamicMapServiceLayer, fnCallback) {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the dynamic layer infos ...
    for (var intLayerInfo = 0; intLayerInfo < objEsriDynamicMapServiceLayer.layerInfos.length; intLayerInfo++) {

        // Get the dynamic layer info ...
        var objDynamicLayerInfo = objEsriDynamicMapServiceLayer.layerInfos[intLayerInfo];

        // Get the map layer by name ...
        var objMapLayer = objMapController.GetMapLayerByName(objMapService.MapServiceID, objDynamicLayerInfo.name);

        // Call the callback function ...
        fnCallback(objMapLayer, objDynamicLayerInfo);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ForEachLayerInWebMapService
//			fnCallback(objMapLayer, objWebMapLayerInfo)
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ForEachLayerInWebMapService = function ForEachLayerInWebMapService(objMapService, objLayerInfos, fnCallback) {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the web map layer infos ...
    for (let intLayerInfo = 0; intLayerInfo < objLayerInfos.length; intLayerInfo++) {

        // Get the web map layer info ...
        let objWebMapLayerInfo = objLayerInfos[intLayerInfo];

        // Get the map layer by name ...
        let objMapLayer = objMapController.GetMapLayerByName(objMapService.MapServiceID, objWebMapLayerInfo.title);

        // Call the callback function ...
        fnCallback(objMapLayer, objWebMapLayerInfo);

        if (objWebMapLayerInfo.subLayers && objWebMapLayerInfo.subLayers.length > 0) {
            objMapController.ForEachLayerInWebMapService(objMapService, objWebMapLayerInfo.subLayers, fnCallback);
        }
    }
}

// **************************************************************************
// FUNCTION: ForEachEsriLayerIDInMapServiceDisplay
// USAGE:    Callback Signature: fnCallback(strEsriLayerID)
// **************************************************************************
TrimbleMap.Controller.ForEachEsriLayerIDInMapServiceDisplay = function ForEachEsriLayerIDInMapServiceDisplay(objMapService, objMapServiceDisplay, fnCallback) {

    // Get the controller ...
    var objMapController = this;

    switch (objMapService.MapServiceType) {
        case TrimbleMap.Controller.enumMapServiceType.Tile:

            // Not implemented for tile services ...
            throw 'TrimbleMap.Controller.ForEachEsriLayerIDInMapServiceDisplay not implemented for tile services ...';
            break;

        case TrimbleMap.Controller.enumMapServiceType.Feature:

            // Get the esri layers for the map service display ...
            var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

            // Loop through all the feature layers created for the feature service ... 
            $.each(arrEsriLayers, function (intFeatureLayer, objFeatureLayer) {

                // Call the callback function with the feature layer id ... 
                fnCallback(objFeatureLayer.LayerID);
            });
            break;

        case TrimbleMap.Controller.enumMapServiceType.Dynamic:

            // Get the esri layers for the map service display ...
            var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

            // When the layer were successfully loaded ...
            if (arrEsriLayers.length > 0) {

                // There will only be one layer which is the dynamic map service layer ...
                var objDynamicMapServiceLayer = arrEsriLayers[0];

                // Loop through all the dynamic layer infos ...
                for (var intLayerInfo = 0; intLayerInfo < objDynamicMapServiceLayer.layerInfos.length; intLayerInfo++) {

                    // Get the dynamic layer info ...
                    var objDynamicLayerInfo = objDynamicMapServiceLayer.layerInfos[intLayerInfo];

                    // Call the callback function with the layer id ... 
                    fnCallback(objDynamicLayerInfo.id);
                }
            }
            break;
        case TrimbleMap.Controller.enumMapServiceType.WebMapService:

            // Get the esri layers for the map service display
            var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

            // When the layer were successfully loaded
            if (arrEsriLayers.length > 0) {

                // There will only be one layer which is the dynamic map service layer
                var objDynamicMapServiceLayer = arrEsriLayers[0];

                // Loop through all the dynamic layer infos
                for (var intLayerInfo = 0; intLayerInfo < objDynamicMapServiceLayer.layerInfos.length; intLayerInfo++) {

                    // Get the dynamic layer info
                    var objDynamicLayerInfo = objDynamicMapServiceLayer.layerInfos[intLayerInfo];

                    if (objDynamicLayerInfo.subLayers && objDynamicLayerInfo.subLayers.length > 0) {
                        for (let intLayerInfo = 0; intLayerInfo < objDynamicLayerInfo.subLayers.length; intLayerInfo++) {
                            let objLayerInfo = objDynamicLayerInfo.subLayers[intLayerInfo];

                            objMapController.ForEachEsriLayerIDInWebMapServiceDisplay(objLayerInfo, fnCallback);
                        }
                    } else {
                        // Call the callback function with the layer id
                        let layerID = TrimbleMap.Controller.Shared.GetWebMapServiceLayerName(objDynamicLayerInfo);

                        fnCallback(layerID);
                    }
                }
            }
            break;
    }
}

// **************************************************************************
// FUNCTION: ForEachEsriLayerIDInWebMapServiceDisplay
// USAGE:    Callback Signature: fnCallback(strEsriLayerID)
// **************************************************************************
TrimbleMap.Controller.ForEachEsriLayerIDInWebMapServiceDisplay = function ForEachEsriLayerIDInWebMapServiceDisplay(objLayerInfo, fnCallback) {
    // Get the controller
    var objMapController = this;

    if (objLayerInfo.subLayers && objLayerInfo.subLayers.length > 0) {
        for (let intLayerInfo = 0; intLayerInfo < objLayerInfo.subLayers.length; intLayerInfo++) {
            let objLayerInfo = objLayerInfo.subLayers[intLayerInfo];

            objMapController.ForEachEsriLayerIDInWebMapServiceDisplay(objLayerInfo, fnCallback);
        }
    } else {
        // Call the callback function with the layer id
        let layerID = TrimbleMap.Controller.Shared.GetWebMapServiceLayerName(objLayerInfo);

        fnCallback(layerID);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapLayerGroupBySectionsForMap
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapLayerGroupBySectionsForMap = function GetMapLayerGroupBySectionsForMap(strMapID) {

    // Get the instance ...
    var objMapController = this;

    // Get the map layer group by sections for the map  ...
    var arrMapLayerGroupBySections = objMapController.State.MapLayerGroupBySections[strMapID];

    // Return the map layer group by section ...
    return arrMapLayerGroupBySections;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapLayerGroupBySection
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapLayerGroupBySection = function GetMapLayerGroupBySection(strMapLayerGroupBySectionID) {

    // Get the instance ...
    var objMapController = this;

    // Get the map layer group by section  ...
    var objMapLayerGroupBySection = objMapController.MapLayerGroupBySectionLookupTable[strMapLayerGroupBySectionID];

    // Return the map layer group by section ...
    return objMapLayerGroupBySection;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapLayerGroupBySectionForMapLayer
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapLayerGroupBySectionForMapLayer = function GetMapLayerGroupBySectionForMapLayer(strMapID, strMapLayerID) {

    // Get the instance ...
    var objMapController = this;

    // Get the map layer group by section for the map layer id ...
    var objMapLayerGroupBySection = objMapController.MapLayerGroupBySectionByMapLayerIDLookupTable[strMapID][strMapLayerID];

    // Return the map layer group by section ...
    return objMapLayerGroupBySection;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapExtent
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapExtent = function GetMapExtent() {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the extent ...
    var esriMapExtent = objMapController.EsriMap.extent;

    // Return ...
    return esriMapExtent;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetLastExtentViewedBookmark
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetLastExtentViewedBookmark = function GetLastExtentViewedBookmark() {

    // Get the map controller instance ...
    var objMapController = this;

    // Start with null ...
    var objLastExtentViewedBookmark = null;

    // When we have a last extent viewed bookmark ...
    if ((typeof objMapController.State.LastExtentViewedBookmarkID != 'undefined') &&
        (objMapController.State.LastExtentViewedBookmarkID != null) &&
        (objMapController.State.LastExtentViewedBookmarkID != SD.Guid.Shared.Empty())) {

        // Get the last extent viewed bookmark ...
        objLastExtentViewedBookmark = objMapController.GetBookmark(objMapController.State.LastExtentViewedBookmarkID);
    }

    return objLastExtentViewedBookmark;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateLastExtentViewed
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.UpdateLastExtentViewed = function UpdateLastExtentViewed(objEsriMapExtent) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the last extent viewed bookmark if any ...
    var objBookmark = objMapController.GetLastExtentViewedBookmark();

    // When we do not have a last extent viewed bookmark yet ...
    if (objBookmark == null) {

        // Create a bookmark from the current extent ...
        objBookmark = SD.Bookmark.Shared.CreateFromEsriMapExtent(objEsriMapExtent,
            'Last extent viewed bookmark',
            SD.Guid.Shared.DefaultUserID(),
            objMapController.CurrentMap.SpatialReferenceID);

        // Add the bookmark to the map controller state ...
        objMapController.AddBookmark(objBookmark);

        // Set the last extent viewed bookmark ...
        objMapController.State.LastExtentViewedBookmarkID = objBookmark.BookmarkID;

    } else {

        // Update to the current map extent ...
        objBookmark.UpdateFromEsriMapExtent(objEsriMapExtent, objMapController.CurrentMap.SpatialReferenceID);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetMapExtent
// 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.SetMapExtent = function SetMapExtent(objEsriMapExtent) {

    // Get the map controller instance ...
    var objMapController = this;

    // When the map has a defined spatial reference ...
    if ((typeof objMapController.EsriMap.spatialReference != 'undefined') && (objMapController.EsriMap.spatialReference != null)) {

        // Set the spatial reference to be the spatial reference of the map ...
        objEsriMapExtent.setSpatialReference(objMapController.EsriMap.spatialReference);
    }

    // Set the esri map's extent ...
    var objDeferred = objMapController.EsriMap.setExtent(objEsriMapExtent);

    // Return the deferred ...
    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetMapCursor
// "wait", ""
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.SetMapCursor = function SetMapCursor(strCursorState) {

    // Get the map controller instance ...
    var objMapController = this;

    // Set the cursor on the map ...
    objMapController.EsriMap.setMapCursor(strCursorState);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddGraphic
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddGraphic = function AddGraphic(objGraphic, blnMoveToBack) {

    // Get the map controller instance ...
    var objMapController = this;

    // When the map has been loaded successfully ...
    if (objMapController.IsEsriMapLoaded()) {

        //Test if dojo shape is defined & add part grapghic...
        let objAddedGraphic = objMapController.EsriMap.graphics.add(objGraphic).getDojoShape();

        if (blnMoveToBack && objAddedGraphic) {
            // move graphic to the back ...
            objAddedGraphic.moveToBack();
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveGraphic
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.RemoveGraphic = function RemoveGraphic(objGraphic) {

    // Get the map controller instance ...
    var objMapController = this;

    // When the map has been loaded successfully ...
    if (objMapController.IsEsriMapLoaded()) {

        // Remove the graphic from the map ...
        objMapController.EsriMap.graphics.remove(objGraphic);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetSpatialReferenceID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.SetSpatialReferenceID = function SetSpatialReferenceID(objMap, guidSpatialReference) {

    // Get the map controller instance ...
    var objMapController = this;

    // Set the current map's spatial reference ...
    objMap.SpatialReferenceID = guidSpatialReference;

    // Trigger the on changed event handlers ...
    objMapController.TriggerOnSpatialReferenceChanged();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetCurrentMapSpatialReference
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetCurrentMapSpatialReference = function GetCurrentMapSpatialReference() {

    // Get the map controller instance ...
    var objMapController = this;

    // And and return the spatial reference ...
    return objMapController.GetSpatialReference(objMapController.CurrentMap.SpatialReferenceID);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetCurrentMapCoordinateDisplaySpatialReference
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetCurrentMapCoordinateDisplaySpatialReference = function GetCurrentMapCoordinateDisplaySpatialReference() {

    // Get the map controller instance
    var objMapController = this;

    // And return the spatial reference
    return objMapController.GetSpatialReference(objMapController.CurrentMap.CoordinatesDisplaySpatialReference);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetGeoTransformation
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetGeoTransformation = function GetGeoTransformation(guidFromSpatialReference, guidToSpatialReference) {

    // Get the map controller instance ...
    var objMapController = this;

    // Create the geo-transformation and direction object to return ...
    var objGeoTransformationAndDirection = {
        GeoTransformation: null,
        TransformForward: true,
        RequiresTransformation: false,
        GeographicFromSpatialReferenceID: null,
        GeographicToSpatialReferenceID: null
    };

    // When the spatial references are not the same ... 
    if (guidFromSpatialReference != guidToSpatialReference) {

        // Get the from and to spatial reference information ...
        var objFromSpatialReference = objMapController.GetSpatialReference(guidFromSpatialReference);
        var objToSpatialReference = objMapController.GetSpatialReference(guidToSpatialReference);

        // Get the geographic spatial reference IDs for the "from " and "to" spatial references ...
        objGeoTransformationAndDirection.GeographicFromSpatialReferenceID = (objFromSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) ? objFromSpatialReference.GeographicSpatialReferenceID : guidFromSpatialReference;
        objGeoTransformationAndDirection.GeographicToSpatialReferenceID = (objToSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) ? objToSpatialReference.GeographicSpatialReferenceID : guidToSpatialReference;

        // A geotransfomation is required when the underlying from and to geographic spatial references is different ...
        objGeoTransformationAndDirection.RequiresTransformation = (objGeoTransformationAndDirection.GeographicFromSpatialReferenceID != objGeoTransformationAndDirection.GeographicToSpatialReferenceID);

        // When the geographic spatial references are not the same ... 
        if (objGeoTransformationAndDirection.GeographicFromSpatialReferenceID != objGeoTransformationAndDirection.GeographicToSpatialReferenceID) {

            // Loop through all the geo-transformations ...
            for (var intGeoTransformation = 0; intGeoTransformation < objMapController.State.GeoTransformations.length; intGeoTransformation++) {

                // Get the geo-transformation ...
                var objGeoTransformation = objMapController.State.GeoTransformations[intGeoTransformation];

                // When the from and to spatial references  matches ...
                if ((objGeoTransformation.FromSpatialReferenceID == objGeoTransformationAndDirection.GeographicFromSpatialReferenceID) && (objGeoTransformation.ToSpatialReferenceID == objGeoTransformationAndDirection.GeographicToSpatialReferenceID)) {

                    // Set the geo-transformation ...
                    objGeoTransformationAndDirection.GeoTransformation = objGeoTransformation;

                    // Stop searching ...
                    break;

                    // When the "from" spatial reference matches the "to" spatial reference and the "to" spatial reference matches the "from" spatial reference ...
                } else if ((objGeoTransformation.FromSpatialReferenceID == objGeoTransformationAndDirection.GeographicToSpatialReferenceID) && (objGeoTransformation.ToSpatialReferenceID == objGeoTransformationAndDirection.GeographicFromSpatialReferenceID)) {

                    // Set the geo-transformation ...
                    objGeoTransformationAndDirection.GeoTransformation = objGeoTransformation;

                    // Set to resverse the transformation ...
                    objGeoTransformationAndDirection.TransformForward = false;

                    // Stop searching ...
                    break;
                }
            }
        }
    }

    return objGeoTransformationAndDirection;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMap
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMap = function GetMap(strMapID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Lookup the map and return it ...
    return objMapController.MapLookupTable[strMapID];
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapService
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapService = function GetMapService(strMapServiceID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Lookup the map and return it ...
    return objMapController.MapServiceLookupTable[strMapServiceID];
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapServiceToken
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapServiceToken = function GetMapServiceToken(strMapServiceTokenId) {

    var strToken = "";

    if (TrimbleMap.Controller.Shared.MapServiceTokensLookupTable !== {} && strMapServiceTokenId >= 1) {

        // Lookup the map service token and return it ...
        strToken = TrimbleMap.Controller.Shared.MapServiceTokensLookupTable[strMapServiceTokenId - 1];
    }

    return strToken;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapServiceDisplay
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapServiceDisplay = function GetMapServiceDisplay(strMapServiceDisplayID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Lookup the map service display and return it ...
    return objMapController.MapServiceDisplayLookupTable[strMapServiceDisplayID];
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetSpatialReference
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetSpatialReference = function GetSpatialReference(strSpatialReferenceID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Lookup the map and return it ...
    return objMapController.SpatialReferenceLookupTable[strSpatialReferenceID];
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetUnderlyingGeographicSpatialReferenceID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetUnderlyingGeographicSpatialReferenceID = function GetUnderlyingGeographicSpatialReferenceID(strSpatialReferenceID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the flexicadastre spatial reference ...
    var objSpatialReference = objMapController.GetSpatialReference(strSpatialReferenceID);

    // Start with the id of the spatial reference ...
    var guidGeographicSpatialReference = strSpatialReferenceID;

    // When the spatial reference type is projected ...
    if (objSpatialReference.SpatialReferenceType == 'PROJECTED') {

        // Use the datum of the projection ...
        guidGeographicSpatialReference = objSpatialReference.GeographicSpatialReferenceID;
    }

    return guidGeographicSpatialReference;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetBookmark
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetBookmark = function GetBookmark(strBookmarkID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Lookup the map and return it ...
    return objMapController.BookmarkLookupTable[strBookmarkID];
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapLayer
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapLayer = function GetMapLayer(strMapLayerID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Lookup the map and return it ...
    return objMapController.MapLayerLookupTable[strMapLayerID];
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetQueryableMapService
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetQueryableMapService = function GetQueryableMapService(strMapID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Lookup the map and return it ...
    return objMapController.QueryableMapServices[strMapID];
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetSelectedGraphicsByMapLayerID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetSelectedGraphicsByMapLayerID = function GetSelectedGraphicsByMapLayerID(strMapLayerID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Lookup the map and return it ...
    return objMapController.SelectedGraphicsByMapLayerID[strMapLayerID];
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetSelectedFeatureCountByMapLayerID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetSelectedFeatureCountByMapLayerID = function GetSelectedFeatureCountByMapLayerID(strMapLayerID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the selected graphics for the map layer ...
    var dicSelectedGraphicsByMapLayerID = objMapController.GetSelectedGraphicsByMapLayerID(strMapLayerID);

    // Start with 0 ...
    var intCount = 0;

    // When we have any selected graphics for the map layer ...
    if ((typeof dicSelectedGraphicsByMapLayerID != 'undefined') && dicSelectedGraphicsByMapLayerID) {

        // Loop through the selected graphics ...
        $.each(dicSelectedGraphicsByMapLayerID, function (strKey, strValue) {

            // Increment the count ...
            intCount++;
        });
    }

    // Return the count ...
    return intCount;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetTotalSelectedFeatureCount
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetTotalSelectedFeatureCount = function GetTotalSelectedFeatureCount() {

    // Get the map controller instance ...
    var objMapController = this;

    // Start with 0 ...
    var intTotalCount = 0;

    // Loop through all the map service displays in the current map ...
    objMapController.ForEachMapServiceDisplayInCurrentMap(function (objMapServiceDisplay, objMapService) {

        // Loop throug all the map layers on the map service display ...
        $.each(objMapService.MapLayers, function (intMapLayer, objMapLayer) {

            // Add the selected feature count for the layer to the total ...
            intTotalCount += objMapController.GetSelectedFeatureCountByMapLayerID(objMapLayer.MapLayerID);
        });
    });

    // Return the count ...
    return intTotalCount;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetCurrentMapQueryableMapService
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetCurrentMapQueryableMapService = function GetCurrentMapQueryableMapService() {

    // Get the map controller instance ...
    var objMapController = this;

    // Lookup the map and return it ...
    return objMapController.GetQueryableMapService(objMapController.CurrentMap.MapID);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetAreaUnit
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetAreaUnit = function GetAreaUnit(strAreaUnitID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the distance area by id from the lookup table ...
    var objAreaUnit = objMapController.AreaUnitLookupTable[strAreaUnitID];

    // Set to return null when not found ...
    objAreaUnit = (typeof objAreaUnit != 'undefined') ? objAreaUnit : null

    // Return the area unit ...
    return objAreaUnit;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetDistanceUnit
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetDistanceUnit = function GetDistanceUnit(strDistanceUnitID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the distance unit by id from the lookup table ...
    var objDistanceUnit = objMapController.DistanceUnitLookupTable[strDistanceUnitID];

    // Return the distance unit ...
    return objDistanceUnit;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapLayerByName
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapLayerByName = function GetMapLayerByName(strMapServiceID, strMapLayerName) {

    // Get the map controller instance ...
    var objMapController = this;

    // Start with not found ...
    var objMapLayer = null;

    // When we have entries for the map service in the lookup table ...
    if (typeof objMapController.MapLayerNameLookupTable[strMapServiceID] != 'undefined') {

        // Get the lookup table that holds the Name -> MapLayer mapping for the map service ...
        var dicMapLayerByNameLookupTable = objMapController.MapLayerNameLookupTable[strMapServiceID];

        // When in the lookup table ...
        if (typeof dicMapLayerByNameLookupTable[strMapLayerName] != 'undefined') {

            // Look the map layer up ...
            objMapLayer = dicMapLayerByNameLookupTable[strMapLayerName];
        }
    }

    return objMapLayer;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetEsriLayerIDForMapLayerID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetEsriLayerIDForMapLayerID = function GetEsriLayerIDForMapLayerID(strMapLayerID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Start with -1 ...
    var intEsriLayerID = -1;

    // When found in the lookup table ...
    if (typeof objMapController.EsriMapLayerIDLookupTable[strMapLayerID] != 'undefined') {
        intEsriLayerID = objMapController.EsriMapLayerIDLookupTable[strMapLayerID];
    }

    return intEsriLayerID;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetOgcLayerIDForMapLayerID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetOgcLayerIDForMapLayerID = function GetOgcLayerIDForMapLayerID(strMapLayerID) {
    // Get the map controller instance
    var objMapController = this;

    // Start with null
    var intOgcLayerID = null;

    // When found in the lookup table
    if (typeof objMapController.OgcMapLayerIDLookupTable[strMapLayerID] != 'undefined') {
        intOgcLayerID = objMapController.OgcMapLayerIDLookupTable[strMapLayerID];
    }

    return intOgcLayerID;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapLayerIDForEsriLayerID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapLayerIDForEsriLayerID = function GetMapLayerIDForEsriLayerID(strMapServiceID, intEsriLayerID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Start with null ...
    var strMapLayerID = null;

    // When entries for the map service were found in the lookup table ...
    if (typeof objMapController.EsriMapLayerIDReverseLookupTable[strMapServiceID] != 'undefined') {

        // Get the hash table for the map service ...
        var dicEsriMapLayerIDByMapLayerIDs = objMapController.EsriMapLayerIDReverseLookupTable[strMapServiceID];

        // When entries for the map service were found in the lookup table ...
        if (typeof dicEsriMapLayerIDByMapLayerIDs[intEsriLayerID] != 'undefined') {

            // Get it and convert to a number ...
            strMapLayerID = dicEsriMapLayerIDByMapLayerIDs[intEsriLayerID];
        }
    }

    return strMapLayerID;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddMapServiceToMap
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddMapServiceToMap = function AddMapServiceToMap(objMapService, objMap, intMapServiceDisplayIndex) {

    // Get the map controller instance ...
    var objMapController = this;

    // Declare the deferred variable ...
    var objDeferred;

    // Get the current map scales ...
    var arrScales = objMapController.GetCurrentMapScales();

    // Use the default scales when no tile layer in map that defines the scales ...
    arrScales = (arrScales != null) ? arrScales : TrimbleMap.Controller.Shared.GetDefaultScales();

    // Create a map service display for the map service ...
    var objMapServiceDisplay = TrimbleMap.Controller.Shared.CreateMapServiceDisplay(objMapService, objMap.MapID, arrScales[0], arrScales[arrScales.length - 1]);

    // Insert the map service display in the list at the position where it was dropped ...
    objMap.MapServiceDisplays.splice(intMapServiceDisplayIndex, 0, objMapServiceDisplay);

    // Add it to the map services display lookup table ...
    objMapController.MapServiceDisplayLookupTable[objMapServiceDisplay.MapServiceDisplayID] = objMapServiceDisplay;

    // Update the map's spatial reference id ...
    objMapController.UpdateMapSpatialReferenceID(objMap);

    // When we've just added the first layer ...
    if (objMap.MapServiceDisplays.length == 1) {

        // Reload the map ... 
        objDeferred = objMapController.ReloadMap();

    } else {

        // Re-order the map service displays ...
        objMapController.ReOrderMapServiceDisplays(objMap, objMap.MapServiceDisplays);

        // Set the loading not to be finalized so that it will be finalized when the layer has been loaded ...
        objMapController.LoadingFinalized = false;

        // Create the layers for the map service ...
        objDeferred = objMapController.CreateMapLayersForMapService(objMapServiceDisplay);
    }

    // Return the deferred ...
    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveMapServiceDisplayFromMap
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.RemoveMapServiceDisplayFromMap = function RemoveMapServiceDisplayFromMap(objMapServiceDisplay, objMap) {

    // Get the map controller instance ...
    var objMapController = this;

    // Remove the map service display from the loaded component list ...
    objMapController.RemoveMapServiceDisplayFromLoadedComponentList(objMapServiceDisplay);

    // Get the index of the map service display in the map ...
    var intMapServiceDisplay = $.inArray(objMapServiceDisplay, objMap.MapServiceDisplays);

    // Remove the map service display from the list ...
    objMap.MapServiceDisplays.splice(intMapServiceDisplay, 1);

    // Re-oder the map service displays ...
    objMapController.ReOrderMapServiceDisplays(objMap, objMap.MapServiceDisplays);

    // Update the map's spatial reference id from the map services in the map ...
    objMapController.UpdateMapSpatialReferenceID(objMap);

    // Set the loading not to be finalized so that it will be finalized when the layer has been loaded ...
    objMapController.LoadingFinalized = false;

    // Re-add all the layers to the map ...
    objMapController.FinalizeLoading();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveMapServiceDisplayFromLoadedComponentList
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.RemoveMapServiceDisplayFromLoadedComponentList = function RemoveMapServiceDisplayFromLoadedComponentList(objMapServiceDisplay) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the loaded components for the map service display ...
    var arrLoadedComponentNames = objMapController.GetMapServiceDisplayLoadedComponents(objMapServiceDisplay);

    // Loop through all the compoments ..
    for (var intLoadedMapComponent = 0; intLoadedMapComponent < arrLoadedComponentNames.length; intLoadedMapComponent++) {

        // Get the component name ...
        var strLoadedComponentName = arrLoadedComponentNames[intLoadedMapComponent];

        // Get the loaded map component index ...
        var intLoadedMapComponentIndex = $.inArray(strLoadedComponentName, objMapController.LoadedMapComponents);

        // When found ...
        if (intLoadedMapComponentIndex > -1) {

            // Remove it from the loaded array ...
            objMapController.LoadedMapComponents.splice(intLoadedMapComponentIndex, 1);
        }

        // Get the failed map component index ...
        var intFailedMapComponentIndex = $.inArray(strLoadedComponentName, objMapController.FailedMapComponents);

        // When found ...
        if (intFailedMapComponentIndex > -1) {

            // Remove it from the failed array ...
            objMapController.FailedMapComponents.splice(intFailedMapComponentIndex, 1);
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMapServiceDisplayLoadedComponents
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetMapServiceDisplayLoadedComponents = function GetMapServiceDisplayLoadedComponents(objMapServiceDisplay) {

    // Get the map controller instance ...
    var objMapController = this;

    // Create an array to return ...
    var arrLoadedComponentNames = new Array();

    // Get the map service to display ...
    var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

    // When it is a feature layer ...
    if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Feature) {

        // Get the esri layers created for the map service display ...
        var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

        // Loop through all the layers ...
        for (var intEsriLayer = 0; intEsriLayer < arrEsriLayers.length; intEsriLayer++) {

            // Get the layer ...
            var objFeatureLayer = arrEsriLayers[intEsriLayer];

            // Add the map service display id ...
            arrLoadedComponentNames.push(objMapServiceDisplay.MapServiceDisplayID + '/' + objFeatureLayer.LayerID);
        }

    } else {

        // Add the map service display id ...
        arrLoadedComponentNames.push(objMapServiceDisplay.MapServiceDisplayID);
    }

    return arrLoadedComponentNames;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddOnScalesChanged
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddOnScalesChanged = function AddOnScalesChanged(fnOnScaleLevelsChanged) {

    // Get the map controller instance ...
    var objMapController = this;

    // Set the scale levels change callback ...
    objMapController.OnScalesChangedFunctions.push(fnOnScaleLevelsChanged);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddOnScaleChanged
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddOnScaleChanged = function AddOnScaleChanged(fnOnScaleChanged) {

    // Get the map controller instance ...
    var objMapController = this;

    // Set the scale change callback ...
    objMapController.OnScaleChangedFunctions.push(fnOnScaleChanged);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddOnSpatialReferenceChanged
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddOnSpatialReferenceChanged = function AddOnSpatialReferenceChanged(fnOnSpatialReferenceChanged) {

    // Get the map controller instance ...
    var objMapController = this;

    // Set the scale change callback ...
    objMapController.OnSpatialReferenceChangedFunctions.push(fnOnSpatialReferenceChanged);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddOnLoadedCallback
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddOnLoadedCallback = function AddOnLoadedCallback(fnAddOnLoadedCallback) {

    // Get the map controller instance ...
    var objMapController = this;

    // Add it to the callback list ...
    objMapController.OnLoadedFunctions.push(fnAddOnLoadedCallback);

    // When loading has already been completed ...
    if (objMapController.LoadingCompleted) {

        // Call the callback immediately ...
        fnAddOnLoadedCallback();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddOnExtentChangedCallback
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddOnExtentChangedCallback = function AddOnExtentChangedCallback(fnAddOnExtentChangedCallback) {

    // Get the map controller instance ...
    var objMapController = this;

    // Add it to the callback list ...
    objMapController.OnExtentChangedFunctions.push(fnAddOnExtentChangedCallback);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveOnLoadedCallback
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.RemoveOnLoadedCallback = function RemoveOnLoadedCallback(fnOnLoadedCallback) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the index of the function into the array ...
    var intOnLoadedCallback = $.inArray(fnOnLoadedCallback, objMapController.OnLoadedFunctions);

    // When in the array ...
    if (intOnLoadedCallback > -1) {

        // Remove it ...
        objMapController.OnLoadedFunctions.splice(intOnLoadedCallback, 1);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddPreReloadedCallback
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddPreReloadedCallback = function AddPreReloadedCallback(fnAddPreReloadedCallback) {

    // Get the map controller instance ...
    var objMapController = this;

    // Add it to the callback list ...
    objMapController.PreReloadedFunctions.push(fnAddPreReloadedCallback);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddOnLegendDataLoaded
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddOnLegendDataLoaded = function AddOnLegendDataLoaded(fnOnLegendDataLoaded) {

    // Get the map controller instance ...
    var objMapController = this;

    // Add it to the callback list ...
    objMapController.OnLegendDataLoadedFunctions.push(fnOnLegendDataLoaded);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveOnLegendDataLoaded
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.RemoveOnLegendDataLoaded = function RemoveOnLegendDataLoaded(fnOnLegendDataLoaded) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the loaded function index ...
    var intFunctionIndex = $.inArray(fnOnLegendDataLoaded, objMapController.OnLegendDataLoadedFunctions);

    // When found in the array ...
    if (intFunctionIndex > -1) {

        // Remove it from the functions array ...
        objMapController.OnLegendDataLoadedFunctions.splice(intFunctionIndex, 1);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION LayerReOrdered
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.LayerReOrdered = function LayerReOrdered() {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the scale levels ...
    var arrScales = objMapController.GetCurrentMapScales();

    // Use the default scales when no tile layer in the map ...
    arrScales = (arrScales != null) ? arrScales : TrimbleMap.Controller.Shared.GetDefaultScales();

    // When we've registerd the current scale levels ...
    if (objMapController.CurrentScales != null) {

        // When the scale levels changed ...
        if (!TrimbleMap.Controller.Shared.ScalesEquals(objMapController.CurrentScales, arrScales)) {

            // Fire the OnScalesChanged callback functions when we have one ...
            objMapController.TriggerOnScalesChanged(arrScales);
        }
    }

    // Set the current scale levels ...
    objMapController.CurrentScales = arrScales;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ZoomEnd
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ZoomEnd = function ZoomEnd() {

    // Get the map controller instance ...
    var objMapController = this;

    // Fire the OnScaleChanged callbacks when we have one ...
    objMapController.TriggerOnScaleChanged()
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ExtentChanged
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ExtentChanged = function ExtentChanged(e) {

    // Get the map controller instance ...
    var objMapController = this;

    // Maintain the last extent viewed ...
    objMapController.UpdateLastExtentViewed(e.extent);

    objMapController.TriggerOnExtentChangedCallbacks();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ZoomToScale
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ZoomToScale = function ZoomToScale(decScalesToZoomTo) {

    // Get the map controller instance ...
    var objMapController = this;

    // Zoom to the scale ...
    objMapController.EsriMap.setScale(decScalesToZoomTo);

    // Trigger the on scale changed event handlers ...
    objMapController.TriggerOnScaleChanged();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ZoomToShape
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ZoomToShape = function ZoomToShape(objShape) {

    // Get the instance ...
    var objMapController = this;

    // Get the extent of the shape ...
    var objShapeExtent = objShape.GetExtentEsriGeometry(objMapController);

    // Compute the zoom to extent (taking the visible extent into account) ...
    objMapController.ComputeZoomToExtent(objShapeExtent, 2, 0).then(TrimbleMap.Controller.Shared.TrapException(function (objExtentToZoomTo) {

        // Zoom to the extent ...
        objMapController.SetMapExtent(objExtentToZoomTo);
    }));
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ZoomToShapes
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ZoomToShapes = function ZoomToShapes(arrShapes) {

    // Get the instance ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we have any shapes to zoom to ...
    if (arrShapes.length > 0) {

        // Get the extents for the shapes ...
        var arrShapeExtents = $.map(arrShapes, function (objShape, intShape) { return objShape.GetExtentEsriGeometry(objMapController); });

        // Project the shapes to the spatial reference of the map ...
        TrimbleMap.Shape.Shared.ProjectShapes(arrShapes, objMapController, objMapController.CurrentMap.SpatialReferenceID, true).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedShapes) {

            // Zoom to the extents ...
            objMapController.ZoomToGeometries(arrShapeExtents).then(TrimbleMap.Controller.Shared.TrapException(function () { objDeferred.resolve(); }));
        }));

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ZoomToGeometries
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ZoomToGeometries = function ZoomToGeometries(arrGeometries) {

    // Get the instance ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we have any geometries to zoom to ...
    if (arrGeometries.length > 0) {

        // Create a new array for the extent geometries ...
        var arrExtentGeometries = [];

        var arrDeferreds = [];

        // Loop through all the geometries ...
        $.each(arrGeometries, function (intGeometry, objGeometry) {

            if (objGeometry.type != "point") {

                // Add the expanded extent to the array ...
                arrExtentGeometries.push(objGeometry.getExtent());
            }
            else {
                // Create a new deferred to return ...
                var objZoomToExtentDeferred = new dojo.Deferred();

                // Add it to the array of deferreds ...
                arrDeferreds.push(objZoomToExtentDeferred);

                objMapController.ExpandGeometryToExtent(objGeometry, 2, 0).then(TrimbleMap.Controller.Shared.TrapException(function (objExpandedExtent) {

                    // Add the expanded extent to the array ...
                    arrExtentGeometries.push(objExpandedExtent);

                    // Resolve the deferred ...
                    objZoomToExtentDeferred.resolve();
                }));
            }
        });

        // when all the deferreds in arrExtentGeometries have been resolved ...
        new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Union the extent geometries ...
            var objUnionedExtent = TrimbleMap.Geometry.Shared.UnionGeometries(arrExtentGeometries);

            // When we have a unioned extent ...
            if (objUnionedExtent != null) {

                // Compute the zoom to extent ...
                objMapController.ComputeZoomToExtent(objUnionedExtent, 2, 0).then(TrimbleMap.Controller.Shared.TrapException(function (objExtentToZoomTo) {

                    // Set the extent of the map ...
                    objMapController.SetMapExtent(objExtentToZoomTo).then(TrimbleMap.Controller.Shared.TrapException(function () {

                        // Resolve the deferred ...
                        objDeferred.resolve();
                    }));
                }));

            } else {

                // Resolve the deferred ...
                objDeferred.resolve();
            }
        }));
    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddAndZoomToShapes
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddAndZoomToShapes = function AddAndZoomToShapes(arrShapesWithSymbology) {

    if (!(typeof arrShapesWithSymbology === 'undefined' || arrShapesWithSymbology === null || arrShapesWithSymbology.length === 0)) {
        var objMapController = this;

        var arrShapes = $.map(arrShapesWithSymbology, function (objShapeWithSymbology, intShape) { return objShapeWithSymbology.Shape; });

        TrimbleMap.Shape.Shared.ProjectShapes(arrShapes, objMapController, objMapController.CurrentMap.SpatialReferenceID, false).then(function (arrProjectedShapes) {
            objMapController.AddShapesWithSymbology(arrShapesWithSymbology);
            objMapController.ZoomToShapes(arrShapes);
        });
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TriggerOnScaleChanged
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.TriggerOnScaleChanged = function TriggerOnScaleChanged() {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the scale ...
    var decScale = objMapController.EsriMap.getScale();

    // Loop through all the on scale changed functions ...
    $.each(objMapController.OnScaleChangedFunctions, function (intOnScaleChangedFunction, fnOnScaleChangedFunction) {

        // Call the callback ...
        fnOnScaleChangedFunction(decScale);
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TriggerOnScalesChanged
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.TriggerOnScalesChanged = function TriggerOnScalesChanged(arrScales) {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the on scale changed functions ...
    $.each(objMapController.OnScalesChangedFunctions, function (intOnScalesChangedFunction, fnOnScalesChangedFunction) {

        // Call the callback ...
        fnOnScalesChangedFunction(arrScales);
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TriggerOnSpatialReferenceChanged
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.TriggerOnSpatialReferenceChanged = function TriggerOnSpatialReferenceChanged() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the on spatial reference changed functions ...
    $.each(objMapController.OnSpatialReferenceChangedFunctions, function (intOnSpatialReferenceChangedFunction, fnOnSpatialReferenceChangedFunction) {

        // Call the callback ...
        fnOnSpatialReferenceChangedFunction(objMapController.GetCurrentMapSpatialReference());
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TriggerPreReloadedCallbacks
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.TriggerPreReloadedCallbacks = function TriggerPreReloadedCallbacks() {

    // Get the map controller instance ...
    var objMapController = this;

    // When reloading the map
    if (objMapController.MapLoadedOnce) {

        // Loop through all the pre reloaded functions ...
        $.each(objMapController.PreReloadedFunctions, function (intPreReloadedFunction, fnPreReloadedFunction) {

            // Call the callback ...
            fnPreReloadedFunction();
        });
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION HighlightShapesWithSymbology
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.HighlightShapesWithSymbology = function HighlightShapesWithSymbology(arrShapesWithSymbology, blnZoomToShapes) {

    var objMapController = this;

    // Remove highlight symbology from currently highlighted shapes and replace with non-highlight symbology
    objMapController.RemoveHighlightOnShapesWithSymbology();

    if (arrShapesWithSymbology && arrShapesWithSymbology.length > 0) {

        // Highlight the new shapes with highlight symbology
        let arrShapes = $.map(arrShapesWithSymbology, function (objShapeWithSymbology, intShape) { return objShapeWithSymbology.Shape; });

        TrimbleMap.Shape.Shared.ProjectShapes(arrShapes, objMapController, objMapController.CurrentMap.SpatialReferenceID, false).then(function (arrProjectedShapes) {

            for (var intIndex = 0; intIndex < arrShapesWithSymbology.length; intIndex++) {
                objMapController.AddShapeWithSymbology(arrShapesWithSymbology[intIndex].Shape, arrShapesWithSymbology[intIndex].ShapeID, arrShapesWithSymbology[intIndex].HighlightSymbol);
                objMapController.HighlightedShapesWithSymbologyByShapeID[arrShapesWithSymbology[intIndex].ShapeID] = arrShapesWithSymbology[intIndex];
            }

            if (blnZoomToShapes) {
                objMapController.ZoomToShapes(arrShapes);
            }
        });
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveHighlightOnShapesWithSymbology
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.RemoveHighlightOnShapesWithSymbology = function RemoveHighlightOnShapesWithSymbology() {
    
    var objMapController = this;

    let arrHighlightedShapesWithSymbology = [];

    // Remove highlight symbology from currently highlighted shapes and replace with non-highlight symbology
    if (Object.keys(objMapController.HighlightedShapesWithSymbologyByShapeID).length > 0) {

        Object.keys(objMapController.HighlightedShapesWithSymbologyByShapeID).forEach(function(guidShapeID, intIndex) {
            arrHighlightedShapesWithSymbology.push(objMapController.HighlightedShapesWithSymbologyByShapeID[guidShapeID]);
        });

        objMapController.RemoveShapesWithSymbology(arrHighlightedShapesWithSymbology);
        objMapController.AddShapesWithSymbology(arrHighlightedShapesWithSymbology);
        objMapController.HighlightedShapesWithSymbologyByShapeID = {};
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddShape
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddShapeWithSymbology = function AddShapeWithSymbology(objShape, guidShapeID, objSymbol) {

    var objMapController = this;

    var objGeometry = objShape.GetGeometry(objMapController, null, false);

    if (objSymbol == null) { var objSymbol = TrimbleMap.Symbols.SelectedFilledPolygon(); }

    var objGraphic = new esri.Graphic(objGeometry, objSymbol);

    objMapController.AddGraphic(objGraphic);

    // Remove current non-highlight symbology on shapes to be highlighted
    objMapController.RemoveShapeWithSymbology(guidShapeID);

    objMapController.EsriGraphicsByShapeID[guidShapeID] = objGraphic;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddShapesWithSymbology
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddShapesWithSymbology = function AddShapesWithSymbology(arrShapesWithSymbology) {
    var objMapController = this;

    for (var intIndex = 0; intIndex < arrShapesWithSymbology.length; intIndex++) {
        let objShapeWithSymbology = arrShapesWithSymbology[intIndex];
        objMapController.AddShapeWithSymbology(objShapeWithSymbology.Shape, objShapeWithSymbology.ShapeID, objShapeWithSymbology.DisplaySymbol);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveShapeWithSymbology
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.RemoveShapeWithSymbology = function RemoveShapeWithSymbology(guidShapeID) {

    var objMapController = this;

    let objGraphic = objMapController.EsriGraphicsByShapeID[guidShapeID];

    if (objGraphic) {

        objMapController.RemoveGraphic(objGraphic);
        delete objMapController.EsriGraphicsByShapeID[guidShapeID];
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveShapesWithSymbology
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.RemoveShapesWithSymbology = function RemoveShapesWithSymbology(arrShapesWithSymbology) {
    var objMapController = this;

    for (var intIndex = 0; intIndex < arrShapesWithSymbology.length; intIndex++) {
        objMapController.RemoveShapeWithSymbology(arrShapesWithSymbology[intIndex].ShapeID);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TriggerOnLoadedCallbacks
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.TriggerOnLoadedCallbacks = function TriggerOnLoadedCallbacks() {

    // Get the map controller instance ...
    var objMapController = this;

    let objAllOnLoadedCallbacksExecutedDeferred = new dojo.Deferred();

    // Loop through all the on loaded functions ...
    $.each(objMapController.OnLoadedFunctions, function (intOnLoadedFunction, fnOnLoadedFunction) {

        // Call the callback ...
        fnOnLoadedFunction(objMapController.MapLoadedOnce, objMapController.State.AllowExtentChangePostMapLoad, objAllOnLoadedCallbacksExecutedDeferred);
    });

    objAllOnLoadedCallbacksExecutedDeferred.resolve();
    
    // Set the map to be loaded at least once ...
    objMapController.MapLoadedOnce = true;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TriggerOnExtentChangedCallbacks
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.TriggerOnExtentChangedCallbacks = function TriggerOnExtentChangedCallbacks() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the on loaded functions ...
    $.each(objMapController.OnExtentChangedFunctions, function (intOnExtentChangedFunction, fnOnExtentChangedFunction) {
        let arrMapServiceDisplay = [];

        for (var intIndex = 0; intIndex < objMapController.FailedMapComponents.length; intIndex++) {
            let objMapServiceDisplay = objMapController.GetMapServiceDisplay(objMapController.FailedMapComponents[intIndex]);

            if (objMapServiceDisplay && arrMapServiceDisplay.indexOf(objMapServiceDisplay) == -1) {
                arrMapServiceDisplay.push(objMapServiceDisplay);
            }
        }

        // Call the callback ...
        fnOnExtentChangedFunction(arrMapServiceDisplay);
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TriggerOnLegendDataLoaded
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.TriggerOnLegendDataLoaded = function TriggerOnLegendDataLoaded(objMap) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the legend data for the current map ....
    var arrLegendDataForMap = objMapController.LegendData[objMap.MapID];

    // Clone the legend data loaded functions (in case a function gets removed while we are iterating through the array) ...
    var arrOnLegendDataLoadedFunctions = objMapController.OnLegendDataLoadedFunctions.slice(0);

    // Loop through all the on legend data loaded functions ...
    $.each(arrOnLegendDataLoadedFunctions, function (intOnLegendDataLoadedFunction, fnOnLegendDataLoadedFunction) {

        // Call the callback ...
        fnOnLegendDataLoadedFunction(objMap, arrLegendDataForMap);
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetScale
// USAGE    Returns the current scale of the map ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetScale = function GetScale() {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the scale ...
    var decScale = objMapController.EsriMap.getScale();

    return decScale;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetCurrentMapScales
// USAGE    Returns the scales of the current map as an array ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetCurrentMapScales = function GetCurrentMapScales() {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the scales of the current map ...
    let arrScales = objMapController.GetScales(objMapController.CurrentMap);

    return arrScales;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetScales
// USAGE    Returns the scales of the map as an array ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetScales = function GetScales(objMap) {

    // Get the map controller instance ...
    var objMapController = this;

    // Declare an array to return ...
    var arrScales = null;

    // When the map contents are being loaded ...
    if (objMapController.LoadMapContents) {

        // Get the first tiled layer on the map ...
        var objFirstEsriTiledLayer = objMapController.GetFirstEsriTileLayer(objMap);

        // When a tile layer were found ...
        if (objFirstEsriTiledLayer) {

            // When the layer has tile info (i.e. it is a valid tile service and it loaded properly) ...
            if ((typeof objFirstEsriTiledLayer.tileInfo != 'undefined') && (objFirstEsriTiledLayer.tileInfo != null)) {

                // Get the levels of detail ...
                var arrLods = objFirstEsriTiledLayer.tileInfo.lods;

                // Map the lods to the scale levels array ... 
                arrScales = $.map(arrLods, function (objLod, intLod) { return objLod.scale; });
            }
        }
    }

    return arrScales;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetLevelScale
// USAGE    Returns the scale for the level ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetLevelScale = function GetLevelScale(intLevel) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the scale for the level ...
    var decScale = objMapController.CurrentScales[intLevel];

    return decScale;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetScaleLevel
// USAGE    Returns the level with a scale that are closest to decScale ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetScaleLevel = function GetScaleLevel(decScale) {

    // Get the map controller instance ...
    var objMapController = this;

    // Start with no closest level ...
    var intClosestLevel = -1;
    var decClosestDifference;

    // Loop through all the levels ...
    for (var intLevel = 0; intLevel < objMapController.CurrentScales.length; intLevel++) {

        // Get the level scale ...
        var decLevelScale = objMapController.CurrentScales[intLevel];

        // Compute the difference ...
        var decDifference = Math.abs(decLevelScale - decScale);

        // When we do have a clozsest level and the current level is further away than it ...
        if ((intClosestLevel > -1) && (decDifference > decClosestDifference)) {

            // Stop searching (closest level already found) ...
            break;
        }

        // When we do not have a closest level yet or the level is closer ...
        if ((intClosestLevel == -1) || (decDifference < decClosestDifference)) {

            // Set to be the closest level ...
            intClosestLevel = intLevel;
            decClosestDifference = decDifference;
        }
    }

    return intClosestLevel;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetLODs
// USAGE    Returns the scales of the map as an array ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetLODs = function GetLODs(objMap) {

    // Get the map controller instance ...
    var objMapController = this;

    // Declare an array to return ...
    var arrLODs = null;

    // When the map contents are being loaded ...
    if (objMapController.LoadMapContents) {

        // Get the first tiled layer on the map ...
        var objFirstEsriTiledLayer = objMapController.GetFirstEsriTileLayer(objMap);

        // When a tile layer were found ...
        if (objFirstEsriTiledLayer) {

            // When the layer has tile info (i.e. it is a valid tile service and it loaded properly) ...
            if ((typeof objFirstEsriTiledLayer.tileInfo != 'undefined') && (objFirstEsriTiledLayer.tileInfo != null)) {

                // Get the levels of detail ...
                arrLODs = objFirstEsriTiledLayer.tileInfo.lods;
            }
        }
    }

    return arrLODs;
}

// **************************************************************************
// FUNCTION GetFirstEsriTileLayer
// **************************************************************************
TrimbleMap.Controller.GetFirstEsriTileLayer = function GetFirstEsriTileLayer(objMap) {

    // Get the map controller ...
    var objMapController = this;

    // Start with no tile layer ...
    var objEsriTiledLayer = null;

    // Loop through all the map service displays ...
    for (var intMapServiceDisplay = 0; intMapServiceDisplay < objMap.MapServiceDisplays.length; intMapServiceDisplay++) {

        // Get the map service display ...
        var objMapServiceDisplay = objMap.MapServiceDisplays[intMapServiceDisplay];

        // Get the map service ...
        var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

        // When a tile layer  ...
        if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Tile) {

            // Get the esri layer created for the map service ...
            objEsriTiledLayer = objMapController.EsriLayersByMapServiceDisplayIDLookupTable[objMapServiceDisplay.MapServiceDisplayID][0];

            // Stop looking ...
            break;
        }
    }

    return objEsriTiledLayer;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DetermineMapSpatialReferenceID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.DetermineMapSpatialReferenceID = function DetermineMapSpatialReferenceID(objMap) {

    // Get the map controller instance ...
    var objMapController = this;

    // Start with no id ...
    var guidSpatialReference = SD.Guid.Shared.Empty();

    // When we have map service displays in the map ...
    if (objMap.MapServiceDisplays.length > 0) {

        // Get the map service display ...
        var objMapService = objMapController.GetMapService(objMap.MapServiceDisplays[0].MapServiceID);

        // Get the spatial reference id ...
        guidSpatialReference = objMapService.SpatialReference;
    }

    // Return the id ...
    return guidSpatialReference;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateMapSpatialReferenceID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.UpdateMapSpatialReferenceID = function UpdateMapSpatialReferenceID(objMap) {

    // Get the map controller instance ...
    var objMapController = this;

    // Determine and set the spatial reference id ...
    var guidSpatialReference = objMapController.DetermineMapSpatialReferenceID(objMap);

    // Set the spatial reference id of the map ...
    objMapController.SetSpatialReferenceID(objMap, guidSpatialReference);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateCurrentMapSpatialReferenceID
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.UpdateCurrentMapSpatialReferenceID = function UpdateCurrentMapSpatialReferenceID() {

    // Get the map controller instance ...
    var objMapController = this;

    // Update the spatial reference id of teh current map ...
    objMapController.UpdateMapSpatialReferenceID(objMapController.CurrentMap);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetSpatialReferenceName
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetSpatialReferenceName = function GetSpatialReferenceName() {

    // Get the map controller instance ...
    var objMapController = this;

    // Start with no name ...
    var strSpatialReferenceName = '';

    // When we have map service displays ...
    if (objMapController.CurrentMap.MapServiceDisplays.length > 0) {

        // Get the map service display ...
        var objMapService = objMapController.GetMapService(objMapController.CurrentMap.MapServiceDisplays[0].MapServiceID);

        // Get the spatial reference of the map service ...
        var objSpatialReference = objMapController.GetSpatialReference(objMapService.SpatialReference);

        // Get the name ...
        strSpatialReferenceName = objSpatialReference.Name;
    }

    // Return the name ...
    return strSpatialReferenceName;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetSpatialReferenceMapServiceName
// Uages    Get the name of the map service that determines the spatial reference of the map 
//          (the first one that are added to the map) ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetSpatialReferenceMapServiceName = function GetSpatialReferenceMapServiceName() {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the map service display ...
    var strMapServiceName = objMapController.GetMapService(objMapController.CurrentMap.MapServiceDisplays[0].MapServiceID).MapServiceName;

    return strMapServiceName;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetMapServiceDisplayTransparency
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.SetMapServiceDisplayTransparency = function SetMapServiceDisplayTransparency(objMapServiceDisplay, decTransparency) {

    // Get the map controller instance ...
    var objMapController = this;

    // Set the value on the map service display ...
    objMapServiceDisplay.Transparency = decTransparency;

    // Get the esri layers for the map service display ...
    var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

    // Loop through all the esri layers ...
    $.each(arrEsriLayers, function (intEsriLayer, objEsriLayer) {

        // Set the opacity based on the Transparency value ...
        objEsriLayer.setOpacity((100.0 - decTransparency) / 100.0);
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetMapServiceDisplayScaleRange
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.SetMapServiceDisplayScaleRange = function SetMapServiceDisplayScaleRange(objMapServiceDisplay, decMinScale, decMaxScale) {

    // Get the map controller instance ...
    var objMapController = this;

    // Set the value on the map service display ...
    objMapServiceDisplay.MinScale = decMinScale;
    objMapServiceDisplay.MaxScale = decMaxScale;

    // Get the esri layers for the map service display ...
    var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

    // Loop through all the esri layers ...
    $.each(arrEsriLayers, function (intEsriLayer, objEsriLayer) {

        // Set the min and max scale ...
        objEsriLayer.setMinScale(decMinScale);
        objEsriLayer.setMaxScale(decMaxScale);
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ReOrderMapServiceDisplays
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ReOrderMapServiceDisplays = function ReOrderMapServiceDisplays(objMap, arrOrderedMapServiceDisplays, blnFinalizeLoading) {

    // Get the map controller instance ...
    var objMapController = this;

    // Set the new map service displays array ...
    objMap.MapServiceDisplays = arrOrderedMapServiceDisplays;

    // Rebuild the lookup table ...
    objMapController.BuildMapServiceDisplaysLookupTable();

    // When blnFinalizeLoading were provided and we are to finalize the loading ...
    if ((typeof blnFinalizeLoading != 'undefined') && blnFinalizeLoading) {

        // Set the loading not to be finalized so that it will be finalized when the layer has been loaded ...
        objMapController.LoadingFinalized = false;

        // Re-add all the layers to the map ...
        objMapController.FinalizeLoading();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION PreProcessMapControllerState
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.PreProcessMapControllerState = function PreProcessMapControllerState() {

    // Get the map controller instance ...
    var objMapController = this;

    // Build the lookup tables ...
    objMapController.BuildBookmarkLookupTable();
    objMapController.BuildSpatialReferenceLookupTable();
    objMapController.BuildMapServiceLookupTable();
    objMapController.BuildMapServiceTokensLookupTable();
    objMapController.BuildMapLookupTable();
    objMapController.BuildMapServiceDisplaysLookupTable();
    objMapController.BuildMapLayerLookupTable();
    objMapController.BuildMapLayerNameLookupTable();
    objMapController.BuildMapLayerGroupBySectionLookupTable();
    objMapController.BuildQueryableMapServicesList();
    objMapController.BuildAreaUnitLookupTable();
    objMapController.BuildDistanceUnitLookupTable();

    // When VisibleLayerIDsByMapServiceDisplayID is not defined ...
    if (objMapController.State.VisibleLayerIDsByMapServiceDisplayID == null) {

        // Create a new object as hash table ...
        objMapController.State.VisibleLayerIDsByMapServiceDisplayID = {};
    }

    // When VisibleMapServiceDisplayIDs is not defined ...
    if (objMapController.State.VisibleMapServiceDisplayIDs == null) {

        // Create a new object as hash table ...
        objMapController.State.VisibleMapServiceDisplayIDs = {};
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildMapLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildMapLookupTable = function BuildMapLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the maps ...
    for (var intMap = 0; intMap < objMapController.State.Maps.length; intMap++) {

        // Get the map ...
        var objMap = objMapController.State.Maps[intMap];

        // Add the lookup table ...
        objMapController.MapLookupTable[objMap.MapID] = objMap;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildMapServiceLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildMapServiceLookupTable = function BuildMapServiceLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the map service ...
    for (var intMapService = 0; intMapService < objMapController.State.MapServices.length; intMapService++) {

        // Get the map service ...
        var objMapService = objMapController.State.MapServices[intMapService];

        // Add the lookup table ...
        objMapController.MapServiceLookupTable[objMapService.MapServiceID] = objMapService;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildMapServiceDisplaysLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildMapServiceDisplaysLookupTable = function BuildMapServiceDisplaysLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Re-create the lookup table ...
    objMapController.MapServiceDisplayLookupTable = {};

    // Loop through all the maps ...
    for (var intMap = 0; intMap < objMapController.State.Maps.length; intMap++) {

        // Get the map ...
        var objMap = objMapController.State.Maps[intMap];

        // Loop through all the map service displays ...
        for (var intMapServiceDisplay = 0; intMapServiceDisplay < objMap.MapServiceDisplays.length; intMapServiceDisplay++) {

            // Get the map service dislpay ...
            var objMapServiceDisplay = objMap.MapServiceDisplays[intMapServiceDisplay];

            // Add the lookup table ...
            objMapController.MapServiceDisplayLookupTable[objMapServiceDisplay.MapServiceDisplayID] = objMapServiceDisplay;
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildSpatialReferenceLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildSpatialReferenceLookupTable = function BuildSpatialReferenceLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    objMapController.State.SpatialReferences.sort(function SortByName(a, b) {
        var aName = a.Name;
        var bName = b.Name;
        return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
    });

    // Loop through all the spatial reference ...
    for (var intSpatialReference = 0; intSpatialReference < objMapController.State.SpatialReferences.length; intSpatialReference++) {

        // Get the spatial reference ...
        var objSpatialReference = objMapController.State.SpatialReferences[intSpatialReference];

        // Add the lookup table ...
        objMapController.SpatialReferenceLookupTable[objSpatialReference.SpatialReferenceID] = objSpatialReference;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildBookmarkLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildBookmarkLookupTable = function BuildBookmarkLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a new hash table ...
    objMapController.BookmarkLookupTable = new Object();

    // Loop through all the bookmarks ...
    for (var intBookmark = 0; intBookmark < objMapController.State.Bookmarks.length; intBookmark++) {

        // Get the map ...
        var objBookmark = objMapController.State.Bookmarks[intBookmark];

        // Add the client side functions ...
        SD.Bookmark.Shared.AddFunctionsToServerSideObject(objBookmark);

        // Add the lookup table ...
        objMapController.BookmarkLookupTable[objBookmark.BookmarkID] = objBookmark;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildMapLayerGroupBySectionLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildMapLayerGroupBySectionLookupTable = function BuildMapLayerGroupBySectionLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the maps for which we have map layer group by sections ...
    $.each(objMapController.State.MapLayerGroupBySections, function (strMapID, arrMapLayerGroupBySectionsForMap) {

        // Create an object to hold the map layer group by sections for the map ...
        var objMapLayerGroupBySectionsForMap = {};

        // Place it on MapLayerGroupBySectionByMapLayerIDLookupTable for the MapID ...
        objMapController.MapLayerGroupBySectionByMapLayerIDLookupTable[strMapID] = objMapLayerGroupBySectionsForMap;

        // Loop through all the map layer group by sections  ...
        for (var intMapLayerGroupBySection = 0; intMapLayerGroupBySection < arrMapLayerGroupBySectionsForMap.length; intMapLayerGroupBySection++) {

            // Get the map service ...
            var objMapLayerGroupBySection = arrMapLayerGroupBySectionsForMap[intMapLayerGroupBySection];

            // Loop throughh all the map layers in the group by section ...
            for (var intMapLayer = 0; intMapLayer < objMapLayerGroupBySection.MapLayerIDs.length; intMapLayer++) {

                // Add the group by section to the lookup table ...
                objMapController.MapLayerGroupBySectionLookupTable[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objMapLayerGroupBySection;

                // Get the map layer id ...
                var strMapLayerID = objMapLayerGroupBySection.MapLayerIDs[intMapLayer];

                // Add the group by section to the lookup table for the map layer id ...
                objMapLayerGroupBySectionsForMap[strMapLayerID] = objMapLayerGroupBySection;
            }
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildMapLayerLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildMapLayerLookupTable = function BuildMapLayerLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the map services ...
    for (var intMapService = 0; intMapService < objMapController.State.MapServices.length; intMapService++) {

        // Get the map service ...
        var objMapService = objMapController.State.MapServices[intMapService];

        // Loop through all the map layers in the map service ...
        for (var intMapLayer = 0; intMapLayer < objMapService.MapLayers.length; intMapLayer++) {

            // Get the map layer ...
            var objMapLayer = objMapService.MapLayers[intMapLayer];

            // Add it to the lookup table ...
            objMapController.MapLayerLookupTable[objMapLayer.MapLayerID] = objMapLayer;
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildMapLayerNameLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildMapLayerNameLookupTable = function BuildMapLayerNameLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the map services ...
    for (var intMapService = 0; intMapService < objMapController.State.MapServices.length; intMapService++) {

        // Get the map service ...
        var objMapService = objMapController.State.MapServices[intMapService];

        // Create a new lookup table to hold the names by map layer id ...
        var dicMapLayerByNameLookupTable = {};

        // Add teh lookup table to the MapLayerNameLookupTable for the map service id ...
        objMapController.MapLayerNameLookupTable[objMapService.MapServiceID] = dicMapLayerByNameLookupTable;

        // Loop through all the map layers in the map service ...
        for (var intMapLayer = 0; intMapLayer < objMapService.MapLayers.length; intMapLayer++) {

            // Get the map layer ...
            var objMapLayer = objMapService.MapLayers[intMapLayer];

            // Add it to the lookup table ...
            dicMapLayerByNameLookupTable[objMapLayer.MapLayerName] = objMapLayer;
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildAreaUnitLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildAreaUnitLookupTable = function BuildAreaUnitLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the area units ...
    for (var intAreaUnits = 0; intAreaUnits < objMapController.State.AreaUnits.length; intAreaUnits++) {

        // Get the distance unit ...
        var objAreaUnit = objMapController.State.AreaUnits[intAreaUnits];

        // Add the area unit to the AreaUnitLookupTable for the area unit id ...
        objMapController.AreaUnitLookupTable[objAreaUnit.ID] = objAreaUnit;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildDistanceUnitLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildDistanceUnitLookupTable = function BuildDistanceUnitLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the distance units ...
    for (var intDistanceUnits = 0; intDistanceUnits < objMapController.State.DistanceUnits.length; intDistanceUnits++) {

        // Get the distance unit ...
        var objDistanceUnit = objMapController.State.DistanceUnits[intDistanceUnits];

        // Add the distance unit to the DistanceUnitLookupTable for the distance unit id ...
        objMapController.DistanceUnitLookupTable[objDistanceUnit.ID] = objDistanceUnit;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildMapServiceTokensLookupTable
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildMapServiceTokensLookupTable = function BuildMapServiceTokensLookupTable() {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the map service tokens ...
    for (var intMapServiceToken = 0; intMapServiceToken < objMapController.State.MapServiceTokens.length; intMapServiceToken++) {

        // Get the map service ...
        var objMapServiceToken = objMapController.State.MapServiceTokens[intMapServiceToken];

        // Add the lookup table ...
        TrimbleMap.Controller.Shared.MapServiceTokensLookupTable[objMapServiceToken.Id] = objMapServiceToken;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildQueryableMapServicesList
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.BuildQueryableMapServicesList = function BuildQueryableMapServicesList() {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a hash table that could hold the queryable for each map ...
    objMapController.QueryableMapServices = {};

    // Loop through all the maps ...
    for (var intMap = 0; intMap < objMapController.State.Maps.length; intMap++) {

        // Get the map ...
        var objMap = objMapController.State.Maps[intMap];

        // Create a new QueryableMapServices object that will contain all the information ...
        var objQueryableMapServices = { Identifiable: {}, Searchable: {}, Selectable: {} };

        // Add it to the hashtable with the MapID as key ...
        objMapController.QueryableMapServices[objMap.MapID] = objQueryableMapServices;

        // Loop through each map service display in the map ...
        objMapController.ForEachMapServiceDisplayInMap(objMap, function (objMapServiceDisplay, objMapService) {

            // Create arrays for the searchable, selectable and identifiable layers ...
            var arrSearchableLayerIDs = [];
            var arrSelectableLayerIDs = [];
            var arrIdentifiableLayerIDs = [];

            // Loop through all the map layers in the current map ...
            for (var intMapLayer = 0; intMapLayer < objMapService.MapLayers.length; intMapLayer++) {

                // Get the map layer ...
                var objMapLayer = objMapService.MapLayers[intMapLayer];

                // When searchable ...
                if (objMapLayer.Searchable) {

                    // Add it to the searchable array ...
                    arrSearchableLayerIDs.push(objMapLayer.MapLayerID);
                }

                // When selectable ...
                if (objMapLayer.Selectable) {

                    // Add it to the selectable array ...
                    arrSelectableLayerIDs.push(objMapLayer.MapLayerID);
                }

                // When identifiable ...
                if (objMapLayer.Identifiable) {

                    // Add it to the search and selectable array ...
                    arrIdentifiableLayerIDs.push(objMapLayer.MapLayerID);
                }
            }

            // When any layers are searchable ...
            if (arrSearchableLayerIDs.length > 0) {

                // When we've already found searchable layers in the map service ...
                if (typeof objQueryableMapServices.Searchable[objMapService.MapServiceID] != 'undefined') {

                    // Add the layer ids to the array ...
                    objQueryableMapServices.Searchable[objMapService.MapServiceID].LayerIDs = objQueryableMapServices.Searchable[objMapService.MapServiceID].LayerIDs.concat(arrSearchableLayerIDs);

                } else {

                    // Create the data structure and add it to the hash table ...
                    objQueryableMapServices.Searchable[objMapService.MapServiceID] = {
                        MapService: objMapService,
                        MapServiceDisplay: objMapServiceDisplay,
                        LayerIDs: arrSearchableLayerIDs
                    };
                }
            }

            // When any layers are selectable ...
            if (arrSelectableLayerIDs.length > 0) {

                // When we've already found selectable layers in the map service ...
                if (typeof objQueryableMapServices.Selectable[objMapService.MapServiceID] != 'undefined') {

                    // Add the layer ids to the array ...
                    objQueryableMapServices.Selectable[objMapService.MapServiceID].LayerIDs = objQueryableMapServices.Selectable[objMapService.MapServiceID].LayerIDs.concat(arrSelectableLayerIDs);

                } else {

                    // Create the data structure and add it to the hash table ...
                    objQueryableMapServices.Selectable[objMapService.MapServiceID] = {
                        MapService: objMapService,
                        MapServiceDisplay: objMapServiceDisplay,
                        LayerIDs: arrSelectableLayerIDs
                    };
                }
            }

            // When any layers are identifiable ...
            if (arrIdentifiableLayerIDs.length > 0) {

                // When we've already found identifiable layers in the map service ...
                if (typeof objQueryableMapServices.Identifiable[objMapService.MapServiceID] != 'undefined') {

                    // Add the layer ids to the array ...
                    objQueryableMapServices.Identifiable[objMapService.MapServiceID].LayerIDs = objQueryableMapServices.Identifiable[objMapService.MapServiceID].LayerIDs.concat(arrIdentifiableLayerIDs);

                } else {

                    // Create the data structure and add it to the hash table ...
                    objQueryableMapServices.Identifiable[objMapService.MapServiceID] = {
                        MapService: objMapService,
                        MapServiceDisplay: objMapServiceDisplay,
                        LayerIDs: arrIdentifiableLayerIDs
                    };
                }
            }
        });
    }
}

// **************************************************************************
// FUNCTION: SetEsriMapLayerIDLookupTableValue
// USAGE:    Load the javascript dependencies ...
// **************************************************************************
TrimbleMap.Controller.SetEsriMapLayerIDLookupTableValue = function SetEsriMapLayerIDLookupTableValue(strMapServiceID, strMapLayerID, intEsriMapLayerID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Add the ID to the lookup table ...
    objMapController.EsriMapLayerIDLookupTable[strMapLayerID] = intEsriMapLayerID;

    // When we do not have a lookup table for the map service yet ...
    if (typeof objMapController.EsriMapLayerIDReverseLookupTable[strMapServiceID] == 'undefined') {

        // Create a new hashtable for the map service ...
        objMapController.EsriMapLayerIDReverseLookupTable[strMapServiceID] = {};
    }

    // Get the hash table for the map service ...
    var dicEsriMapLayerIDByMapLayerIDs = objMapController.EsriMapLayerIDReverseLookupTable[strMapServiceID];

    // Set the strMapLayerID for the intEsriMapLayerID in the lokup table ...
    dicEsriMapLayerIDByMapLayerIDs[intEsriMapLayerID] = strMapLayerID;
}

// **************************************************************************
// FUNCTION: SetOgcMapLayerIDLookupTableValue
// **************************************************************************
TrimbleMap.Controller.SetOgcMapLayerIDLookupTableValue = function SetOgcMapLayerIDLookupTableValue(strMapLayerID, intOgcMapLayerID) {
    // Get the map controller instance
    var objMapController = this;

    // Add the ID to the lookup table
    objMapController.OgcMapLayerIDLookupTable[strMapLayerID] = intOgcMapLayerID;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetEsriMapLayerIDLookupTableValuesForDynamicMapService
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.SetEsriMapLayerIDLookupTableValuesForDynamicMapService = function SetEsriMapLayerIDLookupTableValuesForDynamicMapService(objMapService, objArcGISDynamicMapServiceLayer) {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the dynamic layer infos ...
    objMapController.ForEachLayerInDynamicMapService(objMapService, objArcGISDynamicMapServiceLayer, function (objMapLayer, objDynamicLayerInfo) {

        // When found ...
        if (objMapLayer) {

            // Set the esri map layer id for the FlexiCadastre map layer id in the lookup table ...
            objMapController.SetEsriMapLayerIDLookupTableValue(objMapService.MapServiceID, objMapLayer.MapLayerID, objDynamicLayerInfo.id);
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetMapLayerIDLookupTableValuesForWebMapService
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.SetMapLayerIDLookupTableValuesForWebMapService = function SetMapLayerIDLookupTableValuesForWebMapService(objMapService, objWebMapServiceLayer) {

    // Get the map controller instance ...
    var objMapController = this;

    // Loop through all the web map layer infos ...
    objMapController.ForEachLayerInWebMapService(objMapService, objWebMapServiceLayer.layerInfos, function (objMapLayer, objWebMapLayerInfo) {

        // When found ...
        if (objMapLayer) {
            let strWebMapLayerName = TrimbleMap.Controller.Shared.GetWebMapServiceLayerName(objWebMapLayerInfo);

            // Set the esri map layer id for the FlexiCadastre map layer id in the lookup table ...
            objMapController.SetEsriMapLayerIDLookupTableValue(objMapService.MapServiceID, objMapLayer.MapLayerID, strWebMapLayerName);
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ConvertMapLayerIDsToEsriLayerIDs
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ConvertMapLayerIDsToEsriLayerIDs = function ConvertMapLayerIDsToEsriLayerIDs(arrMapLayerIDs) {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a new array to return ...
    var arrEsrLayerIDs = [];

    // Loop through all the map layer IDs ...
    for (var intMapLayer = 0; intMapLayer < arrMapLayerIDs.length; intMapLayer++) {

        // Get the map layer ID ...
        var strMapLayerID = arrMapLayerIDs[intMapLayer];

        // Get the esri layer id that corresponds to the FlexiCadastre map layer id ...
        var intEsriLayerID = objMapController.GetEsriLayerIDForMapLayerID(strMapLayerID);

        // Add it to the array when found ...
        if (intEsriLayerID > -1) { arrEsrLayerIDs.push(intEsriLayerID); };
    }

    return arrEsrLayerIDs;
}

// **************************************************************************
// FUNCTION: LoadPrerequisites
// USAGE:    Load the javascript dependencies ...
// **************************************************************************
TrimbleMap.Controller.Shared.LoadPrerequisites = function LoadPrerequisites(blnLoadGoogleMapsLayer, strArcGISProxyServiceUrl, fnLoaded) {

    var arrRequiredModules = ["dojo/promise/all",
        "dojox/gfx",
        "dojo/dom",
        "esri/symbols/jsonUtils",
        "esri/geometry/geometryEngine",
        "esri/geometry/jsonUtils",
        "esri/SpatialReference",
        "esri/toolbars/draw",
        "esri/toolbars/edit",
        "dojo/Deferred",
        "dojo/promise/Promise",
        "esri/symbols/Symbol",
        "esri/geometry",
        "esri/map",
        "esri/tasks/query",
        "esri/layers/graphics",
        "esri/layers/agstiled",
        "esri/dijit/Geocoder",
        "esri/dijit/InfoWindow",
        "esri/tasks/QueryTask",
        "esri/tasks/identify",
        "esri/dijit/Legend",
        "esri/layers/ArcGISDynamicMapServiceLayer",
        "esri/layers/WMSLayer",
        "esri/tasks/FindTask",
        "esri/tasks/FindParameters",
        "esri/dijit/Scalebar",
        "dojox/fx/Shadow",
        "esri/layers/FeatureLayer",
        "esri/request",
        "esri/arcgis/utils",
        "esri/tasks/GeometryService",
        "esri/tasks/BufferParameters",
        "esri/tasks/ProjectParameters",
        "esri/tasks/PrintParameters",
        "esri/tasks/PrintTask",
        "esri/tasks/PrintTemplate",
        "esri/tasks/GeneralizeParameters",
        "esri/geometry/Circle",
        "esri/units"];

    // When we are to load the google maps layer ...
    if (blnLoadGoogleMapsLayer) {
        arrRequiredModules.push("modules/GoogleMapsLayer");
    }

    const requireFunction = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;

    // Load the modules required to work with esri maps ...
    requireFunction(arrRequiredModules, function (objDojoPromiseAll, objDojoxGfx, objDojoDom, objJsonUtils, objGeometryEngine, objGeometryJsonUtils) {

        // Set dojo.promise.all to be the loaded module ...
        if (typeof dojo == 'undefined') { dojo = {}; };
        if (typeof dojo.promise == 'undefined') { dojo.promise = {}; };
        dojo.promise.all = objDojoPromiseAll;

        // Set dojox.gfx to be the loaded module ...
        if (typeof dojox == 'undefined') { dojox = {}; };
        if (typeof dojox.gfx == 'undefined') { dojox.gfx = {}; };
        dojox.gfx = objDojoxGfx;

        // Set dojo.dom to be the loaded module ...
        if (typeof dojo.dom == 'undefined') { dojo.dom = {}; };
        dojo.dom = objDojoDom;

        // Set dojox.gfx to be the loaded module ...
        if (typeof esri == 'undefined') { esri = {}; };
        if (typeof esri.symbols == 'undefined') { esri.symbols = {}; };
        esri.symbols.jsonUtils = objJsonUtils;

        // Set esri.geometry.geometryEngine ...
        esri.geometry.geometryEngine = objGeometryEngine;

        // Set objGeometryJsonUtils to be the loaded module ...
        if (typeof esri == 'undefined') { esri = {}; };
        if (typeof esri.geometry == 'undefined') { esri.geometry = {}; };
        esri.geometry.jsonUtils = objGeometryJsonUtils;

        // Configure to use a proxy page for queries ...
        esri.config.defaults.io.proxyUrl = strArcGISProxyServiceUrl;

        // Call the loaded function ...
        fnLoaded();
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION LoadMap
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.LoadMap = function LoadMap() {

    // Get the map controller instance ...
    var objMapController = this;

    // Set the load not to be finalized ...
    objMapController.LoadingFinalized = false;

    // Create an array fro the visible map service display ids ...
    objMapController.State.VisibleMapServiceDisplayIDs = {};

    // Default LoadMapContents from the load map contents option ...
    objMapController.LoadMapContents = objMapController.LoadMapContentsOption;

    // When we are to attempt to load the map contents ...
    if (objMapController.LoadMapContents) {

        // Set to not load the map contents when we do not have any maps to display ...
        if (!objMapController.HaveMapsToDisplay) { objMapController.LoadMapContents = false; }
    }

    // When we are to attempt to load the map contents ...
    if (objMapController.LoadMapContents) {

        // Determine whether or not all the map services in the current map have the same spatial references ...
        var blnDiagnoseSpatialReferences = objMapController.DiagnoseSpatialReferences();

        // Set to not load the map contents when the spatial references are not valid ..
        if (!blnDiagnoseSpatialReferences) { objMapController.LoadMapContents = false; }
    }

    // Set the current map element if in the hidden field ...
    if (objMapController.CurentMapIDElement) { objMapController.CurentMapIDElement.val(objMapController.CurrentMap.MapID); }

    // Get the spatial reference information ...
    var objMapSpatialReferenceInformation = objMapController.GetSpatialReference(objMapController.CurrentMap.SpatialReferenceID);

    // Start with not having an initial extent bookmark ...
    var objInitialExtentBookmark = null;
    var objFallbackInitialExtentBookmark = null;

    if (objMapController.State.AllowExtentChangePostMapLoad) {
        // Get the last extent viewed when we are to use the last extent viewed ...
        if (objMapController.State.UseLastExtentViewed) { objInitialExtentBookmark = objMapController.GetLastExtentViewedBookmark(); } // Get the initial extent bookmark from the MaController.State.ClientSideInitialExtentBookmark property

        // When we do not have an initial extent so far the map have an initial extent bookmark ...
        if (objMapController.CurrentMap.InitialExtentBookmarkID != SD.Guid.Shared.Empty()) {

            // Get the initial extent of the current map ...
            objFallbackInitialExtentBookmark = objMapController.GetInitialExtentOfCurrentMap();
        }
    } else {

        objInitialExtentBookmark = objMapController.State.ClientStoredInitialExtentBookmark;
    }

    // When we do not have a last extent to use as the initial extent ...
    if (objInitialExtentBookmark == null) {

        // Set to use the initial extent of the map ...
        objInitialExtentBookmark = objFallbackInitialExtentBookmark;
        objFallbackInitialExtentBookmark = null;
    }

    // Start off with the initial extent as null ...
    objMapController.InitialExtent = null;

    // When we have an initial extend bookmark id and we have layers ...
    if (objMapController.LoadMapContents && (objInitialExtentBookmark != null) && (objMapController.CurrentMap.MapServiceDisplays.length > 0)) {

        // Get an esri extend for the initial extend ...
        objMapController.GetBookmarkExtentInSpatialReferenceOfCurrentMap(objInitialExtentBookmark).then(TrimbleMap.Controller.Shared.TrapException(function (objEsriMapExtent) {

            // Set the initial extent of the map ..
            objMapController.InitialExtent = objEsriMapExtent;

            // Create the esri map ...
            objMapController.CreateEsriMap();

        }), TrimbleMap.Controller.Shared.TrapException(function (strError) {

            // Get an esri extend for the initial extend ...
            objMapController.GetBookmarkExtentInSpatialReferenceOfCurrentMap(objFallbackInitialExtentBookmark).then(TrimbleMap.Controller.Shared.TrapException(function (objEsriMapExtent) {

                // Set the initial extent of the map ..
                objMapController.InitialExtent = objEsriMapExtent;

                // Create the esri map ...
                objMapController.CreateEsriMap();

            }), TrimbleMap.Controller.Shared.TrapException(function (strError) {

                // Create the esri map ...
                objMapController.CreateEsriMap();
            }));
        }));

    } else {

        // Create the esri map ...
        objMapController.CreateEsriMap();

        // When we are not loading the map contents or wehn we have not layers to load ...
        if ((!objMapController.LoadMapContents) || ((objMapController.CurrentMap.MapServiceDisplays.length == 0))) {

            // Consider finalizing the map ...
            objMapController.ConsiderFinalizingMap();
        }
    }
}

// **************************************************************************
// FUNCTION: CreateEmptyMap
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.CreateEmptyMap = function CreateEmptyMap() {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a legend data item and return it ...
    return {
        MapID: SD.Guid.Shared.NewID(),
        MapName: 'Empty Map',
        MapServiceDisplays: [],
        SpatialReferenceID: (objMapController.State.DefaultSpatialReferenceID != SD.Guid.Shared.Empty()) ? objMapController.State.DefaultSpatialReferenceID : objMapController.State.SpatialReferences[0].SpatialReferenceID,
        InitialExtentBookmarkID: null
    };
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DiagnoseMapsToDisplay
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.DiagnoseMapsToDisplay = function DiagnoseMapsToDisplay() {

    // Get the map controller instance ...
    var objMapController = this;

    // Determine whether or not we have any maps to display ...
    objMapController.HaveMapsToDisplay = (objMapController.State.Maps.length > 0);

    // When we do not have any maps to display ...
    if (!objMapController.HaveMapsToDisplay) {

        // Create an empty map and add it to the state ...
        objMapController.State.Maps.push(objMapController.CreateEmptyMap());

        // Set it as the current map ...
        objMapController.CurrentMapIndex = 0;
        objMapController.CurrentMap = objMapController.State.Maps[0];

        // Get the title and message translations ...

        // No maps to display
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'NoMapsToDisplayTitle');

        // No authorized maps available for display. Ensure that there are maps configured and that the current user has authorization to view at least one map
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'NoMapsToDisplayMessage');

        // No authorized maps available for display. The map will not be displayed
        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'NoMapsToDisplayEndUserMessage');

        // Log the diagnostic message ...
        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DiagnoseSpatialReferences
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.DiagnoseSpatialReferences = function DiagnoseSpatialReferences() {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a new object to contain the unique spatial reference ids ..
    var objUniqueSpatialReferenceIDs = {};

    // Loop through all the map service displays in the current map ...
    objMapController.ForEachMapServiceDisplayInCurrentMap(function (objMapServiceDisplay, objMapService) {

        // Add the map service's spatial reference ...
        objUniqueSpatialReferenceIDs[objMapService.SpatialReference] = objMapService.SpatialReference;
    });

    // Count the number of unique spatial references ...
    var intUniqueSpatialReferenceIDsCount = 0;
    $.each(objUniqueSpatialReferenceIDs, function (strSpatialReferenceID, strSpatialReferenceIDValue) { intUniqueSpatialReferenceIDsCount++; });

    // Valid when not more than one unique spatial references ...
    var blnDiagnoseSpatialReferences = (intUniqueSpatialReferenceIDsCount <= 1);

    // When more than one unique spatial reference ...
    if (!blnDiagnoseSpatialReferences) {

        // Start with an empty string ...
        var strSpatialReferences = '';

        // Loop through all the unique spatial references ...
        $.each(objUniqueSpatialReferenceIDs, function (guidSpatialReference, strSpatialReferenceIDValue) {

            // Get the spatial reference ...
            var objSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

            // Add a comma when not the first one ...
            if (strSpatialReferences.length > 0) { strSpatialReferences += ', '; }

            // Add the spatial reference name to the string ...
            strSpatialReferences += objSpatialReference.Name;
        });

        // Get the title and message translations ...

        // Mismatching coordinate systems
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CoordinateSystemMismatchTitle');

        // Not all of the map services in the map have the same coordinate system. Spatial references detected in map: %1
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CoordinateSystemMismatchMessage', strSpatialReferences);

        // Unable to load map. The coordinate systems of the map services in this map are not all the same
        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CoordinateSystemMismatchEndUserMessage');


        // Log the diagnostic message ...
        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);
    }

    return blnDiagnoseSpatialReferences;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetBookmarkExtentInSpatialReferenceOfCurrentMap
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.GetBookmarkExtentInSpatialReferenceOfCurrentMap = function GetBookmarkExtentInSpatialReferenceOfCurrentMap(objBookmark) {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Declare a map extend object to return ...
    var objEsriMapExtent = null;

    // When we have a bookmark ...
    if ((objBookmark != null) && (objBookmark.GeographicSpatialReferenceID != SD.Guid.Shared.Empty())) {

        // Create the bookmark geographic esri spatial reference ...
        var objBookmarkGeographicEsriSpatialReference = objMapController.CreateEsriSpatialReference(objBookmark.GeographicSpatialReferenceID);

        // Create the bookmark extent ...
        var objEsriMapExtent = esri.geometry.Extent(objBookmark.ExtentMinX, objBookmark.ExtentMinY,
            objBookmark.ExtentMaxX, objBookmark.ExtentMaxY,
            objBookmarkGeographicEsriSpatialReference);

        // Project to the spatial reference of the map ...
        var objProjectGeometryDeferred = objMapController.ProjectGeometry(objEsriMapExtent, objBookmark.GeographicSpatialReferenceID, objMapController.CurrentMap.SpatialReferenceID, true, TrimbleMap.enumProjectionLevel.RELAXED);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedExtent) {

            // Resolve the deferred with the extend ...
            objDeferred.resolve(objProjectedExtent);

        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

            // Get the title and message translations ...

            // Reprojection of bookmark extent failed
            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'BookmarkReprojectionFailedTitle');

            // Attempting to reproject the bookmark extent to the extent of the map failed
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'BookmarkReprojectionFailedMessage');

            // Unable to zoom to bookmark
            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'BookmarkReprojectionFailedEndUserMessage');

            // Log the diagnostic message ...
            objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

            // Reject the deferred with the error ... 
            objDeferred.reject(objError);
        }));

    } else {

        // Resolve the deferred with null ...
        objDeferred.resolve(null);
    }

    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddBookmark
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.AddBookmark = function AddBookmark(objBookmark) {

    // Get the map controller instance ...
    var objMapController = this;

    // Add it to the array of bookmarks ...
    objMapController.State.Bookmarks.push(objBookmark);

    // Sort the bookmarks alphabetically by bookmark name ...
    objMapController.State.Bookmarks.sort(function (objItemA, objItemB) {

        // Get the bookmarks' names and convert them to lower case ...
        var strBookmarkNameA = objItemA.BookmarkName.toLowerCase();
        var strBookmarkNameB = objItemB.BookmarkName.toLowerCase();

        // Return -1 when smaller, 1 when larger and 0 when equal ...
        if (strBookmarkNameA < strBookmarkNameB) { return -1; } else if (strBookmarkNameA > strBookmarkNameB) { return 1; } else { return 0; }
    });

    // Add the lookup table ...
    objMapController.BookmarkLookupTable[objBookmark.BookmarkID] = objBookmark;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetMapIndex
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.SetMapIndex = function SetMapIndex(intMapIndex) {

    // Get the map controller instance ...
    var objMapController = this;

    // When not already set to the map index that we are to change to ...
    if (objMapController.State.CurrentMapIndex != intMapIndex) {

        // Reload the map ...
        objMapController.ReloadMap(TrimbleMap.Controller.Shared.TrapException(function () {

            // Set the current map index ...
            objMapController.State.CurrentMapIndex = intMapIndex;

            // Get the current map ...
            objMapController.CurrentMap = objMapController.State.Maps[objMapController.State.CurrentMapIndex];

            // Allow application of user map settings on map change
            objMapController.State.ApplyMapSettingsOnMapChange = true;

            // Apply user settings for the new map if available in local storage
            objMapController.ApplyUserMapSettingsProxy(objMapController.CurrentMap.MapID);

            // Clear map legend data so it can be recreated using local storage settings
            delete objMapController.LegendData[objMapController.CurrentMap.MapID];
            delete objMapController.LoadingLegendDataForMap[objMapController.CurrentMap.MapID];

        }));
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ReloadMap
// USAGE    fnAfterDestroyBeforeReCreate is an optional function that will be called after destroying
//          the map and before reloading the map ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.ReloadMap = function ReloadMap(fnAfterDestroyBeforeReCreate) {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a new deferred ...
    var objDeferred = new dojo.Deferred();

    // Trigger the pre-reloaded callbacks ...
    objMapController.TriggerPreReloadedCallbacks();

    // Destroy the scale bar ...
    if (objMapController.Scalebar) { objMapController.Scalebar.destroy(); }

    // Destroy the map currently being displayed ...
    objMapController.DestroyMap();

    // Set the loading not to be completed yet ...
    objMapController.LoadingCompleted = false;

    // Call fnAfterDestroyBeforeReCreate if set ...
    if ((typeof fnAfterDestroyBeforeReCreate != 'undefined') && (fnAfterDestroyBeforeReCreate != null)) { fnAfterDestroyBeforeReCreate(); }

    // Define a function to be called when the map has been loaded ... 
    var fnOnLoaded = function () {

        // Remove the on loaded callback ...
        objMapController.RemoveOnLoadedCallback(fnOnLoaded);

        // Resolve the deferred to indicate that ReloadMap has completed successfully ...
        objDeferred.resolve();
    };

    // Add the on loaded callback ...
    objMapController.AddOnLoadedCallback(fnOnLoaded);

    // Reload the map ...
    objMapController.LoadMap();

    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DestroyMap
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.DestroyMap = function DestroyMap() {

    // Get the map controller instance ...
    var objMapController = this;

    // Destroy the map ...
    objMapController.EsriMap.destroy();

    // Delete the map object to avoid any possible memory leaks ...
    delete objMapController.EsriMap;

    // Set EsriMap to null ...
    objMapController.EsriMap = null;

    // Loop through all the map services to diplay in the map ...
    for (var intMapServiceDisplay = 0; intMapServiceDisplay < objMapController.CurrentMap.MapServiceDisplays.length; intMapServiceDisplay++) {

        // Get the map service display ...
        var objMapServiceDisplay = objMapController.CurrentMap.MapServiceDisplays[intMapServiceDisplay];

        // When we have an entry for the map service id ...
        if (typeof objMapController.EsriLayersByMapServiceDisplayIDLookupTable[objMapServiceDisplay.MapServiceDisplayID] != 'undefined') {

            // Delete the array ...
            delete objMapController.EsriLayersByMapServiceDisplayIDLookupTable[objMapServiceDisplay.MapServiceDisplayID];
        }
    }

    // Delete the lookup table ... 
    delete objMapController.EsriLayersByMapServiceDisplayIDLookupTable;

    // Create a new lookup table ...
    objMapController.EsriLayersByMapServiceDisplayIDLookupTable = {};

    // Clear the component loaded and failed arrays ...
    objMapController.LoadedMapComponents = [];
    objMapController.FailedMapComponents = [];

    // When we have a dummy map for extent determination ...
    if (objMapController.DummyMapForExtentDetermination != null) {

        // Destroy the dummy map ...
        objMapController.DummyMapForExtentDetermination.destroy();

        // Delete the dummy map object to avoid any possible memory leaks ...
        delete objMapController.DummyMapForExtentDetermination;

        // Set it to null ...
        objMapController.DummyMapForExtentDetermination = null;

        // Clear the dummy map ...
        objMapController.DummyMapElementForExtentDetermination.empty();
    }
}

// **************************************************************************
// FUNCTION CreateMapLayers
// **************************************************************************
TrimbleMap.Controller.CreateMapLayers = function CreateMapLayers() {

    // Get the map controller instance ...
    var objMapController = this;

    // When we are to load the layers ...
    if (objMapController.LoadMapContents) {

        // Loop through all the map services to diplay in the map ...
        for (var intMapServiceDisplay = 0; intMapServiceDisplay < objMapController.CurrentMap.MapServiceDisplays.length; intMapServiceDisplay++) {

            // Get the map service display ...
            var objMapServiceDisplay = objMapController.CurrentMap.MapServiceDisplays[intMapServiceDisplay];

            // Create the layer for the map service ...
            objMapController.CreateMapLayersForMapService(objMapServiceDisplay);

            // Only add map service display ID to VisibleMapServiceDisplayIDs if the map service display is to be set to visible
            if (objMapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings && objMapController.State.ClientStoredVisibleMapServiceDisplayIDs) {

                if (objMapController.State.ClientStoredVisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID]) {

                    objMapController.State.VisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID] = true;
                }

            } else {
                // Add the map service display ID to VisibleMapServiceDisplayIDs ...
                objMapController.State.VisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID] = true;
            }
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateMapLayersForMapService
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.CreateMapLayersForMapService = function CreateMapLayersForMapService(objMapServiceDisplay) {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a new deferred ...
    var objDeferred = new dojo.Deferred();

    // Get the map service to display ...
    var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

    var objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

    if (objMapServiceRestUrlWithToken.Success) {

        //Esri layer/map service to be created
        let objLayer;

        // Do different things for different map service types ...
        switch (objMapService.MapServiceType) {

            case TrimbleMap.Controller.enumMapServiceType.Tile:

                // Create a tiled map service layer ...
                objLayer = new esri.layers.ArcGISTiledMapServiceLayer(objMapServiceRestUrlWithToken.RestUrlWithToken, { resampling: true });
                break;

            case TrimbleMap.Controller.enumMapServiceType.Feature:

                // Add the format parameter and request json ...
                var strRestUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(objMapServiceRestUrlWithToken.RestUrlWithToken, 'f=json');

                // When cors is not supported ...
                if (!$.support.cors) {

                    // Set to rather get the feature service infomation through our cors proxy ...
                    strRestUrl = objMapController.CorsProxyServiceUrl + "?URL=" + encodeURIComponent(strRestUrl);
                }

                // Create a new object that is set to be a feature service ...
                objLayer = { IsFeatureService: true };

                // Create a new array for the feature layers ...
                objLayer.FeatureLayers = new Array();

                // Create a new deferred for the feature service information request ...
                objLayer.Deferred = new dojo.Deferred();

                // Call the web service to get the feature service information ...
                $.ajax({
                    url: strRestUrl,
                    dataType: 'json',
                    context: {},
                    async: true,
                    cache: false,
                    complete: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus) {

                        // Parse the json response ...
                        var objFeatureService = JSON.parse(jqXHR.responseText);

                        if (objFeatureService) {
                            if (objFeatureService.serviceDescription) {
                                // Set the map service description
                                objMapService.Description = sanitizeHtml(objFeatureService.serviceDescription);
                            }

                            // When we got the layers back ...
                            if ((typeof objFeatureService.layers != 'undefined') && (objFeatureService.layers.length > 0)) {
                                // Set the feature service ...
                                objMapService.FeatureService = objFeatureService;

                                // Resolve the deferred ...
                                objLayer.Deferred.resolve(objFeatureService);

                                // Create a new array for the deferreds ...
                                var arrDeferreds = [];

                                // Loop through all the layers on the feature service ...
                                for (var intFeatureLayer = objFeatureService.layers.length - 1; intFeatureLayer >= 0; intFeatureLayer--) {

                                    // Get the feature layer ...
                                    var objFeatureLayerInformation = objFeatureService.layers[intFeatureLayer];

                                    // Set up the visiblity option based on the defaultVisibility from the service when available ...
                                    var objOptions = { visible: (typeof objFeatureLayerInformation.defaultVisibility == 'undefined') ? true : objFeatureLayerInformation.defaultVisibility };

                                    // Create a new deferred for the feature layer creation process ...
                                    var objFeatureLayerDeferred = new dojo.Deferred();

                                    // Add it to the array of deferreds ...
                                    arrDeferreds.push(objFeatureLayerDeferred);

                                    var objMapLayerRestUrlWithToken = TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, objFeatureLayerInformation.id);

                                    if (objMapLayerRestUrlWithToken.Success) {
                                        // Create a new feature layer ...
                                        let objFeatureLayer = new esri.layers.FeatureLayer(objMapLayerRestUrlWithToken.RestUrlWithToken);

                                        // Get the request's IO arguments ...
                                        var objRequestIOArgs = objMapController.LastEsriRequestIOArgs;

                                        // Set the layer id ...
                                        objFeatureLayer.LayerID = objFeatureLayerInformation.id;

                                        // Add to the list of feature layers created for the feature service ...
                                        objLayer.FeatureLayers.push(objFeatureLayer);

                                        // Add the on load event handler ...
                                        objMapController.AddOnLayerLoad(objFeatureLayer, objMapServiceDisplay, '/' + objFeatureLayer.LayerID, objFeatureLayerDeferred, objRequestIOArgs);

                                        // Add to the dictionary of layers created for the map service ...
                                        objMapController.AddToEsriLayersLookupTable(objMapServiceDisplay, objFeatureLayer);
                                    }
                                    else {
                                        objFeatureLayerDeferred.reject(objMapLayerRestUrlWithToken.Error);
                                    }
                                }

                                // Resolve objDeferred when all the deferreds in arrDeferreds have been resolved ...
                                (new dojo.promise.all(arrDeferreds)).then(TrimbleMap.Controller.Shared.TrapException(function () { objDeferred.resolve(); }));

                            } else {

                                // Get the title and message translations ...

                                // Query to retrieve information from feature service failed
                                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FeatureServiceFailedTitle');

                                // Query to retrieve information from feature service %1 failed. The layer might not show in the map and search, identify and selection will not return any results.
                                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FeatureServiceFailedMessage', objMapService.MapServiceName);

                                // Unable to load map service %1. The data for this map service will not be displayed in the map and any interaction with this map service will not return any results.
                                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FeatureServiceFailedEndUserMessages', objMapService.MapServiceName);

                                let strCrashMessage = '';

                                if (objFeatureService) {
                                    strCrashMessage = (typeof objFeatureService.error != 'undefined') ? TrimbleMap.Controller.Shared.BuildCrashMessage(objFeatureService.error) : objFeatureService.toString();
                                }

                                // Log the diagnostic message ...
                                objMapController.LogDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.RemoveJsonFromatParameterFromUrl(strRestUrl));

                                // Notify that the load has been completed ...
                                objMapController.ComponentLoadCompleted(objMapServiceDisplay.MapServiceDisplayID, false);

                                // Reject the deferred ...
                                objDeferred.resolve();
                            }
                        }
                    }),
                    error: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus, errorThrown) {

                        // Get the title and message translations ...

                        // Query to retrieve information from feature service failed
                        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FeatureServiceFailedTitle');

                        // Query to retrieve information from feature service %1 failed. The layer might not show in the map and search, identify and selection will not return any results.
                        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FeatureServiceFailedMessage', objMapService.MapServiceName);

                        // Unable to load map service %1. The data for this map service will not be displayed in the map and any interaction with this map service will not return any results.
                        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FeatureServiceFailedEndUserMessages', objMapService.MapServiceName);

                        var strCrashMessage = textStatus + '[' + errorThrown + ']';

                        // Log the diagnostic message ...
                        objMapController.LogDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.RemoveJsonFromatParameterFromUrl(strRestUrl));

                        // Notify that the load has been completed ...
                        objMapController.ComponentLoadCompleted(objMapServiceDisplay.MapServiceDisplayID, false);

                        // Reject the deferred ...
                        objDeferred.resolve();
                    })
                });
                break;

            case TrimbleMap.Controller.enumMapServiceType.Dynamic:

                // Add the format parameter and request json
                var strRestUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(objMapServiceRestUrlWithToken.RestUrlWithToken, 'f=json');

                // When cors is not supported
                if (!$.support.cors) {

                    // Set to rather get the map service infomation through our cors proxy
                    strRestUrl = objMapController.CorsProxyServiceUrl + "?URL=" + encodeURIComponent(strRestUrl);
                }

                // Call the web service to get the map service information
                $.ajax({
                    url: strRestUrl,
                    dataType: 'json',
                    context: {},
                    async: true,
                    cache: false,
                    complete: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus) {
                        if (jqXHR.responseText) {
                            try {
                                // Parse the json response
                                var objDynamicMapService = JSON.parse(jqXHR.responseText);

                                // Set the map service description
                                objMapService.Description = sanitizeHtml(objDynamicMapService.serviceDescription);
                            } catch (e) {

                            }
                        }
                    }),
                    error: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus, errorThrown) {
                    })
                });

                // Create a new dynamic map service layer
                objLayer = new esri.layers.ArcGISDynamicMapServiceLayer(objMapServiceRestUrlWithToken.RestUrlWithToken);
                break;

            case TrimbleMap.Controller.enumMapServiceType.WebMapService:

                let arrPathArray = objMapServiceRestUrlWithToken.RestUrlWithToken.split('/');
                let strHost = arrPathArray[2];

                if (!esri.getProxyRule(strHost)) {
                    esri.addProxyRule({
                        urlPrefix: strHost,
                        proxyUrl: objMapController.State.ArcGISProxyServiceUrl
                    });
                }

                let strProtocol = arrPathArray[0];

                if (strProtocol.indexOf('https') > -1) {
                    let strHttpsHost = strHost + ':443';

                    if (!esri.getProxyRule(strHttpsHost)) {
                        esri.addProxyRule({
                            urlPrefix: strHttpsHost,
                            proxyUrl: objMapController.State.ArcGISProxyServiceUrl
                        });
                    }
                }

                // Create a new Web Map Service layer
                // Append map service Id so that we can get details of map service when proxy url is hit and add basic authorization header before making request (used when map layer is loaded up)
                objLayer = new esri.layers.WMSLayer(TrimbleMap.Controller.Shared.AddQueryStringParameter(objMapServiceRestUrlWithToken.RestUrlWithToken, 'MapServiceID=' + objMapService.MapServiceID));

                // Append map service Id so that we can get details of map service when proxy url is hit and add basic authorization header before making request (used when any subsequent map layer calls are made)
                objLayer.setCustomParameters({
                    Token: objMapServiceRestUrlWithToken.Token,
                    MapServiceID: objMapService.MapServiceID
                });
                break;
        }

        if (objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.Tile || objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.Dynamic || objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.WebMapService) {
            // Get the request's IO arguments ...
            var objRequestIOArgs = objMapController.LastEsriRequestIOArgs;

            // Add the on load event handler ...
            objMapController.AddOnLayerLoad(objLayer, objMapServiceDisplay, '', objDeferred, objRequestIOArgs);

            // Add to the dictionary of layers created for the map service ...
            objMapController.AddToEsriLayersLookupTable(objMapServiceDisplay, objLayer);
        }
    }
    else {

        // Map service token expired
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

        // Log a diagnostic info message ...
        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

        objDeferred.resolve();
    }
    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateSelectionFeatureLayersForDynamicMapService
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.CreateSelectionFeatureLayersForDynamicMapService = function CreateSelectionFeatureLayersForDynamicMapService(objMapService, objArcGISDynamicMapServiceLayer) {

    // Get the map controller instance ...
    var objMapController = this;

    var objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

    if (objMapServiceRestUrlWithToken.Success) {

        // Loop through all the dynamic layer infos ...
        objMapController.ForEachLayerInDynamicMapService(objMapService, objArcGISDynamicMapServiceLayer, function (objMapLayer, objDynamicLayerInfo) {

            // When the layer is searchable and selectable ...
            if (objMapLayer && objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {

                // Create the selection feature layer ...
                objMapController.CreateSelectionFeatureLayer(objMapLayer, objMapService, TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, objDynamicLayerInfo.id).RestUrlWithToken);
            }
        });
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateSelectionFeatureLayersForWebFeatureService
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.CreateSelectionFeatureLayersForWebFeatureService = function CreateSelectionFeatureLayersForWebFeatureService(objMapService, arrWebMapServiceLayers) {
    // Get the map controller instance
    let objMapController = this;

    // Loop through all the dynamic layer infos
    objMapController.ForEachLayerInWebMapService(objMapService, arrWebMapServiceLayers, function (objMapLayer, objLayerInfo) {
        // When the layer is searchable and selectable
        if (objMapLayer && objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {
            // Create the selection feature layer
            objMapController.CreateSelectionFeatureLayer(objMapLayer, objMapService);
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateSelectionFeatureLayer
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Controller.CreateSelectionFeatureLayer = function CreateSelectionFeatureLayer(objMapLayer, objMapService, strLayerRestUrl) {

    // Get the map controller instance ...
    var objMapController = this;

    // When we are to create a selection feature layer for the map layer ...
    if (objMapController.IsLayerToCreateSelectionFeatureLayerFor(objMapService, objMapLayer)) {
        if (objMapService.MapServiceType !== TrimbleMap.Controller.enumMapServiceType.WebMapService) {
            // Only set to return the ID field when not generic, otherwise set to return all the fields ...
            let arrOutFields = (objMapLayer.IsGeneric) ? ['*'] : objMapController.GetMapLayerTemplateFields(objMapLayer, false);

            // Create the selection feature layer ...
            let objSelectionFeatureLayer = new esri.layers.FeatureLayer(strLayerRestUrl, { mode: esri.layers.FeatureLayer.MODE_SELECTION, outFields: arrOutFields });

            // Get the request's IO arguments ...
            let objRequestIOArgs = objMapController.LastEsriRequestIOArgs;

            // Add the on layer load event handler ...
            objMapController.AddOnSelectionFeatureLayerOnLayerLoad(objSelectionFeatureLayer, objMapLayer, objMapService, objRequestIOArgs);

            // Add it to the selection feature layer hash table ...
            objMapController.AddSelectionFeatureLayerToLookupTable(objMapLayer.MapLayerID, objSelectionFeatureLayer);
        }

        // Create a graphics layer for the selected features ...
        let objSelectionGraphicsLayer = new esri.layers.GraphicsLayer();

        // Add it to the selection graphics layer hash table ...
        objMapController.AddSelectionGraphicsLayerToLookupTable(objMapLayer.MapLayerID, objSelectionGraphicsLayer);
    }
}

// **************************************************************************
// FUNCTION: EnableAdditionalSelectionOnMapLayers
// USAGE:    This function allows you do to programmatic selection on layers 
//           that are not configred as selectable 
//           Function fnIsAdditionalSelectionEnabledOnMapLayer will be 
//           called for every layer and should return true when a layer is 
//           to be allowed to perform programatic selection on ...
//           Function Signature:
//           fnIsAdditionalSelectionEnabledOnMapLayer(objMapService, objMapLayer)
// **************************************************************************
TrimbleMap.Controller.EnableAdditionalSelectionOnMapLayers = function EnableAdditionalSelectionOnMapLayers(fnIsAdditionalSelectionEnabledOnMapLayer) {

    // Get the controller ...
    var objMapController = this;

    // Set the function that will return true for layers on which programmatic selection is to be performed ...
    objMapController.IsAdditionalSelectionEnabledOnMapLayerFunction = fnIsAdditionalSelectionEnabledOnMapLayer;
}

// **************************************************************************
// FUNCTION IsLayerToCreateSelectionFeatureLayerFor
// **************************************************************************
TrimbleMap.Controller.IsLayerToCreateSelectionFeatureLayerFor = function IsLayerToCreateSelectionFeatureLayerFor(objMapService, objMapLayer) {

    // Get the map controller instance ...
    var objMapController = this;

    // Return true when it is a selectable map layer or when the layer is to be allowed programmatic selection on ...
    return objMapLayer.Selectable || (
        (typeof objMapController.IsAdditionalSelectionEnabledOnMapLayerFunction != 'undefined') &&
        (objMapController.IsAdditionalSelectionEnabledOnMapLayerFunction != null) &&
        (objMapController.IsAdditionalSelectionEnabledOnMapLayerFunction(objMapService, objMapLayer)));
}

// **************************************************************************
// FUNCTION SelectionSymbolForGeometryType
// Usage    Possible values for strGeometryType:
//            - esriGeometryPoint
//            - esriGeometryPolyline
//            - esriGeometryPolygon
// **************************************************************************
TrimbleMap.Controller.SelectionSymbolForGeometryType = function SelectionSymbolForGeometryType(strGeometryType) {

    // Get the map controller instance ...
    var objMapController = this;

    // Return the geometry type based on the seletion symbol ...
    switch (strGeometryType) {
        case "esriGeometryPoint":
            return objMapController.PointSelectionSymbol;
            break;
        case "esriGeometryPolyline":
            return objMapController.PolylineSelectionSymbol;
            break;
        case "esriGeometryPolygon":
            return objMapController.PolygonSelectionSymbol;
            break;
    }
}

// **************************************************************************
// FUNCTION AddSelectionGraphicsLayerToLookupTable
// **************************************************************************
TrimbleMap.Controller.AddSelectionGraphicsLayerToLookupTable = function AddSelectionGraphicsLayerToLookupTable(strMapLayerID, objSelectionGraphicsLayer) {

    // Get the map controller instance ...
    var objMapController = this;

    // Add it to the lookup table ...
    objMapController.SelectionGraphicsLayers[strMapLayerID] = objSelectionGraphicsLayer;
}

// **************************************************************************
// FUNCTION GetSelectionGraphicsLayerByMapLayerID
// **************************************************************************
TrimbleMap.Controller.GetSelectionGraphicsLayerByMapLayerID = function GetSelectionGraphicsLayerByMapLayerID(strMapLayerID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the selection graohics layer for the map layer id ...
    var objSelectionGraphicsLayer = objMapController.SelectionGraphicsLayers[strMapLayerID];

    return objSelectionGraphicsLayer;
}

// **************************************************************************
// FUNCTION AddSelectionFeatureLayerToLookupTable
// **************************************************************************
TrimbleMap.Controller.AddSelectionFeatureLayerToLookupTable = function AddSelectionFeatureLayerToLookupTable(strMapLayerID, objSelectionFeatureLayer) {

    // Get the map controller instance ...
    var objMapController = this;

    // Add it to the lookup table ...
    objMapController.SelectionFeatureLayers[strMapLayerID] = objSelectionFeatureLayer;
}

// **************************************************************************
// FUNCTION GetSelectionFeatureLayerByMapLayerID
// **************************************************************************
TrimbleMap.Controller.GetSelectionFeatureLayerByMapLayerID = function GetSelectionFeatureLayerByMapLayerID(strMapLayerID) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the selection feature layer for the map layer id ...
    var objSelectionFeatureLayer = objMapController.SelectionFeatureLayers[strMapLayerID];

    return objSelectionFeatureLayer;
}

// **************************************************************************
// FUNCTION CreateEsriMap
// **************************************************************************
TrimbleMap.Controller.CreateEsriMap = function CreateEsriMap() {

    // Get the map controller instance ...
    var objMapController = this;

    // Setup the map options ...
    var objMapOptions = {
        showAttribution: false,
        wrapAround180: false,
        nav: false,
        fadeOnZoom: true,
        navigationMode: 'css-transforms',
        slider: true,
        logo: false,
        displayGraphicsOnPan: true,
        slider: objMapController.LoadMapContents
    };

    // When we have an initial extent ...
    if (objMapController.InitialExtent != null) {

        // Set the initial extent ...
        objMapOptions.fitExtent = true;
        objMapOptions.extent = objMapController.InitialExtent;
    }

    // Create a new map object from the element in which to create it ...
    objMapController.EsriMap = new esri.Map(objMapController.MapElement.attr('id'), objMapOptions);

    // When we are loading the layers and we have map service displays to load ...
    if (objMapController.LoadMapContents && (objMapController.CurrentMap.MapServiceDisplays.length > 0)) {

        // Connect to the load event of the map object ...
        objMapController.EsriMap.on("load", TrimbleMap.Controller.Shared.TrapException(function () {

            // The map load completed ...
            objMapController.MapLoadCompleted();
        }));

    } else {

        // Create a new graphics layer to add ...
        var objGraphicsLayer = new esri.layers.GraphicsLayer();

        // Set the spatial reference ...
        objGraphicsLayer.spatialReference = objMapController.CreateEsriSpatialReference(objMapController.CurrentMap.SpatialReferenceID);

        // Create and add a graphics layer to the map ...
        objMapController.EsriMap.addLayer(objGraphicsLayer);

        // Notify that the component's load completed ...
        objMapController.ComponentLoadCompleted(TrimbleMap.Controller.Shared.MAP_COMPONENT_NAME, true);

        // The map load completed ...
        objMapController.MapLoadCompleted();
    }

    // Attach the layer reorder event handler ...
    objMapController.EsriMap.on('layer-reorder', objMapController.LayerReOrderedProxy);

    // Attach the zoom-end event handler ...
    objMapController.EsriMap.on('zoom-end', objMapController.ZoomEndProxy);

    // Attach an extent changed event handler ...
    objMapController.EsriMap.on('extent-change', objMapController.ExtentChangedProxy);

    // Attach a mouseleave event handler to the containing element ...
    objMapController.EsriMap.root.onmouseleave = objMapController.MouseLeftMapProxy;

    // Create the map layers ...
    objMapController.CreateMapLayers();
}

// **************************************************************************
// FUNCTION IsEsriMapLoaded
// **************************************************************************
TrimbleMap.Controller.IsEsriMapLoaded = function IsEsriMapLoaded() {

    // Get the map controller instance ...
    var objMapController = this;

    // Determine whether or not the esri is map laoded ...
    var blnIsEsriMapLoaded = ((objMapController.EsriMap != null) && (objMapController.EsriMap.loaded));

    return blnIsEsriMapLoaded;
}

// **************************************************************************
// FUNCTION MapLoadCompleted
// **************************************************************************
TrimbleMap.Controller.MapLoadCompleted = function MapLoadCompleted() {

    // Get the map controller instance ...
    var objMapController = this;

    // When the map has been loaded ...
    if (objMapController.IsEsriMapLoaded()) {

        // Create the scale bar ...
        objMapController.CreateScaleBar();
    }

    // Notify that the component's load completed ...
    objMapController.ComponentLoadCompleted(TrimbleMap.Controller.Shared.MAP_COMPONENT_NAME, true);

    // When the map has been loaded ...
    if (objMapController.IsEsriMapLoaded()) {

        // Fire the OnScalesChanged callback functions when we have one ...
        objMapController.TriggerOnScalesChanged(objMapController.GetCurrentMapScales());
    }
}

// **************************************************************************
// FUNCTION CreateScaleBar
// **************************************************************************
TrimbleMap.Controller.CreateScaleBar = function CreateScaleBar() {

    // Get the map controller instance ...
    var objMapController = this;

    // Determine the scalebar unit to use ...
    var strScalebarUnit = (objMapController.State.ScalebarUnitSystem == TrimbleMap.enumScalebarUnitSystem.Imperial) ? 'english' : 'metric';

    // Create the scale bar and add it to the map ...
    objMapController.Scalebar = new esri.dijit.Scalebar({
        map: objMapController.EsriMap,
        scalebarStyle: "ruler",
        scalebarUnit: strScalebarUnit,
        attachTo: "bottom-left"
    });
}

// **************************************************************************
// FUNCTION AddOnLayerLoad
// **************************************************************************
TrimbleMap.Controller.AddOnLayerLoad = function AddOnLayerLoad(objLayer, objMapServiceDisplay, strSubIdentifier, objDeferred, objRequestIOArgs) {

    // Get the map controller instance ...
    var objMapController = this;

    // Get the map service ...
    var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

    // Add an event handler for the onload event ...
    objLayer.on("load", TrimbleMap.Controller.Shared.TrapException(function (objTheLayer) {

        // Set the opacity ...
        objLayer.setOpacity(1 - (parseFloat(objMapServiceDisplay.Transparency) / 100));

        // Declare var for default visibility ...
        var blnDefaultVisibility = true;

        // When the layer has an default visibility property ...
        if (objMapService.DisplayByDefault && typeof objLayer.defaultVisibility != 'undefined') {

            // Get the default visibility ...
            blnDefaultVisibility = objLayer.defaultVisibility;
        } else {
            blnDefaultVisibility = objMapService.DisplayByDefault;
        }

        if (objMapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings && objMapController.State.ClientStoredVisibleMapServiceDisplayIDs) {
            blnDefaultVisibility = objMapController.State.ClientStoredVisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID] ? true : false;
        }

        // Set the visibility of the layer ...
        //objLayer.setVisibility(objMapService.Visible && blnDefaultVisibility);
        objLayer.setVisibility(blnDefaultVisibility);

        // Set the min and max scale ...
        objLayer.setMinScale(objMapServiceDisplay.MinScale);
        objLayer.setMaxScale(objMapServiceDisplay.MaxScale);

        let arrMapServiceDependenciesDeferreds = [];

        // Deal with particular service types separately ...
        switch (objMapService.MapServiceType) {
            case TrimbleMap.Controller.enumMapServiceType.WebMapService:
                let blnLayerHasBeenConfigured = false;

                //Create an array for the layers to display
                //Contains the OGCMapLayerID's
                let layerIDs = [];

                //Loops through all the map layers
                $.each(objMapService.MapLayers, function (intIndex, objMapLayer) {
                    //Attempt to find the map layer info based on a map layer name
                    let objWebMapServiceLayerInfo = objMapController.GetWebMapServiceLayerInfoByName(objLayer.layerInfos, objMapLayer.MapLayerName);
                    let strLayerID;

                    //If map layer info is found, get the appropriate ID
                    if (objWebMapServiceLayerInfo) {
                        if (objWebMapServiceLayerInfo.name) {
                            strLayerID = objWebMapServiceLayerInfo.name;
                        } else {
                            // Esri Groups layers do not have names so we use the map layer ID instead
                            // It needs a name so we can manage visibility of layers
                            objWebMapServiceLayerInfo.GeneratedName = objMapLayer.MapLayerID;

                            strLayerID = objWebMapServiceLayerInfo.GeneratedName;
                        }
                    }

                    //Check that the map service has been configured to display by default or was turned on previously when viewing map
                    if (objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden &&
                        objMapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings &&
                        objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID &&
                        objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID]) {
                        if (objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID].includes(strLayerID)) {
                            layerIDs.push(strLayerID);
                        }
                        // TODO: See LF-13755 and LF-13756. This must be removed because it overrides the client side stored user settings
						// WMS service doesn't define which of its layers are visible: https://pro.arcgis.com/en/pro-app/latest/help/data/services/use-wms-services.htm
                    } else if (objMapLayer.Visibility === TrimbleMap.Controller.enumMapLayerVisibility.VisibleByDefault ||
                               objMapLayer.Visibility === TrimbleMap.Controller.enumMapLayerVisibility.InheritFromSource) {
                               layerIDs.push(strLayerID);
                    }

                    blnLayerHasBeenConfigured = objMapLayer.Searchable || objMapLayer.Identifiable || objMapLayer.Selectable

                    if (objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden && (objMapLayer.Searchable || objMapLayer.Identifiable || objMapLayer.Selectable)) {
                        let objCreateMapLayerDataFromWebFeatureServiceDeferred = objMapController.CreateMapLayerDataFromWebFeatureService(objMapService, objMapLayer);
                        arrMapServiceDependenciesDeferreds.push(objCreateMapLayerDataFromWebFeatureServiceDeferred);

                        objCreateMapLayerDataFromWebFeatureServiceDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objMapLayerData) {
                            // Add the map layer to the lookup table ...
                            objMapController.AddMapLayerDataFromService(objMapLayer.MapLayerID, objMapLayerData);
                        }));
                    }
                });

                // Set to have the visible layers for the service ...
                objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] = layerIDs;

                // If there are layers to be displayed
                if (layerIDs.length > 0) {

                    //Set the visible layers on the Web Map Service
                    objMapController.SetLayerVisibilityFromState(objMapServiceDisplay, null);
                }                

                // Set the decription for the map service
                objMapService.Description = sanitizeHtml(objLayer.description);

                var objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);
                let strWebFeatureServiceUrl = objMapController.GetWebFeatureServiceUrlWithQueryParameters(objMapService, TrimbleMap.enumWebFeatureServiceRequest.GetCapabilities);

                // Create the selection feature layers for the web feature service
                objMapController.CreateSelectionFeatureLayersForWebFeatureService(objMapService, objLayer.layerInfos);

                if (objMapServiceRestUrlWithToken.Success) {
                    // Check if layer info has been loaded
                    if (objLayer && objLayer.layerInfos) {
                        // Set layer descriptions
                        objMapController.SetWMSLayersDescriptions(objLayer.layerInfos, objMapService);
                        // Set the esri layer IDs in the lookup table ...
                        objMapController.SetMapLayerIDLookupTableValuesForWebMapService(objMapService, objLayer);
                    }

                    if (objMapServiceRestUrlWithToken.Token) {
                        strWebFeatureServiceUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strWebFeatureServiceUrl, 'Token=' + objMapServiceRestUrlWithToken.Token);
                    }
                }
                else {

                    // Map service token expired
                    let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

                    //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
                    let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

                    //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
                    let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

                    // Log a diagnostic info message ...
                    objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);
                }

                if (blnLayerHasBeenConfigured) {
                    // Set the default html templates for the layers when a custom template and a default object template has not been set
                    let objDefaultHTMLTemplatesForWebFeatureServiceDeferred = objMapController.SetDefaultHTMLTemplatesForWebFeatureServiceFromFields(objMapService, objLayer.layerInfos);
                    arrMapServiceDependenciesDeferreds.push(objDefaultHTMLTemplatesForWebFeatureServiceDeferred);
                }

                strWebFeatureServiceUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strWebFeatureServiceUrl, 'MapServiceID=' + objMapService.MapServiceID);
                strWebFeatureServiceUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(objMapController.State.ArcGISProxyServiceUrl, strWebFeatureServiceUrl);

                let objWebFeatureServiceDeferred = new dojo.Deferred();
                arrMapServiceDependenciesDeferreds.push(objWebFeatureServiceDeferred);

                $.ajax({
                    url: strWebFeatureServiceUrl,
                    datatype: "xml",
                    complete: TrimbleMap.Controller.Shared.TrapException(function (jqXHR) {
                        if (jqXHR.status >= 200 && jqXHR.status < 300) {
                            objWebFeatureServiceDeferred.resolve(true);
                        }
                    }),
                    error: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus, errorThrown) {
                        if (blnLayerHasBeenConfigured) {
                            // Get the title and message translations 

                            // Unable to load map service
                            let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadMapServiceTitle');

                            // Unable to load the companion web feature service of %1 map service. The map service will show in the map but search, identify and selection will not return any results.
                            let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadWebFeatureServiceMessage', objMapService.MapServiceName);

                            // Unable to load companion web feature service of %1 map service. The data for this map service will be displayed in the map but any interaction with this map service will not return any results.
                            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadWebFeatureServiceEndUserMessage', objMapService.MapServiceName);

                            // Log the diagnostic message
                            objMapController.LogDiagnosticMessage(strTitle, strMessage, "", strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strWebFeatureServiceUrl);
                        }

                        objWebFeatureServiceDeferred.resolve(!blnLayerHasBeenConfigured);
                    })
                });

                break;

            case TrimbleMap.Controller.enumMapServiceType.Dynamic:
                // Set the esri layer IDs in the lookup table ...
                objMapController.SetEsriMapLayerIDLookupTableValuesForDynamicMapService(objMapService, objLayer);

                let arrVisibleLayers = [];

                if (objLayer.visibleLayers) {
                    arrVisibleLayers = objLayer.visibleLayers.slice();
                }

                $.each(objMapService.MapLayers, function (intIndex, objMapLayer) {
                    if (objMapLayer.Visibility === TrimbleMap.Controller.enumMapLayerVisibility.Hidden ||
                        (objMapLayer.Visibility === TrimbleMap.Controller.enumMapLayerVisibility.NotVisibleByDefault &&
                            (!objMapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings ||
                                !objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID ||
                                !objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID]))) {
                        let strEsriLayerID = objMapController.GetEsriLayerIDForMapLayerID(objMapLayer.MapLayerID);

                        if (objMapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings &&
                            objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID &&
                            objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID]) {
                            objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] = $.grep(objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID], function (objTestLayerId) {
                                return objTestLayerId != strEsriLayerID;
                            });
                        }

                        if ($.inArray(strEsriLayerID, arrVisibleLayers) > -1) {
                            arrVisibleLayers = $.grep(arrVisibleLayers, function (objTestLayerId) {
                                return objTestLayerId != strEsriLayerID;
                            });
                        }
                    }
                });

                if (objMapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings &&
                    objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID &&
                    objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID]) {

                    //Set the visible layers from the client stored visible layers ...
                    objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] = 
                    objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID];

                    // Display visible layers from the state...
                    objMapController.SetLayerVisibilityFromState(objMapServiceDisplay, objLayer);

                } else {

                    objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] = arrVisibleLayers;
                }

                // Create the selection feature layers for the dynamic map service ...
                objMapController.CreateSelectionFeatureLayersForDynamicMapService(objMapService, objLayer);

                var objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

                if (objMapServiceRestUrlWithToken.Success) {

                    //Add layer to lookup
                    objMapController.ForEachLayerInDynamicMapService(objMapService, objLayer, function (objMapLayer, objDynamicLayerInfo) {
                        if (objMapLayer && objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {
                            var objFeatureLayer = new esri.layers.FeatureLayer(TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, objDynamicLayerInfo.id).RestUrlWithToken);

                            objFeatureLayer.on("load", function (objData) {

                                // Check if layer has description
                                if (objData.layer && objData.layer.description) {
                                    // Set the decription for the map layer
                                    objMapLayer.Description = sanitizeHtml(objData.layer.description);
                                }

                                // Add the for the map layer to the lookup table ...
                                objMapController.AddMapLayerDataFromService(objMapLayer.MapLayerID, TrimbleMap.Controller.Shared.CreateMapLayerDataFromService(objData.layer));

                                // Get the Object ID field name ...
                                var strObjectIdField = objData.layer.objectIdField;

                                // Add it to the lookup table ...
                                objMapController.AddObjectIDFieldNameByMapLayerID(strObjectIdField, objMapLayer.MapLayerID);

                            });

                            objFeatureLayer.on("error", TrimbleMap.Controller.Shared.TrapException(function (objEvent) {
                                if (objEvent.target && objEvent.target._json) {
                                    // Get the map layers resource info
                                    let objResourceInfo = JSON.parse(objEvent.target._json);

                                    if (objResourceInfo && objResourceInfo.description) {
                                        // Set the decription for the map layer
                                        objMapLayer.Description = sanitizeHtml(objResourceInfo.description);
                                    }
                                }
                            }));
                        }
                    });
                }
                else {

                    // Map service token expired
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

                    //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

                    //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
                    var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

                    // Log a diagnostic info message ...
                    objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);
                }

                // Set the default html templates for the layers where needed ...
                objMapController.SetDefaultHTMLTemplatesForDynamicMapServiceFromFields(objMapService, objLayer);

                break;

            case TrimbleMap.Controller.enumMapServiceType.Feature:

                // Get the map layer by name ...
                var objMapLayer = objMapController.GetMapLayerByName(objMapService.MapServiceID, objLayer.name);

                // When the layer visibility is to be initialized 
                // from the information returned from the service ...
                if (objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {
                    // When no array of Layers ids exist for the maps service id ...
                    if (typeof objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] == 'undefined') {

                        // Create the array for the layer ids ...
                        objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] = new Array();
                    }

                    let blnCacheExists = objMapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings && objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID && objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID];

                    if ((blnCacheExists && $.grep(objMapController.State.ClientStoredVisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID], function (objTestLayerId) { return objTestLayerId === objLayer.layerId; }).length > 0) ||
                        // TODO: See LF-13755 and LF-13756. This must be removed because it overrides the client side stored user settings
                        (!blnCacheExists && objMapLayer.Visibility === TrimbleMap.Controller.enumMapLayerVisibility.VisibleByDefault)) {
                        // Add the layer id to the list ...
                        objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID].push(objLayer.layerId);
                    } else {
                        // Set layer to not visible
                        objMapController.SetLayerVisibility(objMapServiceDisplay, objLayer.layerId, false);
                    }
                } else {
                    // Set layer to not visible
                    objMapController.SetLayerVisibility(objMapServiceDisplay, objLayer.layerId, false);
                }

                // Set the decription for the map layer
                objMapService.Description = sanitizeHtml(objLayer.description);

                // Set the esri map layer id for the FlexiCadastre map layer id in the lookup table ...
                objMapController.SetEsriMapLayerIDLookupTableValue(objMapService.MapServiceID, objMapLayer.MapLayerID, objLayer.layerId);

                //Add layer to lookup
                objMapController.AddObjectIDFieldNameByMapLayerID(objLayer.objectIdField, objMapLayer.MapLayerID);

                if (objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {
                    // Create the selection feature layer ...
                    objMapController.CreateSelectionFeatureLayer(objMapLayer, objMapService, objLayer.url);

                    // Set the default html template for the layer where needed ...
                    objMapController.SetDefaultHTMLTemplatesForMapLayerFromFields(objMapService, objMapLayer, objLayer.url);
                }

                break;
        }

        if (!objMapService.Description) {
            if (objLayer.resourceInfo) {
                // Get the map services resource info
                let objResourceInfo = JSON.parse(objLayer.resourceInfo);

                if (objResourceInfo && objResourceInfo.serviceDescription) {
                    // Set the decription for the map service
                    objMapService.Description = sanitizeHtml(objResourceInfo.serviceDescription);
                }
            } else if (objLayer.description) {
                // Set the decription for the map service
                objMapService.Description = sanitizeHtml(objLayer.description);
            }
        }

        new dojo.promise.all(arrMapServiceDependenciesDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function (arrSuccess) {
            let blnSuccess = true;

            for (let intSuccess = 0; intSuccess < arrSuccess.length; intSuccess++) {
                blnSuccess = blnSuccess && arrSuccess[intSuccess];

                if (!blnSuccess) {
                    break;
                }
            }
            // Notify that the component's load completed
            objMapController.ComponentLoadCompleted(objMapServiceDisplay.MapServiceDisplayID + strSubIdentifier, true, blnSuccess);

            // When we received a deferred, resolve it
            if ((typeof objDeferred != 'undefined') && objDeferred) { objDeferred.resolve(blnSuccess); }
        }), TrimbleMap.Controller.Shared.TrapException(function () {
            // Notify that the component's load completed
            objMapController.ComponentLoadCompleted(objMapServiceDisplay.MapServiceDisplayID + strSubIdentifier, true, false);

            // When we received a deferred, resolve it
            if ((typeof objDeferred != 'undefined') && objDeferred) { objDeferred.resolve(false); }
        }));
    }));

    // Add an error event handler ...
    objLayer.on("error", TrimbleMap.Controller.Shared.TrapException(function (objEvent) {

        // Get the map service ...
        var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

        // Determine whether or not we have a layer id ...
        var blnHasLayerID = (typeof strSubIdentifier != 'undefined') && (strSubIdentifier != null) && ((strSubIdentifier).trim() != '');

        // Remove the / to get the esri layer id ...
        var strEsriLayerID = ((strSubIdentifier.length > 0) && (strSubIdentifier[0] == '/')) ? strSubIdentifier.substr(1) : strSubIdentifier;

        // Get the title and message translations ...

        // Unable to load map service
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadMapServiceTitle');

        // Unable to load map service %1. The layer might not show in the map and search, identify and selection will not return any results. 
        // layer with id %1
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadMapServiceMessage', objMapService.MapServiceName + ((blnHasLayerID) ? (SD.Translation.Shared.GetTranslation('Map.Controller.js', 'LayerWithId', strEsriLayerID)) + ' ' : ''));

        // Unable to load map service %1. The data for this map service will not be displayed in the map and any interaction with this map service will not return any results.
        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadMapServiceEndUserMessage', objMapService.MapServiceName);

        // Log the diagnostic message ...
        objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objEvent.error), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs));

        // Notify that the component's load completed ...
        objMapController.ComponentLoadCompleted(objMapServiceDisplay.MapServiceDisplayID + strSubIdentifier, false);

        // Check that we dealing with a Web Map Service
        if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService) {
            //Get the esri layers for the Web Map Service
            let objEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

            //Loop through all objEsriLayers and check that an error property has been added to objEsriLayer. If no error has been added, add one
            //This is because an the esri javascript api throws errors if the GetCapabilities and GetMap services are not enabled for the Web Map Service
            //but only adds an error property if GetCapabilities is not enabled. So we add a error property when GetMap also fails
            //Esri throws errors for theses services if not enabled because they are standard capabilities (specified by the OGC) that must be available with Web Map Services.
            $.each(objEsriLayers, function (intIndex, objEsriLayer) {
                if (!objEsriLayer.loadError) {
                    objEsriLayer.loadError = {};
                }
            });
        }

        // When we received a deferred and it's not already been resolved, resolve it ...
        if ((typeof objDeferred != 'undefined') && objDeferred && (!objDeferred.isResolved())) { objDeferred.resolve(false); }
    }));
}

// **************************************************************************
// FUNCTION SetWMSLayersDescriptions
// **************************************************************************
TrimbleMap.Controller.SetWMSLayersDescriptions = function SetWMSLayersDescriptions(arrLayerInfo, objMapService) {
    // Get the map controller instance
    let objMapController = this;

    // Check if layer info has been set
    if (arrLayerInfo) {
        for (var intLayerInfoIndex = 0; intLayerInfoIndex < arrLayerInfo.length; intLayerInfoIndex++) {
            // Get map layer info
            let objLayerInfo = arrLayerInfo[intLayerInfoIndex];

            // Get map layer
            let objMapLayer = objMapController.GetMapLayerByName(objMapService.MapServiceID, objLayerInfo.title);

            if (objMapLayer && objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {
                // Set the decription for the map layer
                objMapLayer.Description = sanitizeHtml(objLayerInfo.description);
            }

            // Check layer has sub layers
            if (objMapLayer && objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden && objLayerInfo.subLayers && objLayerInfo.subLayers.length > 0) {
                objMapController.SetWMSLayersDescriptions(objLayerInfo.subLayers, objMapService);
            }
        }
    }
}

// **************************************************************************
// FUNCTION GetWebMapServiceLayerInfoByName
// **************************************************************************
TrimbleMap.Controller.GetWebMapServiceLayerInfoByName = function GetWebMapServiceLayerInfoByName(arrlayerInfos, strMapLayerName) {

    // Get the map controller instance ...
    var objMapController = this;

    //Layer info object, if found
    let objLayerInfo = null;

    //Loop through all the layer info objects and attempt to find a particular layer info object based on the map layer name passed in
    //This method (GetWebMapServiceLayerInfoByName) is called recursively so that sub layers, layer info are also checked
    for (let intIndex = 0; intIndex < arrlayerInfos.length; intIndex++) {
        let objTempLayerInfo = arrlayerInfos[intIndex];

        if (objTempLayerInfo.title !== strMapLayerName) {
            if (objTempLayerInfo.subLayers && objTempLayerInfo.subLayers.length > 0) {
                objLayerInfo = objMapController.GetWebMapServiceLayerInfoByName(objTempLayerInfo.subLayers, strMapLayerName);

                if (objLayerInfo) {
                    break;
                }
            }
        } else {
            objLayerInfo = objTempLayerInfo;
            break;
        }
    }

    return objLayerInfo;
}

// **************************************************************************
// FUNCTION SetDefaultHTMLTemplatesForDynamicMapServiceFromFields
// **************************************************************************
TrimbleMap.Controller.SetDefaultHTMLTemplatesForDynamicMapServiceFromFields = function SetDefaultHTMLTemplatesForDynamicMapServiceFromFields(objMapService, objArcGISDynamicMapServiceLayer) {

    // Get the map controller instance ...
    var objMapController = this;

    var objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

    if (objMapServiceRestUrlWithToken.Success) {

        // Loop trhough all the layers in the dynamic map service ...
        objMapController.ForEachLayerInDynamicMapService(objMapService, objArcGISDynamicMapServiceLayer, function (objMapLayer, objDynamicLayerInfo) {

            // When found ...
            if (objMapLayer && objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {

                // Set default html templates for the layer if needed ...
                objMapController.SetDefaultHTMLTemplatesForMapLayerFromFields(objMapService, objMapLayer, TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, objDynamicLayerInfo.id).RestUrlWithToken);
            }
        });
    }
    else {
        // Get the title and message translations ...

        // Layer not configured
        // Map service token expired
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

        // Log a diagnostic info message ...
        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);
    }
}

// **************************************************************************
// FUNCTION SetDefaultHTMLTemplatesForWebFeatureServiceFromFields
// **************************************************************************
TrimbleMap.Controller.SetDefaultHTMLTemplatesForWebFeatureServiceFromFields = function SetDefaultHTMLTemplatesForWebFeatureServiceFromFields(objMapService, arrWebMapServiceLayers) {
    let objMapController = this;
    let objDeferred = new dojo.Deferred();
    let arrHTMLTemplatesForWebFeatureServiceDeferreds = [];
    let arrGetWebFeatureServiceLayerIdDeferreds = [];

    let objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

    if (objMapServiceRestUrlWithToken.Success) {
        objMapController.ForEachLayerInWebMapService(objMapService, arrWebMapServiceLayers, function (objMapLayer) {
            if (objMapLayer && objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {

                let objGetWebFeatureServiceLayerIdDeferred = objMapController.GetWebFeatureServiceLayerId(objMapService, objMapLayer);
                arrGetWebFeatureServiceLayerIdDeferreds.push(objGetWebFeatureServiceLayerIdDeferred);

                objGetWebFeatureServiceLayerIdDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (strLayerID) {
                    let objHTMLTemplatesForWebFeatureServiceDeferred = new dojo.Deferred();
                    arrHTMLTemplatesForWebFeatureServiceDeferreds.push(objHTMLTemplatesForWebFeatureServiceDeferred);

                    if (strLayerID) {

                        let strMapServiceLayerUrl = objMapController.GetWebFeatureServiceUrlWithQueryParameters(objMapService, TrimbleMap.enumWebFeatureServiceRequest.DescribeFeatureType, strLayerID);

                        if (objMapServiceRestUrlWithToken.Token) {
                            strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerUrl, 'Token=' + objMapServiceRestUrlWithToken.Token);
                        }

                        strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerUrl, 'MapServiceID=' + objMapService.MapServiceID);
                        strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(objMapController.State.ArcGISProxyServiceUrl, strMapServiceLayerUrl);

                        // Set default html templates for the layer if needed
                        objMapController.SetDefaultHTMLTemplatesForWebFeatureServiceMapLayerFromFields(objMapLayer, strMapServiceLayerUrl, objMapService).then(TrimbleMap.Controller.Shared.TrapException(function (blnSuccess) {
                            // Resolve the deferred
                            objHTMLTemplatesForWebFeatureServiceDeferred.resolve(blnSuccess);
                        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
                            // Reject the deferred
                            objHTMLTemplatesForWebFeatureServiceDeferred.reject(false);
                        }));
                    } else {
                        // Reject the deferred
                        objHTMLTemplatesForWebFeatureServiceDeferred.resolve(false);
                    }
                }));
            }
        });
    } else {
        // Get the title and message translations
        // Layer not configured
        // Map service token expired
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

        // Log a diagnostic info message
        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);
    }

    new dojo.promise.all(arrGetWebFeatureServiceLayerIdDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function (arrMapLayerIDs) {

        new dojo.promise.all(arrHTMLTemplatesForWebFeatureServiceDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function (arrSuccess) {
            let blnSuccess = true;

            for (let intSuccess = 0; intSuccess < arrSuccess.length; intSuccess++) {
                blnSuccess = blnSuccess && arrSuccess[intSuccess];

                if (!blnSuccess) {
                    break;
                }
            }

            objDeferred.resolve(blnSuccess);

        }));
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION SetDefaultHTMLTemplatesForWebFeatureServiceMapLayerFromFields
// **************************************************************************
TrimbleMap.Controller.SetDefaultHTMLTemplatesForWebFeatureServiceMapLayerFromFields = function SetDefaultHTMLTemplatesForWebFeatureServiceMapLayerFromFields(objMapLayer, strRestUrl, objMapService) {

    // Get the map controller instance ...
    let objMapController = this;

    let objDeferred = new dojo.Deferred();

    // When we have a map layer ...
    if (objMapLayer) {
        // Get the identify and search and select templates ...
        let strIdentifyHTMLTemplate = objMapLayer.ProcessedIdentifyHtmlTemplate;
        let strIdentifyHTMLTemplateByPart = objMapLayer.ProcessedIdentifyHtmlTemplateByPart;
        let strSearchAndSelectHtmlTemplate = objMapLayer.ProcessedSearchAndSelectHtmlTemplate;
        let strSearchAndSelectHtmlTemplateByPart = objMapLayer.ProcessedSearchAndSelectHtmlTemplateByPart;

        // Determine whether or not we need to get the fields to build the templates ...
        let blnRequiresIdentifyTemplate = (objMapLayer.Identifiable || objMapLayer.Searchable || objMapLayer.Selectable) && ((!strIdentifyHTMLTemplate) || ((strIdentifyHTMLTemplate).trim() == ''));
        let blnRequiresIdentifyTemplateByPart = (objMapLayer.Identifiable || objMapLayer.Searchable || objMapLayer.Selectable) && ((!strIdentifyHTMLTemplateByPart) || ((strIdentifyHTMLTemplateByPart).trim() == ''));
        let blnRequiresSearchAndSelectTemplate = (objMapLayer.Searchable || objMapLayer.Selectable) && ((!strSearchAndSelectHtmlTemplate) || ((strSearchAndSelectHtmlTemplate).trim() == ''));
        let blnRequiresSearchAndSelectTemplateByPart = (objMapLayer.Searchable || objMapLayer.Selectable) && ((!strSearchAndSelectHtmlTemplateByPart) || ((strSearchAndSelectHtmlTemplateByPart).trim() == ''));

        // When a template is required ...
        if (blnRequiresIdentifyTemplate || blnRequiresIdentifyTemplateByPart || blnRequiresSearchAndSelectTemplate || blnRequiresSearchAndSelectTemplateByPart) {

            // Request the layer data from the rest service ...
            // Call the web service to get the map service layer fields
            let objGetMapLayerDataFromWebFeatureServiceDeferred = objMapController.GetMapLayerDataFromWebFeatureService(strRestUrl, objMapService);

            //Attach a handler to deal with the response from the service ...
            objGetMapLayerDataFromWebFeatureServiceDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (arrFields) {

                // When we we are to successfully get the data from the service ...
                if (arrFields != null && arrFields.length > 0) {

                    // Create a div for the template ...
                    var objHTMLTemplate = $('<div></div>');

                    // Loop through all the fields ...
                    for (var intField = 0; intField < arrFields.length; intField++) {

                        // Get the field ...
                        var objField = arrFields[intField];

                        // Test whether or not it is a display field type ...
                        var blnIsDisplayableFieldType = (objField.type.toLowerCase().indexOf('gml') === -1)

                        // When it is not the object id field or when we have only one field left (i.e. only the object id field) and the field is displayable ...
                        if (blnIsDisplayableFieldType) {

                            // Determine the value binding to use when a date field, add date formatting to the value data binding ...  ...
                            var strValueDataBind = (objField.type == 'xsd:date') ? '((String($data[\'' + objField.name + '\']).toLowerCase() != &quot;null&quot;) && ($.trim($data[\'' + objField.name + '\']) != &quot;&quot;)? new Date($data[\'' + objField.name + '\']).ToUTCString(&quot;{0:&quot; + $root.DateFormat + &quot;}&quot;) : &quot;&quot;)'
                                : '$data[\'' + objField.name + '\']';

                            // Build the row html with a data-bind attribute that points to the field name (alias) to bind to ...
                            var objRowDiv = (objField.type == 'xsd:date') ? $('<div data-bind="visible: (String($data[\'' + objField.name + '\']).toLowerCase() != &quot;null&quot;) && ((String($data[\'' + objField.name + '\'])).trim() != &quot;&quot;)"></div>')
                                : $('<div></div>');

                            objRowDiv.append('<span>' + objField.alias + ':</span>&nbsp<span class="bold" data-bind="text: ' + strValueDataBind + '"></span>');

                            // Add the row to the html template ...
                            objHTMLTemplate.append(objRowDiv);
                        }

                        // Add the field name to alias mapping ...
                        objMapController.AddFieldNameToAliasMapping(objMapLayer.MapLayerID, objField.name, objField.alias);

                        // Add it to the list of template fields when displayable ...
                        if (blnIsDisplayableFieldType) { objMapLayer.TemplateFields.push(objField.name); }
                    }

                    // Convert the template to html ...
                    var strHtml = objHTMLTemplate.html();

                    var strIdentifyHtmlTemplate = '<div data-bind="with: Attributes">' + strHtml + '</div>';
                    var strSearchAndSelectHtmlTemplate = '<div class="result-item" data-bind="with: Attributes">' + strHtml + '</div>';

                    // Set the html templates on the map layer that needs to be set ...
                    if (blnRequiresIdentifyTemplate) { objMapLayer.ProcessedIdentifyHtmlTemplate = strIdentifyHtmlTemplate; }
                    if (blnRequiresIdentifyTemplateByPart) { objMapLayer.ProcessedIdentifyHtmlTemplateByPart = strIdentifyHtmlTemplate; }
                    if (blnRequiresSearchAndSelectTemplate) { objMapLayer.ProcessedSearchAndSelectHtmlTemplate = strSearchAndSelectHtmlTemplate; }
                    if (blnRequiresSearchAndSelectTemplateByPart) { objMapLayer.ProcessedSearchAndSelectHtmlTemplateByPart = strSearchAndSelectHtmlTemplate; }

                    objDeferred.resolve(true);
                }
            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
                objDeferred.reject(objError);
            }));
        }
        else {
            // Resolve the deferred ...
            objDeferred.resolve(true);
        }
    }

    return objDeferred;
};

// **************************************************************************
// FUNCTION AddFieldNameToAliasMapping
// **************************************************************************
TrimbleMap.Controller.AddFieldNameToAliasMapping = function AddFieldNameToAliasMapping(strMapLayerID, strFieldName, strAlias) {

    // Get the map controller instance ...
    var objMapController = this;

    // When we have no FieldNamesToAliasesMapping for the map layer ...
    if (typeof objMapController.FieldNamesToAliasesMapping[strMapLayerID] == 'undefined') {

        // Create a hash table for the field name to alias mappings ...
        objMapController.FieldNamesToAliasesMapping[strMapLayerID] = {};
    }

    // When we have no AliasesToFieldNamesMapping for the map layer ...
    if (typeof objMapController.AliasesToFieldNamesMapping[strMapLayerID] == 'undefined') {

        // Create a hash table for the alias to field name mappings ...
        objMapController.AliasesToFieldNamesMapping[strMapLayerID] = {};
    }

    // Add the mapping to both the hash tables ...
    objMapController.FieldNamesToAliasesMapping[strMapLayerID][strFieldName] = strAlias;
    objMapController.AliasesToFieldNamesMapping[strMapLayerID][strAlias] = strFieldName;
}

// **************************************************************************
// FUNCTION GetFieldNameForAlias
// **************************************************************************
TrimbleMap.Controller.GetFieldNameForAlias = function GetFieldNameForAlias(strMapLayerID, strAlias) {

    // Get the map controller instance ...
    var objMapController = this;

    // When we have AliasesToFieldNamesMapping for the map layer ...
    if (typeof objMapController.AliasesToFieldNamesMapping[strMapLayerID] != 'undefined') {

        // Return the field name for the alias ... 
        return objMapController.AliasesToFieldNamesMapping[strMapLayerID][strAlias];
    }

    // Not found ...
    return null;
}

// **************************************************************************
// FUNCTION GetAliasForFieldName
// **************************************************************************
TrimbleMap.Controller.GetAliasForFieldName = function GetAliasForFieldName(strMapLayerID, strFieldName) {

    // Get the map controller instance ...
    var objMapController = this;

    // When we have FieldNamesToAliasesMapping for the map layer ...
    if (typeof objMapController.FieldNamesToAliasesMapping[strMapLayerID] != 'undefined') {

        // Return the field name for the alias ... 
        return objMapController.FieldNamesToAliasesMapping[strMapLayerID][strFieldName];
    }

    // Not found ...
    return null;
}

// **************************************************************************
// FUNCTION SetDefaultHTMLTemplatesForMapLayerFromFields
// **************************************************************************
TrimbleMap.Controller.SetDefaultHTMLTemplatesForMapLayerFromFields = function SetDefaultHTMLTemplatesForMapLayerFromFields(objMapService, objMapLayer, strRestUrl) {

    // Get the map controller instance ...
    var objMapController = this;

    // When we have a map layer ...
    if (objMapLayer) {

        // Get the identify and search and select templates ...
        var strIdentifyHTMLTemplate = objMapLayer.ProcessedIdentifyHtmlTemplate;
        var strIdentifyHTMLTemplateByPart = objMapLayer.ProcessedIdentifyHtmlTemplateByPart;
        var strSearchAndSelectHtmlTemplate = objMapLayer.ProcessedSearchAndSelectHtmlTemplate;
        var strSearchAndSelectHtmlTemplateByPart = objMapLayer.ProcessedSearchAndSelectHtmlTemplateByPart;

        // Determine whether or not we need to get the fields to build the templates ...
        var blnRequiresIdentifyTemplate = (objMapLayer.Identifiable || objMapLayer.Searchable || objMapLayer.Selectable) && ((!strIdentifyHTMLTemplate) || ((strIdentifyHTMLTemplate).trim() == ''));
        var blnRequiresIdentifyTemplateByPart = (objMapLayer.Identifiable || objMapLayer.Searchable || objMapLayer.Selectable) && ((!strIdentifyHTMLTemplateByPart) || ((strIdentifyHTMLTemplateByPart).trim() == ''));
        var blnRequiresSearchAndSelectTemplate = (objMapLayer.Searchable || objMapLayer.Selectable) && ((!strSearchAndSelectHtmlTemplate) || ((strSearchAndSelectHtmlTemplate).trim() == ''));
        var blnRequiresSearchAndSelectTemplateByPart = (objMapLayer.Searchable || objMapLayer.Selectable) && ((!strSearchAndSelectHtmlTemplateByPart) || ((strSearchAndSelectHtmlTemplateByPart).trim() == ''));

        // When a template is required ...
        if (blnRequiresIdentifyTemplate || blnRequiresIdentifyTemplateByPart || blnRequiresSearchAndSelectTemplate || blnRequiresSearchAndSelectTemplateByPart) {

            // Request the layer data from the rest service ...
            var objDeferred = objMapController.GetMapLayerDataFromService(objMapLayer, objMapService);

            // Attach a handler to deal with the response from the service ...
            objDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objMapLayerDataFromService) {

                // When we we are to successfully get the data from the service ...
                if (objMapLayerDataFromService != null) {

                    // Create a new empty array for the template fields ...
                    objMapLayer.TemplateFields = [];

                    // Create a div for the template ...
                    var objHTMLTemplate = $('<div></div>');

                    // Loop through all the fields ...
                    for (var intField = 0; intField < objMapLayerDataFromService.Fields.length; intField++) {

                        // Get the field ...
                        var objField = objMapLayerDataFromService.Fields[intField];

                        // Test whether or not it is a display field type ...
                        var blnIsDisplayableFieldType = (objField.type != 'esriFieldTypeBlob') &&
                            (objField.type != 'esriFieldTypeGeometry') &&
                            (objField.type != 'esriFieldTypeXML');

                        // When it is not the object id field or when we have only one field left (i.e. only the object id field) and the field is displayable ...
                        if (((objField.type != 'esriFieldTypeOID') || (objMapLayerDataFromService.Fields.length <= 1)) && blnIsDisplayableFieldType) {

                            // Determine the value binding to use when a date field, add date formatting to the value data binding ...  ...
                            var strValueDataBind = (objField.type == 'esriFieldTypeDate') ? '((String($data[\'' + objField.name + '\']).toLowerCase() != &quot;null&quot;) && ($.trim($data[\'' + objField.name + '\']) != &quot;&quot;)? new Date($data[\'' + objField.name + '\']).ToUTCString(&quot;{0:&quot; + $root.DateFormat + &quot;}&quot;) : &quot;&quot;)'
                                : '$data[\'' + objField.name + '\']';

                            // Build the row html with a data-bind attribute that points to the field name (alias) to bind to ...
                            var objRowDiv = (objField.type == 'esriFieldTypeDate') ? $('<div data-bind="visible: (String($data[\'' + objField.name + '\']).toLowerCase() != &quot;null&quot;) && ((String($data[\'' + objField.name + '\'])).trim() != &quot;&quot;)"></div>')
                                : $('<div></div>');

                            objRowDiv.append('<span>' + objField.alias + ':</span>&nbsp<span class="bold" data-bind="text: ' + strValueDataBind + '"></span>');

                            // Add the row to the html template ...
                            objHTMLTemplate.append(objRowDiv);
                        }

                        // Add the field name to alias mapping ...
                        objMapController.AddFieldNameToAliasMapping(objMapLayer.MapLayerID, objField.name, objField.alias);

                        // Add it to the list of template fields when displayable ...
                        if (blnIsDisplayableFieldType) { objMapLayer.TemplateFields.push(objField.name); }
                    }

                    // Convert the template to html ...
                    var strHtml = objHTMLTemplate.html();

                    var strIdentifyHtmlTemplate = '<div data-bind="with: Attributes">' + strHtml + '</div>';
                    var strSearchAndSelectHtmlTemplate = '<div class="result-item" data-bind="with: Attributes">' + strHtml + '</div>';

                    // Set the html templates on the map layer that needs to be set ...
                    if (blnRequiresIdentifyTemplate) { objMapLayer.ProcessedIdentifyHtmlTemplate = strIdentifyHtmlTemplate; }
                    if (blnRequiresIdentifyTemplateByPart) { objMapLayer.ProcessedIdentifyHtmlTemplateByPart = strIdentifyHtmlTemplate; }
                    if (blnRequiresSearchAndSelectTemplate) { objMapLayer.ProcessedSearchAndSelectHtmlTemplate = strSearchAndSelectHtmlTemplate; }
                    if (blnRequiresSearchAndSelectTemplateByPart) { objMapLayer.ProcessedSearchAndSelectHtmlTemplateByPart = strSearchAndSelectHtmlTemplate; }
                }
            }));
        }
    }
}

// **************************************************************************
// FUNCTION AddOnSelectionFeatureLayerOnLayerLoad
// **************************************************************************
TrimbleMap.Controller.AddOnSelectionFeatureLayerOnLayerLoad = function AddOnSelectionFeatureLayerOnLayerLoad(objSelectionFeatureLayer, objMapLayer, objMapService, objRequestIOArgs) {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a new deferred ...
    var objDeferred = new dojo.Deferred();

    // Add it to the selection feature layer deferreds ...
    objMapController.SelectionFeatureLayerDeferreds.push(objDeferred);

    // Add an event handler for the onload event ...
    objSelectionFeatureLayer.on("load", function (objData) {

        // Add the for the map layer to the lookup table ...
        objMapController.AddMapLayerDataFromService(objMapLayer.MapLayerID, TrimbleMap.Controller.Shared.CreateMapLayerDataFromService(objData.layer));

        // Get the selection symbol to use for the layer ...
        var objSelectionSymbol = objMapController.SelectionSymbolForGeometryType(objData.layer.geometryType);

        // Set the selection symbology on the layer ...
        objData.layer.setSelectionSymbol(objSelectionSymbol);

        // Get the Object ID field name ...
        var strObjectIdField = objData.layer.objectIdField;

        // Add it to the lookup table ...
        objMapController.AddObjectIDFieldNameByMapLayerID(strObjectIdField, objMapLayer.MapLayerID);

        // Resolve the deferred ...
        objDeferred.resolve();
    });

    // Add an error event handler ...
    objSelectionFeatureLayer.on("error", TrimbleMap.Controller.Shared.TrapException(function (objEvent) {

        // Get the title and message translations ...

        // Unable to create selection feature layer
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToCreateSelectionFeatureLayerTitle');

        // Unable to create selection feature layer for map service %1 map layer %2.
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToCreateSelectionFeatureLayerMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

        // Unable to initialize the selection functionality for map service %1 map layer %2. You will not be able to select features from this layer.
        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToCreateSelectionFeatureLayerEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

        // Log the diagnostic message ...
        objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objEvent.error), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs));

        // Resolve the deferred ...
        objDeferred.resolve();
    }));
}

// **************************************************************************
// FUNCTION CreateScaleLevelDisplay
// **************************************************************************
TrimbleMap.Controller.CreateScaleLevelDisplay = function CreateScaleLevelDisplay(objMap) {

    // Get the map controller instance ...
    var objMapController = this;

    // Create a div and span for display ...
    var objScaleLevelDiv = $('<div class="ScaleLevelDiv"></div>');
    var objScaleLevelSpan = $('<span class="ScaleLevelSpan"></span>');

    // Add the span to the div and the div to the body ...
    objScaleLevelDiv.append(objScaleLevelSpan);
    $('body').append(objScaleLevelDiv);

    // Create a function to set the scale levels ...
    var fnSetScaleLevels = function () {

        // Get the current level and scale ...
        var intLevel = objMap.getLevel();
        var intScale = objMap.getScale();

        // Set the span value ...
        objScaleLevelSpan.text('Level: ' + intLevel + ' Scale: ' + intScale);
    }

    // Attach an extent change event handler ...
    objMap.on('extent-change', function (extent, delta, levelChange, lod) {

        // Set the scale levels ...
        fnSetScaleLevels();
    });

    // Set the scale levels ...
    fnSetScaleLevels();
}

// **************************************************************************
// FUNCTION AddToEsriLayersLookupTable
// **************************************************************************
TrimbleMap.Controller.AddToEsriLayersLookupTable = function AddToEsriLayersLookupTable(objMapServiceDisplay, objEsriLayer) {

    // Get the map controller ...
    var objMapController = this;

    // When we do not have an entry for the map service name  yet ...
    if (typeof objMapController.EsriLayersByMapServiceDisplayIDLookupTable[objMapServiceDisplay.MapServiceDisplayID] == 'undefined') {

        // Create and add a new array ...
        objMapController.EsriLayersByMapServiceDisplayIDLookupTable[objMapServiceDisplay.MapServiceDisplayID] = [];
    }

    // Get the esri layers array for the map service ...
    var arrEsriLayers = objMapController.EsriLayersByMapServiceDisplayIDLookupTable[objMapServiceDisplay.MapServiceDisplayID];

    // Add the esri layer to the array ...
    arrEsriLayers.push(objEsriLayer);
}

// **************************************************************************
// FUNCTION GetAllEsriLayers
// **************************************************************************
TrimbleMap.Controller.GetAllEsriLayers = function GetAllEsriLayers() {

    // Get the map controller ...
    var objMapController = this;

    // Create a new array to return ...
    var arrTiledLayers = new Array();

    // Loop through all the map service displays ...
    for (var intMapServiceDisplay = 0; intMapServiceDisplay < objMapController.CurrentMap.MapServiceDisplays.length; intMapServiceDisplay++) {

        // Get the map service display ...
        var objMapServiceDisplay = objMapController.CurrentMap.MapServiceDisplays[intMapServiceDisplay];

        // Get the map service ...
        var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

        // Get the esri layers created for the map service ...
        var arrEsriLayers = objMapController.EsriLayersByMapServiceDisplayIDLookupTable[objMapServiceDisplay.MapServiceDisplayID];

        // Add it to the list ...
        arrTiledLayers = arrTiledLayers.concat(arrEsriLayers);
    }

    return arrTiledLayers;
}

// **************************************************************************
// FUNCTION GetEsriLayersForMapServiceDisplay
// **************************************************************************
TrimbleMap.Controller.GetEsriLayersForMapServiceDisplay = function GetEsriLayersForMapServiceDisplay(objMapServiceDisplay) {

    // Get the map controller ...
    var objMapController = this;

    // Get the map service display ...
    var arrEsriLayers = objMapController.EsriLayersByMapServiceDisplayIDLookupTable[objMapServiceDisplay.MapServiceDisplayID];

    // When we have no loaded layers ...
    if ((typeof arrEsriLayers == 'undefined') && (!arrEsriLayers)) {

        // Set to return an empty array ...
        arrEsriLayers = [];
    }

    // Return the layers ...
    return arrEsriLayers;
}

// **************************************************************************
// FUNCTION: GetMapServiceDisplayLoadedStatus
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMapServiceDisplayLoadedStatus = function GetMapServiceDisplayLoadedStatus(objMapServiceDisplay) {

    // Get the controller ...
    var objMapController = this;

    // Create an object to return ....
    var objLoadedStatus = { LoadedLayers: [], FailedLayers: [], LoadedLayersDependencies: [], FailedLayersDependencies: [] };

    // Get the map service ...
    var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

    switch (objMapService.MapServiceType) {
        case TrimbleMap.Controller.enumMapServiceType.Tile:
        case TrimbleMap.Controller.enumMapServiceType.Dynamic:
        case TrimbleMap.Controller.enumMapServiceType.WebMapService:

            // When the component did not fail to load ...
            if (!objMapController.MapComponentFailedToLoad(objMapServiceDisplay.MapServiceDisplayID)) {

                // Add to the loaded layers array ...
                objLoadedStatus.LoadedLayers.push({ MapServiceDisplay: objMapServiceDisplay });

            } else {

                // Add to the failed layers array ...
                objLoadedStatus.FailedLayers.push({ MapServiceDisplay: objMapServiceDisplay });
            }

            // When the component dependencies did not fail to load
            if (!objMapController.MapComponentDependenciesFailedToLoad(objMapServiceDisplay.MapServiceDisplayID)) {

                // Add to the loaded layers dependencies array
                objLoadedStatus.LoadedLayersDependencies.push({ MapServiceDisplay: objMapServiceDisplay });

            } else {

                // Add to the failed layers dependencies array
                objLoadedStatus.FailedLayersDependencies.push({ MapServiceDisplay: objMapServiceDisplay });
            }
            break;

        case TrimbleMap.Controller.enumMapServiceType.Feature:

            // When the component did not fail to load ...
            if (!objMapController.MapComponentFailedToLoad(objMapServiceDisplay.MapServiceDisplayID)) {

                // Get all the layers for the maps service display ...
                var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

                // Loop through all the esri layers ...
                $.each(arrEsriLayers, function (intEsriLayer, objEsriLayer) {

                    // When the component did not fail to load ...
                    if (!objMapController.MapComponentFailedToLoad(objMapServiceDisplay.MapServiceDisplayID + objEsriLayer.LayerID)) {

                        // Add to the loaded layers array ...
                        objLoadedStatus.LoadedLayers.push({ MapServiceDisplay: objMapServiceDisplay, EsriLayer: objEsriLayer });

                    } else {

                        // Add to the failed layers array ...
                        objLoadedStatus.FailedLayers.push({ MapServiceDisplay: objMapServiceDisplay, EsriLayer: objEsriLayer });
                    }
                });

            } else {

                // Add to the failed layers array ...
                objLoadedStatus.FailedLayers.push({ MapServiceDisplay: objMapServiceDisplay });
            }
            break;
    }

    return objLoadedStatus;
}

// **************************************************************************
// FUNCTION: MapReady
// USAGE:    Returns true when all the map services that we are 
//           to wait for has finished loading ...
// **************************************************************************
TrimbleMap.Controller.MapReady = function MapReady(blnAllFailed) {

    // Get the controller ...
    var objMapController = this;

    // Start with not being ready ...
    var blnMapReady = false;

    // When the Map loaded has already been signalled ...
    if ($.inArray(TrimbleMap.Controller.Shared.MAP_COMPONENT_NAME, objMapController.LoadedMapComponents) > -1) {

        // Set to be ready ...
        blnMapReady = true;

    } else {

        // Set the map to be ready when all failed (the reason why we do this is because the map load event 
        // does not fire when no layres are loaded successfully - it only fires when the first layer are successfully loaded) ...
        if (blnAllFailed) { blnMapReady = true; }
    }

    return blnMapReady;
}

// **************************************************************************
// FUNCTION: AllLayersFailedToLoad
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.AllLayersFailedToLoad = function AllLayersFailedToLoad() {

    // Get the controller ...
    var objMapController = this;

    // Start with all services not being failed ...
    var blnAllFailed = false;

    // When any map components failed to load ...
    if (objMapController.FailedMapComponents.length > 0) {

        // Start with all services being failed ...
        var blnAllFailed = true;

        // Loop through all the map service displays in the current map ...
        objMapController.ForEachMapServiceDisplayInCurrentMap(function (objMapServiceDisplay, objMapService) {

            switch (objMapService.MapServiceType) {
                case TrimbleMap.Controller.enumMapServiceType.Tile:
                case TrimbleMap.Controller.enumMapServiceType.Dynamic:
                case TrimbleMap.Controller.enumMapServiceType.WebMapService:

                    // When the component did not fail to load ...
                    if (!objMapController.MapComponentFailedToLoad(objMapServiceDisplay.MapServiceDisplayID)) {

                        // Set to not have failed all ...
                        blnAllFailed = false;

                        // Stop checking ...
                        return false;
                    }
                    break;

                case TrimbleMap.Controller.enumMapServiceType.Feature:

                    // When the component did not fail to load ...
                    if (!objMapController.MapComponentFailedToLoad(objMapServiceDisplay.MapServiceDisplayID)) {

                        // Get all the layers for the maps service display ...
                        var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

                        // Loop through all the esri layers ...
                        $.each(arrEsriLayers, function (intEsriLayer, objEsriLayer) {

                            // When the component did not fail to load ...
                            if (!objMapController.MapComponentFailedToLoad(objMapServiceDisplay.MapServiceDisplayID + objEsriLayer.LayerID)) {

                                // Set to not have failed all ...
                                blnAllFailed = false;

                                // Stop checking ...
                                return false;
                            }
                        });

                        // Stop checking when already found to not all have failed ...
                        if (!blnAllFailed) { return false; }
                    }
                    break;
            }
        });
    }

    return blnAllFailed;
}

// **************************************************************************
// FUNCTION: MapComponentFailedToLoad
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.MapComponentFailedToLoad = function MapComponentFailedToLoad(strMapComponentName) {

    // Get the controller ...
    var objMapController = this;

    // Determine whether or not the component failed to load ...
    var blnFailedToLoad = ($.inArray(strMapComponentName, objMapController.FailedMapComponents) > -1);

    return blnFailedToLoad;
}

// **************************************************************************
// FUNCTION: MapComponentDependenciesFailedToLoad
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.MapComponentDependenciesFailedToLoad = function MapComponentDependenciesFailedToLoad(strMapComponentName) {

    // Get the controller
    var objMapController = this;

    // Determine whether or not the component failed to load
    var blnFailedToLoad = ($.inArray(strMapComponentName, objMapController.MapComponentFailedDependencies) > -1);

    return blnFailedToLoad;
}

// **************************************************************************
// FUNCTION: AllMapServicesLoadedOrFailed
// USAGE:    Returns true when all the map services that we are 
//           to wait for has finished loading ...
// **************************************************************************
TrimbleMap.Controller.AllMapServicesLoadedOrFailed = function AllMapServicesLoadedOrFailed() {

    // Get the controller ...
    var objMapController = this;

    // Join the all loaded and failed components into a single array ...
    var arrLoadedAndFailedComponents = objMapController.LoadedMapComponents.concat(objMapController.FailedMapComponents);

    // Create a function that will check a map service ...
    var fnCheckMapService = function CheckMapService(objMapServiceDisplay) {

        // Get the map service ...
        var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

        // When a feature service ...
        if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Feature) {

            // When the feature service has been loaded ...
            if (typeof objMapService.FeatureService != 'undefined') {

                // Loop through all the feature layers created ...
                for (var intFeatureLayer = 0; intFeatureLayer < objMapService.FeatureService.layers.length; intFeatureLayer++) {

                    // Get the feature layer ...
                    var objFeatureLayerInformation = objMapService.FeatureService.layers[intFeatureLayer];

                    // When not already loaded ...
                    if ($.inArray(objMapServiceDisplay.MapServiceDisplayID + '/' + objFeatureLayerInformation.id, arrLoadedAndFailedComponents) < 0) {

                        // Not all loaded yet ...
                        return false;
                    }
                }

            } else {

                // When not already loaded ...
                if ($.inArray(objMapServiceDisplay.MapServiceDisplayID, arrLoadedAndFailedComponents) < 0) {

                    // Not all loaded yet ...
                    return false;
                }
            }

        } else {

            // When not already loaded ...
            if ($.inArray(objMapServiceDisplay.MapServiceDisplayID, arrLoadedAndFailedComponents) < 0) {

                // Not all loaded yet ...
                return false;
            }
        }

        // We do not need to still wait for this service to load ...
        return true;
    }

    // Loop through all the map service displays ...
    for (var intMapServiceDisplay = 0; intMapServiceDisplay < objMapController.CurrentMap.MapServiceDisplays.length; intMapServiceDisplay++) {

        // Get the map service display ...
        var objMapServiceDisplay = objMapController.CurrentMap.MapServiceDisplays[intMapServiceDisplay];

        // Check the map service ...
        var blnPass = fnCheckMapService(objMapServiceDisplay);

        // Return false when the map service did not pass the test ...
        if (!blnPass) { return false; };
    }

    // Pass ...
    return true;
}

// **************************************************************************
// FUNCTION: FinalizeLoading
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.FinalizeLoading = function FinalizeLoading() {

    // Get the controller ...
    var objMapController = this;

    // When loading has not been finalized yet ...
    if (!objMapController.LoadingFinalized) {

        // Set to have finalized the loading ...
        objMapController.LoadingFinalized = true;

        // When the layers have been loaded ...
        if (objMapController.LoadMapContents) {

            // Remove all the layers from the map ....
            objMapController.EsriMap.removeAllLayers();

            // Determine whether or not all layers failed to load ...
            var blnAllFailed = objMapController.AllLayersFailedToLoad();

            if (blnAllFailed) {

                // Create and add a graphics layer to the map ...
                objMapController.EsriMap.addLayer(new esri.layers.GraphicsLayer());
            }

            // Loop through all the map services displayed in the current map ...
            for (var intMapServiceDisplay = 0; intMapServiceDisplay < objMapController.CurrentMap.MapServiceDisplays.length; intMapServiceDisplay++) {

                // Get the map service display ...
                var objMapServiceDisplay = objMapController.CurrentMap.MapServiceDisplays[intMapServiceDisplay];

                // Get the esri layers created for the map service display ...
                var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

                // Loop through all the layers to add ...
                for (var intEsriLayer = 0; intEsriLayer < arrEsriLayers.length; intEsriLayer++) {

                    // Get the layer to add ...
                    var objEsriLayer = arrEsriLayers[intEsriLayer];

                    // When the layer has been loaded successfully ...
                    if ((typeof objEsriLayer.loaded != 'undefined') && (objEsriLayer.loaded)) {

                        if (typeof objEsriLayer.layerInfos == 'undefined') {

                            if (typeof objMapController.EsriMap.extent == 'undefined') {
                                objMapController.EsriMap.extent = objEsriLayer.fullExtent
                            }
                            else {
                                objMapController.EsriMap.extent = objMapController.EsriMap.extent.union(objEsriLayer.fullExtent);
                            }
                        }

                        // Add the layer to the map ...
                        objMapController.EsriMap.addLayer(objEsriLayer);
                    }
                }
            }

            // When all the selection layers are done loading (or failed) ....
            new dojo.promise.all(objMapController.SelectionFeatureLayerDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function () {

                // Loop through all the selection feature layers ...
                $.each(objMapController.SelectionFeatureLayers, function (strMapLayerID, objSelectionFeatureLayer) {

                    // Add the layer to the map ...
                    objMapController.EsriMap.addLayer(objSelectionFeatureLayer);
                });

                // Loop through all the selection graphics layers ...
                $.each(objMapController.SelectionGraphicsLayers, function (strMapLayerID, objSelectionGraphicsLayer) {

                    // Add the layer to the map ...
                    objMapController.EsriMap.addLayer(objSelectionGraphicsLayer);
                });
            }));
        }
    }
}

// **************************************************************************
// FUNCTION: ComponentLoadCompleted
// USAGE:    Handle a map component completed event ...
//           blnSuccess is optional and defaults to true
// **************************************************************************
TrimbleMap.Controller.ComponentLoadCompleted = function ComponentLoadCompleted(strMapComponentLoadCompleted, blnSuccess, blnDependentComponentSuccess) {

    // Get the controller ...
    var objMapController = this;

    // Default blnSuccess to true when not specified ...
    if ((typeof blnSuccess == 'undefined') && (blnSuccess == null)) { blnSuccess = true; }

    // Default blnDependentComponentSuccess to true when not specified
    if ((typeof blnDependentComponentSuccess == 'undefined') && (blnDependentComponentSuccess == null)) { blnDependentComponentSuccess = true; }

    // When successfull ...
    if (blnSuccess) {
        if (objMapController.LoadedMapComponents.indexOf(strMapComponentLoadCompleted) == -1) {
            // Add it to the loaded map components array
            objMapController.LoadedMapComponents.push(strMapComponentLoadCompleted);
        }
    } else {
        // Add it to the failed map components array
        if (objMapController.FailedMapComponents.indexOf(strMapComponentLoadCompleted) == -1) {
            objMapController.FailedMapComponents.push(strMapComponentLoadCompleted);
            objMapController.LoadedMapComponents.splice(objMapController.FailedMapComponents.indexOf(strMapComponentLoadCompleted), 1);
        }
    }

    if (blnDependentComponentSuccess) {
        if (objMapController.MapComponentLoadedDependencies.indexOf(strMapComponentLoadCompleted) == -1) {
            // Add it to the map component loaded dependencies array
            objMapController.MapComponentLoadedDependencies.push(strMapComponentLoadCompleted);
        }
    } else {
        if (objMapController.MapComponentFailedDependencies.indexOf(strMapComponentLoadCompleted) == -1) {
            // Add it to the map component failed dependencies  array
            objMapController.MapComponentFailedDependencies.push(strMapComponentLoadCompleted);
            objMapController.MapComponentLoadedDependencies.splice(objMapController.MapComponentFailedDependencies.indexOf(strMapComponentLoadCompleted), 1);
        }
    }

    // Consider finalizing the map ...
    objMapController.ConsiderFinalizingMap();
}

// **************************************************************************
// FUNCTION: ConsiderFinalizingMap
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.ConsiderFinalizingMap = function ConsiderFinalizingMap() {

    // Get the controller ...
    var objMapController = this;

    // Determine whether or not we are waiting for the services to load ...
    var blnWaitingForServicesToLoad = (objMapController.LoadMapContents && (!objMapController.AllMapServicesLoadedOrFailed()));

    // When all the components to wait for have been loaded and the map has been created ...
    if ((objMapController.EsriMap != null) && (!blnWaitingForServicesToLoad)) {

        // Finalize the loading of the map ...
        objMapController.FinalizeLoading();
    }

    // When all the components to wait for have been loaded and the map has been created ...
    if ((objMapController.EsriMap != null) && (!blnWaitingForServicesToLoad) && (objMapController.LoadingFinalized)) {

        // When loading has not been completed yet ...
        if (!objMapController.LoadingCompleted) {

            // Determine whether or not all layers failed to load ...
            var blnAllFailed = objMapController.AllLayersFailedToLoad();

            // When the map is ready ...
            if (objMapController.MapReady(blnAllFailed)) {

                // Set to have completed the loading ...
                objMapController.LoadingCompleted = true;

                // Zoom to the initial extent ...
                let objDeferred = objMapController.ZoomToInitialExtent();

                // When we are done zooming to the initial extend of the map ...
                objDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

                    // Trigger the loaded event handlers ...
                    objMapController.TriggerOnLoadedCallbacks();
                }));
            }
        }
    }
}

// **************************************************************************
// FUNCTION: FindGroupByTemplateByName
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.FindGroupByTemplateByName = function FindGroupByTemplateByName(strGroupByNameToFind) {

    // Get the controller ...
    var objMapController = this;

    // Loop through all the group by templates ...
    for (var intGroupByTemplate = 0; intGroupByTemplate < objMapController.PortalConfigurationJSON.GroupByTemplates.length; intGroupByTemplate++) {

        // Get the group by template ...
        var objGroupByTemplate = objMapController.PortalConfigurationJSON.GroupByTemplates[intGroupByTemplate];

        // Get the group by name from the group template ...
        var strGroupByName = objGroupByTemplate.GroupByName;

        // When the group by name matches ...
        if (strGroupByName == strGroupByNameToFind) {

            // Return the group by template ...
            return objGroupByTemplate;
        }
    }

    // Not found ...
    return null;
}

// **************************************************************************
// FUNCTION: FindLayerTemplatesByID
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.FindLayerTemplatesByID = function FindLayerTemplatesByID(strLayerIDToFind) {

    // Get the controller ...
    var objMapController = this;

    // Create an array for the layer templates ...
    var arrLayerTemplates = new Array();

    // Loop through all the group by templates ...
    for (var intGroupByTemplate = 0; intGroupByTemplate < objMapController.PortalConfigurationJSON.GroupByTemplates.length; intGroupByTemplate++) {

        // Get the group by template ...
        var objGroupByTemplate = objMapController.PortalConfigurationJSON.GroupByTemplates[intGroupByTemplate];

        // Find a layer template in the group by template for the layer id ...
        var objLayerTemplate = TrimbleMap.Controller.Shared.FindLayerTemplateByID(objGroupByTemplate, strLayerIDToFind);

        // When found ...
        if (objLayerTemplate != null) {

            // Add to the list ...
            arrLayerTemplates.push(objLayerTemplate);
        }
    }

    return arrLayerTemplates;
}

// **************************************************************************
// FUNCTION: ZoomToInitialExtent
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.ZoomToInitialExtent = function ZoomToInitialExtent() {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we have a map object ...
    if (objMapController.EsriMap != null) {

        // When we have a shapes extent ...
        if (objMapController.ShapesToSelectExtent) {

            //Zoom to the shapes extent
            objDeferred = objMapController.SetMapExtent(objMapController.ShapesToSelectExtent);

            // When we have an initial extend ...
        } else if (objMapController.InitialExtent) {

            // Zoom to the initial extent ...
            objDeferred = objMapController.SetMapExtent(objMapController.InitialExtent);

        } else {

            // Resolve the deferred ...
            objDeferred.resolve();
        }

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    // Return the deferred ..
    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetUserInitialExtentBookmarkIDForCurrentMap
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetUserInitialExtentBookmarkIDForCurrentMap = function GetUserInitialExtentBookmarkIDForCurrentMap() {

    // Get the controller ...
    var objMapController = this;

    // Get the initial extent bookmark for the current map ...
    var guidBookmark = (objMapController.Preferences.InitialExtentType == TrimbleMap.Preferences.enumUserInitialExtentType.ApplyToAllMaps)
        ? objMapController.Preferences.InitialExtentIDForAllMaps
        : objMapController.Preferences.InitialExtentBookmarkIDByMapID[objMapController.CurrentMap.MapID];

    // Set to guid.empty when null or undefined ...
    if ((typeof guidBookmark == 'undefined') || (guidBookmark == null)) { guidBookmark = SD.Guid.Shared.Empty(); }

    return guidBookmark;
}

// **************************************************************************
// FUNCTION: GetInitialExtentOfCurrentMap
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetInitialExtentOfCurrentMap = function GetInitialExtentOfCurrentMap() {

    // Get the controller ...
    var objMapController = this;

    // Start with no bookmark ...
    var objInitialExtentBookmark = null;

    // Get the user specific initial extent bookmark ID ...
    var guidUserInitialExtentBookmark = objMapController.GetUserInitialExtentBookmarkIDForCurrentMap();

    if (!objMapController.State.AllowExtentChangePostMapLoad && objMapController.State.ClientStoredInitialExtentBookmark) {

        objInitialExtentBookmark = objMapController.State.ClientStoredInitialExtentBookmark;

    } else {
        // When we have a user specific initial extent bookmark ID ...
        if ((typeof guidUserInitialExtentBookmark != 'undefined') && (guidUserInitialExtentBookmark != null) && (guidUserInitialExtentBookmark != SD.Guid.Shared.Empty())) {

            // Use the user specific initial extend bookmark ...
            objInitialExtentBookmark = objMapController.GetBookmark(guidUserInitialExtentBookmark);

        } else {

            // Use the initial extend bookmark ...
            objInitialExtentBookmark = objMapController.GetBookmark(objMapController.CurrentMap.InitialExtentBookmarkID);
        }
    }

    return objInitialExtentBookmark;
}

// **************************************************************************
// FUNCTION: ZoomToInitialExtentOfCurrentMap
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.ZoomToInitialExtentOfCurrentMap = function ZoomToInitialExtentOfCurrentMap() {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we have a map object ...
    if (objMapController.EsriMap != null) {

        // Get the initial extent bookmark of the current map ...
        var objInitialExtentBookmark = objMapController.GetInitialExtentOfCurrentMap();

        // When we have an initial extend ...
        if ((typeof objInitialExtentBookmark != 'undefined') && (objInitialExtentBookmark != null)) {

            // Get an esri extend for the initial extend ...
            objMapController.GetBookmarkExtentInSpatialReferenceOfCurrentMap(objInitialExtentBookmark).then(TrimbleMap.Controller.Shared.TrapException(function (objEsriMapExtent) {

                // Zoom to the extent ...
                objDeferred = objMapController.SetMapExtent(objEsriMapExtent);

            }), TrimbleMap.Controller.Shared.TrapException(function () {

                // Reject the deferred ...
                objDeferred.reject();
            }));

        } else {

            // Resolve the deferred ...
            objDeferred.resolve();
        }
    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    // Return the deferred ..
    return objDeferred;
}

// **************************************************************************
// FUNCTION: SuspendAllLayers
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.SuspendAllLayers = function SuspendAllLayers() {

    // Get the controller ...
    var objMapController = this;

    // Get all the created esri tile layers ...
    var arrEsriTileLayers = objMapController.GetAllEsriLayers();

    // Loop through all the tiled map service layers ...
    for (var intLayer = 0; intLayer < arrEsriTileLayers.length; intLayer++) {

        // Get the layer ...
        var objLayer = arrEsriTileLayers[intLayer];

        // Suspend the layer ...
        objLayer.suspend();
    }
}

// **************************************************************************
// FUNCTION: ResumeAllLayers
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.ResumeAllLayers = function ResumeAllLayers() {

    // Get the controller ...
    var objMapController = this;

    // Get all the created esri tile layers ...
    var arrEsriTileLayers = objMapController.GetAllEsriLayers();

    // Loop through all the tiled map service layers ...
    for (var intLayer = 0; intLayer < arrEsriTileLayers.length; intLayer++) {

        // Get the layer ...
        var objLayer = arrEsriTileLayers[intLayer];

        // Suspend the layer ...
        objLayer.resume();
    }
}

// **************************************************************************
// FUNCTION: SetLayerVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.SetLayerVisibility = function SetLayerVisibility(objMapServiceDisplay, strLayerID, blnVisibility) {

    // Get the controller ...
    var objMapController = this;

    // The layer id that should be made visible or not
    let objLayerID = null;

    // Get the map service ...
    var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

    //Check if web map service
    //Web Map Service layer ID's could be a number or name of layer
    if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService) {
        //Check the layer id string to ensure it is not blank
        //This is because if we cast the string to a number, this will cause a blank string to become a "0"
        if (strLayerID && strLayerID !== "") {
            objLayerID = strLayerID;
        }
    } else {
        //Cast layer id to a number
        objLayerID = Number(strLayerID);
    }

    // Get the visible layers ...
    var arrVisibleLayers = objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID];

    // When the layer id has been set
    if (objLayerID != null) {
        // When the layer is to be visible
        if (blnVisibility) {
            // Add the layer id to the list when not already there ...
            if ($.inArray(objLayerID, arrVisibleLayers) == -1) { arrVisibleLayers.push(objLayerID); }

        } else {
            // Remove the layer id from the list when already there ...
            if ($.inArray(objLayerID, arrVisibleLayers) > -1) { arrVisibleLayers = $.grep(arrVisibleLayers, function (objTestLayerId) { return objTestLayerId != objLayerID; }); };
        }
    }

    // Set the changed visible layers to be a copy of the array of visible layers (since 
    // we do modifications to the array below which we do not want to be included here) ...
    objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] = [].concat(arrVisibleLayers);

    // Get the esri layers for the map service display ...
    var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

    // When it is a tile, dynamic or web map service ...
    if ((objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Tile) || (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Dynamic) || (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService)) {

        // When the layer were successfully loaded ...
        if (arrEsriLayers.length > 0) {
            // When this is a web map service
            if (objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                // Loop through all the layer infos ...
                for (let intLayerInfo = 0; intLayerInfo < arrEsriLayers[0].layerInfos.length; intLayerInfo++) {

                    // Get the layer info ...
                    let objLayerInfo = arrEsriLayers[0].layerInfos[intLayerInfo];

                    if (objLayerInfo.subLayers != null && objLayerInfo.subLayers.length > 0) {
                        let strLayerID = TrimbleMap.Controller.Shared.GetWebMapServiceLayerName(objLayerInfo);

                        // When the parent layer is not visible ...
                        if ($.inArray(strLayerID, arrVisibleLayers) == -1) {

                            // Loop through all the sub layers of the parent layer ...
                            for (var intSubLayer = 0; intSubLayer < objLayerInfo.subLayers.length; intSubLayer++) {

                                // Get the sub layer info ...
                                let objSubLayer = objLayerInfo.subLayers[intSubLayer];
                                let strSubLayerId = TrimbleMap.Controller.Shared.GetWebMapServiceLayerName(objSubLayer);

                                // When the sub layer is set to be visible ...
                                if ($.inArray(strSubLayerId, arrVisibleLayers) > -1) {

                                    // Remove the layer id from the array of visible layer ids ...
                                    arrVisibleLayers = $.grep(arrVisibleLayers, function (strTestLayerId) { return (strTestLayerId != strSubLayerId); });
                                }
                            }
                        }

                        // Remove the parent layer id from the array of visible layer ids so that it does not override the options for the sub layer ids ...
                        arrVisibleLayers = $.grep(arrVisibleLayers, function (intTestLayerId) { return (intTestLayerId != strLayerID); });
                    }
                }
            } else {
                // Loop through all the layer infos ...
                for (let intLayerInfo = 0; intLayerInfo < arrEsriLayers[0].layerInfos.length; intLayerInfo++) {

                    // Get the layer info ...
                    let objLayerInfo = arrEsriLayers[0].layerInfos[intLayerInfo];

                    // When this is a parent layer ...
                    if (objLayerInfo.subLayerIds != null) {

                        // When the parent layer is not visible ...
                        if ($.inArray(objLayerInfo.id, arrVisibleLayers) == -1) {

                            // Loop through all the sub layers of the parent layer ...
                            for (var intSubLayer = 0; intSubLayer < objLayerInfo.subLayerIds.length; intSubLayer++) {

                                // Get the sub layer info ...
                                var strSubLayerId = objLayerInfo.subLayerIds[intSubLayer];

                                // When the sub layer is set to be visible ...
                                if ($.inArray(strSubLayerId, arrVisibleLayers) > -1) {

                                    // Remove the layer id from the array of visible layer ids ...
                                    arrVisibleLayers = $.grep(arrVisibleLayers, function (strTestLayerId) { return (strTestLayerId != strSubLayerId); });
                                }
                            }
                        }

                        // Remove the parent layer id from the array of visible layer ids so that it does not override the options for the sub layer ids ...
                        arrVisibleLayers = $.grep(arrVisibleLayers, function (intTestLayerId) { return (intTestLayerId != objLayerInfo.id); });
                    }
                }
            }
        }
    }

    // Deal with different map service types separately ...
    switch (objMapService.MapServiceType) {
        case TrimbleMap.Controller.enumMapServiceType.Dynamic:

            // When no layers in the list add -1 to indicate that no layers should be visible ...
            if (arrVisibleLayers.length == 0) { arrVisibleLayers.push(-1); }

            // Dynamic map services always results in one client side layer, set the visible layer ids ...
            arrEsriLayers[0].setVisibleLayers(arrVisibleLayers);
            break;
        case TrimbleMap.Controller.enumMapServiceType.WebMapService:

            //set the visible layers for the map service
            let arrLayerIDsGroupLayersExcluded = $.grep(arrVisibleLayers, function (strLayerID) { return !SD.Guid.Shared.IsGuid(strLayerID) });

            arrEsriLayers[0].setVisibleLayers(arrLayerIDsGroupLayersExcluded);
            break;
        case TrimbleMap.Controller.enumMapServiceType.Feature:

            // Find the layer with the id ...
            var objEsriLayer = $.grep(arrEsriLayers, function (objTestLayer) { return objTestLayer.LayerID == objLayerID; })[0];

            // Show or hide the layer based on the visibility setting ...
            if (blnVisibility) { objEsriLayer.show(); } else { objEsriLayer.hide(); }
            break;
    }
}

// **************************************************************************
// FUNCTION: SetLayerVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.SetLayerVisibilityFromState = function SetLayerVisibilityFromState(objMapServiceDisplay, objLayer) {

    // Get the controller ...
    var objMapController = this;

    // Get the map service ...
    var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

    // Get the visible layers ...
    var arrVisibleLayers = objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID];

    // Get the esri layers for the map service display ...
    var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

    // When it is a tile, dynamic or web map service ...
    if ((objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Tile) || (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Dynamic) || (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService)) {

        // When the layer were successfully loaded ...
        if (arrEsriLayers.length > 0) {
            // When this is a web map service
            if (objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                // Loop through all the layer infos ...
                for (let intLayerInfo = 0; intLayerInfo < arrEsriLayers[0].layerInfos.length; intLayerInfo++) {

                    // Get the layer info ...
                    let objLayerInfo = arrEsriLayers[0].layerInfos[intLayerInfo];

                    if (objLayerInfo.subLayers != null && objLayerInfo.subLayers.length > 0) {
                        let strLayerID = TrimbleMap.Controller.Shared.GetWebMapServiceLayerName(objLayerInfo);

                        // When the parent layer is not visible ...
                        if ($.inArray(strLayerID, arrVisibleLayers) == -1) {

                            // Loop through all the sub layers of the parent layer ...
                            for (var intSubLayer = 0; intSubLayer < objLayerInfo.subLayers.length; intSubLayer++) {

                                // Get the sub layer info ...
                                let objSubLayer = objLayerInfo.subLayers[intSubLayer];
                                let strSubLayerId = TrimbleMap.Controller.Shared.GetWebMapServiceLayerName(objSubLayer);

                                // When the sub layer is set to be visible ...
                                if ($.inArray(strSubLayerId, arrVisibleLayers) > -1) {

                                    // Remove the layer id from the array of visible layer ids ...
                                    arrVisibleLayers = $.grep(arrVisibleLayers, function (strTestLayerId) { return (strTestLayerId != strSubLayerId); });
                                }
                            }
                        }

                        // Remove the parent layer id from the array of visible layer ids so that it does not override the options for the sub layer ids ...
                        arrVisibleLayers = $.grep(arrVisibleLayers, function (intTestLayerId) { return (intTestLayerId != strLayerID); });
                    }
                }
            } else {
                // Loop through all the layer infos ...
                for (let intLayerInfo = 0; intLayerInfo < arrEsriLayers[0].layerInfos.length; intLayerInfo++) {

                    // Get the layer info ...
                    let objLayerInfo = arrEsriLayers[0].layerInfos[intLayerInfo];

                    // When this is a parent layer ...
                    if (objLayerInfo.subLayerIds != null) {

                        // When the parent layer is not visible ...
                        if ($.inArray(objLayerInfo.id, arrVisibleLayers) == -1) {

                            // Loop through all the sub layers of the parent layer ...
                            for (var intSubLayer = 0; intSubLayer < objLayerInfo.subLayerIds.length; intSubLayer++) {

                                // Get the sub layer info ...
                                var strSubLayerId = objLayerInfo.subLayerIds[intSubLayer];

                                // When the sub layer is set to be visible ...
                                if ($.inArray(strSubLayerId, arrVisibleLayers) > -1) {

                                    // Remove the layer id from the array of visible layer ids ...
                                    arrVisibleLayers = $.grep(arrVisibleLayers, function (strTestLayerId) { return (strTestLayerId != strSubLayerId); });
                                }
                            }
                        }

                        // Remove the parent layer id from the array of visible layer ids so that it does not override the options for the sub layer ids ...
                        arrVisibleLayers = $.grep(arrVisibleLayers, function (intTestLayerId) { return (intTestLayerId != objLayerInfo.id); });
                    }
                }
            }
        }
    }

    // Deal with different map service types separately ...
    switch (objMapService.MapServiceType) {
        case TrimbleMap.Controller.enumMapServiceType.Dynamic:

            // When no layers in the list add -1 to indicate that no layers should be visible ...
            if (arrVisibleLayers.length == 0) { arrVisibleLayers.push(-1); }

            // Dynamic map services always results in one client side layer, set the visible layer ids ...
            objLayer.setVisibleLayers(arrVisibleLayers);
            break;
        case TrimbleMap.Controller.enumMapServiceType.WebMapService:

            //set the visible layers for the map service
            let arrLayerIDsGroupLayersExcluded = $.grep(arrVisibleLayers, function (strLayerID) { return !SD.Guid.Shared.IsGuid(strLayerID) });

            arrEsriLayers[0].setVisibleLayers(arrLayerIDsGroupLayersExcluded);
            break;
        case TrimbleMap.Controller.enumMapServiceType.Feature:

            // Find the layer with the id ...
            var objEsriLayer = $.grep(arrEsriLayers, function (objTestLayer) { return objTestLayer.LayerID == objLayerID; })[0];

            // Show or hide the layer based on the visibility setting ...
            if (blnVisibility) { objEsriLayer.show(); } else { objEsriLayer.hide(); }
            break;
    }
}

// **************************************************************************
// FUNCTION: GetLayerVisibility
// USAGE:    blnIgnoreParentAndMapServiceVisibility - True when in VisibleLayerIDsByMapServiceDisplayID 
//           even though the map service might be invisible ...
// **************************************************************************
TrimbleMap.Controller.GetLayerVisibility = function GetLayerVisibility(objMapServiceDisplay, strLayerID, blnIgnoreParentAndMapServiceVisibility) {

    // Get the controller ...
    var objMapController = this;

    // Get the visible layers for the map service display ...
    var arrVisibleLayers = objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID];

    //Get the map service
    let objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

    //variable to hold the visibility of layer
    let blnVisibility;
    let objLayerID;

    //Check if Web Map Service
    //Web Map Services can be number or name/word
    if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService) {
        objLayerID = strLayerID;
    } else {
        objLayerID = Number(strLayerID);
    }

    // The layer is visible when in the array ...
    blnVisibility = ($.inArray(objLayerID, arrVisibleLayers) > -1);

    // When the layer is in arrVisibleLayers and we are take the map service visibility into account ...
    if (blnVisibility && (!blnIgnoreParentAndMapServiceVisibility)) {
        // Get the esri layers for the map service display ...
        var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

        if (arrEsriLayers.length > 0) {
            let blnParentVisible = true;

            if (arrEsriLayers[0].layerInfos) {
                $.each(arrEsriLayers[0].layerInfos, function (intLayerInfo, objLayerInfo) {
                    // When this is a web map service
                    if (objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                        // When this is a parent layer
                        if (objLayerInfo.subLayers && $.grep(objLayerInfo.subLayers, function (objTestLayer) { return objTestLayer.name === objLayerID || (objTestLayer.name === "" && objTestLayer.GeneratedName === objLayerID) }).length > 0) {
                            let strLayerID = TrimbleMap.Controller.Shared.GetWebMapServiceLayerName(objLayerInfo);
                            blnParentVisible = objMapController.GetLayerVisibility(objMapServiceDisplay, strLayerID, blnIgnoreParentAndMapServiceVisibility);
                            return false;
                        }
                    } else {
                        // When this is a parent layer
                        if (objLayerInfo.subLayerIds && $.inArray(objLayerID, objLayerInfo.subLayerIds) > -1) {
                            blnParentVisible = objMapController.GetLayerVisibility(objMapServiceDisplay, objLayerInfo.id, blnIgnoreParentAndMapServiceVisibility);
                            return false;
                        }
                    }
                });
            }

            // Check is the map service is visible ...
            blnVisibility = blnParentVisible && objMapController.GetMapServiceDisplayVisibility(objMapServiceDisplay);
        }
    }

    return blnVisibility;
}

// **************************************************************************
// FUNCTION: FilterLayerIDsForVisibleLayerIDs
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.FilterLayerIDsForVisibleLayerIDs = function FilterLayerIDsForVisibleLayerIDs(objMapServiceDisplay, arrMapLayerIDs) {

    // Get the controller ...
    var objMapController = this;

    // Create a new array for the visible identifyable layers ...
    var arrVisibleLayerIDs = [];

    // When the map service is visible ...
    if (objMapController.GetMapServiceDisplayVisibility(objMapServiceDisplay)) {

        // Loop through all the layer IDs ...
        $.each(arrMapLayerIDs, function (intMapLayerID, strMapLayerID) {

            // Get the esri layer ID for the map layer ID ...
            var strEsriLayerID = objMapController.GetEsriLayerIDForMapLayerID(strMapLayerID);

            // When the layer is visible ...
            if (objMapController.GetLayerVisibility(objMapServiceDisplay, strEsriLayerID, false)) {

                // Add it to the array of visible layer IDs ...
                arrVisibleLayerIDs.push(strMapLayerID);
            }
        });
    }

    return arrVisibleLayerIDs;
}

// **************************************************************************
// FUNCTION: GetMapServiceDisplayVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMapServiceDisplayVisibility = function GetMapServiceDisplayVisibility(objMapServiceDisplay) {

    // Get the controller ...
    var objMapController = this;

    // Determine whether or not the map service is visible ...
    var blnVisible = (typeof objMapController.State.VisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID] != 'undefined' && objMapController.State.VisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID]);

    return blnVisible;
}

// **************************************************************************
// FUNCTION: SetMapServiceDisplayVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.SetMapServiceDisplayVisibility = function SetMapServiceDisplayVisibility(objMapServiceDisplay, blnVisibility) {

    // Get the controller ...
    var objMapController = this;

    // Get the map service ...
    var objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

    // Get the esri layers for the map service display ...
    var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

    //Because Feature map services doesn't set the visibleLayers array
    if (typeof arrEsriLayers[0].visibleLayers == 'undefined') {

        objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] = [];

        for (let intLayer = 0; intLayer < arrEsriLayers.length; intLayer++) {

            if (arrEsriLayers[intLayer].defaultVisibility) {

                //Add the visible layers to the controller state
                objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID].push(arrEsriLayers[intLayer].layerId);
            }
        }

    } else {

        // When no array of Layers ids exist for the maps service id ...
        if (typeof objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] == 'undefined') {

            //Add the visible layers to the controller state
            objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID] = arrEsriLayers[0].visibleLayers;
        }        

    }

    // Get the visible layers for the map service display ...
    var arrVisibleLayers = objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID];

    // Deal with different map service types separately ...
    switch (objMapService.MapServiceType) {
        case TrimbleMap.Controller.enumMapServiceType.Dynamic:
        case TrimbleMap.Controller.enumMapServiceType.Tile:
        case TrimbleMap.Controller.enumMapServiceType.WebMapService:

            // When the layer were successfully loaded ...
            if (arrEsriLayers.length > 0) {

                // Dynamic map services always results in one client side layer, show or hide the layer based on the visibility setting ...
                if (blnVisibility) { arrEsriLayers[0].show(); } else { arrEsriLayers[0].hide(); }
            }
            break;

        case TrimbleMap.Controller.enumMapServiceType.Feature:

            // Loop through all the esri layers ...
            $.each(arrEsriLayers, function (intEsriLayer, objEsriLayer) {

                // When the layer is set visible (or to be visible) ...
                if ($.inArray(objEsriLayer.LayerID, arrVisibleLayers) > -1) {

                    // Show or hide the layer based on the visibility setting ...
                    if (blnVisibility) { objEsriLayer.show(); } else { objEsriLayer.hide(); }
                }
            });
            break;
    }

    // When changed to visible ...
    if (blnVisibility) {

        // Add it to VisibleMapServiceDisplayIDs ...
        objMapController.State.VisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID] = true;

    } else {

        // When found VisibleMapServiceDisplayIDs ...
        if (typeof objMapController.State.VisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID] != 'undefined') {

            // Set to false in VisibleMapServiceDisplayIDs ...
            objMapController.State.VisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID] = false;
        }
    }
}

// **************************************************************************
// FUNCTION: GetGeometriesFromMapServiceLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetGeometriesFromMapServiceLayer = function GetGeometriesFromMapServiceLayer(objMapLayer, strID) {

    // Get the controller ...
    var objMapController = this;

    // Get the map service ...
    let objMapService = objMapController.GetMapService(objMapLayer.MapServiceID);

    // Get the esri layer id for the map layer id ...
    var intEsriLayerID = objMapController.GetEsriLayerIDForMapLayerID(objMapLayer.MapLayerID);

    // When found ...
    if (intEsriLayerID > -1) {

        var objMapLayerRestUrlWithToken = TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, String(intEsriLayerID));

        if (objMapLayerRestUrlWithToken.Success) {

            // Create a new query task and parameters for the layer ...
            var objQueryTask = new esri.tasks.QueryTask(objMapLayerRestUrlWithToken.RestUrlWithToken);
            var objQuery = new esri.tasks.Query();

            // Get the rest service id field name ...
            var strRestServiceIDFieldName = objMapController.GetMapLayerIDFieldName(objMapLayer);

            // Set the search parameters ...
            objQuery.where = strRestServiceIDFieldName + " = " + (($.isNumeric(strID)) ? strID : "'" + strID + "'");
            objQuery.returnGeometry = true;
            objQuery.outFields = [strRestServiceIDFieldName];

            // Execute the query task ...
            var objQueryTaskDeferred = objQueryTask.execute(objQuery);

            // Get the request's IO arguments ...
            var objRequestIOArgs = objMapController.LastEsriRequestIOArgs;

            // Create a new deferred to return ...
            var objDeferred = new dojo.Deferred();

            // When the query task returns ...
            objQueryTaskDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objFeatureSet) {

                // Create a new array to return ...
                var arrGeometries = [];

                // Loop through all the returned features ...
                for (var intFeature = 0; intFeature < objFeatureSet.features.length; intFeature++) {

                    // Get the feature ...
                    var objFeature = objFeatureSet.features[intFeature];

                    // Not a valid geometry when a point type with NaN as x or y ...
                    var blnValidGeometry = (typeof objFeature.geometry != 'undefined') &&
                        (objFeature.geometry != null) &&
                        ((objFeature.geometry.type != 'point') || (!isNaN(objFeature.geometry.x)) || (!isNaN(objFeature.geometry.y)));

                    // When its a valid geometry ..
                    if (blnValidGeometry) {

                        // Add the geometry of the feature to the array to return ...
                        arrGeometries.push(objFeature.geometry);
                    }
                }

                // Resolve the deferred ...
                objDeferred.resolve(arrGeometries);

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                // Get the title and message translations ...

                // Unable to get geometries from map service
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceGeomteriesNotFoundTitle');

                // Attempting to get geometries from map service %1 failed. 
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceGeomteriesNotFoundMessage', objMapService.MapServiceName);

                // Unable to retrieve the spatial data from map service %1.
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceGeomteriesNotFoundEndUserMessage', objMapService.MapServiceName);

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs));

                // Reject the deferred with the error ... 
                objDeferred.reject(objError);
            }));
        }
        else {
            // Get the title and message translations ...

            // Map service token expired
            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

            //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

            //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

            // Log a diagnostic info message ...
            objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

            objDeferred.reject();
        }
    } else {

        // Reject the deferred ... 
        objDeferred.reject();
    }

    // Return the deferred ...
    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetMapServiceMaxRecordCount
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMapServiceMaxRecordCount = function GetMapServiceMaxRecordCount(objMapService) {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Get the max record count for the map service from the cache ...
    var intMaxRecordCount = objMapController.MaxRecordCountByMapService[objMapService.MapServiceID];

    // When we already have the max record count in the cache ...
    if (typeof intMaxRecordCount != 'undefined') {

        // Resolve the deferred with the max count ...
        objDeferred.resolve(intMaxRecordCount);

    } else {

        // Call the web service to get all the translations for the js file ...
        $.ajax({
            url: TrimbleMap.Controller.Shared.AddQueryStringParameter(TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService).RestUrlWithToken, 'f=json'),
            dataType: 'json',
            context: {},
            async: true,
            cache: false,
            error: function (jqXHR, textStatus, errorThrown) {

                // Parse the json response ...
                var objResponseData = JSON.parse(jqXHR.responseText);

                // Get the title and message translations ...

                // Unable to get max record count for map service
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MaxMapServiceRecordCountNotFoundTitle');

                // Unable to get max record count for map service %1. 
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MaxMapServiceRecordCountNotFoundMessage', objMapService.MapServiceName);

                // Unable to get max record count for map service %1. The total number of records might be displayed incorrectly.
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MaxMapServiceRecordCountNotFoundEndUserMessage', objMapService.MapServiceName);

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, (objResponseData) ? TrimbleMap.Controller.Shared.BuildCrashMessage(objResponseData.error) : null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objMapController.LastEsriRequestIOArgs));

                // Add a 1000 to the cache ...
                objMapController.MaxRecordCountByMapService[objMapService.MapServiceID] = 1000;

                // Resolve the deferred with 1000 ...
                objDeferred.resolve(1000);
            },
            complete: function (jqXHR, textStatus) {

                // When returned OK ...
                if (jqXHR.status != 0) {

                    // Parse the json response ...
                    var objResponseData = JSON.parse(jqXHR.responseText);

                    // When we did get a response from the service ...
                    if (typeof objResponseData.error == 'undefined') {

                        // Get the max record count ...
                        var intMaxRecordCount = objResponseData['maxRecordCount'];

                        // Add it to the cache ...
                        objMapController.MaxRecordCountByMapService[objMapService.MapServiceID] = intMaxRecordCount;

                        // Resolve the deferred with the max count ...
                        objDeferred.resolve(intMaxRecordCount);

                    } else {

                        // Get the title and message translations ...

                        // Unable to get max record count for map service
                        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MaxMapServiceRecordCountNotFoundTitle');

                        // Unable to get max record count for map service %1. 
                        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MaxMapServiceRecordCountNotFoundMessage', objMapService.MapServiceName);

                        // Unable to get max record count for map service %1. The total number of records might be displayed incorrectly.
                        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MaxMapServiceRecordCountNotFoundEndUserMessage', objMapService.MapServiceName);

                        // Log the diagnostic message ...
                        objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objResponseData.error), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objMapController.LastEsriRequestIOArgs));

                        // Add a 1000 to the cache ...
                        objMapController.MaxRecordCountByMapService[objMapService.MapServiceID] = 1000;

                        // Resolve the deferred with 1000 ...
                        objDeferred.resolve(1000);
                    }
                }
            }
        });
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: QueryMapServiceFromMapLayerUrls
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.QueryMapServiceFromMapLayerUrls = function QueryMapServiceFromMapLayerUrls(objMapServiceDisplay, objRequestQuery, blnRejectDeferredOnAnyFailure) {

    // Get the controller ...
    let objMapController = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    let blnGetRealCount = true;
    let objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);
    let objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

    // Default blnRejectDeferredOnAnyFailure to false when not set ...
    if ((typeof blnRejectDeferredOnAnyFailure == 'undefined') || (blnRejectDeferredOnAnyFailure == null)) { blnRejectDeferredOnAnyFailure = false; }

    // When we are to query a dynamic or feature service service ...
    if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Feature || objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Dynamic || objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService) {

        // Create an array for all the deferreds of each layer's query task and map layers that correspond to it ...
        let arrQueryTaskDeferred = [];
        let arrCountQueryTaskDeferred = [];
        let arrQueriedMapLayers = [];
        let arrRequestIOArgs = [];

        // Loop through all the esri layer ids in the map service query ...
        $.each(objRequestQuery.Requests, function (intRequest, objRequest) {
            let strRequestUrl = "";
            let objQueryTaskDeferred = null;
            let objQueryTask = null;
            let objQuery = null;
            let objRequestIOArgs

            let enMapServiceType = TrimbleMap.Controller.Shared.GetMapServerType(objMapService);
            let strMapServiceLayerUrl = objRequest.Query;

            if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                // Add a new token if token authenitcation is used as we don't save the token as part of the cached request incase it expires
                if (objMapServiceRestUrlWithToken.Success && objMapServiceRestUrlWithToken.Token) {
                    strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerUrl, 'Token=' + objMapServiceRestUrlWithToken.Token);
                }

                let arrFields = objMapController.GetMapLayerTemplateFields(objRequest.MapLayer, true);

                objQueryTaskDeferred = new dojo.Deferred();

                let objMapLayerData = objMapController.GetCachedMapLayerDataFromService(objRequest.MapLayer.MapLayerID);
                let strGeometryField = "";

                for (let intFieldCounter = 0; intFieldCounter < objMapLayerData.Fields.length; intFieldCounter++) {
                    let objField = objMapLayerData.Fields[intFieldCounter];

                    if (objField.type.startsWith(TrimbleMap.Controller.Shared.WFS_GEOMETRY_FIELD_SEARCH)) {
                        strGeometryField = objField.name;
                        break;
                    }
                }

                objMapController.GetWebFeatureServiceFeatures(enMapServiceType, strMapServiceLayerUrl, null, arrFields, strGeometryField).then(TrimbleMap.Controller.Shared.TrapException(function (arrFeatures) {
                    objQueryTaskDeferred.resolve({ features: arrFeatures });
                }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
                    objQueryTaskDeferred.reject(objError);
                }));
            } else {
                let intEsriLayerID = objMapController.GetEsriLayerIDForMapLayerID(objRequest.MapLayer.MapLayerID);
                strRequestUrl = TrimbleMap.Controller.Shared.MapLayerQueryRestUrlWithToken(objMapService, intEsriLayerID, strMapServiceLayerUrl);

                // Create a new query task and parameters for the layer ...
                objQueryTask = new esri.tasks.QueryTask(strRequestUrl);
                objQuery = new esri.tasks.Query();
                objQuery.returnGeometry = true;

                // Execute the identify task ...
                objQueryTaskDeferred = objQueryTask.execute(objQuery);

                // Get the request's IO arguments ...
                objRequestIOArgs = objMapController.LastEsriRequestIOArgs;

                // Add it to the request args array for later use ...
                arrRequestIOArgs.push(objRequestIOArgs);
            }

            // Create a new deferred ...
            let objErrorHandledQueryTaskDeferred = new dojo.Deferred();

            // Add it to the array ...
            arrQueryTaskDeferred.push(objErrorHandledQueryTaskDeferred);

            // Handle the objQueryTaskDeferred calbacks ...
            objQueryTaskDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objQueryTaskResult) {

                // Resolve the deferred ...
                objErrorHandledQueryTaskDeferred.resolve(objQueryTaskResult);

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                // Get the title and message translations ...

                // Query on map service failed
                let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedTitle');

                // Query on map service %1 map layer %2 failed. 
                let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedMessage', objMapService.MapServiceName, objRequest.MapLayer.MapLayerName);

                // Unable to retrieve data from map service %1 map layer %2. The results for the layer will not be displayed.
                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedEndUserMessage', objMapService.MapServiceName, objRequest.MapLayer.MapLayerName);

                let strError = "";
                let strFailedRequestUrl = ""

                if (objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                    strFailedRequestUrl = strMapServiceLayerUrl;
                } else {
                    strError = TrimbleMap.Controller.Shared.BuildCrashMessage(objError);
                    strFailedRequestUrl = TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs);
                }

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, strError, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strFailedRequestUrl);

                // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure ...
                if (blnRejectDeferredOnAnyFailure) { objErrorHandledQueryTaskDeferred.reject(objError); } else { objErrorHandledQueryTaskDeferred.resolve(null); }
            }));

            // When we are to get the real count ...
            if (blnGetRealCount) {
                // Create a new deferred ...
                let objErrorHandledCountQueryTaskDeferred = new dojo.Deferred();

                // Add it to the array of deferreds for the count ...
                arrCountQueryTaskDeferred.push(objErrorHandledCountQueryTaskDeferred);

                if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                    let strMapServiceLayerCountUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerUrl, TrimbleMap.enumWebFeatureServiceQueryParameterKey.ResultType + '=' + TrimbleMap.Controller.Shared.WFS_RESULT_TYPE_HITS);

                    objMapController.GetWebFeatureServiceFeatureCount(strMapServiceLayerCountUrl).then(TrimbleMap.Controller.Shared.TrapException(function (intTotalCount) {
                        // Resolve the deferred ...
                        objErrorHandledCountQueryTaskDeferred.resolve({ TotalCount: intTotalCount, ExactCountRetrieved: true });
                    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
                        // Get the title and message translations ...

                        // Query to get the count on map service failed
                        let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedTitle');

                        // Query to get the count on map service %1 map layer %2 failed. 
                        let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedMessage', objMapService.MapServiceName, objRequest.MapLayer.MapLayerName);

                        // Unable to retrieve the number of records from map  %1 map layer %2. The number of results for this layer will be reflected incorrectly.
                        let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedEndUserMessage', objMapService.MapServiceName, objRequest.MapLayer.MapLayerName);

                        // Log the diagnostic message ...
                        objMapController.LogDiagnosticMessage(strTitle, strMessage, "", strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strMapServiceLayerCountUrl);

                        // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure ...
                        if (blnRejectDeferredOnAnyFailure) { objErrorHandledCountQueryTaskDeferred.reject(objError); } else { objErrorHandledCountQueryTaskDeferred.resolve(null); }
                    }));
                } else {
                    objQuery.returnDistinctValues = !(objRequest.MapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts);

                    // When the query is to not return distinct values (because if
                    // returnDistinctValues is true then we cannot use executeForCount) ...
                    if (!objQuery.returnDistinctValues) {

                        // No need for order by and geometry for count  ...
                        objQuery.orderByFields = null;
                        objQuery.returnGeometry = false;

                        // Execute the identify task ...
                        let objCountQueryTaskDeferred = objQueryTask.executeForCount(objQuery);

                        // Get the request's IO arguments ...
                        let objCountRequestIOArgs = objMapController.LastEsriRequestIOArgs;

                        // Handle the objCountQueryTaskDeferred calbacks ...
                        objCountQueryTaskDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (intTotalCount) {
                            // Resolve the deferred ...
                            objErrorHandledCountQueryTaskDeferred.resolve({ TotalCount: intTotalCount, ExactCountRetrieved: true });
                        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
                            // Get the title and message translations ...

                            // Query to get the count on map service failed
                            let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedTitle');

                            // Query to get the count on map service %1 map layer %2 failed. 
                            let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedMessage', objMapService.MapServiceName, objRequest.MapLayer.MapLayerName);

                            // Unable to retrieve the number of records from map  %1 map layer %2. The number of results for this layer will be reflected incorrectly.
                            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedEndUserMessage', objMapService.MapServiceName, objRequest.MapLayer.MapLayerName);

                            // Log the diagnostic message ...
                            objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objCountRequestIOArgs));

                            // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure ...
                            if (blnRejectDeferredOnAnyFailure) { objErrorHandledCountQueryTaskDeferred.reject(objError); } else { objErrorHandledCountQueryTaskDeferred.resolve(null); }
                        }));

                    } else {
                        // Get the max record count for the service ...
                        let objMaxRecordCountDeferred = objMapController.GetMapServiceMaxRecordCount(objMapService);

                        // When retrieved ...
                        objMaxRecordCountDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (intMaxRecordCount) {

                            // Resolve the deferred the max record count as total count ...
                            objErrorHandledCountQueryTaskDeferred.resolve({ TotalCount: intMaxRecordCount, ExactCountRetrieved: false });
                        }));
                    }
                }
            }

            // Add the map layer to the array of queried map layers ...
            arrQueriedMapLayers.push(objRequest.MapLayer);

        });

        // Join the deferreds together into a single array ...
        let arrAllQueryTaskDeferred = arrQueryTaskDeferred.concat(arrCountQueryTaskDeferred);

        // When the query task completes ...
        new dojo.promise.all(arrAllQueryTaskDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrQueryTaskResults) {

            // Create a new array for the service's query results ...
            let arrMapServiceQueryResults = [];

            // Create a new array for the map service query results deferreds...
            let arrQueriedMapServiceResultsDeferred = [];

            // Loop through all the queried map layers ...
            for (let intResult = 0; intResult < arrQueriedMapLayers.length; intResult++) {

                // Create a new array for the layer's query results ...
                let arrMapLayerQueryResults = [];

                // Create a new array for the layer query results deferreds...
                let arrQueriedMapLayerResultsDeferred = [];

                // Get the layer's query result ...
                let objQueryTaskResult = arrQueryTaskResults[intResult];

                // When we have a valid result ...
                if (objQueryTaskResult) {

                    let objQueriedMapServiceResultDeferred = new dojo.Deferred();

                    arrQueriedMapServiceResultsDeferred.push(objQueriedMapServiceResultDeferred);

                    // Get the map layer that has been queried in order to get the results ...
                    let objQueriedMapLayer = arrQueriedMapLayers[intResult];

                    // When we did get results back ....
                    if (objQueryTaskResult.features && objQueryTaskResult.features.length > 0) {
                        let arrMissingTemplateFields = [];

                        let enMapServer = TrimbleMap.Controller.Shared.GetMapServerType(objMapService);

                        // We only check missing templates fields when map server is esri because Geoserver does not always return fields/attributes if they are blank
                        if (enMapServer === TrimbleMap.enumMapServerType.ESRI) {
                            // Determine whether or not there are any template fields not in objAttributes
                            arrMissingTemplateFields = objMapController.GetMissingTemplateFields(objQueriedMapLayer, objQueryTaskResult.features[0].attributes);
                        }

                        // When the first feature has all the template fields as attributes ...
                        if (arrMissingTemplateFields.length == 0) {

                            let dicAssetQueryResults = {};

                            // Determine whether or not parts will be displayed separately for the map layer ...
                            let blnDisplaySeparateParts = (objQueriedMapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts);
                            let strIDField = "";

                            if (objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                                blnDisplaySeparateParts = true;
                                strIDField = objQueriedMapLayer.IDField;
                            } else {
                                strIDField = objQueriedMapLayer.RestServiceObjectIDFieldName;
                            }

                            // Loop through the results and build a dictionary that groups geometries of one asset together
                            for (let intAssetFeature = 0; intAssetFeature < objQueryTaskResult.features.length; intAssetFeature++) {

                                let objAssetFeature = objQueryTaskResult.features[intAssetFeature];

                                if (dicAssetQueryResults[objAssetFeature.attributes[strIDField]]) {

                                    dicAssetQueryResults[objAssetFeature.attributes[strIDField]].push(objAssetFeature);
                                }
                                else {
                                    let arrAssetFeatures = [];
                                    arrAssetFeatures.push(objAssetFeature);
                                    dicAssetQueryResults[objAssetFeature.attributes[strIDField]] = arrAssetFeatures;
                                }
                            }

                            // Loop through all the returned assets ...
                            $.each(dicAssetQueryResults, function (guidAssetQueryResult, arrAssetFeatures) {

                                // Create a deferred
                                let objQueryResultDeferred = new dojo.Deferred();

                                arrQueriedMapLayerResultsDeferred.push(objQueryResultDeferred);

                                // Default to Current Map spatial reference ...
                                let guidSpatialReference = objMapController.CurrentMap.SpatialReferenceID;

                                if (blnDisplaySeparateParts) {

                                    // Loop through the asset's features ...
                                    for (let intFeature = 0; intFeature < arrAssetFeatures.length; intFeature++) {

                                        // Get the feature ...
                                        let objFeature = arrAssetFeatures[intFeature];

                                        // Build the geometry from the feature (part) geometry when DisplaySeparateParts is true ...
                                        let objGeometry = objFeature.geometry;

                                        // Create the query result object ...
                                        let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objQueriedMapLayer.MapLayerID, objFeature.attributes, objGeometry, guidSpatialReference);

                                        // Add it to the array ...
                                        arrMapLayerQueryResults.push(objMapLayerQueryResult);
                                    }

                                    // Resolve the result deffered to trigger the next logical block of code
                                    objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                                }
                                else {

                                    // Take the first feature is the list of asset features. They will be the same, except for the geometry property 
                                    let objFeature = arrAssetFeatures[0];

                                    // Check to see if there are more parts to the shape 
                                    if (objFeature.attributes[objQueriedMapLayer.ExteriorShapePartCountFieldName] > arrAssetFeatures.length) {

                                        if (objFeature.attributes[strIDField]) {

                                            let guidObject = objFeature.attributes[strIDField].replace(/[{}]/g, "");

                                            let objQueryMapDeferred = new dojo.Deferred();

                                            // Hit the map service to query the same layer with an ordinary search to get the rest of the shape's parts using guidLicense
                                            objQueryMapDeferred = objMapController.QueryMapLayer(objQueriedMapLayer, objMapService, objMapServiceDisplay, null, false, function () { return "(UPPER(" + strIDField + ") = '" + guidObject + "')"; }, function (objMapLayer, objMapServiceDisplay) { return true; });

                                            objQueryMapDeferred.promise.then(function (arrQueryMapServiceResults) {

                                                let arrSecondaryQueryFeaturesGeometries = [];

                                                $.each(arrQueryMapServiceResults.Data, function (intSecondaryQueryFeature, objSecondaryQueryFeature) {
                                                    arrSecondaryQueryFeaturesGeometries.push(objSecondaryQueryFeature.Geometry);
                                                });

                                                // Build the geometry from the union of all shape parts when DisplaySeparateParts is false ...
                                                let objGeometry = esri.geometry.geometryEngine.union(arrSecondaryQueryFeaturesGeometries);

                                                // Create the query result object ...
                                                let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objQueriedMapLayer.MapLayerID, objFeature.attributes, objGeometry, guidSpatialReference);

                                                // Add it to the array ...
                                                arrMapLayerQueryResults.push(objMapLayerQueryResult);

                                                // Resolve the result deffered to trigger the next logical block of code
                                                objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                                            });
                                        }
                                    }
                                    else {

                                        let arrGeometries = [];

                                        $.each(arrAssetFeatures, function (intResultFeature, objResultFeature) {
                                            arrGeometries.push(objResultFeature.geometry);
                                        });

                                        // Build the geometry from the union of all shape parts when DisplaySeparateParts is false ...
                                        let objGeometry = null;
                                        if (arrGeometries && arrGeometries.length > 0) {
                                            objGeometry = esri.geometry.geometryEngine.union(arrGeometries);
                                        }

                                        // Create the query result object ...
                                        let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objQueriedMapLayer.MapLayerID, objFeature.attributes, objGeometry, guidSpatialReference);

                                        // Add it to the array ...
                                        arrMapLayerQueryResults.push(objMapLayerQueryResult);

                                        // Resolve the result deffered to trigger the next logical block of code
                                        objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                                    }
                                }

                            });
                        }
                        else {

                            // Start with an empty string ... 
                            let strMissingTemplateFields = '';

                            // Loop through all the missing fields ...
                            $.each(arrMissingTemplateFields, function (intMissingTemplateField, strMissingTemplateField) {

                                // Add a comma when not the first one ...
                                if (strMissingTemplateFields.length > 0) { strMissingTemplateFields += ', '; }

                                // Add the missing field name ...
                                strMissingTemplateFields += strMissingTemplateField;
                            });

                            // Get the title and message translations ...

                            // Query returned unexpected fields
                            let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnexpectedFieldsReturnedTitle');

                            // Querying map service %1 map layer %2 did not return the following expected fields: %3 
                            let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnexpectedFieldsReturnedMessage', objMapService.MapServiceName, objQueriedMapLayer.MapLayerName, strMissingTemplateFields);

                            // Unable to display data from map service %1 map layer %2. The results for this layer will not be displayed.
                            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnexpectedFieldsReturnedEndUserMessage', objMapService.MapServiceName, objQueriedMapLayer.MapLayerName);

                            // Get the IO args for the request ...
                            let objRequestIOArgs = arrRequestIOArgs[intResult];

                            let strFailedRequestUrl = ""

                            if (objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                                strFailedRequestUrl = strMapServiceLayerUrl;
                            } else {
                                strFailedRequestUrl = TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs);
                            }

                            // Log the diagnostic message ...
                            objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strFailedRequestUrl);
                        }
                    }

                    // When all query tasks for the current QueriedMapLayer complete ...
                    new dojo.promise.all(arrQueriedMapLayerResultsDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrMapLayerQueryResults) {

                        let arrQueriedMapLayerResults = (arrMapLayerQueryResults && arrMapLayerQueryResults.length > 0) ? arrMapLayerQueryResults[0] : [];

                        // Get the total count (use the ExeuteForCount result when we are to get the real count) ...
                        let objTotalCount = (blnGetRealCount) ? arrQueryTaskResults[arrQueriedMapLayers.length + intResult] : { TotalCount: objQueryTaskResult.features.length, ExactCountRetrieved: true };

                        // When we did get the count ...
                        if ((objTotalCount != 'undefined') && (objTotalCount != null)) {

                            // Create a map service query result ...
                            let objMapServiceQueryResult = TrimbleMap.Controller.Shared.CreateMapServiceQueryResult(objQueriedMapLayer.MapLayerID,
                                objTotalCount.TotalCount,
                                objTotalCount.ExactCountRetrieved,
                                arrQueriedMapLayerResults);

                            // Add it to the service query results array ...
                            arrMapServiceQueryResults.push(objMapServiceQueryResult);
                        }

                        // Resolve the map service query results deferred ...
                        objQueriedMapServiceResultDeferred.resolve(arrMapServiceQueryResults);

                    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                        // Reject the deferred with the error ...
                        objDeferred.reject(objError);
                    }));
                }
            }

            new dojo.promise.all(arrQueriedMapServiceResultsDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrMapServiceQueryResults) {
                let arrQueriedMapServiceResults = (arrMapServiceQueryResults && arrMapServiceQueryResults.length > 0) ? arrMapServiceQueryResults[0] : [];

                // Resolve the returned deferred, passing in the results ...
                objDeferred.resolve(arrQueriedMapServiceResults);

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
                // Reject the deferred with the error ...
                objDeferred.reject(objError);
            }));
        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
            // Reject the deferred with the error ...
            objDeferred.reject(objError);
        }));
    } else if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Tile) {
        // Map.Controller.QueryMapService not implemented for tile services
        throw 'TrimbleMap.Controller.QueryMapService not implemented for tile services ...'
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: QueryMapService
// USAGE:    fnBuildLayerWhereClause(objMapService, objMapLayer)
//           - Should build a where clause for the layer ...
//           - Specify at least one of objGeometry or fnBuildLayerWhereClause
//           - blnRejectDeferredOnAnyFailure is optional and defaults to false ...
// **************************************************************************
TrimbleMap.Controller.QueryMapService = function QueryMapService(objMapService, objMapServiceDisplay, objGeometry, blnGetRealCount, fnBuildLayerWhereClause, fnQueryMapLayer, blnRejectDeferredOnAnyFailure, objMapServiceSelection) {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Default blnRejectDeferredOnAnyFailure to false when not set ...
    if ((typeof blnRejectDeferredOnAnyFailure == 'undefined') || (blnRejectDeferredOnAnyFailure == null)) { blnRejectDeferredOnAnyFailure = false; }

    // When we are to query a dynamic or feature service service ...
    if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Feature || objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Dynamic) {

        var objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

        if (objMapServiceRestUrlWithToken.Success) {

            // Create an array for all the deferreds of each layer's query task and map layers that correspond to it ...
            var arrQueryTaskDeferred = [];
            var arrCountQueryTaskDeferred = [];
            var arrQueriedMapLayers = [];
            var arrRequestIOArgs = [];

            // Loop through all the esri layer ids in the map service ...
            objMapController.ForEachEsriLayerIDInMapServiceDisplay(objMapService, objMapServiceDisplay, function (strEsriLayerID) {

                // Get the map layer id for the esri map layer id ...
                var strMapLayerID = objMapController.GetMapLayerIDForEsriLayerID(objMapService.MapServiceID, strEsriLayerID);

                // When we managed to get the map layer ID ...
                if (strMapLayerID != null) {

                    // Get the map layer ...
                    var objMapLayer = objMapController.GetMapLayer(strMapLayerID);

                    // When the map layer is to be included in the query ...
                    if (fnQueryMapLayer(objMapLayer, objMapServiceDisplay)) {
                        // Create a new query task and parameters for the layer ...
                        var objQueryTask = new esri.tasks.QueryTask(TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, strEsriLayerID).RestUrlWithToken);
                        var objQuery = new esri.tasks.Query();

                        // Set the search parameters ...
                        objQuery.spatialRelationship = esri.tasks.Query.SPATIAL_REL_INTERSECTS;
                        objQuery.returnGeometry = true;
                        objQuery.returnDistinctValues = !objQuery.returnGeometry;
                        objQuery.outFields = (objMapLayer.IsGeneric) ? ['*'] : objMapController.GetMapLayerTemplateFields(objMapLayer, true);

                        //When the layer has a heading attribute name ...
                        if ((objMapLayer.TemplateHeaderFields) && (objMapLayer.TemplateHeaderFields.length > 0)) {

                            // Set it as the order by field ...
                            objQuery.orderByFields = objMapLayer.TemplateHeaderFields;
                        }

                        // Set the input geometry when we have one ...
                        if ((typeof objGeometry != 'undefined') && objGeometry) { objQuery.geometry = objGeometry; }

                        // When we have a build where clause function ...
                        if ((typeof fnBuildLayerWhereClause != 'undefined') && fnBuildLayerWhereClause) {

                            // Build the where clause for the map layer ...
                            objQuery.where = fnBuildLayerWhereClause(objMapService, objMapLayer);
                        }

                        // Execute the identify task ...
                        var objQueryTaskDeferred = objQueryTask.execute(objQuery);

                        // Get the request's IO arguments ...
                        var objRequestIOArgs = objMapController.LastEsriRequestIOArgs;

                        // Add it to the request args array for later use ...
                        arrRequestIOArgs.push(objRequestIOArgs);

                        // If we are to build a map service selection object for local storage
                        if (objMapController.Preferences.KeepSearchAndSelectResults && objMapServiceSelection) {

                            let strRequestParameters = TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs);

                            strRequestParameters = TrimbleMap.Controller.Shared.UrlParameters(strRequestParameters);

                            strRequestParameters = TrimbleMap.Controller.Shared.RemoveTokenFromUrlParameters(strRequestParameters);

                            objMapServiceSelection.Requests.push({ "MapLayer": objMapLayer, "Query": strRequestParameters });
                        }

                        // Create a new deferred ...
                        var objErrorHandledQueryTaskDeferred = new dojo.Deferred();

                        // Add it to the array ...
                        arrQueryTaskDeferred.push(objErrorHandledQueryTaskDeferred);

                        // Handle the objQueryTaskDeferred calbacks ...
                        objQueryTaskDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objQueryTaskResult) {

                            // Resolve the deferred ...
                            objErrorHandledQueryTaskDeferred.resolve(objQueryTaskResult);

                        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                            // Get the title and message translations ...

                            // Query on map service failed
                            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedTitle');

                            // Query on map service %1 map layer %2 failed. 
                            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                            // Unable to retrieve data from map service %1 map layer %2. The results for the layer will not be displayed.
                            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                            // Log the diagnostic message ...
                            objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs));

                            // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure ...
                            if (blnRejectDeferredOnAnyFailure) { objErrorHandledQueryTaskDeferred.reject(objError); } else { objErrorHandledQueryTaskDeferred.resolve(null); }
                        }));

                        // When we are to get the real count ...
                        if (blnGetRealCount) {

                            objQuery.returnDistinctValues = !(objMapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts);

                            // When the query is to not return distinct values (because if
                            // returnDistinctValues is true then we cannot use executeForCount) ...
                            if (!objQuery.returnDistinctValues) {

                                // No need for order by and geometry for count  ...
                                objQuery.orderByFields = null;
                                objQuery.returnGeometry = false;

                                // Execute the identify task ...
                                var objCountQueryTaskDeferred = objQueryTask.executeForCount(objQuery);

                                // Get the request's IO arguments ...
                                var objCountRequestIOArgs = objMapController.LastEsriRequestIOArgs;

                                // Create a new deferred ...
                                var objErrorHandledCountQueryTaskDeferred = new dojo.Deferred();

                                // Add it to the array of deferreds for the count ...
                                arrCountQueryTaskDeferred.push(objErrorHandledCountQueryTaskDeferred);

                                // Handle the objCountQueryTaskDeferred calbacks ...
                                objCountQueryTaskDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (intTotalCount) {

                                    // Resolve the deferred ...
                                    objErrorHandledCountQueryTaskDeferred.resolve({ TotalCount: intTotalCount, ExactCountRetrieved: true });

                                }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                                    // Get the title and message translations ...

                                    // Query to get the count on map service failed
                                    var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedTitle');

                                    // Query to get the count on map service %1 map layer %2 failed. 
                                    var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                                    // Unable to retrieve the number of records from map  %1 map layer %2. The number of results for this layer will be reflected incorrectly.
                                    var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                                    // Log the diagnostic message ...
                                    objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objCountRequestIOArgs));

                                    // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure ...
                                    if (blnRejectDeferredOnAnyFailure) { objErrorHandledCountQueryTaskDeferred.reject(objError); } else { objErrorHandledCountQueryTaskDeferred.resolve(null); }
                                }));

                            } else {

                                // Create a new deferred ...
                                var objMaxRecordCountTextDeferred = new dojo.Deferred();

                                // Add it to the array of deferreds for the count ...
                                arrCountQueryTaskDeferred.push(objMaxRecordCountTextDeferred);

                                // Get the max record count for the service ...
                                var objMaxRecordCountDeferred = objMapController.GetMapServiceMaxRecordCount(objMapService);

                                // When retrieved ...
                                objMaxRecordCountDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (intMaxRecordCount) {

                                    // Resolve the deferred the max record count as total count ...
                                    objMaxRecordCountTextDeferred.resolve({ TotalCount: intMaxRecordCount, ExactCountRetrieved: false });
                                }));
                            }
                        }

                        // Add the map layer to the array of queried map layers ...
                        arrQueriedMapLayers.push(objMapLayer);

                    } else {

                        // When the layer has not been configured in FlexiCadastre ...
                        if (strMapLayerID == null) {

                            // Get the title and message translations ...

                            // Layer not configured
                            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'LayerNotConfiguredTitle');

                            // Layer with id %1 on Map service %2 has not been configured in FlexiCadastre. 
                            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'LayerNotConfiguredMessage', strEsriLayerID, objMapService.MapServiceName);

                            // Log a diagnostic info message ...
                            objMapController.LogDiagnosticMessage(strTitle, strMessage, null, null, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, null);
                        }
                    }

                } else {

                    // Get the title and message translations ...

                    // Unable to query layer
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToQueryMapServiceLayerTitle');

                    // Unable to query layer with id %1 on map service %2 because no configuration were found for a layer with the layer's name. 
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToQueryMapServiceLayerMessage', strEsriLayerID, objMapService.MapServiceName);

                    // Unable to query a layer on map service %1 because no configuration were found for a layer with the layer's name. No results will be included for the layer.
                    var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToQueryMapServiceLayerEndUserMessage', objMapService.MapServiceName);

                    // Log the diagnostic message ...
                    objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, null);
                }
            });

            // Join the deferreds together into a single array ...
            var arrAllQueryTaskDeferred = arrQueryTaskDeferred.concat(arrCountQueryTaskDeferred);

            // When the query task completes ...
            new dojo.promise.all(arrAllQueryTaskDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrQueryTaskResults) {

                // Create a new array for the service's query results ...
                let arrMapServiceQueryResults = [];

                // Create a new array for the map service query results deferreds...
                let arrQueriedMapServiceResultsDeferred = [];

                // Loop through all the queried map layers ...
                for (let intResult = 0; intResult < arrQueriedMapLayers.length; intResult++) {

                    // Create a new array for the layer's query results ...
                    let arrMapLayerQueryResults = [];

                    // Create a new array for the layer query results deferreds...
                    let arrQueriedMapLayerResultsDeferred = [];

                    // Get the layer's query result ...
                    let objQueryTaskResult = arrQueryTaskResults[intResult];

                    // When we have a valid result ...
                    if (objQueryTaskResult) {

                        let objQueriedMapServiceResultDeferred = new dojo.Deferred();

                        arrQueriedMapServiceResultsDeferred.push(objQueriedMapServiceResultDeferred);

                        // Get the map layer that has been queried in order to get the results ...
                        let objQueriedMapLayer = arrQueriedMapLayers[intResult];

                        // When we did get results back ....
                        if (objQueryTaskResult.features.length > 0) {

                            // Determine whether or not there are any template fields not in objAttributes ...
                            let arrMissingTemplateFields = objMapController.GetMissingTemplateFields(objQueriedMapLayer, objQueryTaskResult.features[0].attributes);

                            // When the first feature has all the template fields as attributes ...
                            if (arrMissingTemplateFields.length == 0) {

                                let dicAssetQueryResults = {};

                                // Determine whether or not parts will be displayed separately for the map layer ...
                                var blnDisplaySeparateParts = (objQueriedMapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts);

                                // Loop through the results and build a dictionary that groups geometries of one asset together
                                for (let intAssetFeature = 0; intAssetFeature < objQueryTaskResult.features.length; intAssetFeature++) {

                                    let objAssetFeature = objQueryTaskResult.features[intAssetFeature];

                                    if (dicAssetQueryResults[objAssetFeature.attributes[objQueriedMapLayer.RestServiceObjectIDFieldName]]) {

                                        dicAssetQueryResults[objAssetFeature.attributes[objQueriedMapLayer.RestServiceObjectIDFieldName]].push(objAssetFeature);
                                    }
                                    else {
                                        let arrAssetFeatures = [];
                                        arrAssetFeatures.push(objAssetFeature);
                                        dicAssetQueryResults[objAssetFeature.attributes[objQueriedMapLayer.RestServiceObjectIDFieldName]] = arrAssetFeatures;
                                    }
                                }

                                // Loop through all the returned assets ...
                                $.each(dicAssetQueryResults, function (guidAssetQueryResult, arrAssetFeatures) {

                                    // Create a deferred
                                    let objQueryResultDeferred = new dojo.Deferred();

                                    arrQueriedMapLayerResultsDeferred.push(objQueryResultDeferred);

                                    // Default to Current Map spatial reference ...
                                    let guidSpatialReference = objMapController.CurrentMap.SpatialReferenceID;

                                    if (blnDisplaySeparateParts) {

                                        // Loop through the asset's features ...
                                        for (let intFeature = 0; intFeature < arrAssetFeatures.length; intFeature++) {

                                            // Get the feature ...
                                            let objFeature = arrAssetFeatures[intFeature];

                                            // Build the geometry from the feature (part) geometry when DisplaySeparateParts is true ...
                                            let objGeometry = objFeature.geometry;

                                            // Create the query result object ...
                                            let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objQueriedMapLayer.MapLayerID, objFeature.attributes, objGeometry, guidSpatialReference);

                                            // Add it to the array ...
                                            arrMapLayerQueryResults.push(objMapLayerQueryResult);
                                        }

                                        // Resolve the result deffered to trigger the next logical block of code
                                        objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                                    }
                                    else {

                                        // Take the first feature is the list of asset features. They will be the same, except for the geometry property 
                                        let objFeature = arrAssetFeatures[0];

                                        // Check to see if there are more parts to the shape 
                                        if (objFeature.attributes[objQueriedMapLayer.ExteriorShapePartCountFieldName] > arrAssetFeatures.length) {

                                            if (objFeature.attributes[objQueriedMapLayer.RestServiceObjectIDFieldName]) {

                                                let guidObject = objFeature.attributes[objQueriedMapLayer.RestServiceObjectIDFieldName].replace(/[{}]/g, "");

                                                let objQueryMapDeferred = new dojo.Deferred();

                                                // Hit the map service to query the same layer with an ordinary search to get the rest of the shape's parts using guidLicense                 
                                                objQueryMapDeferred = objMapController.QueryMapLayer(objQueriedMapLayer, objMapService, objMapServiceDisplay, null, false, function () { return "(UPPER(" + objQueriedMapLayer.RestServiceObjectIDFieldName + ") = '" + guidObject + "')"; }, function (objMapLayer, objMapServiceDisplay) { return true; });

                                                objQueryMapDeferred.promise.then(function (arrQueryMapServiceResults) {

                                                    let arrSecondaryQueryFeaturesGeometries = [];

                                                    $.each(arrQueryMapServiceResults.Data, function (intSecondaryQueryFeature, objSecondaryQueryFeature) {
                                                        arrSecondaryQueryFeaturesGeometries.push(objSecondaryQueryFeature.Geometry);
                                                    });

                                                    // Build the geometry from the union of all shape parts when DisplaySeparateParts is false ...
                                                    let objGeometry = esri.geometry.geometryEngine.union(arrSecondaryQueryFeaturesGeometries);

                                                    // Create the query result object ...
                                                    let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objQueriedMapLayer.MapLayerID, objFeature.attributes, objGeometry, guidSpatialReference);

                                                    // Add it to the array ...
                                                    arrMapLayerQueryResults.push(objMapLayerQueryResult);

                                                    // Resolve the result deffered to trigger the next logical block of code
                                                    objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                                                });
                                            }
                                        }
                                        else {

                                            let arrGeometries = [];

                                            $.each(arrAssetFeatures, function (intResultFeature, objResultFeature) {
                                                arrGeometries.push(objResultFeature.geometry);
                                            });

                                            // Build the geometry from the union of all shape parts when DisplaySeparateParts is false ...
                                            let objGeometry = esri.geometry.geometryEngine.union(arrGeometries);

                                            // Create the query result object ...
                                            let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objQueriedMapLayer.MapLayerID, objFeature.attributes, objGeometry, guidSpatialReference);

                                            // Add it to the array ...
                                            arrMapLayerQueryResults.push(objMapLayerQueryResult);

                                            // Resolve the result deffered to trigger the next logical block of code
                                            objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                                        }
                                    }

                                });
                            }
                            else {

                                // Start with an empty string ... 
                                var strMissingTemplateFields = '';

                                // Loop through all the missing fields ...
                                $.each(arrMissingTemplateFields, function (intMissingTemplateField, strMissingTemplateField) {

                                    // Add a comma when not the first one ...
                                    if (strMissingTemplateFields.length > 0) { strMissingTemplateFields += ', '; }

                                    // Add the missing field name ...
                                    strMissingTemplateFields += strMissingTemplateField;
                                });

                                // Get the title and message translations ...

                                // Query returned unexpected fields
                                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnexpectedFieldsReturnedTitle');

                                // Querying map service %1 map layer %2 did not return the following expected fields: %3 
                                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnexpectedFieldsReturnedMessage', objMapService.MapServiceName, objQueriedMapLayer.MapLayerName, strMissingTemplateFields);

                                // Unable to display data from map service %1 map layer %2. The results for this layer will not be displayed.
                                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnexpectedFieldsReturnedEndUserMessage', objMapService.MapServiceName, objQueriedMapLayer.MapLayerName);

                                // Get the IO args for the request ...
                                var objRequestIOArgs = arrRequestIOArgs[intResult];

                                // Log the diagnostic message ...
                                objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs));
                            }
                        }

                        // When all query tasks for the current QueriedMapLayer complete ...
                        new dojo.promise.all(arrQueriedMapLayerResultsDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrMapLayerQueryResults) {

                            let arrQueriedMapLayerResults = (arrMapLayerQueryResults && arrMapLayerQueryResults.length > 0) ? arrMapLayerQueryResults[0] : [];

                            // Get the total count (use the ExeuteForCount result when we are to get the real count) ...
                            let objTotalCount = (blnGetRealCount) ? arrQueryTaskResults[arrQueriedMapLayers.length + intResult] : { TotalCount: objQueryTaskResult.features.length, ExactCountRetrieved: true };

                            // When we did get the count ...
                            if ((objTotalCount != 'undefined') && (objTotalCount != null)) {

                                // Create a map service query result ...
                                let objMapServiceQueryResult = TrimbleMap.Controller.Shared.CreateMapServiceQueryResult(objQueriedMapLayer.MapLayerID,
                                    objTotalCount.TotalCount,
                                    objTotalCount.ExactCountRetrieved,
                                    arrQueriedMapLayerResults);

                                // Add it to the service query results array ...
                                arrMapServiceQueryResults.push(objMapServiceQueryResult);
                            }

                            // Resolve the map service query results deferred ...
                            objQueriedMapServiceResultDeferred.resolve(arrMapServiceQueryResults);

                        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                            // Reject the deferred with the error ...
                            objDeferred.reject(objError);
                        }));
                    }
                }

                new dojo.promise.all(arrQueriedMapServiceResultsDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrMapServiceQueryResults) {

                    let arrQueriedMapServiceResults = (arrMapServiceQueryResults && arrMapServiceQueryResults.length > 0) ? arrMapServiceQueryResults[0] : [];

                    // Resolve the returned deferred, passing in the results ...
                    objDeferred.resolve(arrQueriedMapServiceResults);

                }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                    // Reject the deferred with the error ...
                    objDeferred.reject(objError);
                }));

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                // Reject the deferred with the error ...
                objDeferred.reject(objError);
            }));

        } else {


            // Map service token expired
            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

            //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

            //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

            // Log a diagnostic info message ...
            objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

            objDeferred.resolve([]);
        }
    } else if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService) {
        objMapController.QueryWebFeatureService(objMapService, objMapServiceDisplay, objGeometry, blnGetRealCount, fnBuildLayerWhereClause, fnQueryMapLayer, blnRejectDeferredOnAnyFailure, objMapServiceSelection, objDeferred);
    } else if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Tile) {

        // Map.Controller.QueryMapService not implemented for tile services
        throw 'TrimbleMap.Controller.QueryMapService not implemented for tile services ...'
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: QueryWebFeatureService
// USAGE:    Queries a web feature service and returns the features that match 
//           the filters specified
// **************************************************************************
TrimbleMap.Controller.QueryWebFeatureService = function QueryWebFeatureService(objMapService, objMapServiceDisplay, objGeometry, blnGetRealCount, fnBuildLayerWhereClause, fnQueryMapLayer, blnRejectDeferredOnAnyFailure, objMapServiceSelection, objDeferred) {
    let objMapController = this;

    let objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

    if (objMapServiceRestUrlWithToken.Success) {
        let arrMapLayerFeaturesDeferred = [];
        let arrMapLayerFeatureCountDeferred = [];
        let arrQueriedMapLayers = [];

        let enMapServer = TrimbleMap.Controller.Shared.GetMapServerType(objMapService);

        // Loop through all the esri layer ids in the map service
        objMapController.ForEachEsriLayerIDInMapServiceDisplay(objMapService, objMapServiceDisplay, function (strEsriLayerID) {

            // Get the map layer id for the esri map layer id
            let strMapLayerID = objMapController.GetMapLayerIDForEsriLayerID(objMapService.MapServiceID, strEsriLayerID);

            if (strMapLayerID != null) {
                let objMapLayer = objMapController.GetMapLayer(strMapLayerID);

                // When the map layer is to be included in the query 
                if (fnQueryMapLayer(objMapLayer, objMapServiceDisplay)) {
                    let objMapLayerData = objMapController.GetCachedMapLayerDataFromService(strMapLayerID);
                    let strGeometryField = "";

                    for (let intFieldCounter = 0; intFieldCounter < objMapLayerData.Fields.length; intFieldCounter++) {
                        let objField = objMapLayerData.Fields[intFieldCounter];

                        if (objField.type.startsWith(TrimbleMap.Controller.Shared.WFS_GEOMETRY_FIELD_SEARCH)) {
                            strGeometryField = objField.name;
                            break;
                        }
                    }

                    let objMapLayerIDDeferred = objMapController.GetWebFeatureServiceLayerId(objMapService, objMapLayer, blnRejectDeferredOnAnyFailure);

                    // Create a new deferred
                    let objMapLayerFeaturesDeferred = new dojo.Deferred();
                    arrMapLayerFeaturesDeferred.push(objMapLayerFeaturesDeferred);

                    let objMaxRecordCountTextDeferred = null;

                    // When we are to get the real count ...
                    if (blnGetRealCount) {
                        // Create a new deferred
                        objMaxRecordCountTextDeferred = new dojo.Deferred();

                        // Add it to the array of deferreds for the count
                        arrMapLayerFeatureCountDeferred.push(objMaxRecordCountTextDeferred);
                    }

                    objMapLayerIDDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (strLayerID) {
                        if (strLayerID) {
                            let strMapServiceLayerUrl = objMapController.GetWebFeatureServiceUrlWithQueryParameters(objMapService, TrimbleMap.enumWebFeatureServiceRequest.GetFeature, strLayerID);
                            let arrFields = objMapController.GetMapLayerTemplateFields(objMapLayer, true);

                            strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerUrl, 'MapServiceID=' + objMapService.MapServiceID);
                            strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(objMapController.State.ArcGISProxyServiceUrl, strMapServiceLayerUrl);

                            // If we are to build a map service selection object for local storage
                            //TODO: Consequent to LF-11144, caching WFS queries to local storage will need to be reworked to support POST queries by storing the request payload also
                            if (objMapController.Preferences.KeepSearchAndSelectResults && objMapServiceSelection) {
                                objMapServiceSelection.Requests.push({ "MapLayer": objMapLayer, "Query": strMapServiceLayerUrl });
                            }

                            if (objMapServiceRestUrlWithToken.Token) {
                                strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerUrl, 'Token=' + objMapServiceRestUrlWithToken.Token);
                            }

                            let strReturnSpatialReferenceWKID = '';

                            let objSpatialReference = objMapController.GetSpatialReference(objMapController.CurrentMap.SpatialReferenceID);

                            if (objSpatialReference && objSpatialReference.WKID) {
                                strReturnSpatialReferenceWKID = TrimbleMap.enumWebFeatureServiceQueryParameterKey.SrsName + "=\"" + TrimbleMap.Controller.Shared.WFS_EPSG + ":" + objSpatialReference.WKID + "\"";
                            }

                            let strGetFeatureXml = "<wfs:GetFeature service=\"" + TrimbleMap.enumOgcMapService.WFS + "\" version=\"" + TrimbleMap.Controller.Shared.WFS_VERSION + "\" " +
                                TrimbleMap.enumWebFeatureServiceQueryParameterKey.MaxFeatures + "=\"" + TrimbleMap.Controller.Shared.MAX_WFS_FEATURES + "\" " +
                                "xmlns:topp=\"" + TrimbleMap.Controller.Shared.TOPP_NAMESPACE + "\" " +
                                "xmlns:wfs=\"" + TrimbleMap.Controller.Shared.WFS_NAMESPACE + "\" " +
                                "xmlns:ogc=\"" + TrimbleMap.Controller.Shared.OGC_NAMESPACE + "\" " +
                                "xmlns:gml=\"" + TrimbleMap.Controller.Shared.GML_NAMESPACE + "\" " +
                                "xmlns:xsi=\"" + TrimbleMap.Controller.Shared.XSI_NAMESPACE + "\" " +
                                "xsi:schemaLocation=\"" + TrimbleMap.Controller.Shared.WFS_NAMESPACE + " " + TrimbleMap.Controller.Shared.WFS_SCHEMA + "\"> ";

                            let strQueryXml = "<wfs:Query " + TrimbleMap.enumWebFeatureServiceQueryParameterKey.TypeName + "=\"" + strLayerID + "\" " + strReturnSpatialReferenceWKID + "> ";

                            let strFieldsXml = "";
                            let strLayerNamePrefix = strLayerID.substring(0, strLayerID.indexOf(":"));

                            if (arrFields.length > 0) {
                                arrFields.forEach(function (strField, intField) {
                                    strFieldsXml += "<wfs:PropertyName>" + strLayerNamePrefix + ":" + strField + "</wfs:PropertyName> ";
                                });
                            }

                            if (strGeometryField) {
                                strFieldsXml += "<wfs:PropertyName>" + strLayerNamePrefix + ":" + strGeometryField + "</wfs:PropertyName> ";
                            }

                            if (strFieldsXml) {
                                strQueryXml += strFieldsXml;
                            }

                            let strFilterXml = "";

                            if (fnBuildLayerWhereClause) {
                                strFilterXml = fnBuildLayerWhereClause(objMapService, objMapLayer);
                            }

                            let strGeometryFilterXml = "";

                            // Set the input geometry when we have one
                            if (objGeometry) {
                                let arrPoints = TrimbleMap.Controller.Shared.FlattenGeometriesToPointArray([objGeometry]);
                                let strWKID = objGeometry.spatialReference.wkid;
                                let strPoints = "";

                                //If the maps WKID is retrieved then the results will be returned in that spatial reference. The coordinates are expected in X Y order
                                //If the maps WKID is not retrieved then the Coordinates are returned in the default spatial reference of the WFS. The coordinates are expected in Y X order
                                if (objSpatialReference && objSpatialReference.WKID) {
                                    $.each(arrPoints, function (intPoint, objPoint) {
                                        strPoints += objPoint.x + " ";
                                        strPoints += objPoint.y + " ";
                                    });
                                } else {
                                    $.each(arrPoints, function (intPoint, objPoint) {
                                        strPoints += objPoint.y + " ";
                                        strPoints += objPoint.x + " ";
                                    });
                                }

                                strPoints = strPoints.substring(0, strPoints.length - 1);

                                switch (objGeometry.type) {
                                    case 'point':
                                        strGeometryFilterXml = "<ogc:Intersects><ogc:PropertyName>" + strGeometryField + "</ogc:PropertyName><gml:Point srsName=\"urn:x-ogc:def:crs:EPSG:" + strWKID + "\"><gml:posList>" + strPoints + "</gml:posList></gml:Point></ogc:Intersects> ";
                                        break;
                                    case 'polyline':
                                        if (enMapServer === TrimbleMap.enumMapServerType.ESRI) {
                                            strGeometryFilterXml = "<ogc:Intersects><ogc:PropertyName>" + strGeometryField + "</ogc:PropertyName><gml:LineString srsName=\"urn:x-ogc:def:crs:EPSG:" + strWKID + "\"><gml:coordinates>" + strPoints + "</gml:coordinates></gml:LineString></ogc:Intersects> ";
                                        }
                                        else {
                                            strGeometryFilterXml = "<ogc:Intersects><ogc:PropertyName>" + strGeometryField + "</ogc:PropertyName><gml:LineString srsName=\"urn:x-ogc:def:crs:EPSG:" + strWKID + "\"><gml:posList>" + strPoints + "</gml:posList></gml:LineString></ogc:Intersects> ";
                                        }
                                        break;
                                    case 'polygon':
                                        if (enMapServer === TrimbleMap.enumMapServerType.ESRI) {
                                            strGeometryFilterXml = "<ogc:Intersects><ogc:PropertyName>" + strGeometryField + "</ogc:PropertyName><gml:Polygon srsName=\"urn:x-ogc:def:crs:EPSG:" + strWKID + "\"><gml:outerBoundaryIs><gml:LinearRing><gml:coordinates>" + strPoints + "</gml:coordinates></gml:LinearRing></gml:outerBoundaryIs></gml:Polygon></ogc:Intersects> ";
                                        }
                                        else {
                                            strGeometryFilterXml = "<ogc:Intersects><ogc:PropertyName>" + strGeometryField + "</ogc:PropertyName><gml:Polygon srsName=\"urn:x-ogc:def:crs:EPSG:" + strWKID + "\"><gml:exterior><gml:LinearRing> <gml:posList>" + strPoints + "</gml:posList></gml:LinearRing></gml:exterior></gml:Polygon></ogc:Intersects> ";
                                        }
                                        break;
                                    case 'extent':
                                        let strLowerCorner = objGeometry.xmax + " " + objGeometry.ymin;
                                        let strUpperCorner = objGeometry.xmin + " " + objGeometry.ymax;
                                        strGeometryFilterXml = "<ogc:BBOX><ogc:PropertyName>" + strGeometryField + "</ogc:PropertyName><gml:Envelope srsName=\"urn:x-ogc:def:crs:EPSG:" + strWKID + "\"><gml:lowerCorner>" + strLowerCorner + "</gml:lowerCorner><gml:upperCorner>" + strUpperCorner + "</gml:upperCorner></gml:Envelope></ogc:BBOX> ";
                                        break;
                                }
                            }

                            if (strGeometryFilterXml) {
                                if (strFilterXml) {
                                    strFilterXml = strFilterXml.splice(strFilterXml.indexOf("<ogc:Filter>") + 12, 0, "<ogc:And>");
                                    strFilterXml = strFilterXml.splice(strFilterXml.indexOf("</ogc:Filter>") - 1, 0, strGeometryFilterXml + "</ogc:And>");
                                } else {
                                    strFilterXml = "<ogc:Filter>" + strGeometryFilterXml + "</ogc:Filter>";
                                }
                            }

                            strQueryXml += strFilterXml;

                            strQueryXml += "</wfs:Query>";

                            strGetFeatureXml += strQueryXml;

                            strGetFeatureXml += "</wfs:GetFeature>";

                            objMapController.GetWebFeatureServiceFeatures(enMapServer, strMapServiceLayerUrl, strGetFeatureXml, arrFields, strGeometryField).then(TrimbleMap.Controller.Shared.TrapException(function (arrFeatures) {
                                objMapLayerFeaturesDeferred.resolve(arrFeatures);
                            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
                                // Get the title and message translations

                                // Query on map service failed
                                let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedTitle');

                                // Query on map service %1 map layer %2 failed.
                                let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                                // Unable to retrieve data from map service %1 map layer %2. The results for the layer will not be displayed.
                                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                                // Log the diagnostic message
                                objMapController.LogDiagnosticMessage(strTitle, strMessage, "", strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strMapServiceLayerUrl);

                                // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure
                                if (blnRejectDeferredOnAnyFailure) { objMapLayerFeaturesDeferred.reject(objError); } else { objMapLayerFeaturesDeferred.resolve(null); }
                            }));

                            // When we are to get the real count ...
                            if (blnGetRealCount) {
                                let strMapServiceLayerCountUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerUrl, TrimbleMap.enumWebFeatureServiceQueryParameterKey.ResultType + '=' + TrimbleMap.Controller.Shared.WFS_RESULT_TYPE_HITS);

                                objMapController.GetWebFeatureServiceFeatureCount(strMapServiceLayerCountUrl).then(TrimbleMap.Controller.Shared.TrapException(function (objFeatureCount) {
                                    objMaxRecordCountTextDeferred.resolve(objFeatureCount);
                                }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
                                    // Get the title and message translations

                                    // Query to get the count on map service failed
                                    let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedTitle');

                                    // Query to get the count on map service %1 map layer %2 failed. 
                                    let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                                    // Unable to retrieve the number of records from map  %1 map layer %2. The number of results for this layer will be reflected incorrectly.
                                    let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                                    // Log the diagnostic message 
                                    objMapController.LogDiagnosticMessage(strTitle, strMessage, "", strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strMapServiceLayerCountUrl);

                                    // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure
                                    if (blnRejectDeferredOnAnyFailure) { objMaxRecordCountTextDeferred.reject(objError); } else { objMaxRecordCountTextDeferred.resolve(null); }
                                }));
                            }

                            // Add the map layer to the array of queried map layers
                            arrQueriedMapLayers.push(objMapLayer);
                        } else {
                            objMapLayerFeaturesDeferred.resolve(null);

                            // When we are to get the real count
                            if (blnGetRealCount) {
                                objMaxRecordCountTextDeferred.resolve(null);
                            }
                        }
                    }), TrimbleMap.Controller.Shared.TrapException(function () {
                        objMapLayerFeaturesDeferred.resolve(null);

                        // When we are to get the real count
                        if (blnGetRealCount) {
                            objMaxRecordCountTextDeferred.resolve(null);
                        }
                    }));
                } else {
                    // When the layer has not been configured in FlexiCadastre
                    if (strMapLayerID == null) {

                        // Get the title and message translations

                        // Layer not configured
                        let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'LayerNotConfiguredTitle');

                        // Layer with id %1 on Map service %2 has not been configured in FlexiCadastre. 
                        let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'LayerNotConfiguredMessage', strEsriLayerID, objMapService.MapServiceName);

                        // Log a diagnostic info message
                        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, null, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, null);
                    }
                }
            } else {
                // Unable to query layer
                let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToQueryMapServiceLayerTitle');

                // Unable to query layer with id %1 on map service %2 because no configuration were found for a layer with the layer's name. 
                let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToQueryMapServiceLayerMessage', strEsriLayerID, objMapService.MapServiceName);

                // Unable to query a layer on map service %1 because no configuration were found for a layer with the layer's name. No results will be included for the layer.
                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToQueryMapServiceLayerEndUserMessage', objMapService.MapServiceName);

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, null);
            }
        });

        // Join the deferreds together into a single array
        let arrMapLayerFeaturesAndFeatureCountDeferred = arrMapLayerFeaturesDeferred.concat(arrMapLayerFeatureCountDeferred);

        new dojo.promise.all(arrMapLayerFeaturesAndFeatureCountDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrMapLayerFeaturesResults) {
            // Create a new array for the service's query results
            let arrMapServiceQueryResults = [];

            // Create a new array for the map service query results deferreds
            let arrQueriedMapServiceResultsDeferred = [];

            // Loop through all the queried map layers ...
            for (let intResult = 0; intResult < arrQueriedMapLayers.length; intResult++) {
                // Create a new array for the layer's query results
                let arrMapLayerQueryResults = [];

                // Create a new array for the layer query results deferreds
                let arrQueriedMapLayerResultsDeferred = [];

                // Get the layer's query result
                let objMapLayerFeaturesResult = arrMapLayerFeaturesResults[intResult];

                // When we have a valid result
                if (objMapLayerFeaturesResult) {
                    let objQueriedMapServiceResultDeferred = new dojo.Deferred();

                    arrQueriedMapServiceResultsDeferred.push(objQueriedMapServiceResultDeferred);

                    // Get the map layer that has been queried in order to get the results
                    let objQueriedMapLayer = arrQueriedMapLayers[intResult];

                    if (objMapLayerFeaturesResult.length > 0) {
                        let dicAssetQueryResults = {};

                        // Loop through the results and build a dictionary that groups geometries of one asset together
                        for (let intAssetFeature = 0; intAssetFeature < objMapLayerFeaturesResult.length; intAssetFeature++) {

                            let objAssetFeature = objMapLayerFeaturesResult[intAssetFeature];

                            if (dicAssetQueryResults[objAssetFeature.attributes[undefined]]) {

                                dicAssetQueryResults[objAssetFeature.attributes[undefined]].push(objAssetFeature);
                            }
                            else {
                                let arrAssetFeatures = [];
                                arrAssetFeatures.push(objAssetFeature);
                                dicAssetQueryResults[objAssetFeature.attributes[undefined]] = arrAssetFeatures;
                            }
                        }

                        // Loop through all the returned assets ...
                        $.each(dicAssetQueryResults, function (guidAssetQueryResult, arrAssetFeatures) {
                            // Create a deferred
                            let objQueryResultDeferred = new dojo.Deferred();

                            arrQueriedMapLayerResultsDeferred.push(objQueryResultDeferred);

                            // Default to Current Map spatial reference
                            let guidSpatialReference = objMapController.CurrentMap.SpatialReferenceID;

                            // Loop through the asset's features
                            for (let intFeature = 0; intFeature < arrAssetFeatures.length; intFeature++) {

                                // Get the feature
                                let objFeature = arrAssetFeatures[intFeature];

                                // Create the query result object
                                let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objQueriedMapLayer.MapLayerID, objFeature.attributes, objFeature.geometry, guidSpatialReference);

                                // Add it to the array
                                arrMapLayerQueryResults.push(objMapLayerQueryResult);
                            }

                            // Resolve the result deffered to trigger the next logical block of code
                            objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                        });
                    }

                    // When all query tasks for the current QueriedMapLayer complete
                    new dojo.promise.all(arrQueriedMapLayerResultsDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrMapLayerQueryResults) {
                        let arrQueriedMapLayerResults = (arrMapLayerQueryResults && arrMapLayerQueryResults.length > 0) ? arrMapLayerQueryResults[0] : [];

                        // Get the total count (use the ExeuteForCount result when we are to get the real count)
                        let objTotalCount = (blnGetRealCount) ? arrMapLayerFeaturesResults[arrQueriedMapLayers.length + intResult] : { TotalCount: objMapLayerFeaturesResult.length, ExactCountRetrieved: true };

                        // When we did get the count
                        if (objTotalCount != 'undefined') {

                            // Create a map service query result ...
                            let objMapServiceQueryResult = TrimbleMap.Controller.Shared.CreateMapServiceQueryResult(objQueriedMapLayer.MapLayerID,
                                objTotalCount.TotalCount,
                                objTotalCount.ExactCountRetrieved,
                                arrQueriedMapLayerResults);

                            // Add it to the service query results array ...
                            arrMapServiceQueryResults.push(objMapServiceQueryResult);
                        }

                        // Resolve the map service query results deferred ...
                        objQueriedMapServiceResultDeferred.resolve(arrMapServiceQueryResults);

                    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                        // Reject the deferred with the error ...
                        objDeferred.reject(objError);
                    }));
                }
            }

            new dojo.promise.all(arrQueriedMapServiceResultsDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrMapServiceQueryResults) {
                let arrQueriedMapServiceResults = (arrMapServiceQueryResults && arrMapServiceQueryResults.length > 0) ? arrMapServiceQueryResults[0] : [];

                // Resolve the returned deferred, passing in the results
                objDeferred.resolve(arrQueriedMapServiceResults);
            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
                // Reject the deferred with the error
                objDeferred.reject(objError);
            }));
        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
            // Reject the deferred with the error
            objDeferred.reject(objError);
        }));
    } else {
        // Map service token expired
        let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

        // Log a diagnostic info message ...
        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

        objDeferred.resolve([]);
    }
}

// **************************************************************************
// FUNCTION: GetWebFeatureServiceFeatures
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetWebFeatureServiceFeatures = function GetWebFeatureServiceFeatures(enMapServerType, strMapServiceLayerUrl, data, arrFields, strGeometryField) {
    let objMapController = this;

    let objMapLayerFeaturesDeferred = new dojo.Deferred();

    // Call the web service to get the map service layer features
    $.ajax({
        url: strMapServiceLayerUrl,
        type: "POST",
        datatype: "xml",
        contentType: "text/xml",
        data: data,
        complete: TrimbleMap.Controller.Shared.TrapException(function (jqXHR) {
            if (jqXHR.status >= 200 && jqXHR.status < 300) {
                let objXmlResponse = $.parseXML(jqXHR.responseText);

                let objFeatureCollectionXml = objXmlResponse.getElementsByTagNameNS(TrimbleMap.Controller.Shared.WFS_NAMESPACE, "FeatureCollection")[0];

                if (objFeatureCollectionXml) {
                    let objBoundedByXml = objFeatureCollectionXml.getElementsByTagNameNS(TrimbleMap.Controller.Shared.GML_NAMESPACE, "boundedBy")[0];
                    let strSrsName = '';
                    let intWKID = '';

                    if (objBoundedByXml) {
                        strSrsName = objBoundedByXml.getElementsByTagNameNS(TrimbleMap.Controller.Shared.GML_NAMESPACE, "Envelope")[0].getAttribute("srsName");
                        intWKID = Number(strSrsName.substring(strSrsName.indexOf("EPSG::") + 6));
                    }

                    let arrFeatures = [];
                    let arrFeaturesXml = objFeatureCollectionXml.getElementsByTagNameNS(TrimbleMap.Controller.Shared.GML_NAMESPACE, "featureMember");

                    if (!arrFeaturesXml || arrFeaturesXml.length < 1) {
                        let objFeatureMembersXml = objFeatureCollectionXml.getElementsByTagNameNS(TrimbleMap.Controller.Shared.GML_NAMESPACE, "featureMembers")[0];

                        if (objFeatureMembersXml) {
                            arrFeaturesXml = objFeatureMembersXml.children;
                        }
                    }

                    for (let intFeature = 0; intFeature < arrFeaturesXml.length; intFeature++) {
                        let objFeature = {
                            attributes: {},
                            geometry: null
                        };
                        let objFeatureXml = arrFeaturesXml[intFeature];

                        objFeature.attributes[TrimbleMap.Controller.Shared.WFS_ID] = SD.Guid.Shared.NewID();

                        if (arrFields.length > 0) {
                            for (let intAttribute = 0; intAttribute < arrFields.length; intAttribute++) {
                                let objAttribute = objFeatureXml.getElementsByTagNameNS(TrimbleMap.Controller.Shared.ALL_NAMESPACES, arrFields[intAttribute])[0];

                                if (objAttribute !== null && objAttribute !== undefined) {
                                    objFeature.attributes[arrFields[intAttribute]] = objAttribute.textContent;
                                }
                            }
                        }

                        let objGeometryAttribute = objFeatureXml.getElementsByTagNameNS(TrimbleMap.Controller.Shared.ALL_NAMESPACES, strGeometryField)[0];

                        if (objGeometryAttribute !== null && objGeometryAttribute !== undefined && objGeometryAttribute.children[0] && objGeometryAttribute.children[0].nodeName) {
                            if (enMapServerType === TrimbleMap.enumMapServerType.GEOSERVER) {
                                strSrsName = objGeometryAttribute.firstElementChild.getAttribute("srsName");
                                intWKID = Number(strSrsName.substring(strSrsName.indexOf("EPSG:") + 5));

                                if (isNaN(intWKID) || intWKID == null || intWKID == '') {
                                    intWKID = Number(strSrsName.substring(strSrsName.indexOf(".xml") + 5));
                                }
                            }

                            let strOgcGeometryType = objGeometryAttribute.children[0].nodeName.substring(4);
                            let strEsriGeometryType = objMapController.ConvertOgcGeometryTypeToEsriGeometryType(strOgcGeometryType);

                            let arrPosXml = objGeometryAttribute.getElementsByTagNameNS(TrimbleMap.Controller.Shared.GML_NAMESPACE, "posList");

                            if (!arrPosXml || arrPosXml.length < 1) {
                                arrPosXml = objGeometryAttribute.getElementsByTagNameNS(TrimbleMap.Controller.Shared.GML_NAMESPACE, "pos");
                            }

                            let objEsriGeometry = null;

                            switch (strEsriGeometryType) {
                                case TrimbleMap.enumEsriGeometryType.Point:
                                    objEsriGeometry = new esri.geometry.Point(null, null, new esri.SpatialReference({ wkid: intWKID }));
                                    break;
                                case TrimbleMap.enumEsriGeometryType.Polyline:
                                    objEsriGeometry = new esri.geometry.Polyline(new esri.SpatialReference({ wkid: intWKID }));
                                    break;
                                case TrimbleMap.enumEsriGeometryType.Polygon:
                                    objEsriGeometry = new esri.geometry.Polygon(new esri.SpatialReference({ wkid: intWKID }));
                                    break;
                                default:
                            }

                            let insertXAndYCoordinates = null;
                            let objSpatialReference = objMapController.GetSpatialReference(objMapController.CurrentMap.SpatialReferenceID);

                            // If the maps WKID is retrieved then the results will be returned in that spatial reference. The coordinates are returned in X Y order
                            // If the maps WKID is not retrieved then the Coordinates are returned in the default spatial reference of the WFS. The coordinates are returned in Y X order
                            if (objSpatialReference && objSpatialReference.WKID) {
                                insertXAndYCoordinates = function (arrCoordinates, intCoordinate) {
                                    let intX = arrCoordinates[intCoordinate];
                                    let intY = arrCoordinates[intCoordinate + 1];

                                    return [Number(intX), Number(intY)];
                                }
                            } else {
                                insertXAndYCoordinates = function (arrCoordinates, intCoordinate) {
                                    let intY = arrCoordinates[intCoordinate];
                                    let intX = arrCoordinates[intCoordinate + 1];

                                    return [Number(intX), Number(intY)];
                                }
                            }

                            for (let intPosListXml = 0; intPosListXml < arrPosXml.length; intPosListXml++) {
                                let objPosListXml = arrPosXml[intPosListXml];

                                let arrCoordinates = objPosListXml.textContent.split(" ");
                                let arrPart = [];

                                for (var intCoordinate = 0; intCoordinate < arrCoordinates.length; intCoordinate += 2) {
                                    let arrXandYCoordinates = insertXAndYCoordinates(arrCoordinates, intCoordinate);

                                    arrPart.push([Number(arrXandYCoordinates[0]), Number(arrXandYCoordinates[1])]);
                                }

                                switch (strEsriGeometryType) {
                                    case TrimbleMap.enumEsriGeometryType.Point:
                                        objEsriGeometry.update(arrPart[0][0], arrPart[0][1]);
                                        break;
                                    case TrimbleMap.enumEsriGeometryType.Polyline:
                                        objEsriGeometry.addPath(arrPart);
                                        break;
                                    case TrimbleMap.enumEsriGeometryType.Polygon:
                                        objEsriGeometry.addRing(arrPart);
                                        break;
                                    default:
                                }
                            }

                            objFeature.geometry = objEsriGeometry;
                        }

                        arrFeatures.push(objFeature);
                    }

                    objMapLayerFeaturesDeferred.resolve(arrFeatures);
                } else {
                    // Resolve the returned deferred
                    objMapLayerFeaturesDeferred.resolve(null);
                }
            }
        }),
        error: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus, errorThrown) {
            objMapLayerFeaturesDeferred.reject(errorThrown);
        })
    });

    return objMapLayerFeaturesDeferred;
}

// **************************************************************************
// FUNCTION: GetWebFeatureServiceFeatureCount
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetWebFeatureServiceFeatureCount = function GetWebFeatureServiceFeatureCount(strMapServiceLayerUrl) {
    let objMapController = this;

    let objMaxRecordCountTextDeferred = new dojo.Deferred();

    // Call the web service to get the map service layer feature count
    $.ajax({
        url: strMapServiceLayerUrl,
        datatype: "xml",
        complete: TrimbleMap.Controller.Shared.TrapException(function (jqXHR) {
            if (jqXHR.status >= 200 && jqXHR.status < 300) {
                let objXmlResponse = $.parseXML(jqXHR.responseText);

                let objFeatureCollectionXml = objXmlResponse.getElementsByTagNameNS(TrimbleMap.Controller.Shared.WFS_NAMESPACE, "FeatureCollection")[0];

                if (objFeatureCollectionXml) {
                    let intCount = Number(objFeatureCollectionXml.getAttribute("numberOfFeatures"));

                    objMaxRecordCountTextDeferred.resolve({ TotalCount: intCount, ExactCountRetrieved: true });
                } else {
                    // Resolve the returned deferred
                    objMaxRecordCountTextDeferred.resolve(null);
                }
            }
        }),
        error: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus, errorThrown) {
            objMaxRecordCountTextDeferred.reject(errorThrown);
        })
    });

    return objMaxRecordCountTextDeferred;
}

// **************************************************************************
// FUNCTION: GetWebFeatureServiceLayerId
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetWebFeatureServiceLayerId = function GetWebFeatureServiceLayerId(objMapService, objMapLayer, blnRejectDeferredOnAnyFailure) {
    let objMapController = this;
    let objMapLayerIDDeferred = new dojo.Deferred();

    let strLayerID = objMapController.GetOgcLayerIDForMapLayerID(objMapLayer.MapLayerID);

    if (strLayerID) {
        objMapLayerIDDeferred.resolve(strLayerID);
    } else {
        let objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

        let strMapServiceLayerIDUrl = objMapController.GetWebFeatureServiceUrlWithQueryParameters(objMapService, TrimbleMap.enumWebFeatureServiceRequest.GetCapabilities);

        if (objMapServiceRestUrlWithToken.Token) {
            strMapServiceLayerIDUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerIDUrl, 'Token=' + objMapServiceRestUrlWithToken.Token);
        }

        strMapServiceLayerIDUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerIDUrl, 'MapServiceID=' + objMapService.MapServiceID);
        strMapServiceLayerIDUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(objMapController.State.ArcGISProxyServiceUrl, strMapServiceLayerIDUrl);

        // Call the web service to get the map service layer fields
        $.ajax({
            url: strMapServiceLayerIDUrl,
            datatype: "xml",
            complete: TrimbleMap.Controller.Shared.TrapException(function (jqXHR) {
                if (jqXHR.status >= 200 && jqXHR.status < 300) {
                    let objXmlResponse = $.parseXML(jqXHR.responseText);

                    let objFeatureCollectionXml = objXmlResponse.getElementsByTagNameNS(TrimbleMap.Controller.Shared.WFS_NAMESPACE, "FeatureTypeList")[0];

                    if (objFeatureCollectionXml) {
                        let arrFeatureTypesXml = objFeatureCollectionXml.getElementsByTagNameNS(TrimbleMap.Controller.Shared.WFS_NAMESPACE, "FeatureType");

                        for (var intFeatureType = 0; intFeatureType < arrFeatureTypesXml.length; intFeatureType++) {
                            let objFeatureTypeXml = arrFeatureTypesXml[intFeatureType];
                            let objFeatureTypeTitleXml = objFeatureTypeXml.getElementsByTagNameNS(TrimbleMap.Controller.Shared.WFS_NAMESPACE, "Title")[0];

                            if (objFeatureTypeTitleXml.textContent === objMapLayer.MapLayerName) {
                                strLayerID = objFeatureTypeXml.getElementsByTagNameNS(TrimbleMap.Controller.Shared.WFS_NAMESPACE, "Name")[0].textContent;
                                break;
                            }
                        }

                        objMapController.SetOgcMapLayerIDLookupTableValue(objMapLayer.MapLayerID, strLayerID);
                        objMapLayerIDDeferred.resolve(strLayerID);
                    } else {
                        // Get the title and message translations

                        // Query to get the map service layer ID failed
                        let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FailedToGetMapServiceLayerIDTitle');

                        // Query to get the layer ID on map service %1 map layer %2 failed.
                        let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FailedToGetMapServiceLayerIDMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                        // Unable to retrieve the layer ID from map service %1 map layer %2. The results for the layer will not be displayed.
                        let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FailedToGetMapServiceLayerIDEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                        // Log the diagnostic message ...
                        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strMapServiceLayerIDUrl);

                        // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure
                        objMapLayerIDDeferred.reject(null);
                    }
                }
            }),
            error: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus, errorThrown) {
                // Get the title and message translations

                // Query to get the map service layer ID failed
                let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FailedToGetMapServiceLayerIDTitle');

                // Query to get the layer ID on map service %1 map layer %2 failed.
                let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FailedToGetMapServiceLayerIDMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                // Unable to retrieve the layer ID from map service %1 map layer %2. The results for the layer will not be displayed.
                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FailedToGetMapServiceLayerIDEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                // Log the diagnostic message 
                objMapController.LogDiagnosticMessage(strTitle, strMessage, "", strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strMapServiceLayerIDUrl);

                // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure
                if (blnRejectDeferredOnAnyFailure) { objMapLayerIDDeferred.reject(errorThrown); } else { objMapLayerIDDeferred.resolve(null); }
            })
        });
    }

    return objMapLayerIDDeferred;
}

// **************************************************************************
// FUNCTION: CreateMapLayerDataFromWebFeatureService
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.CreateMapLayerDataFromWebFeatureService = function CreateMapLayerDataFromWebFeatureService(objMapService, objMapLayer) {
    let objMapController = this;
    let strMapServiceLayerUrl = '';
    let arrFields = [{ name: '', type: '' }];
    let strEsriGeometryType = '';
    let objMapLayerData = null;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    let objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

    objMapController.GetWebFeatureServiceLayerId(objMapService, objMapLayer).then(TrimbleMap.Controller.Shared.TrapException(function (strLayerID) {
        if (strLayerID) {
            if (objMapServiceRestUrlWithToken.Success) {
                strMapServiceLayerUrl = objMapController.GetWebFeatureServiceUrlWithQueryParameters(objMapService, TrimbleMap.enumWebFeatureServiceRequest.DescribeFeatureType, strLayerID);

                if (objMapServiceRestUrlWithToken.Token) {
                    strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerUrl, 'Token=' + objMapServiceRestUrlWithToken.Token);
                }

                strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapServiceLayerUrl, 'MapServiceID=' + objMapService.MapServiceID);
                strMapServiceLayerUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(objMapController.State.ArcGISProxyServiceUrl, strMapServiceLayerUrl);

                // Request the layer data from the rest service ...
                // Call the web service to get the map service layer fields
                $.ajax({
                    url: strMapServiceLayerUrl,
                    datatype: "xml",
                    complete: TrimbleMap.Controller.Shared.TrapException(function (jqXHR) {
                        if (jqXHR.status >= 200 && jqXHR.status < 300) {
                            let objXmlResponse = $.parseXML(jqXHR.responseText);

                            let objExtensionXml = objXmlResponse.getElementsByTagNameNS(TrimbleMap.Controller.Shared.XSD_NAMESPACE, "extension");

                            if (objExtensionXml) {
                                let objSequenceXml = objExtensionXml[0].getElementsByTagNameNS(TrimbleMap.Controller.Shared.XSD_NAMESPACE, "sequence");

                                if (objSequenceXml) {
                                    let objCollectionXml = objSequenceXml[0].getElementsByTagNameNS(TrimbleMap.Controller.Shared.XSD_NAMESPACE, "element");

                                    if (objCollectionXml) {
                                        for (let intPosListXml = 0; intPosListXml < objCollectionXml.length; intPosListXml++) {
                                            let objFieldElement = objCollectionXml[intPosListXml];
                                            let objAttributes = objFieldElement.attributes;
                                            let strType;

                                            if (objAttributes.type === undefined) {
                                                strType = objFieldElement.getElementsByTagNameNS(TrimbleMap.Controller.Shared.XSD_NAMESPACE, "restriction")[0].attributes.base.value;
                                            } else {
                                                strType = objAttributes.type.value;
                                            }

                                            arrFields.push({
                                                name: objAttributes.name.value,
                                                type: strType
                                            });

                                            if (strType && strType.startsWith(TrimbleMap.Controller.Shared.WFS_GEOMETRY_FIELD_SEARCH)) {
                                                let strOgcGeometryType = strType.substring(strType.indexOf(':') + 1);

                                                strEsriGeometryType = objMapController.ConvertOgcGeometryTypeToEsriGeometryType(strOgcGeometryType);
                                            }

                                        }

                                        objMapLayerData = {
                                            GeometryType: (strEsriGeometryType != '') ? strEsriGeometryType : null,
                                            Fields: ((typeof arrFields != 'undefined') && (arrFields != null)) ? $.map(arrFields, function (objField, intField) {
                                                return {
                                                    name: objField.name,
                                                    alias: objField.name,
                                                    type: objField.type
                                                }
                                            }) : null
                                        };
                                    }
                                }

                                //resolve the deferred
                                objDeferred.resolve(objMapLayerData);
                            } else {
                                //reject the deferred
                                objDeferred.reject(null);
                            }
                        }
                    }),
                    error: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus, errorThrown) {
                        // Get the title and message translations

                        // Unable to load map service
                        let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadMapServiceTitle');

                        // Unable to load the companion web feature service of %1 map service. The map service will show in the map but search, identify and selection will not return any results.
                        let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadWebFeatureServiceMessage', objMapService.MapServiceName);

                        // Unable to load companion web feature service of %1 map service. The data for this map service will be displayed in the map but any interaction with this map service will not return any results.
                        let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadWebFeatureServiceEndUserMessage', objMapService.MapServiceName);

                        // Log the diagnostic message 
                        objMapController.LogDiagnosticMessage(strTitle, strMessage, "", strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strMapServiceLayerUrl);

                        // Reject the returned deferred
                        objDeferred.reject(null);
                    })
                });
            } else {
                // Map service token expired
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

                //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

                //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

                // Log a diagnostic info message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

                // Reject the returned deferred
                objDeferred.reject(null);
            }
        } else {
            // Get the title and message translations

            // Unable to load map service
            let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadMapServiceTitle');

            // Unable to load the companion web feature service of %1 map service. The map service will show in the map but search, identify and selection will not return any results.
            let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadWebFeatureServiceMessage', objMapService.MapServiceName);

            // Unable to load companion web feature service of %1 map service. The data for this map service will be displayed in the map but any interaction with this map service will not return any results.
            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadWebFeatureServiceEndUserMessage', objMapService.MapServiceName);

            // Log the diagnostic message 
            objMapController.LogDiagnosticMessage(strTitle, strMessage, "", strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strMapServiceLayerUrl);

            // Reject the returned deferred
            objDeferred.reject(null);
        }
    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {
        // Reject the returned deferred
        objDeferred.reject(objError);
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: ConvertOgcGeometryTypeToEsriGeometryType
// USAGE:    Converts a Ogc Geometry Type to a Esri Geometry Type
// **************************************************************************
TrimbleMap.Controller.ConvertOgcGeometryTypeToEsriGeometryType = function ConvertOgcGeometryTypeToEsriGeometryType(strOgcGeometryType) {
    let strEsriGeometryType = "";

    switch (strOgcGeometryType.toUpperCase()) {
        case "POINT":
        case "POINTPROPERTYTYPE":
        case "MULTIPOINT":
        case "MULTIPOINTPROPERTYTYPE":
            strEsriGeometryType = TrimbleMap.enumEsriGeometryType.Point;
            break;
        case "CURVE":
        case "CURVEPROPERTYTYPE":
        case "LINESTRING":
        case "LINESTRINGPROPERTYTYPE":
        case "LINE":
        case "LINEPROPERTYTYPE":
        case "LINEARRING":
        case "LINEARRINGPROPERTYTYPE":
        case "MULTILINE":
        case "MULTILINEPROPERTYTYPE":
        case "MULTILINESTRING":
        case "MULTILINESTRINGPROPERTYTYPE":
        case "MULTICURVE":
        case "MULTICURVEPROPERTYTYPE":
        case "LINESTRING":
        case "LINESTRINGPROPERTYTYPE":
        case "MULTILINESTRING":
        case "MULTILINESTRINGPROPERTYTYPE":
            strEsriGeometryType = TrimbleMap.enumEsriGeometryType.Polyline;
            break;
        case "SURFACEPROPERTYTYPE":
        case "POLYGON":
        case "POLYGONPROPERTYTYPE":
        case "MULTIPOLYGON":
        case "MULTIPOLYGONPROPERTYTYPE":
        case "MULTISURFACE":
        case "MULTISURFACEPROPERTYTYPE":
            strEsriGeometryType = TrimbleMap.enumEsriGeometryType.Polygon;
            break;
        case "GEOMETRY":
        case "GEOMETRYPROPERTYTYPE":
        case "GEOMETRYCOLLECTION":
        case "GEOMETRYCOLLECTIONPROPERTYTYPE":
            // These types are generic meaning it can contain points, polylines and polygons so we shouldn't set the geometry type to anything;
            break;
    }

    return strEsriGeometryType;
}

// **************************************************************************
// FUNCTION: QueryMapLayer
// USAGE:    fnBuildLayerWhereClause(objMapService, objMapLayer)
//           - Should build a where clause for the layer ...
//           - Specify at least one of objGeometry or fnBuildLayerWhereClause
//           - blnRejectDeferredOnAnyFailure is optional and defaults to false ...
// **************************************************************************
TrimbleMap.Controller.QueryMapLayer = function QueryMapLayer(objMapLayer, objMapService, objMapServiceDisplay, objGeometry, blnGetRealCount, fnBuildLayerWhereClause, fnQueryMapLayer, blnRejectDeferredOnAnyFailure) {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Default blnRejectDeferredOnAnyFailure to false when not set ...
    if ((typeof blnRejectDeferredOnAnyFailure == 'undefined') || (blnRejectDeferredOnAnyFailure == null)) { blnRejectDeferredOnAnyFailure = false; }

    // When we are to query a dynamic or feature service service ...
    if ((objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Feature) || (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Dynamic)) {

        var objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

        if (objMapServiceRestUrlWithToken.Success) {
            // Create an array for all the deferreds of each layer's query task and map layers that correspond to it ...
            var arrQueryTaskDeferred = [];
            var arrCountQueryTaskDeferred = [];
            var objRequestIOArgs = null;
            var strEsriLayerID = null;

            // Loop through all the esri layer ids in the map service ...
            objMapController.ForEachEsriLayerIDInMapServiceDisplay(objMapService, objMapServiceDisplay, function (strEsriMapLayerID) {

                // Get the map layer id for the esri map layer id ...
                if (objMapController.GetMapLayerIDForEsriLayerID(objMapService.MapServiceID, strEsriMapLayerID) == objMapLayer.MapLayerID) {
                    strEsriLayerID = strEsriMapLayerID;
                }

            });

            // When we managed to get the Esri map layer ID ...
            if (strEsriLayerID != null) {

                // When the map layer may be queried ...
                if (fnQueryMapLayer(objMapLayer, objMapServiceDisplay)) {

                    // Create a new query task and parameters for the layer ...
                    var objQueryTask = new esri.tasks.QueryTask(TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, strEsriLayerID).RestUrlWithToken);
                    var objQuery = new esri.tasks.Query();

                    // Set the search parameters ...
                    objQuery.spatialRelationship = esri.tasks.Query.SPATIAL_REL_INTERSECTS;
                    objQuery.returnGeometry = true;
                    objQuery.returnDistinctValues = !objQuery.returnGeometry;
                    objQuery.outFields = (objMapLayer.IsGeneric) ? ['*'] : objMapController.GetMapLayerTemplateFields(objMapLayer, true);

                    //When the layer has a heading attribute name ...
                    if ((objMapLayer.TemplateHeaderFields) && (objMapLayer.TemplateHeaderFields.length > 0)) {

                        // Set it as the order by field ...
                        objQuery.orderByFields = objMapLayer.TemplateHeaderFields;
                    }

                    // Set the input geometry when we have one ...
                    if ((typeof objGeometry != 'undefined') && objGeometry) { objQuery.geometry = objGeometry; }

                    // When we have a build where clause function ...
                    if ((typeof fnBuildLayerWhereClause != 'undefined') && fnBuildLayerWhereClause) {

                        // Build the where clause for the map layer ...
                        objQuery.where = fnBuildLayerWhereClause(objMapService, objMapLayer);
                    }

                    // Execute the identify task ...
                    var objQueryTaskDeferred = objQueryTask.execute(objQuery);

                    // Get the request's IO arguments ...
                    objRequestIOArgs = objMapController.LastEsriRequestIOArgs;

                    // Create a new deferred ...
                    var objErrorHandledQueryTaskDeferred = new dojo.Deferred();

                    // Add it to the array ...
                    arrQueryTaskDeferred.push(objErrorHandledQueryTaskDeferred);

                    // Handle the objQueryTaskDeferred calbacks ...
                    objQueryTaskDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objQueryTaskResult) {

                        // Resolve the deferred ...
                        objErrorHandledQueryTaskDeferred.resolve(objQueryTaskResult);

                    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                        // Get the title and message translations ...

                        // Query on map service failed
                        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedTitle');

                        // Query on map service %1 map layer %2 failed. 
                        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                        // Unable to retrieve data from map service %1 map layer %2. The results for the layer will not be displayed.
                        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceQueryFailedEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                        // Log the diagnostic message ...
                        objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs));

                        // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure ...
                        if (blnRejectDeferredOnAnyFailure) { objErrorHandledQueryTaskDeferred.reject(objError); } else { objErrorHandledQueryTaskDeferred.resolve(null); }
                    }));

                    // When we are to get the real count ...
                    if (blnGetRealCount) {

                        // When the query is to not return distinct values (because if 
                        // returnDistinctValues is true then we cannot use executeForCount) ...
                        if (!objQuery.returnDistinctValues) {

                            // No need for order by for count ...
                            objQuery.orderByFields = null;

                            // Execute the identify task ...
                            var objCountQueryTaskDeferred = objQueryTask.executeForCount(objQuery);

                            // Get the request's IO arguments ...
                            var objCountRequestIOArgs = objMapController.LastEsriRequestIOArgs;

                            // Create a new deferred ...
                            var objErrorHandledCountQueryTaskDeferred = new dojo.Deferred();

                            // Add it to the array of deferreds for the count ...
                            arrCountQueryTaskDeferred.push(objErrorHandledCountQueryTaskDeferred);

                            // Handle the objCountQueryTaskDeferred calbacks ...
                            objCountQueryTaskDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (intTotalCount) {

                                // Resolve the deferred ...
                                objErrorHandledCountQueryTaskDeferred.resolve({ TotalCount: intTotalCount, ExactCountRetrieved: true });

                            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                                // Get the title and message translations ...

                                // Query to get the count on map service failed
                                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedTitle');

                                // Query to get the count on map service %1 map layer %2 failed. 
                                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                                // Unable to retrieve the number of records from map  %1 map layer %2. The number of results for this layer will be reflected incorrectly.
                                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'CountOnMapServiceFailedEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                                // Log the diagnostic message ...
                                objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objCountRequestIOArgs));

                                // Resolve the returned deferred, depending on blnRejectDeferredOnAnyFailure ...
                                if (blnRejectDeferredOnAnyFailure) { objErrorHandledCountQueryTaskDeferred.reject(objError); } else { objErrorHandledCountQueryTaskDeferred.resolve(null); }
                            }));

                        } else {

                            // Create a new deferred ...
                            var objMaxRecordCountTextDeferred = new dojo.Deferred();

                            // Add it to the array of deferreds for the count ...
                            arrCountQueryTaskDeferred.push(objMaxRecordCountTextDeferred);

                            // Get the max record count for the service ...
                            var objMaxRecordCountDeferred = objMapController.GetMapServiceMaxRecordCount(objMapService);

                            // When retrieved ...
                            objMaxRecordCountDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (intMaxRecordCount) {

                                // Resolve the deferred the max record count as total count ...
                                objMaxRecordCountTextDeferred.resolve({ TotalCount: intMaxRecordCount, ExactCountRetrieved: false });
                            }));
                        }
                    }

                } else {

                    // When the layer has not been configured in FlexiCadastre ...
                    if (objMapLayer.MapLayerID == null) {

                        // Get the title and message translations ...

                        // Layer not configured
                        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'LayerNotConfiguredTitle');

                        // Layer with id %1 on Map service %2 has not been configured in FlexiCadastre. 
                        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'LayerNotConfiguredMessage', strEsriLayerID, objMapService.MapServiceName);

                        // Log a diagnostic info message ...
                        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, null, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, null);
                    }
                }
            }
            else {


                // Unable to query layer
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToQueryMapServiceLayerTitle');

                // Unable to query layer with id %1 on map service %2 because no configuration were found for a layer with the layer's name. 
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToQueryMapServiceLayerMessage', strEsriLayerID, objMapService.MapServiceName);

                // Unable to query a layer on map service %1 because no configuration were found for a layer with the layer's name. No results will be included for the layer.
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToQueryMapServiceLayerEndUserMessage', objMapService.MapServiceName);

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, null);

                objDeferred.reject();
            }

            // Join the deferreds together into a single array ...
            var arrAllQueryTaskDeferred = arrQueryTaskDeferred.concat(arrCountQueryTaskDeferred);

            // When the query task completes ...
            new dojo.promise.all(arrAllQueryTaskDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrQueryTaskResults) {

                // Create a new array for the layer's query results ...
                let arrMapLayerQueryResults = [];

                // Create a new array for the layer query results deferreds...
                let arrQueriedMapLayerResultsDeferred = [];

                // Get the result ...
                let objQueryTaskResult = (arrQueryTaskResults.length > 0) ? arrQueryTaskResults[0] : null;

                // When we have a valid result ...
                if (objQueryTaskResult) {

                    // When we did get results back ....
                    if (objQueryTaskResult.features.length > 0) {

                        // Determine whether or not there are any template fields not in objAttributes ...
                        let arrMissingTemplateFields = objMapController.GetMissingTemplateFields(objMapLayer, objQueryTaskResult.features[0].attributes);

                        // When the first feature has all the template fields as attributes ...
                        if (arrMissingTemplateFields.length == 0) {

                            let dicAssetQueryResults = {};

                            // Determine whether or not parts will be displayed separately for the map layer ...
                            var blnDisplaySeparateParts = (objMapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts);

                            // Loop through the results and build a dictionary that groups geometries of one asset together
                            for (let intAssetFeature = 0; intAssetFeature < objQueryTaskResult.features.length; intAssetFeature++) {

                                let objAssetFeature = objQueryTaskResult.features[intAssetFeature];

                                if (dicAssetQueryResults[objAssetFeature.attributes[objMapLayer.RestServiceObjectIDFieldName]]) {

                                    dicAssetQueryResults[objAssetFeature.attributes[objMapLayer.RestServiceObjectIDFieldName]].push(objAssetFeature);
                                }
                                else {
                                    let arrAssetFeatures = [];
                                    arrAssetFeatures.push(objAssetFeature);
                                    dicAssetQueryResults[objAssetFeature.attributes[objMapLayer.RestServiceObjectIDFieldName]] = arrAssetFeatures;
                                }
                            }

                            // Loop through all the returned assets ...
                            $.each(dicAssetQueryResults, function (guidAssetQueRyresult, arrAssetFeatures) {

                                // Create a deferred
                                let objQueryResultDeferred = new dojo.Deferred();

                                arrQueriedMapLayerResultsDeferred.push(objQueryResultDeferred);

                                if (blnDisplaySeparateParts) {

                                    // Loop through the asset's features ...
                                    for (let intFeature = 0; intFeature < arrAssetFeatures.length; intFeature++) {

                                        // Get the feature ...
                                        let objFeature = arrAssetFeatures[intFeature];

                                        // Build the geometry from the feature (part) geometry when DisplaySeparateParts is true ...
                                        let objGeometry = objFeature.geometry;

                                        // The geometry will be in the map's spatial reference when DisplaySeparateParts is true ...
                                        let guidSpatialReference = objMapController.CurrentMap.SpatialReferenceID;

                                        // Create the query result object ...
                                        let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objMapLayer.MapLayerID, objFeature.attributes, objGeometry, guidSpatialReference);

                                        // Add it to the array ...
                                        arrMapLayerQueryResults.push(objMapLayerQueryResult);
                                    }

                                    // Resolve the result deffered to trigger the next logical block of code
                                    objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                                }
                                else {

                                    // Take the first feature is the list of asset features. They will be the same, except for the geometry property 
                                    let objFeature = arrAssetFeatures[0];

                                    // Check to see if there are more parts to the shape 
                                    if (objFeature.attributes[objMapLayer.ExteriorShapePartCountFieldName] > arrAssetFeatures.length) {

                                        if (objFeature.attributes[objMapLayer.RestServiceObjectIDFieldName]) {

                                            let guidObject = objFeature.attributes[objMapLayer.RestServiceObjectIDFieldName].replace(/[{}]/g, "");

                                            let objQueryMapDeferred = new dojo.Deferred();

                                            // Hit the map service to query the same layer with an ordinary search to get the rest of the shape's parts using guidLicense
                                            objQueryMapDeferred = objMapController.QueryMapLayer(objMapLayer, objMapService, objMapServiceDisplay, null, false, function () { return "(UPPER(" + objMapLayer.RestServiceObjectIDFieldName + ") = '" + guidObject + "')"; }, function (objMapLayer, objMapServiceDisplay) { return true; });

                                            objQueryMapDeferred.promise.then(function (arrQueryMapResults) {

                                                let arrSecondaryQueryFeaturesGeometries = [];

                                                $.each(arrQueryMapResults.Data, function (intSecondaryQueryFeature, objSecondaryQueryFeature) {
                                                    arrSecondaryQueryFeaturesGeometries.push(objSecondaryQueryFeature.Geometry);
                                                });

                                                // Build the geometry from the union of all shape parts when DisplaySeparateParts is false ...
                                                let objGeometry = esri.geometry.geometryEngine.union(arrSecondaryQueryFeaturesGeometries);

                                                // The geometry will be the default spatial reference when DisplaySeparateParts is false ...
                                                let guidSpatialReference = objMapController.State.DefaultSpatialReferenceID;

                                                // Create the query result object ...
                                                let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objMapLayer.MapLayerID, objFeature.attributes, objGeometry, guidSpatialReference);

                                                // Add it to the array ...
                                                arrMapLayerQueryResults.push(objMapLayerQueryResult);

                                                // Resolve the result deffered to trigger the next logical block of code
                                                objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                                            });
                                        }
                                    }
                                    else {

                                        let arrGeometries = [];

                                        $.each(arrAssetFeatures, function (intResultFeature, objResultFeature) {
                                            arrGeometries.push(objResultFeature.geometry);
                                        });

                                        // Build the geometry from the union of all shape parts when DisplaySeparateParts is false ...
                                        let objGeometry = esri.geometry.geometryEngine.union(arrGeometries);

                                        // The geometry will be the default spatial reference when DisplaySeparateParts is false ...
                                        let guidSpatialReference = objMapController.State.DefaultSpatialReferenceID;

                                        // Create the query result object ...
                                        let objMapLayerQueryResult = TrimbleMap.Controller.Shared.CreateMapLayerQueryResult(objMapService, objMapLayer.MapLayerID, objFeature.attributes, objGeometry, guidSpatialReference);

                                        // Add it to the array ...
                                        arrMapLayerQueryResults.push(objMapLayerQueryResult);

                                        // Resolve the result deffered to trigger the next logical block of code
                                        objQueryResultDeferred.resolve(arrMapLayerQueryResults);
                                    }
                                }

                            });
                        }
                        else {

                            // Start with an empty string ... 
                            var strMissingTemplateFields = '';

                            // Loop through all the missing fields ...
                            $.each(arrMissingTemplateFields, function (intMissingTemplateField, strMissingTemplateField) {

                                // Add a comma when not the first one ...
                                if (strMissingTemplateFields.length > 0) { strMissingTemplateFields += ', '; }

                                // Add the missing field name ...
                                strMissingTemplateFields += strMissingTemplateField;
                            });

                            // Get the title and message translations ...

                            // Query returned unexpected fields
                            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnexpectedFieldsReturnedTitle');

                            // Querying map service %1 map layer %2 did not return the following expected fields: %3 
                            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnexpectedFieldsReturnedMessage', objMapService.MapServiceName, objMapLayer.MapLayerName, strMissingTemplateFields);

                            // Unable to display data from map service %1 map layer %2. The results for this layer will not be displayed.
                            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnexpectedFieldsReturnedEndUserMessage', objMapService.MapServiceName, objMapLayer.MapLayerName);

                            // Log the diagnostic message ...
                            objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs));
                        }
                    }

                    // When all query tasks for the current QueriedMapLayer complete ...
                    new dojo.promise.all(arrQueriedMapLayerResultsDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrMapLayerQueryResults) {

                        var arrQueriedMapLayerResults = (arrMapLayerQueryResults && arrMapLayerQueryResults.length > 0) ? arrMapLayerQueryResults[0] : [];

                        // Get the total count (use the ExeuteForCount result when we are to get the real count) ...
                        var objTotalCount = (blnGetRealCount && arrQueryTaskResults.length > 1) ? arrQueryTaskResults[1] : { TotalCount: objQueryTaskResult.features.length, ExactCountRetrieved: true };

                        // When we did get the count ...
                        if ((objTotalCount != 'undefined') && (objTotalCount != null)) {

                            // Create a map service query result ...
                            var objMapServiceQueryResult = TrimbleMap.Controller.Shared.CreateMapServiceQueryResult(objMapLayer.MapLayerID,
                                objTotalCount.TotalCount,
                                objTotalCount.ExactCountRetrieved,
                                arrQueriedMapLayerResults);
                        }

                        // Resolve the returned deferred, passing in the results ...
                        objDeferred.resolve(objMapServiceQueryResult);

                    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                        // Reject the deferred with the error ...
                        objDeferred.reject(objError);
                    }));
                }

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                // Reject the deferred with the error ...
                objDeferred.reject(objError);
            }));

        } else {

            // Map service token expired
            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

            //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

            //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

            // Log a diagnostic info message ...
            objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

            objDeferred.resolve();
        }

    } else if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Tile) {

        // Map.Controller.QueryMapService not implemented for tile services
        throw 'TrimbleMap.Controller.QueryMapService not implemented for tile services ...'
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetMissingTemplateFields
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMissingTemplateFields = function GetMissingTemplateFields(objMapLayer, objAttributes) {

    // Get the controller ...
    var objMapController = this;

    // Create a new array to return ...
    var arrMissingTemplateFields = [];

    // Create a new array for the attributes ...
    var arrAttributes = [];

    // Add all the attributes from objAttributes to the array ...
    $.each(objAttributes, function (strAttribute, objValue) { arrAttributes.push(strAttribute); });

    // Get the MapLayer's template fields ...
    var arrTemplateFields = objMapController.GetMapLayerTemplateFields(objMapLayer, true);

    // Loop through all the template fields ...
    $.each(arrTemplateFields, function (intTemplateField, strTemplateField) {

        // When the attributes do not containe the template field ...
        if ($.inArray(strTemplateField, arrAttributes) < 0) {

            // Add it to the list of missing template field ...
            arrMissingTemplateFields.push(strTemplateField);
        }
    });

    return arrMissingTemplateFields;
}

// **************************************************************************
// FUNCTION: MapFieldNamesToAliases
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.MapFieldNamesToAliases = function MapFieldNamesToAliases(strMapLayerID, objDataToMap) {

    // Get the controller ...
    var objMapController = this;

    // Create a new object to return ...
    var objMappedData = {};

    // Loop through all the properties on the object ...
    $.each(objDataToMap, function (strAlias, objValue) {

        // Get the field name for the alias ...
        var strFieldName = objMapController.GetFieldNameForAlias(strMapLayerID, strAlias);

        // Set the value for the field name on the mapped object ...
        objMappedData[strFieldName] = objValue
    });

    return objMappedData;
}

// **************************************************************************
// FUNCTION: MapFieldNamesToUpperCaseFieldNames
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.MapFieldNamesToUpperCaseFieldNames = function MapFieldNamesToUpperCaseFieldNames(objDataToMap) {

    // Get the controller ...
    var objMapController = this;

    // Create a new object to return ...
    var objMappedData = {};

    // Loop through all the properties on the object ...
    $.each(objDataToMap, function (strFieldName, objValue) {

        // Add the value to the mapped object with the upper case of the field name ...
        objMappedData[strFieldName.toUpperCase()] = objValue
    });

    return objMappedData;
}

// **************************************************************************
// FUNCTION: QueryMap
// USAGE:    fnForEachMapService should take in a function as argument with 
//           the following signature: 
//           function (objMapService, objMapServiceDisplay, arrMapLayerIDs)
// **************************************************************************
TrimbleMap.Controller.QueryMap = function QueryMap(objMap, objGeometry, blnGetRealCount, fnBuildLayerWhereClause, fnForEachMapService) {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objQueryMapDeferred = new dojo.Deferred();

    // Create an array for the deferreds ...
    var arrDeferreds = new Array();

    // Loop through all the map services to be queried in the current map ...
    fnForEachMapService(function (objMapService, objMapServiceDisplay, arrMapLayerIDs) {

        // Build a function to determine whether or not a particular map layer is to be queried ...
        var fnQueryMapLayer = function (objMapLayer) { return $.inArray(objMapLayer.MapLayerID, arrMapLayerIDs) > -1; }

        // Start the map service query ...
        var objDeferred = objMapController.QueryMapService(objMapService, objMapServiceDisplay, objGeometry, blnGetRealCount, fnBuildLayerWhereClause, fnQueryMapLayer);

        // Add to the list of deferreds ...
        arrDeferreds.push(objDeferred);
    });

    // When all the query tasks completes ...
    new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function (arrQueryMapServiceResults) {

        // Create a new array for the combined query map service results ...
        var arrCombinedQueryMapServiceResults = [];

        // Loop through the map service result arrays ...
        for (var intQueryMapServiceResult = 0; intQueryMapServiceResult < arrQueryMapServiceResults.length; intQueryMapServiceResult++) {

            // Get the map service results ...
            var arrQueryMapServiceResultArray = arrQueryMapServiceResults[intQueryMapServiceResult];

            // When results were returned ...
            if (arrQueryMapServiceResultArray) {

                // Add it to the combined results ...
                arrCombinedQueryMapServiceResults = arrCombinedQueryMapServiceResults.concat(arrQueryMapServiceResultArray);
            }
        }

        // Resolve the deferred ...
        objQueryMapDeferred.resolve(arrCombinedQueryMapServiceResults);
    }));

    return objQueryMapDeferred;
}

// **************************************************************************
// FUNCTION: QueryCurrentMap
// USAGE:    Specify at least one of objGeometry and fnBuildLayerWhereClause
// **************************************************************************
TrimbleMap.Controller.QueryCurrentMap = function QueryCurrentMap(objGeometry, blnGetRealCount, fnBuildLayerWhereClause, fnForEachMapService) {

    // Get the controller ...
    var objMapController = this;

    // Query the current map and return the results ...
    return objMapController.QueryMap(objMapController.CurrentMap, objGeometry, blnGetRealCount, fnBuildLayerWhereClause, fnForEachMapService);
}

// **************************************************************************
// FUNCTION: SelectInMapService
// USAGE:    dicActiveLayerIDs -  a hash table containing the active map layer 
//           ids as keys, only features from these layers will be selected ...
// **************************************************************************
TrimbleMap.Controller.SelectInMapService = function SelectInMapService(objMapService, objMapServiceDisplay, objGeometry, fnWhereClauseForMapLayer, enSelectionMethod, fnSelectOnMapLayer, blnDrawSelectionGraphic, objMapServiceSelection, objMapServiceQuery) {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we are to query a dynamic or feature service service ...
    if (objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Feature || objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.Dynamic || objMapService.MapServiceType == TrimbleMap.Controller.enumMapServiceType.WebMapService) {

        var objQueryMapServiceDeferred = new dojo.Deferred();

        // Query the map service ...
        if (!objMapServiceSelection && objMapServiceQuery) {
            // Using map layer urls ...
            objQueryMapServiceDeferred = objMapController.QueryMapServiceFromMapLayerUrls(objMapServiceDisplay, objMapServiceQuery, false);
        }
        else {
            // Using the geometry ...
            objQueryMapServiceDeferred = objMapController.QueryMapService(objMapService, objMapServiceDisplay, objGeometry, true, fnWhereClauseForMapLayer, fnSelectOnMapLayer, false, objMapServiceSelection);
        }

        // When the query completes ...
        objQueryMapServiceDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (arrMapServiceQueryResults) {

            // This check is so that when using pick from map functionality in portal, the selection graphic is not drawn
            // Only in Landfolio is the selection graphic required
            if (blnDrawSelectionGraphic) {

                // Loop through all the query results ...
                $.each(arrMapServiceQueryResults, function (intMapServiceQueryResult, objMapServiceQueryResult) {

                    // Get the queried map layer for the query result ...
                    var objQueriedMapLayer = objMapController.GetMapLayer(objMapServiceQueryResult.MapLayerID);

                    // Get the rest service id field name for the map layer ...
                    var strRestServiceIDFieldName = objMapController.GetMapLayerIDFieldName(objQueriedMapLayer);

                    // Create a new object to contain the IDs from the query for the layer ...
                    var objQueryIDs = {};

                    // Loop through all the map layer query results ...
                    $.each(objMapServiceQueryResult.Data, function (intMapLayerQueryResult, objMapLayerQueryResult) {

                        // Get the ID ...
                        var strID = objMapLayerQueryResult.Attributes[strRestServiceIDFieldName];

                        // When we are doing a new selection or adding to the selection ...
                        if ((enSelectionMethod == esri.layers.FeatureLayer.SELECTION_NEW) || (enSelectionMethod == esri.layers.FeatureLayer.SELECTION_ADD)) {

                            // Add it to the selection ...
                            objMapController.AddToSelection(objQueriedMapLayer, objMapLayerQueryResult.Attributes, objMapLayerQueryResult.Geometry);

                            // When we are removing from the selection ...
                        } else if (enSelectionMethod == esri.layers.FeatureLayer.SELECTION_SUBTRACT) {

                            // Add it to the selection ...
                            objMapController.RemoveFromSelection(objQueriedMapLayer, strID);

                        } else if (enSelectionMethod == TrimbleMap.Controller.Shared.FILTER_SELECTION) {

                            // Add the id to the object ...
                            objQueryIDs[strID] = strID;
                        }
                    });

                    // When filtering the selection ...
                    if (enSelectionMethod == TrimbleMap.Controller.Shared.FILTER_SELECTION) {

                        // Loop though all the map layers for which we have selected graphics ...
                        $.each(objMapController.SelectedGraphicsByMapLayerID, function (strMapLayerID, objSelectedGraphicsByID) {

                            // Loop though the selected graphics in the map layer ...
                            $.each(objSelectedGraphicsByID, function (strID, objGraphic) {

                                // When the id is not in the query results ...
                                if (typeof objQueryIDs[strID] == 'undefined') {

                                    // Remove it from the selection ...
                                    objMapController.RemoveFromSelection(objQueriedMapLayer, strID);
                                }
                            });
                        });
                    }
                });
            }

            // Resolve the returned deferred, passing in the results ...
            objDeferred.resolve(arrMapServiceQueryResults);

        }));

    } else {

        // Resolve the returned deferred, passing in an empty result array ...
        objDeferred.resolve([]);
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: SelectInMap
// USAGE:    Possible values for enSelectionMethod:
//                  - esri.layers.FeatureLayer.SELECTION_ADD
//                  - esri.layers.FeatureLayer.SELECTION_NEW
//                  - esri.layers.FeatureLayer.SELECTION_SUBTRACT
//                  - "FILTER_SELECTION": Select from selection
//           dicActiveLayerIDs - a hash table containing the active map layer 
//           ids as keys, only features from these layers will be selected ...
//           fnWhereClauseForMapLayer - a function that will return the 
//           where clause to use on a layer ...
//           fnForEachMapService(fnToCall) should call fnToCall for each 
//           map service in which to perform selection 
//           fnSelectOnMapLayer(objMapLayer) will be called for each layer 
//           and should return true when selection is to be performed on a 
//           map layer ...
// **************************************************************************
TrimbleMap.Controller.SelectInMap = function SelectInMap(objGeometry, fnWhereClauseForMapLayer, enSelectionMethod, fnForEachMapService, fnSelectOnMapLayer, blnDrawSelectionGraphic, intOrder, blnDoNotCacheSelection) {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objSelectInMapDeferred = new dojo.Deferred();

    // Create an array for the deferreds ...
    var arrDeferreds = new Array();

    // When selecting new features ...
    if (enSelectionMethod == esri.layers.FeatureLayer.SELECTION_NEW) {

        // Clear the selection ...
        objMapController.ClearSelection();
    }

    let arrMapSelection = [];

    // Loop through all the map services to be selected on in the current map ...
    fnForEachMapService(function (objMapService, objMapServiceDisplay, arrVisibleLayerIDs, objMapServiceQuery) {

        let objMapServiceSelection = null;

        if (!objMapServiceQuery) {
            objMapServiceSelection = {
                "MapServiceDisplayID": objMapServiceDisplay.MapServiceDisplayID,
                "Requests": []
            };

            arrMapSelection.push(objMapServiceSelection);
        }

        // Select in the map service ...
        let objDeferred = objMapController.SelectInMapService(objMapService, objMapServiceDisplay, objGeometry, fnWhereClauseForMapLayer, enSelectionMethod, fnSelectOnMapLayer, blnDrawSelectionGraphic, objMapServiceSelection, objMapServiceQuery);

        // Add to the list of deferreds ...
        arrDeferreds.push(objDeferred);
    });

    // When all the selection tasks completes ...
    new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function (arrSelectInMapResults) {

        if (!blnDoNotCacheSelection && arrMapSelection.length > 0) {
            objMapController.UserSettings.UpdateUserSettings(TrimbleMap.UserSettings.Shared.enumSetting.MapProperties, { "SelectionQueries": { "Queries": arrMapSelection, "SelectionMethod": enSelectionMethod } });
        }

        // Create a new array for the combined selection results ...
        var arrCombinedSelectInMapResults = [];

        // Loop through the map service result arrays ...
        for (var intSelectInMapServiceResult = 0; intSelectInMapServiceResult < arrSelectInMapResults.length; intSelectInMapServiceResult++) {

            // Get the map service results ...
            var arrCombinedSelectInMapServiceResults = arrSelectInMapResults[intSelectInMapServiceResult];

            // Add it to the combined results ...
            arrCombinedSelectInMapResults = arrCombinedSelectInMapResults.concat(arrCombinedSelectInMapServiceResults);
        }

        if (typeof intOrder != 'undefined' && intOrder != null) {
            // Create a result object that include the operation order of the query
            let objSelectInMapResult = {
                "SelectionMethod": enSelectionMethod,
                "Order": intOrder,
                Results: arrCombinedSelectInMapResults
            };

            // Resolve the deferred ...
            objSelectInMapDeferred.resolve(objSelectInMapResult);
        }
        else {

            // Resolve the deferred with the results array directly ...
            objSelectInMapDeferred.resolve(arrCombinedSelectInMapResults);
        }

    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

        // Reject the deferred with the error ...
        objSelectInMapDeferred.reject(objError);
    }));

    return objSelectInMapDeferred;
}

// **************************************************************************
// FUNCTION: SelectInMapFromPreviousQueries
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.SelectInMapFromPreviousQueries = function SelectInMapFromPreviousQueries() {

    // Get the controller ...
    let objMapController = this;

    // Create a new deferred to return ...
    let objSelectInMapDeferred = new dojo.Deferred();

    // Create an array for the deferreds ...
    let arrDeferreds = new Array();

    let objSelectionState = objMapController.State.ClientStoredSelectionState;

    for (let intMapQueries = 0; intMapQueries < objSelectionState.SelectionQueries.length; intMapQueries++) {

        let objDeferred = new dojo.Deferred();

        let objMapQuery = objSelectionState.SelectionQueries[intMapQueries];

        // Loop through all the previous selection queries to be re-run ...
        let fnForEachMapService = function (fnCallback) {

            for (let intMapServiceQueries = 0; intMapServiceQueries < objMapQuery.Queries.length; intMapServiceQueries++) {

                let objMapServiceQuery = objMapQuery.Queries[intMapServiceQueries];

                let objMapServiceDisplay = objMapController.GetMapServiceDisplay(objMapServiceQuery.MapServiceDisplayID);
                let objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

                fnCallback(objMapService, objMapServiceDisplay, null, objMapServiceQuery);
            }
        };

        objDeferred = objMapController.SelectInMap(null, null, objMapQuery.SelectionMethod, fnForEachMapService, null, false, intMapQueries);
        arrDeferreds.push(objDeferred);
    }

    // When all the selection tasks completes ...
    new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function (arrSelectInMapResults) {

        // ReOrder the results according to their order property
        let arrOrderedSelectInMapResults = Array(objSelectionState.SelectionQueries.length).fill(null);

        for (let intSelectInMapResult = 0; intSelectInMapResult < arrSelectInMapResults.length; intSelectInMapResult++) {

            let objSelectInMapResults = arrSelectInMapResults[intSelectInMapResult];

            arrOrderedSelectInMapResults[objSelectInMapResults.Order] = objSelectInMapResults;
        }

        // Process the result according to their Operation property
        for (let intSelectInMapResult = 0; intSelectInMapResult < arrOrderedSelectInMapResults.length; intSelectInMapResult++) {

            let objSelectInMapResults = arrOrderedSelectInMapResults[intSelectInMapResult];

            if (objSelectInMapResults) {

                let enSelectionMethod = objSelectInMapResults.SelectionMethod;

                // Draw graphic

                // Loop through all the query results ...
                $.each(objSelectInMapResults.Results, function (intSelectInMapServiceResult, objMapServiceQueryResult) {

                    // Get the queried map layer for the query result ...
                    let objQueriedMapLayer = objMapController.GetMapLayer(objMapServiceQueryResult.MapLayerID);

                    // Get the rest service id field name for the map layer ...
                    let strRestServiceIDFieldName = objMapController.GetMapLayerIDFieldName(objQueriedMapLayer);

                    // Create a new object to contain the IDs from the query for the layer ...
                    let objQueryIDs = {};

                    // Loop through all the map layer query results ...
                    $.each(objMapServiceQueryResult.Data, function (intMapLayerQueryResult, objMapLayerQueryResult) {

                        // Get the ID ...
                        let strID = objMapLayerQueryResult.Attributes[strRestServiceIDFieldName];

                        // When we are doing a new selection or adding to the selection ...
                        if ((enSelectionMethod == esri.layers.FeatureLayer.SELECTION_NEW) || (enSelectionMethod == esri.layers.FeatureLayer.SELECTION_ADD)) {

                            // Add it to the selection ...
                            objMapController.AddToSelection(objQueriedMapLayer, objMapLayerQueryResult.Attributes, objMapLayerQueryResult.Geometry);

                            // When we are removing from the selection ...
                        } else if (enSelectionMethod == esri.layers.FeatureLayer.SELECTION_SUBTRACT) {

                            // Add it to the selection ...
                            objMapController.RemoveFromSelection(objQueriedMapLayer, strID);

                        } else if (enSelectionMethod == TrimbleMap.Controller.Shared.FILTER_SELECTION) {

                            // Add the id to the object ...
                            objQueryIDs[strID] = strID;
                        }
                    });

                    // When filtering the selection ...
                    if (enSelectionMethod == TrimbleMap.Controller.Shared.FILTER_SELECTION) {

                        // Loop though all the map layers for which we have selected graphics ...
                        $.each(objMapController.SelectedGraphicsByMapLayerID, function (strMapLayerID, objSelectedGraphicsByID) {

                            // Loop though the selected graphics in the map layer ...
                            $.each(objSelectedGraphicsByID, function (strID, objGraphic) {

                                // When the id is not in the query results ...
                                if (typeof objQueryIDs[strID] == 'undefined') {

                                    // Remove it from the selection ...
                                    objMapController.RemoveFromSelection(objQueriedMapLayer, strID);
                                }
                            });
                        });
                    }
                });
            }
        }

        // Resolve the deferred ...
        objSelectInMapDeferred.resolve(arrOrderedSelectInMapResults);

    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

        // Reject the deferred with the error ...
        objSelectInMapDeferred.reject(objError);
    }));

    return objSelectInMapDeferred;
}

// **************************************************************************
// FUNCTION: ZoomToSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.ZoomToSelection = function ZoomToSelection() {

    // Get the controller ...
    var objMapController = this;

    // Get the selected geometries ...
    var arrSelectedGeomtries = objMapController.GetSelectedGeometries();

    // Zoom to the selected geometries ...
    var objDeferred = objMapController.ZoomToGeometries(arrSelectedGeomtries);

    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetSelectedGeometries
// USAGE:    fnFilterMapLayerID(strMapLayerID) is optional, it returns true 
//           when the selected geometries in the map layer needs to be returned ...
// **************************************************************************
TrimbleMap.Controller.GetSelectedGeometries = function GetSelectedGeometries(fnFilterMapLayerID) {

    // Get the controller ...
    var objMapController = this;

    // Create an array to return ...
    var arrGeometries = [];

    // Loop through all the selectable map services in the current map ...
    objMapController.ForEachSelectableMapServiceInCurrentMap(function (objMapService, objMapServiceDisplay, arrMapLayerIDs) {

        // Loop through all the selectable layers in the map service ...
        for (var intMapLayer = 0; intMapLayer < arrMapLayerIDs.length; intMapLayer++) {

            // Get the map layer id ...
            var strMapLayerID = arrMapLayerIDs[intMapLayer];

            // When we do not have a layer filter function or the filter function allows the layer ...
            if ((typeof fnFilterMapLayerID == 'undefined') || (fnFilterMapLayerID == null) || (fnFilterMapLayerID(strMapLayerID))) {

                // Get the hash table of currently selected graphics for the map layer ...
                var dicCurrentlySelectedGraphics = objMapController.GetSelectedGraphicsByMapLayerID(strMapLayerID);

                // When we have any selected graphics for the map layer ...
                if ((typeof dicCurrentlySelectedGraphics != 'undefined') && (dicCurrentlySelectedGraphics != null)) {

                    // Loop though all the selected graphics ...
                    $.each(dicCurrentlySelectedGraphics, function (strID, objGraphic) {

                        // Add the geometry of the graphic to the array ...
                        if (objGraphic.geometry != null) { arrGeometries.push(objGraphic.geometry); }
                    });
                }
            }
        }
    });

    return arrGeometries;
}

// **************************************************************************
// FUNCTION: GetSelectedIDs
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetSelectedIDs = function GetSelectedIDs(fnFilterMapLayerID) {

    // Get the controller ...
    var objMapController = this;

    // Create an array to return ...
    var objIDsByMapLayer = {};

    // Loop through all the selectable map services in the current map ...
    objMapController.ForEachSelectableMapServiceInCurrentMap(function (objMapService, objMapServiceDisplay, arrMapLayerIDs) {

        // Loop through all the selectable layers in the map service ...
        for (var intMapLayer = 0; intMapLayer < arrMapLayerIDs.length; intMapLayer++) {

            // Get the map layer id ...
            var strMapLayerID = arrMapLayerIDs[intMapLayer];

            // Get the map layer ...
            var objMapLayer = objMapController.GetMapLayer(strMapLayerID);

            // Create a new array for the IDs of the selected features in the map layer ...
            var arrIDs = [];

            // Add it to the object ...
            objIDsByMapLayer[strMapLayerID] = arrIDs;

            // When we do not have a layer filter function or the filter function allows the layer ...
            if ((typeof fnFilterMapLayerID == 'undefined') || (fnFilterMapLayerID == null) || (fnFilterMapLayerID(strMapLayerID))) {

                // Get the hash table of currently selected graphics for the map layer ...
                var dicCurrentlySelectedGraphics = objMapController.GetSelectedGraphicsByMapLayerID(strMapLayerID);

                // When we have any selected graphics for the map layer ...
                if ((typeof dicCurrentlySelectedGraphics != 'undefined') && (dicCurrentlySelectedGraphics != null)) {

                    // Loop though all the selected graphics ...
                    $.each(dicCurrentlySelectedGraphics, function (strID, objGraphic) {

                        // Add the ID of the graphic to the array ...
                        arrIDs.push(strID);
                    });
                }
            }
        }
    });

    return objIDsByMapLayer;
}

// **************************************************************************
// FUNCTION: AddToSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.AddToSelection = function AddToSelection(objMapLayer, objAttributes, objGeometry) {

    // Get the controller ...
    var objMapController = this;

    // Get the map a service for the map layer ...
    var objMapService = objMapController.GetMapService(objMapLayer.MapServiceID);

    // Get the selected graphics by map layer id ...
    var objSelectedGraphicsByID = objMapController.SelectedGraphicsByMapLayerID[objMapLayer.MapLayerID];

    // When we have no selected features for the map layer yet ...
    if ((typeof objSelectedGraphicsByID == 'undefined') || (objSelectedGraphicsByID == null)) {

        // Create the object to hold the graphics by feature id ...
        objSelectedGraphicsByID = {}

        // Add it to the lookup table for the map layer id ...
        objMapController.SelectedGraphicsByMapLayerID[objMapLayer.MapLayerID] = objSelectedGraphicsByID;
    }

    // Get the rest service id field name for the map layer ...
    var strRestServiceIDFieldName = objMapController.GetMapLayerIDFieldName(objMapLayer);

    // Get the id ...
    var strID = objAttributes[strRestServiceIDFieldName];

    // When not already selected in the map ...
    if ((typeof objSelectedGraphicsByID[strID] == 'undefined') || (objSelectedGraphicsByID[strID] == null)) {
        // Get the selection symbol to use for the layer's geometry type ...
        var objSelectionSymbol = objMapController.SelectionSymbolForGeometryType(TrimbleMap.Shape.Shared.GeometryTypeToEsriGeometrType(objGeometry.type));

        // Create a graphic to draw ...
        var objGraphic = new esri.Graphic(objGeometry, objSelectionSymbol);

        // Get the selection graphics layer for the map layer ...
        var objSelectionGraphicsLayer = objMapController.GetSelectionGraphicsLayerByMapLayerID(objMapLayer.MapLayerID);

        // Add the graphic to the graghics layer ...
        objSelectionGraphicsLayer.add(objGraphic);

        // Add the graphic for the id ...
        objSelectedGraphicsByID[strID] = objGraphic;
    }
}

// **************************************************************************
// FUNCTION: RemoveFromSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.RemoveFromSelection = function RemoveFromSelection(objMapLayer, strID) {

    // Get the controller ...
    var objMapController = this;

    // Get the selected graphics by map layer id ...
    var objSelectedGraphicsByID = objMapController.SelectedGraphicsByMapLayerID[objMapLayer.MapLayerID];

    // When we have selected graphics for the map layer ...
    if ((typeof objSelectedGraphicsByID != 'undefined') || (objSelectedGraphicsByID != null)) {

        // Get the rest service id field name for the map layer ...
        var strRestServiceIDFieldName = objMapController.GetMapLayerIDFieldName(objMapLayer);

        // Get the graphic for the selected feature ...
        var objGraphic = objSelectedGraphicsByID[strID];

        // When we have a graphic for the id ...
        if ((typeof objGraphic != 'undefined') || (objGraphic != null)) {

            // Get the selection graphics layer for the map layer ...
            var objSelectionGraphicsLayer = objMapController.GetSelectionGraphicsLayerByMapLayerID(objMapLayer.MapLayerID);

            // Remove the graphic ...
            objSelectionGraphicsLayer.remove(objGraphic);

            // Remove the lookup entry ...
            delete objSelectedGraphicsByID[strID];
        }
    }
}

// **************************************************************************
// FUNCTION: ClearSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.ClearSelection = function ClearSelection() {

    // Get the controller ...
    var objMapController = this;

    // Loop through all the selectable map services in the current map ...
    objMapController.ForEachSelectableMapServiceInCurrentMap(function (objMapService, objMapServiceDisplay, arrMapLayerIDs) {

        // Loop through all the selectable layers in the map service ...
        $.each(arrMapLayerIDs, function (intMapLayer, strMapLayerID) {

            // Get the selection graphics layer for the map layer ...
            var objSelectionGraphicsLayer = objMapController.GetSelectionGraphicsLayerByMapLayerID(strMapLayerID);

            // Clear the graphics layer ...
            if (objSelectionGraphicsLayer) { objSelectionGraphicsLayer.clear(); }
        });
    });

    // Set to have no selected graphics ...
    objMapController.SelectedGraphicsByMapLayerID = {};
}

// **************************************************************************
// FUNCTION: AddObjectIDFieldNameByMapLayerID
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.AddObjectIDFieldNameByMapLayerID = function AddObjectIDFieldNameByMapLayerID(strObjectIDFieldName, strMapLayerID) {

    // Get the controller ...
    var objMapController = this;

    // Add the object id field name for the map layer id ...
    objMapController.ObjectIDFieldNameByMapLayerID[strMapLayerID] = strObjectIDFieldName;
}

// **************************************************************************
// FUNCTION: GetObjectIDFieldNameByMapLayerID
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetObjectIDFieldNameByMapLayerID = function GetObjectIDFieldNameByMapLayerID(strMapLayerID) {

    // Get the controller ...
    var objMapController = this;

    // Return the object id field name for the map layer id ...
    return objMapController.ObjectIDFieldNameByMapLayerID[strMapLayerID];
}

// **************************************************************************
// FUNCTION: AddMapLayerDataFromService
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.AddMapLayerDataFromService = function AddMapLayerDataFromService(strMapLayerID, objMapLayerData) {

    // Get the controller ...
    var objMapController = this;

    // Add the data for the map layer id ...
    objMapController.MapLayerDataFromService[strMapLayerID] = objMapLayerData;
}

// **************************************************************************
// FUNCTION: GetCachedMapLayerDataFromService
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetCachedMapLayerDataFromService = function GetCachedMapLayerDataFromService(strMapLayerID) {

    // Get the controller ...
    var objMapController = this;

    // Return the data for the map layer id ...
    return objMapController.MapLayerDataFromService[strMapLayerID];
}

// **************************************************************************
// FUNCTION: GetMapLayerDataFromService
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMapLayerDataFromService = function GetMapLayerDataFromService(objMapLayer, objMapService) {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Attempt to get the cahced map layer data ...
    var objMapLayerData = objMapController.GetCachedMapLayerDataFromService(objMapLayer.MapLayerID);

    // When we already have the data for the layer ....
    if ((typeof objMapLayerData != 'undefined') && (objMapLayerData != null)) {

        // Resolve the deferred ...
        objDeferred.resolve(objMapLayerData);

    } else {

        // Get the esri layer ID ...
        var intEsriLayerID = objMapController.GetEsriLayerIDForMapLayerID(objMapLayer.MapLayerID);

        // When found ...
        if (intEsriLayerID > -1) {

            var objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, String(intEsriLayerID));

            if (objMapServiceRestUrlWithToken.Success) {
                // Build the rest url for the layer ...
                var strRestUrl = objMapServiceRestUrlWithToken.RestUrlWithToken;

                // Request the layer data from the rest service ...
                var objLayerDataRequestHandle = esri.request({ url: strRestUrl, content: { f: "json" }, callbackParamName: "callback" });

                // Attach a handler to deal with the response from the service ...
                objLayerDataRequestHandle.then(TrimbleMap.Controller.Shared.TrapException(function (objResponse, io) {

                    // Create a MapLayerDataFromService instance ...
                    var objDataFromService = TrimbleMap.Controller.Shared.CreateMapLayerDataFromService(objResponse);

                    // Set it in the lookup table ...
                    objMapController.AddMapLayerDataFromService(objMapLayer.MapLayerID, objDataFromService);

                    // Resolve the deferred with the geometry type ...
                    objDeferred.resolve(objDataFromService);

                }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                    // Get the title and message translations ...

                    // Unable to retrieve information from map layer
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapLayerInformationNotFoundTitle');

                    // Attempting to retrieve the information for map layer %1 on map service %2 failed.
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapLayerInformationNotFoundMessage', objMapLayer.MapLayerName, objMapService.MapServiceName);

                    // Unable to retrieve the information for map layer %1 on map service %2.
                    var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapLayerInformationNotFoundEndUserMessage', objMapLayer.MapLayerName, objMapService.MapServiceName);

                    // Log the diagnostic message ...
                    objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.RemoveJsonFromatParameterFromUrl(strRestUrl));

                    // Resolve the deferred with null ...
                    objDeferred.resolve(null);
                }));
            }
            else {
                // Get the title and message translations ...

                // Map service token expired
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

                //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

                //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

                // Log a diagnostic info message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

                objDeferred.reject();
            }
        } else {

            // Resolve the deferred with null ...
            objDeferred.resolve(null);
        }
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetMapLayerDataFromWebFeatureService
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMapLayerDataFromWebFeatureService = function GetMapLayerDataFromWebFeatureService(strRestUrl, objMapService) {
    let objMapController = this;
    let arrFields = [];

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    $.ajax({
        url: strRestUrl,
        datatype: "xml",
        complete: TrimbleMap.Controller.Shared.TrapException(function (jqXHR) {
            if (jqXHR.status >= 200 && jqXHR.status < 300) {
                let objXmlResponse = $.parseXML(jqXHR.responseText);

                let objExtensionXml = objXmlResponse.getElementsByTagNameNS(TrimbleMap.Controller.Shared.XSD_NAMESPACE, "extension");

                if (objExtensionXml) {
                    let objSequenceXml = objExtensionXml[0].getElementsByTagNameNS(TrimbleMap.Controller.Shared.XSD_NAMESPACE, "sequence");

                    if (objSequenceXml) {
                        let objCollectionXml = objSequenceXml[0].getElementsByTagNameNS(TrimbleMap.Controller.Shared.XSD_NAMESPACE, "element");

                        if (objCollectionXml) {
                            for (let intPosListXml = 0; intPosListXml < objCollectionXml.length; intPosListXml++) {
                                let objFieldElement = objCollectionXml[intPosListXml];
                                let objAttributes = objFieldElement.attributes;
                                let strType;

                                if (objAttributes.type === undefined) {
                                    strType = objFieldElement.getElementsByTagNameNS(TrimbleMap.Controller.Shared.XSD_NAMESPACE, "restriction")[0].attributes.base.value;
                                } else {
                                    strType = objAttributes.type.value;
                                }

                                arrFields.push({
                                    name: objAttributes.name.value,
                                    alias: objAttributes.name.value,
                                    type: strType
                                });
                            }
                        }
                    }
                    // Create and return the map layer data ...
                    objDeferred.resolve(arrFields);
                } else {
                    // Resolve the deferred with null ....
                    objDeferred.reject(null);
                }
            }
        }),
        error: TrimbleMap.Controller.Shared.TrapException(function (jqXHR, textStatus, errorThrown) {
            // Get the title and message translations

            // Unable to load map service
            let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadMapServiceTitle');

            // Unable to load the companion web feature service of %1 map service. The map service will show in the map but search, identify and selection will not return any results.
            let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadWebFeatureServiceMessage', objMapService.MapServiceName);

            // Unable to load companion web feature service of %1 map service. The data for this map service will be displayed in the map but any interaction with this map service will not return any results.
            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadWebFeatureServiceEndUserMessage', objMapService.MapServiceName);

            // Log the diagnostic message 
            objMapController.LogDiagnosticMessage(strTitle, strMessage, "", strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strRestUrl);

            objDeferred.reject(errorThrown);
        })
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetMapLayerTemplateFields
// USAGE:
// **************************************************************************
TrimbleMap.Controller.GetMapLayerTemplateFields = function GetMapLayerTemplateFields(objMapLayer, blnFilterAreaFields) {

    // Get the controller ...
    var objMapController = this;

    if (blnFilterAreaFields != 'undefined' && blnFilterAreaFields) {

        return objMapController.FilterAreaFieldsFromMapLayerTemplateFields(objMapLayer);
    }
    else {

        // Use TemplateFields or TemplateFieldsByPart based on DisplaySeparatePartsSupported and Preferences.DisplaySeparateParts ...
        return (objMapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts) ? objMapLayer.TemplateFieldsByPart : objMapLayer.TemplateFields;
    }
}

// **************************************************************************
// FUNCTION: FilterAreaFieldsFromMapLayerTemplateFields
// USAGE:
// **************************************************************************
TrimbleMap.Controller.FilterAreaFieldsFromMapLayerTemplateFields = function FilterAreaFieldsFromMapLayerTemplateFields(objMapLayer) {

    // Get the controller ...
    var objMapController = this;

    let arrInputFields = [];
    let arrReturnFields = [];

    // Get the map layer data from the cache ...
    let objMapLayerDataFromService = objMapController.GetCachedMapLayerDataFromService(objMapLayer.MapLayerID);

    if (objMapLayerDataFromService != null && objMapLayerDataFromService != 'undefined') {

        // Use TemplateFields or TemplateFieldsByPart based on DisplaySeparatePartsSupported and Preferences.DisplaySeparateParts ...
        arrInputFields = (objMapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts) ? objMapLayer.TemplateFieldsByPart : objMapLayer.TemplateFields;

        // If the map layer geometry type is not polygon, filter AreaUnit and AreaValue
        if (objMapLayerDataFromService.GeometryType != 'esriGeometryPolygon') {
            $.each(arrInputFields, function (intField, strField) {
                if (!(strField == TrimbleMap.enumMapLayerTemplateFields.AreaUnit || strField == TrimbleMap.enumMapLayerTemplateFields.AreaValue)) {
                    arrReturnFields.push(strField);
                }
            });
        }
        else {
            arrReturnFields = arrInputFields;
        }
    }
    return arrReturnFields;
}

// **************************************************************************
// FUNCTION: GetMapLayerRestServiceIDFieldName
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMapLayerRestServiceIDFieldName = function GetMapLayerRestServiceIDFieldName(objMapLayer) {

    // Get the controller ...
    var objMapController = this;

    // Use RestServiceIDFieldName or RestServiceIDFieldNameByPart based on DisplaySeparatePartsSupported and Preferences.DisplaySeparateParts ...
    return (objMapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts) ? objMapLayer.RestServiceIDFieldNameByPart : objMapLayer.RestServiceIDFieldName;
}

// **************************************************************************
// FUNCTION: GetMapLayerIDFieldName
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMapLayerIDFieldName = function GetMapLayerIDFieldName(objMapLayer) {
    // Get the controller ...
    let objMapController = this;
    // Declare a variable for the return value ...
    let strMapLayerIDFieldName;
    let objMapService = objMapController.GetMapService(objMapLayer.MapServiceID);

    if (objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.WebMapService) {
        if (objMapLayer.IDField) {
            strMapLayerIDFieldName = objMapLayer.IDField;
        } else {
            strMapLayerIDFieldName = TrimbleMap.Controller.Shared.WFS_ID;
        }
    } else {
        // When not a generic layer ...
        if (!objMapLayer.IsGeneric) {

            // Return the map layer id field name ...
            strMapLayerIDFieldName = objMapController.GetMapLayerRestServiceIDFieldName(objMapLayer);

        } else {

            // Get the object ID field name ...
            strMapLayerIDFieldName = objMapController.GetObjectIDFieldNameByMapLayerID(objMapLayer.MapLayerID);
        }
    }

    return strMapLayerIDFieldName;
}

// **************************************************************************
// FUNCTION: GetMapLayerIdentifyHtmlTemplate
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMapLayerIdentifyHtmlTemplate = function GetMapLayerIdentifyHtmlTemplate(objMapLayer) {

    // Get the controller ...
    var objMapController = this;

    // Use ProcessedIdentifyHtmlTemplate or ProcessedIdentifyHtmlTemplateByPart based on DisplaySeparatePartsSupported and Preferences.DisplaySeparateParts ...
    return (objMapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts) ? objMapLayer.ProcessedIdentifyHtmlTemplateByPart : objMapLayer.ProcessedIdentifyHtmlTemplate;
}

// **************************************************************************
// FUNCTION: GetMapLayerSearchAndSelectHtmlTemplate
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetMapLayerSearchAndSelectHtmlTemplate = function GetMapLayerSearchAndSelectHtmlTemplate(objMapLayer) {

    // Get the controller ...
    var objMapController = this;

    // Use ProcessedSearchAndSelectHtmlTemplate or ProcessedSearchAndSelectHtmlTemplateByPart based on DisplaySeparatePartsSupported and Preferences.DisplaySeparateParts ...
    return (objMapLayer.DisplaySeparatePartsSupported && objMapController.Preferences.DisplaySeparateParts) ? objMapLayer.ProcessedSearchAndSelectHtmlTemplateByPart : objMapLayer.ProcessedSearchAndSelectHtmlTemplate;
}

// **************************************************************************
// FUNCTION: GetInitialExtentForMapServiceDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetInitialExtentForMapServiceDisplay = function GetInitialExtentForMapServiceDisplay(objMapServiceDisplay) {

    // Get the controller ...
    var objMapController = this;

    // Declare a variable to return ...
    var objInitialExtent = null;

    // Get the esri layers for the map service display ...
    var arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

    let objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);

    // Depending on the map service type ...
    switch (objMapService.MapServiceType) {
        case TrimbleMap.Controller.enumMapServiceType.Feature:

            // Loop though all the feature layers ...
            for (var intEsriLayer = 0; intEsriLayer < arrEsriLayers.length; intEsriLayer++) {

                // Get the esri layer ...
                var objEsriLayer = arrEsriLayers[intEsriLayer];

                // Get the extent of the layer ...
                var objLayerExtent = ((typeof objEsriLayer.fullExtent != 'undefined') && (objEsriLayer.fullExtent)) ? objEsriLayer.fullExtent : objEsriLayer.initialExtent;

                // When we do not have an initial extend yet ...
                if (!objInitialExtent) {

                    // Set it to be the full extend of the first layer ...
                    objInitialExtent = objLayerExtent;

                } else {

                    // Union the full extend of the feature layer with the initial extend we have so far ...
                    objInitialExtent = objInitialExtent.union(objLayerExtent);
                }
            }
            break;

        case TrimbleMap.Controller.enumMapServiceType.Dynamic:
        case TrimbleMap.Controller.enumMapServiceType.Tile:
        case TrimbleMap.Controller.enumMapServiceType.WebMapService:

            // When the layer were successfully loaded ...
            if (arrEsriLayers.length > 0) {

                // There should only be one esri layer for a dynamic or tile service, get the initial extend of the first layer ...
                objInitialExtent = arrEsriLayers[0].initialExtent;
            }
    }

    return objInitialExtent;
}

// **************************************************************************
// FUNCTION: ProjectGeometry
// USAGE:    enProjectionLevel is optional and defaults to Map.enumProjectionLevel.CRITICAL
//           See Map.Controller.ProjectGeometries for use of enProjectionLevel
// **************************************************************************
TrimbleMap.Controller.ProjectGeometry = function ProjectGeometry(objGeometry, guidFromSpatialReference, guidToSpatialReference, blnSimplify, enProjectionLevel, blnSuppressMeasuresOutOfBoundsDiagnosticMessage) {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Create an array with the geometry in it when not null ...
    var arrGeometries = [];
    if (objGeometry) { arrGeometries.push(objGeometry); }

    // Project the geometry using the ProjectGeometries function ...
    var objProjectGeometriesDeferred = objMapController.ProjectGeometries(arrGeometries, guidFromSpatialReference, guidToSpatialReference, blnSimplify, enProjectionLevel, blnSuppressMeasuresOutOfBoundsDiagnosticMessage);

    // When ProjectGeometries completes ...
    objProjectGeometriesDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

        // Get the projected geometry (if any) ...
        var objProjectedGeometry = (arrProjectedGeometries.length > 0) ? arrProjectedGeometries[0] : null;

        // Resolve the deferred with the projected geometry ...
        objDeferred.resolve(objProjectedGeometry);

    }), TrimbleMap.Controller.Shared.TrapException(function (strError) { objDeferred.reject(strError); }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: HaveValidGeotransformationConfigurationBetween
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.HaveValidGeotransformationConfigurationBetween = function HaveValidGeotransformationConfigurationBetween(guidFromSpatialReference, guidToSpatialReference) {

    // Get the controller ...
    var objMapController = this;

    // Start with having valid geotransformation data ...
    var blnHaveValidGeotransformationConfigurationBetween = true;

    // Get the geo-transformation to perform ...
    var objGeoTransformationAndDirection = objMapController.GetGeoTransformation(guidFromSpatialReference, guidToSpatialReference);

    // When a geo-transformation is required ...
    if (objGeoTransformationAndDirection.RequiresTransformation) {

        // When we do not have a defined geo-transformation and 
        // we are not to allow arcgis server to select one for us ...
        if ((!objGeoTransformationAndDirection.GeoTransformation) && (!objMapController.State.AllowAutomaticGeotransformation)) {

            // Set to not have valid geotransformation data ...
            blnHaveValidGeotransformationConfigurationBetween = false;
        }
    }

    return blnHaveValidGeotransformationConfigurationBetween;
}

// **************************************************************************
// FUNCTION: CreateProj4jsProjection
// USAGE:    Creates a Pro4js projection including the geocentric translations 
//           paramters if any - see https://github.com/proj4js/proj4js
// **************************************************************************
TrimbleMap.Controller.CreateProj4jsProjection = function CreateProj4jsProjection(guidSpatialReference) {

    // Get the controller ...
    var objMapController = this;

    // Attempt to retrieve the Proj4js projection ...
    var objProj4jsProjection = objMapController.Proj4jsProjections[guidSpatialReference];

    // When we do not have a cached proj4js projection ...
    if ((typeof objProj4jsProjection == 'undefined') || (!objProj4jsProjection)) {

        // Get the FlexiCadastre spatial reference ...
        var objSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

        try {
            // Create the proj4js projection ...
            objProj4jsProjection = proj4.Proj(objSpatialReference.WKTDefinition);

        } catch (objError) {

            // Create and throw a new exception ...
            throw { NotSupportedByProj4js: true, Error: objError, SpatialReference: objSpatialReference };
        }

        // Add it to the cache ...
        objMapController.Proj4jsProjections[guidSpatialReference] = objProj4jsProjection;
    }

    return objProj4jsProjection;
}

// **************************************************************************
// FUNCTION: CreateProj4jsTransformer
// USAGE:    Creates a Pro4js transformer including the geocentric translations 
//           paramters if any - see https://github.com/proj4js/proj4js
// **************************************************************************
TrimbleMap.Controller.CreateProj4jsTransformer = function CreateProj4jsTransformer(guidFromSpatialReference, guidToSpatialReference, objGeoTransformationAndDirection) {

    // Get the controller ...
    var objMapController = this;

    // Create the from and to proj4js projections ...
    var objFromProjection = objMapController.CreateProj4jsProjection(guidFromSpatialReference);
    var objToProjection = objMapController.CreateProj4jsProjection(guidToSpatialReference);

    // When a geo-transformation is required and we have one and it's a geocentric and the datum_params hasn't yet been set
    if (objGeoTransformationAndDirection.RequiresTransformation && objGeoTransformationAndDirection.GeoTransformation && objGeoTransformationAndDirection.GeoTransformation.GeoTransformationType == "GeocentricTranslation" && !objFromProjection.datum.datum_params) {
        // Set the geo transformation parameters
        objFromProjection.datum.datum_params = [objGeoTransformationAndDirection.GeoTransformation.Dx,
        objGeoTransformationAndDirection.GeoTransformation.Dy,
        objGeoTransformationAndDirection.GeoTransformation.Dz];
        objFromProjection.datum.datum_type = 1; // PJD_3PARAM
    }

    // Create the proj4js projection ...
    var objProj4jsTransformer = proj4(objFromProjection, objToProjection);

    // Return the proj4js projection ...
    return objProj4jsTransformer;
}

// **************************************************************************
// FUNCTION: GetUseClientSideProjectionInfoFromCache
// USAGE:    Returns the object containing the info from the cache, 
//           it creates and adds it when it does not exist ...
// **************************************************************************
TrimbleMap.Controller.GetUseClientSideProjectionInfoFromCache = function GetUseClientSideProjectionInfoFromCache(guidFromSpatialReference, guidToSpatialReference) {

    // Get the controller ...
    var objMapController = this;

    // Ensure that the from and to spatial reference ids are lower case ...
    guidFromSpatialReference = guidFromSpatialReference.toLowerCase();
    guidToSpatialReference = guidToSpatialReference.toLowerCase();

    // Get the to spatial reference cache for the from spatial reference cache ...
    var objToCache = objMapController.UseClientSideProjectionByFromSpatialReference[guidFromSpatialReference];

    // When not to chache found from the "from" spatial reference ...
    if ((typeof objToCache == 'undefined') && (objToCache == null)) {

        // Create an entry for it ...
        objToCache = {};

        // Add it to the cache ...
        objMapController.UseClientSideProjectionByFromSpatialReference[guidFromSpatialReference] = objToCache;
    }

    // Get the value for the to spatial reference ...
    var objUseClientSideProjection = objToCache[guidToSpatialReference];

    // When not found ...
    if (typeof objUseClientSideProjection == 'undefined') {

        // Create the info object ...
        objUseClientSideProjection = {
            UseClientSideProjection: null,
            BusyTesting: false,
            DeferredsToResolveWithResult: [],
            SetUseClientSideProjectionValue: function (blnUseClientSideProjection) {

                // Set the UseClientSideProjection value ...
                this.UseClientSideProjection = blnUseClientSideProjection;

                // Set to not be testing anymore ...
                this.BusyTesting = false;

                // Get the array of deferreds ...
                var arrDeferredsToResolveWithResult = this.DeferredsToResolveWithResult;

                // Clear the array of deferreds ...
                this.DeferredsToResolveWithResult = [];

                // Resolve all the deferreds in the array with the result ...
                $.each(arrDeferredsToResolveWithResult, function (intDeferred, objDeferred) { objDeferred.resolve(blnUseClientSideProjection); });
            }
        };

        // Add the value for the to spatial reference ...
        objToCache[guidToSpatialReference] = objUseClientSideProjection;
    }

    return objUseClientSideProjection;
}

// **************************************************************************
// FUNCTION: RemoveUseClientSideProjectionInfoFromCache
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.RemoveUseClientSideProjectionInfoFromCache = function RemoveUseClientSideProjectionInfoFromCache(guidFromSpatialReference, guidToSpatialReference) {

    // Get the controller ...
    var objMapController = this;

    // Get the to spatial reference cache for the from spatial reference cache ...
    var objToCache = objMapController.UseClientSideProjectionByFromSpatialReference[guidFromSpatialReference];

    // When the "to" cache were found ...
    if ((typeof objToCache != 'undefined') && (objToCache != null)) {

        // Get the value for the "to" spatial reference ...
        var objUseClientSideProjection = objToCache[guidToSpatialReference];

        // When not found ...
        if ((typeof objUseClientSideProjection != 'undefined') && (objUseClientSideProjection != null)) {

            // Delete the item from the cache ...
            delete objToCache[guidToSpatialReference];
        }
    }
}

// **************************************************************************
// FUNCTION: UseClientSideProjection
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.UseClientSideProjection = function UseClientSideProjection(guidFromSpatialReference,
    guidToSpatialReference,
    objFromEsriSpatialReference,
    objToEsriSpatialReference,
    objFromSpatialReference,
    objToSpatialReference,
    objGeoTransformationAndDirection,
    enProjectionLevel,
    arrGeometries,
    blnSuppressMeasuresOutOfBoundsDiagnosticMessage) {
    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Default to blnSuppressMeasuresOutOfBoundsDiagnosticMessage to false ...
    if ((typeof blnSuppressMeasuresOutOfBoundsDiagnosticMessage == 'undefined') || (blnSuppressMeasuresOutOfBoundsDiagnosticMessage == null)) { blnSuppressMeasuresOutOfBoundsDiagnosticMessage = false; }

    // Client side projections only supported in scenarios where we have no geotransformation or for geo-centric translations ...
    var blnUseClientSideProjection = objMapController.AllowClientSideProjections &&
        (enProjectionLevel == TrimbleMap.enumProjectionLevel.RELAXED) &&
        ((!objGeoTransformationAndDirection.RequiresTransformation) ||
            (!objGeoTransformationAndDirection.GeoTransformation) ||
            (objGeoTransformationAndDirection.GeoTransformation.GeoTransformationType == "GeocentricTranslation"));

    // When determined that the client side reprojection are to be used in this scenario (all that is left is 
    // to test proj4js to the geometry service for this combination of from and to spatial reference) ...
    if (blnUseClientSideProjection) {

        // Attempt to get the value from the cache ...
        var objUseClientSideProjection = objMapController.GetUseClientSideProjectionInfoFromCache(guidFromSpatialReference, guidToSpatialReference);

        // When this combination is currently being tested ...
        if (objUseClientSideProjection.BusyTesting) {

            // Add the deferred to the list of deferreds to resolve when the result comes back ...
            objUseClientSideProjection.DeferredsToResolveWithResult.push(objDeferred);

        } else if (objUseClientSideProjection.UseClientSideProjection != null) {

            // Resolve the deferred with the result ...
            objDeferred.resolve(objUseClientSideProjection.UseClientSideProjection);

        } else {

            // Set to be busy testing the combination of "from" and "to" spatial references ...
            objUseClientSideProjection.BusyTesting = true;

            // Attempt to get a test point from the geometry ...
            var objTestPoint = TrimbleMap.Geometry.GetRandomPointFromGeometries(arrGeometries);

            // When we managed to get a test point ...
            if (objTestPoint != null) {

                // Project the point using the geometry service ...
                var objProjectGeometriesByPointsDeferred = objMapController.ProjectGeometriesByPoints([objTestPoint], objFromEsriSpatialReference, objToEsriSpatialReference, objFromSpatialReference, objToSpatialReference, objGeoTransformationAndDirection, blnSuppressMeasuresOutOfBoundsDiagnosticMessage);

                // When the projection completes ...
                objProjectGeometriesByPointsDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

                    // Get the projected test point ...
                    var objProjectedTestPointGeometryService = arrProjectedGeometries[0];

                    // Declare a local variable for the client side reprojection result ...
                    var arrProjectedGeometriesClientSide;

                    // Start with continuing the comparison ...
                    var blnContinueComparison = true;

                    try {

                        // Project the point on the client side ...
                        arrProjectedGeometriesClientSide = objMapController.ProjectGeometriesClientSide([objTestPoint], guidFromSpatialReference, guidToSpatialReference, objGeoTransformationAndDirection);

                    } catch (objError) {

                        // When not supported by proj4js ...
                        if (typeof objError.NotSupportedByProj4js != 'undefined' && objError.NotSupportedByProj4js) {

                            // Set to not continue with the comparison ...
                            blnContinueComparison = false;

                            // Update the cache to indicate that we cannot use client side projection for the spatial references involved (and notify other callers waiting for the result) ...
                            objUseClientSideProjection.SetUseClientSideProjectionValue(false);

                            // Resolve the deferred with the result ...
                            objDeferred.resolve(false);
                        }
                    }

                    // When we are to continue with the comparison ...
                    if (blnContinueComparison) {

                        // Get the projected test point (client side) ...
                        var objProjectedTestPointClientSide = arrProjectedGeometriesClientSide[0];

                        // Start with true ...
                        blnUseClientSideProjection = true;

                        // Round the coordinates to the number of decimal places of the coordinate system ...
                        var objRoundedProjectedTestPointGeometryService = {
                            x: SD.Number.RoundTo(objProjectedTestPointGeometryService.x, objToSpatialReference.DecimalPlaces),
                            y: SD.Number.RoundTo(objProjectedTestPointGeometryService.y, objToSpatialReference.DecimalPlaces)
                        }
                        var objRoundedProjectedTestPointClientSide = {
                            x: SD.Number.RoundTo(objProjectedTestPointClientSide.x, objToSpatialReference.DecimalPlaces),
                            y: SD.Number.RoundTo(objProjectedTestPointClientSide.y, objToSpatialReference.DecimalPlaces)
                        }

                        // When not the same result ...
                        if ((objRoundedProjectedTestPointGeometryService.x != objRoundedProjectedTestPointClientSide.x) || (objRoundedProjectedTestPointGeometryService.y != objRoundedProjectedTestPointClientSide.y)) {

                            // Set to false ...
                            blnUseClientSideProjection = false;
                        }

                        // Update the cache (and notify other callers waiting for the result) ...
                        objUseClientSideProjection.SetUseClientSideProjectionValue(blnUseClientSideProjection);

                        // Resolve the deferred with the result ...
                        objDeferred.resolve(blnUseClientSideProjection);
                    }

                }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                    // When it's a measures out of bounds exception ...
                    if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

                        // Update the cache (and notify other callers waiting for the result) to not use the client side reprojection ...
                        objUseClientSideProjection.SetUseClientSideProjectionValue(false);

                        // Removeteh use client side projection info from the cache ...
                        objMapController.RemoveUseClientSideProjectionInfoFromCache(guidFromSpatialReference, guidToSpatialReference);

                        // Resolve not to use client side reprojection ...
                        objDeferred.resolve(false);

                    } else {

                        // Reject the deferred with the error ...
                        objDeferred.reject(objError);
                    }
                }));

            } else {

                // Resolve to not use the client side reprojection ...
                objDeferred.resolve(false);
            }
        }

    } else {

        // Resolve the deferred with the result ...
        objDeferred.resolve(blnUseClientSideProjection);
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: ProjectGeometriesClientSide
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.ProjectGeometriesClientSide = function ProjectGeometriesClientSide(arrGeometries, guidFromSpatialReference, guidToSpatialReference, objGeoTransformationAndDirection) {

    // Get the controller ...
    var objMapController = this;

    // Create an array to return ...
    var arrProjectedGeometries = [];

    // Create the proj4js projection object ...
    var objProj4jsTransformer = objMapController.CreateProj4jsTransformer(guidFromSpatialReference, guidToSpatialReference, objGeoTransformationAndDirection);

    // Create the to esri spatial reference ...
    var objToEsriSpatialReference = objMapController.CreateEsriSpatialReference(guidToSpatialReference);

    // Loop through all the geometries in the array ...
    $.each(arrGeometries, function (intGeometry, objGeometry) {

        // Clone the geometry ...
        var objProjectedGeometry = esri.geometry.fromJson(objGeometry.toJson());

        // Loop through all the points in the array ...
        TrimbleMap.Controller.Shared.ForEachXYPointInGeometry(objProjectedGeometry, function (objXYPoint, fnUpdateXYPoint) {

            // Project the point using proj4js ...
            var objProjectedXYPoint = objProj4jsTransformer.forward(objXYPoint);

            // Update the point in the geometry ...
            fnUpdateXYPoint(objProjectedXYPoint.x, objProjectedXYPoint.y);
        });

        // Set the spatial reference ...
        objProjectedGeometry.setSpatialReference(objToEsriSpatialReference);

        // Add it to the output array ...
        arrProjectedGeometries.push(objProjectedGeometry);
    });

    return arrProjectedGeometries;
}

// **************************************************************************
// FUNCTION: ProjectGeometries
// USAGE:    blnSimplify is optional and defaults to true
//           blnSuppressMeasuresOutOfBoundsDiagnosticMessage isd optional and defaults to false
//           enProjectionLevel is used to decide whether or not the projection will be 
//           done on the client side with proj4js or with the esri GeometryService.
//           enProjectionLevel should be a value of Map.enumProjectionLevel (CRITICAL or RELAXED)
//           enProjectionLevel is optional and defaults to Map.enumProjectionLevel.CRITICAL
//           CRITICAL: The GeometryService will always be used
//           RELAXED: Proj4js will be used for transformations supported by 
//                    proj4js and when objMapController.AllowClientSideProjections
//                    is true, otherwise the GeometryService will be used
// **************************************************************************
TrimbleMap.Controller.ProjectGeometries = function ProjectGeometries(arrGeometries, guidFromSpatialReference, guidToSpatialReference, blnSimplify, enProjectionLevel, blnSuppressMeasuresOutOfBoundsDiagnosticMessage) {

    // Get the controller ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Default to simplify the input geometries when blnSimplify is not set ...
    if ((typeof blnSimplify == 'undefined') || (blnSimplify == null)) { blnSimplify = true; }

    // Default to blnSuppressMeasuresOutOfBoundsDiagnosticMessage to false when not set ...
    if ((typeof blnSuppressMeasuresOutOfBoundsDiagnosticMessage == 'undefined') || (blnSuppressMeasuresOutOfBoundsDiagnosticMessage == null)) { blnSuppressMeasuresOutOfBoundsDiagnosticMessage = false; }

    // When simplification are to be allowed ...
    if (blnSimplify) {

        // Count the number of points in the array of geometries ...
        var intTotalPoints = TrimbleMap.Geometry.CountGeometryArrayPoints(arrGeometries);

        // When more than the max per request, set to not simplify (so that the geometries will be broken up into a list of points with multiple calls for groups of points) ...
        if (intTotalPoints > TrimbleMap.Controller.Shared.MAX_POINTS_PER_PROJECTION_REQUEST) { blnSimplify = false; }
    }

    // Default to simplify the input geometries when blnSimplify is not set ...
    if ((typeof enProjectionLevel == 'undefined') || (enProjectionLevel == null)) { enProjectionLevel = TrimbleMap.enumProjectionLevel.CRITICAL; }

    // When the "To" and "From" spatial references is not the same and we have geometries ...
    if ((guidFromSpatialReference != guidToSpatialReference) && arrGeometries && (arrGeometries.length > 0)) {

        // Get the 'From' and 'To' spatial references ...
        var objFromSpatialReference = objMapController.GetSpatialReference(guidFromSpatialReference);
        var objToSpatialReference = objMapController.GetSpatialReference(guidToSpatialReference);

        // Create the 'To' and 'From' esri spatial reference ...
        var objFromEsriSpatialReference = objMapController.CreateEsriSpatialReference(guidFromSpatialReference);
        var objToEsriSpatialReference = objMapController.CreateEsriSpatialReference(guidToSpatialReference);

        // Get the geo-transformation to perform ...
        var objGeoTransformationAndDirection = objMapController.GetGeoTransformation(guidFromSpatialReference, guidToSpatialReference);

        // Start with continuing with the projection (we might not if we donot have a valid geo-transfomration ...
        var blnContinueWithProjection = true;

        // When a geo-transformation is required ...
        if (objGeoTransformationAndDirection.RequiresTransformation) {

            // When we have don't have a geotransformation ...
            if ((!objGeoTransformationAndDirection.GeoTransformation) && (!objMapController.State.AllowAutomaticGeotransformation)) {

                // Get the 'From' and 'To' geographic spatial references ...
                var objFromGeographicSpatialReference = objMapController.GetSpatialReference(objGeoTransformationAndDirection.GeographicFromSpatialReferenceID);
                var objToGeographicSpatialReference = objMapController.GetSpatialReference(objGeoTransformationAndDirection.GeographicToSpatialReferenceID);

                // Get the title and message translations ...

                // Reprojection failed
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionFailedTitle');

                // Unable to project geometry from '%1' to '%2' because there are no geotransformation defined between '%3' and '%4'
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionFailedMessage', objFromSpatialReference.Name, objToSpatialReference.Name, objFromGeographicSpatialReference.Name, objToGeographicSpatialReference.Name);

                // Problem reprojecting the geometry.
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionFailedEndUserMessage');

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

                // Return an error ...
                objDeferred.reject(new Error(strMessage));

                // Set to not continue with the projection ...
                blnContinueWithProjection = false;
            }
        }

        // When we are to continue with the projection ...
        if (blnContinueWithProjection) {

            // Determine whether or not we can use the proj4js library ...
            var objUseClientSideProjectionDeferred = objMapController.UseClientSideProjection(guidFromSpatialReference, guidToSpatialReference, objFromEsriSpatialReference, objToEsriSpatialReference, objFromSpatialReference, objToSpatialReference, objGeoTransformationAndDirection, enProjectionLevel, arrGeometries, blnSuppressMeasuresOutOfBoundsDiagnosticMessage);

            // When we determined whether or not we can use the proj4js library ...
            objUseClientSideProjectionDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (blnUseClientSideProjection) {

                // When strict mode is requested or when the client side library (pro4js) does
                // not support this projection or when projection with proj4js is disabled ...
                if (!blnUseClientSideProjection) {

                    // When we are allowed to simplify the geometry ...
                    if (blnSimplify) {

                        // Create a project parameters instance ...
                        var objProjectParameters = new esri.tasks.ProjectParameters();

                        // Set the geometries to project ...
                        objProjectParameters.geometries = arrGeometries;

                        // Set the output spatial reference ...
                        objProjectParameters.outSR = objToEsriSpatialReference;

                        // When a geo-transformation is required ...
                        if (objGeoTransformationAndDirection.RequiresTransformation) {

                            // When we have a geotransformation ...
                            if (objGeoTransformationAndDirection.GeoTransformation) {

                                // Set to transform forward or not ...
                                objProjectParameters.transformForward = objGeoTransformationAndDirection.TransformForward;

                                // Set the well known text of the geo-transformation ...
                                objProjectParameters.transformation = { wkt: objGeoTransformationAndDirection.GeoTransformation.WKT };
                            }
                        }

                        // Reserve a variable for the request's io args ...
                        var objRequestIOArgs = null;

                        // Project the geometry ...
                        objMapController.GeometryService.project(objProjectParameters, TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

                            // When we have a valid projection result ...
                            if (TrimbleMap.Controller.Shared.IsValidProjectionResult(arrProjectedGeometries, !blnSimplify)) {

                                // Resolve the deferred with the projected geometries ...
                                objDeferred.resolve(arrProjectedGeometries);

                            } else {

                                // When we should not suppress measures out of bounds diagnostic messages ...
                                if (!blnSuppressMeasuresOutOfBoundsDiagnosticMessage) {

                                    // Reprojection failed
                                    var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionMeasuresOutOfBoundsTitle');

                                    // Measures out of bounds (Result returned as NaN)
                                    var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionMeasuresOutOfBoundsMessage');

                                    // Problem reprojecting the geometry. Coordinate measures out of bounds (Result returned as not a number)
                                    var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionMeasuresOutOfBoundsEndUserMessage');

                                    // Log the diagnostic message ...
                                    objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs));
                                }

                                // Return an error ...
                                objDeferred.reject({ IsMeasuresOutOfBoundsException: true, Message: SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionMeasuresOutOfBoundsMessage') });
                            }

                        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                            // Get the 'From' and 'To' spatial references ...
                            var objFromSpatialReference = objMapController.GetSpatialReference(guidFromSpatialReference);
                            var objToSpatialReference = objMapController.GetSpatialReference(guidToSpatialReference);

                            // Start with no geometries ...
                            var strGeometries = '';

                            // Loop through all the geometries in the array ...
                            $.each(objProjectParameters.geometries, function (intGeometry, objGeometry) {

                                // Add a comma if we already have values ...
                                if (strGeometries.length > 0) { strGeometries += ',' }

                                // Convert the geometry to json and add ...
                                strGeometries += JSON.stringify(objGeometry.toJson());
                            })

                            // Add the [] ...
                            strGeometries = '[' + strGeometries + ']';

                            // Get the title and message translations ...

                            // Reprojection failed
                            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ProjectGeometriesFailedTitle');

                            // From Spatial Reference Name: '%1'<br>To Spatial Reference Name: '%2'<br>Geotransformation name: '%3'<br><br>Geotransformation wkt:<br>%4<br><br>From Spatial Reference Json:<br>%5<br><br>To Spatial Reference Json:<br>%6<br><br>Geometries:<br>%7<br>
                            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ProjectGeometriesFailedMessages', objFromSpatialReference.Name, objToSpatialReference.Name, (objGeoTransformationAndDirection.GeoTransformation) ? objGeoTransformationAndDirection.GeoTransformation.Name : '', (objGeoTransformationAndDirection.GeoTransformation) ? objGeoTransformationAndDirection.GeoTransformation.WKT : '', JSON.stringify(objFromEsriSpatialReference.toJson()), JSON.stringify(objToEsriSpatialReference.toJson()), strGeometries);

                            // Reprojection from coordinate system '%1'<br> to coordinate system '%2'<br> failed
                            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ProjectGeometriesFailedEndUserMessages', objFromSpatialReference.Name, objToSpatialReference.Name);

                            // Log the diagnostic message ...
                            objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objRequestIOArgs));

                            // Return an error ...
                            objDeferred.reject(objError);
                        }));

                        // Get the request's IO arguments ...
                        objRequestIOArgs = objMapController.LastEsriRequestIOArgs;

                    } else {

                        // Get the 'From' and 'To' spatial references ...
                        var objFromSpatialReference = objMapController.GetSpatialReference(guidFromSpatialReference);
                        var objToSpatialReference = objMapController.GetSpatialReference(guidToSpatialReference);

                        // Project the geometries by point ...
                        objMapController.ProjectGeometriesByPoints(arrGeometries, objFromEsriSpatialReference, objToEsriSpatialReference, objFromSpatialReference, objToSpatialReference, objGeoTransformationAndDirection, blnSuppressMeasuresOutOfBoundsDiagnosticMessage).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

                            // Resolve the deferred with the projected geometries ...
                            objDeferred.resolve(arrProjectedGeometries);

                        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                            // Return an error ...
                            objDeferred.reject(objError);
                        }));
                    }

                } else {

                    // Project the geometries on the client side using proj4js ...
                    var arrProjectedGeometries = objMapController.ProjectGeometriesClientSide(arrGeometries, guidFromSpatialReference, guidToSpatialReference, objGeoTransformationAndDirection);

                    // Resolve the deferred with the projected geometries ...
                    objDeferred.resolve(arrProjectedGeometries);
                }

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                // Reject the deferred with the error ...
                objDeferred.reject(objError);
            }));
        }

    } else {

        // Resolve the deferred with the geometries as is ...
        objDeferred.resolve(arrGeometries);
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: ProjectGeometriesByPoints
// USAGE:    blnSuppressMeasuresOutOfBoundsDiagnosticMessage is optional and defaults to false
//           objFromSpatialReference, objToSpatialReference and objGeoTransformationAndDirection are optional
//           objFromSpatialReference and objToSpatialReference are only used to log diagnostic messages when 
//           objGeoTransformationAndDirection were specified
//           When objGeoTransformationAndDirection were not specified, we allow to fall back to the 
//           default geotransformation of the projection engine used
// **************************************************************************
TrimbleMap.Controller.ProjectGeometriesByPoints = function ProjectGeometriesByPoints(arrGeometries, objFromEsriSpatialReference, objToEsriSpatialReference, objFromSpatialReference, objToSpatialReference, objGeoTransformationAndDirection, blnSuppressMeasuresOutOfBoundsDiagnosticMessage) {

    // Get the controller ...
    var objMapController = this;

    // Default to blnSuppressMeasuresOutOfBoundsDiagnosticMessage to false when not set ...
    if ((typeof blnSuppressMeasuresOutOfBoundsDiagnosticMessage == 'undefined') || (blnSuppressMeasuresOutOfBoundsDiagnosticMessage == null)) { blnSuppressMeasuresOutOfBoundsDiagnosticMessage = false; }

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Create a new array for the deferreds ...
    var arrDeferreds = [];

    // Create an array for the request io args ...
    var arrRequestIOArgs = [];

    // Build the operation url, start with the geometry service url ...
    var strProjectOperationUrl = objMapController.State.GeometryServiceUrl;

    // Ensure that we have a front slash at the end ...
    if ((strProjectOperationUrl.length != 0) && (strProjectOperationUrl[strProjectOperationUrl.length] != '/')) { strProjectOperationUrl += '/'; }

    // Add the operation name ...
    strProjectOperationUrl += 'project';

    // Serialize the in and out spatial references and the geotransformations ...
    var strInSRJson = JSON.stringify(objFromEsriSpatialReference.toJson());
    var strOutSRJson = JSON.stringify(objToEsriSpatialReference.toJson());
    var strGeotransformationJson = (objGeoTransformationAndDirection && objGeoTransformationAndDirection.GeoTransformation) ? JSON.stringify({ wkt: objGeoTransformationAndDirection.GeoTransformation.WKT }) : null;

    // Flatten the geometry into an array of points ...
    var arrPoints = TrimbleMap.Controller.Shared.FlattenGeometriesToPointArray(arrGeometries, objFromEsriSpatialReference);

    // Start at point 0 ...
    var intCurrentPoint = 0;

    // While we have more points to project ...
    while (intCurrentPoint < arrPoints.length) {

        // Start with an empty point string ...
        var strPoints = '';

        // Loop through the points from the first up to Map.Controller.Shared.MAX_POINTS_PER_PROJECTION_REQUEST points or the end of the array of points ...
        for (var intPoint = 0; (intPoint < TrimbleMap.Controller.Shared.MAX_POINTS_PER_PROJECTION_REQUEST) && (intCurrentPoint < arrPoints.length); intPoint++) {

            // Get and remove the first point ...
            var objPoint = arrPoints[intCurrentPoint++];

            // Add a comma when not the first ...
            if (intPoint > 0) { strPoints += ','; }

            // Add the x and y ...
            strPoints += objPoint.x + ',' + objPoint.y;
        }

        // Create a parameters object ...
        var objParameters = {
            f: 'json',
            geometries: strPoints,
            inSR: strInSRJson,
            outSR: strOutSRJson
        };

        // When we have a geotransformation ...
        if (objGeoTransformationAndDirection && objGeoTransformationAndDirection.GeoTransformation) {

            // Set the transformation ...
            objParameters.transformation = strGeotransformationJson;
            objParameters.transformForward = objGeoTransformationAndDirection.TransformForward;
        }

        // Create a form data object with the parameters ...
        var objParameterFormData = TrimbleMap.Controller.Shared.CreateFormData(objParameters);

        // Perform the request ...
        var objProjectDeferred = esri.request({
            url: strProjectOperationUrl,
            callbackParamName: 'callback',
            form: objParameterFormData.get(0),
            handleAs: 'json'
        }, {
            disableIdentityLookup: true,
            usePost: true,
            useProxy: false
        });

        // Add the deferred to the array of deferreds ...
        arrDeferreds.push(objProjectDeferred);

        // Get the request's IO arguments ...
        arrRequestIOArgs.push(objMapController.LastEsriRequestIOArgs);
    }

    // Start with not being rejected (only keeping track to ensure that we are not rejecting the deferred multiple times) ...
    var blnRejected = false;

    // When all completed ...
    new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function (arrResponse) {

        // Create a new empty array for the result ...
        var arrProjectedPoints = [];

        // Loop through the responses and accumulate all the projected points ...
        $.each(arrResponse, function (intResponse, objResponse) { arrProjectedPoints = arrProjectedPoints.concat(objResponse.geometries); });

        // When we have a valid projection result ...
        if (TrimbleMap.Controller.Shared.IsValidProjectionResult(arrProjectedPoints, true)) {

            // Split the point array up into a geometry again ...
            var arrProjectedGeometries = TrimbleMap.Controller.Shared.CreateGeometriesFromFlattenedPointArray(arrProjectedPoints, arrGeometries, objToEsriSpatialReference);

            // Resolve the deferred with the projected geometries ...
            objDeferred.resolve(arrProjectedGeometries);

        } else {

            // When we should not suppress measures out of bounds diagnostic messages ...
            if (!blnSuppressMeasuresOutOfBoundsDiagnosticMessage) {

                // Reprojection failed
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionMeasuresOutOfBoundsTitle');

                // Measures out of bounds (Result returned as NaN)
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionMeasuresOutOfBoundsMessage');

                // Problem reprojecting the geometry. Coordinate measures out of bounds (Result returned as not a number)
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionMeasuresOutOfBoundsEndUserMessage');

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(arrRequestIOArgs[0]));
            }

            // When the deferred has not already been rejected yet ...
            if (!blnRejected) {

                // Return an error ...
                objDeferred.reject({ IsMeasuresOutOfBoundsException: true, Message: SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ReprojectionMeasuresOutOfBoundsMessage') });

                // Set to be rejected ...
                blnRejected = true;
            }
        }

    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

        // When we have a geotransformation and direction ...
        if (objGeoTransformationAndDirection) {

            // Reprojection failed
            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ProjectGeometriesFailedTitle');

            // From Spatial Reference Name: '%1'<br>To Spatial Reference Name: '%2'<br>Geotransformation name: '%3'<br><br>Geotransformation wkt:<br>%4<br><br>From Spatial Reference Json:<br>%5<br><br>To Spatial Reference Json:<br>%6<br><br>Geometries:<br>%7<br>
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ProjectGeometriesFailedMessages', objFromSpatialReference.Name, objToSpatialReference.Name, ((objGeoTransformationAndDirection.GeoTransformation) ? objGeoTransformationAndDirection.GeoTransformation.Name : ''), ((objGeoTransformationAndDirection.GeoTransformation) ? objGeoTransformationAndDirection.GeoTransformation.WKT : ''), JSON.stringify(objFromEsriSpatialReference.toJson()), JSON.stringify(objToEsriSpatialReference.toJson()), strPoints);

            // Reprojection from coordinate system '%1'<br> to coordinate system '%2'<br> failed
            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'ProjectGeometriesFailedEndUserMessages', objFromSpatialReference.Name, objToSpatialReference.Name);

            // Log the diagnostic message ...
            objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(arrRequestIOArgs[0]));

        } else {

            // Convert the from and to spatial references to json ...
            var strFromSpatialReferenceJson = JSON.stringify(objFromEsriSpatialReference.toJson());
            var strToSpatialReferenceJson = JSON.stringify(objToEsriSpatialReference.toJson());

            // Get the title and message translations ...

            // Reprojection (with automatic geotransformation) failed
            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'AutomaticReprojectionFailedTitle');

            // Geometry Json:<br>%1<br><br>From Spatial Reference:<br>%2<br><br>To Spatial Reference:<br>%3
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'AutomaticReprojectionFailedMessage', strPoints, strFromSpatialReferenceJson, strToSpatialReferenceJson);

            // Reprojection failed
            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'AutomaticReprojectionFailedEndUserMessage');

            // Log the diagnostic message ...
            objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(arrRequestIOArgs[0]));
        }

        // When the deferred has not already been rejected yet ...
        if (!blnRejected) {

            // Reject the deferred with the error ...
            objDeferred.reject(objError);

            // Set to be rejected ...
            blnRejected = true;
        }
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: CreateEsriSpatialReference
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.CreateEsriSpatialReference = function CreateEsriSpatialReference(guidSpatialReference) {

    // Get the controller ...
    var objMapController = this;

    // Get the cached esri spatial reference for the spatial reference id (if we have one) ...
    var objEsriSpatialReference = objMapController.EsriSpatialReferences[guidSpatialReference];

    // When we do not have a cached esri spatial reference ...
    if ((typeof objEsriSpatialReference == 'undefined') || (!objEsriSpatialReference)) {

        // Get the FlexiCadastre spatial reference information ...
        var objFlexiCadastreSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

        // When we have a non-zero well known ID ...
        if (objFlexiCadastreSpatialReference.WKID != 0) {

            // Create an esri spatial reference from the FlexiCadastre spatial reference well known id from ...
            objEsriSpatialReference = new esri.SpatialReference(objFlexiCadastreSpatialReference.WKID);

        } else {

            // Create an esri spatial reference from the FlexiCadastre spatial reference well known text from ...
            objEsriSpatialReference = new esri.SpatialReference(objFlexiCadastreSpatialReference.WKTDefinition);
        }

        // Add it to the cache ...
        objMapController.EsriSpatialReferences[guidSpatialReference] = objEsriSpatialReference;
    }

    // Return the spatial reference ..
    return objEsriSpatialReference;
}

// **************************************************************************
// FUNCTION: ExpandGeometryToExtent
// USAGE:    objGeometry must be in the spatial reference of the map ...
// **************************************************************************
TrimbleMap.Controller.ExpandGeometryToExtent = function ExpandGeometryToExtent(objGeometry, dblZoomFactor, decPointSidePaddingDistanceInMeters) {

    // Get the instance ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Get the extent of the geometry when not a point otherwise build an extent on the point ...
    var objExtentToExpand = (objGeometry.type != 'point') ? objGeometry.getExtent() : (new esri.geometry.Extent(objGeometry.x, objGeometry.y, objGeometry.x, objGeometry.y, objGeometry.spatialReference));

    // Check whether or not we have a zero width and height ? (we do it this way incase we have a multi point with all points at exactly the same location) ...
    var blnIsPoint = ((objExtentToExpand.getHeight() == 0) && (objExtentToExpand.getWidth() == 0));

    // When we have a zero witdh and height i.e. it's a point ...
    if (blnIsPoint) {

        // Get the center of the extent ...
        var objExtentCenter = objExtentToExpand.getCenter();

        // Get the current map's spatial reference ...
        var objCurrentMapSpatialReference = objMapController.GetSpatialReference(objMapController.CurrentMap.SpatialReferenceID);

        // When the current map's spatial reference type is projected ...
        if (objCurrentMapSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) {

            // Convert the padding distance from meters to the units of the spatial reference ...
            var decPaddingDistanceInUnitsOfSpatialReference = decPointSidePaddingDistanceInMeters / objCurrentMapSpatialReference.ConversionFactorToMeters;

            // Build an extent around the center using the padding distance ...
            var objPaddedExtent = new esri.geometry.Extent(objExtentCenter.x - decPaddingDistanceInUnitsOfSpatialReference,
                objExtentCenter.y - decPaddingDistanceInUnitsOfSpatialReference,
                objExtentCenter.x + decPaddingDistanceInUnitsOfSpatialReference,
                objExtentCenter.y + decPaddingDistanceInUnitsOfSpatialReference,
                objGeometry.spatialReference);

            // Resolve the deferred with the padded extent ...
            objDeferred.resolve(objPaddedExtent);

        } else {

            // Instantiate a web mercator spatial reference ...
            var objWebMercator = new esri.SpatialReference(3857);

            // Project the geometries to the current spatial reference ...
            objMapController.ProjectGeometriesByPoints([objExtentCenter], objGeometry.spatialReference, objWebMercator, null, null, null).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedCenter) {

                // Get the projected point ...
                var objProjectedCenter = arrProjectedCenter[0];

                // Build an extent around the projected center using the padding distance ...
                var objExtentInWebMercator = new esri.geometry.Extent(objProjectedCenter.x - decPointSidePaddingDistanceInMeters,
                    objProjectedCenter.y - decPointSidePaddingDistanceInMeters,
                    objProjectedCenter.x + decPointSidePaddingDistanceInMeters,
                    objProjectedCenter.y + decPointSidePaddingDistanceInMeters,
                    objWebMercator);

                // Project the extent back to the spatial reference of the input geometry ...
                objMapController.ProjectGeometriesByPoints([objExtentInWebMercator], objWebMercator, objGeometry.spatialReference, null, null, null).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedPaddedExtents) {

                    // Get the projected padded extent ...
                    var objProjectedPaddedExtent = arrProjectedPaddedExtents[0];

                    // Resolve the deferred with the padded extent ...
                    objDeferred.resolve(objProjectedPaddedExtent);
                }));
            }));
        }

    } else {

        // Expand the extent with the zoom factor ...
        var objExpandedExtent = objExtentToExpand.expand(dblZoomFactor);

        // Resolve the deferred with the expanded extent ...
        objDeferred.resolve(objExpandedExtent);
    }

    // Return the deferred ...
    return objDeferred;
}

// **************************************************************************
// FUNCTION: ComputeZoomToExtent
// USAGE:    objGeometry must be in the spatial reference of the map ...
// **************************************************************************
TrimbleMap.Controller.ComputeZoomToExtent = function ComputeZoomToExtent(objGeometry, dblZoomFactor, intAdjustOffset, decPointSidePaddingDistanceInMeters) {

    // Get the instance ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Set a default value for decPointSidePaddingDistanceInMeters when not set ...
    if ((typeof decPointSidePaddingDistanceInMeters == 'undefined') || (decPointSidePaddingDistanceInMeters == null)) { decPointSidePaddingDistanceInMeters = TrimbleMap.Controller.Shared.POINT_SIDE_PADDING_DISTANCE_METERS; }

    // Expand the geometry to an extent ...
    var objExpandGeometryToExtentDeferred = objMapController.ExpandGeometryToExtent(objGeometry, dblZoomFactor, decPointSidePaddingDistanceInMeters);

    // When the extent expansion completed ...
    objExpandGeometryToExtentDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objExtentToZoomTo) {

        // Check whether or not we have a non-zero width or height ?
        var blnNonZeroWidthOrHeight = ((objExtentToZoomTo.getHeight() > 0) || (objExtentToZoomTo.getWidth() > 0));

        // Get the visible extent of the map in screen coordinates ...
        var objVisibleMapExtentInScreenCoordinates = objMapController.GetVisibleMapExtentInScreenCoordinates();

        // Get the visible map extent in map coordinates ...
        var objVisibleMapExtentInMapUnits = objMapController.GetVisibleMapExtent(objVisibleMapExtentInScreenCoordinates);

        // Ensure that the spatial reference of the extent is the same as the spatial reference of the geometry ...
        objMapController.EsriMap.extent.setSpatialReference(objGeometry.spatialReference);

        // Expand the extent to have the same aspect ratio as the visible portion of the map when we 
        // have a non zero width or height otherwise set to center the current extent of the map ...
        var objExtentToCenter = (blnNonZeroWidthOrHeight) ? TrimbleMap.MapToScreenConversions.ExpandToAspectRatioOfExtent(objExtentToZoomTo, objVisibleMapExtentInMapUnits) : objMapController.EsriMap.extent;

        // Expand the extent to have the same aspect ratio as the map when we have a non
        // zero width or height otherwise set to center the current extent of the map ...
        objExtentToCenter = (blnNonZeroWidthOrHeight) ? TrimbleMap.MapToScreenConversions.ExpandToAspectRatioOfExtent(objExtentToCenter, objMapController.EsriMap.extent) : objExtentToCenter;

        // Deteremine the resultant extent from setting the map extent to objExtentToCenter ...
        objMapController.DetermineResultantExtent(objExtentToCenter).then(TrimbleMap.Controller.Shared.TrapException(function (objResultantExtentToCenter) {

            // Get the center of the extent ...
            var objExtentCenter = objExtentToZoomTo.getCenter();

            // Compute the distance in screen units to correct the center point with to center in the visible area of the map ...
            var dblDistance = parseInt(objMapController.MapElement.innerWidth(), 10) - objVisibleMapExtentInScreenCoordinates.width + intAdjustOffset;

            // Compute the offset in units on the current extent ...
            var dblOffsetInMapUnits = TrimbleMap.MapToScreenConversions.Shared.ComputeDistanceInMapUnits(objResultantExtentToCenter, dblDistance, objMapController.MapElement);

            // Center the extent on the center of the geometry ...
            objExtentToZoomTo = objResultantExtentToCenter.centerAt(new esri.geometry.Point(objExtentCenter.x + dblOffsetInMapUnits, objExtentCenter.y, objExtentCenter.spatialReference));

            // Remove the offset from the centered extent's xmax ...
            objExtentToZoomTo = objExtentToZoomTo.update(objExtentToZoomTo.xmin, objExtentToZoomTo.ymin, objExtentToZoomTo.xmax - dblOffsetInMapUnits, objExtentToZoomTo.ymax, objExtentToZoomTo.spatialReference);

            // Resolve the deferred with the extent ...
            objDeferred.resolve(objExtentToZoomTo);
        }));
    }));

    // Return the deferred ...
    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetVisibleMapExtent
// USAGE:    objVisibleMapExtentInScreenCoordinates is optional, 
//           if not passed in then it will be computed ...
// **************************************************************************
TrimbleMap.Controller.GetVisibleMapExtent = function GetVisibleMapExtent(objVisibleMapExtentInScreenCoordinates) {

    // Get the instance ...
    var objMapController = this;

    // If the visible map extent in screen coordinates were not passed in ...
    if ((typeof objVisibleMapExtentInScreenCoordinates == 'undefined') || (objVisibleMapExtentInScreenCoordinates == null)) {

        // Get the visible map extent in screen coordinates ...
        objVisibleMapExtentInScreenCoordinates = objMapController.GetVisibleMapExtentInScreenCoordinates();
    }

    // Compute the top left and bottom rigth screen points ...
    var objTopLeftScreenPoint = new esri.geometry.ScreenPoint(0, 0);
    var objBottomRightScreenPoint = new esri.geometry.ScreenPoint(objVisibleMapExtentInScreenCoordinates.width, objVisibleMapExtentInScreenCoordinates.height);

    // Convert to map points ...
    var objTopLeftMapPoint = objMapController.EsriMap.toMap(objTopLeftScreenPoint);
    var objBottomRightMapPoint = objMapController.EsriMap.toMap(objBottomRightScreenPoint);

    // Build an extent ...
    var objVisibleMapExtent = new esri.geometry.Extent(objTopLeftMapPoint.x, objBottomRightMapPoint.y, objBottomRightMapPoint.x, objTopLeftMapPoint.y, objMapController.EsriMap.spatialReference);

    return objVisibleMapExtent;
}

// **************************************************************************
// FUNCTION: BuildDynamicMapServiceLegendData
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.BuildDynamicMapServiceLegendData = function BuildDynamicMapServiceLegendData(objResponseData, objMapServiceDisplay, objMapService, objTiledOrDynamicLayer) {

    // Get the instance ...
    var objMapController = this;

    // Create a new hash table for the response data by layer id as key ... 
    var objResponseDataByLayerId = {};

    // Loop through all the layers ...
    for (var intLayer = 0; intLayer < objResponseData.layers.length; intLayer++) {

        // Get the layer ...
        var objLayer = objResponseData.layers[intLayer];

        // Set the layer by layer id ...
        objResponseDataByLayerId[objLayer.layerId] = objLayer;
    }

    // Both ArcGISDynamicMapServiceLayer and ArcGISTiledMapServiceLayer have layerInfos with parentLayerId and subLayerIds ...

    // Create arrays to hold the parent and sub layer ids ...
    var arrParentLayerIDs = [];
    var arrSubLayerIDs = [];

    // Loop through all the layer infos ...
    for (var intLayerInfo = 0; intLayerInfo < objTiledOrDynamicLayer.layerInfos.length; intLayerInfo++) {

        // Get the layer info ...
        var objLayerInfo = objTiledOrDynamicLayer.layerInfos[intLayerInfo];

        // When the layer has a sub layers ...
        if (objLayerInfo.subLayerIds != null) {

            // Add to the parent layer id array ...
            arrParentLayerIDs.push(objLayerInfo.id);

            // Add to the sub layer id array ...
            arrSubLayerIDs = arrSubLayerIDs.concat(objLayerInfo.subLayerIds);
        }
    }

    // Create an array to hold the legend data ...
    var arrLegendData = [];

    // Loop through all the layer infos of the layer ...
    for (var intLayerInfo = 0; intLayerInfo < objTiledOrDynamicLayer.layerInfos.length; intLayerInfo++) {
        // Get the layer info ...
        var objLayerInfo = objTiledOrDynamicLayer.layerInfos[intLayerInfo];

        // Get the map layer id for the esri map layer id ...
        let strMapLayerID = objMapController.GetMapLayerIDForEsriLayerID(objMapService.MapServiceID, objLayerInfo.id);

        // When we managed to get the map layer ID ...
        if (strMapLayerID != null) {
            // Get the map layer ...
            let objMapLayer = objMapController.GetMapLayer(strMapLayerID);

            if (objMapLayer && objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {
                // When we did get response data from the legend service for the layer id (not a group layer) ...
                if (typeof objResponseDataByLayerId[objLayerInfo.id] != 'undefined') {

                    // Get the layer ...
                    var objLayer = objResponseDataByLayerId[objLayerInfo.id];

                    // When there is only one legend item ...
                    if (objLayer.legend.length == 1) {

                        // Create the swatch image element ...
                        var objSwatchElement = $('<img alt="""></img>');

                        // Set the legend image location ...
                        objSwatchElement.attr('src', TrimbleMap.Controller.Shared.LegendServiceSwatchImageUrl(objMapService, objLayer.layerId, objLayer.legend[0].url));

                        // Get the visible layers for the map service display ...
                        var arrVisibleLayers = objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID];

                        //
                        if (typeof arrVisibleLayers == 'undefined') {

                            var blnDefaultVisibility = objLayerInfo.defaultVisibility;

                        } else {

                            // Get the default visibility ...
                            var blnDefaultVisibility = objMapController.GetLayerVisibility(objMapServiceDisplay, objLayer.layerId, true);
                        }

                        // Add legend data for the layer ...
                        arrLegendData.push(TrimbleMap.Controller.Shared.CreateLegendDataItem(objLayer.layerName, objLayer.layerId, objSwatchElement, blnDefaultVisibility));

                    } else {

                        // Get the default visibility ...
                        var blnDefaultVisibility = objMapController.GetLayerVisibility(objMapServiceDisplay, objLayer.layerId, true);

                        // Create legend data with no swatch for the layer ...
                        var objLegendData = TrimbleMap.Controller.Shared.CreateLegendDataItem(objLayer.layerName, objLayer.layerId, null, blnDefaultVisibility);

                        // Add legend data  ...
                        arrLegendData.push(objLegendData);

                        // Loop through all the legend items ...
                        for (var intLegend = 0; intLegend < objLayer.legend.length; intLegend++) {

                            // Get the legend item ...
                            var objLegend = objLayer.legend[intLegend];

                            // Create the swatch image element ...
                            var objSwatchElement = $('<img alt="""></img>');

                            // Set the legend image location ...
                            objSwatchElement.attr('src', TrimbleMap.Controller.Shared.LegendServiceSwatchImageUrl(objMapService, objLayer.layerId, objLegend.url));

                            // Add legend data for the layer ...
                            objLegendData.SubItems.push(TrimbleMap.Controller.Shared.CreateLegendDataSubItem(objLegend.label, null, objSwatchElement, blnDefaultVisibility));
                        }
                    }

                } else {

                    // When a parent layer ...
                    //if ($.inArray(objLayerInfo.id, arrParentLayerIDs) > -1) {

                    // * Add the group layer item to the legend ...

                    // Get the default visibility ...
                    var blnDefaultVisibility = objMapController.GetLayerVisibility(objMapServiceDisplay, objLayerInfo.id, true);

                    // Create the legend data for the layer ...
                    var objLegendData = TrimbleMap.Controller.Shared.CreateLegendDataItem(objLayerInfo.name, objLayerInfo.id, null, blnDefaultVisibility);

                    // Add legend data for the layer ...
                    arrLegendData.push(objLegendData);
                    //}
                }
            }
        }
    }

    // Create a new array for all the data items to move ...
    var arrDataItemsToMove = [];

    // Create a noteh variabel to point to arrLegendData ...
    var arrTopLevelLegendData = [];

    // Loop through all the legend data items ...
    $.each(arrLegendData, function (intLegendData, objLegendData) {

        // When the layer is also a sub layer ...
        if ($.inArray(objLegendData.LayerID, arrSubLayerIDs) > -1) {

            // Add it to the array of items to move ...
            arrDataItemsToMove.push(objLegendData);

        } else {

            // Add it to the array of legend items ...
            arrTopLevelLegendData.push(objLegendData);
        }
    });

    // Only keep the top level data items on arrLegendData ...
    arrLegendData = arrTopLevelLegendData;

    // Create a function to place the sub groups ...
    var fnPlaceSubGroups = function PlaceSubGroups(arrLegendDataToPlaceIn, arrDataItemsToMove) {

        // Loop through all the legend data items again ...
        $.each(arrLegendDataToPlaceIn, function (intLegendData, objLegendData) {

            // When the legend data is for a specific layer (not a catergorized item or quantity) i.e. this layer could be a parent for another layer ...
            if ((typeof objLegendData.LayerID != 'undefined') && (objLegendData.LayerID != null)) {

                // Create an array for the remaining data items to move ...
                var arrRemainingDataItemsToMove = [];

                // Get the layer info for the parent layer ...
                var objParentLayerInfo = $.grep(objTiledOrDynamicLayer.layerInfos, function (objTestLayerInfo, intIndex) {

                    // Return true when the layer info is for the layer ...
                    return (objTestLayerInfo.id == objLegendData.LayerID);
                })[0];

                // Loop through all the data items to move ...
                $.each(arrDataItemsToMove, function (intDataItemToMove, objDataItemToMove) {

                    // When the parent layer contains the layer ... 
                    if ($.inArray(objDataItemToMove.LayerID, objParentLayerInfo.subLayerIds) > -1) {

                        // Add the data item to move to the sub layer ...
                        objLegendData.SubItems.push(objDataItemToMove);

                    } else {

                        // Add it to the remining data items to move ...
                        arrRemainingDataItemsToMove.push(objDataItemToMove);
                    }
                });

                // Replace the data items to move with the remaining data items to move ...
                arrDataItemsToMove = arrRemainingDataItemsToMove;

                // Place all the sub groups for the sub items of the layer ...
                if ((typeof objLegendData.SubItems != 'undefined') && (objLegendData.SubItems != null) && (arrDataItemsToMove.length > 0)) { fnPlaceSubGroups(objLegendData.SubItems, arrDataItemsToMove); }
            }
        });
    }

    // Place all the sub groups ...
    fnPlaceSubGroups(arrLegendData, arrDataItemsToMove);

    // Create the legend data ...
    var objLegendSectionData = TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, arrLegendData, true);

    // Return the data ...
    return objLegendSectionData;
}

// **************************************************************************
// FUNCTION: BuildWebMapServiceLegendData
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.BuildWebMapServiceLegendData = function BuildWebMapServiceLegendData(objResponseData, objMapServiceDisplay, objMapService, objWebMapServiceLayer) {

    // Get the instance ...
    var objMapController = this;

    // Create an array to hold the legend data ...
    let arrLegendData = objMapController.GetWebMapServiceLegendData(objMapServiceDisplay, objWebMapServiceLayer.layerInfos);

    // Create the legend data ...
    let objLegendSectionData = TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, arrLegendData, true);

    // Return the data ...
    return objLegendSectionData;
}

// **************************************************************************
// FUNCTION: GetWebMapServiceLegendData
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetWebMapServiceLegendData = function GetWebMapServiceLegendData(objMapServiceDisplay, arrLayerInfo) {

    // Get the instance ...
    var objMapController = this;

    // Create an array to hold the legend data ...
    let arrLegendData = [];

    // Loop through all the layer infos of the layer ...
    for (let intLayerInfo = 0; intLayerInfo < arrLayerInfo.length; intLayerInfo++) {

        // Get the layer info ...
        let objLayerInfo = arrLayerInfo[intLayerInfo];

        let strLayerID = TrimbleMap.Controller.Shared.GetWebMapServiceLayerName(objLayerInfo);

        let objMapLayer = objMapController.GetMapLayerByName(objMapServiceDisplay.MapServiceID, objLayerInfo.title);

        if (objMapLayer && objMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {
            // When there is a legend url
            if (objLayerInfo.legendURL && objLayerInfo.legendURL !== "") {

                // Create the swatch image element ...
                let objSwatchElement = $('<img alt="""></img>');

                let strArcGISProxyServiceUrl = objMapController.State.ArcGISProxyServiceUrl;
                strArcGISProxyServiceUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strArcGISProxyServiceUrl, objLayerInfo.legendURL);

                let objMapService = objMapController.GetMapService(objMapServiceDisplay.MapServiceID);
                let objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

                if (objMapServiceRestUrlWithToken.Success && objMapServiceRestUrlWithToken.Token) {
                    strArcGISProxyServiceUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strArcGISProxyServiceUrl, 'Token=' + objMapServiceRestUrlWithToken.Token);
                }

                strArcGISProxyServiceUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strArcGISProxyServiceUrl, 'MapServiceID=' + objMapServiceDisplay.MapServiceID);

                // Set the legend image location ...
                objSwatchElement.attr('src', strArcGISProxyServiceUrl);

                // Get the visible layers for the map service display ...
                let arrVisibleLayers = objMapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID];

                //Variable to hold the default visibility of the layer
                let blnDefaultVisibility;

                if (typeof arrVisibleLayers == 'undefined') {
                    blnDefaultVisibility = objLayerInfo.defaultVisibility;
                } else {
                    // Get the default visibility ...
                    blnDefaultVisibility = objMapController.GetLayerVisibility(objMapServiceDisplay, strLayerID, true);
                }

                //Create legend data for the layer
                let objLegendData = TrimbleMap.Controller.Shared.CreateLegendDataItem(objLayerInfo.title, strLayerID, objSwatchElement, blnDefaultVisibility);

                //Create sub layers legend data
                if (objLayerInfo.subLayers.length > 0) {
                    objLegendData.SubItems = objMapController.GetWebMapServiceLegendData(objMapServiceDisplay, objLayerInfo.subLayers);
                }

                //Check to see if any sub layers are visible, if so then the parent should be as well
                $.each(objLegendData.SubItems, function (intIndex, objSubItem) {
                    if (objSubItem.Visible) {
                        objLegendData.Visible = true;
                        return;
                    }
                });

                // Add legend data for the layer ...
                arrLegendData.push(objLegendData);

            } else {

                // Get the default visibility ...
                let blnDefaultVisibility = objMapController.GetLayerVisibility(objMapServiceDisplay, strLayerID, true);

                // Create legend data with no swatch for the layer ...
                let objLegendData = TrimbleMap.Controller.Shared.CreateLegendDataItem(objLayerInfo.title, strLayerID, null, blnDefaultVisibility);

                //Create sub layers legend data
                if (objLayerInfo.subLayers.length > 0) {
                    objLegendData.SubItems = objMapController.GetWebMapServiceLegendData(objMapServiceDisplay, objLayerInfo.subLayers);
                }

                // Add legend data  ...
                arrLegendData.push(objLegendData);
            }
        }
    }

    return arrLegendData;
}

// **************************************************************************
// FUNCTION: GetLegendDataForCurrentMap
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetLegendDataForCurrentMap = function GetLegendDataForCurrentMap(fnCallback) {

    // Get the instance ...
    var objMapController = this;

    // Get the current map id ...
    var strCurrentMapID = objMapController.CurrentMap.MapID;

    // Get the legend dat for the current map ....
    var arrLegendDataForCurrentMap = objMapController.LegendData[strCurrentMapID];

    // When we've not loaded the legend data yet ...
    if (typeof arrLegendDataForCurrentMap == 'undefined') {

        // When we are already busy loading the legend data for the current map ...
        if (typeof objMapController.LoadingLegendDataForMap[strCurrentMapID] != 'undefined') {

            // Create an on legend data loaded event handler ...
            var fnOnLegendDataLoaded = function (objMap, arrLegendDataForMap) {
                
                // When for the current map ...
                if (objMap.MapID == strCurrentMapID) {

                    // Remove the event handler again ...
                    objMapController.RemoveOnLegendDataLoaded(fnOnLegendDataLoaded);

                    // Call the callback function with the legend data ...
                    fnCallback(arrLegendDataForMap);
                }
            };

            // Add an on legend data loaded event handler ...
            objMapController.AddOnLegendDataLoaded(fnOnLegendDataLoaded);

        } else {

            // Set to be loading the legend data for the current map ...
            objMapController.LoadingLegendDataForMap[strCurrentMapID] = true;

            // Create an array for the deferreds for each legend section's data ...
            var arrDeferreds = [];

            // Loop through all the map service displays in the current map ...
            objMapController.ForEachMapServiceDisplayInCurrentMap(function (objMapServiceDisplay, objMapService) {

                // Create a new deferred for the map service display's legend data ...
                var objDeferred = new dojo.Deferred();

                // Add it to the array of deferreds ...
                arrDeferreds.push(objDeferred);

                //Array to hold the esri layers
                let arrEsriLayers;

                // Deal with different map service types separately ...
                switch (objMapService.MapServiceType) {
                    case TrimbleMap.Controller.enumMapServiceType.Tile:

                        // Create the legend data (we do not load legend data for tile services at the moment) ...
                        var objLegendSectionData = TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, [], false);

                        // Resolve the deferred with the result ...
                        objDeferred.resolve(objLegendSectionData);
                        break;

                    case TrimbleMap.Controller.enumMapServiceType.Dynamic:

                        // Get the esri layers created for the map service display ...
                        arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

                        // When any of the layers were loaded successfully ...
                        if (arrEsriLayers.length > 0) {

                            // Get the esri layer created for the map service display ...
                            var objTiledOrDynamicLayer = arrEsriLayers[0];

                            // Build the legend service url for the map service ...
                            var strLegendServiceUrl = objMapController.BuildLegendServiceUrl(objMapService);

                            if (strLegendServiceUrl.length > 0) {
                                // Call the web service to get all the translations for the js file ...
                                $.ajax({
                                    url: strLegendServiceUrl,
                                    dataType: 'json',
                                    context: {},
                                    async: true,
                                    cache: false,
                                    complete: function (jqXHR, textStatus) {

                                        // When returned OK ...
                                        if (jqXHR.status != 0) {
                                            let objResponseData;
                                            let blnDeserialized = false;

                                            try {
                                                // Parse the json response ...
                                                objResponseData = JSON.parse(jqXHR.responseText);
                                                blnDeserialized = true;
                                            } catch (e) {

                                            }

                                            // When we did get a response from the legend service ...
                                            if (blnDeserialized && typeof objResponseData.error == 'undefined') {

                                                // Build the legend section data from the response from the server ...
                                                var objLegendSectionData = objMapController.BuildDynamicMapServiceLegendData(objResponseData, objMapServiceDisplay, objMapService, objTiledOrDynamicLayer);

                                                // Resolve the deferred with the result ...
                                                objDeferred.resolve(objLegendSectionData);

                                            } else {

                                                // Get the title and message translations ...

                                                // Unable to load legend data
                                                var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataTitle');

                                                // Unable to load legend data for map service %1.
                                                var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataMessage', objMapService.MapServiceName);

                                                // Unable to load legend data
                                                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataEndUserMessage');

                                                // Error: 
                                                var strError = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataError');

                                                if (blnDeserialized) {
                                                    // Start with no error items added ...
                                                    var intErrorItem = 0;

                                                    // Loop through all the properties on the error object ... 
                                                    $.each(objResponseData.error, function (strKey, strValue) {

                                                        // When not the first add a ; ...
                                                        if (intErrorItem++ > 0) { strError += '; '; }

                                                        // Add the key and value ...
                                                        strError += strKey + ': ' + strValue;
                                                    });

                                                    // Attempt to convert the error object to a string when we have no properties ...
                                                    if (intErrorItem == 0) { strError += objResponseData.error.toString(); }
                                                }

                                                // Log the diagnostic message ...
                                                objMapController.LogDiagnosticMessage(strTitle, strMessage, strError, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, strLegendServiceUrl);

                                                // Resolve the deferred with no result ...
                                                objDeferred.resolve(TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, null, false));
                                            }

                                        } else {

                                            // Get the title and message translations ...

                                            // Unable to load legend data
                                            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataTitle');

                                            // Unable to load legend data for map service %1.
                                            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataMessage', objMapService.MapServiceName);

                                            // Unable to load legend data
                                            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataEndUserMessage');

                                            // Log the diagnostic message ...
                                            objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, strLegendServiceUrl);

                                            // Resolve the deferred with no result ...
                                            objDeferred.resolve(TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, null, false));
                                        }
                                    }
                                });
                            }
                        } else {

                            // Get the title and message translations ...

                            // Unable to load legend data
                            var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataTitle');

                            // Unable to load legend data for map service %1.
                            var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataMessage', objMapService.MapServiceName);

                            // Unable to load legend data
                            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataEndUserMessage');

                            // Log the diagnostic message ...
                            objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, strLegendServiceUrl);

                            // Resolve the deferred with no result ...
                            objDeferred.resolve(TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, null, false));
                        }
                        break;

                    case TrimbleMap.Controller.enumMapServiceType.WebMapService:

                        // Get the esri layers created for the map service display ...
                        arrEsriLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

                        // When any of the layers were loaded successfully ...
                        if (arrEsriLayers.length > 0) {

                            // Get the esri layer created for the map service display ...
                            let objWebMapServiceLayer = arrEsriLayers[0];

                            if (!objWebMapServiceLayer.loadError) {
                                // Build the legend section data from the response from the server ...
                                let objLegendSectionData = objMapController.BuildWebMapServiceLegendData('', objMapServiceDisplay, objMapService, objWebMapServiceLayer);

                                // Resolve the deferred with the result ...
                                objDeferred.resolve(objLegendSectionData);
                            } else {
                                // Get the title and message translations ...

                                // Unable to load legend data
                                let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataTitle');

                                // Unable to load legend data for map service %1.
                                let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataMessage', objMapService.MapServiceName);

                                // Unable to load legend data
                                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataEndUserMessage');

                                // Log the diagnostic message ...
                                objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, '');

                                // Resolve the deferred with no result ...
                                objDeferred.resolve(TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, null, false));
                            }

                        } else {

                            // Get the title and message translations ...

                            // Unable to load legend data
                            let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataTitle');

                            // Unable to load legend data for map service %1.
                            let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataMessage', objMapService.MapServiceName);

                            // Unable to load legend data
                            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'UnableToLoadLegendDataEndUserMessage');

                            // Log the diagnostic message ...
                            objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.INFORMATION, '');

                            // Resolve the deferred with no result ...
                            objDeferred.resolve(TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, null, false));
                        }

                        break;

                    case TrimbleMap.Controller.enumMapServiceType.Feature:

                        // Create an array to hold the legend data ...
                        var arrLegendData = [];

                        // Get the feature layers created for the map service display ...
                        var arrFeatureLayers = objMapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);

                        // When we have any feature layers ...
                        if (arrFeatureLayers.length > 0) {

                            // Loop through all the feature layers ...
                            for (var intFeatureLayer = arrFeatureLayers.length - 1; intFeatureLayer >= 0; intFeatureLayer--) {

                                // Get the feature layer ...
                                var objFeatureLayer = arrFeatureLayers[intFeatureLayer];

                                // When the feature layer has a single symbol ...
                                if ((typeof objFeatureLayer.renderer != 'undefined') && (objFeatureLayer.renderer != null) &&
                                    (typeof objFeatureLayer.renderer.symbol != 'undefined') && (typeof objFeatureLayer.renderer.symbol != null)) {

                                    // Create the swatch element for the layer ...
                                    var objSwatchElement = TrimbleMap.Legend.Shared.CreateFeatureLayerLegendSwatch(objFeatureLayer, objFeatureLayer.renderer.symbol);

                                    // Get the map layer by name ...
                                    let objFeatureMapLayer = objMapController.GetMapLayerByName(objMapService.MapServiceID, objFeatureLayer.name);
                                    let blnDefaultVisibility = false;

                                    if (objFeatureMapLayer.Visibility !== TrimbleMap.Controller.enumMapLayerVisibility.Hidden) {
                                        // Get the default visibility ...
                                        blnDefaultVisibility = objMapController.GetLayerVisibility(objMapServiceDisplay, objFeatureLayer.LayerID, true);

                                        // Add legend data for the layer ...
                                        arrLegendData.push(TrimbleMap.Controller.Shared.CreateLegendDataItem(objFeatureLayer.name, objFeatureLayer.LayerID, objSwatchElement, blnDefaultVisibility));
                                    }

                                } else {

                                    // Get the default visibility ...
                                    var blnDefaultVisibility = objMapController.GetLayerVisibility(objMapServiceDisplay, objFeatureLayer.LayerID, true);

                                    // Create legend data for the layer with no swatch ...
                                    var objLegendData = TrimbleMap.Controller.Shared.CreateLegendDataItem(objFeatureLayer.name, objFeatureLayer.LayerID, null, blnDefaultVisibility);

                                    // Add legend data for the layer ...
                                    arrLegendData.push(objLegendData);

                                    // When we have breakdown information ...
                                    if ((typeof objFeatureLayer.renderer != 'undefined') && (objFeatureLayer.renderer != null) &&
                                        (typeof objFeatureLayer.renderer.infos != 'undefined') && (objFeatureLayer.renderer.infos != null)) {

                                        // Loop through all the infos ...
                                        for (var intInfo = 0; intInfo < objFeatureLayer.renderer.infos.length; intInfo++) {

                                            // Get the info ...
                                            var objInfo = objFeatureLayer.renderer.infos[intInfo];

                                            // Create the swatch element for the layer ...
                                            var objSwatchElement = TrimbleMap.Legend.Shared.CreateFeatureLayerLegendSwatch(objFeatureLayer, objInfo.symbol);

                                            // Create a new sub item and add to the legend data object ...
                                            objLegendData.SubItems.push(TrimbleMap.Controller.Shared.CreateLegendDataSubItem(objInfo.label, null, objSwatchElement, blnDefaultVisibility));
                                        }
                                    }
                                }
                            }

                            // Create the legend data ...
                            var objLegendSectionData = TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, arrLegendData, true);

                            // Resolve the deferred with the result ...
                            objDeferred.resolve(objLegendSectionData);

                        } else {

                            // Resolve the deferred with no result ...
                            objDeferred.resolve(TrimbleMap.Controller.Shared.CreateLegendSectionData(objMapServiceDisplay, objMapService, null, false));
                        }
                        break;
                }
            });

            // When all the selection layers are done loading (or failed) ....
            new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function (arrLegendSectionData) {

                // Add it to the cahce ...
                objMapController.LegendData[strCurrentMapID] = arrLegendSectionData;

                // Call the callback passing the data ...
                fnCallback(arrLegendSectionData);

                // Trigger the on loaded callbacks for the current map ...
                objMapController.TriggerOnLegendDataLoaded(objMapController.CurrentMap);
            }));
        }

    } else {

        // Call the callback passing the data ...
        fnCallback(arrLegendDataForCurrentMap);
    }
}

// **************************************************************************
// FUNCTION: GetDummyMapForExtentDetermination
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetDummyMapForExtentDetermination = function GetDummyMapForExtentDetermination() {

    // Get the instance ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we do not have a dummy map for extent determination yet ...
    if (objMapController.DummyMapForExtentDetermination == null) {

        // Setup the map options for the dummy map ...
        var objMapOptions = {
            slider: false,
            logo: false,
            optimizePanAnimation: true
        };

        // Get the levels of detail of the map ...
        var arrLODs = objMapController.GetLODs(objMapController.CurrentMap);

        // Set the LODs when we have LODs ...
        if (arrLODs != null) { objMapOptions.lods = arrLODs; }

        // Get map element's width and height ...
        var intMapWidthPx = objMapController.MapElement.outerWidth();
        var intMapHeightPx = objMapController.MapElement.outerHeight();

        // When we do not have a dummy map element for extent determination yet ...
        if (objMapController.DummyMapElementForExtentDetermination == null) {

            // Create a new div element to create the dummy map in ...
            objMapController.DummyMapElementForExtentDetermination = $('<div id="dummnyTest" style="position:fixed;inset-block-start:0px;inset-inline-start:0px;z-index:-10000;opacity:0;pointer-events:none;"></div>');

            // Set the width and heigth the same as the map element ...
            objMapController.DummyMapElementForExtentDetermination.css('width', intMapWidthPx);
            objMapController.DummyMapElementForExtentDetermination.css('height', intMapHeightPx);

            // Add the map div to the page body ...
            $('body').append(objMapController.DummyMapElementForExtentDetermination);
        }

        // Create a new map object from the element in which to create it and the options ...
        objMapController.DummyMapForExtentDetermination = new esri.Map(objMapController.DummyMapElementForExtentDetermination.get(0), objMapOptions);

        // Attach an onload event handler to the map (thios will fire as soon as the graphics layer is added) ...
        objMapController.DummyMapForExtentDetermination.on('load', function () {

            // Resolve the deferred with the map ...
            objDeferred.resolve(objMapController.DummyMapForExtentDetermination);
        });

        // Create a new grahics layer ...
        var objGraphicsLayer = new esri.layers.GraphicsLayer();

        // Set the spatial reference ...
        objGraphicsLayer.spatialReference = objMapController.CreateEsriSpatialReference(objMapController.CurrentMap.SpatialReferenceID);

        // Add the layer to the map ...
        objMapController.DummyMapForExtentDetermination.addLayer(objGraphicsLayer);

    } else {

        // Resolve the deferred with the map ...
        objDeferred.resolve(objMapController.DummyMapForExtentDetermination);
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION DetermineResultantExtent
// 
// **************************************************************************
TrimbleMap.Controller.DetermineResultantExtent = function DetermineResultantExtent(objExtent) {

    // Get the instance ...
    var objMapController = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Get the dummy map for extent determination ...
    objMapController.GetDummyMapForExtentDetermination().then(TrimbleMap.Controller.Shared.TrapException(function (objDummyMap) {

        // Set the zoom duration and rate to 0 in order to set the extent to as quickly as possible ...
        esri.config.defaults.map.zoomDuration = 0;
        esri.config.defaults.map.zoomRate = 0;

        // Set the extnet of the dummy map ...
        objDummyMap.setExtent(objExtent).then(function () {

            // Reset the zoom duration and rate to in order to pan and zoom normally in the map ...
            esri.config.defaults.map.zoomDuration = 500;
            esri.config.defaults.map.zoomRate = 25;

            // Resolve the deferred with the extent of the dummy map ...
            objDeferred.resolve(objDummyMap.extent);
        });
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION EsriRequestPreCallbackHandler
// 
// **************************************************************************
TrimbleMap.Controller.EsriRequestPreCallbackHandler = function EsriRequestPreCallbackHandler(objIOArgs) {

    // Get the instance ...
    var objMapController = this;

    //Intercept Print Calls
    if (objIOArgs.content && objIOArgs.content.Web_Map_as_JSON) {
        // Get print payload
        let objWebMap = JSON.parse(objIOArgs.content.Web_Map_as_JSON);

        //Loop through all layers
        for (var intIndex = 0; intIndex < objWebMap.layoutOptions.legendOptions.operationalLayers.length; intIndex++) {
            let objOperationalLayer = objWebMap.layoutOptions.legendOptions.operationalLayers[intIndex];

            //If layer is a graphics layer, set the id to nothing so that it does not display in the legend as "Override 1"
            //There is a bug (https://support.esri.com/en/bugs/nimbus/QlVHLTAwMDExNDA2Mg==) in the esri javascript api that sets graphics layers to "Override 1"
            //which has been fixed but only in a later version of the api (4.14)
            if (objOperationalLayer.id.indexOf("graphicsLayer") == 0) {
                objOperationalLayer.id = "";
            }
        }

        //Set print payload to updated payload
        objIOArgs.content.Web_Map_as_JSON = JSON.stringify(objWebMap);
    }

    // Set the last esri request io args ...
    objMapController.LastEsriRequestIOArgs = objIOArgs;

    // Set the first esri request io args if not set ...
    if (objMapController.FirstEsriRequestIOArgsSinceReset == null) { objMapController.FirstEsriRequestIOArgsSinceReset = objIOArgs; }

    return objIOArgs;
}

// **************************************************************************
// FUNCTION ResetFirstEsriRequestIOArgs
// 
// **************************************************************************
TrimbleMap.Controller.ResetFirstEsriRequestIOArgs = function ResetFirstEsriRequestIOArgs() {

    // Get the instance ...
    var objMapController = this;

    // Reset FirstEsriRequestIOArgsSinceReset ...
    objMapController.FirstEsriRequestIOArgsSinceReset = null;
}

// **************************************************************************
// FUNCTION: LogDiagnosticMessage
// USAGE:    enMessageLevel id optional, defaults to Map.enumDiagnosticMessageLevel.CRITICAL
// **************************************************************************
TrimbleMap.Controller.LogDiagnosticMessage = function LogDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, enMessageLevel, strRequestUrl) {

    // Get the instance ...
    var objMapController = this;

    // Default enMessageLevel to CRITICAL when not specified ...
    if ((typeof enMessageLevel == 'undefined') || (enMessageLevel == null)) { enMessageLevel = TrimbleMap.enumDiagnosticMessageLevel.CRITICAL; }

    // Create a diagnostic message ...
    var objDiagnosticMessage = TrimbleMap.Controller.Shared.CreateDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, enMessageLevel, strRequestUrl);

    // Add it to the list of diagnostic messages ...
    objMapController.DiagnosticMessages.push(objDiagnosticMessage);

    // Trigger the callbacks ...
    objMapController.TriggerNotifyDiagnosticMessageLogged(objDiagnosticMessage);
}

// **************************************************************************
// FUNCTION: GetDiagnosticMessageByID
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetDiagnosticMessageByID = function GetDiagnosticMessageByID(strDiagnosticMessageID) {

    // Get the instance ...
    var objMapController = this;

    // Start with not found ...
    var objDiagnosticMessage = null;

    // Loop through all the diagnostic messages ...
    $.each(objMapController.DiagnosticMessages, function (intTestDiagnosticMessage, objTestDiagnosticMessage) {

        // When the IDs match ...
        if (objTestDiagnosticMessage.DiagnosticMessageID == strDiagnosticMessageID) {

            // Set the message to return ...
            objDiagnosticMessage = objTestDiagnosticMessage;

            // Stop checking ...
            return false;
        }
    });

    return objDiagnosticMessage;
}

// **************************************************************************
// FUNCTION: AddNotifyDiagnosticMessageLogged
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.AddNotifyDiagnosticMessageLogged = function AddNotifyDiagnosticMessageLogged(fnNotifyDiagnosticMessageLogged) {

    // Get the instance ...
    var objMapController = this;

    // Add it to the array of callback functions ...
    objMapController.NotifyDiagnosticMessageLoggedFunctions.push(fnNotifyDiagnosticMessageLogged);
}

// **************************************************************************
// FUNCTION: TriggerNotifyDiagnosticMessageLogged
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.TriggerNotifyDiagnosticMessageLogged = function TriggerNotifyDiagnosticMessageLogged(objDiagnosticMessage) {

    // Get the instance ...
    var objMapController = this;

    // Loop through all the callback functions ...
    $.each(objMapController.NotifyDiagnosticMessageLoggedFunctions, function (intNotifyDiagnosticMessageLogged, fnNotifyDiagnosticMessageLogged) {

        // Call the callback ...
        fnNotifyDiagnosticMessageLogged(objDiagnosticMessage);
    });
}

// **************************************************************************
// FUNCTION: TriggerNotifyDiagnosticMessageLoggedForAllDiagnosticMessages
// USAGE:    Trigger NotifyDiagnosticMessageLogged for each messages in DiagnosticMessages ...
// **************************************************************************
TrimbleMap.Controller.TriggerNotifyDiagnosticMessageLoggedForAllDiagnosticMessages = function TriggerNotifyDiagnosticMessageLoggedForAllDiagnosticMessages() {

    // Get the instance ...
    var objMapController = this;

    // Loop through all the diagnistic messages ...
    $.each(objMapController.DiagnosticMessages, function (intDiagnosticMessage, objDiagnosticMessage) {

        // Trigger the callbacks ...
        objMapController.TriggerNotifyDiagnosticMessageLogged(objDiagnosticMessage);
    });
}

// **************************************************************************
// FUNCTION: AddNotifyModuleVisibilityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.AddNotifyModuleVisibilityChanged = function AddNotifyModuleVisibilityChanged(fnNotifyModuleVisiblityChanged) {

    // Get the instance ...
    var objMapController = this;

    // Add it to the array of callback functions ...
    objMapController.NotifyModuleVisiblityChangedFunctions.push(fnNotifyModuleVisiblityChanged);
}

// **************************************************************************
// FUNCTION: TriggerNotifyModuleVisibilityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.TriggerNotifyModuleVisibilityChanged = function TriggerNotifyModuleVisibilityChanged(enModule, blnVisible) {

    // Get the instance ...
    var objMapController = this;

    // Loop through all the callback functions ...
    $.each(objMapController.NotifyModuleVisiblityChangedFunctions, function (intNotifyModuleVisiblityChanged, fnNotifyModuleVisiblityChanged) {

        // Call the callback ...
        fnNotifyModuleVisiblityChanged(enModule, blnVisible);
    });
}

// **************************************************************************
// FUNCTION: AddNotifyPreferenceChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.AddNotifyPreferenceChanged = function AddNotifyPreferenceChanged(fnNotifyPreferenceChanged) {

    // Get the instance ...
    var objMapController = this;

    // Add it to the array of callback functions ...
    objMapController.NotifyPreferenceChangedFunctions.push(fnNotifyPreferenceChanged);
}

// **************************************************************************
// FUNCTION: TriggerNotifyPreferenceChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.TriggerNotifyPreferenceChanged = function TriggerNotifyPreferenceChanged(arrPreferencesThatChanged) {

    // Get the instance ...
    var objMapController = this;

    // Loop through all the callback functions ...
    $.each(objMapController.NotifyPreferenceChangedFunctions, function (intNotifyModuleVisiblityChanged, fnNotifyModuleVisiblityChanged) {

        // Call the callback ...
        fnNotifyModuleVisiblityChanged(arrPreferencesThatChanged);
    });
}

// **************************************************************************
// FUNCTION: BuildLegendServiceUrl
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.BuildLegendServiceUrl = function BuildLegendServiceUrl(objMapService) {

    // Get the instance ...
    var objMapController = this;
    var strLegendServiceUrl = '';

    var objMapServiceRestUrlWithToken = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

    if (objMapServiceRestUrlWithToken.Success) {
        // Build the legend rest url from the map service rest url with token ...
        strLegendServiceUrl = TrimbleMap.Controller.Shared.ModifyUrl(objMapServiceRestUrlWithToken.RestUrlWithToken, function (objUrlParts) {
            objUrlParts.Url = TrimbleMap.Controller.Shared.EnsureCharacterAtEndOfString(objUrlParts.Url, '/') + 'legend';
        });

        // Add f=json ...
        strLegendServiceUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strLegendServiceUrl, 'f=json');

        // Add pretty=true ...
        strLegendServiceUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strLegendServiceUrl, 'pretty=true');

        // When cors is not supported ...
        if (!$.support.cors) {

            // Set to rather get the legend infomation through our cors proxy ...
            strLegendServiceUrl = objMapController.State.CorsProxyServiceUrl + "?URL=" + encodeURIComponent(strLegendServiceUrl);
        }
    }
    else {
        // Get the title and message translations ...

        // Map service token expired
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredTitle');

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredMessage', objMapService.MapServiceName);

        //The authentication token associated with map service '%1' has expired. Map layers from this service cannot be displayed or searched at this time.
        var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'MapServiceTokenExpiredEndUserMessage', objMapService.MapServiceName);

        // Log a diagnostic info message ...
        objMapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

    }
    return strLegendServiceUrl;
}

// **************************************************************************
// FUNCTION: BufferShape
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.BufferShape = function BufferShape(objGeometry, decBufferDistance, objBufferDistanceUnit) {
    // Get the instance ...
    let objMapController = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    // Configure the buffer parameters ...
    let objBufferParameters = new esri.tasks.BufferParameters();

    // Set the geometries to be buffered ...
    objBufferParameters.geometries = [objGeometry];

    // Convert the distance to kilometers
    let decDistance = decBufferDistance * objBufferDistanceUnit.ConversionFactorToKm;

    // Set the buffer distances ...
    objBufferParameters.distances = [decDistance];

    // Set the unit to kilometers ...
    objBufferParameters.unit = esri.tasks.GeometryService.UNIT_KILOMETER;

    // Set the units not to be in geodesic coordinates ...
    objBufferParameters.geodesic = false;

    // Set the out and buffer spatial references to be the spatial reference of the input geometry ...
    objBufferParameters.outSpatialReference = objGeometry.spatialReference;

    // Get the spatial reference of the current map ...
    let objSpatialReferenceInformation = objMapController.GetSpatialReference(objMapController.CurrentMap.SpatialReferenceID);

    // Get the well know text of the utm zone in which the first coordinate falls ...
    let strProjectedBufferWKT = (objSpatialReferenceInformation.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) ? objSpatialReferenceInformation.WKTDefinition : TrimbleMap.UTM.GetUTMCoordinateSystem(objGeometry).wkt;

    // Set the utm zone to be the spatial reference in which to perform the buffer operation ...
    objBufferParameters.bufferSpatialReference = new esri.SpatialReference(strProjectedBufferWKT);

    // Buffer the geometry
    objMapController.GeometryService.buffer(objBufferParameters, function (arrBufferedGeometries) {
        // return the buffered geometries
        objDeferred.resolve(arrBufferedGeometries);
    }, function (objError) {
        // Return error buffering shape
        objDeferred.reject(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ErrorBufferingShape'));
    });

    // Return deferred object
    return objDeferred;
}

// **************************************************************************
// FUNCTION: GeneralizeShape
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GeneralizeShape = function GeneralizeShape(objGeometry, objSpatialReference) {

    // Get the instance ...
    let objMapController = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    if (objSpatialReference != null) {

        // Wrap in a try catch block ...
        try {

            //Determine whether the spatial reference is GEOGRAPHIC or PROJECTED
            if (objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC) {

                //Geographic
                objDeferred = objMapController.GeneralizeGeographicShape(objGeometry, objSpatialReference);

            } else if (objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) {

                //Projected
                objDeferred = objMapController.GeneralizeProjectedShape(objGeometry);
            }

        } catch (objError) {

            // Throw the exception ...
            TrimbleMap.Controller.Shared.ForceThrowException(objError);
        }
    }

    // Return deferred object
    return objDeferred;
}

// **************************************************************************
// FUNCTION: GeneraliseGeographicShape
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GeneralizeGeographicShape = function GeneralizeGeographicShape(objGeometry, objSpatialReference) {
    // Get the instance ...
    let objMapController = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    // Configure the generalize parameters
    let objGeneralizeParameters = new esri.tasks.GeneralizeParameters();

    // Create an array with the geometry in it when not null ...
    var arrGeometries = [];
    if (objGeometry) { arrGeometries.push(objGeometry); }

    // Get the utm zone in which to calculate the area ...
    var objUTMCoordinateSystem = TrimbleMap.UTM.GetUTMCoordinateSystem(objGeometry);

    // Get the 'From' and 'To' spatial references ...
    var objFromSpatialReference = new esri.SpatialReference(objSpatialReference.WKID);
    var objToSpatialReference = new esri.SpatialReference(objUTMCoordinateSystem.wkt);

    // Project the geometry to the appropriate utm zone...
    objMapController.ProjectGeometriesByPoints(arrGeometries, objFromSpatialReference, objToSpatialReference, objSpatialReference, null, null, null).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

        // Set the geometries to be generalized
        objGeneralizeParameters.geometries = arrProjectedGeometries;

        // Set the max deviation
        objGeneralizeParameters.maxDeviation = objMapController.State.DensifySettings.MaximumDeviationDegrees;

        // Generalise the geometry
        objMapController.GeometryService.generalize(objGeneralizeParameters, function (arrDensifiedGeometries) {

            //Reproject the geometry back to the original spatial reference
            objMapController.ProjectGeometriesByPoints(arrDensifiedGeometries, objToSpatialReference, objFromSpatialReference, objSpatialReference, null, null, null).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

                // return the densified geometries
                objDeferred.resolve(arrProjectedGeometries);

            }, function (objError) {
                // Return error generalising shape
                objDeferred.reject(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ErrorDensifyingShape'));
            }));

        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

            // Return an error ...
            objDeferred.reject(objError);
        })
    }));

    // Return deferred object
    return objDeferred;
}

// **************************************************************************
// FUNCTION: GeneralizeProjectedShape
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GeneralizeProjectedShape = function GeneralizeProjectedShape(objGeometry) {
    // Get the instance ...
    let objMapController = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    // Configure the generalize parameters
    let objGeneralizeParameters = new esri.tasks.GeneralizeParameters();

    // Set the geometries to be generalized
    objGeneralizeParameters.geometries = [objGeometry];

    // Set the max deviation
    objGeneralizeParameters.maxDeviation = objMapController.State.DensifySettings.MaximumDeviationDegrees;

    // Generalise the geometry
    objMapController.GeometryService.generalize(objGeneralizeParameters, function (arrDensifiedGeometries) {
        // return the densified geometries
        objDeferred.resolve(arrDensifiedGeometries);
    }, function (objError) {
        // Return error generalising shape
        objDeferred.reject(SD.Translation.Shared.GetTranslation('Map.ConstructShapeFromCentroid.js', 'ErrorDensifyingShape'));
    });

    // Return deferred object
    return objDeferred;
}

// **************************************************************************
// FUNCTION: CreateSquareFromPoint
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.CreateSquareFromPoint = function CreateSquareFromPoint(objGeometry, decDistanceFromPoint, objDistanceUnit) {

    let objMapController = this;

    let objDeferred = new dojo.Deferred();

    if (objGeometry.type == 'point') {

        // Convert the distance and coordinates to standard units (meters)
        var decSpatialReferenceLinearUnitConversionFactorToMeters = esri.geometry.getUnitValueForSR(objGeometry.spatialReference);

        var objGeometryCoordinatesInMeters = {
            x: Number.parseFloat(objGeometry.x.toFixed(2)) * decSpatialReferenceLinearUnitConversionFactorToMeters,
            y: Number.parseFloat(objGeometry.y.toFixed(2)) * decSpatialReferenceLinearUnitConversionFactorToMeters
        };

        var decDistanceFromPointInMeters = Number.parseFloat(decDistanceFromPoint / 2) * objDistanceUnit.ConversionFactorToKm * 1000;

        // Create points for the square
        var arrPoints = [];
        arrPoints.push([(objGeometryCoordinatesInMeters.x + decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters, (objGeometryCoordinatesInMeters.y + decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters]);
        arrPoints.push([(objGeometryCoordinatesInMeters.x + decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters, (objGeometryCoordinatesInMeters.y - decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters]);
        arrPoints.push([(objGeometryCoordinatesInMeters.x - decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters, (objGeometryCoordinatesInMeters.y - decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters]);
        arrPoints.push([(objGeometryCoordinatesInMeters.x - decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters, (objGeometryCoordinatesInMeters.y + decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters]);
        arrPoints.push([(objGeometryCoordinatesInMeters.x + decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters, (objGeometryCoordinatesInMeters.y + decDistanceFromPointInMeters) / decSpatialReferenceLinearUnitConversionFactorToMeters]);

        // Create a geometry object from the points
        var objPolygon = new esri.geometry.Polygon(objGeometry.spatialReference);
        objPolygon.addRing(arrPoints);

        objDeferred.resolve(objPolygon);
    }
    else {
        // Invalid geometry type
        objDeferred.reject();
    }
    // Return deferred object
    return objDeferred;
}

// **************************************************************************
// FUNCTION: CreateFormData
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.CreateFormData = function CreateFormData(objParameters) {

    // Create a formdata object ...
    var objParametersFormData = $('<form></form>');

    // Loop through all the parameters ...
    $.each(objParameters, function (strParameterName, objParameterValue) {

        // Serialize the value to json when not already a string ... 
        var strValueJson = (typeof objParameterValue == 'string') ? objParameterValue : JSON.stringify(objParameterValue);

        // Create the input element with the name ...
        var objInput = $('<input type="text" name="' + strParameterName + '"></input>');

        // Set the value ...
        objInput.val(strValueJson);

        // Add the input element ...
        objParametersFormData.append(objInput);
    });

    return objParametersFormData;
}

// **************************************************************************
// FUNCTION: FlattenGeometriesToPointArray
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.FlattenGeometriesToPointArray = function FlattenGeometriesToPointArray(arrGeometries, objEsriSpatialReference) {

    // Create a point array to return ...
    var arrPoints = [];

    // Loop through all the geometries ...
    $.each(arrGeometries, function (intGeometry, objGeometry) {

        // Based on the geometry type ...
        switch (objGeometry.type) {
            case 'point':

                // Add the point to the point array ...
                arrPoints.push({ x: objGeometry.x, y: objGeometry.y });
                break;

            case 'polyline':

                // Loop through all the paths of the polyline ...
                $.each(objGeometry.paths, function (intPath, arrPathPoints) {

                    // Loop through all the points of the path ...
                    $.each(arrPathPoints, function (intPathPoint, objPathPoint) {

                        // Create a point and add it to the point array ...
                        arrPoints.push({ x: objPathPoint[0], y: objPathPoint[1] });
                    });
                });
                break;

            case 'polygon':

                // Loop through all the rings of the polygon ...
                $.each(objGeometry.rings, function (intRing, arrRingPoints) {

                    // Loop through all the points of the ring ...
                    $.each(arrRingPoints, function (intRingPoint, objRingPoint) {

                        // Create a point and add it to the point array ...
                        arrPoints.push({ x: objRingPoint[0], y: objRingPoint[1] });
                    });
                });
                break;

            case 'extent':

                // Add the top left and bottom right points to the array ...
                arrPoints.push({ x: objGeometry.xmin, y: objGeometry.ymax });
                arrPoints.push({ x: objGeometry.xmax, y: objGeometry.ymin });
                break;
        }
    });

    // Return the array of points ...
    return arrPoints;
}

// **************************************************************************
// FUNCTION: CreateGeometriesFromFlattenedPointArray
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.CreateGeometriesFromFlattenedPointArray = function CreateGeometriesFromFlattenedPointArray(arrPoints, arrGeometries, objEsriSpatialReference) {

    // Create a geometry array to return ...
    var arrCreatedGeometries = [];

    // Start at the first point ...
    var intPoint = 0;

    // Loop through all the geometries ...
    $.each(arrGeometries, function (intGeometry, objGeometry) {

        // Based on the geometry type ...
        switch (objGeometry.type) {
            case 'point':

                // Get the point ...
                var objPoint = arrPoints[intPoint];

                // Add the point to the point array as an esri point ...
                arrCreatedGeometries.push(new esri.geometry.Point(objPoint.x, objPoint.y, objEsriSpatialReference));
                break;

            case 'polyline':

                // Create an esri polyline ...
                var objEsriPolyline = new esri.geometry.Polyline(objEsriSpatialReference);

                // Add the polyline to the return array of geometries ...
                arrCreatedGeometries.push(objEsriPolyline);


                // Loop through all the paths of the polyline ...
                $.each(objGeometry.paths, function (intPath, arrPathPoints) {

                    // Create a new array for the path's points ...
                    var arrNewPathPoints = [];

                    // Loop through all the points of the path ...
                    $.each(arrPathPoints, function (intPathPointToUpdate, objPathPointToUpdate) {

                        // Get the point for arrPoints ...
                        var objPathPoint = arrPoints[intPoint++];

                        // Create an array for the point and add the x and y values ...
                        arrNewPathPoints.push([objPathPoint.x, objPathPoint.y]);
                    });

                    // Add the path to the polyline ...
                    objEsriPolyline.addPath(arrNewPathPoints);
                });
                break;

            case 'polygon':

                // Create an esri polygon ...
                var objEsriPolygon = new esri.geometry.Polygon(objEsriSpatialReference);

                // Add the polygon to the return array of geometries ...
                arrCreatedGeometries.push(objEsriPolygon);

                // Loop through all the rings of the polygon ...
                $.each(objGeometry.rings, function (intRing, arrRingPoints) {

                    // Create a new array for the ring's points ...
                    var arrNewRingPoints = [];

                    // Loop through all the ring's points ...
                    for (var intRingPoint = 0; intRingPoint < arrRingPoints.length; intRingPoint++) {

                        // Get the point for arrPoints ...
                        var objRingPoint = arrPoints[intPoint++];

                        // Create an array for the point and add the x and y values ...
                        arrNewRingPoints.push([objRingPoint.x, objRingPoint.y]);
                    }

                    // Ad the ring to the polygon ...
                    objEsriPolygon.addRing(arrNewRingPoints);
                });
                break;

            case 'extent':

                // Get the top left and bottom right points ...
                var objTopLeftCorner = arrPoints[0];
                var objBottomRightCorner = arrPoints[1];

                // Create the extent ...
                var objEsriExtent = new esri.geometry.Extent(objTopLeftCorner.x, objBottomRightCorner.y, objBottomRightCorner.x, objTopLeftCorner.y, objEsriSpatialReference);

                // Add the extent to the return array of geometries ...
                arrCreatedGeometries.push(objEsriExtent);
                break;
        }
    });

    // Return the array of geometries ...
    return arrCreatedGeometries;
}

// **************************************************************************
// FUNCTION: ForEachXYPointInGeometry
// USAGE:    fnCallback({x: z, y: y}, fnUpdatePoint(decNewX, decNewY))
//           fnCallback will be called for every point in the geometry
//           - The first argument supplied to the callback function will
//             be an object with the x and y as properties
//           - The second argument will be a function that you can call 
//             to update the values of the point which take in 
//             decNewX, decNewY as arguments ...
// **************************************************************************
TrimbleMap.Controller.Shared.ForEachXYPointInGeometry = function ForEachXYPointInGeometry(objGeometry, fnCallback) {

    // Based on the geometry type ...
    switch (objGeometry.type) {
        case 'point':

            // Call the callback with the x and y for the point 
            // and the callback function to update it ...
            fnCallback({ x: objGeometry.x, y: objGeometry.y }, function (decNewX, decNewY) {

                // Update the point ...
                objGeometry.x = decNewX;
                objGeometry.y = decNewY;
            });
            break;

        case 'polyline':

            // Loop through all the paths of the polyline ...
            $.each(objGeometry.paths, function (intPath, arrPathPoints) {

                // Loop through all the points of the path ...
                $.each(arrPathPoints, function (intPathPoint, objPathPoint) {

                    // Call the callback with the x and y for the point 
                    // and the callback function to update it ...
                    fnCallback({ x: objPathPoint[0], y: objPathPoint[1] }, function (decNewX, decNewY) {

                        // Update the point ...
                        objPathPoint[0] = decNewX;
                        objPathPoint[1] = decNewY;
                    });
                });
            });
            break;

        case 'polygon':

            // Loop through all the rings of the polygon ...
            $.each(objGeometry.rings, function (intRing, arrRingPoints) {

                // Loop through all the points of the ring ...
                $.each(arrRingPoints, function (intRingPoint, objRingPoint) {

                    // Call the callback with the x and y for the point 
                    // and the callback function to update it ...
                    fnCallback({ x: objRingPoint[0], y: objRingPoint[1] }, function (decNewX, decNewY) {

                        // Update the point ...
                        objRingPoint[0] = decNewX;
                        objRingPoint[1] = decNewY;
                    });
                });
            });
            break;

        case 'extent':

            // Call the callback with the x and y for the min point 
            // and the callback function to update it ...
            fnCallback({ x: objGeometry.xmin, y: objGeometry.ymin }, function (decNewX, decNewY) {

                // Update the point ...
                objGeometry.xmin = decNewX;
                objGeometry.ymin = decNewY;
            });

            // Call the callback with the x and y for the max point 
            // and the callback function to update it ...
            fnCallback({ x: objGeometry.xmax, y: objGeometry.ymax }, function (decNewX, decNewY) {

                // Update the point ...
                objGeometry.xmax = decNewX;
                objGeometry.ymax = decNewY;
            });
            break;
    }
}

// **************************************************************************
// FUNCTION: IsValidProjectionResult
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.IsValidProjectionResult = function IsValidProjectionResult(arrProjectedGeometries, blnAllFlattenedToPoints) {

    // Get the controller ...
    var objMapController = this;

    // Start with a valid result ...
    var blnValidResult = true;

    // When the input geometries has been flattened to points before calling the project function on the geometry service ...
    if (blnAllFlattenedToPoints) {

        // Loop through all the projected points ...
        $.each(arrProjectedGeometries, function (intProjectedPoint, objProjectedPoint) {

            // When either the x or y is not a valid number ...
            if (isNaN(objProjectedPoint.x) || isNaN(objProjectedPoint.y)) {

                // Set to not be valid ...
                blnValidResult = false;

                // Stop checking the geometries ...
                return false;
            }
        });

    } else {

        // Loop through all the projected geometries ...
        $.each(arrProjectedGeometries, function (intProjectedGeometry, objProjectedGeometry) {

            switch (objProjectedGeometry.type) {
                case 'point':

                    // When either the x or y is not a valid number ...
                    if (isNaN(objProjectedGeometry.x) || isNaN(objProjectedGeometry.y)) {

                        // Set to not be valid ...
                        blnValidResult = false;

                        // Stop checking the geometries ...
                        return false;
                    }
                    break;

                case 'polygon':

                    // Loop through all the rings ...
                    $.each(objProjectedGeometry.rings, function (intRing, arrRingPoints) {

                        // Loop through all the ring points ...
                        $.each(arrRingPoints, function (intRingPoint, objRingPoint) {

                            // When either the x or y is not a valid number ...
                            if (isNaN(objRingPoint[0]) || isNaN(objRingPoint[1])) {

                                // Set to not be valid ...
                                blnValidResult = false;

                                // Stop checking the geometries ...
                                return false;
                            }
                        });

                        // Stop checking when found to be false ...
                        if (!blnValidResult) { return false; }
                    });

                    // Stop checking when found to be false ...
                    if (!blnValidResult) { return false; }
                    break;

                case 'extent':

                    // When the xmin, xmax, ymin, ymax is not a valid number ...
                    if (isNaN(objProjectedGeometry.xmin) || isNaN(objProjectedGeometry.xmax) || isNaN(objProjectedGeometry.ymin) || isNaN(objProjectedGeometry.ymax)) {

                        // Set to not be valid ...
                        blnValidResult = false;

                        // Stop checking the geometries ...
                        return false;
                    }
                    break;
            }
        });
    }

    return blnValidResult;
}

// **************************************************************************
// FUNCTION: FindGroupByTemplateByName
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.FindLayerTemplateByID = function FindLayerTemplateByID(objGroupByTemplate, strLayerIDToFind) {

    // Loop through all the layer templates ...
    for (var intLayerTemplate = 0; intLayerTemplate < objGroupByTemplate.LayerTemplates.length; intLayerTemplate++) {

        // Get the group by template ...
        var objLayerTemplate = objGroupByTemplate.LayerTemplates[intLayerTemplate];

        // Get the group by name from the group template ...
        var strLayerID = objLayerTemplate.LayerID;

        // When the group by name matches ...
        if (strLayerID == strLayerIDToFind) {

            // Return the layer template ...
            return objLayerTemplate;
        }
    }

    // Not found ...
    return null;
}

// **************************************************************************
// FUNCTION: ConvertJSONFields
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.ConvertJSONFields = function ConvertJSONFields(arrJSonFields, objAttributes) {

    // Loop through all the json field on the layer temlpate ...
    for (var intJSONField = 0; intJSONField < arrJSonFields.length; intJSONField++) {

        // Get the field name of the json field to convert ...
        var strJSONField = arrJSonFields[intJSONField];

        // When the json field is a string (when its not been converted already) ...
        if (typeof objAttributes[strJSONField] == 'string') {

            // Parse the json in the field and replace the attribute with the json object ...
            objAttributes[strJSONField] = JSON.parse(objAttributes[strJSONField]);
        }
    }
}

// **************************************************************************
// FUNCTION: CreateMapServiceDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.CreateMapServiceDisplay = function CreateMapServiceDisplay(objMapService, strMapID, decMinScale, decMaxScale) {

    // Create a new map service display for the map and map service ...
    var objMapServiceDisplay = {
        MapServiceDisplayID: SD.Guid.Shared.NewID(),
        MapID: strMapID,
        MapServiceID: objMapService.MapServiceID,
        Transparency: 0,
        MinScale: decMinScale,
        MaxScale: decMaxScale,
        Order: 0
    };

    return objMapServiceDisplay;
}

// **************************************************************************
// FUNCTION GetDefaultScales
// USAGE    Returns the scale levels of the map as an array of {level: [LEVEL], scale: [SCALE]} ...
// **************************************************************************
TrimbleMap.Controller.Shared.GetDefaultScales = function GetDefaultScales() {

    return [591657527.591555,
        295828763.795777,
        147914381.897889,
        73957190.948944,
        36978595.474472,
        18489297.737236,
        9244648.868618,
        4622324.434309,
        2311162.217155,
        1155581.108577,
        577790.554289,
        288895.277144,
        144447.638572,
        72223.819286,
        36111.909643,
        18055.954822,
        9027.977411,
        4513.988705,
        2256.994353,
        1128.497176];
}

// **************************************************************************
// FUNCTION ScalesEquals
// USAGE    Returns true when the scale levels matches ...
// **************************************************************************
TrimbleMap.Controller.Shared.ScalesEquals = function ScalesEquals(arrScalesA, arrScalesB) {

    // Start with a match ...
    var blnScalesEquals = true;

    // When both null ...
    if ((arrScalesA == null) && (arrScalesB == null)) {

        // Matching ...
        blnScalesEquals = true;

        // When both not null and the same amount of scale levels ...
    } else if ((arrScalesA != null) && (arrScalesB != null) && (arrScalesA.length == arrScalesB.length)) {

        // Loop through all the scale levels ...
        for (var intScale = 0; intScale < arrScalesA.length; intScale++) {

            // Get the scale level ...
            var decScaleA = arrScalesA[intScale];
            var decScaleB = arrScalesB[intScale];

            // When the scales differs ...
            if (decScaleA != decScaleB) {

                // Not matching ...
                blnScalesEquals = false;

                // Stop checking ...
                break;
            }
        }

    } else {

        // Not matching ...
        blnScalesEquals = false;
    }

    return blnScalesEquals;
}

// **************************************************************************
// FUNCTION: CreateMapLayerQueryResult
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.CreateMapLayerQueryResult = function CreateMapLayerQueryResult(objMapService, strMapLayerID, objAttributes, objGeometry, guidSpatialReference) {

    return {
        MapService: objMapService,
        MapLayerID: strMapLayerID,
        Attributes: objAttributes,
        Geometry: objGeometry,
        SpatialReferenceID: guidSpatialReference
    };
}

// **************************************************************************
// FUNCTION: CreateMapServiceQueryResult
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.CreateMapServiceQueryResult = function CreateMapServiceQueryResult(strMapLayerID, intTotalCount, blnExactCountRetrieved, arrMapLayerQueryResults) {

    return {
        MapLayerID: strMapLayerID,
        TotalCount: intTotalCount,
        ExactCountRetrieved: blnExactCountRetrieved,
        Data: arrMapLayerQueryResults
    };
}

// **************************************************************************
// FUNCTION: GetMapServiceQueryResultsByLayerID
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.GetMapServiceQueryResultsByLayerID = function GetMapServiceQueryResultsByLayerID(arrMapServiceQueryResults, strMapLayerID) {

    // Start with not found ...
    var objMapServiceQueryResult = null;

    // Loop through all the results ...
    $.each(arrMapServiceQueryResults, function (intTestMapServiceQueryResult, objTestMapServiceQueryResult) {

        // When the map layer id matches ...
        if (objTestMapServiceQueryResult.MapLayerID == strMapLayerID) {

            // Set the object to return ...
            objMapServiceQueryResult = objTestMapServiceQueryResult;

            // Stop searching ...
            return false;
        }
    });

    // When not found ...
    if (!objMapServiceQueryResult) {

        // Create a new query result object for the layer ...
        objMapServiceQueryResult = TrimbleMap.Controller.Shared.CreateMapServiceQueryResult(strMapLayerID, 0, true, []);

        // Add it to the array ...
        arrMapServiceQueryResults.push(objMapServiceQueryResult);
    }

    // Return the result ... 
    return objMapServiceQueryResult;
}

// **************************************************************************
// FUNCTION: ForceThrowException
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.ForceThrowException = function ForceThrowException(objError) {

    // Set a timer to fire after 0ms to get out of the current code execution context ...
    setTimeout(function () {

        // Throw the error ...
        throw objError;
    }, 0);
}

// **************************************************************************
// FUNCTION: TrapException
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.TrapException = function TrapException(fnToCall) {

    // Create a new function to return ...
    var fnToReturn = function () {

        // Wrap in a try catch block ...
        try {

            // Call the wrapped function and return the results ...
            return fnToCall.apply(this, arguments);

        } catch (objError) {

            // Throw the exception ...
            TrimbleMap.Controller.Shared.ForceThrowException(objError);
        }
    }

    return fnToReturn;
}

// **************************************************************************
// FUNCTION: CreateDiagnosticMessage
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.CreateDiagnosticMessage = function CreateDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, enMessageLevel, strRequestUrl) {

    // Create and return a message object ...
    return {
        DiagnosticMessageID: SD.Guid.Shared.NewID(),
        Title: strTitle,
        Message: strMessage,
        CrashMessage: strCrashMessage,
        EndUserMessage: strEndUserMessage,
        MessageLevel: enMessageLevel,
        TimeStamp: (new Date).getTime(),
        RequestUrl: strRequestUrl
    };
}

// **************************************************************************
// FUNCTION: BuildCrashMessage
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.BuildCrashMessage = function BuildCrashMessage(objError) {

    // Build the crash message ...
    var strCrashMessage = objError.message + (((typeof objError.details != 'undefined') && (objError.details != null) && (objError.details.length > 0)) ? ' [' + objError.details.toString() + ']' : '');

    // Return it ...
    return strCrashMessage;
}

// **************************************************************************
// FUNCTION: BuildEsriRequestUrl
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.BuildEsriRequestUrl = function BuildEsriRequestUrl(objIOArgs) {

    // Start with no url ...
    var strUrl = null;

    // When we have an objIOArgs with a url ...
    if ((typeof objIOArgs != 'undefined') && objIOArgs && (typeof objIOArgs.url != 'undefined') && objIOArgs.url) {

        // Start with the url of the request ...
        var strUrl = objIOArgs.url;

        // When we have content ...
        if ((typeof objIOArgs.content != 'undefined') && objIOArgs.content) {

            // Start with no arguments ...
            var strArguments = '';

            // Loop through all the content key-value pairs ...
            $.each(objIOArgs.content, function (strKey, strValue) {

                // When not the format (f) option, when you omit the f=json parameter html will be asumed ...
                if (strKey != 'f') {

                    // When the first value add a '?' else add a '&' ...
                    if (strArguments.length == 0) { strArguments += '?'; } else { strArguments += '&'; }

                    // Add the key value pair 
                    strArguments += strKey + '=' + strValue;
                }
            });

            // When the url ends with a '/', remove it ...
            if (strUrl[strUrl.length - 1] == '/') { strUrl = strUrl.substring(0, strUrl.length - 1); }

            // Add the arguments ...
            strUrl += strArguments;

            // When we have form data ...
        } else if ((typeof objIOArgs.form != 'undefined') && objIOArgs.form) {

            // Wrap the form as a jquery object ...
            var objForm = $(objIOArgs.form);

            // Get the input elements ....
            var objChildren = objForm.children();

            // Start with no arguments ...
            var strArguments = '';

            // Loop through all the children of the form ...
            objChildren.each(function (intChild, objChildDOMElement) {

                // Wrap the DOM element as a jquery element ...
                var objChildElement = $(objChildDOMElement);

                // When it's an input element ...
                if (objChildElement.prop('tagName').toLowerCase() == 'input') {

                    // Get the name of the element ...
                    var strKey = objChildElement.attr('name');

                    // Get the value ...
                    var strValue = objChildElement.val();

                    // When not the format (f) option, when you omit the f=json parameter html will be asumed ...
                    if (strKey != 'f') {

                        // When the first value add a '?' else add a '&' ...
                        if (strArguments.length == 0) { strArguments += '?'; } else { strArguments += '&'; }

                        // Add the key value pair 
                        strArguments += strKey + '=' + strValue;
                    }
                }
            });

            // When the url ends with a '/', remove it ...
            if (strUrl[strUrl.length - 1] == '/') { strUrl = strUrl.substring(0, strUrl.length - 1); }

            // Add the arguments ...
            strUrl += strArguments;
        }
    }

    // Return the url ...
    return strUrl;
}

// **************************************************************************
// FUNCTION: RemoveJsonFromatParameterFromUrl
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.RemoveJsonFromatParameterFromUrl = function RemoveJsonFromatParameterFromUrl(strUrl) {

    // When we have url ...
    if ((typeof strUrl != 'undefined') && (strUrl != null) && (strUrl.length > 0)) {

        // Remove f=json from the url ...
        strUrl = strUrl.replace('f=json', '');

        // When the url ends with ? ...
        if (strUrl.charAt(strUrl.length - 1) == '?') {

            // Remove the ? ...
            strUrl = strUrl.substr(0, strUrl.length - 1);
        }
    }

    return strUrl;
}

// **************************************************************************
// FUNCTION: AddQueryStringParameter
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.AddQueryStringParameter = function AddQueryStringParameter(strUrl, strParameterAndValueToAdd) {

    // When we have url ...
    if ((typeof strUrl != 'undefined') && (strUrl != null) && (strUrl.length > 0)) {

        // Attempt to find a question mark in the url ...
        var intQuestionMark = strUrl.indexOf('?');

        // When found ...
        if (intQuestionMark > -1) {

            // Add the parameter to the existing paremeter list ...
            strUrl += '&' + strParameterAndValueToAdd;

        } else {

            // When the url ends with a / ...
            if (strUrl.charAt(strUrl.length - 1) == '/') {

                // Remove the / ...
                strUrl = strUrl.substr(0, strUrl.length - 1);
            }

            // Add the parameter to the url ...
            strUrl += '?' + strParameterAndValueToAdd;
        }

    } else {

        // Just use the parameter to add as the url ...
        strUrl = strParameterAndValueToAdd;
    }

    return strUrl;
}

// **************************************************************************
// FUNCTION: IsTokenExpired
// USAGE:  
// Checks if the map service token has expired or not by comparing the current 
// unix epoch with that of the token expiry datetime
// **************************************************************************
TrimbleMap.Controller.Shared.IsTokenExpired = function IsTokenExpired(objMapServiceToken) {

    //Treat the token as expired 1 minute sooner
    var intCurrentTime = new Date().getTime() + 60000;

    return intCurrentTime > objMapServiceToken.ExpiryDateTime;
}

// **************************************************************************
// FUNCTION: GetTokenForMapService
// USAGE:  
// Provides an ArcGIS server token related to the specified Map Service
// It makes use of a cache to avoid hitting the token generation url everytime a token is requested 
// It handles token renewal in the event that the cached token has expired
// If no map service parameter is provided, the token for the base ArcGIS server is returned
// **************************************************************************
TrimbleMap.Controller.Shared.GetTokenForMapService = function GetTokenForMapService(objMapService) {

    var strToken = "";
    var strMapServiceTokenId = (objMapService == null) ? 1 : objMapService.MapServiceTokenId;

    //Get the token object
    var objMapServiceToken = TrimbleMap.Controller.Shared.MapServiceTokensLookupTable[strMapServiceTokenId];

    //Check if there is a token object and the expiry datetime is set and the token has not expired
    if (objMapServiceToken.Token != null && objMapServiceToken.ExpiryDateTime != null) {

        if (!TrimbleMap.Controller.Shared.IsTokenExpired(objMapServiceToken)) {

            strToken = objMapServiceToken.Token;
        }
    }

    return strToken;
}

// **************************************************************************
// FUNCTION: MapServiceRestUrlWithToken
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken = function MapServiceRestUrlWithToken(objMapService) {
    let result = null;
    // Start with the rest url from the service
    let strRestUrl = objMapService.RestUrl;
    let strToken = '';
    let success = true;
    let error = null;

    if (objMapService.AuthenticationType === TrimbleMap.enumAuthenticationType.Token) {
        strToken = TrimbleMap.Controller.Shared.GetTokenForMapService(objMapService);

        if (strToken.length == 0) {
            // If the token is empty for some reason, use the base ArcGIS Server token
            strToken = TrimbleMap.Controller.Shared.GetTokenForMapService();
        }

        if (strToken.length > 0) {
            // Add the token as a query string parameter ...
            strRestUrl = TrimbleMap.Controller.Shared.AddQueryStringParameter(strRestUrl, 'token=' + strToken);
        }
        else {
            strRestUrl = null;
            success = false;
            error = "The authentication token associated with the map service has expired.";
        }
    }

    result = {
        RestUrlWithToken: strRestUrl,
        Token: strToken,
        Success: success,
        Error: error
    };

    return result;
}

// **************************************************************************
// FUNCTION: GetWebFeatureServiceUrlWithQueryParameters
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.GetWebFeatureServiceUrlWithQueryParameters = function GetWebFeatureServiceUrlWithQueryParameters(objMapService, strRequest, strTypeName) {
    let objMapController = this;
    let strMapServiceLayerUrl = '';

    // Use eplicitly specified wfs url if specified otherwise build up a wfs url based off of the wms url
    if (objMapService.WFSUrl && objMapService.WFSUrl.RelativeUrl) {
        strMapServiceLayerUrl = objMapService.WFSUrl.RelativeUrl;
    } else {
        strMapServiceLayerUrl = objMapService.RestUrl.replace(/\/WMSServer/gi, "/WFSServer");
    }

    // Append the service type, version and request query parameters
    strMapServiceLayerUrl += "?" + TrimbleMap.enumOgcMapServiceQueryParameterKey.Service + "=" + TrimbleMap.enumOgcMapService.WFS;
    strMapServiceLayerUrl += "&" + TrimbleMap.enumOgcMapServiceQueryParameterKey.Version + "=" + TrimbleMap.Controller.Shared.WFS_VERSION;
    strMapServiceLayerUrl += "&" + TrimbleMap.enumOgcMapServiceQueryParameterKey.Request + "=" + strRequest;

    // Append type name/ layer name when specified
    if (strTypeName) {
        strMapServiceLayerUrl += "&" + TrimbleMap.enumWebFeatureServiceQueryParameterKey.TypeName + "=" + strTypeName;
    }

    return strMapServiceLayerUrl;
}

// **************************************************************************
// FUNCTION: GetMapServerType
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.GetMapServerType = function GetMapServerType(objMapService) {
    let enMapServerType = null;

    if (objMapService.RestUrl.indexOf("/MapServer") > -1 || objMapService.RestUrl.indexOf("/FeatureServer") > -1 || objMapService.RestUrl.indexOf("/VectorTileServer") > -1) {
        enMapServerType = TrimbleMap.enumMapServerType.ESRI;
    } else {
        enMapServerType = TrimbleMap.enumMapServerType.GEOSERVER;
    }

    return enMapServerType;
}

// **************************************************************************
// FUNCTION: GetWebMapServiceLayerName
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.GetWebMapServiceLayerName = function GetWebMapServiceLayerName(objWebMapServiceLayerInfo) {
    let strLayerID;

    if (objWebMapServiceLayerInfo) {
        if (objWebMapServiceLayerInfo.name) {
            strLayerID = objWebMapServiceLayerInfo.name;
        } else {
            strLayerID = objWebMapServiceLayerInfo.GeneratedName;
        }
    }

    return strLayerID;
}

// **************************************************************************
// FUNCTION: MapLayerRestUrlWithToken
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken = function MapLayerRestUrlWithToken(objMapService, strEsriLayerID) {

    var result = TrimbleMap.Controller.Shared.MapServiceRestUrlWithToken(objMapService);

    if (result.Success) {

        // Build the layer rest url, from the map service rest url, the token and the layer id ...
        var strRestUrl = TrimbleMap.Controller.Shared.ModifyUrl(result.RestUrlWithToken, function (objUrlParts) {
            objUrlParts.Url = TrimbleMap.Controller.Shared.EnsureCharacterAtEndOfString(objUrlParts.Url, '/') + strEsriLayerID;
        });

        result.RestUrlWithToken = strRestUrl;
    }

    return result;
}

// **************************************************************************
// FUNCTION: MapLayerQueryRestUrlWithToken
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.MapLayerQueryRestUrlWithToken = function MapLayerQueryRestUrlWithToken(objMapService, strEsriLayerID, strRequestQuery) {

    let strMapLayerQueryRestUrlWithToken = TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, strEsriLayerID);

    strMapLayerQueryRestUrlWithToken = TrimbleMap.Controller.Shared.ModifyUrl(strMapLayerQueryRestUrlWithToken.RestUrlWithToken, function (objUrlParts) {
        objUrlParts.Url = TrimbleMap.Controller.Shared.EnsureCharacterAtEndOfString(objUrlParts.Url, '/') + "query";
    });

    strMapLayerQueryRestUrlWithToken = TrimbleMap.Controller.Shared.AddQueryStringParameter(strMapLayerQueryRestUrlWithToken, strRequestQuery);

    return strMapLayerQueryRestUrlWithToken;
}

// **************************************************************************
// FUNCTION: RemoveTokenFromUrlParameters
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.RemoveTokenFromUrlParameters = function RemoveTokenFromUrlParameters(strUrlParameters) {

    let arrUrlParameters = strUrlParameters.split("&");

    arrUrlParameters = arrUrlParameters.filter(function (strUrlParameter) {
        return !(strUrlParameter.startsWith("?token=") || strUrlParameter.startsWith("token="));
    });

    strUrlParameters = arrUrlParameters.join("&");

    while (strUrlParameters.charAt(0) == " " || strUrlParameters.charAt(0) == "?") {
        strUrlParameters = strUrlParameters.substr(1);
    }

    return strUrlParameters;
}

// **************************************************************************
// FUNCTION: LegendServiceSwatchImageUrl
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.LegendServiceSwatchImageUrl = function LegendServiceSwatchImageUrl(objMapService, strEsriLayerID, strLegendItem) {

    var strLegendServiceUrl = '';

    var result = TrimbleMap.Controller.Shared.MapLayerRestUrlWithToken(objMapService, strEsriLayerID);
    if (result.Success) {

        // Build the layers' swatch image url ...
        strLegendServiceUrl = TrimbleMap.Controller.Shared.ModifyUrl(result.RestUrlWithToken, function (objUrlParts) {
            objUrlParts.Url = TrimbleMap.Controller.Shared.EnsureCharacterAtEndOfString(objUrlParts.Url, '/') + 'images/' + strLegendItem;
        });
    }

    return strLegendServiceUrl;
}

// **************************************************************************
// FUNCTION: UrlWithoutParameters
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.UrlWithoutParameters = function UrlWithoutParameters(strUrl) {

    // Attempt to find a question mark in the url ...
    var intQuestionMark = strUrl.indexOf('?');

    // When found ...
    if (intQuestionMark > -1) {

        // Remove everything from the question mark ... 
        strUrl = strUrl.substring(0, intQuestionMark);
    }

    return strUrl;
}

// **************************************************************************
// FUNCTION: UrlParameters
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.UrlParameters = function UrlParameters(strUrl) {

    // Attempt to find a question mark in the url ...
    var intQuestionMark = strUrl.indexOf('?');

    let strParameters = null;

    // When found ...
    if (intQuestionMark > -1) {

        // Remove everything before the question mark ... 
        strParameters = strUrl.substr(intQuestionMark);

    } else {

        // No parameters ...
        strParameters = '';
    }

    return strParameters;
}

// **************************************************************************
// FUNCTION: ModifyUrl
// USAGE:    strUrl is the url to modify
//           fnModifyUrlParts is a function that will be called with the 
//           different parts of the url that can modify the parts of the 
//           url that are passed in, signature: 
//           fnModifyUrlParts({
//                              Url: strUrl
//                              Parameters: strParameters
//                            });
// RETURN:   Returns the modified url
// **************************************************************************
TrimbleMap.Controller.Shared.ModifyUrl = function ModifyUrl(strUrl, fnModifyUrlParts) {

    // Build an object with the url and the parameters separated ...
    var objUrlParts = {
        Url: TrimbleMap.Controller.Shared.UrlWithoutParameters(strUrl),
        Parameters: TrimbleMap.Controller.Shared.UrlParameters(strUrl)
    }

    // Call the callback function to modify the parts ...
    fnModifyUrlParts(objUrlParts);

    // Rebuild the url ...
    strUrl = objUrlParts.Url + objUrlParts.Parameters;

    return strUrl;
}

// **************************************************************************
// FUNCTION: EnsureCharacterAtEndOfString
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.EnsureCharacterAtEndOfString = function EnsureCharacterAtEndOfString(strString, strChar) {

    // When we have a valid string ...
    if ((typeof strString != 'undefined') && (strString != null) && (strString.length > 0)) {

        // Add the character to the end when not already there ...
        if (strString.charAt(strString.length - 1) != strChar) { strString += strChar; }

    } else {

        // Just use the character ...
        strString = strChar;
    }

    return strString;
}

// **************************************************************************
// FUNCTION: RemoveCharacterFromEndOfString
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.RemoveCharacterFromEndOfString = function RemoveCharacterFromEndOfString(strString, strChar) {

    // When we have a valid string ...
    if ((typeof strString != 'undefined') && (strString != null) && (strString.length > 0)) {

        // Remove the character from the end of the string ...
        while ((strString.length > 0) && (strString.charAt(strString.length - 1) == strChar)) { strString = strString.substr(0, strString.length - 1); }
    }

    return strString;
}

// **************************************************************************
// FUNCTION: CreateLegendDataItem
// USAGE:    Use this function to create the items of the array to be 
//           passed into CreateLegendSection ...
// **************************************************************************
TrimbleMap.Controller.Shared.CreateLegendDataItem = function CreateLegendDataItem(strName, strLayerID, objSwatchElement, blnVisible) {

    // Create a legend data item and return it ...
    return {
        Name: strName,
        LayerID: strLayerID,
        SwatchElement: objSwatchElement,
        SubItems: [],
        Visible: blnVisible
    };
}

// **************************************************************************
// FUNCTION: CreateLegendDataSubItem
// USAGE:    Use this function to create the sub items of the array to be 
//           passed into CreateLegendSection ...
// **************************************************************************
TrimbleMap.Controller.Shared.CreateLegendDataSubItem = function CreateLegendDataSubItem(strName, strLayerID, objSwatchElement, blnVisible) {

    // Create a legend data sub item and return it ...
    return {
        Name: strName,
        LayerID: strLayerID,
        SwatchElement: objSwatchElement,
        SubItems: [],
        Visible: blnVisible
    };
}

// **************************************************************************
// FUNCTION: CreateLegendSectionData
// USAGE:    Use this function to create the items of the array to be 
//           passed into CreateLegendSection ...
// **************************************************************************
TrimbleMap.Controller.Shared.CreateLegendSectionData = function CreateLegendSectionData(objMapServiceDisplay, objMapService, arrLegendData, blnLoaded) {

    // Create and return the legend section data ...
    return {
        MapServiceDisplay: objMapServiceDisplay,
        MapService: objMapService,
        DataItems: arrLegendData,
        Loaded: blnLoaded
    };
}

// **************************************************************************
// FUNCTION: CreateMapLayerDataFromService
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.CreateMapLayerDataFromService = function CreateMapLayerDataFromService(objDataFromService) {

    // Create and return the map layer data ...
    return {
        GeometryType: (typeof objDataFromService.geometryType != 'undefined') ? objDataFromService.geometryType : null,
        Fields: ((typeof objDataFromService.fields != 'undefined') && (objDataFromService.fields != null)) ? $.map(objDataFromService.fields, function (objField, intField) {
            return {
                name: objField.name,
                alias: objField.alias,
                type: objField.type
            }
        }) : null
    };
}

// **************************************************************************
// FUNCTION: CallDeferredFunctionSequentially
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.CallDeferredFunctionSequentially = function CallDeferredFunctionSequentially(arrFunctionsThatReturnsDeferreds) {

    // When we have any functions to call ...
    if (arrFunctionsThatReturnsDeferreds.length > 0) {

        // Shift the first function out of the array ...
        let fnUpdate = arrFunctionsThatReturnsDeferreds.shift();

        // Call the function ...
        fnUpdate().then(TrimbleMap.Controller.Shared.TrapException(function () {

            // When completed call this function again with the remaining functions ...
            TrimbleMap.Controller.Shared.CallDeferredFunctionSequentially(arrFunctionsThatReturnsDeferreds);
        }));
    }
}

// **************************************************************************
// FUNCTION: SiteBaseUrl
// USAGE:    
// **************************************************************************
TrimbleMap.Controller.Shared.SiteBaseUrl = function SiteBaseUrl() {
    let strlocation = document.location.toString();
    let intApplicationNameIndex = strlocation.indexOf('/', strlocation.indexOf('://') + 3);
    let strApplicationName = strlocation.substring(0, intApplicationNameIndex) + '/';
    let intWebFolderIndex = strlocation.indexOf('/', strlocation.indexOf(strApplicationName) + strApplicationName.length);

    return strlocation.substring(0, intWebFolderIndex);
}
/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the TrimbleMap namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.CoordinateDisplay = {};
TrimbleMap.CoordinateDisplay.Shared = {};

TrimbleMap.enumSpatialReferenceType.COORDINATESDISPLAYPROJECTEDTOLERANCE = 0.1;
TrimbleMap.enumSpatialReferenceType.COORDINATESDISPLAYGEOGRAPHICTOLERANCE = 0.000001;

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateDisplay.CreateInstance = function CreateInstance(objMapController, objCoordinateContainerElement) {

    // Create the object that will hold the instance properties ...
    var objCoordinateDisplay = {
        MapController: objMapController,
        LeftSpan: $('<span></span>'),
        RightSpan: $('<span></span>'),
        InfoIcon: $('<span></span>'),
        OnMousePanHanlder: null,
        OnMouseMoveEventHanlder: null,
        OnMouseZoomEventHanlder: null,
        CoordinateDisplayUpdateHandler: null,
        CoordinateDisplaySystemInfo: null,
        CoordinateDisplaySystemInfoDiv: null,
        CoordinateSystemHelpLine: null,

        CoordinateDisplaySystemInfoMouseEnterProxy: function (e) { objCoordinateDisplay.CoordinateDisplaySystemInfoMouseEnter(e); },
        CoordinateDisplaySystemInfoMouseLeaveProxy: function (e) { objCoordinateDisplay.CoordinateDisplaySystemInfoMouseLeave(e); },

        CreateElements: TrimbleMap.CoordinateDisplay.CreateElements,
        AttachHandler: TrimbleMap.CoordinateDisplay.AttachHandler,
        DetachHandler: TrimbleMap.CoordinateDisplay.DetachHandler,
        Update: TrimbleMap.CoordinateDisplay.Update,
        CoordinateDisplaySystemInfoMouseEnter: TrimbleMap.CoordinateDisplay.CoordinateDisplaySystemInfoMouseEnter,
        CoordinateDisplaySystemInfoMouseLeave: TrimbleMap.CoordinateDisplay.CoordinateDisplaySystemInfoMouseLeave
    };

    // Create the elements ...
    objCoordinateDisplay.CreateElements(objCoordinateContainerElement);

    return objCoordinateDisplay;
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateDisplay.CreateElements = function CreateElements(objCoordinateContainerElement) {

    // Get the coordinate display instance ...
    var objCoordinateDisplay = this;

    // Add it to the div ...
    objCoordinateContainerElement.append('&nbsp;');
    objCoordinateContainerElement.append(objCoordinateDisplay.LeftSpan);
    objCoordinateContainerElement.append('&nbsp;');
    objCoordinateContainerElement.append('&nbsp;');
    objCoordinateContainerElement.append(objCoordinateDisplay.RightSpan);
    objCoordinateContainerElement.append('&nbsp;');
    objCoordinateContainerElement.append('&nbsp;');

    var objToSpatialReference = objCoordinateDisplay.MapController.GetCurrentMapCoordinateDisplaySpatialReference();

    objCoordinateDisplay.CoordinateDisplaySystemInfo = $('<div class="info-icon"></div>');
    objCoordinateDisplay.InfoIcon.append(objCoordinateDisplay.CoordinateDisplaySystemInfo);
    objCoordinateContainerElement.append(objCoordinateDisplay.InfoIcon);

    if (objToSpatialReference) {
        // Translation: Coordinates are displayed using %1 coordinate system.
        objCoordinateDisplay.CoordinateSystemHelpLine = SD.Translation.Shared.GetTranslation('Map.CoordinateDisplay.js', 'CoordinateSystemDisplay', objToSpatialReference.Name);

        // Render the map info tool display component
        objCoordinateDisplay.CoordinateDisplaySystemInfoDiv = $('<div>').attr({ 'id': 'coordinate_display_info_div', 'visible': 'true', 'class': 'info-details' }).append(
            $('<span>').append(objCoordinateDisplay.CoordinateSystemHelpLine)
        );

        objCoordinateContainerElement.find('.info-icon').append(objCoordinateDisplay.CoordinateDisplaySystemInfoDiv);
    }
}

// **************************************************************************
// FUNCTION: AttachHandler
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateDisplay.AttachHandler = function AttachHandler() {

    // Get the coordinate display instance ...
    var objCoordinateDisplay = this;

    // Create the coordinates display update handler ...
    objCoordinateDisplay.CoordinateDisplayUpdateHandler = function (e) { objCoordinateDisplay.Update(e); };

    // When we are not running n a touch interface ...
    if (!TrimbleMap.CoordinateDisplay.Shared.CanTouch()) {

        // Attach a mouse move event handler ...
        objCoordinateDisplay.OnMouseMoveEventHanlder = objCoordinateDisplay.MapController.EsriMap.on('mouse-move', objCoordinateDisplay.CoordinateDisplayUpdateHandler);

        objCoordinateDisplay.CoordinateDisplaySystemInfo.on('mouseenter',(objCoordinateDisplay.CoordinateDisplaySystemInfoMouseEnterProxy));

        objCoordinateDisplay.CoordinateDisplaySystemInfo.on('mouseleave',(objCoordinateDisplay.CoordinateDisplaySystemInfoMouseLeaveProxy));

    } else {

        // Attach pan and zoom event handlers ...
        objCoordinateDisplay.OnMousePanHanlder = objCoordinateDisplay.MapController.EsriMap.on('pan', objCoordinateDisplay.CoordinateDisplayUpdateHandler);
        objCoordinateDisplay.OnMouseZoomEventHanlder = objCoordinateDisplay.MapController.EsriMap.on('zoom', objCoordinateDisplay.CoordinateDisplayUpdateHandler);
    }
}
// **************************************************************************
// FUNCTION: DetachHandler
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateDisplay.DetachHandler = function DetachHandler() {

    // Get the coordinate display instance ...
    var objCoordinateDisplay = this;

    // When we are not running n a touch interface ...
    if (!TrimbleMap.CoordinateDisplay.Shared.CanTouch()) {

        // Detach a mouse move event handler ...
        objCoordinateDisplay.OnMouseMoveEventHanlder.remove();

        objCoordinateDisplay.CoordinateDisplaySystemInfo.off('mouseenter', objCoordinateDisplay.CoordinateDisplaySystemInfoMouseEnterProxy);

        objCoordinateDisplay.CoordinateDisplaySystemInfo.off('mouseleave', objCoordinateDisplay.CoordinateDisplaySystemInfoMouseLeaveProxy);
    } else {

        // Detach pan and zoom event handlers ...
        objCoordinateDisplay.OnMousePanHanlder.remove();
        objCoordinateDisplay.OnMouseZoomEventHanlder.remove();
    }
}

// **************************************************************************
// FUNCTION: CoordinateDisplaySystemInfoMouseEnter
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateDisplay.CoordinateDisplaySystemInfoMouseEnter = function CoordinateDisplaySystemInfoMouseEnter(e) {
    let objCoordinateDisplay = this;

    let objInfoImagePosition = objCoordinateDisplay.CoordinateDisplaySystemInfo.position();

    objCoordinateDisplay.CoordinateDisplaySystemInfoDiv.show();
};

// **************************************************************************
// FUNCTION: CoordinateDisplaySystemInfoMouseLeave
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateDisplay.CoordinateDisplaySystemInfoMouseLeave = function CoordinateDisplaySystemInfoMouseLeave(e) {
    let objCoordinateDisplay = this;

    objCoordinateDisplay.CoordinateDisplaySystemInfoDiv.hide();
};

// **************************************************************************
// FUNCTION: Update
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateDisplay.Update = function Update(e) {

    // Get the coordinate display instance ...
    var objCoordinateDisplay = this;

    // Create a variable to hold the point to use ...
    var objPointToUse;

    // When we are not running on a touch interface ...
    if (!TrimbleMap.CoordinateDisplay.Shared.CanTouch()) {

        // Use the map point of the current mouse location ...
        objPointToUse = e.mapPoint;

    } else {

        // Use the center of the screen ...
        objPointToUse = e.extent.getCenter();
    }

    // Get the spatial reference ...
    var objFromSpatialReference = objCoordinateDisplay.MapController.GetCurrentMapSpatialReference();
    var objToSpatialReference = objCoordinateDisplay.MapController.GetCurrentMapCoordinateDisplaySpatialReference();

    if (objFromSpatialReference && objToSpatialReference) {

        // Update when switching maps Translation: Coordinates are displayed using %1 coordinate system.
        objCoordinateDisplay.CoordinateSystemHelpLine = SD.Translation.Shared.GetTranslation('Map.CoordinateDisplay.js', 'CoordinateSystemDisplay', objToSpatialReference.Name);
        objCoordinateDisplay.CoordinateDisplaySystemInfoDiv[0].getElementsByTagName('span')[0].innerText = objCoordinateDisplay.CoordinateSystemHelpLine;

        // Reproject the cooridnates
        let objGeoTransformation = objCoordinateDisplay.MapController.GetGeoTransformation(objFromSpatialReference.SpatialReferenceID, objToSpatialReference.SpatialReferenceID);
        let objProjectedCoordinate = objCoordinateDisplay.MapController.ProjectGeometriesClientSide([objPointToUse], objFromSpatialReference.SpatialReferenceID, objToSpatialReference.SpatialReferenceID, objGeoTransformation)[0];

        // When either the x or y is not a valid number
        if (!(isNaN(objProjectedCoordinate.x) || isNaN(objProjectedCoordinate.y))) {

            //Show them if they were hidden
            if (objCoordinateDisplay.RightSpan[0].outerHTML.includes("display: none;")) {

                objCoordinateDisplay.RightSpan.show();
                objCoordinateDisplay.InfoIcon.show();
            }

            // When a projected coordinate system ...
            if (objToSpatialReference.SpatialReferenceType.toLowerCase() == "projected") {

                // Start with not adding the unit abbreviation at all ...
                var strUnitAbbreviationPart = '';

                // Get the unit abbreviation to add when there is one ...
                if (typeof objToSpatialReference.CoordinateUnitAbbreviation != 'undefined') { strUnitAbbreviationPart = ' ' + objToSpatialReference.CoordinateUnitAbbreviation; }

                // Build the latitude and longitudes ...
                var strX = SD.DisplayValue.FromDouble(objProjectedCoordinate.x, objCoordinateDisplay.MapController.State.GroupSeparator, objCoordinateDisplay.MapController.State.DecimalSeparator, 0) + strUnitAbbreviationPart;
                var strY = SD.DisplayValue.FromDouble(objProjectedCoordinate.y, objCoordinateDisplay.MapController.State.GroupSeparator, objCoordinateDisplay.MapController.State.DecimalSeparator, 0) + strUnitAbbreviationPart;

                // When we should display the longitude first and then the lattitude ...
                if (objCoordinateDisplay.MapController.State.ProjectedFormatLongitudeThenLatitude) {

                    // Place the x in the left span and the y in the right span ...
                    objCoordinateDisplay.LeftSpan.text(strX);
                    objCoordinateDisplay.RightSpan.text(strY);

                } else {

                    // Place the y in the left span and the x in the right span ...
                    objCoordinateDisplay.LeftSpan.text(strY);
                    objCoordinateDisplay.RightSpan.text(strX);
                }

            } else {

                // Convert the coordinate to dms ...
                var objDMS = SD.DMS.ToDMS(objProjectedCoordinate.y, objProjectedCoordinate.x, '', '.', 0);

                // Place the latitude in the left span and the longitude in the right span ...
                objCoordinateDisplay.LeftSpan.text(objDMS.Latitude);
                objCoordinateDisplay.RightSpan.text(objDMS.Longitude);
            }
        } else {

            let strOutOFBounds = SD.Translation.Shared.GetTranslation('Map.CoordinateDisplay.js', 'OutOfBounds');

            // Place the y in the left span and the x in the right span ...
            objCoordinateDisplay.LeftSpan.text(strOutOFBounds);
            objCoordinateDisplay.RightSpan.hide();
            objCoordinateDisplay.InfoIcon.hide();
        }
    }
};

// **************************************************************************
// FUNCTION: CanTouch
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateDisplay.Shared.CanTouch = function CanTouch() {
    return ("ontouchstart" in document.documentElement) || ("ontouchstart" in window);
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.CoordinateListEditor = {};
TrimbleMap.CoordinateListEditor.Shared = {};
TrimbleMap.CoordinateListEditor.Shared.ROW_HEIGHT = 24;
TrimbleMap.CoordinateListEditor.Shared.BLOCK_SIZE = 100;
TrimbleMap.CoordinateListEditor.Shared.MAX_COORDINATES_FOR_EDIT = 100;
TrimbleMap.CoordinateListEditor.Shared.BLOCK_LOAD_BUFFER_PX = 480;

// ****************************************************************
//  ENUMERATIONS
// ****************************************************************
TrimbleMap.CoordinateListEditor.enumCoordinateFormat = {};
TrimbleMap.CoordinateListEditor.enumCoordinateFormat.NONE = 'NONE';
TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD = 'GEOGRAPHIC_DD';
TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS = 'GEOGRAPHIC_DMS';
TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED = 'PROJECTED';

var enumField = {
    NONE: 'NONE',
    COORDINATE_NUMBER: 'COORDINATE_NUMBER',
    LATITUDE_DEGREES: 'LATITUDE_DEGREES',
    LATITUDE_MINUTES: 'LATITUDE_MINUTES',
    LATITUDE_SECONDS: 'LATITUDE_SECONDS',
    LATITUDE_DMS: 'LATITUDE_DMS',
    LATITUDE_NS: 'LATITUDE_NS',
    NORTH_SOUTH: 'NORTH_SOUTH',
    LONGITUDE_DEGREES: 'LONGITUDE_DEGREES',
    LONGITUDE_MINUTES: 'LONGITUDE_MINUTES',
    LONGITUDE_SECONDS: 'LONGITUDE_SECONDS',
    LONGITUDE_DMS: 'LONGITUDE_DMS',
    LONGITUDE_EW: 'LONGITUDE_EW',
    EAST_WEST: 'EAST_WEST',
    X: 'X',
    Y: 'Y',
    DELETE: 'DELETE',
    INVALID_REASON: 'INVALID_REASON'
}

var enumNorthSouth = {
    NONE: 'NONE',
    NORTH: 'N',
    SOUTH: 'S'
}

var enumEastWest = {
    NONE: 'NONE',
    EAST: 'E',
    WEST: 'W'
}

var enumMode = {
    NONE: 0,
    VIEW: 'VIEW',
    EDIT: 'EDIT'
}

var enumFocusOnField = {
    PROVIDED: 'PROVIDED',
    NEXT: 'NEXT',
    PREVIOUS: 'PREVIOUS',
    ABOVE: 'ABOVE',
    BELOW: 'BELOW'
}

var enumKeyCode = {
    TAB: 9,
    ENTER: 13,
    UP: 38,
    DOWN: 40
}

var enumDropAction = {
    MOVE: 'MOVE',
    COPY: 'COPY'
}

// Class that holds the coordinates internally as xy and makes available to the outside the coordinates in the appropriate metric
function ShapeCoordinates(coordinateListEditor, arrXYCoordinates) {
    // Internal xy coordinates
    var arrCoordinatesInXY = arrXYCoordinates;
    var objCoordinateListEditor = coordinateListEditor;

    // Function to get coordinates in xy
    this.GetCoordinatesInXY = function () {
        var arrCoordinates = [];

        if (arrCoordinatesInXY) {
            // Splice the xy coordinates so that if the array is altered on the outside, it does not affect the internal xy coordinates array
            arrCoordinates = arrCoordinatesInXY.slice();
        }

        return arrCoordinates;
    };

    // Function to get the coordinates in the appropriate metric
    this.GetDisplayCoordinates = function () {
        var arrCoordinates = [];

        if (arrDisplayCoordinates) {
            // Splice the coordinates so that if the array is altered on the outside, it does not affect the internal coordinates array
            arrCoordinates = arrDisplayCoordinates.slice();
        } else {
            // Create coordinates in the appropriate metric using the xy coordinates array
            for (var index = 0; index < arrCoordinatesInXY.length; index++) {

                // Create and convert coordinate object ...
                var objConvertedCoordinate = fnConvertCoordinate(arrCoordinatesInXY[index]);
                // Add coordinate number
                objConvertedCoordinate.COORDINATE_NUMBER = index + 1;

                arrCoordinates.push(objConvertedCoordinate);
            }

            // Splice the coordinates so that if the array is altered on the outside, it does not affect the internal coordinates array
            arrDisplayCoordinates = arrCoordinates.slice();
        }

        return arrCoordinates;
    };

    // Function that returns the coordinate count
    this.DisplayCoordinatesCount = function () {
        return arrDisplayCoordinates.length;
    };

    // Function to add coordinate in xy
    this.AddCoordinate = function (objCoordinate, intIndex, blnOverwriteExistingCoordinate) {
        // As well as storing the coordinate in xy, we convert coordinate to store it in the appropriate metric
        var objConvertedCoordinate = fnConvertCoordinate(objCoordinate);

        // If index is provided, add coordinate at the index
        if (intIndex || intIndex === 0) {
            // Add coordinate number
            objConvertedCoordinate.COORDINATE_NUMBER = intIndex + 1;
            objCoordinate.COORDINATE_NUMBER = intIndex + 1;

            // Overwrite coordinate at the index
            if (blnOverwriteExistingCoordinate) {
                arrCoordinatesInXY[intIndex] = objCoordinate;
                arrDisplayCoordinates[intIndex] = objConvertedCoordinate;
            } else {
                // Add coordinate at index and shift all coordinates right of index
                arrCoordinatesInXY.splice(intIndex, 0, objCoordinate);
                arrDisplayCoordinates.splice(intIndex, 0, objConvertedCoordinate);
            }
        } else {
            // Add coordinate number
            objConvertedCoordinate.COORDINATE_NUMBER = arrDisplayCoordinates.length + 1;
            objCoordinate.COORDINATE_NUMBER = arrCoordinatesInXY.length + 1;

            // Add coordinate
            arrCoordinatesInXY.push(objCoordinate);
            arrDisplayCoordinates.push(objConvertedCoordinate);
        }
    };

    // Function to only add a display coordinate
    // Where as xy coordinates are always valid, these coordinates are not always valid as they could contain invalid/incomplete/blank coordinates
    this.AddDisplayCoordinate = function (objCoordinate, intIndex) {
        // Overwrite coordinate at index
        if (intIndex || intIndex === 0) {
            arrDisplayCoordinates[intIndex] = objCoordinate;
        } else {
            // Add coordinate
            arrDisplayCoordinates.push(objCoordinate);
        }
    };

    // Function to remove xy and display coordinate
    this.RemoveCoordinate = function (intIndex) {
        // Remove from xy coordinates array
        arrCoordinatesInXY.splice(intIndex, 1);
        // Remove from coordinates in appropriate metric array
        arrDisplayCoordinates.splice(intIndex, 1);
    };

    // Private function for converting xy coordinate to the appropriate metric
    var fnConvertCoordinate = function (objCoordinate) {
        // Create coordinate object ...
        var objConvertedCoordinate = objCoordinateListEditor.CreateCoordinate();

        // Update coordinate to appropriate metric using xy coordinates
        objCoordinateListEditor.UpdateCoordinateValuesFromXY(objConvertedCoordinate, objCoordinate);

        return objConvertedCoordinate;
    };

    // Coordinates array in the appropriate metric
    // Used for display and editing Coordinates
    // xy coordinates array is used for saving coordinates
    var arrDisplayCoordinates = this.GetDisplayCoordinates();
}

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    objDDorDMSDropDownPosition format: {top: [TOP], left: [LEFT]}
//           The relative offset from the top right corner of the grid
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateInstance = function CreateInstance(objContainerElement,
    strGroupSeparator,
    strDecimalSeparator,
    enCoordinateFormat,
    intGeographicSecondsDecimalPlaces,
    blnAllowGeographicFormatSelection,
    blnEditable,
    enGeometryType,
    enDefaultLongitudeDirection,
    enDefaultLatitudeDirection,
    blnProjectedFormatLongitudeThenLatitude,
    objDDorDMSDropDownPosition,
    strApplicationVirtualPath,
    blnCreateGeographicFormatSelection) {

    // Create the object that will hold the instance properties ...
    var objCoordinateListEditor = {
        ContainerElement: objContainerElement,
        IDPrefix: (typeof objContainerElement.attr('id') != 'undefined') ? objContainerElement.attr('id') : '',
        GroupSeparator: strGroupSeparator,
        DecimalSeparator: strDecimalSeparator,
        GeographicSecondsDecimalPlaces: intGeographicSecondsDecimalPlaces,
        AllowGeographicFormatSelection: blnAllowGeographicFormatSelection,
        GeometryType: enGeometryType,
        DecimalPlaces: null,
        ApplicationVirtualPath: (strApplicationVirtualPath !== undefined) ? strApplicationVirtualPath : '',
        DDorDMSDropDownPosition: objDDorDMSDropDownPosition,
        DefaultLongitudeDirection: enDefaultLongitudeDirection,
        DefaultLatitudeDirection: enDefaultLatitudeDirection,
        ProjectedFormatLongitudeThenLatitude: blnProjectedFormatLongitudeThenLatitude,
        Editable: false,
        CoordinateFormat: enCoordinateFormat,
        CoordinateListEditorDiv: null,
        Coordinates: null,
        ValueIdentifiers: [],
        InvalidFields: [],
        InvalidReasonIcons: {},
        FocussedValueIdentifier: null,
        FocussedTableCell: null,
        GeographicFormatSelectorPopupDiv: null,
        GeographicFormatSelectorHeaderCell: null,
        TableDOM: null,
        HeaderTableDOM: null,
        TableBodyDOM: null,
        InvalidReasonsDivDOM: null,
        SkipFocusOutHandler: false,
        SkipCoordinatesChanged: false,
        DraggingRow: false,
        DraggedCoordinate: null,
        DragArrowDOMElement: null,
        DragLineDOMElement: null,
        DragPlusDOMElement: null,
        DropAction: enumDropAction.MOVE,
        DropRowIndex: -1,
        DropBeforeIndex: false,
        LastUniqueId: 0,
        CoordinateChangedFunctions: [],
        CoordinatesChangedFunctions: [],
        CoordinateHoveredFunctions: [],
        GeographicFormatSelectorDiv: null,
        EventHandlersAttached: false,
        HighlightedCoordinateIndex: null,
        HoveredCoordinateIndex: null,
        Height: null,
        CoordinatesNiceScroll: null,
        CoordinatesPopulated: 0,
        CreateGeographicFormatSelection: blnCreateGeographicFormatSelection,

        InvalidReasonIconMouseEnterProxy: function (e) { objCoordinateListEditor.InvalidReasonIconMouseEnter(e); },
        InvalidReasonIconMouseLeaveProxy: function (e) { objCoordinateListEditor.InvalidReasonIconMouseLeave(e); },
        RowDragStartProxy: function (e, ui) { objCoordinateListEditor.RowDragStart(e, ui); },
        RowDragStopProxy: function (e, ui) { objCoordinateListEditor.RowDragStop(e, ui); },
        RowDragProxy: function (e, ui) { objCoordinateListEditor.RowDrag(e, ui); },
        CoordinateListEditorDivClickedProxy: function (e, object) { objCoordinateListEditor.CoordinateListEditorDivClicked(e, object); },
        CoordinateListEditorDivKeyupProxy: function (e, object) { objCoordinateListEditor.CoordinateListEditorDivKeyup(e, object); },
        CoordinateListEditorDivKeydownProxy: function (e, object) { objCoordinateListEditor.CoordinateListEditorDivKeydown(e, object); },
        FocusOutProxy: function (e) { objCoordinateListEditor.FocusOut(e); },
        ActivateGeographicFormatSelectorPopupProxy: function (objPopupCOntainerElement) { objCoordinateListEditor.ActivateGeographicFormatSelectorPopup(objPopupCOntainerElement); },
        DeActivateGeographicFormatSelectorPopupProxy: function () { objCoordinateListEditor.DeActivateGeographicFormatSelectorPopup(); },
        GeographicFormatSelectorClickedProxy: function (e) { objCoordinateListEditor.GeographicFormatSelectorClicked(e); },
        TableMouseLeaveProxy: function (e) { objCoordinateListEditor.TableMouseLeave(e); },
        TableMouseMoveProxy: function (e) { objCoordinateListEditor.TableMouseMove(e); },
        ScrolledProxy: function () { objCoordinateListEditor.Scrolled(); },

        CreateElements: TrimbleMap.CoordinateListEditor.CreateElements,
        SetHeight: TrimbleMap.CoordinateListEditor.SetHeight,
        AttachEventHandlers: TrimbleMap.CoordinateListEditor.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.CoordinateListEditor.DetachEventHandlers,
        ResetStateVariables: TrimbleMap.CoordinateListEditor.ResetStateVariables,
        GetNextField: TrimbleMap.CoordinateListEditor.GetNextField,
        GetPreviousField: TrimbleMap.CoordinateListEditor.GetPreviousField,
        GetAboveField: TrimbleMap.CoordinateListEditor.GetAboveField,
        GetBelowField: TrimbleMap.CoordinateListEditor.GetBelowField,
        CreateValueIdentifier: TrimbleMap.CoordinateListEditor.CreateValueIdentifier,
        GetValueIdentifierByField: TrimbleMap.CoordinateListEditor.GetValueIdentifierByField,
        GetValueIdentifierByCellID: TrimbleMap.CoordinateListEditor.GetValueIdentifierByCellID,
        SearchValueIdentifiers: TrimbleMap.CoordinateListEditor.SearchValueIdentifiers,
        SearchInvalidReasonIcons: TrimbleMap.CoordinateListEditor.SearchInvalidReasonIcons,
        PopulateGrid: TrimbleMap.CoordinateListEditor.PopulateGrid,
        PopulateCoordinates: TrimbleMap.CoordinateListEditor.PopulateCoordinates,
        AppendCoordinateRow: TrimbleMap.CoordinateListEditor.AppendCoordinateRow,
        CreateHeadingRow: TrimbleMap.CoordinateListEditor.CreateHeadingRow,
        CreateGeographicFormatSelectorCell: TrimbleMap.CoordinateListEditor.CreateGeographicFormatSelectorCell,
        CreateRow: TrimbleMap.CoordinateListEditor.CreateRow,
        UniqueID: TrimbleMap.CoordinateListEditor.UniqueID,
        AttachDragEventHandlers: TrimbleMap.CoordinateListEditor.AttachDragEventHandlers,
        PopulateValueCell: TrimbleMap.CoordinateListEditor.PopulateValueCell,
        GetNorthSouthTranslation: TrimbleMap.CoordinateListEditor.GetNorthSouthTranslation,
        GetEastWestTranslation: TrimbleMap.CoordinateListEditor.GetEastWestTranslation,
        CoordinatesValid: TrimbleMap.CoordinateListEditor.CoordinatesValid,
        LastCoordinateCompleted: TrimbleMap.CoordinateListEditor.LastCoordinateCompleted,
        CoordinateCount: TrimbleMap.CoordinateListEditor.CoordinateCount,
        ValidateRowMaximum: TrimbleMap.CoordinateListEditor.ValidateRowMaximum,
        ValidateRow: TrimbleMap.CoordinateListEditor.ValidateRow,
        UpdateRowEditableCells: TrimbleMap.CoordinateListEditor.UpdateRowEditableCells,
        GeographicSecondsMaximum: TrimbleMap.CoordinateListEditor.GeographicSecondsMaximum,
        ValidateField: TrimbleMap.CoordinateListEditor.ValidateField,
        ValidatePositiveNumber: TrimbleMap.CoordinateListEditor.ValidatePositiveNumber,
        ValidateAbsoluteValueBetween: TrimbleMap.CoordinateListEditor.ValidateAbsoluteValueBetween,
        ValidateIsNumber: TrimbleMap.CoordinateListEditor.ValidateIsNumber,
        ValidateDecimalPlaces: TrimbleMap.CoordinateListEditor.ValidateDecimalPlaces,
        UpdateInvalidFields: TrimbleMap.CoordinateListEditor.UpdateInvalidFields,
        UpdateFieldValueFromInterface: TrimbleMap.CoordinateListEditor.UpdateFieldValueFromInterface,
        AddEmptyRowWhenNeeded: TrimbleMap.CoordinateListEditor.AddEmptyRowWhenNeeded,
        InValidFieldsForRow: TrimbleMap.CoordinateListEditor.InValidFieldsForRow,
        RemoveInvalidFieldsForRow: TrimbleMap.CoordinateListEditor.RemoveInvalidFieldsForRow,
        IsFieldValid: TrimbleMap.CoordinateListEditor.IsFieldValid,
        IsCoordinateValid: TrimbleMap.CoordinateListEditor.IsCoordinateValid,
        RowValidationResults: TrimbleMap.CoordinateListEditor.RowValidationResults,
        UpdateCoordinateNumberSpans: TrimbleMap.CoordinateListEditor.UpdateCoordinateNumberSpans,
        AllCoordinateValuesEntered: TrimbleMap.CoordinateListEditor.AllCoordinateValuesEntered,
        AnyCoordinateValuesEntered: TrimbleMap.CoordinateListEditor.AnyCoordinateValuesEntered,
        RePopulateValueCell: TrimbleMap.CoordinateListEditor.RePopulateValueCell,
        UpdateInvalidReasonIcon: TrimbleMap.CoordinateListEditor.UpdateInvalidReasonIcon,
        UpdateAllInvalidReasonIcons: TrimbleMap.CoordinateListEditor.UpdateAllInvalidReasonIcons,
        UpdateDeleteIconsPosition: TrimbleMap.CoordinateListEditor.UpdateDeleteIconsPosition,
        ShowInvalidReasons: TrimbleMap.CoordinateListEditor.ShowInvalidReasons,
        HideInvalidReasons: TrimbleMap.CoordinateListEditor.HideInvalidReasons,
        ConvertDDToProjected: TrimbleMap.CoordinateListEditor.ConvertDDToProjected,
        ConvertProjectedToDD: TrimbleMap.CoordinateListEditor.ConvertProjectedToDD,
        ConvertDMSToDD: TrimbleMap.CoordinateListEditor.ConvertDMSToDD,
        ConvertDDToDMS: TrimbleMap.CoordinateListEditor.ConvertDDToDMS,
        GetTableCellForField: TrimbleMap.CoordinateListEditor.GetTableCellForField,
        FocusValueCell: TrimbleMap.CoordinateListEditor.FocusValueCell,
        DeleteRow: TrimbleMap.CoordinateListEditor.DeleteRow,
        RemoveValueIdentifiersForTableRow: TrimbleMap.CoordinateListEditor.RemoveValueIdentifiersForTableRow,
        CreateDropArrowAndLine: TrimbleMap.CoordinateListEditor.CreateDropArrowAndLine,
        CreateDropPlus: TrimbleMap.CoordinateListEditor.CreateDropPlus,
        PositionDropArrowAndLine: TrimbleMap.CoordinateListEditor.PositionDropArrowAndLine,
        ComputeHoveredRowIndex: TrimbleMap.CoordinateListEditor.ComputeHoveredRowIndex,
        ChangeCoordinate: TrimbleMap.CoordinateListEditor.ChangeCoordinate,
        ChangeCoordinates: TrimbleMap.CoordinateListEditor.ChangeCoordinates,
        ChangeProperties: TrimbleMap.CoordinateListEditor.ChangeProperties,
        InsertCoordinate: TrimbleMap.CoordinateListEditor.InsertCoordinate,
        ScrollbarVisible: TrimbleMap.CoordinateListEditor.ScrollbarVisible,
        Width: TrimbleMap.CoordinateListEditor.Width,
        CoordinatesChanged: TrimbleMap.CoordinateListEditor.CoordinatesChanged,
        FocusOut: TrimbleMap.CoordinateListEditor.FocusOut,
        CoordinateListEditorDivClicked: TrimbleMap.CoordinateListEditor.CoordinateListEditorDivClicked,
        CoordinateListEditorDivKeyup: TrimbleMap.CoordinateListEditor.CoordinateListEditorDivKeyup,
        CoordinateListEditorDivKeydown: TrimbleMap.CoordinateListEditor.CoordinateListEditorDivKeydown,
        CreateGeographicFormatSelectionPopupDiv: TrimbleMap.CoordinateListEditor.CreateGeographicFormatSelectionPopupDiv,
        GeographicFormatSelectorClicked: TrimbleMap.CoordinateListEditor.GeographicFormatSelectorClicked,
        InvalidReasonIconMouseEnter: TrimbleMap.CoordinateListEditor.InvalidReasonIconMouseEnter,
        InvalidReasonIconMouseLeave: TrimbleMap.CoordinateListEditor.InvalidReasonIconMouseLeave,
        RowDragStart: TrimbleMap.CoordinateListEditor.RowDragStart,
        RowDragStop: TrimbleMap.CoordinateListEditor.RowDragStop,
        CopyRowToEnd: TrimbleMap.CoordinateListEditor.CopyRowToEnd,
        RowDrag: TrimbleMap.CoordinateListEditor.RowDrag,
        AddOnCoordinateChangedCallback: TrimbleMap.CoordinateListEditor.AddOnCoordinateChangedCallback,
        AddOnCoordinatesChangedCallback: TrimbleMap.CoordinateListEditor.AddOnCoordinatesChangedCallback,
        AddOnCoordinateHoveredCallback: TrimbleMap.CoordinateListEditor.AddOnCoordinateHoveredCallback,
        TriggerCoordinateChangedCallbacks: TrimbleMap.CoordinateListEditor.TriggerCoordinateChangedCallbacks,
        TriggerCoordinatesChangedCallbacks: TrimbleMap.CoordinateListEditor.TriggerCoordinatesChangedCallbacks,
        TriggerCoordinateHoveredCallbacks: TrimbleMap.CoordinateListEditor.TriggerCoordinateHoveredCallbacks,
        SetDDorDMSDropDownPosition: TrimbleMap.CoordinateListEditor.SetDDorDMSDropDownPosition,
        PopulateMoreCoordinates: TrimbleMap.CoordinateListEditor.PopulateMoreCoordinates,

        ActivateCell: TrimbleMap.CoordinateListEditor.ActivateCell,
        ActivateCoordinate: TrimbleMap.CoordinateListEditor.ActivateCoordinate,
        ActivateGeographicFormatSelectorPopup: TrimbleMap.CoordinateListEditor.ActivateGeographicFormatSelectorPopup,
        DeActivateGeographicFormatSelectorPopup: TrimbleMap.CoordinateListEditor.DeActivateGeographicFormatSelectorPopup,
        SetEditable: TrimbleMap.CoordinateListEditor.SetEditable,
        GetCoordinates: TrimbleMap.CoordinateListEditor.GetCoordinates,
        SetCoordinates: TrimbleMap.CoordinateListEditor.SetCoordinates,
        UpdateCoordinateValuesFromXY: TrimbleMap.CoordinateListEditor.UpdateCoordinateValuesFromXY,
        ConvertCoordinateToXY: TrimbleMap.CoordinateListEditor.ConvertCoordinateToXY,
        GetInvalidOrInCompleteCoordinates: TrimbleMap.CoordinateListEditor.GetInvalidOrInCompleteCoordinates,
        AdjustCoordinateIndexForInvalidOrInCompleteRows: TrimbleMap.CoordinateListEditor.AdjustCoordinateIndexForInvalidOrInCompleteRows,
        IsCoordinateInvalidOrInComplete: TrimbleMap.CoordinateListEditor.IsCoordinateInvalidOrInComplete,
        HighlightCoordinate: TrimbleMap.CoordinateListEditor.HighlightCoordinate,
        ClearCoordinateHighlight: TrimbleMap.CoordinateListEditor.ClearCoordinateHighlight,
        EnsureCoordinatePopulated: TrimbleMap.CoordinateListEditor.EnsureCoordinatePopulated,
        TableMouseLeave: TrimbleMap.CoordinateListEditor.TableMouseLeave,
        TableMouseMove: TrimbleMap.CoordinateListEditor.TableMouseMove,
        Scrolled: TrimbleMap.CoordinateListEditor.Scrolled,
        UpdateScrollbar: TrimbleMap.CoordinateListEditor.UpdateScrollbar,
        ScrollToTop: TrimbleMap.CoordinateListEditor.ScrollToTop,
        ScrollCoordinateIntoView: TrimbleMap.CoordinateListEditor.ScrollCoordinateIntoView,
        GetFieldList: TrimbleMap.CoordinateListEditor.GetFieldList,
        GetDisplayFieldList: TrimbleMap.CoordinateListEditor.GetDisplayFieldList,
        GetEditableFields: TrimbleMap.CoordinateListEditor.GetEditableFields,
        CreateCoordinate: TrimbleMap.CoordinateListEditor.CreateCoordinate,
        GetCombinedFieldWidthInPixels: TrimbleMap.CoordinateListEditor.GetCombinedFieldWidthInPixels,
        GetFieldWidthInPixels: TrimbleMap.CoordinateListEditor.GetFieldWidthInPixels,
        GetTableWidthInPixels: TrimbleMap.CoordinateListEditor.GetTableWidthInPixels
    }

    // Create the main DOM elements ...
    objCoordinateListEditor.CreateElements();

    objCoordinateListEditor.Coordinates = new ShapeCoordinates(objCoordinateListEditor, []);

    // Return the instance ...
    return objCoordinateListEditor;
}

// **************************************************************************
// FUNCTION CreateElements: 
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateElements = function CreateElements() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Clear the container element ...
    objCoordinateListEditor.ContainerElement.empty();

    // Create the coordinte list editor div ...
    objCoordinateListEditor.CoordinateListEditorDiv = $('<div></div>');

    // When the geometry type is point ...
    if (objCoordinateListEditor.GeometryType == TrimbleMap.Shape.enumGeometryType.POINT) {

        // Add the class to indicate that it's a point editor ...
        objCoordinateListEditor.CoordinateListEditorDiv.addClass('coordinates_is_point_geometry_type');
    }

    // Add it to the container element ...
    objCoordinateListEditor.ContainerElement.append(objCoordinateListEditor.CoordinateListEditorDiv);

    // Set the positioning of the div to relative, so that all the absolutely positioned 
    // elements within the div is relative to the top left cornert of div ...
    objCoordinateListEditor.CoordinateListEditorDiv.css('position', 'relative');

    // Create a new heading html table ...
    objCoordinateListEditor.HeaderTableDOM = $('<table cellpadding="0" cellspacing="0"></table>');

    // Append the heading table to the table div tag ...
    objCoordinateListEditor.CoordinateListEditorDiv.append(objCoordinateListEditor.HeaderTableDOM);

    // Create a new div to hold the table ...
    objCoordinateListEditor.TableDiv = $('<div id="' + objCoordinateListEditor.UniqueID('TableDiv') + '" class="map_coordinatelisteditor_tablediv"></div>');

    // Append the table div to the main div tag ...
    objCoordinateListEditor.CoordinateListEditorDiv.append(objCoordinateListEditor.TableDiv);

    // Create a new html table ...
    objCoordinateListEditor.TableDOM = $('<table id="' + objCoordinateListEditor.UniqueID('Table') + '" cellpadding="0" cellspacing="0"></table>');

    objCoordinateListEditor.TableBodyDOM = $('<tbody></tbody>');

    // Append the table to the table div tag ...
    objCoordinateListEditor.TableDiv.append(objCoordinateListEditor.TableDOM);
}

// **************************************************************************
// FUNCTION SetHeight:
// **************************************************************************
TrimbleMap.CoordinateListEditor.SetHeight = function SetHeight(intHeight) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Set the height property ...
    objCoordinateListEditor.Height = intHeight;

    // Set the height of CoordinateListEditorDiv and TableDiv ...
    objCoordinateListEditor.TableDiv.height(intHeight - TrimbleMap.CoordinateListEditor.Shared.ROW_HEIGHT - 1 + 5);

    // Ensure the interface is filled with available coordinates all the way to the bottom ...
    objCoordinateListEditor.Scrolled();

    // Update the scrollbar ...
    objCoordinateListEditor.UpdateScrollbar(null, true);
}

// **************************************************************************
// FUNCTION UpdateScrollbar
// USAGE    blnEventHandlersAttachedOverride is optional, it overrides the value obtained from 
//          objCoordinateListEditor.EventHandlersAttached when set
//          blnResizing is optional, defaults to false
// **************************************************************************
TrimbleMap.CoordinateListEditor.UpdateScrollbar = function UpdateScrollbar(blnEventHandlersAttachedOverride, blnResizing) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Override EventHandlersAttached with blnEventHandlersAttachedOverride when specified ...
    var blnEventHandlersAttached = ((typeof blnEventHandlersAttachedOverride != 'undefined') && (blnEventHandlersAttachedOverride != null)) ? blnEventHandlersAttachedOverride : objCoordinateListEditor.EventHandlersAttached;

    // When a scrollbar is needed ...
    if (blnEventHandlersAttached && (objCoordinateListEditor.TableDiv.innerHeight() < objCoordinateListEditor.TableDOM.outerHeight())) {

        // When the coordinates are not scrollable ...
        if (!objCoordinateListEditor.CoordinatesNiceScroll) {

            // Make the coordinates scrollable ...
            objCoordinateListEditor.CoordinatesNiceScroll = objCoordinateListEditor.TableDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" }); // to make rail dark blue: cursorcolor: "#191970"
        }

        // Add the class that shows the bottom border ...
        objCoordinateListEditor.TableDiv.addClass('map_coordinatelisteditor_tablediv_scrolling');

    } else {

        // When we are not busy resizing ...
        if ((typeof blnResizing == 'undefined') || !blnResizing) {

            // When the coordinates are scrollable ...
            if (objCoordinateListEditor.CoordinatesNiceScroll) {

                // Remove the scrollbar ...
                objCoordinateListEditor.CoordinatesNiceScroll.remove();
                objCoordinateListEditor.CoordinatesNiceScroll = null;
            }
        }

        // Remove the class that shows the bottom border ...
        objCoordinateListEditor.TableDiv.removeClass('map_coordinatelisteditor_tablediv_scrolling');
    }
}

// **************************************************************************
// FUNCTION ScrollToTop
// USAGE    
// **************************************************************************
TrimbleMap.CoordinateListEditor.ScrollToTop = function ScrollToTop() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Scroll the coordinates to the top ...
    objCoordinateListEditor.TableDiv.scrollTop(0);
}

// **************************************************************************
// FUNCTION ScrollCoordinateIntoView
// USAGE    
// **************************************************************************
TrimbleMap.CoordinateListEditor.ScrollCoordinateIntoView = function ScrollCoordinateIntoView(intCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Compute the top and bottom Y of the row in which the coordinate is displayed ...
    var intRowTopY = intCoordinate * TrimbleMap.CoordinateListEditor.Shared.ROW_HEIGHT;
    var intRowBottomY = intRowTopY + TrimbleMap.CoordinateListEditor.Shared.ROW_HEIGHT;

    // Get the scroll position ...
    var intSrollTop = objCoordinateListEditor.TableDiv.scrollTop();

    // Get the coordinate list height ...
    var intCoordinateListHeight = parseInt(objCoordinateListEditor.TableDiv.outerHeight());

    // When the top of the row is above the top of the coordinate list ...
    if (intRowTopY - intSrollTop < 0) {

        // Scroll the coordinate to be displayed at the top ...
        objCoordinateListEditor.TableDiv.scrollTop(intRowTopY);

        // When the bottom of the row is below the bottom of the coordinate list ...
    } else if (intRowBottomY - intSrollTop > intCoordinateListHeight) {

        // Scroll the coordinate to be displayed at the bottom ...
        objCoordinateListEditor.TableDiv.scrollTop(intRowBottomY - intCoordinateListHeight + 2);
    }
}

// **************************************************************************
// FUNCTION AttachEventHandlers: 
// **************************************************************************
TrimbleMap.CoordinateListEditor.AttachEventHandlers = function AttachEventHandlers() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the event handlers are not attached ...
    if (!objCoordinateListEditor.EventHandlersAttached) {

        // When editable ...
        if (objCoordinateListEditor.Editable) {

            // Attach the focusout event handler ...
            objCoordinateListEditor.CoordinateListEditorDiv.focusout(objCoordinateListEditor.FocusOutProxy);

            // Attach a click event handler ...
            objCoordinateListEditor.CoordinateListEditorDiv.click(objCoordinateListEditor.CoordinateListEditorDivClickedProxy);

            // Attach keypress event handler ...
            objCoordinateListEditor.CoordinateListEditorDiv.keyup(objCoordinateListEditor.CoordinateListEditorDivKeyupProxy);

            // Attach keypress event handler ...
            objCoordinateListEditor.CoordinateListEditorDiv.keydown(objCoordinateListEditor.CoordinateListEditorDivKeydownProxy);

            // Attach the mouse enter event handlers to the invalid reason icons ...
            $(objCoordinateListEditor.CoordinateListEditorDiv.find('[InvalidReasonIconID]')).mouseenter(objCoordinateListEditor.InvalidReasonIconMouseEnterProxy);

            // Attach the mouse leave event handlers to the invalid reason icons ...
            $(objCoordinateListEditor.CoordinateListEditorDiv.find('[InvalidReasonIconID]')).mouseleave(objCoordinateListEditor.InvalidReasonIconMouseLeaveProxy);

            // Get the draggable cells ...
            var arrDraggableCells = $(objCoordinateListEditor.CoordinateListEditorDiv.find('.CoordinateNumberCell'));

            // Make the cells draggable ...
            objCoordinateListEditor.AttachDragEventHandlers(arrDraggableCells);
        }

        // Attach the mouse move and mouse leave event handlers to the TableDOM element ...
        objCoordinateListEditor.TableDOM.on('mousemove',(objCoordinateListEditor.TableMouseMoveProxy));
        objCoordinateListEditor.TableDOM.on('mouseleave',(objCoordinateListEditor.TableMouseLeaveProxy));

        // Attach a scroll event ...
        objCoordinateListEditor.TableDiv.on('scroll',(objCoordinateListEditor.ScrolledProxy));

        // When we have a geographic format selector popup ...
        if (objCoordinateListEditor.GeographicFormatSelectorPopup) {

            // Attach the event handlers for the geographic format selector popup ...
            objCoordinateListEditor.GeographicFormatSelectorPopup.AttachEventHandlers();
        }

        // Update the scrollbar ...
        objCoordinateListEditor.UpdateScrollbar(true);

        // Set to have attached the event handlers ...
        objCoordinateListEditor.EventHandlersAttached = true;
    }
}

// **************************************************************************
// FUNCTION DetachEventHandlers: 
// **************************************************************************
TrimbleMap.CoordinateListEditor.DetachEventHandlers = function DetachEventHandlers() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the event handlers are attached ...
    if (objCoordinateListEditor.EventHandlersAttached) {

        // When editable ...
        if (objCoordinateListEditor.Editable) {

            // Detach the focusout event handler ...
            objCoordinateListEditor.CoordinateListEditorDiv.off('focusout', objCoordinateListEditor.FocusOutProxy);

            // Detach a click event handler ...
            objCoordinateListEditor.CoordinateListEditorDiv.off('click', objCoordinateListEditor.CoordinateListEditorDivClickedProxy);

            // Detach keypress event handler ...
            objCoordinateListEditor.CoordinateListEditorDiv.off('keyup', objCoordinateListEditor.CoordinateListEditorDivKeyupProxy);

            // Detach keypress event handler ...
            objCoordinateListEditor.CoordinateListEditorDiv.off('keydown', objCoordinateListEditor.CoordinateListEditorDivKeydownProxy);

            // Detach the mouse enter event handlers to the invalid reason icons ...
            $(objCoordinateListEditor.CoordinateListEditorDiv.find('[InvalidReasonIconID]')).off('mouseenter', objCoordinateListEditor.InvalidReasonIconMouseEnterProxy);

            // Detach the mouse leave event handlers to the invalid reason icons ...
            $(objCoordinateListEditor.CoordinateListEditorDiv.find('[InvalidReasonIconID]')).off('mouseleave', objCoordinateListEditor.InvalidReasonIconMouseLeaveProxy);

            // When the geometry type is not point ...
            if (objCoordinateListEditor.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT) {

                // Get the draggable cells ...
                var objDraggableCells = $(objCoordinateListEditor.CoordinateListEditorDiv.find('.CoordinateNumberCell'));

                // Destroy the draggables ...
                objDraggableCells.draggable('destroy');
            }
        }

        // Attach the mouse move and mouse leave event handlers to the TableDOM element ...
        objCoordinateListEditor.TableDOM.off('mousemove', objCoordinateListEditor.TableMouseMoveProxy);
        objCoordinateListEditor.TableDOM.off('mouseleave', objCoordinateListEditor.TableMouseLeaveProxy);

        // Detach the scroll event ...
        objCoordinateListEditor.TableDiv.off('scroll', objCoordinateListEditor.ScrolledProxy);

        // When we have a geographic format selector popup ...
        if (objCoordinateListEditor.GeographicFormatSelectorPopup) {

            // Attach the event handlers for the geographic format selector popup ...
            objCoordinateListEditor.GeographicFormatSelectorPopup.DetachEventHandlers();
        }

        // Update the scrollbar ...
        objCoordinateListEditor.UpdateScrollbar(false);

        // Set to have detached the event handlers ...
        objCoordinateListEditor.EventHandlersAttached = false;
    }
}

// **************************************************************************
// FUNCTION ResetStateVariables: Reset all the state variables ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ResetStateVariables = function ResetStateVariables() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Intialize some other properties ...
    objCoordinateListEditor.ValueIdentifiers = [];
    objCoordinateListEditor.InvalidFields = [];
    objCoordinateListEditor.InvalidReasonIcons = {};
    objCoordinateListEditor.FocussedValueIdentifier = null;
    objCoordinateListEditor.FocussedTableCell = null;
    objCoordinateListEditor.GeographicFormatSelectorPopupDiv = null;
    objCoordinateListEditor.GeographicFormatSelectorHeaderCell = null;
    objCoordinateListEditor.InvalidReasonsDivDOM = null;
    objCoordinateListEditor.SkipFocusOutHandler = false;
    objCoordinateListEditor.SkipCoordinatesChanged = false;
    objCoordinateListEditor.DraggingRow = false;
    objCoordinateListEditor.DraggedCoordinate = null;
    objCoordinateListEditor.DragArrowDOMElement = null;
    objCoordinateListEditor.DragLineDOMElement = null;
    objCoordinateListEditor.DragPlusDOMElement = null;
    objCoordinateListEditor.DropAction = enumDropAction.MOVE;
    objCoordinateListEditor.DropRowIndex = -1;
    objCoordinateListEditor.DropBeforeIndex = false;
}

// **************************************************************************
// FUNCTION GetNextField: Returns the next field in the row after the field identified by objValueIdentifier ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetNextField = function GetNextField(objValueIdentifier) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the list of editable fields for the coordinate format ...
    var arrEditableFields = (objCoordinateListEditor.Editable) ? objCoordinateListEditor.GetEditableFields() : [];

    // Get the position of the field of the ValueIdentifier in the array of editable fields ...
    var intField = $.inArray(objValueIdentifier.Field, arrEditableFields);

    // Declare a variable to place the next value identifer in ...
    var objNextValueIdentifier;

    // When not the last entry in the list ...
    if (intField < arrEditableFields.length - 1) {

        // The next field in the current row will be the next value ...
        objNextValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(objValueIdentifier.Coordinate, arrEditableFields[intField + 1]);
    }
    else {

        // Get coordinates in appropriate metric
        var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

        // Get the index of the row in Coordinates ...
        var intRow = arrDisplayCoordinates.findIndex(function (objCoordinate) {
            return objCoordinate.COORDINATE_NUMBER === objValueIdentifier.Coordinate.COORDINATE_NUMBER;
        });

        // When we are not in the last row ...
        if (intRow < arrDisplayCoordinates.length - 1) {

            // The first field in the next row will be the next value ...
            objNextValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(arrDisplayCoordinates[intRow + 1], arrEditableFields[0]);
        } else {

            // Return null to indicate that there is no next field  ...
            objNextValueIdentifier = null;
        }
    }

    return objNextValueIdentifier;
}

// **************************************************************************
// FUNCTION GetPreviousField: Returns the previous field in the row before the field identified by objValueIdentifier ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetPreviousField = function GetPreviousField(objValueIdentifier) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the list of editable fields for the coordinate format ...
    var arrEditableFields = (objCoordinateListEditor.Editable) ? objCoordinateListEditor.GetEditableFields() : [];

    // Get the position of the field of the ValueIdentifier in the array of editable fields ...
    var intField = $.inArray(objValueIdentifier.Field, arrEditableFields);

    // Declare a variable to place the next value identifier in ...
    var objNextValueIdentifier;

    // When not the first entry in the list ...
    if (intField > 0) {

        // The previous field in the current row will be the next value ...
        objNextValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(objValueIdentifier.Coordinate, arrEditableFields[intField - 1]);
    }
    else {

        // Get coordinates in appropriate metric
        var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

        // Get the index of the row in Coordinates ...
        var intRow = arrDisplayCoordinates.findIndex(function (objCoordinate) {
            return objCoordinate.COORDINATE_NUMBER === objValueIdentifier.Coordinate.COORDINATE_NUMBER;
        });

        // When we are not in the first row ...
        if (intRow > 0) {

            // The last field in the previous row will be the previous value ...
            objNextValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(arrDisplayCoordinates[intRow - 1], arrEditableFields[arrEditableFields.length - 1]);
        }
        else {

            // Return null to indicate that there is no previous field  ...
            objNextValueIdentifier = null;
        }
    }

    return objNextValueIdentifier;
}

// **************************************************************************
// FUNCTION GetAboveField: Returns the field in the row above ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetAboveField = function GetAboveField(objValueIdentifier) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Declare a variable to place the above value identifer in ...
    var objNextValueIdentifier;

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Get the index of the row in Coordinates ...
    var intRow = arrDisplayCoordinates.findIndex(function (objCoordinate) {
        return objCoordinate.COORDINATE_NUMBER === objValueIdentifier.Coordinate.COORDINATE_NUMBER;
    });

    // When we are not in the first row ...
    if (intRow > 0) {

        // Get the field in the row above ...
        objNextValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(arrDisplayCoordinates[intRow - 1], objValueIdentifier.Field);
    }
    else {

        // Return null to indicate that there is no above field  ...
        objNextValueIdentifier = null;
    }

    return objNextValueIdentifier;
}

// **************************************************************************
// FUNCTION GetBelowField: Returns the field in the row below ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetBelowField = function GetBelowField(objValueIdentifier) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Declare a variable to place the below value identifer in ...
    var objNextValueIdentifier;

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Get the index of the row in Coordinates ...
    var intRow = arrDisplayCoordinates.findIndex(function (objCoordinate) {
        return objCoordinate.COORDINATE_NUMBER === objValueIdentifier.Coordinate.COORDINATE_NUMBER;
    });

    // When we are not in the last row ...
    if (intRow < arrDisplayCoordinates.length - 1) {

        // Get the field in the row below ...
        objNextValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(arrDisplayCoordinates[intRow + 1], objValueIdentifier.Field);
    }
    else {

        // Return null to indicate that there is no below field  ...
        objNextValueIdentifier = null;
    }

    return objNextValueIdentifier;
}

// **************************************************************************
// FUNCTION GetValueIdentifier: Returns a new ValueIdentifer when the field is not in the invalid 
//                              fields array, otherwise returns the identifer from the list ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetValueIdentifierByField = function GetValueIdentifierByField(objCoordinate, enField, blnCreateValueIdentifier) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Value identifier to be returned if found
    var objValueIdentifier = null;

    // Search for the value identifier if one should not be created
    if (!blnCreateValueIdentifier) {
        // Search for an invalid field using the row and field ...
        objValueIdentifier = objCoordinateListEditor.SearchValueIdentifiers(objCoordinate, enField);
    }

    // When value identifier has not been found or we should create one
    if (objValueIdentifier == null || blnCreateValueIdentifier) {

        // Create a new value identifier ...
        objValueIdentifier = objCoordinateListEditor.CreateValueIdentifier(objCoordinate, enField, objCoordinateListEditor.CoordinateFormat, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator, objCoordinateListEditor.DecimalPlaces, objCoordinateListEditor.GeographicSecondsDecimalPlaces);

        // Add the value identifier to the array ...
        objCoordinateListEditor.ValueIdentifiers.push(objValueIdentifier);
    }

    return objValueIdentifier;
}

// **************************************************************************
// FUNCTION GetValueIdentifier: Returns a new ValueIdentifer which a cell is related to
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetValueIdentifierByCellID = function GetValueIdentifierByCellID(strCellId) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Loop through all the invalid fields ...
    for (var intValueIdentifier = 0; intValueIdentifier < objCoordinateListEditor.ValueIdentifiers.length; intValueIdentifier++) {

        // Get the invalid field at the index ...
        var objValueIdentifier = objCoordinateListEditor.ValueIdentifiers[intValueIdentifier];

        if (objValueIdentifier.RelatedCell === strCellId) {
            return objValueIdentifier;
        }
    }

    return null;
}

// **************************************************************************
// FUNCTION SearchValueIdentifiers: Search for the invalid field for the row and field ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.SearchValueIdentifiers = function SearchValueIdentifiers(objCoordinate, enField) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Search for value identifiers based on coordinate only if it is valid/complete/not blank
    // Plus sign represents the coordinate being one of the following above
    if (objCoordinate.COORDINATE_NUMBER !== "+") {
        // Loop through all the invalid fields ...
        for (var intValueIdentifier = 0; intValueIdentifier < objCoordinateListEditor.ValueIdentifiers.length; intValueIdentifier++) {

            // Get the invalid field at the index ...
            var objValueIdentifier = objCoordinateListEditor.ValueIdentifiers[intValueIdentifier];

            // When the row object and field matches ...
            if (objValueIdentifier.Coordinate.COORDINATE_NUMBER == objCoordinate.COORDINATE_NUMBER && objValueIdentifier.Field == enField) {

                // Return the value identifier ...
                return objValueIdentifier;
            }
        }
    }

    // Not found ...
    return null;
}

// **************************************************************************
// FUNCTION SearchInvalidReasonIcons: Search for the invalid field for the row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.SearchInvalidReasonIcons = function SearchInvalidReasonIcons(objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Start with not found ...
    var objInvalidReasonIcon = null;

    // Loop through all the invalid reason icons ...
    $.each(objCoordinateListEditor.InvalidReasonIcons, function (strTestInvalidaReasonIconID, objTestInvalidReasonIcon) {

        // When the row object matches ...
        if (objTestInvalidReasonIcon.Coordinate == objCoordinate) {

            // Set to return the invalid reason icon ... 
            objInvalidReasonIcon = objTestInvalidReasonIcon;
        }
    });

    // Return the icon ...
    return objInvalidReasonIcon;
}

// **************************************************************************
// FUNCTION PopulateGrid: Creates the grid inside the ContainerElement and populates it 
//                        with the coordinates from arrCoordinates ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.PopulateGrid = function PopulateGrid() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get coordinates in appropriate metric
    var intDisplayCoordinates = objCoordinateListEditor.Coordinates.DisplayCoordinatesCount();

    // When the coordinates array is empty ...
    if (intDisplayCoordinates == 0) {

        // Create a new array for the coordinate list values ...
        objCoordinateListEditor.Coordinates = new ShapeCoordinates(objCoordinateListEditor, []);

        // When editable ...
        if (objCoordinateListEditor.Editable) {

            // Create a new empty row object ...
            var objCoordinate = objCoordinateListEditor.CreateCoordinate();

            // Add the row object to the array ...
            objCoordinateListEditor.Coordinates.AddDisplayCoordinate(objCoordinate);
        }
    }

    // Clear all the header table rows ...
    objCoordinateListEditor.HeaderTableDOM.empty();

    // Create the row headings and append it to the table ...
    objCoordinateListEditor.HeaderTableDOM.append(objCoordinateListEditor.CreateHeadingRow(objCoordinateListEditor.CoordinateFormat));

    // Clear all the table rows ...
    objCoordinateListEditor.TableDOM.empty();
    objCoordinateListEditor.TableBodyDOM.empty();

    // Scroll to the top ...
    setTimeout(function () { objCoordinateListEditor.ScrollToTop(); }, 0);

    // Start with 0 coordinates populated ...
    objCoordinateListEditor.CoordinatesPopulated = 0;

    // Get coordinates in appropriate metric count
    intDisplayCoordinates = objCoordinateListEditor.Coordinates.DisplayCoordinatesCount();

    // When we have more than BLOCK_SIZE coordinates, set to only load BLOCK_SIZE coordinates upfront ...
    var intRowsToLoad = (intDisplayCoordinates > TrimbleMap.CoordinateListEditor.Shared.BLOCK_SIZE) ? TrimbleMap.CoordinateListEditor.Shared.BLOCK_SIZE : intDisplayCoordinates;

    // Populate the coordinates ...
    objCoordinateListEditor.PopulateCoordinates(0, intRowsToLoad);

    // Add an empty row when needed ...
    objCoordinateListEditor.AddEmptyRowWhenNeeded();

    // Update all the invalid reason icons for all the rows ...
    objCoordinateListEditor.UpdateAllInvalidReasonIcons();

    // Update the scrollbar ...
    objCoordinateListEditor.UpdateScrollbar();
}

// **************************************************************************
// FUNCTION PopulateCoordinates: 
// **************************************************************************
TrimbleMap.CoordinateListEditor.PopulateCoordinates = function PopulateCoordinates(intStartCoordinate, intEndCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get coordinates in appropriate metric count
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Loop through all the rows in the array ...
    for (let intCoordinate = intStartCoordinate; (intCoordinate < arrDisplayCoordinates.length) && (intCoordinate < intEndCoordinate); intCoordinate++) {

        // Get the row object ...
        var objCoordinate = arrDisplayCoordinates[intCoordinate];

        // Validate the row ...
        objCoordinateListEditor.ValidateRow(objCoordinate, objCoordinateListEditor.CoordinateFormat);

        // Create the html row with contents ...
        var objRow = objCoordinateListEditor.CreateRow(objCoordinate);

        // Append the coordinate row ...
        objCoordinateListEditor.AppendCoordinateRow(objRow);
    }
}

// **************************************************************************
// FUNCTION AppendCoordinateRow: 
// **************************************************************************
TrimbleMap.CoordinateListEditor.AppendCoordinateRow = function AppendCoordinateRow(objCoordinateRow) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    if (objCoordinateListEditor.TableDOM.find('> tbody').length == 0) {
        objCoordinateListEditor.TableDOM.append(objCoordinateListEditor.TableBodyDOM);
    }

    // Append it to the table ...
    objCoordinateListEditor.TableDOM.find('> tbody').append(objCoordinateRow);

    // Increment the number of coordinates populated ...
    objCoordinateListEditor.CoordinatesPopulated++;
}

// **************************************************************************
// FUNCTION Scrolled
// USAGE    
// **************************************************************************
TrimbleMap.CoordinateListEditor.Scrolled = function Scrolled() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the coordinates list is visible on the interface ...
    if (objCoordinateListEditor.TableDiv.is(':visible')) {

        // Get the scroll top ...
        var intScrollTop = parseInt(objCoordinateListEditor.TableDiv.scrollTop());

        // Get the heigth of all the coordinate DOM elements ...
        var intCoordinatesHeight = parseInt(objCoordinateListEditor.TableDOM.outerHeight());

        // Get the available height ...
        var intAvailableHeight = parseInt(objCoordinateListEditor.TableDiv.outerHeight());

        // Compute the y position to be used as a trigger to add more coordinates ...
        var intTrigger = intCoordinatesHeight - intScrollTop - TrimbleMap.CoordinateListEditor.Shared.BLOCK_LOAD_BUFFER_PX;

        // When the trigger position has been scrolled to above the bottom of the list ...
        if (intTrigger < intAvailableHeight) {

            // Calculate the available space ...
            var intAvailableSpace = intAvailableHeight - (intCoordinatesHeight - intScrollTop);

            // Populate more coordinates to fill the available space ...
            objCoordinateListEditor.PopulateMoreCoordinates(intAvailableSpace, intCoordinatesHeight);
        }
    }
}

// **************************************************************************
// FUNCTION PopulateMoreCoordinates
// USAGE    
// **************************************************************************
TrimbleMap.CoordinateListEditor.PopulateMoreCoordinates = function PopulateMoreCoordinates(intAvailabeSpace, intCoordinatesHeight) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get coordinates in appropriate metric count
    var intDisplayCoordinates = objCoordinateListEditor.Coordinates.DisplayCoordinatesCount();

    // When not all coordinates have been populated yet ...
    if (objCoordinateListEditor.CoordinatesPopulated < intDisplayCoordinates) {

        // Populate the next block of coordinates (at least once) ...
        objCoordinateListEditor.PopulateCoordinates(objCoordinateListEditor.CoordinatesPopulated, objCoordinateListEditor.CoordinatesPopulated + TrimbleMap.CoordinateListEditor.Shared.BLOCK_SIZE);

        // When not all coordinates have been populated yet ...
        if (objCoordinateListEditor.CoordinatesPopulated < intDisplayCoordinates) {

            // Get the height of all the coordinate DOM elements ...
            var intCoordinatesHeightAfterAdding = parseInt(objCoordinateListEditor.TableDOM.outerHeight());

            // Set to 0 when undefined ...
            if (typeof intCoordinatesHeightAfterAdding == 'undefined') { intCoordinatesHeightAfterAdding = 0; }

            // Compute the filled space ...
            var intFilledSpace = (intCoordinatesHeightAfterAdding - intCoordinatesHeight);

            // Continue to populate blocks of more coordinates until we've filled the available space ...
            while (intFilledSpace < intAvailabeSpace) {

                // Populate the next block of coordinates ...
                objCoordinateListEditor.PopulateCoordinates(objCoordinateListEditor.CoordinatesPopulated, objCoordinateListEditor.CoordinatesPopulated + TrimbleMap.CoordinateListEditor.Shared.BLOCK_SIZE);

                // Get the height of all the coordinate DOM elements ...
                intCoordinatesHeightAfterAdding = parseInt(objCoordinateListEditor.TableDOM.outerHeight());

                // Compute the filled space ...
                intFilledSpace = (intCoordinatesHeightAfterAdding - intCoordinatesHeight);
            }
        }

        // When the coordinates are scrollable ...
        if (objCoordinateListEditor.CoordinatesNiceScroll) {

            // Resize the scrollbar ...
            objCoordinateListEditor.CoordinatesNiceScroll.resize();
        }
    }
}

// **************************************************************************
// FUNCTION CreateHeadingRow: Create row headings for the coordinate format ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateHeadingRow = function CreateHeadingRow(enCoordinateFormat) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new html table row ...
    var objRow = $('<tr></tr>');

    // Create the row headings for the coordinate format ...
    switch (enCoordinateFormat) {

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED:

            // Compute the column widths ...
            var intNumberCellWidth = objCoordinateListEditor.GetFieldWidthInPixels(enumField.COORDINATE_NUMBER);
            var intXWidth = objCoordinateListEditor.GetFieldWidthInPixels(enumField.X);
            var intYWidth = objCoordinateListEditor.GetFieldWidthInPixels(enumField.Y);
            var intDeleteWidth = objCoordinateListEditor.GetCombinedFieldWidthInPixels([enumField.DELETE, enumField.INVALID_REASON]);

            // Create the cells ...
            var objCoordinatesNumberCell = $('<td class="CoordinatesNumberHeader" style="width:' + intNumberCellWidth + 'px">&nbsp;</td>');
            var objXCell = $('<td class="CoordinatesHeader" style="width:' + intXWidth + 'px"><span>' + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'East') + '</span></td>');
            var objYCell = $('<td class="CoordinatesHeader" style="width:' + intYWidth + 'px"><span>' + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'North') + '</span></td>');
            var objLastCell = $('<td class="CoordinatesHeader" colspan="2" style="width:' + intDeleteWidth + 'px"><div style="height:0px"><div></td>');

            // Add the cells to the row ...
            objRow.append(objCoordinatesNumberCell);
            if (objCoordinateListEditor.ProjectedFormatLongitudeThenLatitude) {
                objRow.append(objXCell);
                objRow.append(objYCell);
            } else {
                objRow.append(objYCell);
                objRow.append(objXCell);
            }
            objRow.append(objLastCell);
            break;

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD:

            // Compute the column widths ...
            var intNumberCellWidth = objCoordinateListEditor.GetFieldWidthInPixels(enumField.COORDINATE_NUMBER);
            var intLatitudeWidth = objCoordinateListEditor.GetCombinedFieldWidthInPixels([enumField.LATITUDE_DEGREES, enumField.NORTH_SOUTH]);
            var intLongitudeWidth = objCoordinateListEditor.GetCombinedFieldWidthInPixels([enumField.LONGITUDE_DEGREES, enumField.EAST_WEST]) + 'px"><span>' + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'Longitude');
            var intDeleteWidth = objCoordinateListEditor.GetCombinedFieldWidthInPixels([enumField.DELETE, enumField.INVALID_REASON]);

            // Create the cells ...
            var objCoordinatesNumberCell = $('<td class="CoordinatesHeader" style="width:' + intNumberCellWidth + 'px">&nbsp;</td>');
            var objLatitudeCell = $('<td class="CoordinatesHeader" colspan="' + ((objCoordinateListEditor.Editable) ? 2 : 1) + '" style="width:' + intLatitudeWidth + 'px"><span>' + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'Latitude') + '</span></td>');
            var objLongitudeCell = $('<td class="CoordinatesHeader" colspan="' + ((objCoordinateListEditor.Editable) ? 2 : 1) + '" style="width:' + intLongitudeWidth + '</span></td>');
            var objLastCell = $('<td class="CoordinatesHeader" style="width:' + intDeleteWidth + 'px">&nbsp;</td>');

            // Add the cells to the row ...
            objRow.append(objCoordinatesNumberCell);
            objRow.append(objLatitudeCell);
            objRow.append(objLongitudeCell);
            objRow.append(objLastCell);

            if (objCoordinateListEditor.CreateGeographicFormatSelection) {
                // Create the geographic format cell and content and set the object level variable ...
                objCoordinateListEditor.GeographicFormatSelectorHeaderCell = objCoordinateListEditor.CreateGeographicFormatSelectorCell(enCoordinateFormat);

                // Append the geographic format cell to the row ...
                objRow.append(objCoordinateListEditor.GeographicFormatSelectorHeaderCell);
            }
            break;

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS:

            // Compute the column widths ...
            var intNumberCellWidth = objCoordinateListEditor.GetFieldWidthInPixels(enumField.COORDINATE_NUMBER);
            var intLatitudeWidth = objCoordinateListEditor.GetCombinedFieldWidthInPixels([enumField.LATITUDE_DEGREES, enumField.LATITUDE_MINUTES, enumField.LATITUDE_SECONDS, enumField.NORTH_SOUTH]);
            var intLongitudeWidth = objCoordinateListEditor.GetCombinedFieldWidthInPixels([enumField.LONGITUDE_DEGREES, enumField.LONGITUDE_MINUTES, enumField.LONGITUDE_SECONDS, enumField.EAST_WEST]);
            var intDeleteWidth = objCoordinateListEditor.GetCombinedFieldWidthInPixels([enumField.DELETE, enumField.INVALID_REASON]);

            // Create the cells ...
            var objCoordinatesNumberCell = $('<td class="CoordinatesHeader" style="width:' + intNumberCellWidth + 'px">&nbsp;</td>');
            var objLatitudeCell = $('<td  class="CoordinatesHeader" colspan="' + ((objCoordinateListEditor.Editable) ? 4 : 1) + '" style="width:' + intLatitudeWidth + 'px"><span>' + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'Latitude') + '</span></td>');
            var objLongitudeCell = $('<td  class="CoordinatesHeader" colspan="' + ((objCoordinateListEditor.Editable) ? 4 : 1) + '" style="width:' + intLongitudeWidth + 'px"><span>' + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'Longitude') + '</span></td>');
            var objLastCell = $('<td class="CoordinatesHeader" style="width:' + intDeleteWidth + 'px">&nbsp;</td>');

            // Add the cells to the row ...
            objRow.append(objCoordinatesNumberCell);
            objRow.append(objLatitudeCell);
            objRow.append(objLongitudeCell);
            objRow.append(objLastCell);

            if (objCoordinateListEditor.CreateGeographicFormatSelection) {
                // Create the geographic format cell and content and set the object level variable ...
                objCoordinateListEditor.GeographicFormatSelectorHeaderCell = objCoordinateListEditor.CreateGeographicFormatSelectorCell(enCoordinateFormat);

                // Append the geographic format cell to the row ...
                objRow.append(objCoordinateListEditor.GeographicFormatSelectorHeaderCell);
            }
            break;
    }

    return objRow;
}

// **************************************************************************
// FUNCTION CreateGeographicFormatSelectorCell: Creates the geographic format selector cell and content ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateGeographicFormatSelectorCell = function CreateGeographicFormatSelectorCell(enCoordinateFormat) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get a new unique id for the cell ...
    var objDropDownCellId = objCoordinateListEditor.UniqueID('GeographicFormatSelectorCell');

    // Calculate the cell width to be the DELETE and INVALID_REASON field together ...
    var intWidthInPixels = objCoordinateListEditor.GetFieldWidthInPixels(enumField.DELETE) + objCoordinateListEditor.GetFieldWidthInPixels(enumField.INVALID_REASON);

    // Create the cell that is to contain the drop down element ...
    var objDropDownCell = $('<td id="' + objDropDownCellId + '" class="CoordinatesHeader" style="cursor:pointer;width:' + intWidthInPixels + 'px" colspan="2"></td>');

    // Create a div with a table and row to 
    // contain the drop down cell elements ...
    objCoordinateListEditor.GeographicFormatSelectorDiv = $('<div class="map_coordinatelisteditor_GeographicFormatSelectorDiv"></div>');

    // When an non default offset has been specified ...
    if (objCoordinateListEditor.DDorDMSDropDownPosition) {

        // Set the position of the element ...
        objCoordinateListEditor.GeographicFormatSelectorDiv.css('position', 'relative');
        objCoordinateListEditor.GeographicFormatSelectorDiv.css('inset-block-start', objCoordinateListEditor.DDorDMSDropDownPosition.top + 'px');
        objCoordinateListEditor.GeographicFormatSelectorDiv.css('inset-inline-end', objCoordinateListEditor.DDorDMSDropDownPosition.right + 'px');
    }

    // Add it to the cell ...
    objDropDownCell.append(objCoordinateListEditor.GeographicFormatSelectorDiv);

    // Declare a variable for the geographic format string ...
    var strGeographicFormat;

    // Set the geographic format string for the fomat ...
    switch (enCoordinateFormat) {
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD: strGeographicFormat = "&nbsp;" + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'DD'); break;
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS: strGeographicFormat = SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'DMS'); break;
    }

    // Add the DD/DMS span ...
    objCoordinateListEditor.GeographicFormatSelectorDiv.append($('<span class="map_coordinatelisteditor_GeographicFormatHeaderText">' + strGeographicFormat + '</span>'));

    // When we are to allow geographic format selection ...
    if (objCoordinateListEditor.AllowGeographicFormatSelection) {

        // Add the drop down image span ...
        objCoordinateListEditor.GeographicFormatSelectorDiv.append($('<div class="map_coordinatelisteditor_GeographicFormatHeader_dropdown"></div>'));

        // Create the operation popup control ...
        objCoordinateListEditor.GeographicFormatSelectorPopup = SD.Popup.CreateInstance(objCoordinateListEditor.GeographicFormatSelectorDiv,
            'map_coordinatelisteditor_popup_div_to_open_downwards',
            'map_coordinatelisteditor_popup_div_to_open_upwards',
            'map_coordinatelisteditor_extended_geographic_format_selector_to_open_downwards',
            'map_coordinatelisteditor_extended_geographic_format_selector_to_open_upwards',
            2, false,
            SD.Popup.enumPopupBehaviour.AlwaysDown,
            objCoordinateListEditor.ActivateGeographicFormatSelectorPopupProxy,
            objCoordinateListEditor.DeActivateGeographicFormatSelectorPopupProxy);
    }

    // Set the object level variable for the geographic format selector header cell ...
    objCoordinateListEditor.GeographicFormatSelectorHeaderCell = objDropDownCell;

    // Return the created cell ...
    return objDropDownCell;
}

// **************************************************************************
// FUNCTION SetDDorDMSDropDownPosition:
// **************************************************************************
TrimbleMap.CoordinateListEditor.SetDDorDMSDropDownPosition = function SetDDorDMSDropDownPosition(objDDorDMSDropDownPosition) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Set it on the control ...
    objCoordinateListEditor.DDorDMSDropDownPosition = objDDorDMSDropDownPosition;

    // When we have geographic drop down ...
    if (objCoordinateListEditor.GeographicFormatSelectorDiv) {

        // Update the position of the elements ...
        objCoordinateListEditor.GeographicFormatSelectorDiv.css('position', 'relative');
        objCoordinateListEditor.GeographicFormatSelectorDiv.css('inset-block-start', objCoordinateListEditor.DDorDMSDropDownPosition.top + 'px');
        objCoordinateListEditor.GeographicFormatSelectorDiv.css('inset-inline-end', objCoordinateListEditor.DDorDMSDropDownPosition.right + 'px');
    }
}

// **************************************************************************
// FUNCTION ActivateGeographicFormatSelectorPopup:
// **************************************************************************
TrimbleMap.CoordinateListEditor.ActivateGeographicFormatSelectorPopup = function ActivateGeographicFormatSelectorPopup(objPopupContainerDiv) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create the geographic format selection div when it does not exists yet ...
    objCoordinateListEditor.CreateGeographicFormatSelectionPopupDiv();

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objCoordinateListEditor.GeographicFormatSelectorPopupDiv);

    // Attach the click event handler ...
    objCoordinateListEditor.GeographicFormatSelectorPopupDiv.click(objCoordinateListEditor.GeographicFormatSelectorClickedProxy);
}

// **************************************************************************
// FUNCTION DeActivateGeographicFormatSelectorPopup:
// **************************************************************************
TrimbleMap.CoordinateListEditor.DeActivateGeographicFormatSelectorPopup = function DeActivateGeographicFormatSelectorPopup() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When we have a geographic format selector popup ..
    if (objCoordinateListEditor.GeographicFormatSelectorPopupDiv) {

        // Detach the click event handler ...
        objCoordinateListEditor.GeographicFormatSelectorPopupDiv.off('click', objCoordinateListEditor.GeographicFormatSelectorClickedProxy);
    }
}

// **************************************************************************
// FUNCTION CreateRow: Create a new html row <tr> with cells <td> for each field for the coordinate format ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateRow = function CreateRow(objCoordinate, blnCreateValueIdentifier) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new html row ...
    var objRow = $('<tr IsCoordinateRow="true"></tr>');

    // Get the list of fields for the coordinate format ...
    var arrFields = objCoordinateListEditor.GetDisplayFieldList();

    // Loop through all the fields ...
    for (var intField = 0; intField < arrFields.length; intField++) {

        // Get the field ...
        var enField = arrFields[intField];

        // Build a value identifier object for the cell ...
        var objValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(objCoordinate, enField, blnCreateValueIdentifier);

        // Get the field width in pixels ...
        var intCellWidthInPixels = objCoordinateListEditor.GetFieldWidthInPixels(enField);

        // Start with not spcifying a style for the cell ...
        var strStyle = 'style = "width:' + intCellWidthInPixels + 'px"';;

        // Declare a variable for the css class ...
        var strCssClass = "CoordinatesCell";

        // Overwrite the css class that will be used for the coordinate number cell ...
        if (enField == enumField.COORDINATE_NUMBER) { strCssClass = "CoordinatesNumberCell" };

        // When the first cell add the LeftMostCell class ...
        if (intField == 0) { strCssClass += ' LeftMostCell'; }

        // When the last cell add the RightMostCell class ...
        if (intField == (arrFields.length - 1)) { strCssClass += ' RightMostCell'; }

        // Create a unique cell id ...
        var strCellId = objCoordinateListEditor.UniqueID('Cell');

        // Create an html table cell ...
        var objCell = $('<td id="' + strCellId + '" CoordinateCellMarker="true" class="' + strCssClass + '" style = "width:' + intCellWidthInPixels + 'px" FieldEnum="' + enField + '"></td>');

        // Create and append the html elements for the field and append it to the cell ...
        objCoordinateListEditor.PopulateValueCell(objValueIdentifier, enumMode.VIEW, objCell);

        // Append the cell to the row ...
        objRow.append(objCell);

        // Add the value identifier to the hash table with the cell id as key ...
        objValueIdentifier.RelatedCell = strCellId;
    }

    return objRow;
}

// **************************************************************************
// FUNCTION UniqueID: Generate a unique id for dynamically created elements on which we want to attatch events to ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.UniqueID = function UniqueID(strElementName) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When we don not have a UniqueId property yet ...
    if (objCoordinateListEditor.LastUniqueId == null) {

        // Set the unique id to 0 ...
        objCoordinateListEditor.LastUniqueId = 0;
    }
    else {

        // Increment the unique id ...
        objCoordinateListEditor.LastUniqueId++;
    }

    // Build a unique id and return it ...
    return objCoordinateListEditor.IDPrefix + '_' + strElementName + '_' + objCoordinateListEditor.LastUniqueId;
}

// **************************************************************************
// FUNCTION AttachDragEventHandlers: Attach the drag event handlers ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.AttachDragEventHandlers = function AttachDragEventHandlers(objDraggableCellElement) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the geometry type is not point ...
    if (objCoordinateListEditor.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT) {

        // Make the cell draggable ...
        objDraggableCellElement.draggable({
            appendTo: "body",
            helper: "clone",
            cursorAt: { top: 13, left: 0 },
            start: objCoordinateListEditor.RowDragStartProxy,
            stop: objCoordinateListEditor.RowDragStopProxy,
            drag: objCoordinateListEditor.RowDragProxy
        });
    }
}

// **************************************************************************
// FUNCTION PopulateValueCell: Populate a value cell <td> with the html elements required for the value identifier ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.PopulateValueCell = function PopulateValueCell(objValueIdentifier, enMode, objParentCellElement) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the field value ...
    var strFieldValue = objValueIdentifier.GetValue();

    // Format the field value (when valid) ...
    var strFormattedValue = (objValueIdentifier.IsValid()) ? TrimbleMap.CoordinateListEditor.Shared.FormatFieldValue(objValueIdentifier.Field, enMode, objCoordinateListEditor.CoordinateFormat, strFieldValue, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator, objCoordinateListEditor.GeographicSecondsDecimalPlaces, objCoordinateListEditor.DecimalPlaces) : strFieldValue;

    // Get the field width in pixels ...
    var intFieldWidthInPixels = objCoordinateListEditor.GetFieldWidthInPixels(objValueIdentifier.Field);

    // When the field is editable ...
    if (TrimbleMap.CoordinateListEditor.Shared.IsEditableField(objValueIdentifier.Field)) {

        // Toggle the 'CoordinatesCell' css class on the parent cell element to 
        // show when the field is valid OR the cell is to be in edit mode ...
        objParentCellElement.toggleClass('CoordinatesCell', (objValueIdentifier.IsValid() || (enMode == enumMode.EDIT)));

        // Toggle 'InvalidCoordinatesCell' css class on the parent cell element to 
        // show when the field is invalid and the cell is to be in VIEW mode ...
        objParentCellElement.toggleClass('InvalidCoordinatesCell', ((!objValueIdentifier.IsValid()) && (enMode == enumMode.VIEW)));
    }

    // Depending on the mode ...
    switch (enMode) {

        case enumMode.VIEW:

            // Build the elements for the field for view mode ...
            switch (objValueIdentifier.Field) {
                case enumField.COORDINATE_NUMBER:

                    // When the value is a plus sign ...
                    if (strFormattedValue == "+") {

                        // Append the plus sign image (looks better than a plus sign using a <span>) ...
                        objParentCellElement.append($('<div class="coordinates_plus_sign"></div>'));

                        // Set the cell cursor to the arrow ...
                        objParentCellElement.css("cursor", "pointer");

                        // Set the cell to align contents in the center ...
                        objParentCellElement.css("text-align", "center");

                    } else {

                        // When editable ...
                        if (objCoordinateListEditor.Editable) {

                            // Create a new table with a row <tr> to hold the content ...
                            var objGrabTable = $('<table cellpadding="0" cellspacing="0" class="coordinates_grab_cell"><tr></tr></table>');

                            // The grab image width of 6 ...
                            var intGrabCellWidth = 6;

                            // Add the table cell for the grab image ...
                            objGrabTable.find('tr').append($('<td style="width:' + intGrabCellWidth + 'px"></td>'));

                            // Add the table cell for the coordinate number <span> ...
                            objGrabTable.find('tr').append($('<td style="width:' + (intFieldWidthInPixels - intGrabCellWidth) + 'px;vertical-align: middle" align="center"></td>'));

                            // Add the grab image to the first cell <td> ...
                            objGrabTable.find('td').first().append($('<div class="coordinates_grab_handle"></div>'));

                            // Append the coordinate number <span> in a div to the second cell <td> ...
                            objGrabTable.find('td').last().append($('<div style="width:' + (intFieldWidthInPixels - intGrabCellWidth - 1) + 'px;overflow:hidden"><span IsCoordinateNumberSpan="true" class="CoordinatesNumberCellText">' + strFormattedValue + '</span></div>'));

                            // Append the grab cell table to the parent cell ...
                            objParentCellElement.append(objGrabTable);

                            // When the geometry type is not point ...
                            if (objCoordinateListEditor.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT) {

                                // Set the cell cursor to the move cursor ...
                                objParentCellElement.css("cursor", "move");
                            }

                            // Attach the drag event handlers ...
                            objCoordinateListEditor.AttachDragEventHandlers(objParentCellElement);

                        } else {

                            // Append the grab cell table to the parent cell ...
                            objParentCellElement.append('<div class="maps_coordinatelisteditor_view_coordinate_number"><span IsCoordinateNumberSpan="true" class="CoordinatesNumberCellText">' + strFormattedValue + '</span></div>');
                        }
                    }

                    break;

                case enumField.LATITUDE_DEGREES:
                case enumField.LATITUDE_MINUTES:
                case enumField.LATITUDE_SECONDS:
                case enumField.NORTH_SOUTH:
                case enumField.LONGITUDE_DEGREES:
                case enumField.LONGITUDE_MINUTES:
                case enumField.LONGITUDE_SECONDS:
                case enumField.EAST_WEST:
                case enumField.X:
                case enumField.Y:

                    // Add a span with the formatted field value ...
                    objParentCellElement.append($('<div' + ((objCoordinateListEditor.Editable) ? '' : ' class=" map_coordinatelisteditor_value_cell"') + '><span class="CoordinatesCellText' + ((objCoordinateListEditor.Editable) ? '' : ' map_coordinatelisteditor_value_text') + '">' + strFormattedValue + '</span></div>'));

                    // Set the cell width ...
                    objParentCellElement.css('width', intFieldWidthInPixels + 'px');
                    break;

                case enumField.LATITUDE_DMS:
                case enumField.LONGITUDE_DMS:
                case enumField.LATITUDE_NS:
                case enumField.LONGITUDE_EW:

                    // Add a span with the formatted field value ...
                    objParentCellElement.append($('<div class="map_coordinatelisteditor_value_cell"><span class="CoordinatesCellText map_coordinatelisteditor_value_text">' + strFormattedValue + '</span></div>'));

                    // Set the cell width ...
                    objParentCellElement.css('width', intFieldWidthInPixels + 'px');
                    break;

                case enumField.DELETE:

                    // When editable ...
                    if (objCoordinateListEditor.Editable) {

                        // The delete should be shown when not the '+' row ...
                        var blnDeleteHidden = (objValueIdentifier.Coordinate.COORDINATE_NUMBER == "+");

                        // Set the cell contents to align in the center ...
                        objParentCellElement.css("text-align", "end");

                        // Remove the right border (so that there is no divide between the delete and invalid reason icons) ...
                        objParentCellElement.css("border-inline-end", "");

                        // Add the red cross image ...
                        objParentCellElement.append($('<span>&nbsp;</span><div style="' + (blnDeleteHidden ? 'display:none' : '') + '" class="coordinates_delete_icon"></div>'));
                    }

                    // Add the delete icon cell class ...
                    objParentCellElement.addClass('map_coordinatelisteditor_delete_icon_cell');

                    break;

                case enumField.INVALID_REASON:

                    // Just add a sopan width a non braking space to ensure that the cell borders are all visible ...
                    objParentCellElement.append($('<span>&nbsp;</span>'));
            }
            break;

        case enumMode.EDIT:

            // Build the elements for the field for edit mode ...
            switch (objValueIdentifier.Field) {
                case enumField.LATITUDE_DEGREES:
                case enumField.LATITUDE_MINUTES:
                case enumField.LATITUDE_SECONDS:
                case enumField.LONGITUDE_DEGREES:
                case enumField.LONGITUDE_MINUTES:
                case enumField.LONGITUDE_SECONDS:
                case enumField.X:
                case enumField.Y:

                    // Get the field width in pixels for the coordinate format ...
                    var intFieldWidth = intFieldWidthInPixels - 10;

                    // Add a textbox with the formatted field value ...
                    objParentCellElement.append($('<input type="text" value="' + strFormattedValue + '" class="EditControl" style="width:' + intFieldWidth + 'px"></input>'));

                    // Update the cell style for the validation result of the field ...
                    TrimbleMap.CoordinateListEditor.Shared.UpdateCellStyleForValidationResult(objValueIdentifier, objParentCellElement);
                    break;

                case enumField.NORTH_SOUTH:

                    // Use the default latitude direction when noty set ...
                    if ((strFormattedValue).trim().length == 0) { strFormattedValue = objCoordinateListEditor.DefaultLatitudeDirection; }

                    // Declare variables to hold the selected attributes ...
                    var strNorthSelected = (strFormattedValue == enumNorthSouth.NORTH) ? 'selected="selected"' : '';
                    var strSouthSelected = (strFormattedValue == enumNorthSouth.SOUTH) ? 'selected="selected"' : '';

                    // Add a a drop down with N - S as values ...
                    objParentCellElement.append($('<select class="EditControl"><option value="N" ' + strNorthSelected + '>' + TrimbleMap.CoordinateListEditor.Shared.GetNorthSouthTranslation(enumNorthSouth.NORTH) + '</option><option value="S" ' + strSouthSelected + '>' + TrimbleMap.CoordinateListEditor.Shared.GetNorthSouthTranslation(enumNorthSouth.SOUTH) + '</option></select>'));
                    break;

                case enumField.EAST_WEST:

                    // Use the default longitude direction when noty set ...
                    if ((strFormattedValue).trim().length == 0) { strFormattedValue = objCoordinateListEditor.DefaultLongitudeDirection; }

                    // Declare variables to hold the selected attributes ...
                    var strEastSelected = (strFormattedValue == enumEastWest.EAST) ? 'selected="selected"' : '';
                    var strWestSelected = (strFormattedValue == enumEastWest.WEST) ? 'selected="selected"' : '';

                    // Add a a drop down with E - W as values ...
                    objParentCellElement.append($('<select class="EditControl"><option value="E" ' + strEastSelected + '>' + TrimbleMap.CoordinateListEditor.Shared.GetEastWestTranslation(enumEastWest.EAST) + '</option><option value="W" ' + strWestSelected + '>' + TrimbleMap.CoordinateListEditor.Shared.GetEastWestTranslation(enumEastWest.WEST) + '</option></select>'));
                    break;
            }
            break;
    }
}

// **************************************************************************
// FUNCTION ValidateRowMaximum: Does validations that can only be done on a row level ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ValidateRowMaximum = function ValidateRowMaximum(objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Start with being valid ...
    var objValidationResult = TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);

    // When the coordinate format is DMS...
    if (objCoordinateListEditor.CoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) {

        // When Latitude degrees is 90 ...
        if (objCoordinate.LATITUDE_DEGREES == 90) {

            // When we non-zero minutes or seconds ...
            if ((objCoordinate.LATITUDE_MINUTES != 0) || (objCoordinate.LATITUDE_SECONDS != 0)) {

                // Invalid: Latitude must be between 0 and 90 ...
                // Translations: '%1 must be between %2 and %2'
                //               'Latitude'
                objValidationResult.Append(TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(false, SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'MustBeBetween', SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'Latitude'), '0', '90')));
            }
        }

        // When longitude degrees is 180 ...
        if (objCoordinate.LONGITUDE_DEGREES == 180) {

            // When we non-zero minutes or seconds ...
            if ((objCoordinate.LONGITUDE_MINUTES != 0) || (objCoordinate.LONGITUDE_SECONDS != 0)) {

                // Invalid: Longitude must be between 0 and 180 ...
                // Translations: '%1 must be between %2 and %2'
                //               'Longitude'
                objValidationResult.Append(TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(false, SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'MustBeBetween', SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'Longitude'), '0', '180')));
            }
        }
    }

    // Return the validation result ...
    return objValidationResult;
}

// **************************************************************************
// FUNCTION ValidateRow: Validate the entire row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ValidateRow = function ValidateRow(objCoordinate, enCoordinateFormat) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get all the fields for the coordinate format ...
    var arrFields = objCoordinateListEditor.GetFieldList();

    // Loop through all the fields for the coordinate format ...
    for (var intField = 0; intField < arrFields.length; intField++) {

        // Get the field at index intField ...
        var enField = arrFields[intField];

        // When the field is editable ...
        if (TrimbleMap.CoordinateListEditor.Shared.IsEditableField(enField)) {

            // Get the value identifier for the field ...
            var objValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(objCoordinate, enField);

            // Allow incomplete entries when the field has focus ...
            var blnAllowInCompleteValidation = (objCoordinateListEditor.FocussedValueIdentifier == objValueIdentifier);

            // Validate the field ...
            objValueIdentifier.ValidationResult = objCoordinateListEditor.ValidateField(objValueIdentifier, blnAllowInCompleteValidation);

            // Update the invalid fields array with the field's validation results ...
            objCoordinateListEditor.UpdateInvalidFields(objValueIdentifier);
        }
    }

    // Validate the row maximums ...
    objCoordinate.RowMaximumValidationResult = objCoordinateListEditor.ValidateRowMaximum(objCoordinate);
}

// **************************************************************************
// FUNCTION CoordinatesValid
// **************************************************************************
TrimbleMap.CoordinateListEditor.CoordinatesValid = function CoordinatesValid() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Not valid when we have any invalid fields ...
    var blnValid = (objCoordinateListEditor.InvalidFields.length == 0);

    // When valid so far ...
    if (blnValid) {

        // Get coordinates in appropriate metric
        var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

        // Loop through all the coordinates ...
        for (var intCoordinate = 0; intCoordinate < arrDisplayCoordinates.length; intCoordinate++) {

            // Get the coordinate ...
            var objCoordinate = arrDisplayCoordinates[intCoordinate];

            // When the row maximum is not valid ...
            if (!objCoordinate.RowMaximumValidationResult.IsValid) {

                // Set to not be valid ...
                blnValid = false;

                // Stop checking the row maximum validation results ...
                break;
            }
        }
    }

    return blnValid;
}

// **************************************************************************
// FUNCTION LastCoordinateCompleted
// **************************************************************************
TrimbleMap.CoordinateListEditor.LastCoordinateCompleted = function LastCoordinateCompleted() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Start with being compeleted ...
    var blnLastCoordinateCompleted = true;

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Get the last coordinate ...
    var objLastCoordinate = arrDisplayCoordinates[arrDisplayCoordinates.length - 1];

    // When any coordinate values has been entered or we have a point geometry type ...
    if (objLastCoordinate && (objCoordinateListEditor.GeometryType == TrimbleMap.Shape.enumGeometryType.POINT || objCoordinateListEditor.AnyCoordinateValuesEntered(objLastCoordinate, objCoordinateListEditor.CoordinateFormat))) {

        // When not all the coordinate values has been entered ...
        if (!objCoordinateListEditor.AllCoordinateValuesEntered(objLastCoordinate, objCoordinateListEditor.CoordinateFormat)) {

            // Set to not be completed ...
            blnLastCoordinateCompleted = false;
        }
    }

    return blnLastCoordinateCompleted;
}

// **************************************************************************
// FUNCTION CoordinateCount
// **************************************************************************
TrimbleMap.CoordinateListEditor.CoordinateCount = function CoordinateCount() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Start with the number of coordinates in the array ...
    var intCoordinateCount = arrDisplayCoordinates.length;

    // Get the last coordinate ...
    var objLastCoordinate = arrDisplayCoordinates[arrDisplayCoordinates.length - 1];

    // When we have a last empty row ...
    if (objCoordinateListEditor.Editable && (objCoordinateListEditor.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT) || (!objCoordinateListEditor.AnyCoordinateValuesEntered(objLastCoordinate, objCoordinateListEditor.CoordinateFormat))) {

        // Remove one from the count ...
        intCoordinateCount--;
    }

    return intCoordinateCount;
}

// **************************************************************************
// FUNCTION UpdateRowEditableCells: Update the editable cells of the row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.UpdateRowEditableCells = function UpdateRowEditableCells(objCoordinate, enCoordinateFormat) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get all the fields for the coordinate format ...
    var arrFields = objCoordinateListEditor.GetFieldList();

    // Loop through all the fields for the coordinate format ...
    for (var intField = 0; intField < arrFields.length; intField++) {

        // Get the field at index intField ...
        var enField = arrFields[intField];

        // Get the value identifier for the field ...
        var objValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(objCoordinate, enField);

        // Update the coordinate property on the value identifier Object
        // This is to keep the coordinates insync with the coordinates property on objCoordinateListEditor
        objValueIdentifier.Coordinate = objCoordinate;

        // When the field is editable ...
        if (TrimbleMap.CoordinateListEditor.Shared.IsEditableField(enField)) {

            // Start with being in view mode ...
            var enMode = enumMode.VIEW;

            // When it is the focussed cell ...
            if (objValueIdentifier == objCoordinateListEditor.FocussedValueIdentifier) {

                // Set to be in edit mode ...
                enMode = enumMode.EDIT;
            }

            // Get the table cell <td> for the field ...
            var objCell = objCoordinateListEditor.GetTableCellForField(objValueIdentifier);

            // Update the html cell contents of the coordinate number field of the row ...
            objCoordinateListEditor.RePopulateValueCell(objValueIdentifier, enMode, objCell);
        }
    }
}

// **************************************************************************
// FUNCTION GeographicSecondsMaximum: Get the maximum value for geographic seconds, e.g 59.99 
//                                    when geographic seconds should have 2 decimal places ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GeographicSecondsMaximum = function GeographicSecondsMaximum() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Declare a variable to use for looping ...
    var intDecimalPosition;

    // Start 59 as the maximum ...
    var strMaximumSeconds = '59';

    // When the need more than 0 decimal places ...
    if (objCoordinateListEditor.GeographicSecondsDecimalPlaces > 0) {

        // Add the decimal point ...
        strMaximumSeconds += '.';

        // Loop through all the decimal positions ...
        for (intDecimalPosition = 0; intDecimalPosition < objCoordinateListEditor.GeographicSecondsDecimalPlaces; intDecimalPosition++) {

            // Add a 9 at the decimal position ...
            strMaximumSeconds += '9';
        }
    }

    // Convert the string to a number ...
    var decMaximumSeconds = Number(strMaximumSeconds);

    // return the maximum ....
    return decMaximumSeconds;
}

// **************************************************************************
// FUNCTION ValidateField: Validates the value identifed by the value identiefer ... 
// **************************************************************************
TrimbleMap.CoordinateListEditor.ValidateField = function ValidateField(objValueIdentifier, blnAllowInComplete) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Start with being valid ...
    var objValidationResult = TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);

    // When the field is a number field ...
    if (!TrimbleMap.CoordinateListEditor.Shared.IsDropDownField(objValueIdentifier.Field)) {

        // Get the field value ...
        var strFieldValue = objValueIdentifier.GetValue();

        // When no value specified ...
        if (strFieldValue == '') {

            // Get coordinates in appropriate metric
            var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

            // Get the row index ...
            var intRow = arrDisplayCoordinates.findIndex(function (objCoordinate) {
                return objCoordinate.COORDINATE_NUMBER === objValueIdentifier.Coordinate.COORDINATE_NUMBER;
            });

            // When not the last row (i.e. the row has already been accepted) ...
            if ((intRow != -1) && (intRow < arrDisplayCoordinates.length - 1)) {

                // Not valid, entry required ...
                // Translation: '%1 not specified'
                objValidationResult.Append(TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(false, (SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'NotSpecified', TrimbleMap.CoordinateListEditor.Shared.GetFieldName(objValueIdentifier.Field)))));
            }
        }
        else {

            // Validate that it is a valid number with the correct group and decimal separators ...
            objValidationResult.Append(objCoordinateListEditor.ValidateIsNumber(objValueIdentifier, strFieldValue, blnAllowInComplete));

            // When valid so far ...
            if (objValidationResult.IsValid) {

                // Do validations that are specific to each coordinate format ...
                switch (objValueIdentifier.CoordinateFormat) {
                    case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS:

                        // Do validations on the specific field ...
                        switch (objValueIdentifier.Field) {
                            case enumField.LATITUDE_DEGREES:

                                // Validate that the field is a positive number, between 0 and 90 and is an integer ...
                                objValidationResult.Append(objCoordinateListEditor.ValidatePositiveNumber(objValueIdentifier, strFieldValue));
                                objValidationResult.Append(objCoordinateListEditor.ValidateAbsoluteValueBetween(objValueIdentifier, strFieldValue, 0, 90));
                                objValidationResult.Append(objCoordinateListEditor.ValidateDecimalPlaces(objValueIdentifier, strFieldValue, 0, blnAllowInComplete));
                                break;

                            case enumField.LONGITUDE_DEGREES:

                                // Validate that the field is a positive number, between 0 and 180 and is an integer ...
                                objValidationResult.Append(objCoordinateListEditor.ValidatePositiveNumber(objValueIdentifier, strFieldValue));
                                objValidationResult.Append(objCoordinateListEditor.ValidateAbsoluteValueBetween(objValueIdentifier, strFieldValue, 0, 180));
                                objValidationResult.Append(objCoordinateListEditor.ValidateDecimalPlaces(objValueIdentifier, strFieldValue, 0, blnAllowInComplete));
                                break;

                            case enumField.LATITUDE_MINUTES:
                            case enumField.LONGITUDE_MINUTES:

                                // Validate that the field is a positive number, between 0 and 60 and is an integer ...
                                objValidationResult.Append(objCoordinateListEditor.ValidatePositiveNumber(objValueIdentifier, strFieldValue));
                                objValidationResult.Append(objCoordinateListEditor.ValidateAbsoluteValueBetween(objValueIdentifier, strFieldValue, 0, 59));
                                objValidationResult.Append(objCoordinateListEditor.ValidateDecimalPlaces(objValueIdentifier, strFieldValue, 0, blnAllowInComplete));
                                break;

                            case enumField.LATITUDE_SECONDS:
                            case enumField.LONGITUDE_SECONDS:

                                // Validate that the field is a positive number, between 0 and 60 and has no more than 2 decimal places ...
                                objValidationResult.Append(objCoordinateListEditor.ValidatePositiveNumber(objValueIdentifier, strFieldValue));
                                objValidationResult.Append(objCoordinateListEditor.ValidateAbsoluteValueBetween(objValueIdentifier, strFieldValue, 0, objCoordinateListEditor.GeographicSecondsMaximum()));
                                objValidationResult.Append(objCoordinateListEditor.ValidateDecimalPlaces(objValueIdentifier, strFieldValue, objCoordinateListEditor.GeographicSecondsDecimalPlaces, blnAllowInComplete));
                                break;
                        }
                        break;

                    case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD:

                        // Do validations on the specific field ...
                        switch (objValueIdentifier.Field) {
                            case enumField.LATITUDE_DEGREES:

                                // Validate that the field is a positive number, between 0 and 90 and have the allowed number of decimal places (objCoordinateListEditor.DecimalPlaces) ...
                                objValidationResult.Append(objCoordinateListEditor.ValidatePositiveNumber(objValueIdentifier, strFieldValue));
                                objValidationResult.Append(objCoordinateListEditor.ValidateAbsoluteValueBetween(objValueIdentifier, strFieldValue, 0, 90));
                                objValidationResult.Append(objCoordinateListEditor.ValidateDecimalPlaces(objValueIdentifier, strFieldValue, objCoordinateListEditor.DecimalPlaces, blnAllowInComplete));
                                break;

                            case enumField.LONGITUDE_DEGREES:

                                // Validate that the field is a positive number, between 0 and 180 and have the allowed number of decimal places (objCoordinateListEditor.DecimalPlaces)  ...
                                objValidationResult.Append(objCoordinateListEditor.ValidatePositiveNumber(objValueIdentifier, strFieldValue));
                                objValidationResult.Append(objCoordinateListEditor.ValidateAbsoluteValueBetween(objValueIdentifier, strFieldValue, 0, 180));
                                objValidationResult.Append(objCoordinateListEditor.ValidateDecimalPlaces(objValueIdentifier, strFieldValue, objCoordinateListEditor.DecimalPlaces, blnAllowInComplete));
                                break;
                        }
                        break;

                    case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED:

                        // Validate that the field have the allowed number of decimal places (objCoordinateListEditor.DecimalPlaces)  ...
                        objValidationResult.Append(objCoordinateListEditor.ValidateDecimalPlaces(objValueIdentifier, strFieldValue, objCoordinateListEditor.DecimalPlaces, blnAllowInComplete));
                        break;
                }
            }
        }
    }

    // Return the validation result ...
    return objValidationResult;
}

// **************************************************************************
// FUNCTION ValidatePositiveNumber: Validates that the value is a positive number ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ValidatePositiveNumber = function ValidatePositiveNumber(objValueIdentifier, strFieldValue) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Validate that the field is positive ...
    if (strFieldValue < 0) {

        // Not valid ...
        // Translation: '%1  must be a positive number'
        return TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(false, SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'MustBePositiveNumber', TrimbleMap.CoordinateListEditor.Shared.GetFieldName(objValueIdentifier.Field)));
    }

    // Valid then ...
    return TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);
}

// **************************************************************************
// FUNCTION ValidateAbsoluteValueBetween: Validates that the absolute value is between the specified numbers ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ValidateAbsoluteValueBetween = function ValidateAbsoluteValueBetween(objValueIdentifier, strFieldValue, decFromValue, decToValue) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Validate that the field is between decFromValue and decToValue ...
    if ((Math.abs(strFieldValue) < decFromValue) || (Math.abs(strFieldValue) > decToValue)) {

        // Not valid ...
        // Translation: '%1 must be between %2 and %3'
        return TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(false, SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'MustBeBetween', TrimbleMap.CoordinateListEditor.Shared.GetFieldName(objValueIdentifier.Field), decFromValue, decToValue));
    }

    // Valid then ...
    return TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);
}

// **************************************************************************
// FUNCTION ValidateNumber: Validates that it as a valid number ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ValidateIsNumber = function ValidateIsNumber(objValueIdentifier, strFieldValue, blnAllowInComplete) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Construct a regular expression to test for a valid number ...
    var objRegExp = new RegExp(TrimbleMap.CoordinateListEditor.Shared.BuildNumberRegexValidationString(objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator, false, 0, blnAllowInComplete));

    // When the valueis not a valid number ...
    if (!objRegExp.test(strFieldValue)) {

        // Not valid (return the number the of decimal places allowed) ...
        // Translation: '%1 is not a valid number'
        return TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(false, SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'NotValidNumber', TrimbleMap.CoordinateListEditor.Shared.GetFieldName(objValueIdentifier.Field)));
    }

    // Valid then ...
    return TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);
}

// **************************************************************************
// FUNCTION ValidateDecimalPlaces: Validates that the number has got the specified number of decimal places ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ValidateDecimalPlaces = function ValidateDecimalPlaces(objValueIdentifier, strFieldValue, intDecimalPlaces, blnAllowInComplete) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Construct a regular expression to test for the number of decimal places ...
    var objRegExp = new RegExp(TrimbleMap.CoordinateListEditor.Shared.BuildNumberRegexValidationString(objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator, true, intDecimalPlaces, blnAllowInComplete));

    // When the value do not have intDecimalPlaces ...
    if (!objRegExp.test(strFieldValue)) {

        // When we tested for NO decimal places ...
        if (intDecimalPlaces == 0) {

            // Not valid (return 'must be a whole number' invalid reason) ...
            // Translation: '%1 must be a whole number'
            return TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(false, SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'MustBeWholeNumber', TrimbleMap.CoordinateListEditor.Shared.GetFieldName(objValueIdentifier.Field)));
        }
        else {

            // Not valid (return the number the of decimal places allowed) ...
            // Translation: '%1 can only have %2 decimal places'
            return TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(false, SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'MaximumDecimalPlaces', TrimbleMap.CoordinateListEditor.Shared.GetFieldName(objValueIdentifier.Field), intDecimalPlaces));
        }
    }

    // Valid then ...
    return TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);
}

// **************************************************************************
// FUNCTION UpdateInvalidFields: Update the invalid fields array with the validation 
//                               result of the value identifer passed in ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.UpdateInvalidFields = function UpdateInvalidFields(objValueIdentifier) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Find the index of the field in the invalid fields array (if it used to be invalid) ...
    var intInvalidFieldArrayIndex = $.inArray(objValueIdentifier, objCoordinateListEditor.InvalidFields);

    // When the field is valid ...
    if (objValueIdentifier.ValidationResult.IsValid) {

        // When the field used to be invalid ...
        if (intInvalidFieldArrayIndex != -1) {

            // Remove the field from the invalid fields array ...
            objCoordinateListEditor.InvalidFields.splice(intInvalidFieldArrayIndex, 1);
        }
    }
    else {

        // When the field didn't used to be invalid ...
        if (intInvalidFieldArrayIndex == -1) {

            // Add the field to the invalid fields array ...
            objCoordinateListEditor.InvalidFields.push(objValueIdentifier);
        }
    }
}

// **************************************************************************
// FUNCTION UpdateFieldValueFromInterface: Update the internal field's value from the interface ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.UpdateFieldValueFromInterface = function UpdateFieldValueFromInterface(objValueIdentifier, objTableCell, blnAllowInCompleteValidation) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the input element (textbox of drop down list) 
    // which would be the first element in the cell ...
    var objInputElement = objTableCell.children().first();

    // Set the value of the field to the value obtained from the dom element ...
    objValueIdentifier.SetValue(objInputElement.val());

    // Validate the field ...
    objValueIdentifier.ValidationResult = objCoordinateListEditor.ValidateField(objValueIdentifier, blnAllowInCompleteValidation);

    // Update the invalid fields array with the field's validation results ...
    objCoordinateListEditor.UpdateInvalidFields(objValueIdentifier);

    // Do validations that can only be done on a row level ...
    objValueIdentifier.Coordinate.RowMaximumValidationResult = objCoordinateListEditor.ValidateRowMaximum(objValueIdentifier.Coordinate);

    // Update the invalid reason icon for the row ...
    objCoordinateListEditor.UpdateInvalidReasonIcon(objValueIdentifier.Coordinate, true);

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Get the coordinate index ...
    var intCoordinate = arrDisplayCoordinates.findIndex(function (objCoordinate) {
        return objCoordinate.COORDINATE_NUMBER === objValueIdentifier.Coordinate.COORDINATE_NUMBER;
    });

    // Only do this when not busy entering a field value ...
    if (!blnAllowInCompleteValidation) {

        // When the plus sign is still showing in the coordinate number field of the row ...
        if (objValueIdentifier.Coordinate.COORDINATE_NUMBER == '+') {

            // When any of the editable fields in the row has been entered ...
            if (objCoordinateListEditor.AnyCoordinateValuesEntered(objValueIdentifier.Coordinate, objValueIdentifier.CoordinateFormat)) {

                // Set the coordinate number ...
                objValueIdentifier.Coordinate.COORDINATE_NUMBER = arrDisplayCoordinates.length;

                // Get the row index (the row on the interface is one lower because the header row is the first row) ...
                var intRow = intCoordinate + 1;

                // Get the coordinate number cell at the row index ...
                var objCoordinateNumberValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(objValueIdentifier.Coordinate, enumField.COORDINATE_NUMBER);

                // Get the coordinate number cell ...
                var objCoordinateNumberCell = objCoordinateListEditor.GetTableCellForField(objCoordinateNumberValueIdentifier);

                // Update the html cell contents of the coordinate number field of the row ...
                objCoordinateListEditor.RePopulateValueCell(objCoordinateNumberValueIdentifier, enumMode.VIEW, objCoordinateNumberCell);

                // Get the delete cell at the row index ...
                var objDeleteValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(objValueIdentifier.Coordinate, enumField.DELETE);

                //Get the coordinate number cell ...
                var objDeleteCell = objCoordinateListEditor.GetTableCellForField(objDeleteValueIdentifier);

                // Show the delete image ...
                objDeleteCell.find('.coordinates_delete_icon').show();
            }
        } else {

            // When this is the last row ...
            if (intCoordinate == arrDisplayCoordinates.length - 1) {

                // Add a new empty row at the end when the row is complete (All fields entered and valid) ...
                objCoordinateListEditor.AddEmptyRowWhenNeeded();

                // Update the scrollbar ...
                objCoordinateListEditor.UpdateScrollbar();
            }
        }
    }

    // When incomplete validation is not to be allowed ...
    if (!blnAllowInCompleteValidation) {

        // Fire the coordinates changed event ...
        objCoordinateListEditor.CoordinatesChanged();

        // Fire the coordinate changed event with the value identifier of the value that changed ...
        objCoordinateListEditor.TriggerCoordinateChangedCallbacks(intCoordinate);
    }
}

// **************************************************************************
// FUNCTION AddEmptyRowWhenNeeded: Add a new empty row when the last row is complete (All fields entered and valid) ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.AddEmptyRowWhenNeeded = function AddEmptyRowWhenNeeded() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When editable and the geometry type is not point ...
    if ((objCoordinateListEditor.Editable) && (objCoordinateListEditor.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT)) {

        // Get coordinates in appropriate metric
        var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

        // Get the last row ...
        var objLastRow = arrDisplayCoordinates[arrDisplayCoordinates.length - 1];

        // When all of the editable fields in the row has been entered, the row is valid and the control is editable ...
        if ((!objLastRow || (objCoordinateListEditor.AllCoordinateValuesEntered(objLastRow, objCoordinateListEditor.CoordinateFormat) &&
            objCoordinateListEditor.IsCoordinateValid(objLastRow))) && objCoordinateListEditor.Editable) {

            // Create a new row ...
            var objNewCoordinate = objCoordinateListEditor.CreateCoordinate();

            // Append the row to the array of values ...
            objCoordinateListEditor.Coordinates.AddDisplayCoordinate(objNewCoordinate);

            // Append the coordinate row ...
            objCoordinateListEditor.AppendCoordinateRow(objCoordinateListEditor.CreateRow(objNewCoordinate));
        }
    }
}

// **************************************************************************
// FUNCTION InValidFieldsForRow: Returns all the invlid fields for the row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.InValidFieldsForRow = function InValidFieldsForRow(objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new array to return the results in ...
    var arrInvalidFields = [];

    // Loop through all the invalid fields ..
    for (let intInvalidField = 0; intInvalidField < objCoordinateListEditor.InvalidFields.length; intInvalidField++) {

        // Get the invalid field value identifier at the index ...
        var objInvalidField = objCoordinateListEditor.InvalidFields[intInvalidField];

        // When the invalid field is in the row that we are checking ...
        if (objInvalidField.Coordinate == objCoordinate) {

            // Add the field to the array ...
            arrInvalidFields.push(objInvalidField);
        }
    }

    return arrInvalidFields;
}

// **************************************************************************
// FUNCTION RemoveInvalidFieldsForRow: Removes all the invalid fields for the row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.RemoveInvalidFieldsForRow = function RemoveInvalidFieldsForRow(objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new array to return the results in ...
    var arrInvalidFields = [];

    // Loop through all the invalid fields (from the last to the first) ..
    for (let intInvalidField = objCoordinateListEditor.InvalidFields.length - 1; intInvalidField >= 0; intInvalidField--) {

        // Get the invalid field value identifier at the index ...
        var objInvalidField = objCoordinateListEditor.InvalidFields[intInvalidField];

        // When the invalid field is in the row that we are clearing ...
        if (objInvalidField.objCoordinate == objCoordinate) {

            // Remove the field from the array ...
            objCoordinateListEditor.InvalidFields.splice(intInvalidField, 1);
        }
    }

    return arrInvalidFields;
}

// **************************************************************************
// FUNCTION InValidFieldsForRow: Returns all the invlid fields for the row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.IsFieldValid = function IsFieldValid(objCoordinate, enField) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Loop through all the invalid fields ..
    for (let intInvalidField = 0; intInvalidField < objCoordinateListEditor.InvalidFields.length; intInvalidField++) {

        // Get the invalid field value identifier at the index ...
        var objInvalidField = objCoordinateListEditor.InvalidFields[intInvalidField];

        // When we find a validation result for the field ...
        if ((objInvalidField.objCoordinate == objCoordinate) &&
            (enField == objInvalidField.enField)) {

            // Not valid ...
            return false;
        }
    }

    // Valid ...
    return true;
}

// **************************************************************************
// FUNCTION IsCoordinateValid: Returns true when the row is valid ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.IsCoordinateValid = function IsCoordinateValid(objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the invalid fields for the row ...
    var arrInValidFieldsForRow = objCoordinateListEditor.InValidFieldsForRow(objCoordinate);

    // Valid when the row no invalid fields and the row is valid overall ...
    return ((arrInValidFieldsForRow.length == 0) && (objCoordinate.RowMaximumValidationResult.IsValid));
}

// **************************************************************************
// FUNCTION RowValidationResults: Returns all the validation results for the row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.RowValidationResults = function RowValidationResults(objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Start with a new VALID validation result object ...
    let objValidationResult = TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);

    // Append the validation results from the row to it ...
    objValidationResult.Append(objCoordinate.RowMaximumValidationResult);

    // Get the invalid fields for the row ...
    var arrInValidFieldsForRow = objCoordinateListEditor.InValidFieldsForRow(objCoordinate);

    // Loop though all the invalid fields in the row ...
    for (let intInvalidField = 0; intInvalidField < arrInValidFieldsForRow.length; intInvalidField++) {

        // Get the invalid field at the index ...
        var objInvalidField = arrInValidFieldsForRow[intInvalidField];

        // Append the validation results from the field to objValidationResult ...
        objValidationResult.Append(objInvalidField.ValidationResult);
    }

    return objValidationResult;
}

// **************************************************************************
// FUNCTION UpdateCoordinateNumberSpans: Updates the values displayed in each 
//                                       cell of the coordinate number column (interface) ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.UpdateCoordinateNumberSpans = function UpdateCoordinateNumberSpans() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Get all the html rows <tr> of the editor ...
    var arrTableRows = $(objCoordinateListEditor.TableDOM.find('[IsCoordinateRow]'));

    // Loop through all the rows ...
    for (let intRow = 0; intRow < arrDisplayCoordinates.length; intRow++) {

        // Get the coordinate object at the index ...
        var objCoordinate = arrDisplayCoordinates[intRow];

        // Get the html row at the index (start at the second row to skip the headings) ...
        var objCoordinateRow = $(arrTableRows[intRow]);

        // Get the coordinate number cell from the row ...
        var objCoordinateNumberCell = $(objCoordinateRow.find('[FieldEnum="' + enumField.COORDINATE_NUMBER + '"]'));

        // Get the span within the cell ...
        var objSpan = objCoordinateNumberCell.find("span[IsCoordinateNumberSpan]");

        // When not the last row or when have any values entered ...
        if ((intRow < (arrDisplayCoordinates.length - 1)) || (objCoordinateListEditor.AnyCoordinateValuesEntered(objCoordinate, objCoordinateListEditor.CoordinateFormat))) {

            // Set the coordinate number or the row object (start at 1 with numbering) ...
            objCoordinate.COORDINATE_NUMBER = intRow + 1;
        }
        else {

            // Set the coordinate number to a plus sign '+' ...
            objCoordinate.COORDINATE_NUMBER = '+';
        }

        // Set the span's content to be the coordinate number ...
        objSpan.text(objCoordinate.COORDINATE_NUMBER);
    }
}

// **************************************************************************
// FUNCTION AllCoordinateValuesEntered: Check if all the editable coordinate have been entered (valid or not) ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.AllCoordinateValuesEntered = function AllCoordinateValuesEntered(objRowObject, enCoordinateFormat) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get all the fields for the coordinate format ...
    var arrFields = objCoordinateListEditor.GetFieldList();

    // Loop through all the fields for the coordinate format ...
    for (var intField = 0; intField < arrFields.length; intField++) {

        // Get the field at index intField ...
        var enField = arrFields[intField];

        // When the field is a value field ...
        if (TrimbleMap.CoordinateListEditor.Shared.IsValueField(enField)) {

            // Get the value as a string ...
            var strValue = '' + objRowObject[enField];

            // When the field value only contains white space ...
            if ((strValue).trim() == "") {

                // All values not entered ...
                return false;
            }
        }
    }

    // All values entered ...
    return true;
}

// **************************************************************************
// FUNCTION AnyCoordinateValuesEntered: Check if any of the editable coordinate have been entered (valid or not) ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.AnyCoordinateValuesEntered = function AnyCoordinateValuesEntered(objRowObject, enCoordinateFormat) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get all the fields for the coordinate format ...
    var arrFields = objCoordinateListEditor.GetFieldList();

    // Loop through all the fields for the coordinate format ...
    for (var intField = 0; intField < arrFields.length; intField++) {

        // Get the field at index intField ...
        var enField = arrFields[intField];

        // When the field is a value field ...
        if (TrimbleMap.CoordinateListEditor.Shared.IsEditableField(enField)) {

            // Get the value as a string ...
            var strValue = '' + objRowObject[enField];

            // When the field value only contains white space ...
            if ((strValue).trim() != "") {

                // A value was found to be entered ...
                return true;
            }
        }
    }

    // No values entered in row yet ...
    return false;
}

// **************************************************************************
// FUNCTION RePopulateValueCell: Swap the elements in a cell from one mode to another (VIEW <-> EDIT) ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.RePopulateValueCell = function RePopulateValueCell(objValueIdentifier, enMode, objTableCell) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the current value of SkipCoordinatesChanged ...
    var blnSkipFocusOutHandler = objCoordinateListEditor.SkipFocusOutHandler;

    // Set to skip the focus out event handler ... 
    objCoordinateListEditor.SkipFocusOutHandler = true;

    // Clear the contents of the cell <td> ...
    objTableCell.empty();

    // Reset the focus out value ...
    objCoordinateListEditor.SkipFocusOutHandler = blnSkipFocusOutHandler;

    // Append the field elements for the field to the table cell ...
    objCoordinateListEditor.PopulateValueCell(objValueIdentifier, enMode, objTableCell);
}

// **************************************************************************
// FUNCTION UpdateInvalidReasonIcon: Update the invalid reason icon for a row ...
// USAGE    blnUpdateDeleteIconsPosition is optional and defaults to false
// **************************************************************************
TrimbleMap.CoordinateListEditor.UpdateInvalidReasonIcon = function UpdateInvalidReasonIcon(objCoordinate, blnUpdateDeleteIconsPosition) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Find the invalid reason icon for the row if it exists ...
    var objInvalidReasonIcon = objCoordinateListEditor.SearchInvalidReasonIcons(objCoordinate);

    // Hide the invalid reasons popup when visible (because the reasons might 
    // have changed, force user to point to icon again for new reasons) ...
    objCoordinateListEditor.HideInvalidReasons();

    // Get the all validation results for the row ...
    var objValidationResults = objCoordinateListEditor.RowValidationResults(objCoordinate);

    // When the row is valid ...
    if (objValidationResults.IsValid) {

        // When an invalid reason icon for the row exists ...
        if (objInvalidReasonIcon) {

            // Get the icon element ...
            var objIconDOMElement = $(objCoordinateListEditor.CoordinateListEditorDiv.find('[InvalidReasonIconID="' + objInvalidReasonIcon.ID + '"]'));

            // Remove the icon from the dom ...
            objIconDOMElement.remove();

            // And remove it from the hashtable ...
            delete objCoordinateListEditor.InvalidReasonIcons[objInvalidReasonIcon.ID];
        }

    } else {

        // When no invalid reason icon for the row already exists ...
        if (objInvalidReasonIcon == null) {

            // Create a uniqe dom id for the icon ...
            var strIconDomId = objCoordinateListEditor.UniqueID('img');

            // Create a new invalid reason icon object ...
            var objInvalidReasonIcon = TrimbleMap.CoordinateListEditor.Shared.CreateInvalidReasonIcon(SD.Guid.Shared.NewID(), objCoordinate);

            // Create the invalid reason icon dom element ...
            var objIconDOMElement = $('<div class="map_coordinatelisteditor_invalid_reason_icon" id="' + strIconDomId + '" InvalidReasonIconID="' + objInvalidReasonIcon.ID + '"></div>');

            // Get the Invalid Reason cell at the row index ...
            var objInvalidReasonValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(objInvalidReasonIcon.Coordinate, enumField.INVALID_REASON);

            //Get the coordinate number cell ...
            var objInvalidReasonCell = objCoordinateListEditor.GetTableCellForField(objInvalidReasonValueIdentifier);

            // Append the icon to the invalid reason icon cell ...
            objInvalidReasonCell.append(objIconDOMElement);

            // Add the invalid reason icon to the list ...
            objCoordinateListEditor.InvalidReasonIcons[objInvalidReasonIcon.ID] = objInvalidReasonIcon;

            // When the event handlers has already been attached ... 
            if (objCoordinateListEditor.EventHandlersAttached) {

                // Attach an event handler for the mouseenter event to the icon ...
                objIconDOMElement.mouseenter(objCoordinateListEditor.InvalidReasonIconMouseEnterProxy);

                // Attach an event handler for the mouseleave event to the icon ...
                objIconDOMElement.mouseleave(objCoordinateListEditor.InvalidReasonIconMouseLeaveProxy);
            }
        }
    }

    // Update the delete icon's position ...
    if (blnUpdateDeleteIconsPosition) { objCoordinateListEditor.UpdateDeleteIconsPosition(); }
}

// **************************************************************************
// FUNCTION UpdateAllInvalidReasonIcons: Update all the invalid reason icons ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.UpdateAllInvalidReasonIcons = function UpdateAllInvalidReasonIcons() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Loop through all the rows ...
    for (var intRow = 0; intRow < arrDisplayCoordinates.length; intRow++) {

        // Get the row at the index ...
        var objCoordinate = arrDisplayCoordinates[intRow];

        // Update the invalid reason icon for the row ...
        objCoordinateListEditor.UpdateInvalidReasonIcon(objCoordinate);
    }

    // Update the delete icon's position ...
    objCoordinateListEditor.UpdateDeleteIconsPosition();
}

// **************************************************************************
// FUNCTION UpdateDeleteIconsPosition
// **************************************************************************
TrimbleMap.CoordinateListEditor.UpdateDeleteIconsPosition = function UpdateDeleteIconsPosition(objInvalidReasonIcon, objIconDOMElement) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Start with not having any invalid reason icons ...
    var blnHasInvalidReasonIcons = false;

    // Check if we have any invalid reason icons ...
    $.each(objCoordinateListEditor.InvalidReasonIcons, function (strTestInvalidaReasonIconID, objTestInvalidReasonIcon) { blnHasInvalidReasonIcons = true; return false; });

    // Add the map_coordinatelisteditor_has_invalid_coordinates class when we have any invalid reason icons ...
    if (blnHasInvalidReasonIcons) { objCoordinateListEditor.CoordinateListEditorDiv.addClass('map_coordinatelisteditor_has_invalid_coordinates'); }
    else { objCoordinateListEditor.CoordinateListEditorDiv.removeClass('map_coordinatelisteditor_has_invalid_coordinates'); }
}

// **************************************************************************
// FUNCTION ShowInvalidReasons: Shows the invalid reasons for the row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ShowInvalidReasons = function ShowInvalidReasons(objInvalidReasonIcon, objIconDOMElement) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new div with a table with row <tr> and one cell <td> to display the invalid reasons in ...
    objCoordinateListEditor.InvalidReasonsDivDOM = $('<div class="coordinatelisteditor_invalidreasons_div" style="position:absolute"><table cellpadding="0" cellspacing="0"><tr><td nowrap="nowrap"></td></tr></table></div>');

    // Get the cell that we created ...
    var objCell = objCoordinateListEditor.InvalidReasonsDivDOM.find('td').first();

    // Add the heading span ...
    // Translation: 'Invalid Coordinate'    
    objCell.append($('<span class="InvalidReasonsHeading">' + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'InvalidCoordinate') + '</span><br />'))

    // Get the all validation results for the row ...
    var objValidationResults = objCoordinateListEditor.RowValidationResults(objInvalidReasonIcon.Coordinate);

    // Loop through all the invalid reasons ...
    for (var intValidationResult = 0; intValidationResult < objValidationResults.InvalidReasons.length; intValidationResult++) {

        // Get the invalid reason at the icon ...
        var strInvalidReason = objValidationResults.InvalidReasons[intValidationResult];

        // Add the reason as a <span> to the cell <td> ...
        objCell.append($('<span class="InvalidReasons">' + strInvalidReason + '</span><br />'))
    }

    // The invalid reason icon height ...
    var intInvalidReasonIconHeight = 13;

    // Get the offset if the table dom relative to the div in which the grid is created ...
    var objInvalidReasonIconPosition = objIconDOMElement.position();

    // Measure the size of the invalid reason element ...
    var objInvalidReasonsDivDOMSize = SD.HtmlFunctions.Shared.MeasureElement(objCoordinateListEditor.InvalidReasonsDivDOM);

    // Compute the top and left so that the reasons would be displayed tp the right of the icon ...
    var intTop = objInvalidReasonIconPosition.top;
    var intLeft = objInvalidReasonIconPosition.left - objInvalidReasonsDivDOMSize.width - 5;

    // Set the position of the icon ...
    objCoordinateListEditor.InvalidReasonsDivDOM.css("inset-block-start", intTop);
    objCoordinateListEditor.InvalidReasonsDivDOM.css("inset-inline-start", intLeft);

    // Add the reasons to the dom ...
    // Append the icon to the div in which the coordinate list has been created ...
    objCoordinateListEditor.CoordinateListEditorDiv.append(objCoordinateListEditor.InvalidReasonsDivDOM);
}

// **************************************************************************
// Function HideInvalidReasons: Hides the invalid reasons for the row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.HideInvalidReasons = function HideInvalidReasons(objInvalidReasonIcon) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When we have an invalid reasons popup ...
    if (objCoordinateListEditor.InvalidReasonsDivDOM) {

        // Remove the invalid reasons popup from the dom ...
        objCoordinateListEditor.InvalidReasonsDivDOM.remove();

        // Set to null ...
        objCoordinateListEditor.InvalidReasonsDivDOM = null;
    }
}

// **************************************************************************
// FUNCTION ConvertDDToProjected: Converts DD value array to projected ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ConvertDDToProjected = function ConvertDDToProjected(arrCoordinates, intDecimalPlaces, blnValidateFields) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new array for the converted values ...
    var arrConvertedCoordinates = [];

    // Loop through each row object on the array ...
    for (let intRowIndex = 0; intRowIndex < arrCoordinates.length; intRowIndex++) {

        // Get the coordinate object ... 
        let objCoordinate = arrCoordinates[intRowIndex];

        // Create a new projected Row object ...
        var objNewCoordinate = objCoordinateListEditor.CreateCoordinate(TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED);

        // When a LATITUDE_DEGREES value is specified and is valid ...
        if (((objCoordinate.LATITUDE_DEGREES).trim() != "") &&
            (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LATITUDE_DEGREES))) {

            // Set Y to be the LATITUDE_DEGREES ...
            objNewCoordinate.Y = SD.Number.RoundTo(SD.Number.ToNumber(objCoordinate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator), intDecimalPlaces);

            // When south ...
            if (objCoordinate.NORTH_SOUTH == enumNorthSouth.SOUTH) {

                // Negate the Y value ...
                objNewCoordinate.Y = -objNewCoordinate.Y;
            }

            // Convert to a string ...
            objNewCoordinate.Y = SD.DisplayValue.FromDouble(objNewCoordinate.Y, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
        }

        // When a LONGITUDE_DEGREES value is specified and is valid ...
        if (((objCoordinate.LONGITUDE_DEGREES).trim() != "") &&
            (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LONGITUDE_DEGREES))) {

            // Set X to be the LONGITUDE_DEGREES ...
            objNewCoordinate.X = SD.Number.RoundTo(SD.Number.ToNumber(objCoordinate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator), intDecimalPlaces);

            // When west ...
            if (objCoordinate.EAST_WEST == enumEastWest.WEST) {

                // Negate the X value ...
                objNewCoordinate.X = -objNewCoordinate.X;
            }

            // Convert to a string ...
            objNewCoordinate.X = SD.DisplayValue.FromDouble(objNewCoordinate.X, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
        }

        // Copy the coordinate number and N/S and E/W properties ...
        if (typeof (objCoordinate.COORDINATE_NUMBER) != 'undefined') { objNewCoordinate.COORDINATE_NUMBER = objCoordinate.COORDINATE_NUMBER; }

        // Add the new row object to the converted array ...
        arrConvertedCoordinates.push(objNewCoordinate);
    }

    // Return the converted array ...
    return arrConvertedCoordinates;
}

// **************************************************************************
// FUNCTION ConvertProjectedToDD: Converts projected value array to dd ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ConvertProjectedToDD = function ConvertProjectedToDD(arrCoordinates, intDecimalPlaces, blnValidateFields) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new array for the converted values ...
    var arrConvertedCoordinates = [];

    // Loop through each row object on the array ...
    for (let intRowIndex = 0; intRowIndex < arrCoordinates.length; intRowIndex++) {

        // Get the coordinate object ... 
        objCoordinate = arrCoordinates[intRowIndex];

        // Create a new geographic dd Row object ...
        var objNewCoordinate = objCoordinateListEditor.CreateCoordinate(TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD);

        // When a Y value is specified and is valid ...
        if (((objCoordinate.Y).trim() != "") &&
            (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.Y))) {

            // Use X as the LATITUDE_DEGREES ...
            objNewCoordinate.LATITUDE_DEGREES = SD.Number.RoundTo(SD.Number.ToNumber(objCoordinate.Y, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator), intDecimalPlaces);

            // When negative Y ...
            if (objNewCoordinate.LATITUDE_DEGREES < 0) {

                // NEGATE the LATITUDE_DEGREES ...
                objNewCoordinate.LATITUDE_DEGREES = -objNewCoordinate.LATITUDE_DEGREES;

                // Set to south ...
                objNewCoordinate.NORTH_SOUTH = enumNorthSouth.SOUTH;
            } else {

                // Set to north ...
                objNewCoordinate.NORTH_SOUTH = enumNorthSouth.NORTH;
            }

            // Convert to a string ...
            objNewCoordinate.LATITUDE_DEGREES = SD.DisplayValue.FromDouble(objNewCoordinate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
        }

        // When a X value is specified and is valid ...
        if (((objCoordinate.X).trim() != "") &&
            (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.X))) {

            // Use X as the LONGITUDE_DEGREES ...
            objNewCoordinate.LONGITUDE_DEGREES = SD.Number.RoundTo(SD.Number.ToNumber(objCoordinate.X, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator), intDecimalPlaces);

            // When negative X ...
            if (objNewCoordinate.LONGITUDE_DEGREES < 0) {

                // NEGATE the LONGITUDE_DEGREES ...
                objNewCoordinate.LONGITUDE_DEGREES = -objNewCoordinate.LONGITUDE_DEGREES;

                // Set to west ...
                objNewCoordinate.EAST_WEST = enumEastWest.WEST;

            } else {

                // Set to east ...
                objNewCoordinate.EAST_WEST = enumEastWest.EAST;
            }

            // Convert to a string ...
            objNewCoordinate.LONGITUDE_DEGREES = SD.DisplayValue.FromDouble(objNewCoordinate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
        }

        // Copy the coordinate number and N/S and E/W properties ...
        objNewCoordinate.COORDINATE_NUMBER = objCoordinate.COORDINATE_NUMBER;

        // Add the new row object to the converted array ...
        arrConvertedCoordinates.push(objNewCoordinate);
    }

    // Return the converted array ...
    return arrConvertedCoordinates;
}

// **************************************************************************
// FUNCTION ConvertDMSToDD: Converts DMS value array to DD ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ConvertDMSToDD = function ConvertDMSToDD(arrCoordinates, intDecimalPlaces, blnValidateFields) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new array for the converted values ...
    var arrConvertedCoordinates = [];

    // Loop through each row object on the array ...
    for (let intRowIndex = 0; intRowIndex < arrCoordinates.length; intRowIndex++) {

        // Get the coordinate object ... 
        objCoordinate = arrCoordinates[intRowIndex];

        // Create a new DD Row object ...
        var objNewCoordinate = objCoordinateListEditor.CreateCoordinate(TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD);

        // Separately check if the latitude degrees, minutes and seconds is specified and are valid ...
        var blnLatitudeDegreesValid = (((objCoordinate.LATITUDE_DEGREES).trim() != "") && (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LATITUDE_DEGREES)));
        var blnLatitudeMinutesValid = (((objCoordinate.LATITUDE_MINUTES).trim() != "") && (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LATITUDE_MINUTES)));
        var blnLatitudeSecondsValid = (((objCoordinate.LATITUDE_SECONDS).trim() != "") && (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LATITUDE_SECONDS)));

        // When the degrees, minutes or seconds have been specified and is valid...
        if (blnLatitudeDegreesValid || blnLatitudeMinutesValid || blnLatitudeSecondsValid) {

            // Use the degrees,minutes and seconds when valid and specified otherwise 0 ...
            var decLatitudeDegrees = (blnLatitudeDegreesValid ? SD.Number.ToNumber(objCoordinate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) : 0);
            var decLatitudeMinutes = (blnLatitudeMinutesValid ? SD.Number.ToNumber(objCoordinate.LATITUDE_MINUTES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) : 0);
            var decLatitudeSeconds = (blnLatitudeSecondsValid ? SD.Number.ToNumber(objCoordinate.LATITUDE_SECONDS, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) : 0);

            // Convert the LATITUDE_DEGREES to DMS ...
            objNewCoordinate.LATITUDE_DEGREES = SD.DisplayValue.FromDouble(SD.Number.RoundTo(decLatitudeDegrees + (decLatitudeMinutes / 60.0) + (decLatitudeSeconds / 3600.0), intDecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
        }

        // Separately check if the longitude degrees, minutes and seconds is specified and are valid ...
        var blnLongitudeDegreesValid = (((objCoordinate.LONGITUDE_DEGREES).trim() != "") && (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LONGITUDE_DEGREES)));
        var blnLongitudeMinutesValid = (((objCoordinate.LONGITUDE_MINUTES).trim() != "") && (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LONGITUDE_MINUTES)));
        var blnLongitudeSecondsValid = (((objCoordinate.LONGITUDE_SECONDS).trim() != "") && (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LONGITUDE_SECONDS)));

        // When the degrees, minutes or seconds have been specified and is valid...
        if (blnLongitudeDegreesValid || blnLongitudeMinutesValid || blnLongitudeSecondsValid) {

            // Use the degrees,minutes and seconds when valid and specified otherwise 0 ...
            var decLongitudeDegrees = (blnLongitudeDegreesValid ? SD.Number.ToNumber(objCoordinate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) : 0);
            var decLongitudeMinutes = (blnLongitudeMinutesValid ? SD.Number.ToNumber(objCoordinate.LONGITUDE_MINUTES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) : 0);
            var decLongitudeSeconds = (blnLongitudeSecondsValid ? SD.Number.ToNumber(objCoordinate.LONGITUDE_SECONDS, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) : 0);

            // Convert the LONGITUDE_DEGREES to DMS ...
            objNewCoordinate.LONGITUDE_DEGREES = SD.DisplayValue.FromDouble(SD.Number.RoundTo(decLongitudeDegrees + (decLongitudeMinutes / 60.0) + (decLongitudeSeconds / 3600.0), intDecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
        }

        // Copy the coordinate number and N/S and E/W properties ...
        if (typeof (objCoordinate.COORDINATE_NUMBER) != 'undefined') { objNewCoordinate.COORDINATE_NUMBER = objCoordinate.COORDINATE_NUMBER; }
        if (typeof (objCoordinate.NORTH_SOUTH) != 'undefined') { objNewCoordinate.NORTH_SOUTH = objCoordinate.NORTH_SOUTH; }
        if (typeof (objCoordinate.EAST_WEST) != 'undefined') { objNewCoordinate.EAST_WEST = objCoordinate.EAST_WEST; }

        // Add the new row object to the converted array ...
        arrConvertedCoordinates.push(objNewCoordinate);
    }

    // Return the converted array ...
    return arrConvertedCoordinates;
}

// **************************************************************************
// FUNCTION ConvertDDToDMS: Converts DD value array to DMS ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ConvertDDToDMS = function ConvertDDToDMS(arrCoordinates, blnValidateFields, intGeographicSecondsDecimalPlaces) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new array for the converted values ...
    var arrConvertedCoordinates = [];

    // Loop through each row object on the array ...
    for (let intRowIndex = 0; intRowIndex < arrCoordinates.length; intRowIndex++) {

        // Get the coordinate object ... 
        objCoordinate = arrCoordinates[intRowIndex];

        // Create a new DD Row object ...
        var objNewCoordinate = objCoordinateListEditor.CreateCoordinate(TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS);

        //When a LATITUDE_DEGREES value is specified and is valid ...
        if (((objCoordinate.LATITUDE_DEGREES).trim() != "") &&
            (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LATITUDE_DEGREES))) {

            // Convert the LATITUDE_DEGREES to DMS ...
            objNewCoordinate.LATITUDE_DEGREES = String(SD.Number.Truncate(SD.Number.ToNumber(objCoordinate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator)));
            objNewCoordinate.LATITUDE_MINUTES = String(SD.Number.Truncate(Math.abs(SD.Number.ToNumber(objCoordinate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator)) * 60.0) % 60.0);
            objNewCoordinate.LATITUDE_SECONDS = SD.DisplayValue.FromDouble(SD.Number.RoundTo((Math.abs(SD.Number.ToNumber(objCoordinate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator)) * 3600.0) % 60.0, intGeographicSecondsDecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);

            // When the seconds works out to 60 ...
            if (objNewCoordinate.LATITUDE_SECONDS == 60) {

                // Use 0 seconds ...
                objNewCoordinate.LATITUDE_SECONDS = '0';

                // Increment the minutes with 1 ...
                objNewCoordinate.LATITUDE_MINUTES = String(SD.Number.ToNumber(objNewCoordinate.LATITUDE_MINUTES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) + 1);
            }

            // When the minutes works out to 60 ...
            if (objNewCoordinate.LATITUDE_MINUTES == 60) {

                // Use 0 minutes ...
                objNewCoordinate.LATITUDE_MINUTES = '0';

                // Increment the degrees with 1 ...
                objNewCoordinate.LATITUDE_DEGREES = String(SD.Number.ToNumber(objNewCoordinate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) + 1);
            }
        }

        //When a LONGITUDE_DEGREES value is specified and is valid ...
        if (((objCoordinate.LONGITUDE_DEGREES).trim() != "") &&
            (!blnValidateFields || objCoordinateListEditor.IsFieldValid(objCoordinate, enumField.LONGITUDE_DEGREES))) {

            // Convert the LONGITUDE_DEGREES to DMS ...
            objNewCoordinate.LONGITUDE_DEGREES = String(SD.Number.Truncate(SD.Number.ToNumber(objCoordinate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator)));
            objNewCoordinate.LONGITUDE_MINUTES = String(SD.Number.Truncate(Math.abs(SD.Number.ToNumber(objCoordinate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator)) * 60.0) % 60.0);
            objNewCoordinate.LONGITUDE_SECONDS = SD.DisplayValue.FromDouble(SD.Number.RoundTo((Math.abs(SD.Number.ToNumber(objCoordinate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator)) * 3600.0) % 60.0, intGeographicSecondsDecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);

            // When the seconds works out to 60 ...
            if (objNewCoordinate.LONGITUDE_SECONDS == 60) {

                // Use 0 seconds ...
                objNewCoordinate.LONGITUDE_SECONDS = '0';

                // Increment the minutes with 1 ...
                objNewCoordinate.LONGITUDE_MINUTES = String(SD.Number.ToNumber(objNewCoordinate.LONGITUDE_MINUTES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) + 1);
            }

            // When the minutes works out to 60 ...
            if (objNewCoordinate.LONGITUDE_MINUTES == 60) {

                // Use 0 minutes ...
                objNewCoordinate.LONGITUDE_MINUTES = '0';

                // Increment the degrees with 1 ...
                objNewCoordinate.LONGITUDE_DEGREES = String(SD.Number.ToNumber(objNewCoordinate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) + 1);
            }
        }

        // Copy the coordinate number and N/S and E/W properties ...
        if (typeof (objCoordinate.COORDINATE_NUMBER) != 'undefined') { objNewCoordinate.COORDINATE_NUMBER = objCoordinate.COORDINATE_NUMBER; }
        if (typeof (objCoordinate.NORTH_SOUTH) != 'undefined') { objNewCoordinate.NORTH_SOUTH = objCoordinate.NORTH_SOUTH; }
        if (typeof (objCoordinate.EAST_WEST) != 'undefined') { objNewCoordinate.EAST_WEST = objCoordinate.EAST_WEST; }

        // Add the new row object to the converted array ...
        arrConvertedCoordinates.push(objNewCoordinate);
    }

    // Return the converted array ...
    return arrConvertedCoordinates;
}

// **************************************************************************
// FUNCTION GetTableCellForField: Get the next table cell for the field 
//                                identified by the value identifier ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetTableCellForField = function GetTableCellForField(objValueIdentifier) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // The variable to return the result in (start with null) ...
    var objTableCell = null;

    // When a valid value identifier were passed in ...
    if (objValueIdentifier) {

        // Get coordinates in appropriate metric
        var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

        // Get the row index ...
        var intRow = arrDisplayCoordinates.findIndex(function (objCoordinate) {
            return objCoordinate.COORDINATE_NUMBER === objValueIdentifier.Coordinate.COORDINATE_NUMBER;
        });

        // Get the html table row at the index (+ 1 to skip the header row) ...
        var objTableRow = $($(objCoordinateListEditor.TableDOM.children()[0]).children()[intRow]);

        // Get the fields for the coordinate format ...
        var arrFields = objCoordinateListEditor.GetFieldList();

        // Get the index of the field in the list ...
        var intField = $.inArray(objValueIdentifier.Field, arrFields);

        // Get the html cell at the field index from the html row ...
        var objTableCell = $(objTableRow.children()[intField]);
    }

    return objTableCell;
}

// **************************************************************************
// FUNCTION FocusValueCell: Changes the interface to be focussed on the field ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.FocusValueCell = function FocusValueCell(objValueIdentifier, objTableCell, enFocusOnField) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the current value of SkipCoordinatesChanged ...
    var blnSkipFocusOutHandler = objCoordinateListEditor.SkipFocusOutHandler;

    // Set to skip the focus out event handler ... 
    objCoordinateListEditor.SkipFocusOutHandler = true;

    // When we had a focussed field ...
    if (objCoordinateListEditor.FocussedValueIdentifier) {

        // Update the internal field's value from the interface ...
        objCoordinateListEditor.UpdateFieldValueFromInterface(objCoordinateListEditor.FocussedValueIdentifier, objCoordinateListEditor.FocussedTableCell, false);

        // Swap elements in the cell for the previously focussed 
        // field to the elements required for VIEW mode ...
        objCoordinateListEditor.RePopulateValueCell(objCoordinateListEditor.FocussedValueIdentifier, enumMode.VIEW, objCoordinateListEditor.FocussedTableCell);
    }

    // When not focussing on the provided field ...
    if (enFocusOnField != enumFocusOnField.PROVIDED) {

        // Get the field to focus on base on enFocusOnField ...
        switch (enFocusOnField) {
            case enumFocusOnField.NEXT: objValueIdentifier = objCoordinateListEditor.GetNextField(objValueIdentifier); break;
            case enumFocusOnField.PREVIOUS: objValueIdentifier = objCoordinateListEditor.GetPreviousField(objValueIdentifier); break;
            case enumFocusOnField.ABOVE: objValueIdentifier = objCoordinateListEditor.GetAboveField(objValueIdentifier); break;
            case enumFocusOnField.BELOW: objValueIdentifier = objCoordinateListEditor.GetBelowField(objValueIdentifier); break;
        }

        // Get the table cell for the field to fucs on ...
        objTableCell = objCoordinateListEditor.GetTableCellForField(objValueIdentifier);
    }

    // When there is a field to focus on ...
    if (objValueIdentifier) {

        // Re-Validate the field allowing incomplete entries ...
        objValueIdentifier.ValidationResult = objCoordinateListEditor.ValidateField(objValueIdentifier, true);

        // Update the invalid fields array with the field's validation results ...
        objCoordinateListEditor.UpdateInvalidFields(objValueIdentifier);

        // Update the invalid reason icon for the row ...
        objCoordinateListEditor.UpdateInvalidReasonIcon(objValueIdentifier.Coordinate, true);

        // Swap elements in the cell to the elements required for EDIT mode ...
        objCoordinateListEditor.RePopulateValueCell(objValueIdentifier, enumMode.EDIT, objTableCell);

        // When it is a text box ...
        if (objTableCell.find('input[type$="text"]').length > 0) {

            // Get the input object inside the cell ...
            var objInputDOMElement = $(objTableCell.find('input'));

            // Focus on the input element and select the contents ...
            objInputDOMElement.focus().select();
        }
        else {

            // Focus on the combobox ...
            $(objTableCell.children()[0]).focus().focus();
        }

        // Set the value indentifier to be focussed ...
        objCoordinateListEditor.FocussedValueIdentifier = objValueIdentifier;

        // Set the focussed table cell to be the cell that the user just clicked on ...
        objCoordinateListEditor.FocussedTableCell = objTableCell;

    } else {

        // Set the not have a focussed field anymore ...
        objCoordinateListEditor.FocussedValueIdentifier = null;

        // Set the not have a focussed table cell anymore ...
        objCoordinateListEditor.FocussedTableCell = null;
    }

    // Set to not skip the focus out event handler after this ... 
    objCoordinateListEditor.SkipFocusOutHandler = blnSkipFocusOutHandler;
}


// **************************************************************************
// FUNCTION DeleteRow: Deletes the row identified by objCoordinate ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.DeleteRow = function DeleteRow(objCoordinate, objTableRow) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create an array of invalid fields ...
    var arrNewInvalidFields = [];

    // Loop through all the invalid fields ...
    for (var intInvalidField = 0; intInvalidField < objCoordinateListEditor.InvalidFields.length; intInvalidField++) {

        // Get the invalid field ...
        var objInvalidField = objCoordinateListEditor.InvalidFields[intInvalidField];

        // When the invalid field is not for the coordinate ...
        if (objInvalidField.Coordinate != objCoordinate) {

            // Add the invalid field to the array ...
            arrNewInvalidFields.push(objInvalidField);
        }
    }

    // Replace the invalid field array ...
    objCoordinateListEditor.InvalidFields = arrNewInvalidFields;

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Get the row
    var intRow = arrDisplayCoordinates.find(function (objTestCoordinate) {
        return objTestCoordinate.COORDINATE_NUMBER === objCoordinate.COORDINATE_NUMBER;
    }).COORDINATE_NUMBER;

    // When we have a focussed cell and the focussed value 
    // cell is in the row that we are deleting ...
    if ((objCoordinateListEditor.FocussedTableCell) &&
        (objTableRow.get(0) == objCoordinateListEditor.FocussedTableCell.parent().get(0))) {

        // Set the focussed field property to null ...
        objCoordinateListEditor.FocussedValueIdentifier = null;

        // Also set the focussed table cell property to null ...
        objCoordinateListEditor.FocussedTableCell = null;
    }

    // Remove all the invalid fields for the row ...
    objCoordinateListEditor.RemoveInvalidFieldsForRow(objCoordinate);

    // Set the row level validation results to valid ...
    objCoordinate.RowMaximumValidationResult = TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);

    // Remove any invalid reason icons that might be showing ...
    objCoordinateListEditor.UpdateInvalidReasonIcon(objCoordinate, true);

    // Remove all the value identifers from the array and hash table for the table row ...
    objCoordinateListEditor.RemoveValueIdentifiersForTableRow(objTableRow);

    // Remove the row from the dom ...
    objTableRow.remove();

    // Decrement the number of coordinates populated ...
    objCoordinateListEditor.CoordinatesPopulated--;

    // Remove the row from the coordinates array ...
    objCoordinateListEditor.Coordinates.RemoveCoordinate(intRow - 1);

    // Add an empty row if required
    objCoordinateListEditor.AddEmptyRowWhenNeeded();

    // Update the coordinate number spans for all the erows ...
    objCoordinateListEditor.UpdateCoordinateNumberSpans();

    // Update the scrollbar ...
    objCoordinateListEditor.UpdateScrollbar();
}

// **************************************************************************
// FUNCTION RemoveValueIdentifiersForTableRow: Remove all the value identifers from the 
//                                             array and hash table for the table row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.RemoveValueIdentifiersForTableRow = function RemoveValueIdentifiersForTableRow(objTableRow) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get all the cells in the row ...
    var arrCells = objTableRow.find('td');

    // Loop through all the cells in the row ...
    for (let intCell = 0; intCell < arrCells.length; intCell++) {

        // Get the cell at the index ...
        var objCell = $(arrCells[intCell]);

        // Get the cell id ...
        var strCellId = objCell.attr('id');

        // Get the value identfier from the hash table ...
        var objValueIdentifier = objCoordinateListEditor.GetValueIdentifierByCellID(strCellId);

        // When the value identifier were found in the hash table ...
        if (objValueIdentifier) {

            // Delete the value identifier from the hash table ...
            delete objCoordinateListEditor.GetValueIdentifierByCellID(strCellId);
        }

        // Get the index of the value identier in the array ...
        var intValueIdentifier = $.inArray(objValueIdentifier, objCoordinateListEditor.ValueIdentifiers);

        // When found ...
        if (intValueIdentifier != -1) {

            // Delete from the array ...
            objCoordinateListEditor.ValueIdentifiers.splice(intValueIdentifier, 1);
        }
    }
}

// **************************************************************************
// FUNCTION CreateDropArrowAndLine: Creates the drop arrow and line ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateDropArrowAndLine = function CreateDropArrowAndLine(objDraggedRow) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create the drag arrow image dom element ...
    objCoordinateListEditor.DragArrowDOMElement = $('<div class="coordinates_drop_arrow"></div>');

    // Create the drag line div dom element ...
    objCoordinateListEditor.DragLineDOMElement = $('<div class="DropLine" style="width:' + objDraggedRow.parent().width() + 'px;"></div>');
}

// **************************************************************************
// FUNCTION CreateDropPlus: Creates the drop plus ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateDropPlus = function CreateDropPlus() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create the drag arrow image dom element ...
    objCoordinateListEditor.DragPlusDOMElement = $('<div class="coordinates_drop_plus"></div>');
}

// **************************************************************************
// FUNCTION TableMouseLeave
// USAGE    
// **************************************************************************
TrimbleMap.CoordinateListEditor.TableMouseLeave = function TableMouseLeave(e) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Set to not have a hovered coordinate ...
    objCoordinateListEditor.HoveredCoordinateIndex = null;

    // Clear the coordinate highlight ...
    objCoordinateListEditor.ClearCoordinateHighlight();

    // Trigger the hovered callbacks ...
    objCoordinateListEditor.TriggerCoordinateHoveredCallbacks(objCoordinateListEditor.HoveredCoordinateIndex);
}

// **************************************************************************
// FUNCTION TableMouseMove
// USAGE    
// **************************************************************************
TrimbleMap.CoordinateListEditor.TableMouseMove = function TableMouseMove(e) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When we are not dragging a row ...
    if (!objCoordinateListEditor.DraggingRow) {

        // Get the current hovered row index ...
        var intPreviousHoveredCoordinateIndex = objCoordinateListEditor.HoveredCoordinateIndex;

        // Compute the hovered table row index ...
        var intHoveredRowIndex = objCoordinateListEditor.ComputeHoveredRowIndex(e.pageY);

        // Compute the hovered coordinate index (set to null when on the header row) ...
        objCoordinateListEditor.HoveredCoordinateIndex = (intHoveredRowIndex > -1) ? intHoveredRowIndex : null;

        // When the hovered coordinate index changed ...
        if (intPreviousHoveredCoordinateIndex != objCoordinateListEditor.HoveredCoordinateIndex) {

            // Get coordinates in appropriate metric
            var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

            // When the last coordinate and an empty row ...
            if ((objCoordinateListEditor.HoveredCoordinateIndex == arrDisplayCoordinates.length - 1) && (arrDisplayCoordinates[objCoordinateListEditor.HoveredCoordinateIndex].COORDINATE_NUMBER == '+')) {

                // Set to not have a hovered row index ...
                objCoordinateListEditor.HoveredCoordinateIndex = null;
            }

            // When the hovered coordinate index changed ...
            if (intPreviousHoveredCoordinateIndex != objCoordinateListEditor.HoveredCoordinateIndex) {

                // When we have a hovered coordinate ...     
                if (objCoordinateListEditor.HoveredCoordinateIndex != null) {

                    // Highlight the hovered coordinate ...
                    objCoordinateListEditor.HighlightCoordinate(objCoordinateListEditor.HoveredCoordinateIndex);

                } else {

                    // Clear the coordinate highlight ...
                    objCoordinateListEditor.ClearCoordinateHighlight();
                }

                // Trigger the hovered callbacks ...
                objCoordinateListEditor.TriggerCoordinateHoveredCallbacks(objCoordinateListEditor.HoveredCoordinateIndex);
            }
        }
    }
}

// **************************************************************************
// FUNCTION ComputeHoveredRowIndex
// USAGE    Computes the row index in which intPageY is ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ComputeHoveredRowIndex = function ComputeHoveredRowIndex(intPageY, blnFromPreviousRowCenterToCurrentRowCenter) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Compute the row (decimal value) ...
    var decRow = (intPageY - objCoordinateListEditor.TableDOM.offset().top) / TrimbleMap.CoordinateListEditor.Shared.ROW_HEIGHT;

    // Convert the decimal row value to an integer index ...
    var intHoverRowIndex = (blnFromPreviousRowCenterToCurrentRowCenter) ? Math.round(decRow) : SD.Number.Truncate(decRow);

    // Return the row index ...
    return intHoverRowIndex;
}

// **************************************************************************
// FUNCTION PositionDropArrowAndLine
// Position the drop arrow and line above the provided cell ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.PositionDropArrowAndLine = function PositionDropArrowAndLine(event, ui) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the rows of the table ...
    var objTableRows = objCoordinateListEditor.TableDOM.children().first().children();

    // Compute the hover row index ...
    var intHoverRowIndex = objCoordinateListEditor.ComputeHoveredRowIndex(event.pageY, true);

    // When we found a row that we are hovering over ...
    if (intHoverRowIndex != -1) {

        // When hovering over the header (row with index 0 is the header row) ...
        if (intHoverRowIndex < 0) {

            // Set the drop index to be the first coordinate row ...
            intHoverRowIndex = 0;
        }

        // Start off with showing above the line ...
        var blnShowAbove = true;

        // Start with not showing the plus sign instead ...
        var blnShowPlusSignInstead = false;

        // When after the last row 
        if (intHoverRowIndex >= objTableRows.length) {

            // Get coordinates in appropriate metric
            var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

            // Get the last row ...
            var objLastCoordinate = arrDisplayCoordinates[arrDisplayCoordinates.length - 1];

            // Set to be the last row ...
            intHoverRowIndex = objTableRows.length - 1;

            // When the last row has a plus sign ...
            if (objLastCoordinate.COORDINATE_NUMBER == '+') {

                // Set to show the plus sign instead ...
                blnShowPlusSignInstead = true;

            } else {

                // Set to show below the cell ...
                blnShowAbove = false;
            }
        }

        // Set the drop index ...
        objCoordinateListEditor.DropRowIndex = intHoverRowIndex;

        // Set to drop before or after the drop index ...
        objCoordinateListEditor.DropBeforeIndex = blnShowAbove;

        // Get the first cell of the table row on which we are hovering ...
        var objHoverCell = $(objTableRows[intHoverRowIndex]).children().first();

        // Get the offset of the grabbed cell relative to the offset parent ...
        var objDraggedCellPosition = objHoverCell.position();

        // When the plus sign is to be shown instead ...
        if (blnShowPlusSignInstead) {

            // When set to move on drop ...
            if (objCoordinateListEditor.DropAction == enumDropAction.MOVE) {

                // Remove the drag arrow and line from the dom ...
                objCoordinateListEditor.DragArrowDOMElement.remove();
                objCoordinateListEditor.DragLineDOMElement.remove();

                // Set to null ...
                objCoordinateListEditor.DragArrowDOMElement = null;
                objCoordinateListEditor.DragLineDOMElement = null;

                // Create the drop plus sign ...
                objCoordinateListEditor.CreateDropPlus();

                // Append the drag plus to the div in which the coordinate list has been created ...
                objCoordinateListEditor.CoordinateListEditorDiv.append(objCoordinateListEditor.DragPlusDOMElement);

                // Set to copy on drop ...
                objCoordinateListEditor.DropAction = enumDropAction.COPY;
            }

            // Set the position of the icon to be to the right of the coordinate list editor ...
            objCoordinateListEditor.DragPlusDOMElement.css("inset-block-start", objDraggedCellPosition.top + (objHoverCell.height() / 2.0) - 6);
            objCoordinateListEditor.DragPlusDOMElement.css("inset-inline-start", objDraggedCellPosition.left - 12);

        } else {

            // When set to copy on drop ...
            if (objCoordinateListEditor.DropAction == enumDropAction.COPY) {

                // When we have a drop plus sign ...
                if (objCoordinateListEditor.DragPlusDOMElement) {

                    // Remove the drag plus from the dom ...
                    objCoordinateListEditor.DragPlusDOMElement.remove();

                    // Set to null ...
                    objCoordinateListEditor.DragPlusDOMElement = null;
                }

                // Create the drop plus sign ...
                objCoordinateListEditor.CreateDropArrowAndLine(objHoverCell.parent());

                // Append the drag arrow to the div in which the coordinate list has been created ...
                objCoordinateListEditor.CoordinateListEditorDiv.append(objCoordinateListEditor.DragArrowDOMElement);

                // Append the drag line div to the div in which the coordinate list has been created ...
                objCoordinateListEditor.CoordinateListEditorDiv.append(objCoordinateListEditor.DragLineDOMElement);

                // Set to move on drop ...
                objCoordinateListEditor.DropAction = enumDropAction.MOVE;
            }

            // Add the height when not to be shown above the cell ...
            var intAddDistance = (!blnShowAbove) ? objHoverCell.height() : 0;

            // Set the position of the icon to be to the right of the coordinate list editor ...
            objCoordinateListEditor.DragArrowDOMElement.css("inset-block-start", objDraggedCellPosition.top - 6 + intAddDistance);
            objCoordinateListEditor.DragArrowDOMElement.css("inset-inline-start", objDraggedCellPosition.left - 12);

            // Set the position of the icon to be to the right of the coordinate list editor ...
            objCoordinateListEditor.DragLineDOMElement.css("inset-block-start", objDraggedCellPosition.top - 1 + intAddDistance);
            objCoordinateListEditor.DragLineDOMElement.css("inset-inline-start", objDraggedCellPosition.left);
        }
    }
}

// **************************************************************************
// FUNCTION ChangeCoordinates: Recreates the grid with the supplied coordinates and coordinate format ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ChangeCoordinates = function ChangeCoordinates(enCoordinateFormat, arrCoordinates, blnKeepInvalidOrInCompleteCoordinates, intDecimalPlaces, blnEditable) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the invalid or incomplete coordinates when blnKeepInvalidOrInCompleteCoordinates and we have coordinates ...
    var dicInvalidOrInCompleteCoordinates = (blnKeepInvalidOrInCompleteCoordinates && objCoordinateListEditor.Coordinates && objCoordinateListEditor.Coordinates.GetDisplayCoordinates()) ? objCoordinateListEditor.GetInvalidOrInCompleteCoordinates() : null;

    // Add the coordinate number field to the coordinates ...
    TrimbleMap.CoordinateListEditor.Shared.AddCoordinateNumberFieldToCoordinates(arrCoordinates);

    // Change properties of the control that require a grid rebuild...
    objCoordinateListEditor.ChangeProperties(function () {

        // Change the propetries on the instance ...
        objCoordinateListEditor.Editable = blnEditable;
        objCoordinateListEditor.CoordinateFormat = enCoordinateFormat;
        objCoordinateListEditor.DecimalPlaces = intDecimalPlaces;

        // Set the coordinates ...
        objCoordinateListEditor.SetCoordinates(arrCoordinates, dicInvalidOrInCompleteCoordinates);
    });
}

// **************************************************************************
// FUNCTION ChangeProperties
// **************************************************************************
TrimbleMap.CoordinateListEditor.ChangeProperties = function ChangeProperties(fnChangeProperties) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Check if the event handlers are attached ...
    var blnEventsWereHandlersAttached = objCoordinateListEditor.EventHandlersAttached;

    // Detach the event handlers ...
    objCoordinateListEditor.DetachEventHandlers();

    // When we had a focussed field ...
    if (objCoordinateListEditor.FocussedValueIdentifier) {

        // Update the internal field's value from the interface ...
        objCoordinateListEditor.UpdateFieldValueFromInterface(objCoordinateListEditor.FocussedValueIdentifier, objCoordinateListEditor.FocussedTableCell, false);
    }

    // When the format drop down is visible ...
    if (objCoordinateListEditor.GeographicFormatSelectorPopupDiv) {

        // Remove the drop down from the DOM ...
        objCoordinateListEditor.GeographicFormatSelectorPopupDiv.remove();
    }

    // Reset all the state variables to appropriate defaults ...
    objCoordinateListEditor.ResetStateVariables();

    // Call the change properties function ...
    fnChangeProperties();

    // Recreate the grid with the new format and coordinates ...
    objCoordinateListEditor.PopulateGrid();

    // When the event handlers were attached ...
    if (blnEventsWereHandlersAttached) {

        // Attach the event handlers ...
        objCoordinateListEditor.AttachEventHandlers();
    }
}

// **************************************************************************
// FUNCTION ScrollbarVisible: Returns true when the scrollbar is set to be visible ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.ScrollbarVisible = function ScrollbarVisible() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Check if the height is set on the scrollable div (i.e. is it set 
    // to have a scrollbar when the contents is bigger than the height) ...
    var blnHasScrollbar = (objCoordinateListEditor.TableDiv.get(0).style.height != '');

    return blnHasScrollbar;
}

// **************************************************************************
// FUNCTION Width: Returns teh width that the coordinate list editor needs ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Width = function Width() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Start with the width being 480 ...
    var intWidth = 480;

    // Add the scrollbar width when visible ...
    if (objCoordinateListEditor.ScrollbarVisible()) { intWidth += $.getScrollbarWidth() }

    return intWidth;
}

// **************************************************************************
// FUNCTION CoordinatesChanged: Fires the coordinates changed event and 
//                              also updates the scrollbar visibility ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.CoordinatesChanged = function CoordinatesChanged() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the coordinates to be changed are to be skipped ...
    if (!objCoordinateListEditor.SkipCoordinatesChanged) {

        // Fire the coordinates changed callbacks ...
        objCoordinateListEditor.TriggerCoordinatesChangedCallbacks();
    }
}






// ****************************************************************
//  EVENT HANDLERS ...
// ****************************************************************


// **************************************************************************
// EVENT HANDLDER FocusOut
// **************************************************************************
TrimbleMap.CoordinateListEditor.FocusOut = function FocusOut(event) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the focus out event handler is not be skipped ...
    if (!objCoordinateListEditor.SkipFocusOutHandler) {

        // Get all the focussed elements that is nested inside the table ..
        var intFocussedTableDOMElements = $('#' + objCoordinateListEditor.TableDOM.attr("id")).find("*:focus").length;

        // When none of the editable fields in the table has focus ...
        if (intFocussedTableDOMElements == 0) {

            // When we had a focussed field ...
            if (objCoordinateListEditor.FocussedValueIdentifier) {

                // Update the internal field's value from the interface ...
                objCoordinateListEditor.UpdateFieldValueFromInterface(objCoordinateListEditor.FocussedValueIdentifier, objCoordinateListEditor.FocussedTableCell, false);

                // When the focussed field has not been removed during the UpdateFieldValueFromInterface ...
                if (objCoordinateListEditor.FocussedValueIdentifier) {

                    // Swap the elements of the previously focussed field with the VIEW mode elements for the field ...
                    objCoordinateListEditor.RePopulateValueCell(objCoordinateListEditor.FocussedValueIdentifier, enumMode.VIEW, objCoordinateListEditor.FocussedTableCell);

                    // Set the previously focussed field to null ...
                    objCoordinateListEditor.FocussedValueIdentifier = null;

                    // Also set the focussed table cell property to null ...
                    objCoordinateListEditor.FocussedTableCell = null;
                }
            }
        }
    }
}

// **************************************************************************
// EVENT HANDLDER CoordinateListEditorDivClicked
// **************************************************************************
TrimbleMap.CoordinateListEditor.CoordinateListEditorDivClicked = function CoordinateListEditorDivClicked(e, object) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the first event target or the parent with CoordinateCellMarker class ...
    let objTableCell = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'CoordinateCellMarker');

    // When the user clicked on a cell element ...
    if (objTableCell) {

        // Get the value identifier for the field on which the user clicked ...
        var objValueIdentifier = objCoordinateListEditor.GetValueIdentifierByCellID(objTableCell.attr('id'));

        // When there is a value identifier for the cell id in the list ...
        if (objValueIdentifier) {

            // When the field is editable ...
            if (TrimbleMap.CoordinateListEditor.Shared.IsEditableField(objValueIdentifier.Field)) {

                // When the field has focus (do nothing) ...
                if (objValueIdentifier == objCoordinateListEditor.FocussedValueIdentifier) { return; }
                else {

                    // Focus on the field ...
                    objCoordinateListEditor.FocusValueCell(objValueIdentifier, objTableCell, enumFocusOnField.PROVIDED);
                }
            }
            else {

                // When the field is the DELETE button field ...
                if (objValueIdentifier.Field == enumField.DELETE) {

                    // When the  user clicked on the delete <img> tag ...
                    if ($(e.target).hasClass('coordinates_delete_icon')) {

                        // Get the parent html row of the cell ...
                        var objTableRow = objTableCell.parent();

                        // Delete the row ...
                        objCoordinateListEditor.DeleteRow(objValueIdentifier.Coordinate, objTableCell.parent());

                        // Clear the coordinate highlight ...
                        objCoordinateListEditor.ClearCoordinateHighlight();

                        // Set to not be hovering over any coordinates ...
                        objCoordinateListEditor.HoveredCoordinateIndex = null;

                        // Trigger the hovered callbacks ...
                        objCoordinateListEditor.TriggerCoordinateHoveredCallbacks(objCoordinateListEditor.HoveredCoordinateIndex);

                        // Fire the coordinates changed event ...
                        objCoordinateListEditor.CoordinatesChanged();
                    }

                    // When the field is the COORDINATE_NUMBER field ...
                } else if (objValueIdentifier.Field == enumField.COORDINATE_NUMBER) {

                    // When the user clicked on the plus sign an the empty row at the bottom ...
                    if (objValueIdentifier.GetValue() == '+') {

                        // Get coordinates in appropriate metric
                        var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

                        // When there is at least one coordinate ...
                        if (arrDisplayCoordinates.length > 1) {

                            // Copy last coordinates to the end ...
                            objCoordinateListEditor.CopyRowToEnd(arrDisplayCoordinates[arrDisplayCoordinates.length - 2]);

                            // Update the coordinate numbers ...
                            objCoordinateListEditor.UpdateCoordinateNumberSpans();

                            // Fire the coordinates changed event ...
                            objCoordinateListEditor.CoordinatesChanged();

                            // When the scrollbar is visible ...
                            if (objCoordinateListEditor.ScrollbarVisible()) {

                                // Scroll to the bottom ...
                                objCoordinateListEditor.TableDiv.animate({ scrollTop: objCoordinateListEditor.TableDiv.attr("scrollHeight") }, 500);
                            }
                        }
                    }
                }
            }
        }
    }
}

// **************************************************************************
// EVENT HANDLDER ActivateCoordinate
// **************************************************************************
TrimbleMap.CoordinateListEditor.ActivateCoordinate = function ActivateCoordinate(intCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the coordinate to activate ...
    var objCoordinate = objCoordinateListEditor.Coordinates.GetDisplayCoordinates()[intCoordinate];

    // Get the editable fields for the coordinate ...
    var arrEditableFields = objCoordinateListEditor.GetEditableFields();

    // Get the first editable field ...
    var enFirstEditableField = arrEditableFields[0];

    // Get the value identifier for the field ...
    var objValueIdentifier = objCoordinateListEditor.GetValueIdentifierByField(objCoordinate, enFirstEditableField);

    // Get the table cell <td> for the field ...
    var objValueCell = objCoordinateListEditor.GetTableCellForField(objValueIdentifier);

    // Activate the value cell ...
    objCoordinateListEditor.ActivateCell(objValueCell);
}

// **************************************************************************
// EVENT HANDLDER ActivateCell
// **************************************************************************
TrimbleMap.CoordinateListEditor.ActivateCell = function ActivateCell(objTableCell) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the value identifier for the field on which the user clicked ...
    var objValueIdentifier = objCoordinateListEditor.GetValueIdentifierByCellID(objTableCell.attr('id'));

    // When there is a value identifier for the cell id in the list ...
    if (objValueIdentifier) {

        // When the field is editable ...
        if (TrimbleMap.CoordinateListEditor.Shared.IsEditableField(objValueIdentifier.Field)) {

            // When the field does not have focus ...
            if (objValueIdentifier != objCoordinateListEditor.FocussedValueIdentifier) {

                // Focus on the field ...
                objCoordinateListEditor.FocusValueCell(objValueIdentifier, objTableCell, enumFocusOnField.PROVIDED);
            }
        }
    }
}

// **************************************************************************
// EVENT HANDLDER CoordinateListEditorDivKeyup
// **************************************************************************
TrimbleMap.CoordinateListEditor.CoordinateListEditorDivKeyup = function CoordinateListEditorDivKeyup(e, object) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the TAB, ENTER, UP or DOWN key were pressed ...
    if ($.inArray(e.which, [enumKeyCode.TAB, enumKeyCode.ENTER, enumKeyCode.UP, enumKeyCode.DOWN]) != -1) {

        // Prevent the event from propagating ...
        e.preventDefault();

    } else {

        // Get the first event target or the parent with CoordinateCellMarker class ...
        let objTableCell = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'CoordinateCellMarker');

        // When the user were on a cell element ...
        if (objTableCell) {

            // Get the value identifier for the field on which the user was ...
            var objValueIdentifier = objCoordinateListEditor.GetValueIdentifierByCellID(objTableCell.attr('id'));

            // When there is a value identifier for the cell id in the list ...
            if (objValueIdentifier) {

                // Update the internal field's value from the interface ...
                objCoordinateListEditor.UpdateFieldValueFromInterface(objValueIdentifier, objTableCell, true);

                // When the field is not a drop down field ...
                if (!TrimbleMap.CoordinateListEditor.Shared.IsDropDownField(objValueIdentifier.Field)) {

                    // Update the cell style for the validation result of the field ...
                    TrimbleMap.CoordinateListEditor.Shared.UpdateCellStyleForValidationResult(objValueIdentifier, objTableCell);
                }
            }
        }
    }
}

// **************************************************************************
// EVENT HANDLDER CoordinateListEditorDivKeydown
// **************************************************************************
TrimbleMap.CoordinateListEditor.CoordinateListEditorDivKeydown = function CoordinateListEditorDivKeydown(e, object) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the TAB, ENTER, UP or DOWN key were pressed ...
    if ($.inArray(e.which, [enumKeyCode.TAB, enumKeyCode.ENTER, enumKeyCode.UP, enumKeyCode.DOWN]) != -1) {

        // Prevent the event from propagating ...
        e.preventDefault();

        // Get the first event target or the parent with CoordinateCellMarker class ...
        let objTableCell = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'CoordinateCellMarker');

        // When the user is on a cell element ...
        if (objTableCell) {

            // Get the value identifier for the field on which the user is ...
            var objValueIdentifier = objCoordinateListEditor.GetValueIdentifierByCellID(objTableCell.attr('id'));

            // When there is a value identifier for the cell id in the list ...
            if (objValueIdentifier) {

                // When the TAB key was pressed ...
                if (e.which == enumKeyCode.TAB) {

                    // When the shift key is down ...
                    if (e.shiftKey) {

                        // Focus on the previous field ...
                        objCoordinateListEditor.FocusValueCell(objValueIdentifier, null, enumFocusOnField.PREVIOUS);

                    } else {

                        // Focus on the next field ...
                        objCoordinateListEditor.FocusValueCell(objValueIdentifier, null, enumFocusOnField.NEXT);
                    }
                }
                else if (e.which == enumKeyCode.UP) {

                    // Focus on the above field ...
                    objCoordinateListEditor.FocusValueCell(objValueIdentifier, null, enumFocusOnField.ABOVE);

                } else if (e.which == enumKeyCode.DOWN) {

                    // Focus on the below field ...
                    objCoordinateListEditor.FocusValueCell(objValueIdentifier, null, enumFocusOnField.BELOW);

                } else if (e.which == enumKeyCode.ENTER) {

                    // Get the current value of SkipFocusOutHandler ...
                    var blnSkipFocusOutHandler = objCoordinateListEditor.SkipFocusOutHandler;

                    // Set to skip the focus out event handler ... 
                    objCoordinateListEditor.SkipFocusOutHandler = true;

                    // Update the internal field's value from the interface ...
                    objCoordinateListEditor.UpdateFieldValueFromInterface(objValueIdentifier, objTableCell, false);

                    //* Change value cell to VIEW mode ...

                    // Swap the EDIT mode cell contents for VIEW mode cell contents ...
                    objCoordinateListEditor.RePopulateValueCell(objValueIdentifier, enumMode.VIEW, objTableCell);

                    // Set the focussed field property to null ...
                    objCoordinateListEditor.FocussedValueIdentifier = null;

                    // Also set the focussed table cell property to null ...
                    objCoordinateListEditor.FocussedTableCell = null;

                    // Reset to skip the focus out event handler to what it was ... 
                    objCoordinateListEditor.SkipFocusOutHandler = blnSkipFocusOutHandler;
                }
            }
        }
    }
}

// **************************************************************************
// EVENT HANDLDER CreateGeographicFormatSelectionPopupDiv: Shows the DD / DMS drop down list ...
// REMARK Attached to the mouse enter event hanlder of the DMS/DD header cell ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateGeographicFormatSelectionPopupDiv = function CreateGeographicFormatSelectionPopupDiv() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When teh dropdown is not open already ...
    if (objCoordinateListEditor.GeographicFormatSelectorPopupDiv == null) {

        // Create a unique id for the table ...
        var strTableId = objCoordinateListEditor.UniqueID('GeographicFormatSelector');

        // Create drop down a table ...
        objCoordinateListEditor.GeographicFormatSelectorPopupDiv = $('<div id="' + strTableId + '" class="map_coordinatelisteditor_CoordinatesFormatDropDownListTable" cellpadding="0" cellspacing="0"></div>');

        // Determine the checked status for each of the check boxes (DD / DMS) ...
        var strDDChecked = (objCoordinateListEditor.CoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD) ? '<div class="map_coordinatelisteditor_checkimage"></div>' : '<div class="map_coordinatelisteditor_check_place_holder"></div>';
        var strDMSChecked = (objCoordinateListEditor.CoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) ? '<div class="map_coordinatelisteditor_checkimage"></div>' : '<div class="map_coordinatelisteditor_check_place_holder"></div>';

        // Create and append the DMS checkbox within a row <tr> ...        
        objCoordinateListEditor.GeographicFormatSelectorPopupDiv.append($('<div DMSFormatSelectorRow="true" class="map_coordinatelisteditor_drop_down_item_div">' + strDMSChecked + '<span class="map_coordinatelisteditor_CoordinatesFormatDropDownList"> ' + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'DMS') + ' </span></div>'));

        // Create and append the DD checkbox ...
        objCoordinateListEditor.GeographicFormatSelectorPopupDiv.append($('<div DDFormatSelectorRow="true" class="map_coordinatelisteditor_drop_down_item_div">' + strDDChecked + '<span class="map_coordinatelisteditor_CoordinatesFormatDropDownList"> ' + SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'DD') + ' </span></div>'));
    }
}

// **************************************************************************
// EVENT HANDLDER GeographicFormatSelectorClicked: Handles the format change click ...
// REMARK Attached to the click event of the DD/DMS header cell and the selectable drop down cell (DD or DMS) ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GeographicFormatSelectorClicked = function GeographicFormatSelectorClicked(event) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    if (objCoordinateListEditor.GeographicFormatSelectorPopup) {
        // Close the popup ...
        objCoordinateListEditor.GeographicFormatSelectorPopup.ClosePopup();
    }

    // Determine the coordinate format to change to ...
    var enNewCoordinateFormat = (objCoordinateListEditor.CoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) ? TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD : TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS;

    // Change the coordinates ...
    objCoordinateListEditor.ChangeCoordinates(enNewCoordinateFormat, objCoordinateListEditor.GetCoordinates(true), false, objCoordinateListEditor.DecimalPlaces, objCoordinateListEditor.Editable);
}

// **************************************************************************
// EVENT HANDLDER InvalidReasonIconMouseEnter: Shows the invalid reasons for the row ...
// REMARK Attached to the mouse enter event hanlder of the invalid reason icon ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.InvalidReasonIconMouseEnter = function InvalidReasonIconMouseEnter(e) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the invalid reason icon for which the event occurred ...
    var objIconDOMElement = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'InvalidReasonIconID');

    // Get the icon id ...
    var strInvalidReasonIconID = objIconDOMElement.attr('InvalidReasonIconID');

    // Get the icon object ...
    var objInvalidReasonIcon = objCoordinateListEditor.InvalidReasonIcons[strInvalidReasonIconID];

    // Show the invalid reasons popup ...
    objCoordinateListEditor.ShowInvalidReasons(objInvalidReasonIcon, objIconDOMElement);
}

// **************************************************************************
// EVENT HANDLDER InvalidReasonIconMouseLeave: Hides the invalid reasons for the row ...
// REMARK Attached to the mouse enter leave hanlder of the invalid reason icon ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.InvalidReasonIconMouseLeave = function InvalidReasonIconMouseLeave(e) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Hide the invalid reasons popup when visible ...
    objCoordinateListEditor.HideInvalidReasons();
}

// **************************************************************************
// EVENT HANDLDER RowDragStart  
// **************************************************************************
TrimbleMap.CoordinateListEditor.RowDragStart = function RowDragStart(e, ui) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the cell wuith the coordinate index attribute ...
    var objDraggedRow = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'IsCoordinateRow');

    // Get the coordinate index ...
    var intCoordinateIndex = $.inArray(objDraggedRow.get(0), objCoordinateListEditor.TableDOM.find('[IsCoordinateRow]'));

    // Set a reference to the current row elements that is being dragged ...
    objCoordinateListEditor.DraggedCoordinate = objCoordinateListEditor.Coordinates.GetDisplayCoordinates()[intCoordinateIndex];

    // Set to be dragging a row ...
    objCoordinateListEditor.DraggingRow = true;

    //Create the drop arrow and line ...
    objCoordinateListEditor.CreateDropArrowAndLine(objDraggedRow);

    // Set to move on drop ...
    objCoordinateListEditor.DropAction = enumDropAction.MOVE;

    // Position the arrow and line above the the grabbed cell  ...
    objCoordinateListEditor.PositionDropArrowAndLine(e, ui);

    // Append the drag arrow to the div in which the coordinate list has been created ...
    objCoordinateListEditor.CoordinateListEditorDiv.append(objCoordinateListEditor.DragArrowDOMElement);

    // Append the drag line div to the div in which the coordinate list has been created ...
    objCoordinateListEditor.CoordinateListEditorDiv.append(objCoordinateListEditor.DragLineDOMElement);

    // Clear the coordinate highlight ...
    objCoordinateListEditor.ClearCoordinateHighlight();
}

// **************************************************************************
// EVENT HANDLDER RowDragStop  
// **************************************************************************
TrimbleMap.CoordinateListEditor.RowDragStop = function RowDragStop(e, ui) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Set to not be dragging a row anymore ...
    objCoordinateListEditor.DraggingRow = false;

    // When we have a drag line and arrow ...
    if (objCoordinateListEditor.DragArrowDOMElement) {

        // Remove the drag line and arrow from the dom ...
        objCoordinateListEditor.DragArrowDOMElement.remove();
        objCoordinateListEditor.DragLineDOMElement.remove();

        // Set to null ...
        objCoordinateListEditor.DragArrowDOMElement = null;
        objCoordinateListEditor.DragLineDOMElement = null;
    }

    // When we have a drop plus ...
    if (objCoordinateListEditor.DragPlusDOMElement) {

        // Remove the drag plus from the dom ...
        objCoordinateListEditor.DragPlusDOMElement.remove();

        // Set to null ...
        objCoordinateListEditor.DragPlusDOMElement = null;
    }

    // When we are to move the coordinate when dropped ...
    if (objCoordinateListEditor.DropAction == enumDropAction.MOVE) {

        // Get the index of the row that is being dragged ...
        var intDraggedRowIndex = objCoordinateListEditor.Coordinates.GetDisplayCoordinates().findIndex(function (objCoordinate) {
            return objCoordinate.COORDINATE_NUMBER === objCoordinateListEditor.DraggedCoordinate.COORDINATE_NUMBER;
        });

        // Start with dropping at the drop index ...
        var intDropAt = objCoordinateListEditor.DropRowIndex;

        // When the user did not drop the row on itself ...
        if (intDraggedRowIndex != intDropAt) {

            // When to drop before the index move the drop at index on with 1 ...
            if (!objCoordinateListEditor.DropBeforeIndex) { intDropAt++; }

            // Insert the row at the drop index ...
            objCoordinateListEditor.Coordinates.AddCoordinate(objCoordinateListEditor.ConvertCoordinateToXY(objCoordinateListEditor.DraggedCoordinate), intDropAt, false);

            // Start with removing at the index to move from ...
            var intRemoveAt = intDraggedRowIndex;

            // But when the index to move from is after the drop at index, then move the remove at on with 1 ...
            if (intRemoveAt >= intDropAt) { intRemoveAt++; }

            // Remove the row from the coordinates array ...
            objCoordinateListEditor.Coordinates.RemoveCoordinate(intRemoveAt);

            // Get the row element of the row that we are dragging <tr> ...
            var objDraggedDomElement = $($(objCoordinateListEditor.TableDOM.children()[0]).children()[intDraggedRowIndex]);

            // Get target row ...
            var objTargetDomElement = $($(objCoordinateListEditor.TableDOM.children()[0]).children()[objCoordinateListEditor.DropRowIndex]);

            // Remove the row from the table ...
            objDraggedDomElement.remove();

            // When to drop before the index ...
            if (objCoordinateListEditor.DropBeforeIndex) {

                // Insert the row before the row at the drop index ...
                objDraggedDomElement.insertBefore(objTargetDomElement);

            } else {

                // Insert the row after the row at the drop index ...
                objDraggedDomElement.insertAfter(objTargetDomElement);
            }

            // Validate the dragged (last) row ...
            objCoordinateListEditor.ValidateRow(objCoordinateListEditor.DraggedCoordinate, objCoordinateListEditor.CoordinateFormat);

            // Update the cell contents of the row ...
            objCoordinateListEditor.UpdateRowEditableCells(objCoordinateListEditor.DraggedCoordinate, objCoordinateListEditor.CoordinateFormat);

            // Update the invalid reason icon for the row ...
            objCoordinateListEditor.UpdateInvalidReasonIcon(objCoordinateListEditor.DraggedCoordinate, true);

            // Start with not having to re-validate any other row ..
            var objOtherRowToValidate = null;

            // Get coordinates in appropriate metric
            var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

            // When dropping after the last row ...
            if ((intDropAt == arrDisplayCoordinates.length - 1)) {

                // Get the second last row to validate as well ...
                objOtherRowToValidate = arrDisplayCoordinates[arrDisplayCoordinates.length - 3];

                // When dragging the last row ...
            } else if (intDraggedRowIndex == arrDisplayCoordinates.length - 1) {

                // Get the last row to validate as well ...
                objOtherRowToValidate = arrDisplayCoordinates[arrDisplayCoordinates.length - 2];
            }

            // When there is another row to validate ...
            if (objOtherRowToValidate) {

                // Validate the other row ...
                objCoordinateListEditor.ValidateRow(objOtherRowToValidate, objCoordinateListEditor.CoordinateFormat);

                // Update the cell contents of the row ...
                objCoordinateListEditor.UpdateRowEditableCells(objOtherRowToValidate, objCoordinateListEditor.CoordinateFormat);

                // Update the invalid reason icon for the row ...
                objCoordinateListEditor.UpdateInvalidReasonIcon(objOtherRowToValidate, true);
            }

            // Attach the drag event handlers again ...
            objCoordinateListEditor.AttachDragEventHandlers($(objDraggedDomElement.children()[0]));

            // Add a new empty row at the end when the row is complete (All fields entered and valid) ...
            objCoordinateListEditor.AddEmptyRowWhenNeeded();
        }

    } else {

        // Copy the dragged row to the end ...
        objCoordinateListEditor.CopyRowToEnd(objCoordinateListEditor.DraggedCoordinate);
    }

    // Update the coordinate numbers ...
    objCoordinateListEditor.UpdateCoordinateNumberSpans();

    // Update the scrollbar ...
    objCoordinateListEditor.UpdateScrollbar();

    // Fire the coordinates changed event ...
    objCoordinateListEditor.CoordinatesChanged();
}

// **************************************************************************
// EVENT HANDLDER CopyRowToEnd: Copy the row to after the last row ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.CopyRowToEnd = function CopyRowToEnd(objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Clone the row ...
    var objClonedRow = TrimbleMap.CoordinateListEditor.Shared.CloneRowObject(objCoordinate, objCoordinateListEditor.CoordinateFormat);

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();
    // Get coordinates in appropriate metric count
    var intDisplayCoordinates = objCoordinateListEditor.Coordinates.DisplayCoordinatesCount();

    // Get the last values of the array of coordinates ...
    var objLastRow = arrDisplayCoordinates[intDisplayCoordinates - 1];

    // Replace the last of the coordinates array row with the cloned ...
    objCoordinateListEditor.Coordinates.RemoveCoordinate(intDisplayCoordinates - 1);
    // Get coordinates in appropriate metric count
    intDisplayCoordinates = objCoordinateListEditor.Coordinates.DisplayCoordinatesCount();

    // Convert coordinate to xy
    var xyCoordinate = objCoordinateListEditor.ConvertCoordinateToXY(objClonedRow);
    objCoordinateListEditor.Coordinates.AddCoordinate(xyCoordinate, intDisplayCoordinates, false);
    // Get coordinates in appropriate metric count
    intDisplayCoordinates = objCoordinateListEditor.Coordinates.DisplayCoordinatesCount();

    // Put the last row back at the end ...
    objCoordinateListEditor.Coordinates.AddDisplayCoordinate(objLastRow, intDisplayCoordinates);
    // Set the coordinate number
    objClonedRow.COORDINATE_NUMBER = intDisplayCoordinates;

    // Validate the cloned row ...
    objCoordinateListEditor.ValidateRow(objClonedRow, objCoordinateListEditor.CoordinateFormat);

    // Get the last row from the table ...
    var objLastRowDom = objCoordinateListEditor.TableDOM.children().first().children().last();

    // Remove it from the table ...
    objLastRowDom.remove();

    // Decrement the number of coordinates populated ...
    objCoordinateListEditor.CoordinatesPopulated--;

    // Create a table row for the coordinate ...
    var objTableRow = objCoordinateListEditor.CreateRow(objClonedRow);

    // Append the coordinate row ...
    objCoordinateListEditor.AppendCoordinateRow(objTableRow);

    // Add the last row back ...
    objCoordinateListEditor.AppendCoordinateRow(objLastRowDom);

    // Update the invalid reason icon for the cloned row ...
    objCoordinateListEditor.UpdateInvalidReasonIcon(objClonedRow, true);

    // Update the scrollbar ...
    objCoordinateListEditor.UpdateScrollbar();
}

// **************************************************************************
// EVENT HANDLDER RowDrag 
// **************************************************************************
TrimbleMap.CoordinateListEditor.RowDrag = function RowDrag(e, ui) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Position the drag arrow and line ...
    objCoordinateListEditor.PositionDropArrowAndLine(e, ui);
}

// **************************************************************************
// FUNCTION AddOnCoordinateChangedCallback:
// **************************************************************************
TrimbleMap.CoordinateListEditor.AddOnCoordinateChangedCallback = function AddOnCoordinateChangedCallback(fnWidthChanged) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Add the callback ...
    objCoordinateListEditor.CoordinateChangedFunctions.push(fnWidthChanged);
}

// **************************************************************************
// FUNCTION AddOnCoordinatesChangedCallback:
// **************************************************************************
TrimbleMap.CoordinateListEditor.AddOnCoordinatesChangedCallback = function AddOnCoordinatesChangedCallback(fnCoordinatesChanged) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Add the callback ...
    objCoordinateListEditor.CoordinatesChangedFunctions.push(fnCoordinatesChanged);
}

// **************************************************************************
// FUNCTION AddOnCoordinateHoveredCallback:
// **************************************************************************
TrimbleMap.CoordinateListEditor.AddOnCoordinateHoveredCallback = function AddOnCoordinateHoveredCallback(fnCoordinateHovered) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Add the callback ...
    objCoordinateListEditor.CoordinateHoveredFunctions.push(fnCoordinateHovered);
}

// **************************************************************************
// FUNCTION TriggerCoordinateChangedCallbacks:
// **************************************************************************
TrimbleMap.CoordinateListEditor.TriggerCoordinateChangedCallbacks = function TriggerCoordinateChangedCallbacks(intCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Get the coordinate ...
    var objCoordinate = arrDisplayCoordinates[intCoordinate];

    // Convert the coordinate to XY format ...
    let objConvertedCoordinate = objCoordinateListEditor.ConvertCoordinateToXY(objCoordinate);

    // Determine whether or not the coordinate has been completed ...
    var blnCoordinateCompleted = objCoordinateListEditor.AllCoordinateValuesEntered(objCoordinate, objCoordinateListEditor.CoordinateFormat);

    // Determine whether or not the coordinate value is valid ...
    var blnCoordinateValid = objCoordinateListEditor.IsCoordinateValid(objCoordinate);

    // Loop through all the callback functions ...
    $.each(objCoordinateListEditor.CoordinateChangedFunctions, function (intCoordinateChanged, fnCoordinateChanged) {

        // Call the callback ...
        fnCoordinateChanged(intCoordinate, objConvertedCoordinate, blnCoordinateCompleted, blnCoordinateValid);
    });
}

// **************************************************************************
// FUNCTION TriggerCoordinatesChangedCallbacks:
// **************************************************************************
TrimbleMap.CoordinateListEditor.TriggerCoordinatesChangedCallbacks = function TriggerCoordinatesChangedCallbacks() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Check if there are any invalid/incomplete coordinates
    let blnCoordinatesValid = Object.keys(objCoordinateListEditor.GetInvalidOrInCompleteCoordinates()).length === 0;

    // Loop through all the callback functions ...
    $.each(objCoordinateListEditor.CoordinatesChangedFunctions, function (intCoordinatesChanged, fnCoordinatesChanged) {

        // Call the callback ...
        fnCoordinatesChanged(blnCoordinatesValid);
    });
}

// **************************************************************************
// FUNCTION TriggerCoordinateHoveredCallbacks:
// **************************************************************************
TrimbleMap.CoordinateListEditor.TriggerCoordinateHoveredCallbacks = function TriggerCoordinateHoveredCallbacks(intHoveredCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Declare a variable for the converted hovered coordinate ...
    var objConvertedHoveredCoordinate = null;

    // Start with the row valid and complete ...
    var blnIsValidAndComplete = true;

    // When we have a hovered coordinate ...
    if (intHoveredCoordinate != null) {

        // Get coordinates in appropriate metric
        var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

        // Get the hovered coordinate ...
        var objHoveredCoordinate = arrDisplayCoordinates[intHoveredCoordinate];

        // When we have a hovered coordinate ...
        if ((typeof objHoveredCoordinate != 'undefined') && (objHoveredCoordinate != null)) {

            // Determine if the row is valid and complete ...
            blnIsValidAndComplete = !objCoordinateListEditor.IsCoordinateInvalidOrInComplete(objHoveredCoordinate);

            // When the coordinate is invalid or incomplete ...
            if (blnIsValidAndComplete) {

                // Convert the coordinate to XY format ...
                objConvertedHoveredCoordinate = objCoordinateListEditor.ConvertCoordinateToXY(objHoveredCoordinate);
            }
        }
    }

    // Loop through all the callback functions ...
    $.each(objCoordinateListEditor.CoordinateHoveredFunctions, function (intCoordinateHovered, fnCoordinateHovered) {

        // Call the callback ...
        fnCoordinateHovered(intHoveredCoordinate, objConvertedHoveredCoordinate, blnIsValidAndComplete);
    });
}

// **************************************************************************
// FUNCTION HighlightCoordinate:
// USAGE    blnScrollCoordinateIntoView is optional and defaults to false ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.HighlightCoordinate = function HighlightCoordinate(intCoordinate, blnScrollCoordinateIntoView) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the coordinate is not already highlighted ...
    if (objCoordinateListEditor.HighlightedCoordinateIndex != intCoordinate) {

        // Ensure that the coordinate has been populated ...
        objCoordinateListEditor.EnsureCoordinatePopulated(intCoordinate);

        // Remove the 'HighlightedCoordinate' class from the currently highlighted coordinate row ...
        $(objCoordinateListEditor.TableDOM.find('.HighlightedCoordinate')).removeClass('HighlightedCoordinate');

        // Get all the coordinate rows ...
        var arrCoordinateRows = objCoordinateListEditor.TableDOM.find('[IsCoordinateRow]');

        // Get the coordinate row ...
        var objCoordinateRow = $(arrCoordinateRows[intCoordinate]);

        // Add the 'HighlightedCoordinate' class to the row ...
        objCoordinateRow.addClass('HighlightedCoordinate');

        // Set the highlighted coordinate index ...
        objCoordinateListEditor.HighlightedCoordinateIndex = intCoordinate;

        // Scroll the coordinate into view ...
        if (blnScrollCoordinateIntoView) { objCoordinateListEditor.ScrollCoordinateIntoView(intCoordinate); }
    }
}

// **************************************************************************
// FUNCTION EnsureCoordinatePopulated:
// **************************************************************************
TrimbleMap.CoordinateListEditor.EnsureCoordinatePopulated = function EnsureCoordinatePopulated(intCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Start populating more when needed ...
    var blnPopulateMoreWhenNeeded = true;

    // While the coordinate has not been populated yet ...
    while (blnPopulateMoreWhenNeeded && (objCoordinateListEditor.CoordinatesPopulated <= intCoordinate)) {

        // Remember how many coordinates were populated before ...
        var intPreviousCoordinatesPopulated = objCoordinateListEditor.CoordinatesPopulated;

        // Populate the next block of coordinates ...
        objCoordinateListEditor.PopulateCoordinates(objCoordinateListEditor.CoordinatesPopulated, objCoordinateListEditor.CoordinatesPopulated + TrimbleMap.CoordinateListEditor.Shared.BLOCK_SIZE);

        // Set to allow to populate more when needed when the previous call to populate coordinates added more ...
        blnPopulateMoreWhenNeeded = (objCoordinateListEditor.CoordinatesPopulated > intPreviousCoordinatesPopulated);
    }
}

// **************************************************************************
// FUNCTION ClearCoordinateHighlight:
// **************************************************************************
TrimbleMap.CoordinateListEditor.ClearCoordinateHighlight = function ClearCoordinateHighlight() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When we have a highlighted coordinate ...
    if (objCoordinateListEditor.HighlightedCoordinateIndex != null) {

        // Remove the 'HighlightedCoordinate' class from the currently highlighted coordinate row ...
        $(objCoordinateListEditor.TableDOM.find('.HighlightedCoordinate')).removeClass('HighlightedCoordinate');

        // Clear the highlighted coordinate index ...
        objCoordinateListEditor.HighlightedCoordinateIndex = null;
    }
}

// **************************************************************************
// FUNCTION IsCoordinateInvalidOrInComplete
// USAGE    
// **************************************************************************
TrimbleMap.CoordinateListEditor.IsCoordinateInvalidOrInComplete = function IsCoordinateInvalidOrInComplete(objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Determine if the row is invalid or incomplete ...
    var blnIsCoordinateInvalidOrInComplete = ((objCoordinate.COORDINATE_NUMBER != '+') && ((!objCoordinateListEditor.IsCoordinateValid(objCoordinate)) || (!objCoordinateListEditor.AllCoordinateValuesEntered(objCoordinate, objCoordinateListEditor.CoordinateFormat))));

    return blnIsCoordinateInvalidOrInComplete;
}

// **************************************************************************
// FUNCTION GetInvalidOrInCompleteCoordinates: 
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetInvalidOrInCompleteCoordinates = function GetInvalidOrInCompleteCoordinates() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a hash table for the invalid or incomplete coordinates ...
    var dicInvalidOrInCompleteCoordinates = {};

    // Loop though all the coordinates ...
    $.each(objCoordinateListEditor.Coordinates.GetDisplayCoordinates(), function (intCoordinate, objCoordinate) {

        // When the coordinate is invalid or incomplete ...
        if (objCoordinateListEditor.IsCoordinateInvalidOrInComplete(objCoordinate)) {

            // Add the coordinate to the hash table with the index as key ...
            dicInvalidOrInCompleteCoordinates[intCoordinate] = objCoordinate;
        }
    });

    return dicInvalidOrInCompleteCoordinates;
}

// **************************************************************************
// FUNCTION AdjustCoordinateIndexForInvalidOrInCompleteRows
// USAGE    
// **************************************************************************
TrimbleMap.CoordinateListEditor.AdjustCoordinateIndexForInvalidOrInCompleteRows = function AdjustCoordinateIndexForInvalidOrInCompleteRows(intCoordinateToAdjust) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Loop though all the coordinates ...
    for (var intCoordinate = 0; intCoordinate <= intCoordinateToAdjust; intCoordinate++) {

        // Get the coordinate ...
        var objCoordinate = arrDisplayCoordinates[intCoordinate];

        // When the coordinate is invalid or incomplete ...
        if (objCoordinateListEditor.IsCoordinateInvalidOrInComplete(objCoordinate)) {

            // Move the coordinate one up ...
            intCoordinateToAdjust++;
        }
    }

    return intCoordinateToAdjust;
}

// **************************************************************************
// FUNCTION GetCoordinates: 
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetCoordinates = function GetCoordinates(blnIncludeInvalidOrInCompleteCoordinates) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new array to return ...
    var arrCoordinates = [];

    // Get coordinates in xy
    var arrXYCoordinates = objCoordinateListEditor.Coordinates.GetCoordinatesInXY();
    // Get coordinates in appropriate metric
    var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

    // Loop though all the coordinates ...
    for (var intCoordinate = 0; intCoordinate < arrDisplayCoordinates.length; intCoordinate++) {

        // Get the coordinate ...
        var objCoordinate = arrDisplayCoordinates[intCoordinate];

        // When it is not an empty row ...
        if (objCoordinate.COORDINATE_NUMBER != '+') {

            // Start with the coordinate is to be added ...
            var blnAddCoordinate = true;

            // When we are not to include invalid or incomplete coordinates ...
            if (!blnIncludeInvalidOrInCompleteCoordinates) {

                // When the coordinate is invalid or incomplete ...
                if ((!objCoordinateListEditor.IsCoordinateValid(arrDisplayCoordinates[intCoordinate])) ||
                    (!objCoordinateListEditor.AllCoordinateValuesEntered(objCoordinate, objCoordinateListEditor.CoordinateFormat))) {

                    // Set to not add the coordinate ...
                    blnAddCoordinate = false;
                }
            }

            // When the coordinate is to be added ...
            if (blnAddCoordinate) {
                // Get coordinate in xy
                var xyCoordinate = arrXYCoordinates[intCoordinate];

                // If xy coordinate found
                if (xyCoordinate) {
                    // Add xy coordinate to array to return
                    arrCoordinates.push(xyCoordinate);
                }
            }
        }
    }

    return arrCoordinates;
}

// **************************************************************************
// FUNCTION ConvertCoordinateToXY:
// **************************************************************************
TrimbleMap.CoordinateListEditor.ConvertCoordinateToXY = function ConvertCoordinateToXY(objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create the coordinate to add ...
    var objConvertedCoordinate = { X: 0, Y: 0 };

    // Set the X and Y based on the coordinate to add ...
    switch (objCoordinateListEditor.CoordinateFormat) {
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD:
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS:

            // Declare variables for the latitude and longitude degrees ...
            var decLatitude;
            var decLongitude;

            // When DMS ...
            if (objCoordinateListEditor.CoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) {

                // Get the degrees, minutes and seconds ...
                var decLatitudeDegrees = SD.Number.ToNumber(objCoordinate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
                var decLatitudeMinutes = SD.Number.ToNumber(objCoordinate.LATITUDE_MINUTES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
                var decLatitudeSeconds = SD.Number.ToNumber(objCoordinate.LATITUDE_SECONDS, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);

                // Convert the Longitude from DMS ...
                decLatitude = SD.Number.RoundTo(decLatitudeDegrees + (decLatitudeMinutes / 60.0) + (decLatitudeSeconds / 3600.0), objCoordinateListEditor.DecimalPlaces);

                // Get the degrees, minutes and seconds ...
                var decLongitudeDegrees = SD.Number.ToNumber(objCoordinate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
                var decLongitudeMinutes = SD.Number.ToNumber(objCoordinate.LONGITUDE_MINUTES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
                var decLongitudeSeconds = SD.Number.ToNumber(objCoordinate.LONGITUDE_SECONDS, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);

                // Convert the Latitude from DMS ...
                decLongitude = SD.Number.RoundTo(decLongitudeDegrees + (decLongitudeMinutes / 60.0) + (decLongitudeSeconds / 3600.0), objCoordinateListEditor.DecimalPlaces);

            } else {

                // Convert the latitude and longitude to numbers ...
                decLatitude = SD.Number.ToNumber(objCoordinate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
                decLongitude = SD.Number.ToNumber(objCoordinate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
            }

            // Take the direction into account and set the X and Y values ...
            objConvertedCoordinate.X = (objCoordinate.EAST_WEST == enumEastWest.EAST) ? decLongitude : -decLongitude;
            objConvertedCoordinate.Y = (objCoordinate.NORTH_SOUTH == enumNorthSouth.NORTH) ? decLatitude : -decLatitude;
            break;

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED:
            objConvertedCoordinate.X = SD.Number.ToNumber(objCoordinate.X, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
            objConvertedCoordinate.Y = SD.Number.ToNumber(objCoordinate.Y, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
            break;
    }

    return objConvertedCoordinate;
}


// **************************************************************************
// FUNCTION UpdateCoordinateValuesFromXY:
// **************************************************************************
TrimbleMap.CoordinateListEditor.UpdateCoordinateValuesFromXY = function UpdateCoordinateValuesFromXY(objCoordinateToUpdate, objCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Set the values based on the coordinate to add ...
    switch (objCoordinateListEditor.CoordinateFormat) {
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD:

            // Convert the X and Y to positive number strings and set it as the latitude and longitude ...
            objCoordinateToUpdate.LATITUDE_DEGREES = SD.DisplayValue.FromDouble(SD.Number.RoundTo(Math.abs(objCoordinate.Y), objCoordinateListEditor.DecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);
            objCoordinateToUpdate.LONGITUDE_DEGREES = SD.DisplayValue.FromDouble(SD.Number.RoundTo(Math.abs(objCoordinate.X), objCoordinateListEditor.DecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);

            // Set the direction based on the sign of the X and Y values ...
            objCoordinateToUpdate.NORTH_SOUTH = (objCoordinate.Y > 0) ? enumNorthSouth.NORTH : enumNorthSouth.SOUTH;
            objCoordinateToUpdate.EAST_WEST = (objCoordinate.X > 0) ? enumEastWest.EAST : enumEastWest.WEST;
            break;

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS:

            // Convert the LATITUDE_DEGREES to DMS ...
            objCoordinateToUpdate.LATITUDE_DEGREES = String(SD.Number.Truncate(Math.abs(objCoordinate.Y)));
            objCoordinateToUpdate.LATITUDE_MINUTES = String(SD.Number.Truncate(Math.abs((Math.abs(objCoordinate.Y) - Math.abs(objCoordinateToUpdate.LATITUDE_DEGREES))) * 60.0));
            objCoordinateToUpdate.LATITUDE_SECONDS = SD.DisplayValue.FromDouble(SD.Number.RoundTo((Math.abs(Math.abs(objCoordinate.Y) - Math.abs(objCoordinateToUpdate.LATITUDE_DEGREES) - (Math.abs(objCoordinateToUpdate.LATITUDE_MINUTES) / 60))) * 3600.0, objCoordinateListEditor.GeographicSecondsDecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);

            // When the seconds works out to 60 ...
            if (objCoordinateToUpdate.LATITUDE_SECONDS == '60') {

                // Use 0 seconds ...
                objCoordinateToUpdate.LATITUDE_SECONDS = '0';

                // Increment the minutes with 1 ...
                objCoordinateToUpdate.LATITUDE_MINUTES = String(SD.Number.ToNumber(objCoordinateToUpdate.LATITUDE_MINUTES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) + 1);
            }

            // When the minutes works out to 60 ...
            if (objCoordinateToUpdate.LATITUDE_MINUTES == '60') {

                // Use 0 minutes ...
                objCoordinateToUpdate.LATITUDE_MINUTES = '0';

                // Set to increment by 1 when positive and -1 when negative ...
                var intIncrement = (objCoordinate.Y >= 0) ? 1 : -1;

                // Increment the degrees with 1 ...
                objCoordinateToUpdate.LATITUDE_DEGREES = String(SD.Number.ToNumber(objCoordinateToUpdate.LATITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) + intIncrement);
            }

            // Convert the LONGITUDE_DEGREES to DMS ...
            objCoordinateToUpdate.LONGITUDE_DEGREES = String(SD.Number.Truncate(Math.abs(objCoordinate.X)));
            objCoordinateToUpdate.LONGITUDE_MINUTES = String(SD.Number.Truncate(Math.abs(Math.abs(objCoordinate.X) - Math.abs(objCoordinateToUpdate.LONGITUDE_DEGREES)) * 60.0));
            objCoordinateToUpdate.LONGITUDE_SECONDS = SD.DisplayValue.FromDouble(SD.Number.RoundTo((Math.abs(Math.abs(objCoordinate.X) - Math.abs(objCoordinateToUpdate.LONGITUDE_DEGREES) - (Math.abs(objCoordinateToUpdate.LONGITUDE_MINUTES) / 60))) * 3600.0, objCoordinateListEditor.GeographicSecondsDecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator);

            // When the seconds works out to 60 ...
            if (objCoordinateToUpdate.LONGITUDE_SECONDS == '60') {

                // Use 0 seconds ...
                objCoordinateToUpdate.LONGITUDE_SECONDS = '0';

                // Increment the minutes with 1 ...
                objCoordinateToUpdate.LONGITUDE_MINUTES = String(SD.Number.ToNumber(objCoordinateToUpdate.LONGITUDE_MINUTES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) + 1);
            }

            // When the minutes works out to 60 ...
            if (objCoordinateToUpdate.LONGITUDE_MINUTES == '60') {

                // Use 0 minutes ...
                objCoordinateToUpdate.LONGITUDE_MINUTES = '0';

                // Set to increment by 1 when positive and -1 when negative ...
                var intIncrement = (objCoordinate.X >= 0) ? 1 : -1;

                // Increment the degrees with 1 ...
                objCoordinateToUpdate.LONGITUDE_DEGREES = String(SD.Number.ToNumber(objCoordinateToUpdate.LONGITUDE_DEGREES, objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator) + intIncrement);
            }

            // Set the direction based on the sign of the X and Y values ...
            objCoordinateToUpdate.NORTH_SOUTH = (objCoordinate.Y > 0) ? enumNorthSouth.NORTH : enumNorthSouth.SOUTH;
            objCoordinateToUpdate.EAST_WEST = (objCoordinate.X > 0) ? enumEastWest.EAST : enumEastWest.WEST;
            break;

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED:

            // Convert the X and Y values to strings ...
            objCoordinateToUpdate.X = SD.DisplayValue.FromDouble(SD.Number.RoundTo(objCoordinate.X, objCoordinateListEditor.DecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator, objCoordinateListEditor.DecimalPlaces);
            objCoordinateToUpdate.Y = SD.DisplayValue.FromDouble(SD.Number.RoundTo(objCoordinate.Y, objCoordinateListEditor.DecimalPlaces), objCoordinateListEditor.GroupSeparator, objCoordinateListEditor.DecimalSeparator, objCoordinateListEditor.DecimalPlaces);
            break;
    }
}

// **************************************************************************
// FUNCTION ChangeCoordinate:
// **************************************************************************
TrimbleMap.CoordinateListEditor.ChangeCoordinate = function ChangeCoordinate(objCoordinate, intCoordinate) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the cooridnate object to update ...
    var objCoordinateToUpdate = objCoordinateListEditor.Coordinates.GetDisplayCoordinates()[intCoordinate];

    // Get the current value of SkipCoordinatesChanged ...
    var blnSkipCoordinatesChanged = objCoordinateListEditor.SkipCoordinatesChanged;

    // Set SkipCoordinatesChanged to prevent the CoordinatesChanged event handler from firing ...
    objCoordinateListEditor.SkipCoordinatesChanged = true;

    // Unfocus any focussed elements ...
    objCoordinateListEditor.FocusOut();

    // Update the coordinate values from the xy values ...
    objCoordinateListEditor.UpdateCoordinateValuesFromXY(objCoordinateToUpdate, objCoordinate);

    // Get coordinate in xy
    objCoordinateListEditor.Coordinates.AddCoordinate(objCoordinate, intCoordinate, true);

    // Update the cell values for the coordinate ...
    objCoordinateListEditor.UpdateRowEditableCells(objCoordinateToUpdate, objCoordinateListEditor.CoordinateFormat);

    // Reset the SkipCoordinatesChanged ...
    objCoordinateListEditor.SkipCoordinatesChanged = blnSkipCoordinatesChanged;
}

// **************************************************************************
// FUNCTION InsertCoordinate
// **************************************************************************
TrimbleMap.CoordinateListEditor.InsertCoordinate = function InsertCoordinate(objCoordinate, intInsertCoordinateAt) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create coordinate object ...
    var objConvertedCoordinate = objCoordinateListEditor.CreateCoordinate();

    // Update the coordinate values from the xy values ...
    objCoordinateListEditor.UpdateCoordinateValuesFromXY(objConvertedCoordinate, objCoordinate);

    // Set the coordinate number ...
    objConvertedCoordinate.COORDINATE_NUMBER = intInsertCoordinateAt + 1;

    // Insert the coordinate into the coordinates array ...
    objCoordinateListEditor.Coordinates.AddCoordinate(objCoordinate, intInsertCoordinateAt, false);

    // Create a table row for the coordinate ...
    var objCoordinateRow = objCoordinateListEditor.CreateRow(objConvertedCoordinate, true);

    // Get the row at the index to insert at ...
    var objRowToInsertBefore = $(objCoordinateListEditor.TableDOM.find('[IsCoordinateRow]')[intInsertCoordinateAt]);

    // Inser the coordinaet row before the row at the index to insert at ...
    objCoordinateRow.insertBefore(objRowToInsertBefore);

    // Increment the number of coordinates populated ...
    objCoordinateListEditor.CoordinatesPopulated++;

    // Update the coordinate number spans for all the erows ...
    objCoordinateListEditor.UpdateCoordinateNumberSpans();

    // Update the scrollbar ...
    objCoordinateListEditor.UpdateScrollbar();
}

// **************************************************************************
// FUNCTION SetCoordinates:
// USAGE    dicInvalidOrInCompleteCoordinates is optional ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.SetCoordinates = function SetCoordinates(arrCoordinates, dicInvalidOrInCompleteCoordinates) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create a new array for the coordinates ...
    objCoordinateListEditor.Coordinates = new ShapeCoordinates(objCoordinateListEditor, []);

    // Create counter to get dicInvalidOrInCompleteCoordinates coordinates at the appropriate index
    var intCounter = 0;

    // Loop through all the coordinates to set ...
    for (var intCoordinate = 0; intCoordinate < arrCoordinates.length; intCoordinate++) {
        // When dicInvalidOrInCompleteCoordinates has been passed in ...
        if ((typeof dicInvalidOrInCompleteCoordinates != 'undefined') && dicInvalidOrInCompleteCoordinates) {

            // Get the next coordinate index to add in at the current index ...
            var objCoordinateInNativeFormat = dicInvalidOrInCompleteCoordinates[intCounter];

            // While we have one to add at the current location ...
            while (typeof objCoordinateInNativeFormat != 'undefined') {

                // Add the coordinate (which should already be in it's native format) to the array ...
                objCoordinateListEditor.Coordinates.AddCoordinate(objCoordinateInNativeFormat);

                // Increase counter by 1
                intCounter += 1;

                // Get the next coordinate index to add in at the current index ...
                objCoordinateInNativeFormat = dicInvalidOrInCompleteCoordinates[intCounter];
            }
        }

        // Add coordinate in xy
        objCoordinateListEditor.Coordinates.AddCoordinate(arrCoordinates[intCoordinate]);

        // Increase counter by 1
        intCounter += 1;
    }

    // When editable and the geometry type is not point ...
    if ((objCoordinateListEditor.Editable) && (objCoordinateListEditor.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT)) {
        // Create and add an empty coordinate to the array ...
        objCoordinateListEditor.Coordinates.AddDisplayCoordinate(objCoordinateListEditor.CreateCoordinate());
    }
}

// **************************************************************************
// FUNCTION SetEditable: 
// **************************************************************************
TrimbleMap.CoordinateListEditor.SetEditable = function SetEditable(blnEditable) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // When the editable property changed ...
    if (objCoordinateListEditor.Editable != blnEditable) {

        // Change properties of the control that require a grid rebuild...
        objCoordinateListEditor.ChangeProperties(function () {

            // Set the editable property ...
            objCoordinateListEditor.Editable = blnEditable;

            // When editable and the geometry type is not point ...
            if ((objCoordinateListEditor.Editable) && (objCoordinateListEditor.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT)) {

                // Create and add an empty coordinate to the array ...
                objCoordinateListEditor.Coordinates.AddDisplayCoordinate(objCoordinateListEditor.CreateCoordinate());

            } else {

                // Get coordinates in appropriate metric
                var arrDisplayCoordinates = objCoordinateListEditor.Coordinates.GetDisplayCoordinates();

                // When the last row is empty ...
                if ((arrDisplayCoordinates.length > 0) && (arrDisplayCoordinates[arrDisplayCoordinates.length - 1].COORDINATE_NUMBER == '+')) {

                    // Delete it ...
                    objCoordinateListEditor.Coordinates.RemoveCoordinate(arrDisplayCoordinates.length - 1);
                }
            }
        });
    }
}

// **************************************************************************
// FUNCTION GetFieldList: Returns a list of fields for the coordinate format ...
//          enCoordinateFormat is optional, uses coordinate format from instance when not set
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetFieldList = function GetFieldList(enCoordinateFormat) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Default to the coordinate format of the coordinate list editor when not specified ...
    if ((typeof enCoordinateFormat == 'undefined') || (enCoordinateFormat == null)) { enCoordinateFormat = objCoordinateListEditor.CoordinateFormat; }

    // Create the array to return ...
    var arrFields = [];

    // Add the fields that belongs to the coordinate format ...
    switch (enCoordinateFormat) {
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED:
            arrFields.push(enumField.COORDINATE_NUMBER);
            if (objCoordinateListEditor.ProjectedFormatLongitudeThenLatitude) { arrFields.push(enumField.X); arrFields.push(enumField.Y); } else { arrFields.push(enumField.Y); arrFields.push(enumField.X); }
            arrFields.push(enumField.DELETE);
            arrFields.push(enumField.INVALID_REASON);
            break;
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD:
            arrFields.push(enumField.COORDINATE_NUMBER);
            arrFields.push(enumField.LATITUDE_DEGREES);
            arrFields.push(enumField.NORTH_SOUTH);
            arrFields.push(enumField.LONGITUDE_DEGREES);
            arrFields.push(enumField.EAST_WEST);
            arrFields.push(enumField.DELETE);
            arrFields.push(enumField.INVALID_REASON);
            break;
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS:
            arrFields.push(enumField.COORDINATE_NUMBER);
            arrFields.push(enumField.LATITUDE_DEGREES);
            arrFields.push(enumField.LATITUDE_MINUTES);
            arrFields.push(enumField.LATITUDE_SECONDS);
            arrFields.push(enumField.NORTH_SOUTH);
            arrFields.push(enumField.LONGITUDE_DEGREES);
            arrFields.push(enumField.LONGITUDE_MINUTES);
            arrFields.push(enumField.LONGITUDE_SECONDS);
            arrFields.push(enumField.EAST_WEST);
            arrFields.push(enumField.DELETE);
            arrFields.push(enumField.INVALID_REASON);
            break;
    }

    return arrFields;
}

// **************************************************************************
// FUNCTION GetDisplayFieldList: Returns a list of displayed fields for the coordinate format ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetDisplayFieldList = function GetDisplayFieldList() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create the array to return ...
    var arrFields = [];

    // Add the fields that belongs to the coordinate format ...
    switch (objCoordinateListEditor.CoordinateFormat) {
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED:

            arrFields.push(enumField.COORDINATE_NUMBER);
            if (objCoordinateListEditor.ProjectedFormatLongitudeThenLatitude) { arrFields.push(enumField.X); arrFields.push(enumField.Y); } else { arrFields.push(enumField.Y); arrFields.push(enumField.X); }
            arrFields.push(enumField.DELETE);
            arrFields.push(enumField.INVALID_REASON);
            break;

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD:

            if (objCoordinateListEditor.Editable) {
                arrFields.push(enumField.COORDINATE_NUMBER);
                arrFields.push(enumField.LATITUDE_DEGREES);
                arrFields.push(enumField.NORTH_SOUTH);
                arrFields.push(enumField.LONGITUDE_DEGREES);
                arrFields.push(enumField.EAST_WEST);
                arrFields.push(enumField.DELETE);
                arrFields.push(enumField.INVALID_REASON);
            } else {
                arrFields.push(enumField.COORDINATE_NUMBER);
                arrFields.push(enumField.LATITUDE_NS);
                arrFields.push(enumField.LONGITUDE_EW);
                arrFields.push(enumField.DELETE);
                arrFields.push(enumField.INVALID_REASON);
            }
            break;

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS:

            if (objCoordinateListEditor.Editable) {
                arrFields.push(enumField.COORDINATE_NUMBER);
                arrFields.push(enumField.LATITUDE_DEGREES);
                arrFields.push(enumField.LATITUDE_MINUTES);
                arrFields.push(enumField.LATITUDE_SECONDS);
                arrFields.push(enumField.NORTH_SOUTH);
                arrFields.push(enumField.LONGITUDE_DEGREES);
                arrFields.push(enumField.LONGITUDE_MINUTES);
                arrFields.push(enumField.LONGITUDE_SECONDS);
                arrFields.push(enumField.EAST_WEST);
                arrFields.push(enumField.DELETE);
                arrFields.push(enumField.INVALID_REASON);
            } else {
                arrFields.push(enumField.COORDINATE_NUMBER);
                arrFields.push(enumField.LATITUDE_DMS);
                arrFields.push(enumField.LONGITUDE_DMS);
                arrFields.push(enumField.DELETE);
                arrFields.push(enumField.INVALID_REASON);
            }
            break;
    }

    return arrFields;
}

// **************************************************************************
// FUNCTION GetEditableFields: Returns a list of editable fields for the coordinate format ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetEditableFields = function GetEditableFields() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the list of fields for the coordinate format ...
    var arrFields = objCoordinateListEditor.GetFieldList();

    // Create a new empty array to place the editable fields in ...
    var arrEditableFields = [];

    // Loop through all the fields ...
    for (var intField = 0; intField < arrFields.length; intField++) {

        // Get the field ...
        var enField = arrFields[intField];

        // When the field is editable ...
        if (TrimbleMap.CoordinateListEditor.Shared.IsEditableField(enField)) {

            // Add the field to the array of editable fields ...
            arrEditableFields.push(enField);
        }
    }

    return arrEditableFields;
}

// **************************************************************************
// FUNCTION CreateCoordinate: Returns an object with all the editable fields needed for the coordinate format ...
//          enCoordinateFormat is optional, uses coordinate format from instance when not set
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateCoordinate = function CreateCoordinate(enCoordinateFormat) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the list of fields for the coordinate format ...
    var arrFields = objCoordinateListEditor.GetFieldList(enCoordinateFormat);

    // Declare a new object for the row array ...
    var objRow = {};

    // Loop through all the fields ...
    for (var intField = 0; intField < arrFields.length; intField++) {

        // Get the field ...
        var enField = arrFields[intField];

        // When it is a value field ...
        if (TrimbleMap.CoordinateListEditor.Shared.IsValueField(enField)) {

            // Add the field to the object and set the value to null ...
            objRow[enField] = "";

            // When the field is the COORDINATE_NUMBER field ...
            if (enField == enumField.COORDINATE_NUMBER) {

                // Set the field value to a plus (+) sign ...
                objRow[enField] = '+';
            }
        }
    }

    // Create a new row maximum validation result property ...
    objRow.RowMaximumValidationResult = TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);

    return objRow;
}

// **************************************************************************
// FUNCTION GetCombinedFieldWidthInPixels: Returns the width of the fields for the coordinate format ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetCombinedFieldWidthInPixels = function GetCombinedFieldWidthInPixels(arrFields) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Start with 0 field with in pixels ...
    var intCombinedFieldWidthInPixels = 0;

    // Loop through all the fields ...
    for (var intField = 0; intField < arrFields.length; intField++) {

        // Get the field ...
        var enField = arrFields[intField];

        // Get the width of the field in pixels and add it to teh combined with ...
        intCombinedFieldWidthInPixels += objCoordinateListEditor.GetFieldWidthInPixels(enField);
    }

    return intCombinedFieldWidthInPixels;
}

// **************************************************************************
// FUNCTION GetFieldWidthInPixels: Returns the width of the field for the coordinate format ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetFieldWidthInPixels = function GetFieldWidthInPixels(enField) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Return the width that the field should be for the coordinate format ...
    switch (objCoordinateListEditor.CoordinateFormat) {
        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED:

            switch (enField) {
                case enumField.COORDINATE_NUMBER: return 33;
                case enumField.X: return 200;
                case enumField.Y: return 200;
                case enumField.DELETE: return 23;
                case enumField.INVALID_REASON: return 24;
            }
            break;

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD:

            switch (enField) {
                case enumField.COORDINATE_NUMBER: return 33;
                case enumField.LATITUDE_DEGREES: return 160;
                case enumField.LATITUDE_NS: return 200;
                case enumField.NORTH_SOUTH: return 40;
                case enumField.LONGITUDE_DEGREES: return 160;
                case enumField.LONGITUDE_EW: return 200;
                case enumField.EAST_WEST: return 40;
                case enumField.DELETE: return 23;
                case enumField.INVALID_REASON: return 24;
            }
            break;

        case TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS:

            switch (enField) {
                case enumField.COORDINATE_NUMBER: return 33;
                case enumField.LATITUDE_DEGREES: return 40;
                case enumField.LATITUDE_MINUTES: return 40;
                case enumField.LATITUDE_SECONDS: return 80;
                case enumField.NORTH_SOUTH: return 40;
                case enumField.LATITUDE_DMS: return 200;
                case enumField.LONGITUDE_DEGREES: return 40;
                case enumField.LONGITUDE_MINUTES: return 40;
                case enumField.LONGITUDE_SECONDS: return 80;
                case enumField.EAST_WEST: return 40;
                case enumField.LONGITUDE_DMS: return 200;
                case enumField.DELETE: return 23;
                case enumField.INVALID_REASON: return 24;
            }
            break;
    }

    return 0;
}

// **************************************************************************
// FUNCTION GetTableWidthInPixels: Returns the width of the table for the coordinate format ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.GetTableWidthInPixels = function GetTableWidthInPixels() {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Get the fields for the coordinate format ...
    var arrFields = objCoordinateListEditor.GetFieldList();

    // Start with a table width of 0 ...
    var intTableWidthInPixels = 0;

    // Loop through all the fields ...
    for (var intField = 0; intField < arrFields.length; intField++) {

        // Get the field at the index ...
        var enField = arrFields[intField];

        // Get the field width for the coordinate format ...
        var intFieldWidthInPixels = objCoordinateListEditor.GetFieldWidthInPixels(enField) + 1;

        // Add the field width to the overall table width ...
        intTableWidthInPixels += intFieldWidthInPixels;
    }

    return intTableWidthInPixels;
}

// **************************************************************************
// FUNCTION IsDropDownField: Returns a true when the field is a drop down field ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.IsDropDownField = function IsDropDownField(enField) {

    // Test if the field is a drop down field ...
    return ((enField == enumField.NORTH_SOUTH) ||
        (enField == enumField.EAST_WEST));
}

// **************************************************************************
// FUNCTION IsEditableField: Returns a true when the field is editable ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.IsEditableField = function IsEditableField(enField) {

    // Return true when the field should be editable ...
    switch (enField) {
        case enumField.COORDINATE_NUMBER: return false;
        case enumField.LATITUDE_DEGREES: return true;
        case enumField.LATITUDE_MINUTES: return true;
        case enumField.LATITUDE_SECONDS: return true;
        case enumField.NORTH_SOUTH: return true;
        case enumField.LATITUDE_DMS: return false;
        case enumField.LATITUDE_NS: return false;
        case enumField.LONGITUDE_DEGREES: return true;
        case enumField.LONGITUDE_MINUTES: return true;
        case enumField.LONGITUDE_SECONDS: return true;
        case enumField.EAST_WEST: return true;
        case enumField.LONGITUDE_DMS: return false;
        case enumField.LONGITUDE_EW: return false;
        case enumField.X: return true;
        case enumField.Y: return true;
        case enumField.DELETE: return false;
    }

    return false;
}

// **************************************************************************
// FUNCTION IsValueField: Returns a true when the field has a value in the row object ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.IsValueField = function IsValueField(enField) {

    // Returns a true when the field has a value in the row object ...
    switch (enField) {
        case enumField.COORDINATE_NUMBER: return true;
        case enumField.LATITUDE_DEGREES: return true;
        case enumField.LATITUDE_MINUTES: return true;
        case enumField.LATITUDE_SECONDS: return true;
        case enumField.NORTH_SOUTH: return true;
        case enumField.LONGITUDE_DEGREES: return true;
        case enumField.LONGITUDE_MINUTES: return true;
        case enumField.LONGITUDE_SECONDS: return true;
        case enumField.EAST_WEST: return true;
        case enumField.X: return true;
        case enumField.Y: return true;
        case enumField.DELETE: return false;
    }

    return false;
}

// **************************************************************************
// FUNCTION CloneRowObject: Returns an copy of the object ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.CloneRowObject = function CloneRowObject(objCoordinate, enCoordinateFormat) {

    // Clone the row object ...
    var objNewCoordinate = $.extend(true, {}, objCoordinate);

    // Create a new row maximum validation result property ...
    objNewCoordinate.RowMaximumValidationResult = TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);

    return objNewCoordinate;
}

// **************************************************************************
// FUNCTION GetFieldName: Returns a user readable field name
// NOTE: Only used for validation so only editable fields included ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.GetFieldName = function GetFieldName(enField) {

    // Return true when the field should be editable ...
    switch (enField) {
        case enumField.LATITUDE_DEGREES: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'LatitudeDegrees');
        case enumField.LATITUDE_MINUTES: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'LatitudeMinutes');
        case enumField.LATITUDE_SECONDS: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'LatitudeSeconds');
        case enumField.NORTH_SOUTH: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'NorthSouthDirection');
        case enumField.LONGITUDE_DEGREES: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'LongitudeDegrees');
        case enumField.LONGITUDE_MINUTES: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'LongitudeMinutes');
        case enumField.LONGITUDE_SECONDS: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'LongitudeSeconds');
        case enumField.EAST_WEST: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'EastWestDirection');
        case enumField.X: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'East');
        case enumField.Y: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'North');
    }

    return '';
}

// **************************************************************************
// FUNCTION GetNorthSouthTranslation: Get the translation for the north / south value ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.GetNorthSouthTranslation = function GetNorthSouthTranslation(enNorthSouth) {

    // Return the translation based on the enum value ...
    switch (enNorthSouth) {
        case enumNorthSouth.NORTH: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'NorthAbbreviation');
        case enumNorthSouth.SOUTH: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'SouthAbbreviation');
    }

    return "";
}

// **************************************************************************
// FUNCTION GetEastWestTranslation: Get the translation for the east / west value ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.GetEastWestTranslation = function GetEastWestTranslation(enEastWest) {

    // Return the translation based on the enum value ...
    switch (enEastWest) {
        case enumEastWest.EAST: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'EastAbbreviation');
        case enumEastWest.WEST: return SD.Translation.Shared.GetTranslation('CoordinateListEditor.js', 'WestAbbreviation');
    }

    return "";
}

// **************************************************************************
// FUNCTION EscapeCharacterForRegex: Validates that the number has got the specified number of decimal places ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.EscapeCharacterForRegex = function EscapeCharacterForRegex(strCharacter) {

    // When a reserved regex character ...
    if ($.inArray(strCharacter, ['[', ']', '{', '}', '(', ')', '<', '>', '\\', '^', '$', '.', '|', '?', '*', '+', '-']) != -1) {

        // Add escape characters to it ...
        strCharacter = '\\' + strCharacter;
    }

    return strCharacter;
}

// **************************************************************************
// FUNCTION BuildNumberRegexValidationString: Validates that the number has got the specified number of decimal places ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.BuildRegexPartFromDecimalPoint = function BuildRegexPartFromDecimalPoint(strDecimalSeparator, blnValidateDecimalPlaces, intDecimalPlaces, blnAllowIncomplete) {

    // Declare a variable for the result ...
    var strFromDecimalPoint = '';

    // Add escape characters to the decimal separator when it is a regex reserved character ...
    strDecimalSeparator = TrimbleMap.CoordinateListEditor.Shared.EscapeCharacterForRegex(strDecimalSeparator);

    // When the number of decimal places should be validated ...
    if (blnValidateDecimalPlaces) {

        // When any digits after the decimal separator is to be allowed ...
        if (intDecimalPlaces > 0) {

            // When incomplete entries are to be allowed ...
            if (blnAllowIncomplete) {

                // Allow to either just be the decimal separator, OR the decimal separator 
                // followed by at least one up to the number of allowed digits ...
                strFromDecimalPoint = '((' + strDecimalSeparator + ')|((' + strDecimalSeparator + '\\d{1,' + intDecimalPlaces + '})?))';
            }
            else {

                // Allow the decimal separator followed by the number of allowed digits ...
                strFromDecimalPoint = '((' + strDecimalSeparator + '\\d{1,' + intDecimalPlaces + '})?)';
            }
        }
    }
    else {

        // When incomplete entries are to be allowed ...
        if (blnAllowIncomplete) {

            // Allow the decimal separator followed by 0 or more digits (notice the *) ...
            strFromDecimalPoint = '((' + strDecimalSeparator + '(\\d)*)?)';
        }
        else {

            // Allow the decimal separator followed by 1 or more digits (notice the +) ...
            strFromDecimalPoint = '((' + strDecimalSeparator + '(\\d)+)?)';
        }
    }

    return strFromDecimalPoint
}

// **************************************************************************
// FUNCTION BuildNumberRegexValidationString: Validates that the number has got the specified number of decimal places ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.BuildNumberRegexValidationString = function BuildNumberRegexValidationString(strGroupSeparator, strDecimalSeparator, blnValidateDecimalPlaces, intDecimalPlaces, blnAllowIncomplete) {

    // Declare a variable for the result ...
    var strRegex;

    // Add escape characters to the group separator when it is a dot (.) ...
    if (strGroupSeparator == '.') { strGroupSeparator = '\\' + strGroupSeparator; }

    // Build the regex part to validate the number from the decimal point onwards ...
    var strFromDecimalPoint = TrimbleMap.CoordinateListEditor.Shared.BuildRegexPartFromDecimalPoint(strDecimalSeparator, blnValidateDecimalPlaces, intDecimalPlaces, blnAllowIncomplete)

    // * Build a regex to check that the group and decimal separators are on 
    //   the right place and that there is the correct amount if decimal places ...

    // When incomplete entries are to be allowed ...
    if (blnAllowIncomplete) {

        // Allow for when the there is less than 3 digits after 
        // a group separator or no digits after a decimal point ...
        strRegex = '^(-?)(((\\d+)' + strFromDecimalPoint + ')|((\\d{1,3})((' + strGroupSeparator + '\\d{3})*)((' + strGroupSeparator + '\\d{0,2})|' + strFromDecimalPoint + ')))$';
    }
    else {

        // Do not allow for incomplete entries ...
        strRegex = '^(-?)(((\\d+)' + strFromDecimalPoint + ')|((\\d{1,3})((' + strGroupSeparator + '\\d{3})*)' + strFromDecimalPoint + '))$';
    }

    // Return the regular expression ...
    return strRegex;
}

// **************************************************************************
// FUNCTION UpdateCellStyleForValidationResult: Create the html elements for a cell ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.UpdateCellStyleForValidationResult = function UpdateCellStyleForValidationResult(objValueIdentifier, objTableCell) {

    // Find the input element on the cell ...
    var objInputElement = $(objTableCell.find('input'));

    // When the field is valid ...
    if (objValueIdentifier.ValidationResult.IsValid) {

        // Set the background color to white ...
        objInputElement.css('background-color', 'white');

    } else {

        // Set the background color to red ...
        objInputElement.css('background-color', '#FF5A5A');
    }
}

// **************************************************************************
// FUNCTION FormatFieldValue: Create the html elements for a cell ...
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.FormatFieldValue = function FormatFieldValue(enField, enMode, enCoordinateFormat, strFieldValue, strGroupSeparator, strDecimalSeparator, intGeographicSecondsDecimalPlaces, intDecimalPlaces) {

    // When the value is just white space ...
    if ((strFieldValue != undefined || strFieldValue != null) && strFieldValue.toString().trim() == "") {

        if (enMode == enumMode.EDIT) {

            // Format and return as an empty string ...
            return "";

        } else {

            // Format and return as a non breaking space ...
            return "&nbsp;";
        }
    }
    else {

        // When a value is needed for view mode ...
        if (enMode == enumMode.VIEW) {

            // Format and return the value ...
            switch (enField) {
                case enumField.COORDINATE_NUMBER: return strFieldValue;
                case enumField.LATITUDE_DEGREES: return ((enCoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) ? SD.String.ZeroPad(strFieldValue, 2) : SD.Number.ZeroPadDecimal(strFieldValue, 2, intDecimalPlaces, strGroupSeparator, strDecimalSeparator)) + '°';
                case enumField.LATITUDE_MINUTES: return SD.String.ZeroPad(strFieldValue, 2) + "'";
                case enumField.LATITUDE_SECONDS: return SD.Number.ZeroPadDecimal(strFieldValue, 2, intGeographicSecondsDecimalPlaces, strGroupSeparator, strDecimalSeparator) + '"';
                case enumField.NORTH_SOUTH: return TrimbleMap.CoordinateListEditor.Shared.GetNorthSouthTranslation(strFieldValue);
                case enumField.LONGITUDE_DEGREES: return ((enCoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) ? SD.String.ZeroPad(strFieldValue, 3) : SD.Number.ZeroPadDecimal(strFieldValue, 3, intDecimalPlaces, strGroupSeparator, strDecimalSeparator)) + '°';
                case enumField.LONGITUDE_MINUTES: return SD.String.ZeroPad(strFieldValue, 2) + "'";
                case enumField.LONGITUDE_SECONDS: return SD.Number.ZeroPadDecimal(strFieldValue, 2, intGeographicSecondsDecimalPlaces, strGroupSeparator, strDecimalSeparator) + '"';
                case enumField.EAST_WEST: return TrimbleMap.CoordinateListEditor.Shared.GetEastWestTranslation(strFieldValue);
                case enumField.X: return SD.Number.ZeroPadDecimal(strFieldValue, null, intDecimalPlaces, strGroupSeparator, strDecimalSeparator);
                case enumField.Y: return SD.Number.ZeroPadDecimal(strFieldValue, null, intDecimalPlaces, strGroupSeparator, strDecimalSeparator);
            }
        }
    }

    // Return the value as is ...
    return strFieldValue;
}

// **************************************************************************
// CONSTUCTOR CreateValueIdentifier
// **************************************************************************
TrimbleMap.CoordinateListEditor.CreateValueIdentifier = function CreateValueIdentifier(objCoordinate, enField, enCoordinateFormat, strGroupSeparator, strDecimalSeparator, intDecimalPlaces, intGeographicSecondsDecimalPlaces) {

    // Get the instance ...
    var objCoordinateListEditor = this;

    // Create the instance ...
    var objValueIdentifier = {
        Coordinate: objCoordinate,
        Field: enField,
        CoordinateFormat: enCoordinateFormat,
        GroupSeparator: strGroupSeparator,
        DecimalSeparator: strDecimalSeparator,
        GeographicSecondsDecimalPlaces: intGeographicSecondsDecimalPlaces,
        ValidationResult: null,
        RelatedCell: null,

        GetValue: function GetValue() { return TrimbleMap.CoordinateListEditor.Shared.GetValueForField(objValueIdentifier.Coordinate, objValueIdentifier.Field, objValueIdentifier.CoordinateFormat, objValueIdentifier.GroupSeparator, objValueIdentifier.DecimalSeparator, intDecimalPlaces, objValueIdentifier.GeographicSecondsDecimalPlaces); },
        SetValue: function SetValue(strValue, intIndex) {
            if (objValueIdentifier.Coordinate[objValueIdentifier.Field] !== (strValue).trim()) {
                objValueIdentifier.Coordinate[objValueIdentifier.Field] = (strValue).trim();

                // Determine whether or not the coordinate has been completed ...
                let blnCoordinateCompleted = objCoordinateListEditor.AllCoordinateValuesEntered(objValueIdentifier.Coordinate, objValueIdentifier.enCoordinateFormat);

                // Determine whether or not the coordinate value is valid ...
                let objValidationResult = TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult(true);

                if (!TrimbleMap.CoordinateListEditor.Shared.IsDropDownField(objValueIdentifier.Field)) {
                    objValidationResult = objCoordinateListEditor.ValidateIsNumber(objValueIdentifier, (strValue).trim(), false);
                }

                // Check if coordinate is valid/complete before converting it to xy and adding it
                if (objValueIdentifier.Coordinate.COORDINATE_NUMBER !== "+" && blnCoordinateCompleted && objValidationResult.IsValid) {
                    // Add coordinate in xy
                    objCoordinateListEditor.Coordinates.AddCoordinate(objCoordinateListEditor.ConvertCoordinateToXY(objValueIdentifier.Coordinate), objValueIdentifier.Coordinate.COORDINATE_NUMBER - 1, true);
                }
            }
        },
        IsValid: function IsValid() { return ((!objValueIdentifier.ValidationResult) || (objValueIdentifier.ValidationResult.IsValid)); }
    }

    return objValueIdentifier;
}

// **************************************************************************
// CONSTUCTOR GetValueForField
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.GetValueForField = function GetValueForField(objCoordinate, enField, enCoordinateFormat, strGroupSeparator, strDecimalSeparator, intDecimalPlaces, intGeographicSecondsDecimalPlaces) {

    // Declare a variable for the value to return ...
    var strValue;

    // Format the value based on the type ...
    switch (enField) {
        case enumField.LATITUDE_DMS:

            // Format the latitude dms value ...
            var strValue = SD.String.ZeroPad(objCoordinate.LATITUDE_DEGREES, 2) + '°   ' + SD.String.ZeroPad(objCoordinate.LATITUDE_MINUTES, 2) + "'   " + SD.Number.ZeroPadDecimal(objCoordinate.LATITUDE_SECONDS, 2, intGeographicSecondsDecimalPlaces, strGroupSeparator, strDecimalSeparator) + '"  ' + ((objCoordinate.NORTH_SOUTH == enumNorthSouth.NORTH) ? 'N' : 'S');
            break;

        case enumField.LONGITUDE_DMS:

            // Format the longitude dms value ...
            var strValue = SD.String.ZeroPad(objCoordinate.LONGITUDE_DEGREES, 3) + '°   ' + SD.String.ZeroPad(objCoordinate.LONGITUDE_MINUTES, 2) + "'   " + SD.Number.ZeroPadDecimal(objCoordinate.LONGITUDE_SECONDS, 2, intGeographicSecondsDecimalPlaces, strGroupSeparator, strDecimalSeparator) + '"  ' + ((objCoordinate.EAST_WEST == enumEastWest.EAST) ? 'E' : 'W');
            break;

        case enumField.LATITUDE_NS:

            // Format the latitude ns value ...
            var strValue = SD.Number.ZeroPadDecimal(objCoordinate.LATITUDE_DEGREES, 2, intDecimalPlaces, strGroupSeparator, strDecimalSeparator) + '°  ' + ((objCoordinate.NORTH_SOUTH == enumNorthSouth.NORTH) ? 'N' : 'S');
            break;

        case enumField.LONGITUDE_EW:

            // Format the longitude ew value ...
            var strValue = SD.Number.ZeroPadDecimal(objCoordinate.LONGITUDE_DEGREES, 3, intDecimalPlaces, strGroupSeparator, strDecimalSeparator) + '°  ' + ((objCoordinate.EAST_WEST == enumEastWest.EAST) ? 'E' : 'W');
            break;

        default:
            // Get the field's value from the coordinate ...
            strValue = objCoordinate[enField];
    }

    return strValue;
}

// **************************************************************************
// CONSTUCTOR ValidationResult
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.CreateValidationResult = function ValidationResult(blnIsValid, strInvalidReason) {

    // Create an instance ...
    var objValidationResult = {
        IsValid: blnIsValid,
        InvalidReasons: [],

        Append: function Append(objValidationResultToAppend) {

            // Get the instance ...
            objValidationResult = this;

            // Valid when both are valid ...
            objValidationResult.IsValid = objValidationResult.IsValid && objValidationResultToAppend.IsValid;

            // Append the invalid reasons ...
            objValidationResult.InvalidReasons = objValidationResult.InvalidReasons.concat(objValidationResultToAppend.InvalidReasons);
        }
    }

    // When an invalid reason were passed in ...
    if (strInvalidReason) {

        // Add strInvalidReason to the invalid reasons ...
        objValidationResult.InvalidReasons.push(strInvalidReason);
    }

    return objValidationResult;
}

// **************************************************************************
// CONSTUCTOR CreateInvalidReasonIcon
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.CreateInvalidReasonIcon = function CreateInvalidReasonIcon(strID, objCoordinate) {

    // Create the instance ...
    var objInvalidReasonIcon = {
        ID: strID,
        Coordinate: objCoordinate
    }

    return objInvalidReasonIcon;
}

// **************************************************************************
// FUNCTION AddCoordinateNumberFieldToCoordinates: 
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.AddCoordinateNumberFieldToCoordinates = function AddCoordinateNumberFieldToCoordinates(arrCoordinates) {

    // Loop through all the coordinates ...
    for (var intCoordinate = 0; intCoordinate < arrCoordinates.length; intCoordinate++) {

        // Get the coordinate ...
        var objCoordinate = arrCoordinates[intCoordinate];

        // Add the COORDINATE_NUMBER field ...
        objCoordinate.COORDINATE_NUMBER = intCoordinate + 1;
    }
}

// **************************************************************************
// FUNCTION: DefaultCoordinateFormatForSpatialReference
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference = function DefaultCoordinateFormatForSpatialReference(objMapController, guidSpatialReference) {

    // Get the spatial reference information ...
    var objSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

    // Get the coordinate format ...
    var enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReferenceType(objSpatialReference.SpatialReferenceType);

    return enCoordinateFormat;
}

// **************************************************************************
// FUNCTION: DefaultCoordinateFormatForSpatialReferenceType
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReferenceType = function DefaultCoordinateFormatForSpatialReferenceType(enSpatialReferenceType) {

    // Declare a variable for the coordinate format to return ...
    var enCoordinateFormat;

    // Determine the default coordiante format based on the spatial reference type ...
    switch (enSpatialReferenceType) {
        case TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC:

            // Set to return DMS ...
            enCoordinateFormat = TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS;
            break;

        case TrimbleMap.enumSpatialReferenceType.PROJECTED:

            // Set to return PROJECTED ...
            enCoordinateFormat = TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED;
            break;

        default:

            // Set to return DMS ...
            enCoordinateFormat = TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS;
            break;
    }

    return enCoordinateFormat;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.CoordinateSystemDropDown = {};
TrimbleMap.CoordinateSystemDropDown.Shared = {};

// Create the CoordinateSystemDropDown namespace ...
var CoordinateSystemDropDown = CoordinateSystemDropDown || {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.CoordinateSystemDropDown.CreateInstance = function CreateInstance(objMapController, intSelectedCoordinateSystem, fnOpened, fnChanged) {

    // Create the object that will hold the instance properties ...
    var objCoordinateSystemDropDown = {
        MapController: objMapController,
        CoordinateSystemDropDownSpan: null,
        CoordinateSystemDropDownArrow: null,
        PopupOpen: false,
        MouseEnterTimer: null,
        PopupDiv: null,
        OpenedFunction: fnOpened,
        ChangedFunction: fnChanged,
        SelectedCoordinateSystem: intSelectedCoordinateSystem,

        AttachPopup: CoordinateSystemDropDown.AttachPopup,
        ClosePopup: CoordinateSystemDropDown.ClosePopup,
        BuildPopup: CoordinateSystemDropDown.BuildPopup
    };

    return objCoordinateSystemDropDown;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AttachAreaPopup: Attach the area popup ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
CoordinateSystemDropDown.AttachPopup = function AttachPopup(objCoordinateSystemDiv) {

    // Get the coordinate system drop down ...
    var objCoordinateSystemDropDown = this;

    // Get the coordinate system drop down span ...
    objCoordinateSystemDropDown.PopupOpen = false;

    // Create the area span and append it to the area span div ...
    objCoordinateSystemDropDown.CoordinateSystemDropDownSpan = $('<span id="CoordinateSystemSpan" class="coordinate-system"></span>');
    objCoordinateSystemDiv.append(objCoordinateSystemDropDown.CoordinateSystemDropDownSpan);

    // Create the drop down arrow div and append it to the coordinate system span div ...
    objCoordinateSystemDropDown.CoordinateSystemDropDownArrow = $('<img src="Images/drop down.png" class="area_drop_down_arrow"></img>');
    objCoordinateSystemDiv.append(objCoordinateSystemDropDown.CoordinateSystemDropDownArrow);

    // Set the text of the drop down ...
    objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.text(objCoordinateSystemDropDown.MapController.CoordinateSystems[objCoordinateSystemDropDown.SelectedCoordinateSystem].Name);

    // When the mouse enters the div around the area span ...
    objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().mouseover(function () {

        // Set a timer to build the area popup ...
        objCoordinateSystemDropDown.MouseEnterTimer = setTimeout(function () {

            // Apply the hover style to the area span ...
            objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().removeClass('area_item_normal');
            objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().addClass('area_item_hover');

        }, 100);
    });

    // When the mouse enters the div around the area span ...
    objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().mouseout(function () {

        // When the popup is not open ...
        if (!objCoordinateSystemDropDown.PopupOpen) {

            // Apply the hover style to the area span ...
            objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().removeClass('area_item_hover');
            objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().addClass('area_item_normal');

            // Stop the timer ...
            clearTimeout(objCoordinateSystemDropDown.MouseEnterTimer);
        }
    });

    // Attach a click event handler ...
    objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.on('click',(function () {

        // When the popup is not open ...
        if (!objCoordinateSystemDropDown.PopupOpen) {

            // Build and display the popup .... 
            objCoordinateSystemDropDown.BuildPopup();

            // Set it to be open ...
            objCoordinateSystemDropDown.PopupOpen = true;

        } else {

            // Close the popup ...
            objCoordinateSystemDropDown.ClosePopup();
        }
    }));
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ClosePopup: Close the popup ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
CoordinateSystemDropDown.ClosePopup = function ClosePopup() {

    // Get the coordinate system drop down ...
    var objCoordinateSystemDropDown = this;

    // When we have a popup open ...
    if (objCoordinateSystemDropDown.PopupDiv) {

        // Apply the hover style to the area span ...
        objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().removeClass('area_item_hover');
        objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().addClass('area_item_normal');

        // Remove the popup ...
        objCoordinateSystemDropDown.PopupDiv.remove();

        // Set to not have a popup open ...
        objCoordinateSystemDropDown.PopupDiv = null;

        // Set it to be open ...
        objCoordinateSystemDropDown.PopupOpen = false;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildPopup
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
CoordinateSystemDropDown.BuildPopup = function BuildPopup() {

    // Get the coordinate system drop down ...
    var objCoordinateSystemDropDown = this;

    // Create the popup div ...
    objCoordinateSystemDropDown.PopupDiv = $('<div class="coordinate_system_drop_down_popup_div"></div>');

    // Get the span position ...
    let objSpanPosition = objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().position();
    let intBlockStart = objSpanPosition.top + objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.parent().outerHeight() - 1;
    let intInlineStart = objSpanPosition.left - 1;

    // Position the popup underneath the span ...
    objCoordinateSystemDropDown.PopupDiv.css('inset-block-start', intBlockStart + 'px');
    objCoordinateSystemDropDown.PopupDiv.css('inset-inline-start', intInlineStart + 'px');

    // Create the table ...
    var objTable = $('<table cellpadding="0" cellspacing="0" border="0"></table>');

    // Append the table to the popup div ...
    objCoordinateSystemDropDown.PopupDiv.append(objTable);

    // Loop through all the coordinate systems that are to be available ...
    for (var intCoordinateSystem = 0; intCoordinateSystem < objCoordinateSystemDropDown.MapController.CoordinateSystems.length; intCoordinateSystem++) {

        // Get the coordinate system ...
        var objCoordinateSystem = objCoordinateSystemDropDown.MapController.CoordinateSystems[intCoordinateSystem];

        // Declare a variable to hold the mark up for the check box if this row is to have a check ...
        var strCheck = '';

        // When it is the selected coordinate system ...
        if (intCoordinateSystem == objCoordinateSystemDropDown.SelectedCoordinateSystem) {

            // Set to add the check image ...
            strCheck = '<img src="Images/Check.png" style="margin-inline-start:6px;margin-inline-end:6px"></img>';
        }

        // Build the corodinate system text ...
        var strCoordinateSystemText = objCoordinateSystem.Name + ' (' + objCoordinateSystem.Description + ')';

        // Build a table row with 2 columns with an optional check and a span with the area text ...
        var objTableRow = $('<tr><td style="width:20px" align="center">' + strCheck + '</td><td><span class="CoordinateSystemPopupText">' + strCoordinateSystemText + '</span>&nbsp;</td></tr>');

        // Add the row to the table ...
        objTable.append(objTableRow);

        // Attach a mouse enter event handler to the row ...
        objTableRow.mouseenter(function (e) {

            // Get the row index, this would be the index into the coordinate systems array ...
            var intCoordinateSystem = $.inArray(this, $(this).parent().find('tr'));

            // When not the currently selected area unit ...
            if (intCoordinateSystem != objCoordinateSystemDropDown.SelectedCoordinateSystem) {

                // Toggle CoordinateSystemRowHighlight class on the row ...
                $(this).toggleClass('CoordinateSystemRowHighlight', true);
            };
        });

        // Attach a mouse leave event handler to the row ...
        objTableRow.mouseleave(function (e) {

            // Toggle CoordinateSystemRowHighlight class on the row ...
            $(this).toggleClass('CoordinateSystemRowHighlight', false);
        });

        // Attach a click event handler to the row ...
        objTableRow.on('click',(function (e) {

            // Get the row index, this would be the index into the coordinate systems array ...
            var intCoordinateSystem = $.inArray(this, $(this).parent().find('tr'));

            // When not the currently selected area unit ...
            if (intCoordinateSystem != objCoordinateSystemDropDown.SelectedCoordinateSystem) {

                // Close the Popup ...
                CoordinateSystemDropDown.ClosePopup();

                // Select the area unit that the user clicked on ...
                objCoordinateSystemDropDown.SelectedCoordinateSystem = intCoordinateSystem;

                // Get the coordinate system ...
                objCoordinateSystem = objCoordinateSystemDropDown.MapController.CoordinateSystems[intCoordinateSystem].Name;

                // Update the area value on the interface ...
                objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.text(objCoordinateSystem.Name);

                // Trigger the Changed event on the span ...
                objCoordinateSystemDropDown.ChangedFunction(objCoordinateSystem);
            };
        }));
    }

    // Add to the page ...
    objCoordinateSystemDropDown.CoordinateSystemDropDownSpan.offsetParent().append(objCoordinateSystemDropDown.PopupDiv);

    // Bring to the front ...
    SD.DOM.BringToFront(objCoordinateSystemDropDown.PopupDiv);

    // When the mouse leaves the div arond the area span ...
    objCoordinateSystemDropDown.PopupDiv.mouseleave(function (e) {

        // Close the Popup ...
        CoordinateSystemDropDown.ClosePopup();
    });

    // Trigger the Opened event on the span ...
    objCoordinateSystemDropDown.OpenedFunction();
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the TrimbleMap.Configuration namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Configuration = {};
TrimbleMap.Configuration.Shared = {};
TrimbleMap.Configuration.Shared.TAB_NAME = 'CONFIGURATION';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.CreateInstance = function CreateInstance(objMapController, objSidebar, blnEditable) {

    // Create the object that will hold the instance properties ...
    var objMapConfiguration = {
        MapController: objMapController,
        EventHandlersAttached: false,
        Sidebar: objSidebar,
        ContainerDiv: null,
        MapNameDiv: null,
        MapNameSpan: null,
        MapNameEditIcon: null,
        MapSpatialReferenceSpan: null,
        MapNameTextBox: null,
        MapSettingsContainerDiv: null,
        MapServiceDisplaysContainerDiv: null,
        MapServiceDisplaysDiv: null,
        MapServicesContainerDiv: null,
        ScrollableMapServiceDisplaysDiv: null,
        MapServicesDiv: null,
        MapServicesScrollableDiv: null,
        CurrentlyDraggedMapServiceDiv: null,
        GoToExtentSpan: null,
        UseCurrentExtentSpan: null,
        SkipUpdateMapServiceDisplayOrder: false,
        MapServiceDisplayInEditMode: null,
        MapServiceDisplayEditDiv: null,
        ScaleRangeSliderDiv: null,
        TransparencySliderDiv: null,
        TransparencySliderValueDiv: null,
        TransparencySliderValueSpan: null,
        ScaleRangeSliderValueSpan: null,
        Editable: blnEditable,
        ConfigurationTabItem: null,
        MapServicesNiceScroll: null,
        ScrollableMapServiceDisplaysDivNiceScroll: null,
        CoordinateSystemDisplayDropDown: null,

        MapServiceDisplaysReceiveProxy: function (event, ui) { objMapConfiguration.MapServiceDisplaysReceive(event, ui, this); },
        ContainerClickedProxy: function (e) { objMapConfiguration.ContainerClicked(e); },
        MapNameUnfocusProxy: function (e) { objMapConfiguration.MapNameUnfocus(e); },
        MapNameKeyUpProxy: function (e) { if (e.which == '13') { objMapConfiguration.MapNameUnfocus(e); } },
        UpdateMapServiceDisplayOrderProxy: function (e) { objMapConfiguration.UpdateMapServiceDisplayOrder(); },
        GoToExtentClickedProxy: function (e) { objMapConfiguration.GoToExtentClicked(); },
        UseCurrentExtentClickedProxy: function (e) { objMapConfiguration.UseCurrentExtentClicked(); },
        CreateTransparencySliderValueDivProxy: function (e, ui) { objMapConfiguration.CreateTransparencySliderValueDiv(e, ui); },
        RemoveTransparencySliderValueDivProxy: function () { objMapConfiguration.RemoveTransparencySliderValueDiv(); },
        TransparencySliderSlidedProxy: function (e, ui) { objMapConfiguration.TransparencySliderSlided(e, ui); },
        ScaleRangeSliderSlidedProxy: function (e, ui) { objMapConfiguration.ScaleRangeSliderSlided(e, ui); },
        OnScalesChangedProxy: function (arrScaleLevels) { objMapConfiguration.OnScalesChanged(arrScaleLevels); },
        CreateScaleRangeSliderValueDivProxy: function (e, ui) { objMapConfiguration.CreateScaleRangeSliderValueDiv(e, ui); },
        RemoveScaleRangeSliderValueDivProxy: function (e, ui) { objMapConfiguration.RemoveScaleRangeSliderValueDiv(e, ui); },
        OnScaleChangedProxy: function (decScale) { objMapConfiguration.OnScaleChanged(decScale); },
        LoadedCallbackProxy: function (blnReloaded) { objMapConfiguration.LoadedCallback(blnReloaded); },
        ExtentChangedCallbackProxy: function (arrFailedMapServiceDisplays) { objMapConfiguration.ExtentChangedCallback(arrFailedMapServiceDisplays); },
        MapServicesDivMouseDownProxy: function (e) { objMapConfiguration.MapServicesDivMouseDown(e); },
        MapServicesDivMouseUpProxy: function () { objMapConfiguration.MapServicesDivMouseUp(); },
        CoordinateSystemDisplayDropDownChangedProxy: function (e) { objMapConfiguration.CoordinateSystemDisplayDropDownChanged(e); },

        PopulateCoordinateSystemDisplayDropDown: TrimbleMap.Configuration.PopulateCoordinateSystemDisplayDropDown,
        CoordinateSystemDisplayDropDownChanged: TrimbleMap.Configuration.CoordinateSystemDisplayDropDownChanged,
        ActivateTab: TrimbleMap.Configuration.ActivateTab,
        DeActivateTab: TrimbleMap.Configuration.DeActivateTab,
        ResizeTab: TrimbleMap.Configuration.ResizeTab,
        CreateElements: TrimbleMap.Configuration.CreateElements,
        PositionElements: TrimbleMap.Configuration.PositionElements,
        Populate: TrimbleMap.Configuration.Populate,
        PopulateMapServiceDisplays: TrimbleMap.Configuration.PopulateMapServiceDisplays,
        PopulateMapName: TrimbleMap.Configuration.PopulateMapName,
        PopulateSpatialReferenceName: TrimbleMap.Configuration.PopulateSpatialReferenceName,
        AttachEventHandlers: TrimbleMap.Configuration.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Configuration.DetachEventHandlers,
        CreateMapServiceDisplayDiv: TrimbleMap.Configuration.CreateMapServiceDisplayDiv,
        CreateMapServiceDiv: TrimbleMap.Configuration.CreateMapServiceDiv,
        PopulateMapServices: TrimbleMap.Configuration.PopulateMapServices,
        MapServiceDisplaysReceive: TrimbleMap.Configuration.MapServiceDisplaysReceive,
        MapServicesDivMouseDown: TrimbleMap.Configuration.MapServicesDivMouseDown,
        MapServicesDivMouseUp: TrimbleMap.Configuration.MapServicesDivMouseUp,
        AttachMapServiceDraggableEventHandlers: TrimbleMap.Configuration.AttachMapServiceDraggableEventHandlers,
        ContainerClicked: TrimbleMap.Configuration.ContainerClicked,
        DetachMapServiceDraggableEventHandlers: TrimbleMap.Configuration.DetachMapServiceDraggableEventHandlers,
        MapNameUnfocus: TrimbleMap.Configuration.MapNameUnfocus,
        UpdateMapServiceDisplayOrder: TrimbleMap.Configuration.UpdateMapServiceDisplayOrder,
        GoToExtentClicked: TrimbleMap.Configuration.GoToExtentClicked,
        UseCurrentExtentClicked: TrimbleMap.Configuration.UseCurrentExtentClicked,
        ShowOrHideMapServiceDisplayEditPanel: TrimbleMap.Configuration.ShowOrHideMapServiceDisplayEditPanel,
        CreateMapServiceDisplayEditPanel: TrimbleMap.Configuration.CreateMapServiceDisplayEditPanel,
        RemoveMapServiceDisplayEditPanel: TrimbleMap.Configuration.RemoveMapServiceDisplayEditPanel,
        CreateMapServiceDisplayEditPanelSliders: TrimbleMap.Configuration.CreateMapServiceDisplayEditPanelSliders,
        RemoveMapServiceDisplayEditPanelSliders: TrimbleMap.Configuration.RemoveMapServiceDisplayEditPanelSliders,
        CreateTransparencySliderValueDiv: TrimbleMap.Configuration.CreateTransparencySliderValueDiv,
        RemoveTransparencySliderValueDiv: TrimbleMap.Configuration.RemoveTransparencySliderValueDiv,
        TransparencySliderSlided: TrimbleMap.Configuration.TransparencySliderSlided,
        ScaleRangeSliderSlided: TrimbleMap.Configuration.ScaleRangeSliderSlided,
        CreateScaleRangeSliderValueDiv: TrimbleMap.Configuration.CreateScaleRangeSliderValueDiv,
        RemoveScaleRangeSliderValueDiv: TrimbleMap.Configuration.RemoveScaleRangeSliderValueDiv,
        OnScaleChanged: TrimbleMap.Configuration.OnScaleChanged,
        OnScalesChanged: TrimbleMap.Configuration.OnScalesChanged,
        ComputeScalePercentage: TrimbleMap.Configuration.ComputeScalePercentage,
        AddDroppedMapServiceDisplay: TrimbleMap.Configuration.AddDroppedMapServiceDisplay,
        UpdateScrollbars: TrimbleMap.Configuration.UpdateScrollbars,
        SetInitialExtent: TrimbleMap.Configuration.SetInitialExtent,
        ZoomToDefaultMapServiceExtent: TrimbleMap.Configuration.ZoomToDefaultMapServiceExtent,
        LoadedCallback: TrimbleMap.Configuration.LoadedCallback,
        ExtentChangedCallback: TrimbleMap.Configuration.ExtentChangedCallback,
        GetScales: TrimbleMap.Configuration.GetScales
    };

    // Create the elements ...
    objMapConfiguration.CreateElements();

    // Create the tab ...
    objMapConfiguration.ConfigurationTabItem = SD.Sidebar.Shared.CreateTabItem(TrimbleMap.Configuration.Shared.TAB_NAME, 'CONFIGURATION', 0,
        function (objTabContainerElement, enTabActivationMethod) { objMapConfiguration.ActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement, enTabActivationMethod) { objMapConfiguration.DeActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement) { objMapConfiguration.ResizeTab(objTabContainerElement); },
        function () { return 286; });

    // Add the tab ...
    objMapConfiguration.Sidebar.AddTab(objMapConfiguration.ConfigurationTabItem);

    // Select the configuration tab ...
    objMapConfiguration.Sidebar.SelectTab(objMapConfiguration.ConfigurationTabItem);

    // Add the on scale changed callback ...
    objMapConfiguration.MapController.AddOnScaleChanged(objMapConfiguration.OnScaleChangedProxy);

    // Add the Loaded and PreReloaded callbacks ...
    objMapConfiguration.MapController.AddOnLoadedCallback(objMapConfiguration.LoadedCallbackProxy);
    objMapConfiguration.MapController.AddOnExtentChangedCallback(objMapConfiguration.ExtentChangedCallbackProxy);

    return objMapConfiguration;
}

// **************************************************************************
// FUNCTION: LoadedCallback
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.LoadedCallback = function LoadedCallback(blnReloaded) {

    // Get the instance ...
    var objMapConfiguration = this;

    // Populate interface ...
    objMapConfiguration.Populate();
}

// **************************************************************************
// FUNCTION: ExtentChangedCallback
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.ExtentChangedCallback = function ExtentChangedCallback(arrFailedMapServiceDisplays) {

    // Get the instance ...
    let objMapConfiguration = this;

    let arrLoadFailureIcons = objMapConfiguration.MapServiceDisplaysDiv.find('.configuration_load_failed_icon');

    arrLoadFailureIcons.each(function () {
        $(this).parent().remove();
    });

    for (let intIndex = 0; intIndex < arrFailedMapServiceDisplays.length; intIndex++) {
        // Get all the map service display divs ...
        let objMapServiceDisplayRow = objMapConfiguration.MapServiceDisplaysDiv.find('.map_config_mapservicedisplay_container_div[MapServiceDisplayID=' + arrFailedMapServiceDisplays[intIndex].MapServiceDisplayID + '] table tr');

        if (objMapServiceDisplayRow && objMapServiceDisplayRow.length > 0) {
            let objLoadFailureIconFound = objMapServiceDisplayRow.find('.configuration_load_failed_icon');

            if (!objLoadFailureIconFound || objLoadFailureIconFound.length < 1) {
                // Create the load failed icon ...
                let objLoadFailureIcon = $('<div class="configuration_load_failed_icon"></div>');

                // Create a cell for the icon ...
                let objLoadFailureIconCell = $('<td></td>');

                // Add the icon to the cell ...
                objLoadFailureIconCell.append(objLoadFailureIcon);

                // Add it to the div ...
                objMapServiceDisplayRow.prepend(objLoadFailureIconCell);

                // Get the translation ...
                // Problems loading map service. The data might not be displayed in the map and any interaction with the map might not return any results for this map service.
                let strUnableToLoadLayer = SD.Translation.Shared.GetTranslation('Map.Legend.js', 'ProblemsLoadingMapService');

                // Add the tooltip ...
                objLoadFailureIcon.attr('title', strUnableToLoadLayer);

                let objMapServiceDisplayNameSpanCell = objMapServiceDisplayRow.find('.map_config_mapservicedisplay_span').parent();

                objMapServiceDisplayNameSpanCell.removeClass('map_config_mapservicedisplay_text_div');
                objMapServiceDisplayNameSpanCell.addClass('map_config_mapservicedisplay_text_failed_div');
            }
        }
    }
}

// **************************************************************************
// FUNCTION: ActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.ActivateTab = function ActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Add the container div to the tab item div ...
    objTabContainerElement.append(objMapConfiguration.ContainerDiv);

    // Attach the event handlers ...
    objMapConfiguration.AttachEventHandlers();
}

// **************************************************************************
// FUNCTION: DeActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.DeActivateTab = function DeActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Attach the event handlers ...
    objMapConfiguration.DetachEventHandlers();

    // Remove the container div from the DOM ...
    objMapConfiguration.ContainerDiv.remove();
}

// **************************************************************************
// FUNCTION: ResizeTab
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.ResizeTab = function ResizeTab(objTabContainerElement) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Position the elements ...
    setTimeout(function () { objMapConfiguration.PositionElements(); }, 1)
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.AttachEventHandlers = function AttachEventHandlers() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // When the event handlers are not attached ...
    if (!objMapConfiguration.EventHandlersAttached) {

        // Make the elements sortable ...
        if (objMapConfiguration.Editable) {
            objMapConfiguration.MapServiceDisplaysDiv.sortable({ receive: objMapConfiguration.MapServiceDisplaysReceiveProxy, update: objMapConfiguration.UpdateMapServiceDisplayOrderProxy });
        }

        // Attach the mousedown and mouseup event handlers to the map services div ...
        objMapConfiguration.MapServicesDiv.mousedown(objMapConfiguration.MapServicesDivMouseDownProxy);
        objMapConfiguration.MapServicesDiv.mouseup(objMapConfiguration.MapServicesDivMouseUpProxy);

        // Attach Coordiante system drop down chnage
        objMapConfiguration.CoordinateSystemDisplayDropDown.change(objMapConfiguration.CoordinateSystemDisplayDropDownChangedProxy);

        // Attach the draggable event handlers for the map services ...
        objMapConfiguration.AttachMapServiceDraggableEventHandlers();

        // Attach the container clicked event handler ...
        objMapConfiguration.ContainerDiv.click(objMapConfiguration.ContainerClickedProxy);

        // Attach the unfocus event handler for the map name text box ...
        objMapConfiguration.MapNameTextBox.blur(objMapConfiguration.MapNameUnfocusProxy);

        // Attach the map name key up proxy ...
        objMapConfiguration.MapNameTextBox.keyup(objMapConfiguration.MapNameKeyUpProxy);

        // Attach event handlers for the initial extent "Go To" and "Use Current Extent" links ...
        objMapConfiguration.GoToExtentSpan.click(objMapConfiguration.GoToExtentClickedProxy);
        objMapConfiguration.UseCurrentExtentSpan.click(objMapConfiguration.UseCurrentExtentClickedProxy);

        // Create the sliders ...
        objMapConfiguration.CreateMapServiceDisplayEditPanelSliders(objMapConfiguration.MapServiceDisplayInEditMode);

        // Update the scrollbars ...
        objMapConfiguration.UpdateScrollbars(true);

        // Set the events to be attached ...
        objMapConfiguration.EventHandlersAttached = true;
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // When the event handlers not attached ...
    if (objMapConfiguration.EventHandlersAttached) {

        // When editable ...
        if (objMapConfiguration.Editable) {

            // Remove the sortable functionality from the map services ...
            objMapConfiguration.MapServiceDisplaysDiv.sortable("destroy");
        }

        // Detach the mousedown and mouseup event handlers from the map services div ...
        objMapConfiguration.MapServicesDiv.off('mousedown', objMapConfiguration.MapServicesDivMouseDownProxy);
        objMapConfiguration.MapServicesDiv.off('mouseup', objMapConfiguration.MapServicesDivMouseUpProxy);

        // Detach the draggable event handlers for the map services ...
        objMapConfiguration.DetachMapServiceDraggableEventHandlers();

        // Detach the coordinate system drop down handler
        objMapConfiguration.CoordinateSystemDisplayDropDown.off('change', objMapConfiguration.CoordinateSystemDisplayDropDownChangedProxy);

        // Remove the clicked event handler ...
        objMapConfiguration.ContainerDiv.off('click', objMapConfiguration.ContainerClickedProxy);

        // Detach the unfocus event handler for the map name text box ...
        objMapConfiguration.MapNameTextBox.off('blur', objMapConfiguration.MapNameUnfocusProxy);

        // Detach the map name key up proxy ...
        objMapConfiguration.MapNameTextBox.off('keyup', objMapConfiguration.MapNameKeyUpProxy);

        // Detach event handlers for the initial extent "Go To" and "Use Current Extent" links ...
        objMapConfiguration.GoToExtentSpan.off('click', objMapConfiguration.GoToExtentClickedProxy);
        objMapConfiguration.UseCurrentExtentSpan.off('click', objMapConfiguration.UseCurrentExtentClickedProxy);

        // Remove the sliders ...
        objMapConfiguration.RemoveMapServiceDisplayEditPanelSliders();

        // Update the scrollbars ...
        objMapConfiguration.UpdateScrollbars(false);

        // Set the events to be detached ...
        objMapConfiguration.EventHandlersAttached = false;
    }
}

// **************************************************************************
// FUNCTION: UpdateScrollbars
// USAGE:    blnOverrideEventHandlersAttached is optional, supply a value 
//           to use instead of objMapConfiguration.EventHandlersAttached ...
// **************************************************************************
TrimbleMap.Configuration.UpdateScrollbars = function UpdateScrollbars(blnOverrideEventHandlersAttached) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Use blnOverrideEventHandlersAttached when supplied otehrwise use objMapConfiguration.EventHandlersAttached ...
    var blnEventHandlersAttached = ((typeof blnOverrideEventHandlersAttached != 'undefined') && (blnOverrideEventHandlersAttached != null)) ? blnOverrideEventHandlersAttached : objMapConfiguration.EventHandlersAttached;

    // When the event handlers have been attached ...
    if (blnEventHandlersAttached) {


        // Activate the nice scroll bar on the available map services list ...
        objMapConfiguration.MapServicesNiceScroll = objMapConfiguration.MapServicesScrollableDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });

        // Activate the nice scroll bar on the map service displays list ...
        objMapConfiguration.ScrollableMapServiceDisplaysDivNiceScroll = objMapConfiguration.ScrollableMapServiceDisplaysDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });

    } else {

        // De-activate the nice-scrollbar on the available map services list ...
        if (objMapConfiguration.MapServicesNiceScroll) { objMapConfiguration.MapServicesNiceScroll.remove(); objMapConfiguration.MapServicesNiceScroll = null; }

        // De-activate the nice-scrollbar on the map service displays list ...
        if (objMapConfiguration.ScrollableMapServiceDisplaysDivNiceScroll) { objMapConfiguration.ScrollableMapServiceDisplaysDivNiceScroll.remove(); objMapConfiguration.ScrollableMapServiceDisplaysDivNiceScroll = null; }
    }
}

// **************************************************************************
// FUNCTION: GoToExtentClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.GoToExtentClicked = function GoToExtentClicked() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // When we have an initial extent ...
    if (objMapConfiguration.MapController.CurrentMap.InitialExtentBookmarkID != SD.Guid.Shared.Empty()) {

        // Get the bookmark ...
        var objBookmark = objMapConfiguration.MapController.GetBookmark(objMapConfiguration.MapController.CurrentMap.InitialExtentBookmarkID);

        // Get the bookmark extent ...
        var objBookmarkExtentDeferred = objMapConfiguration.MapController.GetBookmarkExtentInSpatialReferenceOfCurrentMap(objBookmark);

        // When completed ...
        objBookmarkExtentDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objEsriMapExtent) {

            // Set the extent of the map ...
            objMapConfiguration.MapController.SetMapExtent(objEsriMapExtent);
        }));
    }
}

// **************************************************************************
// FUNCTION: UseCurrentExtentClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.UseCurrentExtentClicked = function UseCurrentExtentClicked() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Get the extent of the esri map ...
    var objEsriExtent = objMapConfiguration.MapController.EsriMap.extent;

    // Set the initial extent ...
    objMapConfiguration.SetInitialExtent(objMapConfiguration.MapController.EsriMap.extent);

    // Notify that the initial extent has been set ...
    TrimbleMap.MessageBox.Shared.ShowMessage('Initial extent set', 'The initial extent for the map has been set to the current extent');
}

// **************************************************************************
// FUNCTION: SetInitialExtent
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.SetInitialExtent = function SetInitialExtent(objInitialExtentInSpatialReferenceOfCurrentMap) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // When we already have an initial extent ...
    if (objMapConfiguration.MapController.CurrentMap.InitialExtentBookmarkID != SD.Guid.Shared.Empty()) {

        // Get the bookmark for the initial extend ...
        var objBookmark = objMapConfiguration.MapController.GetBookmark(objMapConfiguration.MapController.CurrentMap.InitialExtentBookmarkID);

        // Update the bookmark using the current extent ...
        objBookmark.ExtentMinX = objInitialExtentInSpatialReferenceOfCurrentMap.xmin;
        objBookmark.ExtentMinY = objInitialExtentInSpatialReferenceOfCurrentMap.ymin;
        objBookmark.ExtentMaxX = objInitialExtentInSpatialReferenceOfCurrentMap.xmax;
        objBookmark.ExtentMaxY = objInitialExtentInSpatialReferenceOfCurrentMap.ymax;

        // Set the geographic spatial reference id ...
        objBookmark.GeographicSpatialReferenceID = objMapConfiguration.MapController.CurrentMap.SpatialReferenceID;


    } else {

        // Create a new bookmark ...
        var objBookmark = SD.Bookmark.Shared.CreateFromEsriMapExtent(objInitialExtentInSpatialReferenceOfCurrentMap,
            'Initial Map Extent',
            SD.Guid.Shared.DefaultUserID(),
            objMapConfiguration.MapController.CurrentMap.SpatialReferenceID);

        // Set the bookmark name to be the id to avoid unique conatraint violations in the database ...
        objBookmark.BookmarkName = objBookmark.BookmarkID;

        // Initial extent bookmark id for the current map ...
        objMapConfiguration.MapController.CurrentMap.InitialExtentBookmarkID = objBookmark.BookmarkID;

        // Add the bookmark to the map controller ...
        objMapConfiguration.MapController.AddBookmark(objBookmark);
    }
}

// **************************************************************************
// FUNCTION: ContainerClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.ContainerClicked = function ContainerClicked(e) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // When not in readonly mode ...
    if (objMapConfiguration.Editable) {

        // Wrap the target in a jquery object ...
        var objTarget = $(e.target);

        // When the user clicked on a map service display 'Remove' button ....
        if (objTarget.hasClass('map_config_mapservicedisplay_remove_div') || objTarget.hasClass('map_config_mapservicedisplay_edit_div')) {

            // Get the map service display div in which the remove icon is ...
            var objMapServiceDisplayDiv = $(objTarget.closest('.map_config_mapservicedisplay_container_div'));

            // Get the map service display id that is to be removed ...
            var strMapServiceDisplayID = objMapServiceDisplayDiv.attr('MapServiceDisplayID');

            // Get the map servuce display instance ...
            var objMapServiceDisplay = objMapConfiguration.MapController.GetMapServiceDisplay(strMapServiceDisplayID);

            // When the user clicked on a map service display 'Remove' button ....
            if (objTarget.hasClass('map_config_mapservicedisplay_remove_div')) {

                // Remove the map service display edit panel when visible ...
                objMapConfiguration.RemoveMapServiceDisplayEditPanel();

                // Remove the map service from the map ...
                objMapConfiguration.MapController.RemoveMapServiceDisplayFromMap(objMapServiceDisplay, objMapConfiguration.MapController.CurrentMap);

                // Populate the map service displays, map services and the spatial reference name ...
                objMapConfiguration.PopulateMapServiceDisplays();
                objMapConfiguration.PopulateMapServices();
                objMapConfiguration.PopulateSpatialReferenceName();

                //Only populate the coordinate system display drop down if the warning image is not displayed
                if (objMapConfiguration.CoordinateSystemDisplayValueDiv.find('.projection_warning_image').length == 0) {
                    objMapConfiguration.PopulateCoordinateSystemDisplayDropDown(objMapConfiguration.CoordinateSystemDisplayDropDown);
                }

                if (objMapConfiguration.MapController.CurrentMap.MapServiceDisplays.length == 0) {
                    objMapConfiguration.MapController.CurrentMap.InitialExtentBookmarkID = SD.Guid.Shared.Empty();
                }

            } else {

                // Show the map service display edit div ...
                objMapConfiguration.ShowOrHideMapServiceDisplayEditPanel(objMapServiceDisplay, objMapServiceDisplayDiv);
            }

        } else {

            // Get the name div in which the user clicked (if any) ...
            var objMapNameDiv = objTarget.hasClass('map_config_map_name_div') ? objTarget : objTarget.closest('.map_config_map_name_div');

            // When the user clicked in the name div ...
            if (objMapNameDiv.length > 0) {

                // When the map name span is visible ...
                if (objMapConfiguration.MapNameSpan.is(':visible')) {

                    // Hide the name span ...
                    objMapConfiguration.MapNameSpan.hide();

                    // Hide the edit icon ...
                    objMapConfiguration.MapNameEditIcon.hide();

                    // Set the textbox to have the same value as the span ...
                    objMapConfiguration.MapNameTextBox.val(objMapConfiguration.MapNameSpan.text());

                    // Show the name span ...
                    objMapConfiguration.MapNameTextBox.show();

                    // Focus on the text box ...
                    objMapConfiguration.MapNameTextBox.focus();
                }
            }
        }
    }
}

// **************************************************************************
// FUNCTION: ShowOrHideMapServiceDisplayEditPanel
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.ShowOrHideMapServiceDisplayEditPanel = function ShowOrHideMapServiceDisplayEditPanel(objMapServiceDisplay, objMapServiceDisplayDiv) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Remove the expanded class ...
    $(objMapConfiguration.ContainerDiv.find('.map_config_mapservicedisplay_expanded')).removeClass('map_config_mapservicedisplay_expanded');

    // When the edit panel for the map service display is not already visible ....
    if (objMapServiceDisplay != objMapConfiguration.MapServiceDisplayInEditMode) {

        // When we have a map service display that is currently in edit mode ...
        if (objMapConfiguration.MapServiceDisplayEditDiv != null) {

            // Remove the sliders ...
            objMapConfiguration.RemoveMapServiceDisplayEditPanelSliders();

            // Place the div to remove in a local variable so we can use it with closure after sliding 
            // up even though objMapConfiguration.MapServiceDisplayEditDiv will change shortly ...
            var objDivToRemove = objMapConfiguration.MapServiceDisplayEditDiv;

            // Slide the div up and register a complete function to remove it from the dom ...
            objMapConfiguration.MapServiceDisplayEditDiv.slideUp(400, function () {

                // Remove the div from the page ...
                objDivToRemove.remove();
            });

            // Set to not have any sliders or dispaly div ...
            objMapConfiguration.ScaleRangeSliderDiv = null;
            objMapConfiguration.TransparencySliderDiv = null;
            objMapConfiguration.MapServiceDisplayEditDiv = null;
        }

        // Set the current map service display in edit mode ...
        objMapConfiguration.MapServiceDisplayInEditMode = objMapServiceDisplay;

        // Create the edit panel ...
        objMapConfiguration.MapServiceDisplayEditDiv = objMapConfiguration.CreateMapServiceDisplayEditPanel(objMapServiceDisplay);

        // Hide it ...
        objMapConfiguration.MapServiceDisplayEditDiv.hide();

        // Insert it into the page after the div of the map service display for which it is ...
        objMapServiceDisplayDiv.append(objMapConfiguration.MapServiceDisplayEditDiv);

        // Slide it down ...
        objMapConfiguration.MapServiceDisplayEditDiv.slideDown(400);

        // Set the map service dislpay to be the one in edit mode ...
        objMapConfiguration.MapServiceDisplayInEditMode = objMapServiceDisplay;

        // Add the expanded class ...
        objMapServiceDisplayDiv.addClass('map_config_mapservicedisplay_expanded');

    } else {

        // Hide the map service display in edit mode ...
        objMapConfiguration.MapServiceDisplayEditDiv.hide();

        // Set to have no map service display in edit mode ...
        objMapConfiguration.MapServiceDisplayInEditMode = null;
        objMapConfiguration.MapServiceDisplayEditDiv = null;
    }
}

// **************************************************************************
// FUNCTION: CreateMapServiceDisplayEditPanel
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.CreateMapServiceDisplayEditPanel = function CreateMapServiceDisplayEditPanel(objMapServiceDisplay) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Create the div ...
    var objEditPanelDiv = $('<div class="map_config_mapservicedisplay_edit_panel_div"></div>');

    // Create the "Transparency" span and append it ...
    objEditPanelDiv.append('<span class="map_config_edit_panel_span">Transparency:</span>');

    // Create the transparency div ...
    objMapConfiguration.TransparencySliderDiv = $('<div class="map_config_transparency_slider_div"><div class="ui-slider-handle ui-state-default ui-corner-all"></div></div>');

    // Add it to the div ...
    objEditPanelDiv.append(objMapConfiguration.TransparencySliderDiv);

    // Add a div to clear the floats ...
    objEditPanelDiv.append('<div style="clear:both"></div>');

    // Create the "Transparency" span and append it ...
    objEditPanelDiv.append('<span class="map_config_edit_panel_span">Scale Range:</span>');

    // Create the scale range div ...
    objMapConfiguration.ScaleRangeSliderDiv = $('<div class="map_config_scale_range_slider_div"><div class="ui-slider-handle ui-state-default ui-corner-all map_configuration_min_scale"></div><div class="ui-slider-handle ui-state-default ui-corner-all map_configuration_max_scale"></div></div>');

    // Create the current scale div ...
    objMapConfiguration.CurrentScaleDiv = $('<div class="map_config_current_scale_outer_div"><div class="map_config_current_scale_div"></div></div>');

    // Add it to the scale range div ...
    objMapConfiguration.ScaleRangeSliderDiv.append(objMapConfiguration.CurrentScaleDiv);

    // Position the current scale indicator ...
    objMapConfiguration.CurrentScaleDiv.css('inset-inline-start', objMapConfiguration.ComputeScalePercentage(objMapConfiguration.MapController.GetScale()) + '%');

    // Add it to the div ...
    objEditPanelDiv.append(objMapConfiguration.ScaleRangeSliderDiv);

    // Add a div to clear the floats ...
    objEditPanelDiv.append('<div style="clear:both"></div>');

    // Create the sliders ...
    objMapConfiguration.CreateMapServiceDisplayEditPanelSliders(objMapServiceDisplay);

    return objEditPanelDiv;
}

// **************************************************************************
// FUNCTION: GetScales
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.GetScales = function GetScales() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Get the scales from the map ...
    var arrScales = objMapConfiguration.MapController.GetCurrentMapScales();

    // When no scales from map ...
    if (arrScales == null) {

        // Get the default scales ...
        arrScales = TrimbleMap.Controller.Shared.GetDefaultScales();
    }

    return arrScales;
}

// **************************************************************************
// FUNCTION: ComputeScalePercentage
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.ComputeScalePercentage = function ComputeScalePercentage(decScale) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Get the level for the current scale ...
    var intLevel = objMapConfiguration.MapController.GetScaleLevel(decScale);

    // Get the number of scales ...
    var intLevelCount = objMapConfiguration.GetScales().length;

    // Compute the percentage ...
    var decPercentage = (100.0 / (intLevelCount - 1)) * intLevel;

    return decPercentage;
}

// **************************************************************************
// FUNCTION: RemoveMapServiceDisplayEditPanel
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.RemoveMapServiceDisplayEditPanel = function RemoveMapServiceDisplayEditPanel() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Remove the sliders (if any) and set to not have any sliders ...
    objMapConfiguration.RemoveMapServiceDisplayEditPanelSliders();
    if (objMapConfiguration.MapServiceDisplayEditDiv) { objMapConfiguration.MapServiceDisplayEditDiv.remove(); }
    objMapConfiguration.ScaleRangeSliderDiv = null;
    objMapConfiguration.TransparencySliderDiv = null;
    objMapConfiguration.MapServiceDisplayEditDiv = null;
    objMapConfiguration.MapServiceDisplayInEditMode = null;
}

// **************************************************************************
// FUNCTION: CreateMapServiceDisplayEditPanelSliders
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.CreateMapServiceDisplayEditPanelSliders = function CreateMapServiceDisplayEditPanelSliders(objMapServiceDisplay) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Create the transparency slider ...
    if (objMapConfiguration.TransparencySliderDiv) {
        objMapConfiguration.TransparencySliderDiv.slider({
            min: 0,
            max: 100,
            value: objMapServiceDisplay.Transparency,
            orientation: "horizontal",
            start: objMapConfiguration.CreateTransparencySliderValueDivProxy,
            stop: objMapConfiguration.RemoveTransparencySliderValueDivProxy,
            slide: objMapConfiguration.TransparencySliderSlidedProxy
        });
    }

    // Create the scale range slider ...
    if (objMapConfiguration.ScaleRangeSliderDiv) {

        // Get the scale range count ...
        var intScaleRangeCount = objMapConfiguration.GetScales().length;

        // Get the current min and max scale levels ...
        var intMinLevel = objMapConfiguration.MapController.GetScaleLevel(objMapServiceDisplay.MinScale);
        var intMaxLevel = objMapConfiguration.MapController.GetScaleLevel(objMapServiceDisplay.MaxScale);

        // Create the slider ...
        objMapConfiguration.ScaleRangeSliderDiv.slider({
            orientation: "horizontal",
            range: true,
            min: 0,
            max: intScaleRangeCount - 1,
            values: [intMinLevel, intMaxLevel],
            start: objMapConfiguration.CreateScaleRangeSliderValueDivProxy,
            stop: objMapConfiguration.RemoveScaleRangeSliderValueDivProxy,
            slide: objMapConfiguration.ScaleRangeSliderSlidedProxy
        });
    }
}

// **************************************************************************
// FUNCTION: RemoveMapServiceDisplayEditPanelSliders
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.RemoveMapServiceDisplayEditPanelSliders = function RemoveMapServiceDisplayEditPanelSliders() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Remove the transparency slider ...
    if (objMapConfiguration.TransparencySliderDiv) { objMapConfiguration.TransparencySliderDiv.slider('destroy'); }

    // Remove the scale range slider ...
    if (objMapConfiguration.ScaleRangeSliderDiv) { objMapConfiguration.ScaleRangeSliderDiv.slider('destroy'); }
}

// **************************************************************************
// FUNCTION: CreateTransparencySliderValueDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.CreateTransparencySliderValueDiv = function CreateTransparencySliderValueDiv(e, ui) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Create the slider value div ...
    objMapConfiguration.TransparencySliderValueDiv = $('<div class="map_config_transparency_slider_value_div"></div>');

    // Create the span ...
    objMapConfiguration.TransparencySliderValueSpan = $('<span class="map_config_transparency_slider_value_span">' + objMapConfiguration.MapServiceDisplayInEditMode.Transparency + '%</span>');

    // Add it to the div ...
    objMapConfiguration.TransparencySliderValueDiv.append(objMapConfiguration.TransparencySliderValueSpan);

    // Get the slider handle ...
    var objHandle = $(objMapConfiguration.TransparencySliderDiv.find('.ui-slider-handle'));

    // Add the value div to the handle div ...
    objHandle.append(objMapConfiguration.TransparencySliderValueDiv);

    // Position the slider popup ...
    TrimbleMap.Configuration.Shared.PositionSliderPopup($(ui.handle), objMapConfiguration.TransparencySliderValueDiv);
}

// **************************************************************************
// FUNCTION: TransparencySliderSlided
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.TransparencySliderSlided = function TransparencySliderSlided(e, ui) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Set the value on the map service display ...
    objMapConfiguration.MapController.SetMapServiceDisplayTransparency(objMapConfiguration.MapServiceDisplayInEditMode, ui.value);

    // When we have a value span ...
    if (objMapConfiguration.TransparencySliderValueSpan) {

        // Upadte the percentage displayed ...
        objMapConfiguration.TransparencySliderValueSpan.text(objMapConfiguration.MapServiceDisplayInEditMode.Transparency + '%');

        // Position the slider popup ...
        TrimbleMap.Configuration.Shared.PositionSliderPopup($(ui.handle), objMapConfiguration.TransparencySliderValueDiv);
    }
}

// **************************************************************************
// FUNCTION: RemoveTransparencySliderValueDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.RemoveTransparencySliderValueDiv = function RemoveTransparencySliderValueDiv() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Remove the slider value div ...
    objMapConfiguration.TransparencySliderValueDiv.remove();

    // Set to have no value div and span ...
    objMapConfiguration.TransparencySliderValueDiv = null;
    objMapConfiguration.TransparencySliderValueSpan = null;
}

// **************************************************************************
// FUNCTION: CreateScaleRangeSliderValueDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.CreateScaleRangeSliderValueDiv = function CreateScaleRangeSliderValueDiv(e, ui) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Create the slider value div ...
    objMapConfiguration.ScaleRangeSliderValueDiv = $('<div class="map_config_scale_range_slider_value_div"></div>');

    // Create the span ...
    objMapConfiguration.ScaleRangeSliderValueSpan = $('<span class="map_config_scale_range_slider_value_span">Level: ' + ui.value + ', Scale: 1:' + objMapConfiguration.MapController.GetLevelScale(ui.value) + '</span>');

    // Add it to the div ...
    objMapConfiguration.ScaleRangeSliderValueDiv.append(objMapConfiguration.ScaleRangeSliderValueSpan);

    // Get the slider handle ...
    var objHandle = $(ui.handle);

    // Add the value div to the handle div ...
    objHandle.append(objMapConfiguration.ScaleRangeSliderValueDiv);

    // Position the slider popup ...
    TrimbleMap.Configuration.Shared.PositionSliderPopup($(ui.handle), objMapConfiguration.ScaleRangeSliderValueDiv);
}


// **************************************************************************
// FUNCTION: RemoveScaleRangeSliderValueDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.RemoveScaleRangeSliderValueDiv = function RemoveScaleRangeSliderValueDiv(e, ui) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Remove the slider value div ...
    objMapConfiguration.ScaleRangeSliderValueDiv.remove();

    // Set to have no value div and span ...
    objMapConfiguration.ScaleRangeSliderValueDiv = null;
    objMapConfiguration.ScaleRangeSliderValueSpan = null;
}

// **************************************************************************
// FUNCTION: ScaleRangeSliderSlided
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.ScaleRangeSliderSlided = function ScaleRangeSliderSlided(e, ui) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Set the scale range text ...
    objMapConfiguration.ScaleRangeSliderValueSpan.text('Level: ' + ui.value + ', Scale: 1:' + objMapConfiguration.MapController.GetLevelScale(ui.value));

    // Get the new level's scale ...
    var decScale = objMapConfiguration.MapController.GetLevelScale(ui.value);

    // When the min scale handle is being moved ..
    if ($(ui.handle).hasClass('map_configuration_min_scale')) {

        // Set the min scale ...
        objMapConfiguration.MapController.SetMapServiceDisplayScaleRange(objMapConfiguration.MapServiceDisplayInEditMode, decScale, objMapConfiguration.MapServiceDisplayInEditMode.MaxScale);

    } else {

        // Set the max scale ...
        objMapConfiguration.MapController.SetMapServiceDisplayScaleRange(objMapConfiguration.MapServiceDisplayInEditMode, objMapConfiguration.MapServiceDisplayInEditMode.MinScale, decScale);
    }

    // Position the slider popup ...
    TrimbleMap.Configuration.Shared.PositionSliderPopup($(ui.handle), objMapConfiguration.ScaleRangeSliderValueDiv);
}

// **************************************************************************
// FUNCTION: OnScalesChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.OnScalesChanged = function OnScalesChanged(arrScaleLevels) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    alert('scale levels changed:' + $.map(arrScaleLevels, function (o, i) { return o.scale; }).toString());
}

// **************************************************************************
// FUNCTION: OnScaleChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.OnScaleChanged = function OnScaleChanged(decScale) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // When we are indicating the currenty scale on one of the map service display edit panels ...
    if (objMapConfiguration.CurrentScaleDiv) {

        // Position the current scale indicator ...
        objMapConfiguration.CurrentScaleDiv.css('inset-inline-start', objMapConfiguration.ComputeScalePercentage(decScale) + '%');
    }
}

// **************************************************************************
// FUNCTION: MapNameUnfocus
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.MapNameUnfocus = function MapNameUnfocus(e) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Get the map name from the textbox ...
    objMapConfiguration.MapController.CurrentMap.MapName = objMapConfiguration.MapNameTextBox.val();

    // Populate the maps drop down ...
    objMapConfiguration.PopulateMapName();

    // Hide the name textbox ...
    objMapConfiguration.MapNameTextBox.hide();
    objMapConfiguration.MapNameEditIcon.show();

    // Show the name span ...
    objMapConfiguration.MapNameSpan.show();
}

// **************************************************************************
// FUNCTION: AttachMapServiceDraggableEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.AttachMapServiceDraggableEventHandlers = function AttachMapServiceDraggableEventHandlers() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // When not readonly ...
    if (objMapConfiguration.Editable) {

        // Get the divs for the maps services ...
        var arrMapServiceDivs = objMapConfiguration.MapServicesDiv.children();

        // Loop through all the map services ...
        for (var intMapServiceDiv = 0; intMapServiceDiv < arrMapServiceDivs.length; intMapServiceDiv++) {

            // Get the map service div ...
            var objMapServiceDiv = $(arrMapServiceDivs[intMapServiceDiv]);

            // Make the element draggable that will revert back to its original position when released ...
            objMapServiceDiv.draggable({
                revert: 'invalid',
                connectToSortable: objMapConfiguration.MapServiceDisplaysDiv,
                helper: function (objEventObject) {

                    // Start with the element being grabbed as the map services div ... 
                    var objMapServiceDisplayDiv = $(objEventObject.currentTarget);

                    // When it does not have the map_config_mapservicedisplay_container_div class ...
                    if (!objMapServiceDisplayDiv.hasClass('map_config_mapservice_div')) {

                        // Get the DOM element up the tree that have the class ...
                        objMapServiceDisplayDiv = $(objMapServiceDisplayDiv.closest('.map_config_mapservice_div'));
                    }

                    // Clone the map services div ...
                    var objClone = objMapServiceDisplayDiv.clone();

                    // Add the map_config_mapservice_div_force_hover css class ...
                    objClone.addClass('map_config_mapservice_div_force_hover');

                    // Return the clone ...
                    return objClone;

                }, start: function (event, ui) {

                    // Get the currently dragged map service div ...
                    objMapConfiguration.CurrentlyDraggedMapServiceDiv = $(event.currentTarget);

                    // Add the map_config_mapservice_div_force_hover css class ...
                    objMapConfiguration.CurrentlyDraggedMapServiceDiv.addClass('map_config_mapservice_div_force_hover');

                }, stop: function (event, ui) {

                    // Remove the map_config_mapservice_div_force_hover css class ...
                    objMapConfiguration.CurrentlyDraggedMapServiceDiv.removeClass('map_config_mapservice_div_force_hover');

                    // Set it back to null ...
                    objMapConfiguration.CurrentlyDraggedMapServiceDiv = null;
                }
            });
        }
    }
}

// **************************************************************************
// FUNCTION: DetachMapServiceDraggableEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.DetachMapServiceDraggableEventHandlers = function DetachMapServiceDraggableEventHandlers() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // When not readonly ...
    if (objMapConfiguration.Editable) {

        // Get the divs for the maps services ...
        var arrMapServiceDivs = objMapConfiguration.MapServicesDiv.children();

        // Loop through all the map services ...
        for (var intMapServiceDiv = 0; intMapServiceDiv < arrMapServiceDivs.length; intMapServiceDiv++) {

            // Get the map service div ...
            var objMapServiceDiv = $(arrMapServiceDivs[intMapServiceDiv]);

            // Remove the draggable functionality from the map service div ...
            objMapServiceDiv.draggable('destroy');
        }
    }
}

// **************************************************************************
// FUNCTION: MapServicesDivMouseDown
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.MapServicesDivMouseDown = function MapServicesDivMouseDown(e) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Get the target element ...
    var objTarget = $(e.target);

    // Get the map service div inside which objTarget is (if any) ...
    var objMapServiceDiv = SD.DOM.GetElementOrParentWithClass(objTarget, 'map_config_mapservice_div');

    // When found to be inside a map service div ...
    if (objMapServiceDiv) {

        // Hide the scrollbars ...
        objMapConfiguration.UpdateScrollbars(false);
    }
}

// **************************************************************************
// FUNCTION: MapServicesDivMouseUp
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.MapServicesDivMouseUp = function MapServicesDivMouseUp() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Show the scrollbars (if it should be visible) ...
    objMapConfiguration.UpdateScrollbars();
}

// **************************************************************************
// FUNCTION: MapServiceDisplaysReceive
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.MapServiceDisplaysReceive = function MapServiceDisplaysReceive(event, ui, objSortableDOMElement) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Add the map service to the map ...
    objMapConfiguration.AddDroppedMapServiceDisplay(ui.item, objSortableDOMElement);

    return false;
}

// **************************************************************************
// FUNCTION: AddDroppedMapServiceDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.AddDroppedMapServiceDisplay = function AddDroppedMapServiceDisplay(objDraggedElement, objSortableDOMElement) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    var decMaximumExtent = 999999999.999999999;

    // Set to skip the update ...
    objMapConfiguration.SkipUpdateMapServiceDisplayOrder = true;

    // Get the index where the item has been dropped ...
    var intDropIndex = $(objSortableDOMElement).data().uiSortable.currentItem.index();

    // Get the map service id ...
    var strMapServiceID = objDraggedElement.attr('MapServiceID');

    // Get the map service ...
    let objMapService = objMapConfiguration.MapController.GetMapService(strMapServiceID);

    // Set to add after the end of the list of map service displays ...
    var intMapServiceDisplayIndex = 0;

    // When the first map service we are adding or when the spatial reference is the same as all the already added services ...
    if ((objMapConfiguration.MapController.CurrentMap.MapServiceDisplays.length == 0) || (objMapConfiguration.MapController.CurrentMap.SpatialReferenceID == objMapService.SpatialReference)) {

        // When dropped on a sortable ...
        if (typeof objSortableDOMElement != 'undefined') {

            // Get the index in the map service display list where the map service has been dropped ...
            intMapServiceDisplayIndex = objMapConfiguration.MapController.CurrentMap.MapServiceDisplays.length - intDropIndex;
        }

        // Add the map service to the map ...
        var objDeferred = objMapConfiguration.MapController.AddMapServiceToMap(objMapService, objMapConfiguration.MapController.CurrentMap, intMapServiceDisplayIndex);

        // Populate the spatial reference name ...
        objMapConfiguration.PopulateSpatialReferenceName();

        //Only populate the coordinate system display drop down if the warning image is not displayed
        if (objMapConfiguration.CoordinateSystemDisplayValueDiv.find('.projection_warning_image').length == 0) {
            objMapConfiguration.PopulateCoordinateSystemDisplayDropDown(objMapConfiguration.CoordinateSystemDisplayDropDown);
        }

        // Attach a success handler to the deferred which will be called when the layer(s) has been instantiated ...
        objDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Get the map service display for the map service we've just added ...
            var objMapServiceDisplay = objMapConfiguration.MapController.CurrentMap.MapServiceDisplays[intMapServiceDisplayIndex];

            var objMapServiceInitialExtent = objMapConfiguration.MapController.GetInitialExtentForMapServiceDisplay(objMapServiceDisplay);

            if (objMapServiceInitialExtent.xmax > decMaximumExtent || objMapServiceInitialExtent.xmin > decMaximumExtent || objMapServiceInitialExtent.ymax > decMaximumExtent || objMapServiceInitialExtent.ymin > decMaximumExtent) {

                objMapConfiguration.MapController.RemoveMapServiceDisplayFromMap(objMapServiceDisplay, objMapConfiguration.MapController.CurrentMap)

                // Remove the invalid map service element from the div
                setTimeout(function () { objMapConfiguration.MapServiceDisplaysDiv.find('[MapServiceDisplayID="' + objMapServiceDisplay.MapServiceDisplayID + '"]').remove(); }, 0);

                // Remove the map service display edit panel when visible ...
                objMapConfiguration.RemoveMapServiceDisplayEditPanel();

                // Populate the map service displays, map services and the spatial reference name ...
                objMapConfiguration.PopulateMapServiceDisplays();
                objMapConfiguration.PopulateMapServices();
                objMapConfiguration.PopulateSpatialReferenceName();
                objMapConfiguration.PopulateCoordinateSystemDisplayDropDown(objMapConfiguration.CoordinateSystemDisplayDropDown);

                var strTitle = SD.Translation.Shared.GetTranslation('Map.Configuration.js', 'CannotAddMapServiceTitle');
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Configuration.js', 'InvalidMapExtent');

                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

            } else {

                //Zoom to the extent of WMS is not possible as the javascript api does not provide the extent of the data but rather the entire web map service
                if (objMapService.MapServiceType != TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                    // When this is the first map service added to the list ...
                    var blnSetInitialExtent = (objMapConfiguration.MapController.CurrentMap.MapServiceDisplays.length == 1);

                    // Set the initial extend to be the default extend of the map service ...
                    objMapConfiguration.ZoomToDefaultMapServiceExtent(objMapService, objMapServiceDisplay, blnSetInitialExtent);
                } else if (objMapConfiguration.MapController.CurrentMap.MapServiceDisplays.length == 1) {
                    // Set the extent of the map to be the current extent
                    var objDeferred = objMapConfiguration.MapController.SetMapExtent(objMapConfiguration.MapController.GetMapExtent());

                    // When the extent changed
                    objDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {
                        // Set the initial extent
                        objMapConfiguration.SetInitialExtent(objMapConfiguration.MapController.GetMapExtent());
                    }));
                }

                // Update the lists in another thread ...
                setTimeout(function () {

                    // Populate the map service displays and map services ...
                    objMapConfiguration.PopulateMapServiceDisplays();

                    // Populate the map services ...
                    objMapConfiguration.PopulateMapServices();

                }, 0);

            }

        }));

    } else {

        // Remove the dropped element ...
        setTimeout(function () { objMapConfiguration.MapServiceDisplaysDiv.find('[MapServiceID="' + strMapServiceID + '"]').remove(); }, 0);

        // Get the message translations ...

        // Cannot add map service
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Configuration.js', 'CannotAddMapServiceTitle');

        // The coordinate system of the map service do not match the <br />coordinate system of the map services already in the map 
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Configuration.js', 'CannotAddMapServiceMessage');

        // Notify that the initial extent has been set ...
        TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
    }
}

// **************************************************************************
// FUNCTION: ZoomToDefaultMapServiceExtent
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.ZoomToDefaultMapServiceExtent = function ZoomToDefaultMapServiceExtent(objMapService, objMapServiceDisplay, blnSetInitialExtent) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Get the initial extent of the map service ...
    var objMapServiceInitialExtent = objMapConfiguration.MapController.GetInitialExtentForMapServiceDisplay(objMapServiceDisplay);

    // Set the extent of the map to the initial extent of the map service ...
    var objDeferred = objMapConfiguration.MapController.SetMapExtent(objMapServiceInitialExtent);

    // When the extent changed ...
    objDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

        // When we are to set the initial extent ...
        if (blnSetInitialExtent) {

            // Set the initial extent ...
            objMapConfiguration.SetInitialExtent(objMapConfiguration.MapController.EsriMap.extent);
        }
    }));
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.CreateElements = function CreateElements() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;


    // * The container div ...

    // Create the container div in which the interface will live ...
    objMapConfiguration.ContainerDiv = $('<div class="map_config_container_div"></div>');

    // Add the map_config_editmode class when in edit mode ...
    if (objMapConfiguration.Editable) { objMapConfiguration.ContainerDiv.addClass('map_config_editmode'); }

    // * Map Settings Container div ...

    // Create a container div for the settings ...
    objMapConfiguration.MapSettingsContainerDiv = $('<div class="map_config_map_settings_container_div"></div>');

    // Add it to the container div ...
    objMapConfiguration.ContainerDiv.append(objMapConfiguration.MapSettingsContainerDiv);

    // Create the div in which to place the span and text box (when shown) for the map name ...
    objMapConfiguration.MapNameDiv = $('<div class="map_config_map_name_div"></div>');

    // Add it to the container div ...
    objMapConfiguration.MapSettingsContainerDiv.append(objMapConfiguration.MapNameDiv);


    // * Map Service Displays Container div ...

    // Create a div for the list of map services in the map currently being configured ...
    objMapConfiguration.MapServiceDisplaysContainerDiv = $('<div class="map_config_mapservicedisplayscontainer_div"></div>');

    // Add it to the container div ...
    objMapConfiguration.ContainerDiv.append(objMapConfiguration.MapServiceDisplaysContainerDiv);

    // Disable selection ...
    objMapConfiguration.MapServiceDisplaysContainerDiv.disableSelection();


    // * Map Name Span and configure icon ...

    // Add the "Map:" span ...
    objMapConfiguration.MapNameDiv.append('<div class="map_config_map_labels_span">Map:</div>&nbsp;');


    // Create the span for the map name ...
    objMapConfiguration.MapNameSpan = $('<span class="map_config_map_name_span"></span>');

    // Add it to the div ...
    objMapConfiguration.MapNameDiv.append(objMapConfiguration.MapNameSpan);

    // Create the textbox for editing the map name ...  
    objMapConfiguration.MapNameTextBox = $('<input type="textbox" class="map_config_map_name_textbox"></input>');

    // Add it to the div ...
    objMapConfiguration.MapNameDiv.append(objMapConfiguration.MapNameTextBox);

    // Create the name edit button ...
    objMapConfiguration.MapNameEditIcon = $('<div class="map_name_edit_div" title="Edit map name"></div>');

    // Add it to the map name div (when not readonly) ...
    if (objMapConfiguration.Editable) { objMapConfiguration.MapNameDiv.append(objMapConfiguration.MapNameEditIcon); }

    // Add the spacer div bewlow the map name ...
    objMapConfiguration.MapNameDiv.append('<div class="map_config_map_name_extent_spacer"></div>');

    // Create the spatial reference div ...
    objMapConfiguration.SpatialReferenceDiv = $('<div class="map_config_spatial_reference_div"></div>&nbsp;');

    // Add it to the container ...
    objMapConfiguration.MapSettingsContainerDiv.append(objMapConfiguration.SpatialReferenceDiv);

    // Add the 'Coordinate System' text ...
    objMapConfiguration.SpatialReferenceDiv.append('<div class="map_config_map_labels_span">Coordinate System:</div>&nbsp;');

    // Create the spatial reference span ...
    objMapConfiguration.MapSpatialReferenceSpan = $('<span class="map_config_spatial_reference_span"></span>');

    // Add it to the spatial reference div ...
    objMapConfiguration.SpatialReferenceDiv.append(objMapConfiguration.MapSpatialReferenceSpan);

    // Add the spacer div bewlow the map name ...
    objMapConfiguration.SpatialReferenceDiv.append('<div class="map_config_map_name_extent_spacer"></div>');

    // Create the spatial reference div 
    objMapConfiguration.SpatialReferenceDisplayDiv = $('<div class="map_config_spatial_reference_display_div"></div>');

    // Add it to the container
    objMapConfiguration.MapSettingsContainerDiv.append(objMapConfiguration.SpatialReferenceDisplayDiv);

    // Add the 'Coordinate System Display' text 
    objMapConfiguration.SpatialReferenceDisplayDiv.append('<div class="map_config_map_labels_span">Status bar coordinates in:</div>');

    // Add it to the spatial reference display div
    objMapConfiguration.SpatialReferenceDisplayDiv.append(objMapConfiguration.MapSpatialReferenceDisplaySpan);

    // Add the spacer div bewlow the map name ...
    objMapConfiguration.SpatialReferenceDisplayDiv.append('<div class="map_config_map_name_extent_spacer"></div>');

    // Create the coordinate system div
    objMapConfiguration.CoordinateSystemDisplayValueDiv = $('<div>').attr('class', 'measure_right_column_max_width_div');

    // Add to the drop down container div
    objMapConfiguration.SpatialReferenceDisplayDiv.append(objMapConfiguration.CoordinateSystemDisplayValueDiv)

    // When in edit mode, make it selectable
    if (objMapConfiguration.Editable) {

        // Create the coordinate system drop down 
        objMapConfiguration.CoordinateSystemDisplayDropDown = $('<select>').attr('class', 'drop_down');

    } else {

        //Create the coordinate system drop down
        objMapConfiguration.CoordinateSystemDisplayDropDown = $('<select disabled>').attr('class', 'drop_down');
    }

    //Add the drop down to the Div
    objMapConfiguration.CoordinateSystemDisplayValueDiv.append(objMapConfiguration.CoordinateSystemDisplayDropDown)


    // "Go to" extent ...
    objMapConfiguration.GoToExtentSpan = $('<a class="map-link" title="Click to go to the initial extent">Go to</a>');
    // Disable the extent
    objMapConfiguration.GoToExtentSpan.attr("disabled", "disabled");

    // Create the Use Current Extent Span ...
    objMapConfiguration.UseCurrentExtentSpan = $('<a class="map-link" title="Click to use the current extent as the initial extent">Use current extent</a>');
    // Disable the Use Current extent
    objMapConfiguration.UseCurrentExtentSpan.attr("disabled", "disabled");

    // Add the "Initial Extent:" span ...
    objMapConfiguration.MapSettingsContainerDiv.append('<div class="map_config_map_name_extent_spacer"></div>');
    objMapConfiguration.MapSettingsContainerDiv.append('<span class="map_config_map_labels_span">Initial Extent:</span>&nbsp;');

    // Add the goto span ...
    objMapConfiguration.MapSettingsContainerDiv.append(objMapConfiguration.GoToExtentSpan);

    // Add the use current extent span ...
    if (objMapConfiguration.Editable) {
        objMapConfiguration.MapSettingsContainerDiv.append('<span class="map_config_map_labels_span">,</span>&nbsp;');
        objMapConfiguration.MapSettingsContainerDiv.append(objMapConfiguration.UseCurrentExtentSpan);
    }
    objMapConfiguration.MapSettingsContainerDiv.append('<br />');

    // Add the configure icon here ...

    // * "Map Services in map" span ...

    // Create and add the span to the map services container div ...
    objMapConfiguration.MapServiceDisplaysContainerDiv.append('<span class="map_config_map_services_in_map_span">Map Services in Map:</span><div class="map_config_heading_spacer_div"></div>');

    // * Map Service Displays div ...

    // Create the scrollable container div ...
    objMapConfiguration.ScrollableMapServiceDisplaysDiv = $('<div></div>');

    // Add it to the container div ...
    objMapConfiguration.MapServiceDisplaysContainerDiv.append(objMapConfiguration.ScrollableMapServiceDisplaysDiv);

    // Create a div for the list of map services in the map currently being configured ...
    objMapConfiguration.MapServiceDisplaysDiv = $('<div class="map_config_mapservicedisplays_div"></div>');

    // Add it to the container div ...
    objMapConfiguration.ScrollableMapServiceDisplaysDiv.append(objMapConfiguration.MapServiceDisplaysDiv);

    // Disable selection ...
    objMapConfiguration.MapServiceDisplaysDiv.disableSelection();


    // * Map Services container div ...

    // Create the map services container div ...
    objMapConfiguration.MapServicesContainerDiv = $('<div class="map_config_mapservices_container_div"></div>');

    // Disable selection ...
    objMapConfiguration.MapServicesContainerDiv.disableSelection();

    // Add it to the container div ...
    objMapConfiguration.ContainerDiv.append(objMapConfiguration.MapServicesContainerDiv);

    // * "Available Map Services" span ...

    // Create and add the span to the map services container div ...
    objMapConfiguration.MapServicesContainerDiv.append('<span class="map_config_available_map_services_span">Available Map Services:</span><div class="map_config_heading_spacer_div"></div>');


    // * Map Services div ...

    // Create the map services div ...
    objMapConfiguration.MapServicesScrollableDiv = $('<div IsScroller="true" style="overflow:hidden"></div>');

    // Add it to the map services container div ...
    objMapConfiguration.MapServicesContainerDiv.append(objMapConfiguration.MapServicesScrollableDiv);

    // Create the map services div ...
    objMapConfiguration.MapServicesDiv = $('<div class="map_config_mapservices_div"></div>');

    // Add it to the scrollable div ...
    objMapConfiguration.MapServicesScrollableDiv.append(objMapConfiguration.MapServicesDiv);
}

// **************************************************************************
// FUNCTION: Populate
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.Populate = function Populate() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Populate the maps drop down ...
    objMapConfiguration.PopulateMapName();

    // Populate the spatial reference name ...
    objMapConfiguration.PopulateSpatialReferenceName();

    // Populate the coordinate system drop down
    objMapConfiguration.PopulateCoordinateSystemDisplayDropDown(objMapConfiguration.CoordinateSystemDisplayDropDown);

    // Populate the map service displays ...
    objMapConfiguration.PopulateMapServiceDisplays();

    // Populate the map services ...
    objMapConfiguration.PopulateMapServices();
}

// **************************************************************************
// FUNCTION: PopulateMapName
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.PopulateMapName = function PopulateMapName() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Set the name in the span and the textbox ...
    objMapConfiguration.MapNameSpan.text(objMapConfiguration.MapController.CurrentMap.MapName);
    objMapConfiguration.MapNameTextBox.val(objMapConfiguration.MapController.CurrentMap.MapName);

    // Set the tooltip on the span ...
    objMapConfiguration.MapNameSpan.attr('title', objMapConfiguration.MapController.CurrentMap.MapName + ' (click to edit name)');
}

// **************************************************************************
// FUNCTION: PopulateSpatialReferenceName
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.PopulateSpatialReferenceName = function PopulateSpatialReferenceName() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Populate the spatial reference name ...
    objMapConfiguration.MapSpatialReferenceSpan.text(objMapConfiguration.MapController.GetSpatialReferenceName());

    if (objMapConfiguration.MapSpatialReferenceSpan[0].innerText) {
        // Enable the extent links
        objMapConfiguration.GoToExtentSpan.removeAttr("disabled");
        objMapConfiguration.UseCurrentExtentSpan.removeAttr("disabled");
    } else {
        // Disable the extent links
        objMapConfiguration.GoToExtentSpan.attr("disabled", "disabled");
        objMapConfiguration.UseCurrentExtentSpan.attr("disabled", "disabled");
    }
}

// **************************************************************************
// FUNCTION: PopulateCoordinateSystemDisplayDropDown
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.PopulateCoordinateSystemDisplayDropDown = function PopulateCoordinateSystemDisplayDropDown(objCoordinateSystemDisplayDropDown) {

    // Get the map configuration instance
    let objMapConfiguration = this;

    if (objMapConfiguration.MapController.CurrentMap.MapServiceDisplays.length > 0) {

        // Hide the drop down
        objMapConfiguration.CoordinateSystemDisplayValueDiv[0].hidden = false;

        //only populate if the list is not already populated
        if (objCoordinateSystemDisplayDropDown[0].length < objMapConfiguration.MapController.State.SpatialReferences.length - 1) {

            // For each spatial refernce in the list
            $.each(objMapConfiguration.MapController.State.SpatialReferences, function (intSpatialReference, objSpatialReference) {

                if (objSpatialReference.SpatialReferenceID != SD.Guid.Shared.Empty()) {

                    objCoordinateSystemDisplayDropDown.append('<option value="' + objSpatialReference.SpatialReferenceID + '">' + objSpatialReference.Name + '</option>');

                }

            });
        }

        // Change the coordinate system drop down to the value in the db else set the default
        if (objMapConfiguration.MapController.CurrentMap.CoordinatesDisplaySpatialReference != SD.Guid.Shared.Empty()) {
            $(objCoordinateSystemDisplayDropDown).val(objMapConfiguration.MapController.CurrentMap.CoordinatesDisplaySpatialReference);
        }
        else {
            $(objCoordinateSystemDisplayDropDown).val(objMapConfiguration.MapController.CurrentMap.SpatialReferenceID);
            //set the selected spatial reference
            objMapConfiguration.MapController.CurrentMap.CoordinatesDisplaySpatialReference = objMapConfiguration.MapController.CurrentMap.SpatialReferenceID;
        }
    } else {
        // Hide the drop down
        objMapConfiguration.CoordinateSystemDisplayValueDiv[0].hidden = true;
    }

}

// **************************************************************************
// FUNCTION: CoordinateSystemDisplayDropDownChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.CoordinateSystemDisplayDropDownChanged = function CoordinateSystemDisplayDropDownChanged(e) {

    // Get the map configuration instance
    let objMapConfiguration = this;

    if (objMapConfiguration.Editable) {

        let guidCurrentSpatialReference = objMapConfiguration.MapController.DetermineMapSpatialReferenceID(objMapConfiguration.MapController.CurrentMap);
        let guidSelectedSpatialReference = objMapConfiguration.CoordinateSystemDisplayDropDown.val();

        //set the selected spatial reference
        objMapConfiguration.MapController.CurrentMap.CoordinatesDisplaySpatialReference = guidSelectedSpatialReference;

        // Get the visible extent of the map in screen coordinates 
        let objVisibleMapExtentInScreenCoordinates = objMapConfiguration.MapController.GetVisibleMapExtentInScreenCoordinates();

        // Get the visible map extent in map coordinates 
        let objVisibleMapExtentInMapUnits = objMapConfiguration.MapController.GetVisibleMapExtent(objVisibleMapExtentInScreenCoordinates);
        let objTestPoint = objVisibleMapExtentInMapUnits.getCenter();

        let objGeoTransformation = objMapConfiguration.MapController.GetGeoTransformation(guidCurrentSpatialReference, guidSelectedSpatialReference);

        try {
            // Get the projected test point (client side)
            let objGeometryForCalculation = objMapConfiguration.MapController.ProjectGeometriesClientSide([objTestPoint], guidCurrentSpatialReference, guidSelectedSpatialReference, objGeoTransformation)[0];

            objMapConfiguration.MapController.ProjectGeometries([objTestPoint], guidCurrentSpatialReference, guidSelectedSpatialReference, false).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedCoordinates) {
                // Get the projected test point (server side)
                let objProjectedCoordinate = arrProjectedCoordinates[0];

                // Start with true
                blnClientSideProjectionSupported = true;

                let objToSpatialReference = objMapConfiguration.MapController.GetSpatialReference(guidSelectedSpatialReference);

                // Round the coordinates to the number of decimal places of the coordinate system
                let objRoundedProjectedTestPointGeometryService = {
                    x: SD.Number.RoundTo(objProjectedCoordinate.x, objToSpatialReference.DecimalPlaces),
                    y: SD.Number.RoundTo(objProjectedCoordinate.y, objToSpatialReference.DecimalPlaces)
                }

                // Round the coordinates to the number of decimal places of the coordinate system
                let objRoundedProjectedTestPointClientSide = {
                    x: SD.Number.RoundTo(objGeometryForCalculation.x, objToSpatialReference.DecimalPlaces),
                    y: SD.Number.RoundTo(objGeometryForCalculation.y, objToSpatialReference.DecimalPlaces)
                }

                if (objToSpatialReference.SpatialReferenceType === TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC) {
                    // When not the same result
                    if (Math.abs(Math.abs(objRoundedProjectedTestPointGeometryService.x) - Math.abs(objRoundedProjectedTestPointClientSide.x)) > TrimbleMap.enumSpatialReferenceType.COORDINATESDISPLAYGEOGRAPHICTOLERANCE || Math.abs(Math.abs(objRoundedProjectedTestPointGeometryService.y) - Math.abs(objRoundedProjectedTestPointClientSide.y)) > TrimbleMap.enumSpatialReferenceType.COORDINATESDISPLAYGEOGRAPHICTOLERANCE) {
                        // Set to false
                        blnClientSideProjectionSupported = false;
                    }
                }
                else {
                    // When not the same result
                    if (Math.abs(Math.abs(objRoundedProjectedTestPointGeometryService.x) - Math.abs(objRoundedProjectedTestPointClientSide.x)) > TrimbleMap.enumSpatialReferenceType.COORDINATESDISPLAYPROJECTEDTOLERANCE || Math.abs(Math.abs(objRoundedProjectedTestPointGeometryService.y) - Math.abs(objRoundedProjectedTestPointClientSide.y)) > TrimbleMap.enumSpatialReferenceType.COORDINATESDISPLAYPROJECTEDTOLERANCE) {
                        // Set to false
                        blnClientSideProjectionSupported = false;
                    }
                }

                if (blnClientSideProjectionSupported) {
                    objMapConfiguration.CoordinateSystemDisplayValueDiv.find('.projection_warning_image').remove();
                }
                else {
                    if (!objMapConfiguration.CoordinateSystemDisplayValueDiv.find('.projection_warning_image').length > 0) {
                        // Create the load failed icon 
                        let objLoadFailureIcon = $('<div class="projection_warning_image"></div>');

                        // Create a cell for the icon 
                        let objLoadFailureIconCell = $('<td></td>');

                        // Add the icon to the cell 
                        objLoadFailureIconCell.append(objLoadFailureIcon);

                        // Add it to the div
                        objMapConfiguration.CoordinateSystemDisplayValueDiv.append(objLoadFailureIcon);

                        //To prevent the user from saving
                        objMapConfiguration.MapController.CurrentMap.CoordinatesDisplaySpatialReference = SD.Guid.Shared.Empty();

                        let strUnableToLoadLayer = SD.Translation.Shared.GetTranslation('Map.Configuration.js', 'UnableToReproject');

                        // Add the tooltip ...
                        objLoadFailureIcon.attr('title', strUnableToLoadLayer);
                    }
                }
            }));
        } catch (objError) {
            // When not supported by proj4js ...
            if (typeof objError.NotSupportedByProj4js != 'undefined' && objError.NotSupportedByProj4js && !objMapConfiguration.CoordinateSystemDisplayValueDiv.find('.projection_warning_image').length > 0) {

                // Create the load failed icon 
                let objLoadFailureIcon = $('<div class="projection_warning_image"></div>');

                // Create a cell for the icon 
                let objLoadFailureIconCell = $('<td></td>');

                // Add the icon to the cell 
                objLoadFailureIconCell.append(objLoadFailureIcon);

                // Add it to the div
                objMapConfiguration.CoordinateSystemDisplayValueDiv.append(objLoadFailureIcon);

                //To prevent the user from saving
                objMapConfiguration.MapController.CurrentMap.CoordinatesDisplaySpatialReference = SD.Guid.Shared.Empty();

                let strUnableToLoadLayer = SD.Translation.Shared.GetTranslation('Map.Configuration.js', 'UnableToReproject');

                // Add the tooltip ...
                objLoadFailureIcon.attr('title', strUnableToLoadLayer);
            }
        }
    }
}

// **************************************************************************
// FUNCTION: PopulateMapServiceDisplays
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.PopulateMapServiceDisplays = function PopulateMapServiceDisplays() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Remove the map service display panel (if visible) ...
    objMapConfiguration.RemoveMapServiceDisplayEditPanel();

    // Clear the map service displays div ...
    objMapConfiguration.MapServiceDisplaysDiv.empty();

    // Loop through all the map service displays for the currently selected map ...
    for (var intMapServiceDisplay = objMapConfiguration.MapController.CurrentMap.MapServiceDisplays.length - 1; intMapServiceDisplay >= 0; intMapServiceDisplay--) {

        // Get the map service display ...
        var objMapServiceDisplay = objMapConfiguration.MapController.CurrentMap.MapServiceDisplays[intMapServiceDisplay];

        // Create the map service display div ...
        var objMapServiceDisplayDiv = objMapConfiguration.CreateMapServiceDisplayDiv(objMapServiceDisplay);

        // Add it to the div ...
        objMapConfiguration.MapServiceDisplaysDiv.append(objMapServiceDisplayDiv);
    }

    // Disable selection on the elements ...
    objMapConfiguration.MapServiceDisplaysDiv.disableSelection();
}

// **************************************************************************
// FUNCTION: CreateMapServiceDisplayDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.CreateMapServiceDisplayDiv = function CreateMapServiceDisplayDiv(objMapServiceDisplay) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Get the map service ...
    var objMapService = objMapConfiguration.MapController.GetMapService(objMapServiceDisplay.MapServiceID);

    // Create the container div ...
    var objMapServiceDisplayContainerDiv = $('<div class="map_config_mapservicedisplay_container_div" MapServiceDisplayID = "' + objMapServiceDisplay.MapServiceDisplayID + '"></div>');

    // Create a div for the map service display ...
    var objMapServiceDisplayDiv = $('<div class="map_config_mapservicedisplay_div" MapServiceDisplayID = "' + objMapServiceDisplay.MapServiceDisplayID + '"></div>');

    // Add it to the container  ...
    objMapServiceDisplayContainerDiv.append(objMapServiceDisplayDiv);

    // Create a div for the map service display ...
    var objMapServiceDisplayTable = $('<table cellpadding="0px" cellspacing="0px" border="0"></table>');

    // Add it to the div ...
    objMapServiceDisplayDiv.append(objMapServiceDisplayTable);

    // Create a new row ...
    var objMapServiceDisplayRow = $('<tr></tr>');

    // Add it to the table ...
    objMapServiceDisplayTable.append(objMapServiceDisplayRow);

    // Set the text div css class to use when not failed ...
    var strTestCssClass = 'map_config_mapservicedisplay_text_div';

    // When not all the layers were loaded succesfully ...
    if (objMapConfiguration.MapController.GetMapServiceDisplayLoadedStatus(objMapServiceDisplay).FailedLayers.length > 0) {

        // Create the load failed icon ...
        var objLoadFailureIcon = $('<div class="configuration_load_failed_icon"></div>');

        // Create a cell for the icon ...
        var objLoadFailureIconCell = $('<td></td>');

        // Add the icon to the cell ...
        objLoadFailureIconCell.append(objLoadFailureIcon);

        // Add it to the div ...
        objMapServiceDisplayRow.append(objLoadFailureIconCell);

        // Get the translation ...
        // Problems loading map service. The data might not be displayed in the map and any interaction with the map might not return any results for this map service.
        var strUnableToLoadLayer = SD.Translation.Shared.GetTranslation('Map.Legend.js', 'ProblemsLoadingMapService');

        // Add the tooltip ...
        objLoadFailureIcon.attr('title', strUnableToLoadLayer);

        // Set the text css class ...
        strTestCssClass = 'map_config_mapservicedisplay_text_failed_div';
    }

    // Create the map service display name span ...
    var objMapServiceDisplayNameSpanCell = $('<td valign="middle"><div class="' + strTestCssClass + '"><span class="map_config_mapservicedisplay_span">' + objMapService.MapServiceName + '</span></div></td>');

    // Add it to the div ...
    objMapServiceDisplayRow.append(objMapServiceDisplayNameSpanCell);

    // Create the divs for the edit and remove icons ...
    var objEditIconCell = $('<td valign="middle"><div class="map_config_mapservicedisplay_edit_div " title="Edit Properties"></div></td>');
    var objRemoveIconCell = $('<td valign="middle"><div class="map_config_mapservicedisplay_remove_div" title="Remove from map"></div></td>');

    // When not readonly ...
    if (objMapConfiguration.Editable) {

        // Add it to the div for the map service display ...
        objMapServiceDisplayRow.append(objEditIconCell);
        objMapServiceDisplayRow.append(objRemoveIconCell);
    }

    return objMapServiceDisplayContainerDiv;
}

// **************************************************************************
// FUNCTION: PopulateMapServices
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.PopulateMapServices = function PopulateMapServices() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Detach the draggable event handlers when attached ...
    if (objMapConfiguration.EventHandlersAttached) { objMapConfiguration.DetachMapServiceDraggableEventHandlers(); }

    // Clear the map services div ...
    objMapConfiguration.MapServicesDiv.empty();

    // Loop through all the map services ...
    for (var intMapService = 0; intMapService < objMapConfiguration.MapController.State.MapServices.length; intMapService++) {

        // Get the map service ...
        var objMapService = objMapConfiguration.MapController.State.MapServices[intMapService];

        // Start with not found ...
        var blnFound = false;

        // Loop through all the map service displays ...
        $.each(objMapConfiguration.MapController.CurrentMap.MapServiceDisplays, function (intMapServiceDisplay, objMapServiceDisplay) {

            // Test if the map servuice if is found ...
            if (objMapServiceDisplay.MapServiceID == objMapService.MapServiceID) {

                // Set to be found ...
                blnFound = true;
            }
        });

        // When not found ...
        if (!blnFound) {

            // Create the map service display div ...
            var objMapServiceDiv = objMapConfiguration.CreateMapServiceDiv(objMapService);

            // Add it to the div ...
            objMapConfiguration.MapServicesDiv.append(objMapServiceDiv);

            // Disable selection on it ...
            objMapServiceDiv.disableSelection();
        }
    }

    // Re-attach the draggable event handlers when it should be ...
    if (objMapConfiguration.EventHandlersAttached) {
        objMapConfiguration.AttachMapServiceDraggableEventHandlers();
        //Update scroll bars also needs to be added again because the draggable divs were removed
        objMapConfiguration.UpdateScrollbars();
    }
}

// **************************************************************************
// FUNCTION: CreateMapServiceDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.CreateMapServiceDiv = function CreateMapServiceDiv(objMapService) {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Create a div for the map service display ...
    var objMapServiceDiv = $('<div class="map_config_mapservice_div" MapServiceID = "' + objMapService.MapServiceID + '"></div>');

    // Create the map service display name span ...
    var objMapServiceNameSpan = $('<span class="map_config_mapservice_span">' + objMapService.MapServiceName + '</span>');

    // Add it to the div ...
    objMapServiceDiv.append(objMapServiceNameSpan);

    return objMapServiceDiv;
}

// **************************************************************************
// FUNCTION: PositionElements
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.PositionElements = function PositionElements() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // Get the sidebar height ...
    var intSidebarHeight = objMapConfiguration.Sidebar.GetHeight();

    // Get the width that the sidebar should be ...
    var intSidebarWidth = objMapConfiguration.Sidebar.GetWidth();

    // Get the map settings size ...
    var objMapSettingsSize = SD.HtmlFunctions.Shared.MeasureElement(objMapConfiguration.MapSettingsContainerDiv.clone().css('width', intSidebarWidth + 'px'));

    // Compute the height available for each panel ...
    var intPanelHeight = (intSidebarHeight - (objMapSettingsSize.height + 20) - 20) / 2;

    // Set the height of the maps service display container div ...
    objMapConfiguration.MapServiceDisplaysContainerDiv.height((intPanelHeight - 20) + 'px');

    // Set the height of the maps service display div (this is needed to ensure the drop zone covers the whole panel) ...
    objMapConfiguration.ScrollableMapServiceDisplaysDiv.css('height', (intPanelHeight - 40) + 'px');
    objMapConfiguration.ScrollableMapServiceDisplaysDiv.css('min-height', (intPanelHeight - 40) + 'px');
    objMapConfiguration.MapServiceDisplaysDiv.css('height', (intPanelHeight - 40) + 'px');

    // Set the height of the maps service container div ...
    objMapConfiguration.MapServicesContainerDiv.height((intPanelHeight - 20) + 'px');

    // Compute the height available for the available map services list ...
    var intMapServicesHeight = objMapConfiguration.MapServicesContainerDiv.position().top + objMapConfiguration.MapServicesContainerDiv.innerHeight() - objMapConfiguration.MapServicesScrollableDiv.position().top - 10;

    // Set the height ...
    objMapConfiguration.MapServicesScrollableDiv.css('height', intMapServicesHeight);

    // Refresh the nice-scrollbar on the available map services list ...
    if (objMapConfiguration.MapServicesNiceScroll) { objMapConfiguration.MapServicesNiceScroll.resize(); }

    // Refresh the nice-scrollbar on the map service displays list ...
    if (objMapConfiguration.ScrollableMapServiceDisplaysDivNiceScroll) { objMapConfiguration.ScrollableMapServiceDisplaysDivNiceScroll.resize(); }
}

// **************************************************************************
// FUNCTION: UpdateMapServiceDisplayOrder
// USAGE:    
// **************************************************************************
TrimbleMap.Configuration.UpdateMapServiceDisplayOrder = function UpdateMapServiceDisplayOrder() {

    // Get the map configuration instance ...
    var objMapConfiguration = this;

    // When we are not to skip updating ...
    if (!objMapConfiguration.SkipUpdateMapServiceDisplayOrder) {

        // Get all the map service display divs ...
        var arrMapServiceDisplayDivs = objMapConfiguration.MapServiceDisplaysDiv.find('.map_config_mapservicedisplay_container_div');

        // Create a new array for the map service displays...
        var arrMapServiceDisplays = new Array();

        // Loop through all the map service display divs ...
        for (var intMapServiceDisplayDiv = arrMapServiceDisplayDivs.length - 1; intMapServiceDisplayDiv >= 0; intMapServiceDisplayDiv--) {

            // Get the map service display ...
            var objMapServiceDisplayDiv = $(arrMapServiceDisplayDivs[intMapServiceDisplayDiv]);

            // Get the map service display id ...
            var strMapServiceDisplayID = objMapServiceDisplayDiv.attr("MapServiceDisplayID");

            // Get the map service display id ...
            var objMapServiceDisplay = objMapConfiguration.MapController.GetMapServiceDisplay(strMapServiceDisplayID);

            // Add to the map service display ids ...
            arrMapServiceDisplays.push(objMapServiceDisplay);
        }

        // Re-order map service displays ...
        objMapConfiguration.MapController.ReOrderMapServiceDisplays(objMapConfiguration.MapController.CurrentMap, arrMapServiceDisplays, true);
    }

    // Set to not skip next time ...
    objMapConfiguration.SkipUpdateMapServiceDisplayOrder = false;
}

TrimbleMap.Configuration.Shared.PositionSliderPopup = function PositionSliderPopup(objHandleDiv, objSliderPopupDiv) {

    // Ensure it is visible ...
    objSliderPopupDiv.show();

    // Compute half the handle div's width ...
    var decHalfHandleWidth = (parseInt(objHandleDiv.outerWidth(), 10) / 2);

    // Compute the cebnter of the slider handle ...
    var decHandleCenterX = objHandleDiv.position().left + decHalfHandleWidth;

    // Get the slider div ...
    var objSliderDiv = objHandleDiv.parent();

    // Compute the right x of the slider ...
    var decSliderRightX = parseInt(objSliderDiv.outerWidth(), 10);

    // Compute the distance of the handle to the slider right x ...
    var decDistance = decSliderRightX - decHandleCenterX;

    // Compute half the width of the popup div ...
    var decHalfPopupWidth = parseInt(objSliderPopupDiv.outerWidth(), 10) / 2;

    // Declare a variable for the css property value ...
    var decLeft;

    // When there are more than half the space left ...
    if (decDistance > decHalfPopupWidth) {

        // Compute the left to be centered on the handle ...
        decLeft = -decHalfPopupWidth + decHalfHandleWidth;

    } else {

        // Compute the left to be pushed to the left of the center of the handle with the distance that is short ...
        decLeft = -decHalfPopupWidth + decHalfHandleWidth - (decHalfPopupWidth - decDistance);
    }

    // Set the left css property of the slider div ...
    objSliderPopupDiv.css('inset-inline-start', decLeft.toString());
}


// Create the ConvertPolygonToBlock namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ConvertPolygonToBlock = {};

// **************************************************************************
// FUNCTION: ConvertToBlocks
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.ConvertToBlocks = function ConvertToBlocks(objShape,
                                                                     decGridBlockSideLengthMultiplier,
                                                                     decGridBlockSideLengthDivider,
                                                                     decTolerance,
                                                                     blnMergeTouchingParts) {

    // Multiply the ordinates by the inverse of the side length ...
    TrimbleMap.ConvertPolygonToBlock.MultiplyOrdinates(objShape.Parts, decGridBlockSideLengthDivider, decGridBlockSideLengthMultiplier);

    // Snap the coordinates to the grid ...
    TrimbleMap.ConvertPolygonToBlock.SnapTo1x1Grid(objShape.Parts, decTolerance / decGridBlockSideLengthMultiplier * decGridBlockSideLengthDivider);

    // Loop through all the exterior parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // Convert the coordinates to scans ...
        objPart.Scans = Scanlines.ConvertToScanLines(TrimbleMap.ConvertPolygonToBlock.CoordinatesInArrayFormat(objPart.Coordinates));
    });

    // When we are to merge the touching parts ...
    if (blnMergeTouchingParts) {

        // Join all the converted exterior parts that touch ...
        TrimbleMap.ConvertPolygonToBlock.JoinPartsThatTouch(objShape.Parts);
    }

    // Loop through all the exterior parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && (objPart.InteriorParts != null) && (objPart.InteriorParts.length > 0)) {

            // Loop through all the interior parts ...
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Convert the part points to scans ...
                objInteriorPart.Scans = Scanlines.ConvertToScanLines(TrimbleMap.ConvertPolygonToBlock.CoordinatesInArrayFormat(objInteriorPart.Coordinates, true));
            });

            // When we are to merge the touching parts ...
            if (blnMergeTouchingParts) {

                // Join all the converted interior parts that touch ...
                TrimbleMap.ConvertPolygonToBlock.JoinPartsThatTouch(objPart.InteriorParts);
            }
        }
    });

    // Remove the interior partss that touches their exterior parts ...
    TrimbleMap.ConvertPolygonToBlock.RemoveInteriorPartsThatTouchesExteriorParts(objShape);

    // Loop through all the exterior parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // Convert the scans to a polygon ...
        TrimbleMap.ConvertPolygonToBlock.ConvertPartScansToPolygon(objPart);

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && (objPart.InteriorParts != null) && (objPart.InteriorParts.length > 0)) {

            // Loop through all the interior parts ...
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Convert the scans to a polygon ...
                TrimbleMap.ConvertPolygonToBlock.ConvertPartScansToPolygon(objInteriorPart);
            });
        }
    });

    // Multiply the ordinates by the the side length ...
    TrimbleMap.ConvertPolygonToBlock.MultiplyOrdinates(objShape.Parts, decGridBlockSideLengthMultiplier, decGridBlockSideLengthDivider);

    // Remove the closing vertices ...
    TrimbleMap.ConvertPolygonToBlock.RemoveClosingVertices(objShape.Parts);

    return objShape;
}

// **************************************************************************
// FUNCTION: CoordinatesInArrayFormat
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.CoordinatesInArrayFormat = function CoordinatesInArrayFormat(arrCoordinates, blnReverseCoordinates) {

    // Create a new array ...
    var arrConvertedCoordinates = [];

    // Default blnReverseCoordinates to false ...
    if ((typeof blnReverseCoordinates == 'undefined') || (blnReverseCoordinates == null)) { blnReverseCoordinates = false; }

    // Loop through all the coordinates ...
    $.each(arrCoordinates, function(intCoordinate, objCoordinate) {

        // Add the coordiante ...
        arrConvertedCoordinates.push([objCoordinate.X, objCoordinate.Y]);
    });

    // Reverse the coordinates when needed ...
    if (blnReverseCoordinates) { arrConvertedCoordinates.reverse(); }

    return arrConvertedCoordinates;
}

// **************************************************************************
// FUNCTION: ConvertPartScansToPolygon
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.ConvertPartScansToPolygon = function ConvertPartScansToPolygon(objPart) {

    // Get the scans ...
    var objScans = objPart.Scans;

    // Convert the scans to a polygon ...
    var arrConvertedParts = ScanConversion.ConvertScansToPolygon(objScans);

    // Create the converted part coordinate array ...
    var arrConvertedCoordinates = [];

    // When the conversion resulted in any parts ...
    if (arrConvertedParts.length > 0) {

        // * Because we never expect to get a self intersecting polygon as input, we only ever expect to get at most one part back here ...

        // Get the part points of the first part ...
        var arrRingPoints = arrConvertedParts[0].Vertices;

        // Loop through all the ring points ...
        for (var intCoordinate = 0; intCoordinate < arrRingPoints.length; intCoordinate++) {

            // Get the ring point ...
            var objRingPoint = arrRingPoints[intCoordinate];

            // Replace the ring point (x,y) with an array containing the ring points ordinates [x, y] ...
            arrConvertedCoordinates.push({ X: objRingPoint.x, Y: objRingPoint.y });
        }
    }

    // Replace the coordinates of the part ...
    objPart.Coordinates = arrConvertedCoordinates;

    // Remove the scans property 
    delete objPart.Scans;
}

// **************************************************************************
// FUNCTION: RemoveInteriorPartsThatTouchesExteriorParts
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.RemoveInteriorPartsThatTouchesExteriorParts = function RemoveInteriorPartsThatTouchesExteriorParts(objShape) {

    // Loop through all the exterior parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && (objPart.InteriorParts != null) && (objPart.InteriorParts.length > 0)) {

            // Create an array for teh interior parts to keep ...
            var arrInteriorPartsToKeep = [];

            // Loop through all the interior parts ...
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // When the scans of the two parts touches ...
                if (TrimbleMap.ConvertPolygonToBlock.ScansTouch(objInteriorPart.Scans, objPart.Scans, true)) {

                    // Remove the scans of the interior part from the exterior part ...
                    objPart.Scans = Scanlines.RemoveScanlines(objPart.Scans, objInteriorPart.Scans);

                } else {

                    // Add it to the array of parts to keep ...
                    arrInteriorPartsToKeep.push(objInteriorPart);
                }
            });

            // When we have parts to keep ...
            if (arrInteriorPartsToKeep.length > 0) {

                // Add it to the part ...
                objPart.InteriorParts = arrInteriorPartsToKeep;

            } else {

                // Clear the internal parts if it exists on the part ...
                if (typeof objPart.InteriorParts != 'undefined') { delete objPart.InteriorParts; }
            }
        }
    });
}

// **************************************************************************
// FUNCTION: JoinPartsThatTouch
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.JoinPartsThatTouch = function JoinPartsThatTouch(arrParts) {

    // Clone the parts ...
    var arrAllParts = arrParts.slice(0);

    // Clear the parts array ...
    arrParts.splice(0, arrParts.length);

    // While we have more parts to join ...
    while (arrAllParts.length > 0) {

        // Get the first part from the array ...
        var objPart = arrAllParts[0];

        // Remove the first part from the array ...
        arrAllParts.splice(0, 1);

        // Attempt to find a part that touches this part ...
        var intTouchingPart = TrimbleMap.ConvertPolygonToBlock.FindTouchingPartIndex(objPart, arrAllParts);

        // When found ...
        if (intTouchingPart > -1) {

            // Get the touching part ...
            let objTouchingPart = arrAllParts[intTouchingPart];

            // Merge the scans ...
            objPart.Scans = Scanlines.MergeScanlines(objPart.Scans, objTouchingPart.Scans);

            // Merge the part names ...
            objPart.strPartName = objPart.PartName + '/' + objTouchingPart.PartName;

            // When the touching part have interior parts ...
            if ((typeof objTouchingPart.InteriorParts != 'undefined') && objTouchingPart.InteriorParts && (objTouchingPart.InteriorParts.length > 0)) {

                // Create an interior parts array when it does not exist yet ...
                if ((typeof objPart.InteriorParts == 'undefined') || (!objPart.InteriorParts)) { objPart.InteriorParts = []; }

                // Add the touching part's interior parts ...
                objPart.InteriorParts = objPart.InteriorParts.concat(objTouchingPart.InteriorParts);
            }

            // Remove the touching part from all parts ...
            arrAllParts.splice(intTouchingPart, 1);

            // Add the merged part to the list of all parts ...
            arrAllParts.push(objPart);

        } else {

            // Add the part to the output array ...
            arrParts.push(objPart);
        }
    }
}

// **************************************************************************
// FUNCTION: FindTouchingPartIndex
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.FindTouchingPartIndex = function FindTouchingPartIndex(objPart, arrAllParts) {

    // Loop through all the parts ...
    $.each(arrAllParts, function(intPart, objPartToTest) {

        // When the scans touch ...
        if (TrimbleMap.ConvertPolygonToBlock.ScansTouch(objPart.Scans, objPartToTest.Scans, false)) {

            // Return the part index ...
            return intPart;
        }
    });

    return -1;
}

// **************************************************************************
// FUNCTION: GetTouchingPartIndexes
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.GetTouchingPartIndexes = function GetTouchingPartIndexes(dicTouchingIndexes, intPartIndex) {

    // Get the touching indexes
    var arrTouchingIndexes = dicTouchingIndexes[intPartIndex];

    // Create a new array for the touching indexes of the cildren ...
    var arrChildrenTouchingIndexes = [];

    // Loop through all the touching indexes ... 
    for (var intTouching = 0; intTouching < arrTouchingIndexes.length; intTouching++) {

        // Get the touching index ...
        var intTouchingIndex = arrTouchingIndexes[intTouching];

        // When not processed before ...
        if ((intPartIndex != intTouchingIndex) && ($.inArray(intPartIndex, arrChildrenTouchingIndexes)) && (typeof dicTouchingIndexes[intPartIndex] == 'undefined')) {

            // Add the touching indexes of the children ...
            arrChildrenTouchingIndexes = arrChildrenTouchingIndexes.concat(TrimbleMap.ConvertPolygonToBlock.GetTouchingPartIndexes(dicTouchingIndexes, intTouchingIndex));
        }
    }

    // Add the children to the array ...
    arrTouchingIndexes = arrTouchingIndexes.concat(arrChildrenTouchingIndexes);

    // Return a unique list ...
    return TrimbleMap.ConvertPolygonToBlock.UniqueValueArray(arrTouchingIndexes);
}

// **************************************************************************
// FUNCTION: UniqueValueArray
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.UniqueValueArray = function UniqueValueArray(arrValues) {

    // Create an array with the list of unique values to return ...
    var arrUniqueValues = [];

    // Create a new hash table for the values ...
    var dicValues = {};

    // Loop through all the values of the array ...
    for (var intValue = 0; intValue < arrValues.length; intValue++) {

        // Get the value ...
        var objValue = arrValues[intValue];

        // Add to the dictionary when not already there ...
        if (typeof dicValues[objValue] == 'undefined') { dicValues[objValue] = objValue; }
    }

    // Add the keys to the array to return ...
    $.each(dicValues, function (objKey, objValue) { arrUniqueValues.push(objKey); });

    // Return the array ...
    return arrUniqueValues;
}

// **************************************************************************
// FUNCTION: ScansTouch
// USAGE:    Test if the scans overlap
// Still need to improve on this to pick up scans that touch from above or below ...
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.ScansTouch = function ScansTouch(objScans1, objScans2, blnScans1InsideScans2) {

    // When both of the two sets of scans is not empty ...
    if ((objScans1.MinYIndex != null) && (objScans1.MaxYIndex != null) && (objScans2.MinYIndex != null) && (objScans2.MaxYIndex != null)) {

        // Loop through all the scanlines in objScan1 ...
        for (var intY = objScans1.MinYIndex; intY <= objScans1.MaxYIndex; intY++) {

            // Declare variables for the scans ...
            var arrScans1 = null;
            var arrScans2 = null;
            var arrScans2Previous = null;
            var arrScans2Next = null;

            // When the scan is undefined ...
            if (typeof objScans1.Scans[intY] != 'undefined') { arrScans1 = objScans1.Scans[intY]; }
            if (typeof objScans2.Scans[intY] != 'undefined') { arrScans2 = objScans2.Scans[intY]; }

            // When not the first row and we have scans in the previous row in objScans2 ...
            if ((intY - 1 >= objScans2.MinYIndex) && (typeof objScans2.Scans[intY - 1] != 'undefined')) { arrScans2Previous = objScans2.Scans[intY - 1]; }

            // When not the last row and we have scans in the next row in objScans2 ...
            if ((intY + 1 <= objScans2.MaxYIndex) && (typeof objScans2.Scans[intY + 1] != 'undefined')) { arrScans2Next = objScans2.Scans[intY + 1]; }

            // When the scans touch horizontally ...
            if (TrimbleMap.ConvertPolygonToBlock.RowScansTouch(arrScans1, arrScans2, blnScans1InsideScans2)) { return true; }

            // When scans 1 is not inside scans 2 ....
            if (!blnScans1InsideScans2) {

                // When the scans from objScans1 overlap horizontally the scans from the previous row in objScan2 ...
                if (TrimbleMap.ConvertPolygonToBlock.ScanRowsOverlapHorizontally(arrScans1, arrScans2Previous)) { return true; }

                // When the scans from objScans1 overlap horizontally the scans from the next row in objScan2 ...
                if (TrimbleMap.ConvertPolygonToBlock.ScanRowsOverlapHorizontally(arrScans1, arrScans2Next)) { return true; }

            } else {

                // When the scans from the previous row in objScan2 do not completely overlap the scans from objScans1 horizontally  ...
                if (!TrimbleMap.ConvertPolygonToBlock.Scan1RowsCompletelyCoverScan2RowsHorizontally(arrScans2Previous, arrScans1)) { return true; }

                // When the scans from the next row in objScan2 do not completely overlap the scans from objScans1 horizontally  ...
                if (!TrimbleMap.ConvertPolygonToBlock.Scan1RowsCompletelyCoverScan2RowsHorizontally(arrScans2Next, arrScans1)) { return true; }
            }
        }
    }

    // The scans do not overlap ...
    return false;
}

// **************************************************************************
// FUNCTION: RowScansTouch
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.RowScansTouch = function RowScansTouch(arrScans1, arrScans2, blnTouchesFromTheInside) {

    // When both scans had lines for the y ...
    if ((arrScans1 != null) && (arrScans2 != null)) {

        // Loop though all the scans in objScan1 ...                
        for (var intScan1 = 0; intScan1 < arrScans1.length; intScan1++) {

            // Get the scan ...
            var objScan1 = arrScans1[intScan1];

            // Loop though all the scans in objScan2 ...                
            for (var intScan2 = 0; intScan2 < arrScans2.length; intScan2++) {

                // Get the scan ...
                var objScan2 = arrScans2[intScan2];

                // When we are to test for touching from the inside ...
                if (blnTouchesFromTheInside) {

                    // Return true when the scans touches from the inside ...
                    if ((objScan1.xmin == objScan2.xmin) || (objScan1.xmax == objScan2.xmax)) { return true; }

                } else {

                    // Return true when the scans touches on the outside ...
                    if ((objScan1.xmin == objScan2.xmax + 1) || (objScan1.xmax + 1 == objScan2.xmin)) { return true; }
                }
            }
        }
    }

    // No overlap detected ...
    return false;
}

// **************************************************************************
// FUNCTION: ScanRowsOverlapHorizontally
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.ScanRowsOverlapHorizontally = function ScanRowsOverlapHorizontally(arrScans1, arrScans2) {

    // When both scans had lines for the y ...
    if ((arrScans1 != null) && (arrScans2 != null)) {

        // Loop though all the scans in objScan1 ...                
        for (var intScan1 = 0; intScan1 < arrScans1.length; intScan1++) {

            // Get the scan ...
            var objScan1 = arrScans1[intScan1];

            // Loop though all the scans in objScan2 ...                
            for (var intScan2 = 0; intScan2 < arrScans2.length; intScan2++) {

                // Get the scan ...
                var objScan2 = arrScans2[intScan2];

                // When the scans overlap ...
                if ((objScan1.xmin <= objScan2.xmax + 1) && (objScan1.xmax + 1 >= objScan2.xmin)) {

                    // They touch ...
                    return true;
                }
            }
        }
    }

    // No overlap detected ...
    return false;
}

// **************************************************************************
// FUNCTION: Scan1RowsCompletelyCoverScan2RowsHorizontally
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.Scan1RowsCompletelyCoverScan2RowsHorizontally = function Scan1RowsCompletelyCoverScan2RowsHorizontally(arrScans1, arrScans2) {

    // When both scans had lines for the y ...
    if ((arrScans1 != null) && (arrScans2 != null)) {

        // Loop though all the scans in objScan1 ...                
        for (var intScan1 = 0; intScan1 < arrScans1.length; intScan1++) {

            // Get the scan ...
            var objScan1 = arrScans1[intScan1];

            // Loop though all the scans in objScan2 ...                
            for (var intScan2 = 0; intScan2 < arrScans2.length; intScan2++) {

                // Get the scan ...
                var objScan2 = arrScans2[intScan2];

                // When scan 1 completely covers scan 2 ...
                if ((objScan1.xmin < objScan2.xmin) && (objScan1.xmax > objScan2.xmax)) {

                    // They touch ...
                    return true;
                }
            }
        }
    }

    // No overlap detected ...
    return false;
}

// **************************************************************************
// FUNCTION: RemoveClosingVertices
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.RemoveClosingVertices = function RemoveClosingVertices(arrParts) {

    // Loop through all the exterior parts ...
    $.each(arrParts, function (intPart, objPart) {

        // When the part has at least 2 coordinates ...
        if (objPart.Coordinates.length >= 2) {

            // Get the first and last part points ...
            var objFirstPoint = objPart.Coordinates[0];
            var objLastPoint = objPart.Coordinates[objPart.Coordinates.length - 1];

            // When the first and last part points match ...
            if ((objFirstPoint.X == objLastPoint.Y) && (objFirstPoint.Y == objLastPoint.Y)) {

                // Remove the last part point ...
                objPart.Coordinates.splice(objPart.Coordinates.length - 1, 1);
            }

            // When the part has interior parts ...
            if ((typeof objPart.InteriorParts != 'undefined') && (objPart.InteriorParts != null) && (objPart.InteriorParts.length > 0)) {

                // Remove the closing vertices from the interior parts ...
                TrimbleMap.ConvertPolygonToBlock.RemoveClosingVertices(objPart.InteriorParts);
            }
        }
    });
}

// **************************************************************************
// FUNCTION: SnapTo1x1Grid
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.SnapTo1x1Grid = function SnapTo1x1Grid(arrParts, decTolerance) {

    // Loop through all the exterior parts ...
    $.each(arrParts, function (intPart, objPart) {

        // Loop through all the part points ...
        for (var intCoordinate = 0; intCoordinate < objPart.Coordinates.length; intCoordinate++) {

            // Get the part point ...
            var objCoordinate = objPart.Coordinates[intCoordinate];

            // Compute the remainder after dividing by the side length ...
            var decHorizontalRemainder = Math.abs(objCoordinate.X % 1.0);
            var decVerticalRemainder = Math.abs(objCoordinate.Y % 1.0);

            // We are to snap up when closer to 1 than 0 ...
            var blnHorizontallySnapUp = (decHorizontalRemainder > 0.5);
            var blnVerticallySnapUp = (decVerticalRemainder > 0.5);

            // Compute the distance to the grid (horizontally and vertically) ...
            let decHorizontalDistance = Math.abs(blnHorizontallySnapUp ? 1.0 - decHorizontalRemainder : decHorizontalRemainder);
            let decVerticalDistance = Math.abs(blnVerticallySnapUp ? 1.0 - decVerticalRemainder : decVerticalRemainder);

            // Determine whether or not to snap ...
            var blnSnapHorizontally = (decHorizontalDistance < decTolerance);
            var blnSnapVerically = (decVerticalDistance < decTolerance);

            // When we are to snap horizontally ...
            if (blnSnapHorizontally) {

                // When X is positive ...
                if (objCoordinate.X >= 0) {

                    // Snap X up or down ...
                    objCoordinate.X = blnHorizontallySnapUp ? objCoordinate.X + decHorizontalDistance : objCoordinate.X - decHorizontalDistance;

                } else {

                    // Snap X up or down ...
                    objCoordinate.X = blnHorizontallySnapUp ? objCoordinate.X - decHorizontalDistance : objCoordinate.X + decHorizontalDistance;
                }
            }

            // When we are to snap vertically ...
            if (blnSnapVerically) {

                // When Y is positive ...
                if (objCoordinate.Y >= 0) {

                    // Snap Y up or down ...
                    objCoordinate.Y = blnVerticallySnapUp ? objCoordinate.Y + decVerticalDistance : objCoordinate.Y - decVerticalDistance;

                } else {

                    // Snap Y up or down ...
                    objCoordinate.Y = blnVerticallySnapUp ? objCoordinate.Y - decVerticalDistance : objCoordinate.Y + decVerticalDistance;
                }
            }
        }

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && (objPart.InteriorParts != null) && (objPart.InteriorParts.length > 0)) {
        
            // Snap teh coordinates of the interior part to the grid ...
            TrimbleMap.ConvertPolygonToBlock.SnapTo1x1Grid(objPart.InteriorParts, decTolerance);
        }
    });
}

// **************************************************************************
// FUNCTION: MultiplyOrdinates
// USAGE:    
// **************************************************************************
TrimbleMap.ConvertPolygonToBlock.MultiplyOrdinates = function MultiplyOrdinates(arrParts,
                                                                         decGridBlockSideLengthMultiplier,
                                                                         decGridBlockSideLengthDivider) {

    // Loop through all the exterior parts ...
    $.each(arrParts, function (intPart, objPart) {

        // Loop through all the part points ...
        for (var intCoordinate = 0; intCoordinate < objPart.Coordinates.length; intCoordinate++) {

            // Get the part point ...
            var objCoordinate = objPart.Coordinates[intCoordinate];

            // Multiply the point's x and y by the multiplication factor ...
            objCoordinate.X = objCoordinate.X * decGridBlockSideLengthMultiplier / decGridBlockSideLengthDivider;
            objCoordinate.Y = objCoordinate.Y * decGridBlockSideLengthMultiplier / decGridBlockSideLengthDivider;
        }

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && (objPart.InteriorParts != null) && (objPart.InteriorParts.length > 0)) {

            // Multiply the ordinates of the interior parts ...
            TrimbleMap.ConvertPolygonToBlock.MultiplyOrdinates(objPart.InteriorParts, decGridBlockSideLengthMultiplier, decGridBlockSideLengthDivider);
        }
    });
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Diagnostics = {};
TrimbleMap.Diagnostics.Shared = {};
TrimbleMap.Diagnostics.Shared.SIDEBAR_TAB_WIDTH = 300;

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.CreateInstance = function CreateInstance(objMapController, objSidebar, blnVisible, strTabName, strTabCaption) {

    // Create the instance ...
    var objDiagnostics = {
        MapController: objMapController,
        Sidebar: objSidebar,
        Visible: false,
        DiagnosticsDiv: null,
        DiagnosticsTabItem: null,
        TabName: strTabName,
        TabCaption: strTabCaption,
        MessagesDiv: null,
        ScrollableContainerDiv: null,
        ScrollableInnerContainerDiv: null,
        NoMessagesDiv: null,
        NiceScroll: null,

        HandleDiagnosticMessageLoggedProxy: function (objDiagnosticMessage) { objDiagnostics.HandleDiagnosticMessageLogged(objDiagnosticMessage); },
        DiagnosticsDivClickedProxy: function (e) { objDiagnostics.DiagnosticsDivClicked(e); },

        CreateElements: TrimbleMap.Diagnostics.CreateElements,
        ActivateTab: TrimbleMap.Diagnostics.ActivateTab,
        DeActivateTab: TrimbleMap.Diagnostics.DeActivateTab,
        ResizeTab: TrimbleMap.Diagnostics.ResizeTab,
        AttachEventHandlers: TrimbleMap.Diagnostics.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Diagnostics.DetachEventHandlers,
        AddMessage: TrimbleMap.Diagnostics.AddMessage,
        HandleDiagnosticMessageLogged: TrimbleMap.Diagnostics.HandleDiagnosticMessageLogged,
        UpdateScrollbar: TrimbleMap.Diagnostics.UpdateScrollbar,
        UpdateNoMessagesDivVisibility: TrimbleMap.Diagnostics.UpdateNoMessagesDivVisibility,
        DiagnosticsDivClicked: TrimbleMap.Diagnostics.DiagnosticsDivClicked,
        Show: TrimbleMap.Diagnostics.Show,
        Hide: TrimbleMap.Diagnostics.Hide
    };

    // Create the menu icon ...
    objDiagnostics.CreateElements();

    // Create the sidebar tab ...
    objDiagnostics.DiagnosticsTabItem = SD.Sidebar.Shared.CreateTabItem(objDiagnostics.TabName, objDiagnostics.TabCaption,
        TrimbleMap.StandardMap.Shared.enumTabOrder.DIAGNOSTICS,
        function (objTabContainerElement, enTabActivationMethod) { objDiagnostics.ActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement, enTabActivationMethod) { objDiagnostics.DeActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement) { objDiagnostics.ResizeTab(objTabContainerElement); },
        function () { return TrimbleMap.Diagnostics.Shared.SIDEBAR_TAB_WIDTH; });

    // Show the tab when it's to be visible at startup ...
    if (blnVisible) { objDiagnostics.Show(false, false); }

    // Attach the diagnostic message logged callback to 
    // get notification when diagnostic messages are logged ...
    objDiagnostics.MapController.AddNotifyDiagnosticMessageLogged(objDiagnostics.HandleDiagnosticMessageLoggedProxy);

    return objDiagnostics;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
//           blnSelectTab is optional, defaults to true
// **************************************************************************
TrimbleMap.Diagnostics.Show = function Show(blnTriggerNotifyModuleVisibilityChanged, blnSelectTab) {

    // Get the instance ...
    var objDiagnostics = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objDiagnostics.Visible) {

        // Add the tab ...
        objDiagnostics.Sidebar.AddTab(objDiagnostics.DiagnosticsTabItem);

        // When we are to select the tab ...
        if ((typeof blnSelectTab == 'undefined') || (blnSelectTab == null) || blnSelectTab) {

            // Select the tab ...
            objDiagnostics.Sidebar.SelectTab(objDiagnostics.DiagnosticsTabItem);
        }

        // Set to be visible ...
        objDiagnostics.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objDiagnostics.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Diagnostics, true); }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Diagnostics.Hide = function Hide() {

    // Get the instance ...
    var objDiagnostics = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { var blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objDiagnostics.Visible) {

        // Detach all the event handlers (if attached) ...
        objDiagnostics.DetachEventHandlers();

        // Remove the tab ...
        objDiagnostics.Sidebar.RemoveTab(objDiagnostics.DiagnosticsTabItem);

        // Set to not be visible ...
        objDiagnostics.Visible = false;

        // Notify that the module visibility changed to false ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objDiagnostics.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Diagnostics, false); }
    }
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.CreateElements = function CreateElements() {

    // Get the instance ...
    var objDiagnostics = this;

    // Create the div for the tab ...
    objDiagnostics.DiagnosticsDiv = $('<div class="diagnostics_tab_div"></div>');

    // Create the div that will contain all the content (with margins) ...
    var objContainerDiv = $('<div class="diagnostics_container_div"></div>');

    // Add it to the tab div ...
    objDiagnostics.DiagnosticsDiv.append(objContainerDiv);

    // Get the translation for the heading ...

    // Diagnostic Messages
    let strHeading = SD.Translation.Shared.GetTranslation('Map.Diagnostics.js', 'DiagnosticMessagesTitle');

    // Create the heading div ...
    var objHeadingDiv = $('<div class="diagnostics_heading"><span class="diagnostics_heading_span">' + strHeading + '</span></div>');

    // Add it to the container ...
    objContainerDiv.append(objHeadingDiv);

    // Create the div to contain the scrollable div ...
    objDiagnostics.ScrollableContainerDiv = $('<div class="diagnostics_scrollable_container_div"></div>');

    // Add it to the container ...
    objContainerDiv.append(objDiagnostics.ScrollableContainerDiv);

    // Create the div that will be scrolled ...
    objDiagnostics.ScrollableInnerContainerDiv = $('<div class="diagnostics_scrollable_inner_container_div"></div>');

    // Add it to the container div ...
    objDiagnostics.ScrollableContainerDiv.append(objDiagnostics.ScrollableInnerContainerDiv);

    // Create the div that will contain the diagnostic messages ...
    objDiagnostics.MessagesDiv = $('<div class="diagnostics_table_div"></div>');

    // Add it to the inner div ...
    objDiagnostics.ScrollableInnerContainerDiv.append(objDiagnostics.MessagesDiv);

    // Get a translation ...

    // No messages to display  
    var strNoMessages = SD.Translation.Shared.GetTranslation('Map.Diagnostics.js', 'NoMessagesToDisplay');

    // Create the no messages div ...
    objDiagnostics.NoMessagesDiv = $('<div class="diagnostics_no_messages_div">' + strNoMessages + '</div>');

    // Add it to the inner div ...
    objDiagnostics.ScrollableInnerContainerDiv.append(objDiagnostics.NoMessagesDiv);


    // Hide or show the no messages div ...
    objDiagnostics.UpdateNoMessagesDivVisibility();
}

// **************************************************************************
// FUNCTION: DiagnosticsDivClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.DiagnosticsDivClicked = function DiagnosticsDivClicked(e) {

    // Get the instance ...
    var objDiagnostics = this;

    // Get the target element ...
    var objTarget = $(e.target);

    // Get the diagnostic message div clicked on ...
    var objDiagnosticMessageDiv = SD.DOM.GetElementOrParentWithClass(objTarget, 'diagnostics_message_div');

    // When the user clicked on the diagnostic message div ...
    if (objDiagnosticMessageDiv) {

        // Get the message ID ...
        var strDiagnosticMessageID = objDiagnosticMessageDiv.attr('DiagnosticMessageID');

        // Get the diagnostic message ...
        var objDiagnosticMessage = objDiagnostics.MapController.GetDiagnosticMessageByID(strDiagnosticMessageID);

        // Clone the message div ...
        var objMessageDivClone = objDiagnosticMessageDiv.clone();

        // Remove the class ...
        objMessageDivClone.removeClass('diagnostics_message_in_list_div');

        // Create the container div ...
        var objContainerDiv = $('<div class="diagnostic_container_div"></div>');

        // Add the message div clone to it ...
        objContainerDiv.append(objMessageDivClone);

        // Set to not have a request link ...
        var objRequestLink = null;

        // When we have a request url ...
        if ((typeof objDiagnosticMessage.RequestUrl != 'undefined') && (objDiagnosticMessage.RequestUrl) && ((objDiagnosticMessage.RequestUrl).trim() != '')) {

            // Get the link translation ...

            // Recreate Request           
            var strOpenRequestUrl = SD.Translation.Shared.GetTranslation('Map.Diagnostics.js', 'RecreateRequest');

            // Create the link ...
            var objRequestLink = $('<div RequestLink="true"><span class="diagnostics_link_span">' + strOpenRequestUrl + '</span><div>');

            // Add the link to the container ...
            objContainerDiv.append(objRequestLink);

            // Attach a click event handler ...
            objRequestLink.on('click',(function () {

                // Open the request url in a new window ...
                window.open(objDiagnosticMessage.RequestUrl, SD.Translation.Shared.GetTranslation('Map.Diagnostics.js', 'RecreateRequest'));
            }));
        }

        // Create a function to set the max height ...
        var fnSetMaxHeigth = function () {

            // Set the max heigth of the dialog div to be 200 pixels less than the window height ...
            objContainerDiv.css('max-height', parseInt($(window).height()) - 150);
        }

        // Set the max height ...
        fnSetMaxHeigth();

        // Attach the set max height function to the window resize event handler ...
        $(window).resize(fnSetMaxHeigth);

        // Get the translations ...

        // Diagnostic Message     
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Diagnostics.js', 'DiagnosticMessageTitle');

        // OK
        var strOK = SD.Translation.Shared.GetTranslation('Map.Diagnostics.js', 'DiagnosticMessageOk');;

        // Show the message ...
        TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, null, [TrimbleMap.MessageBox.Shared.CreateMessageBoxButton('OK', strOK, function () { $(window).off('resize', fnSetMaxHeigth); if (objRequestLink) { objRequestLink.off('click'); } })], 650, objContainerDiv);
    }
}

// **************************************************************************
// FUNCTION: HandleDiagnosticMessageLogged
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.HandleDiagnosticMessageLogged = function HandleDiagnosticMessageLogged(objDiagnosticMessage) {

    // Get the instance ...
    var objDiagnostics = this;

    // Add the message to the interface ...
    objDiagnostics.AddMessage(objDiagnosticMessage);

    // Set a time out to insert an event at the end of the event queue ...
    setTimeout(function () {

        // When not already visible ...
        if (!objDiagnostics.Visible) {

            // Ensure that tab is visible ...
            objDiagnostics.Show(true, false);
        }

        // Flash the tab ...
        objDiagnostics.Sidebar.FlashTab(objDiagnostics.DiagnosticsTabItem);
    }, 0);
}

// **************************************************************************
// FUNCTION: AddMessage
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.AddMessage = function AddMessage(objDiagnosticMessage) {

    // Get the instance ...
    var objDiagnostics = this;

    // Hide or show the no messages div ...
    objDiagnostics.UpdateNoMessagesDivVisibility();

    // Create a div for the message ...
    var objMessageDiv = $('<div class="diagnostics_message_div diagnostics_message_in_list_div"></div>');

    // Add the diagnostic message id ...
    objMessageDiv.attr('DiagnosticMessageID', objDiagnosticMessage.DiagnosticMessageID);

    // Add the icon indicating the message level ...
    switch (objDiagnosticMessage.MessageLevel) {
        case TrimbleMap.enumDiagnosticMessageLevel.INFORMATION:
            objMessageDiv.append('<div class="diagnostics_information_icon"></div>');
            break;
        case TrimbleMap.enumDiagnosticMessageLevel.CRITICAL:
            objMessageDiv.append('<div class="diagnostics_critical_icon"></div>');
            break;
    }

    // Create a date object from the time stamp ...
    var objTimeStamp = new Date(objDiagnosticMessage.TimeStamp);

    // Build a time stamp string ...
    var strTimeStamp = '[' + SD.String.ZeroPad(String(objTimeStamp.getHours()), 2) + ':' + SD.String.ZeroPad(String(objTimeStamp.getMinutes()), 2) + ':' + SD.String.ZeroPad(String(objTimeStamp.getSeconds()), 2) + '.' + SD.String.ZeroPad(String(objTimeStamp.getMilliseconds()), 3) + ']';

    // Add the time stamp ...
    objMessageDiv.append('<span class="diagnostics_message_normal_text">' + strTimeStamp + '</span>&nbsp;');

    // When we have a title ...
    if ((typeof objDiagnosticMessage.Title != 'undefined') && (objDiagnosticMessage.Title != null) && ((objDiagnosticMessage.Title).trim().length > 0)) {

        // Add the message title ...
        objMessageDiv.append('<span class="diagnostics_message_bold_text">' + objDiagnosticMessage.Title + '</span><br />');
    }

    // Add the message ...
    objMessageDiv.append('<div class="diagnostics_diagnosticmessage_div"><span class="diagnostics_message_italic_text">' + objDiagnosticMessage.Message + '</span></div>');

    // When we have an CrashMessage ...
    if ((typeof objDiagnosticMessage.CrashMessage != 'undefined') && (objDiagnosticMessage.CrashMessage != null) && ((objDiagnosticMessage.CrashMessage).trim().length > 0)) {

        // Add the message error message ...
        objMessageDiv.append('<div class="diagnostics_crashmessage_div"><span class="diagnostics_message_normal_text diagnostics_crashmessage">' + objDiagnosticMessage.CrashMessage + '</span></div>');
    }

    // Get the message divs that are already displayed ...
    var arrMessageDivs = objDiagnostics.MessagesDiv.children();

    // When we have messages already ...
    if (arrMessageDivs.length > 0) {

        // Create a spacer ...
        var objSpacer = $('<div class="template_spacer"></div>');

        // Add it to the messages div before the first message div ...
        objSpacer.insertBefore($(arrMessageDivs[0]));

        // Add the message before the spacer ...
        objMessageDiv.insertBefore(objSpacer);

    } else {

        // Add it to the messages div ...
        objDiagnostics.MessagesDiv.append(objMessageDiv);
    }

    // Update the scrollbar ...
    objDiagnostics.UpdateScrollbar();
}

// **************************************************************************
// FUNCTION: UpdateNoMessagesDivVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.UpdateNoMessagesDivVisibility = function UpdateNoMessagesDivVisibility() {

    // Get the instance ...
    var objDiagnostics = this;

    // When there are messages displayed ...
    if (objDiagnostics.MapController.DiagnosticMessages.length > 0) {

        // Hide the no messgaes div ...
        objDiagnostics.NoMessagesDiv.hide();

    } else {

        // Show the no messgaes div ...
        objDiagnostics.NoMessagesDiv.show();
    }
}

// **************************************************************************
// FUNCTION: ActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.ActivateTab = function ActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objDiagnostics = this;

    // Add the shape div to the tab container element
    objTabContainerElement.append(objDiagnostics.DiagnosticsDiv);

    // Attach the event hanlders ...
    objDiagnostics.AttachEventHandlers();
}

// **************************************************************************
// FUNCTION: DeActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.DeActivateTab = function DeActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objDiagnostics = this;

    // Detach the event handlers
    objDiagnostics.DetachEventHandlers();

    // Remove the shape div from the tab container element ...
    objDiagnostics.DiagnosticsDiv.remove();
}

// **************************************************************************
// FUNCTION: ResizeTab
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.ResizeTab = function ResizeTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objDiagnostics = this;

    // Get the top of the list relative to the tab  ...
    var intTop = parseInt(objDiagnostics.ScrollableContainerDiv.position().top);

    // Get the tab height ...
    var intTabHeight = parseInt(objTabContainerElement.innerHeight());

    // Place some code into the event queue ...
    setTimeout(function () {

        // Set the height of the scrollable container to go to the bottom ...
        objDiagnostics.ScrollableContainerDiv.css('max-height', intTabHeight - intTop - 10);

        // Update the scrollbar ...
        objDiagnostics.UpdateScrollbar();
    }, 0);
}

// **************************************************************************
// FUNCTION: UpdateScrollbar
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.UpdateScrollbar = function UpdateScrollbar() {

    // Get the instance ...
    var objDiagnostics = this;

    // Get the height of the scrollable container ...
    var intMaxHeight = parseInt(objDiagnostics.ScrollableContainerDiv.css('max-height'));

    // Get teh heigth of the content ...
    var intHeight = parseInt(objDiagnostics.ScrollableInnerContainerDiv.height());

    // When we need scrollbar ...
    if ((intHeight > intMaxHeight) && objDiagnostics.EventHandlersAttached) {

        // When we have a scrollbar ...
        if (!objDiagnostics.NiceScroll) {

            // Activate the nice scroll bar on the messages list ...
            objDiagnostics.NiceScroll = objDiagnostics.ScrollableContainerDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });

        } else {

            // Update the scrollbar ...
            objDiagnostics.NiceScroll.resize();
        }

    } else {

        // When we have a scrollbar ...
        if (objDiagnostics.NiceScroll) {

            // De-activate the nice-scrollbar on the messages list ...
            objDiagnostics.NiceScroll.hide();
            objDiagnostics.NiceScroll.remove();
            objDiagnostics.NiceScroll = null;
        }
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.AttachEventHandlers = function AttachEventHandlers() {

    // Get the instance ...
    var objDiagnostics = this;

    // When the event handlers are not attached ...
    if (!objDiagnostics.EventHandlersAttached) {

        // Set the event handlers to be attached ...
        objDiagnostics.EventHandlersAttached = true;

        // Attach the click event handler to DiagnosticsDiv ...
        objDiagnostics.DiagnosticsDiv.click(objDiagnostics.DiagnosticsDivClickedProxy);

        // Update the scrollbar ...
        objDiagnostics.UpdateScrollbar();
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Diagnostics.DetachEventHandlers = function DetachEventHandlers() {

    // Get the instance ...
    var objDiagnostics = this;

    // When the event handlers are attached ...
    if (objDiagnostics.EventHandlersAttached) {

        // Set the event handlers to not be attached ...
        objDiagnostics.EventHandlersAttached = false;

        // Detach the click event handler from DiagnosticsDiv ...
        objDiagnostics.DiagnosticsDiv.off('click', objDiagnostics.DiagnosticsDivClickedProxy);

        // Update the scrollbar ...
        objDiagnostics.UpdateScrollbar();
    }
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the Map.DisplayArea namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.DisplayArea = {};
TrimbleMap.DisplayArea.Shared = {};
TrimbleMap.DisplayArea.Shared.CALCULATION_IN_PROGRESS_TIME_MS = 500;

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.CreateInstance = function CreateInstance(objMapController, objAreaDiv, strLabelText, strCalculationInProgressText, objArea, blnIsVisible, intDefaultAreaUnit, arrAreaUnits) {

    // Create the object that will hold the instance properties ...
    var objDisplayArea = {
        MapController: objMapController,
        AreaDisplayDivContainer: objAreaDiv,
        AreaDisplayDiv: null,
        AreaUnits: arrAreaUnits,
        AreaUnit: (intDefaultAreaUnit >= 0) ? intDefaultAreaUnit : 0,
        Area: objArea,
        LabelText: strLabelText,
        CalculationInProgressText: strCalculationInProgressText,
        AreaDisplaySpan: null,
        AreaPopup: null,
        AreaPopupDiv: null,
        IsVisible: blnIsVisible,
        MaxWidth: null,
        CalculationInProgressIndicatorActive: false,
        CalculationInProgressIndicatorVisible: false,
        CalculationInProgressIndicatorTimer: null,
        OnUnitChangedFunctions: [],

        AreaPopupClickedProxy: function (e) { objDisplayArea.AreaPopupClicked(e); },
        ActivateAreaPopupProxy: function (objPopupContainerDiv) { objDisplayArea.ActivateAreaPopup(objPopupContainerDiv); },
        DeActivateAreaPopupProxy: function (objPopupContainerDiv) { objDisplayArea.DeActivateAreaPopup(objPopupContainerDiv); },

        CreateElements: TrimbleMap.DisplayArea.CreateElements,
        SetMaxWidth: TrimbleMap.DisplayArea.SetMaxWidth,
        UpdateAreaValueSpanMaxWidth: TrimbleMap.DisplayArea.UpdateAreaValueSpanMaxWidth,
        UpdateArea: TrimbleMap.DisplayArea.UpdateArea,
        Show: TrimbleMap.DisplayArea.Show,
        Hide: TrimbleMap.DisplayArea.Hide,
        UpdateAreaDisplaySpanText: TrimbleMap.DisplayArea.UpdateAreaDisplaySpanText,
        AreaDisplayTextAreaOnly: TrimbleMap.DisplayArea.AreaDisplayTextAreaOnly,
        BuildAreaPopup: TrimbleMap.DisplayArea.BuildAreaPopup,
        AreaDisplayText: TrimbleMap.DisplayArea.AreaDisplayText,
        UpdateAreaDisplaySpans: TrimbleMap.DisplayArea.UpdateAreaDisplaySpans,
        ShowCalculationInProgressIndicator: TrimbleMap.DisplayArea.ShowCalculationInProgressIndicator,
        HideCalculationInProgressIndicator: TrimbleMap.DisplayArea.HideCalculationInProgressIndicator,
        ActivateCalculationInProgressIndicator: TrimbleMap.DisplayArea.ActivateCalculationInProgressIndicator,
        DeActivateCalculationInProgressIndicator: TrimbleMap.DisplayArea.DeActivateCalculationInProgressIndicator,
        AreaPopupClicked: TrimbleMap.DisplayArea.AreaPopupClicked,
        ActivateAreaPopup: TrimbleMap.DisplayArea.ActivateAreaPopup,
        DeActivateAreaPopup: TrimbleMap.DisplayArea.DeActivateAreaPopup,
        AttachEventHandlers: TrimbleMap.DisplayArea.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.DisplayArea.DetachEventHandlers,
        AddOnUnitChanged: TrimbleMap.DisplayArea.AddOnUnitChanged,
        RemoveOnUnitChanged: TrimbleMap.DisplayArea.RemoveOnUnitChanged,
        TriggerOnUnitChanged: TrimbleMap.DisplayArea.TriggerOnUnitChanged
    };

    // create the elements
    objDisplayArea.CreateElements();

    return objDisplayArea;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.Show = function Show() {

    // Get the map display area instance ...
    var objDisplayArea = this;

    if (!objDisplayArea.IsVisible) {
        objDisplayArea.AreaDisplayDiv.show();
        objDisplayArea.AttachEventHandlers();
        objDisplayArea.IsVisible = true;
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.Hide = function Hide() {

    // Get the map display area instance ...
    var objDisplayArea = this;

    if (objDisplayArea.IsVisible) {
        objDisplayArea.DetachEventHandlers();
        objDisplayArea.AreaDisplayDiv.hide();
        objDisplayArea.IsVisible = false;
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.AttachEventHandlers = function AttachEventHandlers() {

    // Get the map display area instance ...
    var objDisplayArea = this;

    objDisplayArea.AreaPopup.AttachEventHandlers();
}


// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map display area instance ...
    var objDisplayArea = this;

    objDisplayArea.AreaPopup.DetachEventHandlers();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateElements: Attach the area popup ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.CreateElements = function CreateElements() {

    // Get the map display area instance ...
    var objDisplayArea = this;

    // Create the div ...
    objDisplayArea.AreaDisplayDiv = $('<div class="measurement-value"></div>');

    // Set the visibility according to the initial parameter isVisible
    if (!objDisplayArea.IsVisible) { objDisplayArea.AreaDisplayDiv.hide(); }

    // Append the div ...
    objDisplayArea.AreaDisplayDivContainer.append(objDisplayArea.AreaDisplayDiv);

    // Create a div to contain the area value ...
    objDisplayArea.AreaValueDisplayDiv = $('<div></div>');

    // Add it to the main div ...
    objDisplayArea.AreaDisplayDiv.append(objDisplayArea.AreaValueDisplayDiv);

    // Create the span ...
    objDisplayArea.AreaDisplaySpan = $('<span class="area_span_text"></span>');

    // Add it to the area display div ...
    objDisplayArea.AreaValueDisplayDiv.append(objDisplayArea.AreaDisplaySpan);

    // When we have label text ...
    if ((objDisplayArea.LabelText != null) && (objDisplayArea.LabelText != '')) {

        // Create label text span ...
        objDisplayArea.AreaSpanLabel = $('<span class="area_span_text_bold area_label_span">' + objDisplayArea.LabelText + ':</span>');

        // Append to area span ...
        objDisplayArea.AreaDisplaySpan.append(objDisplayArea.AreaSpanLabel);

        // Add a space ...
        objDisplayArea.AreaDisplaySpan.append('&nbsp;');
    }

    // Create the value span ...
    objDisplayArea.AreaValueSpan = $('<span class="area_span_text area_value_span"></span>');

    // Append to area span ...
    objDisplayArea.AreaDisplaySpan.append(objDisplayArea.AreaValueSpan);

    // Create the span that holds the unit abbreviation ...
    objDisplayArea.AreaSpanUnitAbbreviation = $('<span class="area_span_text_bold area_unit_span"></span>');

    // Append to area span ...
    objDisplayArea.AreaDisplaySpan.append(objDisplayArea.AreaSpanUnitAbbreviation);

    // Create the drop down image ...
    objDisplayArea.DropDownImage = $('<div class="drop_down area_drop_down"></div>');

    // Add the drop down image to the end of the Area display div ...
    objDisplayArea.AreaValueDisplayDiv.append(objDisplayArea.DropDownImage);

    // Create in progress label text span ...
    objDisplayArea.CalculationInProgressAreaSpanLabel = $('<div><span class="area_span_text_italic area_label_span">' + objDisplayArea.CalculationInProgressText + '</span></div>');

    // Hide it ...
    objDisplayArea.CalculationInProgressAreaSpanLabel.hide();

    // Add it to the area span label ...
    objDisplayArea.AreaDisplayDiv.append(objDisplayArea.CalculationInProgressAreaSpanLabel);

    // Create the operation popup control ...
    objDisplayArea.AreaPopup = SD.Popup.CreateInstance(objDisplayArea.AreaDisplayDiv,
        'area popup-downwards',
        'area popup-upwards',
        'area popup-downwards-open',
        'area popup-upwards-open',
        5,
        false,
        SD.Popup.enumPopupBehaviour.AlwaysDown,
        objDisplayArea.ActivateAreaPopupProxy,
        objDisplayArea.DeActivateAreaPopupProxy);

    // Update the area span text ...
    objDisplayArea.UpdateAreaDisplaySpanText();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetMaxWidth
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.SetMaxWidth = function SetMaxWidth(intWidth) {

    // Get the display area instance ...
    var objDisplayArea = this;

    // Set the width property ...
    objDisplayArea.MaxWidth = intWidth;

    // Update the area span max width ...
    objDisplayArea.UpdateAreaValueSpanMaxWidth();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateAreaValueSpanMaxWidth
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.UpdateAreaValueSpanMaxWidth = function UpdateAreaValueSpanMaxWidth() {

    // Get the display area instance ...
    var objDisplayArea = this;

    // When we have a max width set ...
    if (objDisplayArea.MaxWidth != null) {

        // Compute the total width occupied by the other elements ...
        var intTotalOtherContentsWidth = SD.HtmlFunctions.Shared.MeasureElement(objDisplayArea.AreaSpanLabel).width +
            SD.HtmlFunctions.Shared.MeasureElement(objDisplayArea.AreaSpanUnitAbbreviation).width +
            SD.HtmlFunctions.Shared.MeasureElement(objDisplayArea.DropDownImage).width + 30;

        // Compute the remaining width ...
        var intRemainingWidth = objDisplayArea.MaxWidth - intTotalOtherContentsWidth;

        // Set it as the max width ...
        objDisplayArea.AreaValueSpan.css('max-width', intRemainingWidth + 'px');
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateArea
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.UpdateArea = function UpdateArea(objArea) {

    // Get the display area instance ...
    var objDisplayArea = this;

    // Set the area ...
    objDisplayArea.Area = objArea;

    // Update the area span text ...
    objDisplayArea.UpdateAreaDisplaySpanText();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateAreaDisplaySpanText
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.UpdateAreaDisplaySpanText = function UpdateAreaDisplaySpanText() {

    // Get the display area instance ...
    var objDisplayArea = this;

    // When we have units ...
    if (objDisplayArea.AreaUnits.length > 0) {

        // Set the area value in the span ...
        objDisplayArea.UpdateAreaDisplaySpans(objDisplayArea.AreaUnit);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildAreaPopup: Build the area popup ... 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.BuildAreaPopup = function BuildAreaPopup() {

    // Get the display area instance ...
    var objDisplayArea = this;

    // * Build the area popup here ...

    // Create the div ...
    objDisplayArea.AreaPopupDiv = $('<div class="area-popup"></div>');

    // When we have an area ...
    if (objDisplayArea.Area != null) {

        // Create the area units div ...
        var objAreaInUnitsDiv = $('<div></div>');

        // Add it to the popup ...
        objDisplayArea.AreaPopupDiv.append(objAreaInUnitsDiv);

        // Loop through all the area units ...
        for (var intAreaUnit = 0; intAreaUnit < objDisplayArea.AreaUnits.length; intAreaUnit++) {

            // Create a div for the operation item ...
            var objDisplayAreaItemDiv = $('<div class="area-dropdown-item" AreaUnitIndex=' + intAreaUnit + '></div>');

            // Get the area unit object ...
            var objAreaUnit = objDisplayArea.AreaUnits[intAreaUnit];

            // Build a string with the area, unit abbreviation and unit name in brackets ...
            var strArea = objDisplayArea.AreaDisplayText(intAreaUnit) + ' (' + objAreaUnit.Abbreviation + ')';

            // Create a div for the item text ...
            var objItemTextDiv = $('<span>' + strArea + '</span>');

            // Choose the css class depending on whether or not the operation should be checkec or not ...
            var strCssClass = (intAreaUnit == objDisplayArea.AreaUnit) ? 'checked' : 'unchecked';

            // Create a div for the checkbox ...
            var objCheckBoxDiv = $('<div class="' + strCssClass + '"></div>');

            // Add the checkbox ...
            objDisplayAreaItemDiv.append(objCheckBoxDiv);

            // Add the item text ...
            objDisplayAreaItemDiv.append(objItemTextDiv);

            // Add the row to the popup ...
            objAreaInUnitsDiv.append(objDisplayAreaItemDiv);
        }

        // Calculated in
        var strCalculatedInCoordinateSystem = SD.Translation.Shared.GetTranslation('Map.DisplayArea.js', 'CalculatedIn');

        // Create a div for the coordinate system in which the area has been calculated ...
        var objCalculatedInCoordinateSystemDiv = $('<div class="area-message"><span>' + strCalculatedInCoordinateSystem + '</span>&nbsp;<span class="bold">' + objDisplayArea.Area.CoordinateSystemCalculatedIn.Name + '</span></div>');

        // Add it to the popup ...
        objDisplayArea.AreaPopupDiv.append(objCalculatedInCoordinateSystemDiv);

        // When it is not likely that the calculation were accurate ...
        if (!objDisplayArea.Area.CoordinateSystemCalculatedIn.LikelyAccurate) {

            // The calculation might be inaccurate due to the fact that the shape spans multiple UTM Zones
            var strInAccurateMessage = SD.Translation.Shared.GetTranslation('Map.DisplayArea.js', 'CalculationMightBeInaccurate');

            // Add the message ...
            objCalculatedInCoordinateSystemDiv.append('<br /><div class="area-message-inaccurate"><span>' + strInAccurateMessage + '</span></div>');
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AreaPopupClicked: show the area popup ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.AreaPopupClicked = function AreaPopupClicked(e) {

    // Get the display area instance ...
    var objDisplayArea = this;

    // Get the selected element ...
    var objTarget = $(e.target);

    // Get the area unit index ...
    var objAreaUnitIndex = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'AreaUnitIndex');

    // When found ...
    if (objAreaUnitIndex != null) {

        //retrieve the button index that was clicked
        var strAreaUnitIndex = objAreaUnitIndex.attr('AreaUnitIndex');

        //convert the string attribute into an integer
        var intAreaUnitIndex = parseInt(strAreaUnitIndex);

        // When not the currently selected area unit ...
        if ((!isNaN(intAreaUnitIndex)) && intAreaUnitIndex != objDisplayArea.AreaUnit) {

            // Select the area unit that the user clicked on ...
            objDisplayArea.AreaUnit = intAreaUnitIndex;

            // Update the area value on the interface ...
            objDisplayArea.UpdateAreaDisplaySpans(objDisplayArea.AreaUnit);

            //close the popup
            objDisplayArea.AreaPopup.ClosePopup();

            // Trigger the area unit changed event ...
            objDisplayArea.TriggerOnUnitChanged();
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AreaDisplayText: Build the area text ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.AreaDisplayText = function AreaDisplayText(intAreaUnit) {

    // Get the display area instance ...
    var objDisplayArea = this;

    // Convert the area value to a string ...
    var strArea = objDisplayArea.AreaDisplayTextAreaOnly(intAreaUnit);

    // Get the area unit object ...
    var objAreaUnit = objDisplayArea.AreaUnits[intAreaUnit];

    // Append the area unit abbreviation ...
    strArea += ' ' + objAreaUnit.Unit;

    return strArea;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AreaDisplayTextAreaOnly: build the text representing the numeric values for the area
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.AreaDisplayTextAreaOnly = function AreaDisplayTextAreaOnly(intAreaUnit) {

    // Get the display area instance ...
    var objDisplayArea = this;

    // Get the area unit object ...
    var objAreaUnit = objDisplayArea.AreaUnits[intAreaUnit];

    // Convert the area value to the unit ...
    var dblAreaValue = (objDisplayArea.Area != null && objAreaUnit.SpatialReferenceType.toUpperCase() == TrimbleMap.enumSpatialReferenceType.PROJECTED) ? objDisplayArea.Area.AreaInKm2 / objAreaUnit.ConversionFactorToKm2 : (objDisplayArea.Area != null ? objDisplayArea.Area.AreaInDegrees2 / objAreaUnit.ConversionFactorToSquareDegrees : 0);

    // Convert the area value to a string ...
    var strArea = SD.DisplayValue.FromDouble(dblAreaValue, objDisplayArea.MapController.State.GroupSeparator, objDisplayArea.MapController.State.DecimalSeparator, objAreaUnit.DecimalPlaces);

    return strArea;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateAreaDisplaySpans: Build the area text ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.UpdateAreaDisplaySpans = function UpdateAreaDisplaySpans(intAreaUnit) {

    // Get the display area instance ...
    var objDisplayArea = this;

    // Get the area unit object ...
    var objAreaUnit = objDisplayArea.AreaUnits[intAreaUnit];

    // Set the area value ...
    objDisplayArea.AreaValueSpan.text(objDisplayArea.AreaDisplayTextAreaOnly(intAreaUnit));

    // Set the unit abbreviation ...
    objDisplayArea.AreaSpanUnitAbbreviation.text(' ' + objAreaUnit.Abbreviation);

    // Update the area value span max-width ...
    objDisplayArea.UpdateAreaValueSpanMaxWidth();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ActivateAreaPopup: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.ActivateAreaPopup = function ActivateAreaPopup(objPopupContainerDiv) {

    // Get the display area instance ...
    var objDisplayArea = this;

    //create the area pop up
    objDisplayArea.BuildAreaPopup();

    //append the created pop up to the container
    objPopupContainerDiv.append(objDisplayArea.AreaPopupDiv);

    // Attach a click event handler to the popup div ...
    objDisplayArea.AreaPopupDiv.click(objDisplayArea.AreaPopupClickedProxy);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DeActivateAreaPopup: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.DeActivateAreaPopup = function DeActivateAreaPopup(objPopupContainerDiv) {

    // Get the display area instance ...
    var objDisplayArea = this;

    // detach th click event handler on the popup div
    objDisplayArea.AreaPopupDiv.off('click', objDisplayArea.AreaPopupClickedProxy);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ActivateCalculationInProgressIndicator: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.ActivateCalculationInProgressIndicator = function ActivateCalculationInProgressIndicator() {

    // Get the display area instance ...
    var objDisplayArea = this;

    // When not active ...
    if (!objDisplayArea.CalculationInProgressActive) {

        // Set to be active ...
        objDisplayArea.CalculationInProgressActive = true;

        // Set a timer that will display the calculation in progress indicator ... 
        objDisplayArea.CalculationInProgressIndicatorTimer = setTimeout(function () {

            // Clear the timer handle ...
            objDisplayArea.CalculationInProgressIndicatorTimer = null;

            // Show the calculation in progress indicator ...
            objDisplayArea.ShowCalculationInProgressIndicator();

        }, TrimbleMap.DisplayArea.Shared.CALCULATION_IN_PROGRESS_TIME_MS);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DeActivateCalculationInProgressIndicator: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.DeActivateCalculationInProgressIndicator = function DeActivateCalculationInProgressIndicator() {

    // Get the display area instance ...
    var objDisplayArea = this;

    // When active ...
    if (objDisplayArea.CalculationInProgressActive) {

        // Set to not be active ...
        objDisplayArea.CalculationInProgressActive = false;

        // When the timer is active ...
        if (objDisplayArea.CalculationInProgressIndicatorTimer != null) {

            // Stop the timer when active ...
            clearTimeout(objDisplayArea.CalculationInProgressIndicatorTimer);
            objDisplayArea.CalculationInProgressIndicatorTimer = null;
        }

        // Hide the calculation in progress indicator ...
        objDisplayArea.HideCalculationInProgressIndicator();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ShowCalculationInProgressIndicator: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.ShowCalculationInProgressIndicator = function ShowCalculationInProgressIndicator() {

    // Get the display area instance ...
    var objDisplayArea = this;

    // When not visble ...
    if (!objDisplayArea.CalculationInProgressIndicatorVisible) {

        // Set it to be visible ...
        objDisplayArea.CalculationInProgressIndicatorVisible = true;

        // Hide the area display div ...
        objDisplayArea.AreaValueDisplayDiv.hide();

        // Show the in progress indicator ...
        objDisplayArea.CalculationInProgressAreaSpanLabel.show();

        // Disable the area popup ...
        objDisplayArea.AreaPopup.Disable();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION HideCalculationInProgressIndicator: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayArea.HideCalculationInProgressIndicator = function HideCalculationInProgressIndicator() {

    // Get the display area instance ...
    var objDisplayArea = this;

    // When visble ...
    if (objDisplayArea.CalculationInProgressIndicatorVisible) {

        // Set it to not be visible ...
        objDisplayArea.CalculationInProgressIndicatorVisible = false;

        // Hide the in progress indicator ...
        objDisplayArea.CalculationInProgressAreaSpanLabel.hide();

        // Show the area display div ...
        objDisplayArea.AreaValueDisplayDiv.show();

        // Enable the area popup ...
        objDisplayArea.AreaPopup.Enable();
    }
}

// **************************************************************************
// FUNCTION: AddOnUnitChanged
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.AddOnUnitChanged = function AddOnUnitChanged(fnOnUnitChanged) {

    // Get the instance ...
    var objDisplayArea = this;

    // Add the function to the list of on Unit changed functions ...
    objDisplayArea.OnUnitChangedFunctions.push(fnOnUnitChanged);
}

// **************************************************************************
// FUNCTION: RemoveOnUnitChanged
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.RemoveOnUnitChanged = function RemoveOnUnitChanged(fnOnUnitChanged) {

    // Get the instance ...
    var objDisplayArea = this;

    // Get the index of the function into the array ...
    var intOnUnitChangedFunction = $.inArray(fnOnUnitChanged, objDisplayArea.OnUnitChangedFunctions);

    // When in the array ...
    if (intOnUnitChangedFunction > -1) {

        // Remove it ...
        objDisplayArea.OnUnitChangedFunctions.splice(intOnUnitChangedFunction, 1);
    }
}

// **************************************************************************
// FUNCTION: TriggerOnUnitChanged
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.TriggerOnUnitChanged = function TriggerOnUnitChanged(intAreaUnit) {

    // Get the instance ...
    var objDisplayArea = this;

    // Loop through all the on unit changed functions ...
    $.each(objDisplayArea.OnUnitChangedFunctions, function (intOnUnitChangedFunction, fnOnUnitChangedFunction) {

        // Call the function ...
        fnOnUnitChangedFunction(intAreaUnit);
    });
}

// **************************************************************************
// FUNCTION: GetAreaUnitIndex
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.Shared.GetAreaUnitIndex = function GetAreaUnitIndex(guidAreaUnit, arrAreaUnits) {

    // Start with not found ...
    var intAreaUnit = -1;

    // Loop through all the area units ...
    $.each(arrAreaUnits, function (intTestAreaUnit, objTestAreaUnit) {

        // When found ...
        if (objTestAreaUnit.ID == guidAreaUnit) {

            // Set the index to return ...
            intAreaUnit = intTestAreaUnit;

            // Stop looking ...
            return false;
        }
    });

    return intAreaUnit;
}

// **************************************************************************
// FUNCTION: FilterAreaUnits
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayArea.Shared.FilterAreaUnits = function FilterAreaUnits(arrAreaUnits, arrAreaUnitIDs) {

    // Filter arrAreaUnits using arrAreaUnitIDs...
    var arrFilteredAreaUnits = $.grep(arrAreaUnits, function (objAreaUnit, intAreaUnit) {

        // Return true to include when in arrAreaUnitIDs...
        return ($.inArray(objAreaUnit.ID, arrAreaUnitIDs) > -1);
    });

    return arrFilteredAreaUnits;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the Map.DisplayDistance namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.DisplayDistance = {};
TrimbleMap.DisplayDistance.Shared = {};
TrimbleMap.DisplayDistance.Shared.CALCULATION_IN_PROGRESS_TIME_MS = 500;

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.CreateInstance = function CreateInstance(objMapController, objDistanceDiv, objDistance, strLabelText, strCalculationInProgressText, blnIsVisible, intDistanceUnit, arrDistanceUnits) {

    // Create the object that will hold the instance properties ...
    var objDisplayDistance = {
        MapController: objMapController,
        DistanceDisplayContainerDiv: objDistanceDiv,
        DistanceDisplayDiv: null,
        DistanceUnits: arrDistanceUnits,
        DistanceUnit: intDistanceUnit,
        Distance: objDistance,
        DistanceDisplaySpan: null,
        DistancePopup: null,
        DistancePopupDiv: null,
        LabelText: strLabelText,
        CalculationInProgressText: strCalculationInProgressText,
        CalculationInProgressIndicatorVisible: false,
        CalculationInProgressIndicatorTimer: null,
        OnUnitChangedFunctions: [],
        IsVisible: blnIsVisible,

        DistancePopupClickedProxy: function (e) { objDisplayDistance.DistancePopupClicked(e); },
        ActivateDistancePopupProxy: function (objPopupContainerDiv) { objDisplayDistance.ActivateDistancePopup(objPopupContainerDiv); },
        DeActivateDistancePopupProxy: function (objPopupContainerDiv) { objDisplayDistance.DeActivateDistancePopup(objPopupContainerDiv); },

        CreateElements: TrimbleMap.DisplayDistance.CreateElements,
        UpdateDistance: TrimbleMap.DisplayDistance.UpdateDistance,
        Show: TrimbleMap.DisplayDistance.Show,
        Hide: TrimbleMap.DisplayDistance.Hide,
        UpdateDistanceDisplaySpanText: TrimbleMap.DisplayDistance.UpdateDistanceDisplaySpanText,
        ShowCalculationInProgressIndicator: TrimbleMap.DisplayDistance.ShowCalculationInProgressIndicator,
        HideCalculationInProgressIndicator: TrimbleMap.DisplayDistance.HideCalculationInProgressIndicator,
        DistanceDisplayTextDistanceOnly: TrimbleMap.DisplayDistance.DistanceDisplayTextDistanceOnly,
        BuildDistancePopup: TrimbleMap.DisplayDistance.BuildDistancePopup,
        DistanceDisplayText: TrimbleMap.DisplayDistance.DistanceDisplayText,
        UpdateDistanceDisplaySpans: TrimbleMap.DisplayDistance.UpdateDistanceDisplaySpans,
        DistancePopupClicked: TrimbleMap.DisplayDistance.DistancePopupClicked,
        ActivateDistancePopup: TrimbleMap.DisplayDistance.ActivateDistancePopup,
        DeActivateDistancePopup: TrimbleMap.DisplayDistance.DeActivateDistancePopup,
        ActivateCalculationInProgressIndicator: TrimbleMap.DisplayDistance.ActivateCalculationInProgressIndicator,
        DeActivateCalculationInProgressIndicator: TrimbleMap.DisplayDistance.DeActivateCalculationInProgressIndicator,
        AddOnUnitChanged: TrimbleMap.DisplayDistance.AddOnUnitChanged,
        RemoveOnUnitChanged: TrimbleMap.DisplayDistance.RemoveOnUnitChanged,
        TriggerOnUnitChanged: TrimbleMap.DisplayDistance.TriggerOnUnitChanged,

        AttachEventHandlers: TrimbleMap.DisplayDistance.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.DisplayDistance.DetachEventHandlers

    };

    // create the elements
    objDisplayDistance.CreateElements();

    return objDisplayDistance;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.Show = function Show() {

    // Get the map display Distance instance ...
    var objDisplayDistance = this;

    if (!objDisplayDistance.IsVisible) {
        objDisplayDistance.DistanceDisplayDiv.show();
        objDisplayDistance.AttachEventHandlers();
        objDisplayDistance.IsVisible = true;
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.Hide = function Hide() {

    // Get the map display Distance instance ...
    var objDisplayDistance = this;

    if (objDisplayDistance.IsVisible) {
        objDisplayDistance.DetachEventHandlers();
        objDisplayDistance.DistanceDisplayDiv.hide();
        objDisplayDistance.IsVisible = false;
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.AttachEventHandlers = function AttachEventHandlers() {

    // Get the map display Distance instance ...
    var objDisplayDistance = this;

    objDisplayDistance.DistancePopup.AttachEventHandlers();
}


// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map display Distance instance ...
    var objDisplayDistance = this;

    objDisplayDistance.DistancePopup.DetachEventHandlers();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateElements: Attach the Distance popup ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.CreateElements = function CreateElements() {

    // Get the map display Distance instance ...
    var objDisplayDistance = this;

    //Create the div ...
    objDisplayDistance.DistanceDisplayDiv = $('<div class="measurement-value"></div>');

    //set the visibility according to the initial parameter isVisible
    if (!objDisplayDistance.IsVisible) { objDisplayDistance.DistanceDisplayDiv.hide(); }

    //append the div ..
    objDisplayDistance.DistanceDisplayContainerDiv.append(objDisplayDistance.DistanceDisplayDiv);

    // Create a div to contain the distance value ...
    objDisplayDistance.DistanceValueDisplayDiv = $('<div></div>');

    // Add it to the main div ...
    objDisplayDistance.DistanceDisplayDiv.append(objDisplayDistance.DistanceValueDisplayDiv);

    // Create the span ...
    objDisplayDistance.DistanceDisplaySpan = $('<span class="distance_span_text"></span>');

    // Add it to the Distance display div ...
    objDisplayDistance.DistanceDisplayDiv.append(objDisplayDistance.DistanceDisplaySpan);

    // When we have label text ...
    if ((objDisplayDistance.LabelText != null) && (objDisplayDistance.LabelText != '')) {

        // Create label text span ...
        objDisplayDistance.DistanceSpanLabel = $('<span class="distance_span_text_bold distance_label_span">' + objDisplayDistance.LabelText + ':</span>');

        // Append to distance span ...
        objDisplayDistance.DistanceDisplaySpan.append(objDisplayDistance.DistanceSpanLabel);

        // Add a space ...
        objDisplayDistance.DistanceDisplaySpan.append('&nbsp;');
    }

    // Create the value span ...
    objDisplayDistance.DistanceValueSpan = $('<span class="distance_span_text distance_value_span"></span>');

    // Append to Distance span ...
    objDisplayDistance.DistanceDisplaySpan.append(objDisplayDistance.DistanceValueSpan);

    // Create the span that holds the unit abbreviation ...
    objDisplayDistance.DistanceSpanUnitAbbreviation = $('<span class="distance_span_text_bold distance_unit_span"></span>');

    // Append to Distance span ...
    objDisplayDistance.DistanceDisplaySpan.append(objDisplayDistance.DistanceSpanUnitAbbreviation);

    // Create the drop down image ...
    var objDropDownImage = $('<div class="drop_down"></div>');

    // Add the drop down image to the end of the Distance display div ...
    objDisplayDistance.DistanceDisplayDiv.append(objDropDownImage);

    // Create in progress label text span ...
    objDisplayDistance.CalculationInProgressDistanceSpanLabel = $('<div><span class="distance_span_text_italic distance_label_span">' + objDisplayDistance.CalculationInProgressText + '</span></div>');

    // Hide it ...
    objDisplayDistance.CalculationInProgressDistanceSpanLabel.hide();

    // Add it to the distance span label ...
    objDisplayDistance.DistanceDisplayDiv.append(objDisplayDistance.CalculationInProgressDistanceSpanLabel);


    // Create the operation popup control ...
    objDisplayDistance.DistancePopup = SD.Popup.CreateInstance(objDisplayDistance.DistanceDisplayDiv,
        'distance popup-downwards',
        'distance popup-upwards',
        'distance popup-downwards-open',
        'distance popup-upwards-open',
        5,
        false,
        SD.Popup.enumPopupBehaviour.AlwaysDown,
        objDisplayDistance.ActivateDistancePopupProxy,
        objDisplayDistance.DeActivateDistancePopupProxy);

    // Update the Distance span text ...
    objDisplayDistance.UpdateDistanceDisplaySpanText();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateDistance
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.UpdateDistance = function UpdateDistance(objDistance) {

    // Get the display Distance instance ...
    var objDisplayDistance = this;

    // Set the Distance in square kilometers ...
    objDisplayDistance.Distance = objDistance;

    // Update the Distance span text ...
    objDisplayDistance.UpdateDistanceDisplaySpanText();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateDistanceDisplaySpanText
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.UpdateDistanceDisplaySpanText = function UpdateDistanceDisplaySpanText() {

    // Get the display Distance instance ...
    var objDisplayDistance = this;

    // When we have a selected distance unit ...
    if ((objDisplayDistance.DistanceUnits.length > 0) && (objDisplayDistance.DistanceUnit > -1)) {

        // Set the Distance value in the span ...
        objDisplayDistance.UpdateDistanceDisplaySpans(objDisplayDistance.DistanceUnit);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildDistancePopup: Build the Distance popup ... 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.BuildDistancePopup = function BuildDistancePopup() {

    // Get the display Distance instance ...
    var objDisplayDistance = this;

    // * Build the Distance popup here ...

    // Create the div ...
    objDisplayDistance.DistancePopupDiv = $('<div class="distance-popup"></div>');

    // When we have a distance ...
    if (objDisplayDistance.Distance != null) {

        // Create the distance units div ...
        var objDistanceInUnitsDiv = $('<div></div>');

        // Add it to the popup div ...
        objDisplayDistance.DistancePopupDiv.append(objDistanceInUnitsDiv);

        // Loop through all the Distance units ...
        for (var intDistanceUnit = 0; intDistanceUnit < objDisplayDistance.DistanceUnits.length; intDistanceUnit++) {

            // Create a div for the operation item ...
            var objDisplayDistanceItemDiv = $('<div class="distance-dropdown-item" DistanceUnitIndex=' + intDistanceUnit + '></div>');

            // Get the Distance unit object ...
            var objDistanceUnit = objDisplayDistance.DistanceUnits[intDistanceUnit];

            // Build a string with the Distance, unit abbreviation and unit name in brackets ...
            var strDistance = objDisplayDistance.DistanceDisplayText(intDistanceUnit) + ' (' + objDistanceUnit.Abbreviation + ')';

            // Create a div for the item text ...
            var objItemTextDiv = $('<span>' + strDistance + '</span>');

            // Choose the css class depending on whether or not the operation should be checked or not ...
            var strCssClass = (intDistanceUnit == objDisplayDistance.DistanceUnit) ? 'checked' : 'unchecked';

            // Create a div for the checkbox ...
            var objCheckBoxDiv = $('<div class="' + strCssClass + '"></div>');

            // Add the checkbox ...
            objDisplayDistanceItemDiv.append(objCheckBoxDiv);

            // Add the item text div ...
            objDisplayDistanceItemDiv.append(objItemTextDiv);

            // Add it to the div ...
            objDistanceInUnitsDiv.append(objDisplayDistanceItemDiv);
        }

        // Calculated in
        var strCalculatedInCoordinateSystem = SD.Translation.Shared.GetTranslation('Map.DisplayDistance.js', 'CalculatedIn');

        // Create a div for the coordinate system in which the distance has been calculated ...
        var objCalculatedInCoordinateSystemDiv = $('<div class="distance-message"><span>' + strCalculatedInCoordinateSystem + '</span>&nbsp;<span class="bold">' + objDisplayDistance.Distance.CoordinateSystemCalculatedIn.Name + '</span></div>');

        // Add it to the popup ...
        objDisplayDistance.DistancePopupDiv.append(objCalculatedInCoordinateSystemDiv);

        // When it is not likely that the calculation were accurate ...
        if (!objDisplayDistance.Distance.CoordinateSystemCalculatedIn.LikelyAccurate) {

            // The calculation might be inaccurate due to the fact that the shape spans multiple UTM Zones
            var strInAccurateMessage = SD.Translation.Shared.GetTranslation('Map.DisplayDistance.js', 'CalculationMightBeInaccurate');

            // Add the message ...
            objCalculatedInCoordinateSystemDiv.append('<br /><div class="distance-message-innacurate"><span>' + strInAccurateMessage + '</span></div>');
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DistancePopupClicked: show the Distance popup ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.DistancePopupClicked = function DistancePopupClicked(e) {

    // Get the display Distance instance ...
    var objDisplayDistance = this;

    //get the selected element
    var objTarget = $(e.target);

    //retrieve the attribute
    var objDistanceUnitIndex = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'DistanceUnitIndex');

    if (objDistanceUnitIndex) {

        //retrieve the button index that was clicked
        var strDistanceUnitIndex = objDistanceUnitIndex.attr('DistanceUnitIndex');

        //convert the string attribute into an integer
        var intDistanceUnitIndex = parseInt(strDistanceUnitIndex);

        // When not the currently selected Distance unit ...
        if ((!isNaN(intDistanceUnitIndex)) && intDistanceUnitIndex != objDisplayDistance.DistanceUnit) {

            // Select the Distance unit that the user clicked on ...
            objDisplayDistance.DistanceUnit = intDistanceUnitIndex;

            // Update the Distance value on the interface ...
            objDisplayDistance.UpdateDistanceDisplaySpans(objDisplayDistance.DistanceUnit);

            //close the popup
            objDisplayDistance.DistancePopup.ClosePopup();

            // Trigger the distance unit changed event ...
            objDisplayDistance.TriggerOnUnitChanged();
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DistanceDisplayText: Build the Distance text ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.DistanceDisplayText = function DistanceDisplayText(intDistanceUnit) {

    // Get the display Distance instance ...
    var objDisplayDistance = this;

    // When we have a selected distance unit ...
    if (intDistanceUnit > -1) {

        // Convert the Distance value to a string ...
        var strDistance = objDisplayDistance.DistanceDisplayTextDistanceOnly(intDistanceUnit);

        // Get the Distance unit object ...
        var objDistanceUnit = objDisplayDistance.DistanceUnits[intDistanceUnit];

        // Append the Distance unit abbreviation ...
        strDistance += ' ' + objDistanceUnit.Unit;
    }

    return strDistance;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DistanceDisplayTextDistanceOnly: build the text representing the numeric values for the Distance
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.DistanceDisplayTextDistanceOnly = function DistanceDisplayTextDistanceOnly(intDistanceUnit) {

    // Get the display Distance instance ...
    var objDisplayDistance = this;

    // When we have a selected distance unit ...
    if (intDistanceUnit > -1) {

        // Get the Distance unit object ...
        var objDistanceUnit = objDisplayDistance.DistanceUnits[intDistanceUnit];

        // Convert the Distance value to the unit ...
        var dblDistanceValue = (objDisplayDistance.Distance) ? objDisplayDistance.Distance.DistanceInKm / objDistanceUnit.ConversionFactorToKm : 0;

        // Convert the Distance value to a string ...
        var strDistance = SD.DisplayValue.FromDouble(dblDistanceValue, objDisplayDistance.MapController.State.GroupSeparator, objDisplayDistance.MapController.State.DecimalSeparator, objDistanceUnit.DecimalPlaces);
    }

    return strDistance;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UpdateDistanceDisplaySpans: Build the Distance text ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.UpdateDistanceDisplaySpans = function UpdateDistanceDisplaySpans(intDistanceUnit) {

    // Get the display Distance instance ...
    var objDisplayDistance = this;

    //clear spans
    objDisplayDistance.DistanceDisplaySpan.empty();

    // When we have label text ...
    if ((objDisplayDistance.LabelText != null) && (objDisplayDistance.LabelText != '')) {

        //create the object that will say "Distance" in bold in the control
        var objDistanceSpanLabel = $('<span class="distance_span_text_bold">' + objDisplayDistance.LabelText + ':</span>');

        //append to Distance span
        objDisplayDistance.DistanceDisplaySpan.append(objDistanceSpanLabel);

        // Add a space ...
        objDisplayDistance.DistanceDisplaySpan.append('&nbsp;');
    }

    //create the actual Distance amount
    var objDistanceSpanAmount = $('<span class="distance_span_text">' + objDisplayDistance.DistanceDisplayTextDistanceOnly(intDistanceUnit) + '</span>');

    // Get the Distance unit object ...
    var objDistanceUnit = objDisplayDistance.DistanceUnits[intDistanceUnit];

    //append to Distance span
    objDisplayDistance.DistanceDisplaySpan.append(objDistanceSpanAmount);

    //create the span that holds the unit abbreviation
    var objDistanceSpanUnitAbbreviation = $('<span class="distance_span_text_bold">' + ' ' + objDistanceUnit.Abbreviation + '</span>');

    //append to Distance span
    objDisplayDistance.DistanceDisplaySpan.append(objDistanceSpanUnitAbbreviation);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ActivateDistancePopup: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.ActivateDistancePopup = function ActivateDistancePopup(objPopupContainerDiv) {

    // Get the display Distance instance ...
    var objDisplayDistance = this;

    //create the Distance pop up
    objDisplayDistance.BuildDistancePopup();

    //append the created pop up to the container
    objPopupContainerDiv.append(objDisplayDistance.DistancePopupDiv);

    // Attach a click event handler to the popup div ...
    objDisplayDistance.DistancePopupDiv.click(objDisplayDistance.DistancePopupClickedProxy);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DeActivateDistancePopup: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.DeActivateDistancePopup = function DeActivateDistancePopup(objPopupContainerDiv) {

    // Get the display Distance instance ...
    var objDisplayDistance = this;

    // detach th click event handler on the popup div
    objDisplayDistance.DistancePopupDiv.off('click', objDisplayDistance.DistancePopupClickedProxy);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ActivateCalculationInProgressIndicator: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.ActivateCalculationInProgressIndicator = function ActivateCalculationInProgressIndicator() {

    // Get the display Length instance ...
    var objDisplayDistance = this;

    // When not active ...
    if (!objDisplayDistance.CalculationInProgressActive) {

        // Set to be active ...
        objDisplayDistance.CalculationInProgressActive = true;

        // Set a timer that will display the calculation in progress indicator ... 
        objDisplayDistance.CalculationInProgressIndicatorTimer = setTimeout(function () {

            // Clear the timer handle ...
            objDisplayDistance.CalculationInProgressIndicatorTimer = null;

            // Show the calculation in progress indicator ...
            objDisplayDistance.ShowCalculationInProgressIndicator();

        }, TrimbleMap.DisplayDistance.Shared.CALCULATION_IN_PROGRESS_TIME_MS);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION DeActivateCalculationInProgressIndicator: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.DeActivateCalculationInProgressIndicator = function DeActivateCalculationInProgressIndicator() {

    // Get the display Length instance ...
    var objDisplayDistance = this;

    // When active ...
    if (objDisplayDistance.CalculationInProgressActive) {

        // Set to not be active ...
        objDisplayDistance.CalculationInProgressActive = false;

        // When the timer is active ...
        if (objDisplayDistance.CalculationInProgressIndicatorTimer != null) {

            // Stop the timer when active ...
            clearTimeout(objDisplayDistance.CalculationInProgressIndicatorTimer);
            objDisplayDistance.CalculationInProgressIndicatorTimer = null;
        }

        // Hide the calculation in progress indicator ...
        objDisplayDistance.HideCalculationInProgressIndicator();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ShowCalculationInProgressIndicator: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.ShowCalculationInProgressIndicator = function ShowCalculationInProgressIndicator() {

    // Get the display distance instance ...
    var objDisplayDistance = this;

    // When not visble ...
    if (!objDisplayDistance.CalculationInProgressIndicatorVisible) {

        // Set it to be visible ...
        objDisplayDistance.CalculationInProgressIndicatorVisible = true;

        // Hide the distance display div ...
        objDisplayDistance.DistanceValueDisplayDiv.hide();

        // Show the in progress indicator ...
        objDisplayDistance.CalculationInProgressDistanceSpanLabel.show();

        // Disable the distance popup ...
        objDisplayDistance.DistancePopup.Disable();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION HideCalculationInProgressIndicator: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.DisplayDistance.HideCalculationInProgressIndicator = function HideCalculationInProgressIndicator() {

    // Get the display distance instance ...
    var objDisplayDistance = this;

    // When visble ...
    if (objDisplayDistance.CalculationInProgressIndicatorVisible) {

        // Set it to not be visible ...
        objDisplayDistance.CalculationInProgressIndicatorVisible = false;

        // Hide the in progress indicator ...
        objDisplayDistance.CalculationInProgressDistanceSpanLabel.hide();

        // Show the distance display div ...
        objDisplayDistance.DistanceValueDisplayDiv.show();

        // Enable the distance popup ...
        objDisplayDistance.DistancePopup.Enable();
    }
}

// **************************************************************************
// FUNCTION: AddOnUnitChanged
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.AddOnUnitChanged = function AddOnUnitChanged(fnOnUnitChanged) {

    // Get the instance ...
    var objDisplayDistance = this;

    // Add the function to the list of on Unit changed functions ...
    objDisplayDistance.OnUnitChangedFunctions.push(fnOnUnitChanged);
}

// **************************************************************************
// FUNCTION: RemoveOnUnitChanged
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.RemoveOnUnitChanged = function RemoveOnUnitChanged(fnOnUnitChanged) {

    // Get the instance ...
    var objDisplayDistance = this;

    // Get the index of the function into the array ...
    var intOnUnitChangedFunction = $.inArray(fnOnUnitChanged, objDisplayDistance.OnUnitChangedFunctions);

    // When in the array ...
    if (intOnUnitChangedFunction > -1) {

        // Remove it ...
        objDisplayDistance.OnUnitChangedFunctions.splice(intOnUnitChangedFunction, 1);
    }
}

// **************************************************************************
// FUNCTION: TriggerOnUnitChanged
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.TriggerOnUnitChanged = function TriggerOnUnitChanged(intDistanceUnit) {

    // Get the instance ...
    var objDisplayDistance = this;

    // Loop through all the on unit changed functions ...
    $.each(objDisplayDistance.OnUnitChangedFunctions, function (intOnUnitChangedFunction, fnOnUnitChangedFunction) {

        // Call the function ...
        fnOnUnitChangedFunction(intDistanceUnit);
    });
}


// **************************************************************************
// FUNCTION: GetDistanceUnitIndex
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.Shared.GetDistanceUnitIndex = function GetDistanceUnitIndex(guidDistanceUnit, arrDistanceUnits) {

    // Start with not found ...
    var intDistanceUnit = -1;

    // Loop through all the distance units ...
    $.each(arrDistanceUnits, function (intTestDistanceUnit, objTestDistanceUnit) {

        // When found ...
        if (objTestDistanceUnit.ID == guidDistanceUnit) {

            // Set the index to return ...
            intDistanceUnit = intTestDistanceUnit;

            // Stop looking ...
            return false;
        }
    });

    return intDistanceUnit;
}

// **************************************************************************
// FUNCTION: FilterDistanceUnits
// USAGE:    
// **************************************************************************
TrimbleMap.DisplayDistance.Shared.FilterDistanceUnits = function FilterDistanceUnits(arrDistanceUnits, arrDistanceUnitIDs) {

    // Filter arrDistanceUnits using arrDistanceUnitIDs...
    var arrFilteredDistanceUnits = $.grep(arrDistanceUnits, function (objDistanceUnit, intDistanceUnit) {

        // Return true to include when in arrDistanceUnitIDs...
        return ($.inArray(objDistanceUnit.ID, arrDistanceUnitIDs) > -1);
    });

    return arrFilteredDistanceUnits;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.DynamicShapeOptions = {};
TrimbleMap.DynamicShapeOptions.Shared = {};

// **************************************************************************
// FUNCTION CreateInstance
// **************************************************************************
TrimbleMap.DynamicShapeOptions.CreateInstance = function CreateInstance(objStandardMapState, objDynamicShapeOptionsDialogData, strParentGeometryType) {

    // Create the instance ...
    var objDynamicShapeOptions = {
        StandardMapState: objStandardMapState,
        DynamicShapeOptionsDialogData: objDynamicShapeOptionsDialogData,
        DynamicShapeOptionsDiv: null,
        DerivedShapeCheckbox: null,
        DerivedShapeElements: null,
        RelatedLicenseDynamicShapeElements: null,
        RelatedAgreementDynamicShapeElements: null,
        RelatedGroupDynamicShapeElements: null,
        BufferOptionsRadioButtonsElements: null,
        NoBufferOptionsElements: null,
        NoBufferRadioButton: null,
        BufferOptionsElementsFirstRow: null,
        BufferOptionsElementsSecondRow: null,
        BufferRadioButton: null,
        BufferUnitsDropDown: null,
        DerivedShapeGeometryTypeDropDown: null,
        BufferDistanceTextbox: null,
        OfficialAreaOptionsElements: null,
        DynamicShapeOptions: null,
        ValidationMessageDiv: null,
        OnCloseFunction: null,
        DialogID: 0,
        ShapeGeometryType: null,
        ParentGeometryType: strParentGeometryType,
        IsDerivedShape: null,
        IsEditable: null,

        OpenDynamicShapeOptionsDialogProxy: function (objDyanmicShapeOptions, enShapeGeometryType, blnEditable, IsDerivedShape, fnOnClose) { objDynamicShapeOptions.OpenDynamicShapeOptionsDialog(objDyanmicShapeOptions, enShapeGeometryType, blnEditable, IsDerivedShape, fnOnClose); },
        DynamicShapeOptionsClickedProxy: function (e) { objDynamicShapeOptions.DynamicShapeOptionsClicked(e); },

        AttachEventHandlers: TrimbleMap.DynamicShapeOptions.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.DynamicShapeOptions.DetachEventHandlers,
        OpenDynamicShapeOptionsDialog: TrimbleMap.DynamicShapeOptions.OpenDynamicShapeOptionsDialog,
        DynamicShapeOptionsClicked: TrimbleMap.DynamicShapeOptions.DynamicShapeOptionsClicked,
        BuildDynamicShapeOptionsDialog: TrimbleMap.DynamicShapeOptions.BuildDynamicShapeOptionsDialog,
        PopulateDropDowns: TrimbleMap.DynamicShapeOptions.PopulateDropDowns,
        BuildDynamicShapeFilterByRow: TrimbleMap.DynamicShapeOptions.BuildDynamicShapeFilterByRow,
        BuildInterfaceRow: TrimbleMap.DynamicShapeOptions.BuildInterfaceRow,
        PopulateDynamicShapeOptions: TrimbleMap.DynamicShapeOptions.PopulateDynamicShapeOptions,
        ContructDynamicShapeOptions: TrimbleMap.DynamicShapeOptions.ContructDynamicShapeOptions,
        GetDistanceUnitDecimalPlaces: TrimbleMap.DynamicShapeOptions.GetDistanceUnitDecimalPlaces,
        ShowOrHideElements: TrimbleMap.DynamicShapeOptions.ShowOrHideElements,
        Validate: TrimbleMap.DynamicShapeOptions.Validate,
        ShowValidationMessages: TrimbleMap.DynamicShapeOptions.ShowValidationMessages
    }

    // Return the instance ...
    return objDynamicShapeOptions;
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.AttachEventHandlers = function AttachEventHandlers(e) {

    // Get the instance ...
    var objDynamicShapeOptions = this;

}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.DetachEventHandlers = function DetachEventHandlers(e) {

    // Get the instance ...
    var objDynamicShapeOptions = this;

}

// **************************************************************************
// FUNCTION: DynamicShapeOptionsClicked
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.DynamicShapeOptionsClicked = function DynamicShapeOptionsClicked(e) {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // Get the OK and CANCEL buttons ....
    var objOKButton = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'DynamicShapeOptionsOK');
    var objCANCELButton = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'DynamicShapeOptionsCANCEL');
    var objAllCheckbox = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'DynamicShapeOptionsCANCEL');
    var objAllCheckBox = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'AllCheckBox');
    var objIncludeCheckbox = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'IncludeCheckbox');
    var objBufferRadioButton = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'BufferDynamicShape');
    var objDerivedShapeCheckbox = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'DerivedShape');

    switch (true) {
        case (objOKButton != null):

            // Prevent the default behaviour for the button click (form submission) ...
            e.preventDefault();

            // When valid ...
            if (objDynamicShapeOptions.Validate()) {

                // Get the values from the interface ...
                objDynamicShapeOptions.ContructDynamicShapeOptions();

                // Close the modal dialog ...
                TrimbleMap.ModalDialog.Shared.CloseDialog(objDynamicShapeOptions.DialogID);

                // Call the on close function ...
                let blnIsDynamic = objDynamicShapeOptions.DerivedShapeCheckbox.is(':checked');
                if ((typeof objDynamicShapeOptions.OnCloseFunction != 'undefined') && objDynamicShapeOptions.OnCloseFunction) { objDynamicShapeOptions.OnCloseFunction(blnIsDynamic); }
            }
            break;

        case (objCANCELButton != null):

            // Prevent the default behaviour for the button click (form submission) ...
            e.preventDefault();

            // Close the modal dialog ...
            TrimbleMap.ModalDialog.Shared.CloseDialog(objDynamicShapeOptions.DialogID);

            // Clear the validation message div ...
            objDynamicShapeOptions.ValidationMessageDiv.empty();

            // Call the on close function ...
            if ((typeof objDynamicShapeOptions.OnCloseFunction != 'undefined') && objDynamicShapeOptions.OnCloseFunction) { objDynamicShapeOptions.OnCloseFunction(objDynamicShapeOptions.IsDerivedShape); }
            break;

        case ((objAllCheckBox !== null) || (objIncludeCheckbox !== null) || (objBufferRadioButton !== null)):

            if (objBufferRadioButton !== null) {
                if (objBufferRadioButton.attr('BufferDynamicShape') === 'true') {
                    objDynamicShapeOptions.NoBufferRadioButton.prop('checked', false);
                    objDynamicShapeOptions.BufferRadioButton.prop('checked', true);
                } else {
                    objDynamicShapeOptions.BufferRadioButton.prop('checked', false);
                    objDynamicShapeOptions.NoBufferRadioButton.prop('checked', true);
                }
            }

            // Show or hide dom elements ...
            objDynamicShapeOptions.ShowOrHideElements();
            break;

        case (objDerivedShapeCheckbox != null):

            // Get all the input elements ..
            var arrAllInputs = objDynamicShapeOptions.DynamicShapeOptionsDiv.find('input, select');

            if (objDynamicShapeOptions.DerivedShapeCheckbox.is(':checked') && (objDynamicShapeOptions.IsEditable != null && objDynamicShapeOptions.IsEditable)) {

                arrAllInputs.attr('disabled', false);
                arrAllInputs.attr('readonly', false);
            }
            else {
                arrAllInputs.attr('disabled', true);
                arrAllInputs.attr('readonly', true);
                if (objDynamicShapeOptions.IsEditable != null && objDynamicShapeOptions.IsEditable) {
                    objDynamicShapeOptions.DerivedShapeCheckbox.attr('disabled', false);
                    objDynamicShapeOptions.DerivedShapeCheckbox.attr('readonly', false);
                }
            }

            if (TrimbleMap.DynamicShapeOptions.Shared.IsConditionShape(objDynamicShapeOptions)) {
                // Set derived shape geometry type dropdown value and disable it
                objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.val(objDynamicShapeOptions.ParentGeometryType);
                objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.attr('disabled', true);
                objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.attr('readonly', true);
            }
            break;
    }
}

// **************************************************************************
// FUNCTION: OpenDynamicShapeOptionsDialog
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.OpenDynamicShapeOptionsDialog = function OpenDynamicShapeOptionsDialog(objDynamicShapeOptionsData, enShapeGeometryType, blnEditable, blnIsDerivedShape, fnOnClose) {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    objDynamicShapeOptions.IsEditable = blnEditable;

    // Set the dynamic shape options ...
    objDynamicShapeOptions.DynamicShapeOptions = objDynamicShapeOptionsData;

    // Set the Shape Geometry Type
    objDynamicShapeOptions.ShapeGeometryType = enShapeGeometryType;

    // Set the IsDerivedShape property
    objDynamicShapeOptions.IsDerivedShape = blnIsDerivedShape;

    // Set the onclose function ...
    objDynamicShapeOptions.OnCloseFunction = fnOnClose;

    // Build the dialog ...
    objDynamicShapeOptions.BuildDynamicShapeOptionsDialog();

    // Populate the dialog ...
    objDynamicShapeOptions.PopulateDynamicShapeOptions();

    // Get the next modal dialog id ...
    objDynamicShapeOptions.DialogID = TrimbleMap.ModalDialog.Shared.NextDialogID();

    // Get the translation for the title ...

    // Derived shape options    
    var strTitle = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'DerivedShapeOptionsTitle');

    // Show the dialog ...
    TrimbleMap.ModalDialog.Shared.OpenDialog(objDynamicShapeOptions.DynamicShapeOptionsDiv, strTitle, !blnEditable, objDynamicShapeOptions.DialogID);

    // Show or hide dom elements ...
    objDynamicShapeOptions.ShowOrHideElements();

    // Attach the click event handler ...
    objDynamicShapeOptions.DynamicShapeOptionsDiv.click(objDynamicShapeOptions.DynamicShapeOptionsClickedProxy);
}

// **************************************************************************
// FUNCTION: BuildInterfaceRow
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.BuildInterfaceRow = function BuildInterfaceRow() {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // Create an object for the controls ...
    var objControls = {};

    // Create a div for the row ...
    objControls.RowDiv = $('<div></div>');

    // Create divs for the columns ...
    objControls.FirstColumnDiv = $('<div class="first-column"></div>');
    objControls.SecondColumnDiv = $('<div class="second-column"></div>');
    objControls.ThirdColumnDiv = $('<div class="third-column"></div>');

    // Add the columns to the row ...
    objControls.RowDiv.append(objControls.FirstColumnDiv);
    objControls.RowDiv.append(objControls.SecondColumnDiv);
    objControls.RowDiv.append(objControls.ThirdColumnDiv);

    return objControls;
}

// **************************************************************************
// FUNCTION: BuildDynamicShapeFilterByRow
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.BuildDynamicShapeFilterByRow = function BuildDynamicShapeFilterByRow(strIncludeCheckBoxText, strAllCheckboxText) {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // Create an object for the controls ...
    var objControls = objDynamicShapeOptions.BuildInterfaceRow();

    // Create the include check box ...
    objControls.IncludeCheckBox = $('<input IncludeCheckbox="true" type="checkbox"></input>');

    // Add it to the first column ...
    objControls.FirstColumnDiv.append(objControls.IncludeCheckBox);

    // Add strIncludeCheckBoxText after the checkbox ...
    objControls.FirstColumnDiv.append('<span>' + strIncludeCheckBoxText + '</span>');

    // Create the all check box ...
    objControls.AllCheckBox = $('<input AllCheckBox="true" type="checkbox"></input>');

    // Add it to the second column ...
    objControls.SecondColumnDiv.append(objControls.AllCheckBox);

    // Add strAllCheckboxText after the checkbox ...
    objControls.SecondColumnDiv.append('<span>' + strAllCheckboxText + '</span>');

    // Get the translation for 'filter by';

    // filter by
    var strFilterBy = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'FilterBy');

    // Create 'filter by' for the third column ...
    objControls.FilterBySpan = $('<span>' + strFilterBy + ': </span>');

    // Add 'filter by' to the third column ...
    objControls.ThirdColumnDiv.append(objControls.FilterBySpan);

    // Create the filter by search drop down ...
    objControls.FilterBySearchDropDown = $('<select class="m-b-5"></select>');

    // Add it to the third column ...
    objControls.ThirdColumnDiv.append(objControls.FilterBySearchDropDown);

    return objControls;
}

// **************************************************************************
// FUNCTION: PopulateDropDowns
// USAGE:    objNullValue is optional and defaults to Guid.Empty ...
// **************************************************************************
TrimbleMap.DynamicShapeOptions.Shared.PopulateDropDown = function PopulateDropDown(objSelectElement, arrData, strTextProperty, strValueProperty, blnRequired, objNullValue) {

    // Clear the drop down ...
    objSelectElement.empty();

    // When not required ...
    if (!blnRequired) {

        // Add an empty item ...
        objSelectElement.append('<option value="' + (((typeof objNullValue != 'undefined') && (objNullValue != null)) ? objNullValue : SD.Guid.Shared.Empty()) + '"></option>');
    }

    // Loop through all the data items to add ...
    $.each(arrData, function (intData, objData) {

        // Add the drop down element ...
        objSelectElement.append('<option value="' + objData[strValueProperty] + '">' + objData[strTextProperty] + '</option>');
    })
}

// **************************************************************************
// FUNCTION: PopulateDropDowns
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.PopulateDropDowns = function PopulateDropDowns() {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // Populate the license searches ...
    TrimbleMap.DynamicShapeOptions.Shared.PopulateDropDown(objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySearchDropDown, objDynamicShapeOptions.DynamicShapeOptionsDialogData.LicenseSearches, 'Name', 'ID', false);
    TrimbleMap.DynamicShapeOptions.Shared.PopulateDropDown(objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySearchDropDown, objDynamicShapeOptions.DynamicShapeOptionsDialogData.AgreementSearches, 'Name', 'ID', false);
    TrimbleMap.DynamicShapeOptions.Shared.PopulateDropDown(objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySearchDropDown, objDynamicShapeOptions.DynamicShapeOptionsDialogData.GroupSearches, 'Name', 'ID', false);

    // Populate the buffer units drop down ...
    TrimbleMap.DynamicShapeOptions.Shared.PopulateDropDown(objDynamicShapeOptions.BufferUnitsDropDown, objDynamicShapeOptions.StandardMapState.MapControllerState.DistanceUnits, 'Unit', 'ID', false);

    // Populate the geometry type drop down ...
    TrimbleMap.DynamicShapeOptions.Shared.PopulateDropDown(objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown, objDynamicShapeOptions.StandardMapState.MapControllerState.DerivedShapeGeometryTypes, 'Name', 'ID', false);

    // Populate the official area drop down ...
    TrimbleMap.DynamicShapeOptions.Shared.PopulateDropDown(objDynamicShapeOptions.OfficialAreaOptionsDropDown, objDynamicShapeOptions.DynamicShapeOptionsDialogData.OfficialAreaOptions, 'OptionText', 'OfficialAreaOption', false, 0);
}

// **************************************************************************
// FUNCTION: BuildDynamicShapeOptionsDialog
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.BuildDynamicShapeOptionsDialog = function BuildDynamicShapeOptionsDialog() {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // When not created yet ...
    if (!objDynamicShapeOptions.DynamicShapeOptionsDiv) {

        // Get the translations ...

        // Construct shape from
        var strConstructShapeFrom = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'ConstructShapeFrom') + ":";

        if (!(objDynamicShapeOptions.DynamicShapeOptions.ShowRelatedLicenseSearchOptions || objDynamicShapeOptions.DynamicShapeOptions.ShowRelatedAgreementSearchOptions || objDynamicShapeOptions.DynamicShapeOptions.ShowRelatedLicenseGroupSearchOptions)) {
            strConstructShapeFrom = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'ConstructShapeFromParent') + ".";
        }

        // Derived Shape
        var strDerivedShapeCheckboxText = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DerivedShape');

        // OK
        var strOK = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'Ok');

        // CANCEL
        var strCANCEL = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'Cancel');

        // Buffer
        var strBufferShapeCheckboxText = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'Buffer');

        // by
        var strBy = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'By');

        // Official area
        var strOfficialArea = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'OfficialArea');

        //Buffer Option
        var strBufferOptionText = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'BufferOption');

        //No Buffer
        var strNoBufferRadioButtonText = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'NoBuffer');

        //Only shapes with the same geometry type will be used
        var strNoBufferMessage = "(" + SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'NoBufferSameGeometryTypes') + ")";

        //Not supported as the parent object geometry type (%1) does not match this shape''s geometry type (%2)
        var strNoBufferNotSupportedMessage = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'NoBufferNotSupported', objDynamicShapeOptions.ParentGeometryType, objDynamicShapeOptions.ShapeGeometryType);

        //Not supported as this shape is not a Polygon
        var strBufferNotSupportedMessage = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'BufferNotSupported');

        //Only buffer shapes with the geometry type
        var strOnlyBufferShapeMessage = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'OnlyBufferShapesMessage');

        //Buffer distance
        var strBufferDistance = SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'BufferDistance');


        // Create the dialog content div ...
        objDynamicShapeOptions.DynamicShapeOptionsDiv = $('<div class="shape_dynamic_shape_options trimble-map" id="dynamicshapeoptions"></div>');

        // Create the derived check box ...
        objDynamicShapeOptions.DerivedShapeCheckbox = $('<input DerivedShape="true" type="checkbox"></input>');

        // Create the 'Derived Shape' span ...
        objDynamicShapeOptions.DerivedShapeCheckboxLabel = $('<span>' + strDerivedShapeCheckboxText + '</span>');

        // Add them to the div ...
        objDynamicShapeOptions.DynamicShapeOptionsDiv.append(objDynamicShapeOptions.DerivedShapeCheckbox);
        objDynamicShapeOptions.DynamicShapeOptionsDiv.append(objDynamicShapeOptions.DerivedShapeCheckboxLabel);

        // Add the 'Construct shape from' span ...
        objDynamicShapeOptions.DynamicShapeOptionsDiv.append('<span class="block m-t-10 m-b-10">' + strConstructShapeFrom + '</span>');

        // Create and add the related licenses, agreements and groups rows ...
        objDynamicShapeOptions.RelatedLicenseDynamicShapeElements = objDynamicShapeOptions.BuildDynamicShapeFilterByRow('Related licenses', 'All related licenses');
        objDynamicShapeOptions.RelatedAgreementDynamicShapeElements = objDynamicShapeOptions.BuildDynamicShapeFilterByRow('Related agreements', 'All related agreements');
        objDynamicShapeOptions.RelatedGroupDynamicShapeElements = objDynamicShapeOptions.BuildDynamicShapeFilterByRow('Related groups', 'All related groups');
        objDynamicShapeOptions.DynamicShapeOptionsDiv.append(objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.RowDiv);
        objDynamicShapeOptions.DynamicShapeOptionsDiv.append(objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.RowDiv);
        objDynamicShapeOptions.DynamicShapeOptionsDiv.append(objDynamicShapeOptions.RelatedGroupDynamicShapeElements.RowDiv);


        // Create the official area options row div ...
        objDynamicShapeOptions.OfficialAreaOptionsElements = objDynamicShapeOptions.BuildInterfaceRow();

        // Add it to the div ...
        objDynamicShapeOptions.DynamicShapeOptionsDiv.append(objDynamicShapeOptions.OfficialAreaOptionsElements.RowDiv);

        // Add the 'Official area:' span ...
        objDynamicShapeOptions.OfficialAreaOptionsElements.FirstColumnDiv.append('<span>' + strOfficialArea + ':</span>');

        // Create the official area options drop down ...
        objDynamicShapeOptions.OfficialAreaOptionsDropDown = $('<select class="m-t-10"></select>');

        // Add it to the second column ...
        objDynamicShapeOptions.OfficialAreaOptionsElements.SecondColumnDiv.append(objDynamicShapeOptions.OfficialAreaOptionsDropDown);

        //Create the buffer options div to contain the radio buttons
        objDynamicShapeOptions.BufferOptionsRadioButtonsElements = $('<div id="BufferOptionsRadioButtonsElements"></div>');
        objDynamicShapeOptions.DynamicShapeOptionsDiv.append(objDynamicShapeOptions.BufferOptionsRadioButtonsElements);

        // Create the 'Buffer Option' header ...
        objDynamicShapeOptions.BufferOptionsRadioButtonsElements.append('<div class="header-text">' + strBufferOptionText + ':</div>');

        // Create the no buffer options row div ...
        objDynamicShapeOptions.NoBufferOptionsElements = $('<div id="NoBufferOptionsElements"></div>');

        // Add it to the div ...
        objDynamicShapeOptions.BufferOptionsRadioButtonsElements.append(objDynamicShapeOptions.NoBufferOptionsElements);

        // Create the include radio button ...
        objDynamicShapeOptions.NoBufferRadioButton = $('<input BufferDynamicShape="false" type="radio"></input>');

        // Add it to the first column ...
        objDynamicShapeOptions.NoBufferOptionsElements.append(objDynamicShapeOptions.NoBufferRadioButton);

        // Add the 'No Buffer' span ...
        objDynamicShapeOptions.NoBufferOptionsElements.append('<span class="buffer-radio">' + strNoBufferRadioButtonText + ' </span>');

        if (!(TrimbleMap.DynamicShapeOptions.Shared.IsConditionShape(objDynamicShapeOptions)) && (objDynamicShapeOptions.ParentGeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON)) {
            objDynamicShapeOptions.NoBufferOptionsElements.append('<span>' + strNoBufferMessage + '</span>');
        }
        else {
            if ((objDynamicShapeOptions.ShapeGeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) && (objDynamicShapeOptions.ParentGeometryType != TrimbleMap.Shape.enumGeometryType.POLYGON)) {
                objDynamicShapeOptions.NoBufferOptionsElements.append('<span class="text-info">' + strNoBufferNotSupportedMessage + '</span>');
            }
            else {
                objDynamicShapeOptions.NoBufferOptionsElements.append('<span class="text-info">' + strNoBufferMessage + '</span>');
            }
        }

        // Create the buffer options first row div ...
        objDynamicShapeOptions.BufferOptionsElementsFirstRow = objDynamicShapeOptions.BuildInterfaceRow();
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.FirstColumnDiv.addClass('buffer');
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.SecondColumnDiv.addClass('buffer');
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.ThirdColumnDiv.addClass('buffer');

        // Add it to the div ...
        objDynamicShapeOptions.BufferOptionsRadioButtonsElements.append(objDynamicShapeOptions.BufferOptionsElementsFirstRow.RowDiv);

        // Create the buffer radio button ...
        objDynamicShapeOptions.BufferRadioButton = $('<input BufferDynamicShape="true" type="radio"></input>');

        // Add it to the first column ...
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.FirstColumnDiv.append(objDynamicShapeOptions.BufferRadioButton);

        // Add the 'Buffer shape' span ...
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.FirstColumnDiv.append('<span class="buffer-radio">' + strBufferShapeCheckboxText + '</span>');

        if (!TrimbleMap.DynamicShapeOptions.Shared.IsConditionShape(objDynamicShapeOptions) && objDynamicShapeOptions.ParentGeometryType != TrimbleMap.Shape.enumGeometryType.POLYGON) {
            // Add buffer not supported error message to the second column ...
            objDynamicShapeOptions.BufferOptionsElementsFirstRow.SecondColumnDiv.append('<span class="text-info">' + strBufferNotSupportedMessage + '</span>');
        }
        else {
            // Add derived shape geometry type dropdown label to the second column ...
            objDynamicShapeOptions.BufferOptionsElementsFirstRow.SecondColumnDiv.append('<span class="text-info">' + strOnlyBufferShapeMessage + '</span>');
        }

        // Create the geometry type drop down ...
        objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown = $('<select></select>');

        // Add it to the third column ...
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.ThirdColumnDiv.append(objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown);

        // Create the buffer options second row div ...
        objDynamicShapeOptions.BufferOptionsElementsSecondRow = objDynamicShapeOptions.BuildInterfaceRow();
        objDynamicShapeOptions.BufferOptionsElementsSecondRow.SecondColumnDiv.addClass('small');
        objDynamicShapeOptions.BufferOptionsElementsSecondRow.ThirdColumnDiv.addClass('small');

        // Add it to the div ...
        objDynamicShapeOptions.BufferOptionsRadioButtonsElements.append(objDynamicShapeOptions.BufferOptionsElementsSecondRow.RowDiv);

        // Add the 'Buffer distance by' span ...
        objDynamicShapeOptions.BufferOptionsElementsSecondRow.FirstColumnDiv.append('<span>' + strBufferDistance + ':</span>');

        // Create the buffer distance textbox ...
        objDynamicShapeOptions.BufferDistanceTextbox = $('<input type="textbox"></input>');

        // Add it to the third column ...
        objDynamicShapeOptions.BufferOptionsElementsSecondRow.SecondColumnDiv.append(objDynamicShapeOptions.BufferDistanceTextbox);

        // Create the by drop down ...
        objDynamicShapeOptions.BufferUnitsDropDown = $('<select></select>');

        // Add it to the second column ...
        objDynamicShapeOptions.BufferOptionsElementsSecondRow.ThirdColumnDiv.append(objDynamicShapeOptions.BufferUnitsDropDown);

        // Create the validation message div ...
        objDynamicShapeOptions.ValidationMessageDiv = $('<div></div>');

        // Add it to the div ...
        objDynamicShapeOptions.DynamicShapeOptionsDiv.append(objDynamicShapeOptions.ValidationMessageDiv);

        // When editable ...
        if (objDynamicShapeOptions.IsEditable != null && objDynamicShapeOptions.IsEditable) {

            // Create and add the OK and CANCEL buttons ...
            objDynamicShapeOptions.DynamicShapeOptionsDiv.append('<div class="text-right m-t-10"><button class="btn-primary" DynamicShapeOptionsOK="true">' + strOK + '</button> <button class="btn-secondary" DynamicShapeOptionsCANCEL="true">' + strCANCEL + '</button></div>');
        }

        // Populate the drop downs ...
        objDynamicShapeOptions.PopulateDropDowns();

        // When not editable ...
        if (objDynamicShapeOptions.IsEditable == null || !objDynamicShapeOptions.IsEditable) {

            // Get all the input elements ..
            var arrAllInputs = objDynamicShapeOptions.DynamicShapeOptionsDiv.find('input, select');

            // Set them all to be disabled and readnly ... 
            arrAllInputs.attr('disabled', true);
            arrAllInputs.attr('readonly', true);
        }
    }

    return objDynamicShapeOptions.DynamicShapeOptionsDiv;
}

// **************************************************************************
// FUNCTION: PopulateDynamicShapeOptions
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.PopulateDynamicShapeOptions = function PopulateDynamicShapeOptions() {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // Set the derived shape checkbox
    objDynamicShapeOptions.DerivedShapeCheckbox.attr('checked', objDynamicShapeOptions.IsDerivedShape);

    // Set the construct from checkbox values ...
    objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.IncludeCheckBox.attr('checked', objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedLicenses);
    objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.IncludeCheckBox.attr('checked', objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedAgreements);
    objDynamicShapeOptions.RelatedGroupDynamicShapeElements.IncludeCheckBox.attr('checked', objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedLicenseGroups);

    // Set the all check box values ...
    objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.AllCheckBox.attr('checked', (!objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedLicenses || (objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedLicenses && (objDynamicShapeOptions.DynamicShapeOptions.LicenseSearchID == SD.Guid.Shared.Empty()))));
    objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.AllCheckBox.attr('checked', (!objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedAgreements || (objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedAgreements && (objDynamicShapeOptions.DynamicShapeOptions.AgreementSearchID == SD.Guid.Shared.Empty()))));
    objDynamicShapeOptions.RelatedGroupDynamicShapeElements.AllCheckBox.attr('checked', (!objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedLicenseGroups || (objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedLicenseGroups && (objDynamicShapeOptions.DynamicShapeOptions.LicenseGroupSearchID == SD.Guid.Shared.Empty()))));

    // Set the filter seraches ...
    objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySearchDropDown.val(objDynamicShapeOptions.DynamicShapeOptions.LicenseSearchID);
    objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySearchDropDown.val(objDynamicShapeOptions.DynamicShapeOptions.AgreementSearchID);
    objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySearchDropDown.val(objDynamicShapeOptions.DynamicShapeOptions.LicenseGroupSearchID);

    if ((objDynamicShapeOptions.IsDerivedShape !== null) && (objDynamicShapeOptions.IsDerivedShape)) {
        // Set the buffer options ...
        if (objDynamicShapeOptions.DynamicShapeOptions.Buffer) {
            objDynamicShapeOptions.NoBufferRadioButton.prop('checked', false);
            objDynamicShapeOptions.BufferRadioButton.prop('checked', true);

        } else {
            objDynamicShapeOptions.BufferRadioButton.prop('checked', false);
            objDynamicShapeOptions.NoBufferRadioButton.prop('checked', true);
        }

        // Set the Derived Shape Geometry Type
        objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.val(objDynamicShapeOptions.DynamicShapeOptions.DerivedShapeGeometryType);
    }
    else {
        if ((objDynamicShapeOptions.NoBufferRadioButton.is(':checked')) || (objDynamicShapeOptions.BufferRadioButton.is(':checked'))) {
            // Set the buffer options ...
            objDynamicShapeOptions.BufferRadioButton.prop('checked', objDynamicShapeOptions.BufferRadioButton.is(':checked'));
            objDynamicShapeOptions.NoBufferRadioButton.prop('checked', objDynamicShapeOptions.NoBufferRadioButton.is(':checked'));
        }

        // Set the Derived Shape Geometry Type
        objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.val(SD.Guid.Shared.Empty());
    }

    objDynamicShapeOptions.BufferDistanceTextbox.val((objDynamicShapeOptions.DynamicShapeOptions.Buffer) ? SD.DisplayValue.FromDouble(objDynamicShapeOptions.DynamicShapeOptions.BufferDistance, objDynamicShapeOptions.StandardMapState.MapControllerState.GroupSeparator, objDynamicShapeOptions.StandardMapState.MapControllerState.DecimalSeparator, objDynamicShapeOptions.GetDistanceUnitDecimalPlaces(objDynamicShapeOptions.DynamicShapeOptions.BufferDistanceUnitID)) : '');
    objDynamicShapeOptions.BufferUnitsDropDown.val((objDynamicShapeOptions.DynamicShapeOptions.Buffer) ? objDynamicShapeOptions.DynamicShapeOptions.BufferDistanceUnitID : SD.Guid.Shared.Empty());

    // Set the official area options ...
    objDynamicShapeOptions.OfficialAreaOptionsDropDown.val(objDynamicShapeOptions.DynamicShapeOptions.OfficialAreaOption);
}

// **************************************************************************
// FUNCTION: ContructDynamicShapeOptions
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.ContructDynamicShapeOptions = function ContructDynamicShapeOptions() {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // Get the construct from checkbox values ...
    objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedLicenses = objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.IncludeCheckBox.is(':checked');
    objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedAgreements = objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.IncludeCheckBox.is(':checked');
    objDynamicShapeOptions.DynamicShapeOptions.ConstructFromRelatedLicenseGroups = objDynamicShapeOptions.RelatedGroupDynamicShapeElements.IncludeCheckBox.is(':checked');

    // Get the search ids ...
    objDynamicShapeOptions.DynamicShapeOptions.LicenseSearchID = objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.AllCheckBox.is(':checked') ? SD.Guid.Shared.Empty() : objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySearchDropDown.val();
    objDynamicShapeOptions.DynamicShapeOptions.AgreementSearchID = objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.AllCheckBox.is(':checked') ? SD.Guid.Shared.Empty() : objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySearchDropDown.val();
    objDynamicShapeOptions.DynamicShapeOptions.LicenseGroupSearchID = objDynamicShapeOptions.RelatedGroupDynamicShapeElements.AllCheckBox.is(':checked') ? SD.Guid.Shared.Empty() : objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySearchDropDown.val();

    // Get the buffer options ...
    if (objDynamicShapeOptions.DerivedShapeCheckbox && objDynamicShapeOptions.DerivedShapeCheckbox.is(':checked')) {
        objDynamicShapeOptions.DynamicShapeOptions.Buffer = objDynamicShapeOptions.BufferRadioButton.is(':checked');
    }

    objDynamicShapeOptions.DynamicShapeOptions.BufferDistance = SD.Number.ToNumber(objDynamicShapeOptions.BufferDistanceTextbox.val(), objDynamicShapeOptions.StandardMapState.MapControllerState.GroupSeparator, objDynamicShapeOptions.StandardMapState.MapControllerState.DecimalSeparator);
    objDynamicShapeOptions.DynamicShapeOptions.BufferDistanceUnitID = objDynamicShapeOptions.BufferUnitsDropDown.val();

    //Get the derived shape geometry type option
    if (objDynamicShapeOptions.NoBufferRadioButton.is(':checked')) {

        if (!TrimbleMap.DynamicShapeOptions.Shared.IsConditionShape(objDynamicShapeOptions)) {
            objDynamicShapeOptions.DynamicShapeOptions.DerivedShapeGeometryType = objDynamicShapeOptions.ShapeGeometryType;
        }
        else {
            objDynamicShapeOptions.DynamicShapeOptions.DerivedShapeGeometryType = objDynamicShapeOptions.ParentGeometryType;
        }
    }
    else {
        objDynamicShapeOptions.DynamicShapeOptions.DerivedShapeGeometryType = objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.val();
    }

    // Get the official area options ...
    objDynamicShapeOptions.DynamicShapeOptions.OfficialAreaOption = objDynamicShapeOptions.OfficialAreaOptionsDropDown.val();
}

// **************************************************************************
// FUNCTION: ShowOrHideElements
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.ShowOrHideElements = function ShowOrHideElements() {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // When the related license options is to be shown ...
    if (objDynamicShapeOptions.DynamicShapeOptions.ShowRelatedLicenseSearchOptions) {

        // Show the related license options ...
        objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.RowDiv.show();

        // When the related licenses checkbox is checked ...
        if (objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.IncludeCheckBox.is(':checked')) {

            // Show the all check box ...
            objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.SecondColumnDiv.show();

            // Show the filter search when all is not checked ...
            if (objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.AllCheckBox.is(':checked')) {
                objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySpan.hide();
                objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySearchDropDown.hide();
            } else {
                objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySpan.show();
                objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySearchDropDown.show();
            }

        } else {

            // Hide all the all checkbox and filter by search ...
            objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.SecondColumnDiv.hide();
            objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySpan.hide();
            objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySearchDropDown.hide();
        }

    } else {

        // Hide the related license options ...
        objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.RowDiv.hide();
    }

    // When the related agreement options is to be shown ...
    if (objDynamicShapeOptions.DynamicShapeOptions.ShowRelatedAgreementSearchOptions) {

        // Show the related license options ...
        objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.RowDiv.show();

        // When the related agreements checkbox is checked ...
        if (objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.IncludeCheckBox.is(':checked')) {

            // Show the all check box ...
            objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.SecondColumnDiv.show();

            // Show the filter search when all is not checked ...
            if (objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.AllCheckBox.is(':checked')) {
                objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySpan.hide();
                objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySearchDropDown.hide();
            } else {
                objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySpan.show();
                objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySearchDropDown.show();
            }

        } else {

            // Hide all the all checkbox and filter by search ...
            objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.SecondColumnDiv.hide();
            objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySpan.hide();
            objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySearchDropDown.hide();
        }

    } else {

        // Hide the related license options ...
        objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.RowDiv.hide();
    }

    // When the related group options is to be shown ...
    if (objDynamicShapeOptions.DynamicShapeOptions.ShowRelatedLicenseGroupSearchOptions) {

        // Show the related license options ...
        objDynamicShapeOptions.RelatedGroupDynamicShapeElements.RowDiv.show();

        // When the related group checkbox is checked ...
        if (objDynamicShapeOptions.RelatedGroupDynamicShapeElements.IncludeCheckBox.is(':checked')) {

            // Show the all check box ...
            objDynamicShapeOptions.RelatedGroupDynamicShapeElements.SecondColumnDiv.show();

            // Show the filter search when all is not checked ...
            if (objDynamicShapeOptions.RelatedGroupDynamicShapeElements.AllCheckBox.is(':checked')) {
                objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySpan.hide();
                objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySearchDropDown.hide();
            } else {
                objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySpan.show();
                objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySearchDropDown.show();
            }

        } else {

            // Hide all the all checkbox and filter by search ...
            objDynamicShapeOptions.RelatedGroupDynamicShapeElements.SecondColumnDiv.hide();
            objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySpan.hide();
            objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySearchDropDown.hide();
        }

    } else {

        // Hide the related license options ...
        objDynamicShapeOptions.RelatedGroupDynamicShapeElements.RowDiv.hide();
    }

    // Show the buffer distance and unit when buffer is checked ...
    if (objDynamicShapeOptions.BufferRadioButton.is(':checked')) {
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.ThirdColumnDiv.show();
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.SecondColumnDiv.show();
        objDynamicShapeOptions.BufferOptionsElementsSecondRow.RowDiv.show();
    }
    else {
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.ThirdColumnDiv.hide();
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.SecondColumnDiv.hide();
        objDynamicShapeOptions.BufferOptionsElementsSecondRow.RowDiv.hide();
    }

    if (!TrimbleMap.DynamicShapeOptions.Shared.IsConditionShape(objDynamicShapeOptions) && objDynamicShapeOptions.ParentGeometryType != TrimbleMap.Shape.enumGeometryType.POLYGON) {
        objDynamicShapeOptions.BufferOptionsElementsFirstRow.SecondColumnDiv.show();
    }

    // Get all the input elements ..
    var arrAllInputs = objDynamicShapeOptions.DynamicShapeOptionsDiv.find('input, select');

    if (objDynamicShapeOptions.DerivedShapeCheckbox.is(':checked') && (objDynamicShapeOptions.IsEditable != null && objDynamicShapeOptions.IsEditable)) {
        arrAllInputs.attr('disabled', false);
        arrAllInputs.attr('readonly', false);
    }
    else {
        arrAllInputs.attr('disabled', true);
        arrAllInputs.attr('readonly', true);
        if (objDynamicShapeOptions.IsEditable != null && objDynamicShapeOptions.IsEditable) {
            objDynamicShapeOptions.DerivedShapeCheckbox.attr('disabled', false);
            objDynamicShapeOptions.DerivedShapeCheckbox.attr('readonly', false);
        }
    }

    if (TrimbleMap.DynamicShapeOptions.Shared.IsConditionShape(objDynamicShapeOptions)) {
        // Set derived shape geometry type dropdown value and disable it
        objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.val(objDynamicShapeOptions.ParentGeometryType);
        objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.attr('disabled', true);
        objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.attr('readonly', true);
    }

}

// **************************************************************************
// FUNCTION: GetDistanceUnitDecimalPlaces
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.GetDistanceUnitDecimalPlaces = function GetDistanceUnitDecimalPlaces(guidDistanceUnit) {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // Start with no decimal places ...
    var intDecimalPlaces = SD.Number.NULL_NUMBER;

    // Loop through all the distance units ...
    $.each(objDynamicShapeOptions.StandardMapState.MapControllerState.DistanceUnits, function (intDistanceUnit, objDistanceUnit) {

        // When the distance unit id matches ...
        if (objDistanceUnit.ID == guidDistanceUnit) {

            // Set the decimal places ...
            intDecimalPlaces = objDistanceUnit.DecimalPlaces;

            // Stop searching ...
            return false;
        }
    });

    return intDecimalPlaces;
}

// **************************************************************************
// FUNCTION: Validate
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.Validate = function Validate() {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // Create a new array for the validation messages ...
    var arrValidationMessages = [];

    // When 'Related Licenses' is checked and 'All related licenses' is not checked and there is no search set ...
    if (objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.IncludeCheckBox.is(':checked') &&
        (!objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.AllCheckBox.is(':checked')) &&
        (objDynamicShapeOptions.RelatedLicenseDynamicShapeElements.FilterBySearchDropDown.val() == SD.Guid.Shared.Empty())) {

        // Add the validation message ...
        arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'LicenseSearchToFilterByNotSet'));
    }

    // When 'Related Agreements' is checked and 'All related agreements' is not checked and there is no search set ...
    if (objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.IncludeCheckBox.is(':checked') &&
        (!objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.AllCheckBox.is(':checked')) &&
        (objDynamicShapeOptions.RelatedAgreementDynamicShapeElements.FilterBySearchDropDown.val() == SD.Guid.Shared.Empty())) {

        // Add the validation message ...
        arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'AgreementSearchToFilterByNotSet'));
    }

    // When 'Related Groups' is checked and 'All related groups' is not checked and there is no search set ...
    if (objDynamicShapeOptions.RelatedGroupDynamicShapeElements.IncludeCheckBox.is(':checked') &&
        (!objDynamicShapeOptions.RelatedGroupDynamicShapeElements.AllCheckBox.is(':checked')) &&
        (objDynamicShapeOptions.RelatedGroupDynamicShapeElements.FilterBySearchDropDown.val() == SD.Guid.Shared.Empty())) {

        // Add the validation message ...
        arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'GroupSearchToFilterByNotSet'));
    }

    // When derived shape checkbox is checked
    if (objDynamicShapeOptions.DerivedShapeCheckbox.is(":checked")) {

        // When no official area units has been selected ...
        if (objDynamicShapeOptions.OfficialAreaOptionsDropDown.val() == 0) {

            // Add the validation message ...
            arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'OfficialAreaOptionNotSpecified'));
        }

        // When no buffer option is selected
        if (!objDynamicShapeOptions.BufferRadioButton.is(':checked') &&
            (!objDynamicShapeOptions.NoBufferRadioButton.is(':checked'))) {

            // Add the validation message ...
            arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'BufferOptionNotSpecified'));
        }

        // When 'No Buffer' is checked ...
        if (objDynamicShapeOptions.NoBufferRadioButton.is(':checked')) {
            if (TrimbleMap.DynamicShapeOptions.Shared.IsConditionShape(objDynamicShapeOptions) && (objDynamicShapeOptions.ShapeGeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) && (objDynamicShapeOptions.ParentGeometryType != TrimbleMap.Shape.enumGeometryType.POLYGON)) {
                arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'InvalidBufferOptionSelected'));
            }
        }

        // When 'Buffer' is checked ...
        if (objDynamicShapeOptions.BufferRadioButton.is(':checked')) {

            if (!TrimbleMap.DynamicShapeOptions.Shared.IsConditionShape(objDynamicShapeOptions) && objDynamicShapeOptions.ParentGeometryType != TrimbleMap.Shape.enumGeometryType.POLYGON) {
                arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'InvalidBufferOptionSelected'));
            }
            else {
                //when no geometry type has been selected ...
                if (objDynamicShapeOptions.DerivedShapeGeometryTypeDropDown.val() == SD.Guid.Shared.Empty()) {

                    //Add validation message
                    arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'GeometryTypeNotSpecified'));
                }

                if ((objDynamicShapeOptions.BufferDistanceTextbox.val()).trim() == '') {

                    // Add the validation message ...
                    arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'BufferDistanceNotSpecified'));

                } else {

                    // When the buffer distance is not a valid number ...
                    if (!SD.Number.ValidateIsNumber(objDynamicShapeOptions.BufferDistanceTextbox.val(),
                        objDynamicShapeOptions.StandardMapState.MapControllerState.GroupSeparator,
                        objDynamicShapeOptions.StandardMapState.MapControllerState.DecimalSeparator, false)) {

                        // Add the validation message ...
                        arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'InvalidBufferDistance'));
                    }
                }

                // When no buffer unit has been selected ...
                if (objDynamicShapeOptions.BufferUnitsDropDown.val() == SD.Guid.Shared.Empty()) {

                    // Add the validation message ...
                    arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'BufferDistanceUnitNotSpecified'));
                }

                // When ComponentShapeOfficialAreas has been selected as the no official area computation option ...
                if (objDynamicShapeOptions.OfficialAreaOptionsDropDown.val() == TrimbleMap.ShapeEditor.enumDynamicShapeOfficialAreaOptions.ComponentShapeOfficialAreas) {

                    // Add the validation message ...
                    arrValidationMessages.push(SD.Translation.Shared.GetTranslation('Map.DynamicShapeOptions.js', 'BufferingCannotBeEnabledWithSumOfComponentShapeOfficialAreas'));
                }
            }
        }

    }

    // Show the validation messages ...
    objDynamicShapeOptions.ShowValidationMessages(arrValidationMessages);

    // Only valid when no validation messages ...
    var blnValid = (arrValidationMessages.length == 0);

    return blnValid;
}

// **************************************************************************
// FUNCTION: ShowValidationMessages
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.ShowValidationMessages = function ShowValidationMessages(arrValidationMessages) {

    // Get the instance ...
    var objDynamicShapeOptions = this;

    // Clear the validation message div ...
    objDynamicShapeOptions.ValidationMessageDiv.empty();

    // Loop through all the validation messages ...
    $.each(arrValidationMessages, function (intValidationMessage, strValidationMessage) {

        // Create and add a span with the validation message ...
        objDynamicShapeOptions.ValidationMessageDiv.append('<span class="shape_dynamic_shape_validation_span">* ' + strValidationMessage + '</span><br />');
    });
}

// **************************************************************************
// FUNCTION: SetDefaultOptions
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.Shared.SetDefaultOptions = function SetDefaultOptions(objDynamicShapeOptions) {

    // Set the dynamic shape options to default values ...
    objDynamicShapeOptions.ConstructFromRelatedLicenses = false;
    objDynamicShapeOptions.ConstructFromRelatedAgreements = false;
    objDynamicShapeOptions.ConstructFromRelatedLicenseGroups = false;
    objDynamicShapeOptions.LicenseSearchID = SD.Guid.Shared.Empty();
    objDynamicShapeOptions.AgreementSearchID = SD.Guid.Shared.Empty();
    objDynamicShapeOptions.LicenseGroupSearchID = SD.Guid.Shared.Empty();
    objDynamicShapeOptions.Buffer = false;
    objDynamicShapeOptions.BufferDistance = 0;
    objDynamicShapeOptions.BufferDistanceUnitID = SD.Guid.Shared.Empty();
    objDynamicShapeOptions.OfficialAreaOption = 0;
    objDynamicShapeOptions.ShapeGeometryType = "";
    objDynamicShapeOptions.DerivedShapeGeometryType = SD.Guid.Shared.Empty();
}

// **************************************************************************
// FUNCTION: IsConditionShape 
// USAGE:    
// **************************************************************************
TrimbleMap.DynamicShapeOptions.Shared.IsConditionShape = function IsConditionShape(objDynamicShapeOptions) {
    var blnReturn = false;
    if (!(objDynamicShapeOptions.DynamicShapeOptions.ShowRelatedLicenseSearchOptions || objDynamicShapeOptions.DynamicShapeOptions.ShowRelatedAgreementSearchOptions || objDynamicShapeOptions.DynamicShapeOptions.ShowRelatedLicenseGroupSearchOptions)) {
        blnReturn = true;
    }
    return blnReturn;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Expander = {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Expander.CreateInstance = function CreateInstance(objSideBar, objMapContainerElement, objMapElement, blnVisible, objStandardMap) {

    // Create the object that will hold the instance properties ...
    var objExpandMapInstance = {
        Sidebar: objSideBar,
        MapContainerElement: objMapContainerElement,
        StandardMap: objStandardMap,
        MapElement: objMapElement,
        Visible: blnVisible,
        ClickedProxy: function (objMenuItem) { objExpandMapInstance.Clicked(objMenuItem) },

        CreateMaxMinIcon: TrimbleMap.Expander.CreateMaxMinIcon,
        MaximizeOrMimimizeMap: TrimbleMap.Expander.MaximizeOrMimimizeMap,
        ToggleModulesVisibility: TrimbleMap.Expander.ToggleModulesVisibility,

        AttachEventHandlers: TrimbleMap.Expander.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Expander.DetachEventHandlers,
        Clicked: TrimbleMap.Expander.Clicked,
        Show: TrimbleMap.Expander.Show,
        Hide: TrimbleMap.Expander.Hide,

        AddOnBeforeMaximizeOrMinimizeMapCallback: TrimbleMap.Expander.AddOnBeforeMaximizeOrMinimizeMapCallback,
        OnBeforeMaximizeOrMinimizeMapFunctions: []
    };

    // Create the menu item ...
    objExpandMapInstance.ExpandMapButton = objExpandMapInstance.CreateMaxMinIcon();

    // Attach event handlers
    objExpandMapInstance.AttachEventHandlers();

    // Do not show the menu button when its to be invisible at startup ...
    if (!blnVisible) {
        // Set visibility to true temporary so that ExpandMapButton can be hidden
        objExpandMapInstance.Visible = true;
        objExpandMapInstance.Hide();
    }

    return objExpandMapInstance;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    
// **************************************************************************
TrimbleMap.Expander.Show = function Show() {

    // Get the instance ...
    var objExpandMap = this;

    // When not visible ...
    if (!objExpandMap.Visible) {
        // Attach event handlers
        objExpandMap.AttachEventHandlers();

        // Show expand button
        objExpandMap.ExpandMapButton.show();

        // Set to be visible ...
        objExpandMap.Visible = true;
    }
}

TrimbleMap.Expander.CreateMaxMinIcon = function CreateMaxMinIcon() {

    //Get the instance
    var objExpandMap = this;

    // Create the max/min icon, with maximize one shown to start ...
    var objMaxMinIcon = $('<div class="maximize_minimize_icon maximize_image"></div>');

    // Add it to the map element ...
    objExpandMap.MapElement.append(objMaxMinIcon);

    return objMaxMinIcon;
}


TrimbleMap.Expander.MaximizeOrMimimizeMap = function MaximizeOrMimimizeMap() {

    //Get the instance
    var objExpandMap = this;

    //Suspend Drawing of all layers to prevent erroneous behaviour
    objExpandMap.StandardMap.MapController.SuspendAllLayers();

    //Get the extent to return to after the expansion has happened
    var objPreExpandExtent = objExpandMap.StandardMap.MapController.EsriMap.extent;

    let blnIsInPopup = (objExpandMap.MapContainerElement.parents().find(".ModalDialogHost").length > 0);

    if (!blnIsInPopup) {
        //Loop through all the on maximize or minimize functions ...
        $.each(objExpandMap.OnBeforeMaximizeOrMinimizeMapFunctions, function (intBeforeMaximizeOrMinimizeMapFunction, fnBeforeMaximizeOrMimimizeMapCallback) {

            // Call the callback ...
            fnBeforeMaximizeOrMimimizeMapCallback();

        });
    }

    if (!objExpandMap.MapContainerElement.hasClass('fullscreen') || blnIsInPopup) {

        //when the map is opened in the popup
        if (blnIsInPopup) {
            //get the dialog element
            var objDialogElement = objExpandMap.MapContainerElement.parents().find(".ModalDialogHost");

            if (!objDialogElement.hasClass('fullscreen')) {

                objExpandMap.ExpandMapButton.addClass('minimize_image');
                objExpandMap.ExpandMapButton.removeClass('maximize_image');

                objDialogElement.addClass("fullscreen");

                //copy inline style. Will be required when the exiting full screen mode
                objExpandMap.ClonedDialogStyles = objDialogElement.attr("style");

                //copy the width of the map element before maximising
                objExpandMap.MapSizeBeforeMaximize = objExpandMap.MapContainerElement.width();

                //remove inline style on the dialog element
                objDialogElement.removeAttr("style");

                //hide title bar
                objExpandMap.MapElement.parents().find(".TitleBarPinned:visible").hide();

                objDialogElement.css("max-height", "100%");

                //remove margins from the container. This are inherited from a class so there is no need to save them.
                $('.ConditionEditorContainer').css("margin", "0px");

                //hide overlay
                $('.ModalDialogTransparentPageDiv').hide();

                $(".ModalDialogHost").addClass("maximize");
                $("[modalorder]").addClass("maximize");
                $("[modalorder]").css("overflow", "hidden");
                $(".ConditionShapeDiv").addClass("maximize");
                $(".map_container").addClass("maximize");
                $(".ConditionDetailShapeTab").addClass("maximize");
                $(".shape_condition_TabBody_override").addClass("maximize");
                $(".ConditionEditorContainer").addClass("maximize");
                $(".ConditionDetailTab").addClass("maximize");

                if (objExpandMap.MapContainerElement.parents().find(".fullscreen").length > 0) {
                    var objParentDIv = $('.map_container').parent();

                    objParentDIv.prevAll().each(function () {
                        $(this).hide();
                    });

                    objParentDIv = $('.shape_condition_TabBody_override');

                    objParentDIv.prevAll().each(function () {
                        $(this).hide();
                    });
                }
            }
            else {


                objExpandMap.ExpandMapButton.removeClass('minimize_image');
                objExpandMap.ExpandMapButton.addClass('maximize_image');

                objDialogElement.removeClass("fullscreen");

                objDialogElement.attr("style", objExpandMap.ClonedDialogStyles);
                objExpandMap.ClonedDialogStyles = null;
                objExpandMap.MapElement.parents().find(".TitleBarPinned:visible").show();
                $('.ModalDialogTransparentPageDiv').show();

                $('.ConditionEditorContainer').css("margin", "");

                $(".ModalDialogHost").removeClass("maximize");
                $("[modalorder]").removeClass("maximize");
                $("[modalorder]").css("overflow", "");
                $(".ConditionShapeDiv").removeClass("maximize");
                $(".map_container").removeClass("maximize");
                $(".ConditionDetailShapeTabViewMode").removeClass("maximize");
                $(".shape_condition_TabBody_override").removeClass("maximize");
                $(".ConditionEditorContainer").removeClass("maximize");
                $(".ConditionDetailTab").removeClass("maximize");

                objExpandMap.MapContainerElement.width(objExpandMap.MapSizeBeforeMaximize);

                if (objExpandMap.MapContainerElement.parents().find(".fullscreen").length == 0) {
                    var objParentDIv = $('.map_container').parent();

                    objParentDIv.prevAll().each(function () {
                        $(this).show();
                    });

                    objParentDIv = $('.shape_condition_TabBody_override');

                    objParentDIv.prevAll().each(function () {
                        $(this).show();
                    });
                }
            }
        }
        else {

            // The map view is not expanded, therefore hide the Maximize image, show the Minimize image and expand map view
            objExpandMap.ExpandMapButton.addClass('minimize_image');
            objExpandMap.ExpandMapButton.removeClass('maximize_image');
            objExpandMap.MapElement.addClass('fullscreen');
            objExpandMap.MapContainerElement.addClass('fullscreen');

            if (window != window.top) {
                //get the height of all pinned and visible elements from all the parents
                var intFixedElementsHeight = objExpandMap.MapElement.parents().find(".TitleBarPinned:visible").height();

                objExpandMap.MapElement.css({ "inset-block-start": intFixedElementsHeight + "px" });
                objExpandMap.MapContainerElement.css({ "inset-block-start": intFixedElementsHeight + "px" });
            }
        }

    } else {

        //get the height of all pinned and visible elements from all the parents
        var intFixedElementsHeight = objExpandMap.MapElement.parents().find(".TitleBarPinned:visible").height();

        // The view map is expanded, therefore hide the Minimize image, show the Maximize image and contract map to original size
        objExpandMap.ExpandMapButton.removeClass('minimize_image');
        objExpandMap.ExpandMapButton.addClass('maximize_image');
        objExpandMap.MapElement.removeClass('fullscreen');
        objExpandMap.MapContainerElement.removeClass('fullscreen');

        if (window != window.top) {
            objExpandMap.MapElement.css({ "inset-block-start": "0px" });
            objExpandMap.MapContainerElement.css({ "inset-block-start": "0px" });
        }

    }

    objExpandMap.StandardMap.ResizeMap();
    objExpandMap.StandardMap.MapController.EsriMap.resize(true);

    objExpandMap.ToggleModulesVisibility();

    let objSetMapExtentDeferred = objExpandMap.StandardMap.MapController.SetMapExtent(objPreExpandExtent);

    //When setting extent (and zooming if necessary) is done - resume all the layers
    objSetMapExtentDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

        // Resume drawing of the tile layers ...
        objExpandMap.StandardMap.MapController.ResumeAllLayers();
    }));

}


// **************************************************************************
// FUNCTION: ToggleModulesVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.Expander.ToggleModulesVisibility = function ToggleModulesVisibility() {

    // Get the instance ...
    var objExpandMap = this;

    if (objExpandMap.StandardMap.OverrideModuleVisibilityInDefaultView) {

        let blnIsInPopup = (objExpandMap.MapContainerElement.parents().find(".ModalDialogHost").length > 0);

        let blnIsInFullScreen = blnIsInPopup ?
            objExpandMap.MapContainerElement.parents().find(".ModalDialogHost").hasClass('fullscreen') :
            objExpandMap.MapContainerElement.hasClass('fullscreen');

        if (blnIsInFullScreen) {

            // The view has been toggled to full screen therefore show the modules
            if (objExpandMap.StandardMap.HasMenu) { TrimbleMap.c_objMapMenuInstance.Show(); }
            if (objExpandMap.StandardMap.HasModeButtons) { objExpandMap.StandardMap.ModeButtons.Show(); }
            if (objExpandMap.StandardMap.ShowSidebarAutomatically && objExpandMap.StandardMap.Sidebar.VisibilityState !== SD.Sidebar.enumVisibilityState.Visible) { objExpandMap.StandardMap.Sidebar.Show(SD.Sidebar.enumDisplayMethod.NoFadeOrSlide); }

        } else {

            // The view has been toggled from full screen therefore hide the modules
            if (objExpandMap.StandardMap.HasMenu) { TrimbleMap.c_objMapMenuInstance.Hide(); }
            if (objExpandMap.StandardMap.HasModeButtons) { objExpandMap.StandardMap.ModeButtons.Hide(); }
            if (objExpandMap.StandardMap.ShowSidebarAutomatically && objExpandMap.StandardMap.Sidebar.VisibilityState !== SD.Sidebar.enumVisibilityState.Hidden) { objExpandMap.StandardMap.Sidebar.Hide(SD.Sidebar.enumDisplayMethod.NoFadeOrSlide); }
        }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
TrimbleMap.Expander.Hide = function Hide() {

    // Get the instance ...
    var objExpandMap = this;

    // When visible ...
    if (objExpandMap.Visible) {
        // Detach event handlers
        objExpandMap.DetachEventHandlers();

        // Remove the menu item ...
        objExpandMap.ExpandMapButton.hide();

        // Set to not be visible ...
        objExpandMap.Visible = false;
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Expander.AttachEventHandlers = function AttachEventHandlers() {

    // Get the map zoom instance ...
    var objExpandMap = this;

    // Attach the clicked event handler to the expand button ...
    objExpandMap.ExpandMapButton.on('click', (objExpandMap.ClickedProxy));
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Expander.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map zoom instance ...
    var objExpandMap = this;

    // Detach the clicked event handler from the export button ...
    objExpandMap.ExpandMapButton.off('click', objExpandMap.ClickedProxy);
}


// **************************************************************************
// FUNCTION: Clicked
// USAGE:    
// **************************************************************************
TrimbleMap.Expander.Clicked = function Clicked(objMenuItem) {

    // Get the instance ...
    var objExpandMap = this;

    // Maximize or minimize the map
    objExpandMap.MaximizeOrMimimizeMap();
}

// **************************************************************************
// FUNCTION: AddOnBeforeMaximizeOrMinimizeMapCallback
// USAGE:    
// **************************************************************************
TrimbleMap.Expander.AddOnBeforeMaximizeOrMinimizeMapCallback = function AddOnBeforeMaximizeOrMinimizeMapCallback(fnBeforeMaximizeOrMimimizeMapCallback) {

    // Get the instance ...
    var objExpandMap = this;

    //add the callback delegate to the callback delegate list
    objExpandMap.OnBeforeMaximizeOrMinimizeMapFunctions.push(fnBeforeMaximizeOrMimimizeMapCallback);

}
/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.FixInvalidShape = {};
TrimbleMap.FixInvalidShape.Shared = {}
TrimbleMap.FixInvalidShape.Shared.SIDEBAR_TAB_WIDTH = 300;
TrimbleMap.FixInvalidShape.Shared.MAX_EXCEPTIONS_TO_LOAD = 1000;

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.CreateInstance = function CreateInstance(objMapController, objSidebar, blnVisible, strTabName, strTabCaption, objInvalidShapes, objMissingGeometries) {

    // Create the instance ...
    var objFixInvalidShape = {
        MapController: objMapController,
        Sidebar: objSidebar,
        Visible: false,
        InvalidShapes: objInvalidShapes,
        MissingGeometries: objMissingGeometries,
        FixInvalidShapeDiv: null,
        FixInvalidShapeTabItem: null,
        TabName: strTabName,
        TabCaption: strTabCaption,
        MessagesDiv: null,
        ScrollableContainerDiv: null,
        ScrollableInnerContainerDiv: null,
        NoInvalidShapesDiv: null,
        NiceScroll: null,
        DisplayShapeCallbacks: [],
        LastScrollTop: 0,
        ExceptionsLoaded: 0,

        HandleDiagnosticMessageLoggedProxy: function (objDiagnosticMessage) { objFixInvalidShape.HandleDiagnosticMessageLogged(objDiagnosticMessage); },
        ClickedProxy: function (e) { objFixInvalidShape.Clicked(e); },
        ScrolledProxy: function (e) { objFixInvalidShape.Scrolled(e); },

        CreateElements: TrimbleMap.FixInvalidShape.CreateElements,
        ActivateTab: TrimbleMap.FixInvalidShape.ActivateTab,
        DeActivateTab: TrimbleMap.FixInvalidShape.DeActivateTab,
        ResizeTab: TrimbleMap.FixInvalidShape.ResizeTab,
        AttachEventHandlers: TrimbleMap.FixInvalidShape.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.FixInvalidShape.DetachEventHandlers,
        UpdateScrollbar: TrimbleMap.FixInvalidShape.UpdateScrollbar,
        UpdateNoInvalidShapesDivVisibility: TrimbleMap.FixInvalidShape.UpdateNoInvalidShapesDivVisibility,
        Clicked: TrimbleMap.FixInvalidShape.Clicked,
        PopulateMessagesDiv: TrimbleMap.FixInvalidShape.PopulateMessagesDiv,
        GetShapeUpdateExceptionByID: TrimbleMap.FixInvalidShape.GetShapeUpdateExceptionByID,
        GetMissingGeometryByID: TrimbleMap.FixInvalidShape.GetMissingGeometryByID,
        AddDisplayShapeCallback: TrimbleMap.FixInvalidShape.AddDisplayShapeCallback,
        TriggerDisplayShapeCallbacks: TrimbleMap.FixInvalidShape.TriggerDisplayShapeCallbacks,
        DisplayShape: TrimbleMap.FixInvalidShape.DisplayShape,
        GetShape: TrimbleMap.FixInvalidShape.GetShape,
        EvaluateShapeIsSelfIntersectingResult: TrimbleMap.FixInvalidShape.EvaluateShapeIsSelfIntersectingResult,
        UpdateSelfIntersectionElements: TrimbleMap.FixInvalidShape.UpdateSelfIntersectionElements,
        Scrolled: TrimbleMap.FixInvalidShape.Scrolled,
        Show: TrimbleMap.FixInvalidShape.Show,
        Hide: TrimbleMap.FixInvalidShape.Hide
    };

    // Create the menu icon ...
    objFixInvalidShape.CreateElements();

    // Create the sidebar tab ...
    objFixInvalidShape.FixInvalidShapeTabItem = SD.Sidebar.Shared.CreateTabItem(objFixInvalidShape.TabName, objFixInvalidShape.TabCaption,
        TrimbleMap.StandardMap.Shared.enumTabOrder.FIXINVALIDSHAPES,
        function (objTabContainerElement, enTabActivationMethod) { objFixInvalidShape.ActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement, enTabActivationMethod) { objFixInvalidShape.DeActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement) { objFixInvalidShape.ResizeTab(objTabContainerElement); },
        function () { return TrimbleMap.FixInvalidShape.Shared.SIDEBAR_TAB_WIDTH; });

    // Show the tab when it's to be visible at startup ...
    if (blnVisible) { objFixInvalidShape.Show(false, false); }

    return objFixInvalidShape;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
//           blnSelectTab is optional, defaults to true
// **************************************************************************
TrimbleMap.FixInvalidShape.Show = function Show(blnTriggerNotifyModuleVisibilityChanged, blnSelectTab) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objFixInvalidShape.Visible) {

        // Add the tab ...
        objFixInvalidShape.Sidebar.AddTab(objFixInvalidShape.FixInvalidShapeTabItem);

        // When we are to select the tab ...
        if ((typeof blnSelectTab == 'undefined') || (blnSelectTab == null) || blnSelectTab) {

            // Select the tab ...
            objFixInvalidShape.Sidebar.SelectTab(objFixInvalidShape.FixInvalidShapeTabItem);
        }

        // Set to be visible ...
        objFixInvalidShape.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objFixInvalidShape.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.FixInvalidShape, true); }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.FixInvalidShape.Hide = function Hide() {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { var blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objFixInvalidShape.Visible) {

        // Detach all the event handlers (if attached) ...
        objFixInvalidShape.DetachEventHandlers();

        // Remove the tab ...
        objFixInvalidShape.Sidebar.RemoveTab(objFixInvalidShape.FixInvalidShapeTabItem);

        // Set to not be visible ...
        objFixInvalidShape.Visible = false;

        // Notify that the module visibility changed to false ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objFixInvalidShape.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.FixInvalidShape, false); }
    }
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.CreateElements = function CreateElements() {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Create the div for the tab ...
    objFixInvalidShape.FixInvalidShapeDiv = $('<div class="FixInvalidShape_tab_div"></div>');

    // Create the div that will contain all the content (with margins) ...
    var objContainerDiv = $('<div class="FixInvalidShape_container_div"></div>');

    // Add it to the tab div ...
    objFixInvalidShape.FixInvalidShapeDiv.append(objContainerDiv);

    // Get the translation for the heading ...

    // Geometry Errors
    let strHeading = SD.Translation.Shared.GetTranslation('Map.FixInvalidShapes.js', 'GeometryErrorTitle');

    var intInvalidShapes = objFixInvalidShape.InvalidShapes.length + objFixInvalidShape.MissingGeometries.length;

    // Create the heading div ...
    var objHeadingDiv = $('<div class="FixInvalidShape_heading"><span class="FixInvalidShape_heading_span">' + strHeading + '</span><span class="FixInvalidShape_count_span" CountSpan="true">(' + intInvalidShapes + ')</span></div>');

    // Add it to the container ...
    objContainerDiv.append(objHeadingDiv);

    // Create the div to contain the scrollable div ...
    objFixInvalidShape.ScrollableContainerDiv = $('<div class="FixInvalidShape_scrollable_container_div"></div>');

    // Add it to the container ...
    objContainerDiv.append(objFixInvalidShape.ScrollableContainerDiv);

    // Create the div that will be scrolled ...
    objFixInvalidShape.ScrollableInnerContainerDiv = $('<div class="FixInvalidShape_scrollable_inner_container_div"></div>');

    // Add it to the container div ...
    objFixInvalidShape.ScrollableContainerDiv.append(objFixInvalidShape.ScrollableInnerContainerDiv);

    // Create the div that will contain the diagnostic messages ...
    objFixInvalidShape.MessagesDiv = $('<div class="FixInvalidShape_table_div"></div>');

    // Populate the messages div ...
    objFixInvalidShape.PopulateMessagesDiv();

    // When we have more than the maximum number of excpetions to load ...
    if (objFixInvalidShape.ExceptionsLoaded >= TrimbleMap.FixInvalidShape.Shared.MAX_EXCEPTIONS_TO_LOAD) {

        // Update the count span ...
        $(objHeadingDiv.find('[CountSpan]')).text('(' + TrimbleMap.FixInvalidShape.Shared.MAX_EXCEPTIONS_TO_LOAD + ' out of ' + intInvalidShapes + ')');
    }

    // Add it to the inner div ...
    objFixInvalidShape.ScrollableInnerContainerDiv.append(objFixInvalidShape.MessagesDiv);

    // Get a translation ...

    // No invalid shapes
    var strNoMessages = SD.Translation.Shared.GetTranslation('Map.FixInvalidShapes.js', 'NoInvalidShapes');

    // Create the no messages div ...
    objFixInvalidShape.NoInvalidShapesDiv = $('<div class="FixInvalidShape_no_messages_div">' + strNoMessages + '</div>');

    // Add it to the inner div ...
    objFixInvalidShape.ScrollableInnerContainerDiv.append(objFixInvalidShape.NoInvalidShapesDiv);

    // Hide or show the no messages div ...
    objFixInvalidShape.UpdateNoInvalidShapesDivVisibility();
}

// **************************************************************************
// FUNCTION: PopulateMessagesDiv
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.PopulateMessagesDiv = function PopulateMessagesDiv() {

    // Get the instance ...
    var objFixInvalidShape = this;

    var blnMaxExceptionsLoaded = false;

    // Loop through all the invalid shapes ...
    $.each(objFixInvalidShape.InvalidShapes, function (intInvalidShape, objInvalidShape) {

        // Create a div for the message ...
        var objMessageDiv = $('<div class="FixInvalidShape_message_div" ShapeUpdateExceptionID="' + objInvalidShape.ID + '">' +
            ((objInvalidShape.ObjectType) ? '<span class="FixInvalidShape_message_bold_text">' + objInvalidShape.ObjectType + '</span></br>' : '<span class="FixInvalidShape_message_bold_text">Not associated with any objects</span></br>') +
            ((objInvalidShape.Code) ? '<span class="FixInvalidShape_message_normal_text">Code:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text FixInvalidShape_message_link" ViewEditorPage="true">' + objInvalidShape.Code + '</span></br>' : '') +
            ((objInvalidShape.Name) ? '<span class="FixInvalidShape_message_normal_text">Name:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text FixInvalidShape_message_link" ViewEditorPage="true">' + objInvalidShape.Name + '</span></br>' : '') +
            ((objInvalidShape.ShapePart) ? '<span class="FixInvalidShape_message_normal_text">Part:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objInvalidShape.ShapePart + '</span></br>' : '') +
            ((objInvalidShape.ReferencePoint) ? '<span class="FixInvalidShape_message_normal_text">Reference Point:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objInvalidShape.ReferencePoint + '</span></br>' : '') +
            ((objInvalidShape.ActionType) ? '<span class="FixInvalidShape_message_normal_text">Action Type:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objInvalidShape.ActionType + '</span></br>' : '') +
            ((objInvalidShape.ActionShapeType) ? '<span class="FixInvalidShape_message_normal_text">Shape Type:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objInvalidShape.ActionShapeType + '</span></br>' : '') +
            ((objInvalidShape.ShapeSpatialReference) ? '<span class="FixInvalidShape_message_normal_text">Coordinate System:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objInvalidShape.ShapeSpatialReference + '</span></br>' : '') +
            '<div style="margin-top:5px"></div><span class="FixInvalidShape_message_normal_text">Error:</span>' +
            '<div>' +
            ((objInvalidShape.FailedSpatialReference) ? '<span class="FixInvalidShape_message_normal_text">Failed to build geometry in</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objInvalidShape.FailedSpatialReference + '.</span></br>' : '') +
            ((objInvalidShape.ShapeSpatialReference) ? '<span class="FixInvalidShape_link_span" ViewInOriginalCoordinateSystem>View in original coordinate system</span><br/>' : '') +
            '<div TestIsSelfIntersectingLink="true"><span class="FixInvalidShape_link_span">Test: Is self intersecting?</span><br/></div>' +
            '<div style="display:none"><span class="FixInvalidShape_message_italic_text" IsSelfIntersectingResult="true">Part simple or not</span><br/></div><br/>' +
            '<span class="FixInvalidShape_message_italic_text">' + objInvalidShape.Exception + '</span>' +
            '</div>' +
            '</div>' +
            '<div class="FixInvalidShape_spacer"></div>');

        // Add it to the messages div ...
        objFixInvalidShape.MessagesDiv.append(objMessageDiv);

        // Increment exceptions loaded ...
        objFixInvalidShape.ExceptionsLoaded++;

        // When we've loaded the max to load ...
        if (objFixInvalidShape.ExceptionsLoaded >= TrimbleMap.FixInvalidShape.Shared.MAX_EXCEPTIONS_TO_LOAD) {
            blnMaxExceptionsLoaded = true;
            return false;
        }
    });

    if (!blnMaxExceptionsLoaded) {
        // Loop through all the invalid shapes ...
        $.each(objFixInvalidShape.MissingGeometries, function (intMissingGeometry, objMissingGeometry) {

            // Create a div for the message ...
            var objMessageDiv = $('<div class="FixInvalidShape_message_div" MissingGeometryID="' + objMissingGeometry.ID + '">' +
                ((objMissingGeometry.ObjectType) ? '<span class="FixInvalidShape_message_bold_text">' + objMissingGeometry.ObjectType + '</span></br>' : '<span class="FixInvalidShape_message_bold_text">Not associated with any objects</span></br>') +
                ((objMissingGeometry.Code) ? '<span class="FixInvalidShape_message_normal_text">Code:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text FixInvalidShape_message_link" ViewEditorPage="true">' + objMissingGeometry.Code + '</span></br>' : '') +
                ((objMissingGeometry.Name) ? '<span class="FixInvalidShape_message_normal_text">Name:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text FixInvalidShape_message_link" ViewEditorPage="true">' + objMissingGeometry.Name + '</span></br>' : '') +
                ((objMissingGeometry.ShapePart) ? '<span class="FixInvalidShape_message_normal_text">Part:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objMissingGeometry.ShapePart + '</span></br>' : '') +
                ((objMissingGeometry.ReferencePoint) ? '<span class="FixInvalidShape_message_normal_text">Reference Point:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objMissingGeometry.ReferencePoint + '</span></br>' : '') +
                ((objMissingGeometry.ActionType) ? '<span class="FixInvalidShape_message_normal_text">Action Type:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objMissingGeometry.ActionType + '</span></br>' : '') +
                ((objMissingGeometry.ActionShapeType) ? '<span class="FixInvalidShape_message_normal_text">Shape Type:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objMissingGeometry.ActionShapeType + '</span></br>' : '') +
                ((objMissingGeometry.ShapeSpatialReference) ? '<span class="FixInvalidShape_message_normal_text">Coordinate System:</span>&nbsp;' + '<span class="FixInvalidShape_message_bold_text">' + objMissingGeometry.ShapeSpatialReference + '</span></br>' : '') +
                '<div style="margin-top:5px"></div><span class="FixInvalidShape_message_normal_text">Error:</span>' +
                '<div><span class="FixInvalidShape_message_italic_text">' + objMissingGeometry.Exception + '.</span></div>' +
                '</div>' +
                '<div class="FixInvalidShape_spacer"></div>');

            // Add it to the messages div ...
            objFixInvalidShape.MessagesDiv.append(objMessageDiv);

            // Increment exceptions loaded ...
            objFixInvalidShape.ExceptionsLoaded++;

            // When we've loaded the max to load ...
            if (objFixInvalidShape.ExceptionsLoaded >= TrimbleMap.FixInvalidShape.Shared.MAX_EXCEPTIONS_TO_LOAD) {
                blnMaxExceptionsLoaded = true;
                return false;
            }
        });
    }
}

// **************************************************************************
// FUNCTION: GetShapeUpdateExceptionByID
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.GetShapeUpdateExceptionByID = function GetShapeUpdateExceptionByID(guidShapeUpdateException) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Start with not found ...
    var objShapeUpdateException = null;

    // Loop through all the update exceptions ...
    $.each(objFixInvalidShape.InvalidShapes, function (intInvalidShape, objInvalidShape) {

        // When the id matches ...
        if (objInvalidShape.ID == guidShapeUpdateException) {

            // Set to return  ...
            objShapeUpdateException = objInvalidShape;

            // Stop looping ...
            return false;
        }
    });

    return objShapeUpdateException;
}

// **************************************************************************
// FUNCTION: GetMissingGeometryByID
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.GetMissingGeometryByID = function GetMissingGeometryByID(guidMissingGeometry) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Start with not found ...
    var objMissingGeometry = null;

    // Loop through all the missing geometries ...
    $.each(objFixInvalidShape.MissingGeometries, function (intMissingGeometry, objInternalMissingGeometry) {

        // When the id matches ...
        if (objInternalMissingGeometry.ID == guidMissingGeometry) {

            // Set to return  ...
            objMissingGeometry = objInternalMissingGeometry;

            // Stop looping ...
            return false;
        }
    });

    return objMissingGeometry;
}

// **************************************************************************
// FUNCTION: AddDisplayShapeCallback
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.AddDisplayShapeCallback = function AddDisplayShapeCallback(fnCallback) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Add to the list of callbacks ...
    objFixInvalidShape.DisplayShapeCallbacks.push(fnCallback);
}

// **************************************************************************
// FUNCTION: TriggerDisplayShapeCallbacks
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.TriggerDisplayShapeCallbacks = function TriggerDisplayShapeCallbacks(objShape, objShapeUpdateException) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Loop through all the callbacks ...
    $.each(objFixInvalidShape.DisplayShapeCallbacks, function (intDisplayShapeCallback, fnDisplayShapeCallback) {

        // Call the callback ...
        fnDisplayShapeCallback(objShape, objShapeUpdateException);
    });
}

// **************************************************************************
// FUNCTION: LoadShape
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.LoadShape = function LoadShape(guidShape) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Call the web service to get the shape json ...
    $.ajax({
        type: "Post",
        url: 'ServiceLoadShape.aspx?guidShape=' + guidShape,
        data: '{}',
        dataType: 'text',
        success: function (data, textStatus, jqXHR) { objDeferred.resolve(data); },
        error: function (data, textStatus, jqXHR) { objDeferred.reject(); },
        async: false,
        cache: false
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetShape
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.GetShape = function GetShape(objShapeUpdateException, blnGetProjectedShape) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Create a new deferred ...
    var objDeferred = new dojo.Deferred();

    // Create a function that will build the shape and possibly reproject it  ...
    var fnBuildShape = function (strShapeJson) {

        // Desserialize the shape json ...
        var objShape = TrimbleMap.Shape.Shared.fromJson(strShapeJson);

        // When the projected shape is to be displayed ...
        if (blnGetProjectedShape && (objShapeUpdateException.FailedSpatialReferenceID != SD.Guid.Shared.Empty())) {

            // Project the shape to the target spatial reference ...
            objShape.Project(objFixInvalidShape.MapController, objShapeUpdateException.FailedSpatialReferenceID, false).then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedShape) {

                // Resolve the deferred with the projected shape ...
                objDeferred.resolve(objProjectedShape);
            }));

        } else {

            // Resolve the deferred with the shape ...
            objDeferred.resolve(objShape);
        }
    }

    // When we have shape json already ...
    if ((typeof objShapeUpdateException.ShapeJson != 'undefined') && (objShapeUpdateException.ShapeJson != null)) {

        // Display the shape ...
        fnBuildShape(objShapeUpdateException.ShapeJson);

    } else {

        // Fetch the shape from the server ...
        TrimbleMap.FixInvalidShape.LoadShape(objShapeUpdateException.ShapeID).then(function (strShapeJson) {

            // Set the shape json on the update exception ...
            objShapeUpdateException.ShapeJson = strShapeJson;

            // Display the shape ...
            fnBuildShape(strShapeJson);
        });
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: DisplayShape
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.DisplayShape = function DisplayShape(objShapeUpdateException, blnDisplayProjectedShape) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Get the shape ...
    objFixInvalidShape.GetShape(objShapeUpdateException, blnDisplayProjectedShape).then(TrimbleMap.Controller.Shared.TrapException(function (objShape) {

        // Convert the shape to an esri polygon ...
        let objEsriPolygon = objShape.ToEsriPolygon(objFixInvalidShape.MapController);

        // Update the self intersection elements for the message ...
        objFixInvalidShape.UpdateSelfIntersectionElements(objEsriPolygon, objShapeUpdateException);

        // Trigger the display shape callbacks ...
        objFixInvalidShape.TriggerDisplayShapeCallbacks(objShape, objShapeUpdateException);
    }));
}

// **************************************************************************
// FUNCTION: EvaluateShapeIsSelfIntersectingResult
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.EvaluateShapeIsSelfIntersectingResult = function EvaluateShapeIsSelfIntersectingResult(objShapeUpdateException) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Get the shape ...
    objFixInvalidShape.GetShape(objShapeUpdateException, true).then(TrimbleMap.Controller.Shared.TrapException(function (objShape) {

        // Declare a variable to hold the esri polygon ...
        var objEsriPolygon;

        // When for a specific part ...
        if (objShapeUpdateException.ShapePartID != SD.Guid.Shared.Empty()) {

            // Get the part's geometry ...
            objEsriPolygon = objShape.GetPartGeometry(objFixInvalidShape.MapController, objShape.GetPartByID(objShapeUpdateException.ShapePartID));

        } else {

            // Convert the shape to an esri polygon ...
            objEsriPolygon = objShape.ToEsriPolygon(objFixInvalidShape.MapController);
        }

        // Update the self intersection elements for the message ...
        objFixInvalidShape.UpdateSelfIntersectionElements(objEsriPolygon, objShapeUpdateException);
    }));
}

// **************************************************************************
// FUNCTION: UpdateSelfIntersectionElements
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.UpdateSelfIntersectionElements = function UpdateSelfIntersectionElements(objEsriPolygon, objShapeUpdateException) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Get the message div ...
    var objMessageDiv = $(objFixInvalidShape.MessagesDiv.find('[ShapeUpdateExceptionID="' + objShapeUpdateException.ID + '"]'));
    var objTestIsSelfIntersectingLink = $(objMessageDiv.find('[TestIsSelfIntersectingLink]'));
    var objIsSelfIntersectingResult = $(objMessageDiv.find('[IsSelfIntersectingResult]'));

    // When not already updated ...
    if (objTestIsSelfIntersectingLink.is(':visible')) {

        // Test if self intersecting ...
        var blnIsSelfIntersecting = objEsriPolygon.isSelfIntersecting(objEsriPolygon);

        // Set the self intersection result ...
        objIsSelfIntersectingResult.text((blnIsSelfIntersecting) ? 'Tested: Is self intersecting' : 'Tested: NOT self intersecting');

        // Show the result span ...
        objIsSelfIntersectingResult.parent().show();

        // Hide the test if simple link ...
        objTestIsSelfIntersectingLink.hide();
    }
}

// **************************************************************************
// FUNCTION: Clicked
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.Clicked = function Clicked(e) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Get the target element ...
    var objTarget = $(e.target);

    // Get the diagnostic message div clicked on ...
    var objMessageDiv = SD.DOM.GetElementOrParentWithClass(objTarget, 'FixInvalidShape_message_div');
    var objViewEditorPageDiv = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ViewEditorPage');
    var objViewInOriginalCoordinateSystem = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ViewInOriginalCoordinateSystem');
    var objTestIsSelfIntersectingLink = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'TestIsSelfIntersectingLink');

    // When the user clicked on the diagnostic message div ...
    if (objMessageDiv) {

        // Get the message ID ...
        var guidShapeUpdateException = objMessageDiv.attr('ShapeUpdateExceptionID');
        var guidMissingGeometry = objMessageDiv.attr('MissingGeometryID');

        if (guidShapeUpdateException && guidShapeUpdateException != SD.Guid.Shared.Empty()) {
            // Get the shape update exception ...
            var objShapeUpdateException = objFixInvalidShape.GetShapeUpdateExceptionByID(guidShapeUpdateException);

            // When it's a view editor page link ...
            if (objViewEditorPageDiv) {

                // Redirect to the editor page link ...
                window.location.href = objShapeUpdateException.EditorPageLink;

            } else if (objTestIsSelfIntersectingLink) {

                // Evaluate if the shape is self intersecting ...
                objFixInvalidShape.EvaluateShapeIsSelfIntersectingResult(objShapeUpdateException);

            } else {

                // Unselect the previously selected css class ...
                $('.FixInvalidShape_message_Selected').removeClass('FixInvalidShape_message_Selected');

                // Set the currently clicked message as selected ...
                objMessageDiv.addClass('FixInvalidShape_message_Selected');

                // Display the shape ...
                objFixInvalidShape.DisplayShape(objShapeUpdateException, (objViewInOriginalCoordinateSystem == null));
            }
        } else if (guidMissingGeometry && guidMissingGeometry != SD.Guid.Shared.Empty()) {
            // Get the shape update exception ...
            var objMissingGeometry = objFixInvalidShape.GetMissingGeometryByID(guidMissingGeometry);

            // When it's a view editor page link ...
            if (objViewEditorPageDiv) {

                // Redirect to the editor page link ...
                window.location.href = objMissingGeometry.EditorPageLink;

            } else {
                // Unselect the previously selected css class ...
                $('.FixInvalidShape_message_Selected').removeClass('FixInvalidShape_message_Selected');

                // Set the currently clicked message as selected ...
                objMessageDiv.addClass('FixInvalidShape_message_Selected');

                // Display the shape ...
                objFixInvalidShape.DisplayShape(objMissingGeometry, (objViewInOriginalCoordinateSystem == null));
            }
        }
    }
}

// **************************************************************************
// FUNCTION: Scrolled
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.Scrolled = function Scrolled() {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Get the last scroll top ...
    objFixInvalidShape.LastScrollTop = parseInt(objFixInvalidShape.ScrollableContainerDiv.scrollTop());
}

// **************************************************************************
// FUNCTION: UpdateNoInvalidShapesDivVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.UpdateNoInvalidShapesDivVisibility = function UpdateNoInvalidShapesDivVisibility() {

    // Get the instance ...
    var objFixInvalidShape = this;

    // When there are messages displayed ...
    if (objFixInvalidShape.InvalidShapes.length > 0 || objFixInvalidShape.MissingGeometries.length > 0) {

        // Hide the no messgaes div ...
        objFixInvalidShape.NoInvalidShapesDiv.hide();

    } else {

        // Show the no messgaes div ...
        objFixInvalidShape.NoInvalidShapesDiv.show();
    }
}

// **************************************************************************
// FUNCTION: ActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.ActivateTab = function ActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Add the shape div to the tab container element ...
    objTabContainerElement.append(objFixInvalidShape.FixInvalidShapeDiv);

    // Set the scroll top ...
    objFixInvalidShape.ScrollableContainerDiv.scrollTop(objFixInvalidShape.LastScrollTop);

    // Attach the event handlers ...
    objFixInvalidShape.AttachEventHandlers();
}

// **************************************************************************
// FUNCTION: DeActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.DeActivateTab = function DeActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Detach the event handlers
    objFixInvalidShape.DetachEventHandlers();

    // Remove the shape div from the tab container element ...
    objFixInvalidShape.FixInvalidShapeDiv.remove();
}

// **************************************************************************
// FUNCTION: ResizeTab
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.ResizeTab = function ResizeTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Get the top of the list relative to the tab  ...
    var intTop = parseInt(objFixInvalidShape.ScrollableContainerDiv.position().top);

    // Get the tab height ...
    var intTabHeight = parseInt(objTabContainerElement.innerHeight());

    // Place some code into the event queue ...
    setTimeout(function () {

        // Set the height of the scrollable container to go to the bottom ...
        objFixInvalidShape.ScrollableContainerDiv.css('max-height', intTabHeight - intTop - 10);

        // Update the scrollbar ...
        objFixInvalidShape.UpdateScrollbar();
    }, 0);
}

// **************************************************************************
// FUNCTION: UpdateScrollbar
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.UpdateScrollbar = function UpdateScrollbar() {

    // Get the instance ...
    var objFixInvalidShape = this;

    // Get the height of the scrollable container ...
    var intMaxHeight = parseInt(objFixInvalidShape.ScrollableContainerDiv.css('max-height'));

    // Get teh heigth of the content ...
    var intHeight = parseInt(objFixInvalidShape.ScrollableInnerContainerDiv.height());

    // When we need scrollbar ...
    if ((intHeight > intMaxHeight) && objFixInvalidShape.EventHandlersAttached) {

        // When we have a scrollbar ...
        if (!objFixInvalidShape.NiceScroll) {

            // Activate the nice scroll bar on the messages list ...
            objFixInvalidShape.NiceScroll = objFixInvalidShape.ScrollableContainerDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });

        } else {

            // Update the scrollbar ...
            objFixInvalidShape.NiceScroll.resize();
        }

    } else {

        // When we have a scrollbar ...
        if (objFixInvalidShape.NiceScroll) {

            // De-activate the nice-scrollbar on the messages list ...
            objFixInvalidShape.NiceScroll.hide();
            objFixInvalidShape.NiceScroll.remove();
            objFixInvalidShape.NiceScroll = null;
        }
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.AttachEventHandlers = function AttachEventHandlers() {

    // Get the instance ...
    var objFixInvalidShape = this;

    // When the event handlers are not attached ...
    if (!objFixInvalidShape.EventHandlersAttached) {

        // Set the event handlers to be attached ...
        objFixInvalidShape.EventHandlersAttached = true;

        // Attach the click event handler to FixInvalidShapeDiv ...
        objFixInvalidShape.FixInvalidShapeDiv.click(objFixInvalidShape.ClickedProxy);

        // Attach the scrolled proxy ...
        objFixInvalidShape.ScrollableContainerDiv.scroll(objFixInvalidShape.ScrolledProxy);

        // Update the scrollbar ...
        objFixInvalidShape.UpdateScrollbar();
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.FixInvalidShape.DetachEventHandlers = function DetachEventHandlers() {

    // Get the instance ...
    var objFixInvalidShape = this;

    // When the event handlers are attached ...
    if (objFixInvalidShape.EventHandlersAttached) {

        // Set the event handlers to not be attached ...
        objFixInvalidShape.EventHandlersAttached = false;

        // Detach the click event handler from FixInvalidShapeDiv ...
        objFixInvalidShape.FixInvalidShapeDiv.off('click', objFixInvalidShape.ClickedProxy);

        // Update the scrollbar ...
        objFixInvalidShape.UpdateScrollbar();
    }
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.GeographicDDCoordinate = {};
TrimbleMap.GeographicDDCoordinate.Shared = {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// *************************************************************************
TrimbleMap.GeographicDDCoordinate.CreateInstance = function CreateInstance(decLatitudeDegrees, enNorthSouth, decLongitudeDegrees, enEastWest) {

    // Create the object that will hold the instance properties ...
    var objGeographicDDCoordinate = {
        LATITUDE_DEGREES: (typeof decLatitudeDegrees != 'undefined') ? decLatitudeDegrees : 0,
        NORTH_SOUTH: (typeof enNorthSouth != 'undefined') ? enNorthSouth : 0,
        LONGITUDE_DEGREES: (typeof decLongitudeDegrees != 'undefined') ? decLongitudeDegrees : 0,
        EAST_WEST: (typeof enEastWest != 'undefined') ? enEastWest : 0
    }

    return objGeographicDDCoordinate;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.GeographicDMSCoordinate = {};
TrimbleMap.GeographicDMSCoordinate.Shared = {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// *************************************************************************
TrimbleMap.GeographicDMSCoordinate.CreateInstance = function CreateInstance(intLatitudeDegrees, intLatitudeMinutes, decLatitudeSeconds, enNorthSouth, intLongitudeDegrees, intLongitudeMinutes, decLongitudeSeconds, enEastWest) {

    // Create the object that will hold the instance properties ...
    var objGeographicDMSCoordinate = {
        LATITUDE_DEGREES: (typeof intLatitudeDegrees != 'undefined') ? intLatitudeDegrees : 0,
        LATITUDE_MINUTES: (typeof intLatitudeMinutes != 'undefined') ? intLatitudeMinutes : 0,
        LATITUDE_SECONDS: (typeof decLatitudeSeconds != 'undefined') ? decLatitudeSeconds : 0,
        NORTH_SOUTH: (typeof enNorthSouth != 'undefined') ? enNorthSouth : 0,
        LONGITUDE_DEGREES: (typeof intLongitudeDegrees != 'undefined') ? intLongitudeDegrees : 0,
        LONGITUDE_MINUTES: (typeof intLongitudeMinutes != 'undefined') ? intLongitudeMinutes : 0,
        LONGITUDE_SECONDS: (typeof decLongitudeSeconds != 'undefined') ? decLongitudeSeconds : 0,
        EAST_WEST: (typeof enEastWest != 'undefined') ? enEastWest : 0
    }

    return objGeographicDMSCoordinate;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Geometry = {};
TrimbleMap.Geometry.Shared = {};

// **************************************************************************
// FUNCTION: ForEachPointFromGeometry
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.Shared.ForEachPointFromGeometry = function ForEachPointFromGeometry(objGeometry, fnExecuteForPoint) {

    switch (objGeometry.type) {
        case 'point':

            // Call the function for the point ...
            fnExecuteForPoint(objGeometry);
            break;

        case 'polyline':

            // Loop through all the paths ...
            $.each(objGeometry.paths, function (intPath, arrPathPoints) {

                // Loop through all the points ...
                $.each(arrPathPoints, function (intPoint, arrPointsValues) {

                    // Create an esri point ...
                    var objPoint = new esri.geometry.Point(arrPointsValues[0], arrPointsValues[1], objGeometry.spatialReference);

                    // Call the function for the point ...
                    fnExecuteForPoint(objPoint);
                });
            });
            break;

        case 'polygon':

            // Loop through all the rings ...
            $.each(objGeometry.rings, function (intRing, arrRingPoints) {

                // Loop through all the points ...
                $.each(arrRingPoints, function (intPoint, arrPointsValues) {

                    // Create an esri point ...
                    var objPoint = new esri.geometry.Point(arrPointsValues[0], arrPointsValues[1], objGeometry.spatialReference);

                    // Call the function for the point ...
                    fnExecuteForPoint(objPoint);
                });
            });
            break;
    }
}

// **************************************************************************
// FUNCTION: ComputePointInsidePolygon
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.ComputePointInsidePolygon = function ComputePointInsidePolygon(objGeometry) {

    // Declare the return variable ...
    var objPointInside = null;

    // Start with the first ring ...
    var intRing = 0;

    // Get half of the height of the geometry ...
    var dblMaxRandomOffset = (objGeometry.getExtent().getHeight() * 0.1) / 2;

    // While we do not have a point inside the polygon yet ...
    while ((objPointInside == null) && (intRing < objGeometry.rings.length)) {

        // Get the first ring ...
        var objRing = objGeometry.rings[intRing];

        // Increment the ring index to the next for the next iteration ...
        intRing = intRing + 1;

        // Start with not offsetting the y of the center point at all ...
        var dblCenterYOffset = 0;

        // While we do not have a point inside the polygon yet ...
        while (objPointInside == null) {

            // Create a new polygon from the first ring ...
            var objPolygon = new esri.geometry.Polygon(objGeometry.spatialReference);

            // Add the ring to the polygon ...
            objPolygon.addRing(objRing);

            // Get the center of the extent of the ring ...
            var objCenter = objPolygon.getExtent().getCenter();

            // Add the y offset ...
            objCenter.y = objCenter.y + dblCenterYOffset;

            // Create an array for the intersections ...
            var arrIntersectionPointX = new Array();

            // Loop through all the points of the first ring ...
            for (var intPoint = 0; intPoint < objRing.length; intPoint++) {

                // Get the point and the next ...
                var arrPoint = objRing[intPoint];
                var arrNextPoint = objRing[(intPoint + 1) % objRing.length];

                // Create objects with the x and y from the point arrays ...
                var objPoint = { x: arrPoint[0], y: arrPoint[1] };
                var objNextPoint = { x: arrNextPoint[0], y: arrNextPoint[1] };

                // When the center point lies on either the point or the next point ...
                if ((objPoint.y == objCenter.y) || (objNextPoint.y == objCenter.y)) {

                    // Set to have found no intersections so that we will loop back and retry with a random offset from the center ...
                    arrIntersectionPointX = new Array();

                    // Stop checking ...
                    break;
                }

                // When the line through objCenter.y intersects with the line from objPoint to objNextPoint ...
                if (((objCenter.y > objPoint.y) && (objCenter.y < objNextPoint.y)) ||
                    ((objCenter.y > objNextPoint.y) && (objCenter.y < objPoint.y))) {

                    // Compute the point where the line between the points 
                    // intersects with a horizontal line through the center point ...
                    var dblIntersectionPointX = (((objPoint.x * objNextPoint.y) - (objPoint.y * objNextPoint.x)) - ((objPoint.x - objNextPoint.x) * objCenter.y)) / (objNextPoint.y - objPoint.y);

                    // Add to the list of intersection point x values ...
                    arrIntersectionPointX.push(dblIntersectionPointX);
                }
            }

            // Sort the function x values from left to right ...
            arrIntersectionPointX.sort(function (a, b) { return a - b });

            // When we have more than one intersections ...
            if (arrIntersectionPointX.length > 1) {

                // Compute the center between the intersections ...
                let dblX = (arrIntersectionPointX[0] + arrIntersectionPointX[1]) / 2;

                // Create the point inside ...
                objPointInside = new esri.geometry.Point(dblX, objCenter.y, objGeometry.spatialReference);

            } else {

                // Set to add a random offset during the next attempt ...
                dblCenterYOffset = (Math.random() * dblMaxRandomOffset * 2) - dblMaxRandomOffset;
            }
        }

        // Test if the point is actually inside the polygon, we do this in-case the ring is a hole ...
        if (!objGeometry.contains(objPointInside)) {

            // Clear the point inside so that we will try the next ring instead ...
            objPointInside = null;
        }
    }

    // Use the centroid when we've not been able to get a point inside the polygon ...
    if (objPointInside == null) { objPointInside = objGeometry.getCentroid(); }

    return objPointInside;
}

// **************************************************************************
// FUNCTION: UnionGeometries
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.Shared.UnionGeometries = function UnionGeometries(arrGeometries) {

    // Start with a null result ...
    var objUnionedGeometry = null;

    // When we have any geometries to union ...
    if (arrGeometries.length > 0) {

        // Loop through all the geometries ...
        $.each(arrGeometries, function (intGeometry, objGeometry) {

            // When we do not have a unioned geometry yet ...
            if (objUnionedGeometry == null) {

                // Set the unioned geometry to be the geometry ...
                objUnionedGeometry = objGeometry;

            } else {

                // Union the geometry ...
                objUnionedGeometry = objUnionedGeometry.union(objGeometry);
            }
        });
    }

    return objUnionedGeometry;
}

// **************************************************************************
// FUNCTION: CountGeometryPoints
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.CountGeometryPoints = function CountGeometryPoints(objGeometry) {

    // Start with 0 points ...
    var intPoints = 0;

    switch (objGeometry.type) {
        case 'point':

            // Only one point ..
            intPoints = 1;
            break;

        case 'multipoint':

            // Get the number of points that the multi point contains ...
            intPoints = objGeometry.points.length;
            break;

        case 'polygon':

            // Loop through all the rings and add the number of points in each ring ...
            $.each(objGeometry.rings, function (intRing, objRing) { intPoints += objRing.length; });
            break;

        case 'polyline':

            // Loop through all the paths and add the number of points in each path ...
            $.each(objGeometry.paths, function (intPath, objPath) { intPoints += objPath.length; });
            break;

        case 'extent':

            // An extent has 4 points ...
            intPoints = 4;
            break;
    }

    return intPoints;
}

// **************************************************************************
// FUNCTION: CountGeometryArrayPoints
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.CountGeometryArrayPoints = function CountGeometryArrayPoints(arrGeometries) {

    // Start with 0 points ...
    var intTotalPoints = 0;

    // Loop through all the geometries ...
    $.each(arrGeometries, function (intGeometry, objGeometry) {

        // Count the number of points in the geometry and add it to the total ...
        intTotalPoints += TrimbleMap.Geometry.CountGeometryPoints(objGeometry);
    });

    return intTotalPoints;
}

// **************************************************************************
// FUNCTION: GetRandomPointFromGeometry
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.GetRandomPointFromGeometry = function GetRandomPointFromGeometry(objGeometry) {

    // Start with no point ...
    var objPoint = null;

    switch (objGeometry.type) {
        case 'point':

            // Use the point ...
            objPoint = objGeometry;
            break;

        case 'multipoint':

            // When we have at least one point, use the first point ...
            if (objGeometry.points.length > 0) { objPoint = new esri.geometry.Point(objGeometry.points[0][0], objGeometry.points[0][1], objGeometry.spatialReference); }
            break;

        case 'polygon':

            // Get the point from the first ring with points (if any) ...
            $.each(objGeometry.rings, function (intRing, objRing) { if (objRing.length > 0) { objPoint = new esri.geometry.Point(objRing[0][0], objRing[0][1], objGeometry.spatialReference); return false; } });
            break;

        case 'polyline':

            // Get the point from the first ring with points (if any) ...
            $.each(objGeometry.paths, function (intPath, objPath) { if (objPath.length > 0) { objPoint = new esri.geometry.Point(objPath[0][0], objPath[0][1], objGeometry.spatialReference); return false; } });
            break;

        case 'extent':

            // Use the bottom left corner ...
            objPoint = new esri.geometry.Point(objGeometry.xmin, objGeometry.ymin, objGeometry.spatialReference);
            break;
    }

    return objPoint;
}

// **************************************************************************
// FUNCTION: GetRandomPointFromGeometries
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.GetRandomPointFromGeometries = function GetRandomPointFromGeometries(arrGeometries) {

    // Start with no point ...
    var objPoint = null;

    // Loop through all the geometries ...
    $.each(arrGeometries, function (intGeometry, objGeometry) {

        // Attempt to get a point from the geometry ...
        objPoint = TrimbleMap.Geometry.GetRandomPointFromGeometry(objGeometry);

        // Stop looking for a point when found ...
        if (objPoint != null) { return false; }
    });

    return objPoint;
}

// **************************************************************************
// FUNCTION: GeometryFromWKT
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.Shared.GeometryFromWKT = function GeometryFromWKT(strWKT, objEsriSpatialReference) {

    // Start with no geometry to return ...
    var objGeometry = null;

    // When we have wkt ...
    if ((typeof strWKT != 'undefined') && (strWKT != null)) {

        // Convert the WKT to esri json ...
        var objJson = TrimbleMap.Geometry.Shared.EsriJsonFromWKT(strWKT);

        // When we were able to extract a geometry ...
        if (objJson != null) {

            // Create a geometry from the json ...
            objGeometry = esri.geometry.jsonUtils.fromJson(objJson);

            // Set the spatial reference of the geometry ...
            objGeometry.setSpatialReference(objEsriSpatialReference);
        }
    }

    // Return the geometry ...
    return objGeometry;
}

// **************************************************************************
// FUNCTION: EsriJsonFromWKT
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.Shared.EsriJsonFromWKT = function EsriJsonFromWKT(strWKT) {

    // Break up up the geometry WKT string ...
    var arrWKT = strWKT.split("(");

    // Get the geometry type ...
    var strGeometryType = arrWKT.shift().trim();

    // Re-combine the wkt string without the geomerty type ...
    var strRemainingWKT = '(' + (arrWKT.join("(").trim());
    
    // Get the esri json by geometry type ...
    var objEsriJson = TrimbleMap.Geometry.Shared.EsriJsonFromWKTByGeometryType(strGeometryType, strRemainingWKT);

    return objEsriJson;
}

// **************************************************************************
// FUNCTION: EsriJsonFromWKTByGeometryType
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.Shared.EsriJsonFromWKTByGeometryType = function EsriJsonFromWKTByGeometryType(strGeometryType, strWKT) {

    // Call appropriate function based on the geometry type ...
    switch (strGeometryType.toUpperCase()) {
        case 'POLYGON': return TrimbleMap.Geometry.Shared.ParsePolygonWKT(strWKT); break;
        case 'MULTIPOLYGON': return TrimbleMap.Geometry.Shared.ParseMultiPolygonWKT(strWKT); break;
        case 'POINT': return TrimbleMap.Geometry.Shared.ParsePointWKT(strWKT); break;
        case 'MULTIPOINT': return TrimbleMap.Geometry.Shared.ParseMultiPointWKT(strWKT); break;
        case 'LINESTRING': return TrimbleMap.Geometry.Shared.ParseLineStringWKT(strWKT); break;
        case 'MULTILINESTRING': return TrimbleMap.Geometry.Shared.ParseMultiLineStringWKT(strWKT); break;
        case 'GEOMETRYCOLLECTION': return TrimbleMap.Geometry.Shared.ParseGeometryCollectionWKT(strWKT); break;
    }
}

// **************************************************************************
// FUNCTION: ParsePointWKT
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.Shared.ParsePointWKT = function ParsePointWKT(strWKT) {

    // Parse points as multi points ...
    return TrimbleMap.Geometry.Shared.ParseMultiPointWKT(strWKT);
}

// **************************************************************************
// FUNCTION: ParseMultiPointWKT
// FORMAT:   ((x1 y1),(x2 y2),(x3 y3),...,(xn yn))
// **************************************************************************
TrimbleMap.Geometry.Shared.ParseMultiPointWKT = function ParseMultiPointWKT(strWKT) {

    // Extract the points and build a multipoint esri json object ...
    return {
        type: 'multipoint',
        points: TrimbleMap.Geometry.Shared.EsriJsonPointArrayFromWKT(strWKT)
    };
}

// **************************************************************************
// FUNCTION: ParseMultiLineStringWKT
// FORMAT:    ((x1 y1, x2 y2,....),(x1 y1, x2 y2,....))
// **************************************************************************
TrimbleMap.Geometry.Shared.ParseMultiLineStringWKT = function ParseMultiLineStringWKT(strWKT) {

    // Strip outermost parenthesis => remove (( and )) ...
    strWKT = strWKT.replace(/(\(\()|(\)\))/gi, '');

    // Split on tailing parenthesis and comma so we now have ['(x1 y1, x2 y2,....)','(x1 y1, x2 y2,....)',...] ...
    var arrPathStrings = strWKT.split("),");

    // Create an empty array for the paths ...
    var arrPaths = [];

    // Extract the point array for each path ...
    $.each(arrPathStrings, function (intPath, strPath) { arrPaths.push(TrimbleMap.Geometry.Shared.EsriJsonPointArrayFromWKT(strPath)); });

    // Build a polyline esri json object ...
    return {
        type: 'polyline',
        paths: arrPaths
    };
}

// **************************************************************************
// FUNCTION: ParseLineStringWKT
// FORMAT:   (x1 y1, x2 y2, x3 y3,..., xn yn)
// **************************************************************************
TrimbleMap.Geometry.Shared.ParseLineStringWKT = function ParseLineStringWKT(strWKT) {

    // Extract the points and build a multipoint esri json object ...
    return {
        type: 'polyline',
        paths: [TrimbleMap.Geometry.Shared.EsriJsonPointArrayFromWKT(strWKT)]
    };
}

// **************************************************************************
// FUNCTION: ParsePolygonWKT
// FORMAT:   ((x1 y1, x2 y2,....),(x1 y1, x2 y2,....))
// **************************************************************************
TrimbleMap.Geometry.Shared.ParsePolygonWKT = function ParsePolygonWKT(strWKT) {

    // The only difference between a polygon and a multi line string is we output paths instead of rings ...
    var objMultiLineString = TrimbleMap.Geometry.Shared.ParseMultiLineStringWKT(strWKT);

    // Extract the points and build a polygon esri json object ...
    return {
        type: 'polygon',
        rings: objMultiLineString.paths
    };
}

// **************************************************************************
// FUNCTION: ParseMultiPolygonWKT
// FORMAT:   (((x1 y1, x2 y2,....)),((x1 y1, x2 y2,....)))
// **************************************************************************
TrimbleMap.Geometry.Shared.ParseMultiPolygonWKT = function ParseMultiPolygonWKT(strWKT) {

    // Create an empty combined polygon to return ...
    var objCombinedPolygon = {
        type: 'polygon',
        rings: []
    };

    // Replace all the ), occurrences with )* ...
    strWKT = strWKT.replace(/(\)\s*,\s*)/gi, ')*');

    // Get the point strings for each polygon ...
    var arrPolygonPointsStrings = $.map(strWKT.split('*'), function (strPointString, intPointString) { return (strPointString).trim(); });

    // Loop through all the polygon point strings ...
    $.each(arrPolygonPointsStrings, function (intPolygonPoints, strPolygonPoints) {

        // Convert the coordinates to a polygon ...
        var objPolygon = TrimbleMap.Geometry.Shared.ParsePolygonWKT(strPolygonPoints);

        // Combine the rings of the polygon to the the rings of the combined polygon ...
        objCombinedPolygon.rings = objCombinedPolygon.rings.concat(objPolygon.rings);
    });

    // Return the combined polygon ...
    return objCombinedPolygon;
}

// **************************************************************************
// FUNCTION: ParseGeometryCollectionWKT
// USAGE:    GEOMETRYCOLLECTION(POINT(x1 y1),LINESTRING(x2 y2,x3 y3))
// **************************************************************************
TrimbleMap.Geometry.Shared.ParseGeometryCollectionWKT = function ParseGeometryCollectionWKT(strWKT) {

    // Strip outer most parenthesis ...
    strWKT = (strWKT).trim();
    strWKT = strWKT.substring(1, strWKT.length - 1);

    // Replace all the '), ANYTEXT (' or 'EMPTY, ANYTEXT (' occurrences with ') *ANYTEXT (' ...
    strWKT = strWKT.replace(/(\)\s*,\s*[a-zA-Z]+\s*\(|EMPTY\s*,\s*[a-zA-Z]+\s*\()/gi, function (strMatch) { return strMatch.replace(',', '*'); });

    // Split the geometries up ...
    var arrGeometriesWKT = strWKT.split('*');

    // Create an array for the geometries ...
    var arrGeometries = [];

    // Loop though all the geometries ...
    $.each(arrGeometriesWKT, function (intGeometry, strGeometryWKT) {

        // When no EMPTY text ...
        if (strGeometryWKT.toUpperCase().indexOf('EMPTY') < 0) {

            // Remove the whitespace ...
            strGeometryWKT = (strGeometryWKT).trim();

            // Break up the geometry WKT string ...
            var arrWKT = strGeometryWKT.split("(");

            // Get the geometry type ...
            var strGeometryType = arrWKT.shift().trim();

            // Re-combine the wkt string without the geomerty type ...
            var strRemainingWKT = '(' + (arrWKT.join("(").trim());

            // Convert the wkt to a geometry ...
            var objGeometry = TrimbleMap.Geometry.Shared.EsriJsonFromWKTByGeometryType(strGeometryType, strRemainingWKT);

            // Add the geometry to the array ...
            arrGeometries.push(objGeometry);
        }
    });

    // Declare a geometry to return ...
    var objGeometry = null;

    // When we have any geometries ...
    if (arrGeometries.length > 0) {

        // Get the geometry type ...
        var strGeometryType = arrGeometries[0].type;

        // Depending on the geometry type ...
        switch (strGeometryType) {
            case 'polygon':

                // Create a json object for a polygon ...
                objGeometry = { type: 'polygon', rings: [] };
                break;

            case 'multipoint':

                // Create a json object for a multipoint ...
                objGeometry = { type: 'multipoint', points: [] };
                break;

            case 'polyline':

                // Create a json object for a multipoint ...
                objGeometry = { type: 'polyline', paths: [] };
                break;
        }

        // Loop through all the geometries ...
        $.each(arrGeometries, function (intGeometry, objSubGeometry) {

            // When the geometry type matches the geometry type of the first geometry ...
            if (strGeometryType == objSubGeometry.type) {

                // Depending on the geometry type ...
                switch (strGeometryType) {
                    case 'polygon':

                        // Add the rings of the sub geometry to the rings of the geometry ...
                        objGeometry.rings = objGeometry.rings.concat(objSubGeometry.rings)
                        break;

                    case 'multipoint':

                        // Add the points of the sub geometry to the points of the geometry ...
                        objGeometry.points = objGeometry.points.concat(objSubGeometry.points)
                        break;

                    case 'polyline':

                        // Add the points of the sub geometry to the points of the geometry ...
                        objGeometry.paths = objGeometry.paths.concat(objSubGeometry.paths)
                        break;
                }
            }
        });
    }

    return objGeometry;
}

// **************************************************************************
// FUNCTION: EsriJsonFromWKT
// FORMAT:   ((x1 y1),(x2 y2),(x3 y3),...,(xn yn))
// OR        (x1 y1, x2 y2, x3 y3, ..., xn yn)
// **************************************************************************
TrimbleMap.Geometry.Shared.EsriJsonPointArrayFromWKT = function EsriJsonPointArrayFromWKT(strPointArray) {

    // Create an array to return ...
    var arrPoints = [];

    // Remove all ) and ( and split by comma ...
    var arrPointStrings = strPointArray.replace(/\)|\(/gi, "").split(",");

    // Loop through all the point strings ...
    $.each(arrPointStrings, function (intPoint, strPoint) {

        // Split the 'x y' pair ...
        var arrSplitPointXY = strPoint.trim().split(" ");

        // Parse X and Y as floats ...
        var decX = parseFloat(arrSplitPointXY[0], 10);
        var decY = parseFloat(arrSplitPointXY[1], 10);

        // Add the point to the array ...
        arrPoints.push([decX, decY]);
    });

    return arrPoints;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculateRingArea: Calculates the area of a ring ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Geometry.Shared.CalculateRingArea = function CalculateRingArea(arrPoints) {

    // Start with an area of 0 ...
    let dblArea = 0;

    // When at least 2 points ...
    if (arrPoints && arrPoints.length > 2) {

        // Loop through all the points of the ring ...
        for (let intPoint = 0; intPoint < arrPoints.length; intPoint++) {

            // Get the point ...
            let objPoint = arrPoints[intPoint];

            // Get next the point ...
            let objNextPoint = arrPoints[(intPoint + 1) % arrPoints.length];

            // Add to the area ...
            dblArea += (objPoint[0] * objNextPoint[1]) - (objNextPoint[0] * objPoint[1]);
        }

        // Divide by 2 ...
        dblArea /= 2.0;
    }

    return dblArea;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculatePolygonAreaInKm2: Calculates the area of the polygon ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Geometry.Shared.CalculatePolygonAreaInKm2 = function CalculatePolygonAreaInKm2(objEsriPolygon, dblMetersPerUnit) {

    // Start with an area of 0 ...
    var dblArea = 0;

    // Loop through all the rings of the geometry ...
    for (var intRing = 0; intRing < objEsriPolygon.rings.length; intRing++) {

        // Calculate the area of the ring and add it to the total area ...
        dblArea += TrimbleMap.Geometry.Shared.CalculateRingArea(objEsriPolygon.rings[intRing]);
    }

    // Convert the units per meter to units per kilometer ...
    var dblKilometersPerUnit = dblMetersPerUnit / 1000.0;

    // Convert the area to square kilometers ... 
    dblArea = Math.abs(dblArea * (dblKilometersPerUnit * dblKilometersPerUnit));

    // Return the area ...
    return dblArea;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculatePolylineDistanceKm: Calculates the distance of the polyline ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Geometry.Shared.CalculatePolylineDistanceKm = function CalculatePolylineDistanceKm(objEsriPolyline, dblMetersPerUnit) {

    // Start with a distance of 0 ...
    var dblDistance = 0;

    // Loop through all the paths of the geometry ...
    for (var intPath = 0; intPath < objEsriPolyline.paths.length; intPath++) {

        // Get the ring ...
        var arrPoints = objEsriPolyline.paths[intPath];

        // Loop through all the points of the ring ...
        for (var intPoint = 0; intPoint < arrPoints.length - 1; intPoint++) {

            // Get the point ...
            var objPoint = arrPoints[intPoint];

            // Get next the point ...
            var objNextPoint = arrPoints[intPoint + 1];

            // Add the length of the line segment to the distance ...
            dblDistance += Math.sqrt(Math.pow((objPoint[0] - objNextPoint[0]), 2)) + Math.sqrt(Math.pow((objPoint[1] - objNextPoint[1]), 2));
        }
    }

    // Convert the units per meter to units per kilometer ...
    var dblKilometersPerUnit = dblMetersPerUnit / 1000.0;

    // Convert the distance to kilometers ... 
    var dblDistanceKm = Math.abs(dblDistance * (dblKilometersPerUnit));

    // Return the distance ...
    return dblDistanceKm;
}

// **************************************************************************
// FUNCTION: FixPolygonRingOrientation
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.Shared.FixPolygonRingOrientation = function FixPolygonRingOrientation(objEsriPolygon, intRing, enInteriorOrExterior) {

    // Get the ring to fix ...
    var arrRingPoints = objEsriPolygon.rings[intRing];
    
    // Calculate the area of the ring to determine the ring orientation ...
    var decRingArea = TrimbleMap.Geometry.Shared.CalculateRingArea(arrRingPoints);

    // When to be exterior but negative area or when interior but positive area ...
    if (((enInteriorOrExterior == TrimbleMap.Shape.enumInteriorOrExterior.Exterior) && (decRingArea > 0)) ||
        ((enInteriorOrExterior == TrimbleMap.Shape.enumInteriorOrExterior.Interior) && (decRingArea < 0))) {

        // Reverse the coordinates ...
        arrRingPoints = TrimbleMap.Geometry.Shared.RevereseRingOrder(arrRingPoints);

        // Remove and re-add the ring ...
        objEsriPolygon.removeRing(intRing);
        objEsriPolygon.addRing(arrRingPoints);
    }

    return objEsriPolygon;
}

// **************************************************************************
// FUNCTION: FixRingOrientation
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.Shared.FixRingOrientation = function FixRingOrientation(arrRingPoints, enInteriorOrExterior) {

    // Calculate the area of the ring to determine the ring orientation ...
    var decRingArea = TrimbleMap.Geometry.Shared.CalculateRingArea(arrRingPoints);

    // When to be exterior but negative area or when interior but positive area ...
    if (((enInteriorOrExterior == TrimbleMap.Shape.enumInteriorOrExterior.Exterior) && (decRingArea > 0)) ||
        ((enInteriorOrExterior == TrimbleMap.Shape.enumInteriorOrExterior.Interior) && (decRingArea < 0))) {

        // Reverse the coordinates ...
        arrRingPoints = TrimbleMap.Geometry.Shared.RevereseRingOrder(arrRingPoints);
    }

    return arrRingPoints;
}

// **************************************************************************
// FUNCTION: RevereseRingOrder
// USAGE:    Returns a new ring points array in the opposite direction ...
// **************************************************************************
TrimbleMap.Geometry.Shared.RevereseRingOrder = function RevereseRingOrder(arrRingPoints) {

    // Create a new array to return ...
    var arrReversedRingPoints = [];

    // Loop though all the ring points from last to first ...
    for (var intRingPoint = arrRingPoints.length - 1; intRingPoint >= 0; intRingPoint--) {

        // Add the point to the ring ...
        arrReversedRingPoints.push(arrRingPoints[intRingPoint]);
    }

    return arrReversedRingPoints;
}


// **************************************************************************
// FUNCTION: SplitExteriorAndInteriorRings
// **************************************************************************
TrimbleMap.Geometry.Shared.SplitExteriorAndInteriorRings = function SplitExteriorAndInteriorRings(objGeometry) {

    // Create the return object with arrays for the exterior and interior rings ...
    var objRings = {
        ExteriorRings: [],
        InteriorRings: [],
        ExteriorRingIndexes: [],
        InteriorRingIndexes: []
    }

    // Loop through all the rings of the polygon ...
    $.each(objGeometry.rings, function (intRing, arrRingPoints) {
        
        // Create a new geometry with the ring ...
        var objRingGeometry = TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objGeometry.spatialReference);

        // Calculate the intersection between the geometry and the ring geometry ...
        var objIntersectionGeometry = esri.geometry.geometryEngine.intersect(objGeometry, objRingGeometry);
        
        // When we have an intersection ...
        if (objIntersectionGeometry) {

            // Add it as an exterior ring ...
            objRings.ExteriorRings.push(arrRingPoints);
            objRings.ExteriorRingIndexes.push(intRing);

        } else {

            // Add it as an interior ring ...
            objRings.InteriorRings.push(arrRingPoints);
            objRings.InteriorRingIndexes.push(intRing);
        }
    });

    return objRings;
}


// **************************************************************************
// FUNCTION: PolygonFromRing
// **************************************************************************
TrimbleMap.Geometry.Shared.PolygonFromRing = function PolygonFromRing(arrRingPoints, objEsriSpatialReference) {

    // Create a new polygon ...
    var objPolygon = new esri.geometry.Polygon(objEsriSpatialReference);

    // Add a ring to the geometry ...
    objPolygon.addRing(arrRingPoints);

    return objPolygon;
}

// **************************************************************************
// FUNCTION: CombinePolygons
// **************************************************************************
TrimbleMap.Geometry.Shared.CombinePolygons = function CombinePolygons(arrEsriPolygons, objEsriSpatialReference) {

    // Create a new polygon ...
    var objCombinedEsriPolygon = new esri.geometry.Polygon(objEsriSpatialReference);

    // Loop through all the esri polygons ...
    $.each(arrEsriPolygons, function (intEsriPolygon, objEsriPolygon) {

        // Loop through all the rings of the polygon ...
        $.each(objEsriPolygon.rings, function (intRing, objRing) {

            // Add a ring to the polygon ...
            objCombinedEsriPolygon.addRing(objRing);
        });
    });

    return objCombinedEsriPolygon;
}

// **************************************************************************
// FUNCTION: CloseRing
// USAGE:    
// **************************************************************************
TrimbleMap.Geometry.Shared.CloseRing = function CloseRing(arrRingPoints) {

    // When at least 2 points ...
    if (arrRingPoints.length >= 2) {

        // Get the first and last points ...
        var objFirstPoint = arrRingPoints[0];
        var objLastPoint = arrRingPoints[arrRingPoints.length - 1];

        // When the first and last points does not match ..
        if ((objFirstPoint[0] != objLastPoint[0]) && (objFirstPoint[1] != objLastPoint[1])) {

            // Add a copy of the first point at the end ...
            arrRingPoints.push([objFirstPoint[0], objFirstPoint[1]]);
        }
    }

    return arrRingPoints;
}

// **************************************************************************
// FUNCTION: GetFirstPoint
// USAGE: Used to acquire the first point
// **************************************************************************
TrimbleMap.Geometry.Shared.GetFirstPoint = function GetFirstPoint(objGeometry) {

    // Declare variable for the point object...
    var objPoint = null;

    switch (objGeometry.type) {
        case 'point':

            // Set the first x and y to be the x and y of the point ...
            objPoint = objGeometry;
            break;

        case 'polygon':

            // Set the first x and y to be the x and y of the first coordinate of the polygon ...
            var decFirstX = objGeometry.rings[0][0][0];
            var decFirstY = objGeometry.rings[0][0][1];
            objPoint = new esri.geometry.Point(decFirstX, decFirstY, objGeometry.spatialReference);
            break;

        case 'polyline':

            // Set the first x and y to be the x and y of the first coordinate of the polyline ...
            var decFirstX = objGeometry.paths[0][0][0];
            var decFirstY = objGeometry.paths[0][0][1];
            objPoint = new esri.geometry.Point(decFirstX, decFirstY, objGeometry.spatialReference);
            break;
    }
    return objPoint;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.GraticuleRenderer = {};
TrimbleMap.GraticuleRenderer.Shared = {};
TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE =  10;
TrimbleMap.GraticuleRenderer.Shared.FIXED_SIZE_MINIMUM_BLOCK_SIZE_PIXELS = 15;
TrimbleMap.GraticuleRenderer.Shared.DYNAMIC_SIZE_MINIMUM_BLOCK_SIZE_PIXELS = 80;
TrimbleMap.GraticuleRenderer.Shared.MINIMUM_SCREEN_SIZE_FOR_LABEL_DRAW_ON_EVERY_LINE = 50;
TrimbleMap.GraticuleRenderer.Shared.MAX_TILE_RANGE_TO_DRAW = 40;
TrimbleMap.GraticuleRenderer.Shared.THICK_LINE_INTERVAL = 4;

TrimbleMap.GraticuleRenderer.enumGridSizeType = {};
TrimbleMap.GraticuleRenderer.enumGridSizeType.Fixed = 'Fixed';
TrimbleMap.GraticuleRenderer.enumGridSizeType.Dynamic = 'Dynamic';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    objGridColor: { R, G, B }
// **************************************************************************
TrimbleMap.GraticuleRenderer.CreateInstance = function CreateInstance(objMapController, decGridSideLength, guidGridSpatialReference, enGridType, objGridColor) {
    
    // Create the instance ...
    var objGraticuleRenderer = {
        MapController: objMapController,
        GridSideLength: decGridSideLength,
        GridSpatialReferenceID: guidGridSpatialReference,
        GridSpatialReference: objMapController.GetSpatialReference(guidGridSpatialReference),
        GridEsriSpatialReference: objMapController.CreateEsriSpatialReference(guidGridSpatialReference),
        GridType: enGridType,
        GridColor: objGridColor,
        IsActive: false,
        BlockSizeMultiplier: 1,
        ShowFixedSizeBlocksAtCurrentScale: false,
        Range: null,
        Tiles: {},
        LatitudeAndLongitudeGraphics: null,
        ExtentChangedHandle: null,
        PanStartHandle: null,
        PreviousZoomLevel: null,
        GraphicsLayer: null,
        SideLengthOnScreen: null,
        ValidGeographicGridExtentInMapSpatialReference: null,
        OnVisiblityChangedFunctions: [],
        OnExtentValidityChangedFunctions: [],
        DisplayInfoMessageWhenHidden: false,
        HiddenInfoMessageData: null,
        DisplayInfoMessageWhenInvalidExtent: false,
        InvalidExtentInfoMessageData: null,
        IsValidExtent: true,
        AbleToDrawGrid: true,
        IsExtentProcessingInProgress: false,
        DelayedExtentChangeLevelChanged: false,
        HasDelayedExtentChanged: false,
        SideLengthOnScreenComputed: false,

        ExtentChangedProxy: function (e) { objGraticuleRenderer.ExtentChanged(e.levelChange); },
        PanStartProxy: function (e) { objGraticuleRenderer.PanStart(e); },

        Activate: TrimbleMap.GraticuleRenderer.Activate,
        DeActivate: TrimbleMap.GraticuleRenderer.DeActivate,
        AttachMapEventHandlers: TrimbleMap.GraticuleRenderer.AttachMapEventHandlers,
        DetachMapEventHandlers: TrimbleMap.GraticuleRenderer.DetachMapEventHandlers,
        UpdateInfoMessageDisplay: TrimbleMap.GraticuleRenderer.UpdateInfoMessageDisplay,
        SetInfoMessageDataToDisplayWhenHidden: TrimbleMap.GraticuleRenderer.SetInfoMessageDataToDisplayWhenHidden,
        SetInfoMessageDataToDisplayWhenInvalidExtent: TrimbleMap.GraticuleRenderer.SetInfoMessageDataToDisplayWhenInvalidExtent,        
        ExtentChanged: TrimbleMap.GraticuleRenderer.ExtentChanged,
        PanStart: TrimbleMap.GraticuleRenderer.PanStart,
        CreateGraphicsLayer: TrimbleMap.GraticuleRenderer.CreateGraphicsLayer,
        DestroyGraphicsLayer: TrimbleMap.GraticuleRenderer.DestroyGraphicsLayer,
        UpdateGraphicsForCurrentExtent: TrimbleMap.GraticuleRenderer.UpdateGraphicsForCurrentExtent,
        AdjustScaleRelatedVariables: TrimbleMap.GraticuleRenderer.AdjustScaleRelatedVariables,        
        DrawTile: TrimbleMap.GraticuleRenderer.DrawTile,
        DrawLatitudesAndLongitudes: TrimbleMap.GraticuleRenderer.DrawLatitudesAndLongitudes,
        RemoveTilesNotInView: TrimbleMap.GraticuleRenderer.RemoveTilesNotInView,
        RemoveTiles: TrimbleMap.GraticuleRenderer.RemoveTiles,
        RemoveAllTiles: TrimbleMap.GraticuleRenderer.RemoveAllTiles,
        RemoveLatitudesAndLongitudes: TrimbleMap.GraticuleRenderer.RemoveLatitudesAndLongitudes,
        ScreenDistanceToMapDistance: TrimbleMap.GraticuleRenderer.ScreenDistanceToMapDistance,
        ComputeSideLengthOnScreen: TrimbleMap.GraticuleRenderer.ComputeSideLengthOnScreen,
        ComputeGridRange: TrimbleMap.GraticuleRenderer.ComputeGridRange,
        LimitExtentToValidRange: TrimbleMap.GraticuleRenderer.LimitExtentToValidRange,
        ConvertProjectedOrdinateForDisplay: TrimbleMap.GraticuleRenderer.ConvertProjectedOrdinateForDisplay,
        UpdateExtentValidity: TrimbleMap.GraticuleRenderer.UpdateExtentValidity,
        AddOnVisiblityChanged: TrimbleMap.GraticuleRenderer.AddOnVisiblityChanged,
        RemoveOnVisiblityChanged: TrimbleMap.GraticuleRenderer.RemoveOnVisiblityChanged,
        TriggerOnVisiblityChanged: TrimbleMap.GraticuleRenderer.TriggerOnVisiblityChanged,        
        AddOnExtentValidityChanged: TrimbleMap.GraticuleRenderer.AddOnExtentValidityChanged,
        RemoveOnExtentValidityChanged: TrimbleMap.GraticuleRenderer.RemoveOnExtentValidityChanged,
        TriggerOnExtentValidityChanged: TrimbleMap.GraticuleRenderer.TriggerOnExtentValidityChanged
    };

    return objGraticuleRenderer;
}

// **************************************************************************
// FUNCTION: Activate
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.Activate = function Activate() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // When not already active ...
    if (!objGraticuleRenderer.IsActive) {

        // Set to be active ...
        objGraticuleRenderer.IsActive = true;

        // Create the graphics layer ...
        objGraticuleRenderer.CreateGraphicsLayer();

        // Attach the map event handlers ...
        objGraticuleRenderer.AttachMapEventHandlers();

        // Compute the screen distance for the grid size at the current extent and then draw the current extent's blocks ...
        objGraticuleRenderer.AdjustScaleRelatedVariables(function () {

            // Draw the grid for the current extent ...
            objGraticuleRenderer.UpdateGraphicsForCurrentExtent();
        });
    }
}

// **************************************************************************
// FUNCTION: DeActivate
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.DeActivate = function DeActivate() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // When active ...
    if (objGraticuleRenderer.IsActive) {

        // Set to not be active ...
        objGraticuleRenderer.IsActive = false;
        
        // Detach the map event handlers ...
        objGraticuleRenderer.DetachMapEventHandlers();

        // Destroy the graphics layer ...
        objGraticuleRenderer.DestroyGraphicsLayer();

        // Update the info message display ...
        objGraticuleRenderer.UpdateInfoMessageDisplay();
    }
}

// **************************************************************************
// FUNCTION: SetInfoMessageDataToDisplayWhenHidden
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.SetInfoMessageDataToDisplayWhenHidden = function SetInfoMessageDataToDisplayWhenHidden(objInfoMessageData) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Set to display an info message when hidden ...
    objGraticuleRenderer.DisplayInfoMessageWhenHidden = true;

    // Set the info message to display when hidden ...
    objGraticuleRenderer.HiddenInfoMessageData = objInfoMessageData;

    // Update the info messages to display ...
    objGraticuleRenderer.UpdateInfoMessageDisplay();
}

// **************************************************************************
// FUNCTION: UpdateInfoMessageDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.UpdateInfoMessageDisplay = function UpdateInfoMessageDisplay() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // When we have invalid extent message data to display ...
    if (objGraticuleRenderer.InvalidExtentInfoMessageData != null) {

        // When not active or the fixed sized blocks are visible ...
        if ((!objGraticuleRenderer.IsActive) || objGraticuleRenderer.IsValidExtent) {

            // Remove the info message ...
            objGraticuleRenderer.MapController.InfoMessage.RemoveMessageData(objGraticuleRenderer.InvalidExtentInfoMessageData.Key);

        } else {

            // Add the info message ...
            objGraticuleRenderer.MapController.InfoMessage.AddMessageData(objGraticuleRenderer.InvalidExtentInfoMessageData);
        }
    }
    
    // When we have hidden message data to display ...
    if (objGraticuleRenderer.HiddenInfoMessageData != null) {

        // When not active or the fixed sized blocks are visible ...
        if ((!objGraticuleRenderer.IsActive) || objGraticuleRenderer.ShowFixedSizeBlocksAtCurrentScale || ((!objGraticuleRenderer.IsValidExtent) && (objGraticuleRenderer.InvalidExtentInfoMessageData != null))) {

            // Remove the info message ...
            objGraticuleRenderer.MapController.InfoMessage.RemoveMessageData(objGraticuleRenderer.HiddenInfoMessageData.Key);

        } else {

            // Add the info message ...
            objGraticuleRenderer.MapController.InfoMessage.AddMessageData(objGraticuleRenderer.HiddenInfoMessageData);
        }
    }
}

// **************************************************************************
// FUNCTION: SetInfoMessageDataToDisplayWhenInvalidExtent
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.SetInfoMessageDataToDisplayWhenInvalidExtent = function SetInfoMessageDataToDisplayWhenInvalidExtent(objInfoMessageData) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Set to display an info message when invalid extent ...
    objGraticuleRenderer.DisplayInfoMessageWhenInvalidExtent = true;

    // Set the info message to display when invalid extent ...
    objGraticuleRenderer.InvalidExtentInfoMessageData = objInfoMessageData;

    // Update the info messages to display ...
    objGraticuleRenderer.UpdateInfoMessageDisplay();
}

// **************************************************************************
// FUNCTION: CreateGraphicsLayer
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.CreateGraphicsLayer = function CreateGraphicsLayer() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Create a new graphics layer for the grid ...
    objGraticuleRenderer.GraphicsLayer = new esri.layers.GraphicsLayer();

    // Add the graphics layer to the map ...
    objGraticuleRenderer.MapController.EsriMap.addLayer(objGraticuleRenderer.GraphicsLayer);
}

// **************************************************************************
// FUNCTION: DestroyGraphicsLayer
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.DestroyGraphicsLayer = function DestroyGraphicsLayer() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Remove all the tiles from the map ...
    objGraticuleRenderer.RemoveAllTiles();

    // Remove the latitudes and longitudes from the map ...
    objGraticuleRenderer.RemoveLatitudesAndLongitudes();

    // Remove the graphics layer from the map ...
    objGraticuleRenderer.MapController.EsriMap.removeLayer(objGraticuleRenderer.GraphicsLayer);

    // Set the graphics layer back to null ...
    objGraticuleRenderer.GraphicsLayer = null;
}

// **************************************************************************
// FUNCTION: AttachMapEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.AttachMapEventHandlers = function AttachMapEventHandlers() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Attach an extent changed event handler ...
    objGraticuleRenderer.ExtentChangedHandle = objGraticuleRenderer.MapController.EsriMap.on('extent-change', objGraticuleRenderer.ExtentChangedProxy);

    // Attach an pan start event handler ...
    objGraticuleRenderer.PanStartHandle = objGraticuleRenderer.MapController.EsriMap.on('pan-start', objGraticuleRenderer.PanStartProxy);
}

// **************************************************************************
// FUNCTION: DetachMapEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.DetachMapEventHandlers = function DetachMapEventHandlers() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Detach the extent changed event handler ...
    objGraticuleRenderer.ExtentChangedHandle.remove();

    // Detach the pan start event handler ...
    objGraticuleRenderer.PanStartHandle.remove();
}

// **************************************************************************
// FUNCTION: ExtentChanged
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.ExtentChanged = function ExtentChanged(blnLevelChanged) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // When a previous extent changed event processing is not in progress ...
    if (!objGraticuleRenderer.IsExtentProcessingInProgress) {

        // Set to be in progress ...
        objGraticuleRenderer.IsExtentProcessingInProgress = true;

        // Create a new deferred ...
        var objUpdateGraphicsDeferred = new dojo.Deferred();

        // When the zoom level changed or when the side length on th screen has not been computed yet ...
        if (blnLevelChanged || (!objGraticuleRenderer.SideLengthOnScreenComputed)) {

            // Compute the screen distance for the grid size at the current extent and then draw the current extent's blocks ...
            objGraticuleRenderer.AdjustScaleRelatedVariables(function () {

                // Draw the grid for the current extent ...
                objGraticuleRenderer.UpdateGraphicsForCurrentExtent().then(TrimbleMap.Controller.Shared.TrapException(function () { objUpdateGraphicsDeferred.resolve(); }));

            }, function () {

                // Resolve the deferred ...
                objUpdateGraphicsDeferred.resolve();
            });

        } else {

            // Draw the grid for the current extent ...
            objGraticuleRenderer.UpdateGraphicsForCurrentExtent().then(TrimbleMap.Controller.Shared.TrapException(function () { objUpdateGraphicsDeferred.resolve(); }));
        }

        // When the graphics has been updated ...
        objUpdateGraphicsDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Set to not be in progress anymore ...
            objGraticuleRenderer.IsExtentProcessingInProgress = false;

            // When we have a delayed extent changed event ...
            if (objGraticuleRenderer.HasDelayedExtentChanged) {

                // Set to not have a delayed exent changed event handler ...
                objGraticuleRenderer.HasDelayedExtentChanged = false;

                // Process the delayed extent event ...
                objGraticuleRenderer.ExtentChanged(objGraticuleRenderer.DelayedExtentChangeLevelChanged);
                               
                // Clear the delayed leven changed value ...
                objGraticuleRenderer.DelayedExtentChangeLevelChanged = false;
            }
        }));

    } else {

        // Set to have a delayed exent changed event handler ...
        objGraticuleRenderer.HasDelayedExtentChanged = true;

        // Set the delayed level changed to true when the level changed ...
        objGraticuleRenderer.DelayedExtentChangeLevelChanged = objGraticuleRenderer.DelayedExtentChangeLevelChanged || blnLevelChanged;
    }
}

// **************************************************************************
// FUNCTION: PanStart
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.PanStart = function PanStart(e) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Remove all the latitude and longitude graphics ...
    objGraticuleRenderer.RemoveLatitudesAndLongitudes();
}

// **************************************************************************
// FUNCTION: AdjustScaleRelatedVariables
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.AdjustScaleRelatedVariables = function AdjustScaleRelatedVariables(fnComplete, fnFailure) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Start with being able to draw the grid (this might change if we find a problem with the
    // calculations further down the code due to meassure out of bounds after projection) ...
    objGraticuleRenderer.AbleToDrawGrid = true;

    // Compute the screen distance for the grid size at the current extent ...
    var objDeferred = objGraticuleRenderer.ComputeSideLengthOnScreen();

    // When computed ...
    objDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (decDistanceOnScreenInPixels) {

        // Set the result as properties on objGraticuleRenderer ...
        objGraticuleRenderer.SideLengthOnScreen = decDistanceOnScreenInPixels;

        // Get the current value of ShowFixedSizeBlocksAtCurrentScale ...
        var blnPreviousShowFixedSizeBlocksAtCurrentScale = objGraticuleRenderer.ShowFixedSizeBlocksAtCurrentScale;

        // Show large blocks when the zoomed out so that the side length will be more than FIXED_SIZE_MINIMUM_BLOCK_SIZE_PIXELS on the screen ...
        objGraticuleRenderer.ShowFixedSizeBlocksAtCurrentScale = objGraticuleRenderer.SideLengthOnScreen > TrimbleMap.GraticuleRenderer.Shared.FIXED_SIZE_MINIMUM_BLOCK_SIZE_PIXELS;

        // When the value of ShowFixedSizeBlocksAtCurrentScale changes ...
        if (blnPreviousShowFixedSizeBlocksAtCurrentScale != objGraticuleRenderer.ShowFixedSizeBlocksAtCurrentScale) {

            // Trigger the visibility changed event handler ...
            objGraticuleRenderer.TriggerOnVisiblityChanged(objGraticuleRenderer.ShowFixedSizeBlocksAtCurrentScale);
        }

        // Update the info message display ...
        objGraticuleRenderer.UpdateInfoMessageDisplay();
        
        // Call the complete function when set ...
        if ((typeof fnComplete != 'undefined') && (fnComplete != null)) { fnComplete(); }

    }), TrimbleMap.Controller.Shared.TrapException(function () {
        
        // Call the failure function when set ...
        if ((typeof fnFailure != 'undefined') && (fnFailure != null)) { fnFailure(); }        
    }));
}

// **************************************************************************
// FUNCTION: UpdateGraphicsForCurrentExtent
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.UpdateGraphicsForCurrentExtent = function UpdateGraphicsForCurrentExtent() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Create a deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the GridType is Graticule or when it is fixed sized and we are to show the fixed sized grid at the current scale level ...
    if (((objGraticuleRenderer.GridType == TrimbleMap.GraticuleRenderer.enumGridSizeType.Dynamic) || objGraticuleRenderer.ShowFixedSizeBlocksAtCurrentScale) && objGraticuleRenderer.AbleToDrawGrid) {

        // Compute the range of six second blocks that will fit into the map div ...
        var objComputeGridRangeDeferred = objGraticuleRenderer.ComputeGridRange(objGraticuleRenderer.MapController.EsriMap.extent);

        // When computed ...
        objComputeGridRangeDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Depending on the grid type ...
            switch (objGraticuleRenderer.GridType) {
                case TrimbleMap.GraticuleRenderer.enumGridSizeType.Fixed:

                    // Start with a multiplier of 1 ...
                    objGraticuleRenderer.BlockSizeMultiplier = 1;
                    break;

                case TrimbleMap.GraticuleRenderer.enumGridSizeType.Dynamic:

                    // Compute the approximate screen width that one block will be (in pixels) ...
                    var intGridRangeScreenBlockWidth = objGraticuleRenderer.Range.MapScreenWidth / objGraticuleRenderer.Range.WidthBlocks;

                    // Compute the power of 2 that the grid size should be multiplied by to get a block on the screen of the target approximate block size ...
                    var decGridRangePowerOfTwo = (Math.log(TrimbleMap.GraticuleRenderer.Shared.DYNAMIC_SIZE_MINIMUM_BLOCK_SIZE_PIXELS / intGridRangeScreenBlockWidth) / Math.log(2));

                    // Round up to the closest power of two ...
                    decGridRangePowerOfTwo = Math.ceil(decGridRangePowerOfTwo);

                    // Compute by how much the grid sized side lengths should be multiplied to compute the grid block size to draw ...
                    objGraticuleRenderer.BlockSizeMultiplier = Math.pow(2, decGridRangePowerOfTwo);
                    break;
            }

            // Compute the size of the blocks to be displayed ...
            objGraticuleRenderer.BlockSizeToDisplay = objGraticuleRenderer.BlockSizeMultiplier * objGraticuleRenderer.GridSideLength;

            // Compute the block indices in terms of the block sizes that are to be drawn ...
            var intBottomDisplayBlockIndex = Math.floor(objGraticuleRenderer.Range.BottomGridIndex / objGraticuleRenderer.BlockSizeMultiplier);
            var intTopDisplayBlockIndex = Math.ceil(objGraticuleRenderer.Range.TopGridIndex / objGraticuleRenderer.BlockSizeMultiplier);
            var intLeftDisplayBlockIndex = Math.floor(objGraticuleRenderer.Range.LeftGridIndex / objGraticuleRenderer.BlockSizeMultiplier);
            var intRightDisplayBlockIndex = Math.ceil(objGraticuleRenderer.Range.RightGridIndex / objGraticuleRenderer.BlockSizeMultiplier);

            //  Compute the index ranges of the Map.GraticuleRenderer.Shared.TILE_SIZE sized tiles to draw ...
            var intBottomTileIndex = Math.floor(intBottomDisplayBlockIndex / TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE);
            var intTopTileIndex = Math.ceil(intTopDisplayBlockIndex / TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE);
            var intLeftTileIndex = Math.floor(intLeftDisplayBlockIndex / TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE);
            var intRightTileIndex = Math.ceil(intRightDisplayBlockIndex / TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE);

            // Create the Tiles hash table when it does not exist ...
            if (objGraticuleRenderer.Tiles == null) { objGraticuleRenderer.Tiles = {}; }
            
            // Get the zoom level ...
            var intZoomLevel = objGraticuleRenderer.MapController.EsriMap.getLevel();

            // When the zoom level changed ...
            if ((objGraticuleRenderer.GridType == TrimbleMap.GraticuleRenderer.enumGridSizeType.Dynamic) &&
                (objGraticuleRenderer.PreviousZoomLevel != null) && (objGraticuleRenderer.PreviousZoomLevel != intZoomLevel)) {

                // Remove all the tiles ...
                objGraticuleRenderer.RemoveAllTiles();
            }

            // Set the drawn zoom level for the next time ...
            objGraticuleRenderer.PreviousZoomLevel = intZoomLevel;

            // Create a new array to keep the deferreds for drawing the tiles ...
            var arrDeferreds = [];

            // Compute the tile range width and heigth ...
            var intTileRangeWidth = Math.abs(intRightTileIndex - intLeftTileIndex);
            var intTileRangeHeight = Math.abs(intTopTileIndex - intBottomTileIndex);

            // When the grid raneg is not larger than expected ...
            if ((intTileRangeWidth <= TrimbleMap.GraticuleRenderer.Shared.MAX_TILE_RANGE_TO_DRAW) && (intTileRangeHeight <= TrimbleMap.GraticuleRenderer.Shared.MAX_TILE_RANGE_TO_DRAW)) {

                // Loop through all the rows of tiles from the bottom to top ...
                for (var intYTileIndex = intBottomTileIndex; intYTileIndex <= intTopTileIndex; intYTileIndex++) {

                    // Loop through all the columns of tiles from left to right ...
                    for (var intXTileIndex = intLeftTileIndex; intXTileIndex <= intRightTileIndex; intXTileIndex++) {

                        // Draw the tile ...
                        arrDeferreds.push(objGraticuleRenderer.DrawTile(intXTileIndex, intYTileIndex, objGraticuleRenderer.MapController.EsriMap.extent));
                    }
                }
            }

            // When all the tile drawing is completed ...
            (new dojo.promise.all(arrDeferreds)).then(TrimbleMap.Controller.Shared.TrapException(function () {

                // Remove the tiles that are not in view ...
                objGraticuleRenderer.RemoveTilesNotInView(intBottomTileIndex, intTopTileIndex, intLeftTileIndex, intRightTileIndex);

                // Draw the latitude and longitude lines ...
                objGraticuleRenderer.DrawLatitudesAndLongitudes(intBottomDisplayBlockIndex, intTopDisplayBlockIndex, intLeftDisplayBlockIndex, intRightDisplayBlockIndex,
                                                                intBottomTileIndex, intTopTileIndex, intLeftTileIndex, intRightTileIndex);


                // Set to be able to draw the grid ...
                objGraticuleRenderer.AbleToDrawGrid = true;

                // Update the extent validity to true ...
                objGraticuleRenderer.UpdateExtentValidity(objGraticuleRenderer.AbleToDrawGrid);

                // Resolve the deferred ...
                objDeferred.resolve();
            }));

        }), TrimbleMap.Controller.Shared.TrapException(function () {

            // Resolve the deferred ...
            objDeferred.resolve();
        }));

    } else {

        // GridType is fixed sized and the fixed sized blocks are not to be visible at the current scale ...
        
        // Remove all the tiles ...
        objGraticuleRenderer.RemoveAllTiles();

        // Remove the latitude and longitude labels ...
        objGraticuleRenderer.RemoveLatitudesAndLongitudes();

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    // Return the deferred ...
    return objDeferred;
}

// **************************************************************************
// FUNCTION: LimitExtentToValidRange
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.LimitExtentToValidRange = function LimitExtentToValidRange(objExtent) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Create a deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the grid is in a geographic spatial reference ...
    if (objGraticuleRenderer.GridSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC) {

        // When we already computed the Valid geographic extent for the grid in the map's spatial reference ...
        if (objGraticuleRenderer.ValidGeographicGridExtentInMapSpatialReference != null) {

            // Limit the extent to it ...
            var objLimitedExtent = TrimbleMap.GraticuleRenderer.Shared.LimitExtentToExtent(objExtent, objGraticuleRenderer.ValidGeographicGridExtentInMapSpatialReference);

            // Return the limited extent ...
            objDeferred.resolve(objLimitedExtent);

        } else {

            // Create a valid geographic extent in the grid's spatial reference ...
            var objValidGeographicExtent = new esri.geometry.Extent(-179, -89, 179, 89, objGraticuleRenderer.GridEsriSpatialReference);
            
            // Project the extent from the grid's spatial reference to the map's spatial reference ...
            var objProjectGeometryDeferred = objGraticuleRenderer.MapController.ProjectGeometry(objValidGeographicExtent, objGraticuleRenderer.GridSpatialReferenceID, objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID, true, TrimbleMap.enumProjectionLevel.RELAXED);

            // When the projection completes ...
            objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedValidGeographicExtent) {

                // Set it as a property on objGraticuleRenderer for later re-use ...
                objGraticuleRenderer.ValidGeographicGridExtentInMapSpatialReference = objProjectedValidGeographicExtent;

                // Limit the extent to it ...
                var objLimitedExtent = TrimbleMap.GraticuleRenderer.Shared.LimitExtentToExtent(objExtent, objGraticuleRenderer.ValidGeographicGridExtentInMapSpatialReference);

                // Return the limited extent ...
                objDeferred.resolve(objLimitedExtent);
            }), TrimbleMap.Controller.Shared.TrapException(function (objProjectionError) {

                // When the measures are out of bounds ...
                if ((typeof objProjectionError.IsMeasuresOutOfBoundsException != 'undefined') && objProjectionError.IsMeasuresOutOfBoundsException) {
                    
                    // Set to be able to draw the grid ...
                    objGraticuleRenderer.AbleToDrawGrid = false;

                    // Update the extent validity to true ...
                    objGraticuleRenderer.UpdateExtentValidity(objGraticuleRenderer.AbleToDrawGrid);

                    // Reject the deferred ...
                    objDeferred.reject(objProjectionError);
                }
            }));
        }

    } else {

        // Return the extent as is ...
        objDeferred.resolve(objExtent);
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: LimitExtentToExtent
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.Shared.LimitExtentToExtent = function LimitExtentToExtent(objExtentToLimit, objLimitingExtent) {

    // Clone the extent to limit ...
    var objExtent = new esri.geometry.Extent(objExtentToLimit.toJson());

    // Limit xmin within the x range ...
    if (objExtent.xmin < objLimitingExtent.xmin) { objExtent.xmin = objLimitingExtent.xmin; }
    if (objExtent.xmin > objLimitingExtent.xmax) { objExtent.xmin = objLimitingExtent.xmax; }

    // Limit xmax within the x range ...
    if (objExtent.xmax < objLimitingExtent.xmin) { objExtent.xmax = objLimitingExtent.xmin; }
    if (objExtent.xmax > objLimitingExtent.xmax) { objExtent.xmax = objLimitingExtent.xmax; }

    // Limit ymin within the y range ...
    if (objExtent.ymin < objLimitingExtent.ymin) { objExtent.ymin = objLimitingExtent.ymin; }
    if (objExtent.ymin > objLimitingExtent.ymax) { objExtent.ymin = objLimitingExtent.ymax; }

    // Limit ymax within the y range ...
    if (objExtent.ymax < objLimitingExtent.ymin) { objExtent.ymax = objLimitingExtent.ymin; }
    if (objExtent.ymax > objLimitingExtent.ymax) { objExtent.ymax = objLimitingExtent.ymax; }

    return objExtent;
}

// **************************************************************************
// FUNCTION: ComputeGridRange
// USAGE:    Computes the range of six second blocks that will fit into the map div ...
// **************************************************************************
TrimbleMap.GraticuleRenderer.ComputeGridRange = function ComputeGridRange(objExtentToComputeFor) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Create a deferred to return ...
    var objDeferred = new dojo.Deferred();
    
    // Limit the extent to the valid range ...
    var objLimitingDeferred = objGraticuleRenderer.LimitExtentToValidRange(objExtentToComputeFor);

    // When the limiting computation is completed ...
    objLimitingDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objExtent) {

        // Get the mapping spatial reference ...
        var objMapEsriSpatialReference = objGraticuleRenderer.MapController.CreateEsriSpatialReference(objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID);

        // Get the top left and bottom right points of the extent ...
        var objTopLeftPoint = new esri.geometry.Point(objExtent.xmin, objExtent.ymax, objMapEsriSpatialReference);
        var objBottomRightPoint = new esri.geometry.Point(objExtent.xmax, objExtent.ymin, objMapEsriSpatialReference);

        // Project the points to the spatial reference of the map ...
        var objProjectionDeferred = objGraticuleRenderer.MapController.ProjectGeometries([objTopLeftPoint, objBottomRightPoint], objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID, objGraticuleRenderer.GridSpatialReferenceID, true, TrimbleMap.enumProjectionLevel.RELAXED, true);

        // When the projection completes ...
        objProjectionDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedPoints) {

            // Get the projected points ...
            var objProjectedTopLeftPoint = arrProjectedPoints[0];
            var objProjectedBottomRightPoint = arrProjectedPoints[1];

            // Compute the width and height in map coordinates ...
            var intMapWidth = Math.abs(objProjectedBottomRightPoint.x - objProjectedTopLeftPoint.x);
            var intMapHeight = Math.abs(objProjectedBottomRightPoint.y - objProjectedTopLeftPoint.y);

            // Compute the range ...
            objGraticuleRenderer.Range = {
                WidthBlocks: Math.ceil(intMapWidth / objGraticuleRenderer.GridSideLength),
                HeightBlocks: Math.ceil(intMapHeight / objGraticuleRenderer.GridSideLength),
                MapScreenWidth: objGraticuleRenderer.MapController.MapElement.width(),
                MapScreenHeight: objGraticuleRenderer.MapController.MapElement.height(),
                TopGridIndex: Math.ceil(objProjectedTopLeftPoint.y / objGraticuleRenderer.GridSideLength), // Assumes grid origin at (0, 0) ...
                LeftGridIndex: Math.floor(objProjectedTopLeftPoint.x / objGraticuleRenderer.GridSideLength),
                BottomGridIndex: Math.floor(objProjectedBottomRightPoint.y / objGraticuleRenderer.GridSideLength),
                RightGridIndex: Math.ceil(objProjectedBottomRightPoint.x / objGraticuleRenderer.GridSideLength)
            };

            // Resolve the deferred ...
            objDeferred.resolve();
            
        }), TrimbleMap.Controller.Shared.TrapException(function (objProjectionError) {

            // When the measures are out of bounds ...
            if ((typeof objProjectionError.IsMeasuresOutOfBoundsException != 'undefined') && objProjectionError.IsMeasuresOutOfBoundsException) {

                // Set to be able to draw the grid ...
                objGraticuleRenderer.AbleToDrawGrid = false;

                // Update the extent validity to true ...
                objGraticuleRenderer.UpdateExtentValidity(objGraticuleRenderer.AbleToDrawGrid);

                // Reject the deferred ...
                objDeferred.reject(objProjectionError);
            }
        }));
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: DrawTile
// USAGE:    Draws a tile with Map.GraticuleRenderer.Shared.TILE_SIZE rows
//           and Map.GraticuleRenderer.Shared.TILE_SIZE columns of blocks ...
// **************************************************************************
TrimbleMap.GraticuleRenderer.DrawTile = function DrawTile(intXTileIndex, intYTileIndex, objExtent) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Create a new deferred ...
    var objDeferred = new dojo.Deferred();

    // Get the the row of tiles ...
    var objRowTiles = objGraticuleRenderer.Tiles[intYTileIndex];

    // When no row were found ...
    if ((typeof objRowTiles == 'undefined') || (objRowTiles == null)) {

        // Create a new hash table for the row ...
        objRowTiles = {};

        // Add to the main hash table ...
        objGraticuleRenderer.Tiles[intYTileIndex] = objRowTiles;
    }

    // Get the tile ...
    var objTile = objRowTiles[intXTileIndex];

    // When a tile already exists ...
    if ((typeof objTile != 'undefined') && (objTile != null)) {

        // Resolve the deferred ...
        objDeferred.resolve();

    } else {

        // Get the esri map spatial reference ...
        var objMapEsriSpatialReference = objGraticuleRenderer.MapController.CreateEsriSpatialReference(objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID);

        // * Draw the horizontal lines ...

        // Compute the tile x base value (where the left column of the grid should be drawn) ...
        var decTileXBase = intXTileIndex * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE * objGraticuleRenderer.BlockSizeToDisplay;

        // Compute the tile y base value (where the bottom row of the grid should be drawn) ...
        var decTileYBase = intYTileIndex * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE * objGraticuleRenderer.BlockSizeToDisplay;

        // Compute the left x of the tile ...
        var decLeft = intXTileIndex * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE * objGraticuleRenderer.BlockSizeToDisplay;

        // Compute the right x of the tile ...
        var decRight = (intXTileIndex + 1) * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE * objGraticuleRenderer.BlockSizeToDisplay;

        // Compute the top y of the tile ...
        var decTop = intYTileIndex * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE * objGraticuleRenderer.BlockSizeToDisplay;

        // Compute the bottom y of the tile ...
        var decBottom = (intYTileIndex + 1) * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE * objGraticuleRenderer.BlockSizeToDisplay;
        
        // When the grid is in a geographic spatial reference ...
        if (objGraticuleRenderer.GridSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC) {

            // Limit within the valid geographic range ...
            if (decLeft < -179.99999999) { decLeft = -179.99999999; }
            if (decLeft > 179.99999999) { decLeft = 179.99999999; }

            if (decRight < -179.99999999) { decRight = -179.99999999; }
            if (decRight > 179.99999999) { decRight = 179.99999999; }
                        
            if (decTop < -89.99999999) { decTop = -89.99999999; }
            if (decTop > 89.99999999) { decTop = 89.99999999; }

            if (decBottom < -89.99999999) { decBottom = -89.99999999; }
            if (decBottom > 89.99999999) { decBottom = 89.99999999; }
        }

        // Create a new arrays for the thin and thick line paths ...
        var arrThinLinePaths = [];
        var arrThickLinePaths = [];

        // Create arrays for the points ...
        var arrLeftPoints = [];
        var arrRightPoints = [];
        var arrTopPoints = [];
        var arrBottomPoints = [];

        // Loop through all the rows ...
        for (var intY = 0; intY < TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE; intY++) {

            // Compute the Y for the current row ...
            var decY = decTileYBase + (intY * objGraticuleRenderer.BlockSizeToDisplay);

            // Compute and add the left point ...
            arrLeftPoints.push([decLeft, decY]);

            // Compute and add the right point ...
            arrRightPoints.push([decRight, decY]);
        }

        // Loop through all the columns ...
        for (var intX = 0; intX < TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE; intX++) {

            // Compute the X for the current row ...
            var decX = decTileXBase + (intX * objGraticuleRenderer.BlockSizeToDisplay);

            // Compute and add the left point ...
            arrTopPoints.push([decX, decTop]);

            // Compute and add the right point ...
            arrBottomPoints.push([decX, decBottom]);
        }

        // Create a new polyline object from the thin lines ...
        var objEndPointsPolyline = esri.geometry.Polyline({ paths: [arrLeftPoints, arrRightPoints, arrTopPoints, arrBottomPoints], spatialReference: objGraticuleRenderer.GridEsriSpatialReference });

        // Project the geometry ...
        var objProjectGeometryDeferred = objGraticuleRenderer.MapController.ProjectGeometry(objEndPointsPolyline, objGraticuleRenderer.GridSpatialReferenceID, objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID, false, TrimbleMap.enumProjectionLevel.RELAXED);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedEndPoints) {
            
			// When not all the projected paths are returned (something went wrong?) ...
            if (objProjectedEndPoints.paths.length >= 4) {

                // Get the projected left, right, top and bottom points ...
                var arrProjectedLeftPoints = objProjectedEndPoints.paths[0];
                var arrProjectedRightPoints = objProjectedEndPoints.paths[1];
                var arrProjectedTopPoints = objProjectedEndPoints.paths[2];
                var arrProjectedBottomPoints = objProjectedEndPoints.paths[3];

                // Loop through all the rows ...
                for (var intY = 0; intY < TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE; intY++) {

                    // Get the projected left point ...
                    var objLeft = arrProjectedLeftPoints[intY];

                    // Compute the right screen point ...
                    var objRight = arrProjectedRightPoints[intY];

                    // Add a new array with the left and right points of the path ...
                    var objPath = [objLeft, objRight];

                    // When we are to not draw thick lines or when we are on a line within the thick line interval ...
                    if ((((intYTileIndex * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE) + intY) % TrimbleMap.GraticuleRenderer.Shared.THICK_LINE_INTERVAL) != 0) {

                        // Add to the thin line paths ...
                        arrThinLinePaths.push(objPath);

                    } else {

                        // Add to the thick line paths ...
                        arrThickLinePaths.push(objPath);
                    }
                }

                // Loop through all the columns ...
                for (var intX = 0; intX < TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE; intX++) {

                    // Compute the left line point in web mercator ...
                    var objTop = arrProjectedTopPoints[intX];

                    // Compute the right line point in web mercator ...
                    var objBottom = arrProjectedBottomPoints[intX];

                    // Add a new array with the top and bottom points of the path ...
                    var objPath = [objTop, objBottom];

                    // When we are to not draw thick lines or when we are on a line within the thick line interval ...
                    if ((((intXTileIndex * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE) + intX) % TrimbleMap.GraticuleRenderer.Shared.THICK_LINE_INTERVAL) != 0) {

                        // Add to the thin line paths ...
                        arrThinLinePaths.push(objPath);

                    } else {

                        // Add to the thick line paths ...
                        arrThickLinePaths.push(objPath);
                    }
                }

                // Create a new polyline object from the thin lines ...
                var objThinPolyline = esri.geometry.Polyline({ 'paths': arrThinLinePaths, 'spatialReference': objMapEsriSpatialReference });

                // Use a semi-transparent solid line ...
                var objThinLineSymbol = new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([objGraticuleRenderer.GridColor.R, objGraticuleRenderer.GridColor.G, objGraticuleRenderer.GridColor.B, 0.2]), 1);

                // Create the graphic ....
                var objThinLineGraphic = new esri.Graphic(objThinPolyline, objThinLineSymbol);

                // Add the graphic to the map ...
                objGraticuleRenderer.GraphicsLayer.add(objThinLineGraphic);

                // Create a new polyline object from the thick lines ...
                var objThickPolyline = esri.geometry.Polyline({ 'paths': arrThickLinePaths, 'spatialReference': objMapEsriSpatialReference });

                // Use a semi-transparent solid line ...
                var objThickLineSymbol = new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([objGraticuleRenderer.GridColor.R, objGraticuleRenderer.GridColor.G, objGraticuleRenderer.GridColor.B, 0.4]), 2);

                // Create the graphic ....
                var objThickLineGraphic = new esri.Graphic(objThickPolyline, objThickLineSymbol);

                // Add the graphic to the map ...
                objGraticuleRenderer.GraphicsLayer.add(objThickLineGraphic);

                // Create a new tile object to return ...
                var objTile = {
                    ThinLineGraphic: objThinLineGraphic,
                    ThickLineGraphic: objThickLineGraphic,
                    XTileIndex: intXTileIndex,
                    YTileIndex: intYTileIndex,
                    ProjectedLeftPoints: arrProjectedLeftPoints,
                    ProjectedRightPoints: arrProjectedRightPoints,
                    ProjectedTopPoints: arrProjectedTopPoints,
                    ProjectedBottomPoints: arrProjectedBottomPoints
                }

                // Place the tile into the row hash table ...
                objRowTiles[intXTileIndex] = objTile;

                // Resolve the deferred to indicate completion ...
                objDeferred.resolve();

            } else {

                // Set to be able to draw the grid ...
                objGraticuleRenderer.AbleToDrawGrid = false;

                // Update the extent validity to true ...
                objGraticuleRenderer.UpdateExtentValidity(objGraticuleRenderer.AbleToDrawGrid);

                // Reject the deferred ...
                objDeferred.reject('Less than 4 paths returned after projecting polyline with 4 paths');
            }

        }), TrimbleMap.Controller.Shared.TrapException(function (objProjectionError) {

            // When the measures are out of bounds ...
            if ((typeof objProjectionError.IsMeasuresOutOfBoundsException != 'undefined') && objProjectionError.IsMeasuresOutOfBoundsException) {

                // Set to be able to draw the grid ...
                objGraticuleRenderer.AbleToDrawGrid = false;

                // Update the extent validity to true ...
                objGraticuleRenderer.UpdateExtentValidity(objGraticuleRenderer.AbleToDrawGrid);

                // Reject the deferred ...
                objDeferred.reject(objProjectionError);
            }
        }));
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: RemoveTilesNotInView
// USAGE:    Remove all the tiles that are not visible at the current extent ...
// **************************************************************************
TrimbleMap.GraticuleRenderer.RemoveTilesNotInView = function RemoveTilesNotInView(intBottomTileIndex, intTopTileIndex, intLeftTileIndex, intRightTileIndex) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Create a new hash table to add the tiles to remove to ...
    var arrTilesToRemove = [];

    // Loop through all the rows of tiles ...
    $.each(objGraticuleRenderer.Tiles, function (intYTileIndex, objTileRow) {

        // When set ...
        if (objTileRow != null) {

            // When not in view ...
            if ((intYTileIndex < intBottomTileIndex) || (intYTileIndex > intTopTileIndex)) {

                // Add the tiles in the row to the tiles to remove ...
                $.each(objTileRow, function (intIndex, objTile) {

                    // Add to the tiles to remove ...
                    arrTilesToRemove.push(objTile);
                });

            } else {

                // Loop through all the tiles ...
                $.each(objTileRow, function (intXTileIndex, objTile) {

                    // When not in view ...
                    if ((intXTileIndex < intLeftTileIndex) || (intXTileIndex > intRightTileIndex)) {

                        // Add to the tiles to remove ...
                        arrTilesToRemove.push(objTile);
                    }
                });
            }
        }
    });

    // Remove the tiles ...
    objGraticuleRenderer.RemoveTiles(arrTilesToRemove);
}

// **************************************************************************
// FUNCTION: RemoveTiles
// USAGE:    Remove all the tiles in the array from the map ...
// **************************************************************************
TrimbleMap.GraticuleRenderer.RemoveTiles = function RemoveTiles(arrTilesToRemove) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Lopo through all the tiles to remove ...
    $.each(arrTilesToRemove, function (intTile, objTile) {

        // Remove the graphics from the map ...
        objGraticuleRenderer.GraphicsLayer.remove(objTile.ThickLineGraphic);
        objGraticuleRenderer.GraphicsLayer.remove(objTile.ThinLineGraphic);

        // Remove the tile from tiles ...
        delete objGraticuleRenderer.Tiles[objTile.YTileIndex][objTile.XTileIndex];
    });
}

// **************************************************************************
// FUNCTION: RemoveAllTiles
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.RemoveAllTiles = function RemoveAllTiles() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Loop through all the rows of tiles ...
    $.each(objGraticuleRenderer.Tiles, function (intYTileIndex, objTileRow) {

        // Loop through all the tiles ...
        $.each(objTileRow, function (intXTileIndex, objTile) {

            // Remove the graphics from the map ...
            objGraticuleRenderer.GraphicsLayer.remove(objTile.ThickLineGraphic);
            objGraticuleRenderer.GraphicsLayer.remove(objTile.ThinLineGraphic);
        });
    });

    // Clear the tiles hash table ...
    objGraticuleRenderer.Tiles = {};
}

// **************************************************************************
// FUNCTION: RemoveLatitudesAndLongitudes
// USAGE:    Remove all the latitude and longitude symbols on the map ...
// **************************************************************************
TrimbleMap.GraticuleRenderer.RemoveLatitudesAndLongitudes = function RemoveLatitudesAndLongitudes() {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // When we have latitudes and longitudes ...
    if (objGraticuleRenderer.LatitudeAndLongitudeGraphics != null) {

        // Loop through all the latitude and longitude graphics on the map ...
        $.each(objGraticuleRenderer.LatitudeAndLongitudeGraphics, function (intIndex, objGraphic) {

            // Remove the graphic from the map  ...
            objGraticuleRenderer.GraphicsLayer.remove(objGraphic);
        });

        // Delete the array ...
        objGraticuleRenderer.LatitudeAndLongitudeGraphics = null;
    }
}

// **************************************************************************
// FUNCTION: DrawLatitudesAndLongitudes
// USAGE:    Draws the latitudes and longuitudes for the current view ...
// **************************************************************************
TrimbleMap.GraticuleRenderer.DrawLatitudesAndLongitudes = function DrawLatitudesAndLongitudes(intBottomDisplayBlockIndex, intTopDisplayBlockIndex, intLeftDisplayBlockIndex, intRightDisplayBlockIndex,
                                                                                       intBottomTileIndex, intTopTileIndex, intLeftTileIndex, intRightTileIndex) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Remove all the latitude and longitude graphics ...
    objGraticuleRenderer.RemoveLatitudesAndLongitudes();

    // Get the current map extent ...
    var objMapExtent = objGraticuleRenderer.MapController.EsriMap.extent;

    // Get the map spatial reference ...
    var objMapSpatialReference = objGraticuleRenderer.MapController.GetSpatialReference(objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID);
    var objMapEsriSpatialReference = objGraticuleRenderer.MapController.CreateEsriSpatialReference(objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID);
    
    // Get the North, South, East and West translations ...
    var strN = SD.Translation.Shared.GetTranslation('SD.DMS.js', 'NorthAbbreviation');
    var strS = SD.Translation.Shared.GetTranslation('SD.DMS.js', 'SouthAbbreviation');
    var strE = SD.Translation.Shared.GetTranslation('SD.DMS.js', 'EastAbbreviation');
    var strW = SD.Translation.Shared.GetTranslation('SD.DMS.js', 'WestAbbreviation');

    // Create a color to draw the latitude and longitudes with ...
    var objColor = new dojo.Color([objGraticuleRenderer.GridColor.R, objGraticuleRenderer.GridColor.G, objGraticuleRenderer.GridColor.B, 0.4]);

    // Create an array to add the longitude and latitude graphics to ...
    var arrGraphics = [];

    // Compute the distance in map for 1 pixel at the current extent ...
    var decSpacerDistance1px = objGraticuleRenderer.ScreenDistanceToMapDistance(1);

    // Compute the distance on the screen for a the drawn blocks ...
    var intDrawnBlockSideLengthOnScreen = objGraticuleRenderer.BlockSizeMultiplier * objGraticuleRenderer.SideLengthOnScreen;

    // Determine whether or not we should draw a label on every line or only on the thick lines ...
    var blnDrawOnEveryGridLine = intDrawnBlockSideLengthOnScreen > TrimbleMap.GraticuleRenderer.Shared.MINIMUM_SCREEN_SIZE_FOR_LABEL_DRAW_ON_EVERY_LINE;

    // Loop through all the horizontal thick lines ... 
    for (var intY = intBottomDisplayBlockIndex; intY <= intTopDisplayBlockIndex; intY++) {

        // When we are to draw a label on every grid line or when we are on a thick line ...
        if (blnDrawOnEveryGridLine || ((intY % TrimbleMap.GraticuleRenderer.Shared.THICK_LINE_INTERVAL) == 0)) {

            // Compute the latitude of the line ...
            var decY = intY * objGraticuleRenderer.BlockSizeToDisplay;

            // Convert the ordinate to text ...
            var strText = (objGraticuleRenderer.GridSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC) ?
                           SD.DMS.OrdinateToDMS(decY, strN, strS, objGraticuleRenderer.MapController.State.GroupSeparator, objGraticuleRenderer.MapController.State.DecimalSeparator, 0).DMS :
                           objGraticuleRenderer.ConvertProjectedOrdinateForDisplay(decY, objMapSpatialReference);

            // Create a font to draw the latitude and longitudes with ...
            var objFont = new esri.symbol.Font('8pt', esri.symbol.Font.STYLE_NORMAL, esri.symbol.Font.VARIANT_NORMAL, esri.symbol.Font.WEIGHT_BOLD, 'Verdana, Helvetica, Arial, sans-serif');

            // Create a text symbol for the latitude ...
            var objLatitudeTextSymbol = new esri.symbol.TextSymbol(strText, objFont, objColor);

            // Align the text to the right of the graphic ...
            objLatitudeTextSymbol.setHorizontalAlignment('left');

            // Compute the Y grid index ...
            var intYTileIndex = Math.floor(intY / TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE);

            // Get the tiles at the y grid index ....
            var objTilesForRow = objGraticuleRenderer.Tiles[intYTileIndex];
            
            // When we have tiles for the row ...
            if ((typeof objTilesForRow != 'undefined') && (objTilesForRow != null)) {
                
                // Get the grid in which the left most block of the row is ...
                var objTile = objTilesForRow[intLeftTileIndex];

                // When the grid was found ...
                if (typeof objTile != 'undefined') {

                    // Compute the Y position inside the grid ...
                    var intYInTile = intY - (intYTileIndex * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE);

                    // Get the left and right points for the row ...
                    var objLeftPoint = objTile.ProjectedLeftPoints[intYInTile];
                    var objRightPoint = objTile.ProjectedRightPoints[intYInTile];

                    // Set the x to be at the left and calculate the Y as the intersection of the vertical line through objLatitudePoint.x and the line from objLeftPoint to objRightPoint ...
                    var decLatitudePointX = objMapExtent.xmin + (decSpacerDistance1px * 8);
                    var decLatitudePointY = objLeftPoint[1] + (((objRightPoint[1] - objLeftPoint[1]) / (objRightPoint[0] - objLeftPoint[0])) * (decLatitudePointX - objLeftPoint[0])) + (decSpacerDistance1px * 2);

                    // Build an esri point ...
                    let objLatitudePoint = new esri.geometry.Point(decLatitudePointX, decLatitudePointY, objMapEsriSpatialReference);

                    // Create the graphic ...
                    var objGraphic = new esri.Graphic(objLatitudePoint, objLatitudeTextSymbol);

                    // Add the graphic to the map ...
                    objGraticuleRenderer.GraphicsLayer.add(objGraphic);

                    // Add the graphic to the list of graphics ...
                    arrGraphics.push(objGraphic);
                }
            }
        }
    }

    // Loop through all the vertical thick lines ...
    for (var intX = intLeftDisplayBlockIndex; intX <= intRightDisplayBlockIndex; intX++) {

        // When we are to draw a label on every grid line or when we are on a thick line ...
        if (blnDrawOnEveryGridLine || ((intX % TrimbleMap.GraticuleRenderer.Shared.THICK_LINE_INTERVAL) == 0)) {
            
            // Compute the longitude of the line ...
            var decX = intX * objGraticuleRenderer.BlockSizeToDisplay;

            // Create a font to draw the latitude and longitudes with ...
            var objFont = new esri.symbol.Font('8pt', esri.symbol.Font.STYLE_NORMAL, esri.symbol.Font.VARIANT_NORMAL, esri.symbol.Font.WEIGHT_BOLD, 'Verdana, Helvetica, Arial, sans-serif');

            // Convert the ordinate to text ...
            var strText = (objGraticuleRenderer.GridSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC) ?
                           SD.DMS.OrdinateToDMS(decX, strE, strW, objGraticuleRenderer.MapController.State.GroupSeparator, objGraticuleRenderer.MapController.State.DecimalSeparator, 0).DMS :
                           objGraticuleRenderer.ConvertProjectedOrdinateForDisplay(decX, objMapSpatialReference);

            // Create a text symbol for the longitude ...
            var objLongitudeTextSymbol = new esri.symbol.TextSymbol(strText, objFont, objColor);

            // Set to align the start of the text with the anchor point ...
            objLongitudeTextSymbol.setAlign(esri.symbol.TextSymbol.ALIGN_START);

            // Set to rotate clockwise with 90 degrees ...
            objLongitudeTextSymbol.setAngle(90);

            // Compute the X tile index ...
            var intXTileIndex = Math.floor(intX / TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE);

            // Get the row of tiles at the top tile index ...
            var objRowTiles = objGraticuleRenderer.Tiles[intTopTileIndex];

            // When we have tiles for the row ...
            if (typeof objRowTiles != 'undefined') {

                // Get the grid in which the top most block of the column is ...
                var objTile = objRowTiles[intXTileIndex];

                // When we have a grid ...
                if ((typeof objTile != 'undefined') && (objTile != null)) {

                    // Compute the X position inside the grid ...
                    var intXInTile = intX - (intXTileIndex * TrimbleMap.GraticuleRenderer.Shared.TILE_SIZE);

                    // Get the top and bottom points for the row ...
                    var objTopPoint = objTile.ProjectedTopPoints[intXInTile];
                    var objBottomPoint = objTile.ProjectedBottomPoints[intXInTile];

                    // Set the y to be at the bottom and calculate the X as the intersection of the horizontal line through objLatitudePoint.y and the line from objTopPoint to objBottomPoint ...
                    var decLongitudePointY = objMapExtent.ymax - (decSpacerDistance1px * 8);
                    var decLongitudePointX = objTopPoint[0] + (((objBottomPoint[0] - objTopPoint[0]) / (objBottomPoint[1] - objTopPoint[1])) * (decLongitudePointY - objTopPoint[1])) + (decSpacerDistance1px * 2);

                    // Build an esri point ...
                    let objLongitudePoint = new esri.geometry.Point(decLongitudePointX, decLongitudePointY, objMapEsriSpatialReference);

                    // Create the graphic ...
                    var objGraphic = new esri.Graphic(objLongitudePoint, objLongitudeTextSymbol);

                    // Add the graphic to the map ...
                    objGraticuleRenderer.GraphicsLayer.add(objGraphic);

                    // Add the graphic to the list of graphics ...
                    arrGraphics.push(objGraphic);
                }
            }
        }
    }

    // Set the list of graphics added ...
    objGraticuleRenderer.LatitudeAndLongitudeGraphics = arrGraphics;
}

// **************************************************************************
// FUNCTION: ConvertProjectedOrdinateForDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.ConvertProjectedOrdinateForDisplay = function ConvertProjectedOrdinateForDisplay(decOrdinate, objSpatialReference) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Convert the value to a string ...
    var strOrdinate = SD.DisplayValue.FromDouble(decOrdinate, objGraticuleRenderer.MapController.State.GroupSeparator, objGraticuleRenderer.MapController.State.DecimalSeparator);

    // Add the unit abbreviation ...
    var strOrdinateForDisplay = strOrdinate + ' ' + objSpatialReference.CoordinateUnitAbbreviation;

    return strOrdinateForDisplay;
}

// **************************************************************************
// FUNCTION: ScreenDistanceToMapDistance
// USAGE:    Computes the approximate distance in map units for the screen distance for the current extent ...
// **************************************************************************
TrimbleMap.GraticuleRenderer.ScreenDistanceToMapDistance = function ScreenDistanceToMapDistance(decScreenDistance) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Create a point at (xmin, ymin) ...
    var objLeftPoint = objGraticuleRenderer.MapController.EsriMap.toMap(new esri.geometry.Point(objGraticuleRenderer.MapController.EsriMap.extent.xmin, objGraticuleRenderer.MapController.EsriMap.extent.ymax, objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID));

    // Create a point at (xmin + decScreenDistance, ymin) ...
    var objRightPoint = objGraticuleRenderer.MapController.EsriMap.toMap(new esri.geometry.Point(objGraticuleRenderer.MapController.EsriMap.extent.xmin + decScreenDistance, objGraticuleRenderer.MapController.EsriMap.extent.ymax, objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID));

    // Compute the width ...
    var decWidth = Math.abs(objRightPoint.x - objLeftPoint.x);

    return decWidth;
}

// **************************************************************************
// FUNCTION: ComputeSideLengthOnScreen
// USAGE:    Computes the side length on the screen  ...
// **************************************************************************
TrimbleMap.GraticuleRenderer.ComputeSideLengthOnScreen = function ComputeSideLengthOnScreen() {

    // Get the instance ...
    var objGraticuleRenderer = this;
    
    // Create a deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Get the current map extent ...
    var objMapExtent = objGraticuleRenderer.MapController.EsriMap.extent;

    // Get the map div size in pixels ...
    var intMapScreenWidth = objGraticuleRenderer.MapController.MapElement.width();
    var intMapScreenHeight = objGraticuleRenderer.MapController.MapElement.height();

    // Project the current extent of the map to the spatial reference of the grid ...
    var objExtentProjectionDeferred = objGraticuleRenderer.MapController.ProjectGeometry(objMapExtent, objGraticuleRenderer.MapController.CurrentMap.SpatialReferenceID, objGraticuleRenderer.GridSpatialReferenceID, true, TrimbleMap.enumProjectionLevel.RELAXED, true);

    // When the projection completes ...
    objExtentProjectionDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objExtentInGridSpatialReference) {
        
        // Get the width of the map element ...
        var intMapScreenWidth = objGraticuleRenderer.MapController.MapElement.innerWidth();
        var decExtentWidthInGrid = objExtentInGridSpatialReference.xmax - objExtentInGridSpatialReference.xmin;

        // Compute the approximate distance on the screen ...
        var decDistanceOnScreenInPixels = objGraticuleRenderer.GridSideLength * (intMapScreenWidth / decExtentWidthInGrid);

        // Set the side length on the screen to be computed ...
        objGraticuleRenderer.SideLengthOnScreenComputed = true;

        // Resolve the deferred with the distance on the screen ...
        objDeferred.resolve(decDistanceOnScreenInPixels);

    }), TrimbleMap.Controller.Shared.TrapException(function (objProjectionError) {

        // Set the side length on the screen to not be computed ...
        objGraticuleRenderer.SideLengthOnScreenComputed = false;

        // When the measures are out of bounds ...
        if ((typeof objProjectionError.IsMeasuresOutOfBoundsException != 'undefined') && objProjectionError.IsMeasuresOutOfBoundsException) {

            // Set to be able to draw the grid ...
            objGraticuleRenderer.AbleToDrawGrid = false;

            // Update the extent validity to true ...
            objGraticuleRenderer.UpdateExtentValidity(objGraticuleRenderer.AbleToDrawGrid);
        }

        // Reject the deferred ...
        objDeferred.reject(objProjectionError);
    }));
    
    return objDeferred;
}

// **************************************************************************
// FUNCTION: UpdateExtentValidity
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.UpdateExtentValidity = function UpdateExtentValidity(blnValidExtent) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // When the external extent validity changed ...
    if (objGraticuleRenderer.IsValidExtent != blnValidExtent) {

        // Set the property on the instance ...
        objGraticuleRenderer.IsValidExtent = blnValidExtent;

        // Update the info message display ...
        objGraticuleRenderer.UpdateInfoMessageDisplay();

        // Trigger the on changed event handlers ...
        objGraticuleRenderer.TriggerOnExtentValidityChanged(blnValidExtent);
    }
    
}

// **************************************************************************
// FUNCTION: AddOnVisiblityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.AddOnVisiblityChanged = function AddOnVisiblityChanged(fnOnVisiblityChanged) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Add the function to the list of on visiblity changed functions ...
    objGraticuleRenderer.OnVisiblityChangedFunctions.push(fnOnVisiblityChanged);
}

// **************************************************************************
// FUNCTION: RemoveOnVisiblityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.RemoveOnVisiblityChanged = function RemoveOnVisiblityChanged(fnOnVisiblityChanged) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Get the index of the function into the array ...
    var intOnVisiblityChangedFunction = $.inArray(fnOnVisiblityChanged, objGraticuleRenderer.OnVisiblityChangedFunctions);

    // When in the array ...
    if (intOnVisiblityChangedFunction > -1) {

        // Remove it ...
        objGraticuleRenderer.OnVisiblityChangedFunctions.splice(intOnVisiblityChangedFunction, 1);
    }
}

// **************************************************************************
// FUNCTION: TriggerOnVisiblityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.TriggerOnVisiblityChanged = function TriggerOnVisiblityChanged(blnVisible) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Loop through all the on visibility changed functions ...
    $.each(objGraticuleRenderer.OnVisiblityChangedFunctions, function (intOnVisiblityChangedFunction, fnOnVisiblityChangedFunction) {

        // Call the function ...
        fnOnVisiblityChangedFunction(blnVisible);
    });
}

// **************************************************************************
// FUNCTION: AddOnExtentValidityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.AddOnExtentValidityChanged = function AddOnExtentValidityChanged(fnOnExtentValidityChanged) {
    
    // Get the instance ...
    var objGraticuleRenderer = this;

    // Add the function to the list of on validity  changed functions ...
    objGraticuleRenderer.OnExtentValidityChangedFunctions.push(fnOnExtentValidityChanged);
}

// **************************************************************************
// FUNCTION: RemoveOnExtentValidityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.RemoveOnExtentValidityChanged = function RemoveOnExtentValidityChanged(fnOnExtentValidityChanged) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Get the index of the function into the array ...
    var intOnExtentValidityChangedFunction = $.inArray(fnOnExtentValidityChanged, objGraticuleRenderer.OnExtentValidityChangedFunctions);

    // When in the array ...
    if (intOnExtentValidityChangedFunction > -1) {

        // Remove it ...
        objGraticuleRenderer.OnExtentValidityChangedFunctions.splice(intOnExtentValidityChangedFunction, 1);
    }
}

// **************************************************************************
// FUNCTION: TriggerOnExtentValidityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.GraticuleRenderer.TriggerOnExtentValidityChanged = function TriggerOnExtentValidityChanged(blnValidExtent) {

    // Get the instance ...
    var objGraticuleRenderer = this;

    // Loop through all the changed functions ...
    $.each(objGraticuleRenderer.OnExtentValidityChangedFunctions, function (intOnVisiblityChangedFunction, fnOnExtentValidityChanged) {

        // Call the function ...
        fnOnExtentValidityChanged(blnValidExtent);
    });
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Identify = {};
TrimbleMap.Identify.Shared = {};
TrimbleMap.Identify.Shared.TOLERANCE_IN_PIXELS = 3;

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Identify.CreateInstance = function CreateInstance(objMapController, objMapCallout, objModeButtons, blnVisible) {

    // Create the object that will hold the instance properties ...
    var objMapIdentify = {
        IdentifyContent: null,
        IdentifyOnShowAttached: null,
        IdentifyContentScrollbar: null,
        CurrentResults: null,
        CurrentlySelectedGraphic: null,
        MapController: objMapController,
        MapCallout: objMapCallout,
        ModeButtons: objModeButtons,
        ClickHandlerInstance: null,
        IdentifyModeButton: null,
        Visible: false,

        MapClickedHandlerProxy: function (e) { objMapIdentify.MapClickedHandler(e); },
        MapLoadedProxy: function (blnReloaded) { objMapIdentify.MapLoaded(blnReloaded); },
        PreReloadedProxy: function (blnReloaded) { objMapIdentify.PreReloaded(); },

        AttachEventHandlers: TrimbleMap.Identify.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Identify.DetachEventHandlers,
        MapClickedHandler: TrimbleMap.Identify.MapClickedHandler,
        ShowCallout: TrimbleMap.Identify.ShowCallout,
        Activate: TrimbleMap.Identify.Activate,
        DeActivate: TrimbleMap.Identify.DeActivate,
        GetResultAttributes: TrimbleMap.Identify.GetResultAttributes,
        MapLoaded: TrimbleMap.Identify.MapLoaded,
        PreReloaded: TrimbleMap.Identify.PreReloaded,
        Show: TrimbleMap.Identify.Show,
        Hide: TrimbleMap.Identify.Hide
    };

    // Create the mode button ...
    objMapIdentify.IdentifyModeButton = SD.ModeButtons.Shared.CreateButton('IDENTIFY',
        'identify-mode',
        SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Identify'),
        TrimbleMap.StandardMap.Shared.enumModeButtonOrder.IDENTIFY,
        function (objModeButton) { objMapIdentify.Activate(objModeButton); },
        function (objModeButton) { objMapIdentify.DeActivate(objModeButton); })

    // Show the mode button when its to be visible at startup ...
    if (blnVisible) { objMapIdentify.Show(false, false); }

    // Add the gradient style for IE 9 only ...
    SD.HtmlFunctions.Shared.RemoveIE9FilterFromGradient();

    // Add the onloaded event handler to the map controller ...
    objMapIdentify.MapController.AddOnLoadedCallback(objMapIdentify.MapLoadedProxy);

    // Add the pre reloaded event handler to the map controller ...
    objMapIdentify.MapController.AddPreReloadedCallback(objMapIdentify.PreReloadedProxy);

    return objMapIdentify;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
//           blnSelectTab is optional, defaults to true
// **************************************************************************
TrimbleMap.Identify.Show = function Show(blnTriggerNotifyModuleVisibilityChanged, blnSelectTab) {

    // Get the instance ...
    var objMapIdentify = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objMapIdentify.Visible) {

        // Add the mode button ...
        objMapIdentify.ModeButtons.AddButton(objMapIdentify.IdentifyModeButton);

        // Set to be visible ...
        objMapIdentify.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapIdentify.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Identify, true); }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Identify.Hide = function Hide(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objMapIdentify = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objMapIdentify.Visible) {

        // Remove the mode button ...
        objMapIdentify.ModeButtons.RemoveButton(objMapIdentify.IdentifyModeButton);

        // Set to not be visible ...
        objMapIdentify.Visible = false;

        // Notify that the module visibility changed to false ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapIdentify.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Identify, false); }
    }
}

// **************************************************************************
// FUNCTION: Activate
// USAGE:    
// **************************************************************************
TrimbleMap.Identify.Activate = function Activate(objModeButton) {

    // Get the map identify instance ...
    var objMapIdentify = this;

    // Attach the event handlers ...
    objMapIdentify.AttachEventHandlers();
}

// **************************************************************************
// FUNCTION: DeActivate
// USAGE:    
// **************************************************************************
TrimbleMap.Identify.DeActivate = function DeActivate(objModeButton) {

    // Get the map identify instance ...
    var objMapIdentify = this;

    // Hide the map callout if visible ...
    objMapIdentify.MapCallout.Hide();

    // Detach the event handlers ...
    objMapIdentify.DetachEventHandlers();
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Identify.AttachEventHandlers = function AttachEventHandlers() {

    // Get the map identify instance ...
    var objMapIdentify = this;

    // Attach a click event handler to the map ...
    objMapIdentify.ClickHandlerInstance = objMapIdentify.MapController.EsriMap.on('click', objMapIdentify.MapClickedHandlerProxy);
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Identify.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map identify instance ...
    var objMapIdentify = this;

    // Detach a click event handler from the map ...
    objMapIdentify.ClickHandlerInstance.remove();
}

// **************************************************************************
// FUNCTION: MapLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.Identify.MapLoaded = function MapLoaded(blnReloaded) {

    // Get the map identify instance ...
    var objMapIdentify = this;

    // When reloaded ...
    if (blnReloaded) {

        // When the identify mode is active ... 
        if (objMapIdentify.ModeButtons.ActiveButton == objMapIdentify.IdentifyModeButton) {

            // Attach the event handlers ...
            objMapIdentify.AttachEventHandlers();
        }
    }
}

// **************************************************************************
// FUNCTION: PreReloaded
// USAGE:    
// **************************************************************************
TrimbleMap.Identify.PreReloaded = function PreReloaded() {

    // Get the map identify instance ...
    var objMapIdentify = this;

    // When the identify mode is active ... 
    if (objMapIdentify.ModeButtons.ActiveButton == objMapIdentify.IdentifyModeButton) {

        // Detach the event handlers ...
        objMapIdentify.DetachEventHandlers();
    }
}

// **************************************************************************
// FUNCTION: MapClickedHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Identify.MapClickedHandler = function MapClickedHandler(e) {

    // Get the map identify instance ...
    var objMapIdentify = this;

    // When the map has been loaded successfully ...
    if (objMapIdentify.MapController.EsriMap.loaded) {

        // Set the wait cursor on the map ...
        objMapIdentify.MapController.SetMapCursor('wait');

        // Hide the callout ...
        objMapIdentify.MapCallout.Hide();

        // Get html element in which the map live's offset relative to the page ...
        var objMapElementOffset = objMapIdentify.MapController.MapElement.offset();

        // Build a screen point ...
        var objScreenPoint = new esri.geometry.ScreenPoint(e.pageX - objMapElementOffset.left, e.pageY - objMapElementOffset.top);

        // Convert to map units ...
        var objMapPoint = objMapIdentify.MapController.EsriMap.toMap(objScreenPoint);

        // Create a point to the right of the point that are Map.Identify.Shared.TOLERANCE_IN_PIXELS away ...    
        var objToleranceScreenPoint = new esri.geometry.ScreenPoint(objScreenPoint.x + TrimbleMap.Identify.Shared.TOLERANCE_IN_PIXELS, objScreenPoint.y);

        // Convert the tolerance point to map units ... 
        var objToleranceMapPoint = objMapIdentify.MapController.EsriMap.toMap(objToleranceScreenPoint);

        // Compute the tolerance distance in map units ...
        var intToleranceInMapUnits = Math.abs(objMapPoint.x - objToleranceMapPoint.x);

        // Create an extent that have intToleranceInMapUnits width and height centered on the clicked point ...
        var objIdentifyGeometry = new esri.geometry.Extent(objMapPoint.x - intToleranceInMapUnits,
            objMapPoint.y + intToleranceInMapUnits,
            objMapPoint.x + intToleranceInMapUnits,
            objMapPoint.y - intToleranceInMapUnits,
            objMapIdentify.MapController.EsriMap.spatialReference);

        // Query the current map ...
        let objQueryMapDeferred = objMapIdentify.MapController.QueryCurrentMap(objIdentifyGeometry, false, null, TrimbleMap.Controller.Shared.TrapException(function (fnForMapService) { objMapIdentify.MapController.ForEachVisibleIdentifiableMapServiceInCurrentMap(fnForMapService); }));

        // When completed ...
        objQueryMapDeferred.promise.then(TrimbleMap.Controller.Shared.TrapException(function (arrQueryMapResults) {

            // Create a new array for the callout items ...
            var arrMapCalloutItems = [];

            // Loop through all the results ...
            $.each(arrQueryMapResults, function (intQueryMapResult, objQueryMapResult) {

                // Loop through all the query results for the layer ...
                $.each(objQueryMapResult.Data, function (intQueryMapResult, objQueryMapLayerResult) {

                    // When we have a MapLayerID ...
                    if (objQueryMapResult.MapLayerID) {

                        // Get the map layer ...
                        var objMapLayer = objMapIdentify.MapController.GetMapLayer(objQueryMapResult.MapLayerID);

                        // Determine the individual attribute name to use ...
                        var strIndividualItemName = (objMapLayer.IndividualItemNameType == TrimbleMap.enumIndividualItemNameType.UseSpecifiedText) ?
                            objMapLayer.IndividualItemName :
                            objQueryMapLayerResult.Attributes[objMapLayer.IndividualItemNameAttributeName];

                        // Create a callout item ...
                        var objMapCalloutItem = TrimbleMap.Callout.Shared.CreateItem(strIndividualItemName,
                            objMapIdentify.MapController.GetMapLayerIdentifyHtmlTemplate(objMapLayer),
                            objMapLayer.HeadingHtmlTemplate,
                            objQueryMapLayerResult.Geometry,
                            objQueryMapLayerResult.SpatialReferenceID,
                            objQueryMapLayerResult.Attributes);

                        // Add it to the list of callout items to display ...
                        arrMapCalloutItems.push(objMapCalloutItem);
                    }
                });
            });

            // Show the result in a callout ...
            objMapIdentify.ShowCallout(arrMapCalloutItems, objMapPoint, objScreenPoint);

            // Revert back to the default cursor ...
            objMapIdentify.MapController.SetMapCursor('default');
        }));
    }
}

// **************************************************************************
// FUNCTION: ShowCallout
// USAGE:    
// **************************************************************************
TrimbleMap.Identify.ShowCallout = function ShowCallout(arrCalloutItems, objMapPoint, objScreenPoint) {

    // Get the map identify instance ...
    var objMapIdentify = this;

    // When there are any results ...
    if (arrCalloutItems.length > 0) {

        // Show it in a callout ...
        objMapIdentify.MapCallout.Show(arrCalloutItems, objMapPoint, TrimbleMap.Callout.enumExtentChange.KeepCurrentExtent);

    } else {

        // Show that there are no results ...
        objMapIdentify.MapCallout.ShowNoResults(objScreenPoint);
    }
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.InfoMessage = {};
TrimbleMap.InfoMessage.Shared = {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.CreateInstance = function CreateInstance(objMapController) {

    // Create the instance ...
    var objInfoMessage = {
        MapController: objMapController,
        Visible: false,
        InfoMessagesDiv: null,
        MessageDataByKey: {},

        MapResizedProxy: function () { objInfoMessage.MapResized() },

        Show: TrimbleMap.InfoMessage.Show,
        Hide: TrimbleMap.InfoMessage.Hide,
        AddMessageData: TrimbleMap.InfoMessage.AddMessageData,
        RemoveMessageData: TrimbleMap.InfoMessage.RemoveMessageData,
        HaveMessagesToDisplay: TrimbleMap.InfoMessage.HaveMessagesToDisplay,
        UpdateMessageDiv: TrimbleMap.InfoMessage.UpdateMessageDiv,
        AddMessageDiv: TrimbleMap.InfoMessage.AddMessageDiv,
        PositionMessageDiv: TrimbleMap.InfoMessage.PositionMessageDiv,
        RemoveMessageDiv: TrimbleMap.InfoMessage.RemoveMessageDiv,
        AttachEventHandlers: TrimbleMap.InfoMessage.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.InfoMessage.DetachEventHandlers,
        MapResized: TrimbleMap.InfoMessage.MapResized
    };

    return objInfoMessage;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.Show = function Show() {

    // Get the instance ...
    var objInfoMessage = this;

    // When not already visible ...
    if (!objInfoMessage.Visible) {

        // Create the message div ...
        objInfoMessage.AddMessageDiv();

        // Attach the event handlers ...
        objInfoMessage.AttachEventHandlers();

        // Set to be visible ...
        objInfoMessage.Visible = true;
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.Hide = function Hide() {

    // Get the instance ...
    var objInfoMessage = this;

    // When visible ...
    if (objInfoMessage.Visible) {

        // Detach the event handlers ...
        objInfoMessage.DetachEventHandlers();

        // Remove the message div ...
        objInfoMessage.RemoveMessageDiv();

        // Set to be hidden ...
        objInfoMessage.Visible = false;
    }
}

// **************************************************************************
// FUNCTION: AddMessageData
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.AddMessageData = function AddMessageData(objMessageData) {

    // Get the instance ...
    var objInfoMessage = this;

    // Add the message data by key ...
    objInfoMessage.MessageDataByKey[objMessageData.Key] = objMessageData;

    // Update the messages div ...
    objInfoMessage.UpdateMessageDiv();
}

// **************************************************************************
// FUNCTION: RemoveMessageData
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.RemoveMessageData = function RemoveMessageData(strKey) {

    // Get the instance ...
    var objInfoMessage = this;

    // When we have message data for the key ...
    if (typeof objInfoMessage.MessageDataByKey[strKey] != 'undefined') {

        // Remove the message data by key ...
        delete objInfoMessage.MessageDataByKey[strKey];

        // Update the messages div ...
        objInfoMessage.UpdateMessageDiv();
    }
}

// **************************************************************************
// FUNCTION: UpdateMessageDiv
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.UpdateMessageDiv = function UpdateMessageDiv() {

    // Get the instance ...
    var objInfoMessage = this;

    // When we have messages to display ...
    if (objInfoMessage.HaveMessagesToDisplay()) {

        // When visible ...
        if (objInfoMessage.Visible) {

            // Remove the mesages div ..
            objInfoMessage.RemoveMessageDiv();

            // Re-add the messages div ...
            objInfoMessage.AddMessageDiv();

        } else {

            // Show the info div ...
            objInfoMessage.Show();
        }

    } else {

        // Hide the info div ...
        objInfoMessage.Hide();
    }
}

// **************************************************************************
// FUNCTION: HaveMessagesToDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.HaveMessagesToDisplay = function HaveMessagesToDisplay() {

    // Get the instance ...
    var objInfoMessage = this;

    // Start with not having any messages to display ...
    var blnHaveMessagesToDisplay = false;

    // Loop through all the message data by key ...
    $.each(objInfoMessage.MessageDataByKey, function (strKey, objMessageData) {

        // Set to have messages to display ...
        blnHaveMessagesToDisplay = true;

        // Stop looping ...
        return false;
    });

    return blnHaveMessagesToDisplay;
}

// **************************************************************************
// FUNCTION: AddMessageDiv
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.AddMessageDiv = function AddMessageDiv() {

    // Get the instance ...
    var objInfoMessage = this;

    // Create the message div ...
    objInfoMessage.InfoMessagesDiv = $('<div class="map_infomessage_div"></div>');

    // Create the inner placement div ...
    var objInnerContentDiv = $('<div class="map_infomessage_inner_div"></div>');

    // Add it to the message div ...
    objInfoMessage.InfoMessagesDiv.append(objInnerContentDiv);

    // Loop through all the message data by key ...
    $.each(objInfoMessage.MessageDataByKey, function (strKey, objMessageData) {

        // Create the message data div ...
        var objMessageDataDiv = $('<div></div>');

        // Add it to the content div ...
        objInnerContentDiv.append(objMessageDataDiv);

        // When we have an icon to display ...
        if (objMessageData.DisplayIcon) {

            // Add the icon ...
            objMessageDataDiv.append('<div class="map_infomessage_icon_div ' + objMessageData.IconCssClass + '"></div>');
        }

        // Create a div to hold the messages ...
        var objMessagesDiv = $('<div class="map_infomessage_messages_div"></div>');

        // Add it to the inner placement div ...
        objMessageDataDiv.append(objMessagesDiv);

        // Loop through all the messages ...
        $.each(objMessageData.Messages, function (intMessageText, strMessageText) {

            // Add the span with the message ...
            objMessagesDiv.append('<div><span class="map_infomessage_span">' + strMessageText + '</span></div>');
        });
    })

    // Position the message div ...
    objInfoMessage.PositionMessageDiv();

    // Add the message div to the map element ...
    objInfoMessage.MapController.MapElement.append(objInfoMessage.InfoMessagesDiv);

    // Bring the message div to the front ...
    SD.DOM.BringToFront(objInfoMessage.InfoMessagesDiv);

    // Fade in the message div ...
    objInfoMessage.InfoMessagesDiv.fadeIn();
}

// **************************************************************************
// FUNCTION: RemoveMessageDiv
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.RemoveMessageDiv = function RemoveMessageDiv() {

    // Get the instance ...
    var objInfoMessage = this;

    // Remove the message div ...
    objInfoMessage.InfoMessagesDiv.remove();
}

// **************************************************************************
// FUNCTION: PositionMessageDiv
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.PositionMessageDiv = function PositionMessageDiv() {

    // Get the instance ...
    var objInfoMessage = this;

    // Get the visible extent in screen coordinates ...
    let objVisibleExtent = objInfoMessage.MapController.GetVisibleMapExtentInScreenCoordinates();
    let intBlockStart = objVisibleExtent.height;
    let intInlineStart = objVisibleExtent.width / 2;

    // Position the message div in the bottom center ...
    objInfoMessage.InfoMessagesDiv.css('inset-inline-start', intInlineStart + 'px');
    objInfoMessage.InfoMessagesDiv.css('inset-block-start', intBlockStart + 'px');
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.AttachEventHandlers = function AttachEventHandlers() {

    // Get the instance ...
    var objInfoMessage = this;

    // Attach the map resized event handler ...
    $(window).resize(objInfoMessage.MapResizedProxy);
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.DetachEventHandlers = function DetachEventHandlers() {

    // Get the instance ...
    var objInfoMessage = this;

    // Detach the map resized event handler ...
    $(window).off('resize', objInfoMessage.MapResizedProxy);
}

// **************************************************************************
// FUNCTION: MapResized
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.MapResized = function MapResized() {

    // Get the instance ...
    var objInfoMessage = this;

    // Position the message div ...
    objInfoMessage.PositionMessageDiv();
}

// **************************************************************************
// FUNCTION: CreateMessageData
// USAGE:    
// **************************************************************************
TrimbleMap.InfoMessage.Shared.CreateMessageData = function CreateMessageData(strKey, arrMessages, blnDisplayIcon, strIconCssClass) {
    return {
        Key: strKey,
        Messages: arrMessages,
        DisplayIcon: blnDisplayIcon,
        IconCssClass: strIconCssClass
    };
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Legend = {};
TrimbleMap.Legend.Shared = {};
TrimbleMap.Legend.Shared.TAB_WIDTH = 300;
TrimbleMap.Legend.Shared.TOP_LEVEL_LEGEND_TEXT_SPACE = 270;
TrimbleMap.Legend.Shared.CHECK_BOX_WIDTH = 17;
TrimbleMap.Legend.Shared.SWATCH_ELEMENT_WIDTH = 20;
TrimbleMap.Legend.Shared.INDENT = 19;
TrimbleMap.Legend.Shared.INFORMATION_ICON_SPACE = 33;

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.CreateInstance = function CreateInstance(objMapController, objSidebar, strTabName, strTabCaption, blnVisible, fnUpdateUserSettings) {

    // Create the object that will hold the instance properties ...
    var objMapLegend = {
        MapController: objMapController,
        Sidebar: objSidebar,
        TabName: strTabName,
        TabCaption: strTabCaption,
        Visible: false,
        EventHandlersAttached: false,
        LegendTabItem: null,
        CoordinateDisplay: null,
        CoordinateDisplayDiv: null,
        BorderDiv: null,
        LegendDiv: null,
        LegendTabDiv: null,
        LegendOpen: null,
        LegendHandle: null,
        LegendHandleArrow: null,
        LegendHandleActivationDiv: null,
        MapServiceDisplayLegendDivLookupTable: {},
        MapServiceDisplayLoadFailureIcons: {},
        LegendHeadingCheckBoxes: {},
        ScollbarVisible: false,
        NiceScroll: null,
        MapServiceDescriptionContainer: null,
        MapServiceDescriptionDiv: null,
        MapServiceDescriptionDivNiceScroll: null,

        LegendClickedProxy: function (e) { objMapLegend.LegendClicked(e); },
        HeadingMouseEnterProxy: function (e) { objMapLegend.HeadingMouseEnter(e); },
        HeadingMouseLeaveProxy: function (e) { objMapLegend.HeadingMouseLeave(e); },
        GroupMouseOverProxy: function (e) { objMapLegend.GroupMouseOver(e); },
        GroupMouseLeaveProxy: function (e) { objMapLegend.GroupMouseLeave(e); },
        MapLoadedProxy: function (blnReloaded) { objMapLegend.MapLoaded(blnReloaded); },
        ExtentChangedProxy: function (arrFailedMapServiceDisplays) { objMapLegend.ExtentChanged(arrFailedMapServiceDisplays); },
        PreReloadedProxy: function (blnReloaded) { objMapLegend.PreReloaded(); },

        CreateLegend: TrimbleMap.Legend.CreateLegend,
        CreateLegendDiv: TrimbleMap.Legend.CreateLegendDiv,
        CreateLegendSection: TrimbleMap.Legend.CreateLegendSection,
        CreateLegendDataElements: TrimbleMap.Legend.CreateLegendDataElements,
        CreateLegendDataElementsForArray: TrimbleMap.Legend.CreateLegendDataElementsForArray,
        UpdateLoadFailureIconForMapService: TrimbleMap.Legend.UpdateLoadFailureIconForMapService,
        ActivateTab: TrimbleMap.Legend.ActivateTab,
        DeActivateTab: TrimbleMap.Legend.DeActivateTab,
        ResizeTab: TrimbleMap.Legend.ResizeTab,
        PositionElements: TrimbleMap.Legend.PositionElements,
        AttachEventHandlers: TrimbleMap.Legend.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Legend.DetachEventHandlers,
        AttachGroupEventHandlers: TrimbleMap.Legend.AttachGroupEventHandlers,
        DetachGroupEventHandlers: TrimbleMap.Legend.DetachGroupEventHandlers,
        LegendClicked: TrimbleMap.Legend.LegendClicked,
        UpdateScrollbar: TrimbleMap.Legend.UpdateScrollbar,
        HeadingMouseEnter: TrimbleMap.Legend.HeadingMouseEnter,
        HeadingMouseLeave: TrimbleMap.Legend.HeadingMouseLeave,
        GroupMouseOver: TrimbleMap.Legend.GroupMouseOver,
        GroupMouseLeave: TrimbleMap.Legend.GroupMouseLeave,
        MapLoaded: TrimbleMap.Legend.MapLoaded,
        ExtentChanged: TrimbleMap.Legend.ExtentChanged,
        PreReloaded: TrimbleMap.Legend.PreReloaded,
        CreateElements: TrimbleMap.Legend.CreateElements,
        Show: TrimbleMap.Legend.Show,
        Hide: TrimbleMap.Legend.Hide,
        BuildMapServiceDescriptionDialog: TrimbleMap.Legend.BuildMapServiceDescriptionDialog,
        UpdateUserSettings: fnUpdateUserSettings
    };

    // Create the elements ...
    objMapLegend.CreateElements();

    // Create the tab ...
    objMapLegend.LegendTabItem = SD.Sidebar.Shared.CreateTabItem(objMapLegend.TabName, objMapLegend.TabCaption,
        TrimbleMap.StandardMap.Shared.enumTabOrder.LEGEND,
        function (objTabContainerElement, enTabActivationMethod) { objMapLegend.ActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement, enTabActivationMethod) { objMapLegend.DeActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement) { objMapLegend.ResizeTab(objTabContainerElement); },
        function () { return TrimbleMap.Legend.Shared.TAB_WIDTH; });

    // Show the tab and mode button when its to be visible at startup ...
    if (blnVisible) { objMapLegend.Show(false, false); }

    // Add the onloaded event handler to the map controller ...
    objMapLegend.MapController.AddOnLoadedCallback(objMapLegend.MapLoadedProxy);

    objMapLegend.MapController.AddOnExtentChangedCallback(objMapLegend.ExtentChangedProxy)

    // Add the pre reloaded event handler to the map controller ...
    objMapLegend.MapController.AddPreReloadedCallback(objMapLegend.PreReloadedProxy);

    return objMapLegend;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
//           blnSelectTab is optional, defaults to true
// **************************************************************************
TrimbleMap.Legend.Show = function Show(blnTriggerNotifyModuleVisibilityChanged, blnSelectTab) {

    // Get the instance ...
    var objMapLegend = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objMapLegend.Visible) {

        // Add the tab ...
        objMapLegend.Sidebar.AddTab(objMapLegend.LegendTabItem);

        // When we are to select the tab ...
        if ((typeof blnSelectTab == 'undefined') || (blnSelectTab == null) || blnSelectTab) {

            // Select the tab ...
            objMapLegend.Sidebar.SelectTab(objMapLegend.LegendTabItem);
        }

        // Set to be visible ...
        objMapLegend.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapLegend.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Legend, true); }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Legend.Hide = function Hide(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objMapLegend = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objMapLegend.Visible) {

        // Detach all the event handlers (if attached) ...
        objMapLegend.DetachEventHandlers();

        // Remove the tab ...
        objMapLegend.Sidebar.RemoveTab(objMapLegend.LegendTabItem);

        // Set to not be visible ...
        objMapLegend.Visible = false;

        // Notify that the module visibility changed to false ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapLegend.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Legend, false); }
    }
}

// **************************************************************************
// FUNCTION: ActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.ActivateTab = function ActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objMapLegend = this;

    // Add the search panel div to the tab container element ...
    objTabContainerElement.append(objMapLegend.LegendTabDiv);

    // When the tab div exists ...
    if (objMapLegend.LegendDiv) {

        // Position the elements ...
        objMapLegend.PositionElements();

        // Attach the event hanlders ...
        objMapLegend.AttachEventHandlers();
    }
}

// **************************************************************************
// FUNCTION: DeActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.DeActivateTab = function DeActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objMapLegend = this;

    // Remove the search panel div from the tab container element ...
    objMapLegend.LegendTabDiv.remove();

    // Attach the event handlers ...
    objMapLegend.DetachEventHandlers();
}

// **************************************************************************
// FUNCTION: ResizeTab
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.ResizeTab = function ResizeTab(objTabContainerElement) {

    // Get the instance ...
    var objMapLegend = this;

    // Position the elements ...
    objMapLegend.PositionElements();
}

// **************************************************************************
// FUNCTION: MapLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.MapLoaded = function MapLoaded(blnReloaded) {

    // Get the map legend instance ...
    var objMapLegend = this;

    // Create the legend ...
    objMapLegend.CreateLegend();

    // When the measure tab is the current tab ...
    if (objMapLegend.Sidebar.CurrentTab == objMapLegend.LegendTabItem) {

        // Position the elements ...
        objMapLegend.PositionElements();

        // Attach the event hanlders ...
        objMapLegend.AttachEventHandlers();
    }
}

// **************************************************************************
// FUNCTION: ExtentChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.ExtentChanged = function ExtentChanged(arrFailedMapServiceDisplays) {
    // Get the map legend instance ...
    let objMapLegend = this;

    for (let intIndex = 0; intIndex < arrFailedMapServiceDisplays.length; intIndex++) {
        let objMapServiceDisplay = arrFailedMapServiceDisplays[intIndex];

        // Update the load failure icon ...
        objMapLegend.UpdateLoadFailureIconForMapService(objMapServiceDisplay);

        let objSectionLayersContainerDiv = objMapLegend.MapServiceDisplayLegendDivLookupTable[objMapServiceDisplay.MapServiceDisplayID];

        if (objSectionLayersContainerDiv && objSectionLayersContainerDiv.length > 0) {
            objSectionLayersContainerDiv.remove();
        }
    }
}

// **************************************************************************
// FUNCTION: PreReloaded
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.PreReloaded = function PreReloaded() {

    // Get the map legend instance ...
    var objMapLegend = this;

    // When the measure tab is the current tab ...
    if (objMapLegend.Sidebar.CurrentTab == objMapLegend.LegendTabItem) {

        // Detach the event handlers when the tab is active ...
        objMapLegend.DetachEventHandlers();
    }

    // Remove the legend tab div ...
    objMapLegend.LegendDiv.remove();

    // Set the tab div to not exist ...
    objMapLegend.LegendDiv = null;

    // Clear the lookup table ...
    objMapLegend.MapServiceDisplayLegendDivLookupTable = {};
}

//// **************************************************************************
//// FUNCTION: CreateLegend
//// USAGE:    
//// **************************************************************************
TrimbleMap.Legend.CreateLegend = function CreateLegend() {

    // Get the instance ...
    var objMapLegend = this;

    // Create the legend div ...
    objMapLegend.CreateLegendDiv();

    // Get the legend data for the current map ...
    objMapLegend.MapController.GetLegendDataForCurrentMap(function (arrLegendData) {

        // Detatch the event handlers ...
        objMapLegend.DetachGroupEventHandlers();

        // Loop through the legend data for each map service display ...
        $.each(arrLegendData, function (intMapServiceLegendData, objMapServiceLegendData) {

            // Update the load failure icon ...
            objMapLegend.UpdateLoadFailureIconForMapService(objMapServiceLegendData.MapServiceDisplay);

            // When legend data for the section were loaded successfully ...
            if (objMapServiceLegendData.Loaded) {

                // Create the legend data ...
                objMapLegend.CreateLegendSection(objMapServiceLegendData.MapServiceDisplay, objMapServiceLegendData.DataItems);
            }
        });

        // Show the div in the legend div ...
        objMapLegend.LegendDiv.show();

        // Position the elements ...
        objMapLegend.PositionElements();

        // Re-attach the event handlers for group layer highlight ...
        objMapLegend.AttachGroupEventHandlers();
    });
}

//// **************************************************************************
//// FUNCTION: UpdateLoadFailureIconForMapService
//// USAGE:    
//// **************************************************************************
TrimbleMap.Legend.UpdateLoadFailureIconForMapService = function UpdateLoadFailureIconForMapService(objMapServiceDisplay) {

    // Get the instance ...
    let objMapLegend = this;

    // Get the load failure icon ...
    let objLoadFailureIcon = objMapLegend.MapServiceDisplayLoadFailureIcons[objMapServiceDisplay.MapServiceDisplayID];
    let objLegendHeadingCheckBox = objMapLegend.LegendHeadingCheckBoxes[objMapServiceDisplay.MapServiceDisplayID];

    let objMapServiceLoadedStatus = objMapLegend.MapController.GetMapServiceDisplayLoadedStatus(objMapServiceDisplay);

    // When all the layers were loaded succesfully ...
    if (objMapServiceLoadedStatus.FailedLayers.length == 0 && objMapServiceLoadedStatus.FailedLayersDependencies.length == 0) {

        // Hide the load failure icon and show the checkbox ...
        if ((typeof objLoadFailureIcon != 'undefined') && objLoadFailureIcon) { objLoadFailureIcon.hide(); }
        if ((typeof objLegendHeadingCheckBox != 'undefined') && objLegendHeadingCheckBox) { objLegendHeadingCheckBox.show(); }

    } else {
        let strUnableToLoadLayer = "";

        if (objMapServiceLoadedStatus.FailedLayers.length > 0) {
            // Problems loading map service. The data might not be displayed in the map and any interaction with the map might not return any results for this map service
            strUnableToLoadLayer = SD.Translation.Shared.GetTranslation('Map.Legend.js', 'ProblemsLoadingMapService');

            if ((typeof objLegendHeadingCheckBox != 'undefined') && objLegendHeadingCheckBox) { objLegendHeadingCheckBox.hide(); }
        } else {
            // Get the map service ...
            let objMapService = objMapLegend.MapController.GetMapService(objMapServiceDisplay.MapServiceID);

            switch (objMapService.MapServiceType) {
                case TrimbleMap.Controller.enumMapServiceType.WebMapService:
                    // Problems loading companion web feature service. The data will displayed in the map but any interaction with the map will not return any results for this map service
                    strUnableToLoadLayer = SD.Translation.Shared.GetTranslation('Map.Legend.js', 'ProblemsLoadingWebMapServiceDependencies');
                    break;
            }

            if ((typeof objLegendHeadingCheckBox != 'undefined') && objLegendHeadingCheckBox) { objLegendHeadingCheckBox.show(); }
        }

        // Show the load failure icon and hide the checkbox ...
        if ((typeof objLoadFailureIcon != 'undefined') && objLoadFailureIcon) {
            // Add the tooltip ...
            objLoadFailureIcon.attr('title', strUnableToLoadLayer);
            objLoadFailureIcon.show();
        }
        
    }
}

// **************************************************************************
// FUNCTION: PositionElements
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.PositionElements = function PositionElements() {

    // Get the instance ...
    var objMapLegend = this;

    // When the tab div exists ...
    if (objMapLegend.LegendDiv) {

        // Set the spacing div height to position the coordinate display ...
        objMapLegend.BorderDiv.css('height', objMapLegend.Sidebar.GetHeight() - 55);
        objMapLegend.LegendDiv.css('max-height', objMapLegend.Sidebar.GetHeight() - 55);

        // Update the scrollbar ...
        objMapLegend.UpdateScrollbar();
    }
}

// **************************************************************************
// FUNCTION: UpdateScrollbar
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.UpdateScrollbar = function UpdateScrollbar() {

    // Get the instance ...
    var objMapLegend = this;

    // Do this in a new "thread" (at the end of the event queue to be executed at this moment) ...
    // Otherwise the nicescrollbar crashes with error: Unable to get property 'delayed' of undefined or null reference
    setTimeout(function () {

        // When the legend div is taller than there is spacve for ...
        if (parseInt($(objMapLegend.LegendDiv.children()[0]).outerHeight(), 10) > parseInt($(objMapLegend.LegendDiv).innerHeight(), 10)) {

            // When the scrollbar is visible ...
            if (objMapLegend.ScollbarVisible) {
                // Remove the scrollbar ...
                objMapLegend.NiceScroll.remove();
            }

            // Apply a scrollbar to the legend div ...
            objMapLegend.NiceScroll = objMapLegend.LegendDiv.niceScroll({ railpadding: { top: 0, right: 0, left: 8, bottom: 0 }, cursorwidth: "7px", horizrailenabled: false });

            // Set the scrollbar to be visible ...
            objMapLegend.ScollbarVisible = true;

        } else {

            // When the scrollbar is visible ...
            if (objMapLegend.ScollbarVisible) {

                // Remove the scrollbar ...
                objMapLegend.NiceScroll.remove();

                // Set to not be visible ...
                objMapLegend.ScollbarVisible = false;
            }
        }
    }, 0);
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.CreateElements = function CreateElements() {

    // Get the instance ...
    var objMapLegend = this;

    // Create the legend div ...
    objMapLegend.LegendTabDiv = $('<div class="side-panel"></div>');

    // Create the spacing div ...
    objMapLegend.BorderDiv = $('<div class="panel-content"></div>');

    // Add the spacing to the outer div ...
    objMapLegend.LegendTabDiv.append(objMapLegend.BorderDiv);

    // Create the coordinate display div ...
    objMapLegend.CoordinateDisplayDiv = $('<div class="coordinates"></div>');

    // Create the coordinate display in the div ...
    objMapLegend.CoordinateDisplay = TrimbleMap.CoordinateDisplay.CreateInstance(objMapLegend.MapController, objMapLegend.CoordinateDisplayDiv);

    // Add the coordinate display div to the outer div ...
    objMapLegend.LegendTabDiv.append(objMapLegend.CoordinateDisplayDiv);
}

// **************************************************************************
// FUNCTION: CreateLegendDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.CreateLegendDiv = function CreateLegendDiv() {

    // Get the instance ...
    var objMapLegend = this;

    // Create objects to hold the checkboxes and failure icons ...
    objMapLegend.LegendHeadingCheckBoxes = {};
    objMapLegend.MapServiceDisplayLoadFailureIcons = {};

    // Create the inner div ...
    objMapLegend.LegendDiv = $('<div class="legend"></div>');

    // Hide the div in the beginning ...
    objMapLegend.LegendDiv.hide();

    // Add the legend div to the outer div ...
    objMapLegend.BorderDiv.append(objMapLegend.LegendDiv);

    // Create the section container div ...
    var objSectionsContainerDiv = $('<div></div>');

    // Add the section container div ...
    objMapLegend.LegendDiv.append(objSectionsContainerDiv);

    // Loop through all the map service displays ...
    for (var intMapServiceDisplay = objMapLegend.MapController.CurrentMap.MapServiceDisplays.length - 1; intMapServiceDisplay >= 0; intMapServiceDisplay--) {

        // Get the map service display ...
        var objMapServiceDisplay = objMapLegend.MapController.CurrentMap.MapServiceDisplays[intMapServiceDisplay];

        // Get the map service ...
        var objMapService = objMapLegend.MapController.GetMapService(objMapServiceDisplay.MapServiceID);

        // When the map service is to be displayed in the legend ...
        if (objMapService.DisplayInLegend) {
            // Create the section container div ...
            var objSectionContainerDiv = $('<div class="legend-section"></div>');

            if (objMapLegend.MapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings) {

                if (objMapLegend.MapController.State.ClientStoredVisibleMapServiceDisplayIDs &&
                    !objMapLegend.MapController.State.ClientStoredVisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID]) {

                    objSectionContainerDiv.addClass('hidden-service');
                } else if (!objMapService.DisplayByDefault && !objMapLegend.MapController.State.VisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID]) {
                    objSectionContainerDiv.addClass('hidden-service');
                }
            } else {
                if (!objMapService.DisplayByDefault) {
                    objSectionContainerDiv.addClass('hidden-service');
                }
            }

            // Add it to the sections container div ...
            objSectionsContainerDiv.append(objSectionContainerDiv);

            // Determine the class name to add to the div (LegendSectionHeadingDivCollapsible when it should be collapsible other wise just an empty string) ...
            var strCollapsibleClass = (objMapService.DisplayAllLayersInLegend ? ' collapsible-section' : '');

            // Create the section heading row ...
            var objSectionHeadingDiv = $('<div class="section-header-row' + strCollapsibleClass + '"></div>');

            // Add it to the section container div ...
            objSectionContainerDiv.append(objSectionHeadingDiv);

            // Create the legend section heading div ...
            var objLegendSectionHeadingDiv = $('<div class="section-header"></div>');

            // Create the load failed icon ...
            var objLoadFailureIcon = $('<div class="warning-icon"></div>');

            // Place it into MapServiceDisplayLoadFailureIcons ...
            objMapLegend.MapServiceDisplayLoadFailureIcons[objMapServiceDisplay.MapServiceDisplayID] = objLoadFailureIcon;

            // Create the load failed icon ...
            var objLoadFailureIconOuter = $('<div class="warning-icon-container"></div>');

            // Add the icon to the outer div ...
            objLoadFailureIconOuter.append(objLoadFailureIcon);

            // Add it to the legend section ...
            objLegendSectionHeadingDiv.append(objLoadFailureIconOuter);

            // When the user are to be able to turn the entire map service on or off ...
            if (objMapService.AllowSwitchingVisibilityOnEntireMapService) {

                // Create the outer div for the checkbox ...
                var objLegendHeadingCheckBoxOuterDiv = $('<div class="checkbox-container header"><div>');

                // Add it to the heading ...
                objLegendSectionHeadingDiv.append(objLegendHeadingCheckBoxOuterDiv);

                // Create the check box ...
                var objLegendHeadingCheckBox = $('<div class="header-checkbox" MapServiceDisplayID="' + objMapServiceDisplay.MapServiceDisplayID + '"></div>');

                if (objMapLegend.MapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings && objMapLegend.MapController.State.ClientStoredVisibleMapServiceDisplayIDs) {

                    if (objMapLegend.MapController.State.ClientStoredVisibleMapServiceDisplayIDs[objMapServiceDisplay.MapServiceDisplayID]) {

                        objLegendHeadingCheckBox.addClass('checked');
                    }

                } else {
                    if (!objMapService.DisplayByDefault) {
                        //Toggle legend service visibility
                        objMapLegend.MapController.SetMapServiceDisplayVisibility(objMapServiceDisplay, false);
                    }
                    else {
                        objLegendHeadingCheckBox.addClass('checked');
                    }
                }

                // Add it to the outer div ...
                objLegendHeadingCheckBoxOuterDiv.append(objLegendHeadingCheckBox);

                // Place it into LegendHeadingCheckBoxes ...
                objMapLegend.LegendHeadingCheckBoxes[objMapServiceDisplay.MapServiceDisplayID] = objLegendHeadingCheckBox;

                // Create the section heading checkbox ...
                objLegendSectionHeadingDiv.append('<span class="LegendSectionHeadingHasCheckBox" title="' + objMapService.MapServiceName + '">' + objMapService.MapServiceName + '</span>');

            } else {

                // Create the section heading checkbox ...
                objLegendSectionHeadingDiv.append('<span class="LegendSectionHeadingNoCheckBox">' + objMapService.MapServiceName + '</span>');
            }

            if (objMapService.Description) {
                // Create the information icon
                let objInformationIconOuter = $('<div class="info-icon"></div>');

                // Add the tooltip
                objInformationIconOuter.attr('title', objMapService.Description);

                // Add it to the legend section
                objLegendSectionHeadingDiv.append(objInformationIconOuter);
            }

            // Add the span to the row ...
            objSectionHeadingDiv.append(objLegendSectionHeadingDiv);

            // When all the layers are to be displayed in the legend ...
            if (objMapService.DisplayAllLayersInLegend) {

                // Create a div in which the legend for the section will be placed ...
                var objSectionLayersContainerDiv = $('<div class="legend-content"></div>');

                // Add it to the section container div ...
                objSectionContainerDiv.append(objSectionLayersContainerDiv);

                // Set the div in the lookup table ...
                objMapLegend.MapServiceDisplayLegendDivLookupTable[objMapServiceDisplay.MapServiceDisplayID] = objSectionLayersContainerDiv;
            }
        }
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.AttachEventHandlers = function AttachEventHandlers() {

    // Get the instance ...
    var objMapLegend = this;

    // When the event handlers are not attached ...
    if (!objMapLegend.EventHandlersAttached) {

        // Attach a click event handler ...
        objMapLegend.LegendDiv.on('click',(objMapLegend.LegendClickedProxy));

        // Get the legend heading rows ...
        var objLegendSectionHeadingRows = $(objMapLegend.LegendDiv.find('.section-header-row'));

        // Attach the heading mouse enter event handler ...
        objLegendSectionHeadingRows.on('mouseenter',(objMapLegend.HeadingMouseEnterProxy));

        // Attach the heading mouse leave event handler ...
        objLegendSectionHeadingRows.on('mouseleave',(objMapLegend.HeadingMouseLeaveProxy));

        // Attach the group event handlers ...
        objMapLegend.AttachGroupEventHandlers();

        // Attach the coordinate display handler ... 
        objMapLegend.CoordinateDisplay.AttachHandler();

        // Set to have attached the event handlers ...
        objMapLegend.EventHandlersAttached = true;
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.DetachEventHandlers = function DetachEventHandlers() {

    // Get the instance ...
    var objMapLegend = this;

    // When the event handlers are attached ...
    if (objMapLegend.EventHandlersAttached) {

        // Attach a click event handler ...
        objMapLegend.LegendDiv.off('click', objMapLegend.LegendClickedProxy);

        // Get the legend heading rows ...
        var objLegendSectionHeadingRows = $(objMapLegend.LegendDiv.find('.section-header-row'));

        // Detach the heading mouse enter event handler ...
        objLegendSectionHeadingRows.off('mouseenter', objMapLegend.HeadingMouseEnterProxy);

        // Detach the heading mouse leave event handler ...
        objLegendSectionHeadingRows.off('mouseleave', objMapLegend.HeadingMouseLeaveProxy);

        // Detach the group event handlers ...
        objMapLegend.DetachGroupEventHandlers();

        // Detach the coordinate display handler ... 
        objMapLegend.CoordinateDisplay.DetachHandler();

        // When the scrollbar is visible ...
        if (objMapLegend.ScollbarVisible) {

            // Remove the scrollbar ...
            objMapLegend.NiceScroll.remove();

            // Set to not be visible ...
            objMapLegend.ScollbarVisible = false;
        }

        // Set the event handlers to not be attached ...
        objMapLegend.EventHandlersAttached = false;
    }
}

// **************************************************************************
// FUNCTION: AttachGroupEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.AttachGroupEventHandlers = function AttachGroupEventHandlers() {

    // Get the instance ...
    var objMapLegend = this;

    // Get the groups ...
    var objLegendGroups = $(objMapLegend.LegendDiv.find('.group'));

    // Detach the heading mouse enter event handler ...
    objLegendGroups.on('mouseover',(objMapLegend.GroupMouseOverProxy));

    // Detach the group mouse enter event handler ...
    objLegendGroups.on('mouseleave',(objMapLegend.GroupMouseLeaveProxy));
}

// **************************************************************************
// FUNCTION: DetachGroupEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.DetachGroupEventHandlers = function DetachGroupEventHandlers() {

    // Get the instance ...
    var objMapLegend = this;

    // Get the groups ...
    var objLegendGroups = $(objMapLegend.LegendDiv.find('.group'));

    // Detach the heading mouse enter event handler ...
    objLegendGroups.off('mouseover', objMapLegend.GroupMouseOverProxy);

    // Detach the group mouse leave event handler ...
    objLegendGroups.off('mouseleave', objMapLegend.GroupMouseLeaveProxy);
}

// **************************************************************************
// FUNCTION: HeadingMouseEnter
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.HeadingMouseEnter = function HeadingMouseEnter(e) {

    // Get the instance ...
    var objMapLegend = this;

    // Wrap the event target with jquery ...
    var objTarget = $(e.target);

    // Get the legend section container ...
    var objLegendSectionContainer = $(objTarget.closest('.legend-section'));

    // Add the highlight class to the legend section container ...
    objLegendSectionContainer.addClass('highlight');
}

// **************************************************************************
// FUNCTION: HeadingMouseLeave
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.HeadingMouseLeave = function HeadingMouseLeave(e) {

    // Get the instance ...
    var objMapLegend = this;

    // Wrap the event target with jquery ...
    var objTarget = $(e.target);

    // Get the legend section container ...
    var objLegendSectionContainer = $(objTarget.closest('.legend-section'));

    // Remove the highlight class to the legend section container ...
    objLegendSectionContainer.removeClass('highlight');
}

// **************************************************************************
// FUNCTION: GroupMouseOver
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.GroupMouseOver = function GroupMouseOver(e) {

    // Get the instance ...
    var objMapLegend = this;

    // Wrap the event target with jquery ...
    var objTarget = $(e.target);

    // Get the legend group div ...
    var objLegendGroupDiv = objTarget.closest('.group');

    // Remobve all the legend group highlights ...
    $(objMapLegend.LegendDiv.find('.highlight')).removeClass('highlight');

    // When we have a legend group div ...
    if (objLegendGroupDiv.length > 0) {

        // Add the highlight class to the legend section container ...
        objLegendGroupDiv.addClass('highlight');
    }
}

// **************************************************************************
// FUNCTION: GroupMouseLeave
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.GroupMouseLeave = function GroupMouseLeave(e) {

    // Get the instance ...
    var objMapLegend = this;

    // Wrap the event target with jquery ...
    var objTarget = $(e.target);

    // Remove the highlight class to the legend section container ...
    $(objMapLegend.LegendDiv.find('.group.highlight')).removeClass('highlight');
}

// **************************************************************************
// FUNCTION: LegendClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.LegendClicked = function LegendClicked(e) {

    // Get the instance ...
    var objMapLegend = this;

    // Get the target element ...
    var objTarget = $(e.target);

    // Get the section heading div in which the target is if any ...
    var objSectionHeading = objTarget.hasClass('section-header') ? objTarget : objTarget.closest('.section-header');

    // When a checkbox in a map service heading has been clicked ...
    if (objTarget.hasClass('header-checkbox')) {

        // Start with having to becomde not visible ...
        var blnVisible = false;

        // When it is currently clicked ...
        if (objTarget.hasClass('checked')) {

            // Remove the checked class ...
            objTarget.removeClass('checked');

        } else {

            // Add the checked class ...
            objTarget.addClass('checked');

            // Set to make it visible ...
            blnVisible = true;
        }

        // Get the map service display id of the clicked checkbox ... 
        var strMapServiceDisplayID = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'MapServiceDisplayID').attr('MapServiceDisplayID');

        // Get the map service display ...
        var objMapServiceDisplay = objMapLegend.MapController.GetMapServiceDisplay(strMapServiceDisplayID);

        // Set the map service display visibility ...
        objMapLegend.MapController.SetMapServiceDisplayVisibility(objMapServiceDisplay, blnVisible);

        // Update user settings with map layer visibility
        objMapLegend.UpdateUserSettings(TrimbleMap.UserSettings.Shared.enumSetting.MapProperties, { 'LayerVisibility': { 'VisibleMapServiceDisplayIDs': objMapLegend.MapController.State.VisibleMapServiceDisplayIDs, 'VisibleLayerIDsByMapServiceDisplayID': objMapLegend.MapController.State.VisibleLayerIDsByMapServiceDisplayID } });

        // Get the section container div ...
        var objSectionContainerDiv = SD.DOM.GetElementOrParentWithClass(objTarget, 'legend-section')

        // Add or remove the hidden-service class from the section container ...
        if (blnVisible) { objSectionContainerDiv.removeClass('hidden-service'); } else { objSectionContainerDiv.addClass('hidden-service'); }

        // When a checkbox on a layer item has been clicked ...
    } else if (objTarget.hasClass('item-checkbox')) {

        // When not in a hidden map service ...
        if (!SD.DOM.GetElementOrParentWithClass(objTarget, 'hidden-service')) {

            // When not a sub layer of a parent unchecked layer or an uncheck service ...
            if (objTarget.hasClass('group-checkbox') || (objTarget.closest('.unchecked-parent').length == 0)) {

                // Get the map service display id of the clicked chakbox ... 
                var strMapServiceDisplayID = objTarget.attr('MapServiceDisplayID');

                // Get the layer id of the clicked chakbox ... 
                var strLayerID = objTarget.attr('LayerID');

                // Get the map service display ...
                var objMapServiceDisplay = objMapLegend.MapController.GetMapServiceDisplay(strMapServiceDisplayID);

                // When it is currently clicked ...
                if (objTarget.hasClass('checked')) {

                    // Remove the checked class ...
                    objTarget.removeClass('checked');

                    // Hide the layer ...
                    objMapLegend.MapController.SetLayerVisibility(objMapServiceDisplay, strLayerID, false);

                    // When this is a legend group layer checkbox ...
                    if (objTarget.hasClass('group-checkbox')) {

                        // Get the legend group ...
                        var objLegendGroup = $(objTarget.closest('.group'));

                        // Add the legend group unchecked class ...
                        objLegendGroup.addClass('unchecked-parent');
                    }

                } else {

                    // Add the checked class ...
                    objTarget.addClass('checked');

                    // Show the layer ...
                    objMapLegend.MapController.SetLayerVisibility(objMapServiceDisplay, strLayerID, true);

                    // When this is a legend group layer checkbox ...
                    if (objTarget.hasClass('group-checkbox')) {

                        // Get the legend group ...
                        var objLegendGroup = $(objTarget.closest('.group'));

                        // Remove the legend group unchecked class ...
                        objLegendGroup.removeClass('unchecked-parent');
                    }
                }
                // Update user settings with map layer visibility
                objMapLegend.UpdateUserSettings(TrimbleMap.UserSettings.Shared.enumSetting.MapProperties, { 'LayerVisibility': { 'VisibleMapServiceDisplayIDs': objMapLegend.MapController.State.VisibleMapServiceDisplayIDs, 'VisibleLayerIDsByMapServiceDisplayID': objMapLegend.MapController.State.VisibleLayerIDsByMapServiceDisplayID } });
            }
        }

        // When a map service heading has been clicked ...
    } else if (objTarget.hasClass('info-icon')) {
        // Build the dialog
        objMapLegend.BuildMapServiceDescriptionDialog(objTarget.attr("title"));

        let strTitle = null;

        if (objSectionHeading.length > 0) {
            // Map Service Description
            strTitle = SD.Translation.Shared.GetTranslation('Map.Legend.js', 'MapServiceDescription');
        } else {
            // Map Service Description
            strTitle = SD.Translation.Shared.GetTranslation('Map.Legend.js', 'MapLayerDescription');
        }

        // Add a callback when dialog is closed
        TrimbleMap.ModalDialog.Shared.AddOnClosedHandler(function () {
            // Check that a scroll bar does exist before removing
            if (objMapLegend.MapServiceDescriptionDivNiceScroll && objMapLegend.MapServiceDescriptionDivNiceScroll.name) {
                objMapLegend.MapServiceDescriptionDivNiceScroll.remove();
            }
        });

        // Show the dialog
        TrimbleMap.ModalDialog.Shared.OpenDialog(objMapLegend.MapServiceDescriptionContainer, strTitle, true, objMapLegend.MapServiceDescriptionDialogID);
    } else if ((objSectionHeading.length > 0)) {
        // Get the section container div in which the heading is ...
        var objLegendSectionContainerDiv = $(objSectionHeading.closest('.legend-section'));

        // Get the legend section div ...
        var objLegendSectionDiv = objLegendSectionContainerDiv.find('.legend-content');

        // When the section is not collpased ...
        if (!objLegendSectionContainerDiv.hasClass('section-collapsed')) {

            // Add the collapsed class to the heading ...
            objLegendSectionContainerDiv.addClass('section-collapsed');

            // Hide the section div by sliding ...
            objLegendSectionDiv.slideUp(100, function () {

                // Update the scrollbar ...
                objMapLegend.UpdateScrollbar();
            });

        } else {

            // Remove the collapsed class to the heading ...
            objLegendSectionContainerDiv.removeClass('section-collapsed');

            // Show the section div by sliding ...
            objLegendSectionDiv.slideDown(100, function () {

                // Update the scrollbar ...
                objMapLegend.UpdateScrollbar();
            });
        }
    }
}

// **************************************************************************
// FUNCTION: BuildMapServiceDescriptionDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.BuildMapServiceDescriptionDialog = function BuildMapServiceDescriptionDialog(strMapServiceDescription) {
    // Get the instance
    var objMapLegend = this;

    // Create container element
    objMapLegend.MapServiceDescriptionContainer = $('<div></div>')

    objMapLegend.MapServiceDescriptionDiv = $('<div class="map_service_description">' + strMapServiceDescription + '</div>');

    // Create the dialog content div
    objMapLegend.MapServiceDescriptionContainer.append(objMapLegend.MapServiceDescriptionDiv);

    // Add scrolling capability incase description exceeds div max height
    objMapLegend.MapServiceDescriptionDivNiceScroll = objMapLegend.MapServiceDescriptionDiv.niceScroll({ horizrailenabled: false, zindex: "9999999999", cursorwidth: "7px" });

    // Return the modal div
    return objMapLegend.MapServiceDescriptionContainer;
}

// **************************************************************************
// FUNCTION: CreateLegendSection
// USAGE:    addLegendData should be an array of object with the following structure:
//                    Name
//                    LayerID
//                    SwatchElement
//                    HasSubItems 
//                    SubItems 
//                      - When there are any items in this array: do not display swatch for the item in the legend
//                      - should be objects with the folowing structure:
//	                        Name
//	                        LayerID (When null: indicates that the element do not correspond to a layer
//                                   that can be turned on or off - never show a check box for these)
//	                        SwatchElement 
// **************************************************************************
TrimbleMap.Legend.CreateLegendSection = function CreateLegendSection(objMapServiceDisplay, arrLegendData) {

    // Get the instance ...
    var objMapLegend = this;

    // Get the map service for the map service display ...
    var objMapService = objMapLegend.MapController.GetMapService(objMapServiceDisplay.MapServiceID);

    // When the map service is to be displayed in the legend ...
    if (objMapService.DisplayInLegend) {

        // Get the legend section div ...
        var objLegendSectionDiv = objMapLegend.MapServiceDisplayLegendDivLookupTable[objMapServiceDisplay.MapServiceDisplayID];

        // When the legend div has been created ...
        if (typeof objLegendSectionDiv != 'undefined') {

            // Create the legend data elements ...
            objMapLegend.CreateLegendDataElementsForArray(objMapServiceDisplay, objMapService, arrLegendData, objLegendSectionDiv, 0);

            if (objMapService.CollapsedByDefault) {

                var objLegendSectionContainerDiv = $(objLegendSectionDiv.closest('.legend-section'));

                if (!objLegendSectionContainerDiv.hasClass('section-collapsed')) {

                    // Add the collapsed class to the heading ...
                    objLegendSectionContainerDiv.addClass('section-collapsed');

                    // Hide the section div by sliding ...
                    objLegendSectionDiv.hide();
                }
            }
        }
    }
}

// **************************************************************************
// FUNCTION: CreateLegendDataElementsForArray
// **************************************************************************
TrimbleMap.Legend.CreateLegendDataElementsForArray = function CreateLegendDataElementsForArray(objMapServiceDisplay, objMapService, arrLegendData, objParentDiv, intIndentLevel) {

    // Get the instance ...
    var objMapLegend = this;

    // Create the div in which to create the legend section ...
    var objLegendSectionDiv = $('<div></div>');

    // Add the table to the section div ...
    objParentDiv.append(objLegendSectionDiv);

    // Loop through all the legend data ...
    for (var intLegenedData = 0; intLegenedData < arrLegendData.length; intLegenedData++) {

        // Get the legend data ...
        var objLegendData = arrLegendData[intLegenedData];

        // Create the legend data elements ...
        objMapLegend.CreateLegendDataElements(objMapServiceDisplay, objMapService, objLegendData, objLegendSectionDiv, intIndentLevel);
    }
}

// **************************************************************************
// FUNCTION: CreateLegendDataElements
// **************************************************************************
TrimbleMap.Legend.CreateLegendDataElements = function CreateLegendDataElements(objMapServiceDisplay, objMapService, objLegendData, objParentDiv, intIndentLevel) {

    // Get the instance ...
    var objMapLegend = this;

    // Compute the legend text width based on the indentation for the current level ...
    var intLegendTextWidth = TrimbleMap.Legend.Shared.TOP_LEVEL_LEGEND_TEXT_SPACE - (intIndentLevel * TrimbleMap.Legend.Shared.INDENT);

    // Layer ID which could be name or ID
    let strLayerID = null;

    // If layer ID is set then use it otherwise use name
    if (objLegendData.LayerID != null && objLegendData.LayerID.toString() != "") {
        strLayerID = objLegendData.LayerID;
    } else {
        strLayerID = objLegendData.Name;
    }

    // Attempt to find the map layer
    let arrMapLayers = $.grep(objMapService.MapLayers, function (objMapLayer) { return objMapLayer.MapLayerID == objMapLegend.MapController.GetMapLayerIDForEsriLayerID(objMapServiceDisplay.MapServiceID, strLayerID); });

    let objInformationIconOuter = null;

    // Check that the map layer has been found
    // There should only be one
    if (arrMapLayers && arrMapLayers.length > 0) {
        // Get map layer description
        let strMapLayerDescription = arrMapLayers[0].Description;

        if (strMapLayerDescription) {
            // Create the information icon
            objInformationIconOuter = $('<div class="info-icon"></div>');

            // Add the tooltip
            objInformationIconOuter.attr('title', strMapLayerDescription);
        }
    }

    // When the legend item has no sub items ...
    if (objLegendData.SubItems.length == 0) {

        // Create a new div for the row ...
        var objRowDiv = $('<div class="legend-item"></div>');

        // Add it to the row ...
        objParentDiv.append(objRowDiv);

        // When switching is to be allowed on all layers ...
        if (objMapService.AllowSwitchingVisibilityOnAllLayers && (objLegendData.LayerID != null)) {

            // Add the checkbox with text ...
            objRowDiv.append('<div class="checkbox-container item"><div class="item-checkbox ' + (objLegendData.Visible ? 'checked' : '') + '" LayerId="' + objLegendData.LayerID + '" MapServiceDisplayID="' + objMapServiceDisplay.MapServiceDisplayID + '"></div></div>');

            // Remove the checkbox width from the text width ...
            intLegendTextWidth -= TrimbleMap.Legend.Shared.CHECK_BOX_WIDTH;
        }

        // When we have any siblings with swatches ...
        if ((typeof objLegendData.SwatchElement != 'undefined') && (objLegendData.SwatchElement != null)) {

            // Create a cell for the swatch ...
            var objSwatchCell = $('<div class="swatch"></div>');

            // Add the swatch cell to the row ...
            objRowDiv.append(objSwatchCell);

            // Add the Swatch element to the cell ...
            objSwatchCell.append(objLegendData.SwatchElement);

            // Remove the swatch element width from the text width ...
            intLegendTextWidth -= TrimbleMap.Legend.Shared.SWATCH_ELEMENT_WIDTH;
        }

        // Create map layer row html
        let strRowHtml = '<div class="legend-text" title="' + objLegendData.Name + '" style="width:' + (intLegendTextWidth - TrimbleMap.Legend.Shared.INFORMATION_ICON_SPACE) + 'px"><span>' + objLegendData.Name + '</span></div>'

        if (objInformationIconOuter) {
            // Add the information icon for the map layer
            strRowHtml = strRowHtml + objInformationIconOuter[0].outerHTML;
        }

        // Add line break for next map layer section
        objRowDiv.append(strRowHtml + '<br>');
    } else {

        // Create a new div for the row ...
        var objSubItemsContainerDiv = $('<div class="group"></div>');

        // Add it to the row ...
        objParentDiv.append(objSubItemsContainerDiv);

        // Create the parent row ...
        var objParentRowDiv = $('<div class="parent-item"></div>');

        // Add it to the table ...
        objSubItemsContainerDiv.append(objParentRowDiv);

        // When switching is to be allowed on all layers ...
        if (objMapService.AllowSwitchingVisibilityOnAllLayers && (objLegendData.LayerID != null)) {

            // Add the checkbox with text ...
            objParentRowDiv.append('<div class="checkbox-container item"><div class="item-checkbox ' + (objLegendData.Visible ? 'checked' : '') + ' group-checkbox" LayerId="' + objLegendData.LayerID + '" MapServiceDisplayID="' + objMapServiceDisplay.MapServiceDisplayID + '"></div></div>');

            // When the legend item is not visible ...
            if (!objLegendData.Visible) {
                // Add the legend group unchecked class ...
                objSubItemsContainerDiv.addClass('unchecked-parent');
            }

            // Remove the checkbox width from the text width ...
            intLegendTextWidth -= TrimbleMap.Legend.Shared.CHECK_BOX_WIDTH;
        }

        // Create map layer row html
        let strRowHtml = '<div class="legend-text" title="' + objLegendData.Name + '" style="width:' + (intLegendTextWidth - TrimbleMap.Legend.Shared.INFORMATION_ICON_SPACE) + 'px"><span>' + objLegendData.Name + '</span></div>';

        if (objInformationIconOuter) {
            // Add the information icon for the map layer
            strRowHtml = strRowHtml + objInformationIconOuter[0].outerHTML;
        }

        // Add line break for next map layer section
        objParentRowDiv.append(strRowHtml + '<br>');

        // Create a div for the sub items ...
        var objSubItemsDiv = $('<div class="child-item"></div>');

        // Add it to the sub items row ...
        objParentRowDiv.append(objSubItemsDiv);

        // Create the legend data elements ...
        objMapLegend.CreateLegendDataElementsForArray(objMapServiceDisplay, objMapService, objLegendData.SubItems, objSubItemsDiv, intIndentLevel + 1);
    }
}

// **************************************************************************
// FUNCTION: CreateFeatureLayerLegendSwatch
// USAGE:    
// **************************************************************************
TrimbleMap.Legend.Shared.CreateFeatureLayerLegendSwatch = function CreateFeatureLayerLegendSwatch(objFeatureLayer, objSymbol) {

    // Create the div ...
    var objSwatchDiv = $('<div class="FeatureLayerSwatch"></div>');

    // Create a gfx surface in the div ...
    var objGfxSurface = dojox.gfx.createSurface(objSwatchDiv.get(0), 20, 20);

    // Get the shape descriptors needed to draw the feature layer ...
    var objShapeDescriptors = esri.symbols.jsonUtils.getShapeDescriptors(objSymbol);

    // When it is a polygon feature layer ...
    if ((objFeatureLayer.geometryType == 'esriGeometryPolygon') && (objShapeDescriptors.defaultShape.type.toLowerCase() == 'path')) {

        // Create a rectangle for the swatch ...
        var objRectangle = objGfxSurface.createRect({ x: 2, y: 2, width: 17, height: 17 });

        // Set the fill and stroke of the rectangle to be that of the symbol ... 
        var objGfxShape = objRectangle
            .setFill(objShapeDescriptors.fill)
            .setStroke(objShapeDescriptors.stroke);
    } else {

        // When we got a default shape ...
        if (objShapeDescriptors.defaultShape != null) {

            // Use the default shape from the shape descriptor for the symbology ...
            var objGfxShape = objGfxSurface.createShape(objShapeDescriptors.defaultShape)
                .setFill(objShapeDescriptors.fill)
                .setStroke(objShapeDescriptors.stroke);

            // Center the shape in the 20 x 20 div ...
            objGfxShape.applyTransform({ dx: 10, dy: 10 });
        }
    }

    return objSwatchDiv;
}

// **************************************************************************
// FUNCTION: CreateLegendDataItem
// USAGE:    Use this function to create the items of the array to be 
//           passed into CreateLegendSection ...
// **************************************************************************
TrimbleMap.Legend.Shared.CreateLegendDataItem = function CreateLegendDataItem(strName, strLayerID, objSwatchElement, blnVisible) {

    // Create a legend data item and return it ...
    return { Name: strName, LayerID: strLayerID, SwatchElement: objSwatchElement, SubItems: new Array(), Visible: blnVisible };
}

// **************************************************************************
// FUNCTION: CreateLegendDataSubItem
// USAGE:    Use this function to create the sub items of the array to be 
//           passed into CreateLegendSection ...
// **************************************************************************
TrimbleMap.Legend.Shared.CreateLegendDataSubItem = function CreateLegendDataSubItem(strName, strLayerID, objSwatchElement, blnVisible) {

    // Create a legend data sub item and return it ...
    return { Name: strName, LayerID: strLayerID, SwatchElement: objSwatchElement, Visible: blnVisible };
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.MapSelector = {}
TrimbleMap.MapSelector.Shared = {};
TrimbleMap.MapSelector.Shared.MENU_ITEM_NAME = 'MAPS';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.MapSelector.CreateInstance = function CreateInstance(objMapController, objMenuInstance, intMenuItemOrder, blnVisible, fnUpdateUserSettings) {

    // Create the object that will hold the instance properties ...
    var objMapSelectorInstance = {
        MapController: objMapController,
        MenuInstance: objMenuInstance,
        MapListDiv: null,
        MapListContentDiv: null,
        Visible: false,
        MapsMenuItem: null,
        NiceScroll: null,

        ActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objMapSelectorInstance.ActivateSubMenu(objMenuItem, objSubMenuDiv) },
        DeActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objMapSelectorInstance.DeActivateSubMenu(objMenuItem, objSubMenuDiv) },
        MapSelectorClickedProxy: function (e) { objMapSelectorInstance.MapSelectorClicked(e) },
        SubMenuOpenedProxy: function (strSubMenuName) { objMapSelectorInstance.SubMenuOpened(strSubMenuName) },

        ActivateSubMenu: TrimbleMap.MapSelector.ActivateSubMenu,
        DeActivateSubMenu: TrimbleMap.MapSelector.DeActivateSubMenu,
        MapSelectorClicked: TrimbleMap.MapSelector.MapSelectorClicked,
        SubMenuOpened: TrimbleMap.MapSelector.SubMenuOpened,
        Show: TrimbleMap.MapSelector.Show,
        Hide: TrimbleMap.MapSelector.Hide,
        UpdateUserSettings: fnUpdateUserSettings
    };

    // Create the menu item ...
    objMapSelectorInstance.MapsMenuItem = TrimbleMap.Menu.Shared.CreateMenuItem(TrimbleMap.MapSelector.Shared.MENU_ITEM_NAME, SD.Translation.Shared.GetTranslation('Map.MapSelector.js', 'MenuItemName'), intMenuItemOrder, true, null, objMapSelectorInstance.ActivateSubMenuProxy, objMapSelectorInstance.DeActivateSubMenuProxy);

    // Add the on sub menu opened callback ...
    objMenuInstance.AddOnSubMenuOpenedCallback(objMapSelectorInstance.SubMenuOpenedProxy);

    // Show the menu button when its to be visible at startup ...
    if (blnVisible) { objMapSelectorInstance.Show(false); }

    return objMapSelectorInstance;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.MapSelector.Show = function Show(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objMapSelectorInstance = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objMapSelectorInstance.Visible) {

        // Add the menu item ...
        objMapSelectorInstance.MenuInstance.AddMenuItem(objMapSelectorInstance.MapsMenuItem);

        // Set to be visible ...
        objMapSelectorInstance.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapSelectorInstance.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.MapSwitcher, true); }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.MapSelector.Hide = function Hide(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objMapSelectorInstance = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objMapSelectorInstance.Visible) {

        // Remove the menu item ...
        objMapSelectorInstance.MenuInstance.RemoveMenuItem(objMapSelectorInstance.MapsMenuItem);

        // Set to not be visible ...
        objMapSelectorInstance.Visible = false;

        // Notify that the module visibility changed to false ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapSelectorInstance.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.MapSwitcher, false); }
    }
}

// **************************************************************************
// FUNCTION: ActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.MapSelector.ActivateSubMenu = function ActivateSubMenu(objMenuItem, objSubMenuDiv) {

    // Get the map selector instance ...
    var objMapSelectorInstance = this;

    // Create the list's div ...
    objMapSelectorInstance.MapListDiv = $('<div class="map-selector-list"></div>');

    // Create the list content's div ...
    objMapSelectorInstance.MapListContentDiv = $('<div></div>');

    // Add the content div to the list div ...
    objMapSelectorInstance.MapListDiv.append(objMapSelectorInstance.MapListContentDiv);

    // Loop through all the maps ...
    for (var intMap = 0; intMap < objMapSelectorInstance.MapController.State.Maps.length; intMap++) {

        // Get the map ...
        var objMap = objMapSelectorInstance.MapController.State.Maps[intMap];

        // Create a div for the map row ...
        var objMapRowDiv = $('<div class="map-selector" MapIndex="' + intMap + '"></div>');

        // Add a span with the map name ...
        objMapRowDiv.append('<span>' + objMap.MapName + '</span>')

        // When it is the current map, set to use map_selector_check_div  ...
        if (intMap == objMapSelectorInstance.MapController.State.CurrentMapIndex) {

            // Add the check div ...
            objMapRowDiv.append('<div class="check-icon"></div>');
        }

        // Add the row div to the list content div ...
        objMapSelectorInstance.MapListContentDiv.append(objMapRowDiv);
    }

    // Add it to the sub menu div ...
    objSubMenuDiv.append(objMapSelectorInstance.MapListDiv);

    // Attach the click event handler ...
    objMapSelectorInstance.MapListDiv.click(objMapSelectorInstance.MapSelectorClickedProxy);
}

// **************************************************************************
// FUNCTION: DeActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.MapSelector.DeActivateSubMenu = function DeActivateSubMenu(objMenuItem, objSubMenuDiv) {

    // Get the map selector instance ...
    var objMapSelectorInstance = this;

    // Detach the click event handler ...
    objMapSelectorInstance.MapListDiv.off('click', objMapSelectorInstance.MapSelectorClickedProxy);

    // De-activate the nice-scrollbar ...
    objMapSelectorInstance.NiceScroll.hide();
    objMapSelectorInstance.NiceScroll.remove();

    // Remove the div from the container ...
    objMapSelectorInstance.MapListDiv.remove();
}

// **************************************************************************
// FUNCTION: SubMenuOpened
// USAGE:    
// **************************************************************************
TrimbleMap.MapSelector.SubMenuOpened = function SubMenuOpened(strSubMenuName) {

    // Get the instance ...
    var objMapSelectorInstance = this;

    // When the menu were opened ...
    if (strSubMenuName == TrimbleMap.MapSelector.Shared.MENU_ITEM_NAME) {

        // Activate the nice scroll bar ...
        objMapSelectorInstance.NiceScroll = objMapSelectorInstance.MapListDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });
    }
}

// **************************************************************************
// FUNCTION: MapSelectorClicked
// USAGE:    
// **************************************************************************
TrimbleMap.MapSelector.MapSelectorClicked = function MapSelectorClicked(e) {

    // Get the map selector instance ...
    var objMapSelectorInstance = this;

    // Get the element clicked on ...
    var objTarget = $(e.target);

    // When the target is not the row ...
    if (!objTarget.hasClass('map-selector')) {

        // Attempt to find the row in which the target is ...
        objTarget = objTarget.closest('.map-selector');
    }

    // When a map item ...
    if (objTarget.length > 0) {

        // Get the map index ...
        var intMap = parseInt(objTarget.attr('MapIndex'));

        // Set the map index of the map controller ...
        objMapSelectorInstance.MapController.SetMapIndex(intMap);

        // Update UserSettings        
        objMapSelectorInstance.UpdateUserSettings(TrimbleMap.UserSettings.Shared.enumSetting.MapProperties, { 'MapID': objMapSelectorInstance.MapController.CurrentMap.MapID, 'VisibleMapServiceDisplayIDs': objMapSelectorInstance.MapController.State.VisibleMapServiceDisplayIDs, 'VisibleLayerIDsByMapServiceDisplayID': objMapSelectorInstance.MapController.State.VisibleLayerIDsByMapServiceDisplayID });

        // Hide the menu ...
        objMapSelectorInstance.MenuInstance.Hide();
    }
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.MapToScreenConversions = {};
TrimbleMap.MapToScreenConversions.Shared = {};

// **************************************************************************
// FUNCTION: ComputeDistanceInMapUnits
// USAGE:    
// **************************************************************************
TrimbleMap.MapToScreenConversions.Shared.ComputeDistanceInMapUnits = function ComputeDistanceInMapUnits(objExtent, dblDistance, objMapElement) {

    // Create two points that are the specified distance between each other ...
    var objLeftScreenPoint = esri.geometry.toMapPoint(objExtent, objMapElement.innerWidth(), objMapElement.innerHeight(), new esri.geometry.Point(0, 0));
    var objRightScreenPoint = esri.geometry.toMapPoint(objExtent, objMapElement.innerWidth(), objMapElement.innerHeight(), new esri.geometry.Point(dblDistance, 0));

    // Compute the distance in map units at the current extent ...
    var dblDistanceInMapUnits = Math.abs(objRightScreenPoint.x - objLeftScreenPoint.x);

    return dblDistanceInMapUnits;
}

// **************************************************************************
// FUNCTION: ExpandToAspectRatioOfExtent
// USAGE:    Width and height of objExtentWithAspectRatio assumed to not be 0 ...
// **************************************************************************
TrimbleMap.MapToScreenConversions.ExpandToAspectRatioOfExtent = function ExpandToAspectRatioOfExtent(objExtentToExpand, objExtentWithAspectRatio) {

    // Declare a variable for the expanded extent ...
    var objExpandedExtent;

    // Get the widths and heights of the extents ...
    var dblExtentToExpandWidth = objExtentToExpand.getWidth();
    var dblExtentToExpandHeight = objExtentToExpand.getHeight();
    var dblExtentWithAspectRatioWidth = objExtentWithAspectRatio.getWidth();
    var dblExtentWithAspectRatioHeight = objExtentWithAspectRatio.getHeight();

    // When the height of the extent to expand to is not zero ...
    if (dblExtentToExpandHeight != 0) {

        // Compute the aspect ratios of the extents ...
        var dblAspectRatioOfExtentToExpand = dblExtentToExpandWidth / dblExtentToExpandHeight;
        var dblTargetAspectRatio = dblExtentWithAspectRatioWidth / dblExtentWithAspectRatioHeight;

        // When the aspect ratio should be increased i.e. the width of the extent to expand should be increased ...
        if (dblTargetAspectRatio > dblAspectRatioOfExtentToExpand) {

            // Compute what the new width should be ...
            var dblNewWidth = (dblTargetAspectRatio * dblExtentToExpandHeight);

            // Compute half of that ...
            var dblHalfNewWidth = dblNewWidth / 2;

            // Compute the center of the existing extent ...
            var dblCenterX = (objExtentToExpand.xmin + objExtentToExpand.xmax) / 2;

            // Build the new expanded extent ...
            objExpandedExtent = new esri.geometry.Extent(dblCenterX - dblHalfNewWidth, objExtentToExpand.ymin, dblCenterX + dblHalfNewWidth, objExtentToExpand.ymax, objExtentToExpand.spatialReference);

        } else {

            // Compute what the new height should be ...
            var dblNewHeight = (dblExtentToExpandWidth / dblTargetAspectRatio);

            // Compute half of that ...
            var dblHalfNewHeight = dblNewHeight / 2;

            // Compute the center of the existing extent ...
            var dblCenterY = (objExtentToExpand.ymin + objExtentToExpand.ymax) / 2;

            // Build the new expanded extent ...
            objExpandedExtent = new esri.geometry.Extent(objExtentToExpand.xmin, dblCenterY - dblHalfNewHeight, objExtentToExpand.xmax, dblCenterY + dblHalfNewHeight, objExtentToExpand.spatialReference);
        }

    } else {

        // Compute the aspect ratios of the extents ...
        var dblAspectRatioOfExtentToExpand = dblExtentToExpandHeight / dblExtentToExpandWidth;
        var dblTargetAspectRatio = dblExtentWithAspectRatioHeight / dblExtentWithAspectRatioWidth;

        // When the aspect ratio should be decreased i.e. the width of the extent to expand should be decreased ...
        if (dblTargetAspectRatio < dblAspectRatioOfExtentToExpand) {

            // Compute what the new width should be ...
            var dblNewWidth = (dblExtentToExpandHeight / dblTargetAspectRatio);

            // Compute half of that ...
            var dblHalfNewWidth = dblNewWidth / 2;

            // Compute the center of the existing extent ...
            var dblCenterX = (objExtentToExpand.xmin + objExtentToExpand.xmax) / 2;

            // Build the new expanded extent ...
            objExpandedExtent = new esri.geometry.Extent(dblCenterX - dblHalfNewWidth, objExtentToExpand.ymin, dblCenterX + dblHalfNewWidth, objExtentToExpand.ymax, objExtentToExpand.spatialReference);

        } else {

            // Compute what the new height should be ...
            var dblNewHeight = (dblTargetAspectRatio * dblExtentToExpandWidth);

            // Compute half of that ...
            var dblHalfNewHeight = dblNewHeight / 2;

            // Compute the center of the existing extent ...
            var dblCenterY = (objExtentToExpand.ymin + objExtentToExpand.ymax) / 2;

            // Build the new expanded extent ...
            objExpandedExtent = new esri.geometry.Extent(objExtentToExpand.xmin, dblCenterY - dblHalfNewHeight, objExtentToExpand.xmax, dblCenterY + dblHalfNewHeight, objExtentToExpand.spatialReference);
        }
    }

    return objExpandedExtent;
}


/// <reference path="~/JavaScript/jquery.js" />f\
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Measure = {};
TrimbleMap.Measure.Shared = {};
TrimbleMap.Measure.Shared.TAB_NAME = 'Measure';
TrimbleMap.Measure.Shared.MODE_BUTTON_NAME = 'MEASURE';

// **************************************************************************
// FUNCTION: enumToolMode
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.enumToolMode = {};
TrimbleMap.Measure.enumToolMode.None = TrimbleMap.Measure.enumToolMode.None || 'None';
TrimbleMap.Measure.enumToolMode.Area = TrimbleMap.Measure.enumToolMode.Area || 'Area';
TrimbleMap.Measure.enumToolMode.Distance = TrimbleMap.Measure.enumToolMode.Distance || 'Distance';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.CreateInstance = function CreateInstance(objMapController, objSidebar, objModeButtons, strTabName, strTabCaption, blnVisible) {

    // Create the object that will hold the instance properties ...
    var objMapMeasure = {
        MapController: objMapController,
        ModeButtons: objModeButtons,
        Sidebar: objSidebar,
        TabName: strTabName,
        TabCaption: strTabCaption,
        Visible: false,
        SelectTool: TrimbleMap.Measure.SelectTool,
        MeasureModeButton: null,
        MeasureTabItem: null,
        CoordinateDisplay: null,
        CoordinateDisplayDiv: null,
        MeasureTabDiv: null,
        BorderDiv: null,
        MeasureDiv: null,
        DistanceToolButtonDiv: null,
        AreaToolButtonDiv: null,
        DistanceToolDetailsDiv: null,
        AreaToolDetailsDiv: null,
        ClearButtonDiv: null,
        DrawingPolygon: null,
        DrawingLine: null,
        DrawingToolbar: null,
        ResultsDiv: null,
        ResultsContainerDiv: null,
        DistanceDisplaySpan: null,
        DistanceDisplayDiv: null,
        AreaDisplayDiv: null,
        Graphic: null,
        ActivateMeasureToolAutomatically: true,
        DisplayDistance: null,
        DisplayArea: null,
        EndPolygonDrawingHandle: null,
        EndPolylineDrawingHandle: null,
        ToolMode: TrimbleMap.Measure.enumToolMode.None,
        EventHandlersAttached: false,

        CoordinateSystemDiv: null,
        OfficialMeasurementAndCoordinateSystemDiv: null,
        CoordinateSystemDropDown: null,
        GeometrySpatialReference: null,
        Geometry: null,
        CoordinateSystemInfo: null,
        CoordinateSystemInfoDiv: null,

        CoordinateSystemDropDownChangedProxy: function (e) { objMapMeasure.CoordinateSystemDropDownChanged(e); },
        CoordinateSystemInfoMouseEnterProxy: function (e) { objMapMeasure.CoordinateSystemInfoMouseEnter(e); },
        CoordinateSystemInfoMouseLeaveProxy: function (e) { objMapMeasure.CoordinateSystemInfoMouseLeave(e); },
        MeasureDivClickedProxy: function (e) { objMapMeasure.MeasureDivClicked(e); },
        MapLoadedProxy: function (blnReloaded) { objMapMeasure.MapLoaded(blnReloaded); },
        PreReloadedProxy: function () { objMapMeasure.PreReloaded(); },

        PopulateCoordinateSystemDropDown: TrimbleMap.Measure.PopulateCoordinateSystemDropDown,
        CoordinateSystemDropDownChanged: TrimbleMap.Measure.CoordinateSystemDropDownChanged,
        CoordinateSystemInfoMouseEnter: TrimbleMap.Measure.CoordinateSystemInfoMouseEnter,
        CoordinateSystemInfoMouseLeave: TrimbleMap.Measure.CoordinateSystemInfoMouseLeave,
        CreateMeasure: TrimbleMap.Measure.CreateMeasure,
        ActivateTab: TrimbleMap.Measure.ActivateTab,
        DeActivateTab: TrimbleMap.Measure.DeActivateTab,
        ResizeTab: TrimbleMap.Measure.ResizeTab,
        CreateCoordinateDisplay: TrimbleMap.Measure.CreateCoordinateDisplay,
        PositionElements: TrimbleMap.Measure.PositionElements,
        ActivateTool: TrimbleMap.Measure.ActivateTool,
        ActivatePolygonDrawing: TrimbleMap.Measure.ActivatePolygonDrawing,
        ActivateLineDrawing: TrimbleMap.Measure.ActivateLineDrawing,
        AttachEventHandlers: TrimbleMap.Measure.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Measure.DetachEventHandlers,
        MeasureDivClicked: TrimbleMap.Measure.MeasureDivClicked,
        RemoveMeasureGraphic: TrimbleMap.Measure.RemoveMeasureGraphic,
        ActivateMode: TrimbleMap.Measure.ActivateMode,
        DeActivateMode: TrimbleMap.Measure.DeActivateMode,
        ActivateAreaTool: TrimbleMap.Measure.ActivateAreaTool,
        ActivateDistanceTool: TrimbleMap.Measure.ActivateDistanceTool,
        ShowAreaDisplay: TrimbleMap.Measure.ShowAreaDisplay,
        HideAreaDisplay: TrimbleMap.Measure.HideAreaDisplay,
        ShowDisplayDistance: TrimbleMap.Measure.ShowDisplayDistance,
        HideDisplayDistance: TrimbleMap.Measure.HideDisplayDistance,
        DeActivateTools: TrimbleMap.Measure.DeActivateTools,
        DeActivatePolygonDrawing: TrimbleMap.Measure.DeActivatePolygonDrawing,
        MapLoaded: TrimbleMap.Measure.MapLoaded,
        PreReloaded: TrimbleMap.Measure.PreReloaded,
        Show: TrimbleMap.Measure.Show,
        Hide: TrimbleMap.Measure.Hide
    };

    // Set it as the measure div on the Map object ...
    objMapMeasure.CreateMeasure();

    // Create the tab ...
    objMapMeasure.MeasureTabItem = SD.Sidebar.Shared.CreateTabItem(objMapMeasure.TabName, objMapMeasure.TabCaption,
        TrimbleMap.StandardMap.Shared.enumTabOrder.MEASURE,
        function (objTabContainerElement, enTabActivationMethod) { objMapMeasure.ActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement, enTabActivationMethod) { objMapMeasure.DeActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement) { objMapMeasure.ResizeTab(objTabContainerElement); },
        function () { return 300; });

    // Create the measure mode button ...
    objMapMeasure.MeasureModeButton = SD.ModeButtons.Shared.CreateButton(TrimbleMap.Measure.Shared.MODE_BUTTON_NAME,
        'measure-mode',
        SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Measure'),
        TrimbleMap.StandardMap.Shared.enumModeButtonOrder.MEASURE,
        function (objModeButton) { objMapMeasure.ActivateMode(objModeButton); },
        function (objModeButton) { objMapMeasure.DeActivateMode(objModeButton); });

    // Show the tab and mode button when its to be visible at startup ...
    if (blnVisible) { objMapMeasure.Show(false, false); }

    // Add the onloaded event handler to the map controller ...
    objMapMeasure.MapController.AddOnLoadedCallback(objMapMeasure.MapLoadedProxy);

    // Add the pre reloaded event handler to the map controller ...
    objMapMeasure.MapController.AddPreReloadedCallback(objMapMeasure.PreReloadedProxy);

    // Return the instance ...
    return objMapMeasure;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
//           blnSelectTab is optional, defaults to true
// **************************************************************************
TrimbleMap.Measure.Show = function Show(blnTriggerNotifyModuleVisibilityChanged, blnSelectTab) {

    // Get the instance ...
    var objMapMeasure = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objMapMeasure.Visible) {

        // Add the mode button ...
        objMapMeasure.ModeButtons.AddButton(objMapMeasure.MeasureModeButton);

        // Add the tab ...
        objMapMeasure.Sidebar.AddTab(objMapMeasure.MeasureTabItem);

        // When we are to select the tab ...
        if ((typeof blnSelectTab == 'undefined') || (blnSelectTab == null) || blnSelectTab) {

            // Select the tab ...
            objMapMeasure.Sidebar.SelectTab(objMapMeasure.MeasureTabItem);
        }

        // Set to be visible ...
        objMapMeasure.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapMeasure.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Measure, true); }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Measure.Hide = function Hide(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objMapMeasure = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objMapMeasure.Visible) {

        // Detach all the event handlers (if attached) ...
        objMapMeasure.DetachEventHandlers();

        // Remove the mode button ...
        objMapMeasure.ModeButtons.RemoveButton(objMapMeasure.MeasureModeButton);

        // Remove the tab ...
        objMapMeasure.Sidebar.RemoveTab(objMapMeasure.MeasureTabItem);

        // Set to not be visible ...
        objMapMeasure.Visible = false;

        // Notify that the module visibility changed to false ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapMeasure.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Measure, false); }
    }
}

// **************************************************************************
// FUNCTION: RemoveMeasureGraphic
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.RemoveMeasureGraphic = function RemoveMeasureGraphic() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // When we have a graphic ...
    if (objMapMeasure.Graphic) {

        // Remove the persisted geometry
        objMapMeasure.Geometry = null;
        objMapMeasure.GeometrySpatialReference = null;

        // Remove the graphic ...
        objMapMeasure.MapController.RemoveGraphic(objMapMeasure.Graphic);

        // Set it to null ...
        objMapMeasure.Graphic = null;
    }
}

TrimbleMap.Measure.SelectTool = function SelectTool(enToolmode) {

    // Get the map identify instance ...
    var objMapMeasure = this;

    if (enToolmode == TrimbleMap.Measure.enumToolMode.Area) {
        objMapMeasure.ActivateAreaTool();
    }
    else if (enToolmode == TrimbleMap.Measure.enumToolMode.Distance) {
        objMapMeasure.ActivateDistanceTool();
    }

}

// **************************************************************************
// FUNCTION: Activate
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.ActivateMode = function ActivateMode(objModeButton) {

    // Get the map identify instance ...
    var objMapMeasure = this;

    // Select the measure tab ...
    objMapMeasure.Sidebar.SelectTab(objMapMeasure.MeasureTabItem);

    // When the measure tool are to be activated automatically ...
    if (objMapMeasure.ActivateMeasureToolAutomatically) {

        // When we do not have a current tool ...
        if (objMapMeasure.ToolMode == TrimbleMap.Measure.enumToolMode.None) {

            // Activate the area tool ...
            objMapMeasure.ActivateTool(TrimbleMap.Measure.enumToolMode.Area);

        } else {

            // Activate the current tool ...
            objMapMeasure.ActivateTool(objMapMeasure.ToolMode);
        }

    } else {

        // Set to activate the are tool automatically when this function is called from now on ...
        objMapMeasure.ActivateMeasureToolAutomatically = true;
    }
}

// **************************************************************************
// FUNCTION: DeActivate
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.DeActivateMode = function DeActivateMode(objModeButton) {

    // Get the map identify instance ...
    var objMapMeasure = this;

    // De-activate any active tools ...
    objMapMeasure.DeActivateTools();

    objMapMeasure.ActivateMeasureToolAutomatically = true;
}

// **************************************************************************
// FUNCTION: ActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.ActivateTab = function ActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // Add the search panel div to the tab container element ...
    objTabContainerElement.append(objMapMeasure.MeasureTabDiv);

    // Position the elements ...
    objMapMeasure.PositionElements();

    // Attach a resize event handler to the page ...
    $(window).on('resize',(function () {

        // Position the elements ...
        objMapMeasure.PositionElements();
    }));

    // Attach the event hanlders ...
    objMapMeasure.AttachEventHandlers();
}

// **************************************************************************
// FUNCTION: DeActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.DeActivateTab = function DeActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // When this tab has been activated due to the sidebar by slided in to view ...
    if (enTabActivationMethod == SD.Sidebar.enumTabActivationMethod.SidebarVisibilityChangedBySliding) {

        // Remove the measure panel div from the tab container element after 300 ms ...
        setTimeout(function () { objMapMeasure.MeasureTabDiv.remove(); }, 300);

    } else {

        // Remove the search panel div from the tab container element ...
        objMapMeasure.MeasureTabDiv.remove();
    }

    // Attach the event hanlders ...
    objMapMeasure.DetachEventHandlers();
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.AttachEventHandlers = function AttachEventHandlers() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // When the event handlers are not attached ...
    if (!objMapMeasure.EventHandlersAttached) {

        // Attach a click event handler ...
        objMapMeasure.MeasureDiv.on('click',(objMapMeasure.MeasureDivClickedProxy));

        // Attach the coordinate display handler ... 
        objMapMeasure.CoordinateDisplay.AttachHandler();

        objMapMeasure.CoordinateSystemDropDown.on('change',(objMapMeasure.CoordinateSystemDropDownChangedProxy));

        objMapMeasure.CoordinateSystemInfo.on('mouseenter',(objMapMeasure.CoordinateSystemInfoMouseEnterProxy));

        objMapMeasure.CoordinateSystemInfo.on('mouseleave',(objMapMeasure.CoordinateSystemInfoMouseLeaveProxy));

        if ((objMapMeasure.DisplayArea) && (objMapMeasure.DisplayArea.AreaInKm2 > 0)) {
            objMapMeasure.DisplayArea.AttachEventHandlers();
        }

        if ((objMapMeasure.DisplayDistance) && (objMapMeasure.DisplayDistance.DistanceInKm > 0)) {
            objMapMeasure.DisplayDistance.AttachEventHandlers();
        }

        // Set to have attached the event handlers ...
        objMapMeasure.EventHandlersAttached = true;
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // When the event handlers are attached ...
    if (objMapMeasure.EventHandlersAttached) {

        // Attach a click event handler ...
        objMapMeasure.MeasureDiv.off('click', objMapMeasure.MeasureDivClickedProxy);

        // Detach the coordinate display handler ... 
        objMapMeasure.CoordinateDisplay.DetachHandler();

        objMapMeasure.CoordinateSystemDropDown.off('change', objMapMeasure.CoordinateSystemDropDownChangedProxy);

        objMapMeasure.CoordinateSystemInfo.off('mouseenter', objMapMeasure.CoordinateSystemInfoMouseEnterProxy);

        objMapMeasure.CoordinateSystemInfo.off('mouseleave', objMapMeasure.CoordinateSystemInfoMouseLeaveProxy);

        if (objMapMeasure.DisplayArea) {
            objMapMeasure.DisplayArea.DetachEventHandlers();
        }

        if (objMapMeasure.DisplayDistance) {
            objMapMeasure.DisplayDistance.DetachEventHandlers();
        }

        // Set to have detached the event handlers ...
        objMapMeasure.EventHandlersAttached = false;
    }
}

// **************************************************************************
// FUNCTION: ResizeTab
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.ResizeTab = function ResizeTab(objTabContainerElement) {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // Position the elements ...
    objMapMeasure.PositionElements();
}

// **************************************************************************
// FUNCTION: MapLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.MapLoaded = function MapLoaded(blnReloaded) {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // When reloaded ...
    if (blnReloaded) {

        // When the measure mode button is the active button ...
        if (objMapMeasure.ModeButtons.ActiveButton == objMapMeasure.MeasureModeButton) {

            // Activate the currently selected tool ...
            objMapMeasure.ActivateTool(objMapMeasure.ToolMode);
        }

        // When the measure tab is the current tab ...
        if (objMapMeasure.Sidebar.CurrentTab == objMapMeasure.MeasureTabItem) {

            // Attach the coordinate display handler ... 
            objMapMeasure.CoordinateDisplay.AttachHandler();
        }
    }
}

// **************************************************************************
// FUNCTION: PreReloaded
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.PreReloaded = function PreReloaded() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // De-activate any active tools ...
    objMapMeasure.DeActivateTools();

    // When the measure tab is the current tab ...
    if (objMapMeasure.Sidebar.CurrentTab == objMapMeasure.MeasureTabItem) {

        // Attach the coordinate display handler ... 
        objMapMeasure.CoordinateDisplay.DetachHandler();
    }
}

// **************************************************************************
// FUNCTION: CreateCoordinateDisplay
// USAGE:
// **************************************************************************
TrimbleMap.Measure.CreateCoordinateDisplay = function CreateCoordinateDisplay() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // Create the coordinate display div ...
    objMapMeasure.CoordinateDisplayDiv = $('<div class="coordinates"></div>');

    // Create the coordinate display in the div ...
    objMapMeasure.CoordinateDisplay = TrimbleMap.CoordinateDisplay.CreateInstance(objMapMeasure.MapController, objMapMeasure.CoordinateDisplayDiv, objMapMeasure.MapController.GetCurrentMapSpatialReference());
}

// **************************************************************************
// FUNCTION: CreateMeasure
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.CreateMeasure = function CreateMeasure() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // Create the coordinate display ...
    objMapMeasure.CreateCoordinateDisplay();

    // Create the measure div ...
    objMapMeasure.MeasureTabDiv = $('<div class="side-panel"></div>');

    // Create the spacing div ...
    objMapMeasure.BorderDiv = $('<div></div>');

    // Add the spacing to the outer div ...
    objMapMeasure.MeasureTabDiv.append(objMapMeasure.BorderDiv);

    //get the translations
    var strTabInstructions = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'TabInstructions');

    // Create the inner div ...
    objMapMeasure.MeasureDiv = $('<div class="measure-container"><div><span class="measure-description">' + strTabInstructions + '</span><div></div>');

    // Add the measure div to the outer div ...
    objMapMeasure.BorderDiv.append(objMapMeasure.MeasureDiv);

    // Add the coordinate display div to the outer div ...
    objMapMeasure.MeasureTabDiv.append(objMapMeasure.CoordinateDisplayDiv);

    // Create the measure tools container div ...
    objMapMeasure.MeasureToolContainer = $('<div class="measure-tools"></div>');

    // Add it to the measure div ... 
    objMapMeasure.MeasureDiv.append(objMapMeasure.MeasureToolContainer);

    //Tools header
    objMapMeasure.MeasureToolContainer.append('<span class="tools-header">' + SD.Translation.Shared.GetTranslation('Map.Measure.js', 'MeasureToolsLabel') + ':</span>');

    // Get the translation for the tool tips ...

    // Measure Area
    var strMeasureAreaTranslation = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'MeasureArea');

    // Measure Length
    var strMeasureLengthTranslation = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'MeasureLength');

    // Clear Results
    var strMeasureClearTranslation = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'ClearResults');

    // Create the tool button container div ...
    objMapMeasure.ToolButtonContainer = $('<div class="measure-tool-buttons"></div>');

    // Add it to the measure div ...
    objMapMeasure.MeasureToolContainer.append(objMapMeasure.ToolButtonContainer);

    // Create the area tool button div ...
    objMapMeasure.AreaToolButtonDiv = $('<div class="area-tool" AreaTool="true" title="' + strMeasureAreaTranslation + '"></div>');

    // Add the section container div ...
    objMapMeasure.ToolButtonContainer.append(objMapMeasure.AreaToolButtonDiv);

    // Create the section container div ...
    objMapMeasure.DistanceToolButtonDiv = $('<div class="distance-tool" DistanceTool="true" title="' + strMeasureLengthTranslation + '"></div>');

    // Add the section container div ...
    objMapMeasure.ToolButtonContainer.append(objMapMeasure.DistanceToolButtonDiv);

    // Create the clear button div ...
    objMapMeasure.ClearButtonDiv = $('<div class="clear-measure" title="' + strMeasureClearTranslation + '"></div>');

    // Add the clear button container div ...
    objMapMeasure.ToolButtonContainer.append(objMapMeasure.ClearButtonDiv);

    // Get the translations ..
    var strToolResult = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'ToolResult');

    // Coordinate system
    var strCoordinateSystem = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'CoordinateSystem');

    // Create the coordinate system div
    objMapMeasure.CoordinateSystemDiv = $('<span>').attr('class', 'tools-header').append(strCoordinateSystem);

    // Add the CoordinateSystemDiv
    objMapMeasure.MeasureToolContainer.append(objMapMeasure.CoordinateSystemDiv);

    // Create the coordinate system div ... 
    let objCoordinateSystemValueDiv = $('<div>').attr('class', 'measure-coordinates');

    // Add it to the div ...
    objMapMeasure.MeasureToolContainer.append(objCoordinateSystemValueDiv);

    // Create the coordinate system drop down ...
    objMapMeasure.CoordinateSystemDropDown = $('<select>');

    // Add it to the div ...
    objCoordinateSystemValueDiv.append(objMapMeasure.CoordinateSystemDropDown);

    objMapMeasure.CoordinateSystemInfo = $('<div>').attr({ 'id': 'map_measure_info_image', 'class': 'info-icon' });

    objCoordinateSystemValueDiv.append(objMapMeasure.CoordinateSystemInfo);

    // Populate the coordinate system drop down ...
    objMapMeasure.PopulateCoordinateSystemDropDown(objMapMeasure.CoordinateSystemDropDown);

    // Create the results div ...
    objMapMeasure.ResultsDiv = $('<div class="measure-results"><span class="tools-header">' + strToolResult + ':</span></div>');

    // Add the it to the map measure control ...
    objMapMeasure.MeasureDiv.append(objMapMeasure.ResultsDiv);

    // Create the results container div ...
    objMapMeasure.ResultsContainerDiv = $('<div></div>');

    // Add the it to the results div ...
    objMapMeasure.ResultsDiv.append(objMapMeasure.ResultsContainerDiv);

    //get the translations
    var strAreaToolInstruction = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'AreaToolInstruction');
    var strDistanceToolInstruction = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'DistanceToolInstruction');

    // Create the area tool details div ...
    objMapMeasure.AreaToolDetailsDiv = $('<div class="measure-description" AreaToolDetails>' + strAreaToolInstruction + '</div>');

    // Create the distance tool details div ...
    objMapMeasure.DistanceToolDetailsDiv = $('<div class="measure-description" DistanceToolDetails>' + strDistanceToolInstruction + '</div>');

    // Create the area display control
    objMapMeasure.AreaDisplayDiv = $('<div>');

    // Add it to the results container div ...
    objMapMeasure.ResultsContainerDiv.append(objMapMeasure.AreaDisplayDiv);

    // Get the translation ...
    var strArea = SD.Translation.Shared.GetTranslation('Map.DisplayArea.js', 'AreaLabel');
    var strAreaCalculationInProgress = 'Calculating Area ...';

    // Create the DisplayArea control ...
    objMapMeasure.DisplayArea = TrimbleMap.DisplayArea.CreateInstance(objMapMeasure.MapController, objMapMeasure.AreaDisplayDiv, strArea, strAreaCalculationInProgress, null, false, objMapMeasure.MapController.State.DefaultAreaUnitIndex, objMapMeasure.MapController.State.AreaUnits);

    // Create the distance display control
    objMapMeasure.DistanceDisplayDiv = $('<div>');

    // Add it to the results container div ...
    objMapMeasure.ResultsContainerDiv.append(objMapMeasure.DistanceDisplayDiv);

    var strLengthCalculationInProgress = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatingLength') + ' ...';

    //Get the translation for 'Length:'
    var strDistanceLabel = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'LengthLabel');

    // Create the DisplayDistance control ...
    objMapMeasure.DisplayDistance = TrimbleMap.DisplayDistance.CreateInstance(objMapMeasure.MapController, objMapMeasure.DistanceDisplayDiv, null, strDistanceLabel, strLengthCalculationInProgress, false, objMapMeasure.MapController.State.DefaultDistanceUnitIndex, objMapMeasure.MapController.State.DistanceUnits);

    // Translation: Selecting a different Coordinate System will affect the calculation result.
    let strCoordinateSystemHelpLine1 = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'strCoordinateSystemHelpLine1');

    // Translation: Results may vary due to distortion caused by the different projection parameters.
    let strCoordinateSystemHelpLine2 = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'strCoordinateSystemHelpLine2');

    // Render the map info tool display component
    objMapMeasure.CoordinateSystemInfoDiv = $('<div>').attr({ 'id': 'map_measure_info_div', 'visible': 'true', 'class': 'info-details' }).append(
        $('<table>').attr({ 'id': 'tblCoordinateSystemHelpInfo', 'cellspacing': '0', 'cellpadding': '0', 'width': '100%', 'border': '0' }).append(
            $('<tr>').append(
                $('<td>').attr('colspan', 2).append(
                    $('<span>').attr('class', 'bold').append(strCoordinateSystemHelpLine1)))
        ).append(
            $('<tr>').append(
                $('<td>').attr('colspan', 2).append(
                    $('<span>').attr('class', 'bold').append(strCoordinateSystemHelpLine2)))
        )
    );

    objMapMeasure.BorderDiv.find('.info-icon').append(objMapMeasure.CoordinateSystemInfoDiv);

}

// **************************************************************************
// FUNCTION: ShowDisplayDistance
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.ShowDisplayDistance = function ShowDisplayDistance(intDefaultDistanceUnit, objDistance) {

    // Get the map measure instance ...
    var objMapMeasure = this;

    //update the area amount
    objMapMeasure.DisplayDistance.UpdateDistance(objDistance);

    //show the display area
    objMapMeasure.DisplayDistance.Show();

    // Show the results div ...
    objMapMeasure.ResultsDiv.show();

    // Show the clear button ...
    objMapMeasure.ClearButtonDiv.show();
}

// **************************************************************************
// FUNCTION: HideDisplayDistance
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.HideDisplayDistance = function HideDisplayDistance() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // Detach the event handlers here ...
    objMapMeasure.DisplayDistance.DetachEventHandlers();

    // Reset the variables ...
    objMapMeasure.DisplayDistance.Hide();

    // Hide the results div ...
    objMapMeasure.ResultsDiv.hide();

    // Hide the clear button ...
    objMapMeasure.ClearButtonDiv.hide();
}

// **************************************************************************
// FUNCTION: ShowAreaDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.ShowAreaDisplay = function ShowAreaDisplay(intDefaultAreaUnit, decArea) {

    // Get the map measure instance ...
    var objMapMeasure = this;

    //update the area amount
    objMapMeasure.DisplayArea.UpdateArea(decArea);

    //show the display area
    objMapMeasure.DisplayArea.Show();

    // Show the results div ...
    objMapMeasure.ResultsDiv.show();

    // Show the clear button ...
    objMapMeasure.ClearButtonDiv.show();
}

// **************************************************************************
// FUNCTION: HideAreaDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.HideAreaDisplay = function HideAreaDisplay() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // Detach the event handlers here ...
    objMapMeasure.DisplayArea.DetachEventHandlers();

    // Reset the variables ...
    objMapMeasure.DisplayArea.Hide();

    // Hide the results div ...
    objMapMeasure.ResultsDiv.hide();

    // Hide the clear button ...
    objMapMeasure.ClearButtonDiv.hide();
}

// **************************************************************************
// FUNCTION: DeActivateTools
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.DeActivateTools = function DeActivateTools() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // When the area is being displayed ...
    if (objMapMeasure.DisplayArea) {

        // Hide the area ...
        objMapMeasure.HideAreaDisplay();

        // Detach the poylgon drawing end event handler ...
        dojo.disconnect(objMapMeasure.EndPolygonDrawingHandle);
    }

    // When the distance is being displayed ...
    if (objMapMeasure.DisplayDistance) {

        // Hide the distance ...
        objMapMeasure.HideDisplayDistance();

        // Detach the poylgon drawing end event handler ...
        dojo.disconnect(objMapMeasure.EndLineDrawingHandle);
    }

    // De-activate the polygon drawing ...
    objMapMeasure.DeActivatePolygonDrawing();

    // Remove the measure graphic ...
    objMapMeasure.RemoveMeasureGraphic();

    // Remove the active classes ...
    objMapMeasure.AreaToolButtonDiv.removeClass('selected');
    objMapMeasure.DistanceToolButtonDiv.removeClass('selected');

    // Hide the details divs ...
    objMapMeasure.AreaToolDetailsDiv.remove();
    objMapMeasure.DistanceToolDetailsDiv.remove();
}

// **************************************************************************
// FUNCTION: PositionElements
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.PositionElements = function PositionElements() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // Set the spacing div height to position the coordinate display ...
    objMapMeasure.BorderDiv.css('height', objMapMeasure.Sidebar.GetHeight() - 55);
    objMapMeasure.MeasureDiv.css('max-height', objMapMeasure.Sidebar.GetHeight() - 55);
}

TrimbleMap.Measure.ActivateAreaTool = function ActivateAreaTool() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // De-activate any active tools ...
    objMapMeasure.DeActivateTools();

    //set the mode
    objMapMeasure.ToolMode = TrimbleMap.Measure.enumToolMode.Area;

    // Activate the mode button ...
    objMapMeasure.ModeButtons.ActivateButton(objMapMeasure.MeasureModeButton);

    objMapMeasure.AreaToolButtonDiv.addClass('selected');

    objMapMeasure.MeasureDiv.append(objMapMeasure.AreaToolDetailsDiv);

    objMapMeasure.ActivatePolygonDrawing();
}

TrimbleMap.Measure.ActivateDistanceTool = function ActivateDistanceTool() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // De-activate any active tools ...
    objMapMeasure.DeActivateTools();

    //set the mode
    objMapMeasure.ToolMode = TrimbleMap.Measure.enumToolMode.Distance;

    // Activate the mode button ...
    objMapMeasure.ModeButtons.ActivateButton(objMapMeasure.MeasureModeButton);

    objMapMeasure.DistanceToolButtonDiv.addClass('selected');

    objMapMeasure.MeasureDiv.append(objMapMeasure.DistanceToolDetailsDiv);

    objMapMeasure.ActivateLineDrawing();
}

// **************************************************************************
// FUNCTION: MeasureDivClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.MeasureDivClicked = function MeasureDivClicked(e) {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // Get the target element ...
    var objTarget = $(e.target);

    // Determine on which interface elemnts we clicked ...
    var objMeasureDistance = SD.DOM.GetElementOrParentWithClass(objTarget, 'distance-tool');
    var objMeasureArea = SD.DOM.GetElementOrParentWithClass(objTarget, 'area-tool');
    var objClearMeasurement = SD.DOM.GetElementOrParentWithClass(objTarget, 'clear-measure');

    // When a checkbox in a map service heading has been clicked ...
    if (objMeasureDistance) {

        objMapMeasure.ActivateMeasureToolAutomatically = false;
        objMapMeasure.ActivateTool(TrimbleMap.Measure.enumToolMode.Distance);

    } else if (objMeasureArea) {

        objMapMeasure.ActivateMeasureToolAutomatically = false;
        objMapMeasure.ActivateTool(TrimbleMap.Measure.enumToolMode.Area);

    } else if (objClearMeasurement) {

        // Hide the area when the area is being displayed ...
        if (objMapMeasure.DisplayArea) { objMapMeasure.HideAreaDisplay(); }

        // Hide the distance when the distance is being displayed ...
        if (objMapMeasure.DisplayDistance) { objMapMeasure.HideDisplayDistance(); }

        // Remove the measure graphic ...
        objMapMeasure.RemoveMeasureGraphic();
    }
}

// **************************************************************************
// FUNCTION: DeActivatePolygonDrawing
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.DeActivatePolygonDrawing = function DeActivatePolygonDrawing() {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // When we have a drawing toolbar ...
    if (objMapMeasure.DrawingToolbar) {

        // Deactivate it ...
        objMapMeasure.DrawingToolbar.deactivate();

        // Set it to be null ...
        objMapMeasure.DrawingToolbar = null;
    }
}

// **************************************************************************
// FUNCTION: ActivateTool
// USAGE:    
// **************************************************************************
TrimbleMap.Measure.ActivateTool = function ActivateTool(enToolMode) {

    // Get the map measure instance ...
    var objMapMeasure = this;

    // Set the tool mode ...
    objMapMeasure.ToolMode = enToolMode;

    // Depending on the tool mode ...
    switch (enToolMode) {
        case TrimbleMap.Measure.enumToolMode.Area:

            // Activate the area tool ...
            objMapMeasure.ActivateAreaTool();
            break;

        case TrimbleMap.Measure.enumToolMode.Distance:

            // Activate the distance tool ...
            objMapMeasure.ActivateDistanceTool();
            break;
    }
}

TrimbleMap.Measure.ActivatePolygonDrawing = function ActivatePolygonDrawing() {

    // Get the instance ...
    var objMapMeasure = this;

    // Set to be drawing a polygon ...
    objMapMeasure.DrawingPolygon = true;

    // When the map has been loaded successfully ...
    if (objMapMeasure.MapController.EsriMap.loaded) {

        // De-activate the drawing toolbar when open ...
        objMapMeasure.DeActivatePolygonDrawing();

        if (objMapMeasure.DisplayDistance) {
            objMapMeasure.DisplayDistance.DetachEventHandlers();
        }

        // Create a new drawing toolbar for the map ...
        objMapMeasure.DrawingToolbar = new esri.toolbars.Draw(objMapMeasure.MapController.EsriMap);

        // Connect to the onDrawEnd event ...
        objMapMeasure.EndPolygonDrawingHandle = dojo.connect(objMapMeasure.DrawingToolbar, "onDrawEnd", function (objGeometry) {

            // clear all previous graphics & results
            objMapMeasure.RemoveMeasureGraphic();

            // Set the wait cursor ...
            objMapMeasure.MapController.SetMapCursor(TrimbleMap.enumEsriCursorType.Wait);

            // Create a symbol to draw the user drawn polygon with ...
            var objDrawnSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID,
                new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([0, 0, 0]), 2, 0.3),
                new dojo.Color([0, 0, 0, 0.1]));

            // Create a graphic for the user drawn polygon ...
            objMapMeasure.Graphic = new esri.Graphic(new esri.geometry.Polygon(objGeometry.toJson()), objDrawnSymbol);

            // Add the user drawn polygon to the map ...
            objMapMeasure.MapController.AddGraphic(objMapMeasure.Graphic);

            // De-activate the drawing toolbar ...
            objMapMeasure.DrawingToolbar.deactivate();

            if (objMapMeasure.DisplayArea.AreaUnits.length > 0) {

                // Start a separate thread so that the user drawn graphic and the wait cursor will display on the map immediately ....
                setTimeout(function () {

                    let guidSelectedSpatialReference = objMapMeasure.CoordinateSystemDropDown.val();

                    // Transform the geometry from the base layer's spatial reference to the selected spatial reference
                    let objGeoTransformation = objMapMeasure.MapController.GetGeoTransformation(objMapMeasure.MapController.CurrentMap.SpatialReferenceID, guidSelectedSpatialReference);

                    // Project the geometry
                    let objGeometryForCalculation = objMapMeasure.MapController.ProjectGeometriesClientSide([objGeometry], objMapMeasure.MapController.CurrentMap.SpatialReferenceID,
                        guidSelectedSpatialReference, objGeoTransformation)[0];

                    // Persist the geometry and the current spatial reference id
                    objMapMeasure.Geometry = objGeometryForCalculation;
                    objMapMeasure.GeometrySpatialReference = guidSelectedSpatialReference;

                    // Calculate the area ...
                    var objAreaDeferred = TrimbleMap.Shape.Shared.CalculateAreaSquareKm(objMapMeasure.MapController, [{ Geometry: objGeometryForCalculation, ExteriorPartID: SD.Guid.Shared.NewID() }], guidSelectedSpatialReference);

                    objAreaDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objArea) {

                        // Show the area ...
                        objMapMeasure.ShowAreaDisplay(1, objArea);

                        // Select the measure tab ...
                        objMapMeasure.Sidebar.SelectTab(objMapMeasure.MeasureTabItem);

                        // Activate polygon drawing ...
                        objMapMeasure.ActivatePolygonDrawing();

                        // Return to the default cursor ...
                        objMapMeasure.MapController.SetMapCursor(TrimbleMap.enumEsriCursorType.Default);

                    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                        // Activate polygon drawing ...
                        objMapMeasure.ActivatePolygonDrawing();

                        // Return to the default cursor ...
                        objMapMeasure.MapController.SetMapCursor(TrimbleMap.enumEsriCursorType.Default);
                    }));
                }, 1);

            } else {

                // Get the title and message translations ...

                // No Area Units                
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'NoAreaUnitsTitle');

                // The system has no area units specified
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'NoAreaUnitsMessage');

                // The system has no area units specified
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'NoAreaUnitsEndUserMessage');

                // Log the diagnostic message ...
                objMapMeasure.MapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);
            }

        });

        // Activate the drawing toolbar ...
        objMapMeasure.DrawingToolbar.activate(esri.toolbars.Draw.POLYGON);
    }
}

TrimbleMap.Measure.ActivateLineDrawing = function ActivateLineDrawing() {

    var objMapMeasure = this;

    // Set to be drawing a line ...
    objMapMeasure.DrawingLine = true;

    // When the map has been loaded successfully ...
    if (objMapMeasure.MapController.EsriMap.loaded) {

        if (objMapMeasure.DrawingToolbar) {
            objMapMeasure.DrawingToolbar.deactivate();
        }

        if (objMapMeasure.DisplayArea) {

            objMapMeasure.DisplayArea.DetachEventHandlers();
        }

        // Create a new drawing toolbar for the map ...
        objMapMeasure.DrawingToolbar = new esri.toolbars.Draw(objMapMeasure.MapController.EsriMap);

        // Connect to the onDrawEnd event ...
        objMapMeasure.EndPolylineDrawingHandle = dojo.connect(objMapMeasure.DrawingToolbar, "onDrawEnd", function (objGeometry) {

            // clear all previous graphics & results
            objMapMeasure.RemoveMeasureGraphic();

            // Set the wait cursor ...
            objMapMeasure.MapController.SetMapCursor(TrimbleMap.enumEsriCursorType.Wait);

            // Create a symbol to draw the user drawn polygon with ...
            var objDrawnSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_NULL,
                new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([0, 0, 0]), 2, 0.3),
                new dojo.Color([0, 0, 0, 0.1]));

            // Create a graphic for the user drawn line ...
            objMapMeasure.Graphic = new esri.Graphic(new esri.geometry.Polyline(objGeometry.toJson()), objDrawnSymbol);

            // Add the user drawn polygon to the map ...
            objMapMeasure.MapController.AddGraphic(objMapMeasure.Graphic);

            // De-activate the drawing toolbar ...
            objMapMeasure.DrawingToolbar.deactivate();

            if (objMapMeasure.DisplayDistance.DistanceUnits.length > 0) {

                // Start a separate thread so that the user drawn graphic and the wait cursor will display on the map immediately ....
                setTimeout(function () {

                    let guidSelectedSpatialReference = objMapMeasure.CoordinateSystemDropDown.val();

                    // Transform the geometry from the base layer's spatial reference to the selected spatial reference
                    let objGeoTransformation = objMapMeasure.MapController.GetGeoTransformation(objMapMeasure.MapController.CurrentMap.SpatialReferenceID, guidSelectedSpatialReference);

                    // Project the geometry
                    let objGeometryForCalculation = objMapMeasure.MapController.ProjectGeometriesClientSide([objGeometry], objMapMeasure.MapController.CurrentMap.SpatialReferenceID,
                        guidSelectedSpatialReference, objGeoTransformation)[0];

                    // Persist the geometry and the current spatial reference id
                    objMapMeasure.Geometry = objGeometryForCalculation;
                    objMapMeasure.GeometrySpatialReference = guidSelectedSpatialReference;

                    // Calculate the distance ...
                    var objDistanceDeferred = TrimbleMap.Shape.Shared.CalculateDistanceKm(objMapMeasure.MapController, { Geometry: objGeometryForCalculation }, guidSelectedSpatialReference);

                    // When the distance calculate has been deferred ...
                    objDistanceDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objDistance) {

                        // Show the distance ...
                        objMapMeasure.ShowDisplayDistance(0, objDistance);

                        // Select the measure tab ...
                        objMapMeasure.Sidebar.SelectTab(objMapMeasure.MeasureTabItem);

                        // Activate polygon drawing ...
                        objMapMeasure.ActivateLineDrawing();

                        // Return to the default cursor ...            
                        objMapMeasure.MapController.SetMapCursor(TrimbleMap.enumEsriCursorType.Default);

                    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                        // Activate polygon drawing ...
                        objMapMeasure.ActivateLineDrawing();

                        // Return to the default cursor ...
                        objMapMeasure.MapController.SetMapCursor(TrimbleMap.enumEsriCursorType.Default);
                    }));
                }, 1);

            } else {

                // Get the title and message translations ...

                // No Distance Units
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'NoDistanceUnitsTitle');

                // The system has no distance units specified
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'NoDistanceUnitsMessage');

                // The system has no distance units specified
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Measure.js', 'NoDistanceUnitsEndUserMessage');

                // Log the diagnostic message ...
                objMapMeasure.MapController.LogDiagnosticMessage(strTitle, strMessage, null, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);
            }

        });

        // Activate the drawing toolbar ...
        objMapMeasure.DrawingToolbar.activate(esri.toolbars.Draw.POLYLINE);
    }
}

TrimbleMap.Measure.PopulateCoordinateSystemDropDown = function PopulateCoordinateSystemDropDown(objCoordinateSystemDropDown) {
    var objMapMeasure = this;

    $.each(objMapMeasure.MapController.State.SpatialReferences, function (intSpatialReference, objSpatialReference) {

        if (objSpatialReference.SpatialReferenceID != SD.Guid.Shared.Empty()) {
            objCoordinateSystemDropDown.append('<option value="' + objSpatialReference.SpatialReferenceID + '">' + objSpatialReference.Name + '</option>');
        }

    });

    if (objMapMeasure.MapController.State.DefaultMapMeasureSpatialReferenceID != null) {
        $(objCoordinateSystemDropDown).val(objMapMeasure.MapController.State.DefaultMapMeasureSpatialReferenceID);
    }
}

TrimbleMap.Measure.CoordinateSystemDropDownChanged = function CoordinateSystemDropDownChanged(e) {
    var objMapMeasure = this;

    if (objMapMeasure.Geometry != null && objMapMeasure.ToolMode != TrimbleMap.Measure.enumToolMode.None) {

        let guidCurrentSpatialReference = objMapMeasure.GeometrySpatialReference;
        let guidSelectedSpatialReference = objMapMeasure.CoordinateSystemDropDown.val();

        let objGeoTransformation = objMapMeasure.MapController.GetGeoTransformation(guidCurrentSpatialReference, guidSelectedSpatialReference);
        let objGeometryForCalculation = objMapMeasure.MapController.ProjectGeometriesClientSide([objMapMeasure.Geometry], guidCurrentSpatialReference,
            guidSelectedSpatialReference, objGeoTransformation)[0];

        switch (objMapMeasure.ToolMode) {
            case TrimbleMap.Measure.enumToolMode.Area:

                let objAreaDeferred = TrimbleMap.Shape.Shared.CalculateAreaSquareKm(objMapMeasure.MapController, [{ Geometry: objGeometryForCalculation, ExteriorPartID: SD.Guid.Shared.NewID() }], guidSelectedSpatialReference);

                objAreaDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objArea) {
                    objMapMeasure.ShowAreaDisplay(1, objArea);
                }),
                    TrimbleMap.Controller.Shared.TrapException(function (strError) {
                        objMapMeasure.DisplayArea.Hide();
                    })
                );

                break;

            case TrimbleMap.Measure.enumToolMode.Distance:

                let objDistanceDeferred = TrimbleMap.Shape.Shared.CalculateDistanceKm(objMapMeasure.MapController, { Geometry: objGeometryForCalculation }, guidSelectedSpatialReference);

                objDistanceDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objDistance) {
                    objMapMeasure.ShowDisplayDistance(0, objDistance);
                }),
                    TrimbleMap.Controller.Shared.TrapException(function (strError) {
                        objMapMeasure.DisplayDistance.Hide();
                    })
                );

                break;
        }
    }
};

TrimbleMap.Measure.CoordinateSystemInfoMouseEnter = function CoordinateSystemInfoMouseEnter(e) {
    let objMapMeasure = this;
    let objInfoImagePosition = objMapMeasure.CoordinateSystemInfo.position();

    objMapMeasure.CoordinateSystemInfoDiv.show();
};

TrimbleMap.Measure.CoordinateSystemInfoMouseLeave = function CoordinateSystemInfoMouseLeave(e) {
    let objMapMeasure = this;

    objMapMeasure.CoordinateSystemInfoDiv.hide();
};


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Menu = {};
TrimbleMap.Menu.Shared = {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.CreateInstance = function CreateInstance(objMapController) {

    // Create the object that will hold the instance properties ...
    var objMenu = {
        MapController: objMapController,
        Visible: false,
        MenuIcon: null,
        MenuElement: null,
        MenuItemContainerElement: null,
        SubMenuContainerElement: null,
        ExtendedMenuIcon: null,
        MenuMouseLeaveTimer: null,
        MenuItems: [],
        VisibleSubMenuItem: null,
        VisibleSubMenuDiv: null,
        OnSubMenuOpenedFunctions: [],

        MenuElementClickedProxy: function (e) { objMenu.MenuElementClicked(e) },
        MenuIconClickedProxy: function () { objMenu.MenuIconClicked() },
        MenuIconMouseLeaveProxy: function (e) { objMenu.MenuIconMouseLeave(e) },
        MenuIconMouseReEnterProxy: function (e) { objMenu.MenuIconMouseReEnter(e) },

        CreateIcon: TrimbleMap.Menu.CreateIcon,
        CreateAndShowElements: TrimbleMap.Menu.CreateAndShowElements,
        CreateMenuItemElements: TrimbleMap.Menu.CreateMenuItemElements,
        GetMenuItemDiv: TrimbleMap.Menu.GetMenuItemDiv,
        Show: TrimbleMap.Menu.Show,
        Hide: TrimbleMap.Menu.Hide,
        AddMenuItem: TrimbleMap.Menu.AddMenuItem,
        RemoveMenuItem: TrimbleMap.Menu.RemoveMenuItem,
        GetMenuItemIndex: TrimbleMap.Menu.GetMenuItemIndex,
        ShowSubMenu: TrimbleMap.Menu.ShowSubMenu,
        HideSubMenu: TrimbleMap.Menu.HideSubMenu,
        SubMenuHeightChanged: TrimbleMap.Menu.SubMenuHeightChanged,
        UpdateVerticalDivider: TrimbleMap.Menu.UpdateVerticalDivider,
        UpdateMenuElements: TrimbleMap.Menu.UpdateMenuElements,
        MenuElementClicked: TrimbleMap.Menu.MenuElementClicked,
        MenuItemClicked: TrimbleMap.Menu.MenuItemClicked,
        MenuIconClicked: TrimbleMap.Menu.MenuIconClicked,
        MenuIconMouseLeave: TrimbleMap.Menu.MenuIconMouseLeave,
        MenuIconMouseReEnter: TrimbleMap.Menu.MenuIconMouseReEnter,
        AddOnSubMenuOpenedCallback: TrimbleMap.Menu.AddOnSubMenuOpenedCallback,
        TriggerOnSubMenuOpened: TrimbleMap.Menu.TriggerOnSubMenuOpened,
        AttachPopupEventHandlers: TrimbleMap.Menu.AttachPopupEventHandlers,
        DetachPopupEventHandlers: TrimbleMap.Menu.DetachPopupEventHandlers
    };

    // Create the menu icon ...
    objMenu.CreateIcon();

    return objMenu;
}

// **************************************************************************
// FUNCTION: CreateIcon
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.CreateIcon = function CreateIcon() {

    // Get the instance ...
    var objMenu = this;

    // Create the menu icon ...
    var objMenuIcon = $('<div class="menu-btn"><div class="menu-icon"></div></div>');

    // Add it to the map element ...
    objMenu.MapController.MapElement.append(objMenuIcon);

    // Attach the mouse enter event handler ...
    objMenuIcon.on('click', (objMenu.MenuIconClickedProxy));

    // Set the menu icon ...
    objMenu.MenuIcon = objMenuIcon;
}

// **************************************************************************
// FUNCTION: CreateAndShowElements
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.CreateAndShowElements = function CreateAndShowElements() {

    // Get the instance ...
    var objMenu = this;

    // When we've not created the menu yet ...
    if (objMenu.MenuElement == null) {

        // Create the menu div and the container elements for the menu items and the sub menu ...
        objMenu.MenuElement = $('<div class="menu"></div>');
        objMenu.MenuItemContainerElement = $('<div class="menu-items"></div>');
        objMenu.SubMenuContainerElement = $('<div class="item-contents"></div>');

        // Add the containers to the menu element ...
        objMenu.MenuElement.append(objMenu.MenuItemContainerElement);
        objMenu.MenuElement.append(objMenu.SubMenuContainerElement);

        // Create the item elemnts ...
        objMenu.CreateMenuItemElements();

        // Create the extended menu icon ...
        objMenu.ExtendedMenuIcon = $('<div class="menu-btn-open"></div>');

        // Create the extent menu icon image element ...
        var objExtendedMenuIconImage = $('<div class="menu-icon-open"></div>')

        // Append to the extent menu icon ...
        objMenu.ExtendedMenuIcon.append(objExtendedMenuIconImage);

        // Add to the document ...
        objMenu.MapController.MapElement.append(objMenu.MenuElement);
        objMenu.MapController.MapElement.append(objMenu.ExtendedMenuIcon);

        // Attach the mouse leave and enter event handler to the menu and extended menu icon ...
        objMenu.AttachPopupEventHandlers();

    } else {

        // Show the menu ...
        objMenu.MenuElement.show();
        objMenu.ExtendedMenuIcon.show();
    }

    // Select the menu item when there are only one ...
    if (objMenu.MenuItems.length == 1) { objMenu.MenuItemClicked(objMenu.MenuItems[0]); }

    // Set to be visible ...
    objMenu.Visible = true;
}

// **************************************************************************
// FUNCTION: CreateMenuItemElements
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.CreateMenuItemElements = function CreateMenuItemElements() {

    // Get the instance ...
    var objMenu = this;

    // Clear the item container ...
    objMenu.MenuItemContainerElement.empty();

    // Sort the menu items according to order ...
    var arrSortedMenuItems = objMenu.MenuItems.sort(function (objMenuItemA, objMenuItemB) { return objMenuItemA.Order - objMenuItemB.Order; });

    // Loop through all the menu items ...
    for (var intMenuItem = 0; intMenuItem < arrSortedMenuItems.length; intMenuItem++) {

        // Get the menu item ...
        var objMenuItem = arrSortedMenuItems[intMenuItem];

        // When not a separator ...
        if (!objMenuItem.IsSeparator) {

            // Create the item div ...
            var objItemDiv = $('<div class="menu-item" MenuItemName="' + objMenuItem.Name + '"></div>');

            // Create the span ...
            var objItemSpan = $('<span></span>');

            // Set the item text ...
            objItemSpan.text(objMenuItem.DisplayText);

            // Add the span to the div ...
            objItemDiv.append(objItemSpan);

            // When this is to be a visibility switch ...
            if (objMenuItem.HasSubMenu) {

                // Add the check box item ...
                objItemDiv.append('<div class="menu-arrow-icon"></div>');
            }

            // Add the div to the menu ...
            objMenu.MenuItemContainerElement.append(objItemDiv);

        } else {

            // Add a separator div ...
            objMenu.MenuItemContainerElement.append('<div class="menu_separator"></div>');
        }
    }
}

// **************************************************************************
// FUNCTION: GetMenuItemDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.GetMenuItemDiv = function GetMenuItemDiv(objMenuItem) {

    // Get the instance ...
    var objMenu = this;

    // Get the div ...
    var objMenuItemDiv = objMenu.MenuItemContainerElement.find('[MenuItemName="' + objMenuItem.Name + '"]');

    // Return it ...
    return objMenuItemDiv;
}

// **************************************************************************
// FUNCTION: AttachPopupEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.AttachPopupEventHandlers = function AttachPopupEventHandlers() {

    // Get the instance ...
    var objMenu = this;

    // Attach the mouse leave and enter event handler to the menu and extended menu icon ...
    objMenu.MenuElement.mouseleave(objMenu.MenuIconMouseLeaveProxy);
    objMenu.ExtendedMenuIcon.mouseleave(objMenu.MenuIconMouseLeaveProxy);
    objMenu.MenuElement.mouseenter(objMenu.MenuIconMouseReEnterProxy);
    objMenu.ExtendedMenuIcon.mouseenter(objMenu.MenuIconMouseReEnterProxy);

    // Attach a click event handler ...
    objMenu.MenuElement.click(objMenu.MenuElementClickedProxy);
}

// **************************************************************************
// FUNCTION: DetachPopupEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.DetachPopupEventHandlers = function DetachPopupEventHandlers() {

    // Get the instance ...
    var objMenu = this;

    // Attach the mouse leave and enter event handler to the menu and extended menu icon ...
    objMenu.MenuElement.off('mouseleave', objMenu.MenuIconMouseLeaveProxy);
    objMenu.ExtendedMenuIcon.off('mouseleave', objMenu.MenuIconMouseLeaveProxy);
    objMenu.MenuElement.off('mouseenter', objMenu.MenuIconMouseReEnterProxy);
    objMenu.ExtendedMenuIcon.off('mouseenter', objMenu.MenuIconMouseReEnterProxy);

    // Attach a click event handler ...
    objMenu.MenuElement.off('click', objMenu.MenuElementClickedProxy);
}

// **************************************************************************
// FUNCTION: MenuIconClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.MenuIconClicked = function MenuIconClicked() {

    // Get the instance ...
    var objMenu = this;

    // Create and display the menu ...
    objMenu.CreateAndShowElements();
}

// **************************************************************************
// FUNCTION: MenuIconMouseLeave
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.MenuIconMouseLeave = function MenuIconMouseLeave(e) {

    // Get the instance ...
    var objMenu = this;

    // Set to hide the menu after 300 ms if the mouse did not enter the menu again ...
    objMenu.MenuMouseLeaveTimer = setTimeout(function () {

        // Hide the menu ...
        objMenu.Hide();
    }, 300);
}

// **************************************************************************
// FUNCTION: MenuIconMouseReEnter
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.MenuIconMouseReEnter = function MenuIconMouseReEnter(e) {

    // Get the instance ...
    var objMenu = this;

    // Clear the timer (i.e. do not hide the menu) ...
    clearTimeout(objMenu.MenuMouseLeaveTimer);
}

// **************************************************************************
// FUNCTION: MenuElementClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.MenuElementClicked = function MenuElementClicked(e) {

    // Get the instance ...
    var objMenu = this;

    // Find the first element up the dom tree that have the 'menu_item_div' class ...
    var objMenuItemDiv = $(e.target).closest('.menu-item, .menu-item-disabled');

    // When found ...
    if (objMenuItemDiv.length > 0) {

        // Get the menu item name ...
        var strMenuItemName = objMenuItemDiv.attr('MenuItemName');

        // Get the menu item ...
        var objMenuItem = $.grep(objMenu.MenuItems, function (objTestMenuItem, intTestMenuItem) {
            return objTestMenuItem.Name == strMenuItemName;
        })[0];

        // Fire the menu item clicked callback ...
        objMenu.MenuItemClicked(objMenuItem);
    }
}

// **************************************************************************
// FUNCTION: MenuItemClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.MenuItemClicked = function MenuItemClicked(objMenuItem) {

    // Get the instance ...
    var objMenu = this;

    // Call the clicked function ...
    if ((typeof objMenuItem.Clicked != undefined) && (objMenuItem.Clicked != null)) { objMenuItem.Clicked(objMenuItem); }

    // When the item has a sub menu ...
    if (objMenuItem.HasSubMenu) {

        // When not already visible ...
        if ((!objMenu.VisibleSubMenuItem) || (objMenu.VisibleSubMenuItem.Name != objMenuItem.Name)) {

            // Show the sub menu ...
            objMenu.ShowSubMenu(objMenuItem);
        }

    } else {

        // Hide the menu ...
        objMenu.Hide();
    }
}

// **************************************************************************
// FUNCTION: CreateMenuItem
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.Shared.CreateMenuItem = function CreateMenuItem(strName, strDisplayText, intOrder, blnHasSubMenu, fnClicked, fnActivateSubMenu, fnDeActivateSubMenu) {

    // Create a new menu item object ...
    return {
        Name: strName,
        DisplayText: strDisplayText,
        Order: intOrder,
        HasSubMenu: blnHasSubMenu,
        IsSeparator: false,
        Clicked: fnClicked,
        ActivateSubMenu: fnActivateSubMenu,
        DeActivateSubMenu: fnDeActivateSubMenu
    };
}

// **************************************************************************
// FUNCTION: CreateSeparator
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.Shared.CreateSeparator = function CreateSeparator(intOrder) {

    // Create a new menu item object ...
    return {
        IsSeparator: true,
        Name: '',
        DisplayText: '',
        Order: intOrder,
        HasSubMenu: false,
        Clicked: null,
        ActivateSubMenu: null,
        DeActivateSubMenu: null,
        MenuItemEnabled: null
    };
}

// **************************************************************************
// FUNCTION: AddMenuItem
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.AddMenuItem = function AddMenuItem(objMenuItem) {

    // Get the instance ...
    var objMenu = this;

    // Add it to the array of menu items ...
    objMenu.MenuItems.push(objMenuItem);

    // Update the menu elements ...
    objMenu.UpdateMenuElements();
}

// **************************************************************************
// FUNCTION: RemoveMenuItem
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.RemoveMenuItem = function RemoveMenuItem(objMenuItem) {

    // Get the instance ...
    var objMenu = this;

    // Get the menu item index ...
    var intMenuItem = objMenu.GetMenuItemIndex(objMenuItem);

    // Remove it from the array of menu items ...
    objMenu.MenuItems.splice(intMenuItem, 1);

    // Update the menu elements ...
    objMenu.UpdateMenuElements();
}

// **************************************************************************
// FUNCTION: GetMenuItemIndex
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.GetMenuItemIndex = function GetMenuItemIndex(objMenuItem) {

    // Get the instance ...
    var objMenu = this;

    // Get the menu item index ...
    var intMenuItem = $.inArray(objMenuItem, objMenu.MenuItems);

    return intMenuItem;
}

// **************************************************************************
// FUNCTION: UpdateMenuElements
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.UpdateMenuElements = function UpdateMenuElements() {

    // Get the instance ...
    var objMenu = this;

    // When the menu is visble ...
    if (objMenu.Visible) {

        // Update the menu item elements ...
        objMenu.CreateMenuItemElements();

    } else {

        // When we have a menu element (already built) ...
        if (objMenu.MenuElement) {

            // Detach the popup event handlers ...
            objMenu.DetachPopupEventHandlers();

            // Set the menu element to null so that it would be re-created when the menu are opened ...
            objMenu.MenuElement = null;
        }
    }
}

// **************************************************************************
// FUNCTION: HideSubMenu 
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.HideSubMenu = function HideSubMenu(fnDone, intDurationMilliSeconds) {

    // Get the instance ...
    var objMenu = this;

    // Animate the sub menu to full width ...
    objMenu.SubMenuContainerElement.animate({
        width: '0px'
    }, {
        duration: intDurationMilliSeconds,
        done: function () {

            // De-Activate the sub menu ...
            objMenu.VisibleSubMenuItem.DeActivateSubMenu(objMenu.VisibleSubMenuItem, objMenu.VisibleSubMenuDiv);

            // Remove it from the dom ...
            objMenu.VisibleSubMenuDiv.remove();

            // Get the menu item div ...
            var objMenuItemDiv = objMenu.GetMenuItemDiv(objMenu.VisibleSubMenuItem);

            // Remove the selected class to it ...
            objMenuItemDiv.removeClass('menu-item-selected');

            // Clear the visible sub menu item and div ...
            objMenu.VisibleSubMenuItem = null;
            objMenu.VisibleSubMenuDiv = null;

            // Update the vertical divider ...
            objMenu.UpdateVerticalDivider();

            // Call the done callback when given one ...
            if (typeof fnDone != 'undefined') { fnDone(); }
        }
    });
}

// **************************************************************************
// FUNCTION: SubMenuHeightChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.SubMenuHeightChanged = function SubMenuHeightChanged(objMenuItem) {

    // Get the instance ...
    var objMenu = this;

    // Update the vertical divider ...
    objMenu.UpdateVerticalDivider();
}

// **************************************************************************
// FUNCTION: UpdateVerticalDivider
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.UpdateVerticalDivider = function UpdateVerticalDivider(objMenuItem) {

    // Get the instance ...
    var objMenu = this;

    // When the sub menu is visible ... 
    if (objMenu.VisibleSubMenuItem) {

        // Measure the size of the menu item container and sub menu containers ...
        var objMenuItemContainerSize = SD.HtmlFunctions.Shared.MeasureElement(objMenu.MenuItemContainerElement);
        var objSubMenuContainerSize = SD.HtmlFunctions.Shared.MeasureElement(objMenu.VisibleSubMenuDiv);

        // When menu item container is taller than the sub menu container ...
        if (objMenuItemContainerSize.height > objSubMenuContainerSize.height) {

            // Add the divider to the left and remove from the right ...
            objMenu.MenuItemContainerElement.addClass('menu-divider-start');
            objMenu.SubMenuContainerElement.removeClass('menu-divider-end');

        } else {
            // Add the divider to the right and remove from the left ...
            objMenu.MenuItemContainerElement.removeClass('menu-divider-start');
            objMenu.SubMenuContainerElement.addClass('menu-divider-end');
        }

    } else {

        // Remove the divider classes ...
        objMenu.MenuItemContainerElement.removeClass('menu-divider-start');
        objMenu.SubMenuContainerElement.removeClass('menu-divider-end');
    }
}

// **************************************************************************
// FUNCTION: ShowSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.ShowSubMenu = function ShowSubMenu(objMenuItem) {

    // Get the instance ...
    var objMenu = this;

    // Create a new div in which to display the sub menu ...
    var objSubMenuDiv = $('<div></div>');

    // Activate the sub menu to be displayed ...
    objMenuItem.ActivateSubMenu(objMenuItem, objSubMenuDiv);

    // Create a function that will show the sub menu ...
    var fnShowSubMenu = function () {

        // Measure the sub menu element ...
        let objSubMenuSize = SD.HtmlFunctions.Shared.MeasureElement(objSubMenuDiv);

        // Set the sub menu width to start at 0px ...
        objMenu.SubMenuContainerElement.css('width', '0px');

        // Add the sub menu to the container ...
        objMenu.SubMenuContainerElement.append(objSubMenuDiv);

        // Animate the sub menu to full width ...
        objMenu.SubMenuContainerElement.animate({ width: objSubMenuSize.width }, 100, function () {

            // Remove the width so that the element could naturally define it's width ...
            objMenu.SubMenuContainerElement.css('width', 'auto');

            // Trigger the on sub menu opened event handlers ...
            objMenu.TriggerOnSubMenuOpened(objMenuItem.Name);
        });

        // Set the visible sub menu item and div ...
        objMenu.VisibleSubMenuItem = objMenuItem;
        objMenu.VisibleSubMenuDiv = objSubMenuDiv;

        // Update the vertical divider ...
        objMenu.UpdateVerticalDivider();

        // Get the menu item div ...
        var objMenuItemDiv = objMenu.GetMenuItemDiv(objMenuItem);

        // Add the selected class to it ...
        objMenuItemDiv.addClass('menu-item-selected');
    };

    // When we have an already visible sub menu ...
    if (objMenu.VisibleSubMenuItem) {

        // Hide the sub menu that is currently visible ...
        objMenu.HideSubMenu(function () {

            // Show the sub menu ...
            fnShowSubMenu();
        }, 100);

    } else {

        // Show the sub menu ...
        fnShowSubMenu();
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.Hide = function Hide() {

    // Get the instance ...
    var objMenu = this;

    // Create the hide function ...
    var fnHide = function () {

        if (objMenu.MenuElement && objMenu.Visible) {

            // Hide the menu ...
            objMenu.MenuElement.hide();
            objMenu.ExtendedMenuIcon.hide();
        } else {

            objMenu.MenuIcon.hide();
        }

        // Set to not be visible ...
        objMenu.Visible = false;
    }

    // When we have an already visible sub menu ...
    if (objMenu.VisibleSubMenuItem) {

        // Hide the sub menu that is currently visible ...
        objMenu.HideSubMenu(function () {

            // Hide the menu ...
            fnHide();
        }, 0);

    } else {

        // Hide the menu ...
        fnHide();
    }
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    
// **************************************************************************
TrimbleMap.Menu.Show = function Show() {

    // Get the instance ...
    var objMenu = this;

    if (objMenu.MenuElement) {

        objMenu.Visible = true;
    }

    // Set to be visible ...
    objMenu.MenuIcon.show();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddOnSubMenuOpenedCallback
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Menu.AddOnSubMenuOpenedCallback = function AddOnSubMenuOpenedCallback(fnAddOnSubMenuOpenedCallback) {

    // Get the instance ...
    var objMenu = this;

    // Add it to the callback list ...
    objMenu.OnSubMenuOpenedFunctions.push(fnAddOnSubMenuOpenedCallback);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TriggerOnSubMenuOpened
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Menu.TriggerOnSubMenuOpened = function TriggerOnSubMenuOpened(strSubMenuName) {

    // Get the instance ...
    var objMenu = this;

    // Loop through all the on sub menu opened functions ...
    $.each(objMenu.OnSubMenuOpenedFunctions, function (intOnSubMenuOpenedFunctions, fnOnSubMenuOpenedFunctions) {

        // Call the callback ...
        fnOnSubMenuOpenedFunctions(strSubMenuName);
    });
}
/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace
var TrimbleMap = TrimbleMap || {};
TrimbleMap.MessageBox = {};
TrimbleMap.MessageBox.Shared = {}
TrimbleMap.MessageBox.Shared.OKButtonID = 'OKButton';
TrimbleMap.MessageBox.Shared.CancelButtonID = 'CancelButtonID';

// **************************************************************************
// FUNCTION: ShowMessage
// USAGE:    objOnCloseFunctionOrButtons is optional
//           objOnCloseFunctionOrButtons could either be a function in which 
//           case an OK button will be added to the dialog and the function 
//           will be called when it is clicked or objOnCloseFunctionOrButtons
//           could be an array with items created with the shared function
//           Map.MessageBox.Shared.CreateMessageBoxButton that are button that 
//           will be added to the dialog. When objOnCloseFunctionOrButtons is 
//           not specified then an OK button will be added ...
//           intMaxWidth is optional, blnCloseDialogAutomatically is optional
//           and defaults to true ...
// **************************************************************************
TrimbleMap.MessageBox.Shared.ShowMessage = function ShowMessage(strTitle, strMessage, objOnCloseFunctionOrButtons, intMaxWidth, objJQueryElement, blnCloseDialogAutomatically, fnContentClick, blnShowCancelButton, fnMessageBoxOpened) {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // Create a new defreed to return ...
    var objDeferred = new dojo.Deferred();

    // Default blnCloseDialogAutomatically to true when not set ...
    if ((typeof blnCloseDialogAutomatically == 'undefined') || (blnCloseDialogAutomatically == null)) { blnCloseDialogAutomatically = true; }

    // Set the button array to be the input variable ...
    var arrButtons = [];

    // Get the next dialog id ...
    var objDialogID = TrimbleMap.ModalDialog.Shared.NextDialogID();

    // First check to see if objOnCloseFunctionOrButtons is not already an Array
    if (!Array.isArray(objOnCloseFunctionOrButtons)) {

        // When not defined or objOnCloseFunctionOrButtons is a function ... 
        if ((typeof objOnCloseFunctionOrButtons == 'undefined') || !objOnCloseFunctionOrButtons || (typeof objOnCloseFunctionOrButtons == 'function')) {

            // Create an array with an OK button that will call the function when clicked ...
            arrButtons.push(TrimbleMap.MessageBox.Shared.CreateMessageBoxButton(TrimbleMap.MessageBox.Shared.OKButtonID, 'OK', objOnCloseFunctionOrButtons));
        }

        //When we are to display the cancel button
        if (blnShowCancelButton) {
            arrButtons.push(TrimbleMap.MessageBox.Shared.CreateMessageBoxButton(TrimbleMap.MessageBox.Shared.CancelButtonID, 'CANCEL', TrimbleMap.ModalDialog.Shared.CloseDialog(objDialogID)));
        }
    }
    else {

        // Validate that the keys, to create the dialog buttons, exist in the objOnCloseFunctionOrButtons array for each object
        var blnIsValid = true;
        for (var i = 0; i < objOnCloseFunctionOrButtons.length; i++) {
            var objButton = objOnCloseFunctionOrButtons[i];
            if (objButton !== null && (typeof objButton === 'object')) {
                if (!objButton.hasOwnProperty("ButtonID") && !objButton.hasOwnProperty("ButtonText") && !objButton.hasOwnProperty("ClickedFunction")) {
                    blnIsValid = false;
                }
            }
            else {
                blnIsValid = false;
            }
        }

        // If the keys exist necessary to build dialog buttons, set the arrButtons variable to be used later
        if (blnIsValid) {
            arrButtons = objOnCloseFunctionOrButtons;
        }
    }

    // Create the content div for the dialog ...
    var objDialogContent = $('<div class="map-message-box"></div>');

    // When we have a strMessage ...
    if ((typeof strMessage != 'undefined') && (strMessage != null) && ((strMessage).trim() != '')) {

        // Add it to the dialog... 
        objDialogContent.append('<span>' + strMessage + '</span><br />');
    }

    // When we have a jquery element ...
    if ((typeof objJQueryElement != 'undefined') && objJQueryElement) {

        if (typeof fnContentClick === 'function') {
            objJQueryElement.on("click", fnContentClick)
        }

        // Add it to the dialog... 
        objDialogContent.append(objJQueryElement);
    }

    // Add an empty line ...
    objDialogContent.append('<br />');

    // When we have a max width specified ...
    if ((typeof intMaxWidth != 'undefined') && (intMaxWidth != null)) {

        // Set the max width on the dialog content ...
        objDialogContent.css('max-width', intMaxWidth);
    }

    //create div for footer buttons
    var objButtonDiv = $('<div class="dialog_footer_buttons"></div>');

    // Loop through all the buttons from last to first ...
    for (var intButton = arrButtons.length - 1; intButton >= 0; intButton--) {

        // Get the button ...
        var objButton = arrButtons[intButton];

        // Create the button element to add ...
        var objButtonElement = $('<button ButtonID="' + objButton.ButtonID + '" class="Button pull-right" style="margin-inline-start:10px;cursor:pointer;">' + objButton.ButtonText + '</button>');

        // When this is the right most button ...
        if (intButton == arrButtons.length - 1) {

            // Move the button to lign up with the dialog heading right side ...
            objButtonElement.css('margin-inline-end', '0px');
        }

        // Add the button to the button div ...
        objButtonDiv.append(objButtonElement);
    }

    // Add the button div to the dialog ...
    objDialogContent.append(objButtonDiv);

    if (arrButtons.length < 2) {
        // Add an empty line at the bottom of the dialog ...
        objDialogContent.append('<br /><br />');
    }

    // Show the dialog ...
    TrimbleMap.ModalDialog.Shared.OpenDialog(objDialogContent, strTitle, false, objDialogID);

    // Use a time out to ensure the event queue is processed before attaching the key press event handler again ...
    setTimeout(function () {

        // Create the key pressed function that will only be used when we have an OK button ...
        var fnKeyPressed = function () { objOnCloseFunctionOrButtons(TrimbleMap.MessageBox.Shared.OKButtonID); };

        // Create a function that will close the dialog ...
        var fnButtonClicked = function (e) {

            // Prevent the default action (submit) ...
            e.preventDefault();

            // Get the element clicked on that has a ButtonID attribute ...
            var objButtonClicked = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'ButtonID');

            // When a button has been clciked on ...
            if (objButtonClicked) {

                // When objOnCloseFunctionOrButtons is a function (i.e. when we only have an OK button) ... 
                if (typeof objOnCloseFunctionOrButtons == 'function') {

                    // Detach the keypressed event handler ...
                    $(window).off('keypress', fnKeyPressed);
                }

                // Get the button ID ...
                var strButtonID = objButtonClicked.attr('ButtonID');

                // Close the modal dialog ...
                if (blnCloseDialogAutomatically) { TrimbleMap.ModalDialog.Shared.CloseDialog(objDialogID); }

                // Start with no button found with the id ...
                var objButton = null;

                // Loop through all the buttons ...
                $.each(arrButtons, function (intButtonToCheck, objButtonToCheck) {

                    // When the button ID matches ...
                    if (objButtonToCheck.ButtonID == strButtonID) {

                        // Set the button ...
                        objButton = objButtonToCheck;

                        // Stop searching ...
                        return false;
                    }
                });

                // When a button with the id were found ...
                if (objButton) {

                    // When we have a clicked function ...
                    if ((typeof objButton.ClickedFunction != 'undefined') && objButton.ClickedFunction) {

                        // Call it with the button id ...
                        objButton.ClickedFunction(strButtonID);
                    }
                }
            }
        }

        // When objOnCloseFunctionOrButtons is a function (i.e. when we only have an OK button) ... 
        if (typeof objOnCloseFunctionOrButtons == 'function') {

            // Attach the key pressed event handler to the document ...
            $(window).keypress(fnKeyPressed);
        }

        if (typeof fnMessageBoxOpened == "function") {
            fnMessageBoxOpened();
        }

        // Attach a click event handler to the dialog button ... 
        objDialogContent.on('click',(fnButtonClicked));

        // Resolve the deferred ...
        objDeferred.resolve();
    }, 0);

    // Return an object containing functions that can close or reposition the modal dialog later and a defererd to indaicate when the dialog has openned ...
    return {
        Close: function () {

            // Close the dialog ...
            TrimbleMap.ModalDialog.Shared.CloseDialog(objDialogID);
        },
        Center: function () {

            // Reposition the dialog ...
            TrimbleMap.ModalDialog.Shared.RepositionDialog(objDialogID);
        },
        Deferred: objDeferred
    };
}

// **************************************************************************
// FUNCTION: CreateMessageBoxButton
// USAGE:    
// **************************************************************************
TrimbleMap.MessageBox.Shared.CreateMessageBoxButton = function CreateMessageBoxButton(strButtonID, strButtonText, fnClicked) {

    return {
        ButtonID: strButtonID,
        ButtonText: strButtonText,
        ClickedFunction: fnClicked
    };
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ModalDialog = {};
TrimbleMap.ModalDialog.Shared = {};
TrimbleMap.ModalDialog.Shared.Handler =null;

// **************************************************************************
// FUNCTION: SetHandler
// USAGE:    
// **************************************************************************
TrimbleMap.ModalDialog.Shared.SetHandler = function SetHandler(objModalDialogHandler) {

    // Set the handler ...
    TrimbleMap.ModalDialog.Shared.Handler = objModalDialogHandler;
}

// **************************************************************************
// FUNCTION: NextDialogID
// USAGE:    
// **************************************************************************
TrimbleMap.ModalDialog.Shared.NextDialogID = function NextDialogID() {

    // Get the next dialog id using the handler ...
    var objNextID = TrimbleMap.ModalDialog.Shared.Handler.NextDialogID();

    return objNextID;
}

// **************************************************************************
// FUNCTION: OpenDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ModalDialog.Shared.OpenDialog = function OpenDialog(objDialogContent, strTitle, blnShowCloseButton, objDialogID) {

    // Open a new dialog using the handler ...
    TrimbleMap.ModalDialog.Shared.Handler.OpenDialog(objDialogContent, strTitle, blnShowCloseButton, objDialogID);

    if (TrimbleMap.ModalDialog.Shared.Handler.RepositionDialog) {

    // Repositon dialog when window is resized every 250 milliseconds
        $(window).resize(function () {
            clearTimeout(window.resizedFinished);
            window.resizedFinished = setTimeout(function () {
                TrimbleMap.ModalDialog.Shared.RepositionDialog(objDialogID);
            }, 250);
        });
    }
}

// **************************************************************************
// FUNCTION: CloseDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ModalDialog.Shared.CloseDialog = function CloseDialog(objDialogID) {

    // Close the dialog using the handler ...
    var objNextID = TrimbleMap.ModalDialog.Shared.Handler.CloseDialog(objDialogID);

    return objNextID;
}

// **************************************************************************
// FUNCTION: RepositionDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ModalDialog.Shared.RepositionDialog = function RepositionDialog(objDialogID) {

    if (TrimbleMap.ModalDialog.Shared.Handler.RepositionDialog) {
        // Reposition the dialog using the handler ...
        var objNextID = TrimbleMap.ModalDialog.Shared.Handler.RepositionDialog(objDialogID);

        return objNextID;
    }
}

// **************************************************************************
// FUNCTION: AddOnClosedHandler
// USAGE:    
// **************************************************************************
TrimbleMap.ModalDialog.Shared.AddOnClosedHandler = function AddOnClosedHandler(fnOnClosedHandler) {

    // Add the on close handler ...
    TrimbleMap.ModalDialog.Shared.Handler.AddOnClosedHandler(fnOnClosedHandler);
}

// **************************************************************************
// FUNCTION: RemoveOnClosedHandler
// USAGE:    
// **************************************************************************
TrimbleMap.ModalDialog.Shared.RemoveOnClosedHandler = function RemoveOnClosedHandler(fnOnClosedHandler) {

    // Remove the on close handler ...
    TrimbleMap.ModalDialog.Shared.Handler.RemoveOnClosedHandler(fnOnClosedHandler);
}


// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.CSVShapeImporter = {};
TrimbleMap.CSVShapeImporter.Shared = {};

TrimbleMap.CSVShapeImporter.Shared.RequiredFileTypesRegex = "(\.|\/)(csv)$";
TrimbleMap.CSVShapeImporter.Shared.AcceptedFileTypesRegex = "/(\.|\/)(csv)$/i";

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.CreateInstance = function CreateInstance(objShapeImporter) {
    // Create the object that will hold the instance properties ...
    let objCSVShapeImporter = {
        ShapeImporter: objShapeImporter,
        AllowedFileTypes: ".csv",
        RequiredFileTypes: [{
            Key: "csv",
            Value: false
        }],
        GetDisplayConfiguration: TrimbleMap.CSVShapeImporter.GetDisplayConfiguration,
        Validate: TrimbleMap.CSVShapeImporter.Validate,
        Import: TrimbleMap.CSVShapeImporter.Import,
        AddFile: TrimbleMap.CSVShapeImporter.AddFile,
        Next: TrimbleMap.CSVShapeImporter.Next,
        Previous: TrimbleMap.CSVShapeImporter.Previous,
        CustomFileUpLoadPluginConfiguration: TrimbleMap.CSVShapeImporter.CustomFileUpLoadPluginConfiguration,
        SetCurrentStep: TrimbleMap.CSVShapeImporter.SetCurrentStep
    }

    return objCSVShapeImporter;
}

// **************************************************************************
// FUNCTION: GetDisplayConfiguration
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.GetDisplayConfiguration = function GetDisplayConfiguration() {
    //Get the csv shape importer instance ...
    let objCSVShapeImporter = this;
    let objDisplayConfiguration = objCSVShapeImporter.ShapeImporter.InitialiseDisplayConfiguration();

    objDisplayConfiguration.AddedFileName(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVAddedFileName'));
    objDisplayConfiguration.AddedFileSize(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVAddedFileSize'));
    objDisplayConfiguration.AddShapeOption(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVAddShapeOption'));
    objDisplayConfiguration.CancelButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVCancelButton'));
    objDisplayConfiguration.ImportButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVImportButton'));
    objDisplayConfiguration.InvalidFile(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVInvalidFile'));
    objDisplayConfiguration.NextButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVNextButton'));
    objDisplayConfiguration.NoFiles(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVNoFiles'));
    objDisplayConfiguration.PreviousButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVPreviousButton'));
    objDisplayConfiguration.ReplaceShapeOption(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVReplaceShapeOption'));
    objDisplayConfiguration.RequiredFilesMissingTooltip(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVRequiredFilesMissingTooltip'));
    objDisplayConfiguration.SelectedAddReplaceShape(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVSelectedAddReplaceShape'));
    objDisplayConfiguration.SelectedCoordinateSystem(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVSelectedCoordinateSystem'));
    objDisplayConfiguration.Step1Title(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVStep1Title'));
    objDisplayConfiguration.Step3Title(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVStep3Title'));
    objDisplayConfiguration.TemplateDownloadText(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVTemplate'));
    objDisplayConfiguration.UploadInstructions(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVUploadInstructions'));
    objDisplayConfiguration.ValidationErrorsDescription(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVValidationErrorsDescription'));
    objDisplayConfiguration.ValidationErrorsTitle(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'CSVValidationErrorsTitle'));

    // UI Configuration object which is for text displayed on UI.
    return objDisplayConfiguration;
}

// **************************************************************************
// FUNCTION: Validate
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.Validate = function Validate() {
    //Get the csv shape importer instance ...
    let objCSVShapeImporter = this;

    //Ensure the file is not submitted while validating...
    objCSVShapeImporter.ShapeImporter.FileUpLoadConfiguration().formData.ImportOption = TrimbleMap.ShapeImporter.enumImportOptions.Validate;
    $('#fileupload').fileupload(objCSVShapeImporter.ShapeImporter.FileUpLoadConfiguration());

    //Populate spatial reference drop down with the shapes default spatial reference, if no default specified, leave it empty
    if (objCSVShapeImporter.ShapeImporter.ShapeEditor.Shape.SpatialReferenceID && objCSVShapeImporter.ShapeImporter.ShapeEditor.Shape.SpatialReferenceID != SD.Guid.Shared.Empty()) {
        let objPrePopulateSpatialReference = objCSVShapeImporter.ShapeImporter.Options().SpatialReferences().find(function (objSpatialReference) {
            return objSpatialReference.SpatialReferenceID == objCSVShapeImporter.ShapeImporter.ShapeEditor.Shape.SpatialReferenceID;
        });

        objCSVShapeImporter.ShapeImporter.Options().SelectedSpatialReference(objPrePopulateSpatialReference);
    }

    objCSVShapeImporter.ShapeImporter.Options().FileuploadDataObject.submit()
        .complete(function (objData) {

            let response = objData.responseJSON ? objData.responseJSON : objData;

            if (response && response.ErrorMessages && response.ErrorMessages.length > 0) {
                objCSVShapeImporter.ShapeImporter.Options().ValidationMessages(response.ErrorMessages);
                //Show Validation error steps
                objCSVShapeImporter.ShapeImporter.Options().CurrentStep(-1);
            }
            else {
                //increment the current step
                objCSVShapeImporter.SetCurrentStep(TrimbleMap.ShapeImporter.enumNavigation.Next);
            }

            TrimbleMap.ModalDialog.Shared.RepositionDialog(objCSVShapeImporter.ShapeImporter.DialogID);
            objCSVShapeImporter.ShapeImporter.HideProcessingDiv();
        });
}

// **************************************************************************
// FUNCTION: AddFile
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.AddFile = function AddFile(objFile) {
    //Get the csv shape importer instance ...
    let objCSVShapeImporter = this;

    let objPattern = new RegExp(TrimbleMap.CSVShapeImporter.Shared.RequiredFileTypesRegex, "i");
    let blnAddFile = true;
    let blnInvalidFileFound = false;

    if (!objPattern.test(objFile.name)) {
        blnAddFile = false;
        blnInvalidFileFound = true;
    } else {
        objCSVShapeImporter.ShapeImporter.Options().RequiredFiles().find(function (objKeyValuePair) {
            return objKeyValuePair.Key == "csv";
        }).Value = true;
    }

    return {
        AddFile: blnAddFile,
        InvalidFileFound: blnInvalidFileFound
    };
}

// **************************************************************************
// FUNCTION: Import
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.Import = function Import(data) {
    //Get the csv shape importer instance ...
    let objCSVShapeImporter = this;

    //Ensure the file is not submitted while validating...
    objCSVShapeImporter.ShapeImporter.FileUpLoadConfiguration().formData.ImportOption = TrimbleMap.ShapeImporter.enumImportOptions.Submit;
    objCSVShapeImporter.ShapeImporter.FileUpLoadConfiguration().formData.SpatialReferenceID = objCSVShapeImporter.ShapeImporter.Options().SelectedSpatialReference().SpatialReferenceID;
    $('#fileupload').fileupload(objCSVShapeImporter.ShapeImporter.FileUpLoadConfiguration());

    data.submit()
        .complete(function (data) {
            
            let response = data.responseJSON ? data.responseJSON : data;

            if (response && response.ErrorMessages && response.ErrorMessages.length > 0) {
                objCSVShapeImporter.ShapeImporter.Options().ValidationMessages(response.ErrorMessages);
                //Show Validation error steps
                objCSVShapeImporter.ShapeImporter.Options().CurrentStep(-1);
                objCSVShapeImporter.ShapeImporter.HideProcessingDiv();
                return;
            }

            let objSelectedSpatialReference = objCSVShapeImporter.ShapeImporter.Options().SelectedSpatialReference();
            let blnAddToExistingShape = objCSVShapeImporter.ShapeImporter.Options().AddToExistingShape();
            
            let arrGeometries = [];
            let objGeometryJson = JSON.parse(response.GeometryJson);

            var objEsriGeometry = esri.geometry.jsonUtils.fromJson(JSON.parse(response.GeometryJson));

            switch (objEsriGeometry.type) {
                case 'point':

                    let objPoint = {
                        Geometry: new esri.geometry.Point(objEsriGeometry.x, objEsriGeometry.y, objEsriGeometry.spatialReference)
                    };

                    arrGeometries.push(objPoint);

                    break;
                case 'multipoint':

                    if (objGeometryJson.points.length > 1) {

                        let intPart = 0;

                        // Loop through all the points ...
                        $.each(objGeometryJson.points, function (intPart, objPart) {

                            let objGetPoint = objEsriGeometry.getPoint(intPart);

                            //create esri point
                            let objEsriPoint = {
                                Geometry: new esri.geometry.Point(objGetPoint.x, objGetPoint.y, objGetPoint.spatialReference)
                            };

                            intPart++;

                            arrGeometries.push(objEsriPoint);
                        });

                    } else {

                        let objEsriPoint = objEsriGeometry.getPoint(0);

                        let objPoint = {
                            Geometry: new esri.geometry.Point(objEsriPoint.x, objEsriPoint.y, objEsriPoint.spatialReference)
                        };

                        arrGeometries.push(objPoint);
                    }
                    break;
                case 'polyline':

                    let intPart = 0;

                    $.each(objGeometryJson.paths, function (intPart, objPart) {

                        let arrPoints = objEsriGeometry.paths[intPart];

                        let objPolyline = {
                            Geometry: new esri.geometry.Polyline(objEsriGeometry.spatialReference)
                        };

                        objPolyline.Geometry.paths.push(arrPoints);

                        intPart++;

                        arrGeometries.push(objPolyline);
                    });

                    break;
                case 'polygon':

                    // Loop through all the rings of the geometry ...
                    $.each(objGeometryJson.rings, function (intRing, arrRingPoints) {

                        let objPolygon = {
                            Geometry: new esri.geometry.Polygon(arrRingPoints),
                            isInterior: false
                        };

                        // Calculate the area of the ring to determine the ring orientation ...
                        let decRingArea = TrimbleMap.Geometry.Shared.CalculateRingArea(arrRingPoints);

                        // When a negative area (must be an exterior ring) ...
                        if (decRingArea > 0) {

                            // set interior to true
                            objPolygon.isInterior = true;
                        }

                        arrGeometries.push(objPolygon);
                    });

                    break;

            }

            if (!blnAddToExistingShape) {
                objCSVShapeImporter.ShapeImporter.ShapeEditor.RemoveShape(true);
            };

            objCSVShapeImporter.ShapeImporter.ShapeEditor.Shape.SpatialReferenceID = objSelectedSpatialReference.SpatialReferenceID;

            $.each(arrGeometries, function (intGeometry, objGeometry) {
                if (!objGeometry.isInterior) {

                    objCSVShapeImporter.ShapeImporter.ShapeEditor.DrawToAdd(objGeometry.Geometry, objSelectedSpatialReference.SpatialReferenceID, [], false, false);

                    objCSVShapeImporter.ShapeImporter.ShapeEditor.CoordinateSystemDropDown.val(objSelectedSpatialReference.SpatialReferenceID);

                } else {
                    //Remove from shape
                    objCSVShapeImporter.ShapeImporter.ShapeEditor.DrawToRemove(objGeometry.Geometry, objSelectedSpatialReference.SpatialReferenceID, false);
                }

                //Zoom to shape..
                objCSVShapeImporter.ShapeImporter.ShapeEditor.ZoomToShape();
            });

            objCSVShapeImporter.ShapeImporter.Options(objCSVShapeImporter.ShapeImporter.ResetImporter());

            //Detach event handlers
            objCSVShapeImporter.ShapeImporter.DetachEventHandlers();

            objCSVShapeImporter.ShapeImporter.CloseDialog();

            //reposition the dialog
            TrimbleMap.ModalDialog.Shared.RepositionDialog(objCSVShapeImporter.ShapeImporter.DialogID);

            objCSVShapeImporter.ShapeImporter.HideProcessingDiv();
        });
}

// **************************************************************************
// FUNCTION: Next
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.Next = function Next() {
    //Get the csv shape importer instance ...
    let objCSVShapeImporter = this;

    //validate CSV headings
    if (objCSVShapeImporter.ShapeImporter.Options().CurrentStep() == 1) {
        objCSVShapeImporter.Validate(objCSVShapeImporter.ShapeImporter.Options().FileuploadDataObject);
    }
    else if (objCSVShapeImporter.ShapeImporter.Options().CurrentStep() == 3){
        //Import
        objCSVShapeImporter.Import(objCSVShapeImporter.ShapeImporter.Options().FileuploadDataObject);
    }
    else {
        //increment the current step
        objCSVShapeImporter.SetCurrentStep(TrimbleMap.ShapeImporter.enumNavigation.Next);
    }
}

// **************************************************************************
// FUNCTION: Previous
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.Previous = function Previous() {
    //Get the csv shape importer instance ...
    let objCSVShapeImporter = this;

    //decrement the current step
    objCSVShapeImporter.SetCurrentStep(TrimbleMap.ShapeImporter.enumNavigation.Previous);

    $('#fileupload').fileupload(objCSVShapeImporter.ShapeImporter.FileUpLoadConfiguration());
    objCSVShapeImporter.CustomFileUpLoadPluginConfiguration();

    $("#fileupload").prop("disabled", objCSVShapeImporter.ShapeImporter.Options().CurrentStep() == 1 && objCSVShapeImporter.ShapeImporter.Options().PluginDataFiles().length >= objCSVShapeImporter.ShapeImporter.Options().LimitFileUploadFiles());
}

// **************************************************************************
// FUNCTION: CustomFileUpLoadPluginConfiguration
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.CustomFileUpLoadPluginConfiguration = function CustomFileUpLoadPluginConfiguration() {
    //Get the csv shape importer instance ...
    let objCSVShapeImporter = this;

    let blnMultipleFileSelection = false;
    objCSVShapeImporter.ShapeImporter.FileUpLoadConfiguration().formData.GeometryType = objCSVShapeImporter.ShapeImporter.ShapeEditor.Shape.GeometryType;
    objCSVShapeImporter.ShapeImporter.FileUpLoadConfiguration().formData.ImportType = TrimbleMap.ShapeImporter.enumImportType.CSV;

    objCSVShapeImporter.ShapeImporter.FileUpLoadConfiguration().acceptFileTypes(TrimbleMap.CSVShapeImporter.Shared.AcceptedFileTypesRegex);
    objCSVShapeImporter.ShapeImporter.Options().AllowedFileTypes(objCSVShapeImporter.AllowedFileTypes);
    objCSVShapeImporter.ShapeImporter.Options().LimitFileUploadFiles(1);

    objCSVShapeImporter.ShapeImporter.Options().RequiredFiles(objCSVShapeImporter.RequiredFileTypes);

    objCSVShapeImporter.ShapeImporter.Options().NumberOfSteps(2);

    // File upload plugin is changed manually in javascript because knockout does not always work. 
    // It works the first time importing but is unpredictable there after.
    $("#fileupload").attr("accept", objCSVShapeImporter.ShapeImporter.Options().AllowedFileTypes());
    $("#fileupload").prop("multiple", blnMultipleFileSelection);
    $("#fileupload").prop("disabled", (objCSVShapeImporter.ShapeImporter.Options().CurrentStep() == 1 && objCSVShapeImporter.ShapeImporter.Options().PluginDataFiles().length >= objCSVShapeImporter.ShapeImporter.Options().LimitFileUploadFiles()));
}

// **************************************************************************
// FUNCTION: SetCurrentStep
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.SetCurrentStep = function SetCurrentStep(enumNavigation) {
    //Get the csv shape importer instance ...
    let objCSVShapeImporter = this;

    if (enumNavigation == TrimbleMap.ShapeImporter.enumNavigation.Next) {
        objCSVShapeImporter.ShapeImporter.Options().CurrentStep(objCSVShapeImporter.ShapeImporter.Options().CurrentStep() + 2);
    } else {
        if (objCSVShapeImporter.ShapeImporter.Options().CurrentStep() == -1) {
            objCSVShapeImporter.ShapeImporter.Options().CurrentStep(1);
        }
        else {
            objCSVShapeImporter.ShapeImporter.Options().CurrentStep(objCSVShapeImporter.ShapeImporter.Options().CurrentStep() - 2);
        }
    }
}

// **************************************************************************
// FUNCTION: CreateImportItem
// USAGE:    
// **************************************************************************
TrimbleMap.CSVShapeImporter.Shared.CreateImportItem = function CreateImportItem() {
    // Create a new menu item object ...
    return {
        DisplayText: SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'ImportCoordinatesCSV'),
        ImportType: TrimbleMap.ShapeImporter.enumImportType.CSV,
        ImportTypeText: "CSV"
    };
}
// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ShapeFileShapeImporter = {};
TrimbleMap.ShapeFileShapeImporter.Shared = {};

TrimbleMap.ShapeFileShapeImporter.Shared.RequiredFileTypesRegex = "(\.|\/)(zip)$";
TrimbleMap.ShapeFileShapeImporter.Shared.AcceptedFileTypesRegex = "/(\.|\/)(zip)$/i";

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.CreateInstance = function CreateInstance(objShapeImporter, objTcpfConfiguration) {
    // Create the object that will hold the instance properties ...
    let objShapeFileShapeImporter = {
        ShapeImporter: objShapeImporter,
        TcpfShapeImporter: TrimbleMap.TcpfShapeImporter.CreateInstance(objTcpfConfiguration),
        TcpfUploadFileDetails: null,
        TcpfDownloadFileResults: null,
        FeaturesToImport: [],
        AllowedFileTypes: ".zip",
        RequiredFileTypes: [{
            Key: "zip",
            Value: false
        }],
        GetDisplayConfiguration: TrimbleMap.ShapeFileShapeImporter.GetDisplayConfiguration,
        Validate: TrimbleMap.ShapeFileShapeImporter.Validate,
        AddFile: TrimbleMap.ShapeFileShapeImporter.AddFile,
        Next: TrimbleMap.ShapeFileShapeImporter.Next,
        FeatureSelection: TrimbleMap.ShapeFileShapeImporter.FeatureSelection,
        Import: TrimbleMap.ShapeFileShapeImporter.Import,
        Previous: TrimbleMap.ShapeFileShapeImporter.Previous,
        CustomFileUpLoadPluginConfiguration: TrimbleMap.ShapeFileShapeImporter.CustomFileUpLoadPluginConfiguration,
        SetCurrentStep: TrimbleMap.ShapeFileShapeImporter.SetCurrentStep,
        SearchFeatureItemKeyup: TrimbleMap.ShapeFileShapeImporter.SearchFeatureItemKeyup,
        ResetFeatureSelectSearch: TrimbleMap.ShapeFileShapeImporter.ResetFeatureSelectSearch,
        SelectAllClicked: TrimbleMap.ShapeFileShapeImporter.SelectAllClicked,

        SearchFeatureItemKeyUpProxy: function (e) { objShapeFileShapeImporter.SearchFeatureItemKeyup(e); },
        ResetFeatureSelectSearchProxy: function (e) { objShapeFileShapeImporter.ResetFeatureSelectSearch(e); },
        SelectAllClickedProxy: function (e) { objShapeFileShapeImporter.SelectAllClicked(e); }
    }

    return objShapeFileShapeImporter;
}

// **************************************************************************
// FUNCTION: GetDisplayConfiguration
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.GetDisplayConfiguration = function GetDisplayConfiguration() {
    //Get the shape file shape importer instance ...
    let objShapeFileShapeImporter = this;
    let objDisplayConfiguration = objShapeFileShapeImporter.ShapeImporter.InitialiseDisplayConfiguration();

    objDisplayConfiguration.AddedFileName(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFAddedFileName'));
    objDisplayConfiguration.AddedFileSize(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFAddedFileSize'));
    objDisplayConfiguration.AddShapeOption(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFAddShapeOption'));
    objDisplayConfiguration.CancelButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFCancelButton'));
    objDisplayConfiguration.CurrentSpatialReference(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFCurrentSpatialReference'));
    objDisplayConfiguration.ImportButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFImportButton'));
    objDisplayConfiguration.InvalidFile(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFInvalidFile'));
    objDisplayConfiguration.NextButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFNextButton')); //TODO: Buttons to 
    objDisplayConfiguration.NoFiles(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFNoFiles'));
    objDisplayConfiguration.PreviousButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFPreviousButton'));
    objDisplayConfiguration.ReplaceShapeOption(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFReplaceShapeOption'));
    objDisplayConfiguration.RequiredFilesMissingTooltip(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFRequiredFilesMissingTooltip'));
    objDisplayConfiguration.SelectedAddReplaceShape(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFSelectedAddReplaceShape'));
    objDisplayConfiguration.SelectedCoordinateSystem(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFSelectedCoordinateSystem'));
    objDisplayConfiguration.SelectFeaturesInstructions(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFSelectFeaturesInstructions'));
    objDisplayConfiguration.SelectFeaturesValidator(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFSelectFeaturesValidator'));
    objDisplayConfiguration.ShowAllButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFClear'));
    objDisplayConfiguration.Step1Title(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFStep1Title'));
    objDisplayConfiguration.Step2Title(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFStep2Title'));
    objDisplayConfiguration.Step3Title(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFStep3Title'));
    objDisplayConfiguration.TemplateDownloadText(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFTemplate'));
    objDisplayConfiguration.UploadInstructions(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFUploadInstructions'));
    objDisplayConfiguration.ValidationErrorsDescription(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFValidationErrorsDescription'));
    objDisplayConfiguration.ValidationErrorsTitle(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFValidationErrorsTitle'));
    objDisplayConfiguration.FilterRecords(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFFilterRecordsLabel'));

    // UI Configuration object which is for text displayed on UI.
    return objDisplayConfiguration;
}

// **************************************************************************
// FUNCTION: Validate
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.Validate = function Validate() {
    //Get the shape file shape importer instance ...
    let objShapeFileShapeImporter = this;

    //Ensure the file is not submitted while validating...
    objShapeFileShapeImporter.ShapeImporter.FileUpLoadConfiguration().formData.ImportOption = TrimbleMap.ShapeImporter.enumImportOptions.Validate;
    objShapeFileShapeImporter.ShapeImporter.ShowProcessingDiv();

    let objDeferred = new dojo.Deferred();
    let objError = { ErrorMessages: [] };

    objShapeFileShapeImporter.TcpfShapeImporter.PrepareFileUpload().then(TrimbleMap.Controller.Shared.TrapException(function (objResponseData) {

        objShapeFileShapeImporter.TcpfUploadFileDetails = objResponseData;

        objShapeFileShapeImporter.TcpfShapeImporter.UploadFileToDataOcean(objResponseData.FileUploadUrl, objShapeFileShapeImporter.ShapeImporter.Options().FileuploadDataObject.files[0]).then(TrimbleMap.Controller.Shared.TrapException(function () {

            function fnGetFileMetadataFromDataOceanFunction(){return objShapeFileShapeImporter.TcpfShapeImporter.GetFileMetadataFromDataOcean(objResponseData.FilePath)};

            objShapeFileShapeImporter.TcpfShapeImporter.Poll(
                fnGetFileMetadataFromDataOceanFunction,
                function (result) { return (result.file.download != undefined) ? true : false }
            ).then(TrimbleMap.Controller.Shared.TrapException(function () {

                objShapeFileShapeImporter.TcpfShapeImporter.ExecuteTcpfProcedure(objResponseData.FilePath, objResponseData.FileUploadPath, TrimbleMap.TcpfShapeImporter.enumContent.ALL).then(TrimbleMap.Controller.Shared.TrapException(function (objExecutionData) {

                    function fnGetProcedureResultFunction(){return objShapeFileShapeImporter.TcpfShapeImporter.GetTcpfProcedureResult(objExecutionData.execution.id)};

                    objShapeFileShapeImporter.TcpfShapeImporter.Poll(
                        fnGetProcedureResultFunction,
                        function (result) { return (result.execution.execution_status == TrimbleMap.TcpfShapeImporter.enumExecutionStatus.FINISHED) ? true : false }
                    ).then(TrimbleMap.Controller.Shared.TrapException(function (objExecutionData) {

                        objShapeFileShapeImporter.TcpfShapeImporter.GetFileMetadataFromDataOcean(objResponseData.FileUploadPath + '/' + TrimbleMap.TcpfShapeImporter.enumStandardFileName.RESULTS).then(TrimbleMap.Controller.Shared.TrapException(function (objResultsResponseData) {

                            objShapeFileShapeImporter.TcpfShapeImporter.DownloadFileFromDataOcean(objResultsResponseData.file.id).then(TrimbleMap.Controller.Shared.TrapException(function (objData) {

                                objShapeFileShapeImporter.TcpfDownloadFileResults = objData;

                                let arrFeatures = JSON.parse(objData).features;

                                let strHtml = "";
                                strHtml += "<table id ='tbl_select_features' class='table table-hover table-striped'> \n";
                                strHtml += "<thead> \n";
                                strHtml += "<tr> \n";
                                strHtml += "<th><a id='btnSelectAllFeatures' href='javascript: void (0)' style='text-decoration: none'>" + SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'All') + "</a></th>";
                                Object.keys(arrFeatures[0].properties).forEach(function (columnHeader) {
                                    if (columnHeader.trim() !== 'Shape') {
                                        strHtml += "<th>" + columnHeader + "</th> \n";
                                    }
                                });
                                strHtml += "</tr> \n";
                                strHtml += "</thead> \n";

                                strHtml += "<tbody> \n";
                                arrFeatures.forEach(function (objFeature) {
                                    delete objFeature.properties.Shape;

                                    strHtml += "<tr class='trSelectFeature'> \n";
                                    strHtml += "<td><input class='chkSelectFeature' type='checkbox' fid ='" + objFeature.properties.FID + "' /></td> \n";
                                    Object.keys(objFeature.properties).map(function (key) {
                                        return objFeature.properties[key];
                                    }).forEach(function (columnValue) {
                                        strHtml += "<td>" + columnValue + "</td> \n";
                                    });
                                    strHtml += "</tr> \n";
                                });
                                strHtml += "</tbody> \n";

                                objShapeFileShapeImporter.ShapeImporter.Options().FeatureTableDetails(strHtml);
                                objShapeFileShapeImporter.ShapeImporter.Options().Features(arrFeatures);
                                objShapeFileShapeImporter.SetCurrentStep(parseInt(TrimbleMap.ShapeImporter.enumNavigation.Next));

                                //Remove spinner processing div
                                objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

                                objDeferred.resolve();

                            }), TrimbleMap.Controller.Shared.TrapException(function () {

                                // Unable to download file from server
                                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfResultsDownloadFailed');

                                objError.ErrorMessages.push(strEndUserMessage);

                                objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                                //Show Validation error steps
                                objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-1);

                                //Remove spinner processing div
                                objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

                                //Reject the deffered
                                objDeferred.reject();

                            }));

                            //Attempt to get the wkt
                            objShapeFileShapeImporter.TcpfShapeImporter.GetFileMetadataFromDataOcean(objResponseData.FileUploadPath + '/' + TrimbleMap.TcpfShapeImporter.enumStandardFileName.WKT).then(TrimbleMap.Controller.Shared.TrapException(function (wktResponseData) {

                                objShapeFileShapeImporter.TcpfShapeImporter.DownloadFileFromDataOcean(wktResponseData.file.id).then(TrimbleMap.Controller.Shared.TrapException(function (objWktData) {

                                    let intWKID = parseInt(objWktData.substring(objWktData.lastIndexOf("EPSG") + 7, objWktData.lastIndexOf("EPSG") + 11));

                                    //Find spatial reference using the WKID
                                    let filteredSpatialReference = objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferences().filter(function (objElement) {
                                        return objElement.WKID === intWKID;
                                    });

                                    //alternatively try to find the spatial reference using the WKT definition
                                    if (filteredSpatialReference.length == 0) {
                                        filteredSpatialReference = objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferences().filter(function (objElement) {
                                            return objElement.WKTDefinition === objWktData;
                                        });
                                    }

                                    //Set the spatial reference
                                    if (filteredSpatialReference && filteredSpatialReference.length > 0) {

                                        objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferenceID(filteredSpatialReference[0].SpatialReferenceID);
                                        objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferenceName(filteredSpatialReference[0].Name);
                                        objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferences(objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferences().filter(function (objElement) {
                                            return objElement.SpatialReferenceType === filteredSpatialReference[0].SpatialReferenceType;
                                        }));
                                    }

                                }), TrimbleMap.Controller.Shared.TrapException(function () {

                                    // Unable to download file from server
                                    let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfWKTDownloadFailed');

                                    objError.ErrorMessages.push(strEndUserMessage);

                                    objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                                    //Show Validation error steps
                                    objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-1);

                                    //Remove spinner processing div
                                    objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

                                    //Reject the deffered
                                    objDeferred.reject();

                                }));

                            }), TrimbleMap.Controller.Shared.TrapException(function () {

                                // Unable to download file from server
                                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfGetFileMetaDataFailed');

                                objError.ErrorMessages.push(strEndUserMessage);

                                objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                                //Show Validation error steps
                                objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-1);

                                //Remove spinner processing div
                                objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

                                objDeferred.reject(objError);

                            }));

                        }), TrimbleMap.Controller.Shared.TrapException(function () {

                            // Unable to get File Metadata
                            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfGetFileMetaDataFailed');

                            objError.ErrorMessages.push(strMessage);

                            objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                            //Remove spinner processing div
                            objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

                            //Show Validation error steps
                            objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-1);

                        }));


                    }), TrimbleMap.Controller.Shared.TrapException(function () {

                        // Unable to get procedure result
                        let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfProcedureResultFailure');

                        objError.ErrorMessages.push(strEndUserMessage);

                        objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                        //Show Validation error steps
                        objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-1);

                        //Remove spinner processing div
                        objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

                        //Reject the deffered
                        objDeferred.reject();

                    }));

                }), TrimbleMap.Controller.Shared.TrapException(function () {

                    // Unable to execute procedure
                    let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfExecuteProcedureFailure');

                    objError.ErrorMessages.push(strEndUserMessage);

                    objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                    //Show Validation error steps
                    objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-1);

                    //Remove spinner processing div
                    objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

                    //Reject the deffered
                    objDeferred.reject();

                }));


            }), TrimbleMap.Controller.Shared.TrapException(function () {

                // Unable to execute procedure
                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfGetFileMetaDataFailed');

                objError.ErrorMessages.push(strEndUserMessage);

                objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                //Show Validation error steps
                objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-1);

                //Remove spinner processing div
                objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

                //Reject the deffered
                objDeferred.reject();

            }));

        }), TrimbleMap.Controller.Shared.TrapException(function () {

            // Unable to execute procedure
            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfUploadFileFailure');

            objError.ErrorMessages.push(strEndUserMessage);

            objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

            //Show Validation error steps
            objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-1);

            //Remove spinner processing div
            objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

            //Reject the deffered
            objDeferred.reject();

        }));


    }), TrimbleMap.Controller.Shared.TrapException(function () {

        // Unable to execute procedure
        let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfPrepareFileUploadFailure');

        objError.ErrorMessages.push(strEndUserMessage);

        objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

        //Show Validation error steps
        objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-1);

        //Remove spinner processing div
        objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

        //Reject the deffered
        objDeferred.reject();

    }));

    TrimbleMap.ModalDialog.Shared.RepositionDialog(objShapeFileShapeImporter.ShapeImporter.DialogID);

}

// **************************************************************************
// FUNCTION: AddFile
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.AddFile = function AddFile(objFile) {
    //Get the shape file shape importer instance ...
    let objShapeFileShapeImporter = this;

    let objPattern = new RegExp(TrimbleMap.ShapeFileShapeImporter.Shared.RequiredFileTypesRegex, "i");
    let blnAddFile = true;
    let blnInvalidFileFound = false;

    if (!objPattern.test(objFile.name)) {
        blnAddFile = false;
        blnInvalidFileFound = true;
    } else {
        objShapeFileShapeImporter.ShapeImporter.Options().RequiredFiles().find(function (objKeyValuePair) {
            return objKeyValuePair.Key == "zip";
        }).Value = true;
    }

    if (blnAddFile && !blnInvalidFileFound) {
        objShapeFileShapeImporter.TcpfShapeImporter.CreateTcpfDirectory(objFile.name);
    }

    return {
        AddFile: blnAddFile,
        InvalidFileFound: blnInvalidFileFound
    };
}

// **************************************************************************
// FUNCTION: Next
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.Next = function Next() {
    //Get the shape file shape importer instance ...
    let objShapeFileShapeImporter = this;

    if (objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() === 1) {

        objShapeFileShapeImporter.Validate(objShapeFileShapeImporter.ShapeImporter.Options().FileuploadDataObject);
    }
    else if (objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() === 2) {

        objShapeFileShapeImporter.FeatureSelection();

    }
    else if (objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() === 3) {

        objShapeFileShapeImporter.Import();

    }
}

// **************************************************************************
// FUNCTION: FeatureSelection
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.FeatureSelection = function FeatureSelection() {
    //Get the shape file shape importer instance ...
    let objShapeFileShapeImporter = this;
    let arrSelectedFeatures = [];

    let fids = new Array();
    let codes = new Array();

    $("#spn_select_features_validator").css("display", "none");

    $('.chkSelectFeature').each(function () {

        if ($(this).prop('checked'))
            fids.push($(this).attr('fid'));
        codes.push($('.trSelectFeature > td:nth-child(2)')[($(this).attr('fid'))].innerText);
    });

    if (fids.length === 0) {
        $("#spn_select_features_validator").css("display", "block");
        return;
    }

    objShapeFileShapeImporter.ShapeImporter.Options().SelectedFeatures(fids);
    objShapeFileShapeImporter.ShapeImporter.ShowProcessingDiv();

    let arrFeatures = JSON.parse(objShapeFileShapeImporter.TcpfDownloadFileResults).features;

    $.each(fids, function (intFid, Fid) {

        let objFilteredFeature = arrFeatures.filter(function (objFeature) {
            return objFeature.properties.FID === parseInt(Fid);
        });

        arrSelectedFeatures.push(objFilteredFeature[0]);
    })

    let strWKT = objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferences().filter(function (objElement) {
        return objElement.SpatialReferenceID === objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferenceID();
    });

    $.each(arrSelectedFeatures, function (intSelectedFeature, objSelectedFeature) {

        //convert to esri geometry type
        let strEsriGeometryType = objShapeFileShapeImporter.ShapeImporter.ShapeEditor.MapController.ConvertOgcGeometryTypeToEsriGeometryType(objSelectedFeature.geometry.type.toUpperCase());
        let strGeometryType = TrimbleMap.Shape.Shared.EsriGeometrTypeToGeometryType(strEsriGeometryType);

        if (objShapeFileShapeImporter.ShapeImporter.ShapeEditor.Shape.GeometryType == strGeometryType) {

            objShapeFileShapeImporter.FeaturesToImport.push(TrimbleMap.Shape.Shared.ConvertPartsToEsriGeometry(objSelectedFeature.geometry.coordinates, strGeometryType, objSelectedFeature.geometry.type.toUpperCase(), strWKT));

        } else {

            // Geometry type does not match
            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'GeometryTypeMismatch', objShapeFileShapeImporter.ShapeImporter.ShapeEditor.Shape.GeometryType.toLowerCase());

            objShapeFileShapeImporter.ShapeImporter.Options().ValidationMessages([strEndUserMessage]);

            //Show Validation error steps
            objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(-2);

            //Remove spinner processing div
            objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();
        };
    })

    if (objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferenceID() && objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferenceID() != SD.Guid.Shared.Empty()) {
        let objPrePropulateSpatialReference = objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferences().find(function (objSpatialReference) {
            return objSpatialReference.SpatialReferenceID === objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferenceID();
        });

        if (objPrePropulateSpatialReference) {
            objShapeFileShapeImporter.ShapeImporter.Options().SelectedSpatialReference(objPrePropulateSpatialReference);
        }
        else {
            objShapeFileShapeImporter.ShapeImporter.Options().SpatialReferences().splice(0, 0, { SpatialReferenceID: SD.Guid.Shared.Empty(), Name: '' });
        }
    }

    objShapeFileShapeImporter.SetCurrentStep(TrimbleMap.ShapeImporter.enumNavigation.Next);
    objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();
}

// **************************************************************************
// FUNCTION: Import
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.Import = function Import() {
    //Get the shape file shape importer instance ...
    let objShapeFileShapeImporter = this;

    var selectedSpatialReference = objShapeFileShapeImporter.ShapeImporter.Options().SelectedSpatialReference();
    var blnAddToExistingShape = objShapeFileShapeImporter.ShapeImporter.Options().AddToExistingShape();

    if (!blnAddToExistingShape) {
        objShapeFileShapeImporter.ShapeImporter.ShapeEditor.RemoveShape(true);
    };

    objShapeFileShapeImporter.ShapeImporter.ShapeEditor.Shape.SpatialReferenceID = selectedSpatialReference.SpatialReferenceID;

    $.each(objShapeFileShapeImporter.FeaturesToImport, function (intFeature, arrGeometry) {
        $.each(arrGeometry, function (intGeometry, objGeometry) {

            if (!objGeometry.isInterior) {

                objShapeFileShapeImporter.ShapeImporter.ShapeEditor.DrawToAdd(objGeometry.Geometry, selectedSpatialReference.SpatialReferenceID, [], false, false);

                objShapeFileShapeImporter.ShapeImporter.ShapeEditor.CoordinateSystemDropDown.val(selectedSpatialReference.SpatialReferenceID);

            } else {
                //Remove from shape
                objShapeFileShapeImporter.ShapeImporter.ShapeEditor.DrawToRemove(objGeometry.Geometry, selectedSpatialReference.SpatialReferenceID, false);
            }
        });

        //Zoom to shape..
        objShapeFileShapeImporter.ShapeImporter.ShapeEditor.ZoomToShape();
    });

    objShapeFileShapeImporter.ShapeImporter.Options(objShapeFileShapeImporter.ShapeImporter.ResetImporter());

    //Detach event handlers
    objShapeFileShapeImporter.ShapeImporter.DetachEventHandlers();

    objShapeFileShapeImporter.ShapeImporter.CloseDialog();

    //reposition the dialog
    TrimbleMap.ModalDialog.Shared.RepositionDialog(objShapeFileShapeImporter.ShapeImporter.DialogID);

    objShapeFileShapeImporter.ShapeImporter.HideProcessingDiv();

}

// **************************************************************************
// FUNCTION: Previous
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.Previous = function Previous() {
    //Get the shape file shape importer instance ...
    let objShapeFileShapeImporter = this;

    //decrement the current step
    objShapeFileShapeImporter.SetCurrentStep(TrimbleMap.ShapeImporter.enumNavigation.Previous);

    $('#fileupload').fileupload(objShapeFileShapeImporter.ShapeImporter.FileUpLoadConfiguration());
    objShapeFileShapeImporter.CustomFileUpLoadPluginConfiguration();

    $("#fileupload").prop("disabled", objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() == 1 && objShapeFileShapeImporter.ShapeImporter.Options().PluginDataFiles().length >= objShapeFileShapeImporter.ShapeImporter.Options().LimitFileUploadFiles());
}

// **************************************************************************
// FUNCTION: CustomFileUpLoadPluginConfiguration
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.CustomFileUpLoadPluginConfiguration = function CustomFileUpLoadPluginConfiguration() {
    //Get the shape file shape importer instance ...
    let objShapeFileShapeImporter = this;

    let blnMultipleFileSelection = false;
    objShapeFileShapeImporter.ShapeImporter.FileUpLoadConfiguration().formData.GeometryType = objShapeFileShapeImporter.ShapeImporter.ShapeEditor.Shape.GeometryType;
    objShapeFileShapeImporter.ShapeImporter.FileUpLoadConfiguration().formData.ImportType = TrimbleMap.ShapeImporter.enumImportType.ShapeFile;

    objShapeFileShapeImporter.ShapeImporter.FileUpLoadConfiguration().acceptFileTypes(TrimbleMap.ShapeFileShapeImporter.Shared.AcceptedFileTypesRegex);//objShapeFileShapeImporter.ShapeImporter.FileUpLoadConfiguration().acceptFileTypes("/(\.|\/)(dbf|prj|shp|shx)$/i");
    objShapeFileShapeImporter.ShapeImporter.Options().AllowedFileTypes(objShapeFileShapeImporter.AllowedFileTypes);//objShapeFileShapeImporter.ShapeImporter.Options().AllowedFileTypes(".dbf,.prj,.shp,.shx");
    objShapeFileShapeImporter.ShapeImporter.Options().LimitFileUploadFiles(1);

    objShapeFileShapeImporter.ShapeImporter.Options().RequiredFiles(objShapeFileShapeImporter.RequiredFileTypes);

    objShapeFileShapeImporter.ShapeImporter.Options().NumberOfSteps(3);

    // File upload plugin is changed manually in javascript because knockout does not always work. 
    // It works the first time importing but is unpredictable there after.
    $("#fileupload").attr("accept", objShapeFileShapeImporter.ShapeImporter.Options().AllowedFileTypes());
    $("#fileupload").prop("multiple", blnMultipleFileSelection);
    $("#fileupload").prop("disabled", (objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() == 1 && objShapeFileShapeImporter.ShapeImporter.Options().PluginDataFiles().length >= objShapeFileShapeImporter.ShapeImporter.Options().LimitFileUploadFiles()));
}

// **************************************************************************
// FUNCTION: SetCurrentStep
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.SetCurrentStep = function SetCurrentStep(enumNavigation) {
    //Get the shape file shape importer instance ...
    let objShapeFileShapeImporter = this;

    let AttachShapeFileStep2Events = function () {
        $('#txtSearchFeatureNames').on('keyup', objShapeFileShapeImporter.SearchFeatureItemKeyUpProxy);
        $('#btnResetFeatureSelectSearch').on('click', objShapeFileShapeImporter.ResetFeatureSelectSearchProxy);
        $('#btnSelectAllFeatures').on('click', objShapeFileShapeImporter.SelectAllClickedProxy);
    };

    if (enumNavigation === TrimbleMap.ShapeImporter.enumNavigation.Next) {
        objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() + 1)

        if (objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() === 2) {
            AttachShapeFileStep2Events();
        }
    }
    else if (enumNavigation === TrimbleMap.ShapeImporter.enumNavigation.Previous) {
        if (objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() === -1) {
            objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(1);
        }
        else {
            objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() - 1);
            if (objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() === 2) {
                AttachShapeFileStep2Events();
                $("#spn_select_features_validator").css("display", "none");
            }
        }
    }
    else {
        if (objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() === -1) {
            objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(1);
        }
        else {
            objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep(objShapeFileShapeImporter.ShapeImporter.Options().CurrentStep() - 1);
        }
    }
}

// **************************************************************************
// FUNCTION: SearchFeatureItemKeyup
// USAGE:
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.SearchFeatureItemKeyup = function SearchFeatureItemKeyup(e) {
    let strSearchText = ($('#txtSearchFeatureNames').val()).toLowerCase();

    //Search text is empty string: show all
    if (!strSearchText) {
        $(".trSelectFeature").css("display", "table-row")
        return;
    }

    $(".trSelectFeature").each(function () {
        let strRecordText = $(this).html().toLowerCase();

        if (strRecordText.indexOf(strSearchText) === -1) {
            $(this).css("display", "none");
        }
        else {
            $(this).css("display", "table-row");
        }

    });
};

// **************************************************************************
// FUNCTION: ResetFeatureSelectSearch
// USAGE:
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.ResetFeatureSelectSearch = function ResetFeatureSelectSearch(e) {
    $("#txtSearchFeatureNames").val('');
    $("#txtSearchFeatureNames").keyup();
};

// **************************************************************************
// FUNCTION: SelectAllClicked
// USAGE:
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.SelectAllClicked = function SelectAllClicked(e) {
    let blnAllChecked = true;

    $('.chkSelectFeature').each(function () {
        if (!$(this).prop('checked')) {
            blnAllChecked = false;
            return false;
        }
    });

    $('.chkSelectFeature').each(function () {
        $(this).prop('checked', !blnAllChecked);
    });
};

// **************************************************************************
// FUNCTION: CreateImportItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeFileShapeImporter.Shared.CreateImportItem = function CreateImportItem() {
    // Create a new menu item object ...
    return {
        DisplayText: SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'ImportCoordinatesShapeFile'),
        ImportType: TrimbleMap.ShapeImporter.enumImportType.ShapeFile,
        ImportTypeText: "Shapefile"
    };
}

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.MapInfoImporter = {};
TrimbleMap.MapInfoImporter.Shared = {};

TrimbleMap.MapInfoImporter.Shared.RequiredFileTypesRegex = "(\.|\/)(zip)$";
TrimbleMap.MapInfoImporter.Shared.AcceptedFileTypesRegex = "/(\.|\/)(zip)$/i";

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.CreateInstance = function CreateInstance(objShapeImporter, objTcpfConfiguration) {
    // Create the object that will hold the instance properties ...
    let objMapInfoImporter = {
        ShapeImporter: objShapeImporter,
        TcpfShapeImporter: TrimbleMap.TcpfShapeImporter.CreateInstance(objTcpfConfiguration),
        TcpfUploadFileDetails: null,
        TcpfDownloadFileResults: null,
        FeaturesToImport: [],
        AllowedFileTypes: ".zip",
        RequiredFileTypes: [{
            Key: "zip",
            Value: false
        }],
        GetDisplayConfiguration: TrimbleMap.MapInfoImporter.GetDisplayConfiguration,
        Validate: TrimbleMap.MapInfoImporter.Validate,
        AddFile: TrimbleMap.MapInfoImporter.AddFile,
        Next: TrimbleMap.MapInfoImporter.Next,
        FeatureSelection: TrimbleMap.MapInfoImporter.FeatureSelection,
        Import: TrimbleMap.MapInfoImporter.Import,
        Previous: TrimbleMap.MapInfoImporter.Previous,
        CustomFileUpLoadPluginConfiguration: TrimbleMap.MapInfoImporter.CustomFileUpLoadPluginConfiguration,
        SetCurrentStep: TrimbleMap.MapInfoImporter.SetCurrentStep,
        SearchFeatureItemKeyup: TrimbleMap.MapInfoImporter.SearchFeatureItemKeyup,
        ResetFeatureSelectSearch: TrimbleMap.MapInfoImporter.ResetFeatureSelectSearch,
        SelectAllClicked: TrimbleMap.MapInfoImporter.SelectAllClicked,

        SearchFeatureItemKeyUpProxy: function (e) { objMapInfoImporter.SearchFeatureItemKeyup(e); },
        ResetFeatureSelectSearchProxy: function (e) { objMapInfoImporter.ResetFeatureSelectSearch(e); },
        SelectAllClickedProxy: function (e) { objMapInfoImporter.SelectAllClicked(e); }
    }

    return objMapInfoImporter;
}

// **************************************************************************
// FUNCTION: GetDisplayConfiguration
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.GetDisplayConfiguration = function GetDisplayConfiguration() {
    //Get the map info shape importer instance ...
    let objMapInfoImporter = this;
    let objDisplayConfiguration = objMapInfoImporter.ShapeImporter.InitialiseDisplayConfiguration();

    objDisplayConfiguration.AddedFileName(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFAddedFileName'));
    objDisplayConfiguration.AddedFileSize(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFAddedFileSize'));
    objDisplayConfiguration.AddShapeOption(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFAddShapeOption'));
    objDisplayConfiguration.CancelButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFCancelButton'));
    objDisplayConfiguration.CurrentSpatialReference(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFCurrentSpatialReference'));
    objDisplayConfiguration.ImportButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFImportButton'));
    objDisplayConfiguration.InvalidFile(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFInvalidFile'));
    objDisplayConfiguration.NextButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFNextButton'));
    objDisplayConfiguration.NoFiles(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFNoFiles'));
    objDisplayConfiguration.PreviousButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFPreviousButton'));
    objDisplayConfiguration.ReplaceShapeOption(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFReplaceShapeOption'));
    objDisplayConfiguration.RequiredFilesMissingTooltip(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFRequiredFilesMissingTooltip'));
    objDisplayConfiguration.SelectedAddReplaceShape(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFSelectedAddReplaceShape'));
    objDisplayConfiguration.SelectedCoordinateSystem(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFSelectedCoordinateSystem'));
    objDisplayConfiguration.SelectFeaturesInstructions(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFSelectFeaturesInstructions'));
    objDisplayConfiguration.SelectFeaturesValidator(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFSelectFeaturesValidator'));
    objDisplayConfiguration.ShowAllButton(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFClear'));
    objDisplayConfiguration.Step1Title(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'MIStep1Title'));
    objDisplayConfiguration.Step2Title(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFStep2Title'));
    objDisplayConfiguration.Step3Title(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFStep3Title'));
    objDisplayConfiguration.TemplateDownloadText(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFTemplate'));
    objDisplayConfiguration.UploadInstructions(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'MIUploadInstructions'));
    objDisplayConfiguration.ValidationErrorsDescription(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFValidationErrorsDescription'));
    objDisplayConfiguration.ValidationErrorsTitle(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFValidationErrorsTitle'));
    objDisplayConfiguration.FilterRecords(SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'SFFilterRecordsLabel'));

    // UI Configuration object which is for text displayed on UI.
    return objDisplayConfiguration;
}

// **************************************************************************
// FUNCTION: Validate
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.Validate = function Validate() {
    //Get the map info shape importer instance ...
    let objMapInfoImporter = this;

    //Ensure the file is not submitted while validating...
    objMapInfoImporter.ShapeImporter.FileUpLoadConfiguration().formData.ImportOption = TrimbleMap.ShapeImporter.enumImportOptions.Validate;
    objMapInfoImporter.ShapeImporter.ShowProcessingDiv();

    let objDeferred = new dojo.Deferred();
    let objError = { ErrorMessages: [] };

    objMapInfoImporter.TcpfShapeImporter.PrepareFileUpload().then(TrimbleMap.Controller.Shared.TrapException(function (objResponseData) {

        objMapInfoImporter.TcpfUploadFileDetails = objResponseData;

        objMapInfoImporter.TcpfShapeImporter.UploadFileToDataOcean(objResponseData.FileUploadUrl, objMapInfoImporter.ShapeImporter.Options().FileuploadDataObject.files[0]).then(TrimbleMap.Controller.Shared.TrapException(function () {

            function fnGetFileMetadataFromDataOceanFunction(){return objMapInfoImporter.TcpfShapeImporter.GetFileMetadataFromDataOcean(objResponseData.FilePath)};

            objMapInfoImporter.TcpfShapeImporter.Poll(
                fnGetFileMetadataFromDataOceanFunction,
                function (result) { return (result.file.download != undefined) ? true : false }
            ).then(TrimbleMap.Controller.Shared.TrapException(function () {

                objMapInfoImporter.TcpfShapeImporter.ExecuteTcpfProcedure(objResponseData.FilePath, objResponseData.FileUploadPath, TrimbleMap.TcpfShapeImporter.enumContent.ALL).then(TrimbleMap.Controller.Shared.TrapException(function (objExecutionData) {

                    function fnGetProcedureResultFunction(){return objMapInfoImporter.TcpfShapeImporter.GetTcpfProcedureResult(objExecutionData.execution.id)};

                    objMapInfoImporter.TcpfShapeImporter.Poll(
                        fnGetProcedureResultFunction,
                        function (result) { return (result.execution.execution_status == TrimbleMap.TcpfShapeImporter.enumExecutionStatus.FINISHED) ? true : false }
                    ).then(TrimbleMap.Controller.Shared.TrapException(function (objExecutionData) {

                        objMapInfoImporter.TcpfShapeImporter.GetFileMetadataFromDataOcean(objResponseData.FileUploadPath + '/' + TrimbleMap.TcpfShapeImporter.enumStandardFileName.RESULTS).then(TrimbleMap.Controller.Shared.TrapException(function (objResultsResponseData) {

                            objMapInfoImporter.TcpfShapeImporter.DownloadFileFromDataOcean(objResultsResponseData.file.id).then(TrimbleMap.Controller.Shared.TrapException(function (objData) {

                                objMapInfoImporter.TcpfDownloadFileResults = objData;

                                let arrFeatures = JSON.parse(objData).features;

                                let strHtml = "";
                                strHtml += "<table id ='tbl_select_features' class='table table-hover table-striped'> \n";
                                strHtml += "<thead> \n";
                                strHtml += "<tr> \n";
                                strHtml += "<th><a id='btnSelectAllFeatures' href='javascript: void (0)' style='text-decoration: none'>" + SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'All') + "</a></th>";
                                Object.keys(arrFeatures[0].properties).forEach(function (columnHeader) {
                                    if (columnHeader.trim() !== 'Shape') {
                                        strHtml += "<th>" + columnHeader + "</th> \n";
                                    }
                                });
                                strHtml += "</tr> \n";
                                strHtml += "</thead> \n";

                                strHtml += "<tbody> \n";
                                arrFeatures.forEach(function (objFeature) {
                                    delete objFeature.properties.Shape;

                                    strHtml += "<tr class='trSelectFeature'> \n";
                                    strHtml += "<td><input class='chkSelectFeature' type='checkbox' fid ='" + objFeature.properties.FID + "' /></td> \n";
                                    Object.keys(objFeature.properties).map(function (key) {
                                        return objFeature.properties[key];
                                    }).forEach(function (columnValue) {
                                        strHtml += "<td>" + columnValue + "</td> \n";
                                    });
                                    strHtml += "</tr> \n";
                                });
                                strHtml += "</tbody> \n";

                                objMapInfoImporter.ShapeImporter.Options().FeatureTableDetails(strHtml);
                                objMapInfoImporter.ShapeImporter.Options().Features(arrFeatures);
                                objMapInfoImporter.SetCurrentStep(parseInt(TrimbleMap.ShapeImporter.enumNavigation.Next));

                                //Remove spinner processing div
                                objMapInfoImporter.ShapeImporter.HideProcessingDiv();

                                objDeferred.resolve();

                            }), TrimbleMap.Controller.Shared.TrapException(function () {

                                // Unable to download file from server
                                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfResultsDownloadFailed');

                                objError.ErrorMessages.push(strEndUserMessage);

                                objMapInfoImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                                //Show Validation error steps
                                objMapInfoImporter.ShapeImporter.Options().CurrentStep(-1);

                                //Remove spinner processing div
                                objMapInfoImporter.ShapeImporter.HideProcessingDiv();

                                //Reject the deffered
                                objDeferred.reject();

                            }));

                            //Attempt to get the wkt
                            objMapInfoImporter.TcpfShapeImporter.GetFileMetadataFromDataOcean(objResponseData.FileUploadPath + '/' + TrimbleMap.TcpfShapeImporter.enumStandardFileName.WKT).then(TrimbleMap.Controller.Shared.TrapException(function (wktResponseData) {

                                objMapInfoImporter.TcpfShapeImporter.DownloadFileFromDataOcean(wktResponseData.file.id).then(TrimbleMap.Controller.Shared.TrapException(function (objWktData) {

                                    let intWKID = parseInt(objWktData.substring(objWktData.lastIndexOf("EPSG") + 7, objWktData.lastIndexOf("EPSG") + 11));

                                    //Find spatial reference using the WKID
                                    let filteredSpatialReference = objMapInfoImporter.ShapeImporter.Options().SpatialReferences().filter(function (objElement) {
                                        return objElement.WKID === intWKID;
                                    });

                                    //alternatively try to find the spatial reference using the WKT definition
                                    if (filteredSpatialReference.length == 0) {
                                        filteredSpatialReference = objMapInfoImporter.ShapeImporter.Options().SpatialReferences().filter(function (objElement) {
                                            return objElement.WKTDefinition === objWktData;
                                        });
                                    }

                                    //Set the spatial reference
                                    if (filteredSpatialReference && filteredSpatialReference.length > 0) {

                                        objMapInfoImporter.ShapeImporter.Options().SpatialReferenceID(filteredSpatialReference[0].SpatialReferenceID);
                                        objMapInfoImporter.ShapeImporter.Options().SpatialReferenceName(filteredSpatialReference[0].Name);
                                        objMapInfoImporter.ShapeImporter.Options().SpatialReferences(objMapInfoImporter.ShapeImporter.Options().SpatialReferences().filter(function (objElement) {
                                            return objElement.SpatialReferenceType === filteredSpatialReference[0].SpatialReferenceType;
                                        }));
                                    }

                                }), TrimbleMap.Controller.Shared.TrapException(function () {

                                    // Unable to download file from server
                                    let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfWKTDownloadFailed');

                                    objError.ErrorMessages.push(strEndUserMessage);

                                    objMapInfoImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                                    //Show Validation error steps
                                    objMapInfoImporter.ShapeImporter.Options().CurrentStep(-1);

                                    //Remove spinner processing div
                                    objMapInfoImporter.ShapeImporter.HideProcessingDiv();

                                    //Reject the deffered
                                    objDeferred.reject();

                                }));

                            }), TrimbleMap.Controller.Shared.TrapException(function () {

                                // Unable to download file from server
                                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfGetFileMetaDataFailed');

                                objError.ErrorMessages.push(strEndUserMessage);

                                objMapInfoImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                                //Show Validation error steps
                                objMapInfoImporter.ShapeImporter.Options().CurrentStep(-1);

                                //Remove spinner processing div
                                objMapInfoImporter.ShapeImporter.HideProcessingDiv();

                                objDeferred.reject(objError);

                            }));

                        }), TrimbleMap.Controller.Shared.TrapException(function () {

                            // Unable to get File Metadata
                            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfGetFileMetaDataFailed');

                            objError.ErrorMessages.push(strMessage);

                            objMapInfoImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                            //Remove spinner processing div
                            objMapInfoImporter.ShapeImporter.HideProcessingDiv();

                            //Show Validation error steps
                            objMapInfoImporter.ShapeImporter.Options().CurrentStep(-1);

                        }));


                    }), TrimbleMap.Controller.Shared.TrapException(function () {

                        // Unable to get procedure result
                        let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfProcedureResultFailure');

                        objError.ErrorMessages.push(strEndUserMessage);

                        objMapInfoImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                        //Show Validation error steps
                        objMapInfoImporter.ShapeImporter.Options().CurrentStep(-1);

                        //Remove spinner processing div
                        objMapInfoImporter.ShapeImporter.HideProcessingDiv();

                        //Reject the deffered
                        objDeferred.reject();

                    }));

                }), TrimbleMap.Controller.Shared.TrapException(function () {

                    // Unable to execute procedure
                    let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfExecuteProcedureFailure');

                    objError.ErrorMessages.push(strEndUserMessage);

                    objMapInfoImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                    //Show Validation error steps
                    objMapInfoImporter.ShapeImporter.Options().CurrentStep(-1);

                    //Remove spinner processing div
                    objMapInfoImporter.ShapeImporter.HideProcessingDiv();

                    //Reject the deffered
                    objDeferred.reject();

                }));


            }), TrimbleMap.Controller.Shared.TrapException(function () {

                // Unable to execute procedure
                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfGetFileMetaDataFailed');

                objError.ErrorMessages.push(strEndUserMessage);

                objMapInfoImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

                //Show Validation error steps
                objMapInfoImporter.ShapeImporter.Options().CurrentStep(-1);

                //Remove spinner processing div
                objMapInfoImporter.ShapeImporter.HideProcessingDiv();

                //Reject the deffered
                objDeferred.reject();

            }));

        }), TrimbleMap.Controller.Shared.TrapException(function () {

            // Unable to execute procedure
            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfUploadFileFailure');

            objError.ErrorMessages.push(strEndUserMessage);

            objMapInfoImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

            //Show Validation error steps
            objMapInfoImporter.ShapeImporter.Options().CurrentStep(-1);

            //Remove spinner processing div
            objMapInfoImporter.ShapeImporter.HideProcessingDiv();

            //Reject the deffered
            objDeferred.reject();

        }));


    }), TrimbleMap.Controller.Shared.TrapException(function () {

        // Unable to execute procedure
        let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'TcpfPrepareFileUploadFailure');

        objError.ErrorMessages.push(strEndUserMessage);

        objMapInfoImporter.ShapeImporter.Options().ValidationMessages(objError.ErrorMessages);

        //Show Validation error steps
        objMapInfoImporter.ShapeImporter.Options().CurrentStep(-1);

        //Remove spinner processing div
        objMapInfoImporter.ShapeImporter.HideProcessingDiv();

        //Reject the deffered
        objDeferred.reject();

    }));

    TrimbleMap.ModalDialog.Shared.RepositionDialog(objMapInfoImporter.ShapeImporter.DialogID);

}

// **************************************************************************
// FUNCTION: AddFile
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.AddFile = function AddFile(objFile) {
    //Get the map info shape importer instance ...
    let objMapInfoImporter = this;

    let objPattern = new RegExp(TrimbleMap.MapInfoImporter.Shared.RequiredFileTypesRegex, "i");
    let blnAddFile = true;
    let blnInvalidFileFound = false;

    if (!objPattern.test(objFile.name)) {
        blnAddFile = false;
        blnInvalidFileFound = true;
    } else {
        objMapInfoImporter.ShapeImporter.Options().RequiredFiles().find(function (objKeyValuePair) {
            return objKeyValuePair.Key == "zip";
        }).Value = true;
    }

    if (blnAddFile && !blnInvalidFileFound) {
        objMapInfoImporter.TcpfShapeImporter.CreateTcpfDirectory(objFile.name);
    }

    return {
        AddFile: blnAddFile,
        InvalidFileFound: blnInvalidFileFound
    };
}

// **************************************************************************
// FUNCTION: Next
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.Next = function Next() {
    //Get the map info shape importer instance ...
    let objMapInfoImporter = this;

    if (objMapInfoImporter.ShapeImporter.Options().CurrentStep() === 1) {

        objMapInfoImporter.Validate(objMapInfoImporter.ShapeImporter.Options().FileuploadDataObject);
    }
    else if (objMapInfoImporter.ShapeImporter.Options().CurrentStep() === 2) {

        objMapInfoImporter.FeatureSelection();

    }
    else if (objMapInfoImporter.ShapeImporter.Options().CurrentStep() === 3) {

        objMapInfoImporter.Import();

    }
}

// **************************************************************************
// FUNCTION: FeatureSelection
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.FeatureSelection = function FeatureSelection() {
    //Get the map info shape importer instance ...
    let objMapInfoImporter = this;
    let arrSelectedFeatures = [];

    let fids = new Array();
    let codes = new Array();

    $("#spn_select_features_validator").css("display", "none");

    $('.chkSelectFeature').each(function () {

        if ($(this).prop('checked'))
            fids.push($(this).attr('fid'));
        codes.push($('.trSelectFeature > td:nth-child(2)')[($(this).attr('fid'))].innerText);
    });

    if (fids.length === 0) {
        $("#spn_select_features_validator").css("display", "block");
        return;
    }

    objMapInfoImporter.ShapeImporter.Options().SelectedFeatures(fids);
    objMapInfoImporter.ShapeImporter.ShowProcessingDiv();

    let arrFeatures = JSON.parse(objMapInfoImporter.TcpfDownloadFileResults).features;

    $.each(fids, function (intFid, Fid) {

        let objFilteredFeature = arrFeatures.filter(function (objFeature) {
            return objFeature.properties.FID === parseInt(Fid);
        });

        arrSelectedFeatures.push(objFilteredFeature[0]);
    })

    let strWKT = objMapInfoImporter.ShapeImporter.Options().SpatialReferences().filter(function (objElement) {
        return objElement.SpatialReferenceID === objMapInfoImporter.ShapeImporter.Options().SpatialReferenceID();
    });

    $.each(arrSelectedFeatures, function (intSelectedFeature, objSelectedFeature) {

        //convert to esri geometry type
        let strEsriGeometryType = objMapInfoImporter.ShapeImporter.ShapeEditor.MapController.ConvertOgcGeometryTypeToEsriGeometryType(objSelectedFeature.geometry.type.toUpperCase());
        let strGeometryType = TrimbleMap.Shape.Shared.EsriGeometrTypeToGeometryType(strEsriGeometryType);

        if (objMapInfoImporter.ShapeImporter.ShapeEditor.Shape.GeometryType == strGeometryType) {

            objMapInfoImporter.FeaturesToImport.push(TrimbleMap.Shape.Shared.ConvertPartsToEsriGeometry(objSelectedFeature.geometry.coordinates, strGeometryType, objSelectedFeature.geometry.type.toUpperCase(), strWKT));

        } else {

            // Geometry type does not match
            let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.ShapeImporter.js', 'GeometryTypeMismatch', objMapInfoImporter.ShapeImporter.ShapeEditor.Shape.GeometryType.toLowerCase());

            objMapInfoImporter.ShapeImporter.Options().ValidationMessages([strEndUserMessage]);

            //Show Validation error steps
            objMapInfoImporter.ShapeImporter.Options().CurrentStep(-2);

            //Remove spinner processing div
            objMapInfoImporter.ShapeImporter.HideProcessingDiv();
        };
    })

    if (objMapInfoImporter.ShapeImporter.Options().SpatialReferenceID() && objMapInfoImporter.ShapeImporter.Options().SpatialReferenceID() != SD.Guid.Shared.Empty()) {
        let objPrePropulateSpatialReference = objMapInfoImporter.ShapeImporter.Options().SpatialReferences().find(function (objSpatialReference) {
            return objSpatialReference.SpatialReferenceID === objMapInfoImporter.ShapeImporter.Options().SpatialReferenceID();
        });

        if (objPrePropulateSpatialReference) {
            objMapInfoImporter.ShapeImporter.Options().SelectedSpatialReference(objPrePropulateSpatialReference);
        }
        else {
            objMapInfoImporter.ShapeImporter.Options().SpatialReferences().splice(0, 0, { SpatialReferenceID: SD.Guid.Shared.Empty(), Name: '' });
        }
    }

    objMapInfoImporter.SetCurrentStep(TrimbleMap.ShapeImporter.enumNavigation.Next);
    objMapInfoImporter.ShapeImporter.HideProcessingDiv();
}

// **************************************************************************
// FUNCTION: Import
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.Import = function Import() {
    //Get the map info shape importer instance ...
    let objMapInfoImporter = this;

    var selectedSpatialReference = objMapInfoImporter.ShapeImporter.Options().SelectedSpatialReference();
    var blnAddToExistingShape = objMapInfoImporter.ShapeImporter.Options().AddToExistingShape();

    if (!blnAddToExistingShape) {
        objMapInfoImporter.ShapeImporter.ShapeEditor.RemoveShape(true);
    };

    objMapInfoImporter.ShapeImporter.ShapeEditor.Shape.SpatialReferenceID = selectedSpatialReference.SpatialReferenceID;

    $.each(objMapInfoImporter.FeaturesToImport, function (intFeature, arrGeometry) {
        $.each(arrGeometry, function (intGeometry, objGeometry) {

            if (!objGeometry.isInterior) {

                objMapInfoImporter.ShapeImporter.ShapeEditor.DrawToAdd(objGeometry.Geometry, selectedSpatialReference.SpatialReferenceID, [], false, false);

                objMapInfoImporter.ShapeImporter.ShapeEditor.CoordinateSystemDropDown.val(selectedSpatialReference.SpatialReferenceID);

            } else {
                //Remove from shape
                objMapInfoImporter.ShapeImporter.ShapeEditor.DrawToRemove(objGeometry.Geometry, selectedSpatialReference.SpatialReferenceID, false);
            }
        });

        //Zoom to shape..
        objMapInfoImporter.ShapeImporter.ShapeEditor.ZoomToShape();
    });

    objMapInfoImporter.ShapeImporter.Options(objMapInfoImporter.ShapeImporter.ResetImporter());

    //Detach event handlers
    objMapInfoImporter.ShapeImporter.DetachEventHandlers();

    objMapInfoImporter.ShapeImporter.CloseDialog();

    //reposition the dialog
    TrimbleMap.ModalDialog.Shared.RepositionDialog(objMapInfoImporter.ShapeImporter.DialogID);

    objMapInfoImporter.ShapeImporter.HideProcessingDiv();

}

// **************************************************************************
// FUNCTION: Previous
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.Previous = function Previous() {
    //Get the map info shape importer instance ...
    let objMapInfoImporter = this;

    //decrement the current step
    objMapInfoImporter.SetCurrentStep(TrimbleMap.ShapeImporter.enumNavigation.Previous);

    $('#fileupload').fileupload(objMapInfoImporter.ShapeImporter.FileUpLoadConfiguration());
    objMapInfoImporter.CustomFileUpLoadPluginConfiguration();

    $("#fileupload").prop("disabled", objMapInfoImporter.ShapeImporter.Options().CurrentStep() == 1 && objMapInfoImporter.ShapeImporter.Options().PluginDataFiles().length >= objMapInfoImporter.ShapeImporter.Options().LimitFileUploadFiles());
}

// **************************************************************************
// FUNCTION: CustomFileUpLoadPluginConfiguration
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.CustomFileUpLoadPluginConfiguration = function CustomFileUpLoadPluginConfiguration() {
    //Get the map info shape importer instance ...
    let objMapInfoImporter = this;

    let blnMultipleFileSelection = false;
    objMapInfoImporter.ShapeImporter.FileUpLoadConfiguration().formData.GeometryType = objMapInfoImporter.ShapeImporter.ShapeEditor.Shape.GeometryType;
    objMapInfoImporter.ShapeImporter.FileUpLoadConfiguration().formData.ImportType = TrimbleMap.ShapeImporter.enumImportType.MapInfoImporter;

    objMapInfoImporter.ShapeImporter.FileUpLoadConfiguration().acceptFileTypes(TrimbleMap.MapInfoImporter.Shared.AcceptedFileTypesRegex);//objMapInfoImporter.ShapeImporter.FileUpLoadConfiguration().acceptFileTypes("/(\.|\/)(dbf|prj|shp|shx)$/i");
    objMapInfoImporter.ShapeImporter.Options().AllowedFileTypes(objMapInfoImporter.AllowedFileTypes);//objMapInfoImporter.ShapeImporter.Options().AllowedFileTypes(".dbf,.prj,.shp,.shx");
    objMapInfoImporter.ShapeImporter.Options().LimitFileUploadFiles(1);

    objMapInfoImporter.ShapeImporter.Options().RequiredFiles(objMapInfoImporter.RequiredFileTypes);

    objMapInfoImporter.ShapeImporter.Options().NumberOfSteps(3);

    // File upload plugin is changed manually in javascript because knockout does not always work. 
    // It works the first time importing but is unpredictable there after.
    $("#fileupload").attr("accept", objMapInfoImporter.ShapeImporter.Options().AllowedFileTypes());
    $("#fileupload").prop("multiple", blnMultipleFileSelection);
    $("#fileupload").prop("disabled", (objMapInfoImporter.ShapeImporter.Options().CurrentStep() == 1 && objMapInfoImporter.ShapeImporter.Options().PluginDataFiles().length >= objMapInfoImporter.ShapeImporter.Options().LimitFileUploadFiles()));
}

// **************************************************************************
// FUNCTION: SetCurrentStep
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.SetCurrentStep = function SetCurrentStep(enumNavigation) {
    //Get the map info shape importer instance ...
    let objMapInfoImporter = this;

    let fnAttachMapInfoImporterStep2Events = function () {
        $('#txtSearchFeatureNames').on('keyup', objMapInfoImporter.SearchFeatureItemKeyUpProxy);
        $('#btnResetFeatureSelectSearch').on('click', objMapInfoImporter.ResetFeatureSelectSearchProxy);
        $('#btnSelectAllFeatures').on('click', objMapInfoImporter.SelectAllClickedProxy);
    };

    if (enumNavigation === TrimbleMap.ShapeImporter.enumNavigation.Next) {
        objMapInfoImporter.ShapeImporter.Options().CurrentStep(objMapInfoImporter.ShapeImporter.Options().CurrentStep() + 1)

        if (objMapInfoImporter.ShapeImporter.Options().CurrentStep() === 2) {
            fnAttachMapInfoImporterStep2Events();
        }
    }
    else if (enumNavigation === TrimbleMap.ShapeImporter.enumNavigation.Previous) {
        if (objMapInfoImporter.ShapeImporter.Options().CurrentStep() === -1) {
            objMapInfoImporter.ShapeImporter.Options().CurrentStep(1);
        }
        else {
            objMapInfoImporter.ShapeImporter.Options().CurrentStep(objMapInfoImporter.ShapeImporter.Options().CurrentStep() - 1);
            if (objMapInfoImporter.ShapeImporter.Options().CurrentStep() === 2) {
                fnAttachMapInfoImporterStep2Events();
                $("#spn_select_features_validator").css("display", "none");
            }
        }
    }
    else {
        if (objMapInfoImporter.ShapeImporter.Options().CurrentStep() === -1) {
            objMapInfoImporter.ShapeImporter.Options().CurrentStep(1);
        }
        else {
            objMapInfoImporter.ShapeImporter.Options().CurrentStep(objMapInfoImporter.ShapeImporter.Options().CurrentStep() - 1);
        }
    }
}

// **************************************************************************
// FUNCTION: SearchFeatureItemKeyup
// USAGE:
// **************************************************************************
TrimbleMap.MapInfoImporter.SearchFeatureItemKeyup = function SearchFeatureItemKeyup(e) {
    let strSearchText = ($('#txtSearchFeatureNames').val()).toLowerCase();

    //Search text is empty string: show all
    if (!strSearchText) {
        $(".trSelectFeature").css("display", "table-row")
        return;
    }

    $(".trSelectFeature").each(function () {
        let strRecordText = $(this).html().toLowerCase();

        if (strRecordText.indexOf(strSearchText) === -1) {
            $(this).css("display", "none");
        }
        else {
            $(this).css("display", "table-row");
        }

    });
};

// **************************************************************************
// FUNCTION: ResetFeatureSelectSearch
// USAGE:
// **************************************************************************
TrimbleMap.MapInfoImporter.ResetFeatureSelectSearch = function ResetFeatureSelectSearch(e) {
    $("#txtSearchFeatureNames").val('');
    $("#txtSearchFeatureNames").keyup();
};

// **************************************************************************
// FUNCTION: SelectAllClicked
// USAGE:
// **************************************************************************
TrimbleMap.MapInfoImporter.SelectAllClicked = function SelectAllClicked(e) {
    let blnAllChecked = true;

    $('.chkSelectFeature').each(function () {
        if (!$(this).prop('checked')) {
            blnAllChecked = false;
            return false;
        }
    });

    $('.chkSelectFeature').each(function () {
        $(this).prop('checked', !blnAllChecked);
    });
};

// **************************************************************************
// FUNCTION: CreateImportItem
// USAGE:    
// **************************************************************************
TrimbleMap.MapInfoImporter.Shared.CreateImportItem = function CreateImportItem() {
    // Create a new menu item object ...
    return {
        DisplayText: SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'ImportCoordinatesMapInfoImporter'),
        ImportType: TrimbleMap.ShapeImporter.enumImportType.MapInfoImporter,
        ImportTypeText: "MapInfoImporter"
    };
}
// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ShapeImporter = {};
TrimbleMap.ShapeImporter.Shared = {};

// ****************************************************************
//  ENUMERATIONS
// ****************************************************************
TrimbleMap.ShapeImporter.enumImportType = {};
// If number changed ensure binding in html is also changed.
TrimbleMap.ShapeImporter.enumImportType.CSV = 0;
TrimbleMap.ShapeImporter.enumImportType.Excel = 1;
TrimbleMap.ShapeImporter.enumImportType.ShapeFile = 2;
TrimbleMap.ShapeImporter.enumImportType.MapInfo = 3;
TrimbleMap.ShapeImporter.enumImportType.FILEGDB = 4;

TrimbleMap.ShapeImporter.enumNavigation = {};
TrimbleMap.ShapeImporter.enumNavigation.Next = 0;
TrimbleMap.ShapeImporter.enumNavigation.Previous = 1;

TrimbleMap.ShapeImporter.enumImportOptions = {};
TrimbleMap.ShapeImporter.enumImportOptions.Validate = 0;
TrimbleMap.ShapeImporter.enumImportOptions.Submit = 1;
TrimbleMap.ShapeImporter.enumImportOptions.ValidateAndSubmit = 2;

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.CreateInstance = function CreateInstance(arrImportTypes, strHiddenImportTypeFieldID, objShapeEditor) {

    // Create the object that will hold the instance properties ...
    var objShapeImporter = {
        PopupContainer: null,
        StepOneDiv: null,
        StepTwoDiv: null,
        ProcessingDiv: null,
        StepThreeDiv: null,

        DialogID: null,
        ImportOptionsDiv: null,
        DivCurrentlyInView: null,
        CurrentImportType: ko.observable(),
        ImportModel: ko.observable(),

        HiddenImportTypeField: null,

        ImportItems: [],
        ImportTypes: arrImportTypes,
        CurrentStep: null,
        Dialog: null,
        ShapeEditor: objShapeEditor,
        ImportedShapeGeometry: null,

        FileUpLoadConfiguration: null,
        Options: null,

        ImportItemClickedProxy: function (e) { objShapeImporter.ImportItemClicked(e); },
        NextClickedProxy: function (e) { objShapeImporter.NextClicked(e); },
        PreviousClickedProxy: function (e) { objShapeImporter.PreviousClicked(e); },
        CancelClickedProxy: function (e) { objShapeImporter.CancelClicked(e); },

        InjectImporterHtmlAndApplyBindings: TrimbleMap.ShapeImporter.InjectImporterHtmlAndApplyBindings,
        GetDefaultDisplayConfiguration: TrimbleMap.ShapeImporter.GetDefaultDisplayConfiguration,
        RemoveImporterHtml: TrimbleMap.ShapeImporter.RemoveImporterHtml,
        ResetImporter: TrimbleMap.ShapeImporter.ResetImporter,
        AttachEventHandlers: TrimbleMap.ShapeImporter.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.ShapeImporter.DetachEventHandlers,
        ShowDialog: TrimbleMap.ShapeImporter.ShowDialog,
        CloseDialog: TrimbleMap.ShapeImporter.CloseDialog,
        DefaultFileUpLoadPluginConfiguration: TrimbleMap.ShapeImporter.DefaultFileUpLoadPluginConfiguration,
        CreateElements: TrimbleMap.ShapeImporter.CreateElements,
        ShowProcessingDiv: TrimbleMap.ShapeImporter.ShowProcessingDiv,
        HideProcessingDiv: TrimbleMap.ShapeImporter.HideProcessingDiv,
        NextClicked: TrimbleMap.ShapeImporter.NextClicked,
        PreviousClicked: TrimbleMap.ShapeImporter.PreviousClicked,
        CancelClicked: TrimbleMap.ShapeImporter.CancelClicked,
        ImportItemClicked: TrimbleMap.ShapeImporter.ImportItemClicked,
        CreateImportItems: TrimbleMap.ShapeImporter.CreateImportItems,
        InitialiseDisplayConfiguration: TrimbleMap.ShapeImporter.InitialiseDisplayConfiguration
    };

    // Creates menu list with list of importers.
    objShapeImporter.CreateImportItems();

    // Configuration object to the upload plugin which the plugin requires.
    objShapeImporter.FileUpLoadConfiguration = ko.observable();

    objShapeImporter.Options = ko.observable(objShapeImporter.ResetImporter());

    return objShapeImporter;
}

// **************************************************************************
// FUNCTION: RemoveImporterHtml
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.RemoveImporterHtml = function RemoveImporterHtml() {
    if (document.getElementById("MapImporterContainer")) {
        $("#MapImporterContainer").remove();
    }
    if (document.getElementById("import-step1")) {
        $("#import-step1").remove();
    }
    if (document.getElementById("import-step3")) {
        $("#import-step3").remove();
    }
    if (document.getElementById("import-validation-messages")) {
        $("#import-validation-messages").remove();
    }
}

// **************************************************************************
// FUNCTION: InjectImporterHtmlAndApplyBindings
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.InjectImporterHtmlAndApplyBindings = function InjectImporterHtmlAndApplyBindings() {
    //Get the shape importer instance ...
    var objShapeImporter = this;

    var objMapImportMaster = $.get(SD.Url.Shared.CurrentMappingLibraryURL + "/templates/MapImportMaster.html", function (html) {
        if (document.getElementById("MapImporterContainer")) {
            var mapImporterInnerContainer = document.getElementById("MapImporterInnerContainer");

            if (mapImporterInnerContainer) {
                mapImporterInnerContainer.remove();
            }

            $("#MapImporterContainer").append(html);
        } else {
            var strInnerHtml = '<div id="MapImporterContainer" class="container" style="display: none">' + html + '</div>';
            $("body").append(strInnerHtml);
        }
    });

    var objStep1 = $.get(SD.Url.Shared.CurrentMappingLibraryURL + "/templates/imports/Step1.html", function (html) {
        if (document.getElementById("import-step1")) {
            $("#import-step1").remove();
        }

        $('body').append(html);
    });

    var objStep2 = $.get(SD.Url.Shared.CurrentMappingLibraryURL + "/templates/imports/Step2.html", function (html) {
        if (document.getElementById("import-step2")) {
            $("#import-step2").remove();
        }

        $('body').append(html);
    });

    var objStep3 = $.get(SD.Url.Shared.CurrentMappingLibraryURL + "/templates/imports/Step3.html", function (html) {
        if (document.getElementById("import-step3")) {
            $("#import-step3").remove();
        }

        $('body').append(html);
    });

    var objImportValidationErrors = $.get(SD.Url.Shared.CurrentMappingLibraryURL + "/templates/imports/ImportValidationErrors.html", function (html) {
        if (document.getElementById("import-validation-messages")) {
            $("#import-validation-messages").remove();
        }

        $('body').append(html);
    });


    var injectImporterHtmlAndApplyBindings = $.when(objMapImportMaster, objStep1, objStep2, objStep3, objImportValidationErrors).done(function () {
        objShapeImporter.PopupContainer = $("#MapImporterInnerContainer");
        objShapeImporter.HiddenImportTypeField = $("#ImportTypeField");
        ko.applyBindings(objShapeImporter.Options, objShapeImporter.PopupContainer[0]);
    });

    return injectImporterHtmlAndApplyBindings;
}

// **************************************************************************
// FUNCTION: ResetImporter
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.ResetImporter = function ResetImporter() {

    //Get the shape importer instance ...
    var objShapeImporter = this;

    var objDisplayConfiguration = objShapeImporter.GetDefaultDisplayConfiguration();

    //create shape importer options
    // Object which is bound to the UI
    var objShapeImporterOptions = {
        // UI Configuration display text which is actually only configurable from portal.
        DisplayConfiguration: ko.observable(objDisplayConfiguration),
        // No need to be observable because it is not used on the UI.
        FileuploadDataObject: null,
        NumberOfSteps: ko.observable(1),
        CurrentStep: ko.observable(1),
        ImportType: ko.observable(0),
        ImportTypeText: ko.observable(),
        PluginDataFiles: ko.observableArray([]),
        // Whether all required files have been selected.
        RequiredFilesAdded: ko.observable(false),
        // An array of required files with a key/value pair. The key being the file type and the value being boolean (whether it has been selected or not). 
        RequiredFiles: ko.observable([]),
        InvalidFileSelected: ko.observable(false),
        AllowedFileTypes: ko.observable(''),
        // Integer value of how much files a importer is allowed. CSV importer for example is 1.
        LimitFileUploadFiles: ko.observable(0),
        ValidationMessages: ko.observableArray([]),
        SpatialReferences: ko.observableArray(objShapeImporter.ShapeEditor.MapController.State.SpatialReferences),
        SelectedSpatialReference: ko.observable(),
        Features: ko.observableArray([]),
        FeatureTableDetails: ko.observable(),
        SelectedFeatures: ko.observable([]),
        SpatialReferenceName: ko.observable(''),
        SpatialReferenceID: ko.observable(''),
        // The event which sends the request to the server with the files. Determines whether it has already been attached or not.
        FileSubmitEventAttached: ko.observable(false),
        AddToExistingShape: ko.observable(null),
        //Set the mapping library url
        MappingLibraryURL: ko.observable(SD.Url.Shared.CurrentMappingLibraryURL),
        EmptyGuid: ko.observable(SD.Guid.Shared.Empty()),
        // Displays the file size on the UI.
        DisplaySize: function (objFile) {
            var objConvertedSize = objFile.size / 1000;

            if (objConvertedSize <= 1000) {
                objConvertedSize = objConvertedSize.toFixed(2) + "KB";
            } else {
                objConvertedSize = (objConvertedSize / 1000).toFixed(2) + "MB";
            }

            return objConvertedSize;
        },
        // Removes the selected file from the list to send to the server.
        RemoveFile: function (name) {
            objShapeImporterOptions.PluginDataFiles.remove(function (objUploadedFile) {
                if (objUploadedFile.name == name) {
                    var objFileType = objUploadedFile.name.substring(objUploadedFile.name.indexOf(".") + 1).toLowerCase();

                    var objInvalidPair = objShapeImporter.Options().RequiredFiles().find(function (objKeyValuePair) {
                        return objKeyValuePair.Key == objFileType;
                    });

                    // If a required file has been removed. The next button is disabled.
                    if (objInvalidPair) {
                        objInvalidPair.Value = false;
                        objShapeImporter.Options().RequiredFilesAdded(false);
                    }
                }
                return objUploadedFile.name === name;
            });
            //Didn't use knockout for this because for some reason even though i changed the variable binded to the element, it's state never changed to disabled.
            $("#fileupload").prop("disabled", !(objShapeImporterOptions.PluginDataFiles().length < objShapeImporter.Options().LimitFileUploadFiles()));
        }
    };

    // By default a beforeunload event is added to links which adds a overlay and spinner.
    // This needs to be removed as we are not redirecting but downloading a template.
    $(window).off("beforeunload");

    return objShapeImporterOptions;
}

// **************************************************************************
// FUNCTION: GetDefaultDisplayConfiguration
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.GetDefaultDisplayConfiguration = function GetDefaultDisplayConfiguration() {
    return {
        AddedFileName: ko.observable(''),
        AddedFileSize: ko.observable(''),
        AddShapeOption: ko.observable(''),
        CancelButton: ko.observable(''),
        CurrentSpatialReference: ko.observable(''),
        ImportButton: ko.observable(''),
        InvalidFile: ko.observable(''),
        NextButton: ko.observable(''),
        NoFiles: ko.observable(''),
        PreviousButton: ko.observable(''),
        ReplaceShapeOption: ko.observable(''),
        RequiredFilesMissingTooltip: ko.observable(''),
        SelectedAddReplaceShape: ko.observable(''),
        SelectedCoordinateSystem: ko.observable(''),
        SelectFeaturesInstructions: ko.observable(''),
        SelectFeaturesValidator: ko.observable(''),
        ShowAllButton: ko.observable(''),
        Step1Title: ko.observable(''),
        Step2Title: ko.observable(''),
        Step3Title: ko.observable(''),
        TemplateDownloadText: ko.observable(''),
        UploadInstructions: ko.observable(''),
        ValidationErrorsDescription: ko.observable(''),
        ValidationErrorsTitle: ko.observable(''),
        FilterRecords: ko.observable('')
    };
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.AttachEventHandlers = function AttachEventHandlers() {

    // Get the shape importer instance ...
    var objShapeImporter = this;

    // Attach the changed event handler to the specific buttons ...
    $(".shape_importer_cancel_button").on("click", objShapeImporter.CancelClickedProxy);
    $(".shape_importer_next_button").on("click", objShapeImporter.NextClickedProxy);
    $(".shape_importer_import_button").on("click", objShapeImporter.NextClickedProxy);
    $(".tooltip_overlay").on("mouseenter", function (event) {
        if ($('.shape_importer_next_button')[0].hasAttribute("disabled")) {
            $(".tooltip_overlay").attr("Title", objShapeImporter.Options().DisplayConfiguration().RequiredFilesMissingTooltip());
        } else {
            $(".tooltip_overlay").removeAttr("Title");
        }
    });



    $('#fileupload').fileupload(objShapeImporter.FileUpLoadConfiguration());

    $(".shape_importer_previous_button").on("click", objShapeImporter.PreviousClickedProxy);
};

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map zoom instance ...
    var objShapeImporter = this;

    // Remove the attached event handlers from the buttons ...
    $(".shape_importer_cancel_button").off("click");
    $(".shape_importer_next_button").off("click");
    $(".tooltip_overlay").off("mouseenter");

    $('#fileupload').off("click");

    $(".shape_importer_previous_button").off("click");
    $(".shape_importer_import_button").off("click");

    objShapeImporter.Options().FileSubmitEventAttached(false);
}

// **************************************************************************
// FUNCTION: CreateImportItems
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.CreateImportItems = function CreateImportItems() {

    // Get the instance ...
    var objShapeImporter = this;

    for (var intImportType = 0; intImportType < objShapeImporter.ImportTypes.length; intImportType++) {

        var objItem = TrimbleMap.ShapeImporter.Shared.CreateImportItem(objShapeImporter.ImportTypes[intImportType]);

        objShapeImporter.ImportItems[intImportType] = objItem;
    }
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.CreateElements = function CreateElements(objContainer) {

    // Get the instance ...
    var objShapeImporter = this;

    // When the options div has not been create yet ...
    if (!objShapeImporter.ImportOptionsDiv) {

        objShapeImporter.ImportOptionsDiv = $("<div></div>");

        for (var key in objShapeImporter.ImportItems) {

            var objItem = objShapeImporter.ImportItems[key];

            // Create the item div ...
            var objItemDiv = $('<div class="menu-item" ImportType="' + objItem.ImportType + '"></div>');

            // Create the span ...
            var objItemSpan = $('<span></span>');

            // Set the item text ...
            objItemSpan.text(objItem.DisplayText);

            // Add the span to the div ...
            objItemDiv.append(objItemSpan);

            //append to container
            objShapeImporter.ImportOptionsDiv.append(objItemDiv);
        }
    }

    var objEvents = $._data(objShapeImporter.ImportOptionsDiv.get(0), "events");

    if (!objEvents) {
        objShapeImporter.ImportOptionsDiv.on('click', (objShapeImporter.ImportItemClickedProxy));
    }

    objContainer.append(objShapeImporter.ImportOptionsDiv);
}

// **************************************************************************
// FUNCTION: ShowProcessingDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.ShowProcessingDiv = function ShowProcessingDiv() {

    // Get the instance ...
    var objShapeImporter = this;
	let objSpinnerElement = null;
	let strSpinnerElementID = 'file-processing';

    // Create the processing div ...
    objShapeImporter.ProcessingDiv = $('<div runat="server" id="' + strSpinnerElementID + '" class="process-loading"></div>');

    // Add it to the body ...
    $(objShapeImporter.PopupContainer).append(objShapeImporter.ProcessingDiv);
	
	//show the spinner
	SD.SpinnerFunctions.Shared.CreateSpinnerInContainerElement($('#' + strSpinnerElementID), 12, 22, 18, 3, '#333', 'Processing File', 'map-loading-text', 'loading-content');
}

// **************************************************************************
// FUNCTION: HideProcessingDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.HideProcessingDiv = function HideProcessingDiv() {

    // Get the instance ...
    var objShapeImporter = this;

    if (objShapeImporter.ProcessingDiv){
        // Remove the processing div ...
        objShapeImporter.ProcessingDiv.remove();
    }

    // Set it to null ...
    objShapeImporter.ProcessingDiv = null;
}

// **************************************************************************
// FUNCTION: ShowDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.ShowDialog = function ShowDialog() {

    // Get the instance ...
    var objShapeImporter = this;

    objShapeImporter.DialogID = TrimbleMap.ModalDialog.Shared.NextDialogID();

    TrimbleMap.ModalDialog.Shared.OpenDialog(objShapeImporter.PopupContainer, "", false, objShapeImporter.DialogID);
}

// **************************************************************************
// FUNCTION: CloseDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.CloseDialog = function CloseDialog() {

    // Get the instance ...
    var objShapeImporter = this;

    TrimbleMap.ModalDialog.Shared.CloseDialog(objShapeImporter.DialogID);

    objShapeImporter.RemoveImporterHtml();
}

// **************************************************************************
// FUNCTION: DefaultFileUpLoadPluginConfiguration
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.DefaultFileUpLoadPluginConfiguration = function DefaultFileUpLoadPluginConfiguration() {

    // Get the instance ...
    var objShapeImporter = this;

    // Configuration object which is required by the file upload plugin.
    var objFileUpLoadConfiguration = {
        //members are lowercase because this is the object which is used to configure the settings for the file upload plugin.
        // Data format which is expected back from the server.
        dataType: 'json',
        // Files types which are allowed to be selected.
        acceptFileTypes: ko.observable(),
        // Setting which disables the uploading of files immediatly to the server.
        autoUpload: ko.observable(false),
        // Ensures all files that are newly selected, are added to data.files as an array and not individually because if this setting is set to true the add function below is called for every new file added.
        // whereas if "false" the add function is called only once for all newly selected files.
        singleFileUploads: false,
        formData: {
            // To be sent with files as additional information to the server.
            // CoordinateFormat: ko.observable(),
            GeometryType: ko.observable(),
            // Determines on the server side whether to validate file, submit file or both.
            ImportOption: ko.observable()
        },
        // Called just before submitting request and files to server.
        start: function (e, data) {
            objShapeImporter.ShowProcessingDiv();
        },
        add: function (e, data) {
            var blnAddFile = true;
            var blnInvalidFileFound = false;
            objShapeImporter.Options().InvalidFileSelected(false);

            // Loops through all newly selected and added files.
            $.each(data.files, function (index, file) {
                let result = objShapeImporter.Importer.AddFile(file);
                blnAddFile = result.AddFile;
                blnInvalidFileFound = result.InvalidFileFound;

                // Checks to see if file should be add to PluginDataFiles as the file could be of not the required type.
                if (blnAddFile) {

                    if (objShapeImporter.Options().PluginDataFiles().length < objShapeImporter.Options().LimitFileUploadFiles()) {
                        objShapeImporter.Options().PluginDataFiles.push(file);

                        // Checks to see if there are any outstanding required files.
                        // For IE a polyfill was added for the function "find" as it did not initially work.
                        var objInvalidPair = objShapeImporter.Options().RequiredFiles().find(function (objKeyValuePair) {
                            return objKeyValuePair.Value == false;
                        })

                        // If all required files have been added. The next button is enabled.
                        if (!objInvalidPair) {
                            objShapeImporter.Options().RequiredFilesAdded(true);
                        }
                    }
                    //Didn't use knockout for this because for some reason even though the variable binded to the element changed, it's state never changed to disabled.
                    $("#fileupload").prop("disabled", objShapeImporter.Options().PluginDataFiles().length >= objShapeImporter.Options().LimitFileUploadFiles());
                }
            });

            // After new files have been added to our maintained "PluginDataFiles" array object. We assign it to data.files property.
            // This property is used by the file upload plugin to send files along with the request.
            data.files = objShapeImporter.Options().PluginDataFiles();

            objShapeImporter.Options().InvalidFileSelected(blnInvalidFileFound);

            //reposition the dialog
            TrimbleMap.ModalDialog.Shared.RepositionDialog(objShapeImporter.DialogID);

            objShapeImporter.Options().FileuploadDataObject = data;
        },
        done: function (e, data) {
        },
        send: function (e, data) {
        },
        fail: function (e, data) {
        }
    };

    return objFileUpLoadConfiguration;
}

// **************************************************************************
// FUNCTION: ImportItemClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.ImportItemClicked = function ImportItemClicked(e) {

    // Get the instance ...
    var objShapeImporter = this;

    var objTarget = $(e.target);

    //get the element clicked
    var objItem = SD.DOM.GetElementOrParentWithAttribute(objTarget, "ImportType");

    if (objItem) {

        //get the import type if not null
        var intImportType = parseInt($(objItem).attr('ImportType'));

        $.when(objShapeImporter.InjectImporterHtmlAndApplyBindings()).done(function () {
            objShapeImporter.Options(objShapeImporter.ResetImporter());
            objShapeImporter.HiddenImportTypeField.val(intImportType);
            objShapeImporter.Options().ImportType(intImportType);
            objShapeImporter.Options().ImportTypeText(objShapeImporter.ImportItems.filter(function (obj) {
                return obj.ImportType === intImportType;
            }).ImportTypeText);

            switch (intImportType) {
                case TrimbleMap.ShapeImporter.enumImportType.CSV:
                    objShapeImporter.Importer = TrimbleMap.CSVShapeImporter.CreateInstance(objShapeImporter);
                    break;
                case TrimbleMap.ShapeImporter.enumImportType.ShapeFile:
                    objShapeImporter.Importer = TrimbleMap.ShapeFileShapeImporter.CreateInstance(objShapeImporter, objShapeImporter.ShapeEditor.Options.TcpfConfiguration);
                    break;
                case TrimbleMap.ShapeImporter.enumImportType.MapInfo:
                    objShapeImporter.Importer = TrimbleMap.MapInfoImporter.CreateInstance(objShapeImporter, objShapeImporter.ShapeEditor.Options.TcpfConfiguration);
                    break;
                default:
                    throw new Error("Import type '" + intImportType + "' not implemented");
            }

            objShapeImporter.Options().DisplayConfiguration(objShapeImporter.Importer.GetDisplayConfiguration());

            objShapeImporter.ShowDialog();

            // Radio buttons are not being binded for an unknown reason.
            // To resolve this issue the appropriate radio button is being dynamically clicked based on the AddToExistingShape observable which it is binded to.
            if (objShapeImporter.Options().AddToExistingShape()) {
                $("#rdbAddtoExistingShape").trigger('click');
            } else {
                $("#rdbReplaceExistingShape").trigger('click');
            }

            // Assigns the default configuration settings which the plugin requires.
            objShapeImporter.FileUpLoadConfiguration(objShapeImporter.DefaultFileUpLoadPluginConfiguration());
            objShapeImporter.Importer.CustomFileUpLoadPluginConfiguration();

            objShapeImporter.AttachEventHandlers();
        });
    }
}

// **************************************************************************
// FUNCTION: CancelClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.CancelClicked = function CancelClicked(e) {

    // Get the instance ...
    var objShapeImporter = this;

    // Detach the event handlers ...
    objShapeImporter.DetachEventHandlers();

    //Close Dialog
    objShapeImporter.CloseDialog();
}

// **************************************************************************
// FUNCTION: NextClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.NextClicked = function NextClicked(e) {

    // Get the instance ...
    var objShapeImporter = this;

    objShapeImporter.Importer.Next();

    //reposition the dialog
    TrimbleMap.ModalDialog.Shared.RepositionDialog(objShapeImporter.DialogID);
}

// **************************************************************************
// FUNCTION: PreviousClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.PreviousClicked = function PreviousClicked(e) {

    // Get the instance ...
    var objShapeImporter = this;

    objShapeImporter.Importer.Previous();

    //reposition the dialog
    TrimbleMap.ModalDialog.Shared.RepositionDialog(objShapeImporter.DialogID);
}

// **************************************************************************
// FUNCTION: CreateImportItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.Shared.CreateImportItem = function CreateImportItem(enumShapeImporterType) {
    let objImportItem;

    switch (enumShapeImporterType) {
        case TrimbleMap.ShapeImporter.enumImportType.CSV:
            objImportItem = TrimbleMap.CSVShapeImporter.Shared.CreateImportItem();
            break;
        case TrimbleMap.ShapeImporter.enumImportType.Excel:
            objImportItem = {
                DisplayText: SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'ImportCoordinatesExcel'),
                ImportType: enumShapeImporterType,
                ImportTypeText: "Excel"
            };
            break;
        case TrimbleMap.ShapeImporter.enumImportType.ShapeFile:
            objImportItem = TrimbleMap.ShapeFileShapeImporter.Shared.CreateImportItem();
            break;
        case TrimbleMap.ShapeImporter.enumImportType.MapInfo:
            objImportItem = {
                DisplayText: SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'ImportCoordinatesMapInfo'),
                ImportType: enumShapeImporterType,
                ImportTypeText: "MapInfo"
            };
            break;
        case TrimbleMap.ShapeImporter.enumImportType.FILEGDB:
            objImportItem = {
                DisplayText: SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'ImportCoordinatesFileGeodatabase'),
                ImportType: enumShapeImporterType,
                ImportTypeText: "File Geodatabase"
            };
    }

    // Create a new menu item object ...
    return objImportItem
}

// **************************************************************************
// FUNCTION: InitialiseDisplayConfiguration
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeImporter.InitialiseDisplayConfiguration = function InitialiseDisplayConfiguration() {
    return {
        AddedFileName: ko.observable(''),
        AddedFileSize: ko.observable(''),
        AddShapeOption: ko.observable(''),
        CancelButton: ko.observable(''),
        CurrentSpatialReference: ko.observable(''),
        ImportButton: ko.observable(''),
        InvalidFile: ko.observable(''),
        NextButton: ko.observable(''),
        NoFiles: ko.observable(''),
        PreviousButton: ko.observable(''),
        ReplaceShapeOption: ko.observable(''),
        RequiredFilesMissingTooltip: ko.observable(''),
        SelectedAddReplaceShape: ko.observable(''),
        SelectedCoordinateSystem: ko.observable(''),
        SelectFeaturesInstructions: ko.observable(''),
        SelectFeaturesValidator: ko.observable(''),
        ShowAllButton: ko.observable(''),
        Step1Title: ko.observable(''),
        Step2Title: ko.observable(''),
        Step3Title: ko.observable(''),
        TemplateDownloadText: ko.observable(''),
        UploadInstructions: ko.observable(''),
        ValidationErrorsDescription: ko.observable(''),
        ValidationErrorsTitle: ko.observable(''),
        FilterRecords: ko.observable(''),
    };
};


// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.TcpfShapeImporter = {};
TrimbleMap.TcpfShapeImporter.Shared = {};

// ****************************************************************
//  ENUMERATIONS
// ****************************************************************
TrimbleMap.TcpfShapeImporter.enumMalwareStatus = {};
TrimbleMap.TcpfShapeImporter.enumMalwareStatus.CLEAN = 'CLEAN';

TrimbleMap.TcpfShapeImporter.enumExecutionStatus = {};
TrimbleMap.TcpfShapeImporter.enumExecutionStatus.EXECUTING = 'EXECUTING';
TrimbleMap.TcpfShapeImporter.enumExecutionStatus.FINISHED = 'FINISHED';
TrimbleMap.TcpfShapeImporter.enumExecutionStatus.FAILED = 'FAILED';

TrimbleMap.TcpfShapeImporter.enumContent = {};
TrimbleMap.TcpfShapeImporter.enumContent.GEOMETRY = 'GEOMETRY';
TrimbleMap.TcpfShapeImporter.enumContent.ATTRIBUTES = 'ATTRIBUTES';
TrimbleMap.TcpfShapeImporter.enumContent.ALL = 'ALL';

TrimbleMap.TcpfShapeImporter.enumStandardFileName = {};
TrimbleMap.TcpfShapeImporter.enumStandardFileName.RESULTS = 'results.json';
TrimbleMap.TcpfShapeImporter.enumStandardFileName.WKT = 'wkt.txt';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.TcpfShapeImporter.CreateInstance = function CreateInstance(objTcpfConfiguration) {

    let objTcpfShapeImporter = {
        TcpfConfiguration: objTcpfConfiguration,
        FileUploadJson: null,
        PollFileUploadCounter: 1,
        FileUploadUrl: '',
        FileDownloadUrl: '',
        FilePath: '',
        ProcedureExecutionId: '',

        CreateTcpfDirectory: TrimbleMap.TcpfShapeImporter.CreateTcpfDirectory,
        PrepareFileUpload: TrimbleMap.TcpfShapeImporter.PrepareFileUpload,
        UploadFileToDataOcean: TrimbleMap.TcpfShapeImporter.UploadFileToDataOcean,
        GetFileMetadataFromDataOcean: TrimbleMap.TcpfShapeImporter.GetFileMetadataFromDataOcean,
        ExecuteTcpfProcedure: TrimbleMap.TcpfShapeImporter.ExecuteTcpfProcedure,
        GetTcpfProcedureResult: TrimbleMap.TcpfShapeImporter.GetTcpfProcedureResult,
        GetTcpfProcedureError: TrimbleMap.TcpfShapeImporter.GetTcpfProcedureError,
        DownloadFileFromDataOcean: TrimbleMap.TcpfShapeImporter.DownloadFileFromDataOcean,
        Poll: TrimbleMap.TcpfShapeImporter.Shared.Poll,
    }

    return objTcpfShapeImporter;
}

// **************************************************************************
// FUNCTION: CreateTcpfDirectory
// USAGE:
// **************************************************************************
TrimbleMap.TcpfShapeImporter.CreateTcpfDirectory = function CreateTcpfDirectory(strFileName) {
    //Get the tcpf shape importer instance ...
    let objTcpfShapeImporter = this;

    //Get current date time in UTC zero and increment by 30 minutes ...    
    let expiresAt = new Date(new Date().getTime() + 180 * 60000).toISOString();

    //Create temporary file directory guid...
    let tempDirectoryGuid = SD.Guid.Shared.NewID();

    //create file json object here
    objTcpfShapeImporter.FileUploadJson = {
        "file":
        {
            "path": tempDirectoryGuid + '/' + strFileName,
            "regions": ["us1"],
            "multipart": false,
            "expires_at": expiresAt
        }
    };
}

// **************************************************************************
// FUNCTION: prepareFileUpload
// USAGE:
// **************************************************************************
TrimbleMap.TcpfShapeImporter.PrepareFileUpload = function PrepareFileUpload() {
    //Get the tcpf shape importer instance ...
    let objTcpfShapeImporter = this;
    let objDeferred = new dojo.Deferred();

    $.ajax({
        url: objTcpfShapeImporter.TcpfConfiguration.ProxyUrl + '?proxyUrl=' + objTcpfShapeImporter.TcpfConfiguration.DataOceanUrl + '/files',
        type: 'POST',
        data: JSON.stringify(objTcpfShapeImporter.FileUploadJson),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        processData: false,
        success: function (response) {

            let objData = {
                FileUploadUrl: response.file.upload.url,
                FilePath: response.file.path,
                FileUploadPath: response.file.path.substring(0, response.file.path.indexOf('/', response.file.path.indexOf('/') + 2))
            };
            objDeferred.resolve(objData);
        }
    }).fail(function (error) {
        console.log(error);
        //TODO
        objDeferred.reject();
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: uploadFileToDataOcean
// USAGE:
// **************************************************************************
TrimbleMap.TcpfShapeImporter.UploadFileToDataOcean = function UploadFileToDataOcean(strFileUploadUrl, objFile) {
    //Get the tcpf shape importer instance ...
    let objTcpfShapeImporter = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    let formData = new FormData();
    formData.append('file', objFile);
    formData.append('upload_file', true);

    //uploade file to url
    $.ajax({
        url: strFileUploadUrl,
        type: 'PUT',
        contentType: false,
        processData: false,
        data: formData,
        success: function (e, response) {
            objDeferred.resolve();
        }
    }).fail(function (data) {
        //TODO
        objDeferred.reject();
    });

    return objDeferred;
};

// **************************************************************************
// FUNCTION: GetFileMetadataFromDataOcean
// USAGE:    
// **************************************************************************
TrimbleMap.TcpfShapeImporter.GetFileMetadataFromDataOcean = function GetFileMetadataFromDataOcean(filePath) {
    //Get the tcpf shape importer instance ...
    let objTcpfShapeImporter = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    $.ajax({
        url: objTcpfShapeImporter.TcpfConfiguration.ProxyUrl + '?proxyUrl=' + objTcpfShapeImporter.TcpfConfiguration.DataOceanUrl + '/files?path=' + filePath,
        type: 'GET',
        async: false, //Why is this sync?
        dataType: 'json',
    }).done(function (response) {

        objDeferred.resolve(response);

    }).fail(function (response) {
        //TODO
        objDeferred.reject();
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: ExecuteTcpfProcedure
// USAGE:    
// **************************************************************************
TrimbleMap.TcpfShapeImporter.ExecuteTcpfProcedure = function ExecuteTcpfProcedure(strFilePath, strFileUploadPath, enumContentFilter) {
    //Get the tcpf shape importer instance ...
    let objTcpfShapeImporter = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    let body = {
        execution: {
            procedure_id: objTcpfShapeImporter.TcpfConfiguration.ProcedureId,
            parameters: {
                DOWNLOAD_PATH: strFilePath,
                ARCHIVE_TYPE: "zip",
                UPLOAD_OUTPUT_PATH: strFileUploadPath,
                UPLOAD_RESTRICTED_ACCESS: "false",
                CONTENT: enumContentFilter
            }
        }
    }

    $.ajax({
        url: objTcpfShapeImporter.TcpfConfiguration.ProxyUrl + '?proxyUrl=' + objTcpfShapeImporter.TcpfConfiguration.TcpfUrl + '/executions',
        type: 'POST',
        data: JSON.stringify(body),
        dataType: 'json',
        contentType: 'application/json',
        processData: false, //what does this do?
    }).done(function (response) {
        //TODO
        objDeferred.resolve(response);

    }).fail(function (response) {
        //TODO
        objDeferred.reject();
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetTcpfProcedureResult
// USAGE:    
// **************************************************************************
TrimbleMap.TcpfShapeImporter.GetTcpfProcedureResult = function GetTcpfProcedureResult(guidExecutionId) {
    //Get the tcpf shape importer instance ...
    let objTcpfShapeImporter = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    $.ajax({
        url: objTcpfShapeImporter.TcpfConfiguration.ProxyUrl + '?proxyUrl=' + objTcpfShapeImporter.TcpfConfiguration.TcpfUrl + '/executions/' + guidExecutionId,
        type: 'GET',
        async: false, //why is this sync?
        dataType: 'json',
    }).done(function (data) {
        objDeferred.resolve(data);

    }).fail(function (data) {
        //TODO
        objDeferred.reject();
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: DownloadFileFromDataOcean
// USAGE:    
// **************************************************************************
TrimbleMap.TcpfShapeImporter.DownloadFileFromDataOcean = function DownloadFileFromDataOcean(guidFileId) {
    //Get the tcpf shape importer instance ...
    let objTcpfShapeImporter = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    $.ajax({
        url: objTcpfShapeImporter.TcpfConfiguration.ProxyUrl + 'raw?proxyUrl=' + objTcpfShapeImporter.TcpfConfiguration.DataOceanUrl + '/files/' + guidFileId + '/download',
        type: 'GET',
    }).done(function (response) {
        //TODO
        objDeferred.resolve(response);

    }).fail(function (data) {
        //TODO
        objDeferred.reject();
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: GetTcpfProcedureError
// USAGE:    
// **************************************************************************
TrimbleMap.TcpfShapeImporter.GetTcpfProcedureError = function GetTcpfProcedureError(guidExecutionId) {
    //Get the tcpf shape importer instance ...
    let objTcpfShapeImporter = this;

    // Create a new deferred to return ...
    let objDeferred = new dojo.Deferred();

    $.ajax({
        url: objTcpfShapeImporter.TcpfConfiguration.ProxyUrl + '?proxyUrl=' + objTcpfShapeImporter.TcpfConfiguration.DataOceanUrl + '/' + guidExecutionId + '/events',
        type: 'GET',
        dataType: 'json',
        beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', BearerToken);
        }
    }).done(function (data) {
        //TODO
        objDeferred.resolve();

    }).fail(function (data) {
        //TODO
        objDeferred.reject();
    });
}

// **************************************************************************
// FUNCTION: Poll
// USAGE:    
// **************************************************************************
TrimbleMap.TcpfShapeImporter.Shared.Poll = function (fnToCall, fnValidateCondition, objDeferred, timeOut) {

    objDeferred ||= new dojo.Deferred();
    timeOut ||= 1000;

    console.log(`Shape Importer polling interval: ${timeOut}ms`);

    //Get the result
    fnToCall().then(TrimbleMap.Controller.Shared.TrapException(function (response) {
        //If the condition is met, return the result
        if (fnValidateCondition(response)) {
            objDeferred.resolve(response);

        } else {
            setTimeout(function () {
                TrimbleMap.TcpfShapeImporter.Shared.Poll(fnToCall, fnValidateCondition, objDeferred, timeOut += 1000);
            }, timeOut);
        }

    })), TrimbleMap.Controller.Shared.TrapException(function (objError) {

        objDeferred.reject(objError);

    });

    return objDeferred;
};
/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ModuleVisibilitySwitcher = {};
TrimbleMap.ModuleVisibilitySwitcher.Shared = {};
TrimbleMap.ModuleVisibilitySwitcher.Shared.MENU_ITEM_NAME = 'MODULE_VISIBILITY_SWITCHER';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    * arrModulesToSwitch should be the the modules that should be switchable,
//             and should be an array of Map.StandardMap.Shared.enumModule values
//             it will also define the order in which the tabs will be diplayed 
//             in the tab switcher sub menu 
//           * arrVisibleModulesOnStartUp should contain values from 
//             Map.StandardMap.Shared.enumModule
//           * fnUpdateUserSettings is passed in from TrimbleMap.UserSettings via TrimbleMap.StandardMap
// **************************************************************************
TrimbleMap.ModuleVisibilitySwitcher.CreateInstance = function CreateInstance(objMapController, objMenu, intMenuItemOrder, arrModulesToSwitch, arrVisibleModulesOnStartUp,
    fnSetModuleVisiblity, fnGetTabDisplayName, fnUpdateUserSettings) {

    // Create the object that will hold the instance properties ...
    var objModuleVisibilitySwitcher = {
        MapController: objMapController,
        Menu: objMenu,
        ModulesToSwitch: arrModulesToSwitch,
        VisibleModulesOnStartUp: arrVisibleModulesOnStartUp,
        SetModuleVisiblityFunction: fnSetModuleVisiblity,
        GetTabDisplayNameFunction: fnGetTabDisplayName,
        ModuleVisibility: null,
        TabsListDiv: null,

        ActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objModuleVisibilitySwitcher.ActivateSubMenu(objMenuItem, objSubMenuDiv) },
        DeActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objModuleVisibilitySwitcher.DeActivateSubMenu(objMenuItem, objSubMenuDiv) },
        ModuleVisibilitySwitcherClickedProxy: function (e) { objModuleVisibilitySwitcher.ModuleVisibilitySwitcherClicked(e) },
        ModuleVisibilityChangedProxy: function (enModule, blnVisible) { objModuleVisibilitySwitcher.ModuleVisibilityChanged(enModule, blnVisible) },

        InitializeModuleVisibility: TrimbleMap.ModuleVisibilitySwitcher.InitializeModuleVisibility,
        IsModuleVisible: TrimbleMap.ModuleVisibilitySwitcher.IsModuleVisible,
        SetModuleVisibility: TrimbleMap.ModuleVisibilitySwitcher.SetModuleVisibility,
        ActivateSubMenu: TrimbleMap.ModuleVisibilitySwitcher.ActivateSubMenu,
        DeActivateSubMenu: TrimbleMap.ModuleVisibilitySwitcher.DeActivateSubMenu,
        ModuleVisibilitySwitcherClicked: TrimbleMap.ModuleVisibilitySwitcher.ModuleVisibilitySwitcherClicked,
        ModuleVisibilityChanged: TrimbleMap.ModuleVisibilitySwitcher.ModuleVisibilityChanged,
        UpdateUserSettings: fnUpdateUserSettings
    };

    // Create and add the menu item ...
    objMenu.AddMenuItem(TrimbleMap.Menu.Shared.CreateMenuItem(TrimbleMap.ModuleVisibilitySwitcher.Shared.MENU_ITEM_NAME, 'Show', intMenuItemOrder, true, null, objModuleVisibilitySwitcher.ActivateSubMenuProxy, objModuleVisibilitySwitcher.DeActivateSubMenuProxy));

    // Initialize teh module visibility from the startup values ...
    objModuleVisibilitySwitcher.InitializeModuleVisibility();

    // Attach the module visibility changed event handler ...
    objMapController.AddNotifyModuleVisibilityChanged(objModuleVisibilitySwitcher.ModuleVisibilityChangedProxy);

    return objModuleVisibilitySwitcher;
}

// **************************************************************************
// FUNCTION: InitializeModuleVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.ModuleVisibilitySwitcher.InitializeModuleVisibility = function InitializeModuleVisibility() {

    // Get the instance ...
    var objModuleVisibilitySwitcher = this;

    // Create a new hash table for the module visibility values ...
    objModuleVisibilitySwitcher.ModuleVisibility = {};

    // Loop through all the modules to switch ..
    $.each(objModuleVisibilitySwitcher.ModulesToSwitch, function (intModule, enModule) {

        // Set the module to be visible when in objModuleVisibilitySwitcher.VisibleModulesOnStartUp ...
        objModuleVisibilitySwitcher.ModuleVisibility[enModule] = ($.inArray(enModule, objModuleVisibilitySwitcher.VisibleModulesOnStartUp) > -1);
    });
}

// **************************************************************************
// FUNCTION: IsModuleVisible
// USAGE:    
// **************************************************************************
TrimbleMap.ModuleVisibilitySwitcher.IsModuleVisible = function IsModuleVisible(enModule) {

    // Get the instance ...
    var objModuleVisibilitySwitcher = this;

    // Get the module visibility ...
    var blnVisible = objModuleVisibilitySwitcher.ModuleVisibility[enModule];

    return blnVisible;
}

// **************************************************************************
// FUNCTION: SetModuleVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.ModuleVisibilitySwitcher.SetModuleVisibility = function SetModuleVisibility(enModule, blnVisible) {

    // Get the instance ...
    var objModuleVisibilitySwitcher = this;

    // Set the module visibility ...
    objModuleVisibilitySwitcher.ModuleVisibility[enModule] = blnVisible;

    // Call SetModuleVisiblityFunction to actually show or hide the module ...
    objModuleVisibilitySwitcher.SetModuleVisiblityFunction(enModule, blnVisible);

    return blnVisible;
}

// **************************************************************************
// FUNCTION: ModuleVisibilityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ModuleVisibilitySwitcher.ModuleVisibilityChanged = function ModuleVisibilityChanged(enModule, blnVisible) {

    // Get the instance ...
    var objModuleVisibilitySwitcher = this;

    // Set the module's visibility ...
    objModuleVisibilitySwitcher.SetModuleVisibility(enModule, blnVisible);
}

// **************************************************************************
// FUNCTION: ActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ModuleVisibilitySwitcher.ActivateSubMenu = function ActivateSubMenu(objMenuItem, objSubMenuDiv) {

    // Get the instance ...
    var objModuleVisibilitySwitcher = this;

    // Create the list's div ...
    objModuleVisibilitySwitcher.TabsListDiv = $('<div></div>');

    // Loop through all the modules to switch ...
    for (var intModuleToSwitch = 0; intModuleToSwitch < objModuleVisibilitySwitcher.ModulesToSwitch.length; intModuleToSwitch++) {

        // Get the module to swicth ...
        var enModule = objModuleVisibilitySwitcher.ModulesToSwitch[intModuleToSwitch];

        // Get the tab display name ...
        var strTabDisplayName = objModuleVisibilitySwitcher.GetTabDisplayNameFunction(enModule);

        // When the module is suported by the tab switcher ...
        if (strTabDisplayName) {

            // Create a div for the map row ...
            var objMapRowDiv = $('<div class="module-item" enumModule="' + enModule + '"></div>');

            // Add a span with the map name ...
            objMapRowDiv.append('<span>' + strTabDisplayName + '</span>')

            // Add the row div to the list div ...
            objModuleVisibilitySwitcher.TabsListDiv.append(objMapRowDiv);

            // Add the check div ...
            objMapRowDiv.append('<div class="' + ((objModuleVisibilitySwitcher.IsModuleVisible(enModule)) ? 'checked' : 'unchecked') + '"></div>')

        }
    }

    // Add it to the sub menu div ...
    objSubMenuDiv.append(objModuleVisibilitySwitcher.TabsListDiv);

    // Attach the click event handler ...
    objModuleVisibilitySwitcher.TabsListDiv.click(objModuleVisibilitySwitcher.ModuleVisibilitySwitcherClickedProxy);
}

// **************************************************************************
// FUNCTION: DeActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ModuleVisibilitySwitcher.DeActivateSubMenu = function DeActivateSubMenu(objMenuItem, objSubMenuDiv) {

    // Get the instance ...
    var objModuleVisibilitySwitcher = this;

    // Detach the click event handler ...
    objModuleVisibilitySwitcher.TabsListDiv.off('click', objModuleVisibilitySwitcher.ModuleVisibilitySwitcherClickedProxy);

    // Remove the div from the container ...
    objModuleVisibilitySwitcher.TabsListDiv.remove();
}

// **************************************************************************
// FUNCTION: ModuleVisibilitySwitcherClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ModuleVisibilitySwitcher.ModuleVisibilitySwitcherClicked = function ModuleVisibilitySwitcherClicked(e) {

    // Get the instance ...
    var objModuleVisibilitySwitcher = this;

    // Get the element clicked on ...
    var objTarget = $(e.target);

    // Attempt to find an element with the enumModule up the DOM tree ...
    var objModuleDiv = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'enumModule');

    // When found ...
    if (objModuleDiv) {

        // Get the module enum ...
        var enModule = objModuleDiv.attr('enumModule');

        // Get the module visibility ...
        var blnIsModuleVisible = objModuleVisibilitySwitcher.IsModuleVisible(enModule);

        // Flip the module visibility ...
        objModuleVisibilitySwitcher.SetModuleVisibility(enModule, (!blnIsModuleVisible));

        // When the module were visible ...
        if (blnIsModuleVisible) {

            // Remove the check ...
            $(objModuleDiv.find('.checked')).removeClass('checked').addClass('unchecked');

        } else {

            // Add the check ...
            $(objModuleDiv.find('.unchecked')).removeClass('unchecked').addClass('checked');
        }

        objModuleVisibilitySwitcher.UpdateUserSettings(TrimbleMap.UserSettings.Shared.enumSetting.ModulesVisible, { "module": enModule, "enabled": !blnIsModuleVisible });
    }
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Preferences = {};
TrimbleMap.Preferences.Shared = {};
TrimbleMap.Preferences.Shared.CANCEL_BUTTON = 'CANCEL';
TrimbleMap.Preferences.Shared.OK_BUTTON = 'OK';

TrimbleMap.Preferences.enumPreference = {};
TrimbleMap.Preferences.enumPreference.DisplaySeparateParts = 'DisplaySeparateParts';
TrimbleMap.Preferences.enumPreference.KeepSearchAndSelectResults = 'KeepSearchAndSelectResults';
TrimbleMap.Preferences.enumPreference.InitialExtent = 'InitialExtent';

TrimbleMap.Preferences.enumUserInitialExtentType = {};
TrimbleMap.Preferences.enumUserInitialExtentType.ApplyToAllMaps = 'ApplyToAllMaps';
TrimbleMap.Preferences.enumUserInitialExtentType.EachMapHaveOwnInitialExtent = 'EachMapHaveOwnInitialExtent';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.CreateInstance = function CreateInstance(objMapController, objMenuInstance, intMenuItemOrder, objUserSettings) {

    // Create the object that will hold the instance properties ...
    var objPreferences = {
        MapController: objMapController,
        MenuInstance: objMenuInstance,
        SubMenuContentDiv: null,
        PreferencesDiv: null,
        InitialExtentDialogDiv: null,
        InitialExtentDialog: null,
        BookmarksDiv: null,
        ScrollableBookmarksDiv: null,
        BookmarksDivNiceScroll: null,
        SelectedInitialExtentBookmark: null,
        ApplyToAllMaps: false,
        UserSettings: objUserSettings,

        ActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objPreferences.ActivateSubMenu(objMenuItem, objSubMenuDiv) },
        DeActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objPreferences.DeActivateSubMenu(objMenuItem, objSubMenuDiv) },

        ClickedHandlerProxy: function (e) { objPreferences.ClickedHandler(e) },
        InitialExtentDialogClickedProxy: function (e) { objPreferences.InitialExtentDialogClicked(e) },

        ActivateSubMenu: TrimbleMap.Preferences.ActivateSubMenu,
        DeActivateSubMenu: TrimbleMap.Preferences.DeActivateSubMenu,
        CreateSubMenuContentDiv: TrimbleMap.Preferences.CreateSubMenuContentDiv,
        ClickedHandler: TrimbleMap.Preferences.ClickedHandler,
        InitialExtentDialogClicked: TrimbleMap.Preferences.InitialExtentDialogClicked,
        PopulateFromPreferences: TrimbleMap.Preferences.PopulateFromPreferences,
        GetBookmarkNameByID: TrimbleMap.Preferences.GetBookmarkNameByID,
        AcceptInitialExtentDialog: TrimbleMap.Preferences.AcceptInitialExtentDialog,
        OpenChangeInitialExtentDialog: TrimbleMap.Preferences.OpenChangeInitialExtentDialog,
        CloseChangeInitialExtentDialog: TrimbleMap.Preferences.CloseChangeInitialExtentDialog,
        CreateInitialExtentDialogDiv: TrimbleMap.Preferences.CreateInitialExtentDialogDiv,
        SetInitialExtentBookmarkIDForCurrentMap: TrimbleMap.Preferences.SetInitialExtentBookmarkIDForCurrentMap,
        AttachEventHandlersForInitialExtentDialog: TrimbleMap.Preferences.AttachEventHandlersForInitialExtentDialog,
        DetachEventHandlersForInitialExtentDialog: TrimbleMap.Preferences.DetachEventHandlersForInitialExtentDialog,
        AttachEventHandlers: TrimbleMap.Preferences.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Preferences.DetachEventHandlers
    };

    // Create and add the menu item ...
    objMenuInstance.AddMenuItem(TrimbleMap.Menu.Shared.CreateMenuItem('PREFERENCES', SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'MenuItemName'), intMenuItemOrder, true, null, objPreferences.ActivateSubMenuProxy, objPreferences.DeActivateSubMenuProxy));

    return objPreferences;
}

// **************************************************************************
// FUNCTION: ActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.ActivateSubMenu = function ActivateSubMenu(objMenuItem, objSubMenuDiv) {

    // Get the instance ...
    var objPreferences = this;

    // Create the sub menu content div ...
    objPreferences.CreateSubMenuContentDiv();

    // Add the content to the sub menu container div ...
    objSubMenuDiv.append(objPreferences.SubMenuContentDiv);

    // Attach the event handlers ...
    objPreferences.AttachEventHandlers()
}

// **************************************************************************
// FUNCTION: DeActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.DeActivateSubMenu = function DeActivateSubMenu(objMenuItem, objSubMenuDiv) {

    // Get the instance ...
    var objPreferences = this;

    // Detach the event handlers ...
    objPreferences.DetachEventHandlers();
}

// **************************************************************************
// FUNCTION: CreateSubMenuContentDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.CreateSubMenuContentDiv = function CreateSubMenuContentDiv() {

    // Get the instance ...
    var objPreferences = this;

    // Simultaneously select all parts of a multi-part shape
    var strSimultaneouslySelectAllParts = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'SimultaneouslySelectAllParts');

    // Keep previous search and select results while signed in
    var strKeepSearchAndSelectResults = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'KeepPreviousSearchAndSelectResults');

    // Initial extent (bookmark)
    var strInitialExtentBookmark = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'InitialExtentBookmark') + ':';

    // Change
    var strChange = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'ChangeInitialExtent');

    // Create the div ...
    objPreferences.SubMenuContentDiv = $('<div></div>');

    // Create the multi part option div ...
    objPreferences.PreferencesDiv = $('<div class="checklist"></div>');

    // Add the simultaneousely select all parts of a multi part shape option ...
    objPreferences.PreferencesDiv.append('<div SimultaneouslySelectAllParts="true" class="preferences-item"><div IsCheckDiv="true" class="check-icon"></div><span>' + strSimultaneouslySelectAllParts + '</span></div>');

    // Add the keep search and select results option ...
    objPreferences.PreferencesDiv.append('<div KeepSearchAndSelectResults="true" class="preferences-item"><div IsCheckDiv="true" class="check-icon"></div><span>' + strKeepSearchAndSelectResults + '</span></div>');

    // Add the initial extent bookmark option ...
    objPreferences.PreferencesDiv.append('<div InitialExtentBookmark="true" class="initial-extent"><span>' + strInitialExtentBookmark + '</span><span InitialExtentBookmarkName="true" class="bold">&nbsp;</span><span ChangeInitialExtentButton="true" class="link">(' + strChange + ')</span></div>');

    // Populate from the preferences ...
    objPreferences.PopulateFromPreferences();

    // Add it to the sub menu div ...
    objPreferences.SubMenuContentDiv.append(objPreferences.PreferencesDiv);
}

// **************************************************************************
// FUNCTION: PopulateFromPreferences
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.PopulateFromPreferences = function PopulateFromPreferences() {

    // Get the instance ...
    var objPreferences = this;

    // When parts are to be displayed separately ...
    if (objPreferences.MapController.Preferences.DisplaySeparateParts) {

        // Remove the checked class ...
        objPreferences.PreferencesDiv.find('[SimultaneouslySelectAllParts]').find('.check-icon').removeClass('checked');

    } else {

        // Add the checked class ...
        objPreferences.PreferencesDiv.find('[SimultaneouslySelectAllParts]').find('.check-icon').addClass('checked');
    }

    // When we are to keep the search and select results ...
    if (objPreferences.MapController.Preferences.KeepSearchAndSelectResults) {

        // Add the checked class ...
        objPreferences.PreferencesDiv.find('[KeepSearchAndSelectResults]').find('.check-icon').addClass('checked');

    } else {

        // Remove the checked class ...
        objPreferences.PreferencesDiv.find('[KeepSearchAndSelectResults]').find('.check-icon').removeClass('checked');
    }

    // Set the initial extent bookmark name ...
    objPreferences.PreferencesDiv.find('[InitialExtentBookmarkName]').text(objPreferences.GetBookmarkNameByID(objPreferences.MapController.GetUserInitialExtentBookmarkIDForCurrentMap()));
}

// **************************************************************************
// FUNCTION: ClickedHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.ClickedHandler = function ClickedHandler(e) {

    // Get the instance ...
    var objPreferences = this;

    // Get the clicked target ...
    var objTarget = $(e.target);

    // Check if in a div with class preferences_check_div ...
    var objDisplaySeparatePartsDiv = SD.DOM.GetElementOrParentWithClass(objTarget, 'checklist');

    // When in a div with class preferences_check_div ...
    if (objDisplaySeparatePartsDiv != null) {

        // Get the option clciked on based on the attaribute ... 
        var objSimultaneouslySelectAllParts = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'SimultaneouslySelectAllParts');
        var objKeepSearchAndSelectResults = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'KeepSearchAndSelectResults');
        var objChangeInitialExtent = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ChangeInitialExtentButton');

        // Depending on which option were clicked on ...
        if (objSimultaneouslySelectAllParts != null) {

            // Change the DisplaySeparateParts setting ...
            objPreferences.MapController.Preferences.DisplaySeparateParts = !objPreferences.MapController.Preferences.DisplaySeparateParts;

            // Trigger the preference changed notifications ...
            objPreferences.MapController.TriggerNotifyPreferenceChanged([TrimbleMap.Preferences.enumPreference.DisplaySeparateParts]);

        } else if (objKeepSearchAndSelectResults != null) {

            // Change the KeepSearchAndSelectResults setting ...
            objPreferences.MapController.Preferences.KeepSearchAndSelectResults = !objPreferences.MapController.Preferences.KeepSearchAndSelectResults;

            // Trigger the preference changed notifications ...
            objPreferences.MapController.TriggerNotifyPreferenceChanged([TrimbleMap.Preferences.enumPreference.KeepSearchAndSelectResults]);

        } else if (objChangeInitialExtent != null) {

            // Hide the menu ...
            objPreferences.MenuInstance.Hide();

            // Prevent the post back ...
            e.preventDefault();

            // Open the change initial extent dialog ...
            objPreferences.OpenChangeInitialExtentDialog();
        }

        // Update the interface from the prefrenecs ...
        objPreferences.PopulateFromPreferences();
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlersForInitialExtentDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.AttachEventHandlersForInitialExtentDialog = function AttachEventHandlersForInitialExtentDialog() {

    // Get the instance ...
    var objPreferences = this;

    // Attach the clicked handler ...
    objPreferences.InitialExtentDialogDiv.click(objPreferences.InitialExtentDialogClickedProxy);

    // Create a scrollbar ...
    objPreferences.BookmarksDivNiceScroll = objPreferences.ScrollableBookmarksDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });
}

// **************************************************************************
// FUNCTION: DetachEventHandlersForInitialExtentDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.DetachEventHandlersForInitialExtentDialog = function DetachEventHandlersForInitialExtentDialog() {

    // Get the instance ...
    var objPreferences = this;

    // Detach the clicked handler ...
    objPreferences.InitialExtentDialogDiv.off('click', objPreferences.InitialExtentDialogClickedProxy);

    // Remove the scrollbar ...
    objPreferences.BookmarksDivNiceScroll.hide();
    objPreferences.BookmarksDivNiceScroll.remove();
}

// **************************************************************************
// FUNCTION: InitialExtentDialogClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.InitialExtentDialogClicked = function InitialExtentDialogClicked(e) {

    // Get the instance ...
    var objPreferences = this;

    // Get the clicked target ...
    var objTarget = $(e.target);

    // Determine what the user clicked on ...
    var objBookmarkDiv = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'BookmarkID');
    var objApplyToAllMaps = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ApplyToAllMaps');

    // When the user clicked on a bookmark ...
    if (objBookmarkDiv != null) {

        // Set the bookmark id ...
        objPreferences.SelectedInitialExtentBookmark = objBookmarkDiv.attr('BookmarkID');

        // Remove the selected class from the previously selected bookmark ...
        objPreferences.BookmarksDiv.children().removeClass('selected');

        // Add the selected class to the newly selected bookmark ...
        objBookmarkDiv.addClass('selected');

    } else if (objApplyToAllMaps != null) {

        // Swap the apply to all maps ...
        objPreferences.ApplyToAllMaps = !objPreferences.ApplyToAllMaps;

        // Get the checkbox div ...
        var objCheckDiv = $(objApplyToAllMaps.find('[IsCheckDiv]'));

        // When to be applied to all the maps, add the checked class, otherwise remove it ...
        if (objPreferences.ApplyToAllMaps) { objCheckDiv.addClass('checked'); } else { objCheckDiv.removeClass('checked'); }
    }
}

// **************************************************************************
// FUNCTION: GetBookmarkNameByID
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.GetBookmarkNameByID = function GetBookmarkNameByID(guidBookmark) {

    // Get the instance ...
    var objPreferences = this;

    // Attempt to get the initial extent bookmark ...
    var objInitialExtentBookmark = objPreferences.MapController.GetBookmark(guidBookmark);

    // When found ...
    if ((typeof objInitialExtentBookmark != 'undefined') && (objInitialExtentBookmark != null)) {

        // Return the bookmark name ... 
        return objInitialExtentBookmark.BookmarkName;

    } else {

        // Default of map
        return SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'DefaultOfMap');
    }
}

// **************************************************************************
// FUNCTION: OpenChangeInitialExtentDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.OpenChangeInitialExtentDialog = function OpenChangeInitialExtentDialog() {

    // Get the instance ...
    var objPreferences = this;

    // Create the initial extent dialog div ...
    objPreferences.CreateInitialExtentDialogDiv();

    // CANCEL
    var strCancel = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'Cancel');
    var strOK = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'OK');

    // Create the dialog buttons ...
    var arrButtons = [TrimbleMap.MessageBox.Shared.CreateMessageBoxButton(TrimbleMap.Preferences.Shared.OK_BUTTON, strOK, function () { objPreferences.AcceptInitialExtentDialog(); }),
    TrimbleMap.MessageBox.Shared.CreateMessageBoxButton(TrimbleMap.Preferences.Shared.CANCEL_BUTTON, strCancel, function () { objPreferences.CloseChangeInitialExtentDialog(); })];

    // Initial extent of map
    var strTitle = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'InitialExtentOfMap');

    // Show the dialog ...
    objPreferences.InitialExtentDialog = TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, null, arrButtons, 500, objPreferences.InitialExtentDialogDiv, false);

    // When the initial extent dialog opened ...
    objPreferences.InitialExtentDialog.Deferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

        // Attach the event handlers ...
        objPreferences.AttachEventHandlersForInitialExtentDialog();
    }));
}

// **************************************************************************
// FUNCTION: CloseChangeInitialExtentDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.CloseChangeInitialExtentDialog = function CloseChangeInitialExtentDialog() {

    // Get the instance ...
    var objPreferences = this;

    // Detach the event handlers ...
    objPreferences.DetachEventHandlersForInitialExtentDialog();

    // Close the initial extent dialog ...
    objPreferences.InitialExtentDialog.Close();
}

// **************************************************************************
// FUNCTION: AcceptInitialExtentDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.AcceptInitialExtentDialog = function AcceptInitialExtentDialog() {

    // Get the instance ...
    var objPreferences = this;

    // Set the initial extent bookmark of the current map ...
    objPreferences.SetInitialExtentBookmarkIDForCurrentMap();

    let objUpdatedPreferences = {
        'DisplaySeparateParts': objPreferences.MapController.Preferences.DisplaySeparateParts,
        'KeepSearchAndSelectResults': objPreferences.MapController.Preferences.KeepSearchAndSelectResults,
        'InitialExtentBookmarkIDByMapID': objPreferences.MapController.Preferences.InitialExtentBookmarkIDByMapID,
        'InitialExtentIDForAllMaps': objPreferences.MapController.Preferences.InitialExtentIDForAllMaps,
        'InitialExtentType': objPreferences.MapController.Preferences.InitialExtentType
    };

    // Update User preference settings 
    objPreferences.UserSettings.UpdateUserSettings(TrimbleMap.UserSettings.Shared.enumSetting.Preferences, objUpdatedPreferences);

    // Trigger the preference changed notifications ...
    objPreferences.MapController.TriggerNotifyPreferenceChanged([TrimbleMap.Preferences.enumPreference.InitialExtent]);

    // Close the dialog ...
    objPreferences.CloseChangeInitialExtentDialog();
}

// **************************************************************************
// FUNCTION: SetInitialExtentBookmarkIDForCurrentMap
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.SetInitialExtentBookmarkIDForCurrentMap = function SetInitialExtentBookmarkIDForCurrentMap() {

    // Get the instance ...
    var objPreferences = this;

    // When to be applied to all maps ....
    if (objPreferences.ApplyToAllMaps) {

        // Set for all maps ...
        objPreferences.MapController.Preferences.InitialExtentType = TrimbleMap.Preferences.enumUserInitialExtentType.ApplyToAllMaps;

        // Clear the initial extent per map dictionary ...
        objPreferences.MapController.Preferences.InitialExtentBookmarkIDByMapID = {};

        // Set the initial extent bookmark id to be used for all maps ...
        objPreferences.MapController.Preferences.InitialExtentIDForAllMaps = objPreferences.SelectedInitialExtentBookmark;

    } else {

        // When currently set for all maps ...
        if (objPreferences.MapController.Preferences.InitialExtentType == TrimbleMap.Preferences.enumUserInitialExtentType.ApplyToAllMaps) {

            // Clear the initial extent per map dictionary ...
            objPreferences.MapController.Preferences.InitialExtentBookmarkIDByMapID = {};

            // Loop through all the maps ...
            $.each(objPreferences.MapController.State.Maps, function (intMap, objMap) {

                // Set the initial extent bookmark for the map to be the initial extent that was set for all maps ...
                objPreferences.MapController.Preferences.InitialExtentBookmarkIDByMapID[objMap.MapID] = objPreferences.MapController.Preferences.InitialExtentIDForAllMaps;
            });
        }

        // Set to have an initial extent for each map ...
        objPreferences.MapController.Preferences.InitialExtentType = TrimbleMap.Preferences.enumUserInitialExtentType.EachMapHaveOwnInitialExtent;

        // Set the initial extent bookmark for the current map ...
        objPreferences.MapController.Preferences.InitialExtentBookmarkIDByMapID[objPreferences.MapController.CurrentMap.MapID] = objPreferences.SelectedInitialExtentBookmark;
    }
}

// **************************************************************************
// FUNCTION: CreateInitialExtentDialogDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.CreateInitialExtentDialogDiv = function CreateInitialExtentDialogDiv() {

    // Get the instance ...
    var objPreferences = this;

    // Create the dialog div 
    objPreferences.InitialExtentDialogDiv = $('<div></div>');

    // The intial extent is
    var strCurrentBookmark = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'TheIntialExtentIs') + ': ';

    // Get the current map's initial extent bookmark name ...
    var strBookmarkName = objPreferences.GetBookmarkNameByID(objPreferences.MapController.GetUserInitialExtentBookmarkIDForCurrentMap());

    // Add the message ...
    objPreferences.InitialExtentDialogDiv.append('<span>' + strCurrentBookmark + '</span><span class="current-bookmark">' + strBookmarkName + '</span>');

    // Select the bookmark to be used as the initial extent for this map
    var strMessage = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'SelectBookmarkForIntialExtent') + ':';

    // Add the message ...
    objPreferences.InitialExtentDialogDiv.append('<div class="initial-extent-message"><span>' + strMessage + '</span></div>');

    // Create a new div to contain the bookmarks ...
    objPreferences.ScrollableBookmarksDiv = $('<div  class="preferences-scroll-bookmarks"></div>');

    // Set max heigth to make the div scrollable ...
    objPreferences.ScrollableBookmarksDiv.css('max-height', '315px');

    // Add the bookmarks div ...
    objPreferences.InitialExtentDialogDiv.append(objPreferences.ScrollableBookmarksDiv);

    // Create a new div to contain the bookmarks ...
    objPreferences.BookmarksDiv = $('<div  class="preferences-bookmarks"></div>');

    // Add the bookmarks div ...
    objPreferences.ScrollableBookmarksDiv.append(objPreferences.BookmarksDiv);

    // Let guidDefaultOfMapService be the empty guid and get the 'Default of map service' translation text ...
    var guidDefaultOfMapService = SD.Guid.Shared.Empty();
    var strDefaultBookmarkName = objPreferences.GetBookmarkNameByID(guidDefaultOfMapService);

    // Get the initial extent bookmark ID ...
    var guidInitialExtentBookmark = objPreferences.MapController.GetUserInitialExtentBookmarkIDForCurrentMap();

    // Determine the css class to add to indicate selection ...
    var strSelectedCss = ((guidDefaultOfMapService.toLowerCase() == guidInitialExtentBookmark.toLowerCase()) ? ' selected' : '');

    // Add the default of map service list entry for the bookmark ...
    objPreferences.BookmarksDiv.append($('<div class="bookmark-item' + strSelectedCss + '" BookmarkID="' + guidDefaultOfMapService + '"><span class="default-bookmark">' + strDefaultBookmarkName + '</span></div>'));

    // Loop through all the bookmarks ...
    $.each(objPreferences.MapController.State.Bookmarks, function (intBookmark, objBookmark) {

        // When for the current user ...
        if ((objBookmark.UserID != SD.Guid.Shared.DefaultUserID) && (objBookmark.UserID == objPreferences.MapController.State.LoggedInUserID)) {

            // Determine the css class to add to indicate selection ...
            var strSelectedCss = ((objBookmark.BookmarkID.toLowerCase() == guidInitialExtentBookmark.toLowerCase()) ? ' selected' : '');

            // Add a list entry for the bookmark ...
            objPreferences.BookmarksDiv.append($('<div class="bookmark-item' + strSelectedCss + '" BookmarkID="' + objBookmark.BookmarkID + '"><span>' + objBookmark.BookmarkName + '</span></div>'));
        }
    });

    // Apply to all maps
    var strApplyToAllMaps = SD.Translation.Shared.GetTranslation('Map.Preferences.js', 'ApplyToAllMaps');

    // Determine whether or not to apply to all maps ...
    objPreferences.ApplyToAllMaps = (objPreferences.MapController.Preferences.InitialExtentType == TrimbleMap.Preferences.enumUserInitialExtentType.ApplyToAllMaps);

    // Add the apply to all maps checkbox ...
    objPreferences.InitialExtentDialogDiv.append('<div ApplyToAllMaps="true" class="apply-to-all"><div IsCheckDiv="true" class="preferences-checkbox ' + ((objPreferences.ApplyToAllMaps) ? ' checked' : '') + '"></div><span>' + strApplyToAllMaps + '</span></div>');
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.AttachEventHandlers = function AttachEventHandlers(e) {

    // Get the instance ...
    var objPreferences = this;

    // Attach the click event hanlder ...
    objPreferences.SubMenuContentDiv.click(objPreferences.ClickedHandlerProxy);
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.DetachEventHandlers = function DetachEventHandlers(e) {

    // Get the instance ...
    var objPreferences = this;

    // Detach the click event hanlder ...
    objPreferences.SubMenuContentDiv.off('click', objPreferences.ClickedHandlerProxy);
}

// **************************************************************************
// FUNCTION: CreatePreferences
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.Shared.CreatePreferences = function CreatePreferences(blnDisplaySeparateParts, blnKeepSearchAndSelectResults) {

    // Create and return the legend section data ...
    return {
        DisplaySeparateParts: blnDisplaySeparateParts,
        KeepSearchAndSelectResults: blnKeepSearchAndSelectResults,
        InitialExtentType: TrimbleMap.Preferences.enumUserInitialExtentType.EachMapHaveOwnInitialExtent,
        InitialExtentBookmarkIDByMapID: {},
        InitialExtentIDForAllMaps: SD.Guid.Shared.Empty()
    };
}

// **************************************************************************
// FUNCTION: CreateOptions
// USAGE:    
// **************************************************************************
TrimbleMap.Preferences.Shared.CreateOptions = function CreateOptions(objPreferences) {

    // Create and return the options object ...
    return {
        Preferences: objPreferences
    };
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Print = {}
TrimbleMap.Print.Shared = {};
TrimbleMap.Print.Shared.MIN_SCALE = 1000;
TrimbleMap.Print.Shared.MAX_SCALE = 100000000;

// **************************************************************************
// ENUM enumResolution
// **************************************************************************
TrimbleMap.Print.enumResolution = {}
TrimbleMap.Print.enumResolution.Standard = '150';
TrimbleMap.Print.enumResolution.High = '300';
TrimbleMap.Print.enumResolution.VeryHigh = '600';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Print.CreateInstance = function CreateInstance(objMapController, objMenuInstance, intMenuItemOrder, blnVisible) {

    // Create the object that will hold the instance properties ...
    var objPrintInstance = {
        MapController: objMapController,
        MenuInstance: objMenuInstance,
        Visible: false,
        PrintMenuItem: null,
        DialogDiv: null,
        DialogID: null,
        TemplateDropDown: null,
        FormatDropDown: null,
        CurrentExtentRadioButton: null,
        CurrentScaleRadioButton: null,
        SpecificScaleRadioButton: null,
        SpecificScaleTextBox: null,
        ExportButton: null,
        Formats: ['PDF', 'PNG32', 'PNG8', 'JPG', 'GIF', 'EPS', 'SVG', 'SVGZ'],
        Templates: null,
        ProcessingDiv: null,
        InitialCurrentExtentRadioButtonValue: true,
        InitialCurrentScaleRadioButtonValue: false,
        InitialSpecificScaleRadioButtonValue: false,
        ResolutionDropDown: null,

        ClickedProxy: function (objMenuItem) { objPrintInstance.Clicked(objMenuItem) },
        ExportClickedProxy: function (e) { objPrintInstance.ExportClicked(e) },
        OnModalDialogClosedProxy: function (intModalOrder) { objPrintInstance.OnModalDialogClosed(intModalOrder) },
        UpdateSpecificScaleReadOnlyProxy: function () { objPrintInstance.UpdateSpecificScaleReadOnly() },
        ExtentOptionsTextClickedProxy: function (e) { objPrintInstance.ExtentOptionsTextClicked(e) },
        WindowResizedProxy: function () { objPrintInstance.WindowResized() },

        AttachEventHandlers: TrimbleMap.Print.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Print.DetachEventHandlers,
        ShowDialog: TrimbleMap.Print.ShowDialog,
        CreateDialog: TrimbleMap.Print.CreateDialog,
        LoadTemplates: TrimbleMap.Print.LoadTemplates,
        ShowProcessingDiv: TrimbleMap.Print.ShowProcessingDiv,
        HideProcessingDiv: TrimbleMap.Print.HideProcessingDiv,
        Clicked: TrimbleMap.Print.Clicked,
        ExportClicked: TrimbleMap.Print.ExportClicked,
        UpdateSpecificScaleReadOnly: TrimbleMap.Print.UpdateSpecificScaleReadOnly,
        ExtentOptionsTextClicked: TrimbleMap.Print.ExtentOptionsTextClicked,
        OnModalDialogClosed: TrimbleMap.Print.OnModalDialogClosed,
        ValidateDialogInput: TrimbleMap.Print.ValidateDialogInput,
        SaveInitialRadioButtonValues: TrimbleMap.Print.SaveInitialRadioButtonValues,
        WindowResized: TrimbleMap.Print.WindowResized,
        Show: TrimbleMap.Print.Show,
        Hide: TrimbleMap.Print.Hide,
        Shared: {
            DownloadFile: TrimbleMap.Print.Shared.DownloadFile
        }
    };

    // Create the menu item ...
    objPrintInstance.PrintMenuItem = TrimbleMap.Menu.Shared.CreateMenuItem('PRINT', SD.Translation.Shared.GetTranslation('Map.Print.js', 'MenuItemName'), intMenuItemOrder, false, objPrintInstance.ClickedProxy, null, null);

    // Show the menu button when its to be visible at startup ...
    if (blnVisible) { objPrintInstance.Show(); }

    return objPrintInstance;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    
// **************************************************************************
TrimbleMap.Print.Show = function Show() {

    // Get the instance ...
    var objPrint = this;

    // When not visible ...
    if (!objPrint.Visible) {

        // Add the menu item ...
        objPrint.MenuInstance.AddMenuItem(objPrint.PrintMenuItem);

        // Set to be visible ...
        objPrint.Visible = true;
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
TrimbleMap.Print.Hide = function Hide() {

    // Get the instance ...
    var objPrint = this;

    // When visible ...
    if (objPrint.Visible) {

        // Remove the menu item ...
        objPrint.MenuInstance.RemoveMenuItem(objPrint.PrintMenuItem);

        // Set to not be visible ...
        objPrint.Visible = false;
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Print.AttachEventHandlers = function AttachEventHandlers() {

    // Get the map zoom instance ...
    var objPrint = this;

    // Attach the clicked event handler to the export button ...
    objPrint.ExportButton.click(objPrint.ExportClickedProxy);

    // Attach the changed event handler to the specific scale radio button ...
    objPrint.CurrentExtentRadioButton.change(objPrint.UpdateSpecificScaleReadOnlyProxy);
    objPrint.CurrentScaleRadioButton.change(objPrint.UpdateSpecificScaleReadOnlyProxy);
    objPrint.SpecificScaleRadioButton.change(objPrint.UpdateSpecificScaleReadOnlyProxy);

    // Attach a click event handler to the radio button spans ...
    objPrint.DialogDiv.find('.PrintScaleOptionsText').click(objPrint.ExtentOptionsTextClickedProxy);

    // Attach the on modal dialog closed event handler ...
    TrimbleMap.ModalDialog.Shared.AddOnClosedHandler(objPrint.OnModalDialogClosedProxy);

    // Attach the resize event handler ...
    $(window).resize(objPrint.WindowResizedProxy);
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Print.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map zoom instance ...
    var objPrint = this;

    // Detach the clicked event handler from the export button ...
    objPrint.ExportButton.off('click', objPrint.ExportClickedProxy);

    // Detach the changed event handler to the specific scale radio button ...
    objPrint.CurrentExtentRadioButton.off('change', objPrint.UpdateSpecificScaleReadOnlyProxy);
    objPrint.CurrentScaleRadioButton.off('change', objPrint.UpdateSpecificScaleReadOnlyProxy);
    objPrint.SpecificScaleRadioButton.off('change', objPrint.UpdateSpecificScaleReadOnlyProxy);

    // Detach the click event handler from the radio button spans ...
    objPrint.DialogDiv.find('.PrintScaleOptionsText').off('click', objPrint.ExtentOptionsTextClickedProxy);

    // Detach the on modal dialog closed event handler ...
    TrimbleMap.ModalDialog.Shared.RemoveOnClosedHandler(objPrint.OnModalDialogClosedProxy);

    // Detach the resize event handler ...
    $(window).off('resize', objPrint.WindowResizedProxy);
}

// **************************************************************************
// FUNCTION: ValidateDialogInput
// USAGE:    
// **************************************************************************
TrimbleMap.Print.ValidateDialogInput = function ValidateDialogInput() {

    // Get the instance ...
    var objPrint = this;

    // Start with being valid ...
    var blnValid = true;

    // Check if the specifc scale option has been checked ...
    var blnSpecificScaleChecked = objPrint.SpecificScaleRadioButton.prop('checked');

    // When the specifc scale option has been checked ...
    if (blnSpecificScaleChecked) {

        // Get the scale text ...
        var strScale = objPrint.SpecificScaleTextBox.val();

        // When no scale value has been specified ...
        if ((strScale).trim() == '') {

            // Set to not be valid ...
            blnValid = false;

            // Get the translations for the message ...

            // No Scale            
            var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'NoScaleTitle');

            // Please enter a valid scale, only<br /> whole numbers are allowed
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'NoScaleMessage');

            // Notify the user of the problem ...
            TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

        } else {

            // Test if the scale entered is a valid number ...
            if (SD.Number.ValidateIsNumber(strScale, objPrint.MapController.State.GroupSeparator, objPrint.MapController.State.DecimalSeparator, false)) {

                // Get the scale value as a number ...
                var intScale = SD.Number.ToNumber(strScale, objPrint.MapController.State.GroupSeparator, objPrint.MapController.State.DecimalSeparator);

                // When smaller than MIN_SCALE ...
                if (intScale < TrimbleMap.Print.Shared.MIN_SCALE) {

                    // Set to not be valid ...
                    blnValid = false;

                    // Convert the min scale to text ...
                    var strMinScale = SD.DisplayValue.FromDouble(TrimbleMap.Print.Shared.MIN_SCALE, objPrint.MapController.State.GroupSeparator, objPrint.MapController.State.DecimalSeparator, 0);

                    // Get the translations for the message ...

                    // Invalid Scale                    
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'ScaleTooSmallTitle');

                    // The scale value that you entered is too small<br />(The minimum allowed is 1: %1)
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'ScaleTooSmallMessage', strMinScale);

                    // Notify the user of the problem ...
                    TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

                    // When a very large number ...
                } else if (intScale > TrimbleMap.Print.Shared.MAX_SCALE) {

                    // Set to not be valid ...
                    blnValid = false;

                    // Convert the max scale to text ...
                    var strMaxScale = SD.DisplayValue.FromDouble(TrimbleMap.Print.Shared.MAX_SCALE, objPrint.MapController.State.GroupSeparator, objPrint.MapController.State.DecimalSeparator, 0);

                    // Get the translations for the message ...

                    // Invalid Scale
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'ScaleTooLargeTitle');

                    // The scale value that you entered is too large<br />(The maximum allowed is 1: %1)
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'ScaleTooLargeMessage', strMaxScale)

                    // Notify the user of the problem ...
                    TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
                }

            } else {

                // Set to not be valid ...
                blnValid = false;

                // Get the translations for the message ...

                // Invalid Scale
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'InvalidScaleTitle');

                // Please enter a valid scale, only<br /> whole numbers are allowed
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'InvalidScaleMessage');

                // Notify the user of the problem ...
                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
            }
        }
    }

    return blnValid;
}

// **************************************************************************
// FUNCTION: UpdateSpecificScaleReadOnly
// USAGE:    
// **************************************************************************
TrimbleMap.Print.UpdateSpecificScaleReadOnly = function UpdateSpecificScaleReadOnly(e) {

    // Get the instance ...
    var objPrint = this;

    // Enable the specific scale text box when the specific scale radio button is checked ...
    objPrint.SpecificScaleTextBox.attr('readonly', !objPrint.SpecificScaleRadioButton.prop('checked'));
}

// **************************************************************************
// FUNCTION: ExtentOptionsTextClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Print.ExtentOptionsTextClicked = function ExtentOptionsTextClicked(e) {

    // Get the instance ...
    var objPrint = this;

    // Get the clicked element ...
    var objTarget = $(e.target);

    // Check the radio button next to the span ...
    objTarget.prev('.PrintScaleOptionsRadioButtons').prop('checked', true);

    // Update the specific scale textbox's readonly property ...
    objPrint.UpdateSpecificScaleReadOnly();
}

// **************************************************************************
// FUNCTION: ExportClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Print.ExportClicked = function ExportClicked(e) {

    // Get the instance ...
    var objPrint = this;

    // Prevent the full postback from happening ...
    e.preventDefault();

    // Validate the dialog input and when it is valid ... 
    if (objPrint.ValidateDialogInput()) {

        // Show the processing div over the dialog ...
        objPrint.ShowProcessingDiv();

        // Create the print template ...
        var objPrintTemplate = new esri.tasks.PrintTemplate();

        // Null check done to determine if the identify popup is displayed on the map 
        // after print/export map was clicked.
        if (objPrint.MapController.IdentifyPopup != null) {
            objPrint.MapController.IdentifyPopup.Hide();
        }

        // Set the format ...
        objPrintTemplate.format = objPrint.FormatDropDown.val();

        // Set the layout template to use ...
        objPrintTemplate.layout = objPrint.TemplateDropDown.val();

        // Set no layout options with no legendLayers set so that all the operatinal layers will be included in the legend ...
        objPrintTemplate.layoutOptions = {};

        // Set the dpi ...
        objPrintTemplate.exportOptions = { dpi: parseInt(objPrint.ResolutionDropDown.val()) };

        if (!objPrintTemplate.layout) {
            objPrintTemplate.exportOptions.height = $(window).innerHeight();
            objPrintTemplate.exportOptions.width = $(window).innerWidth();
        }

        // Do not show map attribution ...
        objPrintTemplate.showAttribution = false;

        // Show the labels ...
        objPrintTemplate.showLabels = true;

        // Create the print parameters object ...
        var objPrintParameters = new esri.tasks.PrintParameters();

        var arrEsriLayersToShow = [];

        //There is a bug currently in the Esri Javascript API (v3.28) or Print Service. We havent tested changing the API so thats why
        //we cant rule out the bug being in the API (The crash happens on the Print Service though).
        //The bug is if a map service is published with no layers being visible by default, and in Landfolio a user does not turn on any layers for that map service in the legend
        //and attempts to print, a crash will occur on the Print Service side.
        //The fix is to hide the map service when printing if no layers were turned on for any particular map service and then show it again after printing.
        //See case in Jira: https://jira.trimble.tools/browse/LF-3406
        objPrint.MapController.ForEachMapServiceDisplayInCurrentMap(function (objMapServiceDisplay, objMapService) {
            let arrEsriLayers = objPrint.MapController.GetEsriLayersForMapServiceDisplay(objMapServiceDisplay);
            //let t = objPrint.MapController.State.VisibleLayerIDsByMapServiceDisplayID

            if (objMapService.MapServiceType !== TrimbleMap.Controller.enumMapServiceType.Tile) {
                $.each(arrEsriLayers, function (intEsriLayer, objEsriLayer) {
                    if ((objEsriLayer.visibleLayers.length === 0 || $.inArray(-1, objEsriLayer.visibleLayers) > -1) && objEsriLayer.visible === true) {
                        arrEsriLayersToShow.push(objEsriLayer);
                        objEsriLayer.hide();
                    }
                });
            }
        });

        // Set the parameters ...
        objPrintParameters.map = objPrint.MapController.EsriMap;

        // Set the template ...
        objPrintParameters.template = objPrintTemplate;

        // Set to print with the spatial reference of the map ...
        objPrintParameters.outSpatialReference = objPrint.MapController.EsriMap.spatialReference;

        // Get the selected scale options from the interface ...
        var blnUseCurrentExtent = objPrint.CurrentExtentRadioButton.prop('checked');
        var blnUseCurrentScale = objPrint.CurrentScaleRadioButton.prop('checked');
        var blnUseSpecificScale = objPrint.SpecificScaleRadioButton.prop('checked');

        // Get the current extent of the map ...
        var objCurrentExtent = objPrint.MapController.EsriMap.extent;

        // Zoom (the whole map) to the visible extent of the map (to accomodate for the sidebar) ...
        let objExtentDeferred = objPrint.MapController.SetMapExtent(objPrint.MapController.GetVisibleMapExtent());

        // Set to use the extent of the map when blnUseCurrentExtent is true ...
        objPrintTemplate.preserveScale = !blnUseCurrentExtent;

        // When we are to use the current scale of the map ...
        if (blnUseCurrentScale) {

            // Set the out scale to the scale of the map ...
            objPrintTemplate.outScale = objPrint.MapController.EsriMap.getScale();

        } else if (blnUseSpecificScale) {

            // Get the scale text ...
            var strScale = objPrint.SpecificScaleTextBox.val();

            // Get the scale value as a number ...
            var intScale = SD.Number.ToNumber(strScale, objPrint.MapController.State.GroupSeparator, objPrint.MapController.State.DecimalSeparator);

            // Set the out scale to the specified scale ...
            objPrintTemplate.outScale = intScale;
        }

        var strPrintServiceUrl = objPrint.MapController.State.PrintServiceURL;

        if (objPrint.MapController.ServerToken) {
            strPrintServiceUrl += "?token=" + objPrint.MapController.ServerToken;
        }

        // Create a new print task (synchronous for now) ...
        let objPrintTask = new esri.tasks.PrintTask(strPrintServiceUrl, { async: true });

        // Reset the first esri io request args so we can capture the first request that execute makes ...
        objPrint.MapController.ResetFirstEsriRequestIOArgs();

        // Function that will be called to show the map services that were hidden before printing.
        var showMapServicesThatWereHidden = function () {
            $.each(arrEsriLayersToShow, function (intEsriLayer, objEsriLayer) {
                objEsriLayer.show();
            });
        };

        objExtentDeferred.then(function () {

            // Execute the print task ...
            objPrintTask.execute(objPrintParameters, function (e) {

                // Get the print output translation ...

                // Print Output
                var strPrintOutputTranslation = SD.Translation.Shared.GetTranslation('Map.Print.js', 'PrintOutput');

                if (objPrintParameters.template.format == 'SVGZ') {
                    // Initiate auto-download
                    let strFileName = objPrint.MapController.CurrentMap.MapName + '.svgz';

                    TrimbleMap.Print.Shared.DownloadFile(e.url, strFileName);
                } else {

                    // Open the result file into a new browser window ...
                    objPrint.MapController.OpenPopup(e.url, strPrintOutputTranslation, '', 800, 600);
                }

                // Save the radio buttn values ...
                objPrint.SaveInitialRadioButtonValues();

                // Hide the processing div ...
                objPrint.HideProcessingDiv();

                // Reset the map services to original state
                // Some map services visibility state is changed to hidden before printing because of a bug in the Esri Javascript API or Print Service
                showMapServicesThatWereHidden();

                // Close the dialog ...
                TrimbleMap.ModalDialog.Shared.CloseDialog(objPrint.DialogID);

            }, function (objError) {

                // Save the radio buttn values ...
                objPrint.SaveInitialRadioButtonValues();

                // Hide the processing div ...
                objPrint.HideProcessingDiv();

                // Reset the map services to original state
                // Some map services visibility state is changed to hidden before printing because of a bug in the Esri Javascript API or Print Service
                showMapServicesThatWereHidden();

                // Close the dialog ...
                TrimbleMap.ModalDialog.Shared.CloseDialog(objPrint.DialogID);

                // Get the title and message translations ...

                // Unable to export map           
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'MapExportFailedTitle');

                // Call to the print service failed
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'MapExportFailedMessage');

                // Unable to export the map. A problem occurred with the print service
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'MapExportFailedEndUserMessage');
                var strCrashMessage = TrimbleMap.Controller.Shared.BuildCrashMessage(objError);

                // Log the diagnostic message ...
                objPrint.MapController.LogDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objPrint.MapController.LastEsriRequestIOArgs));
            });

            // Revert back to the extent the map was before ...
            objPrint.MapController.SetMapExtent(objCurrentExtent);
        });
    }
}

// **************************************************************************
// FUNCTION: LoadTemplates
// USAGE:    
// **************************************************************************
TrimbleMap.Print.LoadTemplates = function LoadTemplates() {

    // Get the instance ...
    var objPrint = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we do not have the templates yet ...
    if (objPrint.Templates == null) {

        // Get the print url from the map controller state ...
        var strPrintUrl = objPrint.MapController.State.PrintServiceURL;

        // Check that the print servuce url is set ...
        if ((typeof strPrintUrl != 'undefined') && (strPrintUrl != null) && ((strPrintUrl).trim() != '')) {

            // Set to get the response in json fomat ...
            strPrintUrl += '?f=json';

            //if there is a server token, append it to url
            if (objPrint.MapController.ServerToken) {
                strPrintUrl += "&token=" + objPrint.MapController.ServerToken;
            }


            // Call the web service to get all the templates ...
            $.ajax({
                url: strPrintUrl,
                dataType: 'json',
                context: {},
                async: true,
                cache: false,
                error: function (jqXHR, textStatus, errorThrown) {

                    // Get the title and message translations ...

                    // Unable retrieve template list                    
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedTitle');

                    // Unable to retrieve information about the available templates
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedMessage');

                    // Unable to retrieve information about the available templates
                    var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedEndUserMessage');
                    var strCrashMessage = errorThrown;

                    // Log the diagnostic message ...
                    objPrint.MapController.LogDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strPrintUrl);

                    // Reject the deferred ...
                    objDeferred.reject();
                },
                complete: function (jqXHR, textStatus) {

                    // When returned OK ...
                    if (jqXHR.status != 0) {

                        // Declare a variable to hold the parsed json reponse ...
                        var objResponseData = null;

                        // Start with invalid json ...
                        var blnValidJson = false;

                        try {

                            // Parse the json response ...
                            objResponseData = JSON.parse(jqXHR.responseText);

                            // Set to have valid json ...
                            blnValidJson = true;

                        } catch (e) {

                            // Get the title and message translations ...

                            // Unable retrieve template list
                            var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'UnableToRetrieveTemplatesTitle');

                            // Unable to parse the json reponse from the print service
                            var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'UnableToRetrieveTemplatesMessage');

                            // Unable to retrieve information about the available templates
                            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'UnableToRetrieveTemplatesEndUserMessage');
                            var strCrashMessage = TrimbleMap.Controller.Shared.BuildCrashMessage(e);

                            // Log the diagnostic message ...
                            objPrint.MapController.LogDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strPrintUrl);
                        }

                        // Check that the response object contains a property named 'parameters' ...
                        if ((objResponseData == null) || (typeof objResponseData.parameters == 'undefined') || (objResponseData.parameters == null)) {

                            // Set to not have valid json ...
                            blnValidJson = false;

                            // Get the title and message translations ...

                            // Unable retrieve template list                    
                            var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedTitle');

                            // Unable to retrieve information about the available templates
                            var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedMessage');

                            // Unable to retrieve information about the available templates
                            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedEndUserMessage');

                            // The response contains no property named "parameters"
                            var strCrashMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedPropertyCrashMessage');

                            // Log the diagnostic message ...
                            objPrint.MapController.LogDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strPrintUrl);
                        }

                        // When we have valid json ...
                        if (blnValidJson) {

                            // Declare a variable for the layout template ...
                            var objLayoutTemplateParameter;

                            // Loop through all the parameters ...
                            $.each(objResponseData.parameters, function (intParameter, objParameter) {

                                // When the parameter name is 'Layout_Template' ...
                                if (objParameter.name == "Layout_Template") {

                                    // Set the layout template parameter ...
                                    objLayoutTemplateParameter = objParameter;

                                    // Stop searching ...
                                    return false;
                                }
                            });

                            // When we did get a the layout template parameter ...
                            if (objLayoutTemplateParameter != null) {
                                objPrint.Templates = [];
                                $.each(objPrint.MapController.State.MapPrintTemplates, function (intMapPrintTemplate, objMapPrintTemplate) {

                                    if ($.inArray(objMapPrintTemplate.Name, objLayoutTemplateParameter.choiceList) > -1) {
                                        objPrint.Templates.push(objMapPrintTemplate.Name);
                                    }
                                });

                                // Resolve the deferred ...
                                objDeferred.resolve();

                            } else {

                                // Get the title and message translations ...

                                // Unable retrieve template list                    
                                var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedTitle');

                                // Unable to retrieve information about the available templates
                                var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedMessage');

                                // Unable to retrieve information about the available templates
                                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedEndUserMessage');

                                // The response contains no parameter named "Layout_Template"
                                var strCrashMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalFailedLayoutCrashMessage');

                                // Log the diagnostic message ...
                                objPrint.MapController.LogDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strPrintUrl);
                            }
                        }
                    }
                }
            });

        } else {

            // Get the title and message translations ...

            // Unable retrieve template list, the print service url is not configured
            var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalUrlFailedTitle');

            // Print service url is not configured
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalUrlFailedMessage');

            // Unable to retrieve information about the available templates
            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Print.js', 'TemplatesRetrievalUrlFailedEndUserMessage');
            var strCrashMessage = null;

            // Log the diagnostic message ...
            objPrint.MapController.LogDiagnosticMessage(strTitle, strMessage, strCrashMessage, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, strPrintUrl);
        }

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    // Return the deferred ...
    return objDeferred;
}

// **************************************************************************
// FUNCTION: CreateDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Print.CreateDialog = function CreateDialog() {

    // Get the instance ...
    var objPrint = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the dialog has not been create yet ...
    if (objPrint.DialogDiv == null) {

        // Ensure that the templates are loaded ...
        let objLoadTemplatesDeferred = objPrint.LoadTemplates();

        // When the templates have been loaded ...
        objLoadTemplatesDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Get the translations ...

            // EXPORT            
            var strExportTranslation = SD.Translation.Shared.GetTranslation('Map.Print.js', 'Export');

            // Template
            var strTemplateTranslation = SD.Translation.Shared.GetTranslation('Map.Print.js', 'Template');

            // Format
            var strFormatTranslation = SD.Translation.Shared.GetTranslation('Map.Print.js', 'Format');

            // Resolution
            var strResolutionTranslation = SD.Translation.Shared.GetTranslation('Map.Print.js', 'Resolution');

            // Scale
            var strScaleTranslation = SD.Translation.Shared.GetTranslation('Map.Print.js', 'Scale');

            // Current Extent
            var strCurrentExtentTranslation = SD.Translation.Shared.GetTranslation('Map.Print.js', 'CurrentExtent');

            // Current Scale
            var strCurrentScaleTranslation = SD.Translation.Shared.GetTranslation('Map.Print.js', 'CurrentScale');

            // Specific Scale
            var strSpecificScaleTranslation = SD.Translation.Shared.GetTranslation('Map.Print.js', 'SpecificScale');

            // Create the dialog div ...
            objPrint.DialogDiv = $('<div class="PrintDialogDiv"></div>');

            // Create the content table ...
            var objContentTable = $('<table cellspacing="0" cellpadding="0" border="0"></table>');

            // Add a row ...
            objContentTable.append('<tr><td width="80px" height="25px"><span>' + strTemplateTranslation + ':</span></td><td TemplateDropDownCell></td></tr>');

            // Add a row ...
            objContentTable.append('<tr><td height="27px"><span>' + strFormatTranslation + ':</span></td><td FormatDropDownCell></td></tr>');

            // Add a row ...
            objContentTable.append('<tr><td height="27px"><span>' + strResolutionTranslation + ':</span></td><td ResolutionDropDownCell></td></tr>');

            // Add a row ...
            objContentTable.append('<tr><td><div style="height:3px"></div></td></tr>');

            // Add a row ...
            objContentTable.append('<tr><td class="PrintScaleTextCell"><span>' + strScaleTranslation + ':</span></td><td ScaleOptionsCell></td></tr>');

            // Add a row ...
            objContentTable.append('<tr><td></td><td ExportButtonCell></td></tr>');

            // Add it to the div ...
            objPrint.DialogDiv.append(objContentTable);

            // Create the print drop down ...
            objPrint.TemplateDropDown = $('<select class="PrintDropDown"></select>');

            // Add it to the template drop down cell ...
            objContentTable.find('[TemplateDropDownCell]').append(objPrint.TemplateDropDown);

            var strTemplateAliasedName;

            // Loop through all the templates ...
            $.each(objPrint.Templates, function (intTemplate, strTemplate) {
                $.each(objPrint.MapController.State.MapPrintTemplates, function (intMapPrintTemplate, objMapPrintTemplate) {

                    if (strTemplate == objMapPrintTemplate.Name) {
                        strTemplateAliasedName = objMapPrintTemplate.AliasedName;
                        return false;
                    }
                });
                // Add the template to the drop down ...
                objPrint.TemplateDropDown.append('<option value="' + strTemplate + '">' + strTemplateAliasedName + '</option>');
            });

            // Create the format drop down ...
            objPrint.FormatDropDown = $('<select class="PrintDropDown"></select>');

            // Add it to the format drop down cell ...
            objContentTable.find('[FormatDropDownCell]').append(objPrint.FormatDropDown);

            // Loop through all the formats ...
            $.each(objPrint.Formats, function (intFormat, strFormat) {

                // Add the format to the drop down ...
                objPrint.FormatDropDown.append('<option value="' + strFormat + '">' + strFormat + '</option>');
            });

            // Create the resolution drop down ...
            objPrint.ResolutionDropDown = $('<select class="PrintDropDown"></select>');

            // Add it to the format drop down cell ...
            objContentTable.find('[ResolutionDropDownCell]').append(objPrint.ResolutionDropDown);

            // Get the print unit used which is dpi
            var printUnit = SD.Translation.Shared.GetTranslation('Map.Print.js', 'DPI');

            // Add the resolutions to the drop down ...
            objPrint.ResolutionDropDown.append('<option value="' + TrimbleMap.Print.enumResolution.Standard + '">' + SD.Translation.Shared.GetTranslation('Map.Print.js', 'Standard') + ' (' + TrimbleMap.Print.enumResolution.Standard + ' ' + printUnit + ')</option>');
            objPrint.ResolutionDropDown.append('<option value="' + TrimbleMap.Print.enumResolution.High + '">' + SD.Translation.Shared.GetTranslation('Map.Print.js', 'High') + ' (' + TrimbleMap.Print.enumResolution.High + ' ' + printUnit + ')</option>');
            objPrint.ResolutionDropDown.append('<option value="' + TrimbleMap.Print.enumResolution.VeryHigh + '">' + SD.Translation.Shared.GetTranslation('Map.Print.js', 'VeryHigh') + ' (' + TrimbleMap.Print.enumResolution.VeryHigh + ' ' + printUnit + ')</option>');

            // Set the default resolution to be standard
            objPrint.ResolutionDropDown.val(TrimbleMap.Print.enumResolution.Standard);

            // Create a div for the scale options ...
            var objScaleOptionsDiv = $('<div></div>');

            // Add it to the cell for the scale options ...
            objContentTable.find('[ScaleOptionsCell]').append(objScaleOptionsDiv);

            // Create the current extent radio button ...
            objPrint.CurrentExtentRadioButton = $('<input type="radio" name="PrintScaleOptions" value="CurrentExtent" class="PrintScaleOptionsRadioButtons"></input>');

            // Add it to the scale options div ...
            objScaleOptionsDiv.append(objPrint.CurrentExtentRadioButton);
            objScaleOptionsDiv.append('<span class="PrintScaleOptionsText">' + strCurrentExtentTranslation + '</span>');
            objScaleOptionsDiv.append('<br />');

            // Create the current scale radio button ...
            objPrint.CurrentScaleRadioButton = $('<input type="radio" name="PrintScaleOptions" value="CurrentScale" class="PrintScaleOptionsRadioButtons"></input>');

            // Add it to the scale options div ...
            objScaleOptionsDiv.append(objPrint.CurrentScaleRadioButton);
            objScaleOptionsDiv.append('<span class="PrintScaleOptionsText">' + strCurrentScaleTranslation + '</span>');
            objScaleOptionsDiv.append('<br />');

            // Create the specific scale radio button ...
            objPrint.SpecificScaleRadioButton = $('<input type="radio" name="PrintScaleOptions" value="CurrentScale" class="PrintScaleOptionsRadioButtons"></input>');

            // Add it to the scale options div ...
            objScaleOptionsDiv.append(objPrint.SpecificScaleRadioButton);
            objScaleOptionsDiv.append('<span class="PrintScaleOptionsText">' + strSpecificScaleTranslation + '</span>');
            objScaleOptionsDiv.append('<br />');

            // Create the specific scale text box ...
            objPrint.SpecificScaleTextBox = $('<input type="text" class="PrintSpecificScaleTextBox FloatRight"></input>');

            // Add it to the scale options div ...
            objScaleOptionsDiv.append('<div style="height:5px">&nbsp;</div>&nbsp;<span>1:</span>&nbsp;');
            objScaleOptionsDiv.append(objPrint.SpecificScaleTextBox);
            objScaleOptionsDiv.append('<div style="clear:both"></div><br />');

            // Create the export button ...
            objPrint.ExportButton = $('<button class="Button PrintExportButton FloatRight" >' + strExportTranslation + '</button>');

            // Add it to the export button cell ...
            objContentTable.find('[ExportButtonCell]').append(objPrint.ExportButton);

            // Resolve the deferred ...
            objDeferred.resolve();
        }));

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: ShowProcessingDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Print.ShowProcessingDiv = function ShowProcessingDiv() {

    // Get the instance ...
    var objPrint = this;

    // Create the processing div ...
    objPrint.ProcessingDiv = $('<div class="process-loading"></div>');

    // Add it to the body ...
    $('body').append(objPrint.ProcessingDiv);
}

// **************************************************************************
// FUNCTION: HideProcessingDiv
// USAGE:    
// **************************************************************************
TrimbleMap.Print.HideProcessingDiv = function HideProcessingDiv() {

    // Get the instance ...
    var objPrint = this;

    // Remove the processing div ...
    objPrint.ProcessingDiv.remove();

    // Set it to null ...
    objPrint.ProcessingDiv = null;
}

// **************************************************************************
// FUNCTION: ShowDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Print.ShowDialog = function ShowDialog() {

    // Get the instance ...
    var objPrint = this;

    // Create the dialog when it does not exist ...
    var objCreateDialogDeferred = objPrint.CreateDialog();

    // When the dialog has been created ...
    objCreateDialogDeferred.then(function () {

        // Get the translation for the title ...

        // Export for Printing        
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Print.js', 'ExportForPrintingTitle');

        // Get the next dialog id ...
        objPrint.DialogID = TrimbleMap.ModalDialog.Shared.NextDialogID();

        // Show the dialog ...
        TrimbleMap.ModalDialog.Shared.OpenDialog(objPrint.DialogDiv, strTitle, true, objPrint.DialogID);

        // Check the initial radio button values ...
        objPrint.CurrentExtentRadioButton.prop('checked', objPrint.InitialCurrentExtentRadioButtonValue);
        objPrint.CurrentScaleRadioButton.prop('checked', objPrint.InitialCurrentScaleRadioButtonValue);
        objPrint.SpecificScaleRadioButton.prop('checked', objPrint.InitialSpecificScaleRadioButtonValue);

        // Update the specific scale textbox's readonly property ...
        objPrint.UpdateSpecificScaleReadOnly();

        // Attach the event handlers ...
        objPrint.AttachEventHandlers();
    });
}

// **************************************************************************
// FUNCTION: SaveInitialRadioButtonValues
// USAGE:    
// **************************************************************************
TrimbleMap.Print.SaveInitialRadioButtonValues = function SaveInitialRadioButtonValues() {

    // Get the instance ...
    var objPrint = this;

    // Save the current radio button values as the initial values ...
    objPrint.InitialCurrentExtentRadioButtonValue = objPrint.CurrentExtentRadioButton.prop('checked');
    objPrint.InitialCurrentScaleRadioButtonValue = objPrint.CurrentScaleRadioButton.prop('checked');
    objPrint.InitialSpecificScaleRadioButtonValue = objPrint.SpecificScaleRadioButton.prop('checked');
}

// **************************************************************************
// FUNCTION: WindowResized
// USAGE:    
// **************************************************************************
TrimbleMap.Print.WindowResized = function WindowResized() {

    // Get the instance ...
    var objPrint = this;

    // When the processing div is visible ...
    if (objPrint.ProcessingDiv != null) {

        // Adjust the size of the div to cover the whole page ...
        objPrint.ProcessingDiv.css('width', $(window).innerWidth());
        objPrint.ProcessingDiv.css('height', $(window).innerHeight());
    }
}

// **************************************************************************
// FUNCTION: OnModalDialogClosed
// USAGE:    
// **************************************************************************
TrimbleMap.Print.OnModalDialogClosed = function OnModalDialogClosed(objDialogID) {

    // Get the instance ...
    var objPrint = this;

    // When the print dialog are being closed ...
    if (objPrint.DialogID == objDialogID) {

        // Detach the event handlers ...
        objPrint.DetachEventHandlers();

        // Save the radio buttn values ...
        objPrint.SaveInitialRadioButtonValues();
    }
}

// **************************************************************************
// FUNCTION: Clicked
// USAGE:    
// **************************************************************************
TrimbleMap.Print.Clicked = function Clicked(objMenuItem) {

    // Get the instance ...
    var objPrint = this;

    // Show the print dialog ...
    objPrint.ShowDialog();
}

// **************************************************************************
// FUNCTION: DownloadFile
// USAGE:    
// **************************************************************************
TrimbleMap.Print.Shared.DownloadFile = function (strUrl, strFileName) {

    let lnkDownloadLink = document.createElement('a');
    lnkDownloadLink.setAttribute('href', strUrl);
    lnkDownloadLink.setAttribute('download', strFileName);

    lnkDownloadLink.trigger('click');
};


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ProjectedCoordinate = {};
TrimbleMap.ProjectedCoordinate.Shared = {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// *************************************************************************
TrimbleMap.ProjectedCoordinate.CreateInstance = function CreateInstance(decX, decY) {

    // Create the object that will hold the instance properties ...
    var objProjectedCoordinate = {
        X: (typeof decX != 'undefined') ? decX : 0,
        Y: (typeof decY != 'undefined') ? decY : 0
    }

    return objProjectedCoordinate;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Query = {};
TrimbleMap.Query.Shared = {};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION QueryFeatureService:
// Possible values for strSpatialRel: 
//          esriSpatialRelIntersects 
//          esriSpatialRelContains
//          esriSpatialRelCrosses
//          esriSpatialRelEnvelopeIntersects
//          esriSpatialRelIndexIntersects
//          esriSpatialRelOverlaps
//          esriSpatialRelTouches
//          esriSpatialRelWithin
// arrLayerWhereClauses: Array containing objects with LayerID and Where properties ...
// Rest end point online help: http://resources.arcgis.com/en/help/arcgis-rest-api/#/Query_Feature_Service/02r3000000w5000000/
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Query.Shared.QueryFeatureService = function QueryFeatureService(strRestUrl, strToken, arrLayerWhereClauses, objGeometry, strSpatialRel, dblMaxAllowableOffset) {

    // Start with the rest url ...
    var strUrl = strRestUrl;

    // Add a backslash to the end when there is not already one ...
    if (strUrl[strUrl.length - 1] != '/') { strUrl = strUrl + '/' };

    // Add query to indicate the operation whe want to perform ...
    strUrl = strUrl + 'query';

    // Create the content object to add the parameters to ...
    var objContent = {};

    // Build the layer defs url argument ...
    var strLayerDefs;

    // Loop through all the layer where clauses ...
    for (var intLayerWhereClause = 0; intLayerWhereClause < arrLayerWhereClauses.length; intLayerWhereClause++) {

        // When we don ot have any layer defs in the url argument yet ...
        if (strLayerDefs == null) {

            // Start with an empty string ...
            strLayerDefs = '';

        } else {

            // Add a ; to separate the layer defs ...
            strLayerDefs = strLayerDefs + ';';
        }

        // Get the layer where clause ...
        var objLayerWhereClause = arrLayerWhereClauses[intLayerWhereClause];

        // Add the layer id and where clause ...
        strLayerDefs = strLayerDefs + objLayerWhereClause.LayerID + ':(' + objLayerWhereClause.Where + ')';
    }

    // Add the layerDefs argument ...
    objContent.layerDefs = strLayerDefs;

    // When we received a geometry ...
    if (objGeometry != null) {

        // Add the geometry json to the arguments ...
        objContent.geometry = objGeometry.toJson()
    }

    // When we received a geometry ...
    if (objGeometry != null) {

        // Add the geometry type ...
        switch (objGeometry.type) {
            case 'point': objContent.geometryType = 'esriGeometryPoint'; break;
            case 'multipoint': objContent.geometryType = 'esriGeometryMultipoint'; break;
            case 'polyline': objContent.geometryType = 'esriGeometryPolyline'; break;
            case 'polygon': objContent.geometryType = 'esriGeometryPolygon'; break;
            case 'extent': objContent.geometryType = 'esriGeometryEnvelope'; break;
        }
    }

    // Set the spatial relationship ...
    objContent.spatialRel = strSpatialRel;

    // Add the Max Allowable Offset parameter ...
    objContent.maxAllowableOffset = dblMaxAllowableOffset;

    // Add an url argument to indicate that not only the ids or count is to be returned ...
    objContent.returnIdsOnly = false;
    objContent.returnCountOnly = false;

    // Add an url argument to indicate that the response should be in json format ...
    objContent.f = 'json';

    // When we have a token to add ...
    if (strToken != null) {

        // Add the token ...
        objContent.token = strToken;
    }

    // Call the web service ...
    var objDeferred = objDeferred = esri.request({ url: strUrl, content: objContent });

    // Return the deferred ...
    return objDeferred;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.QueryResultsDisplay = {};
TrimbleMap.QueryResultsDisplay.Shared = {}
TrimbleMap.QueryResultsDisplay.Shared.RESULTS_TO_LOAD_IMMEDIATELY = 30;
TrimbleMap.QueryResultsDisplay.Shared.DELAYED_RESULTS_LOAD_CHUNK_SIZE = 10;
TrimbleMap.QueryResultsDisplay.Shared.RESULT_LOAD_DELAY_MS = 100;
TrimbleMap.QueryResultsDisplay.Shared.SPINNER_FADE_OUT_DELAY = 1000;
TrimbleMap.QueryResultsDisplay.Shared.DISABLE_HOVER_TIME_MS = 1000;
TrimbleMap.QueryResultsDisplay.Shared.TRANSITION_DURATION_MS = 300;
TrimbleMap.QueryResultsDisplay.Shared.SCROLL_BUFFER_PIXELS = 100;
TrimbleMap.QueryResultsDisplay.Shared.SEARCH_ADD_TO_SELECTION = 'search_add_to_selection';

// **************************************************************************
// FUNCTION: enumFilterDataMethod
// USAGE:    
// **************************************************************************
TrimbleMap.enumFilterDataMethod = {};
TrimbleMap.enumFilterDataMethod.RemoveInputData = 'RemoveInputData';
TrimbleMap.enumFilterDataMethod.OnlyKeepInputData = 'OnlyKeepInputData';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.CreateInstance = function CreateInstance(objContainerElement, objMapController, objMapCallout, fnGetHtmlTemplateFromLayer, fnGetByPartHtmlTemplateFromLayer, fnGetEnabledFlagFromLayer, fnPopulateMapLayerGroupBySectionMenu, blnVisible, strSerializedDataJson) {

    // Create the query results display object ...
    var objQueryResultsDisplay = {
        ContainerElement: objContainerElement,
        MapController: objMapController,
        MapCallout: objMapCallout,
        PopulateMapLayerGroupBySectionMenu: fnPopulateMapLayerGroupBySectionMenu,
        QueryResultsDisplayDiv: null,
        ContentDiv: null,
        GetHtmlTemplateFromLayerFunction: fnGetHtmlTemplateFromLayer,
        GetByPartHtmlTemplateFromLayerFunction: fnGetByPartHtmlTemplateFromLayer,
        GetEnabledFlagFromLayerFunction: fnGetEnabledFlagFromLayer,
        QueryResultsDisplayHeadingCountSpans: {},
        QueryResultsDisplayHeadingDivs: {},
        PopupMenus: {},
        NiceScrolls: {},
        ScrollContainerDivs: {},
        ScrollContainerInnerDivs: {},
        QueryResultsTables: {},
        LoadingIndicators: {},
        LoadDataCounter: 0,
        SectionDisplayUpdatedForLoadDataCounter: -1,
        ResultsToBeLoaded: null,
        GroupBySectionCounts: null,
        DisplayedGraphics: null,
        ResultBindingsApplied: false,
        ResultData: {},
        MapLayerTemplateTagIDs: {},
        MapLayerTemplateByPartTagIDs: {},
        IsVisible: blnVisible,
        EventHandlersAttached: false,
        KnockoutBindingsApplied: false,
        GroupBySectionElementsCreatedForCurrentMap: false,
        GeometryCache: {},
        SpinnerVisible: false,
        SpinnerBackgroundDiv: null,
        SpinnerDiv: null,
        HighlightedQueryResultElement: null,
        HoveredResultIcons: [],
        HoveredResultIconsDiv: null,
        HoveredQueryResultElement: null,
        DisplayedData: {},
        ReceivedSerializedData: ((typeof strSerializedDataJson != 'undefined') && (strSerializedDataJson != null) && ((strSerializedDataJson).trim().length > 0)),
        Data: ((typeof strSerializedDataJson != 'undefined') && (strSerializedDataJson != null) && ((strSerializedDataJson).trim().length > 0)) ? TrimbleMap.QueryResultsDisplay.Shared.DeserializeData(strSerializedDataJson, objMapController) : {},
        DisplayedCountForSection: {},
        MinimumCountForSection: {},
        CurrentSectionDisplayDetails: null,
        PreviousSectionDisplayDetails: null,
        OrderedMapLayerGroupBySections: [],
        AnimatingSectionTransition: false,
        SwatchElementsByMapLayerGroupBySection: {},
        OnLoadedFunctions: [],
        TemplateElementsDeferred: new dojo.Deferred(),
        GroupBySectionElementsDeferred: new dojo.Deferred(),

        QueryResultsDisplayClickedProxy: function (e) { objQueryResultsDisplay.QueryResultsDisplayClicked(e); },
        QueryResultsDisplayMouseOverProxy: function (e) { objQueryResultsDisplay.QueryResultsDisplayMouseOver(e); },
        QueryResultsDisplayMouseLeaveProxy: function () { objQueryResultsDisplay.QueryResultsDisplayMouseLeave(); },
        ResizeSpinnerProxy: function () { objQueryResultsDisplay.ResizeSpinner(); },
        MapCalloutHiddenProxy: function () { objQueryResultsDisplay.MapCalloutHidden(); },
        ZoomToIconClickedProxy: function (objQueryResult) { objQueryResultsDisplay.ZoomToIconClicked(objQueryResult); },
        KnockoutAfterRenderProxy: function (arrDomElements, objDataItem) { objQueryResultsDisplay.KnockoutAfterRender(arrDomElements, objDataItem); },
        MapLoadedProxy: function (blnReloaded) { objQueryResultsDisplay.MapLoaded(blnReloaded); },
        MapPreReloadedProxy: function (blnReloaded) { objQueryResultsDisplay.MapPreReloaded(); },
        SectionScrolledProxy: function (e) { objQueryResultsDisplay.SectionScrolled(e); },

        AttachEventHandlers: TrimbleMap.QueryResultsDisplay.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.QueryResultsDisplay.DetachEventHandlers,
        Resize: TrimbleMap.QueryResultsDisplay.Resize,
        CreateElements: TrimbleMap.QueryResultsDisplay.CreateElements,
        CreateTemplateElements: TrimbleMap.QueryResultsDisplay.CreateTemplateElements,
        CreateGroupBySectionElements: TrimbleMap.QueryResultsDisplay.CreateGroupBySectionElements,
        CreateGroupBySectionElementsForCurrentMap: TrimbleMap.QueryResultsDisplay.CreateGroupBySectionElementsForCurrentMap,
        AddOrderedMapLayerGroupBySection: TrimbleMap.QueryResultsDisplay.AddOrderedMapLayerGroupBySection,
        RecursiveAddOrderedMapLayerGroupBySection: TrimbleMap.QueryResultsDisplay.RecursiveAddOrderedMapLayerGroupBySection,
        SetOrderedMapLayerGroupBySections: TrimbleMap.QueryResultsDisplay.SetOrderedMapLayerGroupBySections,
        GetMapLayerGroupBySectionSwatchElement: TrimbleMap.QueryResultsDisplay.GetMapLayerGroupBySectionSwatchElement,
        ForEachMapLayerGroupBySectionInCurrentMapInOrder: TrimbleMap.QueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder,
        LoadData: TrimbleMap.QueryResultsDisplay.LoadData,
        FilterData: TrimbleMap.QueryResultsDisplay.FilterData,
        ClearAllResultData: TrimbleMap.QueryResultsDisplay.ClearAllResultData,
        QueryResultsDisplayClicked: TrimbleMap.QueryResultsDisplay.QueryResultsDisplayClicked,
        QueryResultsDisplayMouseOver: TrimbleMap.QueryResultsDisplay.QueryResultsDisplayMouseOver,
        QueryResultsDisplayMouseLeave: TrimbleMap.QueryResultsDisplay.QueryResultsDisplayMouseLeave,
        UpdateScrollbarOnSections: TrimbleMap.QueryResultsDisplay.UpdateScrollbarOnSections,
        CreateLoadingMoreResultsSpinners: TrimbleMap.QueryResultsDisplay.CreateLoadingMoreResultsSpinners,
        ScrollAllToTop: TrimbleMap.QueryResultsDisplay.ScrollAllToTop,
        Show: TrimbleMap.QueryResultsDisplay.Show,
        Hide: TrimbleMap.QueryResultsDisplay.Hide,
        AddToGeometryCache: TrimbleMap.QueryResultsDisplay.AddToGeometryCache,
        AddGeometriesToGeometryCache: TrimbleMap.QueryResultsDisplay.AddGeometriesToGeometryCache,
        GetGeometry: TrimbleMap.QueryResultsDisplay.GetGeometry,
        GetCachedGeometry: TrimbleMap.QueryResultsDisplay.GetCachedGeometry,
        UpdateGroupBySectionCounts: TrimbleMap.QueryResultsDisplay.UpdateGroupBySectionCounts,
        SetGroupBySectionCountsFromData: TrimbleMap.QueryResultsDisplay.SetGroupBySectionCountsFromData,
        ShowSpinner: TrimbleMap.QueryResultsDisplay.ShowSpinner,
        HideSpinner: TrimbleMap.QueryResultsDisplay.HideSpinner,
        ResizeSpinner: TrimbleMap.QueryResultsDisplay.ResizeSpinner,
        TemporarilyDeactivateZoomToResult: TrimbleMap.QueryResultsDisplay.TemporarilyDeactivateZoomToResult,
        HighligthAndZoomToResult: TrimbleMap.QueryResultsDisplay.HighligthAndZoomToResult,
        GetGeometryAndHighligthAndZoomToResult: TrimbleMap.QueryResultsDisplay.GetGeometryAndHighligthAndZoomToResult,
        GetDataForQueryResultElement: TrimbleMap.QueryResultsDisplay.GetDataForQueryResultElement,
        GetDataForItem: TrimbleMap.QueryResultsDisplay.GetDataForItem,
        MapCalloutHidden: TrimbleMap.QueryResultsDisplay.MapCalloutHidden,
        AddHoveredResultIcon: TrimbleMap.QueryResultsDisplay.AddHoveredResultIcon,
        RemoveHoveredResultIcon: TrimbleMap.QueryResultsDisplay.RemoveHoveredResultIcon,
        GetHoveredResultIconIndex: TrimbleMap.QueryResultsDisplay.GetHoveredResultIconIndex,
        DisplayHoveredResultIcons: TrimbleMap.QueryResultsDisplay.DisplayHoveredResultIcons,
        HideHoveredResultIcons: TrimbleMap.QueryResultsDisplay.HideHoveredResultIcons,
        ZoomToIconClicked: TrimbleMap.QueryResultsDisplay.ZoomToIconClicked,
        ApplyKnockoutBindings: TrimbleMap.QueryResultsDisplay.ApplyKnockoutBindings,
        RemoveKnockoutBindings: TrimbleMap.QueryResultsDisplay.RemoveKnockoutBindings,
        ClearAllKnockoutArrays: TrimbleMap.QueryResultsDisplay.ClearAllKnockoutArrays,
        GetGroupBySectionCount: TrimbleMap.QueryResultsDisplay.GetGroupBySectionCount,
        DetermineSectionDisplayDetails: TrimbleMap.QueryResultsDisplay.DetermineSectionDisplayDetails,
        ChangeSectionDisplays: TrimbleMap.QueryResultsDisplay.ChangeSectionDisplays,
        UpdateSectionDisplays: TrimbleMap.QueryResultsDisplay.UpdateSectionDisplays,
        KnockoutAfterRender: TrimbleMap.QueryResultsDisplay.KnockoutAfterRender,
        MinimumDataLoaded: TrimbleMap.QueryResultsDisplay.MinimumDataLoaded,
        GetDisplayedCountForSection: TrimbleMap.QueryResultsDisplay.GetDisplayedCountForSection,
        GetMinimumCountForSection: TrimbleMap.QueryResultsDisplay.GetMinimumCountForSection,
        AddToData: TrimbleMap.QueryResultsDisplay.AddToData,
        AddArrayDataToObject: TrimbleMap.QueryResultsDisplay.AddArrayDataToObject,
        RemoveFromData: TrimbleMap.QueryResultsDisplay.RemoveFromData,
        ClearDisplayedData: TrimbleMap.QueryResultsDisplay.ClearDisplayedData,
        HasData: TrimbleMap.QueryResultsDisplay.HasData,
        DisplayData: TrimbleMap.QueryResultsDisplay.DisplayData,
        SerializeData: TrimbleMap.QueryResultsDisplay.SerializeData,
        SectionScrolled: TrimbleMap.QueryResultsDisplay.SectionScrolled,
        AddOnLoadedCallback: TrimbleMap.QueryResultsDisplay.AddOnLoadedCallback,
        RemoveOnLoadedCallback: TrimbleMap.QueryResultsDisplay.RemoveOnLoadedCallback,
        TriggerOnLoadedCallbacks: TrimbleMap.QueryResultsDisplay.TriggerOnLoadedCallbacks,
        MapLoaded: TrimbleMap.QueryResultsDisplay.MapLoaded,
        MapPreReloaded: TrimbleMap.QueryResultsDisplay.MapPreReloaded,
        IsItemLoaded: TrimbleMap.QueryResultsDisplay.IsItemLoaded
    }

    // Create the dom elements ...
    objQueryResultsDisplay.CreateElements();

    // Add a hide callback for the map call out ...
    objQueryResultsDisplay.MapCallout.AddHideCallback(objQueryResultsDisplay.MapCalloutHiddenProxy);

    // Attach the event handlers when visible ...
    if (blnVisible) { objQueryResultsDisplay.AttachEventHandlers(); }

    // Create and add the zoom to hovered result icon ...
    objQueryResultsDisplay.AddHoveredResultIcon(TrimbleMap.QueryResultsDisplay.Shared.CreateHoveredResultIcon('Zoom to', 'query_zoom_to', objQueryResultsDisplay.ZoomToIconClickedProxy));

    // Add a map loaded and pre reloaded callback ...
    objQueryResultsDisplay.MapController.AddOnLoadedCallback(objQueryResultsDisplay.MapLoadedProxy);
    objQueryResultsDisplay.MapController.AddPreReloadedCallback(objQueryResultsDisplay.MapPreReloadedProxy);

    return objQueryResultsDisplay;
}

// **************************************************************************
// FUNCTION: MapLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.MapLoaded = function MapLoaded(blnReloaded) {

    // Get the map search instance ...
    var objQueryResultsDisplay = this;

    // Create the group by section element for the current map ...
    objQueryResultsDisplay.CreateGroupBySectionElementsForCurrentMap(function () {

        // Create the loading more results spinners ...
        objQueryResultsDisplay.CreateLoadingMoreResultsSpinners();

        // Update the section displays ...
        objQueryResultsDisplay.UpdateSectionDisplays();
    });

    // When we've received serialized data to start with ...
    if (objQueryResultsDisplay.ReceivedSerializedData) {

        // Add the geometries to the cache ...
        objQueryResultsDisplay.AddGeometriesToGeometryCache(objQueryResultsDisplay.Data);
    }
}

// **************************************************************************
// FUNCTION: MapPreReloaded
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.MapPreReloaded = function MapPreReloaded() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Set to have not created the group by section elements for the current map ...
    objQueryResultsDisplay.GroupBySectionElementsCreatedForCurrentMap = false;

    // Clear the query result data ...
    objQueryResultsDisplay.ClearAllResultData();

    // Hide the spinner if visible ...
    objQueryResultsDisplay.HideSpinner();

    // Revert back to the default cursor ...
    objQueryResultsDisplay.MapController.SetMapCursor('default');

    // Recreate the template and group by section deferreds ...
    objQueryResultsDisplay.TemplateElementsDeferred = new dojo.Deferred();
    objQueryResultsDisplay.GroupBySectionElementsDeferred = new dojo.Deferred();
}

// **************************************************************************
// FUNCTION: DetermineSectionDisplayDetails
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.DetermineSectionDisplayDetails = function DetermineSectionDisplayDetails(strTopMostVisibleSectionID) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // When no top most visible section has been specified ...
    if ((typeof strTopMostVisibleSectionID == 'undefined') || (strTopMostVisibleSectionID == null)) {

        // Use the top most visble section on the CurrentSectionDisplayDetails is we have current sectin details ...
        strTopMostVisibleSectionID = (objQueryResultsDisplay.CurrentSectionDisplayDetails != null) ? objQueryResultsDisplay.CurrentSectionDisplayDetails.TopMostVisibleSectionID : null;

        // When we have no top most visible section ...
        if ((strTopMostVisibleSectionID == null) && objQueryResultsDisplay.PreviousSectionDisplayDetails) {

            // Get the count for the previous top most visible group by section ...
            var intGroupBySectionCount = objQueryResultsDisplay.GetGroupBySectionCount(objQueryResultsDisplay.PreviousSectionDisplayDetails.TopMostVisibleSectionID);

            // When we have any items in the section ...
            if (intGroupBySectionCount > 0) {

                // Get the previously selected top most visible section ...
                strTopMostVisibleSectionID = objQueryResultsDisplay.PreviousSectionDisplayDetails.TopMostVisibleSectionID;
            }
        }
    }

    // Create the object to return ...
    var objSectionDisplayDetails = {
        ContainerHeight: parseInt(objQueryResultsDisplay.ContainerElement.innerHeight(), 10),
        TopMostVisibleSectionID: strTopMostVisibleSectionID,
        Sections: [],
        SectionsWithData: {},
        SectionsWithoutData: {},
        VisibleSections: {},
        SectionsWithScrollbars: {},
        SectionHeights: {},
        SectionWithDataCount: 0,
        LastSectionWithData: null,
        HasData: function HasData(strMapLayerGroupBySectionID) { return (typeof this.SectionsWithData[strMapLayerGroupBySectionID] != 'undefined'); },
        IsVisible: function IsVisible(strMapLayerGroupBySectionID) { return (typeof this.VisibleSections[strMapLayerGroupBySectionID] != 'undefined'); }
    };

    // Loop through all the map layer group by sections in the current map ...
    objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

        // Add it to the sections object ...
        objSectionDisplayDetails.Sections.push(objMapLayerGroupBySection);

        // Get the count for the group by section ...
        var intGroupBySectionCount = objQueryResultsDisplay.GetGroupBySectionCount(objMapLayerGroupBySection.MapLayerGroupBySectionID);

        // When we have any results to display for the group by section ... 
        if (intGroupBySectionCount > 0) {

            // Set the TopMostVisibleSectionID to objMapLayerGroupBySection.MapLayerGroupBySectionID when not set ...
            if ((typeof objSectionDisplayDetails.TopMostVisibleSectionID == 'undefined') || (objSectionDisplayDetails.TopMostVisibleSectionID == null)) { objSectionDisplayDetails.TopMostVisibleSectionID = objMapLayerGroupBySection.MapLayerGroupBySectionID; }

            // Add the section to the visible array ...
            objSectionDisplayDetails.SectionsWithData[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objMapLayerGroupBySection;

            // Set it to be the last section with data ...
            objSectionDisplayDetails.LastSectionWithData = objMapLayerGroupBySection;

            // Increment the sections with data count ...
            objSectionDisplayDetails.SectionWithDataCount++;

            // Measure the element's size ...
            var objSize = SD.HtmlFunctions.Shared.MeasureElement(objQueryResultsDisplay.QueryResultsDisplayHeadingDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID]);

            // Get the height of the heading ...
            var intHeadingHeight = objSize.height + 2;

            // Substract it from the container height ...
            objSectionDisplayDetails.ContainerHeight -= intHeadingHeight;

        } else {

            // Add the section to the hidden section array ...
            objSectionDisplayDetails.SectionsWithoutData[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objMapLayerGroupBySection;
        }
    });

    // Start with the top and bottom most visible sections not reached yet ... 
    var blnTopMostReached = false;
    var blnBottomMostReached = false;

    // Start with the container height being available ...
    var intAvailableHeight = objSectionDisplayDetails.ContainerHeight;

    // Loop through all the map layer group by sections ...
    for (var intMapLayerGroupBySection = 0; intMapLayerGroupBySection < objSectionDisplayDetails.Sections.length; intMapLayerGroupBySection++) {

        // Get the map layer group by section ...
        var objMapLayerGroupBySection = objSectionDisplayDetails.Sections[intMapLayerGroupBySection];

        // When the top most visible section then set blnTopMostReached ...
        if (objSectionDisplayDetails.TopMostVisibleSectionID == objMapLayerGroupBySection.MapLayerGroupBySectionID) { blnTopMostReached = true; }

        // When the top most visible section has been reached and the bottom most visible section has not been reached ...
        if (blnTopMostReached && (!blnBottomMostReached)) {

            // When the section has data ...
            if (objSectionDisplayDetails.HasData(objMapLayerGroupBySection.MapLayerGroupBySectionID)) {

                // Get the results to still be loaded for this map layer group by section ...
                var arrResultsToBeLoadedForMapLayerGroupBySection = objQueryResultsDisplay.ResultsToBeLoaded[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                // Start with using all the available space ...
                var blnUseAllAvailableSpace = true;

                // When not the last section with data ...
                if (objMapLayerGroupBySection != objSectionDisplayDetails.LastSectionWithData) {

                    // Determine whether or not we have more results to be loaded ...
                    var blnNoMoreResultsToLoad = ((typeof arrResultsToBeLoadedForMapLayerGroupBySection == 'undefined') ||
                        (arrResultsToBeLoadedForMapLayerGroupBySection == null) ||
                        (arrResultsToBeLoadedForMapLayerGroupBySection.length == 0));

                    // When we do not have any more results to be loaded ...
                    if (blnNoMoreResultsToLoad) {

                        // Get the scrollable inner div for the section ...
                        var objScrollContainerInnerDiv = objQueryResultsDisplay.ScrollContainerInnerDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                        // Get the height of the section content ...
                        objQueryResultsDisplay.ScrollContainerDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID].show();
                        var intSectionContentHeight = parseInt(objScrollContainerInnerDiv.outerHeight());

                        // When the section content height is less than the available height ...
                        if (intSectionContentHeight < intAvailableHeight) {

                            // Set to use the section's height ...
                            objSectionDisplayDetails.SectionHeights[objMapLayerGroupBySection.MapLayerGroupBySectionID] = intSectionContentHeight;

                            // Subtract the section height from the available height ...
                            intAvailableHeight -= intSectionContentHeight;

                            // Set to not use all available space ...
                            blnUseAllAvailableSpace = false;
                        }
                    }
                }

                // When we are to use all the space available ...
                if (blnUseAllAvailableSpace) {

                    // Set to use the containers's height ...
                    objSectionDisplayDetails.SectionHeights[objMapLayerGroupBySection.MapLayerGroupBySectionID] = intAvailableHeight;

                    // Set to need a scrollbar for the section 
                    objSectionDisplayDetails.SectionsWithScrollbars[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objMapLayerGroupBySection;

                    // Set to have reached the bottom most visible section ...
                    blnBottomMostReached = true;
                }

                // When the query results display is visible ...
                if (objQueryResultsDisplay.IsVisible) {

                    // Set the section to be visible ...
                    objSectionDisplayDetails.VisibleSections[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objMapLayerGroupBySection;
                }
            }
        }
    }

    return objSectionDisplayDetails;
}

// **************************************************************************
// FUNCTION: ChangeSectionDisplays
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.ChangeSectionDisplays = function ChangeSectionDisplays(objSectionDisplayDetails, blnAnimate) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // When we have section display details and the group by section elements have been cretaed for the current map ...
    if ((objSectionDisplayDetails != null) && objQueryResultsDisplay.GroupBySectionElementsCreatedForCurrentMap) {

        // Remove the selected class from the selected section heading if any ...
        $(objQueryResultsDisplay.QueryResultsDisplayDiv.find('.QueryResultsDisplayHeadingSelected')).removeClass('QueryResultsDisplayHeadingSelected');

        // When we have a top most visible section ...
        if ((typeof objSectionDisplayDetails.TopMostVisibleSectionID != 'undefined') && (objSectionDisplayDetails.TopMostVisibleSectionID != null)) {

            // Add the selected class to the top most visible section ...
            objQueryResultsDisplay.QueryResultsDisplayHeadingDivs[objSectionDisplayDetails.TopMostVisibleSectionID].addClass('QueryResultsDisplayHeadingSelected');
        }

        // Set to be animating the section transition when we are to animate ...
        if (blnAnimate) { objQueryResultsDisplay.AnimatingSectionTransition = true; }

        // Create a new array for the deferreds ...
        var arrDeferreds = [];

        // Loop through all the sections ...
        $.each(objSectionDisplayDetails.Sections, function (intMapLayerGroupBySection, objMapLayerGroupBySection) {

            // Create a new deferred ...
            var objDeferred = new dojo.Deferred();

            // Add it to the array of deferreds ...
            arrDeferreds.push(objDeferred);

            // When the section has data ...
            if (objSectionDisplayDetails.HasData(objMapLayerGroupBySection.MapLayerGroupBySectionID)) {

                // Show the group by heading for the group by section ...
                objQueryResultsDisplay.QueryResultsDisplayHeadingDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID].show();

            } else {

                // Hide the group by heading for the group by section ...
                objQueryResultsDisplay.QueryResultsDisplayHeadingDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID].hide();
            }

            // Get the scrollable container div for the section ...
            var objScrollContainerDiv = objQueryResultsDisplay.ScrollContainerDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID];

            // When the section is to be visible ...
            if (objSectionDisplayDetails.IsVisible(objMapLayerGroupBySection.MapLayerGroupBySectionID)) {

                // Get the section height ...
                var intSectionHeight = objSectionDisplayDetails.SectionHeights[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                // When we are to animate the transition and we have existing sections ...
                if (blnAnimate && objQueryResultsDisplay.CurrentSectionDisplayDetails) {

                    // When the section is not currently visible ...
                    if (!objQueryResultsDisplay.CurrentSectionDisplayDetails.IsVisible(objMapLayerGroupBySection.MapLayerGroupBySectionID)) {

                        // Set the section's height to 0 ...
                        objScrollContainerDiv.css('height', '0px');
                        objScrollContainerDiv.css('max-height', '0px');

                        // Show the scrollable container div for the group by section ...
                        objScrollContainerDiv.show();
                    }

                    // Animate the section's height and max-height to the target height ...
                    objScrollContainerDiv.animate({ 'height': intSectionHeight + 'px', 'max-height': intSectionHeight + 'px' }, TrimbleMap.QueryResultsDisplay.Shared.TRANSITION_DURATION_MS, function () { objDeferred.resolve(); });

                } else {

                    // Set the section's height ...
                    setTimeout(function () {
                        objScrollContainerDiv.css('height', intSectionHeight + 'px');
                        objScrollContainerDiv.css('max-height', intSectionHeight + 'px');
                    }, 0);


                    // Show the scrollable container div for the group by section ...
                    objScrollContainerDiv.show();

                    // Resolve the deferred ...
                    objDeferred.resolve();
                }

            } else {

                // Get the nice scroll for the section ...
                var objNiceScroll = objQueryResultsDisplay.NiceScrolls[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                // When we have a nice scroll for the section ...
                if (objNiceScroll) {

                    // De-activate the scrollbar ...
                    objNiceScroll.hide();
                    objNiceScroll.remove();
                    objQueryResultsDisplay.NiceScrolls[objMapLayerGroupBySection.MapLayerGroupBySectionID] = null;
                }

                // When we are to animate the transition and we have existing sections ...
                if (blnAnimate && objQueryResultsDisplay.CurrentSectionDisplayDetails) {

                    // Animate the section's height and max-height to the 0px height ...
                    objScrollContainerDiv.animate({ 'height': '0px', 'max-height': '0px' }, TrimbleMap.QueryResultsDisplay.Shared.TRANSITION_DURATION_MS, function () {

                        // Hide the scrollable container div for the group by section ...
                        objScrollContainerDiv.hide();

                        // Resolve the deferred ...
                        objDeferred.resolve();
                    });

                } else {

                    // Hide the scrollable container div for the group by section ...
                    objScrollContainerDiv.hide();

                    // Resolve the deferred ...
                    objDeferred.resolve();
                }
            }
        });

        // Set the current section display details ...
        objQueryResultsDisplay.CurrentSectionDisplayDetails = objSectionDisplayDetails;

        // When all the section transitionhas taken place ...
        new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Update the scrollbars ...
            objQueryResultsDisplay.UpdateScrollbarOnSections();

            // Set to not be animating the section transition when we animated ...
            if (blnAnimate) { objQueryResultsDisplay.AnimatingSectionTransition = false; }
        }));

    } else {

        // Remove the scrollbars ...
        objQueryResultsDisplay.UpdateScrollbarOnSections(true);
    }
}

// **************************************************************************
// FUNCTION: UpdateSectionDisplays
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.UpdateSectionDisplays = function UpdateSectionDisplays() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // When the query results display is visible ...
    if (objQueryResultsDisplay.IsVisible) {

        // Determine the group section heights ...
        var objSectionDisplayDetails = objQueryResultsDisplay.DetermineSectionDisplayDetails();

        // Change the section displays ...
        objQueryResultsDisplay.ChangeSectionDisplays(objSectionDisplayDetails, false);
    }
}

// **************************************************************************
// FUNCTION: Resize
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.Resize = function Resize() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Update the section displays ...
    objQueryResultsDisplay.UpdateSectionDisplays();

    // When the spinner is visible ...
    if (objQueryResultsDisplay.SpinnerVisible) {

        // Resize the spinner ...
        objQueryResultsDisplay.ResizeSpinner();
    }
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.CreateElements = function CreateElements(objContainerElement, objMapController) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Create the query display div ...
    objQueryResultsDisplay.QueryResultsDisplayDiv = $('<div class="query-results"></div>');

    // Add it to the container div ...
    objQueryResultsDisplay.ContainerElement.append(objQueryResultsDisplay.QueryResultsDisplayDiv);

    // Create the content div ...
    objQueryResultsDisplay.ContentDiv = $('<div class=""></div>');

    // Add it to the QueryResultsDisplayDiv ...
    objQueryResultsDisplay.QueryResultsDisplayDiv.append(objQueryResultsDisplay.ContentDiv);

    // Add a loaded callback to the map ...
    objQueryResultsDisplay.MapController.AddOnLoadedCallback(function (blnReloaded) {

        // Create the template elements ...
        objQueryResultsDisplay.CreateTemplateElements();
    });

    // * Create the no results div ...

    //get the translation for 0 results found
    var strNoResultsFound = SD.Translation.Shared.GetTranslation('Map.QueryResultsDisplay.js', 'NoResultsFound');

    // Create the no search results div ...
    objQueryResultsDisplay.NoResults = $('<div class="no-results"><span>' + strNoResultsFound + '</span></div>');

    // Add to the container ...
    objQueryResultsDisplay.QueryResultsDisplayDiv.append(objQueryResultsDisplay.NoResults);
}

// **************************************************************************
// FUNCTION: ForEachMapLayerGroupBySectionInCurrentMapInOrder
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder = function ForEachMapLayerGroupBySectionInCurrentMapInOrder(fnCallback) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // When we have ordered map layer group by sections for the current map ...
    if (objQueryResultsDisplay.OrderedMapLayerGroupBySections != null) {

        // Loop through the ordered map layer group by sections in order ...
        $.each(objQueryResultsDisplay.OrderedMapLayerGroupBySections, function (intMapLayerGroupBySections, objMapLayerGroupBySections) {

            // Call the callback with the map layer group by section ...
            fnCallback(objMapLayerGroupBySections);
        });
    }
}

// **************************************************************************
// FUNCTION: GetMapLayerGroupBySectionSwatchElement
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.GetMapLayerGroupBySectionSwatchElement = function GetMapLayerGroupBySectionSwatchElement(objMapLayerGroupBySection) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Get the swatch element for the map layer group by section ...
    var objSwatchElement = objQueryResultsDisplay.SwatchElementsByMapLayerGroupBySection[objMapLayerGroupBySection.MapLayerGroupBySectionID];

    // Set to null when not found in the object (undefined) ...
    if (typeof objSwatchElement == 'undefined') { objSwatchElement = null; }

    return objSwatchElement;
}

// **************************************************************************
// FUNCTION: AddOrderedMapLayerGroupBySection
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.AddOrderedMapLayerGroupBySection = function AddOrderedMapLayerGroupBySection(strMapServiceID, strLayerName, strCurrentMapID, objLegendDataItem) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Get the map layer by name ...
    var objMapLayer = objQueryResultsDisplay.MapController.GetMapLayerByName(strMapServiceID, strLayerName);

    // When we have configuration for the map layer ...
    if (objMapLayer != null) {

        // Get the map layer group by section in which the map layer is ...
        var objMapLayerGroupBySection = objQueryResultsDisplay.MapController.GetMapLayerGroupBySectionForMapLayer(strCurrentMapID, objMapLayer.MapLayerID);

        // When we have a map layer group by section for the layer ...
        if ((typeof objMapLayerGroupBySection != 'undefined') && (objMapLayerGroupBySection != null)) {

            // Add it to the ordered array ...
            objQueryResultsDisplay.OrderedMapLayerGroupBySections.push(objMapLayerGroupBySection);

            // When we have a swatch element ...
            if ((typeof objLegendDataItem.SwatchElement != 'undefined') && (objLegendDataItem.SwatchElement != null)) {

                // Add it to SwatchElementsByMapLayerGroupBySection for the map layer group by section ...
                objQueryResultsDisplay.SwatchElementsByMapLayerGroupBySection[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objLegendDataItem.SwatchElement;
            }
        }
    }
}

// **************************************************************************
// FUNCTION: SetOrderedMapLayerGroupBySections
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.SetOrderedMapLayerGroupBySections = function SetOrderedMapLayerGroupBySections(arrLegendData) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Get the current map ID ...
    var strCurrentMapID = objQueryResultsDisplay.MapController.CurrentMap.MapID;

    // Create a new array ...
    objQueryResultsDisplay.OrderedMapLayerGroupBySections = [];

    // Clear the swatch elements ...
    objQueryResultsDisplay.SwatchElementsByMapLayerGroupBySection = {};

    // Loop through all the map services for which we got legend data ...
    for (var intMapServiceLegendData = 0; intMapServiceLegendData < arrLegendData.length; intMapServiceLegendData++) {

        // Get the legend data ...
        var objMapServiceLegendData = arrLegendData[intMapServiceLegendData];

        // When legend data for the section were loaded successfully ...
        if (objMapServiceLegendData.Loaded) {

            // Get the map service ID ...
            var strMapServiceID = objMapServiceLegendData.MapService.MapServiceID;

            // Loop through all the layers from the map service ...
            $.each(objMapServiceLegendData.DataItems, function (intLayerLegendData, objLayerLegendData) {

                objQueryResultsDisplay.RecursiveAddOrderedMapLayerGroupBySection(strMapServiceID, strCurrentMapID, objLayerLegendData);
            });
        }
    }
}

// **************************************************************************
// FUNCTION: RecursiveAddOrderedMapLayerGroupBySection
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.RecursiveAddOrderedMapLayerGroupBySection = function RecursiveAddOrderedMapLayerGroupBySection(strMapServiceID, strCurrentMapID, objLayerLegendData) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Add the map layer group by section for the layer ...
    objQueryResultsDisplay.AddOrderedMapLayerGroupBySection(strMapServiceID, objLayerLegendData.Name, strCurrentMapID, objLayerLegendData);

    if (objLayerLegendData.SubItems != 'undefined' && objLayerLegendData.SubItems != null && objLayerLegendData.SubItems.length > 0) {

        // Loop through all the sub items ...
        $.each(objLayerLegendData.SubItems, function (intSubItemLegendData, objSubItemLegendData) {

            // Add the map layer group by section for the layer ...
            objQueryResultsDisplay.RecursiveAddOrderedMapLayerGroupBySection(strMapServiceID, strCurrentMapID, objSubItemLegendData);
        });
    }
}

// **************************************************************************
// FUNCTION: CreateGroupBySectionElementsForCurrentMap
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.CreateGroupBySectionElementsForCurrentMap = function CreateGroupBySectionElementsForCurrentMap(fnComplete) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // UnApply the knockout bindings when applied ...
    objQueryResultsDisplay.RemoveKnockoutBindings();

    // Clear the content div ...
    objQueryResultsDisplay.ContentDiv.empty();

    // Clear the group by section div objects ...
    objQueryResultsDisplay.QueryResultsDisplayHeadingCountSpans = {};
    objQueryResultsDisplay.QueryResultsDisplayHeadingDivs = {};

    // Get the legend data for the current map ...
    objQueryResultsDisplay.MapController.GetLegendDataForCurrentMap(function (arrLegendData) {

        // Set the ordered map layer group by sections using the legend data ...
        objQueryResultsDisplay.SetOrderedMapLayerGroupBySections(arrLegendData);

        // Loop through all the map layer group by sections in the current map in order ...
        objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

            // Create the display elements for the group by section ...
            objQueryResultsDisplay.CreateGroupBySectionElements(objMapLayerGroupBySection);
        });

        // When the event handlers are attached ...
        if (objQueryResultsDisplay.EventHandlersAttached) {

            // Apply the knockout bindings ...
            objQueryResultsDisplay.ApplyKnockoutBindings();
        }

        // Set the group by elements to be created ...
        objQueryResultsDisplay.GroupBySectionElementsCreatedForCurrentMap = true;

        // Resolve the deferred ...
        objQueryResultsDisplay.GroupBySectionElementsDeferred.resolve();

        // Trigger the loaded callbacks ...
        objQueryResultsDisplay.TriggerOnLoadedCallbacks();

        // Call the complete function when we have one ...
        if ((typeof fnComplete != 'undefined') && (fnComplete != null)) { fnComplete(); }
    });
}

// **************************************************************************
// FUNCTION: MinimumDataLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.MinimumDataLoaded = function MinimumDataLoaded() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Start with the minimum loaded ...
    var blnMinimumDataLoaded = true;

    // Loop through the minimum count required for each section ...
    $.each(objQueryResultsDisplay.MinimumCountForSection, function (strMapLayerGroupBySectionID, intMinimumCountForSection) {

        // Get the displayed count for the section ...
        var intDisplayedCountForSection = objQueryResultsDisplay.GetDisplayedCountForSection(strMapLayerGroupBySectionID);

        // When the minimum for the section has not been loaded yet ... 
        if (intDisplayedCountForSection < intMinimumCountForSection) {

            // Set to not have loaded minimum ...
            blnMinimumDataLoaded = false;

            // Stop checking ...
            return false;
        }
    });

    return blnMinimumDataLoaded;
}

// **************************************************************************
// FUNCTION: GetMinimumCountForSection
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.GetMinimumCountForSection = function GetMinimumCountForSection(strMapLayerGroupBySectionID) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Get the minimum count for the section ...
    var intMinimumCountForSection = objQueryResultsDisplay.MinimumCountForSection[strMapLayerGroupBySectionID];

    // Set to 0 when not found ...
    if (typeof intMinimumCountForSection == 'undefined') { intMinimumCountForSection = 0; }

    return intMinimumCountForSection;
}

// **************************************************************************
// FUNCTION: GetDisplayedCountForSection
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.GetDisplayedCountForSection = function GetDisplayedCountForSection(strMapLayerGroupBySectionID) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Get the displayed count for the section ...
    var intDisplayedCountForSection = objQueryResultsDisplay.DisplayedCountForSection[strMapLayerGroupBySectionID];

    // Set to 0 when not found ...
    if (typeof intDisplayedCountForSection == 'undefined') { intDisplayedCountForSection = 0; }

    return intDisplayedCountForSection;
}

// **************************************************************************
// FUNCTION: KnockoutAfterRender
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.KnockoutAfterRender = function KnockoutAfterRender(arrDomElements, objDataItem) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Get the group by section in which the map layer is ...
    var objMapLayerGroupBySection = objQueryResultsDisplay.MapController.GetMapLayerGroupBySectionForMapLayer(objQueryResultsDisplay.MapController.CurrentMap.MapID, objDataItem.MapLayerID);

    // Get the displayed count for the section ...
    var intDisplayedCountForSection = objQueryResultsDisplay.GetDisplayedCountForSection(objMapLayerGroupBySection.MapLayerGroupBySectionID);

    // Set the displayed count for the section to be one more ...
    objQueryResultsDisplay.DisplayedCountForSection[objMapLayerGroupBySection.MapLayerGroupBySectionID] = intDisplayedCountForSection + 1;

    // When the minimum data has been loaded for each section and the section display has not been updated yet ...
    if (objQueryResultsDisplay.MinimumDataLoaded() && (objQueryResultsDisplay.SectionDisplayUpdatedForLoadDataCounter < objQueryResultsDisplay.LoadDataCounter)) {

        // Update the section displays ...
        objQueryResultsDisplay.UpdateSectionDisplays();

        // Set to have updated the section displays for the load data counter ...
        objQueryResultsDisplay.SectionDisplayUpdatedForLoadDataCounter = objQueryResultsDisplay.LoadDataCounter;
    }
}

// **************************************************************************
// FUNCTION: ApplyKnockoutBindings
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.ApplyKnockoutBindings = function ApplyKnockoutBindings() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // When the knockout bindings are not applied ...
    if (!objQueryResultsDisplay.KnockoutBindingsApplied) {

        // Set the knockout bindings to be applied ...
        objQueryResultsDisplay.KnockoutBindingsApplied = true;

        // Create a function to get the template tag id using the MapLayerID of the element being rendered ...
        var fnGetTemplateName = function (objDataItem) {

            // Return the template tag ID for the map layer ...
            return (objQueryResultsDisplay.MapController.Preferences.DisplaySeparateParts) ? objQueryResultsDisplay.MapLayerTemplateByPartTagIDs[objDataItem.MapLayerID] : objQueryResultsDisplay.MapLayerTemplateTagIDs[objDataItem.MapLayerID];
        };

        // When the template elements has been created ...
        objQueryResultsDisplay.TemplateElementsDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Bind to the view model ...
            ko.applyBindings({
                Results: objQueryResultsDisplay.ResultData,
                GetTemplateName: fnGetTemplateName,
                DateFormat: objQueryResultsDisplay.MapController.State.DateFormat,
                KnockoutAfterRender: objQueryResultsDisplay.KnockoutAfterRenderProxy
            }, objQueryResultsDisplay.ContentDiv.get(0));
        }));
    }
}

// **************************************************************************
// FUNCTION: RemoveKnockoutBindings
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.RemoveKnockoutBindings = function RemoveKnockoutBindings() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // When the knockout bindings are applied ...
    if (objQueryResultsDisplay.KnockoutBindingsApplied) {

        // Set the knockout bindings to not be applied ...
        objQueryResultsDisplay.KnockoutBindingsApplied = false;

        // Unbind all the events ...
        objQueryResultsDisplay.ContentDiv.find('*').each(function () { $(this).off(); });

        // Clean the knockout bindings to the node ...
        ko.cleanNode(objQueryResultsDisplay.ContentDiv.get(0));
    }
}

// **************************************************************************
// FUNCTION: CreateTemplateElements
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.CreateTemplateElements = function CreateTemplateElements() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Loop through all the layers in the current map ...
    objQueryResultsDisplay.MapController.ForEachLayerInCurrentMap(function (objMapLayer) {

        // Create a unique script element id ...
        var strScriptElementID = 'Template_' + objMapLayer.MapLayerID + SD.Guid.Shared.NewID();

        // Create the html template ...
        var strHtmlTemplate = objQueryResultsDisplay.GetHtmlTemplateFromLayerFunction(objMapLayer);

        // Create the script element for the template ...
        var objScriptElement = $('<script type="text/html" id="' + strScriptElementID + '">' + strHtmlTemplate + '</script>');

        // Add it to the document body ...
        $('body').append(objScriptElement);

        // Place the ID into the global dictionary ...
        objQueryResultsDisplay.MapLayerTemplateTagIDs[objMapLayer.MapLayerID] = strScriptElementID;

        // Create a unique script element id for the by part template ...
        var strScriptElementIDByPart = 'Template_' + objMapLayer.MapLayerID + SD.Guid.Shared.NewID() + '_ByPart';

        // Create the html template ...
        var strByPartHtmlTemplate = objQueryResultsDisplay.GetByPartHtmlTemplateFromLayerFunction(objMapLayer);

        // Create the script element for the template ...
        var objScriptElementByPart = $('<script type="text/html" id="' + strScriptElementIDByPart + '">' + strByPartHtmlTemplate + '</script>');

        // Add it to the document body ...
        $('body').append(objScriptElementByPart);

        // Place the ID into the global dictionary ...
        objQueryResultsDisplay.MapLayerTemplateByPartTagIDs[objMapLayer.MapLayerID] = strScriptElementIDByPart;
    });

    // Resolve the deferred ...
    objQueryResultsDisplay.TemplateElementsDeferred.resolve();
}

// **************************************************************************
// FUNCTION: CreateGroupBySectionElements
// USAGE:
// **************************************************************************
TrimbleMap.QueryResultsDisplay.CreateGroupBySectionElements = function CreateGroupBySectionElements(objMapLayerGroupBySection) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // * Heading div ...

    // Create the collapsible heading:
    var objHeadingDiv = $('<div class="QueryResultsDisplayHeading" MapLayerGroupBySectionID="' + objMapLayerGroupBySection.MapLayerGroupBySectionID + '" QueryResultsDisplayHeading=""></div>');

    // Set the heading in the hash table ...
    objQueryResultsDisplay.QueryResultsDisplayHeadingDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objHeadingDiv;

    // Add the heading to the container div ...
    objQueryResultsDisplay.ContentDiv.append(objHeadingDiv);

    var objHeadingInner = $('<div></div>');

    objHeadingDiv.append(objHeadingInner);

    // Get the swatch element for the map layer group by section ...
    var objSwatchElement = objQueryResultsDisplay.GetMapLayerGroupBySectionSwatchElement(objMapLayerGroupBySection);

    // When we have a swatch element ...
    if (objSwatchElement != null) {

        // Clone the element ...
        objSwatchElement = objSwatchElement.clone();

        // Set the height ...
        objSwatchElement.css('height', '15px');

        // Clone the swatch and add it to a div ...
        objSwatchElement = $('<div class="query-swatch"></div>').append(objSwatchElement);

        // Add it to the heading div ...
        objHeadingInner.append(objSwatchElement);
    }

    // Create the heading text div ...
    var objHeadingTextDiv = $('<div class="heading-text"></div>');

    // Add the heading text div to the heading ...
    objHeadingInner.append(objHeadingTextDiv);

    // Add the heading text span ...
    objHeadingTextDiv.append($('<div><span>' + objMapLayerGroupBySection.Heading + '</span></div>'));

    // * Heading count span ...

    // Create the count span ...
    var objHeadingCountSpan = $('<span class="heading-count">(100)</span>');

    // Place it into the hash table for retrieval later when we populate the results ...
    objQueryResultsDisplay.QueryResultsDisplayHeadingCountSpans[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objHeadingCountSpan;

    // Add the count span div to the heading div ...
    objHeadingTextDiv.append(objHeadingCountSpan);

    // When we have a PopulateMapLayerGroupBySectionMenu function ...
    if ((typeof objQueryResultsDisplay.PopulateMapLayerGroupBySectionMenu != 'undefined') && (objQueryResultsDisplay.PopulateMapLayerGroupBySectionMenu)) {

        // Create the menu icon ...
        var objHeadingMenuIcon = $('<div class="result-menu"></div>');

        // Add it to the heading ...
        objHeadingInner.append(objHeadingMenuIcon);

        // Create the view in list popup menu ...
        var objPopupMenu = SD.PopupMenu.CreateInstance(objHeadingMenuIcon,
            'popup-downwards',
            'popup-upwards',
            'popup-downwards-open',
            'popup-upwards-open',
            2,
            false,
            SD.Popup.enumPopupBehaviour.DownOrUpBasedOnSpaceAvailable,
            function () { });

        // Populate the menu ...
        objQueryResultsDisplay.PopulateMapLayerGroupBySectionMenu(objMapLayerGroupBySection, objPopupMenu, objQueryResultsDisplay);

        // Add it to the hash table ...
        objQueryResultsDisplay.PopupMenus[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objPopupMenu;
    }

    // * scroll container div ...

    // Create the scroll container div ...
    var objScrollContainerDiv = $('<div class="results-scroller"></div>');

    // Add the map layer group by section ID as an attribute ...
    objScrollContainerDiv.attr('MapLayerGroupBySectionID', objMapLayerGroupBySection.MapLayerGroupBySectionID);

    // Set the scrollable container div in the hash table ...
    objQueryResultsDisplay.ScrollContainerDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objScrollContainerDiv;

    // Add the scroll container to the container div ...
    objQueryResultsDisplay.ContentDiv.append(objScrollContainerDiv);


    // * scroll container inner div ...

    // Create the scroll inner container div ...
    var objScrollContainerInnerDiv = $('<div></div>');

    // Set the inner scrollable container div in the hash table ...
    objQueryResultsDisplay.ScrollContainerInnerDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objScrollContainerInnerDiv;

    // Add the inner container div to the container ...
    objScrollContainerDiv.append(objScrollContainerInnerDiv);


    // * Query results table ...

    // Create the results table ...
    var objQueryResultsTable = $('<div class="results-list"></div>');

    // Set the table in the hash table ...
    objQueryResultsDisplay.QueryResultsTables[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objQueryResultsTable;

    // Add the results table to the container div ...
    objScrollContainerInnerDiv.append(objQueryResultsTable);


    // * Loading indicator ...

    // Create the loading indicator ...
    var objLoadingIndicator = $('<div class="loading-outer"><div id="LoadingQueryResults_' + objMapLayerGroupBySection.MapLayerGroupBySectionID + '" class="loading-spinner"></div><span class="loading-text">Loading More Results ...</span></div>');

    // Add to the hash table for later use ...
    objQueryResultsDisplay.LoadingIndicators[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objLoadingIndicator;

    // Add to the container div ...
    objScrollContainerInnerDiv.append(objLoadingIndicator);


    // * Observable Array ...

    // Create an observable array to contain the attribute data to be bound to ...
    var arrResultData = ko.observableArray(new Array());

    // Place it in the dictionary ...
    objQueryResultsDisplay.ResultData[objMapLayerGroupBySection.MapLayerGroupBySectionID] = arrResultData;

    // * Query results template row ...

    // Setup the query results table to bind to the attributes ...
    objQueryResultsTable.attr('data-bind', 'template: { name: $root.GetTemplateName, foreach: Results["' + objMapLayerGroupBySection.MapLayerGroupBySectionID + '"], afterRender: KnockoutAfterRender }');
}

// **************************************************************************
// FUNCTION: AddToGeometryCache
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.AddToGeometryCache = function AddToGeometryCache(strMapLayerID, strID, objGeometry, guidSpatialReference, blnOverwriteGeometryInCache) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    if ((typeof blnOverwriteGeometryInCache == 'undefined') || (blnOverwriteGeometryInCache == null)) { blnOverwriteGeometryInCache = true; }

    // When we do not have any geometries cached for the map layer yet ...
    if (typeof objQueryResultsDisplay.GeometryCache[strMapLayerID] == 'undefined') {

        // Create a new hash table and add it to GeometryCache ...
        objQueryResultsDisplay.GeometryCache[strMapLayerID] = {};
    }

    // Get the geometry cache for the map layer ...
    var objGeometryCacheForMapLayer = objQueryResultsDisplay.GeometryCache[strMapLayerID];
    let objGeometryCache = objGeometryCacheForMapLayer[strID];

    if (blnOverwriteGeometryInCache || !objGeometryCache || !objGeometryCache.Geometry || !objGeometryCache.SpatialReferenceID) {
        // Add the geometry to the cahce for the id ...
        objGeometryCacheForMapLayer[strID] = {
            Geometry: objGeometry,
            SpatialReferenceID: guidSpatialReference
        };
    }
}

// **************************************************************************
// FUNCTION: AddGeometriesToGeometryCache
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.AddGeometriesToGeometryCache = function AddGeometriesToGeometryCache(arrQueryResultsByLayer) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Loop through all the layers with results ...
    $.each(arrQueryResultsByLayer, function (intQueryResultsByLayer, objQueryResultsByLayer) {

        // Get the map layer object ...
        var objMapLayer = objQueryResultsDisplay.MapController.GetMapLayer(objQueryResultsByLayer.MapLayerID);

        // Get the map layer ID field name ...
        var strIDFieldName = objQueryResultsDisplay.MapController.GetMapLayerIDFieldName(objMapLayer);

        // Loop through all the query results ...
        $.each(objQueryResultsByLayer.Data, function (intQueryResult, objQueryResult) {

            // When the query result has a geometry ...
            if ((typeof objQueryResult.Geometry != 'undefined') && (typeof objQueryResult.Geometry != null)) {

                // Get the id ...
                var strID = objQueryResult.Attributes[strIDFieldName];

                // Add the geometry to the cache ...
                objQueryResultsDisplay.AddToGeometryCache(objQueryResultsByLayer.MapLayerID, strID, objQueryResult.Geometry, objQueryResult.SpatialReferenceID, false);
            }
        });
    });
}

// **************************************************************************
// FUNCTION: GetCachedGeometry
// USAGE:    returns object : { Geometry, InCache }
// **************************************************************************
TrimbleMap.QueryResultsDisplay.GetCachedGeometry = function GetCachedGeometry(strMapLayerID, strID) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Start with not being in cache ...
    var objCachedGeometry = {
        GeometryAndSpatialReference: null,
        InCache: false
    };

    // When we do not have any geometries cached for the map layer yet ...
    if (typeof objQueryResultsDisplay.GeometryCache[strMapLayerID] != 'undefined') {

        // Get the geometry cache for the map layer ...
        var objGeometryCacheForMapLayer = objQueryResultsDisplay.GeometryCache[strMapLayerID];

        // When we have a cached geometry for the id ...
        if (typeof objGeometryCacheForMapLayer[strID] != 'undefined') {

            // Get the geometry and spatial reference id from the cache ...
            objCachedGeometry.GeometryAndSpatialReference = objGeometryCacheForMapLayer[strID];

            // Set to be in the cache ...
            objCachedGeometry.InCache = true;
        }
    }

    return objCachedGeometry;
}

// **************************************************************************
// FUNCTION: ScrollAllToTop
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.ScrollAllToTop = function ScrollAllToTop() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Loop through all the layers in the current map ...
    objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

        // Scroll the section content to the top ...
        objQueryResultsDisplay.ScrollContainerDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID].scrollTop('0px');
    });
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.Show = function Show() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // When not visible already ...
    if (!objQueryResultsDisplay.IsVisible) {

        // Set to be visible ...
        objQueryResultsDisplay.IsVisible = true;

        // Display the data ...
        objQueryResultsDisplay.DisplayData(false);
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.Hide = function Hide() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // When visible ...
    if (objQueryResultsDisplay.IsVisible) {

        // Set to be not visible ...
        objQueryResultsDisplay.IsVisible = false;

        // Clear the displayed data ...
        objQueryResultsDisplay.ClearDisplayedData();

        // Remove all the scrollbars ...
        objQueryResultsDisplay.UpdateScrollbarOnSections(true);
    }
}

// **************************************************************************
// FUNCTION: LoadData
// USAGE:    arrLayerData - Array of objects created by CreateLayerData 
//                          { MapLayerID: strMapLayerID, Data: arrData }
//           blnClearExistingData - true to clear the existing data ...
// **************************************************************************
TrimbleMap.QueryResultsDisplay.LoadData = function LoadData(arrLayerData, blnClearExistingData) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // When are to clear the existing data ...
    if (blnClearExistingData) { objQueryResultsDisplay.Data = {}; }

    // Add to the loaded data ...
    objQueryResultsDisplay.AddToData(arrLayerData);

    // Load the data into the knockout arrays ...
    objQueryResultsDisplay.DisplayData(true);
}

// **************************************************************************
// FUNCTION: FilterData
// USAGE:    arrLayerData - Array of objects created by CreateLayerData 
//                          { MapLayerID: strMapLayerID, Data: arrData }
// **************************************************************************
TrimbleMap.QueryResultsDisplay.FilterData = function FilterData(arrLayerData, enFilterDataMethod) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Remove data from the loaded data object ...
    objQueryResultsDisplay.RemoveFromData(arrLayerData, enFilterDataMethod);

    // Load the data into the knockout arrays ...
    objQueryResultsDisplay.DisplayData(true);
}

// **************************************************************************
// FUNCTION: ClearAllResultData
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.ClearAllResultData = function ClearAllResultData() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // When we do have a highlighted query result element, hide the map callout ...
    if (objQueryResultsDisplay.HighlightedQueryResultElement) { objQueryResultsDisplay.MapCallout.Hide(); }

    // Clear all the loaded data and geometries ...
    objQueryResultsDisplay.Data = {};
    objQueryResultsDisplay.GeometryCache = {};

    // Load the data into the knockout arrays ...
    objQueryResultsDisplay.DisplayData(false);
}

// **************************************************************************
// FUNCTION: ClearAllKnockoutArrays
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.ClearAllKnockoutArrays = function ClearAllKnockoutArrays() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Loop through all the group by sections ...
    objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

        // Get the result data for the group by section ...
        var arrResultData = objQueryResultsDisplay.ResultData[objMapLayerGroupBySection.MapLayerGroupBySectionID];

        // Clear all the existing results ...
        arrResultData.removeAll();
    });
}

// **************************************************************************
// FUNCTION: ClearDisplayedData
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.ClearDisplayedData = function ClearDisplayedData() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Increment the load data counter to prevent further loading ...
    objQueryResultsDisplay.LoadDataCounter = objQueryResultsDisplay.LoadDataCounter + 1;

    // Clear all the arrays that are bound with knockout ...
    objQueryResultsDisplay.ClearAllKnockoutArrays();

    // Remember the previous section display details (only when we have sectin details) ...
    if (objQueryResultsDisplay.CurrentSectionDisplayDetails) { objQueryResultsDisplay.PreviousSectionDisplayDetails = objQueryResultsDisplay.CurrentSectionDisplayDetails; }

    // Clear all the loaded data and section display details ...
    objQueryResultsDisplay.DisplayedData = {};
    objQueryResultsDisplay.DisplayedCountForSection = {};
    objQueryResultsDisplay.MinimumCountForSection = {};
    objQueryResultsDisplay.CurrentSectionDisplayDetails = null;
    objQueryResultsDisplay.ResultsToBeLoaded = {};
    objQueryResultsDisplay.GroupBySectionCounts = {};
}

// **************************************************************************
// FUNCTION: DisplayData
// USAGE     blnShowNoResultsLabelWhenNoResults - when true the "no results" text 
//           will be shown when here no results ...
// **************************************************************************
TrimbleMap.QueryResultsDisplay.DisplayData = function DisplayData(blnShowNoResultsLabelWhenNoResults) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // When the group by section elements has been created ... 
    objQueryResultsDisplay.GroupBySectionElementsDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

        // Loop through all the map layer group by sections in the current map ...
        objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

            // Hide the loading more results div for the section ...
            objQueryResultsDisplay.LoadingIndicators[objMapLayerGroupBySection.MapLayerGroupBySectionID].hide();
        });

        // When visible ...
        if (objQueryResultsDisplay.IsVisible) {

            // Prepare for loading the data ...
            objQueryResultsDisplay.ClearDisplayedData();

            // Hide the no results div ...
            objQueryResultsDisplay.NoResults.hide();

            // Get the current map ID ...
            var strCurrentMapID = objQueryResultsDisplay.MapController.CurrentMap.MapID;

            // * Accumulate the results by map layer group by section ...

            // Loop through all the map layers for which we have data to load ...
            $.each(objQueryResultsDisplay.Data, function (strMapLayerID, objMapLayerData) {

                // Get the group by section in which the map layer is ...
                var objMapLayerGroupBySection = objQueryResultsDisplay.MapController.GetMapLayerGroupBySectionForMapLayer(strCurrentMapID, strMapLayerID);

                // Create a new array for the data to add ...
                var arrDataToAdd = [];

                // Get the map layer ...
                var objMapLayer = objQueryResultsDisplay.MapController.GetMapLayer(strMapLayerID);

                // Get the ID field name ...
                var strMapLayerIDFieldName = objQueryResultsDisplay.MapController.GetMapLayerIDFieldName(objMapLayer)

                // Start with 0 added ...
                var intAddedCount = 0;

                // Loop through all the items to add ...
                $.each(objMapLayerData.Data, function (strID, objResultDataToLoad) {

                    // Add the MapLayerID field to the result object ...
                    objResultDataToLoad.MapLayerID = strMapLayerID;

                    // Add it to the array of data to load ...
                    arrDataToAdd.push(objResultDataToLoad);

                    // Increment the count ...
                    intAddedCount++;
                });

                // When we already have a results array for the map layer group by section ...
                if (typeof objQueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID] != 'undefined') {

                    // Add it to the accumulated results for the map layer group by section ...
                    objQueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objQueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID].concat(arrDataToAdd);

                } else {

                    // Set the results array in the dictionary for the map layer group by section ...
                    objQueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID] = arrDataToAdd;
                }

                // When we do not have a count for the group by section yet ...
                if (typeof objQueryResultsDisplay.GroupBySectionCounts[objMapLayerGroupBySection.MapLayerGroupBySectionID] == 'undefined') {

                    // Set it as the count ...
                    objQueryResultsDisplay.GroupBySectionCounts[objMapLayerGroupBySection.MapLayerGroupBySectionID] = TrimbleMap.QueryResultsDisplay.Shared.CreateGroupBySectionCountObject(intAddedCount, objMapLayerData.TotalCount, objMapLayerData.ExactCountRetrieved);

                } else {

                    // Get the object containing the counts ...
                    var objCount = objQueryResultsDisplay.GroupBySectionCounts[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                    // Add to the count and total counts ...
                    objCount.Count += intAddedCount;
                    objCount.TotalCount += objMapLayerData.TotalCount;
                }
            });

            // * Sort the data ...

            // Loop through all the map layer group by sections in the current map ...
            objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

                // Get the accumulated results for the group by section ...
                var arrAccumulatedResults = objQueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                // When we are to sort the data for the this section ...
                if (objMapLayerGroupBySection.SortData && (typeof arrAccumulatedResults != 'undefined') && (arrAccumulatedResults != null)) {

                    // Sort the items in the array according to the SortByFieldName ...
                    arrAccumulatedResults.sort(function (objItemA, objItemB) {
                        return (objItemA.Attributes[objMapLayerGroupBySection.SortByFieldName] < objItemB.Attributes[objMapLayerGroupBySection.SortByFieldName]) ? -1 : 1;
                    });
                }
            });

            // Loop through all the map layer group by sections in the current map ...
            objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

                // When we have any accumulated results for the map layer group by section ...
                if (typeof objQueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID] != 'undefined') {

                    // Get the accumulated results for the group by section ...
                    var arrAccumulatedResults = objQueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                    // Deteremine whether or not we have more results to load into the section ...
                    var blnMoreToLoad = arrAccumulatedResults.length > TrimbleMap.QueryResultsDisplay.Shared.RESULTS_TO_LOAD_IMMEDIATELY;

                    // Set the minimum to be loaded ...
                    objQueryResultsDisplay.MinimumCountForSection[objMapLayerGroupBySection.MapLayerGroupBySectionID] = (blnMoreToLoad) ? TrimbleMap.QueryResultsDisplay.Shared.RESULTS_TO_LOAD_IMMEDIATELY : arrAccumulatedResults.length;
                }
            });

            // * Load the first RESULTS_TO_LOAD_IMMEDIATELY items, and log the rest to be loaded later ...

            // Loop through all the layers in the current map ...
            objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

                // When we have any accumulated results for the map layer group by section ...
                if (typeof objQueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID] != 'undefined') {

                    // Accumulated results ...
                    var arrAccumulatedResults = objQueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                    // Get the result data ...
                    var arrResultData = objQueryResultsDisplay.ResultData[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                    // When an entry for the map layer name do not exist yet ...
                    if (typeof objQueryResultsDisplay.ResultsToBeLoaded[objMapLayerGroupBySection.MapLayerGroupBySectionID] == 'undefined') {

                        // Create an array to hold the data that has not been loaded for the map layer yet ....
                        objQueryResultsDisplay.ResultsToBeLoaded[objMapLayerGroupBySection.MapLayerGroupBySectionID] = [];
                    }

                    // Get the results to be loaded for this map layer group by section ...
                    var arrResultsToBeLoadedForMapLayerGroupBySection = objQueryResultsDisplay.ResultsToBeLoaded[objMapLayerGroupBySection.MapLayerGroupBySectionID];

                    // Loop through all the results ...
                    for (var intResult = 0; intResult < arrAccumulatedResults.length; intResult++) {

                        // Get the result ...
                        var objResultDataToLoad = arrAccumulatedResults[intResult];

                        // When there are more results that is to be loaded immediately ...
                        if (intResult < TrimbleMap.QueryResultsDisplay.Shared.RESULTS_TO_LOAD_IMMEDIATELY) {

                            // Add to the array ...
                            arrResultData.push(objResultDataToLoad);

                        } else {

                            // Add the result ...
                            arrResultsToBeLoadedForMapLayerGroupBySection.push(objResultDataToLoad);
                        }
                    }
                }
            });

            // Update the group by section counts ...
            objQueryResultsDisplay.UpdateGroupBySectionCounts();

            // Scroll all the sections to the top ...
            objQueryResultsDisplay.ScrollAllToTop();

            // When we do not have any data to display ...
            if (!objQueryResultsDisplay.HasData()) {

                // Update the section displays (since the knockout after render will not fire in this case) ... 
                objQueryResultsDisplay.UpdateSectionDisplays();

                // Show the no results div ...
                if (blnShowNoResultsLabelWhenNoResults) { objQueryResultsDisplay.NoResults.show(); }
            }
        }
    }));
}

// **************************************************************************
// FUNCTION: AddToData
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.AddToData = function AddToData(arrLayerData) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Add the array data to the Data object ...
    objQueryResultsDisplay.AddArrayDataToObject(arrLayerData, objQueryResultsDisplay.Data);

    // Add the geometries to the cache ...
    objQueryResultsDisplay.AddGeometriesToGeometryCache(arrLayerData);
}

// **************************************************************************
// FUNCTION: AddArrayDataToObject
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.AddArrayDataToObject = function AddArrayDataToObject(arrLayerData, objData) {
    // Get the instance ...
    let objQueryResultsDisplay = this;

    // Loop through all the layer data ...
    $.each(arrLayerData, function (intLayerData, objLayerData) {

        // Get the loaded data for the map layer ...
        var objLoadedMapLayerData = objData[objLayerData.MapLayerID];

        // When we do not have any data for the layer yet ...
        if (typeof objLoadedMapLayerData == 'undefined') {

            // Create the layer data object for the layer ...
            objLoadedMapLayerData = {
                Data: {},
                MapLayerID: objLayerData.MapLayerID,
                TotalCount: objLayerData.TotalCount,
                ExactCountRetrieved: objLayerData.ExactCountRetrieved
            }

            // Add it to Data ...
            objData[objLayerData.MapLayerID] = objLoadedMapLayerData;

        } else {

            // Update the exact count retrieved flag ...
            if (!objLayerData.ExactCountRetrieved) { objLoadedMapLayerData.ExactCountRetrieved = false; }
        }

        // Get the map layer in which the object is
        let objMapLayer = objQueryResultsDisplay.MapController.GetMapLayer(objLayerData.MapLayerID);

        // Get the map layer ID field name ...
        let strRestServiceIDFieldName = objQueryResultsDisplay.MapController.GetMapLayerIDFieldName(objMapLayer);

        // Loop through all the data for the layer ...
        $.each(objLayerData.Data, function (intData, objData) {
            // Get the object's id ...
            let strID = objData.Attributes[strRestServiceIDFieldName];

            if (!objLoadedMapLayerData.Data[strID]) {
                // Place the data into the loaded data object for the map layer ...
                objLoadedMapLayerData.Data[strID] = objData;

                if (objLoadedMapLayerData.ExactCountRetrieved) {
                    // Update the total count ...
                    objLoadedMapLayerData.TotalCount++;
                }

            } else {

                // Multiple features with the same Id
                let strTitle = SD.Translation.Shared.GetTranslation('Map.QueryResultsDisplay.js', 'MapServiceLayerResultsNotUniqueTitle');

                // Multiple features with the same Id %1 were found in map service %2 map layer %3.
                let strMessage = SD.Translation.Shared.GetTranslation('Map.QueryResultsDisplay.js', 'MapServiceLayerResultsNotUniqueMessage', strID, objData.MapService.MapServiceName, objMapLayer.MapLayerName);

                // Multiple features with the same Id %1 were found in map service %2 map layer %3. Search and Select functions cannot display results correctly for the layer. Please ensure the Id field contains unique values only.
                let strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.QueryResultsDisplay.js', 'MapServiceLayerResultsNotUniqueEndUserMessage', strID, objData.MapService.MapServiceName, objMapLayer.MapLayerName);

                // Log the diagnostic message ...
                objQueryResultsDisplay.MapController.LogDiagnosticMessage(strTitle, strMessage, "", strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, "");
            }
        });
    });
}

// **************************************************************************
// FUNCTION: IsItemLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.IsItemLoaded = function IsItemLoaded(strMapLayerID, strID) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Get the map layer data ...
    var objMapLayerData = objQueryResultsDisplay.Data[strMapLayerID];

    // When we have data for the map layer, check if we have data for the item ...
    if (typeof objMapLayerData != 'undefined') { return (typeof objMapLayerData.Data[strID] != 'undefined'); } else { return false; }
}

// **************************************************************************
// FUNCTION: RemoveFromData
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.RemoveFromData = function RemoveFromData(arrLayerData, enFilterDataMethod) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    switch (enFilterDataMethod) {
        case TrimbleMap.enumFilterDataMethod.RemoveInputData:

            // Loop through all the layer data ...
            $.each(arrLayerData, function (intLayerData, objLayerData) {

                // Get the loaded data for the map layer ...
                var objLoadedMapLayerData = objQueryResultsDisplay.Data[objLayerData.MapLayerID];

                // When we do not have any data for the layer yet ...
                if (typeof objLoadedMapLayerData != 'undefined') {

                    // Get the map layer in which the object is ...
                    var objMapLayer = objQueryResultsDisplay.MapController.GetMapLayer(objLayerData.MapLayerID);

                    // Get the map layer ID field name ...
                    var strRestServiceIDFieldName = objQueryResultsDisplay.MapController.GetMapLayerIDFieldName(objMapLayer);

                    // Loop through all the data for the layer ...
                    $.each(objLayerData.Data, function (intData, objData) {

                        // Get the object's id ...
                        var strID = objData.Attributes[strRestServiceIDFieldName];

                        // Remove the item ...
                        if (typeof objLoadedMapLayerData.Data[strID] != 'undefined') { delete objLoadedMapLayerData.Data[strID]; objLoadedMapLayerData.TotalCount--; }
                    });
                }
            });
            break;

        case TrimbleMap.enumFilterDataMethod.OnlyKeepInputData:

            // Convert the input array to an object that contains the data to keep in objects instead of arrays ...
            var objDataToKeep = {};
            objQueryResultsDisplay.AddArrayDataToObject(arrLayerData, objDataToKeep);

            // Loop through all the loaded data ...
            $.each(objQueryResultsDisplay.Data, function (strMapLayerID, objSectionData) {

                // Get the data to keep for the layer ...
                var objSectionDataToKeep = objDataToKeep[strMapLayerID];

                // Get the first map layer for the section ...
                var objMapLayer = objQueryResultsDisplay.MapController.GetMapLayer(strMapLayerID);

                // Get the map layer ID field name ...
                var strRestServiceIDFieldName = objQueryResultsDisplay.MapController.GetMapLayerIDFieldName(objMapLayer);

                // Create a new array for the IDs to remove ...
                var arrIDToRemove = [];

                // Loop through all the data for the layer ...
                $.each(objSectionData.Data, function (intData, objData) {

                    // Get the object's id ...
                    var strID = objData.Attributes[strRestServiceIDFieldName];

                    // When the ID is not in the data to keep ...
                    if ((typeof objSectionDataToKeep == 'undefined') || (typeof objSectionDataToKeep.Data[strID] == 'undefined')) {

                        // Add the ID to the array of IDs to remove ...
                        arrIDToRemove.push(strID);
                    }
                });

                // Loop through all the IDs to keep ...
                $.each(arrIDToRemove, function (intID, strID) {

                    // Remove the item ...
                    if (typeof objSectionData.Data[strID] != 'undefined') { delete objSectionData.Data[strID]; }
                });
            });
            break;
    }
}

// **************************************************************************
// FUNCTION: HasData
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.HasData = function HasData() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Start with not having any data ...
    var blnHasData = false;

    // Loop through all the loaded data ...
    $.each(objQueryResultsDisplay.Data, function (strMapLayerGroupBySectionID, objMapLayerGroupBySectionData) {

        // Loop through all the data items for the section ...
        $.each(objMapLayerGroupBySectionData.Data, function (intDataItem, objDataItem) {

            // Set to have data ...
            blnHasData = true;

            // Stop checking ...
            return false;
        });
    });

    return blnHasData;
}

// **************************************************************************
// FUNCTION: UpdateScrollbarOnSections
// USAGE:    blnRemoveAll - Optional and defaults to false ...
// **************************************************************************
TrimbleMap.QueryResultsDisplay.UpdateScrollbarOnSections = function UpdateScrollbarOnSections(blnRemoveAll) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Default blnRemoveAll to false when not set ...
    if ((typeof blnRemoveAll == 'undefined') || (blnRemoveAll == null)) { blnRemoveAll = false; }

    // When we have section display details ...
    if (blnRemoveAll || (objQueryResultsDisplay.CurrentSectionDisplayDetails != null)) {

        // Loop through all the layers in the current map ...
        objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

            // Get the group by section id ...
            var strMapLayerGroupBySectionID = objMapLayerGroupBySection.MapLayerGroupBySectionID;

            // Check if we need a scrollbar for the section ...
            var blnNeedScrollbarForSection = blnRemoveAll ||
                (objQueryResultsDisplay.CurrentSectionDisplayDetails.IsVisible(objMapLayerGroupBySection.MapLayerGroupBySectionID) &&
                    (typeof objQueryResultsDisplay.CurrentSectionDisplayDetails.SectionsWithScrollbars[strMapLayerGroupBySectionID] != 'undefined'));

            // Get the nice scroll for the section ...
            var objNiceScroll = objQueryResultsDisplay.NiceScrolls[strMapLayerGroupBySectionID];

            // When visible and the event handlers are attached ...
            if ((blnNeedScrollbarForSection && objQueryResultsDisplay.EventHandlersAttached) && (!blnRemoveAll)) {

                // When we do not already have a nice scroll for the section ...
                if (!objNiceScroll) {

                    // Activate the scrollbar ...
                    objQueryResultsDisplay.NiceScrolls[strMapLayerGroupBySectionID] = objQueryResultsDisplay.ScrollContainerDivs[strMapLayerGroupBySectionID].niceScroll({ cursorwidth: "7px" });
                }

            } else {

                // When we have a nice scroll for the section ...
                if (objNiceScroll) {

                    // De-activate the scrollbar ...
                    objNiceScroll.hide();
                    objNiceScroll.remove();
                    objQueryResultsDisplay.NiceScrolls[strMapLayerGroupBySectionID] = null;
                }
            }
        });
    }

    // Set to be activated ...
    objQueryResultsDisplay.ScrollbarsActivated = true;
}

// **************************************************************************
// FUNCTION: GetGroupBySectionCount
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.GetGroupBySectionCount = function GetGroupBySectionCount(strMapLayerGroupBySectionID) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Start with 0 ...
    var intGroupBySectionCount = 0;

    // When we have any counts ...
    if (objQueryResultsDisplay.GroupBySectionCounts) {

        //  Get the group by section count ...
        var objGroupBySectionCount = objQueryResultsDisplay.GroupBySectionCounts[strMapLayerGroupBySectionID];

        // When we have a count for the map layer group by section ...
        if ((typeof objGroupBySectionCount != 'undefined') && (objGroupBySectionCount)) {

            // Get the count ...
            intGroupBySectionCount = objGroupBySectionCount.Count;
        }
    }

    return intGroupBySectionCount;
}

// **************************************************************************
// FUNCTION: SetGroupBySectionCountsFromData
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.SetGroupBySectionCountsFromData = function SetGroupBySectionCountsFromData() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Loop through all the map layer group by sections in the current map ...
    objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

        // Get the loaded data for the map layer group by section ...
        var objMapLayerGroupBySectionData = objQueryResultsDisplay.Data[objMapLayerGroupBySection.MapLayerGroupBySectionID];

        // Start with none ...
        var intSectionCount = 0;

        // When we have loaded data for the section ...
        if (typeof objMapLayerGroupBySectionData != 'undefined') {

            // Add to the section count ...
            $.each(objMapLayerGroupBySectionData.Data, function () { intSectionCount++; });
        }

        // When we do not have counts for the section yet ...
        if (typeof objQueryResultsDisplay.GroupBySectionCounts[objMapLayerGroupBySection.MapLayerGroupBySectionID] == 'undefined') {

            // Create and set the count for the section ...
            objQueryResultsDisplay.GroupBySectionCounts[objMapLayerGroupBySection.MapLayerGroupBySectionID] = TrimbleMap.QueryResultsDisplay.Shared.CreateGroupBySectionCountObject(intSectionCount, -1, true);

        } else {

            // Get the object containing the counts ...
            var objCount = objQueryResultsDisplay.GroupBySectionCounts[objMapLayerGroupBySection.MapLayerGroupBySectionID];

            // Set the count ...
            objCount.Count = intSectionCount;
        }
    });
}

// **************************************************************************
// FUNCTION: UpdateGroupBySectionCounts
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.UpdateGroupBySectionCounts = function UpdateGroupBySectionCounts() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Get the heading width (for spacing calculations later) ...
    var intHeadingWidth = parseInt(objQueryResultsDisplay.QueryResultsDisplayDiv.innerWidth() - 2);

    // Loop through all the layers in the current map ...
    objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

        // When we do have a counter for the group by section ...
        if (typeof objQueryResultsDisplay.GroupBySectionCounts[objMapLayerGroupBySection.MapLayerGroupBySectionID] != 'undefined') {

            // Get the object containing the counts ...
            var objCount = objQueryResultsDisplay.GroupBySectionCounts[objMapLayerGroupBySection.MapLayerGroupBySectionID];

            // Determine the count string to display ...
            var strCount;

            // When we were able to retrieve the exact count ...
            if (objCount.ExactCountRetrieved) {

                // Use 'Count of TotalCount' when TotalCount > Count otherwise just 'Count' ...
                strCount = (objCount.TotalCount > objCount.Count) ? (String(objCount.Count) + ' of ' + String(objCount.TotalCount)) : objCount.Count;

            } else {

                // Use 'Count of more than TotalCount' when TotalCount = Count otherwise just 'Count' ...
                strCount = (objCount.TotalCount == objCount.Count) ? (String(objCount.Count) + ' of more than ' + String(objCount.TotalCount)) : objCount.Count;
            }

            // Get the count span ...
            var objCountSpan = objQueryResultsDisplay.QueryResultsDisplayHeadingCountSpans[objMapLayerGroupBySection.MapLayerGroupBySectionID];

            // Set the count in the heading ...
            objCountSpan.text('(' + strCount + ')');

            // *** Compute and update the max-width of the layer name span ...

            // Get the heading element ...
            var objHeadingElement = objCountSpan.closest('.QueryResultsDisplayHeading');

            // Get the div containing the count span ...
            var objCountDiv = objHeadingElement.find('.QueryResultsDisplayHeadingCountSpanDiv');

            // Get the menu icon div ...
            var objMenuDiv = objHeadingElement.find('.result-menu');

            // Get the div containing the map layer name ...
            var objLayerNameDiv = objHeadingElement.find('.heading-text');

            // Get the div that provides the left marging for the map layer name ...
            var objLayerNameMarginDiv = objHeadingElement.find('.heading-text');

            // Measure the count div ....
            var objCountDivSize = SD.HtmlFunctions.Shared.MeasureElement(objCountDiv);

            // Compute the max width for the layer name to there is enough space ...
            var intMaxWidth = intHeadingWidth - objCountDivSize.width - parseInt(objMenuDiv.outerWidth()) - parseInt(objLayerNameMarginDiv.css('margin-inline-start')) - 5;

            // Set the max width of the layer name ...
            objLayerNameDiv.css('max-width', String(intMaxWidth) + 'px');
        }
    });
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.AttachEventHandlers = function AttachEventHandlers() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // When the event handlers is not attached ...
    if (!objQueryResultsDisplay.EventHandlersAttached) {

        // Set to have attached the event handlers ...
        objQueryResultsDisplay.EventHandlersAttached = true;

        // Attach a click event handler to the main div ...
        objQueryResultsDisplay.QueryResultsDisplayDiv.on('click',(objQueryResultsDisplay.QueryResultsDisplayClickedProxy));

        // Attach a mouse over event handler to the main div ...
        objQueryResultsDisplay.QueryResultsDisplayDiv.on('mouseover',(objQueryResultsDisplay.QueryResultsDisplayMouseOverProxy));

        // Attach a mouse leave event handler to the main div ...
        objQueryResultsDisplay.QueryResultsDisplayDiv.on('mouseleave',(objQueryResultsDisplay.QueryResultsDisplayMouseLeaveProxy));

        // Loop through all the map layer group by sections in the current map ...
        objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

            // Attach the scroll event proxy ...
            objQueryResultsDisplay.ScrollContainerDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID].on('scroll',(objQueryResultsDisplay.SectionScrolledProxy));
        });

        // Update the scrollbars ...
        objQueryResultsDisplay.UpdateScrollbarOnSections();

        // Loop through the view in list popup menus for each map layer group by section ...
        $.each(objQueryResultsDisplay.PopupMenus, function (strMapLayerGroupBySectionID, objPopupMenu) {

            // Attach the event handlers ...
            objPopupMenu.AttachEventHandlers();
        });

        // When the group by section elements have beeen created ...
        if (objQueryResultsDisplay.GroupBySectionElementsCreatedForCurrentMap) {

            // Apply the knockout bindings ...
            objQueryResultsDisplay.ApplyKnockoutBindings();
        }
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.DetachEventHandlers = function DetachEventHandlers() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // When the event handlers is attached ...
    if (objQueryResultsDisplay.EventHandlersAttached) {

        // Set to not have the event handlers attached ...
        objQueryResultsDisplay.EventHandlersAttached = false;

        // Detach the click event handler to the main div ...
        objQueryResultsDisplay.QueryResultsDisplayDiv.off('click', objQueryResultsDisplay.QueryResultsDisplayClickedProxy);

        // Detach the mouse over event handler to the main div ...
        objQueryResultsDisplay.QueryResultsDisplayDiv.off('mouseover', objQueryResultsDisplay.QueryResultsDisplayMouseOverProxy);

        // Detach the mouse leave event handler to the main div ...
        objQueryResultsDisplay.QueryResultsDisplayDiv.off('mouseleave', objQueryResultsDisplay.QueryResultsDisplayMouseLeaveProxy);

        // Loop through all the map layer group by sections in the current map ...
        objQueryResultsDisplay.ForEachMapLayerGroupBySectionInCurrentMapInOrder(function (objMapLayerGroupBySection) {

            // Detach the scroll event proxy ...
            objQueryResultsDisplay.ScrollContainerDivs[objMapLayerGroupBySection.MapLayerGroupBySectionID].off('scroll', objQueryResultsDisplay.SectionScrolledProxy);
        });

        // Update the scrollbars ...
        objQueryResultsDisplay.UpdateScrollbarOnSections();

        // Loop through the view in list popup menus for each map layer group by section ...
        $.each(objQueryResultsDisplay.PopupMenus, function (strMapLayerGroupBySectionID, objPopupMenu) {

            // Attach the event handlers ...
            objPopupMenu.DetachEventHandlers();
        });

        // UnApply the knockout bindings when applied ...
        objQueryResultsDisplay.RemoveKnockoutBindings();
    }
}

// **************************************************************************
// FUNCTION: CreateLoadingMoreResultsSpinners
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.CreateLoadingMoreResultsSpinners = function CreateLoadingMoreResultsSpinners() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Get all the spinner elements for the loading indicators ...
    var objSpinnerElements = $(objQueryResultsDisplay.QueryResultsDisplayDiv.find('.results-spinner'));

    // Loop through all the spinner elements ...
    for (var intSpinnerElement = 0; intSpinnerElement < objSpinnerElements.length; intSpinnerElement++) {

        // Get the element id ...
        var objSpinnerElement = $(objSpinnerElements.get(intSpinnerElement));

        // Create the spinner ...
        SD.SpinnerFunctions.Shared.CreateSpinner(objSpinnerElement, 4, 9, 10, 2, '#000080');
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SectionScrolled
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.SectionScrolled = function SectionScrolled(e) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Get the target element that were scrolled ...
    var objScrollableContainerDiv = $(e.target);

    // Get the map layer group by section ID ...
    var strMapLayerGroupBySectionID = objScrollableContainerDiv.attr('MapLayerGroupBySectionID');

    // Get the scrollable inner div ...
    var objScrollContainerInnerDiv = objQueryResultsDisplay.ScrollContainerInnerDivs[strMapLayerGroupBySectionID];

    // Get the sections content height ...
    var intSectionContentHeight = parseInt(objScrollContainerInnerDiv.outerHeight());

    // Get the section's available height ...
    var intSectionAvailableHeight = parseInt(objScrollableContainerDiv.outerHeight());

    // Get the current scrolling position ...
    var intScrollTop = parseInt(objScrollableContainerDiv.scrollTop());

    // When we've scrolled to below the scroll buffer at the bottom ...
    if ((intScrollTop + intSectionAvailableHeight) > (intSectionContentHeight - TrimbleMap.QueryResultsDisplay.Shared.SCROLL_BUFFER_PIXELS)) {

        // Get the results for the section that has not been loaded yet ...
        var arrResultDataToLoad = objQueryResultsDisplay.ResultsToBeLoaded[strMapLayerGroupBySectionID];

        // When we have more results to load for the section ...
        if ((typeof arrResultDataToLoad != 'undefined') && (arrResultDataToLoad.length > 0)) {

            // Get the observable array to load into ...
            var arrResultDataToLoadInto = objQueryResultsDisplay.ResultData[strMapLayerGroupBySectionID];

            // Get the dislpayed count for the section ...
            var intDisplayedCountForSection = objQueryResultsDisplay.GetDisplayedCountForSection(strMapLayerGroupBySectionID);

            // Get the internal javascript array for the results to be loaded ...
            var arrInternalResultDataToLoadInto = arrResultDataToLoadInto();

            // When we have results to be loaded ...
            if ((typeof arrInternalResultDataToLoadInto != 'undefined') && (arrInternalResultDataToLoadInto != null)) {

                // When all the results added to the knockout observable array has been rendered ...
                if (intDisplayedCountForSection >= arrInternalResultDataToLoadInto.length) {

                    // Show the loading more results div for the map layer ...
                    objQueryResultsDisplay.LoadingIndicators[strMapLayerGroupBySectionID].show();

                    // Start with none loaded ...
                    var intCount = 0;

                    // While there are more results to load and we have not loaded the chunk size during this call yet ...
                    while ((arrResultDataToLoad.length > 0) && (intCount < TrimbleMap.QueryResultsDisplay.Shared.DELAYED_RESULTS_LOAD_CHUNK_SIZE)) {

                        // Increment the count ...
                        intCount = intCount + 1;

                        // Get the first element from the array and remove it from the array ...
                        var objResultData = arrResultDataToLoad.shift();

                        // Add to the observable array ...
                        arrResultDataToLoadInto.push(objResultData);
                    }

                    // Hide the loading more results div for the map layer ...
                    objQueryResultsDisplay.LoadingIndicators[strMapLayerGroupBySectionID].hide();
                }
            }
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION QueryResultsDisplayClicked
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.QueryResultsDisplayClicked = function QueryResultsDisplayClicked(e) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Get the target that has been clicked on ...
    var objTarget = $(e.target);

    // Get the elements in which we are that are clickable ...
    var objQueryResultsDisplayHeading = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'QueryResultsDisplayHeading');
    var objHoveredResultIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'HoveredResultIconIndex');
    var objQueryResult = SD.DOM.GetElementOrParentWithClass(objTarget, 'result-item');

    switch (true) {
        case (objQueryResultsDisplayHeading != null):

            // When we are not busy animating a section transition ...
            if (!objQueryResultsDisplay.AnimatingSectionTransition) {

                // Get the map layer group by section id for the heading clicked on ...
                var strMapLayerGroupBySectionID = objQueryResultsDisplayHeading.attr('MapLayerGroupBySectionID');

                // Determine the group section heights ...
                let objSectionDisplayDetails = objQueryResultsDisplay.DetermineSectionDisplayDetails(strMapLayerGroupBySectionID);

                // Change the section displays ...
                objQueryResultsDisplay.ChangeSectionDisplays(objSectionDisplayDetails, true);
            }
            break;

        case (objHoveredResultIcon != null):

            // Get the icon index ...
            var intHoveredResultIconIndex = Number(objHoveredResultIcon.attr('HoveredResultIconIndex'));

            // Get the icon ...
            var objHoveredResultIcon = objQueryResultsDisplay.HoveredResultIcons[intHoveredResultIconIndex];

            // Get the data for the query result element ...
            var objDeferred = objQueryResultsDisplay.GetDataForQueryResultElement(objQueryResult);

            // When the data gets returned ...
            objDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objDataForQueryResult) {

                // Call the clicked function ...
                objHoveredResultIcon.ClickFunction(objDataForQueryResult);
            }));
            break;

        case (objQueryResult != null):

            // Highlight and zoom to the query result ...
            objQueryResultsDisplay.GetGeometryAndHighligthAndZoomToResult(objQueryResult, TrimbleMap.Callout.enumExtentChange.PanAndZoomOut);
            break;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ZoomToIconClicked
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.ZoomToIconClicked = function ZoomToIconClicked(objDataForQueryResult) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Highlight and zoom to the query result ...
    objQueryResultsDisplay.HighligthAndZoomToResult(objDataForQueryResult, TrimbleMap.Callout.enumExtentChange.Zoom);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION QueryResultsDisplayMouseOver
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.QueryResultsDisplayMouseOver = function QueryResultsDisplayMouseOver(e) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Get the target that has been clicked on ...
    var objTarget = $(e.target);

    // Get the query result div over which we are hovering ...
    var objHoveredQueryResultElement = SD.DOM.GetElementOrParentWithClass(objTarget, 'result-item');

    // When we have a hovered result element ...
    if (objHoveredQueryResultElement) {

        // When we are hovering over another element than the element (if any) that we were hovering over ...
        if ((!objQueryResultsDisplay.HoveredQueryResultElement) || (!objHoveredQueryResultElement.is(objQueryResultsDisplay.HoveredQueryResultElement))) {

            // Hide the hovered result icons (if any) ...
            objQueryResultsDisplay.HideHoveredResultIcons();

            // Display the hovered result icons on the hovered result element ...
            objQueryResultsDisplay.DisplayHoveredResultIcons(objHoveredQueryResultElement);
        }
    } else {

        // Hide the hovered result icons (if any) ...
        objQueryResultsDisplay.HideHoveredResultIcons();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION QueryResultsDisplayMouseLeave
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.QueryResultsDisplayMouseLeave = function QueryResultsDisplayMouseLeave() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Hide the hovered result icons (if any) ...
    objQueryResultsDisplay.HideHoveredResultIcons();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ShowSpinner
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.ShowSpinner = function ShowSpinner(strSpinnerText) {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Only when the spinner is not visible yet ...
    if (!objQueryResultsDisplay.SpinnerVisible) {

        // Create the background div for the spinner ...
        objQueryResultsDisplay.SpinnerBackgroundDiv = $('<div class="spinner-backdrop"></div>');

        // Resize the query results display ...
        objQueryResultsDisplay.Resize();

        // Resize the spinner ...
        objQueryResultsDisplay.ResizeSpinner();

        // Hide the spinner element ...
        objQueryResultsDisplay.SpinnerBackgroundDiv.hide();

        // Add the background spinner div to the query results display div ...
        objQueryResultsDisplay.QueryResultsDisplayDiv.prepend(objQueryResultsDisplay.SpinnerBackgroundDiv);

        // Fade the background spinner in ...
        objQueryResultsDisplay.SpinnerBackgroundDiv.fadeIn(TrimbleMap.QueryResultsDisplay.Shared.SPINNER_FADE_OUT_DELAY);

        // Create the spinner elements within the SpinnerBackgroundDiv ...
        objQueryResultsDisplay.SpinnerElements = SD.SpinnerFunctions.Shared.CreateSpinnerInContainerElement(objQueryResultsDisplay.SpinnerBackgroundDiv, 9, 16, 18, 2, '#000080', strSpinnerText, 'spinner-text', 'spinner-group');

        // Set the spinner to be visible ...
        objQueryResultsDisplay.SpinnerVisible = true;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION HideSpinner
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.HideSpinner = function HideSpinner() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Only when the spinner is visible ...
    if (objQueryResultsDisplay.SpinnerVisible) {

        // Remove the spinner ...
        objQueryResultsDisplay.SpinnerBackgroundDiv.remove();
        objQueryResultsDisplay.SpinnerBackgroundDiv = null;
        objQueryResultsDisplay.SpinnerDiv = null;

        // Set the spinner to be not visible ...
        objQueryResultsDisplay.SpinnerVisible = false;
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ResizeSpinner
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.ResizeSpinner = function ResizeSpinner() {

    // Get the QueryResultsDisplay instance ...
    var objQueryResultsDisplay = this;

    // Get the container height ...
    var intContainerHeight = parseInt(objQueryResultsDisplay.ContainerElement.innerHeight(), 10);

    // Set the height of the SpinnerBackgroundDiv to match the query result display ...
    objQueryResultsDisplay.SpinnerBackgroundDiv.css('height', intContainerHeight);

    // When we have spinner elements yet ...
    if (objQueryResultsDisplay.SpinnerVisible) {

        // Position the spinner inside the spinner background element ...
        SD.SpinnerFunctions.Shared.PositionSpinnerInContainerElement(objQueryResultsDisplay.SpinnerElements);
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TemporarilyDeactivateZoomToResult
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.TemporarilyDeactivateZoomToResult = function TemporarilyDeactivateZoomToResult() {

    // This is just so that the user cannot click a lot of results in short succcession after each other and cause the map to clog up ...

    // Get the query result display instance ...
    var objQueryResultsDisplay = this;

    // Detach a click event handler to the main div ...
    objQueryResultsDisplay.QueryResultsDisplayDiv.off('click', objQueryResultsDisplay.QueryResultsDisplayClickedProxy);

    // Deactivate the hover styling on the query results ...
    objQueryResultsDisplay.QueryResultsDisplayDiv.addClass('query_result_div_deactivated');

    // Set a timer to rebind the click event after a second ...
    setTimeout(function () {

        // Re-activate the event ....
        objQueryResultsDisplay.QueryResultsDisplayDiv.click(objQueryResultsDisplay.QueryResultsDisplayClickedProxy);

        // De-activate the hover styling on the query results ...
        objQueryResultsDisplay.QueryResultsDisplayDiv.removeClass('query_result_div_deactivated');

    }, TrimbleMap.QueryResultsDisplay.Shared.DISABLE_HOVER_TIME_MS);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetGeometry
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.GetGeometry = function GetGeometry(objMapLayer, strID) {

    // Get the query result display instance ...
    var objQueryResultsDisplay = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Get the cached geometry (if any) for the object ...
    var objCachedGeometry = objQueryResultsDisplay.GetCachedGeometry(objMapLayer.MapLayerID, strID);

    // When we have a cached geometry for the object ...
    if (objCachedGeometry.InCache) {

        // Resolve the deferred with the geometry  ...
        objDeferred.resolve(objCachedGeometry.GeometryAndSpatialReference.Geometry);

    } else {

        // Get the geometry from the map service ...
        var objGetGeometriesFromMapServiceLayerDeferred = objQueryResultsDisplay.MapController.GetGeometriesFromMapServiceLayer(objMapLayer, strID);

        // When the geometry gets returned ...
        objGetGeometriesFromMapServiceLayerDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (arrGeometries) {

            // When we did get a geometry ...
            if (arrGeometries.length > 0) {

                // Get the first geometry ...
                var objGeometry = arrGeometries[0];

                // When the geometry is a polygon ...
                if ((objGeometry != null) && (objGeometry.type == 'polygon')) {

                    // * Deal with multiple parts stored as separate geometries in the feature class ...

                    // Loop through the rest of the geometries returned ...
                    for (var intGeometry = 1; intGeometry < arrGeometries.length; intGeometry++) {

                        // Get the geometry to add ...
                        var objGeometryToAdd = arrGeometries[intGeometry];

                        // Loop through all the rings of the geometry to add ...
                        for (var intRing = 0; intRing < objGeometryToAdd.rings.length; intRing++) {

                            // Get the ring ...
                            var objRing = objGeometryToAdd.rings[intRing];

                            // Add it to the geometry ...
                            objGeometry.addRing(objRing);
                        }
                    }
                }

                // Add the geometry to the cache ...
                objQueryResultsDisplay.AddToGeometryCache(objMapLayer.MapLayerID, strID, objGeometry, objQueryResultsDisplay.MapController.CurrentMap.SpatialReferenceID, true);

                // Resolve the deferred with the geometry  ...
                objDeferred.resolve(objGeometry);

            } else {

                // Resolve with null ...
                objDeferred.resolve(null);
            }
        }));
    }

    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetDataForQueryResultElement
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.GetDataForQueryResultElement = function GetDataForQueryResultElement(objQueryResultElement) {

    // Get the query result display instance ...
    var objQueryResultsDisplay = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Get the binding data for the element ...
    var objDataForElement = ko.dataFor(objQueryResultElement.get(0));

    // Get the map layer in which the object is ...
    var objMapLayer = objQueryResultsDisplay.MapController.GetMapLayer(objDataForElement.MapLayerID);

    // Get the map layer ID field name ...
    var strRestServiceIDFieldName = objQueryResultsDisplay.MapController.GetMapLayerIDFieldName(objMapLayer);

    // Get the object's id ...
    var strID = objDataForElement.Attributes[strRestServiceIDFieldName];

    // Get the geometry for the query result ...
    var objGetGeometryDeferred = objQueryResultsDisplay.GetGeometry(objMapLayer, strID);

    // When the geometry gets returned ...
    objGetGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objGeometry) {

        // Set the geometry and spatial reference id on the data for the element ...
        objDataForElement.Geometry = objGeometry;
        objDataForElement.SpatialReferenceID = objQueryResultsDisplay.MapController.CurrentMap.SpatialReferenceID;

        // Resolve the deferred with the result ...
        objDeferred.resolve({
            ID: strID,
            QueryResultElement: objQueryResultElement,
            DataForElement: objDataForElement,
            MapLayer: objMapLayer
        });
    }));

    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetDataForItem
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.GetDataForItem = function GetDataForItem(strMapLayerID, strID) {

    // Get the query result display instance ...
    var objQueryResultsDisplay = this;

    // Start with not found ...
    var objDataForItem = null;

    // Get the data for the map layer ...
    var objDataForMapLayer = objQueryResultsDisplay.Data[strMapLayerID];

    // Wen we have data for the map layer ...
    if ((typeof objDataForMapLayer != 'undefined') && (objDataForMapLayer != null)) {

        // Get the data for the item ...
        objDataForItem = objDataForMapLayer.Data[strID];

        // Set to null when undefined ...
        if (typeof objDataForItem == 'undefined') { objDataForItem = null; }
    }

    return objDataForItem;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetGeometryAndHighligthAndZoomToResult
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.GetGeometryAndHighligthAndZoomToResult = function GetGeometryAndHighligthAndZoomToResult(objQueryResultElement, enExtentChange) {

    // Get the query result display instance ...
    var objQueryResultsDisplay = this;

    // When the geometry for the query result element is not already highlighted ...
    if (objQueryResultsDisplay.HighlightedQueryResultElement != objQueryResultElement) {

        // Get the data for the query result element ...
        var objDeferred = objQueryResultsDisplay.GetDataForQueryResultElement(objQueryResultElement);

        // When the data gets returned ...
        objDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objDataForQueryResult) {

            // Highlight and zoom to the result ...
            objQueryResultsDisplay.HighligthAndZoomToResult(objDataForQueryResult, enExtentChange);
        }));
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION HighligthAndZoomToResult
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.HighligthAndZoomToResult = function HighligthAndZoomToResult(objDataForQueryResult, enExtentChange) {

    // Get the query result display instance ...
    var objQueryResultsDisplay = this;

    // Get the data for the element ...
    var objDataForElement = objDataForQueryResult.DataForElement;

    // Test if we have a valid geometry ...
    var blnHaveValidGeometry = objDataForElement.Geometry &&
        ((objDataForElement.Geometry.type != 'point') ||
            (!isNaN(objDataForElement.Geometry.x)) ||
            (!isNaN(objDataForElement.Geometry.y)));

    // When the item is visible ...
    if (blnHaveValidGeometry) {

        // Hide the callout ...
        objQueryResultsDisplay.MapCallout.Hide();

        // Remove the highlighted class from the highlighted query result div ...
        if (objQueryResultsDisplay.HighlightedQueryResultElement) { objQueryResultsDisplay.HighlightedQueryResultElement.removeClass('highlighted'); }

        // Add the highlighted class ...
        objDataForQueryResult.QueryResultElement.addClass('highlighted');

        // Get the highlighted query result element ...
        objQueryResultsDisplay.HighlightedQueryResultElement = objDataForQueryResult.QueryResultElement;

        // Temporarily de-activate the query result display click event handler ...
        objQueryResultsDisplay.TemporarilyDeactivateZoomToResult();

        // Declare a variable for the zoom to point ...
        var objZoomToPoint;

        // When we are to zoom to a geometry ...
        if (objDataForElement.Geometry.type == 'polygon') {

            // Compute a point inside the first ring of the polygon ...
            objZoomToPoint = TrimbleMap.Geometry.ComputePointInsidePolygon(objDataForElement.Geometry);

        } else if (objDataForElement.Geometry.type == 'polyline') {

            //zoom to center of extent
            objZoomToPoint = objDataForElement.Geometry.getExtent().getCenter();

        } else {

            // Set to zoom to the point to highlight ...
            objZoomToPoint = objDataForElement.Geometry;

            // Use the first point when a multi point ...
            if ((typeof objZoomToPoint != 'undefined') && (objZoomToPoint != null) && (objZoomToPoint.type == 'multipoint')) {
                objZoomToPoint = objZoomToPoint.getPoint(0);
            }
        }

        // When we have a point to zoom to ...
        if (typeof objZoomToPoint != 'undefined') {

            // Determine the individual attribute name to use ...
            var strIndividualItemName = (objDataForQueryResult.MapLayer.IndividualItemNameType == TrimbleMap.enumIndividualItemNameType.UseSpecifiedText) ?
                objDataForQueryResult.MapLayer.IndividualItemName :
                objDataForElement.Attributes[objDataForQueryResult.MapLayer.IndividualItemNameAttributeName];

            // Create a callout item ...
            var objMapCalloutItem = TrimbleMap.Callout.Shared.CreateItem(strIndividualItemName,
                objQueryResultsDisplay.MapController.GetMapLayerIdentifyHtmlTemplate(objDataForQueryResult.MapLayer),
                objDataForQueryResult.MapLayer.HeadingHtmlTemplate,
                objDataForElement.Geometry,
                objDataForElement.SpatialReferenceID,
                objDataForElement.Attributes);

            // Show the map callout window ...
            objQueryResultsDisplay.MapCallout.Show([objMapCalloutItem], objZoomToPoint, enExtentChange);
        }

    } else {

        // Get the translations ...

        // Item not in map       
        var strTitle = SD.Translation.Shared.GetTranslation('Map.QueryResultsDisplay.js', 'ItemNotInMapTitle');

        // Item not found in the map
        var strMessage = SD.Translation.Shared.GetTranslation('Map.QueryResultsDisplay.js', 'ItemNotInMapMessage');

        // Show a message to the user ...
        TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
    }
}

// **************************************************************************
// FUNCTION: MapCalloutHidden
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.MapCalloutHidden = function MapCalloutHidden() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // When we have a highlighted query result element ...
    if (objQueryResultsDisplay.HighlightedQueryResultElement) {

        // Remove the highlighted class ...
        objQueryResultsDisplay.HighlightedQueryResultElement.removeClass('highlighted');

        // Set to not have a highlighted query result element ...
        objQueryResultsDisplay.HighlightedQueryResultElement = false;
    }
}

// **************************************************************************
// FUNCTION: DisplayHoveredResultIcons
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.DisplayHoveredResultIcons = function DisplayHoveredResultIcons(objQueryResultElement) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // When we do not have a hovered icon result list div ... 

    var objMapLayerGroupBySection = SD.DOM.GetElementOrParentWithAttribute(objQueryResultElement, 'maplayergroupbysectionid');

    var groupSectionID = objMapLayerGroupBySection.attr("maplayergroupbysectionid");

    var objMapLayer = objQueryResultsDisplay.MapController.GetMapLayer(groupSectionID);

    // Create the icons div ...
    objQueryResultsDisplay.HoveredResultIconsDiv = $('<div class="icons"></div>');

    // Loop though all the hovered result icons ...
    for (var intHoveredResultIcon = 0; intHoveredResultIcon < objQueryResultsDisplay.HoveredResultIcons.length; intHoveredResultIcon++) {

        if (objQueryResultsDisplay.HoveredResultIcons[intHoveredResultIcon].CssClass != TrimbleMap.QueryResultsDisplay.Shared.SEARCH_ADD_TO_SELECTION || (objQueryResultsDisplay.HoveredResultIcons[intHoveredResultIcon].CssClass == TrimbleMap.QueryResultsDisplay.Shared.SEARCH_ADD_TO_SELECTION && objMapLayer.Selectable)) {

            // Get the hovered result icon ...
            var objHoveredResultIcon = objQueryResultsDisplay.HoveredResultIcons[intHoveredResultIcon];

            // Create the icon div ...
            var objHoveredResultIconDiv = $('<div class="icon"></div>');

            // Add the tooltip to the icon ...
            objHoveredResultIconDiv.attr('title', objHoveredResultIcon.ToolTip);

            // Add the css class to the icon ...
            objHoveredResultIconDiv.addClass(objHoveredResultIcon.CssClass)

            // Add the tooltip to the icon ...
            objHoveredResultIconDiv.attr('tooltip', objHoveredResultIcon.ToolTip);

            // Add the index to the icon ...
            objHoveredResultIconDiv.attr('HoveredResultIconIndex', intHoveredResultIcon);

            // Add it to the icons div ...
            objQueryResultsDisplay.HoveredResultIconsDiv.append(objHoveredResultIconDiv);
        }
    }
    // Compute the size of the icons div ...
    var objHoveredResultIconsSize = SD.HtmlFunctions.Shared.MeasureElement(objQueryResultsDisplay.HoveredResultIconsDiv);

    // Compute the position in pixels ...
    //var strPositionInPixels = String(-objHoveredResultIconsSize.height + 10 - 2) + 'px'

    // Set the top position to bring the icons div above the current insertion position ...
    //objQueryResultsDisplay.HoveredResultIconsDiv.css('top', strPositionInPixels);
    //objQueryResultsDisplay.HoveredResultIconsDiv.css('margin-bottom', strPositionInPixels);


    // Add the icons div to the result element ...
    objQueryResultElement.append(objQueryResultsDisplay.HoveredResultIconsDiv);

    // Set the hovered result element ...
    objQueryResultsDisplay.HoveredQueryResultElement = objQueryResultElement;
}

// **************************************************************************
// FUNCTION: HideHoveredResultIcons
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.HideHoveredResultIcons = function HideHoveredResultIcons() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // When have have a current hovered element ...
    if (objQueryResultsDisplay.HoveredQueryResultElement) {

        // Remove the icons from the interface ...
        objQueryResultsDisplay.HoveredResultIconsDiv.remove();

        // Set to have no hovered result element ...
        objQueryResultsDisplay.HoveredQueryResultElement = null;
    }
}

// **************************************************************************
// FUNCTION: AddHoveredResultIcon
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.AddHoveredResultIcon = function AddHoveredResultIcon(objHoveredResultIcon) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Add to the list of hovered result icons ...
    objQueryResultsDisplay.HoveredResultIcons.push(objHoveredResultIcon);

    // Hide the hovered result element when visible ...
    objQueryResultsDisplay.HideHoveredResultIcons();

    // Set to recreate the div containing the icons next time that we hover over an element in the list ...
    objQueryResultsDisplay.HoveredResultIconsDiv = null;
}

// **************************************************************************
// FUNCTION: RemoveHoveredResultIcon
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.RemoveHoveredResultIcon = function RemoveHoveredResultIcon(objHoveredResultIcon) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Get the icon index ...
    var intHoveredResultIcon = objQueryResultsDisplay.GetHoveredResultIconIndex(objHoveredResultIcon);

    // Remove it from the list ...
    objQueryResultsDisplay.HoveredResultIcons.splice(intHoveredResultIcon, 1);

    // Hide the hovered result element when visible ...
    objQueryResultsDisplay.HideHoveredResultIcons();

    // Set to recreate the div containing the icons next time that we hover over an element in the list ...
    objQueryResultsDisplay.HoveredResultIconsDiv = null;
}

// **************************************************************************
// FUNCTION: GetHoveredResultIconIndex
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.GetHoveredResultIconIndex = function GetHoveredResultIconIndex(objHoveredResultIcon) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Get the index ...
    var intHoveredResultIcon = $.inArray(objQueryResultsDisplay.HoveredResultIcons, objHoveredResultIcon);

    return intHoveredResultIcon;
}

// **************************************************************************
// FUNCTION: AddOnLoadedCallback
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.AddOnLoadedCallback = function AddOnLoadedCallback(fnLoaded) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Add the loaded function ...
    objQueryResultsDisplay.OnLoadedFunctions.push(fnLoaded);
}

// **************************************************************************
// FUNCTION: RemoveOnLoadedCallback
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.RemoveOnLoadedCallback = function RemoveOnLoadedCallback(fnLoaded) {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Find the function in the array ...
    var intLoadedFunction = $.inArray(fnLoaded, objQueryResultsDisplay.OnLoadedFunctions);

    // When found ...
    if (intLoadedFunction > -1) {

        // Remove it from the array ...
        objQueryResultsDisplay.OnLoadedFunction.splice(intLoadedFunction, 1);
    }
}

// **************************************************************************
// FUNCTION: TriggerOnLoadedCallbacks
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.TriggerOnLoadedCallbacks = function TriggerOnLoadedCallbacks() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Loop through all the on loaded functions ...
    $.each(objQueryResultsDisplay.OnLoadedFunctions, function (intLoaded, fnLoaded) {

        // Call the function ...
        fnLoaded();
    });
}

// **************************************************************************
// FUNCTION: SerializeData
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.SerializeData = function SerializeData() {

    // Get the instance ...
    var objQueryResultsDisplay = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we have data ...
    if (objQueryResultsDisplay.HasData()) {

        // Create a new array for all the deferreds ...
        var arrDeferreds = [];

        // Create a new empty object to return ...
        var objSerializableQueryResultsDisplayData = {};

        // Loop through the data for each map layer ...
        $.each(objQueryResultsDisplay.Data, function (strMapLayerID, objMapLayerData) {

            // Create a new deferred for the map layer results ...
            var objMapLayerDeferred = new dojo.Deferred();

            // Add it to the array of deferreds ...
            arrDeferreds.push(objMapLayerDeferred);

            // Get the map layer ...
            var objMapLayer = objQueryResultsDisplay.MapController.GetMapLayer(strMapLayerID);

            // Get the map service in which the layer map is ...
            var objMapService = objQueryResultsDisplay.MapController.GetMapService(objMapLayer.MapServiceID);

            // Get the map layer data from the service ...
            objQueryResultsDisplay.MapController.GetMapLayerDataFromService(objMapLayer, objMapService).then(TrimbleMap.Controller.Shared.TrapException(function (objMapLayerInfo) {

                // Create a new serializable version of the map layer data object ...
                var objSerializableMapLayerData = {};

                // Create a new data object and copy the other values ...
                objSerializableMapLayerData.ExactCountRetrieved = objMapLayerData.ExactCountRetrieved;
                objSerializableMapLayerData.MapLayerID = objMapLayerData.MapLayerID;
                objSerializableMapLayerData.TotalCount = objMapLayerData.TotalCount;
                objSerializableMapLayerData.GeometryType = TrimbleMap.Shape.Shared.EsriGeometrTypeToGeometryType(objMapLayerInfo.GeometryType);

                // When the map layer is not generic ...
                if (!objMapLayer.IsGeneric) {

                    // Create an IDs array ...
                    objSerializableMapLayerData.IDs = [];

                    // Loop through all the map layer data ...
                    $.each(objMapLayerData.Data, function (strID, objMapLayerDataItem) {

                        // Add the ID to the list ...
                        objSerializableMapLayerData.IDs.push(strID);
                    });

                } else {

                    // Create a Data property ...
                    objSerializableMapLayerData.Data = {};

                    // Loop through all the map layer data ...
                    $.each(objMapLayerData.Data, function (strID, objMapLayerDataItem) {

                        // Create new serializable version of the data item ...
                        var objSerializableMapLayerDataItem = {};

                        // Set the attributes ...
                        objSerializableMapLayerDataItem.Attributes = $.extend(objMapLayerDataItem.Attributes, {});

                        // Convert the geometry to json ...
                        objSerializableMapLayerDataItem.GeometryJson = ((typeof objMapLayerDataItem.Geometry != 'undefined') && (objMapLayerDataItem.Geometry != null)) ? JSON.stringify(objMapLayerDataItem.Geometry.toJson()) : null;

                        // Place it into the Data object ...
                        objSerializableMapLayerData.Data[strID] = objSerializableMapLayerDataItem;
                    });
                }

                // Place the results into the result object ...
                objSerializableQueryResultsDisplayData[objMapLayerData.MapLayerID] = objSerializableMapLayerData;

                // Resolve the deferred ...
                objMapLayerDeferred.resolve();
            }));
        });

        // When all are done ...
        new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function (objResult) {

            // Serialize the data ...
            var strSerializedDataJson = JSON.stringify(objSerializableQueryResultsDisplayData);

            // Resolve the deferred with the serialized data ...
            objDeferred.resolve(strSerializedDataJson);
        }));

    } else {

        // No data ...
        objDeferred.resolve(null);
    }

    // Return the deferred ...
    return objDeferred;
}

// **************************************************************************
// FUNCTION: DeserializeData
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.Shared.DeserializeData = function DeserializeData(strSerializedDataJson, objMapController) {

    // Desrialize the json ...
    var objSerializedQueryResultsDisplayData = JSON.parse(strSerializedDataJson);

    // Instantiate an esri spatial reference for the current map ...
    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objMapController.CurrentMap.SpatialReferenceID);

    // Create a new empty object to return ...
    var objQueryResultsDisplayData = {};

    // Loop through the data for each map layer ...
    $.each(objSerializedQueryResultsDisplayData, function (strMapLayerID, objSerializedMapLayerData) {

        // Make the map layer id lower case ...
        strMapLayerID = strMapLayerID.toLowerCase();

        // Create a new serializable version of the map layer data object ...
        var objMapLayerData = {};

        // Create a new data object and copy the other values ...
        objMapLayerData.Data = {};
        objMapLayerData.ExactCountRetrieved = objSerializedMapLayerData.ExactCountRetrieved;
        objMapLayerData.MapLayerID = strMapLayerID;
        objMapLayerData.TotalCount = objSerializedMapLayerData.TotalCount;

        // Loop through all the map layer data ...
        $.each(objSerializedMapLayerData.Data, function (strID, objSerializedMapLayerDataItem) {

            // Create new serializable version of the data item ... 
            var objMapLayerDataItem = {};

            // Set the attributes ...
            objMapLayerDataItem.Attributes = $.extend(objSerializedMapLayerDataItem.Attributes, {});

            // When we have a GeometryWKT value ...
            if ((typeof objSerializedMapLayerDataItem.GeometryWKT != 'undefined') && (objSerializedMapLayerDataItem.GeometryWKT != null) && ((objSerializedMapLayerDataItem.GeometryWKT).trim().length > 0)) {

                // Convert the geometry from wkt ...
                objMapLayerDataItem.Geometry = TrimbleMap.Geometry.Shared.GeometryFromWKT(objSerializedMapLayerDataItem.GeometryWKT, objEsriSpatialReference);

                // When we have a GeometryJson value ...
            } else if ((typeof objSerializedMapLayerDataItem.GeometryJson != 'undefined') && (objSerializedMapLayerDataItem.GeometryJson != null) && ((objSerializedMapLayerDataItem.GeometryJson).trim().length > 0)) {

                // Convert the geometry from json ...
                objMapLayerDataItem.Geometry = esri.geometry.jsonUtils.fromJson(JSON.parse(objSerializedMapLayerDataItem.GeometryJson));

                // When we have a GeometryJson value ...
            } else {

                // No geoemtry ...
                objMapLayerDataItem.Geometry = null;
            }

            // Set the map layer id ...
            objMapLayerData.MapLayerID = strMapLayerID;

            // Place it into the Data object ...
            objMapLayerData.Data[strID] = objMapLayerDataItem;
        });

        // Add it to the return object ... 
        objQueryResultsDisplayData[strMapLayerID] = objMapLayerData;
    });

    return objQueryResultsDisplayData;
}

// **************************************************************************
// FUNCTION: CreateLayerData
// USAGE:    arrData - An array of objects each containing the attributes 
//                     as properties ...
// **************************************************************************
TrimbleMap.QueryResultsDisplay.Shared.CreateLayerData = function CreateLayerData(strMapLayerID, arrData) {
    return {
        MapLayerID: strMapLayerID,
        Data: arrData
    };
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateQueryResultsDisplayData
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.QueryResultsDisplay.Shared.CreateQueryResultsDisplayData = function CreateQueryResultsDisplayData(arrData, strMapLayerID, intTotalCount) {

    // Create and return the object ...
    return {
        Data: arrData,
        MapLayerID: strMapLayerID,
        TotalCount: intTotalCount
    };
}

// **************************************************************************
// FUNCTION: CreateGroupBySectionCountObject
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.Shared.CreateGroupBySectionCountObject = function CreateGroupBySectionCountObject(intCount, intTotalCount, blnExactCountRetrieved) {

    // Create and return a group by section count object ...
    return {
        Count: intCount,
        TotalCount: intTotalCount,
        ExactCountRetrieved: blnExactCountRetrieved
    };
}

// **************************************************************************
// FUNCTION: CreateHoveredResultIcon
// USAGE:    
// **************************************************************************
TrimbleMap.QueryResultsDisplay.Shared.CreateHoveredResultIcon = function CreateHoveredResultIcon(strToolTip, strCssClass, fnClick) {

    // Create and return a hovered result icon ...
    return {
        ToolTip: strToolTip,
        CssClass: strCssClass,
        ClickFunction: fnClick
    };
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Search = {};
TrimbleMap.Search.Shared = {};
TrimbleMap.Search.Shared.SIDEBAR_TAB_WIDTH = 300;
TrimbleMap.Search.Shared.TOTAL_HORIZONTAL_PADDDING = 20;
TrimbleMap.Search.Shared.SEARCH_ADD_TO_SELECTION = 'search_add_to_selection';

// **************************************************************************
// ENUMS
// **************************************************************************
TrimbleMap.Search.enumMapSearchType = {};
TrimbleMap.Search.enumMapSearchType.None = 'None';
TrimbleMap.Search.enumMapSearchType.QuickSearch = 'QuickSearch';
TrimbleMap.Search.enumMapSearchType.AdvancedSearch = 'AdvancedSearch';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Search.CreateInstance = function CreateInstance(objMapController, objMapCallout, objSidebar, objSelection, strTabName, strTabCaption, blnVisible, objOptions) {

    // Create the object that will hold the instance properties ...
    var objMapSearch = {
        MapController: objMapController,
        MapCallout: objMapCallout,
        Sidebar: objSidebar,
        Selection: objSelection,
        TabName: strTabName,
        TabCaption: strTabCaption,
        Options: objOptions,
        Visible: false,
        QueryResultsDisplay: null,
        GroupByName: null,
        CurrentHoveredSearchResultDiv: null,
        CurrentSelectedSearchResultDiv: null,
        CurrentSelectedSearchResult: null,
        RunSearchCounter: 0,
        SearchResultReturnedCallCounter: 0,
        SearchResultData: null,
        SearchResultsDisplayed: false,
        SearchResultBindingsApplied: null,
        ResultsToLoadImmediately: 10,
        DelayedResultLoadChunckSize: 1,
        ResultLoadDelay: 100,
        SearchPanelInnerPadding: 10,
        SearchGraphics: null,
        SearchHelpText: '',
        ClearSearchResultsIcon: null,
        AdvancedSearchIcon: null,
        AdvancedSearchPopupMenu: null,
        SearchBoxTable: null,
        SearchTextBox: null,
        SpinnerPlaceHolderDiv: null,
        SearchTabItem: null,
        EventHandlersAttached: false,
        AddToSelectionHoveredResultIcon: null,
        AddToSelectionMenuItemByMapLayerGroupBySectionID: {},
        MapLayerGroupBySectionMenusByID: {},
        LastExecutedSearchType: null,
        LastExecutedQuickSearchText: null,

        ClearSearchResultsClickedProxy: function (e) { objMapSearch.ClearSearchResultsClicked(e); },
        SearchTextBoxFocusProxy: function (e) { objMapSearch.SearchTextBoxFocus(e); },
        SearchTextBoxBlurProxy: function (e) { objMapSearch.SearchTextBoxBlur(e); },
        SearchIconClickProxy: function (e) { objMapSearch.SearchIconClick(e); },
        SearchTextBoxKeypressProxy: function (e) { objMapSearch.SearchTextBoxKeypress(e); },
        MapLoadedProxy: function (blnReloaded) { objMapSearch.MapLoaded(blnReloaded); },
        PreferenceChangedProxy: function (arrPreferencesChanged) { objMapSearch.PreferenceChanged(arrPreferencesChanged); },
        OnSelectionShowProxy: function () { objMapSearch.OnSelectionShow(); },
        OnSelectionHideProxy: function () { objMapSearch.OnSelectionHide(); },
        AddToSelectionClickedProxy: function (objDataForQueryResult) { objMapSearch.AddToSelectionClicked(objDataForQueryResult); },
        PopulateMapLayerGroupBySectionMenuProxy: function (objMapLayerGroupBySection, objPopupMenu, objQueryResultDisplay) { objMapSearch.PopulateMapLayerGroupBySectionMenu(objMapLayerGroupBySection, objPopupMenu, objQueryResultDisplay); },

        CreateSearchElements: TrimbleMap.Search.CreateSearchElements,
        SearchPanelMouseOver: TrimbleMap.Search.SearchPanelMouseOver,
        CreateSearchBox: TrimbleMap.Search.CreateSearchBox,
        ClearSearchResults: TrimbleMap.Search.ClearSearchResults,
        SelectResult: TrimbleMap.Search.SelectResult,
        RemoveSearchResultZoomToIcon: TrimbleMap.Search.RemoveSearchResultZoomToIcon,
        UnselectSearchResult: TrimbleMap.Search.UnselectSearchResult,
        Run: TrimbleMap.Search.Run,
        SearchResultsReturned: TrimbleMap.Search.SearchResultsReturned,
        ActivateTab: TrimbleMap.Search.ActivateTab,
        DeActivateTab: TrimbleMap.Search.DeActivateTab,
        ResizeTab: TrimbleMap.Search.ResizeTab,
        AttachEventHandlers: TrimbleMap.Search.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Search.DetachEventHandlers,
        TemporarilyDeactivateSearchResultClickEvent: TrimbleMap.Search.TemporarilyDeactivateSearchResultClickEvent,
        ClearSearchResultsClicked: TrimbleMap.Search.ClearSearchResultsClicked,
        SearchTextBoxFocus: TrimbleMap.Search.SearchTextBoxFocus,
        SearchTextBoxBlur: TrimbleMap.Search.SearchTextBoxBlur,
        SearchIconClick: TrimbleMap.Search.SearchIconClick,
        SearchTextBoxKeypress: TrimbleMap.Search.SearchTextBoxKeypress,
        ManageElementHeight: TrimbleMap.Search.ManageElementHeight,
        MapLoaded: TrimbleMap.Search.MapLoaded,
        PreferenceChanged: TrimbleMap.Search.PreferenceChanged,
        OnSelectionShow: TrimbleMap.Search.OnSelectionShow,
        OnSelectionHide: TrimbleMap.Search.OnSelectionHide,
        AddToSelectionClicked: TrimbleMap.Search.AddToSelectionClicked,
        AddToSelectionMenuItemClicked: TrimbleMap.Search.AddToSelectionMenuItemClicked,
        AddSelectionIcons: TrimbleMap.Search.AddSelectionIcons,
        RemoveSelectionIcons: TrimbleMap.Search.RemoveSelectionIcons,
        SetQuickSearchText: TrimbleMap.Search.SetQuickSearchText,
        PopulateMapLayerGroupBySectionMenu: TrimbleMap.Search.PopulateMapLayerGroupBySectionMenu,
        Show: TrimbleMap.Search.Show,
        Hide: TrimbleMap.Search.Hide
    }

    // Create the search panel ...
    objMapSearch.CreateSearchElements();

    // Add the gradient style for IE 9 only ...
    SD.HtmlFunctions.Shared.RemoveIE9FilterFromGradient();

    // Create the tab item ...
    objMapSearch.SearchTabItem = SD.Sidebar.Shared.CreateTabItem(objMapSearch.TabName, objMapSearch.TabCaption,
        TrimbleMap.StandardMap.Shared.enumTabOrder.SEARCH,
        function (objTabContainerElement, enTabActivationMethod) { objMapSearch.ActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement, enTabActivationMethod) { objMapSearch.DeActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement) { objMapSearch.ResizeTab(objTabContainerElement); },
        function () { return TrimbleMap.Search.Shared.SIDEBAR_TAB_WIDTH; });

    // Show the tab and mode button when its to be visible at startup ...
    if (blnVisible) { objMapSearch.Show(false, false); }

    // Add the onloaded event handler to the map controller ...
    objMapSearch.MapController.AddOnLoadedCallback(objMapSearch.MapLoadedProxy);

    // Add the notify preference changed event handler to the map controller ...
    objMapSearch.MapController.AddNotifyPreferenceChanged(objMapSearch.PreferenceChangedProxy);

    return objMapSearch;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
//           blnSelectTab is optional, defaults to true
// **************************************************************************
TrimbleMap.Search.Show = function Show(blnTriggerNotifyModuleVisibilityChanged, blnSelectTab) {

    // Get the instance ...
    var objMapSearch = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objMapSearch.Visible) {

        // Add the tab ...
        objMapSearch.Sidebar.AddTab(objMapSearch.SearchTabItem);

        // When we are to select the tab ...
        if ((typeof blnSelectTab == 'undefined') || (blnSelectTab == null) || blnSelectTab) {

            // Select the tab ...
            objMapSearch.Sidebar.SelectTab(objMapSearch.SearchTabItem);
        }

        // Set to be visible ...
        objMapSearch.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapSearch.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Search, true); }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Search.Hide = function Hide(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objMapSearch = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objMapSearch.Visible) {

        // Detach all the event handlers (if attached) ...
        objMapSearch.DetachEventHandlers();

        // Remove the tab ...
        objMapSearch.Sidebar.RemoveTab(objMapSearch.SearchTabItem);

        // Set to not be visible ...
        objMapSearch.Visible = false;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapSearch.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Search, false); }
    }
}

// **************************************************************************
// FUNCTION: ActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Search.ActivateTab = function ActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the map search instance ...
    var objMapSearch = this;

    // Add the search panel div to the tab container element ...
    objTabContainerElement.append(objMapSearch.SearchPanelDiv);

    // Attach the event handlers ...
    objMapSearch.AttachEventHandlers();

    // Show the query results ...
    objMapSearch.QueryResultsDisplay.Show();
}

// **************************************************************************
// FUNCTION: DeActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Search.DeActivateTab = function DeActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the map search instance ...
    var objMapSearch = this;

    // Remove the search panel div from the tab container element ...
    objMapSearch.SearchPanelDiv.remove();

    // Hide the query results ...
    objMapSearch.QueryResultsDisplay.Hide();

    // Detach the event handlers ... 
    objMapSearch.DetachEventHandlers();
}

// **************************************************************************
// FUNCTION: ResizeTab
// USAGE:    
// **************************************************************************
TrimbleMap.Search.ResizeTab = function ResizeTab(objTabContainerElement) {

    // Get the map search instance ...
    var objMapSearch = this;

    // Manage the height of the elements ...
    objMapSearch.ManageElementHeight(objTabContainerElement);
}

// **************************************************************************
// FUNCTION: MapLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.Search.MapLoaded = function MapLoaded(blnReloaded) {

    // Get the map search instance ...
    var objMapSearch = this;

    // When reloaded ...
    if (blnReloaded) {

        // Increment the run search counter to prevent the search results from being loaded when the search returns ...
        objMapSearch.RunSearchCounter = objMapSearch.RunSearchCounter + 1;

        // Clear the search results ...
        objMapSearch.ClearSearchResults();
    }
}

// **************************************************************************
// FUNCTION: PreferenceChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Search.PreferenceChanged = function PreferenceChanged(arrPreferencesChanged) {

    // Get the map search instance ...
    var objMapSearch = this;

    // When DisplaySeparateParts preference changed ...
    if ($.inArray(TrimbleMap.Preferences.enumPreference.DisplaySeparateParts, arrPreferencesChanged) > -1) {

        // Clear the search results ...
        objMapSearch.ClearSearchResults();
    }
}

// **************************************************************************
// FUNCTION: ManageElementHeight
// USAGE:    
// **************************************************************************
TrimbleMap.Search.ManageElementHeight = function ManageElementHeight(objTabContainerElement) {

    // Get the map search instance ...
    var objMapSearch = this;

    // Compute the width and height to set on the query result display ...
    var intHeight = objTabContainerElement.innerHeight() - parseInt(objMapSearch.SearchBoxTable.outerHeight(), 10) - 41;

    // Set the height of the container ...  
    objMapSearch.SearchResultsContainerDiv.css('height', intHeight + 'px');

    // Resize the query results display ...
    objMapSearch.QueryResultsDisplay.Resize();
}

// **************************************************************************
// FUNCTION: CreateSearchElements
// USAGE:    
// **************************************************************************
TrimbleMap.Search.CreateSearchElements = function CreateSearchElements() {

    // Get the map search instance ...
    var objMapSearch = this;

    // * Search panel div ...

    // Create a new div for the search panel ... 
    objMapSearch.SearchPanelDiv = $('<div class="side-panel"></div>');

    // * Search panel table ...

    // Create the search panel table with a row for the search controls and a row for the search results ...
    objMapSearch.SearchPanelTable = $('<table cellpadding="0px" cellspacing="0px" class="search-panel"></table>');

    // Add the table to the panel ...
    objMapSearch.SearchPanelDiv.append(objMapSearch.SearchPanelTable);

    // * Search text box ...

    // Create the search text box ...
    objMapSearch.CreateSearchBox();

    // Create the search row ...
    var objSearchBoxRow = $('<tr><td><div class="search-tools"></div></td></tr>');

    // When advanced search is enabled ...
    if (objMapSearch.Options.AdvancedSearchEnabled) {

        // Create the advanced search icon ...
        objMapSearch.AdvancedSearchIcon = $('<div class="advanced-search"></div>');

        // Add it to the search row ...
        $(objSearchBoxRow.find('.search-tools')).append(objMapSearch.AdvancedSearchIcon);

        // Create the advanced search popup menu ...
        objMapSearch.AdvancedSearchPopupMenu = SD.PopupMenu.CreateInstance(objMapSearch.AdvancedSearchIcon,
            'popup-downwards',
            'popup-upwards',
            'popup-downwards-open',
            'popup-upwards-open',
            5,
            false,
            SD.Popup.enumPopupBehaviour.AlwaysDown,
            objMapSearch.Options.AdvancedSearchPopupMenuClicked);

        // When we have a function to populate the menu items ...
        if ((typeof objMapSearch.Options.PopulateAdvancedSearchMenu != 'undefined') && objMapSearch.Options.PopulateAdvancedSearchMenu) {

            // Populate the advanced search menu items ...
            objMapSearch.Options.PopulateAdvancedSearchMenu(objMapSearch.AdvancedSearchPopupMenu);
        }
    }

    // Add the box to the cell row ...
    $(objSearchBoxRow.find('.search-tools')).append(objMapSearch.SearchBoxTable);

    // Add the row to the table ...
    objMapSearch.SearchPanelTable.append(objSearchBoxRow);

    // * Search results row ...

    // Create the search results row ...
    objMapSearch.SearchResultsRow = $('<tr><td></td></tr>');

    // Add to the table ...
    objMapSearch.SearchPanelTable.append(objMapSearch.SearchResultsRow);

    // * Search box container div ...

    // Create the search box container div ...
    objMapSearch.SearchResultsContainerDiv = $('<div class="search-results"></div>');

    // Get the cell to add the container to ...
    var objCellToAddContainer = $(objMapSearch.SearchResultsRow.find('td'));

    // Add the search box div to the search controls cell ...
    objCellToAddContainer.append(objMapSearch.SearchResultsContainerDiv);

    // Create the query results display instance ...
    objMapSearch.QueryResultsDisplay = TrimbleMap.QueryResultsDisplay.CreateInstance(objMapSearch.SearchResultsContainerDiv,
        objMapSearch.MapController,
        objMapSearch.MapCallout,
        function (objMapLayer) {
            return objMapLayer.ProcessedSearchAndSelectHtmlTemplate;
        },
        function (objMapLayer) {
            return objMapLayer.ProcessedSearchAndSelectHtmlTemplateByPart;
        },
        function () {
            return true;
        },
        objMapSearch.PopulateMapLayerGroupBySectionMenuProxy,
        false,
        objMapSearch.Options.QueryResultsDataJson);

    // When we have selection ...
    if (objMapSearch.Selection) {

        // Add on show and on hide functions to the selection ...
        objMapSearch.Selection.AddOnShowFunction(objMapSearch.OnSelectionShowProxy);
        objMapSearch.Selection.AddOnHideFunction(objMapSearch.OnSelectionHideProxy);

        // Get the translations ...

        // Add to selection ...
        var strAddToSelectionToolTip = SD.Translation.Shared.GetTranslation('Map.Search.js', 'AddToSelection');

        // Create the add to shape and remove from shape hovered result icon ...
        objMapSearch.AddToSelectionHoveredResultIcon = TrimbleMap.QueryResultsDisplay.Shared.CreateHoveredResultIcon(strAddToSelectionToolTip, TrimbleMap.Search.Shared.SEARCH_ADD_TO_SELECTION, objMapSearch.AddToSelectionClickedProxy);

        // When it is visible ...
        if (objMapSearch.Selection.Visible) {

            // Add the shape editor icons ...
            objMapSearch.AddSelectionIcons();
        }
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:
// **************************************************************************
TrimbleMap.Search.AttachEventHandlers = function AttachEventHandlers() {

    // Get the map search instance ...
    var objMapSearch = this;

    // When the event handlers are not attached ...
    if (!objMapSearch.EventHandlersAttached) {

        // Attach a click event handler to the clear button ...
        objMapSearch.ClearSearchResultsIcon.on('click',(objMapSearch.ClearSearchResultsClickedProxy));

        // Attach a focus event handler to the search text box ...
        objMapSearch.SearchTextBox.on('focus',(objMapSearch.SearchTextBoxFocusProxy));

        // Attach a blur event handler to the search text box ...
        objMapSearch.SearchTextBox.on('blur',(objMapSearch.SearchTextBoxBlurProxy));

        // Attach a click handler on the search icon ...
        objMapSearch.SearchIcon.on('click',(objMapSearch.SearchIconClickProxy));

        // Attach a keypress handler on the search icon ...
        objMapSearch.SearchTextBox.on('keypress',(objMapSearch.SearchTextBoxKeypressProxy));

        // Attach event handlers ...
        objMapSearch.QueryResultsDisplay.AttachEventHandlers();

        // Attach view in list event handlers ...
        if (objMapSearch.AdvancedSearchPopupMenu) {
            objMapSearch.AdvancedSearchPopupMenu.AttachEventHandlers();
        }

        // Set to have attached the event handlers ...
        objMapSearch.EventHandlersAttached = true;
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:
// **************************************************************************
TrimbleMap.Search.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map search instance ...
    var objMapSearch = this;

    // When the event handlers are attached ...
    if (objMapSearch.EventHandlersAttached) {

        // Detach a focus event handler to the search text box ...
        objMapSearch.SearchTextBox.off('focus', objMapSearch.SearchTextBoxFocusProxy);

        // Detach a blur event handler to the search text box ...
        objMapSearch.SearchTextBox.off('blur', objMapSearch.SearchTextBoxBlurProxy);

        // Detach a click event handler to the clear button ...
        objMapSearch.ClearSearchResultsIcon.off('click', objMapSearch.ClearSearchResultsClickedProxy);

        // Detach a click handler on the search icon ...
        objMapSearch.SearchIcon.off('click', TrimbleMap.Search.SearchIconClickProxy);

        // Detach a keypress handler on the search icon ...
        objMapSearch.SearchTextBox.off('keypress', TrimbleMap.Search.SearchTextBoxKeypressProxy);

        // Detach event handlers ...
        objMapSearch.QueryResultsDisplay.DetachEventHandlers();

        if (objMapSearch.AdvancedSearchPopupMenu) {
            objMapSearch.AdvancedSearchPopupMenu.DetachEventHandlers();
        }

        // Set to have detached the event handlers ...
        objMapSearch.EventHandlersAttached = false;
    }
}

// **************************************************************************
// FUNCTION: AddSelectionIcons
// USAGE:    
// **************************************************************************
TrimbleMap.Search.AddSelectionIcons = function AddSelectionIcons() {

    // Get the instance ...
    var objMapSearch = this;

    // Add the draw to add to hovered result icon ...
    objMapSearch.QueryResultsDisplay.AddHoveredResultIcon(objMapSearch.AddToSelectionHoveredResultIcon);

    // Loop through all the group by section popup menus we have ...
    $.each(objMapSearch.MapLayerGroupBySectionMenusByID, function (strMapLayerGroupBySectionID, objPopupMenu) {

        // Get the add to selection menu item for the group by section ...
        var objAddToSelectionMenuItem = objMapSearch.AddToSelectionMenuItemByMapLayerGroupBySectionID[strMapLayerGroupBySectionID];

        var objMapLayer = objMapSearch.MapController.GetMapLayer(strMapLayerGroupBySectionID);

        if (objMapLayer.Selectable) {
            // Add the draw to add to hovered result icon ...
            objPopupMenu.AddMenuItem(objAddToSelectionMenuItem);
            return false;
        } else {
            objMapSearch.QueryResultsDisplay.RemoveHoveredResultIcon(objMapSearch.AddToSelectionHoveredResultIcon);
        }
    });
}

// **************************************************************************
// FUNCTION: RemoveSelectionIcons
// USAGE:    
// **************************************************************************
TrimbleMap.Search.RemoveSelectionIcons = function RemoveSelectionIcons() {

    // Get the instance ...
    var objMapSearch = this;

    // Remove the add to selection to hovered result icon ...
    objMapSearch.QueryResultsDisplay.RemoveHoveredResultIcon(objMapSearch.AddToSelectionHoveredResultIcon);

    // Loop through all the group by section popup menus we have ...
    $.each(objMapSearch.MapLayerGroupBySectionMenusByID, function (strMapLayerGroupBySectionID, objPopupMenu) {

        // Get the add to selection menu item for the group by section ...
        var objAddToSelectionMenuItem = objMapSearch.AddToSelectionMenuItemByMapLayerGroupBySectionID[strMapLayerGroupBySectionID];

        // Remove the add to selection menu item ...
        objPopupMenu.RemoveMenuItem(objAddToSelectionMenuItem);
    });
}

// **************************************************************************
// FUNCTION: OnSelectionShow
// USAGE:    
// **************************************************************************
TrimbleMap.Search.OnSelectionShow = function OnSelectionShow() {

    // Get the instance ...
    var objMapSearch = this;

    // Add the selection icons ...
    objMapSearch.AddSelectionIcons();
}

// **************************************************************************
// FUNCTION: OnSelectionHide
// USAGE:    
// **************************************************************************
TrimbleMap.Search.OnSelectionHide = function OnSelectionHide() {

    // Get the instance ...
    var objMapSearch = this;

    // Remove the selection icons ...
    objMapSearch.RemoveSelectionIcons();
}

// **************************************************************************
// FUNCTION: AddToSelectionClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Search.AddToSelectionClicked = function AddToSelectionClicked(objDataForQueryResult) {

    // Get the instance ...
    var objMapSearch = this;

    // Get the map layer ID field name ...
    var strRestServiceIDFieldName = objMapSearch.MapController.GetMapLayerIDFieldName(objDataForQueryResult.MapLayer);

    // Get the ID ...
    var strID = objDataForQueryResult.DataForElement.Attributes[strRestServiceIDFieldName];

    // When not already selected ...
    if (!objMapSearch.Selection.QueryResultsDisplay.IsItemLoaded(objDataForQueryResult.MapLayer.MapLayerID, strID)) {

        // Create the map service query results array ...
        var arrMapServiceQueryResults = [TrimbleMap.Controller.Shared.CreateMapServiceQueryResult(objDataForQueryResult.MapLayer.MapLayerID, 1, true, [objDataForQueryResult.DataForElement])];

        // Add to the selection ...
        objMapSearch.Selection.AddToSelection(arrMapServiceQueryResults);
    }
}

// **************************************************************************
// FUNCTION: AddToSelectionMenuItemClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Search.AddToSelectionMenuItemClicked = function AddToSelectionMenuItemClicked(objMapLayerGroupBySection) {

    // Get the instance ...
    var objMapSearch = this;

    // Get the displayed data for the map layer group by section ...
    var arrMapLayerGroupBySectionData = objMapSearch.QueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID];

    // Create a new object to hold (MapLayerGroupBySectionID -> Array of data items) key value pairs ...
    var objDataByMapLayer = {};

    // Loop through all the data items ...
    $.each(arrMapLayerGroupBySectionData, function (intMapLayerGroupBySectionDataItem, objMapLayerGroupBySectionDataItem) {

        // Create a new array to hold the items for the map layer when we have none ...
        if (typeof objDataByMapLayer[objMapLayerGroupBySectionDataItem.MapLayerID] == 'undefined') { objDataByMapLayer[objMapLayerGroupBySectionDataItem.MapLayerID] = []; }

        // Add the item to the array ...
        objDataByMapLayer[objMapLayerGroupBySectionDataItem.MapLayerID].push(objMapLayerGroupBySectionDataItem);
    });

    // Create a new array of data items to get the geometries for ...
    var arrDataItemsToLoadGeometry = [];

    // Create a new array for the deferreds ...
    var arrDeferreds = [];

    // Create the map service query results array ...
    var arrMapServiceQueryResults = [];

    // Loop through all the map layers for which we have data ...
    $.each(objDataByMapLayer, function (strMapLayerID, arrDataItems) {

        // Get the map layer in which the object is ...
        var objMapLayer = objMapSearch.MapController.GetMapLayer(strMapLayerID);

        // Get the map layer ID field name ...
        var strRestServiceIDFieldName = objMapSearch.MapController.GetMapLayerIDFieldName(objMapLayer);

        // Create an array of items ...
        var arrItems = [];

        // Loop through the array of items ...
        $.each(arrDataItems, function (intDataItem, objDataItem) {

            // Get the ID ...
            var strID = objDataItem.Attributes[strRestServiceIDFieldName];

            // When not already selected ...
            if (!objMapSearch.Selection.QueryResultsDisplay.IsItemLoaded(strMapLayerID, strID)) {

                // Add it to the array of items ...
                arrItems.push(objDataItem);

                // When the data item do not have a geometry ...
                if ((typeof objDataItem.Geometry != 'undefined') && (objDataItem.Geometry != null)) {

                    // Add the data item to the array for which we need to fetch the geometries ...
                    arrDataItemsToLoadGeometry.push(objDataItem);

                    // Get the geometry for the data item, add the deferred to the array ...
                    arrDeferreds.push(objMapSearch.QueryResultsDisplay.GetGeometry(objMapLayer, strID));
                }
            }
        });

        // Create and add a map service query result with the items ...
        if (arrItems.length > 0) { arrMapServiceQueryResults.push(TrimbleMap.Controller.Shared.CreateMapServiceQueryResult(strMapLayerID, arrItems.length, true, arrItems)); }
    });

    // When all the GetGeometry calls completed ...
    (new dojo.promise.all(arrDeferreds)).then(TrimbleMap.Controller.Shared.TrapException(function (arrGeometries) {

        // Loop through all the data items to load the geometry ...
        $.each(arrDataItemsToLoadGeometry, function (intDataItem, objDataItem) {

            // Get the geometry ...
            var objGeometry = arrGeometries[intDataItem];

            // Set on the data item when not null ...
            if (objGeometry) { objDataItem.Geometry = objGeometry; }
        });

        // Add to the selection ...
        if (arrMapServiceQueryResults.length > 0) { objMapSearch.Selection.AddToSelection(arrMapServiceQueryResults); }
    }));
}

// **************************************************************************
// FUNCTION: PopulateMapLayerGroupBySectionMenu
// USAGE:
// **************************************************************************
TrimbleMap.Search.PopulateMapLayerGroupBySectionMenu = function PopulateMapLayerGroupBySectionMenu(objMapLayerGroupBySection, objPopupMenu, objQueryResultDisplay) {

    // Get the map search instance ...
    var objMapSearch = this;

    // Add the popup menu to MapLayerGroupBySectionMenusByID ...
    objMapSearch.MapLayerGroupBySectionMenusByID[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objPopupMenu;

    // When we have a PopulateMapLayerGroupBySectionMenu function ...
    if ((typeof objMapSearch.Options.PopulateMapLayerGroupBySectionMenu != 'undefined') && (objMapSearch.Options.PopulateMapLayerGroupBySectionMenu != null)) {

        // Call the populate function from the options ...
        objMapSearch.Options.PopulateMapLayerGroupBySectionMenu(objMapLayerGroupBySection, objPopupMenu, objQueryResultDisplay);
    }

    // When we have a selection module ...
    if (objMapSearch.Selection) {

        // Create a function that will call AddToSelectionMenuItemClicked with the details about the map layer group by section ...
        var fnCallAddToSelectionMenuItemClicked = function () { objMapSearch.AddToSelectionMenuItemClicked(objMapLayerGroupBySection); }

        // Get the translations ...

        // Add to Selection
        var strAddToSelectionTranslation = SD.Translation.Shared.GetTranslation('Map.Search.js', 'AddToSelection');

        // Create the add to selection menu item ...
        var objAddToSelectionMenuItem = SD.PopupMenu.Shared.CreateMenuItem(strAddToSelectionTranslation, strAddToSelectionTranslation, fnCallAddToSelectionMenuItemClicked)

        // Add the menu item too AddToSelectionMenuItemByMapLayerGroupBySectionID ...
        objMapSearch.AddToSelectionMenuItemByMapLayerGroupBySectionID[objMapLayerGroupBySection.MapLayerGroupBySectionID] = objAddToSelectionMenuItem;

        // Add the menu item when the selection module is visible ...
        if (objMapSearch.Selection.Visible) {
            var objMapLayer = objMapSearch.MapController.GetMapLayer(objMapLayerGroupBySection.MapLayerGroupBySectionID);

            if (objMapLayer.Selectable) {
                objPopupMenu.AddMenuItem(objAddToSelectionMenuItem);
                return false;
            }
        }
    }
}

// **************************************************************************
// FUNCTION: CreateSearchBox
// USAGE:
// **************************************************************************
TrimbleMap.Search.CreateSearchBox = function CreateSearchBox() {

    // Get the map search instance ...
    var objMapSearch = this;

    // Create the table for the search box ...
    objMapSearch.SearchBoxTable = $('<div class="search-box"><div class="search-icon"></div><input type="text"></input><div class="search-spinner-container"><div class="spinner-placeholder"></div><div class="search-spinner"></div><div class="clear-search"></div></div></div>');

    // Get the created search text box ...
    objMapSearch.SearchTextBox = $(objMapSearch.SearchBoxTable.find('input'));

    // Set the search help text ...
    objMapSearch.SearchTextBox.val(objMapSearch.SearchHelpText);
    objMapSearch.SearchTextBox.addClass('help-text');

    // Get the created search spinner ...
    objMapSearch.SearchSpinner = $(objMapSearch.SearchBoxTable.find('.search-spinner')[0]);

    // Get the clear search results ...
    objMapSearch.ClearSearchResultsIcon = $(objMapSearch.SearchBoxTable.find('.clear-search')[0]);

    // Get the placeholder div ...
    objMapSearch.SpinnerPlaceHolderDiv = $(objMapSearch.SearchBoxTable.find('.spinner-placeholder')[0]);

    // Get the created search icon ...
    objMapSearch.SearchIcon = $(objMapSearch.SearchBoxTable.find('.search-icon')[0]);

    // Create a inside the div ...
    SD.SpinnerFunctions.Shared.CreateSpinner(objMapSearch.SearchSpinner, 4, 9, 10, 2, '#9EB7D8');

    // When we have initial data to show ...
    if ((typeof objMapSearch.Options.QueryResultsDataJson != 'undefined') && (objMapSearch.Options.QueryResultsDataJson != null) && ((objMapSearch.Options.QueryResultsDataJson).trim().length > 0)) {
        // Show the clear search results icon ...
        objMapSearch.SpinnerPlaceHolderDiv.hide();
        objMapSearch.SearchSpinner.hide();
        objMapSearch.ClearSearchResultsIcon.show();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetQuickSearchText
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Search.SetQuickSearchText = function SetQuickSearchText(strSearchText) {

    // Get the map search instance ...
    var objMapSearch = this;

    // Set the search text box's text ...
    objMapSearch.SearchTextBox.val(strSearchText);

    // Remove the help text class ...
    objMapSearch.SearchTextBox.removeClass('help-text');
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SearchTextBoxFocus
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Search.SearchTextBoxFocus = function SearchTextBoxFocus() {

    // Get the map search instance ...
    var objMapSearch = this;

    // Get the search text ...
    var strSearchText = objMapSearch.SearchTextBox.val();

    // When the search help text is still displaying ...
    if (objMapSearch.MapController.SearchHelpText && (strSearchText).trim() == ((objMapSearch.MapController.SearchHelpText).trim())) {

        // Clear the search text box ...
        objMapSearch.SearchTextBox.val('');

        // Remove the class ...
        objMapSearch.SearchTextBox.removeClass('help-text');
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SearchTextBoxBlur
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Search.SearchTextBoxBlur = function SearchTextBoxBlur() {

    // Get the map search instance ...
    var objMapSearch = this;

    // Get the search text ...
    var strSearchText = objMapSearch.SearchTextBox.val();

    // When the search help text is still displaying ...
    if ((strSearchText).trim().length == 0) {

        // Clear the search text box ...
        objMapSearch.SearchTextBox.val(objMapSearch.SearchHelpText);

        // Remove the class ...
        objMapSearch.SearchTextBox.addClass('help-text');
    }
}

// **************************************************************************
// FUNCTION: SearchIconClick
// USAGE:
// **************************************************************************
TrimbleMap.Search.SearchIconClick = function SearchIconClick() {

    // Get the map search instance ...
    var objMapSearch = this;

    // Run the search ...
    objMapSearch.Run();
}

// **************************************************************************
// FUNCTION: SearchTextBoxKeypress
// USAGE:
// **************************************************************************
TrimbleMap.Search.SearchTextBoxKeypress = function SearchTextBoxKeypress(e) {

    // Get the map search instance ...
    var objMapSearch = this;

    // When the enter key has been pressed ...
    if (e.keyCode == 13) {

        // Run the search ...
        objMapSearch.Run();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ClearSearchResultsClicked
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Search.ClearSearchResultsClicked = function ClearSearchResultsClicked() {

    // Get the map search instance ...
    var objMapSearch = this;

    // Clear the search results ...
    objMapSearch.ClearSearchResults();
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ClearSearchResults
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Search.ClearSearchResults = function ClearSearchResults() {

    // Get the map search instance ...
    var objMapSearch = this;

    // Hide the callout ...
    objMapSearch.MapCallout.Hide();

    // Clear all the search result data ...
    objMapSearch.QueryResultsDisplay.ClearAllResultData();

    // Hide the search spinner (if visible) ...
    objMapSearch.SearchSpinner.hide();

    // Show the container div for when the results has been cleared ...
    objMapSearch.SpinnerPlaceHolderDiv.show();

    // Hide the clear search results icon ...
    objMapSearch.ClearSearchResultsIcon.hide();

    // Clear the search text box ...
    objMapSearch.SearchTextBox.val('');

    // Clear the last executed search type and text ...
    objMapSearch.LastExecutedSearchType = TrimbleMap.Search.enumMapSearchType.None;
    objMapSearch.LastExecutedQuickSearchText = '';

    // * Show the search help text ...

    // Clear the search text box ...
    objMapSearch.SearchTextBox.val(objMapSearch.SearchHelpText);

    // Remove the class ...
    objMapSearch.SearchTextBox.addClass('help-text');
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveSearchResultZoomToIcon
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Search.RemoveSearchResultZoomToIcon = function RemoveSearchResultZoomToIcon(objSearchResultDiv) {

    // Get the map search instance ...
    var objMapSearch = this;

    // When we have an result div ...
    if (objSearchResultDiv) {

        // Remove the search result zoom to icon from the div ...
        objSearchResultDiv.find('.zoom_to_icon').remove();
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION UnselectSearchResult
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Search.UnselectSearchResult = function UnselectSearchResult() {

    // Get the map search instance ...
    var objMapSearch = this;

    // Get the selected search result div ...
    var objSelectedSearchResultElements = $('div.search_result_div_selected');

    // Remove the search result zoom to icon from the div ...
    objMapSearch.RemoveSearchResultZoomToIcon(objSelectedSearchResultElements);

    // Ensure that no item have the selected class (unselect existing selection) ...
    objSelectedSearchResultElements.removeClass('search_result_div_selected');

    // Remove the currently selected search result ...
    objMapSearch.CurrentSelectedSearchResultDiv = null;

    // Set to have no search result ...
    objMapSearch.CurrentSelectedSearchResult = null;
}

// **************************************************************************
// FUNCTION: Run
// USAGE:    
// **************************************************************************
TrimbleMap.Search.Run = function Run() {

    // Get the map search instance ...
    var objMapSearch = this;

    // Hide the keyboard for ipads (by removing the focus from the textbox) ...
    objMapSearch.SearchTextBox.blur();

    // Increment the run search counter ...
    objMapSearch.RunSearchCounter = objMapSearch.RunSearchCounter + 1;

    // Get the run search counter into a local variable ...
    var intRunSearchCounter = objMapSearch.RunSearchCounter;

    // Get the search text ...
    var strSearchText = (objMapSearch.SearchTextBox.val()).trim();

    // Set the last executed search type and text ...
    objMapSearch.LastExecutedSearchType = TrimbleMap.Search.enumMapSearchType.QuickSearch;
    objMapSearch.LastExecutedQuickSearchText = strSearchText;

    // Convert the search text to upper case ...
    var strSearchText = strSearchText.toUpperCase();

    // When the user entered a search phrase ...
    if (strSearchText.length > 0) {

        // Hide the callout ...
        objMapSearch.MapCallout.Hide();

        // When the tab is active ...
        if (objMapSearch.SearchTabItem == objMapSearch.Sidebar.CurrentTab) {

            // Attach the event handlers ...
            objMapSearch.DetachEventHandlers();
        }

        // Query the current map ...
        var objQueryMapDeferred = objMapSearch.MapController.QueryCurrentMap(null, true,
            TrimbleMap.Controller.Shared.TrapException(function (objMapService, objMapLayer) {
                let strWhere = "";

                if (objMapService.MapServiceType !== TrimbleMap.Controller.enumMapServiceType.WebMapService) {
                    // Start with a where clause that will return no results ...
                    strWhere = '(1=2)';

                    // When we have any search fields ...
                    if (objMapLayer.SearchFields.length > 0) {

                        // Start with an empty where clause ...
                        strWhere = '';

                        // Loop through all the search fields ... 
                        $.each(objMapLayer.SearchFields, function (intSearchField, strSearchField) {

                            // Add a , when not the first clause ...
                            if (intSearchField > 0) { strWhere += ' OR '; }

                            // Add the clause for strSearchField ...
                            strWhere += "(UPPER(" + strSearchField + ") LIKE N'%" + strSearchText + "%')";
                        });
                    }
                } else {
                    if (objMapLayer.SearchFields.length > 0) {
                        strWhere = "<ogc:Filter>";
                        let arrFieldFilters = [];

                        // Build up where clause for each search field and add to array of field filters
                        for (let intLayerFilter = 0; intLayerFilter < objMapLayer.SearchFields.length; intLayerFilter++) {
                            let strfield = objMapLayer.SearchFields[intLayerFilter];
                            let strFieldFilter = "<ogc:PropertyIsLike matchCase=\"false\" wildCard=\"*\" singleChar=\"#\" escape=\"!\">";
                            strFieldFilter += "<ogc:PropertyName>" + strfield + "</ogc:PropertyName>";
                            strFieldFilter += "<ogc:Literal>*" + strSearchText + "*</ogc:Literal>";
                            strFieldFilter += "</ogc:PropertyIsLike>";

                            arrFieldFilters.push(strFieldFilter);
                        }

                        let intFieldFilters = arrFieldFilters.length;

                        // Append or tag if there are more that one search field
                        if (intFieldFilters > 1) {
                            strWhere += "<ogc:Or>"
                        }

                        strWhere += arrFieldFilters.join("");

                        if (intFieldFilters > 1) {
                            strWhere += "</ogc:Or>";
                        }

                        strWhere += "</ogc:Filter>";
                    }
                }

                // Return the where clause ...
                return strWhere;
            }),
            TrimbleMap.Controller.Shared.TrapException(function (fnForMapService) { objMapSearch.MapController.ForEachVisibleSearchableMapServiceInCurrentMap(fnForMapService); }));

        // Show the spinner ...
        objMapSearch.ClearSearchResultsIcon.hide();
        objMapSearch.SpinnerPlaceHolderDiv.hide();
        objMapSearch.SearchSpinner.fadeIn();

        // When completed ...
        objQueryMapDeferred.promise.then(TrimbleMap.Controller.Shared.TrapException(function (arrQueryMapResults) {

            // Populate the interface with the results ...
            objMapSearch.SearchResultsReturned(arrQueryMapResults, intRunSearchCounter);
        }));
    };
}

// **************************************************************************
// FUNCTION: SearchResultsReturned
// USAGE:    
// **************************************************************************
TrimbleMap.Search.SearchResultsReturned = function SearchResultsReturned(arrMapSearchResults, intRunSearchCounter) {

    // Get the map search instance ...
    var objMapSearch = this;

    // When this is the search results for the last search executed ...
    if (intRunSearchCounter == objMapSearch.RunSearchCounter) {

        // Call query results LoadData here ...

        // Fade the spinner out ...
        objMapSearch.SearchSpinner.fadeOut(400, function Complete() {

            // Completely hide the spinner ...
            objMapSearch.SpinnerPlaceHolderDiv.hide();
            objMapSearch.SearchSpinner.hide();

            // Show the clear search results icon ...
            objMapSearch.ClearSearchResultsIcon.fadeIn();
        });

        // Load the data into the interface ...
        objMapSearch.QueryResultsDisplay.LoadData(arrMapSearchResults, true);

        // When the tab is active ...
        if (objMapSearch.SearchTabItem == objMapSearch.Sidebar.CurrentTab) {

            // Attach the event handlers ...
            objMapSearch.AttachEventHandlers();
        }
    }
}

// **************************************************************************
// FUNCTION: CreateOptions
// USAGE:    
// **************************************************************************
TrimbleMap.Search.Shared.CreateOptions = function CreateOptions(blnEnableAdvancedSearch, strQueryResultsDataJson, fnAdvancedSearchPopupMenuClicked, fnPopulateAdvancedSearchMenu, fnPopulateMapLayerGroupBySectionMenu) {

    // Create and return the options object ...
    return {
        AdvancedSearchEnabled: blnEnableAdvancedSearch,
        QueryResultsDataJson: strQueryResultsDataJson,
        AdvancedSearchPopupMenuClicked: fnAdvancedSearchPopupMenuClicked,
        PopulateAdvancedSearchMenu: fnPopulateAdvancedSearchMenu,
        PopulateMapLayerGroupBySectionMenu: fnPopulateMapLayerGroupBySectionMenu
    };
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Selection = {};
TrimbleMap.Selection.Shared = {};
TrimbleMap.Selection.Shared.SIDEBAR_TAB_WIDTH = 300;
TrimbleMap.Selection.Shared.MODE_BUTTON_NAME = 'SELECTION';
TrimbleMap.Selection.Shared.FLEXICADASTRE_GENERIC_OBJECT_TYPE_ID = -9999;
TrimbleMap.Selection.Shared.VIEW_IN_LICENSE_LIST = 'VIEW_IN_LICENSE_LIST';
TrimbleMap.Selection.Shared.VIEW_IN_AGREEMENT_LIST = 'VIEW_IN_AGREEMENT_LIST';
TrimbleMap.Selection.Shared.VIEW_IN_GROUP_LIST = 'VIEW_IN_GROUP_LIST';
TrimbleMap.Selection.Shared.VIEW_IN_ACTION_LIST = 'VIEW_IN_ACTION_LIST';
TrimbleMap.Selection.Shared.SELECT_BY_LOCATION_CANCEL_BUTTON = 'CANCEL';
TrimbleMap.Selection.Shared.SELECT_BY_LOCATION_SELECT_BUTTON = 'SELECT';
TrimbleMap.Selection.Shared.TOLERANCE_IN_PIXELS = 3;

// **************************************************************************
// FUNCTION: enumToolMode
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.enumToolMode = {};
TrimbleMap.Selection.enumToolMode.None = 'None';
TrimbleMap.Selection.enumToolMode.SelectByPoint = 'SelectByPoint';
TrimbleMap.Selection.enumToolMode.SelectByPolygon = 'SelectByPolygon';
TrimbleMap.Selection.enumToolMode.SelectByPolyline = 'SelectByPolyline';

// **************************************************************************
// FUNCTION: enumOperation
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.enumOperation = {};
TrimbleMap.Selection.enumOperation.SelectFeatures = 'SelectFeatures';
TrimbleMap.Selection.enumOperation.AddFeatures = 'AddFeatures';
TrimbleMap.Selection.enumOperation.RemoveFeatures = 'RemoveFeatures';
TrimbleMap.Selection.enumOperation.FilterCurrentSelection = 'FilterCurrentSelection';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.CreateInstance = function CreateInstance(objMapController, objSidebar, objModeButtons, objMapCallout, objShapeEditor, strTabName, strTabCaption, blnVisible, objOptions) {

    // Create the object that will hold the instance properties ...
    var objMapSelection = {
        MapController: objMapController,
        Sidebar: objSidebar,
        ModeButtons: objModeButtons,
        MapCallout: objMapCallout,
        ShapeEditor: objShapeEditor,
        TabName: strTabName,
        TabCaption: strTabCaption,
        Options: objOptions,
        Operation: TrimbleMap.Selection.enumOperation.SelectFeatures,
        Visible: false,
        ToolMode: TrimbleMap.Selection.enumToolMode.None,
        ActiveLayerIDs: null,
        SelectionDiv: null,
        EventHandlersAttached: false,

        QueryResultsDisplay: null,
        OperationPopup: null,
        LayersPopup: null,
        OperationPopupDiv: null,
        LayersPopupDiv: null,
        ToolModePopup: null,
        ToolModePopupDiv: null,
        SelectByLocationPopup: null,
        SelectByLocationIcon: null,
        SelectByLocationDialogDiv: null,
        SelectByLocationTargetLayersDiv: null,
        SelectByLocationSourceLayersDiv: null,
        ClickHandlerInstance: null,
        DrawingToolbar: null,
        EndPolygonDrawingHandle: null,
        EndPolylineDrawingHandle: null,
        ApplyBuffer: false,
        SelectByLocationActiveSourceLayerIDs: {},
        SelectByLocationActiveTargetLayerIDs: {},
        BufferValue: null,
        BufferUnit: null,
        PerformingSelection: false,
        SelectionModeButton: null,
        SelectionTabItem: null,
        AddToShapeHoveredResultIcon: null,
        RemoveFromShapeHoveredResultIcon: null,
        RemoveFromSelectionHoveredResultIcon: null,
        OnLoadedFunctions: [],
        SelectByLocationDialog: null,
        SelectFromSelectionCountSpan: null,
        OverlapsWithSelectionCountSpan: null,
        BufferDiv: null,
        BufferValidationMessage: null,
        SelectFromSection: null,
        OverlapWithSection: null,
        BufferSection: null,
        SelectFromSectionNiceScroll: null,
        OverlapWithSectionNiceScroll: null,
        SelectByLocationTabBusySliding: false,
        OnShowFunctions: [],
        OnHideFunctions: [],

        SelectionDivClickHandlerProxy: function (e) { objMapSelection.SelectionDivClickHandler(e); },
        MapClickedHandlerProxy: function (e) { objMapSelection.MapClickedHandler(e); },

        PolygonDrawEndHandlerProxy: function (objGeometry) { objMapSelection.PolygonDrawEndHandler(objGeometry); },
        PolylineDrawEndHandlerProxy: function (objGeometry) { objMapSelection.PolylineDrawEndHandler(objGeometry); },

        ActivateOperationPopupProxy: function (objPopupContainerDiv) { objMapSelection.ActivateOperationPopup(objPopupContainerDiv); },
        DeActivateOperationPopupProxy: function (objPopupContainerDiv) { objMapSelection.DeActivateOperationPopup(objPopupContainerDiv); },

        ActivateLayersPopupProxy: function (objPopupContainerDiv) { objMapSelection.ActivateLayersPopup(objPopupContainerDiv); },
        DeActivateLayersPopupProxy: function (objPopupContainerDiv) { objMapSelection.DeActivateLayersPopup(objPopupContainerDiv); },

        ActivateToolModePopupProxy: function (objPopupContainerDiv) { objMapSelection.ActivateToolModePopup(objPopupContainerDiv); },
        DeActivateToolModePopupProxy: function (objPopupContainerDiv) { objMapSelection.DeActivateToolModePopup(objPopupContainerDiv); },

        PreferenceChangedProxy: function (arrPreferencesChanged) { objMapSelection.PreferenceChanged(arrPreferencesChanged); },

        OperationPopupClickedProxy: function (e) { objMapSelection.OperationPopupClicked(e); },
        LayersPopupClickedProxy: function (e) { objMapSelection.LayersPopupClicked(e); },
        ToolModePopupClickedProxy: function (e) { objMapSelection.ToolModePopupClicked(e); },
        SelectByLocationDialogClickedProxy: function (e) { objMapSelection.SelectByLocationDialogClicked(e); },
        BufferValueChangedProxy: function (e) { objMapSelection.BufferValueChanged(e); },
        MapLoadedProxy: function (blnReloaded) { objMapSelection.MapLoaded(blnReloaded); },
        PreReloadedProxy: function (blnReloaded) { objMapSelection.PreReloaded(); },

        AddToShapeClickedProxy: function (objDataForQueryResult) { objMapSelection.AddToShapeClicked(objDataForQueryResult); },
        RemoveFromShapeClickedProxy: function (objDataForQueryResult) { objMapSelection.RemoveFromShapeClicked(objDataForQueryResult); },
        RemoveFromSelectionClickedProxy: function (objDataForQueryResult) { objMapSelection.RemoveFromSelectionClicked(objDataForQueryResult); },
        OnShapeEditorShowProxy: function () { objMapSelection.OnShapeEditorShow(); },
        OnShapeEditorHideProxy: function () { objMapSelection.OnShapeEditorHide(); },
        QueryResultsDisplayLoadedProxy: function () { objMapSelection.QueryResultsDisplayLoaded(); },

        PopulateMapLayerGroupBySectionMenuProxy: function (objMapLayerGroupBySection, objPopupMenu, objQueryResultDisplay) { objMapSelection.PopulateMapLayerGroupBySectionMenu(objMapLayerGroupBySection, objPopupMenu, objQueryResultDisplay); },

        CreateSelectionElements: TrimbleMap.Selection.CreateSelectionElements,
        ActivateMode: TrimbleMap.Selection.ActivateMode,
        DeActivateMode: TrimbleMap.Selection.DeActivateMode,
        ActivateTab: TrimbleMap.Selection.ActivateTab,
        DeActivateTab: TrimbleMap.Selection.DeActivateTab,
        ResizeTab: TrimbleMap.Selection.ResizeTab,
        AttachEventHandlers: TrimbleMap.Selection.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Selection.DetachEventHandlers,
        SelectTool: TrimbleMap.Selection.SelectTool,
        SelectionDivClickHandler: TrimbleMap.Selection.SelectionDivClickHandler,
        ActivateOperationPopup: TrimbleMap.Selection.ActivateOperationPopup,
        DeActivateOperationPopup: TrimbleMap.Selection.DeActivateOperationPopup,

        ActivateLayersPopup: TrimbleMap.Selection.ActivateLayersPopup,
        DeActivateLayersPopup: TrimbleMap.Selection.DeActivateLayersPopup,

        ActivateToolModePopup: TrimbleMap.Selection.ActivateToolModePopup,
        DeActivateToolModePopup: TrimbleMap.Selection.DeActivateToolModePopup,

        SelectGeometriesFromOptions: TrimbleMap.Selection.SelectGeometriesFromOptions,
        CreateOperationPopup: TrimbleMap.Selection.CreateOperationPopup,
        CreateToolModePopup: TrimbleMap.Selection.CreateToolModePopup,
        OperationPopupClicked: TrimbleMap.Selection.OperationPopupClicked,
        CreateLayersPopup: TrimbleMap.Selection.CreateLayersPopup,
        CreateLayerList: TrimbleMap.Selection.CreateLayerList,
        LayersPopupClicked: TrimbleMap.Selection.LayersPopupClicked,
        InitializeActiveLayerIDs: TrimbleMap.Selection.InitializeActiveLayerIDs,
        InitializeUserOptions: TrimbleMap.Selection.InitializeUserOptions,
        IsActiveLayer: TrimbleMap.Selection.IsActiveLayer,
        IsActiveSelectByLocationSourceLayer: TrimbleMap.Selection.IsActiveSelectByLocationSourceLayer,
        IsActiveSelectByLocationTargetLayer: TrimbleMap.Selection.IsActiveSelectByLocationTargetLayer,
        ActivateLayer: TrimbleMap.Selection.ActivateLayer,
        ToolModePopupClicked: TrimbleMap.Selection.ToolModePopupClicked,
        UpdateToolModeIcon: TrimbleMap.Selection.UpdateToolModeIcon,
        DeActivateLayer: TrimbleMap.Selection.DeActivateLayer,
        DeActivateSelectByPoint: TrimbleMap.Selection.DeActivateSelectByPoint,
        DeActivateSelectByPolygon: TrimbleMap.Selection.DeActivateSelectByPolygon,
        DeActivateSelectByPolyline: TrimbleMap.Selection.DeActivateSelectByPolyline,
        ActivateSelectByPolygon: TrimbleMap.Selection.ActivateSelectByPolygon,
        ActivateSelectByPolyline: TrimbleMap.Selection.ActivateSelectByPolyline,
        ActivateSelectByPoint: TrimbleMap.Selection.ActivateSelectByPoint,
        ActivateTool: TrimbleMap.Selection.ActivateTool,
        DeActivateTool: TrimbleMap.Selection.DeActivateTool,
        MapClickedHandler: TrimbleMap.Selection.MapClickedHandler,
        PolygonDrawEndHandler: TrimbleMap.Selection.PolygonDrawEndHandler,
        PolylineDrawEndHandler: TrimbleMap.Selection.PolylineDrawEndHandler,
        PerformSelection: TrimbleMap.Selection.PerformSelection,
        BufferAndPerformSelection: TrimbleMap.Selection.BufferAndPerformSelection,
        PerformPreviousSelection: TrimbleMap.Selection.PerformPreviousSelection,
        AddToSelection: TrimbleMap.Selection.AddToSelection,
        RemoveFromSelection: TrimbleMap.Selection.RemoveFromSelection,
        UpdateOperationIcon: TrimbleMap.Selection.UpdateOperationIcon,
        OpenSelectByLocationDialog: TrimbleMap.Selection.OpenSelectByLocationDialog,
        CloseSelectByLocationDialog: TrimbleMap.Selection.CloseSelectByLocationDialog,
        CreateSelectByLocationDialog: TrimbleMap.Selection.CreateSelectByLocationDialog,
        ValidateSelectByLocation: TrimbleMap.Selection.ValidateSelectByLocation,
        ShowBufferValidationMessage: TrimbleMap.Selection.ShowBufferValidationMessage,
        SelectByLocationDialogClicked: TrimbleMap.Selection.SelectByLocationDialogClicked,
        OpenSelectByLocationDialogTab: TrimbleMap.Selection.OpenSelectByLocationDialogTab,
        AttachSelectByLocationScrollbars: TrimbleMap.Selection.AttachSelectByLocationScrollbars,
        DetachSelectByLocationScrollbars: TrimbleMap.Selection.DetachSelectByLocationScrollbars,
        PopulateBufferUnitsDropDown: TrimbleMap.Selection.PopulateBufferUnitsDropDown,
        LayerListClicked: TrimbleMap.Selection.LayerListClicked,
        ActivateSelectByLocationSourceLayer: TrimbleMap.Selection.ActivateSelectByLocationSourceLayer,
        DeActivateSelectByLocationSourceLayer: TrimbleMap.Selection.DeActivateSelectByLocationSourceLayer,
        ActivateSelectByLocationTargetLayer: TrimbleMap.Selection.ActivateSelectByLocationTargetLayer,
        DeActivateSelectByLocationTargetLayer: TrimbleMap.Selection.DeActivateSelectByLocationTargetLayer,
        SelectByLocation: TrimbleMap.Selection.SelectByLocation,
        BufferValueChanged: TrimbleMap.Selection.BufferValueChanged,
        UpdateSelectByLocationCountSpans: TrimbleMap.Selection.UpdateSelectByLocationCountSpans,
        UpdateSelectByLocationHeadingCountSpans: TrimbleMap.Selection.UpdateSelectByLocationHeadingCountSpans,
        MapLoaded: TrimbleMap.Selection.MapLoaded,
        PreReloaded: TrimbleMap.Selection.PreReloaded,
        AddToShapeClicked: TrimbleMap.Selection.AddToShapeClicked,
        RemoveFromShapeClicked: TrimbleMap.Selection.RemoveFromShapeClicked,
        RemoveFromSelectionClicked: TrimbleMap.Selection.RemoveFromSelectionClicked,
        AddShapeEditorIcons: TrimbleMap.Selection.AddShapeEditorIcons,
        RemoveShapeEditorIcons: TrimbleMap.Selection.RemoveShapeEditorIcons,
        OnShapeEditorShow: TrimbleMap.Selection.OnShapeEditorShow,
        OnShapeEditorHide: TrimbleMap.Selection.OnShapeEditorHide,
        QueryResultsDisplayLoaded: TrimbleMap.Selection.QueryResultsDisplayLoaded,
        AddOnLoadedCallback: TrimbleMap.Selection.AddOnLoadedCallback,
        RemoveOnLoadedCallback: TrimbleMap.Selection.RemoveOnLoadedCallback,
        TriggerOnLoadedCallbacks: TrimbleMap.Selection.TriggerOnLoadedCallbacks,
        PreferenceChanged: TrimbleMap.Selection.PreferenceChanged,
        PopulateMapLayerGroupBySectionMenu: TrimbleMap.Selection.PopulateMapLayerGroupBySectionMenu,
        RemoveFromSelectionMenuItemClicked: TrimbleMap.Selection.RemoveFromSelectionMenuItemClicked,
        PopulateMapLayerSectionAddOrRemoveMenuItems: TrimbleMap.Selection.PopulateMapLayerSectionAddOrRemoveMenuItems,
        AddLayerFeaturesToShapeMenuItemClicked: TrimbleMap.Selection.AddLayerFeaturesToShapeMenuItemClicked,
        RemoveLayerFeaturesFromShapeMenuItemClicked: TrimbleMap.Selection.RemoveLayerFeaturesFromShapeMenuItemClicked,
        IsValidPolygonForPolygonSelection: TrimbleMap.Selection.IsValidPolygonForPolygonSelection,
        AddOnShowFunction: TrimbleMap.Selection.AddOnShowFunction,
        AddOnHideFunction: TrimbleMap.Selection.AddOnHideFunction,
        TriggerOnShowFunctions: TrimbleMap.Selection.TriggerOnShowFunctions,
        TriggerOnHideFunctions: TrimbleMap.Selection.TriggerOnHideFunctions,
        Show: TrimbleMap.Selection.Show,
        Hide: TrimbleMap.Selection.Hide
    };

    // Initialize the layer IDs from the current map ...
    objMapSelection.InitializeActiveLayerIDs();

    // Set it as the Selection div on the Map object ...
    objMapSelection.CreateSelectionElements();

    // Create the mode button ...
    objMapSelection.SelectionModeButton = SD.ModeButtons.Shared.CreateButton(TrimbleMap.Selection.Shared.MODE_BUTTON_NAME,
        'selection-mode',
        SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Select'),
        TrimbleMap.StandardMap.Shared.enumModeButtonOrder.SELECT,
        function (objModeButton) { objMapSelection.ActivateMode(objModeButton); },
        function (objModeButton) { objMapSelection.DeActivateMode(objModeButton); });

    // Create the tab item ...
    objMapSelection.SelectionTabItem = SD.Sidebar.Shared.CreateTabItem(objMapSelection.TabName, objMapSelection.TabCaption,
        TrimbleMap.StandardMap.Shared.enumTabOrder.SELECT,
        function (objTabContainerElement, enTabActivationMethod) { objMapSelection.ActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement, enTabActivationMethod) { objMapSelection.DeActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement) { objMapSelection.ResizeTab(objTabContainerElement); },
        function () { return TrimbleMap.Selection.Shared.SIDEBAR_TAB_WIDTH; });

    // Show the tab and mode button when its to be visible at startup ...
    if (blnVisible) { objMapSelection.Show(false, false); }

    // Add the onloaded event handler to the map controller ...
    objMapSelection.MapController.AddOnLoadedCallback(objMapSelection.MapLoadedProxy);

    // Add the pre reloaded event handler to the map controller ...
    objMapSelection.MapController.AddPreReloadedCallback(objMapSelection.PreReloadedProxy);

    // Add the notify preference changed event handler to the map controller ...
    objMapSelection.MapController.AddNotifyPreferenceChanged(objMapSelection.PreferenceChangedProxy);

    return objMapSelection;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
//           blnSelectTab is optional, defaults to true 
// **************************************************************************
TrimbleMap.Selection.Show = function Show(blnTriggerNotifyModuleVisibilityChanged, blnSelectTab) {

    // Get the instance ...
    var objMapSelection = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objMapSelection.Visible) {

        // Add the mode button ...
        objMapSelection.ModeButtons.AddButton(objMapSelection.SelectionModeButton);

        // Add the tab ...
        objMapSelection.Sidebar.AddTab(objMapSelection.SelectionTabItem);

        // When we are to select the tab ...
        if ((typeof blnSelectTab == 'undefined') || (blnSelectTab == null) || blnSelectTab) {

            // Select the tab ...
            objMapSelection.Sidebar.SelectTab(objMapSelection.SelectionTabItem);
        }

        // Set to be visible ...
        objMapSelection.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapSelection.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Selection, true); }

        // Trigger the on show callbacks ...
        objMapSelection.TriggerOnShowFunctions();
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Selection.Hide = function Hide(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objMapSelection = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objMapSelection.Visible) {

        // Detach all the event handlers (if attached) ...
        objMapSelection.DetachEventHandlers();

        // Remove the mode button ...
        objMapSelection.ModeButtons.RemoveButton(objMapSelection.SelectionModeButton);

        // Remove the tab ...
        objMapSelection.Sidebar.RemoveTab(objMapSelection.SelectionTabItem);

        // Set to not be visible ...
        objMapSelection.Visible = false;

        // Notify that the module visibility changed to false ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objMapSelection.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Selection, false); }

        // Trigger the on hide callbacks ...
        objMapSelection.TriggerOnHideFunctions();
    }
}

// **************************************************************************
// FUNCTION: InitializeActiveLayerIDs
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.InitializeActiveLayerIDs = function InitializeActiveLayerIDs() {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Create a new hash tables for the active layer ids ...
    objMapSelection.ActiveLayerIDs = {};
    objMapSelection.SelectByLocationActiveSourceLayerIDs = {};
    objMapSelection.SelectByLocationActiveTargetLayerIDs = {};

    // Loop through all the selectable map services in the current map ...
    objMapSelection.MapController.ForEachSelectableMapServiceInCurrentMap(function (objMapService, objMapServiceDisplay, arrLayerIDs) {

        // Loop through all the selectable layers ...
        for (var intLayer = 0; intLayer < arrLayerIDs.length; intLayer++) {

            // Get the map layer id ...
            var strMapLayerID = arrLayerIDs[intLayer];

            // Get the map layer by id ...
            var objMapLayer = objMapSelection.MapController.GetMapLayer(strMapLayerID);

            let objSelectionState = objMapSelection.MapController.State.ClientStoredSelectionState;

            let blnUserMapSettingsActiveLayerIDsApplied = false;
            let blnUserMapSettingsSelectByLocationActiveSourceLayerIDsApplied = false;
            let blnUserMapSettingsSelectByLocationActiveTargetLayerIDsApplied = false;

            if (objMapSelection.MapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings && objSelectionState && objSelectionState.ActiveLayerIDs) {

                if (objSelectionState.ActiveLayerIDs[strMapLayerID] && (objMapService.MapServiceType === TrimbleMap.Controller.enumMapServiceType.WebMapService || objMapLayer.ObjectTypeID != TrimbleMap.Selection.Shared.FLEXICADASTRE_GENERIC_OBJECT_TYPE_ID)) {

                    // Add the layer ID to the active layer ids array and to the select by location source and target layer IDs ...
                    objMapSelection.ActiveLayerIDs[strMapLayerID] = strMapLayerID;
                }

                blnUserMapSettingsActiveLayerIDsApplied = true;
            }

            if (objMapSelection.MapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings && objSelectionState && objSelectionState.SelectByLocationActiveSourceLayerIDs) {

                if (objSelectionState.SelectByLocationActiveSourceLayerIDs[strMapLayerID] && objMapLayer.ObjectTypeID != TrimbleMap.Selection.Shared.FLEXICADASTRE_GENERIC_OBJECT_TYPE_ID) {

                    // Add the layer ID to the active layer ids array and to the select by location source and target layer IDs ...
                    objMapSelection.SelectByLocationActiveSourceLayerIDs[strMapLayerID] = strMapLayerID;
                }

                blnUserMapSettingsSelectByLocationActiveSourceLayerIDsApplied = true;
            }

            if (objMapSelection.MapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings && objSelectionState && objSelectionState.SelectByLocationActiveTargetLayerIDs) {

                if (objSelectionState.SelectByLocationActiveTargetLayerIDs[strMapLayerID] && objMapLayer.ObjectTypeID != TrimbleMap.Selection.Shared.FLEXICADASTRE_GENERIC_OBJECT_TYPE_ID) {

                    // Add the layer ID to the active layer ids array and to the select by location source and target layer IDs ...
                    objMapSelection.SelectByLocationActiveTargetLayerIDs[strMapLayerID] = strMapLayerID;
                }

                blnUserMapSettingsSelectByLocationActiveTargetLayerIDsApplied = true;
            }

            // When a FlexiCadastre managed layer ...
            if (objMapLayer.ObjectTypeID != TrimbleMap.Selection.Shared.FLEXICADASTRE_GENERIC_OBJECT_TYPE_ID) {

                // Add the layer ID to the active layer ids array and to the select by location source and target layer IDs ...
                if (!blnUserMapSettingsActiveLayerIDsApplied) { objMapSelection.ActiveLayerIDs[strMapLayerID] = strMapLayerID; }
                if (!blnUserMapSettingsSelectByLocationActiveSourceLayerIDsApplied) { objMapSelection.SelectByLocationActiveSourceLayerIDs[strMapLayerID] = strMapLayerID; }
                if (!blnUserMapSettingsSelectByLocationActiveTargetLayerIDsApplied) { objMapSelection.SelectByLocationActiveTargetLayerIDs[strMapLayerID] = strMapLayerID; }
            }
        }
    });
}

// **************************************************************************
// FUNCTION: InitializeUserOptions
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.InitializeUserOptions = function InitializeUserOptions() {

    // Get the map Selection instance ...
    var objMapSelection = this;

    let objSelectionState = objMapSelection.MapController.State.ClientStoredSelectionState;

    let blnApplyUserSelectionState = (objMapSelection.MapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings && objSelectionState) ? true : false;

    let blnRecreatePreviousSelectionResults = (blnApplyUserSelectionState &&
        objMapSelection.MapController.Preferences.KeepSearchAndSelectResults &&
        objSelectionState.SelectionQueries &&
        objSelectionState.SelectionQueries.length > 0) ? true : false;

    objMapSelection.ApplyBuffer = (blnApplyUserSelectionState && objSelectionState.ApplyBuffer) ? objSelectionState.ApplyBuffer : false;
    objMapSelection.BufferValue = (blnApplyUserSelectionState && objSelectionState.BufferValue) ? objSelectionState.BufferValue : null;
    objMapSelection.BufferUnit = (blnApplyUserSelectionState && objSelectionState.BufferUnit) ? objSelectionState.BufferUnit : null;

    let enSelectionTool = (objMapSelection.MapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings &&
        objMapSelection.MapController.State.ClientStoredSelectionToolMode) ?
        objMapSelection.MapController.State.ClientStoredSelectionToolMode : TrimbleMap.Selection.enumToolMode.None;
    objMapSelection.SelectTool(enSelectionTool);

    objMapSelection.Operation = (objMapSelection.MapController.State.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings &&
        objMapSelection.MapController.State.ClientStoredSelectionOperation) ?
        objMapSelection.MapController.State.ClientStoredSelectionOperation : TrimbleMap.Selection.enumOperation.SelectFeatures;
    objMapSelection.UpdateOperationIcon();

    if (blnRecreatePreviousSelectionResults) {
        objMapSelection.PerformPreviousSelection();
    }
}

// **************************************************************************
// FUNCTION: IsActiveLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.IsActiveLayer = function IsActiveLayer(strMapLayerID) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Check if in the active hash table ... ...
    var blnIsActive = (typeof objMapSelection.ActiveLayerIDs[strMapLayerID] != 'undefined');

    return blnIsActive;
}

// **************************************************************************
// FUNCTION: ActivateLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateLayer = function ActivateLayer(strMapLayerID) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Add it to the ActiveLayerIDs hash table ...
    objMapSelection.ActiveLayerIDs[strMapLayerID] = strMapLayerID;
}

// **************************************************************************
// FUNCTION: DeActivateLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateLayer = function DeActivateLayer(strMapLayerID) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Remove it from the ActiveLayerIDs hash table ...
    delete objMapSelection.ActiveLayerIDs[strMapLayerID];
}

// **************************************************************************
// FUNCTION: IsActiveSelectByLocationSourceLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.IsActiveSelectByLocationSourceLayer = function IsActiveSelectByLocationSourceLayer(strMapLayerID) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Check if in the active hash table ... ...
    var blnIsActive = (typeof objMapSelection.SelectByLocationActiveSourceLayerIDs[strMapLayerID] != 'undefined');

    return blnIsActive;
}

// **************************************************************************
// FUNCTION: ActivateSelectByLocationSourceLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateSelectByLocationSourceLayer = function ActivateSelectByLocationSourceLayer(strMapLayerID) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Add it to the SelectByLocationActiveSourceLayerIDs hash table ...
    objMapSelection.SelectByLocationActiveSourceLayerIDs[strMapLayerID] = strMapLayerID;
}

// **************************************************************************
// FUNCTION: DeActivateSelectByLocationSourceLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateSelectByLocationSourceLayer = function DeActivateSelectByLocationSourceLayer(strMapLayerID) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Remove it from the SelectByLocationActiveSourceLayerIDs hash table ...
    delete objMapSelection.SelectByLocationActiveSourceLayerIDs[strMapLayerID];
}

// **************************************************************************
// FUNCTION: IsActiveSelectByLocationTargetLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.IsActiveSelectByLocationTargetLayer = function IsActiveSelectByLocationTargetLayer(strMapLayerID) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Check if in the active hash table ... ...
    var blnIsActive = (typeof objMapSelection.SelectByLocationActiveTargetLayerIDs[strMapLayerID] != 'undefined');

    return blnIsActive;
}

// **************************************************************************
// FUNCTION: ActivateSelectByLocationTargetLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateSelectByLocationTargetLayer = function ActivateSelectByLocationTargetLayer(strMapLayerID) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Add it to the SelectByLocationActiveTargetLayerIDs hash table ...
    objMapSelection.SelectByLocationActiveTargetLayerIDs[strMapLayerID] = strMapLayerID;
}

// **************************************************************************
// FUNCTION: DeActivateSelectByLocationTargetLayer
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateSelectByLocationTargetLayer = function DeActivateSelectByLocationTargetLayer(strMapLayerID) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Remove it from the SelectByLocationActiveTargetLayerIDs hash table ...
    delete objMapSelection.SelectByLocationActiveTargetLayerIDs[strMapLayerID];
}

// **************************************************************************
// FUNCTION: AddToShapeClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.AddToShapeClicked = function AddToShapeClicked(objDataForQueryResult) {

    // Get the instance ...
    var objMapSelection = this;

    //when  selected shape is a polygon and the ShapeEditor shape is of 'MIXED' type or both shapes have the same type
    if ((objDataForQueryResult.DataForElement.Geometry.type == "polygon" && objMapSelection.ShapeEditor.Shape.GeometryType == "MIXED") || (objDataForQueryResult.DataForElement.Geometry.type.toUpperCase() == objMapSelection.ShapeEditor.Shape.GeometryType.toUpperCase())) {

        // Draw to add the selected geometry ...
        objMapSelection.ShapeEditor.DrawToAddMultiPart(objDataForQueryResult.DataForElement.Geometry, objDataForQueryResult.DataForElement.SpatialReferenceID, true, false);
    }
    else {

        // Unable to add the selection to the shape        
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'UnableToAddSelection');

        // The geometry type of the selection does not match the geometry type of the shape        
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'GeometryTypeMismatch');

        //Show the dialog
        TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
    }

}


// **************************************************************************
// FUNCTION: CreateDialog
TrimbleMap.Selection.RemoveFromShapeClicked = function RemoveFromShapeClicked(objDataForQueryResult) {

    // Get the instance ...
    var objMapSelection = this;

    // Draw to remove the selected geometry ...
    objMapSelection.ShapeEditor.DrawToRemoveMultiPart(objDataForQueryResult.DataForElement.Geometry, objDataForQueryResult.DataForElement.SpatialReferenceID, false);
}

// **************************************************************************
// FUNCTION: RemoveFromSelectionClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.RemoveFromSelectionClicked = function RemoveFromSelectionClicked(objDataForQueryResult) {

    // Get the instance ...
    var objMapSelection = this;

    // Create the map service query results array for the element's data object ...
    var arrMapServiceQueryResults = [TrimbleMap.Controller.Shared.CreateMapServiceQueryResult(objDataForQueryResult.MapLayer.MapLayerID, 1, true, [objDataForQueryResult.DataForElement])];

    // Remove from the selection ...
    objMapSelection.RemoveFromSelection(arrMapServiceQueryResults);
}

// **************************************************************************
// FUNCTION: CreateSelectionElements
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.CreateSelectionElements = function CreateSelectionElements(objModeButton) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Get the translation for the selection description ...
    var strSelectionDescription = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectionDescription');

    // Create the selection div ...
    objMapSelection.SelectionDiv = $('<div class="side-panel"></div>');

    // Create the selection tools div ...
    objMapSelection.SelectionToolsDiv = $('<div class="selection-container"><div class="description">' + strSelectionDescription + ':</div></div>');

    // Add it to the selection div ...
    objMapSelection.SelectionDiv.append(objMapSelection.SelectionToolsDiv);

    // Create a div for the icons ...
    var objIconDiv = $('<div class="selection-tools"></div>');

    // Add the icon div ...
    objMapSelection.SelectionToolsDiv.append(objIconDiv);

    var strClearSelectionToolTip = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'ClearSelectionToolTip');

    // Select by location
    var strSelectionByLocationToolTip = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectByLocation');

    // Remove from selection
    var strRemoveFromSelectionToolTip = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'RemoveFromSelection');

    // Create the selection mode drop down ...
    objMapSelection.SelectionToolModeDropDown = $('<div class="tool-button tool-dropdown select-polygon selection-background"></div>');

    // Add the selection button drop down ...
    objIconDiv.append(objMapSelection.SelectionToolModeDropDown);

    // Create the selection mode drop down ...
    objMapSelection.SelectionLayersDropDown = $('<div class="tool-button tool-dropdown select-layer"></div>');

    // Add the selection mode drop down ...
    objIconDiv.append(objMapSelection.SelectionLayersDropDown);

    // Create the selection mode drop down ...
    objMapSelection.SelectionModeDropDown = $('<div class="tool-button tool-dropdown select-operation select-select"></div>');

    // Add the selection mode drop down ...
    objIconDiv.append(objMapSelection.SelectionModeDropDown);

    // Add the select by clear selection button ...
    objIconDiv.append('<div class="tool-button clear-selection" title="' + strClearSelectionToolTip + '" ClearSelectionIcon="ClearSelectionIcon"></div>');

    // Create the select by location drop down ...
    objMapSelection.SelectByLocationIcon = $('<div class="tool-button select-location" title="' + strSelectionByLocationToolTip + '" SelectByLocationIcon="true"></div>');

    // Add the selection by location drop down ...
    objIconDiv.append(objMapSelection.SelectByLocationIcon);

    // Create a container in which to display the selection list ...
    objMapSelection.QueryResultsDisplayDiv = $('<div class="selection-container"><div>');

    // Add it to the selection div ...
    objMapSelection.SelectionDiv.append(objMapSelection.QueryResultsDisplayDiv);

    // Create the query results display instance ...
    objMapSelection.QueryResultsDisplay = TrimbleMap.QueryResultsDisplay.CreateInstance(objMapSelection.QueryResultsDisplayDiv,
        objMapSelection.MapController,
        objMapSelection.MapCallout,
        function (objMapLayer) {
            return objMapLayer.ProcessedSearchAndSelectHtmlTemplate;
        },
        function (objMapLayer) {
            return objMapLayer.ProcessedSearchAndSelectHtmlTemplateByPart;
        },
        function () {
            return true;
        },
        objMapSelection.PopulateMapLayerGroupBySectionMenuProxy,
        false,
        objMapSelection.Options.QueryResultsDataJson);

    // Add the onloaded callback ...
    objMapSelection.QueryResultsDisplay.AddOnLoadedCallback(objMapSelection.QueryResultsDisplayLoadedProxy);

    // When we have shape editor ...
    if (objMapSelection.ShapeEditor) {

        // Add on show and on hide functions to the shape editor ...
        objMapSelection.ShapeEditor.AddOnShowFunction(objMapSelection.OnShapeEditorShowProxy);
        objMapSelection.ShapeEditor.AddOnHideFunction(objMapSelection.OnShapeEditorHideProxy);

        // Create the add to shape and remove from shape hovered result icon ...
        objMapSelection.AddToShapeHoveredResultIcon = TrimbleMap.QueryResultsDisplay.Shared.CreateHoveredResultIcon('Add to shape', 'add-shape', objMapSelection.AddToShapeClickedProxy);
        objMapSelection.RemoveFromShapeHoveredResultIcon = TrimbleMap.QueryResultsDisplay.Shared.CreateHoveredResultIcon('Remove from shape', 'query_remove_from_shape', objMapSelection.RemoveFromShapeClickedProxy);

        // When it is visible ...
        if (objMapSelection.ShapeEditor.Visible) {

            // Add the shape editor icons ...
            objMapSelection.AddShapeEditorIcons();
        }
    }

    // Create the 'Remove from selectiom' hovered result icon ...
    objMapSelection.RemoveFromSelectionHoveredResultIcon = TrimbleMap.QueryResultsDisplay.Shared.CreateHoveredResultIcon(strRemoveFromSelectionToolTip, 'remove-shape', objMapSelection.RemoveFromSelectionClickedProxy);

    // Add the 'Remove from selectiom' hovered result icon ...
    objMapSelection.QueryResultsDisplay.AddHoveredResultIcon(objMapSelection.RemoveFromSelectionHoveredResultIcon);

    // Create the operation popup control ...
    objMapSelection.OperationPopup = SD.Popup.CreateInstance(objMapSelection.SelectionModeDropDown,
        'popup-downwards',
        'popup-upwards',
        'popup-downwards-open',
        'popup-upwards-open',
        5,
        false,
        SD.Popup.enumPopupBehaviour.AlwaysDown,
        objMapSelection.ActivateOperationPopupProxy,
        objMapSelection.DeActivateOperationPopupProxy);

    // Create the layers popup control ...
    objMapSelection.LayersPopup = SD.Popup.CreateInstance(objMapSelection.SelectionLayersDropDown,
        'popup-downwards',
        'popup-upwards',
        'popup-downwards-open',
        'popup-upwards-open',
        5,
        false,
        SD.Popup.enumPopupBehaviour.AlwaysDown,
        objMapSelection.ActivateLayersPopupProxy,
        objMapSelection.DeActivateLayersPopupProxy);

    // Create the layers popup control ...
    objMapSelection.ToolModePopup = SD.Popup.CreateInstance(objMapSelection.SelectionToolModeDropDown,
        'popup-downwards',
        'popup-upwards',
        'popup-downwards-open',
        'popup-upwards-open',
        5,
        false,
        SD.Popup.enumPopupBehaviour.AlwaysDown,
        objMapSelection.ActivateToolModePopupProxy,
        objMapSelection.DeActivateToolModePopupProxy);
}

// **************************************************************************
// FUNCTION: SelectGeometriesFromOptions
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.SelectGeometriesFromOptions = function SelectGeometriesFromOptions() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Loop through all the map layers ...
    $.each(objMapSelection.QueryResultsDisplay.Data, function (strMapLayerID, objMapLayerData) {

        // Get the map layer ...
        var objMapLayer = objMapSelection.MapController.GetMapLayer(strMapLayerID);

        // Add all the data to the selection in the map ...
        $.each(objMapLayerData.Data, function (intData, objData) {
            objMapSelection.MapController.AddToSelection(objMapLayer, objData.Attributes, objData.Geometry);
        });
    });
}

// **************************************************************************
// FUNCTION: PopulateMapLayerGroupBySectionMenu
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.PopulateMapLayerGroupBySectionMenu = function PopulateMapLayerGroupBySectionMenu(objMapLayerGroupBySection, objPopupMenu, objQueryResultDisplay) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When we have a PopulateMapLayerGroupBySectionMenu function ...
    if ((typeof objMapSelection.Options.PopulateMapLayerGroupBySectionMenu != 'undefined') && (objMapSelection.Options.PopulateMapLayerGroupBySectionMenu != null)) {

        // Call the populate function from the options ...
        objMapSelection.Options.PopulateMapLayerGroupBySectionMenu(objMapLayerGroupBySection, objPopupMenu, objQueryResultDisplay);
    }

    // Create a function that will call RemoveFromSelectionMenuItemClicked with the details about the map layer group by section ...
    var fnCallRemoveFromSelectionMenuItemClicked = function () { objMapSelection.RemoveFromSelectionMenuItemClicked(objMapLayerGroupBySection); }

    // Remove From Selection
    var strRemoveFromTranslation = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'RemoveFromSelection');

    // Create and add the remove from selection menu item ...
    objPopupMenu.AddMenuItem(SD.PopupMenu.Shared.CreateMenuItem(strRemoveFromTranslation, strRemoveFromTranslation, fnCallRemoveFromSelectionMenuItemClicked));

    //display only when in edit mode
    if (objMapSelection.ShapeEditor && (objMapSelection.ShapeEditor.Editable)) {
        objMapSelection.PopulateMapLayerSectionAddOrRemoveMenuItems(objMapLayerGroupBySection, objPopupMenu);
    }

}

// **************************************************************************
// FUNCTION: PopulateMapLayerSectionAddOrRemoveMenuItems
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.PopulateMapLayerSectionAddOrRemoveMenuItems = function PopulateMapLayerSectionAddOrRemoveMenuItems(objMapLayerGroupBySection, objPopupMenu) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create a function that will call AddLayerFeaturesToShapeMenuItemClicked with the details about the map layer group by section ...
    var fnCallAddLayerFeaturesToShapeMenuItemClicked = function () { objMapSelection.AddLayerFeaturesToShapeMenuItemClicked(objMapLayerGroupBySection); }

    // Create a function that will call RemoveLayerFeaturesFromShapeMenuItemClicked with the details about the map layer group by section ...
    var fnCallRemoveLayerFeaturesFromShapeMenuItemClicked = function () { objMapSelection.RemoveLayerFeaturesFromShapeMenuItemClicked(objMapLayerGroupBySection); }

    var strAddToShapeTranslation = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'AddToShape');
    var strRemoveFromShapeTranslation = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'RemoveFromShape');

    // Create and add the "add to shape" menu item ...
    objPopupMenu.AddMenuItem(SD.PopupMenu.Shared.CreateMenuItem(strAddToShapeTranslation, strAddToShapeTranslation, fnCallAddLayerFeaturesToShapeMenuItemClicked));

    // Create and add the "remove from shape" menu item ...
    objPopupMenu.AddMenuItem(SD.PopupMenu.Shared.CreateMenuItem(strRemoveFromShapeTranslation, strRemoveFromShapeTranslation, fnCallRemoveLayerFeaturesFromShapeMenuItemClicked));
}

// **************************************************************************
// FUNCTION: RemoveFromSelectionMenuItemClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.RemoveFromSelectionMenuItemClicked = function RemoveFromSelectionMenuItemClicked(objMapLayerGroupBySection) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the displayed data for the map layer group by section ...
    var arrMapLayerGroupBySectionData = objMapSelection.QueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID];

    // Create a new object to hold (MapLayerGroupBySectionID -> Array of data items) key value pairs ...
    var objDataByMapLayer = {};

    // Loop through all the data items ...
    $.each(arrMapLayerGroupBySectionData, function (intMapLayerGroupBySectionDataItem, objMapLayerGroupBySectionDataItem) {

        // Create a new array to hold the items for the map layer when we have none ...
        if (typeof objDataByMapLayer[objMapLayerGroupBySectionDataItem.MapLayerID] == 'undefined') { objDataByMapLayer[objMapLayerGroupBySectionDataItem.MapLayerID] = []; }

        // Add the item to the array ...
        objDataByMapLayer[objMapLayerGroupBySectionDataItem.MapLayerID].push(objMapLayerGroupBySectionDataItem);
    });

    // Create the map service query results array ...
    var arrMapServiceQueryResults = [];

    // Loop through all the map layers for which we have data ...
    $.each(objDataByMapLayer, function (strMapLayerID, arrDataItems) {

        // Create and add map service query results ...
        arrMapServiceQueryResults.push(TrimbleMap.Controller.Shared.CreateMapServiceQueryResult(strMapLayerID, arrDataItems.length, true, arrDataItems));
    });

    // Remove from the selection ...
    objMapSelection.RemoveFromSelection(arrMapServiceQueryResults);
}

// **************************************************************************
// FUNCTION: AddLayerFeaturesToShapeMenuItemClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.AddLayerFeaturesToShapeMenuItemClicked = function AddLayerFeaturesToShapeMenuItemClicked(objMapLayerGroupBySection) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the query result elements for the map layer group by section ...
    var arrMapLayerGroupBySectionData = objMapSelection.QueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID];

    if (arrMapLayerGroupBySectionData.length > 0) {

        //We assume that each feature in a layer will have the same spatial reference. So we can get if from the first one
        var strSpatialReferenceID = objMapSelection.QueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID][0].SpatialReferenceID;

        //get an array with only Geometries from MapLayerGroupBySectionData array
        var arrGeometries = $.map(arrMapLayerGroupBySectionData, function (objDisplayItem) {
            return objDisplayItem.Geometry;
        });


        for (var index = 0; index < arrGeometries.length; index++) {

            if ((arrGeometries[index].type == "polygon" && objMapSelection.ShapeEditor.Shape.GeometryType == "MIXED") || (arrGeometries[index].type.toUpperCase() == objMapSelection.ShapeEditor.Shape.GeometryType.toUpperCase())) {

                // Draw to add the selected geometry ...
                objMapSelection.ShapeEditor.DrawToAddMultiPart(arrGeometries[index], strSpatialReferenceID, true);

            }
            else {

                // Unable to add the selection to the shape        
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'UnableToAddSelection');

                // The geometry type of the selection does not match the geometry type of the shape        
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'GeometryTypeMismatch');

                //Show the dialog
                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
                break;
            }
        }
    }
}

// **************************************************************************
// FUNCTION: RemoveLayerFeaturesFromShapeMenuItemClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.RemoveLayerFeaturesFromShapeMenuItemClicked = function RemoveLayerFeaturesFromShapeMenuItemClicked(objMapLayerGroupBySection) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the query result elements for the map layer group by section ...
    var arrMapLayerGroupBySectionData = objMapSelection.QueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID];

    if (arrMapLayerGroupBySectionData.length > 0) {

        //We assume that each feature in a layer will have the same spatial reference. So we can get if from the first one
        var strSpatialReferenceID = objMapSelection.QueryResultsDisplay.DisplayedData[objMapLayerGroupBySection.MapLayerGroupBySectionID][0].SpatialReferenceID;

        var arrGeometries = $.map(arrMapLayerGroupBySectionData, function (objDisplayItem) {
            return objDisplayItem.Geometry;
        });

        for (var index = 0; index < arrGeometries.length; index++) {
            // Draw to add the selected geometry ...
            objMapSelection.ShapeEditor.DrawToRemoveMultiPart(arrGeometries[index], strSpatialReferenceID);
        }
    }
}


// **************************************************************************
// FUNCTION: AddShapeEditorIcons
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.AddShapeEditorIcons = function AddShapeEditorIcons() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When the shape editor is editable ...
    if (objMapSelection.ShapeEditor.Editable) {

        // Add the draw to add to hovered result icon ...
        objMapSelection.QueryResultsDisplay.AddHoveredResultIcon(objMapSelection.AddToShapeHoveredResultIcon);

        // Add the draw to removed to hovered result icon ...
        objMapSelection.QueryResultsDisplay.AddHoveredResultIcon(objMapSelection.RemoveFromShapeHoveredResultIcon);
    }
}

// **************************************************************************
// FUNCTION: RemoveShapeEditorIcons
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.RemoveShapeEditorIcons = function RemoveShapeEditorIcons() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When the shape editor is editable ...
    if (objMapSelection.ShapeEditor.Editable) {

        // Remove the draw to add to hovered result icon ...
        objMapSelection.QueryResultsDisplay.RemoveHoveredResultIcon(objMapSelection.AddToShapeHoveredResultIcon);

        // Remove the draw to removed to hovered result icon ...
        objMapSelection.QueryResultsDisplay.RemoveHoveredResultIcon(objMapSelection.RemoveFromShapeHoveredResultIcon);
    }
}

// **************************************************************************
// FUNCTION: OnShapeEditorShow
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.OnShapeEditorShow = function OnShapeEditorShow() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Add the shape editor icons ...
    objMapSelection.AddShapeEditorIcons();
}

// **************************************************************************
// FUNCTION: OnShapeEditorHide
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.OnShapeEditorHide = function OnShapeEditorHide() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Remove the shape editor icons ...
    objMapSelection.RemoveShapeEditorIcons();
}

// **************************************************************************
// FUNCTION: ActivateMode
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateMode = function ActivateMode(objModeButton) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Select the selection tab ...
    objMapSelection.Sidebar.SelectTab(objMapSelection.SelectionTabItem);

    // When we have a selection tool ...
    if (objMapSelection.ToolMode != TrimbleMap.Selection.enumToolMode.None) {

        // Select the ToolMode ...
        objMapSelection.SelectTool(objMapSelection.ToolMode);

    } else {

        // Select the SelectByPoint tool ...
        objMapSelection.SelectTool(TrimbleMap.Selection.enumToolMode.SelectByPolygon);
    }

    objMapSelection.UpdateToolModeIcon();
}

// **************************************************************************
// FUNCTION: DeActivateMode
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateMode = function DeActivateMode(objModeButton) {

    // Get the map Selection instance ...
    var objMapSelection = this;

    // Clear the selection tool ...
    objMapSelection.SelectTool(TrimbleMap.Selection.enumToolMode.None);
}

// **************************************************************************
// FUNCTION: ActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateTab = function ActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Add the selection div to the tab container element ...
    objTabContainerElement.append(objMapSelection.SelectionDiv);

    // When not performing selection ...
    if (!objMapSelection.PerformingSelection) {

        // Attach the event handlers ...
        objMapSelection.AttachEventHandlers();
    }

    // Show the query results ...
    objMapSelection.QueryResultsDisplay.Show();
}

// **************************************************************************
// FUNCTION: DeActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateTab = function DeActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Hide the query results ...
    objMapSelection.QueryResultsDisplay.Hide();

    // When not performing selection ...
    if (!objMapSelection.PerformingSelection) {

        // Detach the event handlers ...
        objMapSelection.DetachEventHandlers();
    }

    // Remove the selection div from the tab container element ...
    objMapSelection.SelectionDiv.remove();
}

// **************************************************************************
// FUNCTION: ResizeTab
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ResizeTab = function ResizeTab(objTabContainerElement) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Compute the width and height to set on the query result display ...
    var intHeight = parseInt(objTabContainerElement.innerHeight(), 10) - parseInt(objMapSelection.SelectionToolsDiv.outerHeight(), 10) - 35;

    // Set the height of the container ...
    objMapSelection.QueryResultsDisplayDiv.css('height', intHeight + 'px');

    // Resize the query results display ...
    objMapSelection.QueryResultsDisplay.Resize();
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.AttachEventHandlers = function AttachEventHandlers(objTabContainerElement) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When the event handlers are not attached ...
    if (!objMapSelection.EventHandlersAttached) {

        // Attach the click event handler proxy ...
        objMapSelection.SelectionDiv.on('click',(objMapSelection.SelectionDivClickHandlerProxy));

        // Attach query results display event handlers ...
        objMapSelection.QueryResultsDisplay.AttachEventHandlers();

        // Attach operation popup event handlers ...
        objMapSelection.OperationPopup.AttachEventHandlers();

        // Attach layers event handlers ...
        objMapSelection.LayersPopup.AttachEventHandlers();

        // Attach layers event handlers ...
        objMapSelection.ToolModePopup.AttachEventHandlers();

        // Set to have attached the event handlers ...
        objMapSelection.EventHandlersAttached = true;
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DetachEventHandlers = function DetachEventHandlers(objTabContainerElement) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When the event handlers are attached ...
    if (objMapSelection.EventHandlersAttached) {

        // Detach the click event handler proxy ...
        objMapSelection.SelectionDiv.off('click', objMapSelection.SelectionDivClickHandlerProxy);

        // Detach event handlers ...
        objMapSelection.QueryResultsDisplay.DetachEventHandlers();

        // Detach operation result event handlers ...
        objMapSelection.OperationPopup.DetachEventHandlers();

        // Detach layers event handlers ...
        objMapSelection.LayersPopup.DetachEventHandlers();


        // Set to have detached the event handlers ...
        objMapSelection.EventHandlersAttached = false;
    }
}

// **************************************************************************
// FUNCTION: MapLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.MapLoaded = function MapLoaded(blnReloaded) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When reloaded ...
    if (blnReloaded) {

        // Initialize the active layer IDs ...
        objMapSelection.InitializeActiveLayerIDs();

        // Activate the tool (if we have an active tool) ...
        objMapSelection.ActivateTool();

    } else {

        // Select the geometries passed in to the options ...
        objMapSelection.SelectGeometriesFromOptions();
    }

    // Set user options
    objMapSelection.InitializeUserOptions();
}

// **************************************************************************
// FUNCTION: PreReloaded
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.PreReloaded = function PreReloaded() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // De-activate the tool (if we have an active tool) ...
    objMapSelection.DeActivateTool();

    // Clear the selection ...
    objMapSelection.MapController.ClearSelection();

    // Set to not be performing the selection ...
    objMapSelection.PerformingSelection = false;
}

// **************************************************************************
// FUNCTION: PreferenceChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.PreferenceChanged = function PreferenceChanged(arrPreferencesChanged) {

    // Get the map search instance ...
    var objMapSelection = this;

    // When DisplaySeparateParts preference changed ...
    if ($.inArray(TrimbleMap.Preferences.enumPreference.DisplaySeparateParts, arrPreferencesChanged) > -1) {

        // Clear the selection ...
        objMapSelection.MapController.ClearSelection();

        // Clear the query result data ...
        objMapSelection.QueryResultsDisplay.ClearAllResultData();

        // Hide the spinner if visible ...
        objMapSelection.QueryResultsDisplay.HideSpinner();

        // Revert back to the default cursor ...
        objMapSelection.MapController.SetMapCursor('default');

        // Set to not be performing the selection ...
        objMapSelection.PerformingSelection = false;

        // Clear previous selection results in local storage
        objMapSelection.MapController.UserSettings.ClearSelectionQueries(true);
    }
}

// **************************************************************************
// FUNCTION: SelectionDivClickHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.SelectionDivClickHandler = function SelectionDivClickHandler(e) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the target ...
    var objTarget = $(e.target);

    // Get the SelectionTool element clicked on if any ...
    var objClearSelectionIconButton = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ClearSelectionIcon');
    var objSelectByLocationIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'SelectByLocationIcon');

    // When found ...
    if (objClearSelectionIconButton) {

        // Clear the selection ...
        objMapSelection.MapController.ClearSelection();

        // Clear the query result data ...
        objMapSelection.QueryResultsDisplay.ClearAllResultData();

        // Hide the spinner if visible ...
        objMapSelection.QueryResultsDisplay.HideSpinner();

        // Revert back to the default cursor ...
        objMapSelection.MapController.SetMapCursor('default');

        // Clear previous selection results in local storage
        objMapSelection.MapController.UserSettings.ClearSelectionQueries(false);

    } else if (objSelectByLocationIcon) {

        // Open the select by location popup ...
        objMapSelection.OpenSelectByLocationDialog();
    }
}

// **************************************************************************
// FUNCTION: SelectTool
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.SelectTool = function SelectTool(enSelectionTool) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When not already selected ...
    if (enSelectionTool != objMapSelection.ToolMode) {

        // Remove the selected class from the currently selected tool ...
        $(objMapSelection.SelectionDiv.find('.selected')).removeClass('selected');

        // Get the selection tool button ...
        var objSelectionToolButton = objMapSelection.SelectionDiv.find('[SelectionTool="' + enSelectionTool + '"]')

        // Add the selected class to the icon ...
        objSelectionToolButton.addClass('selected');

        // When we are not performing the selection ...
        if (!objMapSelection.PerformingSelection) {

            // De-Activate the tool ...
            objMapSelection.DeActivateTool();
        }

        // Set the tool mode ...
        objMapSelection.ToolMode = enSelectionTool;

        // Get the mode button by name ...
        var objButtonToActivate = objMapSelection.ModeButtons.GetButtonByName(TrimbleMap.Selection.Shared.MODE_BUTTON_NAME);

        // Activate the button ...
        objMapSelection.ModeButtons.ActivateButton(objButtonToActivate);

        // When we are not performing the selection ...
        if (!objMapSelection.PerformingSelection) {

            // Activate the tool ...
            objMapSelection.ActivateTool();
        }
    }
}

// **************************************************************************
// FUNCTION: ActivateTool
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateTool = function ActivateTool() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Activate the tool based on the ToolMode ...
    switch (objMapSelection.ToolMode) {
        case TrimbleMap.Selection.enumToolMode.None:
            break;

        case TrimbleMap.Selection.enumToolMode.SelectByPoint:
            objMapSelection.ActivateSelectByPoint();
            break;

        case TrimbleMap.Selection.enumToolMode.SelectByPolygon:
            objMapSelection.ActivateSelectByPolygon();
            break;

        case TrimbleMap.Selection.enumToolMode.SelectByPolyline:
            objMapSelection.ActivateSelectByPolyline();
            break;
    }
}

// **************************************************************************
// FUNCTION: DeActivateTool
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateTool = function DeActivateTool() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // De-Activate the tool based on the ToolMode ...
    switch (objMapSelection.ToolMode) {
        case TrimbleMap.Selection.enumToolMode.None:
            break;

        case TrimbleMap.Selection.enumToolMode.SelectByPoint:
            objMapSelection.DeActivateSelectByPoint();
            break;

        case TrimbleMap.Selection.enumToolMode.SelectByPolygon:
            objMapSelection.DeActivateSelectByPolygon();
            break;

        case TrimbleMap.Selection.enumToolMode.SelectByPolyline:
            objMapSelection.DeActivateSelectByPolyline();
            break;
    }
}

// **************************************************************************
// FUNCTION: ActivateSelectByPoint
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateSelectByPoint = function ActivateSelectByPoint() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Attach a click event handler to the map ...
    objMapSelection.ClickHandlerInstance = objMapSelection.MapController.EsriMap.on('click', objMapSelection.MapClickedHandlerProxy);
}

// **************************************************************************
// FUNCTION: DeActivateSelectByPoint
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateSelectByPoint = function DeActivateSelectByPoint() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Detach a click event handler from the map ...
    objMapSelection.ClickHandlerInstance.remove();
}

// **************************************************************************
// FUNCTION: ActivateSelectByPolygon
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateSelectByPolygon = function ActivateSelectByPolygon() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // De-activate the drawing toolbar when active ...
    objMapSelection.DeActivateSelectByPolygon();

    // When the map has been loaded successfully ...
    if (objMapSelection.MapController.EsriMap.loaded) {

        // Create a new drawing toolbar for the map ...
        objMapSelection.DrawingToolbar = new esri.toolbars.Draw(objMapSelection.MapController.EsriMap);

        // Connect to the onDrawEnd event ...
        objMapSelection.EndPolygonDrawingHandle = dojo.connect(objMapSelection.DrawingToolbar, "onDrawEnd", objMapSelection.PolygonDrawEndHandlerProxy);

        // Activate the drawing toolbar ...
        objMapSelection.DrawingToolbar.activate(esri.toolbars.Draw.POLYGON);
    }
}

// **************************************************************************
// FUNCTION: DeActivateSelectByPolygon
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateSelectByPolygon = function DeActivateSelectByPolygon() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When we have a drawing toolbar ...
    if (objMapSelection.DrawingToolbar) {

        // Deactivate it ...
        objMapSelection.DrawingToolbar.deactivate();

        // Set it to be null ...
        objMapSelection.DrawingToolbar = null;

        // Detach the poylgon drawing end event handler ...
        dojo.disconnect(objMapSelection.EndPolygonDrawingHandle);
    }
}


// **************************************************************************
// FUNCTION: ActivateSelectByPolyline
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateSelectByPolyline = function ActivateSelectByPolyline() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // De-activate the drawing toolbar when active ...
    objMapSelection.DeActivateSelectByPolyline();

    // When the map has been loaded successfully ...
    if (objMapSelection.MapController.EsriMap.loaded) {

        // Create a new drawing toolbar for the map ...
        objMapSelection.DrawingToolbar = new esri.toolbars.Draw(objMapSelection.MapController.EsriMap);

        // Connect to the onDrawEnd event ...
        objMapSelection.EndPolylineDrawingHandle = dojo.connect(objMapSelection.DrawingToolbar, "onDrawEnd", objMapSelection.PolylineDrawEndHandlerProxy);

        // Activate the drawing toolbar ...
        objMapSelection.DrawingToolbar.activate(esri.toolbars.Draw.POLYLINE);
    }
}

// **************************************************************************
// FUNCTION: DeActivateSelectByPolygon
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateSelectByPolyline = function DeActivateSelectByPolyline() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When we have a drawing toolbar ...
    if (objMapSelection.DrawingToolbar) {

        // Deactivate it ...
        objMapSelection.DrawingToolbar.deactivate();

        // Set it to be null ...
        objMapSelection.DrawingToolbar = null;

        // Detach the poylgon drawing end event handler ...
        dojo.disconnect(objMapSelection.EndPolylineDrawingHandle);
    }
}

// **************************************************************************
// FUNCTION: ActivateOperationPopup
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateOperationPopup = function ActivateOperationPopup(objPopupContainerDiv) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create the operation popup ...
    objMapSelection.CreateOperationPopup();

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objMapSelection.OperationPopupDiv);

    // Attach a click event handler to the popup div ...
    objMapSelection.OperationPopupDiv.on('click',(objMapSelection.OperationPopupClickedProxy));
}

// **************************************************************************
// FUNCTION: DeActivateOperationPopup
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateOperationPopup = function DeActivateOperationPopup(objPopupContainerDiv) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Detach the click event handler from the popup div ...
    objMapSelection.OperationPopupDiv.off('click', objMapSelection.OperationPopupClickedProxy);
}

// **************************************************************************
// FUNCTION: ActivateToolModePopup
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateToolModePopup = function ActivateToolModePopup(objPopupContainerDiv) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create the operation popup ...
    objMapSelection.CreateToolModePopup();

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objMapSelection.ToolModePopupDiv);

    // Attach a click event handler to the popup div ...
    objMapSelection.ToolModePopupDiv.on('click',(objMapSelection.ToolModePopupClickedProxy));
}

// **************************************************************************
// FUNCTION: DeActivateToolModePopup
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateToolModePopup = function DeActivateToolModePopup(objPopupContainerDiv) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Detach the click event handler from the popup div ...
    objMapSelection.ToolModePopupDiv.off('click', objMapSelection.ToolModePopupClickedProxy);
}

// **************************************************************************
// FUNCTION: ActivateLayersPopup
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ActivateLayersPopup = function ActivateLayersPopup(objPopupContainerDiv) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create the layers popup div ...
    objMapSelection.CreateLayersPopup();

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objMapSelection.LayersPopupDiv);
}

// **************************************************************************
// FUNCTION: DeActivateLayersPopup
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DeActivateLayersPopup = function DeActivateLayersPopup(objPopupContainerDiv) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Detach the click event handler ...
    objMapSelection.LayersPopupDiv.off('click', objMapSelection.LayersPopupClickedProxy);

    // Clear the reference to the layers div (to recreate on next open again) ...
    objMapSelection.LayersPopupDiv = null;
}

// **************************************************************************
// FUNCTION: BufferValueChanged
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.BufferValueChanged = function BufferValueChanged() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the buffer value and buffer unit ...
    objMapSelection.BufferValue = objMapSelection.BufferTextbox.val();
    objMapSelection.BufferUnit = objMapSelection.BufferDropDown.val();
}

// **************************************************************************
// FUNCTION: OpenSelectByLocationDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.OpenSelectByLocationDialog = function OpenSelectByLocationDialog() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create the select by location popup div ...
    objMapSelection.CreateSelectByLocationDialog().then(TrimbleMap.Controller.Shared.TrapException(function () {

        // Attach the click event handler to the popup div ...
        objMapSelection.SelectByLocationDialogDiv.on('click',(objMapSelection.SelectByLocationDialogClickedProxy));

        // Get the buffer value when we have value ...
        if (objMapSelection.BufferValue) { objMapSelection.BufferTextbox.val(objMapSelection.BufferValue); }

        // Select the buffer unit if we have one ...
        if (objMapSelection.BufferUnit) { objMapSelection.BufferDropDown.val(objMapSelection.BufferUnit); }

        // Attach change event handlers to the buffer value and drop downs ...
        objMapSelection.BufferDropDown.change(objMapSelection.BufferValueChangedProxy);
        objMapSelection.BufferTextbox.blur(objMapSelection.BufferValueChangedProxy);

        // Update the layer selection count spans ...
        objMapSelection.UpdateSelectByLocationCountSpans();

        // Get the translations ...

        // Select By Location        
        var strTitleTranslation = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectByLocation');

        // SELECT
        var strSelect = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectionSelect');

        // CANCEL
        var strCancel = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'Cancel');

        // Create the dialog buttons ...
        var arrButtons = [TrimbleMap.MessageBox.Shared.CreateMessageBoxButton(TrimbleMap.Selection.Shared.SELECT_BY_LOCATION_CANCEL_BUTTON, strCancel, function () { objMapSelection.CloseSelectByLocationDialog(); }),
        TrimbleMap.MessageBox.Shared.CreateMessageBoxButton(TrimbleMap.Selection.Shared.SELECT_BY_LOCATION_SELECT_BUTTON, strSelect, function () { objMapSelection.SelectByLocation(); })];

        // Show the dialog ...
        objMapSelection.SelectByLocationDialog = TrimbleMap.MessageBox.Shared.ShowMessage(strTitleTranslation, null, arrButtons, 500, objMapSelection.SelectByLocationDialogDiv, false);

        // When the dialog opened ...
        objMapSelection.SelectByLocationDialog.Deferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Attach the scrollbars ...
            objMapSelection.AttachSelectByLocationScrollbars();
        }));
    }));
}

// **************************************************************************
// FUNCTION: AttachSelectByLocationScrollbars
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.AttachSelectByLocationScrollbars = function AttachSelectByLocationScrollbars() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Activate the nice scroll on the select from and overlap with sections ...
    objMapSelection.SelectFromSectionNiceScroll = objMapSelection.SelectFromSection.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });
    objMapSelection.OverlapWithSectionNiceScroll = objMapSelection.OverlapWithSection.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });
}

// **************************************************************************
// FUNCTION: DetachSelectByLocationScrollbars
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.DetachSelectByLocationScrollbars = function DetachSelectByLocationScrollbars() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Remove the nice scrollbars ...
    objMapSelection.SelectFromSectionNiceScroll.hide();
    objMapSelection.SelectFromSectionNiceScroll.remove();
    objMapSelection.SelectFromSectionNiceScroll = null;
    objMapSelection.OverlapWithSectionNiceScroll.hide();
    objMapSelection.OverlapWithSectionNiceScroll.remove();
    objMapSelection.OverlapWithSectionNiceScroll = null;
}

// **************************************************************************
// FUNCTION: CloseSelectByLocationDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.CloseSelectByLocationDialog = function CloseSelectByLocationDialog(objPopupContainerDiv) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Update the buffer value ...
    objMapSelection.BufferValueChanged();

    // Detach the click event handler ...
    objMapSelection.SelectByLocationDialogDiv.off('click', objMapSelection.SelectByLocationDialogClickedProxy);

    // Detach change event handlers to the buffer value and drop downs ...
    objMapSelection.BufferDropDown.off('change', objMapSelection.BufferValueChangedProxy);
    objMapSelection.BufferTextbox.off('blur', objMapSelection.BufferValueChangedProxy);

    // Detach the scrollbars ...
    objMapSelection.DetachSelectByLocationScrollbars();

    // Close the dialog ...
    objMapSelection.SelectByLocationDialog.Close();

    // Remove the reference to the dialog ...
    objMapSelection.SelectByLocationDialogDiv = null;
}

// **************************************************************************
// FUNCTION: UpdateSelectByLocationCountSpans
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.UpdateSelectByLocationCountSpans = function UpdateSelectByLocationCountSpans() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get all the count spans ...
    var arrCountSpans = objMapSelection.SelectByLocationDialogDiv.find('[CountSpan]');

    // Loop through all the count spans ...
    for (var intCountSpan = 0; intCountSpan < arrCountSpans.length; intCountSpan++) {

        // Get the count span ...
        var objCountSpan = $(arrCountSpans[intCountSpan]);

        // Get the map layer id ...
        var strMapLayerID = objCountSpan.attr("MapLayerID");

        // Get the selected feature count by map layer id ...
        var intSelectionCount = objMapSelection.MapController.GetSelectedFeatureCountByMapLayerID(strMapLayerID);

        // Set the count in the span ...
        objCountSpan.text(intSelectionCount);
    }
}

// **************************************************************************
// FUNCTION: CreateSelectByLocationDialog
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.CreateSelectByLocationDialog = function CreateSelectByLocationDialog() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create a deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Get some translations ...

    // Choose the layers from which you would like to select
    var strSelectFromSection = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'LayersToSelectFrom');

    // Choose the layers containing the selected shapes to use as the location
    var strOverlapsWith = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'LayersContainingSelectedShape'); //SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectionByLocationDescription');

    // Apply a buffer to the selected shapes
    var strBufferSection = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'BufferSelectedShape');
    var strSelect = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'Select');
    var strBuffer = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'Buffer');

    // I want to select shapes from
    var strSelectFromSectionHeading = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectShapesFrom') + ' ...';

    // that overlap with selected shapes in
    var strOverlapsWithSectionHeading = '... ' + SD.Translation.Shared.GetTranslation('Map.Selection.js', 'OverlapWithSelectedShapeTitle') + ' ...';

    // I want to apply a buffer to the selected shapes
    var strApplyBufferSectionHeading = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'OverlapWithSelectedShapeMessage');

    // Create the select by location popup ...
    objMapSelection.SelectByLocationDialogDiv = $('<div class="location-dialog"></div>');

    // *** Select from Selection section ...

    // Create the select from with section heading ...
    var objSelectFromHeading = $('<div class="section-header selected"><span>' + strSelectFromSectionHeading + '</span><span class="heading-count" SelectionCountSpan="true"></span><div class="expand-icon"></div></div>');

    // Get the count span ...
    objMapSelection.SelectFromSelectionCountSpan = $(objSelectFromHeading.find('[SelectionCountSpan]'));

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.SelectByLocationDialogDiv.append(objSelectFromHeading);

    // Create the overlaps with section ...
    objMapSelection.SelectFromSection = $('<div class="section" SelectFromSection="True"></div>');

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.SelectByLocationDialogDiv.append(objMapSelection.SelectFromSection);

    // Add the description ...
    objMapSelection.SelectFromSection.append($('<div class="location-description">' + strSelectFromSection + ':</div>'));

    // Create the select by location layers div ...
    objMapSelection.SelectByLocationTargetLayersDiv = $('<div class="select_by_location_layers_div"></div>');

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.SelectFromSection.append(objMapSelection.SelectByLocationTargetLayersDiv);

    // Create the layer list ...
    var objDeferredCreateTargetLayerList = objMapSelection.CreateLayerList(objMapSelection.SelectByLocationTargetLayersDiv, false, function (strMapLayerID) { return objMapSelection.IsActiveSelectByLocationTargetLayer(strMapLayerID); });

    // *** That overlaps with section ...

    // Create the overlaps with section heading ...
    var objOverlapWithSectionHeading = $('<div class="section-header"><span>' + strOverlapsWithSectionHeading + '</span><span class="heading-count" SelectionCountSpan="true"></span><div class="expand-icon"></div></div>');

    // Get the count span ...
    objMapSelection.OverlapsWithSelectionCountSpan = $(objOverlapWithSectionHeading.find('[SelectionCountSpan]'));

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.SelectByLocationDialogDiv.append(objOverlapWithSectionHeading);

    // Create the overlaps with section ...
    objMapSelection.OverlapWithSection = $('<div class="section" style="display:none" OverlapsWithSection="True"></div>');

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.SelectByLocationDialogDiv.append(objMapSelection.OverlapWithSection);

    // Create the selection tools div ...
    objMapSelection.SelectByLocationMessageDiv = $('<div class="location-description">' + strOverlapsWith + ':</div>');

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.OverlapWithSection.append(objMapSelection.SelectByLocationMessageDiv);

    // Create the select by location layers div ...
    objMapSelection.SelectByLocationSourceLayersDiv = $('<div class="select_by_location_layers_div"></div>');

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.OverlapWithSection.append(objMapSelection.SelectByLocationSourceLayersDiv);

    // Create the layer list ...
    var objDeferredCreateSourceLayerList = objMapSelection.CreateLayerList(objMapSelection.SelectByLocationSourceLayersDiv, true, function (strMapLayerID) { return objMapSelection.IsActiveSelectByLocationSourceLayer(strMapLayerID); });

    // *** Buffer section ...

    // Create the overlaps with section heading ...
    var objBufferSectionHeading = $('<div class="section-header" IsBufferSectionHeading="true"><span>' + strApplyBufferSectionHeading + '</span><div class="expand-icon"></div></div>');

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.SelectByLocationDialogDiv.append(objBufferSectionHeading);

    // Create the buffer section ...
    objMapSelection.BufferSection = $('<div class="section" style="display:none" BufferSection="True"></div>');

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.SelectByLocationDialogDiv.append(objMapSelection.BufferSection);

    // Create a div for the the apply buffer check box ...
    objMapSelection.ApplyBufferCheckboxDiv = $('<div class="apply-buffer" ApplyBuffer="true"></div>');

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.BufferSection.append(objMapSelection.ApplyBufferCheckboxDiv);

    // Choose the css class depending on whether or not the operation should be checked or not ...
    var strCssClass = (objMapSelection.ApplyBuffer) ? 'checked-box' : 'unchecked-box';

    // Create a div for the checkbox ...
    objMapSelection.ApplyBufferCheckBoxDiv = $('<div class="' + strCssClass + '"></div>');

    // Add it to the ApplyBufferCheckboxDiv ...
    objMapSelection.ApplyBufferCheckboxDiv.append(objMapSelection.ApplyBufferCheckBoxDiv);

    // Add the description ...
    objMapSelection.ApplyBufferCheckboxDiv.append($('<span class="location-description">' + strBufferSection + '</span>'));

    // Create the buffer div ...
    objMapSelection.BufferDiv = $('<div class="select-buffer"></div>');

    // Hide the buffer div ...
    if (!objMapSelection.ApplyBuffer) { objMapSelection.BufferDiv.hide(); };

    // Add it to the SelectByLocationDialogDiv ...
    objMapSelection.BufferSection.append(objMapSelection.BufferDiv);

    // Create a span containing the text: 'Buffer:' ...
    objMapSelection.BufferDivSpan = $('<span>' + strBuffer + ':</span>');

    // Add the span to the div ...
    objMapSelection.BufferDiv.append(objMapSelection.BufferDivSpan);

    // Create the buffer text box ...
    objMapSelection.BufferTextbox = $('<input type="text"></input>');

    // Add it to the buffer div ...
    objMapSelection.BufferDiv.append(objMapSelection.BufferTextbox);

    // Create the buffer drop down ...
    objMapSelection.BufferDropDown = $('<select></select>');

    // Add it to the buffer div ...
    objMapSelection.BufferDiv.append(objMapSelection.BufferDropDown);

    // Populate the buffer units drop down ...
    objMapSelection.PopulateBufferUnitsDropDown();

    // Create the buffer validation message ...
    objMapSelection.BufferValidationMessage = $('<div class="validation-message"></div>');

    // Add it to the buffer div ....
    objMapSelection.BufferDiv.append(objMapSelection.BufferValidationMessage);

    // Update the heading count spans ...
    objMapSelection.UpdateSelectByLocationHeadingCountSpans();

    // When both layer lists have been created ...
    new dojo.promise.all([objDeferredCreateSourceLayerList, objDeferredCreateTargetLayerList]).then(TrimbleMap.Controller.Shared.TrapException(function () {

        // Resolve the deferred ...
        objDeferred.resolve();
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: UpdateSelectByLocationHeadingCountSpans
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.UpdateSelectByLocationHeadingCountSpans = function UpdateSelectByLocationHeadingCountSpans() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Start with no visible layers ...
    var intTotalVisibleLayers = 0;

    // Loop through all the selectable map services in the current map ...
    objMapSelection.MapController.ForEachSelectableMapServiceInCurrentMap(function (objMapService, objMapServiceDisplay, arrLayerIDs) {

        // Add the number of visible layers to the total ...
        intTotalVisibleLayers += objMapSelection.MapController.FilterLayerIDsForVisibleLayerIDs(objMapServiceDisplay, arrLayerIDs).length;
    });

    // Start with no visible layers ...
    var intSelectedSourceLayers = 0;

    // Count the number of selected source layers ...
    $.each(objMapSelection.SelectByLocationActiveSourceLayerIDs, function () { intSelectedSourceLayers++; });

    // Start with no visible layers ...
    var intSelectedTargetLayers = 0;

    // Count the number of selected target layers ...
    $.each(objMapSelection.SelectByLocationActiveTargetLayerIDs, function () { intSelectedTargetLayers++; });

    // Set the count spans (translations required) ...

    // of %1 layers   
    objMapSelection.SelectFromSelectionCountSpan.text('(' + intSelectedTargetLayers + ' ' + SD.Translation.Shared.GetTranslation('Map.Selection.js', 'OfLayers', intTotalVisibleLayers) + ')');
    objMapSelection.OverlapsWithSelectionCountSpan.text('(' + intSelectedSourceLayers + ' ' + SD.Translation.Shared.GetTranslation('Map.Selection.js', 'OfLayers', intTotalVisibleLayers) + ')');
}

// **************************************************************************
// FUNCTION: PopulateBufferUnitsDropDown
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.PopulateBufferUnitsDropDown = function PopulateBufferUnitsDropDown() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Loop through all the distance units ...
    for (var intDistanceUnit = 0; intDistanceUnit < objMapSelection.MapController.State.DistanceUnits.length; intDistanceUnit++) {

        // Get the distance unit object ...
        var objDistanceUnit = objMapSelection.MapController.State.DistanceUnits[intDistanceUnit];

        // Create the distance option ...
        var objDistanceOption = $('<option value="' + objDistanceUnit.ID + '">' + objDistanceUnit.Unit + '</option>');

        // Add the distance unit to the drop down ...
        objMapSelection.BufferDropDown.append(objDistanceOption);
    }
}

// **************************************************************************
// FUNCTION: OpenSelectByLocationDialogTab
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.OpenSelectByLocationDialogTab = function OpenSelectByLocationDialogTab(objSectionHeading) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When not busy sliding already ...
    if (!objMapSelection.SelectByLocationTabBusySliding) {

        // Set to be busy sliding ...
        objMapSelection.SelectByLocationTabBusySliding = true;

        // When not visible ...
        if (!objSectionHeading.next().is(':visible')) {

            // Detach the scrollbars ...
            objMapSelection.DetachSelectByLocationScrollbars();

            // Remove the selected class from the currently selected section's heading ...
            $(objMapSelection.SelectByLocationDialogDiv.find('.selected')).removeClass('selected');

            // Add the selected class to the clicked section heading ...
            objSectionHeading.addClass('selected');

            // Slide all the visible sections up ...
            $(objMapSelection.SelectByLocationDialogDiv.find('.section:visible')).slideUp();

            // Slide down the clicked section ...
            objSectionHeading.next().slideDown(function () {

                // Attach the scrollbars ...
                objMapSelection.AttachSelectByLocationScrollbars();

                // Set to be done sliding ...
                objMapSelection.SelectByLocationTabBusySliding = false;
            });
        }
    }
}

// **************************************************************************
// FUNCTION: SelectByLocationDialogClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.SelectByLocationDialogClicked = function SelectByLocationDialogClicked(e) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the element clicked on ...
    var objTarget = $(e.target);

    // Get the select button ...
    var objApplyBufferDiv = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ApplyBuffer');
    var objSectionHeading = SD.DOM.GetElementOrParentWithSelector(objTarget, '.section-header:not(.selected)');
    var objSelectFromSection = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'SelectFromSection');
    var objOverlapsWithSection = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'OverlapsWithSection');

    // When the apply buffer div has been clicked ...
    if (objApplyBufferDiv) {

        // Flip the apply buffer flag ... 
        objMapSelection.ApplyBuffer = !objMapSelection.ApplyBuffer;

        // Remove the checked classes ...
        objMapSelection.ApplyBufferCheckBoxDiv.removeClass('checked-box');
        objMapSelection.ApplyBufferCheckBoxDiv.removeClass('unchecked-box');

        // Choose the css class depending on whether or not the operation should be checked or not ...
        var strCssClass = (objMapSelection.ApplyBuffer) ? 'checked-box' : 'unchecked-box';

        // Add the class to the div ...
        objMapSelection.ApplyBufferCheckBoxDiv.addClass(strCssClass);

        // When the buffer is to be applied ...
        if (objMapSelection.ApplyBuffer) {

            // Show the buffer div ...
            objMapSelection.BufferDiv.show();

        } else {

            // Hide the buffer div ...
            objMapSelection.BufferDiv.hide();
        }

    } else if (objSectionHeading) {

        // Open the tab ...
        objMapSelection.OpenSelectByLocationDialogTab(objSectionHeading);

    } else {

        // When clicked within the select from section ...
        if (objSelectFromSection) {

            // Use the LayerListClicked function to deal with the click ...
            objMapSelection.LayerListClicked(e, function (strMapLayerID) { return objMapSelection.IsActiveSelectByLocationTargetLayer(strMapLayerID); },
                function (strMapLayerID) { return objMapSelection.ActivateSelectByLocationTargetLayer(strMapLayerID); },
                function (strMapLayerID) { return objMapSelection.DeActivateSelectByLocationTargetLayer(strMapLayerID); });

            // Update the heading count spans ...
            objMapSelection.UpdateSelectByLocationHeadingCountSpans();

            // When clicked within the overlaps with section ...
        } else if (objOverlapsWithSection) {

            // Use the LayerListClicked function to deal with the click ...
            objMapSelection.LayerListClicked(e, function (strMapLayerID) { return objMapSelection.IsActiveSelectByLocationSourceLayer(strMapLayerID); },
                function (strMapLayerID) { return objMapSelection.ActivateSelectByLocationSourceLayer(strMapLayerID); },
                function (strMapLayerID) { return objMapSelection.DeActivateSelectByLocationSourceLayer(strMapLayerID); });

            // Update the heading count spans ...
            objMapSelection.UpdateSelectByLocationHeadingCountSpans();
        }
    }
}

// **************************************************************************
// FUNCTION: ShowBufferValidationMessage
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ShowBufferValidationMessage = function ShowBufferValidationMessage(strMessage) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Set the message ...
    objMapSelection.BufferValidationMessage.text(strMessage);

    // Show the validation message ...
    objMapSelection.BufferValidationMessage.show();

    // Get the buffer section heading ...
    var objBufferSectionHeading = $(objMapSelection.SelectByLocationDialogDiv.find('[IsBufferSectionHeading]'));

    // Open the buffer tab ...
    objMapSelection.OpenSelectByLocationDialogTab(objBufferSectionHeading);
}

// **************************************************************************
// FUNCTION: ValidateSelectByLocation
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ValidateSelectByLocation = function ValidateSelectByLocation() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Start with not being valid ...
    var blnValid = true;

    // When a buffer is to be applied ...
    if (objMapSelection.ApplyBuffer) {

        // Get the selected distance unit option tag ...
        var objDistanceUnitOption = $(objMapSelection.BufferDropDown.find('option:selected'));

        // When a unit is selected ...
        if (objDistanceUnitOption.length > 0) {

            // Get the selected distance unit id ...
            objMapSelection.BufferUnit = objDistanceUnitOption.val();

        } else {

            // Set the validation message (Translation required) ...

            // No buffer distance unit selected
            objMapSelection.ShowBufferValidationMessage('* ' + SD.Translation.Shared.GetTranslation('Map.Selection.js', 'NoBufferDistanceUnitSelected'));

            // Set to not continue and perform the selection ...
            blnValid = false;
        }

        // Get the buffer distance ...
        var strBufferDistance = objMapSelection.BufferTextbox.val();

        // Test if the buffer distance entered is a valid number ...
        if (!SD.Number.ValidateIsNumber(strBufferDistance, objMapSelection.MapController.State.GroupSeparator, objMapSelection.MapController.State.DecimalSeparator, false)) {

            // Set the validation message (Translation required) ...

            // Invalid buffer distance. The buffer distance is not a valid number
            objMapSelection.ShowBufferValidationMessage('* ' + SD.Translation.Shared.GetTranslation('Map.Selection.js', 'InvalidBufferDistance'));

            // Set to not continue and perform the selection ...
            blnValid = false;
        }
        else {
            objMapSelection.BufferValue = strBufferDistance;
        }
    }

    return blnValid;
}

// **************************************************************************
// FUNCTION: SelectByLocation
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.SelectByLocation = function SelectByLocation() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Validate the dialog ...
    var blnValid = objMapSelection.ValidateSelectByLocation();

    // When valid ...
    if (blnValid) {

        // Close the dialog ...
        objMapSelection.CloseSelectByLocationDialog();

        // Get the selected geometries ...
        var arrSelectedGeometries = objMapSelection.MapController.GetSelectedGeometries(function (strMapLayerID) { return objMapSelection.IsActiveSelectByLocationSourceLayer(strMapLayerID); });

        // Select the selection tab ...
        objMapSelection.Sidebar.SelectTab(objMapSelection.SelectionTabItem);

        // When we have any selected geometries ...
        if (arrSelectedGeometries.length > 0) {

            // Show the spinner on the query results display ...
            objMapSelection.QueryResultsDisplay.ShowSpinner("Performing Selection");

            // Start with no type ...
            var strGeometryType = null;

            // Start with all types matching ...
            var blnAllGeometryTypesMatches = true;

            // Loop through all the selected geometries ...
            for (var intSelectedGeometry = 0; intSelectedGeometry < arrSelectedGeometries.length; intSelectedGeometry++) {

                // Get the selected geometry ...
                var objSelectedGeometry = arrSelectedGeometries[intSelectedGeometry];

                // When we have a type of at least one of the geometries and 
                // that type differs from the current geometry's type ...
                if ((strGeometryType) && (strGeometryType != objSelectedGeometry.type)) {

                    // Set to not match ...
                    blnAllGeometryTypesMatches = false;

                    // Stop checking ...
                    break;
                }

                // Get the geometry's type ...
                strGeometryType = objSelectedGeometry.type;
            }

            // When all geometry types matches ...
            if (blnAllGeometryTypesMatches) {

                // Unoin all the geometries together ...
                var objUnionedGeometry = esri.geometry.geometryEngine.union(arrSelectedGeometries);

                // When a buffer is to be applied ...
                if (objMapSelection.ApplyBuffer) {

                    // Perform the selection ...
                    objMapSelection.BufferAndPerformSelection(objUnionedGeometry, objMapSelection.BufferValue, objMapSelection.BufferUnit);

                } else {

                    // Perform the selection ...
                    objMapSelection.PerformSelection(objUnionedGeometry, null, true, null, function (strMapLayerID) { return objMapSelection.IsActiveSelectByLocationTargetLayer(strMapLayerID); }, null);
                }

            } else {

                // Notify the user of the problem ...
                TrimbleMap.MessageBox.Shared.ShowMessage('Invalid geometry type combination', 'This operation can only be performed using selected shapes from layers with the same geometry type.');
            }

        } else {

            // Clear the selection ...
            objMapSelection.MapController.ClearSelection();

            // Clear the query result data ...
            objMapSelection.QueryResultsDisplay.ClearAllResultData();

            objMapSelection.MapController.UserSettings.ClearSelectionQueries(false);
        }
    }
}

// **************************************************************************
// FUNCTION: CreateOperationPopup
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.CreateToolModePopup = function CreateToolModePopup() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create the operation popup div ...
    objMapSelection.ToolModePopupDiv = $('<div class="selection-popup"></div>');

    // Get the translations ...
    var objOptionsTranslations = {
        SelectByPoint: SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectByPointToolTip'),
        SelectByPolyline: SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectByPolylineToolTip'),
        SelectByPolygon: SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectByPolygonToolTip')
    };

    // Loop through all the operations to popuplate ...
    $.each(objOptionsTranslations, function (enSelectionToolMode, strOptionsTranslation) {

        // Create a div for the operation item ...
        var objToolModeItemDiv = $('<div class="popup-item" selectiontool="' + enSelectionToolMode + '"></div>');

        // Choose the css class depending on whether or not the tool mode should be checkec or not ...
        var strCssClass = (enSelectionToolMode == objMapSelection.ToolMode) ? 'checked' : 'unchecked';

        // Create a div for the checkbox ...
        var objCheckBoxDiv = $('<div class="' + strCssClass + '"></div>');

        // Create a div for the icon ...
        var objIconDiv = $('<div class="select_operation_drop_down_icon ' + TrimbleMap.Selection.Shared.ToolModeIconCssClass(enSelectionToolMode) + '"></div>');

        // Create a div for the item text ...
        var objItemTextDiv = $('<span>' + strOptionsTranslation + '</span>');

        // Add the checkbox, icon and item text ...
        objToolModeItemDiv.append(objIconDiv);
        objToolModeItemDiv.append(objItemTextDiv);
        objToolModeItemDiv.append(objCheckBoxDiv);

        // Add the item div to the toolmode popup div ...
        objMapSelection.ToolModePopupDiv.append(objToolModeItemDiv);
    });

    // Attach a click event handler to the popup div ...
    objMapSelection.ToolModePopupDiv.on('click',(objMapSelection.ToolModePopupClickedProxy));
}

// **************************************************************************
// FUNCTION: CreateOperationPopup
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.CreateOperationPopup = function CreateOperationPopup() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create the operation popup div ...
    objMapSelection.OperationPopupDiv = $('<div class="selection-popup"></div>');

    // Get the translations ...
    var objOptionsTranslations = {
        SelectFeatures: SD.Translation.Shared.GetTranslation('Map.Selection.js', 'SelectFeatures'),
        AddFeatures: SD.Translation.Shared.GetTranslation('Map.Selection.js', 'AddFeatures'),
        RemoveFeatures: SD.Translation.Shared.GetTranslation('Map.Selection.js', 'RemoveFeatures'),
        FilterCurrentSelection: SD.Translation.Shared.GetTranslation('Map.Selection.js', 'FilterCurrentSelection')
    };

    // Loop through all the operations to popuplate ...
    $.each(objOptionsTranslations, function (enOperation, strOptionsTranslation) {

        // Create a div for the operation item ...
        var objOperationItemDiv = $('<div class="popup-item" SelectionOperation="' + enOperation + '"></div>');

        // Choose the css class depending on whether or not the operation should be checkec or not ...
        var strCssClass = (enOperation == objMapSelection.Operation) ? 'checked' : 'unchecked';

        // Create a div for the checkbox ...
        var objCheckBoxDiv = $('<div class="' + strCssClass + '"></div>');

        // Create a div for the icon ...
        var objIconDiv = $('<div class="' + TrimbleMap.Selection.Shared.OperationIconCssClass(enOperation) + '"></div>');

        // Create a div for the item text ...
        var objItemTextDiv = $('<span>' + strOptionsTranslation + '</span>');

        // Add the checkbox, icon and item text ...
        objOperationItemDiv.append(objIconDiv);
        objOperationItemDiv.append(objItemTextDiv);
        objOperationItemDiv.append(objCheckBoxDiv);

        // Add the item div to the operation popup div ...
        objMapSelection.OperationPopupDiv.append(objOperationItemDiv);
    });

    // Attach a click event handler to the popup div ...
    objMapSelection.OperationPopupDiv.on('click',(objMapSelection.OperationPopupClickedProxy));
}

// **************************************************************************
// FUNCTION: OperationPopupClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.OperationPopupClicked = function OperationPopupClicked(e) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the element clicked on ...
    var objTarget = $(e.target);

    // Find the element or parent element with the operation attribute
    objTarget = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'SelectionOperation');

    // When found ...
    if (objTarget) {

        // Get the operation ...
        var enOperation = objTarget.attr('SelectionOperation');

        // Set the operation ...
        objMapSelection.Operation = enOperation;

        // Update the operation icon ...
        objMapSelection.UpdateOperationIcon();

        // Close the popup ...
        objMapSelection.OperationPopup.ClosePopup();

        // Detach the click event handler ...
        objMapSelection.OperationPopupDiv.off('click', objMapSelection.OperationPopupClickedProxy);
    }
}

// **************************************************************************
// FUNCTION: CreateLayersPopup
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.CreateLayersPopup = function CreateLayersPopup() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create the operation popup div ...
    objMapSelection.LayersPopupDiv = $('<div class="selection-popup"></div>');

    // Create the layer list ...
    objMapSelection.CreateLayerList(objMapSelection.LayersPopupDiv, false, function (strMapLayerID) { return objMapSelection.IsActiveLayer(strMapLayerID); });

    // Attach a click event handler to the popup div ...
    objMapSelection.LayersPopupDiv.on('click',(objMapSelection.LayersPopupClickedProxy));
}

// **************************************************************************
// FUNCTION: CreateLayerList
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.CreateLayerList = function CreateLayerList(objContainerDiv, blnCreateCountDivs, fnIsActiveLayer) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Create a deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Get the legend data for the current map ...
    objMapSelection.MapController.GetLegendDataForCurrentMap(function (arrLegendData) {

        // Create an object to use as a lookup ...
        var objLegendDataByMapServiceID = {};

        // Add the legend data to the lookup ...
        $.each(arrLegendData, function (intLegendData, objLegendData) {
            if (objLegendData && objLegendData.DataItems && objLegendData.DataItems.length > 0 && objMapSelection.MapController.FailedMapComponents.indexOf(objLegendData.MapServiceDisplay.MapServiceDisplayID) == -1) {
                objLegendDataByMapServiceID[objLegendData.MapService.MapServiceID] = objLegendData;
            }
        });

        // Start with 0 layers added ...
        var intLayersAdded = 0;

        // Loop through all the selectable map services in the current map ...
        objMapSelection.MapController.ForEachSelectableMapServiceInCurrentMap(function (objMapService, objMapServiceDisplay, arrLayerIDs) {

            // Get the legend data for the map service ...
            var objLegendData = objLegendDataByMapServiceID[objMapService.MapServiceID];

            // When we have legend data for the map service ...
            if ((typeof objLegendData != 'undefined') && (objLegendData != null) && objLegendData.Loaded) {

                // Create a new array for the ordered layer ids ...
                var arrOrderedLayerIDs = [];

                // Loop through all the data items ...
                $.each(objLegendData.DataItems, function (intDataItem, objDataItem) {

                    // Get the map layer by name ...
                    var objMapLayer = objMapSelection.MapController.GetMapLayerByName(objMapService.MapServiceID, objDataItem.Name);
                    let arrVisibleLayerIDs = objMapSelection.MapController.State.VisibleLayerIDsByMapServiceDisplayID[objMapServiceDisplay.MapServiceDisplayID];

                    // When selectable ...
                    if ($.inArray(objDataItem.LayerID, arrVisibleLayerIDs) > -1 && $.inArray(objMapLayer.MapLayerID, arrLayerIDs) > -1 && objMapSelection.MapController.GetMapServiceDisplayVisibility(objMapServiceDisplay)) { arrOrderedLayerIDs.push(objMapLayer.MapLayerID); }

                    if (!objMapSelection.MapController.GetLayerVisibility(objMapServiceDisplay, objDataItem.LayerID, false)) {
                        if (objMapSelection.ActiveLayerIDs[objMapLayer.MapLayerID]) {
                            delete objMapSelection.ActiveLayerIDs[objMapLayer.MapLayerID];
                        }

                        if (objMapSelection.SelectByLocationActiveTargetLayerIDs[objMapLayer.MapLayerID]) {
                            delete objMapSelection.SelectByLocationActiveTargetLayerIDs[objMapLayer.MapLayerID];
                        }

                        if (objMapSelection.SelectByLocationActiveSourceLayerIDs[objMapLayer.MapLayerID]) {
                            delete objMapSelection.SelectByLocationActiveSourceLayerIDs[objMapLayer.MapLayerID];
                        }
                    }

                    // When we have sub items ...
                    if ((typeof objDataItem.SubItems != 'undefined') && (objDataItem.SubItems != null)) {

                        // Loop through all the sub items ...
                        $.each(objDataItem.SubItems, function (intSubItem, objSubItem) {

                            // When we have a layer id (when not just categorized and not actual layers) ...
                            if ((typeof objSubItem.LayerID != 'undefined') && (objSubItem.LayerID != null)) {

                                // Get the map layer by name ...
                                var objMapLayer = objMapSelection.MapController.GetMapLayerByName(objMapService.MapServiceID, objSubItem.Name);

                                // When selectable ...
                                if ($.inArray(objMapLayer.MapLayerID, arrLayerIDs) > -1) { arrOrderedLayerIDs.push(objMapLayer.MapLayerID); }

                                if (!objMapSelection.MapController.GetLayerVisibility(objMapServiceDisplay, objDataItem.LayerID, false)) {
                                    if (objMapSelection.ActiveLayerIDs[objMapLayer.MapLayerID]) {
                                        delete objMapSelection.ActiveLayerIDs[objMapLayer.MapLayerID];
                                    }

                                    if (objMapSelection.SelectByLocationActiveTargetLayerIDs[objMapLayer.MapLayerID]) {
                                        delete objMapSelection.SelectByLocationActiveTargetLayerIDs[objMapLayer.MapLayerID];
                                    }

                                    if (objMapSelection.SelectByLocationActiveSourceLayerIDs[objMapLayer.MapLayerID]) {
                                        delete objMapSelection.SelectByLocationActiveSourceLayerIDs[objMapLayer.MapLayerID];
                                    }
                                }
                            }
                        });
                    }
                });

                if (arrOrderedLayerIDs.length > 0) {
                    // Add the map service name to the popup div ...
                    objContainerDiv.append('<span class="mapservice-name">' + objMapService.MapServiceName + '</span>');
                }

                // Loop through all the selectable layers ...
                for (var intLayer = 0; intLayer < arrOrderedLayerIDs.length; intLayer++) {

                    // Get the map layer id ...
                    var strMapLayerID = arrOrderedLayerIDs[intLayer];

                    // Get the map layer id ...
                    var objMapLayer = objMapSelection.MapController.GetMapLayer(strMapLayerID);

                    // Get the esri layer ID for the map layer ID ...
                    var strEsriLayerID = objMapSelection.MapController.GetEsriLayerIDForMapLayerID(strMapLayerID);

                    // Determine the css class to indicate layer visibility ...
                    var strCssClassVisible = (objMapSelection.MapController.GetLayerVisibility(objMapServiceDisplay, strEsriLayerID, false)) ? '' : ' selection_drop_down_item_div_invisible';

                    // Create a div for the operation item ...
                    var objLayerItemDiv = $('<div class="popup-item ' + strCssClassVisible + '" MapLayerID="' + strMapLayerID + '" style="margin-inline-start:0px" LayerItemDiv="true"></div>');

                    // Choose the css class depending on whether or not the operation should be checked or not ...
                    var strCssClass = (fnIsActiveLayer(strMapLayerID)) ? 'checked-box' : 'unchecked-box';

                    // Create a div for the checkbox ...
                    var objCheckBoxDiv = $('<div class="' + strCssClass + '"></div>');

                    // Create a div for the item text ...
                    var objItemTextDiv = $('<span>' + objMapLayer.MapLayerName + '</span>');

                    // Add the checkbox and item text ...
                    objLayerItemDiv.append(objCheckBoxDiv);
                    objLayerItemDiv.append(objItemTextDiv);

                    // When we are to create count divs ...
                    if (blnCreateCountDivs) {

                        // Create a count div ...
                        var objCountDiv = $('<div class="selection_count_div" CountDiv="True" MapLayerID="' + strMapLayerID + '"></div>');

                        // Add the open bracket ...
                        objCountDiv.append('&nbsp;<span>(</span>');

                        // Create the count span ...
                        var objCountSpan = $('<span CountSpan="True" MapLayerID="' + strMapLayerID + '"></span>');

                        // Add it to the count div ...
                        objCountDiv.append(objCountSpan);

                        // Add the close bracket ...
                        objCountDiv.append('<span>)</span>');

                        // Add it to the item div ...
                        objLayerItemDiv.append(objCountDiv);
                    }

                    // Add the item div to the operation popup div ...
                    objContainerDiv.append(objLayerItemDiv);

                    // Increment the number of layers added ...
                    intLayersAdded++;
                }
            }
        });

        // When no layers have been added ...
        if (intLayersAdded == 0) {

            // Add an empty div ...
            objContainerDiv.append('<span class="no-layers">No selectable layers</span>');
        }

        // Resolve the deferred ...
        objDeferred.resolve();
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: LayersPopupClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.LayersPopupClicked = function LayersPopupClicked(e) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Use the LayerListClicked function to deal with the click ...
    objMapSelection.LayerListClicked(e, function (strMapLayerID) { return objMapSelection.IsActiveLayer(strMapLayerID); },
        function (strMapLayerID) { return objMapSelection.ActivateLayer(strMapLayerID); },
        function (strMapLayerID) { return objMapSelection.DeActivateLayer(strMapLayerID); });
}

// **************************************************************************
// FUNCTION: LayerListClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.LayerListClicked = function LayerListClicked(e, fnIsActiveLayer, fnActivateLayer, fnDeActivateLayer) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the element clicked on ...
    var objTarget = $(e.target);

    // Find the element or parent element with the operation attribute
    objTarget = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'LayerItemDiv');

    // When found ...
    if (objTarget) {

        // When the layer is not invisible ...
        if (!objTarget.hasClass('popup-item-invisible')) {

            // Get the MapLayerID ...
            var strMapLayerID = objTarget.attr('MapLayerID');

            // When the layer is currently active ...
            if (fnIsActiveLayer(strMapLayerID)) {

                // De-Activate the layer ...
                fnDeActivateLayer(strMapLayerID);

                // Remove the checked class and add the unchecked class ...
                $(objTarget.find('.checked-box')).removeClass('checked-box').addClass('unchecked-box');

            } else {

                // De-Activate the layer ...
                fnActivateLayer(strMapLayerID);

                // Remove the checked class and add the unchecked class ...
                $(objTarget.find('.unchecked-box')).removeClass('unchecked-box').addClass('checked-box');
            }
        }
    }
}

// **************************************************************************
// FUNCTION: ToolModePopupClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.ToolModePopupClicked = function ToolModePopupClicked(e) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the element clicked on ...
    var objTarget = $(e.target);

    //prevent normal flow of the click event
    e.stopPropagation();
    e.preventDefault();

    // Find the element or parent element with the operation attribute
    objTarget = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'selectiontool');

    // When found ...
    if (objTarget) {

        // Get the operation ...
        var enSelectionToolMode = objTarget.attr('selectiontool');

        // Select the tool ...
        objMapSelection.SelectTool(enSelectionToolMode);

        // Update the operation icon ...
        objMapSelection.UpdateToolModeIcon();

        // Close the popup ...
        objMapSelection.ToolModePopup.ClosePopup();

        // Detach the click event handler ...
        objMapSelection.ToolModePopupDiv.off('click', objMapSelection.ToolModePopupClickedProxy);
    }
}

// **************************************************************************
// FUNCTION: MapClickedHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.MapClickedHandler = function MapClickedHandler(e) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // When the map has been loaded successfully ...
    if (objMapSelection.MapController.EsriMap.loaded) {

        // Get html element in which the map live's offset relative to the page ...
        var objMapElementOffset = objMapSelection.MapController.MapElement.offset();

        // Build a screen point ...
        var objScreenPoint = new esri.geometry.ScreenPoint(e.pageX - objMapElementOffset.left, e.pageY - objMapElementOffset.top);

        // Convert to map units ...
        var objMapPoint = objMapSelection.MapController.EsriMap.toMap(objScreenPoint);


        // Create a point to the right of the point that are Map.Selection.Shared.TOLERANCE_IN_PIXELS away ...    
        var objToleranceScreenPoint = new esri.geometry.ScreenPoint(objScreenPoint.x + TrimbleMap.Selection.Shared.TOLERANCE_IN_PIXELS, objScreenPoint.y);

        // Convert the tolerance point to map units ... 
        var objToleranceMapPoint = objMapSelection.MapController.EsriMap.toMap(objToleranceScreenPoint);

        // Compute the tolerance distance in map units ...
        var intToleranceInMapUnits = Math.abs(objMapPoint.x - objToleranceMapPoint.x);

        // Create an extent that have intToleranceInMapUnits width and height centered on the clicked point ...
        var objSelectionGeometry = new esri.geometry.Extent(objMapPoint.x - intToleranceInMapUnits,
            objMapPoint.y + intToleranceInMapUnits,
            objMapPoint.x + intToleranceInMapUnits,
            objMapPoint.y - intToleranceInMapUnits,
            objMapSelection.MapController.EsriMap.spatialReference);


        // Perform the selection ...
        objMapSelection.PerformSelection(objSelectionGeometry, null, true, null, null, null);
    }
}

// **************************************************************************
// FUNCTION: IsValidPolygonForPolygonSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.IsValidPolygonForPolygonSelection = function IsValidPolygonForPolygonSelection(objGeometry) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Start with not being valid ...
    var blnValid = false;

    // When it's a polygon with a ring ...
    if ((objGeometry.type == 'polygon') && (objGeometry.rings.length > 0)) {

        // Get the ring ...
        var arrRing = objGeometry.rings[0];

        // Only perform the check when we have at least 2 coordinates ...
        if (arrRing.length >= 2) {

            // Get the first and last coordinate ...
            var objFirstCoordinate = arrRing[0];
            var objLastCoordinate = arrRing[arrRing.length - 1];

            // When the first and last coordinates matches ...
            var blnFirstAndLastEqual = (objFirstCoordinate[0] == objLastCoordinate[0]) && (objFirstCoordinate[1] == objLastCoordinate[1]);

            // We need at least 4 coordinates when the first and last are the same, otherwise 3 ...
            var intMinCoords = (blnFirstAndLastEqual) ? 4 : 3;

            // Determine whether or not we have the minimum number of coordinates ...
            blnValid = (arrRing.length >= intMinCoords);
        }
    }

    return blnValid;
}

// **************************************************************************
// FUNCTION: PolygonDrawEndHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.PolygonDrawEndHandler = function PolygonDrawEndHandler(objGeometry) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // WHen the geometry is valid for polygon selection (have at least 3 distinct coordinates) ...
    if (objMapSelection.IsValidPolygonForPolygonSelection(objGeometry)) {

        // Perform the selection ...
        objMapSelection.PerformSelection(objGeometry, null, true);

    } else {

        // Unable to perform selection
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'UnableToPerformSelectionTitle');

        // Draw a polygon with at least 3 coordinates.
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'UnableToPerformSelectionMessage');

        // Show the message ...
        TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
    }
}

// **************************************************************************
// FUNCTION: PolygonDrawEndHandler
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.PolylineDrawEndHandler = function PolylineDrawEndHandler(objGeometry) {

    // Get the map selection instance ...
    var objMapSelection = this;

    objMapSelection.PerformSelection(objGeometry, null, true);
}

// **************************************************************************
// FUNCTION: BufferAndPerformSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.BufferAndPerformSelection = function BufferAndPerformSelection(objGeometry, decBufferDistance, strDistanceUnitID) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the distance unit by id ...
    var objDistanceUnit = objMapSelection.MapController.GetDistanceUnit(strDistanceUnitID);

    // Convert the buffer distance to kilometer ...
    var decBufferDistanceKM = decBufferDistance * objDistanceUnit.ConversionFactorToKm;

    // Configure the buffer parameters ...
    var objBufferParameters = new esri.tasks.BufferParameters();

    // Set the geometries to be buffered ...
    objBufferParameters.geometries = [objGeometry];

    // Set the buffer distances ...
    objBufferParameters.distances = [decBufferDistanceKM];

    // Set the unit to kilometers ...
    objBufferParameters.unit = esri.tasks.GeometryService.UNIT_KILOMETER;

    // Set the units not to be in geodesic coordinates ...
    objBufferParameters.geodesic = false;

    // Set the out and buffer spatial references to be the spatial reference of the input geometry ...
    objBufferParameters.outSpatialReference = objGeometry.spatialReference;

    // Get the spatial reference of the current map ...
    var objSpatialReferenceInformation = objMapSelection.MapController.GetSpatialReference(objMapSelection.MapController.CurrentMap.SpatialReferenceID);

    // Get the well know text of the utm zone in which the first coordinate falls ...
    var strProjectedBufferWKT = (objSpatialReferenceInformation.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) ? objSpatialReferenceInformation.WKTDefinition : TrimbleMap.UTM.GetUTMCoordinateSystem(objGeometry).wkt;

    // Set the utm zone to be the spatial reference in which to perform the buffer operation ...
    objBufferParameters.bufferSpatialReference = new esri.SpatialReference(strProjectedBufferWKT);

    // Union the geometries ...
    objMapSelection.MapController.GeometryService.buffer(objBufferParameters, function (arrBufferedGeometries) {

        // Perform the selection with the buffered geometry ...
        objMapSelection.PerformSelection(arrBufferedGeometries[0], null, true, null, function (strMapLayerID) { return objMapSelection.IsActiveSelectByLocationTargetLayer(strMapLayerID); }, null);

    }, function (objError) {
        alert('Error buffering');
    });
}

// **************************************************************************
// FUNCTION: PerformSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.PerformSelection = function PerformSelection(objGeometry, fnWhereClauseForMapLayer, blnOnlyOnVisibleSelectableMapServices, fnSelectOnMapLayer, fnIsActiveLayer, enOperationOverride, blnDoNotCacheSelection) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Set performing selection to true ...
    objMapSelection.PerformingSelection = true;

    // Create a deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the tab is active ...
    if (objMapSelection.SelectionTabItem == objMapSelection.Sidebar.CurrentTab) {

        // Detach the event handlers ...
        objMapSelection.DetachEventHandlers();
    }

    // When the selection mode button is the active mode button ...
    if (objMapSelection.ModeButtons.ActiveButton == objMapSelection.SelectionModeButton) {

        // De-Activate the tool ...
        objMapSelection.DeActivateTool();
    }

    // Set the wait cursor on the map ...
    objMapSelection.MapController.SetMapCursor('wait');

    // Show the spinner on the query results display ...
    objMapSelection.QueryResultsDisplay.ShowSpinner("Performing Selection");

    // Select the selection tab ...
    objMapSelection.Sidebar.SelectTab(objMapSelection.SelectionTabItem);

    // Deterimine the operation to use (override when specified) ...
    var enOperation = ((typeof enOperationOverride == 'undefined') || (enOperationOverride == null)) ? objMapSelection.Operation : enOperationOverride;

    // Determine the selection mod ebased on the operation ... 
    var enSelectionMode = TrimbleMap.Selection.Shared.SelectionMethodForOperation(enOperation);

    // Declare a variable for the for each map service function ... 
    var fnForEachMapService;

    // When we are only to perform selection on visible selectable map services ...
    if (blnOnlyOnVisibleSelectableMapServices) {

        // Use fnIsActiveLayer when set otherwise use objMapSelection.ActiveLayerIDs ...
        if ((typeof fnIsActiveLayer == 'undefined') || (fnIsActiveLayer == null)) { fnIsActiveLayer = function (strMapLayerID) { return objMapSelection.IsActiveLayer(strMapLayerID); } }

        // Set fnSelectOnMapLayer to a function that will select on the selectable layers that are active ...
        fnSelectOnMapLayer = function (objMapLayer, objMapServiceDisplay) {

            // Get the esri layer ID for the map layer ID ...
            var strEsriLayerID = objMapSelection.MapController.GetEsriLayerIDForMapLayerID(objMapLayer.MapLayerID);

            // Only perform the selection on active selectable layers ...
            return objMapLayer.Selectable &&
                fnIsActiveLayer(objMapLayer.MapLayerID) &&
                (objMapSelection.MapController.GetLayerVisibility(objMapServiceDisplay, strEsriLayerID, false));
        }

        // Create a function that will call fnForMapService for 
        // each visible selectable map service in the current map ...
        fnForEachMapService = function (fnForMapService) { objMapSelection.MapController.ForEachVisibleSelectableMapServiceInCurrentMap(fnForMapService); }

    } else {

        // Create a function that will call fnForMapService for 
        // all the map services in the current map ...
        fnForEachMapService = function (fnForMapService) {

            // Loop through all the map service displays in the current map ...
            objMapSelection.MapController.ForEachMapServiceDisplayInCurrentMap(function (objMapServiceDisplay, objMapService) {

                // Call the fucntion to call for each map service ...
                fnForMapService(objMapService, objMapServiceDisplay);
            });
        }
    }

    // Add it to the selection in the map ...
    var objSelectInMapDeferred = objMapSelection.MapController.SelectInMap(objGeometry, fnWhereClauseForMapLayer, enSelectionMode, fnForEachMapService, fnSelectOnMapLayer, true, null, blnDoNotCacheSelection);

    // Get the current map index for which the selection will be performed ...
    var intMapIndexForCurrentSelection = objMapSelection.MapController.State.CurrentMapIndex;

    // When SelectInMap completes ...
    objSelectInMapDeferred.promise.then(TrimbleMap.Controller.Shared.TrapException(function (arrMapServiceQueryResults) {

        // When the map for which the selection has been performed are still the active map ...
        if (intMapIndexForCurrentSelection == objMapSelection.MapController.State.CurrentMapIndex) {

            // Create a new hash table for the query results display data ...
            var dicQueryResultsDisplayData = {};

            // Loop through all the query results ...
            $.each(arrMapServiceQueryResults, function (intMapServiceQueryResult, objMapServiceQueryResult) {

                // Get the queried map layer for the query result ...
                var objQueriedMapLayer = objMapSelection.MapController.GetMapLayer(objMapServiceQueryResult.MapLayerID);

                // Loop through all the map layer query results ...
                $.each(objMapServiceQueryResult.Data, function (intMapLayerQueryResult, objMapLayerQueryResult) {

                    // If we do not have any results for the map layer yet ...
                    if (typeof dicQueryResultsDisplayData[objMapServiceQueryResult.MapLayerID] == 'undefined') {

                        // Create a new query results display data and add it to the dictionary ...
                        dicQueryResultsDisplayData[objMapServiceQueryResult.MapLayerID] = TrimbleMap.QueryResultsDisplay.Shared.CreateQueryResultsDisplayData([], objMapServiceQueryResult.MapLayerID, 0);
                    }

                    // Get the query results display data ...
                    var objQueryResultsDisplayData = dicQueryResultsDisplayData[objMapServiceQueryResult.MapLayerID];

                    // Add the attributes to the data array ...
                    objQueryResultsDisplayData.Data.push(objMapLayerQueryResult);
                });
            });

            // Create a new array for the query results display data ...
            var arrQueryResultsDisplayData = [];

            // Loop through all the query results display datas ...
            $.each(dicQueryResultsDisplayData, function (strMapLayerID, objQueryResultsDisplayData) {

                // Add it to the array ...
                arrQueryResultsDisplayData.push(objQueryResultsDisplayData);
            });

            // Depending on the current operation ...
            switch (enOperation) {
                case TrimbleMap.Selection.enumOperation.SelectFeatures:

                    // Load the data into the query results display (clear exiting data) ...
                    objMapSelection.QueryResultsDisplay.LoadData(arrQueryResultsDisplayData, true);
                    break;

                case TrimbleMap.Selection.enumOperation.AddFeatures:

                    // Load the data into the query results display (do not clear exiting data) ...
                    objMapSelection.QueryResultsDisplay.LoadData(arrQueryResultsDisplayData, false);
                    break;

                case TrimbleMap.Selection.enumOperation.RemoveFeatures:

                    // Remove the data drom the query results display ...
                    objMapSelection.QueryResultsDisplay.FilterData(arrQueryResultsDisplayData, TrimbleMap.enumFilterDataMethod.RemoveInputData);
                    break;

                case TrimbleMap.Selection.enumOperation.FilterCurrentSelection:

                    // Filter the data drom the query results display ...
                    objMapSelection.QueryResultsDisplay.FilterData(arrQueryResultsDisplayData, TrimbleMap.enumFilterDataMethod.OnlyKeepInputData);
                    break;
            }

            // Hide the spinner on the query results display ...
            objMapSelection.QueryResultsDisplay.HideSpinner();

            // Revert back to the default cursor ...
            objMapSelection.MapController.SetMapCursor('default');

            // Set to not perform the selection ...
            objMapSelection.PerformingSelection = false;

            // When the tab is active ...
            if (objMapSelection.SelectionTabItem == objMapSelection.Sidebar.CurrentTab) {

                // Attach the event handlers ...
                objMapSelection.AttachEventHandlers();
            }

            // When the selection mode button is the active mode button ...
            if (objMapSelection.ModeButtons.ActiveButton == objMapSelection.SelectionModeButton) {

                // Activate the tool ...
                objMapSelection.ActivateTool();
            }

            // Resolve the deferred ...
            objDeferred.resolve();
        }
        else {

            // Reject the deferred ...
            objDeferred.reject();
        }
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: PerformPreviousSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.PerformPreviousSelection = function PerformPreviousSelection() {

    // Get the map selection instance ...
    let objMapSelection = this;

    // Set performing selection to true ...
    objMapSelection.PerformingSelection = true;

    // Create a deferred to return ...
    let objDeferred = new dojo.Deferred();

    // When the tab is active ...
    if (objMapSelection.SelectionTabItem == objMapSelection.Sidebar.CurrentTab) {

        // Detach the event handlers ...
        objMapSelection.DetachEventHandlers();
    }

    // When the selection mode button is the active mode button ...
    if (objMapSelection.ModeButtons.ActiveButton == objMapSelection.SelectionModeButton) {

        // De-Activate the tool ...
        objMapSelection.DeActivateTool();
    }

    // Set the wait cursor on the map ...
    objMapSelection.MapController.SetMapCursor('wait');

    // Show the spinner on the query results display ...
    objMapSelection.QueryResultsDisplay.ShowSpinner("Performing Selection");

    // Select the selection tab ...
    objMapSelection.Sidebar.SelectTab(objMapSelection.SelectionTabItem);

    // Perform selection from previous queries ...
    let objSelectInMapDeferred = objMapSelection.MapController.SelectInMapFromPreviousQueries();

    let intMapIndexForCurrentSelection = objMapSelection.MapController.State.CurrentMapIndex;

    objSelectInMapDeferred.promise.then(TrimbleMap.Controller.Shared.TrapException(function (arrOrderedSelectInMapResults) {

        // When the map for which the selection has been performed is still the active map ...
        if (intMapIndexForCurrentSelection == objMapSelection.MapController.State.CurrentMapIndex) {

            // Process the results according to each results object's SelectionOperation property
            for (let intSelectInMapResult = 0; intSelectInMapResult < arrOrderedSelectInMapResults.length; intSelectInMapResult++) {

                let objSelectInMapResults = arrOrderedSelectInMapResults[intSelectInMapResult];

                if (objSelectInMapResults) {

                    let enSelectionOperation = TrimbleMap.Selection.Shared.OperationForSelectionMethod(objSelectInMapResults.SelectionMethod);

                    // Create a new hash table for the query results display data ...
                    let dicQueryResultsDisplayData = {};

                    // Loop through all the query results ...
                    $.each(objSelectInMapResults.Results, function (intMapServiceQueryResult, objMapServiceQueryResult) {

                        // Get the queried map layer for the query result ...
                        let objQueriedMapLayer = objMapSelection.MapController.GetMapLayer(objMapServiceQueryResult.MapLayerID);

                        // Loop through all the map layer query results ...
                        $.each(objMapServiceQueryResult.Data, function (intMapLayerQueryResult, objMapLayerQueryResult) {

                            // If we do not have any results for the map layer yet ...
                            if (typeof dicQueryResultsDisplayData[objMapServiceQueryResult.MapLayerID] == 'undefined') {

                                // Create a new query results display data and add it to the dictionary ...
                                dicQueryResultsDisplayData[objMapServiceQueryResult.MapLayerID] = TrimbleMap.QueryResultsDisplay.Shared.CreateQueryResultsDisplayData([], objMapServiceQueryResult.MapLayerID, 0);
                            }

                            // Get the query results display data ...
                            let objQueryResultsDisplayData = dicQueryResultsDisplayData[objMapServiceQueryResult.MapLayerID];

                            // Add the attributes to the data array ...
                            objQueryResultsDisplayData.Data.push(objMapLayerQueryResult);
                        });
                    });

                    // Create a new array for the query results display data ...
                    let arrQueryResultsDisplayData = [];

                    // Loop through all the query results display datas ...
                    $.each(dicQueryResultsDisplayData, function (strMapLayerID, objQueryResultsDisplayData) {

                        // Add it to the array ...
                        arrQueryResultsDisplayData.push(objQueryResultsDisplayData);
                    });

                    // Depending on the current operation ...
                    switch (enSelectionOperation) {
                        case TrimbleMap.Selection.enumOperation.SelectFeatures:

                            // Load the data into the query results display (clear exiting data) ...
                            objMapSelection.QueryResultsDisplay.LoadData(arrQueryResultsDisplayData, true);
                            break;

                        case TrimbleMap.Selection.enumOperation.AddFeatures:

                            // Load the data into the query results display (do not clear exiting data) ...
                            objMapSelection.QueryResultsDisplay.LoadData(arrQueryResultsDisplayData, false);
                            break;

                        case TrimbleMap.Selection.enumOperation.RemoveFeatures:

                            // Remove the data drom the query results display ...
                            objMapSelection.QueryResultsDisplay.FilterData(arrQueryResultsDisplayData, TrimbleMap.enumFilterDataMethod.RemoveInputData);
                            break;

                        case TrimbleMap.Selection.enumOperation.FilterCurrentSelection:

                            // Filter the data drom the query results display ...
                            objMapSelection.QueryResultsDisplay.FilterData(arrQueryResultsDisplayData, TrimbleMap.enumFilterDataMethod.OnlyKeepInputData);
                            break;
                    }
                }
            }

            // Hide the spinner on the query results display ...
            objMapSelection.QueryResultsDisplay.HideSpinner();

            // Revert back to the default cursor ...
            objMapSelection.MapController.SetMapCursor('default');

            // Set to not perform the selection ...
            objMapSelection.PerformingSelection = false;

            // When the tab is active ...
            if (objMapSelection.SelectionTabItem == objMapSelection.Sidebar.CurrentTab) {

                // Attach the event handlers ...
                objMapSelection.AttachEventHandlers();
            }

            // When the selection mode button is the active mode button ...
            if (objMapSelection.ModeButtons.ActiveButton == objMapSelection.SelectionModeButton) {

                // Activate the tool ...
                objMapSelection.ActivateTool();
            }

            // Resolve the deferred ...
            objDeferred.resolve();

        } else {

            // Reject the deferred ...
            objDeferred.reject();
        }
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: AddToSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.AddToSelection = function AddToSelection(arrMapServiceQueryResults) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Loop through all the query results ...
    $.each(arrMapServiceQueryResults, function (intMapServiceQueryResult, objMapServiceQueryResult) {

        // Get the queried map layer for the query result ...
        var objQueriedMapLayer = objMapSelection.MapController.GetMapLayer(objMapServiceQueryResult.MapLayerID);

        // Loop through all the map layer query results ...
        $.each(objMapServiceQueryResult.Data, function (intMapLayerQueryResult, objMapLayerQueryResult) {

            // Add the item to the selection on the map ...
            objMapSelection.MapController.AddToSelection(objQueriedMapLayer, objMapLayerQueryResult.Attributes, objMapLayerQueryResult.Geometry);
        });
    });

    // Load the data into the query results display (do not clear exiting data) ...
    objMapSelection.QueryResultsDisplay.LoadData(arrMapServiceQueryResults, false);

    // Flash the tab ...
    objMapSelection.Sidebar.FlashTab(objMapSelection.SelectionTabItem);
}

// **************************************************************************
// FUNCTION: RemoveFromSelection
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.RemoveFromSelection = function RemoveFromSelection(arrMapServiceQueryResults) {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Remove from the selection ...
    objMapSelection.QueryResultsDisplay.FilterData(arrMapServiceQueryResults, TrimbleMap.enumFilterDataMethod.RemoveInputData);

    // Loop through all the query results ...
    $.each(arrMapServiceQueryResults, function (intMapServiceQueryResult, objMapServiceQueryResult) {

        // Get the queried map layer for the query result ...
        var objQueriedMapLayer = objMapSelection.MapController.GetMapLayer(objMapServiceQueryResult.MapLayerID);

        // Get the map layer ID field name ...
        var strIDFieldName = objMapSelection.MapController.GetMapLayerIDFieldName(objQueriedMapLayer);

        // Loop through all the map layer query results ...
        $.each(objMapServiceQueryResult.Data, function (intMapLayerQueryResult, objMapLayerQueryResult) {

            // Get the id ...
            var strID = objMapLayerQueryResult.Attributes[strIDFieldName];

            // Remove the item from the selection on the map ...
            objMapSelection.MapController.RemoveFromSelection(objQueriedMapLayer, strID);
        });
    });
}

// **************************************************************************
// FUNCTION: UpdateOperationIcon
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.UpdateOperationIcon = function UpdateOperationIcon() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the icon element ...
    var objIcon = objMapSelection.SelectionModeDropDown.find('.select-operation');

    // Remove all the icon image css classes from the icon ...
    objIcon.removeClass('select-select');
    objIcon.removeClass('select-add');
    objIcon.removeClass('select-remove');
    objIcon.removeClass('select-from-selection');

    // Add the specific icon ...
    objIcon.addClass(TrimbleMap.Selection.Shared.OperationIconCssClass(objMapSelection.Operation));
}

// **************************************************************************
// FUNCTION: UpdateOperationIcon
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.UpdateToolModeIcon = function UpdateToolModeIcon() {

    // Get the map selection instance ...
    var objMapSelection = this;

    // Get the icon element ...
    var objIcon = objMapSelection.SelectionToolModeDropDown.find('.selection-background');

    // Remove all the icon image css classes from the icon ...
    objIcon.removeClass('select-polygon');
    objIcon.removeClass('select-polyline');
    objIcon.removeClass('select-point');

    // Add the specific icon ...
    objIcon.addClass(TrimbleMap.Selection.Shared.ToolModeIconCssClass(objMapSelection.ToolMode));
}

// **************************************************************************
// FUNCTION: QueryResultsDisplayLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.QueryResultsDisplayLoaded = function QueryResultsDisplayLoaded(fnLoaded) {

    // Get the instance ...
    var objMapSelection = this;

    // Trigger the loaded callbacks ...
    objMapSelection.TriggerOnLoadedCallbacks();
}

// **************************************************************************
// FUNCTION: AddOnLoadedCallback
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.AddOnLoadedCallback = function AddOnLoadedCallback(fnLoaded) {

    // Get the instance ...
    var objMapSelection = this;

    // Add the loaded function ...
    objMapSelection.OnLoadedFunctions.push(fnLoaded);
}

// **************************************************************************
// FUNCTION: RemoveOnLoadedCallback
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.RemoveOnLoadedCallback = function RemoveOnLoadedCallback(fnLoaded) {

    // Get the instance ...
    var objMapSelection = this;

    // Find the function in the array ...
    var intLoadedFunction = $.inArray(fnLoaded, objMapSelection.OnLoadedFunctions);

    // When found ...
    if (intLoadedFunction > -1) {

        // Remove it from the array ...
        objMapSelection.OnLoadedFunctions.splice(intLoadedFunction, 1);
    }
}

// **************************************************************************
// FUNCTION: TriggerOnLoadedCallbacks
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.TriggerOnLoadedCallbacks = function TriggerOnLoadedCallbacks() {

    // Get the instance ...
    var objMapSelection = this;

    // Loop through all the on loaded functions ...
    $.each(objMapSelection.OnLoadedFunctions, function (intLoaded, fnLoaded) {

        // Call the function ...
        fnLoaded();
    });
}

// **************************************************************************
// FUNCTION: AddOnShowFunction
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.AddOnShowFunction = function AddOnShowFunction(fnOnShow) {

    // Get the instance ...
    var objSelection = this;

    // Add the function to the list of on show functions ...
    objSelection.OnShowFunctions.push(fnOnShow);
}

// **************************************************************************
// FUNCTION: AddOnHideFunction
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.AddOnHideFunction = function AddOnHideFunction(fnOnHide) {

    // Get the instance ...
    var objSelection = this;

    // Add the function to the list of on hide functions ...
    objSelection.OnHideFunctions.push(fnOnHide);
}

// **************************************************************************
// FUNCTION: TriggerOnShowFunctions
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.TriggerOnShowFunctions = function TriggerOnShowFunctions() {

    // Get the instance ...
    var objSelection = this;

    // Loop through all the on show functions ...
    $.each(objSelection.OnShowFunctions, function (intOnShow, fnOnShow) {

        // Call the on show function ...
        fnOnShow();
    });
}

// **************************************************************************
// FUNCTION: TriggerOnHideFunctions
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.TriggerOnHideFunctions = function TriggerOnHideFunctions() {

    // Get the instance ...
    var objSelection = this;

    // Loop through all the on hide functions ...
    $.each(objSelection.OnHideFunctions, function (intOnHide, fnOnHide) {

        // Call the on hide function ...
        fnOnHide();
    });
}

// **************************************************************************
// FUNCTION: OperationIconCssClass
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.Shared.OperationIconCssClass = function OperationIconCssClass(enOperation) {

    // Depending on the operation ...
    switch (enOperation) {
        case TrimbleMap.Selection.enumOperation.SelectFeatures: return "select-select"; break;
        case TrimbleMap.Selection.enumOperation.AddFeatures: return "select-add"; break;
        case TrimbleMap.Selection.enumOperation.RemoveFeatures: return "select-remove"; break;
        case TrimbleMap.Selection.enumOperation.FilterCurrentSelection: return "select-from-selection"; break;
    }
}

// **************************************************************************
// FUNCTION: ToolModeIconCssClass
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.Shared.ToolModeIconCssClass = function ToolModeIconCssClass(enSelectionToolMode) {

    // Depending on the toolmode ...
    switch (enSelectionToolMode) {
        case TrimbleMap.Selection.enumToolMode.SelectByPolygon: return "select-polygon"; break;
        case TrimbleMap.Selection.enumToolMode.SelectByPoint: return "select-point"; break;
        case TrimbleMap.Selection.enumToolMode.SelectByPolyline: return "select-polyline"; break;
    }
}

// **************************************************************************
// FUNCTION: SelectionMethodForOperation
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.Shared.SelectionMethodForOperation = function SelectionMethodForOperation(enOperation) {

    // Declare a variable to return ...
    var enSelectionMode;

    // Deterimine the selection mode based on the operation ...
    switch (enOperation) {
        case TrimbleMap.Selection.enumOperation.SelectFeatures:
            enSelectionMode = esri.layers.FeatureLayer.SELECTION_NEW;
            break;
        case TrimbleMap.Selection.enumOperation.AddFeatures:
            enSelectionMode = esri.layers.FeatureLayer.SELECTION_ADD;
            break;
        case TrimbleMap.Selection.enumOperation.RemoveFeatures:
            enSelectionMode = esri.layers.FeatureLayer.SELECTION_SUBTRACT;
            break;
        case TrimbleMap.Selection.enumOperation.FilterCurrentSelection:
            enSelectionMode = TrimbleMap.Controller.Shared.FILTER_SELECTION;
            break;
    }

    return enSelectionMode;
}

// **************************************************************************
// FUNCTION: OperationForSelectionMethod
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.Shared.OperationForSelectionMethod = function OperationForSelectionMethod(enSelectionMode) {

    // Declare a variable to return ...
    var enOperation;

    // Deterimine the selection mode based on the operation ...
    switch (enSelectionMode) {
        case esri.layers.FeatureLayer.SELECTION_NEW:
            enOperation = TrimbleMap.Selection.enumOperation.SelectFeatures;
            break;
        case esri.layers.FeatureLayer.SELECTION_ADD:
            enOperation = TrimbleMap.Selection.enumOperation.AddFeatures;
            break;
        case esri.layers.FeatureLayer.SELECTION_SUBTRACT:
            enOperation = TrimbleMap.Selection.enumOperation.RemoveFeatures;
            break;
        case TrimbleMap.Controller.Shared.FILTER_SELECTION:
            enOperation = TrimbleMap.Selection.enumOperation.FilterCurrentSelection;
            break;
    }

    return enOperation;
}

// **************************************************************************
// FUNCTION: CreateOptions
// USAGE:    
// **************************************************************************
TrimbleMap.Selection.Shared.CreateOptions = function CreateOptions(strQueryResultsDataJson, fnPopulateMapLayerGroupBySectionMenu) {

    return {
        QueryResultsDataJson: strQueryResultsDataJson,
        PopulateMapLayerGroupBySectionMenu: fnPopulateMapLayerGroupBySectionMenu
    };
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Shape = {};
TrimbleMap.Shape.Shared = {};

TrimbleMap.Shape.Shared.GEOGRAPHIC_TOLERANCE_VERTICES_ALONG_STRAIGHT_LINE = 0.000002778;
TrimbleMap.Shape.Shared.PROJECTED_TOLERANCE_VERTICES_ALONG_STRAIGHT_LINE = 0.31;
TrimbleMap.Shape.Shared.GEOGRAPHIC_TOLERANCE_SLIVER = 0.000002778;
TrimbleMap.Shape.Shared.PROJECTED_TOLERANCE_SLIVER = 0.31;

// ****************************************************************
//  ENUMERATIONS
// ****************************************************************
TrimbleMap.Shape.enumGeometryType = {};
TrimbleMap.Shape.enumGeometryType.MIXED = 'MIXED';
TrimbleMap.Shape.enumGeometryType.POINT = 'POINT';
TrimbleMap.Shape.enumGeometryType.POLYLINE = 'POLYLINE';
TrimbleMap.Shape.enumGeometryType.POLYGON = 'POLYGON';
TrimbleMap.Shape.enumGeometryType.NONE = 'NONE';

TrimbleMap.Shape.enumNorthSouth = {};
TrimbleMap.Shape.enumNorthSouth.NORTH = 'N';
TrimbleMap.Shape.enumNorthSouth.SOUTH = 'S';

TrimbleMap.Shape.enumEastWest = {};
TrimbleMap.Shape.enumEastWest.EAST = 'E';
TrimbleMap.Shape.enumEastWest.WEST = 'W';

TrimbleMap.Shape.enumInteriorOrExterior = {};
TrimbleMap.Shape.enumInteriorOrExterior.Interior = 'Interior';
TrimbleMap.Shape.enumInteriorOrExterior.Exterior = 'Exterior';

TrimbleMap.Shape.enumReferencePointCalculationMethod = {};
TrimbleMap.Shape.enumReferencePointCalculationMethod.None = String(SD.Number.NULL_NUMBER);
TrimbleMap.Shape.enumReferencePointCalculationMethod.Centroid = 'Centroid';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.CreateInstance = function CreateInstance(guidSpatialReference, enGeometryType, arrParts, decOfficialArea, guidOfficialAreaUnit, decOfficialLength, guidOfficialLengthUnit, blnIsDynamic, objDynamicShapeOptions, arrReferencePoints, strLegalDescription, strOfficialAreaText, strOfficialLengthText) {

    // Create the object that will hold the instance properties ...
    var objShape = {
        GeometryType: ((typeof enGeometryType != 'undefined') && enGeometryType) ? enGeometryType : TrimbleMap.Shape.enumGeometryType.MIXED,
        SpatialReferenceID: guidSpatialReference,
        Parts: ((typeof arrParts != 'undefined') && arrParts) ? arrParts : [],
        OfficialArea: ((typeof decOfficialArea != 'undefined') && decOfficialArea) ? decOfficialArea : 0,
        OfficialAreaUnitID: ((typeof guidOfficialAreaUnit != 'undefined') && guidOfficialAreaUnit) ? guidOfficialAreaUnit : SD.Guid.Shared.Empty(),
        OfficialLength: ((typeof decOfficialLength != 'undefined') && decOfficialLength) ? decOfficialLength : 0,
        OfficialLengthUnitID: ((typeof guidOfficialLengthUnit != 'undefined') && guidOfficialLengthUnit) ? guidOfficialLengthUnit : SD.Guid.Shared.Empty(),
        IsDynamic: ((typeof blnIsDynamic != 'undefined') && blnIsDynamic) ? blnIsDynamic : false,
        ReferencePoints: ((typeof arrReferencePoints != 'undefined') && arrReferencePoints) ? arrReferencePoints : null,
        LegalDescription: ((typeof strLegalDescription != 'undefined') && (strLegalDescription != null)) ? strLegalDescription : '',
        DynamicShapeOptions: ((typeof objDynamicShapeOptions != 'undefined') && (objDynamicShapeOptions != null)) ? objDynamicShapeOptions : null,
        OfficialAreaText: ((typeof strOfficialAreaText != 'undefined') && (strOfficialAreaText != null)) ? strOfficialAreaText : '',
        OfficialLengthText: ((typeof strOfficialLengthText != 'undefined') && (strOfficialLengthText != null)) ? strOfficialLengthText : '',

        AddPart: TrimbleMap.Shape.AddPart,
        RemovePart: TrimbleMap.Shape.RemovePart,
        ForEachPart: TrimbleMap.Shape.ForEachPart,
        GetPartByID: TrimbleMap.Shape.GetPartByID,
        GetReferencePointByID: TrimbleMap.Shape.GetReferencePointByID,
        GetPartIndex: TrimbleMap.Shape.GetPartIndex,
        PartNameIsUnique: TrimbleMap.Shape.PartNameIsUnique,
        IsExteriorPart: TrimbleMap.Shape.IsExteriorPart,
        ToEsriPolygon: TrimbleMap.Shape.ToEsriPolygon,
        GetGeometry: TrimbleMap.Shape.GetGeometry,
        ToEsriMultiPoint: TrimbleMap.Shape.ToEsriMultiPoint,
        ToEsriPolyline: TrimbleMap.Shape.ToEsriPolyline,
        GetExtentEsriGeometry: TrimbleMap.Shape.GetExtentEsriGeometry,
        GetExteriorPartForInteriorPart: TrimbleMap.Shape.GetExteriorPartForInteriorPart,
        GetExteriorPartsGeometries: TrimbleMap.Shape.GetExteriorPartsGeometries,
        GetInteriorPartsGeometries: TrimbleMap.Shape.GetInteriorPartsGeometries,
        GetPartGeometry: TrimbleMap.Shape.GetPartGeometry,
        GetExteriorAndInteriorPartsGeometry: TrimbleMap.Shape.GetExteriorAndInteriorPartsGeometry,
        GetExteriorAndInteriorPartsGeometries: TrimbleMap.Shape.GetExteriorAndInteriorPartsGeometries,
        CountCoordinates: TrimbleMap.Shape.CountCoordinates,
        HasCoordinates: TrimbleMap.Shape.HasCoordinates,
        HasReferencePoints: TrimbleMap.Shape.HasReferencePoints,
        HasParts: TrimbleMap.Shape.HasParts,
        HasReferencePointWithValues: TrimbleMap.Shape.HasReferencePointWithValues,
        HasCalculatedReferencePoints: TrimbleMap.Shape.HasCalculatedReferencePoints,
        ReferencePointsWithValues: TrimbleMap.Shape.ReferencePointsWithValues,
        ReferencePointsWithoutValues: TrimbleMap.Shape.ReferencePointsWithoutValues,
        UpdateCalculatedReferencePoints: TrimbleMap.Shape.UpdateCalculatedReferencePoints,
        EnsureCorrectRingOrientation: TrimbleMap.Shape.EnsureCorrectRingOrientation,
        RoundCoordinates: TrimbleMap.Shape.RoundCoordinates,
        RemoveCoordinatesAlongStraightLine: TrimbleMap.Shape.RemoveCoordinatesAlongStraightLine,
        MergeParts: TrimbleMap.Shape.MergeParts,
        PartOverlapsOtherParts: TrimbleMap.Shape.PartOverlapsOtherParts,
        PartContainsAllItsInteriorParts: TrimbleMap.Shape.PartContainsAllItsInteriorParts,
        SortPartsByName: TrimbleMap.Shape.SortPartsByName,
        Clone: TrimbleMap.Shape.Clone,
        Project: TrimbleMap.Shape.Project,
        CalculateAreaSquareKm: TrimbleMap.Shape.CalculateAreaSquareKm,
        CalculateDistanceKm: TrimbleMap.Shape.CalculateDistanceKm,
        HaveValidGeotransformationConfigurationTo: TrimbleMap.Shape.HaveValidGeotransformationConfigurationTo,
        DefaultNewPartName: TrimbleMap.Shape.DefaultNewPartName,
        toJson: TrimbleMap.Shape.toJson,
        GetPolygonCentroid: TrimbleMap.Shape.GetPolygonCentroid
    }

    return objShape;
}

// **************************************************************************
// FUNCTION: toJson
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.toJson = function toJson() {

    // Get the instance ...
    var objShape = this;

    // Clone the shape ...
    objShape = $.extend(true, {}, objShape);

    // Pack the part coordinates ...
    TrimbleMap.Shape.Shared.PackPartCoordinates(objShape.Parts);

    // Serialize the shape ...
    var strShapeJson = JSON.stringify(objShape);

    // Return the json ..
    return strShapeJson;
}

// **************************************************************************
// FUNCTION: ConvertPartsToEsriGeometry
// USAGE:
// **************************************************************************
TrimbleMap.Shape.Shared.ConvertPartsToEsriGeometry = function ConvertPartsToEsriGeometry(arrPartsCoordinates, strGeometryType, strGeoJsonGeometryType, strWkt) {
    let arrReturnGeometry = [];

    if (arrPartsCoordinates && arrPartsCoordinates.length > 0) {

        switch (strGeometryType) {
            case TrimbleMap.Shape.enumGeometryType.POLYLINE:

                if (strGeoJsonGeometryType == 'MULTILINESTRING') {

                    if (arrPartsCoordinates.length > 1) {
                        $.each(arrPartsCoordinates, function (intPartCoordinate, arrPolylinePartCoordinates) {

                            let objPolyline = {
                                Geometry: new esri.geometry.Polyline(strWkt[0]),
                            };

                            objPolyline.Geometry.paths.push(arrPolylinePartCoordinates);

                            //Add geometry to the array
                            arrReturnGeometry.push(objPolyline);

                        });
                    } else {

                        let objPolyline = {
                            Geometry: new esri.geometry.Polyline(strWkt[0]),
                        };

                        objPolyline.Geometry.paths.push(arrPartsCoordinates);

                        //Add geometry to the array
                        arrReturnGeometry.push(objPolyline);
                    };

                } else {

                    let objPolyline = {
                        Geometry: new esri.geometry.Polyline(strWkt[0]),
                    };

                    objPolyline.Geometry.paths.push(arrPartsCoordinates);

                    //Add geometry to the array
                    arrReturnGeometry.push(objPolyline);
                }

                break;

            case TrimbleMap.Shape.enumGeometryType.POINT:

                if (strGeoJsonGeometryType == 'MULTIPOINT') {

                    if (arrPartsCoordinates.length > 1) {
                        $.each(arrPartsCoordinates, function (intPartCoordinate, objPartCoordinate) {

                            let objPoint = {
                                Geometry: new esri.geometry.Point(objPartCoordinate[0], objPartCoordinate[1], strWkt)
                            };

                            //Add geometry to the array
                            arrReturnGeometry.push(objPoint);

                        });
                    } else {

                        let objPoint = {
                            Geometry: new esri.geometry.Point(arrPartsCoordinates[0], arrPartsCoordinates[1], strWkt)
                        };

                        //Add geometry to the array
                        arrReturnGeometry.push(objPoint);
                    };
                } else {

                    let objPoint = {
                        Geometry: new esri.geometry.Point(arrPartsCoordinates[0], arrPartsCoordinates[1], strWkt)
                    };

                    //Add geometry to the array
                    arrReturnGeometry.push(objPoint);

                };

                break;

            case TrimbleMap.Shape.enumGeometryType.POLYGON:

                for (let intPartIndex = 0; intPartIndex < arrPartsCoordinates.length; intPartIndex++) {
                    let arrCoordinates = arrPartsCoordinates[intPartIndex].reverse();

                    let objPolygon = {
                        Geometry: new esri.geometry.Polygon(arrCoordinates),
                        isInterior: false,
                        spatialReference: strWkt
                    };

                    // Calculate the area of the ring to determine the ring orientation ...
                    let decRingArea = TrimbleMap.Geometry.Shared.CalculateRingArea(arrCoordinates);

                    // When a negative area (must be an exterior ring) ...
                    if (decRingArea > 0) {

                        // set interior to true
                        objPolygon.isInterior = true;
                    }

                    //Add geometry to the array
                    arrReturnGeometry.push(objPolygon);

                }

                break;
        }
    }

    //Return the Geometries
    return arrReturnGeometry;
};

// **************************************************************************
// FUNCTION: ForEachPart
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.ForEachPart = function ForEachPart(fnExecuteForEachPart) {

    // Get the instance ...
    var objShape = this;

    // Loop through all the parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // Execute the function for the part ...
        fnExecuteForEachPart(objPart, false, null);

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

            // Loop through all the interior parts ...
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Execute the function for the part passing in the exterior part as well ...
                fnExecuteForEachPart(objInteriorPart, true, objPart);
            });
        }
    });
}

// **************************************************************************
// FUNCTION: HaveValidGeotransformationConfigurationTo
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.HaveValidGeotransformationConfigurationTo = function HaveValidGeotransformationConfigurationTo(objMapController, guidToSpatialReference) {

    // Get the instance ...
    var objShape = this;

    // Determine whether or not we have a valid geotransformation configured in order to project the shape project to guidToSpatialReference ...
    var blnHaveValidGeotransformationConfigurationTo = objMapController.HaveValidGeotransformationConfigurationBetween(objShape.SpatialReferenceID, guidToSpatialReference);

    return blnHaveValidGeotransformationConfigurationTo;
}

// **************************************************************************
// FUNCTION: Project
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Project = function Project(objMapController, guidToSpatialReference, blnSimplify) {

    // Get the instance ...
    var objShape = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred;

    // Create the esri spatial references for the spatial reference id of the shape spatial reference ...
    var objShapeEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

    // Create two arrays, one for the part geometries to reproject and one for the reference point geometries to reproject ...
    var arrPartGeometries = [];
    var arrReferencePointGeometries = [];

    // Loop through all the shape parts (interior and exterior) ...
    objShape.ForEachPart(function (objPart) {

        // Create an esri geometry from the part's coordinates and add it to the array of geometries to project ...
        arrPartGeometries.push(TrimbleMap.ShapePart.Shared.EsriGeometryFromCoordinates(objPart.Coordinates, objShapeEsriSpatialReference, objShape.GeometryType));
    });

    // Get the non-calulated reference points with values ...
    var arrReferencePointsWithValues = objShape.ReferencePointsWithValues(false);

    // When the shape has non-calculated reference points with values ...
    if (arrReferencePointsWithValues.length > 0) {

        // Loop through the reference points with values ... 
        $.each(arrReferencePointsWithValues, function (intReferencePoint, objReferencePoint) {

            // Add the reference point to be re-projected ....
            arrReferencePointGeometries.push(new esri.geometry.Point(objReferencePoint.X, objReferencePoint.Y, objShapeEsriSpatialReference));
        });
    }

    // Project to the spatial reference in which to do the block conversion ...
    var objProjectPartGeometriesDeferred = objMapController.ProjectGeometries(arrPartGeometries, objShape.SpatialReferenceID, guidToSpatialReference, blnSimplify);

    // Project to the spatial reference in which to do the block conversion ...
    var objProjectReferencePointGeometriesDeferred = objMapController.ProjectGeometries(arrReferencePointGeometries, objShape.SpatialReferenceID, guidToSpatialReference, blnSimplify);

    // When the projection completes ...
    (new dojo.promise.all([objProjectPartGeometriesDeferred, objProjectReferencePointGeometriesDeferred])).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

        // Get the projected part and reference point  geometry arrays ...
        var arrProjectedPartGeometries = arrProjectedGeometries[0];
        var arrProjectedReferencePointGeometries = arrProjectedGeometries[1];

        // Set the spatial reference id of the shape ...
        objShape.SpatialReferenceID = guidToSpatialReference;

        // Start at geometry 0 ...
        var intGeometry = 0;

        // Loop through all the shape parts (interior and exterior) ...
        objShape.ForEachPart(function (objPart) {

            // Replace the coordinates with the projected coordinates ...
            objPart.Coordinates = TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(arrProjectedPartGeometries[intGeometry++], 0);
        });

        // Start at geometry 0 ...
        var intGeometry = 0;

        // When the shape has reference points with values ...
        if (arrReferencePointsWithValues.length > 0) {

            // Loop through the reference points with values ... 
            $.each(arrReferencePointsWithValues, function (intReferencePoint, objReferencePoint) {

                // Get the projected point ...
                var objProjectedReferencePoint = arrProjectedReferencePointGeometries[intGeometry++];

                // Set the X and Y values ...
                objReferencePoint.X = objProjectedReferencePoint.x;
                objReferencePoint.Y = objProjectedReferencePoint.y;
            });
        }

        // Round the coordinates to the number of decimal places available for the spatial reference ...
        objShape.RoundCoordinates(objMapController);

        // Resolve the deferred ...
        objDeferred.resolve(objShape);

    }), TrimbleMap.Controller.Shared.TrapException(function (strError) { objDeferred.reject(strError); }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: RoundCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.RoundCoordinates = function RoundCoordinates(objMapController) {

    // Get the instance ...
    var objShape = this;

    // Get the spatial reference ...
    var objSpatialReference = objMapController.GetSpatialReference(objShape.SpatialReferenceID);

    // Get the number of decimal places for the spatial reference ...
    var intDecimalPlaces = objSpatialReference.DecimalPlaces;

    // Loop through all the exterior parts ....
    $.each(objShape.Parts, function (strPartID, objPart) {

        // Round the part's coordinates ...
        TrimbleMap.ShapePart.Shared.RoundCoordinates(objPart, intDecimalPlaces);

        // When the shape has interior parts ....
        if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

            // Loop through all the interior parts ....
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Round the part's coordinates ...
                TrimbleMap.ShapePart.Shared.RoundCoordinates(objInteriorPart, intDecimalPlaces);
            });
        }
    });

    // Get the non-calulated reference points with values ...
    var arrReferencePointsWithValues = objShape.ReferencePointsWithValues(false);

    // When the shape has reference points with values ...
    if (arrReferencePointsWithValues.length > 0) {

        // Loop through the reference points with values ... 
        $.each(arrReferencePointsWithValues, function (intReferencePoint, objReferencePoint) {

            // Set the X and Y values ...
            objReferencePoint.X = SD.Number.RoundTo(objReferencePoint.X, intDecimalPlaces);
            objReferencePoint.Y = SD.Number.RoundTo(objReferencePoint.Y, intDecimalPlaces);
        });
    }
}

// **************************************************************************
// FUNCTION: RemoveCoordinatesAlongStraightLine
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.RemoveCoordinatesAlongStraightLine = function RemoveCoordinatesAlongStraightLine(objMapController) {

    // Get the instance ...
    var objShape = this;

    // Get the tolerance value to be used ...
    var decOrdinateTolerance = TrimbleMap.Shape.Shared.ToleranceForStraighLineRemoval(objMapController, objShape.SpatialReferenceID);

    // Loop through all the exterior parts ....
    $.each(objShape.Parts, function (strPartID, objPart) {

        // Remove the vertices along the straight line from the part, continue until all is removed ...
        while (TrimbleMap.ShapePart.Shared.RemoveCoordinatesAlongStraightLine(objPart, decOrdinateTolerance)) { }

        // When the shape has interior parts ....
        if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

            // Loop through all the interior parts ....
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Remove the vertices along the straight line from the part ...
                while (TrimbleMap.ShapePart.Shared.RemoveCoordinatesAlongStraightLine(objInteriorPart, decOrdinateTolerance)) { }
            });
        }
    });
}

// **************************************************************************
// FUNCTION: Clone
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Clone = function Clone() {

    // Get the instance ...
    var objShape = this;

    // Create a new array for the cloned parts ...
    var arrClonedParts = [];

    // Loop through all the exterior parts ....
    $.each(objShape.Parts, function (strPartID, objPart) {

        // Clone the part and add it to the array ...
        arrClonedParts.push(TrimbleMap.ShapePart.Clone(objPart));
    });

    // Start with no reference points ...
    var arrClonedReferencePoints = null;

    // When we have reference points ...
    if ((typeof objShape.ReferencePoints != 'undefined') && objShape.ReferencePoints) {

        // Create a new array ...
        arrClonedReferencePoints = [];

        // Loop through all the Reference Points ....
        $.each(objShape.ReferencePoints, function (intReferencePoint, objReferencePoint) {

            // Clone and add the reference point ...
            arrClonedReferencePoints.push(TrimbleMap.Shape.Shared.CloneReferencePoint(objReferencePoint));
        });
    }

    // When we have dynamic shape options, clone it ...
    var objClonedDynamicShapeOptions = ((typeof objShape.DynamicShapeOptions != 'undefined') && objShape.DynamicShapeOptions) ? TrimbleMap.Shape.Shared.CloneDynamicShapeOptions(objShape.DynamicShapeOptions) : null;

    // Clone the shape ...
    var objClonedShape = TrimbleMap.Shape.CreateInstance(objShape.SpatialReferenceID,
        objShape.GeometryType,
        arrClonedParts,
        objShape.OfficialArea,
        objShape.OfficialAreaUnitID,
        objShape.OfficialLength,
        objShape.OfficialLengthUnitID,
        objShape.IsDynamic,
        objClonedDynamicShapeOptions,
        arrClonedReferencePoints,
        objShape.LegalDescription,
        objShape.OfficialAreaText,
        objShape.OfficialLengthText);

    // Return the clone ..
    return objClonedShape;
}

// **************************************************************************
// FUNCTION: AddPart
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.AddPart = function AddPart(objPart, objExteriorPartToAddTo) {

    // Get the instance ...
    var objShape = this;

    // When an exterior part to add to has been passed in ...
    if ((typeof objExteriorPartToAddTo != 'undefined') && objExteriorPartToAddTo) {

        // Create a new interior parts array when it does not exist yet ...
        if ((typeof objExteriorPartToAddTo.InteriorParts == 'undefined') || (!objExteriorPartToAddTo.InteriorParts)) { objExteriorPartToAddTo.InteriorParts = []; }

        // Add the part to the interior parts ...
        objExteriorPartToAddTo.InteriorParts.push(objPart);

    } else {

        // Add the part to the exterior parts ...
        objShape.Parts.push(objPart);
    }

    return objShape;
}

// **************************************************************************
// FUNCTION: RemovePart
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.RemovePart = function RemovePart(objPartToRemove) {

    // Get the instance ...
    var objShape = this;

    // Get the part index ...
    var intPart = objShape.GetPartIndex(objPartToRemove);

    // When an exterior part ...
    if (intPart > -1) {

        // Remove the part from the exterior parts ...
        objShape.Parts.splice(intPart, 1);

    } else {

        // Loop through all the exterior parts ....
        $.each(objShape.Parts, function (strPartID, objPart) {

            // When the shape has interior parts ....
            if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

                // Get the interior part index ...
                var intInteriorPart = TrimbleMap.Shape.Shared.GetPartIndex(objPart.InteriorParts, objPartToRemove);

                // Determine whether or not the part has been found as an interior part of the part ...
                var blnFoundAsInterior = (intInteriorPart > -1);

                // When found ...
                if (blnFoundAsInterior) {

                    // Remove the part from the exterior parts ...
                    objPart.InteriorParts.splice(intInteriorPart, 1);
                }
            }

            // Return false when found to not continue looking for it ...
            return !blnFoundAsInterior;
        });
    }

    return objShape;
}

// **************************************************************************
// FUNCTION: GetPartIndex
// USAGE:    Returns -1 when not found ...
// **************************************************************************
TrimbleMap.Shape.GetPartIndex = function GetPartIndex(objShapePart) {

    // Get the instance ...
    var objShape = this;

    // Get the index of the part ...
    var intPart = TrimbleMap.Shape.Shared.GetPartIndex(objShape.Parts, objShapePart);

    // Return the index of the part ...
    return intPart;
}

// **************************************************************************
// FUNCTION: GetPartByID
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.GetPartByID = function GetPartByID(strPartID) {

    // Get the instance ...
    var objShape = this;

    // Start with not found ...
    var objShapePart = null;

    // Loop through all the parts ...
    $.each(objShape.Parts, function (intPart, objPartToCheck) {

        // When the ID matches ...
        if (strPartID == objPartToCheck.ID) {

            // Set to return the part ...
            objShapePart = objPartToCheck;

            // Stop searching ...
            return false;

            // Other wise When the part has interior parts ...
        } else if ((typeof objPartToCheck.InteriorParts != 'undefined') && objPartToCheck.InteriorParts) {

            // Start with not being found ...
            var blnFound = false;

            // Loop through all the interior parts ...
            $.each(objPartToCheck.InteriorParts, function (intInteriorPart, objInteriorPartToCheck) {

                // When the ID matches ...
                if (strPartID == objInteriorPartToCheck.ID) {

                    // Set to return the part ...
                    objShapePart = objInteriorPartToCheck;

                    // Set to be found ...
                    blnFound = true;

                    // Stop searching ...
                    return false;
                }
            });

            // Return false to stop checking the other parts when found ...
            return !blnFound;
        }
    });

    return objShapePart;
}

// **************************************************************************
// FUNCTION: GetReferencePointByID
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.GetReferencePointByID = function GetReferencePointByID(strReferencePointByID) {

    // Get the instance ...
    var objShape = this;

    // Start with not found ...
    var objReferencePoint = null;

    // Loop through all the reference points ...
    $.each(objShape.ReferencePoints, function (intReferencePoint, objReferencePointToCheck) {

        // When the id matches ...
        if (objReferencePointToCheck.ID == strReferencePointByID) {

            // Set the reference point ...            
            objReferencePoint = objReferencePointToCheck;

            // Stop searching ...
            return false;
        }
    });

    return objReferencePoint
}

// **************************************************************************
// FUNCTION: PartNameIsUnique
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.PartNameIsUnique = function PartNameIsUnique(strPartName, objPartToIgnore) {

    // Get the instance ...
    var objShape = this;

    // Test if the part name is unique ...
    var blnUnique = TrimbleMap.Shape.Shared.PartNameIsUnique(objShape.Parts, strPartName, objPartToIgnore);

    return blnUnique;
}

// **************************************************************************
// FUNCTION: IsExteriorPart
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.IsExteriorPart = function IsExteriorPart(objShapePart) {

    // Get the instance ...
    var objShape = this;

    // Determine if the part is in the exterior parts list ...
    var blnIsExteriorPart = ($.inArray(objShapePart, objShape.Parts) > -1);

    return blnIsExteriorPart;
}

// **************************************************************************
// FUNCTION: GetGeometry
// USAGE:    dicCoordinatesToReplace is optional by default there are no
//           coordinates to replace ...
// **************************************************************************
TrimbleMap.Shape.GetGeometry = function GetGeometry(objMapController, dicCoordinatesToReplace, blnFixOrientation) {

    // Get the instance ...
    var objShape = this;

    var objReturnGeometry = null;

    switch (objShape.GeometryType) {
        case TrimbleMap.Shape.enumGeometryType.POLYLINE:
            objReturnGeometry = objShape.ToEsriPolyline(objMapController, dicCoordinatesToReplace);
            break;

        case TrimbleMap.Shape.enumGeometryType.POINT:
            objReturnGeometry = objShape.ToEsriMultiPoint(objMapController, dicCoordinatesToReplace);
            break;

        case TrimbleMap.Shape.enumGeometryType.POLYGON:
            objReturnGeometry = objShape.ToEsriPolygon(objMapController, dicCoordinatesToReplace, blnFixOrientation);
            break;
    }

    return objReturnGeometry;
}

// **************************************************************************
// FUNCTION: ToEsriMultiPoint
// USAGE:    dicCoordinatesToReplace is optional by default there are no
//           coordinates to replace ...
// **************************************************************************
TrimbleMap.Shape.ToEsriMultiPoint = function ToEsriMultiPoint(objMapController, dicCoordinatesToReplace) {

    // Get the instance ...
    var objShape = this;

    // Create the esri spatial reference for the spatial reference id of the shape ...
    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

    // create a multi-point ...
    var objEsriMultiPoint = new esri.geometry.Multipoint(objEsriSpatialReference);

    // Loop through all the parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // Get the coordinates to replace for the part ID ...
        var arrCoordinatesToReplace = ((typeof dicCoordinatesToReplace != 'undefined') && dicCoordinatesToReplace) ? dicCoordinatesToReplace[objPart.ID] : null;

        // Get the coordinates for the part, replace it when we have coordinates to replace for the part ...
        var arrCoordinates = ((typeof arrCoordinatesToReplace != 'undefined') && arrCoordinatesToReplace) ? arrCoordinatesToReplace : objPart.Coordinates;

        //create esri point
        var objEsriPoint = new esri.geometry.Point(arrCoordinates[0].X, arrCoordinates[0].Y, objEsriSpatialReference);

        //Add it to the multipoint
        objEsriMultiPoint.addPoint(objEsriPoint);
    });

    return objEsriMultiPoint;
}

// **************************************************************************
// FUNCTION: ToEsriPolyline
// USAGE:    dicCoordinatesToReplace is optional by default there are no
//           coordinates to replace ...
// **************************************************************************
TrimbleMap.Shape.ToEsriPolyline = function ToEsriPolyline(objMapController, dicCoordinatesToReplace) {

    // Get the instance ...
    var objShape = this;

    // Create the esri spatial reference for the spatial reference id of the shape ...
    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

    // Create a polygon ...
    var objEsriPolyline = new esri.geometry.Polyline(objEsriSpatialReference);

    // Loop through all the parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // Get the coordinates to replace for the part ID ...
        var arrCoordinatesToReplace = ((typeof dicCoordinatesToReplace != 'undefined') && dicCoordinatesToReplace) ? dicCoordinatesToReplace[objPart.ID] : null;

        // Get the coordinates for the part, replace it when we have coordinates to replace for the part ...
        var arrCoordinates = ((typeof arrCoordinatesToReplace != 'undefined') && arrCoordinatesToReplace) ? arrCoordinatesToReplace : objPart.Coordinates;

        // Create a new array for the path ...
        var arrPathCoordinates = [];

        // Add the coordinates tro the path array ...
        $.each(arrCoordinates, function (intCoordinate, objCoordinate) { arrPathCoordinates.push([objCoordinate.X, objCoordinate.Y]) });

        // Convert the coordinates to a path and add it as a path to the polyline ...
        objEsriPolyline.paths.push(arrPathCoordinates);
    });

    return objEsriPolyline;
}

// **************************************************************************
// FUNCTION: ToEsriPolygon
// USAGE:    dicCoordinatesToReplace is optional by default there are no
//           coordinates to replace ...
//           blnFixOrientation is optional and defaults to true
// **************************************************************************
TrimbleMap.Shape.ToEsriPolygon = function ToEsriPolygon(objMapController, dicCoordinatesToReplace, blnFixOrientation) {

    // Get the instance ...
    var objShape = this;

    // Default blnFixOrientation to true when not set ...
    if ((typeof blnFixOrientation == 'undefined') && (blnFixOrientation == null)) { blnFixOrientation = true; }

    // Create the esri spatial reference for the spatial reference id of the shape ...
    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

    // Create a polygon ...
    var objEsriPolygon = new esri.geometry.Polygon(objEsriSpatialReference);

    // Loop through all the parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // Get the coordinates to replace for the part ID ...
        var arrCoordinatesToReplace = ((typeof dicCoordinatesToReplace != 'undefined') && dicCoordinatesToReplace) ? dicCoordinatesToReplace[objPart.ID] : null;

        // Get the coordinates for the part, replace it when we have coordinates to replace for the part ...
        var arrCoordinates = ((typeof arrCoordinatesToReplace != 'undefined') && arrCoordinatesToReplace) ? arrCoordinatesToReplace : objPart.Coordinates;

        // When the part has at least 3 coordinates ...
        if (arrCoordinates.length > 2) {

            // Create a ring from the coordinates and close it of not closed ...
            var arrRing = TrimbleMap.Geometry.Shared.CloseRing(TrimbleMap.ShapePart.Shared.RingFromCoordinates(arrCoordinates));

            // Ensure we have the correct ring orientation for exterior rings ...
            if (blnFixOrientation) { arrRing = TrimbleMap.Geometry.Shared.FixRingOrientation(arrRing, TrimbleMap.Shape.enumInteriorOrExterior.Exterior); }

            // Add the ring to the polygon ...
            objEsriPolygon.rings.push(arrRing);
        }

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

            // Loop through all the interior parts ...
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Get the coordinates to replace for the part ID ...
                var arrInteriorPartCoordinatesToReplace = ((typeof dicCoordinatesToReplace != 'undefined') && dicCoordinatesToReplace) ? dicCoordinatesToReplace[objInteriorPart.ID] : null;

                // Get the coordinates for the interior part, replace it when we have coordinates to replace for the part ...
                var arrInteriorCoordinates = ((typeof arrInteriorPartCoordinatesToReplace != 'undefined') && arrInteriorPartCoordinatesToReplace) ? arrInteriorPartCoordinatesToReplace : objInteriorPart.Coordinates;

                // When the part has at least 3 coordinates ...
                if (arrInteriorCoordinates.length > 2) {

                    // Create a ring from the coordinates and close it of not closed ...
                    var arrInteriorRing = TrimbleMap.Geometry.Shared.CloseRing(TrimbleMap.ShapePart.Shared.RingFromCoordinates(arrInteriorCoordinates));

                    // Ensure we have the correct ring orientation for interior rings ...
                    if (blnFixOrientation) { arrInteriorRing = TrimbleMap.Geometry.Shared.FixRingOrientation(arrInteriorRing, TrimbleMap.Shape.enumInteriorOrExterior.Interior); }

                    // Add the ring to the polygon ...
                    objEsriPolygon.rings.push(arrInteriorRing);
                }
            });
        }
    });

    // Return the polygon ...
    return objEsriPolygon;
}

// **************************************************************************
// FUNCTION: GetExtentEsriGeometry
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.GetExtentEsriGeometry = function GetExtentEsriGeometry(objMapController, dicCoordinatesToReplace) {

    // Get the instance ...
    var objShape = this;

    // Create a new array for all the coordinates ...
    var arrAllCoordinates = [];

    // Create the esri spatial reference for the spatial reference id of the shape ...
    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

    // Loop through all the parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // Get the coordinates to replace for the part ID ...
        var arrCoordinatesToReplace = ((typeof dicCoordinatesToReplace != 'undefined') && dicCoordinatesToReplace) ? dicCoordinatesToReplace[objPart.ID] : null;

        // Get the coordinates for the part, replace it when we have coordinates to replace for the part ...
        var arrCoordinates = ((typeof arrCoordinatesToReplace != 'undefined') && arrCoordinatesToReplace) ? arrCoordinatesToReplace : objPart.Coordinates;

        // Add the coordinates to the array ...
        arrAllCoordinates = arrAllCoordinates.concat(arrCoordinates);

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

            // Loop through all the interior parts ...
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Get the coordinates to replace for the part ID ...
                var arrInteriorPartCoordinatesToReplace = ((typeof dicCoordinatesToReplace != 'undefined') && dicCoordinatesToReplace) ? dicCoordinatesToReplace[objInteriorPart.ID] : null;

                // Get the coordinates for the interior part, replace it when we have coordinates to replace for the part ...
                var arrInteriorCoordinates = ((typeof arrInteriorPartCoordinatesToReplace != 'undefined') && arrInteriorPartCoordinatesToReplace) ? arrInteriorPartCoordinatesToReplace : objInteriorPart.Coordinates;

                // Add the coordinates to the array ...
                arrAllCoordinates = arrAllCoordinates.concat(arrInteriorCoordinates);
            });
        }
    });

    // Start with no extent geometry ...
    var objEsriGeometry = null;

    // When we have only one coordinate ...
    if (arrAllCoordinates.length == 1) {

        // Create a point geometry ...
        objEsriGeometry = new esri.geometry.Point(arrAllCoordinates[0].X, arrAllCoordinates[0].Y, objEsriSpatialReference);

    } else if (arrAllCoordinates.length > 1) {

        // Create a polygon ...
        var objEsriPolyline = new esri.geometry.Polyline(objEsriSpatialReference);

        // Create a new polyline from all the coordinates ...
        objEsriPolyline.addPath(TrimbleMap.ShapePart.Shared.RingFromCoordinates(arrAllCoordinates));

        // Get the extend of the coordinates ...
        objEsriGeometry = objEsriPolyline.getExtent();
    }

    return objEsriGeometry;
}

// **************************************************************************
// FUNCTION: GetExteriorPartForInteriorPart
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.GetExteriorPartForInteriorPart = function GetExteriorPartForInteriorPart(objInteriorPart) {

    // Get the instance ...
    var objShape = this;

    // Start with not found ...
    var objShapePart = null;

    // Loop through all the parts ...
    $.each(objShape.Parts, function (intPart, objPartToCheck) {

        // Otherwise when the part has interior parts ...
        if ((typeof objPartToCheck.InteriorParts != 'undefined') && objPartToCheck.InteriorParts) {

            // Start with not being found ...
            var blnFound = false;

            // Loop through all the interior parts ...
            $.each(objPartToCheck.InteriorParts, function (intInteriorPart, objInteriorPartToCheck) {

                // When the ID matches ...
                if (objInteriorPart.ID == objInteriorPartToCheck.ID) {

                    // Set to return the exterior part ...
                    objShapePart = objPartToCheck;

                    // Set to be found ...
                    blnFound = true;

                    // Stop searching ...
                    return false;
                }
            });

            // Return false to stop checking the other parts when found ...
            return !blnFound;
        }
    });

    return objShapePart;
}

// **************************************************************************
// FUNCTION: GetExteriorPartsGeometries
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.GetExteriorPartsGeometries = function GetExteriorPartsGeometries(objMapController, dicCoordinatesToReplace) {

    // Get the instance ...
    var objShape = this;

    // Create a new hash table for the part geometries to return ...
    var objPartGeometries = {};

    // Create the esri spatial reference for the spatial reference ID of the shape ...
    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

    // Loop through all the parts ...
    $.each(objShape.Parts, function (intPart, objPart) {

        // Build a geometry for the exterior part ...
        var objPartEsriGeometry = objShape.GetPartGeometry(objMapController, objPart, dicCoordinatesToReplace);

        // When the part has a geometry ...
        if (objPartEsriGeometry) {

            // Place it in the hash table with the part id as the key ...
            objPartGeometries[objPart.ID] = objPartEsriGeometry;
        }
    });

    // Return the part geometries ...
    return objPartGeometries;
}

// **************************************************************************
// FUNCTION: GetPartGeometry
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.GetPartGeometry = function GetPartGeometry(objMapController, objShapePart, dicCoordinatesToReplace) {

    // Get the instance ...
    var objShape = this;

    // Default dicCoordinatesToReplace to an empty object when not set ...
    dicCoordinatesToReplace = ((typeof dicCoordinatesToReplace == 'undefined') || (dicCoordinatesToReplace == null)) ? {} : dicCoordinatesToReplace;

    // Get the coordinates to replace for the part if any ... 
    var arrCoordinatesToReplace = dicCoordinatesToReplace[objShapePart.ID];

    // Create the esri spatial reference for the spatial reference ID of the shape ...
    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

    // Get the coordinates of the part but replace it if we have replacement coordinate for the part ... 
    var arrCoordinates = ((typeof arrCoordinatesToReplace == 'undefined') || (arrCoordinatesToReplace == null)) ? objShapePart.Coordinates : arrCoordinatesToReplace;

    // Create the part's esri geometry ...
    var objEsriGeometry = TrimbleMap.ShapePart.Shared.EsriGeometryFromCoordinates(arrCoordinates, objEsriSpatialReference, objShape.GeometryType);

    // Return the esri geometry ...
    return objEsriGeometry;
}

// **************************************************************************
// FUNCTION: GetExteriorAndInteriorPartsGeometry
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.GetExteriorAndInteriorPartsGeometry = function GetExteriorAndInteriorPartsGeometry(objMapController, objShapePart, dicCoordinatesToReplace, blnFixRingOrientation) {

    // Get the instance ...
    var objShape = this;

    // Build a geometry for the exterior part ...
    var objEsriGeometry = objShape.GetPartGeometry(objMapController, objShapePart, dicCoordinatesToReplace);

    // When we are to fix the ring orientation and we have a polygon with at least one ring ...
    if (blnFixRingOrientation && (objEsriGeometry != null) && (objEsriGeometry.type == 'polygon') && (objEsriGeometry.rings.length > 0)) {

        // Reverse the ring orientation ...
        var arrReversedRingPoints = TrimbleMap.Geometry.Shared.FixRingOrientation(objEsriGeometry.rings[0], TrimbleMap.Shape.enumInteriorOrExterior.Exterior);
        objEsriGeometry.removeRing(0);
        objEsriGeometry.addRing(arrReversedRingPoints);
    }

    // Create the esri spatial reference for the spatial reference ID of the shape ...
    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

    // Add the interior rings to the geometry ...
    TrimbleMap.ShapePart.Shared.AddInteriorRingsToEsriGeometry(objShapePart, objEsriGeometry, objEsriSpatialReference, dicCoordinatesToReplace, blnFixRingOrientation);

    // Return an object with the esri geometry and exterior part id ...
    return {
        Geometry: objEsriGeometry,
        ExteriorPartID: objShapePart.ID
    };
}

// **************************************************************************
// FUNCTION: GetExteriorAndInteriorPartsGeometries
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.GetExteriorAndInteriorPartsGeometries = function GetExteriorAndInteriorPartsGeometries(objMapController, dicCoordinatesToReplace, blnFixRingOrientation) {

    // Get the instance ...
    var objShape = this;

    // Create a new array for the part geometries to return ...
    var arrExteriorAndInteriorPartsGeometries = [];

    // Loop through all the exterior parts ...
    $.each(objShape.Parts, function (intExteriorPart, objExteriorPart) {

        // Create and add an object withe the geometry and exterior part id ...
        arrExteriorAndInteriorPartsGeometries.push(objShape.GetExteriorAndInteriorPartsGeometry(objMapController, objExteriorPart, dicCoordinatesToReplace, blnFixRingOrientation));
    });

    // Return the part geometries ...
    return arrExteriorAndInteriorPartsGeometries;
}

// **************************************************************************
// FUNCTION: GetInteriorPartsGeometries
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.GetInteriorPartsGeometries = function GetInteriorPartsGeometries(objMapController, objExteriorPart) {

    // Get the instance ...
    var objShape = this;

    // Create a new hashtable for the part geometries to return ...
    var objPartGeometries = {};

    // Create the esri spatial reference for the spatial reference ID of the shape ...
    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

    // When the part has interior parts ...
    if ((typeof objExteriorPart.InteriorParts != 'undefined') && objExteriorPart.InteriorParts) {

        // Loop through all the parts ...
        $.each(objExteriorPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

            // Create the part's esri geometry ...
            var objPartEsriGeometry = TrimbleMap.ShapePart.Shared.EsriGeometryFromCoordinates(objInteriorPart.Coordinates, objEsriSpatialReference, objShape.GeometryType);

            // When the part has a geometry ...
            if (objPartEsriGeometry) {

                // Place it in the hash table with the part id as the key ...
                objPartGeometries[objInteriorPart.ID] = objPartEsriGeometry;
            }
        });
    }

    // Return the part geometries ...
    return objPartGeometries;
}

// **************************************************************************
// FUNCTION: CountCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.CountCoordinates = function CountCoordinates() {

    // Get the instance ...
    var objShape = this;

    // Start with 0 ...
    var intCoordinateCount = 0;

    // Loop through all the exterior parts ... 
    $.each(objShape.Parts, function (intPart, objPart) {

        // Add the number of coordinates on the part ...
        intCoordinateCount += objPart.Coordinates.length;

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

            // Loop through all the interior parts and add the number of coordiantes on each interior part ...
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) { intCoordinateCount += objInteriorPart.Coordinates.length; });
        }
    });

    return intCoordinateCount;
}

// **************************************************************************
// FUNCTION: HasCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.HasCoordinates = function HasCoordinates(objMapController) {

    // Get the instance ...
    var objShape = this;

    // Start with not having any coordinates ...
    var blnHasCoordinates = false;

    // Loop through all the exterior parts ... 
    $.each(objShape.Parts, function (intPart, objPart) {

        // When the part has coordinates ...
        if (objPart.Coordinates.length > 0) {

            // Set to have coordinates ...
            blnHasCoordinates = true;

            // Stop checking ...
            return false;

        } else {

            // When the part has interior parts ...
            if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

                // Loop through all the interior parts ... 
                $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                    // When the interior part has coordinates ...
                    if (objInteriorPart.Coordinates.length > 0) {

                        // Set to have coordinates ...
                        blnHasCoordinates = true;

                        // Stop checking ...
                        return false;
                    }
                });

                // When found to have coordinates ...
                if (blnHasCoordinates) {

                    // Stop checking ...
                    return false;
                }
            }
        }
    });

    return blnHasCoordinates;
}

// **************************************************************************
// FUNCTION: HasParts
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.HasParts = function HasParts() {

    // Get the instance ...
    var objShape = this;

    // Determine whether or not the shape has parts ...
    var blnHasParts = ((typeof objShape.Parts != 'undefined') && objShape.Parts && (objShape.Parts.length > 0));

    return blnHasParts;
}

// **************************************************************************
// FUNCTION: HasReferencePoints
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.HasReferencePoints = function HasReferencePoints() {

    // Get the instance ...
    var objShape = this;

    // Determine whether or not the shape has reference points ...
    var blnHasReferencePoints = ((typeof objShape.ReferencePoints != 'undefined') && objShape.ReferencePoints &&
        (objShape.ReferencePoints.length > 0));

    return blnHasReferencePoints;
}

// **************************************************************************
// FUNCTION: HasReferencePointWithValues
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.HasReferencePointWithValues = function HasReferencePointWithValues(blnIgnoreCalculatedReferencePoints) {

    // Get the instance ...
    var objShape = this;

    // Start with not having any reference points with values ...
    var blnHasReferencePointWithValues = false;

    // When the shape has reference points ...
    if (objShape.HasReferencePoints()) {

        // Loop through all the reference points ...
        $.each(objShape.ReferencePoints, function (intReferencePoint, objReferencePoint) {

            // When reference point has values and we are not to ignore calculated 
            // reference point or the calculation method is not centroid  ...
            if (objReferencePoint.HasValues && ((!blnIgnoreCalculatedReferencePoints) || (objReferencePoint.CalculationMethod != TrimbleMap.Shape.enumReferencePointCalculationMethod.Centroid))) {

                // Set to have a reference point with values ...
                blnHasReferencePointWithValues = true;

                // Stop checking ...
                return false;
            }
        });
    }

    return blnHasReferencePointWithValues;
}

// **************************************************************************
// FUNCTION: HasCalculatedReferencePoints
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.HasCalculatedReferencePoints = function HasCalculatedReferencePoints() {

    // Get the instance ...
    var objShape = this;

    // Start with not having any reference points with values ...
    var blnHasCalculatedReferencePoints = false;

    // When the shape has reference points ...
    if (objShape.HasReferencePoints()) {

        // Loop through all the reference points ...
        $.each(objShape.ReferencePoints, function (intReferencePoint, objReferencePoint) {

            // When reference calculation method is centroid  ...
            if (objReferencePoint.CalculationMethod == TrimbleMap.Shape.enumReferencePointCalculationMethod.Centroid) {

                // Set to have a reference point with values ...
                blnHasCalculatedReferencePoints = true;

                // Stop checking ...
                return false;
            }
        });
    }

    return blnHasCalculatedReferencePoints;
}


// **************************************************************************
// FUNCTION: ReferencePointsWithValues
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.ReferencePointsWithValues = function ReferencePointsWithValues(blnIgnoreCalculatedReferencePoints) {

    // Get the instance ...
    var objShape = this;

    // Create a new array to return ...
    var arrReferencePointsWithValues = [];

    // When the shape has reference points ...
    if (objShape.HasReferencePoints()) {

        // Loop through all the reference points ...
        $.each(objShape.ReferencePoints, function (intReferencePoint, objReferencePoint) {

            // When reference point has values and we are not to ignore calculated 
            // referencve point or the calculation method is not centroid ...
            if (objReferencePoint.HasValues && ((!blnIgnoreCalculatedReferencePoints) || (objReferencePoint.CalculationMethod != TrimbleMap.Shape.enumReferencePointCalculationMethod.Centroid))) {

                // Add it to the array ...
                arrReferencePointsWithValues.push(objReferencePoint);
            }
        });
    }

    return arrReferencePointsWithValues;
}


// **************************************************************************
// FUNCTION: ReferencePointsWithoutValues
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.ReferencePointsWithoutValues = function ReferencePointsWithoutValues() {

    // Get the instance ...
    var objShape = this;

    // Create a new array to return ...
    var arrReferencePointsWithoutValues = [];

    // When the shape has reference points ...
    if (objShape.HasReferencePoints()) {

        // Loop through all the reference points ...
        $.each(objShape.ReferencePoints, function (intReferencePoint, objReferencePoint) {

            // Add the reference point when it has no values and is not calculated ...
            if ((!objReferencePoint.HasValues) && (objReferencePoint.CalculationMethod != TrimbleMap.Shape.enumReferencePointCalculationMethod.Centroid)) { arrReferencePointsWithoutValues.push(objReferencePoint); }
        });
    }

    return arrReferencePointsWithoutValues;
}

// **************************************************************************
// FUNCTION: UpdateCalculatedReferencePoints
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.UpdateCalculatedReferencePoints = function UpdateCalculatedReferencePoints(objMapController) {

    // Get the instance ...
    var objShape = this;

    // When the shape has reference points ...
    if (objShape.HasReferencePoints()) {

        // Loop through all the reference points ...
        $.each(objShape.ReferencePoints, function (intReferencePoint, objReferencePoint) {

            // When the reference point is to be calculated as the centroid ...
            if (objReferencePoint.CalculationMethod == TrimbleMap.Shape.enumReferencePointCalculationMethod.Centroid) {

                // When the shape has coordinates ...
                if (objShape.HasCoordinates()) {
                    var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(objShape.SpatialReferenceID);

                    // When the geometry Type is a point
                    if (objShape.GeometryType == TrimbleMap.Shape.enumGeometryType.POINT) {

                        //If there is only 1 coordinate
                        if (objShape.CountCoordinates() == 1) {
                            var objEsriCentroidPoint = new esri.geometry.Point(objShape.Parts[0].Coordinates[0].X, objShape.Parts[0].Coordinates[0].Y, objEsriSpatialReference);

                        } else {
                            var objEsriMultiPoint = objShape.ToEsriMultiPoint(objMapController)
                            var objEsriCentroidPoint = objEsriMultiPoint.getExtent().getCenter();
                        }

                        //Geometry is a polyline
                    } else if (objShape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYLINE) {
                        var objEsriPolyline = objShape.ToEsriPolyline(objMapController);
                        var objEsriCentroidPoint = objEsriPolyline.getExtent().getCenter();

                    } else if (objShape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) {
                        // Convert the shape to an esri polygon ...
                        var objEsriPolygon = objShape.ToEsriPolygon(objMapController, null, true);

                        // When we have a polygon ...
                        if (objEsriPolygon) {

                            var objEsriCentroidPoint = undefined;

                            //if we have one ring, get the centroid
                            //getCentroid() returns the centre of a polygon with 1 ring, for multiple rings it will return the center of the largest
                            if (objEsriPolygon.rings.length > 0) {
                                //otherwise, get the center of the polygon
                                var objDeferred = objShape.GetPolygonCentroid(JSON.stringify(objEsriPolygon.toJson()));

                                //parse the json
                                objDeferred.then(function (objCentroid) { objEsriCentroidPoint = JSON.parse(objCentroid) });
                            }
                        }

                    }

                    // When we have a centroid ...
                    if (objEsriCentroidPoint) {

                        // Set the X and Y of the reference point ...
                        objReferencePoint.HasValues = true;
                        objReferencePoint.X = objEsriCentroidPoint.x;
                        objReferencePoint.Y = objEsriCentroidPoint.y;

                    } else {

                        // Set to not have any values ...
                        objReferencePoint.HasValues = false;
                    }


                } else {

                    // Set to not have any values ...
                    objReferencePoint.HasValues = false;
                }
            }
        });
    }
}

// **************************************************************************
// FUNCTION: GetPolygonCentroid
// USAGE: Gets the centroid of the polygon using the weighting of the area
// **************************************************************************
TrimbleMap.Shape.GetPolygonCentroid = function GetPolygonCentroid(strPolygonJson) {

    // Get the instance ...
    var objShape = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Call the web service to get the centroid ...
    $.ajax({
        type: "Post",
        url: TrimbleMap.Controller.Shared.SiteBaseUrl() + '/ServiceGetPolygonCentroid.aspx',
        data: strPolygonJson,
        dataType: 'text',
        success: function (data, textStatus, jqXHR) { objDeferred.resolve(data); },
        error: function (data, textStatus, jqXHR) { objDeferred.reject(); },
        async: false,
        cache: false
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: EnsureCorrectRingOrientation
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.EnsureCorrectRingOrientation = function EnsureCorrectRingOrientation() {

    // Get the instance ...
    var objShape = this;

    // Loop through the exterior parts ...
    $.each(objShape.Parts, function (intExteriorPart, objExteriorPart) {

        // Ensure that the ring orientation is correct for the exterior part ...
        objExteriorPart.Coordinates = TrimbleMap.ShapePart.Shared.FixRingOrientation(objExteriorPart.Coordinates, TrimbleMap.Shape.enumInteriorOrExterior.Exterior);

        // When the part has interior parts ...
        if ((typeof objExteriorPart.InteriorParts != 'undefined') && objExteriorPart.InteriorParts) {

            // Loop through all the parts ...
            $.each(objExteriorPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Ensure that the ring orientation is correct for the interior part ...
                objInteriorPart.Coordinates = TrimbleMap.ShapePart.Shared.FixRingOrientation(objInteriorPart.Coordinates, TrimbleMap.Shape.enumInteriorOrExterior.Interior);
            });
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculateAreaSquareKm:
// USAGE    dicCoordinatesToReplace are optional by default there are no coordinates to replace ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.CalculateAreaSquareKm = function CalculateAreaSquareKm(objMapController, dicCoordinatesToReplace) {

    // Get the instance ...
    var objShape = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we have polygon ...
    if ((objShape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) || (objShape.GeometryType == TrimbleMap.Shape.enumGeometryType.MIXED)) {

        // Get an object containing the geometries with each geometry containing the rings for an exterior part and all it's interior parts ...
        var arrExteriorAndInteriorPartsGeometries = objShape.GetExteriorAndInteriorPartsGeometries(objMapController, dicCoordinatesToReplace, true);

        // Include geometries that are polygons only
        // Other geometries types exist in the array (arrExteriorAndInteriorPartsGeometries) when a user manually enters coordinates
        // For example when adding a new part and entering the first coordinate, at that type the geometry is a point still
        arrExteriorAndInteriorPartsGeometries = $.grep(arrExteriorAndInteriorPartsGeometries, function (objGeometry, intGeometry) { return objGeometry.Geometry !== null && objGeometry.Geometry.type === TrimbleMap.Shape.enumGeometryType.POLYGON.toLowerCase(); });

        // Cut the overlapping area exclusion polygons ...
        TrimbleMap.Shape.Shared.CutOverlappingAreaExclusionPolygons(objMapController, arrExteriorAndInteriorPartsGeometries, objShape.SpatialReferenceID).then(TrimbleMap.Controller.Shared.TrapException(function (arrExteriorAndInteriorPartsGeometriesAreaExclusionsRemoved) {

            // Geometry has parts that has an area which has not been completely clipped
            var blnHasRings = false;

            $.each(arrExteriorAndInteriorPartsGeometriesAreaExclusionsRemoved, function (intPart, objPart) {

                if (objPart.Geometry && objPart.Geometry.rings && objPart.Geometry.rings.length > 0) {
                    blnHasRings = true;
                }
            });
            //Don't calculate area if there is no shape
            if (blnHasRings) {
                // Calculate the area ...
                TrimbleMap.Shape.Shared.CalculateAreaSquareKm(objMapController, arrExteriorAndInteriorPartsGeometriesAreaExclusionsRemoved, objShape.SpatialReferenceID).then(TrimbleMap.Controller.Shared.TrapException(function (objArea) {

                    // Resolve with the result ...
                    objDeferred.resolve(objArea);
                }));
            } else {

                // Resolve with no result ...
                objDeferred.resolve(null);
            }
        }));

    } else {

        // Resolve with no result ...
        objDeferred.resolve(null);
    }

    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculateDistanceKm:
// USAGE    dicCoordinatesToReplace are optional by default there are no coordinates to replace ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.CalculateDistanceKm = function CalculateDistanceKm(objMapController, dicCoordinatesToReplace) {

    // Get the instance ...
    var objShape = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we polyline ...
    if ((objShape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYLINE) || (objShape.GeometryType == TrimbleMap.Shape.enumGeometryType.MIXED)) {

        // Get the exterior part geometries ...
        var objExteriorPartGeometries = objShape.GetExteriorPartsGeometries(objMapController, dicCoordinatesToReplace);

        // Geometry has paths
        var blnHasPaths = false;

        //Only calculate the distance if we have at least two points
        if (objExteriorPartGeometries) {
            $.each(objExteriorPartGeometries, function (intExteriorPart, objExteriorPartGeometry) {
                blnHasPaths = objExteriorPartGeometry && objExteriorPartGeometry.paths && objExteriorPartGeometry.paths[0].length > 1;
            });
        }

        if (blnHasPaths) {
            // Calculate the distance ...        
            TrimbleMap.Shape.Shared.CalculateDistanceKm(objMapController, objExteriorPartGeometries, objShape.SpatialReferenceID).then(TrimbleMap.Controller.Shared.TrapException(function (objDistance) {

                // Resolve with the result ...
                objDeferred.resolve(objDistance);
            }));
        } else {
            // Resolve with no result ...
            objDeferred.resolve(null);
        }

    } else {

        // Resolve with no result ...
        objDeferred.resolve(null);
    }

    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SortPartsByName : 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.SortPartsByName = function SortPartsByName() {

    // Get the instance ...
    var objShape = this;

    // Sort the parts by name ...
    TrimbleMap.Shape.Shared.SortPartsByName(objShape.Parts);

    // Loop through the exterior parts ...
    $.each(objShape.Parts, function (intExteriorPart, objExteriorPart) {

        // Sort the interior parts by name ...
        TrimbleMap.Shape.Shared.SortPartsByName(objExteriorPart.InteriorParts);
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION MergeParts : Merges the touching or overlapping parts ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.MergeParts = function MergeParts(objMapController, blnRemoveCoordinatesAlongStraightLine) {

    // Get the instance ...
    var objShape = this;

    // When this is not a point shape ...
    if (objShape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) {

        // Create arrays for the parts, and the merged parts ...
        var arrParts = [];
        var arrMergedParts = [];

        // Loop through all the exterior parts ...
        $.each(objShape.Parts, function (intPart, objPart) {

            // When at least 3 coordiantes (throw away lines and points if any) ...
            if (objPart.Coordinates.length >= 3) {

                // Create a geometry containing the exterior and interior parts and add it and and the part name to the array  ...
                arrParts.push({
                    Geometry: objShape.GetExteriorAndInteriorPartsGeometry(objMapController, objPart, {}, true).Geometry,
                    PartName: objPart.PartName
                });
            }
        });

        // Grab the first part geometry and name ...
        var objPart = arrParts.pop();

        // Add it to the merged part list ...
        arrMergedParts.push(objPart);

        // Start with the first part geometry as the merged all parts geometry ...
        var objMergedAllPartsGeometry = objPart.Geometry;

        // While we have more parts to merge ...
        while (arrParts.length > 0) {

            // Grab the next part geometry and name ...
            objPart = arrParts.pop();

            // When touching or overlapping the parts that we have already looked at ... 
            if (!esri.geometry.geometryEngine.disjoint(objPart.Geometry, objMergedAllPartsGeometry)) {

                // Loop through all the merged parts ...
                for (var intMergedPart = arrMergedParts.length - 1; intMergedPart >= 0; intMergedPart--) {

                    // Get the part geometry ...
                    var objMergedPart = arrMergedParts[intMergedPart];

                    // When touching or overlapping the part ... 
                    if (!esri.geometry.geometryEngine.disjoint(objPart.Geometry, objMergedPart.Geometry)) {

                        // Union the part geometries ...
                        objPart.Geometry = esri.geometry.geometryEngine.union(objPart.Geometry, objMergedPart.Geometry);

                        // Set the part name to null be to be re-generated at the end ...
                        objPart.PartName = null;

                        // Remove the merged part from the array ...
                        arrMergedParts.splice(intMergedPart, 1);
                    }
                }
            }

            // Add the part to the array of merged parts ...
            arrMergedParts.push(objPart);

            // Merge the part's geometry into the all parts merged geometry ...
            objMergedAllPartsGeometry = esri.geometry.geometryEngine.union(objMergedAllPartsGeometry, objPart.Geometry);
        }

        // Clear the parts from the shape ...
        objShape.Parts = [];

        // Loop through all the merged parts ...
        $.each(arrMergedParts, function (intMergedPart, objMergedPart) {

            // Declare a variable for the exterior ring index and an array for the interior ring indexes ...

            var arrExteriorRings = [];
            var arrInteriorRings = [];

            // Loop through all the rings of the geometry ...
            $.each(objMergedPart.Geometry.rings, function (intRing, arrRingPoints) {

                // Calculate the area of the ring to determine the ring orientation ...
                var decRingArea = TrimbleMap.Geometry.Shared.CalculateRingArea(arrRingPoints);

                // When a negative area (must be an exterior ring) ...
                if (decRingArea <= 0) {

                    // Set the index as the exterior ring index ...
                    arrExteriorRings.push(intRing);

                } else {

                    // Add the index to the array of interior rings ...
                    arrInteriorRings.push(intRing);
                }
            });

            // Create a new part name when not set ...
            //objMergedPart.PartName = (objMergedPart.PartName != null) ? objMergedPart.PartName : objShape.DefaultNewPartName();
            var lstExteriorWithInteriors = [];
            var spatialReference = objMergedPart.Geometry.spatialReference;
            for (var intExteriorRingIndex = 0; intExteriorRingIndex < arrExteriorRings.length; intExteriorRingIndex++) {

                lstExteriorWithInteriors.push({
                    ExteriorRing: arrExteriorRings[intExteriorRingIndex],
                    InteriorRings: []
                });
                var exteriorRingGeometry = new esri.geometry.Polygon(objMergedPart.Geometry.rings[arrExteriorRings[intExteriorRingIndex]]);
                exteriorRingGeometry.spatialReference = spatialReference;
                for (var intInteriorRingIndex = arrInteriorRings.length - 1; intInteriorRingIndex >= 0; intInteriorRingIndex--) {
                    var interiorRingGeometry = new esri.geometry.Polygon(objMergedPart.Geometry.rings[arrInteriorRings[intInteriorRingIndex]]);
                    interiorRingGeometry.spatialReference = spatialReference;

                    if (esri.geometry.geometryEngine.contains(exteriorRingGeometry, interiorRingGeometry)) {
                        lstExteriorWithInteriors[intExteriorRingIndex].InteriorRings.push(arrInteriorRings[intInteriorRingIndex]);
                        arrInteriorRings.splice(intInteriorRingIndex, 1);
                    }
                }
            }



            $.each(lstExteriorWithInteriors, function (intExteriorRingObjectIndex, objExteriorWithInteriors) {
                var objExteriorPart = TrimbleMap.ShapePart.CreateInstance(objShape.DefaultNewPartName(), SD.Guid.Shared.NewID());

                objExteriorPart.Coordinates = TrimbleMap.ShapePart.Shared.CoordinatesFromRing(objMergedPart.Geometry.rings[objExteriorWithInteriors.ExteriorRing], true);
                objShape.AddPart(objExteriorPart, null);

                $.each(objExteriorWithInteriors.InteriorRings, function (intInteriorRing, intInteriorRingIndex) {

                    // Create the interior part to add ...
                    var objInteriorPart = TrimbleMap.ShapePart.CreateInstance(objShape.DefaultNewPartName(objExteriorPart), SD.Guid.Shared.NewID());

                    // Extract the exterior ring coordinates from the geometry and set it on the part ...
                    objInteriorPart.Coordinates = TrimbleMap.ShapePart.Shared.CoordinatesFromRing(objMergedPart.Geometry.rings[intInteriorRingIndex], true);

                    // Add the interior part to the exterior part ...
                    objShape.AddPart(objInteriorPart, objExteriorPart);
                });
            });

        });

        // Round the coordinates of the shape to the number of decimal places for the spatial reference ...
        objShape.RoundCoordinates(objMapController);

        if (blnRemoveCoordinatesAlongStraightLine === true) {

            // Remove coordinates along a straight line ...
            objShape.RemoveCoordinatesAlongStraightLine(objMapController);
        }

        // Sort the parts by name ...
        objShape.SortPartsByName();
    }
}

// **************************************************************************
// FUNCTION: PartOverlapsOtherParts
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.PartOverlapsOtherParts = function PartOverlapsOtherParts(objMapController, guidPart, arrPartsToTest, dicCoordinatesToReplace) {

    // Get the instance ...
    var objShape = this;

    // Start with not overlapping ...
    var blnPartOverlapsOtherParts = false;

    // Get the part by id ...
    var objPart = objShape.GetPartByID(guidPart);

    // Determine whether or not it's an exterior part ...
    var blnIsExteriorPart = objShape.IsExteriorPart(objPart);

    // Get the part's geometry ...
    var objGeometry = (blnIsExteriorPart) ?
        objShape.GetExteriorAndInteriorPartsGeometry(objMapController, objPart, dicCoordinatesToReplace, true).Geometry :
        objShape.GetPartGeometry(objMapController, objPart, dicCoordinatesToReplace);

    // Ensure we have the correct ring orientation (clockwise) ...
    if (objGeometry.type == 'polygon') { objGeometry.rings[0] = TrimbleMap.Geometry.Shared.FixRingOrientation(objGeometry.rings[0], TrimbleMap.Shape.enumInteriorOrExterior.Exterior); }

    // Loop through all the parts of the shape ...
    $.each(arrPartsToTest, function (intOtherPart, objOtherPart) {

        // When not the part itself ...
        if (guidPart != objOtherPart.ID) {

            // Get the other part's geometry ...
            var objOtherGeometry = (blnIsExteriorPart) ?
                objShape.GetExteriorAndInteriorPartsGeometry(objMapController, objOtherPart, dicCoordinatesToReplace, true).Geometry :
                objShape.GetPartGeometry(objMapController, objOtherPart, dicCoordinatesToReplace);

            // Ensure we have the correct ring orientation (clockwise) ...
            if (objOtherGeometry.type == 'polygon') { objOtherGeometry.rings[0] = TrimbleMap.Geometry.Shared.FixRingOrientation(objOtherGeometry.rings[0], TrimbleMap.Shape.enumInteriorOrExterior.Exterior); }

            // When the part and the other part's geometry intersects ...
            if (esri.geometry.geometryEngine.intersect(objGeometry, objOtherGeometry)) {

                // Set to overlap ...
                blnPartOverlapsOtherParts = true;

                // Stop looping ...
                return false;
            }
        }
    });

    return blnPartOverlapsOtherParts;
}

// **************************************************************************
// FUNCTION: PartContainsAllItsInteriorParts
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.PartContainsAllItsInteriorParts = function PartContainsAllItsInteriorParts(objMapController, guidPart, dicCoordinatesToReplace) {

    // Get the instance ...
    var objShape = this;

    // Set to contain all the interior parts ...
    var blnPartContainsAllItsInteriorParts = true;

    // Get the part by id ...
    var objExteriorPart = objShape.GetPartByID(guidPart);

    // When the part has interior parts ...
    if ((objExteriorPart.InteriorParts != null) & (objExteriorPart.InteriorParts != 'undefined')) {

        // Get the part's geometry ...
        var objExteriorPartGeometry = objShape.GetPartGeometry(objMapController, objExteriorPart, dicCoordinatesToReplace);

        // Ensure we have the correct ring orientation (clockwise)...
        if (objExteriorPartGeometry.type == 'polygon') { objExteriorPartGeometry.rings[0] = TrimbleMap.Geometry.Shared.FixRingOrientation(objExteriorPartGeometry.rings[0], TrimbleMap.Shape.enumInteriorOrExterior.Exterior); }

        // Loop through all the parts of the shape ...
        $.each(objExteriorPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

            // Get the part's geometry ...
            var objInteriorPartGeometry = objShape.GetPartGeometry(objMapController, objInteriorPart, dicCoordinatesToReplace);

            // Ensure we have the correct ring orientation (clockwise)...
            if (objInteriorPartGeometry.type == 'polygon') { objInteriorPartGeometry.rings[0] = TrimbleMap.Geometry.Shared.FixRingOrientation(objInteriorPartGeometry.rings[0], TrimbleMap.Shape.enumInteriorOrExterior.Exterior); }

            // When the interior part is not completely inside the exterior part and that the the interior and exterior part shares more than a single vertex ...
            if (!esri.geometry.geometryEngine.relate(objExteriorPartGeometry, objInteriorPartGeometry, 'TT*FFTFF*') && !esri.geometry.geometryEngine.relate(objExteriorPartGeometry, objInteriorPartGeometry, '****0****')) {

                // Set to overlap ...
                blnPartContainsAllItsInteriorParts = false;

                // Stop looping ...
                return false;
            }
        });
    }

    return blnPartContainsAllItsInteriorParts;
}

// **************************************************************************
// FUNCTION: DefaultNewPartName
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.DefaultNewPartName = function DefaultNewPartName(objExteriorPart) {

    // Get the instance ...
    var objShape = this;

    // When do not have an exterior part ...
    if (!objExteriorPart) {

        // Point
        // Part
        var strPartTranslation = (objShape.GeometryType == TrimbleMap.Shape.enumGeometryType.POINT) ? SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Point') : SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Part');

        // Start at 'Part 1' ...
        var intPart = 1;

        // Build the initial part name to check ...
        var strPartName = strPartTranslation + ' ' + String(objShape.Parts.length + intPart);

        // While the part name exists ...
        while (!objShape.PartNameIsUnique(strPartName)) {

            // Increment the part index ...
            intPart++;

            // Build the part name to check ...
            strPartName = strPartTranslation + ' ' + String(intPart);
        }

    } else {

        // Exclusion
        var strExclusionTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Exclusion');

        // Start at 'Exclusion 1' ...
        var intExclusionPart = 1;

        // Build the initial part name to check ...
        var strPartName = objExteriorPart.PartName + ', ' + strExclusionTranslation + ' ' + String(intExclusionPart);

        // When the part has interior parts ...
        if ((typeof objExteriorPart.InteriorParts != 'undefined') && objExteriorPart.InteriorParts) {

            // While the part name exists ...
            while (!TrimbleMap.Shape.Shared.PartNameIsUnique(objExteriorPart.InteriorParts, strPartName)) {

                // Increment the part index ...
                intExclusionPart++;

                // Build the part name to check ...
                var strPartName = objExteriorPart.PartName + ', ' + strExclusionTranslation + ' ' + String(intExclusionPart);
            }
        }
    }

    return strPartName;
}

// **************************************************************************
// FUNCTION: PartNameIsUnique
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.PartNameIsUnique = function PartNameIsUnique(arrParts, strPartName, objPartToIgnore) {

    // Convert the part name to lower case ...
    var strLowerCasePartName = strPartName.toLowerCase();

    // Start with being unique ...
    var blnUnique = true;

    // Loop through all the parts ...
    $.each(arrParts, function (intPart, objPart) {

        // When we have no part to ignore or when it's not 
        // the part to ignore and the part name matches ...
        if (((typeof objPartToIgnore == 'undefined') || (objPartToIgnore != objPart)) && (objPart.PartName.toLowerCase() == strLowerCasePartName)) {

            // Set to already exist ...
            blnUnique = false;

            // Stop searching ...
            return false;
        }
    });

    return blnUnique;
}

// **************************************************************************
// FUNCTION: GetPartIndex
// USAGE:    Returns -1 when not found ...
// **************************************************************************
TrimbleMap.Shape.Shared.GetPartIndex = function GetPartIndex(arrParts, objShapePart) {

    // Get the instance ...
    var objShape = this;

    // Start with not found ...
    var intPart = -1;

    // Loop through all the parts ...
    $.each(arrParts, function (intPartToCheck, objPartToCheck) {

        // When the ID matches ...
        if (objShapePart.ID == objPartToCheck.ID) {

            // Set to return the part index ...
            intPart = intPartToCheck;

            // Stop searching ...
            return false;
        }
    });

    return intPart;
}

// **************************************************************************
// FUNCTION: DecimalPlacesForSpatialReference
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.DecimalPlacesForSpatialReference = function DecimalPlacesForSpatialReference(objMapController, guidSpatialReference) {

    // Get the spatial reference information ...
    var objSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

    // Get the number of decimal places ...
    var intDecimalPlaces = objSpatialReference.DecimalPlaces;

    return intDecimalPlaces;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculatePartArea: Calculates the area of a part ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.Shared.CalculatePartArea = function CalculatePartArea(arrCoordinates) {

    // Start with an area of 0 ...
    var dblArea = 0;

    // Loop through all the coordinates of the part ...
    for (var intCoordinate = 0; intCoordinate < arrCoordinates.length; intCoordinate++) {

        // Get the coordinate ...
        var objCoordinate = arrCoordinates[intCoordinate];

        // Get next the coordinate ...
        var objNextCoordinate = arrCoordinates[(intCoordinate + 1) % arrCoordinates.length];

        // Add to the area ...
        dblArea += (objCoordinate.X * objNextCoordinate.Y) - (objNextCoordinate.X * objCoordinate.Y);
    }

    // Divide by 2 ...
    dblArea /= 2.0;

    return dblArea;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CutOverlappingAreaExclusionPolygons : Cuts out the overlapping exclusion areas from the geometry ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.Shared.CutOverlappingAreaExclusionPolygons = function CutOverlappingAreaExclusionPolygons(objMapController, arrExteriorAndInteriorPartsGeometries, guidSpatialReference) {

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Determine whether or not we have an area exclusion dataset ...
    var blnHaveAreaExclusionSpatialDataset = (typeof objMapController.State.AreaExclusionSpatialDatasetURL != 'undefined') &&
        (objMapController.State.AreaExclusionSpatialDatasetURL != null) &&
        ((objMapController.State.AreaExclusionSpatialDatasetURL).trim() != '');

    // When we have an area exclusion dataset and it loaded successfully...
    if (blnHaveAreaExclusionSpatialDataset && objMapController.State.AreaExclusionSpatialDatasetURLLoadedSuccessfully) {

        // Get the esri spatial reference ...
        var objEsriSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

        // Map arrExteriorAndInteriorPartsGeometries to an array containing only the geometries ...
        var arrGeometries = $.map(arrExteriorAndInteriorPartsGeometries, function (objExteriorAndInteriorPartsGeometry, intExteriorAndInteriorPartsGeometry) { return objExteriorAndInteriorPartsGeometry.Geometry; });

        // Project the geometries to the spatial reference of area exclusion dataset ...
        var objProjectGeometryDeferred = objMapController.ProjectGeometries(arrGeometries, guidSpatialReference, objMapController.State.AreaExclusionSpatialReferenceID, false, TrimbleMap.enumProjectionLevel.CRITICAL);

        // When Projected ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

            // Combine all the rings from all the polygons into a single polygon ...
            var objCombinedProjectedGeometry = TrimbleMap.Geometry.Shared.CombinePolygons(arrProjectedGeometries, objMapController.CreateEsriSpatialReference(objMapController.State.AreaExclusionSpatialReferenceID));

            // Create the query parameters object ...
            var objQuery = new esri.tasks.Query();

            // Create the query task on the area exclusion dataset ...
            var objQueryTask = new esri.tasks.QueryTask(objMapController.State.AreaExclusionSpatialDatasetURL);

            // Set the query parameters ...
            objQuery.geometry = objCombinedProjectedGeometry;
            objQuery.returnGeometry = true;
            objQuery.outFields = [];

            // Execute the query task ...
            var objQueryTaskDeferred = objQueryTask.execute(objQuery);

            // When the query task returns ...
            objQueryTaskDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objFeatureSet) {

                // When we have any overlaps ...
                if (objFeatureSet.features.length > 0) {

                    // Loop through all the features in the feature set ...
                    $.each(objFeatureSet.features, function (intFeature, objFeature) {

                        // Create a new esri polygon by part id map ...
                        var arrClippedGeometries = [];

                        // Loop through all the geometries ...
                        $.each(arrProjectedGeometries, function (intExteriorPart, objExteriorPartGeometry) {

                            // Clip the overlapping area exclusion feature from the geometry (when not null) ...
                            var objClippedGeometry = (objExteriorPartGeometry != null) ? esri.geometry.geometryEngine.difference(objExteriorPartGeometry, objFeature.geometry) : null;

                            // Add to the array ...
                            arrClippedGeometries.push(objClippedGeometry);
                        });

                        // Replace the geometries array with the clipped geometries array ...
                        arrProjectedGeometries = arrClippedGeometries;
                    });

                    // Map all the geometrtries that have been clipped away to new empty polygons ...
                    arrProjectedGeometries = $.map(arrProjectedGeometries, function (objProjectedGeometry, intProjectedGeometry) {
                        return (objProjectedGeometry != null) ? objProjectedGeometry : new esri.geometry.Polygon(objCombinedProjectedGeometry.spatialReference);
                    });

                    // Project the resultant geometry to the spatial reference of the shape ...
                    var objProjectResultGeometryDeferred = objMapController.ProjectGeometries(arrProjectedGeometries, objMapController.State.AreaExclusionSpatialReferenceID, guidSpatialReference, false, TrimbleMap.enumProjectionLevel.CRITICAL);

                    // When projected ...
                    objProjectResultGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (arrResultGeometries) {

                        // Create a new array to contain the results ...
                        var arrResultExteriorAndInteriorPartsGeometries = [];

                        // Loop through all the result geometries ...
                        $.each(arrResultGeometries, function (intExteriorPart, objResultExteriorPartGeometry) {

                            // Get the corresponding geometry and part id object ...
                            var objGeometriesAndExtriorPartID = arrExteriorAndInteriorPartsGeometries[intExteriorPart];

                            // Create and add a new object containg the result geometry and exterior part id ...
                            arrResultExteriorAndInteriorPartsGeometries.push({
                                Geometry: objResultExteriorPartGeometry,
                                ExteriorPartID: objGeometriesAndExtriorPartID.ExteriorPartID
                            });
                        });

                        // Resolve the deferred with the results ...
                        objDeferred.resolve(arrResultExteriorAndInteriorPartsGeometries);
                    }));

                } else {

                    // Resolve the deferred with the input geometry ...
                    objDeferred.resolve(arrExteriorAndInteriorPartsGeometries);
                }

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                // Get the title and message translations ...

                // Unable to test for overlaps with the area exclusion polygons
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToTestOverlapsTitle');

                // The query to find overlapping area exclusion polygons failed
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToTestOverlapsMessage');

                // Unable to test for overlaps with the area exclusion polygons
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToTestOverlapsEndUserMessage');

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, TrimbleMap.Controller.Shared.BuildCrashMessage(objError), strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, TrimbleMap.Controller.Shared.BuildEsriRequestUrl(objMapController.LastEsriRequestIOArgs));

                // Reject the deferred with the error ... 
                objDeferred.reject(objError);
            }));
        }));

    } else {

        // When an area exclusion was configured but we weren't able to connect
        if (objMapController.State.AreaExclusionSpatialReferenceID != SD.Guid.Shared.Empty() && !objMapController.State.AreaExclusionSpatialDatasetURLLoadedSuccessfully) {

            // Get the title and message translations ...
            // Unable to test for overlaps with the area exclusion polygons
            var strTitle = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToTestOverlapsTitle');

            // The query to find overlapping area exclusion polygons failed
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToTestOverlapsMessage');

            // Unable to connect to the Spatial Dataset used for exclusions from the Area Calculation
            var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToTestOverlapsEndUserMessage');

            // Log the diagnostic message ...
            objMapController.LogDiagnosticMessage(strTitle, strMessage, strEndUserMessage, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, "");

            // Resolve with no area ...
            objDeferred.resolve(null);
        }
        else {

            // Resolve the deferred with the geometries as is ...
            objDeferred.resolve(arrExteriorAndInteriorPartsGeometries);
        }
    }

    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculateAreaSquareKm : Calculates the area of the polygon ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.Shared.CalculateAreaSquareKm = function CalculateAreaSquareKm(objMapController, arrExteriorAndInteriorPartsGeometries, guidSpatialReference) {

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Start with no non null exterior part geometries ...
    var objFirstNonNullExteriorPartGeometry = null;

    // Find the first non null exterior part geometry ...
    $.each(arrExteriorAndInteriorPartsGeometries, function (intExteriorPart, objExteriorPartAndID) {
        if (objExteriorPartAndID.Geometry && objExteriorPartAndID.Geometry.rings && objExteriorPartAndID.Geometry.rings.length > 0) { objFirstNonNullExteriorPartGeometry = objExteriorPartAndID.Geometry; return false; }
    });

    // When we have any parts with coordinates ...
    if (objFirstNonNullExteriorPartGeometry != null) {

        // Map arrExteriorAndInteriorPartsGeometries to an array containing only the geometries ...
        var arrGeometries = $.map(arrExteriorAndInteriorPartsGeometries, function (objExteriorAndInteriorPartsGeometry, intExteriorAndInteriorPartsGeometry) { return objExteriorAndInteriorPartsGeometry.Geometry; });

        // Get the spatial reference ...
        var objSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

        // Get the esri spatial reference ...
        var objEsriSpatialReference = objMapController.CreateEsriSpatialReference(guidSpatialReference);

        // Get the utm zone in which to calculate the area ...
        var objUTMCoordinateSystem = TrimbleMap.UTM.GetUTMCoordinateSystem(objFirstNonNullExteriorPartGeometry);

        // When the coordinates is in a geographic coordinate system ...
        if (objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC) {

            // Instantiate the spatial reference to which to reproject ...
            var objUTMProjection = new esri.SpatialReference(objUTMCoordinateSystem.wkt);

            //Create new object to hold Area in Degrees2
            var objPartAreaInDegrees2 = {};

            // Loop through the array of geometries ...
            for (var intGeom = 0; intGeom < arrGeometries.length; intGeom++) {

                if (arrGeometries[intGeom].type == "polygon") {
                    var dblArea = 0;

                    // Loop through all the rings of the geometry ...
                    for (var intRing = 0; intRing < arrGeometries[intGeom].rings.length; intRing++) {

                        // Calculate the area of the ring and add it to the total area ...
                        dblArea += TrimbleMap.Geometry.Shared.CalculateRingArea(arrGeometries[intGeom].rings[intRing]);
                    }
                }

                objPartAreaInDegrees2[intGeom] = Math.abs(dblArea);
            }

            // Project the geometries to the current spatial reference ...
            objMapController.ProjectGeometriesByPoints(arrGeometries, objEsriSpatialReference, objUTMProjection, null, null, null).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

                // Create a new array to contain the results ...
                var arrProjectedGeometriesAndExtriorPartID = [];

                // Loop through all the projected geometries ...
                $.each(arrProjectedGeometries, function (intExteriorPart, objProjectedExteriorPartGeometry) {

                    // Get the corresponding geometry and part id object ...
                    var objGeometriesAndExtriorPartID = arrExteriorAndInteriorPartsGeometries[intExteriorPart];

                    // Create and add a new object containing the result geometry and exterior part id ...
                    arrProjectedGeometriesAndExtriorPartID.push({
                        Geometry: objProjectedExteriorPartGeometry,
                        ExteriorPartID: objGeometriesAndExtriorPartID.ExteriorPartID
                    });
                });

                // Calculate the polygon and part area ...
                var objPolygonAndPartArea = TrimbleMap.Shape.Shared.CalculatePolygonAndPartAreaKm2(arrProjectedGeometriesAndExtriorPartID, 1, objUTMCoordinateSystem, objPartAreaInDegrees2);

                // Resolve the deferred with the result ...
                objDeferred.resolve(objPolygonAndPartArea);

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                // Unable to calculate area
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToCalculateArea');

                // Unable to project the coordinates to %1 and hence the area cannot be calculated.
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToProjectTheCoordinatesCannotCalculateArea', objUTMCoordinateSystem.Name);

                // Unable to project the coordinates to %1 and hence the area cannot be calculated.
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToProjectTheCoordinatesCannotCalculateArea', objUTMCoordinateSystem.Name);

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, objError.Message, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

                // Reject the deferred ...
                objDeferred.reject(objError);
            }));

        } else {

            var guidToSpatialReference = objMapController.GetUnderlyingGeographicSpatialReferenceID(guidSpatialReference);

            var objEsriBaseGeographicSpatialReference = objMapController.CreateEsriSpatialReference(guidToSpatialReference);

            // Project the geometries to the current spatial reference ...
            objMapController.ProjectGeometriesByPoints(arrGeometries, objEsriSpatialReference, objEsriBaseGeographicSpatialReference, null, null, null).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

                //Create new object to hold Area in Degrees2
                var objPartAreaInDegrees2 = {};

                // Loop through the array of geometries ...
                for (var intGeom = 0; intGeom < arrProjectedGeometries.length; intGeom++) {

                    if (arrProjectedGeometries[intGeom].type == "polygon") {
                        // Loop through all the rings of the geometry ...
                        for (var intRing = 0; intRing < arrProjectedGeometries[intGeom].rings.length; intRing++) {

                            // Calculate the area of the ring and add it to the total area ...
                            objPartAreaInDegrees2[intGeom] = Math.abs(TrimbleMap.Geometry.Shared.CalculateRingArea(arrProjectedGeometries[intGeom].rings[intRing]));
                        }
                    }
                }

                // Calculate the polygon and part area ...
                var objPolygonAndPartArea = TrimbleMap.Shape.Shared.CalculatePolygonAndPartAreaKm2(arrExteriorAndInteriorPartsGeometries,
                    objSpatialReference.ConversionFactorToMeters,
                    TrimbleMap.UTM.CreateCoordinateSystemResult(objSpatialReference.Name, objSpatialReference.WKT, true), objPartAreaInDegrees2);
                // Resolve the deferred with the result ...
                objDeferred.resolve(objPolygonAndPartArea);

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                // Unable to calculate area
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToCalculateArea');

                // Unable to project the coordinates to %1 and hence the area cannot be calculated.
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToProjectTheCoordinatesCannotCalculateArea', objUTMCoordinateSystem.Name);

                // Unable to project the coordinates to %1 and hence the area cannot be calculated.
                var strEndUserMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToProjectTheCoordinatesCannotCalculateArea', objUTMCoordinateSystem.Name);

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, objError.Message, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

                // Reject the deferred ...
                objDeferred.reject(objError);
            }));
        }
    } else {

        // Resolve with no area ...
        objDeferred.resolve(null);
    }

    // Return the deferred ..
    return objDeferred;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreatePolygonAndPartAreaResult: Create a polygon and part area result object
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.Shared.CreatePolygonAndPartAreaResult = function CreatePolygonAndPartAreaResult(dblAreaInKm2, dblAreaInDegrees2, objAreaByPartID, objCoordinateSystemCalculatedIn) {
    return {
        AreaInKm2: dblAreaInKm2,
        AreaInDegrees2: dblAreaInDegrees2,
        AreaByPartID: objAreaByPartID,
        CoordinateSystemCalculatedIn: objCoordinateSystemCalculatedIn
    };
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculatePolygonAndPartAreaKm2: Calculates the area of a polygon and each individual part ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.Shared.CalculatePolygonAndPartAreaKm2 = function CalculatePolygonAndPartAreaKm2(arrExteriorAndInteriorPartsGeometries, dblMetersPerUnit, objCoordinateSystemCalculatedIn, dicPartAreaInDegrees2) {

    // Create the result object to return (start with a polygon area of 0) ...
    var objPolygonAndPartArea = TrimbleMap.Shape.Shared.CreatePolygonAndPartAreaResult(0, 0, {}, objCoordinateSystemCalculatedIn);

    // Loop through all the geometries for the exterior parts with their interior parts ...
    $.each(arrExteriorAndInteriorPartsGeometries, function (intExteriorAndInteriorPartsGeometry, objExteriorAndInteriorPartsGeometry) {

        // When the geometry is not empty and when it is a polygon ...
        if ((objExteriorAndInteriorPartsGeometry.Geometry != null) && (objExteriorAndInteriorPartsGeometry.Geometry.type == 'polygon')) {

            // Calculate part polygon's area ...
            var dblPartAreaInKm2 = TrimbleMap.Geometry.Shared.CalculatePolygonAreaInKm2(objExteriorAndInteriorPartsGeometry.Geometry, dblMetersPerUnit);

            var objPartArea = { AreaInKm2: dblPartAreaInKm2, AreaInDegrees2: dicPartAreaInDegrees2[intExteriorAndInteriorPartsGeometry] }

            // Update the area for the part ...
            objPolygonAndPartArea.AreaByPartID[objExteriorAndInteriorPartsGeometry.ExteriorPartID] = objPartArea;

            // Add the part's area in Km2 to the polygon's area ...
            objPolygonAndPartArea.AreaInKm2 += dblPartAreaInKm2;

            // Add the part's area in Degrees2 to the polygon's area ...
            objPolygonAndPartArea.AreaInDegrees2 += dicPartAreaInDegrees2[intExteriorAndInteriorPartsGeometry];
        }
    });

    return objPolygonAndPartArea;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateShapeAndPartDistanceResult: Create a shape and part distance result object
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.Shared.CreateShapeAndPartDistanceResult = function CreateShapeAndPartDistanceResult(dblDistanceKm, objDistanceByPartID, objCoordinateSystemCalculatedIn) {
    return {
        DistanceInKm: dblDistanceKm,
        DistanceByPartID: objDistanceByPartID,
        CoordinateSystemCalculatedIn: objCoordinateSystemCalculatedIn
    };
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculateShapeAndPartDistanceKm2: Calculates the disnace of a polyline shape and each individual part ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.Shared.CalculateShapeAndPartDistanceKm2 = function CalculateShapeAndPartDistanceKm2(objExteriorPartGeometries, dblMetersPerUnit, objCoordinateSystemCalculatedIn) {

    // Create the result object to return (start with a distance of 0) ...
    var objShapeAndPartDistance = TrimbleMap.Shape.Shared.CreateShapeAndPartDistanceResult(0, {}, objCoordinateSystemCalculatedIn);

    // Loop through all the geometries for the exterior parts ...
    $.each(objExteriorPartGeometries, function (guidExteriorPart, objExteriorPartGeometry) {

        // When the geometry is not empty and when it is a polyline ...
        if ((objExteriorPartGeometry != null) && (objExteriorPartGeometry.type == 'polyline')) {

            // Calculate part polyline distance ...
            var dblPartDistanceInKm = TrimbleMap.Geometry.Shared.CalculatePolylineDistanceKm(objExteriorPartGeometry, dblMetersPerUnit);

            // Update the area for the part ...
            objShapeAndPartDistance.DistanceByPartID[guidExteriorPart] = dblPartDistanceInKm;

            // Add the part's distance to the shape's distance ...
            objShapeAndPartDistance.DistanceInKm += dblPartDistanceInKm;
        }
    });

    return objShapeAndPartDistance;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CalculateDistanceKm : Calculates the length of the polygon ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.Shape.Shared.CalculateDistanceKm = function CalculateDistanceKm(objMapController, objExteriorPartGeometries, guidSpatialReference) {

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Start with no non null exterior part geometries ...
    var objFirstNonNullGeometry = null;

    // Find the first non null exterior part geometry ...
    $.each(objExteriorPartGeometries, function (intExteriorPart, objExteriorPartGeometry) {
        if (objExteriorPartGeometry != null) { objFirstNonNullGeometry = objExteriorPartGeometry; return false; }
    });

    // When we have a non null exterior part geometry ...
    if (objFirstNonNullGeometry != null) {

        // Convert to an array of geometries ...
        var arrExteriorPartGeometries = [];
        var arrExteriorPartIDs = [];
        $.each(objExteriorPartGeometries, function (guidExteriorPart, objExteriorPartGeometry) { arrExteriorPartGeometries.push(objExteriorPartGeometry); arrExteriorPartIDs.push(guidExteriorPart); });

        // Get the spatial reference ...
        var objSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

        // When the coordinates is in a geographic coordinate system ...
        if (objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC) {

            // Instantiate the spatial reference in which it currently is ...
            var objCurrentEsriSpatialReference = objMapController.CreateEsriSpatialReference(objSpatialReference.SpatialReferenceID);

            // Get the utm zone in which to calculate the distance ...
            var objUTMCoordinateSystem = TrimbleMap.UTM.GetUTMCoordinateSystem(objFirstNonNullGeometry);

            // Instantiate the spatial reference to which to reproject ...
            var objUTMProjection = new esri.SpatialReference(objUTMCoordinateSystem.wkt);

            // Project the geometries to the current spatial reference ...
            objMapController.ProjectGeometriesByPoints(arrExteriorPartGeometries, objCurrentEsriSpatialReference, objUTMProjection, null, null, null).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedGeometries) {

                // Convert the array to an object with the geometries as properties with the part id as name ...
                var objProjectExteriorPartGeometries = {};
                $.each(arrProjectedGeometries, function (intProjectedExteriorPartGeometry, objProjectedExteriorPartGeometry) {
                    var strExteriorPartID = arrExteriorPartIDs[intProjectedExteriorPartGeometry];
                    objProjectExteriorPartGeometries[strExteriorPartID] = objProjectedExteriorPartGeometry;
                });

                // Calculate the distance ...
                var objShapeAndPartDistance = TrimbleMap.Shape.Shared.CalculateShapeAndPartDistanceKm2(objProjectExteriorPartGeometries, 1, objUTMCoordinateSystem);

                // Resolve the deferred with the result ...
                objDeferred.resolve(objShapeAndPartDistance);

            }), TrimbleMap.Controller.Shared.TrapException(function (strError) {

                // Unable to calculate distance
                var strTitle = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToCalculateDistance');

                // Unable to project the coordinates to %1 and hence the distance cannot be calculated.
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'UnableToProjectTheCoordinatesCannotCalculateDistance', objUTMCoordinateSystem.Name);

                // Unable to project the coordinates to %1 and hence the distance cannot be calculated.
                var strEndUserMessage = strMessage;

                // Log the diagnostic message ...
                objMapController.LogDiagnosticMessage(strTitle, strMessage, objError.Message, strEndUserMessage, TrimbleMap.enumDiagnosticMessageLevel.CRITICAL, null);

                // Reject the deferred ...
                objDeferred.reject(strError);
            }));

        } else {

            // Calculate the distance ...
            var objShapeAndPartDistance = TrimbleMap.Shape.Shared.CalculateShapeAndPartDistanceKm2(objExteriorPartGeometries,
                objSpatialReference.ConversionFactorToMeters,
                TrimbleMap.UTM.CreateCoordinateSystemResult(objSpatialReference.Name, objSpatialReference.WKT, true));

            // Resolve the deferred with the result ...
            objDeferred.resolve(objShapeAndPartDistance);
        }
    } else {

        // Resolve the deferred with null ...
        objDeferred.resolve(null);
    }

    // Return the deferred ..
    return objDeferred;
}

// **************************************************************************
// FUNCTION: PartsThatOverlaps
// USAGE:    Returns an array with the IDs of the parts that crosses the input geometry 
// **************************************************************************
TrimbleMap.Shape.Shared.PartsThatOverlaps = function PartsThatOverlaps(objPartGeometries, objEsriGeometry) {

    // Create a new array to return that will contain the part
    // ids of the parts that overlaps the input geometry ...
    var arrPartIDsThatOverlaps = [];

    // Loop through all the part geometries ...
    $.each(objPartGeometries, function (strPartID, objPartEsriGeometry) {

        // When the part geometry overlaps with the test geometry ...
        if (esri.geometry.geometryEngine.overlaps(objPartEsriGeometry, objEsriGeometry)) {

            // Add the part id ...
            arrPartIDsThatOverlaps.push(strPartID);
        }
    });

    return arrPartIDsThatOverlaps;
}

// **************************************************************************
// FUNCTION: PartsThatContains
// USAGE:    Returns an array with the IDs of the parts that contains the input geometry 
// **************************************************************************
TrimbleMap.Shape.Shared.PartsThatContains = function PartsThatContains(objPartGeometries, objEsriGeometry) {

    // Create a new array to return that will contain the part 
    // ids of the parts that contains the input geometry ...
    var arrPartIDsThatContains = [];

    // Loop through all the part geometries ...
    $.each(objPartGeometries, function (strPartID, objPartEsriGeometry) {

        // When the part geometry contains the test geometry ...
        if (esri.geometry.geometryEngine.contains(objPartEsriGeometry, objEsriGeometry)) {

            // Add the part id ...
            arrPartIDsThatContains.push(strPartID);
        }
    });

    return arrPartIDsThatContains;
}

// **************************************************************************
// FUNCTION: PartsWithin
// USAGE:    Returns an array with the IDs of the parts that are within the input geometry 
// **************************************************************************
TrimbleMap.Shape.Shared.PartsWithin = function PartsWithin(objPartGeometries, objEsriGeometry) {

    // Create a new array to return that will contain the part 
    // ids of the parts that are within the input geometry ...
    var arrPartIDsWithin = [];

    // Loop through all the part geometries ...
    $.each(objPartGeometries, function (strPartID, objPartEsriGeometry) {

        // When the part geometry is within the test geometry ...
        if (esri.geometry.geometryEngine.within(objPartEsriGeometry, objEsriGeometry)) {

            // Add the part id ...
            arrPartIDsWithin.push(strPartID);
        }
    });

    return arrPartIDsWithin;
}

// **************************************************************************
// FUNCTION: PartsThatTouches
// USAGE:    Returns an array with the IDs of the parts that touches the input geometry 
// **************************************************************************
TrimbleMap.Shape.Shared.PartsThatTouches = function PartsThatTouches(objPartGeometries, objEsriGeometry) {

    // Create a new array to return that will contain the part
    // ids of the parts that touches the input geometry ...
    var arrPartIDsThatTouches = [];

    // Loop through all the part geometries ...
    $.each(objPartGeometries, function (strPartID, objPartEsriGeometry) {

        // When the part geometry touches with the test geometry ...
        if (esri.geometry.geometryEngine.touches(objPartEsriGeometry, objEsriGeometry)) {

            // Add the part id ...
            arrPartIDsThatTouches.push(strPartID);
        }
    });

    return arrPartIDsThatTouches;
}

// **************************************************************************
// FUNCTION: PartsThatTouchesAsLines
// USAGE:    Returns an array with the IDs of the parts that touches the input geometry's boundary
// **************************************************************************
TrimbleMap.Shape.Shared.PartsThatTouchesAsLines = function PartsThatTouchesAsLines(objPartGeometries, objEsriGeometry) {

    // Find all teh parts that touches objEsriGeometry in line segments ...
    return TrimbleMap.Shape.Shared.PartsThatRelate(objPartGeometries, objEsriGeometry, '****1****');
}

// **************************************************************************
// FUNCTION: PartsThatTouchesAsLinesFromTheOutside
// USAGE:    Returns an array with the IDs of the parts that touches the 
//           input geometry's boundary from the outside ...
// **************************************************************************
TrimbleMap.Shape.Shared.PartsThatTouchesAsLinesFromTheOutside = function PartsThatTouchesAsLinesFromTheOutside(objPartGeometries, objEsriGeometry) {

    // Find all teh parts that touches objEsriGeometry from the outside in line segments ...
    return TrimbleMap.Shape.Shared.PartsThatRelate(objPartGeometries, objEsriGeometry, 'F*T*1*T**');
}

// **************************************************************************
// FUNCTION: PartsThatRelate
// USAGE:    Returns an array with the IDs of the parts that relate with objEsriGeometry
// **************************************************************************
TrimbleMap.Shape.Shared.PartsThatRelate = function PartsThatRelate(objPartGeometries, objEsriGeometry, strRelation) {

    // Create a new array to return that will contain the part
    // ids of the parts that touches the input geometry's boundary ...
    var arrPartIDsThatRelate = [];

    // Loop through all the part geometries ...
    $.each(objPartGeometries, function (strPartID, objPartEsriGeometry) {

        // When the part geometry relates with the test geometry ...
        if (esri.geometry.geometryEngine.relate(objPartEsriGeometry, objEsriGeometry, strRelation)) {

            // Add the part id ...
            arrPartIDsThatRelate.push(strPartID);
        }
    });

    return arrPartIDsThatRelate;
}

// **************************************************************************
// FUNCTION: ConvertCoordinatesFromValueArray
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.ConvertCoordinatesFromValueArray = function ConvertCoordinatesFromValueArray(arrValues) {

    // Create an array to return ...
    var arrCoordinate = [];

    // Compute the coordinate count ...
    var intCoordinates = arrValues.length / 2;

    // Start at the first value ...
    var intValue = 0;

    // Loop through all the coordinates ...
    for (var intCoordinate = 0; intCoordinate < intCoordinates; intCoordinate++) {

        // Create an object with the x and y values and add it to the array ...
        arrCoordinate.push({ X: arrValues[intValue++], Y: arrValues[intValue++] });
    }

    return arrCoordinate;
}

// **************************************************************************
// FUNCTION: ConvertCoordinatesToValueArray
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.ConvertCoordinatesToValueArray = function ConvertCoordinatesToValueArray(arrCoordinates) {

    // Create an array to return ...
    var arrValues = [];

    // Loop through all the coordinates ...
    $.each(arrCoordinates, function (intCoordinate, objCoordinate) {

        // Add the x and y values ...
        arrValues.push(objCoordinate.X);
        arrValues.push(objCoordinate.Y);
    });

    // Return the values ...
    return arrValues;
}

// **************************************************************************
// FUNCTION: UnpackPartCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.UnpackPartCoordinates = function UnpackPartCoordinates(arrPart) {

    // Loop through all the parts ...
    $.each(arrPart, function (intPart, objPart) {

        // Convert from an array of values to an array of object with x and y properties ...
        objPart.Coordinates = TrimbleMap.Shape.Shared.ConvertCoordinatesFromValueArray(objPart.Coordinates);

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

            // Loop through all the interior parts ...
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Convert from an array of values to an array of object with x and y properties ...
                objInteriorPart.Coordinates = TrimbleMap.Shape.Shared.ConvertCoordinatesFromValueArray(objInteriorPart.Coordinates);
            });
        }
    });
}

// **************************************************************************
// FUNCTION: PackPartCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.PackPartCoordinates = function PackPartCoordinates(arrPart) {

    // Loop through all the parts ...
    $.each(arrPart, function (intPart, objPart) {

        // Convert from an array of values to an array of object with x and y properties ...
        objPart.Coordinates = TrimbleMap.Shape.Shared.ConvertCoordinatesToValueArray(objPart.Coordinates);

        // When the part has interior parts ...
        if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts) {

            // Loop through all the interior parts ...
            $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                // Convert from an array of values to an array of object with x and y properties ...
                objInteriorPart.Coordinates = TrimbleMap.Shape.Shared.ConvertCoordinatesToValueArray(objInteriorPart.Coordinates);
            });
        }
    });
}

// **************************************************************************
// FUNCTION: fromJson
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.fromJson = function fromJson(strShapeJson) {

    // Desrialize the shape json ...
    var objShape = JSON.parse(strShapeJson);

    // Unpack the coordinates ...
    if ((typeof objShape != 'undefined') && (objShape != null)) { TrimbleMap.Shape.Shared.UnpackPartCoordinates(objShape.Parts); }

    // When the shape is set, create a client side clone to include all the client side methods ...
    objShape = (objShape) ? TrimbleMap.Shape.CreateInstance(objShape.SpatialReferenceID,
        objShape.GeometryType,
        objShape.Parts,
        objShape.OfficialArea,
        objShape.OfficialAreaUnitID,
        objShape.OfficialLength,
        objShape.OfficialLengthUnitID,
        objShape.IsDynamic,
        objShape.DynamicShapeOptions,
        objShape.ReferencePoints,
        objShape.LegalDescription,
        objShape.OfficialAreaText,
        objShape.OfficialLengthText) : null;

    // Return the shape ..
    return objShape;
}

// **************************************************************************
// FUNCTION: ProjectShapes
// **************************************************************************
TrimbleMap.Shape.Shared.ProjectShapes = function ProjectShapes(arrShapes, objMapController, guidToSpatialReference, blnSimplify) {

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Create a new array for the deferred ...
    var arrProjectDeferred = [];

    // Loop through all the shapes ...
    $.each(arrShapes, function (intShape, objShape) {

        // Project the shape and add the deferred to an array ...
        arrProjectDeferred.push(objShape.Project(objMapController, guidToSpatialReference, blnSimplify))
    });

    // When all the projections are complete ...
    (new dojo.promise.all(arrProjectDeferred)).then(TrimbleMap.Controller.Shared.TrapException(function (arrProjectedShapes) {

        // Resolve the deferred with the projected shapes ...
        objDeferred.resolve(arrProjectedShapes);
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: fromJson
// **************************************************************************
TrimbleMap.Shape.Shared.ShapesAndSymbologyFromJson = function ShapesAndSymbologyFromJson(strShapesAndSymbologyJson) {

    // Parse the json ...
    var arrJsonShapesAndSymbology = JSON.parse(strShapesAndSymbologyJson);

    // Create a new array to return ...
    var arrShapesAndSymbology = [];

    // Loop through all the json shape and symbologies ...
    $.each(arrJsonShapesAndSymbology, function (intJsonShapesAndSymbology, objJsonShapesAndSymbology) {

        let objSymbol = null;

        if (objJsonShapesAndSymbology.Symbol) {
            if (objJsonShapesAndSymbology.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POINT) {
                objSymbol = new esri.symbol.SimpleMarkerSymbol(objJsonShapesAndSymbology.Symbol);
            } else if (objJsonShapesAndSymbology.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYLINE) {
                objSymbol = new esri.symbol.SimpleLineSymbol(objJsonShapesAndSymbology.Symbol);
            } else {
                objSymbol = new esri.symbol.SimpleFillSymbol(objJsonShapesAndSymbology.Symbol);
            }
        } else {
            objSymbol = null;
        }

        // Create and add a new shape and symbology object and desirialize the shape and symbology ...
        arrShapesAndSymbology.push({
            Shape: (objJsonShapesAndSymbology.Shape != null) ? TrimbleMap.Shape.Shared.fromJson(JSON.stringify(objJsonShapesAndSymbology.Shape)) : null,
            Symbol: objSymbol,
            ShapeID: objJsonShapesAndSymbology.Shape.ID
        });
    });

    return arrShapesAndSymbology;
}

// **************************************************************************
// FUNCTION: CloneReferencePoint
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.CloneReferencePoint = function CloneReferencePoint(objReferencePoint) {

    // Create and return a clone ...
    return {
        ID: objReferencePoint.ID,
        X: objReferencePoint.X,
        Y: objReferencePoint.Y,
        HasValues: objReferencePoint.HasValues,
        ReferencePointTypeID: objReferencePoint.ReferencePointTypeID,
        ReferencePointTypeName: objReferencePoint.ReferencePointTypeName,
        CalculationMethod: objReferencePoint.CalculationMethod
    };
}

// **************************************************************************
// FUNCTION: CloneDynamicShapeOptions
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.CloneDynamicShapeOptions = function CloneDynamicShapeOptions(objDynamicShapeOptions) {

    // Create and return a clone ...
    return {
        ConstructFromRelatedLicenses: objDynamicShapeOptions.ConstructFromRelatedLicenses,
        ConstructFromRelatedAgreements: objDynamicShapeOptions.ConstructFromRelatedAgreements,
        ConstructFromRelatedLicenseGroups: objDynamicShapeOptions.ConstructFromRelatedLicenseGroups,
        LicenseSearchID: objDynamicShapeOptions.LicenseSearchID,
        AgreementSearchID: objDynamicShapeOptions.AgreementSearchID,
        GroupSearchID: objDynamicShapeOptions.GroupSearchID,
        Buffer: objDynamicShapeOptions.Buffer,
        BufferDistance: objDynamicShapeOptions.BufferDistance,
        BufferDistanceUnitID: objDynamicShapeOptions.BufferDistanceUnitID,
        OfficialAreaOption: objDynamicShapeOptions.OfficialAreaOption,
        ShowRelatedAgreementSearchOptions: objDynamicShapeOptions.ShowRelatedAgreementSearchOptions,
        ShowRelatedLicenseSearchOptions: objDynamicShapeOptions.ShowRelatedLicenseSearchOptions,
        ShowRelatedLicenseGroupSearchOptions: objDynamicShapeOptions.ShowRelatedLicenseGroupSearchOptions,
        DerivedShapeGeometryType: objDynamicShapeOptions.DerivedShapeGeometryType
    };
}

// **************************************************************************
// FUNCTION: EsriGeometrTypeToGeometryType
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.EsriGeometrTypeToGeometryType = function EsriGeometrTypeToGeometryType(strEsriGeometrType) {

    if (!strEsriGeometrType) {
        strEsriGeometrType = '';
    }

    switch (strEsriGeometrType.toLowerCase()) {
        case 'esrigeometrypoint': return TrimbleMap.Shape.enumGeometryType.POINT; break;
        case 'esrigeometrymultipoint': return TrimbleMap.Shape.enumGeometryType.POINT; break;
        case 'esrigeometrypolygon': return TrimbleMap.Shape.enumGeometryType.POLYGON; break;
        case 'esrigeometrypolyline': return TrimbleMap.Shape.enumGeometryType.POLYLINE; break;
        default: return TrimbleMap.Shape.enumGeometryType.NONE;
    }

    return null;
}

// **************************************************************************
// FUNCTION: GeometryTypeToEsriGeometrType
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.GeometryTypeToEsriGeometrType = function GeometryTypeToEsriGeometrType(strGeometrType) {

    if (!strGeometrType) {
        strGeometrType = '';
    }

    switch (strGeometrType.toLowerCase()) {
        case 'point': return TrimbleMap.enumEsriGeometryType.Point; break;
        case 'multipoint': return TrimbleMap.enumEsriGeometryType.Point; break;
        case 'polygon': return TrimbleMap.enumEsriGeometryType.Polygon; break;
        case 'polyline': return TrimbleMap.enumEsriGeometryType.Polyline; break;
        default: return TrimbleMap.Shape.enumGeometryType.NONE;
    }

    return null;
}

// **************************************************************************
// FUNCTION: ToleranceForStraighLineRemoval
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.ToleranceForStraighLineRemoval = function ToleranceForStraighLineRemoval(objMapController, guidSpatialReference) {

    // Get the spatial reference ...
    var objSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

    // Return the tolerance to be used for the spatial reference type ...
    switch (objSpatialReference.SpatialReferenceType) {
        case TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC:
            return TrimbleMap.Shape.Shared.GEOGRAPHIC_TOLERANCE_VERTICES_ALONG_STRAIGHT_LINE;
            break;

        case TrimbleMap.enumSpatialReferenceType.PROJECTED:
            return TrimbleMap.Shape.Shared.PROJECTED_TOLERANCE_VERTICES_ALONG_STRAIGHT_LINE;
            break;
    }

    return null;
}

// **************************************************************************
// FUNCTION: ToleranceForSliverRemoval
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.ToleranceForSliverRemoval = function ToleranceForSliverRemoval(objMapController, guidSpatialReference) {

    // Get the spatial reference ...
    var objSpatialReference = objMapController.GetSpatialReference(guidSpatialReference);

    // Return the tolerance to be used for the spatial reference type ...
    switch (objSpatialReference.SpatialReferenceType) {
        case TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC:
            return TrimbleMap.Shape.Shared.GEOGRAPHIC_TOLERANCE_SLIVER;
            break;

        case TrimbleMap.enumSpatialReferenceType.PROJECTED:
            return TrimbleMap.Shape.Shared.PROJECTED_TOLERANCE_SLIVER;
            break;
    }

    return null;
}

// **************************************************************************
// FUNCTION: SortPartsByName
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.SortPartsByName = function SortPartsByName(arrParts) {

    // When we have parts ...
    if ((typeof arrParts != 'undefined') && arrParts) {

        // Sort the parts by name ...
        arrParts.sort(function SortByName(objPartA, objPartB) { return ((objPartA.PartName < objPartB.PartName) ? -1 : ((objPartA.PartName > objPartB.PartName) ? 1 : 0)); });
    }
}


// **************************************************************************
// FUNCTION: RemoveSliverParts
// USAGE:    
// **************************************************************************
TrimbleMap.Shape.Shared.RemoveSliverParts = function (objEsriGeometry, decOrdinateTolerance) {
    let lstParts = [];
    let objGeometry = null;

    if (objEsriGeometry.type == 'polygon') {
        // Creates a esri polygon geometry
        objGeometry = esri.geometry.Polygon(objEsriGeometry.spatialReference);

        // Loops through all the rings/parts of the geometry
        $.each(objEsriGeometry.rings, function (objPartIndex, objPart) {
            // Checks that the part is not a sliver
            if (!TrimbleMap.Shape.Shared.IsSliverPart(objPart, objEsriGeometry.type, objEsriGeometry.spatialReference, decOrdinateTolerance)) {
                // Adds the part to the geometry
                objGeometry.addRing(objPart);
            }
        });
    } else if (objEsriGeometry.type == 'polyline') {
        // Creates a esri polyline geometry
        objGeometry = esri.geometry.Polyline(objEsriGeometry.spatialReference);
    } else {
        // Creates a esri multipoint geometry
        objGeometry = esri.geometry.Multipoint(objEsriGeometry.spatialReference);
    }

    return objGeometry;
}

TrimbleMap.Shape.Shared.IsSliverPart = function (objPart, strGeometryType, objSpatialReference, decOrdinateTolerance) {
    let blnSliver = true;
    let objEsriGeometry = null;

    objPart = TrimbleMap.Shape.Shared.SnapCoordinates(objPart, decOrdinateTolerance);

    if (objPart && objPart.length > 0) {
        if (strGeometryType == 'polygon') {
            // Create an esri polygon geometry
            objEsriGeometry = esri.geometry.Polygon(objSpatialReference);
            // Add the passed in part parameter as a ring to the geometry
            objEsriGeometry.addRing(objPart);

            // Check the spatial reference of the part
            // WGS-84 (wkid: 4326) or Web Mercator Auxiliary Sphere (wkid: 3857)
            if (objSpatialReference.wkid == 4326 || objSpatialReference.wkid == 3857) {
                blnSliver = Math.abs(esri.geometry.geometryEngine.geodesicArea(objEsriGeometry)) <= 0.0000000000000001;
            } else {
                blnSliver = Math.abs(esri.geometry.geometryEngine.planarArea(objEsriGeometry)) <= 0.0000000000000001;
            }
        } else if (strGeometryType == 'polyline') {
            // Create an esri polyline geometry
            objEsriGeometry = esri.geometry.Polyline(objSpatialReference);
            // Add the passed in part parameter as a path to the geometry
            objEsriGeometry.addPath(objPart);

            // Check the spatial reference of the part
            // WGS-84 (wkid: 4326) or Web Mercator Auxiliary Sphere (wkid: 3857)
            if (objSpatialReference.wkid == 4326 || objSpatialReference.wkid == 3857) {
                blnSliver = Math.abs(esri.geometry.geometryEngine.geodesicLength(objEsriGeometry)) <= 0.0000000000000001;
            } else {
                blnSliver = Math.abs(esri.geometry.geometryEngine.planarLength(objEsriGeometry)) <= 0.0000000000000001;
            }
        } else {
            // Point shapes are only sliver when there are no points
            blnSliver = (objPart[0] && objPart[0].length) >= 2;
        }
    }

    return blnSliver;
}

TrimbleMap.Shape.Shared.SnapCoordinates = function (objPart, decOrdinateTolerance) {
    let objSnappedPart = objPart.slice();

    if (objSnappedPart && objSnappedPart.length > 0) {
        let intPartLength = objSnappedPart.length;

        let objFirstPoint = objSnappedPart[0];
        let objLastPoint = objSnappedPart[objSnappedPart.length - 1];

        if (objFirstPoint[0] == objLastPoint[0] && objFirstPoint[1] == objLastPoint[1]) {
            intPartLength--;
        }

        $.each(objPart, function (objPointIndex, objPoint) {
            for (let intIndex = objPointIndex + 1; intIndex < intPartLength; intIndex++) {
                if (Math.abs(objPoint[0] - objPart[intIndex][0]) <= decOrdinateTolerance || Math.abs(objPoint[1] - objPart[intIndex][1]) <= decOrdinateTolerance) {
                    objSnappedPart.splice(intIndex, 1);
                }
            }
        });
    }

    return objSnappedPart;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the TrimbleMap.Shape namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ShapeEditor = {};
TrimbleMap.ShapeEditor.Shared = {};

TrimbleMap.ShapeEditor.Shared.MODE_BUTTON_NAME = 'SHAPE';
TrimbleMap.ShapeEditor.Shared.SIDEBAR_TAB_WIDTH = 500;
TrimbleMap.ShapeEditor.Shared.SLIDE_TIME_MS = 200;
TrimbleMap.ShapeEditor.Shared.COMMONLY_USED_TEXT = '----------------';
TrimbleMap.ShapeEditor.Shared.COMMONLY_USED_GUID = 'ffffffff-ffff-ffff-ffff-ffffffffffff';
TrimbleMap.ShapeEditor.Shared.INNER_WIDTH = 500;
TrimbleMap.ShapeEditor.Shared.CONTAINER_PADDING = 10;
TrimbleMap.ShapeEditor.Shared.MAX_ON_THE_FLY_MEASUREMENT_CALCULATION_COORDINATES = 20000;
TrimbleMap.ShapeEditor.Shared.MAX_COORDINATES_TO_ALLOW_EDITING_IN_MAP = 1000;
TrimbleMap.ShapeEditor.Shared.MAX_COORDINATES_TO_DRAW_IN_MAP = 1000;
TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_BY_POINT_NOT_VISIBLE_MESSAGE_DATA_KEY = 'BLOCK_SELECTION_BY_POINT_NOT_VISIBLE';
TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_BY_POLYGON_NOT_VISIBLE_MESSAGE_DATA_KEY = 'BLOCK_SELECTION_BY_POLYGON_NOT_VISIBLE';
TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_COORDINATE_SYSTEM_MESSAGE_DATA_KEY = 'BLOCK_SELECTION_COORDINATE_SYSTEM';
TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_INVALID_EXTENT_MESSAGE_DATA_KEY = 'BLOCK_SELECTION_INVALID_EXTENT';
TrimbleMap.ShapeEditor.Shared.CALCULATION_IN_PROGRESS_TIME_MS = 500;
TrimbleMap.ShapeEditor.Shared.PARTS_LIST_MAX_HEIGHT = 22 * 3; // Each part row requires 22px ...

// **************************************************************************
// ENUM enumToolMode
// **************************************************************************
TrimbleMap.ShapeEditor.enumToolMode = {};
TrimbleMap.ShapeEditor.enumToolMode.None = 'None';
TrimbleMap.ShapeEditor.enumToolMode.DrawGeometry = 'DrawGeometry';
TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint = 'BlockSelectionByPoint';
TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon = 'BlockSelectionByPolygon';
TrimbleMap.ShapeEditor.enumToolMode.EditCoordinates = 'EditCoordinates';

// **************************************************************************
// FUNCTION: enumChooseExistingShapeToolMode
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.enumChooseExistingShapeToolMode = {};
TrimbleMap.ShapeEditor.enumChooseExistingShapeToolMode.ChooseShapeByPoint = 'ChooseShapeByPoint';
TrimbleMap.ShapeEditor.enumChooseExistingShapeToolMode.ChooseShapeByPolygon = 'ChooseShapeByPolygon';

// **************************************************************************
// FUNCTION: enumChooseExistingShapeOperation
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.enumChooseExistingShapeOperation = {};
TrimbleMap.ShapeEditor.enumChooseExistingShapeOperation.ChooseExistingShapeAdd = 'ChooseExistingShapeAdd';
TrimbleMap.ShapeEditor.enumChooseExistingShapeOperation.ChooseExistingShapeRemove = 'ChooseExistingShapeRemove';

// **************************************************************************
// ENUM enumPredefinedIcon
// **************************************************************************
TrimbleMap.ShapeEditor.enumPredefinedIcon = {};
TrimbleMap.ShapeEditor.enumPredefinedIcon.DrawPolygon = 'DrawPolygon';
TrimbleMap.ShapeEditor.enumPredefinedIcon.BlockSelectionByPoint = 'BlockSelectionByPoint';
TrimbleMap.ShapeEditor.enumPredefinedIcon.BlockSelectionByPolygon = 'BlockSelectionByPolygon';
TrimbleMap.ShapeEditor.enumPredefinedIcon.DrawMode = 'DrawMode';
TrimbleMap.ShapeEditor.enumPredefinedIcon.ReProject = 'ReProject';
TrimbleMap.ShapeEditor.enumPredefinedIcon.ZoomToShape = 'ZoomToShape';
TrimbleMap.ShapeEditor.enumPredefinedIcon.MergeParts = 'MergeParts';
TrimbleMap.ShapeEditor.enumPredefinedIcon.ConstructShapeFromCentroid = 'ConstructShapeFromCentroid';

// **************************************************************************
// ENUM enumEditorInterfaceFields
// **************************************************************************
TrimbleMap.ShapeEditor.enumEditorInterfaceFields = {};
TrimbleMap.ShapeEditor.enumEditorInterfaceFields.SpatialReference = 'SpatialReference';
TrimbleMap.ShapeEditor.enumEditorInterfaceFields.OfficialAreaAndUnit = 'OfficialAreaAndUnit';
TrimbleMap.ShapeEditor.enumEditorInterfaceFields.OfficialLengthAndUnit = 'OfficialLengthAndUnit';
TrimbleMap.ShapeEditor.enumEditorInterfaceFields.ShapeCoordinates = 'ShapeCoordinates';
TrimbleMap.ShapeEditor.enumEditorInterfaceFields.ReferencePoints = 'ReferencePoints';
TrimbleMap.ShapeEditor.enumEditorInterfaceFields.DynamicShapeOptions = 'DynamicShapeOptions';

// **************************************************************************
// ENUM enumDynamicShapeOfficialAreaOptions
// **************************************************************************
TrimbleMap.ShapeEditor.enumDynamicShapeOfficialAreaOptions = {};
TrimbleMap.ShapeEditor.enumDynamicShapeOfficialAreaOptions.Specify = 'Specify';
TrimbleMap.ShapeEditor.enumDynamicShapeOfficialAreaOptions.ComponentShapeOfficialAreas = 'ComponentShapeOfficialAreas';
TrimbleMap.ShapeEditor.enumDynamicShapeOfficialAreaOptions.CalculatedArea = 'CalculatedArea';

// **************************************************************************
// ENUM enumDrawMode
// **************************************************************************
TrimbleMap.ShapeEditor.enumDrawMode = {};
TrimbleMap.ShapeEditor.enumDrawMode.Add = 'Add';
TrimbleMap.ShapeEditor.enumDrawMode.Remove = 'Remove';

// **************************************************************************
// ENUM enumHorizontalAlignment
// **************************************************************************
TrimbleMap.ShapeEditor.enumHorizontalAlignment = {};
TrimbleMap.ShapeEditor.enumHorizontalAlignment.Left = 'Left';
TrimbleMap.ShapeEditor.enumHorizontalAlignment.Right = 'Right';

// **************************************************************************
// ENUM enumMapReferenceOverlapTopology
// **************************************************************************
TrimbleMap.ShapeEditor.enumMapReferenceOverlapTopology = {};
TrimbleMap.ShapeEditor.enumMapReferenceOverlapTopology.ShapeEntirelyOutsideMapReference = 'ShapeEntirelyOutsideMapReference';
TrimbleMap.ShapeEditor.enumMapReferenceOverlapTopology.ShapeEntirelyWithinMapReference = 'ShapeEntirelyWithinMapReference';
TrimbleMap.ShapeEditor.enumMapReferenceOverlapTopology.ShapePartiallyWithinMapReference = 'ShapePartiallyWithinMapReference';
TrimbleMap.ShapeEditor.enumMapReferenceOverlapTopology.ShapeDoesNotPartiallyOverlapAnyMapReferences = 'ShapeDoesNotPartiallyOverlapAnyMapReferences';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateInstance = function CreateInstance(objMapController, objSidebar, objModeButtons, strTabName, strTabCaption, objOptions, blnEditable, blnVisible, arrModules, blnRemoveVerticesAlongStraightLine) {

    // Create the instance ...
    let objShapeEditor = {
        MapController: objMapController,
        Sidebar: objSidebar,
        Options: objOptions,
        Modules: arrModules,
        Shape: ((typeof objOptions.Shape != 'undefined') && (objOptions.Shape)) ? objOptions.Shape : TrimbleMap.Shape.CreateInstance(SD.Guid.Shared.Empty()),
        TabName: strTabName,
        TabCaption: strTabCaption,
        Visible: false,
        SelectedPart: null,
        SelectedReferencePoint: null,
        ShapePartDetailsVisible: false,
        ReferencePointDetailsVisible: false,
        EditingCoordinateMode: false,
        EditingReferencePoint: false,
        CoordinateDisplay: null,
        CoordinateDisplayDiv: null,
        ModeButtons: objModeButtons,
        ToolMode: TrimbleMap.ShapeEditor.enumToolMode.None,
        ToolModeBeforeEditingPartOrReferencePoint: TrimbleMap.ShapeEditor.enumToolMode.None,
        IsToolActive: false,
        IsBlockSelectionByPointModificationEnabled: false,
        IsBlockSelectionByPolygonModificationEnabled: false,
        ActiveModeButtonBeforeEditingPartOrReferencePoint: null,
        ShapeEditorDiv: null,
        ShapeDiv: null,
        ToolDiv: null,
        RenameShapePartDialogDiv: null,
        RenameShapePartTextBox: null,
        RenameSaveButton: null,
        ChooseExistingShapeToolDiv: null,
        FunctionalityDisabledDiv: null,
        ShapeDetailsDiv: null,
        CoordinateSystemDiv: null,
        CoordinateSystemDropDown: null,
        ChooseExistingShapeSelectShapesFromDropDown: null,
        ChooseExistingShapeToolDropDown: null,
        ChooseExistingShapeToolMode: TrimbleMap.ShapeEditor.enumChooseExistingShapeToolMode.ChooseShapeByPoint,
        ChooseExistingShapeClickHandlerInstance: null,
        ChoosingExistingShape: false,
        CoordinateSystemSpan: null,
        OfficialMeasurementAndCoordinateSystemDiv: null,
        OfficialAreaDiv: null,
        OfficialAreaValuesDiv: null,
        OfficialAreaTextBox: null,
        OfficialAreaUnitsDropDown: null,
        OfficialAreaValueAndUnitSpan: null,
        UseCalculatedAreaLink: null,
        OfficialLengthDiv: null,
        OfficialLengthValuesDiv: null,
        OfficialLengthTextBox: null,
        OfficialLengthValueAndUnitSpan: null,
        OfficialLengthUnitsDropDown: null,
        UseCalculatedLengthLink: null,
        ShapePartsDiv: null,
        EditPartHamburgerMenuIcon: null,
        EditPartHamburgerMenu: null,
        ReferencePointsDiv: null,
        NewReferencePointIconDiv: null,
        NoReferencePointsMessageDiv: null,
        ReferencePointsItemsDiv: null,
        ReferencePointDivs: {},
        ShapePartDetailsDiv: null,
        ShapePartDetailsTopMarkerDiv: null,
        ShapePartDetailsInnerDiv: null,
        ViewingPartTextDiv: null,
        EditingPartUpperDiv: null,
        PartNameTextBox: null,
        PartNameSpan: null,
        CoordinateListEditor: null,
        CoordinateListEditorDiv: null,
        ReferencePointCoordinateListEditor: null,
        ReferencePointCoordinateListEditorDiv: null,
        ReferencePointValidationMessagesIcon: null,
        EsriDrawingToolbar: null,
        EndPolygonDrawingHandle: null,
        Editable: blnEditable,
        CoordinatesEditable: blnEditable && (!objOptions.AllowEditingOfOfficialAreaOnly),
        ShapePartDivs: {},
        TabContainerElement: null,
        EsriGraphicByPartID: {},
        EsriPointGraphicsByPartID: {},
        EsriGraphicByReferencePointID: {},
        PointSymbol: null,
        LineSymbol: null,
        FilledPolygonSymbol: null,
        HollowPolygonSymbol: null,
        SelectedPointSymbol: null,
        SelectedLineSymbol: null,
        SelectedFilledPolygonSymbol: null,
        SelectedHollowPolygonSymbol: null,
        HoveredPointSymbol: null,
        VertexSymbol: null,
        SelectedVertexSymbol: null,
        GhostVertexSymbol: null,
        BlockSelectionHoveredBlockSymbol: null,
        EsriEdit: null,
        EsriEditActivated: false,
        CoordinateAddedOnMapHandle: null,
        CoordinateStartMovingOnMapHandle: null,
        CoordinateMovedOnMapHandle: null,
        GraphicMovedOnMapHandle: null,
        MouseOverCoordinateOnMapHandle: null,
        MouseOutCoordinateOnMapHandle: null,
        GraphicsLayerMouseOverHandle: null,
        GraphicsLayerMouseOutHandle: null,
        ModifiedInteriorPartCoordinates: null,
        CoordinateListEditorOnCoordinateHoveredCount: 0,
        CoordinateListHoveredCoordinateGraphic: null,
        CoordinateListHoveredCoordinateIndex: null,
        VertexEsriPointAtStartMove: null,
        AreaDisplayDiv: null,
        DisplayArea: null,
        ReprojectIconDiv: null,
        ReprojectPopupDiv: null,
        ReProjectPopup: null,
        ReProjectCoordinateSystemListDiv: null,
        ReProjectCoordinateSystemNiceScroll: null,
        DrawModePopupDiv: null,
        DrawModePopup: null,
        DrawMode: TrimbleMap.ShapeEditor.enumDrawMode.Add,
        ChooseExistingShapeDrawMode: TrimbleMap.ShapeEditor.enumChooseExistingShapeOperation.ChooseExistingShapeAdd,
        ChooseExistingShapePopupDiv: null,
        EventHandlersAttached: false,
        ReferencePointCoordinateListEditorOnCoordinateHoveredCount: 0,
        ReferencePointCoordinateListHoveredCoordinateIndex: null,
        ReferencePointCoordinateListHoveredCoordinateGraphic: null,
        ShapeModeButton: null,
        ShapeEditorTabItem: null,
        ShapePartDropDown: null,
        PartsItemsDiv: null,
        PartsItemsScrollDiv: null,
        PartsItemsDivNiceScroll: null,
        ReferencePointCoordinateDiv: null,
        ViewingReferencePointSpan: null,
        EditingReferencePointSpan: null,
        ReferencePointNameSpan: null,
        NewReferencePointPopupDiv: null,
        NewReferencePointTypeListDiv: null,
        AddingNewPart: false,
        DynamicShapeDiv: null,
        DefineDynamicShapeOptions: null,
        ViewDynamicShapeOptions: null,
        DynamicShapeNotShownMessageDiv: null,
        ValidationMessagesDiv: null,
        OnShowFunctions: [],
        OnHideFunctions: [],
        IconPopups: [],
        IconPopupMenus: [],
        PartEditButtonsWidth: 110,
        ReferencePointEditButtonsWidth: 0,
        CalculatedPartAreaDiv: null,
        CalculatedPartAreaSpan: null,
        CalculatedPartLengthDiv: null,
        CalculatedPartLengthSpan: null,
        PartAreaCalculationInProgressIndicator: null,
        PartLengthCalculationInProgressIndicator: null,
        IconsDiv: null,
        CalculateMeasurementOnTheFly: true,
        AreaCalculationOnLargeShapesActivated: false,
        AllowCoordinateEditingInMap: true,
        DrawCoordinatesInMap: true,
        FunctionalityDisabledPopupDiv: null,
        PartToZoomToOnLoad: null,
        PartToSelectOnLoad: null,
        CalculatedAreaSpacingWidth: 0,
        CalculatedAreaLabelColumnWidth: 0,
        CalculateAreaIconDiv: null,
        CalculatedAreaDiv: null,
        CalculatedLengthDiv: null,
        CalculatedLengthSpacingWidth: null,
        CalculatedLengthLabelColumnWidth: null,
        CalculateLengthIconDiv: null,
        LengthDisplayDiv: null,
        DisplayLength: null,
        MouseMoveHandle: null,
        MouseDownHandle: null,
        MouseUpHandle: null,
        PanStartHandle: null,
        PanEndHandle: null,
        ZoomStartHandle: null,
        ZoomEndHandle: null,
        MouseDownScreenPoint: null,
        IsMouseInView: false,
        IsPanning: false,
        IsZooming: false,
        IsBlockSelectionMouseMoveProcessingInProgress: false,
        DelayedMouseMoveScreenPoint: null,
        GraticuleRenderer: null,
        HoveredBlockXIndex: null,
        HoveredBlockYIndex: null,
        HoveredBlockGraphic: null,
        PartAreaCalculationInProgressActive: false,
        PartLengthCalculationInProgressActive: false,
        PartAreaCalculationInProgressIndicatorTimer: null,
        PartLengthCalculationInProgressIndicatorTimer: null,
        ReprojectCoordinatesToSpatialReference: null,
        SelectedPartOrReferencePointValid: true,
        AddingExclusion: false,
        ShapePartValidationMessage: null,
        ConstructShapeFromCentroid: null,

        ClickedHandlerProxy: function (e) { objShapeEditor.ClickedHandler(e); },
        CoordinateSystemDropDownChangedProxy: function () { objShapeEditor.CoordinateSystemDropDownChanged(); },
        ShapePartDropDownChangedProxy: function () { objShapeEditor.ShapePartDropDownChanged(); },
        LegalDescriptionChangedProxy: function (e) { objShapeEditor.LegalDescriptionChanged(e); },
        GeometryDrawEndHandlerProxy: function (objGeometry) { objShapeEditor.GeometryDrawEndHandler(objGeometry); },
        CoordinateListEditorCoordinateChangedProxy: function (intCoordinate, objCoordinate, blnCoordinateCompleted, blnCoordinateValid) { objShapeEditor.CoordinateListEditorCoordinateChanged(intCoordinate, objCoordinate, blnCoordinateCompleted, blnCoordinateValid); },
        CoordinateListEditorCoordinatesChangedProxy: function (blnCoordinatesValid) { objShapeEditor.CoordinateListEditorCoordinatesChanged(blnCoordinatesValid); },
        CoordinateListEditorOnCoordinateHoveredProxy: function (intHoveredCoordinate, objHoveredCoordinate, blnIsValidAndComplete) { objShapeEditor.CoordinateListEditorOnCoordinateHovered(intHoveredCoordinate, objHoveredCoordinate, blnIsValidAndComplete); },
        ReferencePointCoordinateListEditorCoordinateChangedProxy: function (intCoordinate, objCoordinate, blnCoordinateCompleted, blnCoordinateValid) { objShapeEditor.ReferencePointCoordinateListEditorCoordinateChanged(intCoordinate, objCoordinate, blnCoordinateCompleted, blnCoordinateValid); },
        ReferencePointCoordinateListEditorOnCoordinateHoveredProxy: function (intHoveredCoordinate, objHoveredCoordinate, blnIsValidAndComplete) { objShapeEditor.ReferencePointCoordinateListEditorOnCoordinateHovered(intHoveredCoordinate, objHoveredCoordinate, blnIsValidAndComplete); },
        DefineDynamicShapeOptionsClickedProxy: function (e) { objShapeEditor.DefineDynamicShapeOptionsClicked(e); },
        ViewDynamicShapeOptionsClickedProxy: function (e) { objShapeEditor.ViewDynamicShapeOptionsClicked(e); },
        LoadedCallbackProxy: function (blnReloaded, blnAllowExtentChangePostMapLoad) { objShapeEditor.LoadedCallback(blnReloaded, blnAllowExtentChangePostMapLoad); },
        PreReloadedCallbackProxy: function (blnReloaded) { objShapeEditor.PreReloadedCallback(blnReloaded); },
        CoordinateAddedOnMapProxy: function (objData) { objShapeEditor.CoordinateAddedOnMap(objData); },
        CoordinateMovedOnMapProxy: function (objData) { objShapeEditor.CoordinateMovedOnMap(objData); },
        CoordinateStartMovingOnMapProxy: function (objData) { objShapeEditor.CoordinateStartMovingOnMap(objData); },
        GraphicMovedOnMapProxy: function (objData) { objShapeEditor.GraphicMovedOnMap(objData); },
        MouseOverCoordinateOnMapProxy: function (objData) { objShapeEditor.MouseOverCoordinateOnMap(objData); },
        MouseOutCoordinateOnMapProxy: function (objData) { objShapeEditor.MouseOutCoordinateOnMap(objData); },
        GraphicsLayerMouseOverProxy: function (objMouseEvent) { objShapeEditor.GraphicsLayerMouseOver(objMouseEvent); },
        GraphicsLayerMouseOutProxy: function (objMouseEvent) { objShapeEditor.GraphicsLayerMouseOut(objMouseEvent); },
        ActivateReProjectPopupProxy: function (e) { objShapeEditor.ActivateReProjectPopup(e); },
        DeActivateReProjectPopupProxy: function (objPopupContainerDiv) { objShapeEditor.DeActivateReProjectPopup(objPopupContainerDiv); },
        ReProjectPopupOpenedProxy: function (objPopupContainerDiv) { objShapeEditor.ReProjectPopupOpened(objPopupContainerDiv); },
        ReProjectPopupClickedProxy: function (e) { objShapeEditor.ReProjectPopupClicked(e); },
        ReprojectOkClickedProxy: function (e) { objShapeEditor.ReprojectOkClicked(e); },
        PopulateSelectShapesFromDropDownProxy: function (blnReloaded) { objShapeEditor.PopulateSelectShapesFromDropDown(blnReloaded); },
        ChooseExistingShapeMapClickedHandlerProxy: function (e) { objShapeEditor.ChooseExistingShapeMapClickedHandler(e); },
        ChooseExistingShapePolygonDrawEndHandlerProxy: function (objGeometry) { objShapeEditor.ChooseExistingShapePolygonDrawEndHandler(objGeometry); },

        ActivateDrawOnMapSubMenuProxy: function (objPopupContainerDiv) { objShapeEditor.ActivateDrawOnMapSubMenu(objPopupContainerDiv); },
        DeActivateDrawOnMapSubMenuProxy: function (objPopupContainerDiv) { objShapeEditor.DeActivateDrawOnMapSubMenu(objPopupContainerDiv); },
        ActivateImportCoordinateSubMenuProxy: function (objPopupContainerDiv) { objShapeEditor.ActivateImportCoordinateSubMenu(objPopupContainerDiv); },
        ImportCoordinateSubMenuClickHandlerProxy: function (e) { objShapeEditor.ImportCoordinateSubMenuClickHandler(e); },
        DrawOnMapSubMenuOpenedProxy: function (objPopupContainerDiv) { objShapeEditor.DrawOnMapSubMenuOpened(objPopupContainerDiv); },
        ImportCoordinateSubMenuOpenedProxy: function (objPopupContainerDiv) { objShapeEditor.ImportCoordinateSubMenuOpened(objPopupContainerDiv); },
        ActivateTypeCoordinateSubMenuProxy: function (objPopupContainerDiv) { objShapeEditor.ActivateTypeCoordinateSubMenu(objPopupContainerDiv); },
        ActivateAdvancedToolSubMenuProxy: function (objPopupContainerDiv) { objShapeEditor.ActivateAdvancedToolSubMenu(objPopupContainerDiv); },
        AdvancedToolsSubMenuClickHandlerProxy: function (e) { objShapeEditor.AdvancedToolsSubMenuClickHandler(e); },
        ChooseExistingShapeSubMenuOpenedProxy: function (objPopupContainerDiv) { objShapeEditor.ChooseExistingShapeSubMenuOpened(objPopupContainerDiv); },
        ActivateChooseExistingShapeSubMenuProxy: function (objPopupContainerDiv) { objShapeEditor.ActivateChooseExistingShapeSubMenu(objPopupContainerDiv); },
        DeActivateChooseExistingShapeSubMenuProxy: function (objPopupContainerDiv) { objShapeEditor.DeActivateChooseExistingShapeSubMenu(objPopupContainerDiv); },

        DrawOnMapClickedProxy: function (e) { objShapeEditor.DrawModePopupClicked(e); },
        ChooseExistingShapeDrawModeClickedProxy: function (e) { objShapeEditor.ChooseExistingShapeDrawModeClicked(e); },
        ChooseExistingShapeToolModeClickedProxy: function (e) { objShapeEditor.ChooseExistingShapeToolModeClicked(e); },
        ActivateNewReferencePointPopupProxy: function (objPopupContainerDiv) { objShapeEditor.ActivateNewReferencePointPopup(objPopupContainerDiv); },
        DeActivateNewReferencePointPopupProxy: function (objPopupContainerDiv) { objShapeEditor.DeActivateNewReferencePointPopup(objPopupContainerDiv); },
        ActivateFunctionalityDisabledPopupProxy: function (objPopupContainerDiv) { objShapeEditor.ActivateFunctionalityDisabledPopup(objPopupContainerDiv); },
        NewReferencePointPopupClickedProxy: function (e) { objShapeEditor.NewReferencePointPopupClicked(e); },
        OfficialAreaChangedProxy: function (e) { objShapeEditor.OfficialAreaChanged(e); },
        OfficialAreaUnitChangedProxy: function (e) { objShapeEditor.OfficialAreaUnitChanged(e); },
        OfficialLengthUnitChangedProxy: function (e) { objShapeEditor.OfficialLengthUnitChanged(e); },
        OfficialLengthChangedProxy: function (e) { objShapeEditor.OfficialLengthChanged(e); },
        CalculatedAreaUnitChangedProxy: function () { objShapeEditor.CalculatedAreaUnitChanged(); },
        CalculatedLengthUnitChangedProxy: function () { objShapeEditor.CalculatedLengthUnitChanged(); },
        ValidationMessageIconMouseEnterProxy: function (e) { objShapeEditor.ValidationMessageIconMouseEnter(e); },
        ValidationMessageIconMouseLeaveProxy: function (e) { objShapeEditor.ValidationMessageIconMouseLeave(e); },
        OnDynamicShapeOptionsClosedProxy: function (blnIsDynamic) { objShapeEditor.OnDynamicShapeOptionsClosed(blnIsDynamic); },
        GraticuleRendererVisibilityChangedProxy: function (blnVisible) { objShapeEditor.GraticuleRendererVisibilityChanged(blnVisible); },
        GraticuleRendererExtentValidityChangedProxy: function (blnValidExent) { objShapeEditor.GraticuleRendererExtentValidityChanged(blnValidExent); },
        MouseMoveProxy: function (e) { objShapeEditor.MouseMove(e.screenPoint); },
        MouseDownProxy: function (e) { objShapeEditor.MouseDown(e); },
        MouseUpProxy: function (e) { objShapeEditor.MouseUp(e); },
        MouseOutProxy: function (e) { objShapeEditor.MouseOut(e); },
        PanStartProxy: function (e) { objShapeEditor.PanStart(e); },
        PanEndProxy: function (e) { objShapeEditor.PanEnd(e); },
        ZoomStartProxy: function (e) { objShapeEditor.ZoomStart(e); },
        ZoomEndProxy: function (e) { objShapeEditor.ZoomEnd(e); },
        ShapePartDetailsDivFocusOutProxy: function (e) { objShapeEditor.ShapePartDetailsDivFocusOut(e); },
        ReferencePointDivFocusOutProxy: function (e) { objShapeEditor.ReferencePointDivFocusOut(e); },
        GeographicFormatSelectorClickedProxy: function (e) { objShapeEditor.GeographicFormatSelectorClicked(e); },

        ShapePartDeleteClickedProxy: function (e) { objShapeEditor.ShapePartDeleteClicked(e); },
        ShapePartZoomClickedProxy: function (e) { objShapeEditor.ShapePartZoomClicked(e); },
        ShapePartAddExclusionClickedProxy: function (e) { objShapeEditor.ShapePartAddExclusionClicked(e); },
        ShapePartRenameClickedProxy: function (e) { objShapeEditor.ShapePartRenameClicked(e); },

        ShowRenameShapePartDialog: TrimbleMap.ShapeEditor.ShowRenameShapePartDialog,
        ShapePartDropDownUpdate: TrimbleMap.ShapeEditor.ShapePartDropDownUpdate,
        RemoveShapePartDropDownItem: TrimbleMap.ShapeEditor.RemoveShapePartDropDownItem,
        GetShapeIDFromShapePartDropDown: TrimbleMap.ShapeEditor.GetShapeIDFromShapePartDropDown,
        ShapePartAddExclusionClicked: TrimbleMap.ShapeEditor.ShapePartAddExclusionClicked,
        ShapePartRenameClicked: TrimbleMap.ShapeEditor.ShapePartRenameClicked,
        ShapePartZoomClicked: TrimbleMap.ShapeEditor.ShapePartZoomClicked,
        ShapePartDeleteClicked: TrimbleMap.ShapeEditor.ShapePartDeleteClicked,
        ClickedHandler: TrimbleMap.ShapeEditor.ClickedHandler,
        ShapePartDetailsDivFocusOut: TrimbleMap.ShapeEditor.ShapePartDetailsDivFocusOut,
        ReferencePointDivFocusOut: TrimbleMap.ShapeEditor.ReferencePointDivFocusOut,
        CoordinateSystemDropDownChanged: TrimbleMap.ShapeEditor.CoordinateSystemDropDownChanged,
        ShapePartDropDownChanged: TrimbleMap.ShapeEditor.ShapePartDropDownChanged,
        CoordinateSystemChanged: TrimbleMap.ShapeEditor.CoordinateSystemChanged,
        ChangeSpatialReferenceOfShapeWithNoCoordinates: TrimbleMap.ShapeEditor.ChangeSpatialReferenceOfShapeWithNoCoordinates,
        LegalDescriptionChanged: TrimbleMap.ShapeEditor.LegalDescriptionChanged,
        SetElementVisibilityForOptionsAndDynamicShapeOptions: TrimbleMap.ShapeEditor.SetElementVisibilityForOptionsAndDynamicShapeOptions,
        DefineDynamicShapeOptionsClicked: TrimbleMap.ShapeEditor.DefineDynamicShapeOptionsClicked,
        ViewDynamicShapeOptionsClicked: TrimbleMap.ShapeEditor.ViewDynamicShapeOptionsClicked,
        ChangeCoordinateSystemWithoutReproject: TrimbleMap.ShapeEditor.ChangeCoordinateSystemWithoutReproject,
        CreateElements: TrimbleMap.ShapeEditor.CreateElements,
        CreateFunctionalityDisabledMessageDivElements: TrimbleMap.ShapeEditor.CreateFunctionalityDisabledMessageDivElements,
        CreateFunctionalityDisabledPopup: TrimbleMap.ShapeEditor.CreateFunctionalityDisabledPopup,
        CreateFunctionalityDisabledPopupDiv: TrimbleMap.ShapeEditor.CreateFunctionalityDisabledPopupDiv,
        ActivateFunctionalityDisabledPopup: TrimbleMap.ShapeEditor.ActivateFunctionalityDisabledPopup,
        CreateToolsDivElements: TrimbleMap.ShapeEditor.CreateToolsDivElements,
        CreateAndAddIcons: TrimbleMap.ShapeEditor.CreateAndAddIcons,
        CreateAreaDisplayDiv: TrimbleMap.ShapeEditor.CreateAreaDisplayDiv,
        CreateLengthDisplayDiv: TrimbleMap.ShapeEditor.CreateLengthDisplayDiv,
        CreateShapeDetailsDivElements: TrimbleMap.ShapeEditor.CreateShapeDetailsDivElements,
        CreateDynamicShapeElements: TrimbleMap.ShapeEditor.CreateDynamicShapeElements,
        CreateOfficialLengthElements: TrimbleMap.ShapeEditor.CreateOfficialLengthElements,
        CreateOfficialAreaElements: TrimbleMap.ShapeEditor.CreateOfficialAreaElements,
        CreateCalculatedAreaElements: TrimbleMap.ShapeEditor.CreateCalculatedAreaElements,
        CreateCalculatedLengthElements: TrimbleMap.ShapeEditor.CreateCalculatedLengthElements,
        CreateShapePartsDivElements: TrimbleMap.ShapeEditor.CreateShapePartsDivElements,
        CreateShapePartsHamburgerMenu: TrimbleMap.ShapeEditor.CreateShapePartsHamburgerMenu,
        CreateReferencePointsDivElements: TrimbleMap.ShapeEditor.CreateReferencePointsDivElements,
        CreateReferencePointCoordinateDivElements: TrimbleMap.ShapeEditor.CreateReferencePointCoordinateDivElements,
        CreateNewReferencePointPopup: TrimbleMap.ShapeEditor.CreateNewReferencePointPopup,
        CreateShapePartDetailsDivElements: TrimbleMap.ShapeEditor.CreateShapePartDetailsDivElements,
        CreateDynamicShapeNotShownMessageDiv: TrimbleMap.ShapeEditor.CreateDynamicShapeNotShownMessageDiv,
        ShowOrHideNewReferencePointIconDiv: TrimbleMap.ShapeEditor.ShowOrHideNewReferencePointIconDiv,
        UpdateReferencePointsDisplay: TrimbleMap.ShapeEditor.UpdateReferencePointsDisplay,
        CreateCoordinateDisplayDiv: TrimbleMap.ShapeEditor.CreateCoordinateDisplayDiv,
        AttachEventHandlers: TrimbleMap.ShapeEditor.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.ShapeEditor.DetachEventHandlers,
        AttachMapEventHandlers: TrimbleMap.ShapeEditor.AttachMapEventHandlers,
        DetachMapEventHandlers: TrimbleMap.ShapeEditor.DetachMapEventHandlers,
        ActivateTool: TrimbleMap.ShapeEditor.ActivateTool,
        DeActivateTool: TrimbleMap.ShapeEditor.DeActivateTool,
        SelectTool: TrimbleMap.ShapeEditor.SelectTool,
        ActivateTab: TrimbleMap.ShapeEditor.ActivateTab,
        DeActivateTab: TrimbleMap.ShapeEditor.DeActivateTab,
        ActivateMode: TrimbleMap.ShapeEditor.ActivateMode,
        DeActivateMode: TrimbleMap.ShapeEditor.DeActivateMode,
        ResizeTab: TrimbleMap.ShapeEditor.ResizeTab,
        IsCommonlyUsedSpatialReference: TrimbleMap.ShapeEditor.IsCommonlyUsedSpatialReference,
        PopulateSelectShapesFromDropDown: TrimbleMap.ShapeEditor.PopulateSelectShapesFromDropDown,
        PopulateToolsDropDown: TrimbleMap.ShapeEditor.PopulateToolsDropDown,
        PopulateCoordinateSystemDropDown: TrimbleMap.ShapeEditor.PopulateCoordinateSystemDropDown,
        PopulateOfficialAreaUnitsDropDown: TrimbleMap.ShapeEditor.PopulateOfficialAreaUnitsDropDown,
        PopulateOfficialLengthUnitsDropDown: TrimbleMap.ShapeEditor.PopulateOfficialLengthUnitsDropDown,
        PopulateOfficialArea: TrimbleMap.ShapeEditor.PopulateOfficialArea,
        PopulateOfficialLength: TrimbleMap.ShapeEditor.PopulateOfficialLength,
        PopulateShapePartDropDown: TrimbleMap.ShapeEditor.PopulateShapePartDropDown,
        GeometryDrawEndHandler: TrimbleMap.ShapeEditor.GeometryDrawEndHandler,
        DrawToAdd: TrimbleMap.ShapeEditor.DrawToAdd,
        DrawToRemove: TrimbleMap.ShapeEditor.DrawToRemove,
        DrawToAddMultiPart: TrimbleMap.ShapeEditor.DrawToAddMultiPart,
        DrawToRemoveMultiPart: TrimbleMap.ShapeEditor.DrawToRemoveMultiPart,
        MergeParts: TrimbleMap.ShapeEditor.MergeParts,
        PartsThatTouchesFromInside: TrimbleMap.ShapeEditor.PartsThatTouchesFromInside,
        SetDefaultCoordinateSystemWhenNotSet: TrimbleMap.ShapeEditor.SetDefaultCoordinateSystemWhenNotSet,
        UpdateNoPartsDisplayVisibility: TrimbleMap.ShapeEditor.UpdateNoPartsDisplayVisibility,
        UpdateNoReferencePointsDisplayVisibility: TrimbleMap.ShapeEditor.UpdateNoReferencePointsDisplayVisibility,
        UpdateViewAndEditPartVisibility: TrimbleMap.ShapeEditor.UpdateViewAndEditPartVisibility,
        UpdateViewAndEditReferencePointVisibility: TrimbleMap.ShapeEditor.UpdateViewAndEditReferencePointVisibility,
        UpdateForEditModeChange: TrimbleMap.ShapeEditor.UpdateForEditModeChange,
        AddShapePartDiv: TrimbleMap.ShapeEditor.AddShapePartDiv,
        AddReferencePointDiv: TrimbleMap.ShapeEditor.AddReferencePointDiv,
        ReferencePointDivDisplayed: TrimbleMap.ShapeEditor.ReferencePointDivDisplayed,
        RemoveShapePartDiv: TrimbleMap.ShapeEditor.RemoveShapePartDiv,
        CreateShapePartDiv: TrimbleMap.ShapeEditor.CreateShapePartDiv,
        CreateReferencePointDiv: TrimbleMap.ShapeEditor.CreateReferencePointDiv,
        AddShapePart: TrimbleMap.ShapeEditor.AddShapePart,
        RemoveShape: TrimbleMap.ShapeEditor.RemoveShape,
        RemoveShapePart: TrimbleMap.ShapeEditor.RemoveShapePart,
        UpdateShapePart: TrimbleMap.ShapeEditor.UpdateShapePart,
        UpdateReferencePoint: TrimbleMap.ShapeEditor.UpdateReferencePoint,
        AddReferencePoint: TrimbleMap.ShapeEditor.AddReferencePoint,
        RemoveReferencePoint: TrimbleMap.ShapeEditor.RemoveReferencePoint,
        ResizeElements: TrimbleMap.ShapeEditor.ResizeElements,
        PopulateFromShape: TrimbleMap.ShapeEditor.PopulateFromShape,
        PopulateShapeParts: TrimbleMap.ShapeEditor.PopulateShapeParts,
        PopulateReferencePoints: TrimbleMap.ShapeEditor.PopulateReferencePoints,
        ReplaceShape: TrimbleMap.ShapeEditor.ReplaceShape,
        ReplaceShapeAndSetMapIndex: TrimbleMap.ShapeEditor.ReplaceShapeAndSetMapIndex,
        UpdateCalculatedReferencePoints: TrimbleMap.ShapeEditor.UpdateCalculatedReferencePoints,
        SelectShapePart: TrimbleMap.ShapeEditor.SelectShapePart,
        UnSelectShapePart: TrimbleMap.ShapeEditor.UnSelectShapePart,
        UnSelectReferencePoint: TrimbleMap.ShapeEditor.UnSelectReferencePoint,
        SelectReferencePoint: TrimbleMap.ShapeEditor.SelectReferencePoint,
        GetShapePartDiv: TrimbleMap.ShapeEditor.GetShapePartDiv,
        GetReferencePointDiv: TrimbleMap.ShapeEditor.GetReferencePointDiv,
        ShowShapePartDetails: TrimbleMap.ShapeEditor.ShowShapePartDetails,
        HideShapePartDetails: TrimbleMap.ShapeEditor.HideShapePartDetails,
        ShowReferencePointCoordinate: TrimbleMap.ShapeEditor.ShowReferencePointCoordinate,
        HideReferencePointCoordinate: TrimbleMap.ShapeEditor.HideReferencePointCoordinate,

        GetCheckedStatus: TrimbleMap.ShapeEditor.GetCheckedStatus,
        ToggleAddExclusionMenuItem: TrimbleMap.ShapeEditor.ToggleAddExclusionMenuItem,
        EnableCheckMenuItem: TrimbleMap.ShapeEditor.EnableCheckMenuItem,
        CreateRenameDialog: TrimbleMap.ShapeEditor.CreateRenameDialog,
        ToggleEditFocus: TrimbleMap.ShapeEditor.ToggleEditFocus,
        ResetShapeEditorMode: TrimbleMap.ShapeEditor.ResetShapeEditorMode,
        PersistPartUpdates: TrimbleMap.ShapeEditor.PersistPartUpdates,
        PersistReferencePointUpdates: TrimbleMap.ShapeEditor.PersistReferencePointUpdates,
        SelectFirstPartOrAddPart: TrimbleMap.ShapeEditor.SelectFirstPartOrAddPart,
        AddNewShapePart: TrimbleMap.ShapeEditor.AddNewShapePart,
        AllowNavigationFromPartEditing: TrimbleMap.ShapeEditor.AllowNavigationFromPartEditing,
        ToggleAddIcons: TrimbleMap.ShapeEditor.ToggleAddIcons,
        ToggleDeleteIconOnShapePart: TrimbleMap.ShapeEditor.ToggleDeleteIconOnShapePart,
        ToggleDeleteIconOnReferencePoint: TrimbleMap.ShapeEditor.ToggleDeleteIconOnReferencePoint,
        ValidateCurrentlyEditedDetails: TrimbleMap.ShapeEditor.ValidateCurrentlyEditedDetails,

        AcceptChanges: TrimbleMap.ShapeEditor.AcceptChanges,
        ExitPartEditMode: TrimbleMap.ShapeEditor.ExitPartEditMode,
        ExitReferencePointEditMode: TrimbleMap.ShapeEditor.ExitReferencePointEditMode,
        ValidatePartDetails: TrimbleMap.ShapeEditor.ValidatePartDetails,
        ValidateReferencePointDetails: TrimbleMap.ShapeEditor.ValidateReferencePointDetails,

        GetDecimalPlacesForSpatialReferenceOfShape: TrimbleMap.ShapeEditor.GetDecimalPlacesForSpatialReferenceOfShape,
        CoordinateListEditorCoordinateChanged: TrimbleMap.ShapeEditor.CoordinateListEditorCoordinateChanged,
        CoordinateListEditorCoordinatesChanged: TrimbleMap.ShapeEditor.CoordinateListEditorCoordinatesChanged,
        CoordinateListEditorOnCoordinateHovered: TrimbleMap.ShapeEditor.CoordinateListEditorOnCoordinateHovered,
        ReferencePointCoordinateListEditorCoordinateChanged: TrimbleMap.ShapeEditor.ReferencePointCoordinateListEditorCoordinateChanged,
        ReferencePointCoordinateListEditorOnCoordinateHovered: TrimbleMap.ShapeEditor.ReferencePointCoordinateListEditorOnCoordinateHovered,
        GetSelectedPartCoordinateIndexForGraphic: TrimbleMap.ShapeEditor.GetSelectedPartCoordinateIndexForGraphic,
        CreateSymbols: TrimbleMap.ShapeEditor.CreateSymbols,
        GetSymbolToUse: TrimbleMap.ShapeEditor.GetSymbolToUse,
        GetReferencePointSymbolToUse: TrimbleMap.ShapeEditor.GetReferencePointSymbolToUse,
        LoadedCallback: TrimbleMap.ShapeEditor.LoadedCallback,
        PreReloadedCallback: TrimbleMap.ShapeEditor.PreReloadedCallback,
        DisplayPartGraphics: TrimbleMap.ShapeEditor.DisplayPartGraphics,
        RemovePartGraphics: TrimbleMap.ShapeEditor.RemovePartGraphics,
        RemoveAllGraphics: TrimbleMap.ShapeEditor.RemoveAllGraphics,
        DisplayReferencePointGraphic: TrimbleMap.ShapeEditor.DisplayReferencePointGraphic,
        RemoveReferencePointGraphic: TrimbleMap.ShapeEditor.RemoveReferencePointGraphic,
        ZoomToShapePart: TrimbleMap.ShapeEditor.ZoomToShapePart,
        ZoomToReferencePoint: TrimbleMap.ShapeEditor.ZoomToReferencePoint,
        GetModifiedPartCoordinates: TrimbleMap.ShapeEditor.GetModifiedPartCoordinates,
        ZoomToShape: TrimbleMap.ShapeEditor.ZoomToShape,
        DisplayShape: TrimbleMap.ShapeEditor.DisplayShape,
        ActivateMapCoordinateEditor: TrimbleMap.ShapeEditor.ActivateMapCoordinateEditor,
        DeactivateMapCoordinateEditor: TrimbleMap.ShapeEditor.DeactivateMapCoordinateEditor,
        CoordinateAddedOnMap: TrimbleMap.ShapeEditor.CoordinateAddedOnMap,
        CoordinateMovedOnMap: TrimbleMap.ShapeEditor.CoordinateMovedOnMap,
        CoordinateStartMovingOnMap: TrimbleMap.ShapeEditor.CoordinateStartMovingOnMap,
        GraphicMovedOnMap: TrimbleMap.ShapeEditor.GraphicMovedOnMap,
        MouseOverCoordinateOnMap: TrimbleMap.ShapeEditor.MouseOverCoordinateOnMap,
        MouseOutCoordinateOnMap: TrimbleMap.ShapeEditor.MouseOutCoordinateOnMap,
        UpdatePartNameOnInterface: TrimbleMap.ShapeEditor.UpdatePartNameOnInterface,
        GraphicsLayerMouseOver: TrimbleMap.ShapeEditor.GraphicsLayerMouseOver,
        GraphicsLayerMouseOut: TrimbleMap.ShapeEditor.GraphicsLayerMouseOut,
        UpdateMeasurementDisplay: TrimbleMap.ShapeEditor.UpdateMeasurementDisplay,
        UpdateAreaDisplay: TrimbleMap.ShapeEditor.UpdateAreaDisplay,
        UpdateLengthDisplay: TrimbleMap.ShapeEditor.UpdateLengthDisplay,
        UpdateSelectedPartAreaDisplay: TrimbleMap.ShapeEditor.UpdateSelectedPartAreaDisplay,
        UpdateSelectedPartLengthDisplay: TrimbleMap.ShapeEditor.UpdateSelectedPartLengthDisplay,
        ActivatePartAreaCalculationInProgressIndicator: TrimbleMap.ShapeEditor.ActivatePartAreaCalculationInProgressIndicator,
        DeActivatePartAreaCalculationInProgressIndicator: TrimbleMap.ShapeEditor.DeActivatePartAreaCalculationInProgressIndicator,
        ActivatePartLengthCalculationInProgressIndicator: TrimbleMap.ShapeEditor.ActivatePartLengthCalculationInProgressIndicator,
        DeActivatePartLengthCalculationInProgressIndicator: TrimbleMap.ShapeEditor.DeActivatePartLengthCalculationInProgressIndicator,
        UpdateShapeHasCoordinatesCss: TrimbleMap.ShapeEditor.UpdateShapeHasCoordinatesCss,
        UpdateForShapeChange: TrimbleMap.ShapeEditor.UpdateForShapeChange,
        UpdateFunctionalityDisabledMessageDisplay: TrimbleMap.ShapeEditor.UpdateFunctionalityDisabledMessageDisplay,
        SetOfficialAreaToCalculatedArea: TrimbleMap.ShapeEditor.SetOfficialAreaToCalculatedArea,
        SetOfficialLengthToCalculatedLength: TrimbleMap.ShapeEditor.SetOfficialLengthToCalculatedLength,
        GetSelectedOfficialAreaUnit: TrimbleMap.ShapeEditor.GetSelectedOfficialAreaUnit,
        GetSelectedOfficialLengthUnit: TrimbleMap.ShapeEditor.GetSelectedOfficialLengthUnit,
        HasUnitInOfficialAreaUnitDropDown: TrimbleMap.ShapeEditor.HasUnitInOfficialAreaUnitDropDown,
        HasUnitInOfficialLengthUnitDropDown: TrimbleMap.ShapeEditor.HasUnitInOfficialLengthUnitDropDown,
        CreateReProjectPopup: TrimbleMap.ShapeEditor.CreateReProjectPopup,
        CreateReProjectPopupDiv: TrimbleMap.ShapeEditor.CreateReProjectPopupDiv,
        ActivateReProjectPopup: TrimbleMap.ShapeEditor.ActivateReProjectPopup,
        DeActivateReProjectPopup: TrimbleMap.ShapeEditor.DeActivateReProjectPopup,
        ReProjectPopupOpened: TrimbleMap.ShapeEditor.ReProjectPopupOpened,
        ReProjectPopupClicked: TrimbleMap.ShapeEditor.ReProjectPopupClicked,
        ReprojectOkClicked: TrimbleMap.ShapeEditor.ReprojectOkClicked,

        ActivateDrawOnMapSubMenu: TrimbleMap.ShapeEditor.ActivateDrawOnMapSubMenu,
        DeActivateDrawOnMapSubMenu: TrimbleMap.ShapeEditor.DeActivateDrawOnMapSubMenu,
        ActivateImportCoordinateSubMenu: TrimbleMap.ShapeEditor.ActivateImportCoordinateSubMenu,
        DrawOnMapSubMenuOpened: TrimbleMap.ShapeEditor.DrawOnMapSubMenuOpened,
        ImportCoordinateSubMenuOpened: TrimbleMap.ShapeEditor.ImportCoordinateSubMenuOpened,
        ImportCoordinateSubMenuClickHandler: TrimbleMap.ShapeEditor.ImportCoordinateSubMenuClickHandler,
        ActivateTypeCoordinateSubMenu: TrimbleMap.ShapeEditor.ActivateTypeCoordinateSubMenu,
        ActivateAdvancedToolSubMenu: TrimbleMap.ShapeEditor.ActivateAdvancedToolSubMenu,
        AdvancedToolsSubMenuClickHandler: TrimbleMap.ShapeEditor.AdvancedToolsSubMenuClickHandler,
        ChooseExistingShapeSubMenuOpened: TrimbleMap.ShapeEditor.ChooseExistingShapeSubMenuOpened,
        ActivateChooseExistingShapeSubMenu: TrimbleMap.ShapeEditor.ActivateChooseExistingShapeSubMenu,
        DeActivateChooseExistingShapeSubMenu: TrimbleMap.ShapeEditor.DeActivateChooseExistingShapeSubMenu,

        DrawModePopupClicked: TrimbleMap.ShapeEditor.DrawModePopupClicked,
        CreateDrawModePopupDiv: TrimbleMap.ShapeEditor.CreateDrawModePopupDiv,
        UpdateDrawModeSelectedItem: TrimbleMap.ShapeEditor.UpdateDrawModeSelectedItem,
        UpdateChooseExistingShapeDrawModeSelectedItem: TrimbleMap.ShapeEditor.UpdateChooseExistingShapeDrawModeSelectedItem,
        ActivateNewReferencePointPopup: TrimbleMap.ShapeEditor.ActivateNewReferencePointPopup,
        DeActivateNewReferencePointPopup: TrimbleMap.ShapeEditor.DeActivateNewReferencePointPopup,
        CreateNewReferencePointPopupDiv: TrimbleMap.ShapeEditor.CreateNewReferencePointPopupDiv,
        NewReferencePointPopupClicked: TrimbleMap.ShapeEditor.NewReferencePointPopupClicked,
        GeographicFormatSelectorClicked: TrimbleMap.ShapeEditor.GeographicFormatSelectorClicked,
        ValidationMessageIconMouseEnter: TrimbleMap.ShapeEditor.ValidationMessageIconMouseEnter,
        ValidationMessageIconMouseLeave: TrimbleMap.ShapeEditor.ValidationMessageIconMouseLeave,
        CreateChooseExistingShapePopupDiv: TrimbleMap.ShapeEditor.CreateChooseExistingShapePopupDiv,
        ChooseExistingShapeDrawModeClicked: TrimbleMap.ShapeEditor.ChooseExistingShapeDrawModeClicked,
        ChooseExistingShapeToolModeClicked: TrimbleMap.ShapeEditor.ChooseExistingShapeToolModeClicked,
        ChooseExistingShapeSelectTool: TrimbleMap.ShapeEditor.ChooseExistingShapeSelectTool,
        ChooseExistingShapeActivateTool: TrimbleMap.ShapeEditor.ChooseExistingShapeActivateTool,
        ChooseExistingShapeDeActivateTool: TrimbleMap.ShapeEditor.ChooseExistingShapeDeActivateTool,
        ChooseExistingShapeActivateSelectByPoint: TrimbleMap.ShapeEditor.ChooseExistingShapeActivateSelectByPoint,
        ChooseExistingShapeActivateSelectByPolygon: TrimbleMap.ShapeEditor.ChooseExistingShapeActivateSelectByPolygon,
        ChooseExistingShapeDeActivateSelectByPoint: TrimbleMap.ShapeEditor.ChooseExistingShapeDeActivateSelectByPoint,
        ChooseExistingShapeDeActivateSelectByPolygon: TrimbleMap.ShapeEditor.ChooseExistingShapeDeActivateSelectByPolygon,
        ChooseExistingShapeIsValidPolygonForPolygonSelection: TrimbleMap.ShapeEditor.ChooseExistingShapeIsValidPolygonForPolygonSelection,
        ChooseExistingShapeMapClickedHandler: TrimbleMap.ShapeEditor.ChooseExistingShapeMapClickedHandler,
        ChooseExistingShapePolygonDrawEndHandler: TrimbleMap.ShapeEditor.ChooseExistingShapePolygonDrawEndHandler,
        ChooseExistingShape: TrimbleMap.ShapeEditor.ChooseExistingShape,
        UpdateShape: TrimbleMap.ShapeEditor.UpdateShape,
        ClipShapeOverlap: TrimbleMap.ShapeEditor.ClipShapeOverlap,
        GetEditedCoordinatesToReplace: TrimbleMap.ShapeEditor.GetEditedCoordinatesToReplace,
        UpdatePartsListScrollbar: TrimbleMap.ShapeEditor.UpdatePartsListScrollbar,
        ReProject: TrimbleMap.ShapeEditor.ReProject,
        OfficialAreaChanged: TrimbleMap.ShapeEditor.OfficialAreaChanged,
        OfficialAreaUnitChanged: TrimbleMap.ShapeEditor.OfficialAreaUnitChanged,
        OfficialLengthChanged: TrimbleMap.ShapeEditor.OfficialLengthChanged,
        OfficialLengthUnitChanged: TrimbleMap.ShapeEditor.OfficialLengthUnitChanged,
        CalculatedAreaUnitChanged: TrimbleMap.ShapeEditor.CalculatedAreaUnitChanged,
        CalculatedLengthUnitChanged: TrimbleMap.ShapeEditor.CalculatedLengthUnitChanged,
        EnableModeChange: TrimbleMap.ShapeEditor.EnableModeChange,
        DisableModeChange: TrimbleMap.ShapeEditor.DisableModeChange,
        HasValidationMessagesFor: TrimbleMap.ShapeEditor.HasValidationMessagesFor,
        OnDynamicShapeOptionsClosed: TrimbleMap.ShapeEditor.OnDynamicShapeOptionsClosed,
        AddOnShowFunction: TrimbleMap.ShapeEditor.AddOnShowFunction,
        AddOnHideFunction: TrimbleMap.ShapeEditor.AddOnHideFunction,
        TriggerOnShowFunctions: TrimbleMap.ShapeEditor.TriggerOnShowFunctions,
        TriggerOnHideFunctions: TrimbleMap.ShapeEditor.TriggerOnHideFunctions,
        CreateIconElement: TrimbleMap.ShapeEditor.CreateIconElement,
        ShowTransformationOptionDialog: TrimbleMap.ShapeEditor.ShowTransformationOptionDialog,
        ActivateBlockSelectionByPointTool: TrimbleMap.ShapeEditor.ActivateBlockSelectionByPointTool,
        DeActivateBlockSelectionByPointTool: TrimbleMap.ShapeEditor.DeActivateBlockSelectionByPointTool,
        ActivateBlockSelectionByPolygonTool: TrimbleMap.ShapeEditor.ActivateBlockSelectionByPolygonTool,
        DeActivateBlockSelectionByPolygonTool: TrimbleMap.ShapeEditor.DeActivateBlockSelectionByPolygonTool,
        EnableBlockSelectionModification: TrimbleMap.ShapeEditor.EnableBlockSelectionModification,
        EnableBlockSelectionByPointModification: TrimbleMap.ShapeEditor.EnableBlockSelectionByPointModification,
        EnableBlockSelectionByPolygonModification: TrimbleMap.ShapeEditor.EnableBlockSelectionByPolygonModification,
        DisableBlockSelectionModification: TrimbleMap.ShapeEditor.DisableBlockSelectionModification,
        DisableBlockSelectionByPointModification: TrimbleMap.ShapeEditor.DisableBlockSelectionByPointModification,
        DisableBlockSelectionByPolygonModification: TrimbleMap.ShapeEditor.DisableBlockSelectionByPolygonModification,
        UpdateBlockSelectionModificationEnabledState: TrimbleMap.ShapeEditor.UpdateBlockSelectionModificationEnabledState,
        RemoveBlockSelectionInfoMessages: TrimbleMap.ShapeEditor.RemoveBlockSelectionInfoMessages,
        ActivateGeometryInput: TrimbleMap.ShapeEditor.ActivateGeometryInput,
        DeActivateGeometryInput: TrimbleMap.ShapeEditor.DeActivateGeometryInput,
        ActivateGraticuleRenderer: TrimbleMap.ShapeEditor.ActivateGraticuleRenderer,
        DeActivateGraticuleRenderer: TrimbleMap.ShapeEditor.DeActivateGraticuleRenderer,
        GraticuleRendererVisibilityChanged: TrimbleMap.ShapeEditor.GraticuleRendererVisibilityChanged,
        GraticuleRendererExtentValidityChanged: TrimbleMap.ShapeEditor.GraticuleRendererExtentValidityChanged,

        MouseMove: TrimbleMap.ShapeEditor.MouseMove,
        MouseDown: TrimbleMap.ShapeEditor.MouseDown,
        MouseUp: TrimbleMap.ShapeEditor.MouseUp,
        MouseOut: TrimbleMap.ShapeEditor.MouseOut,
        PanStart: TrimbleMap.ShapeEditor.PanStart,
        PanEnd: TrimbleMap.ShapeEditor.PanEnd,
        ZoomStart: TrimbleMap.ShapeEditor.ZoomStart,
        ZoomEnd: TrimbleMap.ShapeEditor.ZoomEnd,
        Show: TrimbleMap.ShapeEditor.Show,
        Hide: TrimbleMap.ShapeEditor.Hide,
        ShapeEditorOptions: null,
        RemoveVerticesAlongStraightLine: blnRemoveVerticesAlongStraightLine
    };

    //Create ShapeEditor Options
    objShapeEditor.ShapeEditorOptions = TrimbleMap.ShapeEditorOptions.CreateInstance(objShapeEditor);

    // Create ConstructShapeFromCentroid plugin
    objShapeEditor.ConstructShapeFromCentroid = TrimbleMap.ConstructShapeFromCentroid.CreateInstance(objShapeEditor);

    // Create Shape Importer Options
    objShapeEditor.ShapeImporter = TrimbleMap.ShapeImporter.CreateInstance(objShapeEditor.Options.ClientSideImporters, 'ImportTypeField', objShapeEditor);

    // Create the elements for the tab ...
    objShapeEditor.CreateElements();

    // Hide the ToolDiv if it is empty
    if (objShapeEditor.ShapeEditorOptions.MenuItems.length == 0 && objShapeEditor.ToolDiv) {
        objShapeEditor.ToolDiv.hide();
    }

    // Populate from the shape ...
    objShapeEditor.PopulateFromShape();

    // Update the inteface for the shape change ...
    objShapeEditor.UpdateForShapeChange(true);

    // Create the mode button ...
    objShapeEditor.ShapeModeButton = SD.ModeButtons.Shared.CreateButton(TrimbleMap.ShapeEditor.Shared.MODE_BUTTON_NAME,
        'draw-mode',
        SD.Translation.Shared.GetTranslation('Map.Shape.js', 'ModeButtonName'),
        TrimbleMap.StandardMap.Shared.enumModeButtonOrder.DRAW,
        function (objModeButton) { objShapeEditor.ActivateMode(objModeButton); },
        function (objModeButton) { objShapeEditor.DeActivateMode(); });

    // Create the sidebar tab ...
    objShapeEditor.ShapeEditorTabItem = SD.Sidebar.Shared.CreateTabItem(objShapeEditor.TabName, objShapeEditor.TabCaption,
        TrimbleMap.StandardMap.Shared.enumTabOrder.SHAPE,
        function (objTabContainerElement, enTabActivationMethod) { objShapeEditor.ActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement, enTabActivationMethod) { objShapeEditor.DeActivateTab(objTabContainerElement, enTabActivationMethod); },
        function (objTabContainerElement) { objShapeEditor.ResizeTab(objTabContainerElement); },
        function () { return TrimbleMap.ShapeEditor.Shared.SIDEBAR_TAB_WIDTH; });

    // Show the tab and mode button when its to be visible at startup ...
    if (blnVisible) { objShapeEditor.Show(false, false); }

    // Create synbol for drawing on the map ...
    objShapeEditor.CreateSymbols();

    // Add the Loaded and PreReloaded callbacks ...
    objShapeEditor.MapController.AddOnLoadedCallback(objShapeEditor.LoadedCallbackProxy);
    objShapeEditor.MapController.AddPreReloadedCallback(objShapeEditor.PreReloadedCallbackProxy);

    return objShapeEditor;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
//           blnSelectTabAndShowGraphics is optional, defaults to true
// **************************************************************************
TrimbleMap.ShapeEditor.Show = function Show(blnTriggerNotifyModuleVisibilityChanged, blnSelectTabAndShowGraphics) {

    // Get the instance ...
    var objShapeEditor = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objShapeEditor.Visible) {

        // When the shape editor is editable and the geometry type is not point ...
        if (objShapeEditor.CoordinatesEditable && objShapeEditor.Options.ShowPartsInListAndMap) {

            // Add the mode button ...
            objShapeEditor.ModeButtons.AddButton(objShapeEditor.ShapeModeButton);
        }

        // Add the tab ...
        objShapeEditor.Sidebar.AddTab(objShapeEditor.ShapeEditorTabItem);

        // When we are to select the tab ...
        if ((typeof blnSelectTabAndShowGraphics == 'undefined') || (blnSelectTabAndShowGraphics == null) || blnSelectTabAndShowGraphics) {

            // Select the tab ...
            objShapeEditor.Sidebar.SelectTab(objShapeEditor.ShapeEditorTabItem);

            // Zoom to the shape ...
            var objZoomToShapeDeferred = objShapeEditor.ZoomToShape();

            // When the shape has been displayed ...
            objZoomToShapeDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

                // Display the shape ...
                objShapeEditor.DisplayShape();
            }));
        }

        // Set to be visible ...
        objShapeEditor.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objShapeEditor.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.ShapeEditor, true); }

        // Trigger the on show callbacks ...
        objShapeEditor.TriggerOnShowFunctions();
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.ShapeEditor.Hide = function Hide(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objShapeEditor = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objShapeEditor.Visible) {

        // Detach all the event handlers (if attached) ...
        objShapeEditor.DetachEventHandlers();

        // Remove all the graphics form the map ...
        objShapeEditor.RemoveAllGraphics();

        // Remove the mode button ...
        objShapeEditor.ModeButtons.RemoveButton(objShapeEditor.ShapeModeButton);

        // Remove the tab ...
        objShapeEditor.Sidebar.RemoveTab(objShapeEditor.ShapeEditorTabItem);

        // Set to not be visible ...
        objShapeEditor.Visible = false;

        // Notify that the module visibility changed to false ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objShapeEditor.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.ShapeEditor, false); }

        // Trigger the on hide callbacks ...
        objShapeEditor.TriggerOnHideFunctions();
    }
}

// **************************************************************************
// FUNCTION: LoadedCallback
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.LoadedCallback = function LoadedCallback(blnReloaded, blnAllowExtentChangePostMapLoad) {

    // Get the instance ...
    var objShapeEditor = this;

    // When we do not have an esri edit toolbar yet ...
    if (!objShapeEditor.EsriEdit) {

        // Create the editing toolbar ...
        objShapeEditor.EsriEdit = new esri.toolbars.Edit(objShapeEditor.MapController.EsriMap, { allowDeleteVertices: false });

        // Attach a 'vertex-add' event handler  ...
        objShapeEditor.CoordinateAddedOnMapHandle = objShapeEditor.EsriEdit.on('vertex-add', objShapeEditor.CoordinateAddedOnMapProxy);

        // Attach a 'vertex-move-stop' event handler ...
        objShapeEditor.CoordinateMovedOnMapHandle = objShapeEditor.EsriEdit.on('vertex-move-stop', objShapeEditor.CoordinateMovedOnMapProxy);

        // Attach a 'vertex-move-start' event handler ...
        objShapeEditor.CoordinateStartMovingOnMapHandle = objShapeEditor.EsriEdit.on('vertex-move-start', objShapeEditor.CoordinateStartMovingOnMapProxy);

        // Attach a 'graphic-move-stop' event handler ...
        objShapeEditor.GraphicMovedOnMapHandle = objShapeEditor.EsriEdit.on('graphic-move-stop', objShapeEditor.GraphicMovedOnMapProxy);

        // Attach a 'vertex-mouse-over' event handler ...
        objShapeEditor.MouseOverCoordinateOnMapHandle = objShapeEditor.EsriEdit.on('vertex-mouse-over', objShapeEditor.MouseOverCoordinateOnMapProxy);

        // Attach a 'vertex-mouse-out' event handler ...        
        objShapeEditor.MouseOutCoordinateOnMapHandle = objShapeEditor.EsriEdit.on('vertex-mouse-out', objShapeEditor.MouseOutCoordinateOnMapProxy);
    }

    // When reloaded ...
    if (blnReloaded) {

        // When the shape mode button is the active button ...
        if (objShapeEditor.ModeButtons.ActiveButton == objShapeEditor.ShapeModeButton) {

            // Activate the tool ...
            objShapeEditor.ActivateTool();
        }

        // When the shape tab is the current tab ...
        if (objShapeEditor.Sidebar.CurrentTab == objShapeEditor.ShapeEditorTabItem) {

            // Attach the map event handlers ... 
            objShapeEditor.AttachMapEventHandlers();
        }

    } else {

        // When we don't have a specific shape part to select but we have parts ...
        if ((objShapeEditor.PartToSelectOnLoad == null) && (objShapeEditor.Shape.Parts.length > 0)) {

            // Select the first shape part ...
            objShapeEditor.SelectShapePart(objShapeEditor.Shape.Parts[0], false, false);
        }
    }

    // Select the shape part when we have a shape part to select ...
    if (objShapeEditor.PartToSelectOnLoad) { objShapeEditor.SelectShapePart(objShapeEditor.PartToSelectOnLoad, false, false); }

    // Set to not select the part again on next load ...
    objShapeEditor.PartToSelectOnLoad = null;

    // When visible ...
    if (objShapeEditor.Visible) {

        // Display the shape ...
        var objDisplayShapeDeferred = objShapeEditor.DisplayShape();

        // When the shape has been displayed ...
        objDisplayShapeDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

            if (blnAllowExtentChangePostMapLoad) {
                // When we have a part to zoom to on load ...
                if (objShapeEditor.PartToZoomToOnLoad != null) {

                    // Zoom to the shape ...
                    objShapeEditor.ZoomToShapePart(objShapeEditor.PartToZoomToOnLoad);

                    // Set to not zoom to the part again on next load ...
                    objShapeEditor.PartToZoomToOnLoad = null;

                } else {

                    // Zoom to the shape ...
                    objShapeEditor.ZoomToShape();
                }
            }

            // When reloaded ...
            if (blnReloaded) {

                // Activate the map coordinate editor when we have a selected part ...
                objShapeEditor.ActivateMapCoordinateEditor();
            }

            if (objShapeEditor.Editable && objShapeEditor.ShapeEditorOptions.MenuItems.length > 0) {

                // Select the sole menu item when it's only one ...
                if (objShapeEditor.ShapeEditorOptions.MenuItems.length == 1) {
                    objShapeEditor.ShapeEditorOptions.MenuItemClicked(objShapeEditor.ShapeEditorOptions.MenuItems[0]);

                } else {

                    let shapeEditingToolToActivate = objShapeEditor.ShapeEditorOptions.MenuItems.find(menuItem => menuItem.Name == objShapeEditor.Options.DefaultSelectedEditor);

                    if (!shapeEditingToolToActivate) {
                        shapeEditingToolToActivate = objShapeEditor.ShapeEditorOptions.MenuItems.find(menuItem => menuItem.Order == 1);
                    }

                    objShapeEditor.ShapeEditorOptions.MenuItemClicked(shapeEditingToolToActivate);
                }
            }
        }));
    }
}

// **************************************************************************
// FUNCTION: PreReloadedCallback
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.PreReloadedCallback = function PreReloadedCallback() {

    // Get the instance ...
    var objShapeEditor = this;

    // De-activate the map coordinate editor ...
    objShapeEditor.DeactivateMapCoordinateEditor();

    // Detach the 'vertex-add' event handler ...
    objShapeEditor.CoordinateAddedOnMapHandle.remove();

    // Detach the 'vertex-move-stop' event handler ...
    objShapeEditor.CoordinateMovedOnMapHandle.remove();

    // Detach the 'vertex-first-move' event handler ...
    objShapeEditor.CoordinateStartMovingOnMapHandle.remove();

    // Detach the 'graphic-move-stop' event handler ...
    objShapeEditor.GraphicMovedOnMapHandle.remove();

    // Detach the 'vertex-mouse-over' event handler ...
    objShapeEditor.MouseOverCoordinateOnMapHandle.remove();

    // Detach the 'vertex-mouse-out' event handler ...
    objShapeEditor.MouseOutCoordinateOnMapHandle.remove();

    // Set the esri editing toolbar to null ...
    objShapeEditor.EsriEdit = null;

    // Re-create the displayed graphics hash tables ...
    objShapeEditor.EsriGraphicByPartID = {};
    objShapeEditor.EsriPointGraphicsByPartID = {};
    objShapeEditor.EsriGraphicByReferencePointID = {};

    // De-activate any active tools ...
    objShapeEditor.DeActivateTool();

    // When the shape tab is the current tab ...
    if (objShapeEditor.Sidebar.CurrentTab == objShapeEditor.ShapeEditorTabItem) {

        // Detach the map event handlers ... 
        objShapeEditor.DetachMapEventHandlers();
    }
}

// **************************************************************************
// FUNCTION: ClickedHandler
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ClickedHandler = function ClickedHandler(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the target ...
    var objTarget = $(e.target);

    // Attempt to get the relevant elements up the dom tree from the clicked target ...
    var objCustomToolIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'IconIndex');
    var objShapeDrawToolButton = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ShapeTool');
    var objZoomToShapeIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ZoomToShapeIcon');
    var objMergePartsIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'MergePartsIcon');
    var objAddPartIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'AddPartIcon');
    var objDeleteShapePartIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'DeleteShapePartIcon');
    var objZoomToShapePartIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ZoomToShapePartIcon');
    var objAddExclusionPartIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'AddExclusionPartIcon');
    var objShapePartDiv = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ShapePartID');
    var objUseCalculatedAreaLink = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'IsUseCalculatedAreaLink');
    var objUseCalculatedLengthLink = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'IsUseCalculatedLengthLink');
    var objDeleteReferencePointIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'DeleteReferencePointIcon');
    var objZoomToReferencePointIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ZoomToReferencePointIcon');
    var objReferencePointDiv = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ReferencePointID');
    var objAreaCalculationActivationIcon = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'IsAreaCalculationActivationIcon');
    var objCoordinateDeleteIcon = SD.DOM.GetElementOrParentWithClass(objTarget, 'coordinates_delete_icon');
    var objShapePartDropDown = SD.DOM.GetElementOrParentWithClass(objTarget, 'part-dropdown');
    var objConstructShapeFromCentroid = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ConstructShapeFromCentroid');

    switch (true) {
        case (objCustomToolIcon != null):

            // Retrieve the button index that was clicked ...
            var intIconIndex = objCustomToolIcon.attr('IconIndex');

            var arrAdvancedIcons = objShapeEditor.Options.Icons.filter(function (objIcon) {
                return objIcon.IsAdvanced == true;
            });

            // Call the applicable event handler ...
            arrAdvancedIcons[intIconIndex].ClickFunction();

            break;
        case (objShapePartDropDown != null):

            //Get the selected shape part option
            var objSelectedShapePartOption = objShapeEditor.ShapePartDropDown.find(':selected');

            if (objSelectedShapePartOption.length > 0) {

                //Get the shape part ID
                var guidShapePartID = objSelectedShapePartOption.val();

                let objPartToSelect = objShapeEditor.Shape.GetPartByID(guidShapePartID);

                objShapeEditor.AcceptChanges();
                objShapeEditor.SelectShapePart(objPartToSelect, objShapeEditor.EditingCoordinateMode, true);

            }

            break;
        case (objShapeDrawToolButton != null):

            // Retrieve the button that was clicked ...
            var enToolMode = objShapeDrawToolButton.attr('ShapeTool');

            // When coordinate editing are allowed in the map ...
            if (objShapeEditor.AllowCoordinateEditingInMap) {

                // Select the tool ...
                objShapeEditor.SelectTool(enToolMode);

            } else {

                // When the draw to add tool is to be activated ...
                if (enToolMode == TrimbleMap.ShapeEditor.enumToolMode.DrawGeometry) {

                    // 'The "Draw Polygon" tool is disabled'
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DrawPolygonDisabled');

                    //'The "Draw Polygon" tool is disabled due to the large number of coordinates on the shape'
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DrawPolygonToolDisabledDueToLargeShape');

                    // Notify the user ...
                    TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

                } else if (enToolMode == TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint) {

                    // 'The "Block selection by point" tool is disabled'
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'BlockSelectionByPointToolDisabled');

                    // 'The "Block selection by point" tool is disabled due to the large number of coordinates on the shape'
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'BlockSelectionByPointToolDisabledDueToLargeShape');

                    // Notify the user ...
                    TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

                } else if (enToolMode == TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon) {

                    // 'The "Block selection by point" tool is disabled'
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'BlockSelectionByPolygonToolDisabled');

                    // 'The "Block selection by polygon" tool is disabled due to the large number of coordinates on the shape'
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'BlockSelectionByPolygonToolDisabledDueToLargeShape');

                    // Notify the user ...
                    TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
                }
            }

            break;

        case (objAddPartIcon != null):

            // When the spatial reference is set ...
            if (objShapeEditor.Shape.SpatialReferenceID != SD.Guid.Shared.Empty()) {

                objShapeEditor.AddNewShapePart(false, null);

            } else {

                // Get the translations ...

                // Cannot add point without coordinate system
                // Cannot add part without coordinate system
                var strTitle = (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POINT) ? SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotAddPointTitle') : SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotAddPartTitle');

                // You cannot add a new point when the coordinate system is not set. <br />You need to first set the coordinate system and then add the point.
                // You cannot add a new part when the coordinate system is not set. <br />You need to first set the coordinate system and then add the part.
                var strMessage = (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POINT) ? SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotAddPointMessage') : SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotAddPartMessage');

                // Show a message to the user ...
                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
            }
            break;
        case (objCoordinateDeleteIcon != null):

            if (!objShapeEditor.ValidatePartDetails().Valid) {
                objShapeEditor.ToggleEditFocus(true);
            }

            break;
        case (objShapePartDiv != null):

            if (objShapeEditor.AllowNavigationFromPartEditing()) {
                let strShapePartID = GetShapeIDFromShapePartDropDown();
                let objPartToSelect = objShapeEditor.Shape.GetPartByID(strShapePartID);

                objShapeEditor.AcceptChanges();
                objShapeEditor.SelectShapePart(objPartToSelect, objShapeEditor.EditingCoordinateMode, true);
            }

            break;

        case (objUseCalculatedAreaLink != null):

            // Use the calculated area as the official area ...
            objShapeEditor.SetOfficialAreaToCalculatedArea();
            break;

        case (objUseCalculatedLengthLink != null):

            // Use the calculated area as the official area ...
            objShapeEditor.SetOfficialLengthToCalculatedLength();
            break;

        case (objDeleteReferencePointIcon != null):

            var strReferencePointID = objReferencePointDiv.attr('ReferencePointID');
            var objReferencePoinToDelete = objShapeEditor.Shape.GetReferencePointByID(strReferencePointID);

            objShapeEditor.RemoveReferencePoint(objReferencePoinToDelete, objReferencePointDiv);
            objShapeEditor.ToggleEditFocus(false);
            objShapeEditor.UpdateForShapeChange();
            break;

        case (objZoomToReferencePointIcon != null):

            var strReferencePointID = objReferencePointDiv.attr('ReferencePointID');
            var objReferencePoinToZoomTo = objShapeEditor.Shape.GetReferencePointByID(strReferencePointID);

            objShapeEditor.ZoomToReferencePoint(objReferencePoinToZoomTo);
            break;

        case (objReferencePointDiv != null):

            if (objShapeEditor.AllowNavigationFromPartEditing()) {
                let strReferencePointID = objReferencePointDiv.attr('ReferencePointID');
                let objReferencePointToSelect = objShapeEditor.Shape.GetReferencePointByID(strReferencePointID);
                let blnEditableReferencePoint = !objReferencePointDiv.hasClass('calculated-reference-point');

                objShapeEditor.AcceptChanges();
                objShapeEditor.SelectReferencePoint(objReferencePointToSelect, objShapeEditor.EditingCoordinateMode && blnEditableReferencePoint);
            }
            break;

        case (objZoomToShapeIcon != null):

            if (!objShapeEditor.Shape.Parts || !objShapeEditor.Shape.Parts.length) {

                var strTitle = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'NoShapeSystemTitle');
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'NoShapeSystemMessage');

                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

            } else {

                // Zoom to the shape ...
                objShapeEditor.ZoomToShape(true);

            }
            break;

        case (objAreaCalculationActivationIcon != null):

            // Activate the area calculation on large shapes ...
            objShapeEditor.AreaCalculationOnLargeShapesActivated = true;

            // Show the calculation in progress indicator ...
            objShapeEditor.DisplayArea.ShowCalculationInProgressIndicator();

            // Update the interface ...
            objShapeEditor.UpdateForShapeChange(false);
            break;

        case (objMergePartsIcon != null):

            if (!objShapeEditor.Shape.Parts || !objShapeEditor.Shape.Parts.length) {

                var strTitle = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'NoShapeSystemTitle');
                var strMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'NoShapeSystemMessage');

                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

            } else {

                // Merge the parts ...
                objShapeEditor.MergeParts();

            }
            break;
        case (objConstructShapeFromCentroid != null):

            // Open the dialog
            objShapeEditor.ConstructShapeFromCentroid.OpenDialog();

            break;
    }
}

// **************************************************************************
// FUNCTION: ResetShapeEditorMode
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ResetShapeEditorMode = function ResetShapeEditorMode() {
    let objShapeEditor = this;

    objShapeEditor.DeActivateMode();
    objShapeEditor.DeactivateMapCoordinateEditor();
    objShapeEditor.ChooseExistingShapeDeActivateTool();
    objShapeEditor.ToggleAddIcons(false);

    objShapeEditor.EditingCoordinateMode = false;
    objShapeEditor.EditingReferencePoint = false;
    objShapeEditor.AddingExclusion = false;

    if (objShapeEditor.SelectedPart != null) {
        objShapeEditor.ExitPartEditMode();
    }

    if (objShapeEditor.SelectedReferencePoint != null) {
        objShapeEditor.ExitReferencePointEditMode();
    }

}

// **************************************************************************
// FUNCTION: AddNewShapePart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AddNewShapePart = function AddNewShapePart(blnIsExclusion, strShapePartID) {
    let objShapeEditor = this;

    objShapeEditor.AddingNewPart = true;
    let objAddShapePartDeferred;

    objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddExclusion'), false);

    if (!blnIsExclusion) {
        objAddShapePartDeferred = objShapeEditor.AddShapePart([]);
        objShapeEditor.AddingExclusion = false;
    } else {
        objShapeEditor.AddingExclusion = true;
        var objPartToAddExclusionTo = objShapeEditor.Shape.GetPartByID(strShapePartID);
        objAddShapePartDeferred = objShapeEditor.AddShapePart([], objPartToAddExclusionTo);
    }

    objAddShapePartDeferred.then(function (objShapePart) {

        objShapeEditor.SelectShapePart(objShapePart, true, true);
        objShapeEditor.CoordinateListEditor.ActivateCoordinate(0);
        objShapeEditor.AddingExclusion = false;
        objShapeEditor.ToggleEditFocus(true);
    });
}

// **************************************************************************
// FUNCTION: SelectFirstPartOrAddPart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.SelectFirstPartOrAddPart = function SelectFirstPartOrAddPart(blnAllowAddPart) {
    let objShapeEditor = this;
    let objShapePartDiv = objShapeEditor.PartsItemsDiv;

    if (objShapePartDiv && objShapeEditor.ShapePartDropDown.has('option').length > 0) {

        objShapeEditor.ShapePartDropDownUpdate();
    } else if (blnAllowAddPart) {

        let objAddPart = objShapeEditor.ShapeEditorDiv.find('[AddPartIcon]');

        if (objAddPart && objAddPart.length > 0) {
            objAddPart.trigger('click');
        }
    }
}

// **************************************************************************
// FUNCTION: ToggleEditFocus
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ToggleEditFocus = function ToggleEditFocus(blnInvalid) {
    let objShapeEditor = this;


    if (objShapeEditor.SelectedReferencePoint != null) {
        objShapeEditor.ToggleDeleteIconOnReferencePoint(blnInvalid, objShapeEditor.SelectedReferencePoint.ID);
    }

    if (blnInvalid) {

        objShapeEditor.DisableModeChange();
        objShapeEditor.SelectedPartOrReferencePointValid = false;

    } else {

        objShapeEditor.EnableModeChange();
        objShapeEditor.SelectedPartOrReferencePointValid = true;

    }

    objShapeEditor.UpdateNoReferencePointsDisplayVisibility();
    objShapeEditor.UpdateForEditModeChange();
}

// **************************************************************************
// FUNCTION: ToggleAddIcons
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ToggleAddIcons = function ToggleAddIcons(blnShowAddIcons) {
    let objShapeEditor = this;

    let objAddReferencePoint = objShapeEditor.ShapeEditorDiv.find('[AddReferencePointIcon]');
    let objAddPart = objShapeEditor.ShapeEditorDiv.find('[AddPartIcon]');

    objShapeEditor.ToggleAddExclusionMenuItem();

    if (objShapeEditor.EditingCoordinateMode) {

        if (blnShowAddIcons) {
            objAddPart.removeClass('add-icon-hidden');
            objAddReferencePoint.removeClass('add-icon-hidden');
        } else {
            objAddPart.addClass('add-icon-hidden');
            objAddReferencePoint.addClass('add-icon-hidden');
        }

    } else {

        if (!objAddPart.hasClass('add-icon-hidden')) {
            objAddPart.addClass('add-icon-hidden');
        }

        if (!objAddReferencePoint.hasClass('add-icon-hidden')) {
            objAddReferencePoint.addClass('add-icon-hidden');
        }
    }
}

// **************************************************************************
// FUNCTION: ToggleDeleteIconOnShapePart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ToggleDeleteIconOnShapePart = function ToggleDeleteIconOnShapePart(blnPartInvalid, strPartID) {
    let objShapeEditor = this;
    let objDeleteIcon = objShapeEditor.ShapePartDivs[strPartID].children('[DeleteShapePartIcon]');

    if (blnPartInvalid) {

        if (objDeleteIcon.hasClass('shape_part_delete_icon')) {

            objDeleteIcon.removeClass('shape_part_delete_icon');
            objDeleteIcon.addClass('shape_part_delete_icon_on_invalid_part');

        }

    } else {

        if (objDeleteIcon.hasClass('shape_part_delete_icon_on_invalid_part')) {

            objDeleteIcon.removeClass('shape_part_delete_icon_on_invalid_part');
            objDeleteIcon.addClass('shape_part_delete_icon');

        }
    }

}

// **************************************************************************
// FUNCTION: ToggleDeleteIconOnReferencePoint
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ToggleDeleteIconOnReferencePoint = function ToggleDeleteIconOnReferencePoint(blnReferencePointInvalid, strReferencePointID) {
    let objShapeEditor = this;
    let objDeleteIcon = objShapeEditor.ReferencePointDivs[strReferencePointID].children('[DeleteReferencePointIcon]');

    if (blnReferencePointInvalid) {

        if (objDeleteIcon.hasClass('shape_referencepoint_delete_icon')) {

            objDeleteIcon.removeClass('shape_referencepoint_delete_icon');
            objDeleteIcon.addClass('shape_referencepoint_delete_icon_on_invalid_reference_point');

        }

    } else {

        if (objDeleteIcon.hasClass('shape_referencepoint_delete_icon_on_invalid_reference_point')) {

            objDeleteIcon.removeClass('shape_referencepoint_delete_icon_on_invalid_reference_point');
            objDeleteIcon.addClass('shape_referencepoint_delete_icon');

        }
    }

}

// **************************************************************************
// FUNCTION: PersistPartUpdates
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.PersistPartUpdates = function PersistPartUpdates() {
    let objShapeEditor = this;

    objShapeEditor.UpdateViewAndEditPartVisibility();
    objShapeEditor.SelectedPart.Coordinates = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

    objShapeEditor.UpdatePartNameOnInterface(objShapeEditor.SelectedPart);

    if (objShapeEditor.ModifiedInteriorPartCoordinates) {
        $.each(objShapeEditor.ModifiedInteriorPartCoordinates, function (intInteriorPart, arrModifiedCoordinateCopy) {

            let objInteriorPart = objShapeEditor.SelectedPart.InteriorParts[intInteriorPart];
            objInteriorPart.Coordinates = arrModifiedCoordinateCopy;
        });
    }

    objShapeEditor.ModifiedInteriorPartCoordinates = null;

    objShapeEditor.UpdateForShapeChange();
    objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart);

    if (objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart) && (typeof objShapeEditor.SelectedPart.InteriorParts != 'undefined') && (objShapeEditor.SelectedPart.InteriorParts)) {

        $.each(objShapeEditor.SelectedPart.InteriorParts, function (intInteriorPart, objInteriorPart) {
            objShapeEditor.DisplayPartGraphics(objInteriorPart);
        });
    }
}

// **************************************************************************
// FUNCTION: PersistReferencePointUpdates
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.PersistReferencePointUpdates = function PersistReferencePointUpdates() {
    let objShapeEditor = this;

    let arrCoordinates = objShapeEditor.ReferencePointCoordinateListEditor.GetCoordinates(false);

    if (arrCoordinates.length > 0) {
        objShapeEditor.SelectedReferencePoint.X = arrCoordinates[0].X;
        objShapeEditor.SelectedReferencePoint.Y = arrCoordinates[0].Y;
        objShapeEditor.SelectedReferencePoint.HasValues = true;

        objShapeEditor.ReferencePointCoordinateListEditor.SetDDorDMSDropDownPosition({ top: -28, right: 0 });
        objShapeEditor.DisplayReferencePointGraphic(objShapeEditor.SelectedReferencePoint);
        objShapeEditor.ReferencePointCoordinateListEditor.SetDDorDMSDropDownPosition({ top: -28, right: 0 });

        objShapeEditor.UpdateReferencePointsDisplay();
    }
}

// **************************************************************************
// FUNCTION: LegalDescriptionChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.LegalDescriptionChanged = function LegalDescriptionChanged(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the new legal decsription on the shape ...
    objShapeEditor.Shape.LegalDescription = objShapeEditor.LegalDescriptionTextArea.val();
}

// **************************************************************************
// FUNCTION: SetElementVisibilityForOptionsAndDynamicShapeOptions
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.SetElementVisibilityForOptionsAndDynamicShapeOptions = function SetElementVisibilityForOptionsAndDynamicShapeOptions(blnUpdateMeasurementDisplay) {

    // Get the instance ...
    var objShapeEditor = this;

    // Determine whether to show or hide the controls ...
    var blnShowShape = objShapeEditor.Options.ShowPartsInListAndMap && (!objShapeEditor.Shape.IsDynamic || !objShapeEditor.Editable);
    var blnShowDefineDynamicShapeOptions = objShapeEditor.Options.ShowDynamicShape && objShapeEditor.Editable;
    var blnShowViewDynamicShapeOptions = objShapeEditor.Options.ShowDynamicShape && !objShapeEditor.Editable;
    var blnShowUseCalculatedAreaLink = objShapeEditor.Options.ShowPartsInListAndMap && !objShapeEditor.Shape.IsDynamic && objShapeEditor.Editable;
    var blnShowUseCalculatedLengthLink = objShapeEditor.Options.ShowPartsInListAndMap && !objShapeEditor.Shape.IsDynamic && objShapeEditor.Editable;
    var blnShowDynamicShapeNotShownMessageDiv = objShapeEditor.Options.ShowPartsInListAndMap && objShapeEditor.Shape.IsDynamic && objShapeEditor.Editable;
    var blnShowOfficialArea = objShapeEditor.Options.ShowOfficialArea &&
        ((!objShapeEditor.Editable) || (!objShapeEditor.Shape.IsDynamic) ||
            (objShapeEditor.Shape.DynamicShapeOptions.OfficialAreaOption == TrimbleMap.ShapeEditor.enumDynamicShapeOfficialAreaOptions.Specify));
    var blnShowOfficialLength = objShapeEditor.Options.ShowOfficialLength;

    // Show or hide DefineDynamicShapeOptions, ViewDynamicShapeOptions, UseCalculatedAreaLink and DynamicShapeNotShownMessageDiv ...
    if (objShapeEditor.DefineDynamicShapeOptions != null) { if (blnShowDefineDynamicShapeOptions) { objShapeEditor.DefineDynamicShapeOptions.show(); } }
    if (objShapeEditor.ViewDynamicShapeOptions != null) { if (blnShowViewDynamicShapeOptions) { objShapeEditor.ViewDynamicShapeOptions.show(); } else { objShapeEditor.ViewDynamicShapeOptions.hide(); } }
    if (objShapeEditor.UseCalculatedAreaLink != null) { if (blnShowUseCalculatedAreaLink) { objShapeEditor.UseCalculatedAreaLink.show(); } else { objShapeEditor.UseCalculatedAreaLink.hide(); } }
    if (objShapeEditor.UseCalculatedLengthLink != null) { if (blnShowUseCalculatedLengthLink) { objShapeEditor.UseCalculatedLengthLink.show(); } else { objShapeEditor.UseCalculatedLengthLink.hide(); } }
    if (objShapeEditor.DynamicShapeNotShownMessageDiv != null) { if (blnShowDynamicShapeNotShownMessageDiv) { objShapeEditor.DynamicShapeNotShownMessageDiv.show(); } else { objShapeEditor.DynamicShapeNotShownMessageDiv.hide(); } }
    if (objShapeEditor.OfficialAreaMeasurementDiv != null) { if (blnShowOfficialArea) { objShapeEditor.OfficialAreaMeasurementDiv.show(); } else { objShapeEditor.OfficialAreaMeasurementDiv.hide(); } }
    if (objShapeEditor.OfficialLengthMeasurementDiv != null) { if (blnShowOfficialLength) { objShapeEditor.OfficialLengthMeasurementDiv.show(); } else { objShapeEditor.OfficialLengthMeasurementDiv.hide(); } }

    // When the shape should be shown ...
    if (blnShowShape) {

        // Show the icons, reference points and shape parts divs ...
        if (objShapeEditor.ToolDiv != null) { objShapeEditor.ToolDiv.show(); }
        if (objShapeEditor.ReferencePointsDiv != null) { objShapeEditor.ReferencePointsDiv.show(); }
        if (objShapeEditor.ShapePartsDiv != null) { objShapeEditor.ShapePartsDiv.show(); }
        if (objShapeEditor.OfficialMeasurementAndCoordinateSystemDiv != null) { objShapeEditor.OfficialMeasurementAndCoordinateSystemDiv.show(); }

    } else {

        // Hide the icons, reference points and shape parts divs ...
        if (objShapeEditor.ToolDiv != null) { objShapeEditor.ToolDiv.hide(); }
        if (objShapeEditor.ReferencePointsDiv != null) { objShapeEditor.ReferencePointsDiv.hide(); }
        if (objShapeEditor.ShapePartsDiv != null) { objShapeEditor.ShapePartsDiv.hide(); }
        if (objShapeEditor.OfficialMeasurementAndCoordinateSystemDiv != null) { objShapeEditor.OfficialMeasurementAndCoordinateSystemDiv.hide(); }
    }

    // When the measurement is expected to be udpated and displayed
    if (blnUpdateMeasurementDisplay) {

        // Update the measurement display ...
        objShapeEditor.UpdateMeasurementDisplay();
    }
}

// **************************************************************************
// FUNCTION: DefineDynamicShapeOptionsClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DefineDynamicShapeOptionsClicked = function DefineDynamicShapeOptionsClicked(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have an OpenDynamicShapeOptionsDialogFunction ...
    if ((typeof objShapeEditor.Options.OpenDynamicShapeOptionsDialogFunction != 'undefined') && (objShapeEditor.Options.OpenDynamicShapeOptionsDialogFunction)) {

        // Call it in edit mode ...
        objShapeEditor.Options.OpenDynamicShapeOptionsDialogFunction(objShapeEditor.Shape.DynamicShapeOptions, objShapeEditor.Shape.GeometryType, true, objShapeEditor.Shape.IsDynamic, objShapeEditor.OnDynamicShapeOptionsClosedProxy);
    }
}

// **************************************************************************
// FUNCTION: OnDynamicShapeOptionsClosed
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.OnDynamicShapeOptionsClosed = function OnDynamicShapeOptionsClosed(blnIsDynamic) {

    // Get the instance ...
    var objShapeEditor = this;

    // "Derived shape options"
    var strDerivedShapeOptions = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DerivedShapeOptions');

    // "Not a derived shape"
    var strNotDerivedShape = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NotDerivedShape');

    if ((objShapeEditor.Shape.IsDynamic !== 'undefined') && (objShapeEditor.Shape.IsDynamic != blnIsDynamic)) {

        // Flip the IsDynamic property ...
        objShapeEditor.Shape.IsDynamic = !objShapeEditor.Shape.IsDynamic;

        // When changed to dynamic ...
        if (objShapeEditor.Shape.IsDynamic) {

            objShapeEditor.DefineDynamicShapeOptions.text(strDerivedShapeOptions);

            // Remove the graphics from the map ...
            objShapeEditor.RemoveAllGraphics();

        } else {

            objShapeEditor.DefineDynamicShapeOptions.text(strNotDerivedShape);

            // Display the shape ...
            var objDisplayShapeDeferred = objShapeEditor.DisplayShape();

            // When the shape has been displayed ...
            objDisplayShapeDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

                // Zoom to the shape ...
                objShapeEditor.ZoomToShape();
            }));
        }

        // Set the element visibility ...
        objShapeEditor.SetElementVisibilityForOptionsAndDynamicShapeOptions(true);

        // Resize the elements ...
        objShapeEditor.ResizeElements();
    }
}

// **************************************************************************
// FUNCTION: ViewDynamicShapeOptionsClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ViewDynamicShapeOptionsClicked = function ViewDynamicShapeOptionsClicked(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have an OpenDynamicShapeOptionsDialogFunction ...
    if ((typeof objShapeEditor.Options.OpenDynamicShapeOptionsDialogFunction != 'undefined') && (objShapeEditor.Options.OpenDynamicShapeOptionsDialogFunction) && (objShapeEditor.Shape.IsDynamic)) {

        // Call it in view mode ...
        objShapeEditor.Options.OpenDynamicShapeOptionsDialogFunction(objShapeEditor.Shape.DynamicShapeOptions, objShapeEditor.Shape.GeometryType, false, objShapeEditor.Shape.IsDynamic);
    }
}


// **************************************************************************
// FUNCTION: ShapePartDropDownChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ShapePartDropDownChanged = function ShapePartDropDownChanged() {

    //Get the instance
    var objShapeEditor = this;

    //Get the selected shape part option
    var objSelectedShapePartOption = objShapeEditor.ShapePartDropDown.find(':selected');

    //Get the shape part ID
    var guidShapePartID = objSelectedShapePartOption.val();

    let objPartToSelect = objShapeEditor.Shape.GetPartByID(guidShapePartID);

    if (objShapeEditor.Shape.IsExteriorPart(objPartToSelect)) {

        var renameItem = objShapeEditor.EditPartHamburgerMenu.MenuItems.find(function (menuItem) {
            return menuItem.ItemID === SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'RenameExclusion');
        });
        var deleteItem = objShapeEditor.EditPartHamburgerMenu.MenuItems.find(function (menuItem) {
            return menuItem.ItemID === SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DeleteExclusion');
        });

        if (renameItem && deleteItem) {

            var renameIndex = objShapeEditor.EditPartHamburgerMenu.MenuItems.findIndex(function (menuItem) {
                return menuItem.ItemID === SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'RenameExclusion');
            });
            var deleteIndex = objShapeEditor.EditPartHamburgerMenu.MenuItems.findIndex(function (menuItem) {
                return menuItem.ItemID === SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DeleteExclusion');
            });

            var renameTrans = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'RenamePart');
            var deleteTrans = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DeletePart');

            objShapeEditor.EditPartHamburgerMenu.ReplaceMenuItem(renameIndex, SD.PopupMenu.Shared.CreateMenuItem(renameTrans, renameTrans, renameItem.ClickHandler, renameItem.ReadOnly, renameItem.ToolTipWhenReadOnly));
            objShapeEditor.EditPartHamburgerMenu.ReplaceMenuItem(deleteIndex, SD.PopupMenu.Shared.CreateMenuItem(deleteTrans, deleteTrans, deleteItem.ClickHandler, deleteItem.ReadOnly, deleteItem.ToolTipWhenReadOnly));
        }

    } else {

        var renameItem = objShapeEditor.EditPartHamburgerMenu.MenuItems.find(function (menuItem) {
            return menuItem.ItemID === SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'RenamePart');
        });
        var deleteItem = objShapeEditor.EditPartHamburgerMenu.MenuItems.find(function (menuItem) {
            return menuItem.ItemID === SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DeletePart');
        });

        if (renameItem && deleteItem) {

            var renameIndex = objShapeEditor.EditPartHamburgerMenu.MenuItems.findIndex(function (menuItem) {
                return menuItem.ItemID === SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'RenamePart');
            });
            var deleteIndex = objShapeEditor.EditPartHamburgerMenu.MenuItems.findIndex(function (menuItem) {
                return menuItem.ItemID === SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DeletePart');
            });

            var renameTrans = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'RenameExclusion');
            var deleteTrans = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DeleteExclusion');

            objShapeEditor.EditPartHamburgerMenu.ReplaceMenuItem(renameIndex, SD.PopupMenu.Shared.CreateMenuItem(renameTrans, renameTrans, renameItem.ClickHandler, renameItem.ReadOnly, renameItem.ToolTipWhenReadOnly));
            objShapeEditor.EditPartHamburgerMenu.ReplaceMenuItem(deleteIndex, SD.PopupMenu.Shared.CreateMenuItem(deleteTrans, deleteTrans, deleteItem.ClickHandler, deleteItem.ReadOnly, deleteItem.ToolTipWhenReadOnly));

        }

    }

    objShapeEditor.AcceptChanges();
    objShapeEditor.SelectShapePart(objPartToSelect, objShapeEditor.EditingCoordinateMode, true);

}

// **************************************************************************
// FUNCTION: CoordinateSystemDropDownChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CoordinateSystemDropDownChanged = function CoordinateSystemDropDownChanged() {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the selected coordinate system option ...
    var objSelectedCoordinateSystemOption = objShapeEditor.CoordinateSystemDropDown.find(':selected');

    // Get the selected spatial reference id ...
    var guidSpatialReference = objSelectedCoordinateSystemOption.val();

    // When the user did not click on the commonly used spacer ...
    if ((guidSpatialReference != TrimbleMap.ShapeEditor.Shared.COMMONLY_USED_GUID)) {

        // When the coordinate system were changed ...
        if (objShapeEditor.Shape.SpatialReferenceID != guidSpatialReference) {

            // When the part has coordinates or reference points ...
            if (objShapeEditor.Shape.HasCoordinates() || objShapeEditor.Shape.HasReferencePointWithValues(true)) {

                // When the user selected a spatial reference ...
                if (guidSpatialReference != SD.Guid.Shared.Empty()) {

                    // Get the selected coordinate system name ...
                    var strSelectedCoordinateSystem = objSelectedCoordinateSystemOption.text();

                    // When the transformation options dialog ...
                    objShapeEditor.ShowTransformationOptionDialog(function (blnTransform) {

                        // When we are to transform the coordinates ...
                        if (blnTransform) {

                            // Transform the coordinates ...
                            objShapeEditor.ReProject(guidSpatialReference, true);

                        } else {

                            // Change the coordinates without re-projecting ...
                            objShapeEditor.ChangeCoordinateSystemWithoutReproject(guidSpatialReference, strSelectedCoordinateSystem);
                        }

                        // Get the spatial reference information of the shape ...
                        let objSpatialReference = objShapeEditor.MapController.GetSpatialReference(guidSpatialReference);
                        let blnGeographicSpatialReferenceType = objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC;

                        let strDMSTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DegMinSec');
                        let strDDTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DecimalDeg');

                        objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(strDMSTranslation, blnGeographicSpatialReferenceType);
                        objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(strDDTranslation, blnGeographicSpatialReferenceType);

                        if (blnGeographicSpatialReferenceType) {
                            let enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, guidSpatialReference);

                            let enabledCoordinateFormatItemId;

                            if (enCoordinateFormat === TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) {
                                enabledCoordinateFormatItemId = strDMSTranslation;
                            } else {
                                enabledCoordinateFormatItemId = strDDTranslation;
                            }

                            objShapeEditor.EditPartHamburgerMenu.EnableMenuItemChecked(enabledCoordinateFormatItemId, true);
                        }
                    }, function () {

                        // Revert to the previous coordinate system selection ...
                        objShapeEditor.CoordinateSystemDropDown.val(objShapeEditor.Shape.SpatialReferenceID); objShapeEditor.CoordinateSystemSpan.text(objShapeEditor.CoordinateSystemDropDown.find(':selected').text());
                    });

                } else {

                    // Revert the spatial reference selection ...
                    objShapeEditor.CoordinateSystemDropDown.val(objShapeEditor.Shape.SpatialReferenceID);

                    // Get the translations ...

                    // Changing the coordinate system
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ChangeCoordinateSystemTitle');

                    // You cannot change the coordinate system to none while you have points
                    // You cannot change the coordinate system to none while <br />you have parts with coordinates or reference points
                    var strMessage = (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POINT) ? SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ChangeCoordinateSystemPointMessage') : SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ChangeCoordinateSystemPartMessage');

                    // Show a message to the user ...
                    TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
                }

            } else {

                // Change the spatial reference of the shape with no coordinates ...
                objShapeEditor.ChangeSpatialReferenceOfShapeWithNoCoordinates(guidSpatialReference);

                // Get the spatial reference information of the shape ...
                let objSpatialReference = objShapeEditor.MapController.GetSpatialReference(guidSpatialReference);
                let blnGeographicSpatialReferenceType = objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC;

                let strDMSTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DegMinSec');
                let strDDTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DecimalDeg');

                objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(strDMSTranslation, blnGeographicSpatialReferenceType);
                objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(strDDTranslation, blnGeographicSpatialReferenceType);

                if (blnGeographicSpatialReferenceType) {
                    let enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, guidSpatialReference);

                    let enabledCoordinateFormatItemId;

                    if (enCoordinateFormat === TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) {
                        enabledCoordinateFormatItemId = strDMSTranslation;
                    } else {
                        enabledCoordinateFormatItemId = strDDTranslation;
                    }

                    objShapeEditor.EditPartHamburgerMenu.EnableMenuItemChecked(enabledCoordinateFormatItemId, true);
                }
            }
        }

    } else {

        // Revert the spatial reference selection ...
        objShapeEditor.CoordinateSystemDropDown.val(objShapeEditor.Shape.SpatialReferenceID);
    }
}

// **************************************************************************
// FUNCTION: ChangeSpatialReferenceOfShapeWithNoCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChangeSpatialReferenceOfShapeWithNoCoordinates = function ChangeSpatialReferenceOfShapeWithNoCoordinates(guidToSpatialReference) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the spatial reference of the shape ...
    objShapeEditor.Shape.SpatialReferenceID = guidToSpatialReference;

    // Select the coordinate system in the drop down ...
    objShapeEditor.CoordinateSystemDropDown.val(objShapeEditor.Shape.SpatialReferenceID);

    // Set the text of the coordinate system span ...
    objShapeEditor.CoordinateSystemSpan.text(objShapeEditor.CoordinateSystemDropDown.find(':selected').text());

    objShapeEditor.ToggleAddIcons(guidToSpatialReference != SD.Guid.Shared.Empty());

    // When the shape has calculated reference points ... 
    if (objShapeEditor.Shape.HasCalculatedReferencePoints()) {

        // Update the calculated reference points ...
        objShapeEditor.UpdateCalculatedReferencePoints();
    }

    // When we have a spatial reference set ...
    if (guidToSpatialReference != SD.Guid.Shared.Empty()) {

        // Get the default coordinate format for the spatial reference ...
        var enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, guidToSpatialReference);

        // Change the coordinate formats on the coordinate list editors ...
        objShapeEditor.CoordinateListEditor.CoordinateFormat = enCoordinateFormat;
        if (objShapeEditor.ReferencePointCoordinateListEditor) { objShapeEditor.ReferencePointCoordinateListEditor.CoordinateFormat = enCoordinateFormat; }
    }

    // Perform additional operations needed when the coordinate system changed ...
    objShapeEditor.CoordinateSystemChanged();
}

// **************************************************************************
// FUNCTION: ShowTransformationOptionDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ShowTransformationOptionDialog = function ShowTransformationOptionDialog(fnOkClicked, fnCancelClicked) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the translations ...

    // Changing the coordinate system
    var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ChangingCoordinateSystemTitle');

    // Operation to be preformed on coordinates
    var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ChangingCoordinateSystemMessage') + ':';

    // Transform the coordinates to the selected coordinate system
    var strTransformOption = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'TransformCoordinatesOption');

    // Change the coordinate system without any coordinate transformation
    var strNoTransformationOption = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NoCoordinateTransformationOption');

    // Transform coordinates
    var strTransformCoordinates = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'TransformCoordinates');

    // Change without transformation
    var strChangeWithoutTransformation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ChangeWithoutTransformation');

    // OK
    var strOK = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Ok');

    // CANCEL
    var strCancel = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Cancel');

    // Get the next dialog id ...
    var objDialogID = TrimbleMap.ModalDialog.Shared.NextDialogID();

    // Create the content div for the dialog with the message ...
    var objDialogContent = $('<div class="map-message-box"><span>' + strMessage + '</span><br /></div>');

    // Add the option radio buttons ...
    objDialogContent.append('<input type="radio" name="options" value="TRANSFORM" style="position: relative;inset-block-start: 2px;"/>&nbsp;<span>' + strTransformOption + '</span><br/>');
    objDialogContent.append('<input type="radio" name="options" value="NO_TRANSFORM" style="position: relative;inset-block-start: 2px;"/>&nbsp;<span>' + strNoTransformationOption + '</span><br/><br/>');

    // Add the button to the dialog ...
    objDialogContent.append('<button CancelButton="true" type="button" class="Button pull-right" style="margin-inline-start:5px;margin-block-end:5px">' + strCancel + '</button>');
    objDialogContent.append('<button OKButton="true" type="button" class="Button pull-right" style="margin-inline-start:10px;">' + strOK + '</button>');

    // Show the dialog ...
    TrimbleMap.ModalDialog.Shared.OpenDialog(objDialogContent, strTitle, false, objDialogID);

    // Check the transform option ... 
    objDialogContent.find('input[value="TRANSFORM"]').prop('checked', true);

    // Create the close dialog function ...
    var fnCloseDialog = function () {

        // Remove the click handler ...
        objDialogContent.off('click', fnDialogClicked);

        // Close the modal dialog ...
        TrimbleMap.ModalDialog.Shared.CloseDialog(objDialogID);
    }

    // Create the dialog clicked function ...
    var fnDialogClicked = function (e) {

        // Get the target that the user clicked on ...
        var objTarget = $(e.target);


        // Determine if the user clciked on the OK or cancel button ...
        var objOKButton = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'OKButton');
        var objCancelButton = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'CancelButton');

        // Depending on the button clicked on (if any) ...
        switch (true) {
            case (objOKButton != null):

                // Get the checked element ... 
                var objCheckedElement = objDialogContent.find(':checked');

                // Determine whether or not the transfrom option is checked ...
                var blnTransform = (objCheckedElement.val() == 'TRANSFORM');

                // Close the dialog ...
                fnCloseDialog();

                // Call the OK clicked function ...
                fnOkClicked(blnTransform);
                break;

            case (objCancelButton != null):

                // Close the dialog ...
                fnCloseDialog();

                // Call the Cancel clicked function ...
                fnCancelClicked();
                break;
        }

        // When the user clicked on a span just after a radio button ...
        if (objTarget.is('span') && objTarget.prev().is('input[type="radio"]')) {

            // Check the radio button ...
            objTarget.prev().prop('checked', true);
        }
    }

    // Attach a click event handler to the dialog button ... 
    objDialogContent.on('click', (fnDialogClicked));
}

// **************************************************************************
// FUNCTION: ChangeCoordinateSystemWithoutReproject
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChangeCoordinateSystemWithoutReproject = function ChangeCoordinateSystemWithoutReproject(guidSpatialReference, strSelectedCoordinateSystem) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the selected coordinate system name ...
    objShapeEditor.CoordinateSystemSpan.text(strSelectedCoordinateSystem);

    // Set the spatial reference id on the shape ...
    objShapeEditor.Shape.SpatialReferenceID = guidSpatialReference;

    // Get the spatial reference information ...
    var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(guidSpatialReference);

    // When the spatial reference changed from a projected to geographic or from geographic to projected ...
    if ((objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) != (objShapeEditor.CoordinateListEditor.CoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED)) {

        // Get the default coordinate format to use fo the seletced spatial reference ...
        var enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, guidSpatialReference);

        // Set the editable property on the coordinate list editor ...
        objShapeEditor.CoordinateListEditor.ChangeCoordinates(enCoordinateFormat, (objShapeEditor.SelectedPart) ? objShapeEditor.CoordinateListEditor.GetCoordinates(false) : [],
            true, TrimbleMap.Shape.Shared.DecimalPlacesForSpatialReference(objShapeEditor.MapController, guidSpatialReference), false);

        // Get the non-calculated reference points with values ...
        var arrReferencePointsWithValues = objShapeEditor.Shape.ReferencePointsWithValues(false);

        // When the shape has non-calculated reference points with values ...
        if (arrReferencePointsWithValues.length > 0) {

            // Loop through the reference points with values ... 
            $.each(arrReferencePointsWithValues, function (intReferencePoint, objReferencePoint) {

                // Update the interface ...
                objShapeEditor.UpdateReferencePoint(objReferencePoint);
            });
        }
    }

    // Update the shape on the interface ...
    objShapeEditor.DisplayShape();

    // Zoom to the shape ...
    objShapeEditor.ZoomToShape();

    // Update the inteface for the shape change ...
    objShapeEditor.UpdateForShapeChange();

    // Perform additional operations needed when the coordinate system changed ...
    objShapeEditor.CoordinateSystemChanged();
}

// **************************************************************************
// FUNCTION: CoordinateSystemChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CoordinateSystemChanged = function CoordinateSystemChanged() {

    // Get the instance ...
    var objShapeEditor = this;

    // When in block selection mode ...
    switch (objShapeEditor.ToolMode) {
        case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon:
        case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint:

            // Update the block selection modification enabled state ...
            objShapeEditor.UpdateBlockSelectionModificationEnabledState();
            break;
    }

    // recreate the re-projection popup div ...
    objShapeEditor.CreateReProjectPopupDiv(true);
}

// **************************************************************************
// FUNCTION: UpdateBlockSelectionModificationEnabledState 
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateBlockSelectionModificationEnabledState = function UpdateBlockSelectionModificationEnabledState() {

    // Get the instance ...
    var objShapeEditor = this;

    // Start with enabling the modification ...
    var blnEnableModification = true;

    // When the spatial reference of the shape is the same as the grid spatial reference ...
    if (objShapeEditor.Shape.SpatialReferenceID != objShapeEditor.Options.GridOptions.SpatialReferenceID) {

        // Set to disable modification ...
        blnEnableModification = false;

        // Get the grid spatial reference ...
        var objGridSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Options.GridOptions.SpatialReferenceID);

        // Add the info messages ...

        // Create a new array for the messages ...
        var arrMessages = [];

        // 'The coordinate system of the shape differs from the coordinate system of the grid.'
        arrMessages.push(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'BlockSelectionNotInGridCoordinateSystem'));

        // 'Change the coordinate system to %1 in order to use the tool'
        arrMessages.push(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'BlockSelectionChangeCoordinateSystem', objGridSpatialReference.Name));

        // Get the tool icon css class to use ...
        var strToolIconCssClass = (objShapeEditor.ToolMode == TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon) ? 'shape_block_selection_by_polygon_tool' : 'shape_block_selection_by_point_tool';

        // Create the message data ...
        var objInfoMessageData = TrimbleMap.InfoMessage.Shared.CreateMessageData(TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_COORDINATE_SYSTEM_MESSAGE_DATA_KEY, arrMessages, true, strToolIconCssClass);

        // Update the message that are being displayed ...
        objShapeEditor.MapController.InfoMessage.AddMessageData(objInfoMessageData);

        // De-Activate the graticule renderer when active ...
        objShapeEditor.DeActivateGraticuleRenderer();

    } else {

        // Remove the invalid coordinate system message ...
        objShapeEditor.MapController.InfoMessage.RemoveMessageData(TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_COORDINATE_SYSTEM_MESSAGE_DATA_KEY);

        // Activate the graticule renderer when in-active ...
        objShapeEditor.ActivateGraticuleRenderer();

        // When not at a valid extent ...
        if (!objShapeEditor.GraticuleRenderer.IsValidExtent) {

            // Set to disable modification ...
            blnEnableModification = false;
        }
    }

    // When modification is to be enabled ...
    if (blnEnableModification) {

        // Enable block selection modification ...
        objShapeEditor.EnableBlockSelectionModification();

    } else {

        // Disable block selection modification ...
        objShapeEditor.DisableBlockSelectionModification();
    }
}

// **************************************************************************
// FUNCTION: RemoveBlockSelectionInfoMessages
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.RemoveBlockSelectionInfoMessages = function RemoveBlockSelectionInfoMessages() {

    // Get the instance ...
    var objShapeEditor = this;

    // Remove the message data that might have been added by the TrimbleMap.ShapeEditor instance ...
    objShapeEditor.MapController.InfoMessage.RemoveMessageData(TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_COORDINATE_SYSTEM_MESSAGE_DATA_KEY);
    objShapeEditor.MapController.InfoMessage.RemoveMessageData(TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_INVALID_EXTENT_MESSAGE_DATA_KEY);
}

// **************************************************************************
// FUNCTION: ActivateMode
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateMode = function ActivateMode() {

    // Get the instance ...
    var objShapeEditor = this;

    // When we not are to activate the EditCoordinates tool mode ...
    if (objShapeEditor.ToolMode != TrimbleMap.ShapeEditor.enumToolMode.EditCoordinates) {

        // When coordinate editing are to be allowed on the map ...
        if (objShapeEditor.AllowCoordinateEditingInMap) {

            // Select the shape editor tab ...
            objShapeEditor.Sidebar.SelectTab(objShapeEditor.ShapeEditorTabItem);

            // When we have a shape tool
            if (objShapeEditor.ToolMode != TrimbleMap.ShapeEditor.enumToolMode.None) {

                // Select the ToolMode
                objShapeEditor.SelectTool(objShapeEditor.ToolMode);

            } else {

                // Select the draw polygon tool ...
                objShapeEditor.SelectTool(TrimbleMap.ShapeEditor.enumToolMode.DrawGeometry);
            }

        } else {

            // Activate the default mode button ...
            objShapeEditor.ModeButtons.ActivateDefaultButton();

            // The "Draw to Add" tool is disabled
            var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DrawToAddToolDisabled');

            // The "Draw to Add" tool is disabled due to the large number of coordinates on the shape
            var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DrawToAddToolDisabledDueToLargeShape');

            // Notify the user ...
            TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
        }
    }
}

// **************************************************************************
// FUNCTION: DeActivateMode
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateMode = function DeActivateMode() {

    // Get the instance ...
    var objShapeEditor = this;

    // Clear the shape tool ...
    objShapeEditor.SelectTool(TrimbleMap.ShapeEditor.enumToolMode.None);
}

// **************************************************************************
// FUNCTION: ReplaceShape
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.ReplaceShape = function ReplaceShape(objShape, guidShapePartToZoomToAndSelect) {

    // Get the instance ...
    var objShapeEditor = this;

    // Unselect the shape part of we have a selected part ...
    objShapeEditor.UnSelectShapePart(false);

    // Unselect the shape reference point of we have a selected reference point ...
    objShapeEditor.UnSelectReferencePoint(false);

    // When the shape editor is visible ...
    if (objShapeEditor.Visible) {

        // Remove the graphics from the map ...
        objShapeEditor.RemoveAllGraphics();
    }

    // Set the shape ...
    objShapeEditor.Shape = objShape;

    // Populate the interface from the shape ...
    objShapeEditor.PopulateFromShape();

    // When we have at least one part ...
    if (objShape.Parts.length > 0) {

        // Select the the first shape part ...
        objShapeEditor.SelectShapePart(objShape.Parts[0], false);
    }

    // Update the inteface for the shape change ...
    objShapeEditor.UpdateForShapeChange();

    // Resize the elements ...
    objShapeEditor.ResizeElements();

    // When the shape editor is visible ...
    if (objShapeEditor.Visible) {

        // Display the shape ...
        var objDisplayShapeDeferred = objShapeEditor.DisplayShape();

        // When the shape has been displayed ...
        objDisplayShapeDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

            // When we have a specific part to zoom to ...
            if ((typeof guidShapePartToZoomToAndSelect != 'undefined') && (guidShapePartToZoomToAndSelect != null) && (guidShapePartToZoomToAndSelect != SD.Guid.Shared.Empty())) {

                // Get the part to zoom too ...
                var objShapePartToZoomTo = objShape.GetPartByID(guidShapePartToZoomToAndSelect);

                // Zoom to the shape part ...
                objShapeEditor.ZoomToShapePart(objShapePartToZoomTo);

                // Select the part ...
                objShapeEditor.SelectShapePart(objShapePartToZoomTo, false, false);

            } else {

                // Zoom to the shape ...
                objShapeEditor.ZoomToShape();
            }
        }));
    }
}

// **************************************************************************
// FUNCTION: ReplaceShapeAndSetMapIndex
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.ReplaceShapeAndSetMapIndex = function ReplaceShapeAndSetMapIndex(objShape, objShapePartToZoomTo, objShapePartToSelect, intNewMapIndex) {

    // Get the instance ...
    var objShapeEditor = this;

    // Unselect the shape part of we have a selected part ...
    objShapeEditor.UnSelectShapePart(false).then(TrimbleMap.Controller.Shared.TrapException(function () {

        // Unselect the shape reference point of we have a selected reference point ...
        objShapeEditor.UnSelectReferencePoint(false).then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Set the shape ...
            objShapeEditor.Shape = objShape;

            // Populate the interface from the shape ...
            objShapeEditor.PopulateFromShape();

            // Update the inteface for the shape change ...
            objShapeEditor.UpdateForShapeChange();

            // Resize the elements ...
            objShapeEditor.ResizeElements();

            // Set the shape part to zoom to after changing the map ...
            objShapeEditor.PartToZoomToOnLoad = objShapePartToZoomTo;

            // Set to select the part on load ...
            objShapeEditor.PartToSelectOnLoad = objShapePartToSelect;

            // Set the map index ..
            objShapeEditor.MapController.SetMapIndex(intNewMapIndex);
        }));
    }));
}

// **************************************************************************
// FUNCTION: PopulateFromShape
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateFromShape = function PopulateFromShape() {

    // Get the instance ...
    var objShapeEditor = this;

    // Select the coordinate system of the shape ...
    objShapeEditor.CoordinateSystemDropDown.val(objShapeEditor.Shape.SpatialReferenceID);

    // Get the selected coordinate system name ...
    var strSelectedCoordinateSystem = objShapeEditor.CoordinateSystemDropDown.find(':selected').text();

    // Set the selected coordinate system name ...
    objShapeEditor.CoordinateSystemSpan.text(strSelectedCoordinateSystem);

    // Set the legal description when the legal description is to be shown ...
    if (objShapeEditor.Options.ShowLegalDescription) { objShapeEditor.LegalDescriptionTextArea.val(objShapeEditor.Shape.LegalDescription); }

    // Populate the official area ...
    objShapeEditor.PopulateOfficialArea();

    // Populate the official area ...
    objShapeEditor.PopulateOfficialLength();

    // Populate the shape parts ...
    objShapeEditor.PopulateShapeParts();

    // Populate the reference points ...
    objShapeEditor.PopulateReferencePoints();
}

// **************************************************************************
// FUNCTION: PopulateShapeParts
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateShapeParts = function PopulateShapeParts() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create an empty object for the shape part divs ...
    objShapeEditor.ShapePartDivs = {};

    // Clear the part drop down ...
    objShapeEditor.ShapePartDropDown.empty();

    // When we have any parts ...
    if (objShapeEditor.Shape.Parts.length > 0) {

        // Loop through all the parts ...
        for (var intPart = 0; intPart < objShapeEditor.Shape.Parts.length; intPart++) {

            // Get the part ...
            var objShapePart = objShapeEditor.Shape.Parts[intPart];

            objShapeEditor.PopulateShapePartDropDown(objShapePart, false, false);


            // When the part has exclusions ...
            if ((typeof objShapePart.InteriorParts != 'undefined') && (objShapePart.InteriorParts)) {

                // Loop through all exlusions of the part ...
                for (var intExclusionPart = 0; intExclusionPart < objShapePart.InteriorParts.length; intExclusionPart++) {

                    // Get the exclusion part ...
                    var objExclusionShapePart = objShapePart.InteriorParts[intExclusionPart];

                    objShapeEditor.PopulateShapePartDropDown(objExclusionShapePart, objShapePart, false);
                }
            }
        }

        // Update the no parts display visiblity ...
        objShapeEditor.UpdateNoPartsDisplayVisibility();
    }
}

// **************************************************************************
// FUNCTION: PopulateReferencePoints
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateReferencePoints = function PopulateReferencePoints() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create an empty object for the reference point divs ...
    objShapeEditor.ReferencePointDivs = {};

    // Clear the reference points div ...
    if (objShapeEditor.ReferencePointsItemsDiv) { objShapeEditor.ReferencePointsItemsDiv.empty(); }

    // When the shape has reference points ...
    if (objShapeEditor.Shape.HasReferencePoints()) {

        // When the shape has reference points with values ...
        if (objShapeEditor.Shape.HasReferencePointWithValues(false)) {

            // Loop through all the reference points ...
            $.each(objShapeEditor.Shape.ReferencePoints, function (intReferencePoint, objReferencePoint) {

                // Reference points has values ...
                if (objReferencePoint.HasValues) {

                    // Create a new reference point div ...
                    var objReferencePointDiv = objShapeEditor.CreateReferencePointDiv(objReferencePoint);

                    // Add it to the part items div ...
                    objShapeEditor.AddReferencePointDiv(objReferencePointDiv, objReferencePoint, false);
                }
            });
        }
    }

    // Update the reference points display ...
    objShapeEditor.UpdateReferencePointsDisplay();
}

// **************************************************************************
// FUNCTION: UpdateCalculatedReferencePoints
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateCalculatedReferencePoints = function UpdateCalculatedReferencePoints() {

    // Get the instance ...
    var objShapeEditor = this;

    // Update the calculated reference points ...
    objShapeEditor.Shape.UpdateCalculatedReferencePoints(objShapeEditor.MapController);

    // When the shape has reference points ...
    if (objShapeEditor.Shape.HasReferencePoints()) {

        // Loop through all the reference points ...
        $.each(objShapeEditor.Shape.ReferencePoints, function (intReferencePoint, objReferencePoint) {

            // When the reference point is to be calculated as the centroid ...
            if (objReferencePoint.CalculationMethod == TrimbleMap.Shape.enumReferencePointCalculationMethod.Centroid) {

                // When the reference point has values ...
                if (objReferencePoint.HasValues) {

                    // When the reference point are being displayed ...
                    if (objShapeEditor.ReferencePointDivDisplayed(objReferencePoint)) {

                        // Update the interface ...
                        objShapeEditor.UpdateReferencePoint(objReferencePoint);

                    } else {

                        // Add the reference point to the interface ...
                        objShapeEditor.AddReferencePoint(objReferencePoint, false);
                    }

                } else {

                    // When the reference point are being displayed ...
                    if (objShapeEditor.ReferencePointDivDisplayed(objReferencePoint)) {

                        // Remove the reference point div from the interface ...
                        objShapeEditor.RemoveReferencePoint(objReferencePoint, objShapeEditor.GetReferencePointDiv(objReferencePoint.ID));
                    }
                }
            }
        });
    }
}

// **************************************************************************
// FUNCTION: AddReferencePointDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AddReferencePointDiv = function AddReferencePointDiv(objReferencePointDiv, objReferencePoint, blnUpdateVisibilityAndSizes) {

    // Get the instance ...
    var objShapeEditor = this;

    // Add it to the reference point divs hash table ...
    objShapeEditor.ReferencePointDivs[objReferencePoint.ID] = objReferencePointDiv;

    // Add it to the reference point items div ...
    objShapeEditor.ReferencePointsItemsDiv.append(objReferencePointDiv);

    // When we are to update the visibility and sizes ...
    if (blnUpdateVisibilityAndSizes) {

        // Update the reference points display ...
        objShapeEditor.UpdateReferencePointsDisplay();

        // Resize the elements ...
        objShapeEditor.ResizeElements();
    }
}

// **************************************************************************
// FUNCTION: ReferencePointDivDisplayed
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ReferencePointDivDisplayed = function ReferencePointDivDisplayed(objReferencePoint) {

    // Get the instance ...
    var objShapeEditor = this;

    // Determine whether or not the reference point div for the reference point are being displayed ...
    var blnReferencePointDivDisplayed = (typeof objShapeEditor.ReferencePointDivs[objReferencePoint.ID] != 'undefined');

    return blnReferencePointDivDisplayed;
}

// **************************************************************************
// FUNCTION: DisplayShape
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DisplayShape = function DisplayShape() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the esri map has been loaded and we are to show the parts ...
    if (objShapeEditor.MapController.IsEsriMapLoaded() && objShapeEditor.Options.ShowPartsInListAndMap) {

        // Create a new array for the deferred for the display of each part ...
        var arrDeferreds = [];

        // Get the coordinates to replace for the edited part if any ...
        var dicCoordinatesToReplace = objShapeEditor.GetEditedCoordinatesToReplace();

        // Loop through all the parts of the shape ...
        $.each(objShapeEditor.Shape.Parts, function (intPart, objPart) {

            // Update the part graphics ...
            if (objPart != objShapeEditor.SelectedPart) { arrDeferreds.push(objShapeEditor.DisplayPartGraphics(objPart, dicCoordinatesToReplace)); }

            // Determine if we are editing the part ...
            var blnIsEditingPart = (objShapeEditor.EditingCoordinateMode && (objShapeEditor.SelectedPart.ID == objPart.ID));

            // When the part has interior parts and we are not editing the exterior part ...
            if ((typeof objPart.InteriorParts != 'undefined') && objPart.InteriorParts && (!blnIsEditingPart)) {

                // Loop through all the interior parts of the part ...
                $.each(objPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                    // Display the interior part graphics ...
                    if (objInteriorPart != objShapeEditor.SelectedPart) { arrDeferreds.push(objShapeEditor.DisplayPartGraphics(objInteriorPart, dicCoordinatesToReplace)); }
                });
            }
        });

        // Draw the selected part last so that it will be at the top ...
        if (objShapeEditor.SelectedPart != null) { arrDeferreds.push(objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart, dicCoordinatesToReplace)); }

        // When the shape has reference points ...
        if (objShapeEditor.Shape.HasReferencePoints()) {

            // Loop through all the reference points of the shape ...
            $.each(objShapeEditor.Shape.ReferencePoints, function (intReferencePoint, objReferencePoint) {

                // Display the reference point graphic ...
                arrDeferreds.push(objShapeEditor.DisplayReferencePointGraphic(objReferencePoint));
            });
        }

        // When all the parts have been displayed ...
        new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Resolve the deferred ...
            objDeferred.resolve();
        }));
    }

    // Return the deferred ...
    return objDeferred;
}

// **************************************************************************
// FUNCTION: AddShapePartDiv
// USAGE:    objExteriorPartToAddBelow is optional
// **************************************************************************
TrimbleMap.ShapeEditor.AddShapePartDiv = function AddShapePartDiv(objShapePartDiv, objShapePart, blnUpdateNoPartsDisplayVisibilityAndDivSizes, objExteriorPartToAddBelow) {

    // Get the instance ...
    var objShapeEditor = this;

    // Add it to the shape part divs hash table ...
    objShapeEditor.ShapePartDivs[objShapePart.ID] = objShapePartDiv;

    // When we do not have an exterior part to add below ...
    if ((typeof objExteriorPartToAddBelow == 'undefined') || (!objExteriorPartToAddBelow)) {

        // Add it to the parts div ...
        objShapeEditor.PartsItemsDiv.append(objShapePartDiv);

    } else {

        // Get the exterior shape part div to add below ...
        var objExteriorShapePartDiv = objShapeEditor.GetShapePartDiv(objExteriorPartToAddBelow.ID);

        // Add the shape part div after the exterior shape part div ...
        objExteriorShapePartDiv.after(objShapePartDiv);
    }

    // When we are to update the no parts display visibility and div sizes ...
    if (blnUpdateNoPartsDisplayVisibilityAndDivSizes) {

        // Update the no parts display visiblity ...
        objShapeEditor.UpdateNoPartsDisplayVisibility();

        // Resize the elements ...
        objShapeEditor.ResizeElements();
    }
}
// **************************************************************************
// FUNCTION: RemoveShapePartDropDownItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.RemoveShapePartDropDownItem = function RemoveShapePartDropDownItem(objShapePart) {

    // Get the instance ...
    var objShapeEditor = this;

    //Remove the selected dropdown item
    var objSelectedShapePartOption = objShapeEditor.ShapePartDropDown.find("option[value='" + objShapePart.ID + "']");

    // Remove it from the shape part divs hash table ...
    delete objShapeEditor.ShapePartDivs[objSelectedShapePartOption.ID];

    objSelectedShapePartOption.remove();

    // Update the no parts display visiblity ...
    objShapeEditor.UpdateNoPartsDisplayVisibility();

    // Resize the elements ...
    objShapeEditor.ResizeElements();

}


// **************************************************************************
// FUNCTION: RemoveShapePartDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.RemoveShapePartDiv = function RemoveShapePartDiv(objShapePart) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the shape part div fro the shape part id ...
    var objShapePartDiv = objShapeEditor.GetShapePartDiv(objShapePart.ID);

    // Remove it from the shape part divs hash table ...
    delete objShapeEditor.ShapePartDivs[objShapePart.ID];

    // Remove the part div from the dom ...
    objShapePartDiv.remove();

    // Update the no parts display visiblity ...
    objShapeEditor.UpdateNoPartsDisplayVisibility();

    // Resize the elements ...
    objShapeEditor.ResizeElements();
}

// **************************************************************************
// FUNCTION: CreateShapePartDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateShapePartDiv = function CreateShapePartDiv(objShapePart, blnExclusionPart) {

    // Get the instance ...
    var objShapeEditor = this;

    // Determine the css class to use ...
    var strCSSClass = (blnExclusionPart) ? 'shape_exclusion_part_div' : 'shape_part_div';

    // Create the shape part div ...
    var objShapePartDiv = $('<div class="' + strCSSClass + '" ShapePartID="' + objShapePart.ID + '"></div>');

    // When the part is selected ...
    if (objShapeEditor.SelectedPart == objShapePart) {

        // Add the selected class ...
        objShapePartDiv.addClass('shape_part_div_selected');
    }

    // Create and add the part name span ...
    objShapePartDiv.append('<span class="shape_part_name_span" ShapePartNameSpan="true">' + objShapePart.PartName + '</span>');

    let objDeleteIconDiv = $('<div>').attr({
        'DeleteShapePartIcon': 'true',
        'title': SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DeletePart')
    });

    if (objShapeEditor.AddingNewPart) {
        objDeleteIconDiv.addClass('shape_part_delete_icon_on_invalid_part');
    } else {
        objDeleteIconDiv.addClass('shape_part_delete_icon');
    }

    // Create and add the delete icon ...
    objShapePartDiv.append(objDeleteIconDiv);

    // When it's not an exclusion part and the geometry type is not point ...
    if ((!blnExclusionPart) && (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON || objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.MIXED)) {

        // Create and add the 'add exclusion part' icon ...
        objShapePartDiv.append('<div class="shape_add_exclusion_part_icon" AddExclusionPartIcon="true" title="' + 'Add exclusion part' + '"></div>');
    }

    // Create and add the zoom to icon ...
    objShapePartDiv.append('<div class="shape_part_zoom_icon" ZoomToShapePartIcon="true" title="' + 'Zoom to part' + '"></div>');

    // Clear the floats ...
    objShapePartDiv.append('<div style="clear:both"></div>');

    return objShapePartDiv;
}

// **************************************************************************
// FUNCTION: CreateReferencePointDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateReferencePointDiv = function CreateReferencePointDiv(objReferencePoint) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set to add calculated-reference-point css class when it's a calculated reference point ...
    var strCalculatedCss = (objReferencePoint.CalculationMethod == TrimbleMap.Shape.enumReferencePointCalculationMethod.Centroid) ? ' calculated-reference-point' : '';

    // Create the reference point div ...
    var objReferencePointDiv = $('<div class="reference-point' + strCalculatedCss + '" ReferencePointID="' + objReferencePoint.ID + '"></div>');

    // When the reference point is selected ...
    if (objShapeEditor.SelectedReferencePoint == objReferencePoint) {

        // Add the selected class ...
        objReferencePointDiv.addClass('selected');
    }

    // Create and add the reference point type name span ...
    objReferencePointDiv.append('<span ShapePartNameSpan="true">' + objReferencePoint.ReferencePointTypeName + '</span>');

    // Create and add the zoom to icon ...
    objReferencePointDiv.append('<div class="zoom-icon" ZoomToReferencePointIcon="true" title="' + 'Zoom to reference point' + '"></div>');

    // Create and add the delete icon ...
    objReferencePointDiv.append('<div class="delete-icon" DeleteReferencePointIcon="true" title="' + 'Delete reference point' + '"></div>');

    return objReferencePointDiv;
}

// **************************************************************************
// FUNCTION: AcceptChanges
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AcceptChanges = function AcceptChanges() {
    let objShapeEditor = this;

    if (objShapeEditor.EditingCoordinateMode) {
        if (objShapeEditor.SelectedPart != null) {
            objShapeEditor.ValidatePartDetails();
            objShapeEditor.PersistPartUpdates();
        }

        if (objShapeEditor.SelectedReferencePoint != null && objShapeEditor.EditingReferencePoint) {
            objShapeEditor.ValidateReferencePointDetails();
            objShapeEditor.PersistReferencePointUpdates();
        }
    }
}

// **************************************************************************
// FUNCTION: ValidatePartDetails
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ValidatePartDetails = function ValidatePartDetails() {

    // Get the instance ...
    var objShapeEditor = this;

    // Start with being valid ...
    var objValidationResult = {
        Valid: true,
        InvalidReason: ''
    };

    // Get the part name from the text ...
    var strPartName = objShapeEditor.RenameShapePartTextBox.val();

    // When no part name has been specified ...
    if (strPartName.trim() == '') {

        // Set to not be valid ...
        objValidationResult.Valid = false;

        // 'The part must have a name'
        objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'PartMustHaveName');
    }

    // When still valid ...
    if (objValidationResult.Valid) {

        // When the part name is not unique ...
        if (!objShapeEditor.Shape.PartNameIsUnique(strPartName, objShapeEditor.SelectedPart)) {

            // Set to not be valid ...
            objValidationResult.Valid = false;

            // 'The part name must be unique'
            objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'PartNameMustBeUnique');
        }
    }

    // When still valid ...
    if (objValidationResult.Valid) {

        // Check if the coordinates are valid ...
        objValidationResult.Valid = objShapeEditor.CoordinateListEditor.CoordinatesValid();

        // When not valid ...
        if (!objValidationResult.Valid) {

            // Set the reason to be: 'The coordinates are invalid.' ...
            objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CoordinatesInvalid');
        }
    }

    // When still valid ...
    if (objValidationResult.Valid) {

        // Check if the last coordinate has been completed ...
        objValidationResult.Valid = objShapeEditor.CoordinateListEditor.LastCoordinateCompleted();

        // When not valid ...
        if (!objValidationResult.Valid) {

            // 'Complete the last coordinate.'
            objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CompleteLastCoordinate');
        }
    }

    // When still valid ...
    if (objValidationResult.Valid) {

        // When a polygon geometry type ...
        if (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) {

            // When less than 3 coordinates ...
            if (objShapeEditor.CoordinateListEditor.CoordinateCount() < 3) {

                // Set to not be valid ...
                objValidationResult.Valid = false;

                // 'The part must have at least 3 coordinates'
                objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'PartMustHaveAtLeast3Coordinates');
            }
        }
    }

    // Determine whether or not the selected part is exterior ...
    var blnSelectedPartIsExterior = objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart);

    // When still valid ...
    if (objValidationResult.Valid) {

        // When mixed geometry type ...
        if (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.MIXED) {

            // When less than 3 coordinates ...
            if (objShapeEditor.CoordinateListEditor.CoordinateCount() < 3) {

                // When an interior part or when the selecte part has interior parts ...
                if ((!blnSelectedPartIsExterior) || (typeof objShapeEditor.SelectedPart.InteriorParts != 'undefined') && (objShapeEditor.SelectedPart.InteriorParts != null) && (objShapeEditor.SelectedPart.InteriorParts.length > 0)) {

                    // Set to not be valid ...
                    objValidationResult.Valid = false;

                    // 'The part must have at least 3 coordinates'
                    objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'PartMustHaveAtLeast3Coordinates');
                }
            }
        }
    }

    // When still valid and coordinate editing in the map is allowed ...
    if ((objValidationResult.Valid) && objShapeEditor.AllowCoordinateEditingInMap) {

        // When not a point geometry type ...
        if (objShapeEditor.Shape.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT) {

            // Create an object containing the coordinates to replace ...
            var objCoordinatesToReplace = {};

            // Get the edited coordinates ...
            objCoordinatesToReplace[objShapeEditor.SelectedPart.ID] = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

            // When the selected part is exterior and we have modified interior part coordinates ...
            if (blnSelectedPartIsExterior && objShapeEditor.ModifiedInteriorPartCoordinates) {

                // Loop through the modified coordinate array copies for the interior parts ...
                $.each(objShapeEditor.ModifiedInteriorPartCoordinates, function (intInteriorPart, arrModifiedCoordinateCopy) {

                    // Get the interior part ...
                    var objInteriorPart = objShapeEditor.SelectedPart.InteriorParts[intInteriorPart];

                    // Set the interior part's modified coordinates in the coordinate to replace ...
                    objCoordinatesToReplace[objInteriorPart.ID] = arrModifiedCoordinateCopy;
                });
            }


            // Convert the selected part to an esri polygon providing the edited coordinates for the selected part ...
            var objEsriPolygon = objShapeEditor.Shape.GetPartGeometry(objShapeEditor.MapController, objShapeEditor.SelectedPart, objCoordinatesToReplace);

            if (objEsriPolygon != null) {

                // When the ring is self intersecting or overlapping with any of the other rings ... 
                if ((objEsriPolygon.type == 'polygon') && (objEsriPolygon.isSelfIntersecting(objEsriPolygon))) {

                    // Set to not be valid ...
                    objValidationResult.Valid = false;

                    // 'The coordinates of the part is self intersecting.'
                    objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CoordinatesOfPartIsSelfIntersecting');
                }

                // When still valid ...
                if (objValidationResult.Valid) {

                    // Determine the parts to test against (the other exterior parts when it's an exterior part, otherwise the other interior parts) ...
                    var arrPartsToTest = (blnSelectedPartIsExterior) ? objShapeEditor.Shape.Parts : objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapeEditor.SelectedPart).InteriorParts;

                    // When we have parts to test against ...
                    if ((typeof arrPartsToTest != 'undefined') && (arrPartsToTest != null)) {

                        // When the part overlaps other parts ...
                        if (objShapeEditor.Shape.PartOverlapsOtherParts(objShapeEditor.MapController, objShapeEditor.SelectedPart.ID, arrPartsToTest, objCoordinatesToReplace)) {

                            // Set to not be valid ...
                            objValidationResult.Valid = false;

                            // 'The coordinates of the part is overlapping with the other parts of the shape.'
                            objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CoordinatesOfPartOverlappingWithOtherParts');
                        }
                    }
                }

                // When still valid ...
                if (objValidationResult.Valid) {

                    // When an interior part ...
                    if (!blnSelectedPartIsExterior) {

                        // Get the exterior part for the interio part ...
                        var objExteriorPart = objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapeEditor.SelectedPart);

                        // When the part overlaps other parts ...
                        if (objShapeEditor.Shape.PartOverlapsOtherParts(objShapeEditor.MapController, objExteriorPart.ID, objShapeEditor.Shape.Parts, objCoordinatesToReplace)) {

                            // Set to not be valid ...
                            objValidationResult.Valid = false;

                            // 'The coordinates of the part is overlapping with the other parts of the shape.'
                            objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CoordinatesOfPartOverlappingWithOtherParts');
                        }
                    }
                }

                // When still valid ...
                if (objValidationResult.Valid) {

                    // Get the exterior part when the selected part is interior ...
                    var objExteriorPart = (blnSelectedPartIsExterior) ? objShapeEditor.SelectedPart : objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapeEditor.SelectedPart);

                    // When the part does not contain all it's interior parts ...
                    if (!objShapeEditor.Shape.PartContainsAllItsInteriorParts(objShapeEditor.MapController, objExteriorPart.ID, objCoordinatesToReplace)) {

                        // Set to not be valid ...
                        objValidationResult.Valid = false;

                        // 'One or more interior parts of the part are not inside the part.'
                        objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'InteriorPartsOfPartNotInsidePart');
                    }
                }
            } else {
                objValidationResult.Valid = false;
            }
        }
    }

    objShapeEditor.SelectedPartOrReferencePointValid = objValidationResult.Valid;

    return objValidationResult;
}

// **************************************************************************
// FUNCTION: ValidateReferencePointDetails
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ValidateReferencePointDetails = function ValidateReferencePointDetails() {

    // Get the instance ...
    var objShapeEditor = this;

    // Start with being valid ...
    var objValidationResult = {
        Valid: true,
        InvalidReason: ''
    };

    // Check if the coordinates are valid ...
    objValidationResult.Valid = objShapeEditor.ReferencePointCoordinateListEditor.CoordinatesValid();

    // When not valid ...
    if (!objValidationResult.Valid) {

        // 'The coordinate is invalid.'
        objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CoordinateInvalid');
    }

    // When still valid ...
    if (objValidationResult.Valid) {

        // Check if the last coordinate has been completed ...
        objValidationResult.Valid = objShapeEditor.ReferencePointCoordinateListEditor.LastCoordinateCompleted();

        // When not valid ...
        if (!objValidationResult.Valid) {

            // 'Complete the reference point.'
            objValidationResult.InvalidReason = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CompleteReferencePoint');
        }
    }

    objShapeEditor.SelectedPartOrReferencePointValid = objValidationResult.Valid;

    return objValidationResult;
}

// **************************************************************************
// FUNCTION: ValidateCurrentlyEditedDetails
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ValidateCurrentlyEditedDetails = function ValidateCurrentlyEditedDetails() {
    let objShapeEditor = this;

    let objReturn = {
        Valid: true,
        InvalidReason: ''
    };

    if (objShapeEditor.SelectedPart != null && objShapeEditor.EditingCoordinateMode) {
        objReturn = objShapeEditor.ValidatePartDetails();
    } else if (objShapeEditor.SelectedReferencePoint != null && objShapeEditor.EditingReferencePoint) {
        objReturn = objShapeEditor.ValidateReferencePointDetails();
    }

    return objReturn;
}

// **************************************************************************
// FUNCTION: UpdatePartNameOnInterface
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdatePartNameOnInterface = function UpdatePartNameOnInterface(objShapePart) {

    // Get the instance ...
    var objShapeEditor = this;

    var objSelectedShapePartOption = objShapeEditor.ShapePartDropDown.find(':selected');

    var objIsExclusion = SD.DOM.GetElementOrParentWithAttribute(objSelectedShapePartOption, 'IsExclusion');

    if (objIsExclusion !== null) {
        objShapeEditor.ShapePartDropDown.find(':selected').html("&nbsp;&nbsp;&nbsp;" + objShapePart.PartName);
    } else {
        objShapeEditor.ShapePartDropDown.find(':selected').text(objShapePart.PartName);
    }

    // When the part is selected ...
    if (objShapePart.ID === objShapeEditor.SelectedPart.ID) {

        // Set the part name in the viewing part details span ...
        objShapeEditor.RenameShapePartTextBox.val(objShapePart.PartName);
    }
}

// **************************************************************************
// FUNCTION: ExitPartEditMode
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ExitPartEditMode = function ExitPartEditMode() {

    // Get the instance ...
    var objShapeEditor = this;

    // Set to not be editing the part ...
    objShapeEditor.EditingCoordinateMode = false;

    // Deactivate the map coordinate editor ...
    objShapeEditor.DeactivateMapCoordinateEditor();

    // Update the view and edit part coordinates div visibility ...
    objShapeEditor.UpdateViewAndEditPartVisibility();

    // Get the coordinates from the coordinate list editor ...
    objShapeEditor.SelectedPart.Coordinates = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

    // Update the part's name on the interface ...
    objShapeEditor.UpdatePartNameOnInterface(objShapeEditor.SelectedPart);

    // Set the coordinate list editor to not be editable ...
    objShapeEditor.CoordinateListEditor.SetEditable(false);

    // When we have modified interior part coordinates ...
    if (objShapeEditor.ModifiedInteriorPartCoordinates) {

        // Loop through the modified coordinate array copies for the interior parts ...
        $.each(objShapeEditor.ModifiedInteriorPartCoordinates, function (intInteriorPart, arrModifiedCoordinateCopy) {

            // Get the interior part ...
            var objInteriorPart = objShapeEditor.SelectedPart.InteriorParts[intInteriorPart];

            // Set the interior part's coordinates ...
            objInteriorPart.Coordinates = arrModifiedCoordinateCopy;
        });
    }

    // Clear the hash table of modified interior part coordinates ...
    objShapeEditor.ModifiedInteriorPartCoordinates = null;

    // Update for the shape change ...
    objShapeEditor.UpdateForShapeChange();

    // Update the part graphics ...
    objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart);

    // When the selected part is an exterior part and the selected part has interior parts ...
    if (objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart) && (typeof objShapeEditor.SelectedPart.InteriorParts != 'undefined') && (objShapeEditor.SelectedPart.InteriorParts)) {

        // Loop through all the interior parts ...
        $.each(objShapeEditor.SelectedPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

            // Display the interior part's graphics on the map ...
            objShapeEditor.DisplayPartGraphics(objInteriorPart);
        });
    }

    // Resize the elements ...
    objShapeEditor.ResizeElements();
}

// **************************************************************************
// FUNCTION: EnableModeChange
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.EnableModeChange = function EnableModeChange() {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the mode buttons to allow a mode change ...
    objShapeEditor.ModeButtons.EnableModeChange();

    // Get the shape editor mode button ...
    var objShapeEditorModeButton = objShapeEditor.ModeButtons.GetButtonByName(TrimbleMap.ShapeEditor.Shared.MODE_BUTTON_NAME);

    // When the active mode button before editing the part was the shape editor ...
    if (objShapeEditor.ActiveModeButtonBeforeEditingPartOrReferencePoint == objShapeEditorModeButton) {

        // Select the tool that was active before editing the part ...
        objShapeEditor.SelectTool(objShapeEditor.ToolModeBeforeEditingPartOrReferencePoint);

    } else {

        // Activate the mode button that was active before editing the part ...
        objShapeEditor.ModeButtons.ActivateButton(objShapeEditor.ActiveModeButtonBeforeEditingPartOrReferencePoint);
    }
}

// **************************************************************************
// FUNCTION: DisableModeChange
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DisableModeChange = function DisableModeChange() {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the active mode button before editing the part ...
    objShapeEditor.ActiveModeButtonBeforeEditingPartOrReferencePoint = objShapeEditor.ModeButtons.ActiveButton;

    // Set the current tool mode to be the tool mode we had before editing ...
    objShapeEditor.ToolModeBeforeEditingPartOrReferencePoint = objShapeEditor.ToolMode;

    // Select the editing part coordinates tool ...
    objShapeEditor.SelectTool(TrimbleMap.ShapeEditor.enumToolMode.EditCoordinates);

    // Get the translation fro the message to display ...

    // You cannot change the mode while editing a part.
    // You cannot change the mode while editing a reference point.
    var strMessage = (objShapeEditor.EditingCoordinateMode) ? SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotChangeModePartMessage') : SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotChangeModePointMessage');

    // Set the mode buttons to not allow a mode change ...

    // Cannot change mode
    objShapeEditor.ModeButtons.DisableModeChange(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotChangeMode'), strMessage);
}
// FUNCTION: SelectShapePart
// USAGE:    blnSlide is optional, defaults to true ...
// **************************************************************************
TrimbleMap.ShapeEditor.SelectShapePart = function SelectShapePart(objPartToSelect, blnEditable, blnSlide) {

    // Get the instance ...
    var objShapeEditor = this;

    // Default blnSlide to true when not set ...
    blnSlide = ((typeof blnSlide == 'undefined') || (blnSlide == null)) ? true : blnSlide;

    // Start with the edit mode in the coordinates list not already set ...
    var blnCoordinatesListEditModeAlreadySet = false;

    if (objShapeEditor.SelectedPart != null) {
        objShapeEditor.DeactivateMapCoordinateEditor();
    }

    // When the part is not already selected ...
    if (objShapeEditor.SelectedPart != objPartToSelect) {

        // Unselect the selected reference point if we have one ...
        objShapeEditor.UnSelectReferencePoint(blnSlide).then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Show the shape part coordinates ...
            objShapeEditor.ShowShapePartDetails(blnSlide).then(TrimbleMap.Controller.Shared.TrapException(function () {

                // Resize the elements ...
                objShapeEditor.ResizeElements();
            }));
        }));

        // Take a note of the part that has been selected before ...
        var objPartSelectedBefore = objShapeEditor.SelectedPart;

        // When we have a selected part ...

        objShapeEditor.ShapePartDropDown.val(objPartToSelect.ID);

        // Set the part to be selected ...
        objShapeEditor.SelectedPart = objPartToSelect;

        // Update the graphics of the part that has been selected before to not display it in selected symbology anymore ...
        if (objPartSelectedBefore) { objShapeEditor.DisplayPartGraphics(objPartSelectedBefore); }

        // Set the part name in the part name span and textbox ...
        objShapeEditor.RenameShapePartTextBox.val(objPartToSelect.PartName);

        // Clone the coordinates array ...
        var arrClonedCoordinates = objPartToSelect.Coordinates.slice(0);

        // Get the cordinate format of the coordinate list editor ...
        var enCoordinateFormat = objShapeEditor.CoordinateListEditor.CoordinateFormat;

        // Get the spatial reference information of the shape ...
        var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // When the spatial reference changed from a projected to geographic or from geographic to projected ...
        if ((objSpatialReference.SpatialReferenceType === TrimbleMap.enumSpatialReferenceType.PROJECTED) !== (enCoordinateFormat === TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED)) {

            // Get the default coordinate format to use fo the shape's spatial reference ...
            enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID);
        }

        // Set the editable property on the coordinate list editor ...
        objShapeEditor.CoordinateListEditor.ChangeCoordinates(enCoordinateFormat, arrClonedCoordinates, false,
            TrimbleMap.Shape.Shared.DecimalPlacesForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID),
            blnEditable);

        // Update the part graphics ...
        objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart);

        // Set the coordinate list to alreay be set to be in edit mode if blnEditable is true ...
        blnCoordinatesListEditModeAlreadySet = blnEditable;

        // Scroll the coordinate list to the top ...
        objShapeEditor.CoordinateListEditor.ScrollToTop();
    }

    // When already set to be in edit mode ...
    if (!blnCoordinatesListEditModeAlreadySet) {

        // Set the editable property on the coordinate list editor ...
        objShapeEditor.CoordinateListEditor.SetEditable(blnEditable);
    }

    // Activate the map coordinate editor ...
    if (blnEditable) { objShapeEditor.ActivateMapCoordinateEditor(); }

    // When the selected part is an exterior part and the selected part has interior parts ...
    if (objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart) && (typeof objShapeEditor.SelectedPart.InteriorParts != 'undefined') && (objShapeEditor.SelectedPart.InteriorParts)) {

        // Create new hash table for the modified interior part coordinates ...
        objShapeEditor.ModifiedInteriorPartCoordinates = {};

        // Loop through all the interior parts ...
        $.each(objShapeEditor.SelectedPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

            // Remove the interior part's graphics ...
            objShapeEditor.RemovePartGraphics(objInteriorPart.ID);

            // Add a deep copy of the coordinates to the hash table ...
            objShapeEditor.ModifiedInteriorPartCoordinates[intInteriorPart] = $.map(objInteriorPart.Coordinates, function (objCoordinate, intCoordinate) { return { X: objCoordinate.X, Y: objCoordinate.Y }; });
        });
    } else { objShapeEditor.ModifiedInteriorPartCoordinates = null; }

    // Update the part graphics ...
    objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart);

    // Update the view and edit part coordinates div visibility ...
    objShapeEditor.UpdateViewAndEditPartVisibility();

    // Update the selected part area display ...
    objShapeEditor.UpdateSelectedPartAreaDisplay();

    // Update the selected part length display ...
    objShapeEditor.UpdateSelectedPartLengthDisplay();

    // Resize the elements ...
    objShapeEditor.ResizeElements();
}

// **************************************************************************
// FUNCTION: UnSelectShapePart
// USAGE:    blnSlide is optional, defaults to false ...
// **************************************************************************
TrimbleMap.ShapeEditor.UnSelectShapePart = function UnSelectShapePart(blnSlide) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we have a selected part ...
    if (objShapeEditor.SelectedPart) {


        // Get the part that we will unselect ...
        var objPartToUnSelect = objShapeEditor.SelectedPart;

        // Set to have no selected part ...
        objShapeEditor.SelectedPart = null;

        // Update the graphics of the selected part to not display it in selected symbology anymore ...
        objShapeEditor.DisplayPartGraphics(objPartToUnSelect);

        // Hide the shape part details ...
        objDeferred = objShapeEditor.HideShapePartDetails(blnSlide);

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: UnSelectReferencePoint
// USAGE:    blnSlide is optional, defaults to false ...
// **************************************************************************
TrimbleMap.ShapeEditor.UnSelectReferencePoint = function UnSelectReferencePoint(blnSlide) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When we have a selected reference point ...
    if (objShapeEditor.SelectedReferencePoint) {

        // Get the selected reference point div ...
        var objSelectedReferencePointDiv = objShapeEditor.GetReferencePointDiv(objShapeEditor.SelectedReferencePoint.ID);

        // Remove the class that indicates that it's selected ...
        objSelectedReferencePointDiv.removeClass('selected');

        // Get the reference point that we will unselect ...
        var objReferencePointToUnSelect = objShapeEditor.SelectedReferencePoint;

        // Set to have no selected reference point ...
        objShapeEditor.SelectedReferencePoint = null;

        // Update the graphics of the selected reference point to not display it in selected symbology anymore ...
        objShapeEditor.DisplayReferencePointGraphic(objReferencePointToUnSelect);

        // Hide the reference point details ...
        objDeferred = objShapeEditor.HideReferencePointCoordinate(blnSlide);

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: SelectReferencePoint
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.SelectReferencePoint = function SelectReferencePoint(objReferencePointToSelect, blnEditable) {

    // Get the instance ...
    var objShapeEditor = this;

    // Start with the edit mode in the coordinates list not already set ...
    var blnCoordinatesListEditModeAlreadySet = false;

    objShapeEditor.DeactivateMapCoordinateEditor();

    // When the reference point is not already selected ...
    if (objShapeEditor.SelectedReferencePoint != objReferencePointToSelect) {

        // Unselect the selected part if we have one ...
        objShapeEditor.UnSelectShapePart(true).then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Show the reference point destails ...
            objShapeEditor.ShowReferencePointCoordinate(true);
        }));

        // Take a note of the reference point that has been selected before ...
        var objReferencePointSelectedBefore = objShapeEditor.SelectedReferencePoint;

        // When we have a selected reference point ...
        if (objShapeEditor.SelectedReferencePoint) {

            // Get the reference point div ...
            var objReferencePointDiv = objShapeEditor.GetReferencePointDiv(objShapeEditor.SelectedReferencePoint.ID);

            // Remove the class that indicates that it's selected ...
            objReferencePointDiv.removeClass('selected');
        }

        // Get the reference point div to select ...
        var objReferencePointDivToSelect = objShapeEditor.GetReferencePointDiv(objReferencePointToSelect.ID);

        // Add the class that indicates that it's selected ...
        objReferencePointDivToSelect.addClass('selected');

        // Set the part to be selected ...
        objShapeEditor.SelectedReferencePoint = objReferencePointToSelect;

        // Update the graphics of the reference that has been selected before to not display it in the selected symbology anymore ...
        if (objReferencePointSelectedBefore) { objShapeEditor.DisplayReferencePointGraphic(objReferencePointSelectedBefore); }

        // Set the part name in the part name span and textbox ...
        objShapeEditor.ReferencePointNameSpan.text(objShapeEditor.SelectedReferencePoint.ReferencePointTypeName);

        // Create a coordinates array with the reference point ...
        var arrCoordinates = (objShapeEditor.SelectedReferencePoint.HasValues) ? [{ X: objShapeEditor.SelectedReferencePoint.X, Y: objShapeEditor.SelectedReferencePoint.Y }] : [];

        // Get the spatial reference ...
        var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // Get the coordiante format set on the coordinate list editor ...
        var enCoordinateFormat = objShapeEditor.ReferencePointCoordinateListEditor.CoordinateFormat;

        // When the spatial reference changed from a projected to geographic or from geographic to projected ...
        if ((objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) != (enCoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED)) {

            // Get the default coordinate format to use fo the shape's spatial reference ...
            enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID);
        }

        // Set the editable property on the coordinate list editor ...
        objShapeEditor.ReferencePointCoordinateListEditor.ChangeCoordinates(enCoordinateFormat, arrCoordinates, blnEditable,
            TrimbleMap.Shape.Shared.DecimalPlacesForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID),
            blnEditable);

        // Update the part graphics ...
        objShapeEditor.DisplayReferencePointGraphic(objShapeEditor.SelectedReferencePoint);

        // Set the coordinate list to alreay be set to be in edit mode ...
        blnCoordinatesListEditModeAlreadySet = blnEditable;
    }

    // When the editable property changed ...
    if (objShapeEditor.EditingReferencePoint != blnEditable) {

        // Set to not be editing the reference point ...
        objShapeEditor.EditingReferencePoint = blnEditable;

        // When already set to be in edit mode ...
        if (!blnCoordinatesListEditModeAlreadySet) {

            // Set the editable property on the coordinate list editor ...
            objShapeEditor.ReferencePointCoordinateListEditor.SetEditable(blnEditable);
        }

        // Set the dd / dms drop down location ...
        objShapeEditor.ReferencePointCoordinateListEditor.SetDDorDMSDropDownPosition({ "inset-block-start": -30, "inset-inline-start": ((blnEditable) ? -objShapeEditor.ReferencePointEditButtonsWidth : 0) });

        // Activate the map coordinate editor ...
        if (blnEditable) { objShapeEditor.ActivateMapCoordinateEditor(); }
    }

    // Update the reference point graphic ...
    objShapeEditor.DisplayReferencePointGraphic(objShapeEditor.SelectedReferencePoint);

    // Update the view and edit part coordinates div visibility ...
    objShapeEditor.UpdateViewAndEditReferencePointVisibility();

    // Resize the elements ...
    objShapeEditor.ResizeElements();
}

// **************************************************************************
// FUNCTION: ExitReferencePointEditMode
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ExitReferencePointEditMode = function ExitReferencePointEditMode() {

    // Get the instance ...
    var objShapeEditor = this;

    // Set to not be editing the reference point ...
    objShapeEditor.EditingReferencePoint = false;

    // Deactivate the map coordinate editor ...
    objShapeEditor.DeactivateMapCoordinateEditor();

    // Get the completed coordinates ...
    var arrCoordinates = objShapeEditor.ReferencePointCoordinateListEditor.GetCoordinates(false);

    // Set the reference point values ...
    objShapeEditor.SelectedReferencePoint.X = arrCoordinates[0].X;
    objShapeEditor.SelectedReferencePoint.Y = arrCoordinates[0].Y;
    objShapeEditor.SelectedReferencePoint.HasValues = true;

    // Set the coordinate list editor to not be editable ...
    objShapeEditor.ReferencePointCoordinateListEditor.SetEditable(false);
    objShapeEditor.ReferencePointCoordinateListEditor.SetDDorDMSDropDownPosition({ "inset-block-start": -28, "inset-inline-start": 0 });

    // Update the reference point graphic ...
    objShapeEditor.DisplayReferencePointGraphic(objShapeEditor.SelectedReferencePoint);

    // Set the dd or dms drop down position ...
    objShapeEditor.ReferencePointCoordinateListEditor.SetDDorDMSDropDownPosition({ "inset-block-start": -28, "inset-inline-start": 0 });

    // Update the reference points display ...
    objShapeEditor.UpdateReferencePointsDisplay();

    // Resize the elements ...
    objShapeEditor.ResizeElements();
}

// **************************************************************************
// FUNCTION: UpdateForEditModeChange
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateForEditModeChange = function UpdateForEditModeChange() {

    // Get the instance ...
    var objShapeEditor = this;

    // When a part or reference point is in edit mode ...
    if (!objShapeEditor.AllowNavigationFromPartEditing()) {

        // Add the shapemode-part-refpoint-edit class to the PartsItemsDiv if not already there ...
        if (!objShapeEditor.ShapeDiv.hasClass('shapemode-part-refpoint-edit')) { objShapeEditor.ShapeDiv.addClass('shapemode-part-refpoint-edit'); }
        $(objShapeEditor.ShapePartDropDown.attr('disabled', 'disabled'));

        // When we have a dynamic shape options link ...
        if (objShapeEditor.DefineDynamicShapeOptions) {

            // Disable the dynamic shape options link ...
            objShapeEditor.DefineDynamicShapeOptions.removeClass('shape_link');
            objShapeEditor.DefineDynamicShapeOptions.addClass('shape_link_inactive');
        }

        // When the event handlers are attached ...
        if (objShapeEditor.EventHandlersAttached) {

            // Detach event handlers to all the icon popups ...
            $.each(objShapeEditor.IconPopups, function (intIconPopup, objIconPopup) { objIconPopup.DetachEventHandlers(); });

            // Detach event handlers to all the icon popup menus ...
            $.each(objShapeEditor.IconPopupMenus, function (intIconPopupMenu, objIconPopupMenu) { objIconPopupMenu.DetachEventHandlers(); });
        }

    } else {

        // Remove the shapemode-part-refpoint-edit class to the PartsItemsDiv when present ...
        if (objShapeEditor.ShapeDiv.hasClass('shapemode-part-refpoint-edit')) { objShapeEditor.ShapeDiv.removeClass('shapemode-part-refpoint-edit'); }
        $(objShapeEditor.ShapePartDropDown.removeAttr('disabled'));

        if (objShapeEditor.DefineDynamicShapeOptions) {

            // When the coordinates are editable ...
            if (objShapeEditor.CoordinatesEditable) {

                // Enable the dynamic shape options link ...
                objShapeEditor.DefineDynamicShapeOptions.removeClass('shape_link_inactive');
                objShapeEditor.DefineDynamicShapeOptions.addClass('shape_link');

            } else {

                // Disable the dynamic shape options link ...
                objShapeEditor.DefineDynamicShapeOptions.removeClass('shape_link');
                objShapeEditor.DefineDynamicShapeOptions.addClass('shape_link_inactive');
            }
        }

        // When the event handlers are attached ...
        if (objShapeEditor.EventHandlersAttached) {

            // Attach the event handlers to the re-project popup ...
            if (objShapeEditor.ReProjectPopup) { objShapeEditor.ReProjectPopup.AttachEventHandlers(); }

            // Attach event handlers to all the icon popups ...
            $.each(objShapeEditor.IconPopups, function (intIconPopup, objIconPopup) { objIconPopup.AttachEventHandlers(); });

            // Attach event handlers to all the icon popup menus ...
            $.each(objShapeEditor.IconPopupMenus, function (intIconPopupMenu, objIconPopupMenu) { objIconPopupMenu.AttachEventHandlers(); });
        }
    }
}

// **************************************************************************
// FUNCTION: AllowNavigationFromPartEditing
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AllowNavigationFromPartEditing = function AllowNavigationFromPartEditing() {
    let objShapeEditor = this;

    let blnAddingNewPart = objShapeEditor.AddingNewPart;
    let blnSelectedPartInvalid = !objShapeEditor.SelectedPartOrReferencePointValid;

    let blnReturn = !(blnAddingNewPart || blnSelectedPartInvalid);

    return blnReturn;
}

// **************************************************************************
// FUNCTION: GetShapePartDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetShapePartDiv = function GetShapePartDiv(strPartID) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the shape part div ...
    var objShapePartDiv = objShapeEditor.ShapePartDivs[strPartID];

    return objShapePartDiv;
}

// **************************************************************************
// FUNCTION: GetReferencePointDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetReferencePointDiv = function GetReferencePointDiv(strReferencePointID) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the reference point div ...
    var objReferencePointDiv = objShapeEditor.ReferencePointDivs[strReferencePointID];

    return objReferencePointDiv;
}

// **************************************************************************
// FUNCTION: ShowShapePartDetails
// USAGE:    blnSlide is optional, defaults to false ...
// **************************************************************************
TrimbleMap.ShapeEditor.ShowShapePartDetails = function ShowShapePartDetails(blnSlide) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the shape part details is not visible ...
    if (!objShapeEditor.ShapePartDetailsVisible) {

        // When we are not to slide ...
        if ((typeof blnSlide == 'undefined') || !blnSlide) {

            // Show the shape part details div ...
            objShapeEditor.ShapePartDetailsDiv.show();

            // Set the shape part details to be visible ...
            objShapeEditor.ShapePartDetailsVisible = true;

            // Resolve the deferred ...
            objDeferred.resolve();

        } else {

            // Show the shape part details div ...
            objShapeEditor.ShapePartDetailsDiv.slideDown(TrimbleMap.ShapeEditor.Shared.SLIDE_TIME_MS, function () {

                // Set the shape part details to be visible ...
                objShapeEditor.ShapePartDetailsVisible = true;

                // Resolve the deferred ...
                objDeferred.resolve();
            });
        }
    } else {

        objDeferred.resolve();
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: HideShapePartDetails
// USAGE:    blnSlide is optional, defaults to false ...
// **************************************************************************
TrimbleMap.ShapeEditor.HideShapePartDetails = function HideShapePartDetails(blnSlide) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the shape part details is visible ...
    if (objShapeEditor.ShapePartDetailsVisible) {

        // When we are not to slide ...
        if ((typeof blnSlide == 'undefined') || !blnSlide) {

            // Hide the div ...
            objShapeEditor.ShapePartDetailsDiv.hide();

            // Set the shape part details to not be visible ...
            objShapeEditor.ShapePartDetailsVisible = false;

            // Resolve the deferred ...
            objDeferred.resolve();

        } else {

            // Slide the shape part details div up ...
            objShapeEditor.ShapePartDetailsDiv.slideUp(TrimbleMap.ShapeEditor.Shared.SLIDE_TIME_MS, function () {

                // Set the shape part details to not be visible ...
                objShapeEditor.ShapePartDetailsVisible = false;

                // Resolve the deferred ...
                objDeferred.resolve();
            });
        }
    } else {

        objDeferred.resolve();
    }
    return objDeferred;
}

// **************************************************************************
// FUNCTION: ShowReferencePointCoordinate
// USAGE:    blnSlide is optional, defaults to false ...
// **************************************************************************
TrimbleMap.ShapeEditor.ShowReferencePointCoordinate = function ShowReferencePointCoordinate(blnSlide) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the reference point details is not visible ...
    if (!objShapeEditor.ReferencePointDetailsVisible) {

        // When we are not to slide ...
        if ((typeof blnSlide == 'undefined') || !blnSlide) {

            // Show the reference point details div ...
            objShapeEditor.ReferencePointCoordinateDiv.show();

            // Set the reference point details to be visible ...
            objShapeEditor.ReferencePointDetailsVisible = true;

            // Resolve the deferred ...
            objDeferred.resolve();

        } else {

            // Show the reference point details div ...
            objShapeEditor.ReferencePointCoordinateDiv.slideDown(TrimbleMap.ShapeEditor.Shared.SLIDE_TIME_MS, function () {

                // Set the reference point details to be visible ...
                objShapeEditor.ReferencePointDetailsVisible = true;

                // Resolve the deferred ...
                objDeferred.resolve();
            });
        }
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: HideReferencePointCoordinate
// USAGE:    blnSlide is optional, defaults to false ...
// **************************************************************************
TrimbleMap.ShapeEditor.HideReferencePointCoordinate = function HideReferencePointCoordinate(blnSlide) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the reference point details is visible ...
    if (objShapeEditor.ReferencePointDetailsVisible) {

        // When we are not to slide ...
        if ((typeof blnSlide == 'undefined') || !blnSlide) {

            // Hide the div ...
            objShapeEditor.ReferencePointCoordinateDiv.hide();

            // Set the reference point details to not be visible ...
            objShapeEditor.ReferencePointDetailsVisible = false;

            // Resolve the deferred ...
            objDeferred.resolve();

        } else {

            // Slide the reference point details div up ...
            objShapeEditor.ReferencePointCoordinateDiv.slideUp(TrimbleMap.ShapeEditor.Shared.SLIDE_TIME_MS, function () {

                // Set the reference point details to not be visible ...
                objShapeEditor.ReferencePointDetailsVisible = false;

                // Resolve the deferred ...
                objDeferred.resolve();
            });
        }
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: SelectTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.SelectTool = function SelectTool(enShapeTool) {

    // Get the instance ...
    var objShapeEditor = this;

    // When not already selected ...
    if (enShapeTool != objShapeEditor.ToolMode) {

        // De-Activate the tool ...
        objShapeEditor.DeActivateTool();

        // Remove the selected class from the currently selected tool ...
        $(objShapeEditor.ShapeDiv.find('.shape_icon_div_selected')).removeClass('shape_icon_div_selected');

        // Get the shape tool button ...
        var objShapeToolButton = objShapeEditor.ShapeDiv.find('[ShapeTool="' + enShapeTool + '"]');

        // Add the selected class to the icon ...
        objShapeToolButton.addClass('shape_icon_div_selected');

        // Set the tool mode ...
        objShapeEditor.ToolMode = enShapeTool;

        // Get the mode button by name ...
        var objButtonToActivate = objShapeEditor.ModeButtons.GetButtonByName(TrimbleMap.ShapeEditor.Shared.MODE_BUTTON_NAME);

        // Activate the button ...
        objShapeEditor.ModeButtons.ActivateButton(objButtonToActivate);

        // Activate the tool ...
        objShapeEditor.ActivateTool();
    }
}

// **************************************************************************
// FUNCTION: ActivateTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateTool = function ActivateTool() {

    // Get the map Shape instance
    var objShapeEditor = this;

    // When the selected tool is not currently active ...
    if (!objShapeEditor.IsToolActive) {

        // Activate the tool based on the ToolMode ...
        switch (objShapeEditor.ToolMode) {
            case TrimbleMap.ShapeEditor.enumToolMode.DrawGeometry:

                // Activate polygon input ...
                objShapeEditor.ActivateGeometryInput(objShapeEditor.Shape.GeometryType);
                break;

            case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon:

                // Activate the block selection by polygon tool ...
                objShapeEditor.ActivateBlockSelectionByPolygonTool();
                break;

            case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint:

                // Activate the block selection by point tool ...
                objShapeEditor.ActivateBlockSelectionByPointTool();
                break;
        }

        // Set the selected tool to be active ...
        objShapeEditor.IsToolActive = true;
    }
}

// **************************************************************************
// FUNCTION: DeActivateTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateTool = function DeActivateTool() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the selected tool is active ...
    if (objShapeEditor.IsToolActive) {

        // De-activate the tool based on the ToolMode ...
        switch (objShapeEditor.ToolMode) {
            case TrimbleMap.ShapeEditor.enumToolMode.DrawGeometry:

                // De-activate polygon input ...
                objShapeEditor.DeActivateGeometryInput();
                break;

            case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon:

                // De-Activate the block selection by polygon tool ...
                objShapeEditor.DeActivateBlockSelectionByPolygonTool();
                break;

            case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint:

                // De-activate the block selection by point tool ...
                objShapeEditor.DeActivateBlockSelectionByPointTool();
                break;
        }

        // Set the selected tool to not be active ...
        objShapeEditor.IsToolActive = false;
    }
}

// **************************************************************************
// FUNCTION: ActivateGeometryInput
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateGeometryInput = function ActivateGeometryInput(enGeometryType) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the map has been loaded successfully ...
    if (objShapeEditor.MapController.EsriMap.loaded) {

        // Create a new drawing toolbar for the map ...
        objShapeEditor.EsriDrawingToolbar = new esri.toolbars.Draw(objShapeEditor.MapController.EsriMap);

        // Connect to the onDrawEnd event ...
        objShapeEditor.EndPolygonDrawingHandle = dojo.connect(objShapeEditor.EsriDrawingToolbar, "onDrawEnd", objShapeEditor.GeometryDrawEndHandlerProxy);

        // Determine the drawing tool geometry type constant ...
        var strDrawingToolGeometryType = '';
        switch (enGeometryType) {
            case TrimbleMap.Shape.enumGeometryType.POINT: strDrawingToolGeometryType = esri.toolbars.Draw.POINT; break;
            case TrimbleMap.Shape.enumGeometryType.POLYGON: strDrawingToolGeometryType = esri.toolbars.Draw.POLYGON; break;
            case TrimbleMap.Shape.enumGeometryType.POLYLINE: strDrawingToolGeometryType = esri.toolbars.Draw.POLYLINE; break;
            case TrimbleMap.Shape.enumGeometryType.MIXED: strDrawingToolGeometryType = esri.toolbars.Draw.POLYGON; break;
            default: strDrawingToolGeometryType = esri.toolbars.Draw.POLYGON; break;
        }

        // Activate the drawing toolbar in poylgon mode ...
        objShapeEditor.EsriDrawingToolbar.activate(strDrawingToolGeometryType);
    }
}

// **************************************************************************
// FUNCTION: DeActivateGeometryInput
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateGeometryInput = function DeActivateGeometryInput() {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have a drawing toolbar ...
    if (objShapeEditor.EsriDrawingToolbar) {

        // Deactivate it ...
        objShapeEditor.EsriDrawingToolbar.deactivate();

        // Set it to be null ...
        objShapeEditor.EsriDrawingToolbar = null;

        // Detach the poylgon drawing end event handler ...
        dojo.disconnect(objShapeEditor.EndPolygonDrawingHandle);
    }
}

// **************************************************************************
// FUNCTION: ActivateBlockSelectionByPointTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateBlockSelectionByPointTool = function ActivateBlockSelectionByPointTool() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the map has been loaded successfully ...
    if (objShapeEditor.MapController.EsriMap.loaded) {

        // Update the block selection modification enabled state ...
        objShapeEditor.UpdateBlockSelectionModificationEnabledState();
    }
}

// **************************************************************************
// FUNCTION: DeActivateBlockSelectionByPointTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateBlockSelectionByPointTool = function DeActivateBlockSelectionByPointTool() {

    // Get the instance ...
    var objShapeEditor = this;

    // Disable the block selection by point modification ...
    objShapeEditor.DisableBlockSelectionByPointModification();

    // De-Activate the graticule renderer ...
    objShapeEditor.DeActivateGraticuleRenderer();

    // Remove the info messages added by this instance ...
    objShapeEditor.RemoveBlockSelectionInfoMessages();
}

// **************************************************************************
// FUNCTION: ActivateBlockSelectionByPolygonTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateBlockSelectionByPolygonTool = function ActivateBlockSelectionByPolygonTool() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the map has been loaded successfully ...
    if (objShapeEditor.MapController.EsriMap.loaded) {

        // Update the block selection modification enabled state ...
        objShapeEditor.UpdateBlockSelectionModificationEnabledState();
    }
}

// **************************************************************************
// FUNCTION: DeActivateBlockSelectionByPolygonTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateBlockSelectionByPolygonTool = function DeActivateBlockSelectionByPolygonTool() {

    // Get the instance ...
    var objShapeEditor = this;

    // Enable the block selection by polygon modification ...
    objShapeEditor.DisableBlockSelectionByPolygonModification();

    // De-Activate the graticule renderer ...
    objShapeEditor.DeActivateGraticuleRenderer();

    // Remove the info messages added by this instance ...
    objShapeEditor.RemoveBlockSelectionInfoMessages();
}

// **************************************************************************
// FUNCTION: EnableBlockSelectionModification
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.EnableBlockSelectionModification = function EnableBlockSelectionModification() {

    // Get the instance ...
    var objShapeEditor = this;

    // Based on the tool mode ...
    switch (objShapeEditor.ToolMode) {
        case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon:

            // Enable the block selection by polygon modification ...
            objShapeEditor.EnableBlockSelectionByPolygonModification();
            break;

        case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint:

            // Enable the block selection by point modification ...
            objShapeEditor.EnableBlockSelectionByPointModification();
            break;
    }
}

// **************************************************************************
// FUNCTION: DisableBlockSelectionModification
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DisableBlockSelectionModification = function DisableBlockSelectionModification() {

    // Get the instance ...
    var objShapeEditor = this;

    // Based on the tool mode ...
    switch (objShapeEditor.ToolMode) {
        case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon:

            // Enable the block selection by polygon modification ...
            objShapeEditor.DisableBlockSelectionByPolygonModification();
            break;

        case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint:

            // Enable the block selection by point modification ...
            objShapeEditor.DisableBlockSelectionByPointModification();
            break;
    }
}

// **************************************************************************
// FUNCTION: EnableBlockSelectionByPointModification
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.EnableBlockSelectionByPointModification = function EnableBlockSelectionByPointModification() {

    // Get the instance ...
    var objShapeEditor = this;

    // When block selection by point modification is not already enabled ...
    if (!objShapeEditor.IsBlockSelectionByPointModificationEnabled) {

        // Attach a mouse move event handler to the map ...
        objShapeEditor.MouseMoveHandle = objShapeEditor.MapController.EsriMap.on('mouse-move', objShapeEditor.MouseMoveProxy);

        // Attach a mouse down event handler to the map ...
        objShapeEditor.MouseDownHandle = objShapeEditor.MapController.EsriMap.on('mouse-down', objShapeEditor.MouseDownProxy);

        // Attach a mouse up event handler to the map ...
        objShapeEditor.MouseUpHandle = objShapeEditor.MapController.EsriMap.on('mouse-up', objShapeEditor.MouseUpProxy);

        // Attach a mouse out event handler to the map ...
        objShapeEditor.MouseOutHandle = objShapeEditor.MapController.EsriMap.on('mouse-out', objShapeEditor.MouseOutProxy);

        // Attach a pan-start event handler to the map ...
        objShapeEditor.PanStartHandle = objShapeEditor.MapController.EsriMap.on('pan-start', objShapeEditor.PanStartProxy);

        // Attach a pan-end event handler to the map ...
        objShapeEditor.PanEndHandle = objShapeEditor.MapController.EsriMap.on('pan-end', objShapeEditor.PanEndProxy);

        // Attach a zoom-start event handler to the map ...
        objShapeEditor.ZoomStartHandle = objShapeEditor.MapController.EsriMap.on('zoom-start', objShapeEditor.ZoomStartProxy);

        // Attach a zoom-end event handler to the map ...
        objShapeEditor.ZoomEndHandle = objShapeEditor.MapController.EsriMap.on('zoom-end', objShapeEditor.ZoomEndProxy);

        // Set the modification to be enabled ...
        objShapeEditor.IsBlockSelectionByPointModificationEnabled = true;
    }
}

// **************************************************************************
// FUNCTION: DisableBlockSelectionByPointModification
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DisableBlockSelectionByPointModification = function DisableBlockSelectionByPointModification() {

    // Get the instance ...
    var objShapeEditor = this;

    // When block selection by point modification is enabled ...
    if (objShapeEditor.IsBlockSelectionByPointModificationEnabled) {

        // Detach the mouse move event handler ...
        objShapeEditor.MouseMoveHandle.remove();

        // Detach the mouse down event handler ...
        objShapeEditor.MouseDownHandle.remove();

        // Detach the mouse up event handler ...
        objShapeEditor.MouseUpHandle.remove();

        // Detach the mouse out event handler ...
        objShapeEditor.MouseOutHandle.remove();

        // Attach a pan-start event handler to the map ...
        objShapeEditor.PanStartHandle.remove();

        // Attach a pan-end event handler to the map ...
        objShapeEditor.PanEndHandle.remove();

        // Attach a zoom-start event handler to the map ...
        objShapeEditor.ZoomStartHandle.remove();

        // Attach a zoom-end event handler to the map ...
        objShapeEditor.ZoomEndHandle.remove();

        // Remove the hovered block graphic from the map when we have one ...
        if (objShapeEditor.HoveredBlockGraphic != null) { objShapeEditor.MapController.EsriMap.graphics.remove(objShapeEditor.HoveredBlockGraphic); }

        // Set the hovered block properties to null ...
        objShapeEditor.HoveredBlockXIndex = null;
        objShapeEditor.HoveredBlockYIndex = null;
        objShapeEditor.HoveredBlockGraphic = null;
        objShapeEditor.DelayedMouseMoveScreenPoint = null;

        // Set modification to be enabled ...
        objShapeEditor.IsBlockSelectionByPointModificationEnabled = false;
    }
}

// **************************************************************************
// FUNCTION: EnableBlockSelectionByPolygonModification
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.EnableBlockSelectionByPolygonModification = function EnableBlockSelectionByPolygonModification() {

    // Get the instance ...
    var objShapeEditor = this;

    // When block selection by polygon modification is not already enabled ...
    if (!objShapeEditor.IsBlockSelectionByPolygonModificationEnabled) {

        // Activate polygon input ...
        objShapeEditor.ActivateGeometryInput(TrimbleMap.Shape.enumGeometryType.POLYGON);

        // Set modification to be enabled ...
        objShapeEditor.IsBlockSelectionByPolygonModificationEnabled = true;
    }
}

// **************************************************************************
// FUNCTION: DisableBlockSelectionByPolygonModification
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DisableBlockSelectionByPolygonModification = function DisableBlockSelectionByPolygonModification() {

    // Get the instance ...
    var objShapeEditor = this;

    // When block selection by polygon modification is enabled ...
    if (objShapeEditor.IsBlockSelectionByPolygonModificationEnabled) {

        // De-activate polygon input ...
        objShapeEditor.DeActivateGeometryInput();

        // Set modification to be disabled ...
        objShapeEditor.IsBlockSelectionByPolygonModificationEnabled = false;
    }
}

// **************************************************************************
// FUNCTION: ActivateGraticuleRenderer
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateGraticuleRenderer = function ActivateGraticuleRenderer() {

    // Get the instance ...
    var objShapeEditor = this;

    // When we've not created the graticule renderer yet ...
    if (objShapeEditor.GraticuleRenderer == null) {

        // Create the graticule renderer ...
        objShapeEditor.GraticuleRenderer = TrimbleMap.GraticuleRenderer.CreateInstance(objShapeEditor.MapController,
            objShapeEditor.Options.GridOptions.GridBlockSideLengthMultiplier / objShapeEditor.Options.GridOptions.GridBlockSideLengthDivider,
            objShapeEditor.Options.GridOptions.SpatialReferenceID,
            TrimbleMap.GraticuleRenderer.enumGridSizeType.Fixed,
            {
                R: objShapeEditor.Options.GridOptions.GridColorRed,
                G: objShapeEditor.Options.GridOptions.GridColorGreen,
                B: objShapeEditor.Options.GridOptions.GridColorBlue
            });
    }

    // Add the graticule renderer visibility and extent validity changed event handlers ...
    objShapeEditor.GraticuleRenderer.AddOnVisiblityChanged(objShapeEditor.GraticuleRendererVisibilityChangedProxy);
    objShapeEditor.GraticuleRenderer.AddOnExtentValidityChanged(objShapeEditor.GraticuleRendererExtentValidityChangedProxy);

    // Create an array for the info messages ...
    var arrInfoMessages = [];
    var strIconCssClass;
    var strMessageDataKey = '';

    switch (objShapeEditor.ToolMode) {
        case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon:

            // 'You are zoomed out too far to see the grid.'
            arrInfoMessages.push(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ZoomedOutTooFarToSeeGrid'));

            // 'Zoom in closer to see the grid.'
            arrInfoMessages.push(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ZoomInCloserToSeeGrid'));

            // Set the icon css class ...
            strIconCssClass = 'shape_block_selection_by_polygon_tool';

            // Set the message data key ...
            strMessageDataKey = TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_BY_POLYGON_NOT_VISIBLE_MESSAGE_DATA_KEY;
            break;

        case TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint:

            // 'You are zoomed out too far to use the block selection tool.'
            arrInfoMessages.push(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ZoomedOutTooFarToUseBlockSelectionTool'));

            // 'Zoom in closer to see the grid and activate the tool.'
            arrInfoMessages.push(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ZoomInCloserToSeeTheGridAndActivateTool'));

            // Set the icon css class ...
            strIconCssClass = 'shape_block_selection_by_point_tool';

            // Set the message data key ...
            strMessageDataKey = TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_BY_POINT_NOT_VISIBLE_MESSAGE_DATA_KEY;
            break;
    }

    // Set the info message to display when teh grid is not visible ...
    objShapeEditor.GraticuleRenderer.SetInfoMessageDataToDisplayWhenHidden(TrimbleMap.InfoMessage.Shared.CreateMessageData(strMessageDataKey, arrInfoMessages, true, strIconCssClass));

    // Create an array for the invalid extent messages ...
    var arrInvalidExtentMessages = [];

    // 'The current location is outside of the grid.'
    arrInvalidExtentMessages.push(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ZoomInCloserToSeeTheGridAndActivateTool'));

    // 'Move to a location inside the grid to see the grid and use the tool.'
    arrInvalidExtentMessages.push(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'MoveToLocationInsideGrid'));

    // Set the info messages to display when teh extent is invalid ...
    objShapeEditor.GraticuleRenderer.SetInfoMessageDataToDisplayWhenInvalidExtent(TrimbleMap.InfoMessage.Shared.CreateMessageData(TrimbleMap.ShapeEditor.Shared.BLOCK_SELECTION_INVALID_EXTENT_MESSAGE_DATA_KEY,
        arrInvalidExtentMessages, true, strIconCssClass));

    // Activate the graticule renderer ...
    objShapeEditor.GraticuleRenderer.Activate();
}

// **************************************************************************
// FUNCTION: DeActivateGraticuleRenderer
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateGraticuleRenderer = function DeActivateGraticuleRenderer() {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have a graticule renderer ...
    if (objShapeEditor.GraticuleRenderer != null) {

        // Remove the graticule renderer visibility and extent validity changed event handlers ...
        objShapeEditor.GraticuleRenderer.RemoveOnVisiblityChanged(objShapeEditor.GraticuleRendererVisibilityChangedProxy);
        objShapeEditor.GraticuleRenderer.RemoveOnExtentValidityChanged(objShapeEditor.GraticuleRendererExtentValidityChangedProxy);

        // DeActivate the graticule renderer ...
        objShapeEditor.GraticuleRenderer.DeActivate();
    }
}

// **************************************************************************
// FUNCTION: GraticuleRendererVisibilityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GraticuleRendererVisibilityChanged = function GraticuleRendererVisibilityChanged(blnVisible) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the tool mode is block selection by point ...
    if (objShapeEditor.ToolMode == TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint) {

        // When visible ...
        if (blnVisible) {

            // Enable the block selection by point modification ...
            objShapeEditor.EnableBlockSelectionByPointModification();

        } else {

            // Disable the block selection by point modification ...
            objShapeEditor.DisableBlockSelectionByPointModification();
        }
    }
}

// **************************************************************************
// FUNCTION: GraticuleRendererExtentValidityChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GraticuleRendererExtentValidityChanged = function GraticuleRendererExtentValidityChanged(blnValidExtent) {

    // Get the instance ...
    var objShapeEditor = this;

    // Update the block selection modification enabled state ...
    objShapeEditor.UpdateBlockSelectionModificationEnabledState();
}

// **************************************************************************
// FUNCTION: MouseMove
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.MouseMove = function MouseMove(objScreenPoint) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the mouse to be in view ...
    objShapeEditor.IsMouseInView = true;

    // When not panning or zooming ...
    if ((!objShapeEditor.IsPanning) && (!objShapeEditor.IsZooming) && objShapeEditor.GraticuleRenderer.ShowFixedSizeBlocksAtCurrentScale && objShapeEditor.GraticuleRenderer.IsValidExtent) {

        // When a previous mouse move event processing is not in progress ...
        if (!objShapeEditor.IsBlockSelectionMouseMoveProcessingInProgress) {

            // Set to be in progress ...
            objShapeEditor.IsBlockSelectionMouseMoveProcessingInProgress = true;

            // Convert the mouse location from screen space to map space ...
            var objMousePointInMap = objShapeEditor.MapController.EsriMap.toMap(new esri.geometry.ScreenPoint(objScreenPoint.x, objScreenPoint.y));

            // Project the mouse point to the grid spatial reference ...
            var objProjectionDeferred = objShapeEditor.MapController.ProjectGeometry(objMousePointInMap, objShapeEditor.MapController.CurrentMap.SpatialReferenceID, objShapeEditor.Options.GridOptions.SpatialReferenceID, true, TrimbleMap.enumProjectionLevel.RELAXED);

            // When the projection completes ...
            objProjectionDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objMousePointInGrid) {

                // Compute the grid side length ...
                var decGridSideLength = objShapeEditor.Options.GridOptions.GridBlockSideLengthMultiplier / objShapeEditor.Options.GridOptions.GridBlockSideLengthDivider;

                // Compute the x and y indices in the grid ...
                var intXIndex = Math.floor(objMousePointInGrid.x / decGridSideLength);
                var intYIndex = Math.floor(objMousePointInGrid.y / decGridSideLength);

                // When we do not currently have a hovered block or the block index changed ...
                if ((objShapeEditor.HoveredBlockGraphic == null) || (objShapeEditor.HoveredBlockXIndex != intXIndex) || (objShapeEditor.HoveredBlockYIndex != intYIndex)) {

                    // Set the hovered block indexes ...
                    objShapeEditor.HoveredBlockXIndex = intXIndex;
                    objShapeEditor.HoveredBlockYIndex = intYIndex;

                    // Remove the hovered block graphic from the map when we already have one ...
                    if (objShapeEditor.HoveredBlockGraphic != null) { objShapeEditor.MapController.EsriMap.graphics.remove(objShapeEditor.HoveredBlockGraphic); }

                    // Create the grid esri spatial reference ...
                    var objGridEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Options.GridOptions.SpatialReferenceID);

                    // Create a polygon to represent the block ...
                    objShapeEditor.HoveredBlockGeometryInGrid = new esri.geometry.Polygon(objGridEsriSpatialReference);

                    // Add the corner points of the block as a ring ...
                    objShapeEditor.HoveredBlockGeometryInGrid.addRing([[intXIndex * decGridSideLength, intYIndex * decGridSideLength],
                    [intXIndex * decGridSideLength, (intYIndex + 1) * decGridSideLength],
                    [(intXIndex + 1) * decGridSideLength, (intYIndex + 1) * decGridSideLength],
                    [(intXIndex + 1) * decGridSideLength, intYIndex * decGridSideLength],
                    [intXIndex * decGridSideLength, intYIndex * decGridSideLength]]);

                    // Round the selected block to the spatial references decimal places in order to match the shape accuracy to prevent any blocks not matching on the shape ...
                    var objGeometrySpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Options.GridOptions.SpatialReferenceID);

                    for (var i = 0; i < objShapeEditor.HoveredBlockGeometryInGrid.rings[0].length; i++) {
                        objShapeEditor.HoveredBlockGeometryInGrid.rings[0][i][0] = SD.Number.RoundTo(objShapeEditor.HoveredBlockGeometryInGrid.rings[0][i][0], objGeometrySpatialReference.DecimalPlaces)
                        objShapeEditor.HoveredBlockGeometryInGrid.rings[0][i][1] = SD.Number.RoundTo(objShapeEditor.HoveredBlockGeometryInGrid.rings[0][i][1], objGeometrySpatialReference.DecimalPlaces)
                    };

                    // Project the block extent to the map spatial reference ...
                    var objBlockProjectionDeferred = objShapeEditor.MapController.ProjectGeometry(objShapeEditor.HoveredBlockGeometryInGrid, objShapeEditor.Options.GridOptions.SpatialReferenceID, objShapeEditor.MapController.CurrentMap.SpatialReferenceID, true, TrimbleMap.enumProjectionLevel.RELAXED);

                    // When the projection completes ...
                    objBlockProjectionDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objHoveredBlockInMap) {

                        // When the mouse is in view and the grid is to be shown in the current view ...
                        if (objShapeEditor.IsMouseInView && objShapeEditor.GraticuleRenderer.ShowFixedSizeBlocksAtCurrentScale) {

                            // Create a new graphic for the block ...
                            objShapeEditor.HoveredBlockGraphic = new esri.Graphic(objHoveredBlockInMap, objShapeEditor.BlockSelectionHoveredBlockSymbol);

                            // Add the graphic to the map ...
                            objShapeEditor.MapController.EsriMap.graphics.add(objShapeEditor.HoveredBlockGraphic);

                            // Set to not be in progress anymore ...
                            objShapeEditor.IsBlockSelectionMouseMoveProcessingInProgress = false;

                            // When we have a delayed mouse move screen point ...
                            if (objShapeEditor.DelayedMouseMoveScreenPoint != null) {

                                // Process the delayed mouse move event ...
                                objShapeEditor.MouseMove(objShapeEditor.DelayedMouseMoveScreenPoint);

                                // Clear the delayed mouse move screen point ....
                                objShapeEditor.DelayedMouseMoveScreenPoint = null;
                            }

                        } else {

                            // Set to not be in progress anymore ...
                            objShapeEditor.IsBlockSelectionMouseMoveProcessingInProgress = false;

                            // Clear the delayed mouse move screen point ....
                            objShapeEditor.DelayedMouseMoveScreenPoint = null;
                        }
                    }));

                } else {

                    // Set to not be in progress anymore ...
                    objShapeEditor.IsBlockSelectionMouseMoveProcessingInProgress = false;

                    // When we have a delayed mouse move screen point ...
                    if (objShapeEditor.DelayedMouseMoveScreenPoint != null) {

                        // Process the delayed mouse move event ...
                        objShapeEditor.MouseMove(objShapeEditor.DelayedMouseMoveScreenPoint);

                        // Clear the delayed mouse move screen point ....
                        objShapeEditor.DelayedMouseMoveScreenPoint = null;
                    }
                }
            }));

        } else {

            // Set the delayed mouse move screen point ...
            objShapeEditor.DelayedMouseMoveScreenPoint = objScreenPoint;
        }
    }
}

// **************************************************************************
// FUNCTION: MouseDown
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.MouseDown = function MouseDown(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Remember the screen point at which the mouse were pressed down ...
    objShapeEditor.MouseDownScreenPoint = new esri.geometry.ScreenPoint(e.screenPoint.x, e.screenPoint.y);
}

// **************************************************************************
// FUNCTION: MouseUp
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.MouseUp = function MouseUp(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // When teh grid is visble and the extent is valid ...
    if ((objShapeEditor.GraticuleRenderer.ShowFixedSizeBlocksAtCurrentScale) && (objShapeEditor.GraticuleRenderer.IsValidExtent) && (objShapeEditor.MouseDownScreenPoint != null)) {

        // If the mouse did not move since it was pressed down ...
        if ((e.screenPoint.x == objShapeEditor.MouseDownScreenPoint.x) && (e.screenPoint.y == objShapeEditor.MouseDownScreenPoint.y)) {

            // Perform the drawing function based on the draw mode ...
            switch (objShapeEditor.DrawMode) {
                case TrimbleMap.ShapeEditor.enumDrawMode.Add:

                    // Draw to add the polygon ...
                    objShapeEditor.DrawToAdd(objShapeEditor.HoveredBlockGeometryInGrid, objShapeEditor.Options.GridOptions.SpatialReferenceID, null, true);
                    break;

                case TrimbleMap.ShapeEditor.enumDrawMode.Remove:

                    // Draw to remove the polygon ...
                    objShapeEditor.DrawToRemove(objShapeEditor.HoveredBlockGeometryInGrid, objShapeEditor.Options.GridOptions.SpatialReferenceID);
                    break;
            }
        }
    }
}

// **************************************************************************
// FUNCTION: MouseOut
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.MouseOut = function MouseOut(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the mouse to not be in view ...
    objShapeEditor.IsMouseInView = false;

    // Remove the hovered block graphic from the map when we have one ...
    if (objShapeEditor.HoveredBlockGraphic != null) { objShapeEditor.MapController.EsriMap.graphics.remove(objShapeEditor.HoveredBlockGraphic); }

    // Set the hovered block properties to null ...
    objShapeEditor.HoveredBlockXIndex = null;
    objShapeEditor.HoveredBlockYIndex = null;
    objShapeEditor.HoveredBlockGraphic = null;
    objShapeEditor.DelayedMouseMoveScreenPoint = null;
}

// **************************************************************************
// FUNCTION: PanStart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.PanStart = function PanStart(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set to be panning ...
    objShapeEditor.IsPanning = true;
}

// **************************************************************************
// FUNCTION: PanEnd
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.PanEnd = function PanEnd(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set to not be panning ...
    objShapeEditor.IsPanning = false;
}

// **************************************************************************
// FUNCTION: ZoomStart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ZoomStart = function ZoomStart(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set to be zooming ...
    objShapeEditor.IsZooming = true;
}

// **************************************************************************
// FUNCTION: ZoomEnd
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ZoomEnd = function ZoomEnd(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set to not be zooming ...
    objShapeEditor.IsZooming = false;
}

// **************************************************************************
// FUNCTION: GeometryDrawEndHandler
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GeometryDrawEndHandler = function GeometryDrawEndHandler(objEsriGeometry) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the block selection by polygon is activated ...
    if (objShapeEditor.ToolMode == TrimbleMap.ShapeEditor.enumToolMode.DrawGeometry) {

        // Perform the drawing function based on the draw mode ...
        switch (objShapeEditor.DrawMode) {
            case TrimbleMap.ShapeEditor.enumDrawMode.Add:

                // Draw to add the polygon ...
                objShapeEditor.DrawToAdd(objEsriGeometry, objShapeEditor.MapController.CurrentMap.SpatialReferenceID);
                break;

            case TrimbleMap.ShapeEditor.enumDrawMode.Remove:

                // Draw to remove the polygon ...
                objShapeEditor.DrawToRemove(objEsriGeometry, objShapeEditor.MapController.CurrentMap.SpatialReferenceID);
                break;
        }

    } else if (objShapeEditor.ToolMode == TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon) {

        // Create a new shape part ...
        var objShapePart = TrimbleMap.ShapePart.CreateInstance('Part 1', SD.Guid.Shared.NewID());

        // Convert the geometry to an array of coordinates and place it on the part ...
        objShapePart.Coordinates = TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objEsriGeometry, 0);

        // Create a new shape in the maps spatial reference ...
        var objShape = TrimbleMap.Shape.CreateInstance(objShapeEditor.MapController.CurrentMap.SpatialReferenceID, TrimbleMap.Shape.enumGeometryType.POLYGON, [objShapePart]);

        // Get the grid spatial reference ...
        var objGridSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Options.GridOptions.SpatialReferenceID);
        var objGridEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Options.GridOptions.SpatialReferenceID);

        // Project the shape to the grid's spatial reference ...
        var objProjectDeferred = objShape.Project(objShapeEditor.MapController, objGridSpatialReference.SpatialReferenceID, true);

        // When the project completes ...
        objProjectDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

            // Convert the part to blocks ...
            TrimbleMap.ConvertPolygonToBlock.ConvertToBlocks(objShape, objShapeEditor.Options.GridOptions.GridBlockSideLengthMultiplier, objShapeEditor.Options.GridOptions.GridBlockSideLengthDivider, Math.pow(10, -objGridSpatialReference.DecimalPlaces), true);

            // Convert the shape to an esri polygon ...
            var objConvertedGeometry = objShape.ToEsriPolygon(objShapeEditor.MapController, {}, true);

            // Perform the drawing function based on the draw mode ...
            switch (objShapeEditor.DrawMode) {
                case TrimbleMap.ShapeEditor.enumDrawMode.Add:

                    // Draw to add the polygon ...
                    objShapeEditor.DrawToAddMultiPart(objConvertedGeometry, objShapeEditor.Options.GridOptions.SpatialReferenceID, true);
                    break;

                case TrimbleMap.ShapeEditor.enumDrawMode.Remove:

                    // Draw to add the polygon ...
                    objShapeEditor.DrawToRemoveMultiPart(objConvertedGeometry, objShapeEditor.Options.GridOptions.SpatialReferenceID);
                    break;
            }
        }));
    }
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateElements = function CreateElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the div to hold all the elements ...
    objShapeEditor.ShapeEditorDiv = $('<div class="shape-editor"></div>');

    // Determine the css classes to add to the main div ...
    var strCssClasses = ((objShapeEditor.Editable) ? 'shapemode-edit' : 'shapemode-readonly') +
        ((objShapeEditor.Options.AllowEditingOfOfficialAreaOnly) ? ' shapemode-official-area-edit' : '') +
        ((!objShapeEditor.Options.OfficialAreaEditable) ? ' shapemode-official-area-readonly' : '') +
        ((!objShapeEditor.Options.OfficialLengthEditable) ? ' shapemode-official-length-readonly' : '');

    // Create the div to hold all the elements ...
    objShapeEditor.ShapeDiv = $('<div class="side-panel ' + strCssClasses + '"></div>');

    // Add it to the shape editor div ...
    objShapeEditor.ShapeEditorDiv.append(objShapeEditor.ShapeDiv);

    // Create and add the functionality disabled message div element ...
    objShapeEditor.ShapeDiv.append(objShapeEditor.CreateFunctionalityDisabledMessageDivElements());

    // Create and add the icon div element ...
    objShapeEditor.ShapeDiv.append(objShapeEditor.CreateToolsDivElements());

    // Create and add the shape details div elements ...
    objShapeEditor.ShapeDiv.append(objShapeEditor.CreateShapeDetailsDivElements());

    // Create and add the shape parts div elements ...
    objShapeEditor.ShapeDiv.append(objShapeEditor.CreateReferencePointsDivElements());

    // Create and add the shape parts div elements ...
    objShapeEditor.ShapeDiv.append(objShapeEditor.CreateShapePartsDivElements());

    // Create and add the dynamic shape not shown message ...
    objShapeEditor.ShapeDiv.append(objShapeEditor.CreateDynamicShapeNotShownMessageDiv());

    // Create and add the coordinate display ...
    objShapeEditor.ShapeEditorDiv.append(objShapeEditor.CreateCoordinateDisplayDiv());

    // Set the element visibility ...
    objShapeEditor.SetElementVisibilityForOptionsAndDynamicShapeOptions(false);
}

// **************************************************************************
// FUNCTION: CreateFunctionalityDisabledMessageDivElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateFunctionalityDisabledMessageDivElements = function CreateFunctionalityDisabledMessageDivElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a div to hold the message ...
    objShapeEditor.FunctionalityDisabledDiv = $('<div class="shape-container"></div>');

    // Some functionality has been disabled due to the large number of coordinates
    var strFunctionalityDisabled = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'SomeFunctionalityDisabled');

    // Create and add the message span ...
    objShapeEditor.FunctionalityDisabledDiv.append('<span class="disabled-message">' + strFunctionalityDisabled + '<span>');

    // Create the icon div ...
    objShapeEditor.FunctionalityDisabledIconDiv = $('<div class="info-icon"></div>');

    // Add the icon to FunctionalityDisabledDiv ...
    objShapeEditor.FunctionalityDisabledDiv.append(objShapeEditor.FunctionalityDisabledIconDiv);

    // Create the detail popup ...
    objShapeEditor.CreateFunctionalityDisabledPopup();

    // Return the div ...
    return objShapeEditor.FunctionalityDisabledDiv;
}


// **************************************************************************
// FUNCTION: CreateFunctionalityDisabledPopup
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateFunctionalityDisabledPopup = function CreateFunctionalityDisabledPopup() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the functionality disabled popup control ...
    objShapeEditor.FunctionalityDisabledPopup = SD.Popup.CreateInstance(objShapeEditor.FunctionalityDisabledIconDiv,
        'shape_functionality_disabled_div_to_open_downwards',
        'shape_functionality_disabled_div_to_open_upwards',
        'shape_functionality_disabled_div_popped_up_to_open_downwards',
        'shape_functionality_disabled_div_popped_up_to_open_upwards',
        5,
        false,
        SD.Popup.enumPopupBehaviour.AlwaysDown,
        objShapeEditor.ActivateFunctionalityDisabledPopupProxy,
        null);
}

// **************************************************************************
// FUNCTION: CreateFunctionalityDisabledPopupDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateFunctionalityDisabledPopupDiv = function CreateFunctionalityDisabledPopupDiv() {

    // Get the instance ...
    var objShapeEditor = this;

    // Count the number of coordinates on the shape ...
    var intCoordinateCount = objShapeEditor.Shape.CountCoordinates();

    // Convert the coordinate count to a string ...
    var strCoordinateCount = SD.DisplayValue.FromDouble(intCoordinateCount, objShapeEditor.MapController.State.GroupSeparator, objShapeEditor.MapController.State.DecimalSeparator, 0);

    // Create a div to contain the messages ...
    objShapeEditor.FunctionalityDisabledPopupDiv = $('<div class="shape-functionality-popup"></div>');

    // This shape has %1 coordinates in total
    var strShapeCoordinateCount = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ShapeCoordinateCount', strCoordinateCount) + ':';

    // Add the message ...
    objShapeEditor.FunctionalityDisabledPopupDiv.append('<span class="bold">' + strShapeCoordinateCount + '</span><br />');

    // When coordinate editing on the map is not allowed ...
    if (!objShapeEditor.DrawCoordinatesInMap) {

        // Map coordinate highlighting is disabled.
        var strDrawCoordinatesInMap = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'MapCoordinateHighlightingDisabled');

        // Add the message ...
        objShapeEditor.FunctionalityDisabledPopupDiv.append('<span>' + strDrawCoordinatesInMap + '</span>');
    }

    // When we cannot calculate the area on the fly ...
    if (objShapeEditor.Editable && (!objShapeEditor.CalculateMeasurementOnTheFly)) {

        // Determine the calculated measurement not shown message based on the geometry type ... 
        var strCalculateMeasurementOnTheFly;
        switch (objShapeEditor.Shape.GeometryType) {
            case TrimbleMap.Shape.enumGeometryType.POLYGON:
            case TrimbleMap.Shape.enumGeometryType.MIXED:

                // The calculated area is not shown.
                strCalculateMeasurementOnTheFly = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatedAreaNotShown');
                break;
            case TrimbleMap.Shape.enumGeometryType.POLYLINE:

                // The calculated length is not shown.
                strCalculateMeasurementOnTheFly = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatedLengthNotShown');
                break;
        }

        // Add the message ...
        objShapeEditor.FunctionalityDisabledPopupDiv.append('<span>' + strCalculateMeasurementOnTheFly + '</span>');
    }

    // When coordinate editing on the map is not allowed ...
    if (objShapeEditor.Editable && (!objShapeEditor.AllowCoordinateEditingInMap)) {

        // The "Draw to Add" and "Draw to Remove" tools are disabled.
        var strDrawToAddAndRemove = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DrawToAddAndRemoveToolDisabledDueToLargeShape');

        // Add the message ...
        objShapeEditor.FunctionalityDisabledPopupDiv.append('<span>' + strDrawToAddAndRemove + '</span>');

        // You are not able to edit parts with large number of coordinates by dragging the points in the map. However you are still able to edit the coordinates manually.
        var strCoordinateEditingNotAllowed = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotEditShapeByDraggingPointsInMap');

        // Add the message ...
        objShapeEditor.FunctionalityDisabledPopupDiv.append('<span>' + strCoordinateEditingNotAllowed + '</span>');
    }
}

// **************************************************************************
// FUNCTION: ActivateFunctionalityDisabledPopup
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateFunctionalityDisabledPopup = function ActivateFunctionalityDisabledPopup(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the popup div ...
    objShapeEditor.CreateFunctionalityDisabledPopupDiv();

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objShapeEditor.FunctionalityDisabledPopupDiv);
}

// **************************************************************************
// FUNCTION: CreateToolsDivElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateToolsDivElements = function CreateToolsDivElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // When editable ...
    if (objShapeEditor.Editable) {

        // Create a div to hold the draw on map icons ...
        objShapeEditor.ToolDiv = $('<div class="shape-container shape-tools"></div>');

        // Create a div to hold the choose existing shape icons ...
        objShapeEditor.ChooseExistingShapeToolDiv = $('<div class="shape-container shape-tools"></div>');

        // Create the icons div for Draw On Map ...
        objShapeEditor.IconsDiv = $('<div class="shape-icons"></div>');

        objShapeEditor.ShapeEditorOptions.CreateAndShowElements();

        // Add it to the draw on map tools div ...
        objShapeEditor.ToolDiv.append(objShapeEditor.IconsDiv);
    }

    // Return the created div ...
    return objShapeEditor.ToolDiv;
}

// **************************************************************************
// FUNCTION: CreateAndAddIcons
// USAGE:    enHorizontalAlignment: TrimbleMap.ShapeEditor.enumHorizontalAlignment
// **************************************************************************
TrimbleMap.ShapeEditor.CreateAndAddIcons = function CreateAndAddIcons(enHorizontalAlignment) {

    // Get the instance ...
    var objShapeEditor = this;

    // Clone the icons array when to be aligned right ...
    var arrIcons = (enHorizontalAlignment == TrimbleMap.ShapeEditor.enumHorizontalAlignment.Left) ? objShapeEditor.Options.Icons : objShapeEditor.Options.Icons.slice();

    // Reverse the icons array when to be aligned right ...
    if (enHorizontalAlignment == TrimbleMap.ShapeEditor.enumHorizontalAlignment.Right) { arrIcons.reverse(); }

    // Loop through all the icons ...
    for (var intIcon = 0; intIcon < arrIcons.length; intIcon++) {

        // Get the icon object ...
        var objIcon = arrIcons[intIcon];

        // When left aligned ...
        if (objIcon.HorizontalAlignment == enHorizontalAlignment) {

            // Create elements for the icon ...
            var objIconElement = objShapeEditor.CreateIconElement(objIcon, intIcon, objShapeEditor.Shape.GeometryType);

            // Add it to the tool div ...
            if (objIconElement) { objShapeEditor.IconsDiv.append(objIconElement); }
        }
    }
}

// **************************************************************************
// FUNCTION: CreateAreaDisplayDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateAreaDisplayDiv = function CreateAreaDisplayDiv(objDivToAddTo) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the outer div for the display area control ...
    var objAreaDisplayOuterDiv = $('<div class="shape-measurement-container"></div>');

    // Add it to the tool div ...
    objDivToAddTo.append(objAreaDisplayOuterDiv);

    // Create the area display control ...
    objShapeEditor.AreaDisplayDiv = $('<div></div>');

    // Add it to the tool div ...
    objAreaDisplayOuterDiv.append(objShapeEditor.AreaDisplayDiv);

    // Get the translation ...

    // Calculating Area
    var strCalculationInProgress = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatingArea') + ' ...';

    // Filter the area units by the AreaUnitIDs when set otherwise use all ...
    var arrAreaUnits = ((typeof objShapeEditor.Options.AreaUnitIDs != 'undefined') && (objShapeEditor.Options.AreaUnitIDs)) ? TrimbleMap.DisplayArea.Shared.FilterAreaUnits(objShapeEditor.MapController.State.AreaUnits, objShapeEditor.Options.AreaUnitIDs) : objShapeEditor.MapController.State.AreaUnits;

    // Create the DisplayArea control ...
    objShapeEditor.DisplayArea = TrimbleMap.DisplayArea.CreateInstance(objShapeEditor.MapController, objShapeEditor.AreaDisplayDiv, null, strCalculationInProgress, null, false, TrimbleMap.DisplayArea.Shared.GetAreaUnitIndex(objShapeEditor.Options.DefaultAreaUnitID, arrAreaUnits), arrAreaUnits);
}

// **************************************************************************
// FUNCTION: CreateLengthDisplayDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateLengthDisplayDiv = function CreateLengthDisplayDiv(objDivToAddTo) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the outer div for the display length control ...
    var objLengthDisplayOuterDiv = $('<div class="shape-measurement-container"></div>');

    // Add it to the tool div ...
    objDivToAddTo.append(objLengthDisplayOuterDiv);

    // Create the length display control ...
    objShapeEditor.LengthDisplayDiv = $('<div></div>');

    // Add it to the tool div ...
    objLengthDisplayOuterDiv.append(objShapeEditor.LengthDisplayDiv);

    // Get the translation ...

    // Calculating Length ...
    var strCalculationInProgress = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatingLength') + ' ...';

    // Filter the distance units by the DistanceUnitIDs when set otherwise use all ...
    var arrDistanceUnits = ((typeof objShapeEditor.Options.DistanceUnitIDs != 'undefined') && (objShapeEditor.Options.DistanceUnitIDs != null)) ? TrimbleMap.DisplayDistance.Shared.FilterDistanceUnits(objShapeEditor.MapController.State.DistanceUnits, objShapeEditor.Options.DistanceUnitIDs) : objShapeEditor.MapController.State.DistanceUnits;

    // Create the DisplayLength control ...
    objShapeEditor.DisplayLength = TrimbleMap.DisplayDistance.CreateInstance(objShapeEditor.MapController, objShapeEditor.LengthDisplayDiv, null, null, strCalculationInProgress, false, TrimbleMap.DisplayDistance.Shared.GetDistanceUnitIndex(objShapeEditor.Options.DefaultDistanceUnitID, arrDistanceUnits), arrDistanceUnits);
}

// **************************************************************************
// FUNCTION: GetEditedCoordinatesToReplace
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetEditedCoordinatesToReplace = function GetEditedCoordinatesToReplace() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a hash table for the coordinates to replace ...
    var dicCoordinatesToReplace = {};

    // When we have a selected part that we are busy editing ...
    if (objShapeEditor.SelectedPart && objShapeEditor.EditingCoordinateMode) {

        // Add the changed coordinates from the coordinate list editor to the hash table ...
        dicCoordinatesToReplace[objShapeEditor.SelectedPart.ID] = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

        // When we have modified interior parts ...
        if (objShapeEditor.ModifiedInteriorPartCoordinates) {

            // Loop through the modified interior parts ...
            $.each(objShapeEditor.ModifiedInteriorPartCoordinates, function (intInteriorPart, arrModifiedInteriorPartCoordinates) {

                // Get the interior part for which the modified coordinates is ...
                var objInteriorPart = objShapeEditor.SelectedPart.InteriorParts[Number(intInteriorPart)];

                // Add the changed interior part coordinates to the hash table ...
                dicCoordinatesToReplace[objInteriorPart.ID] = arrModifiedInteriorPartCoordinates;
            });
        }
    }

    return dicCoordinatesToReplace;
}

// **************************************************************************
// FUNCTION: UpdateMeasurementDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateMeasurementDisplay = function UpdateMeasurementDisplay() {

    // Get the instance ...
    var objShapeEditor = this;

    // Update the area and length displays ...
    objShapeEditor.UpdateAreaDisplay();
    objShapeEditor.UpdateLengthDisplay();
}

// **************************************************************************
// FUNCTION: UpdateAreaDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateAreaDisplay = function UpdateAreaDisplay() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the shape's geometry type is not point and the shape has parts ...
    if (((objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) ||
        (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.MIXED)) &&
        objShapeEditor.Shape.HasParts() && objShapeEditor.Options.ShowPartsInListAndMap &&
        (!objShapeEditor.Shape.IsDynamic || !objShapeEditor.Editable)) {

        // Get the edited coordinates to replace ...
        var dicCoordinatesToReplace = objShapeEditor.GetEditedCoordinatesToReplace();

        // Activate the calculation in progress indicator on the main area drop down ...
        objShapeEditor.DisplayArea.ActivateCalculationInProgressIndicator();

        // Activate the calculation in progress indicator for the part area ...
        objShapeEditor.ActivatePartAreaCalculationInProgressIndicator();

        // Perform the area calculation and update asynchronously ... 
        setTimeout(function () {

            // Perform the area calculation and update ... 
            objShapeEditor.Shape.CalculateAreaSquareKm(objShapeEditor.MapController, dicCoordinatesToReplace).then(TrimbleMap.Controller.Shared.TrapException(function (objArea) {

                // Update the area amount ...
                objShapeEditor.DisplayArea.UpdateArea(objArea);

                // Update the selected part area display ...
                objShapeEditor.UpdateSelectedPartAreaDisplay();

                // De-Activate the calculation in progress indicator ...
                objShapeEditor.DisplayArea.DeActivateCalculationInProgressIndicator();

                // De-Activate the calculation in progress indicator for the part area ...
                objShapeEditor.DeActivatePartAreaCalculationInProgressIndicator();
            }));
        }, 0);

        // Show the area display ...
        objShapeEditor.DisplayArea.Show();
        objShapeEditor.CalculatedAreaDiv.show();

    } else {

        // Hide the area display ...
        objShapeEditor.DisplayArea.Hide();
        objShapeEditor.CalculatedAreaDiv.hide();
    }
}

// **************************************************************************
// FUNCTION: UpdateSelectedPartAreaDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateSelectedPartAreaDisplay = function UpdateSelectedPartAreaDisplay() {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have a selected part ...
    if (objShapeEditor.SelectedPart != null) {

        // Start with not showing the part area ...
        var blnShowPartArea = false;

        // When we have a calculated area ...
        if (objShapeEditor.DisplayArea.Area != null) {

            // Get the selected area unit ...
            var objAreaUnit = objShapeEditor.DisplayArea.AreaUnits[objShapeEditor.DisplayArea.AreaUnit];

            // Get the part area if we have any ...
            var objPartArea = objShapeEditor.DisplayArea.Area.AreaByPartID[objShapeEditor.SelectedPart.ID];

            // When we have a calculated area for the part (i.e. it's an exterior part) ...
            if (typeof objPartArea != 'undefined') {

                // Convert the area value to the unit ...
                var dblAreaValue = (objPartArea != null && objAreaUnit.SpatialReferenceType.toUpperCase() == TrimbleMap.enumSpatialReferenceType.PROJECTED) ? objPartArea.AreaInKm2 / objAreaUnit.ConversionFactorToKm2 : (objPartArea != null ? objPartArea.AreaInDegrees2 / objAreaUnit.ConversionFactorToSquareDegrees : 0);

                // Convert the area value to a string ...
                var strArea = SD.DisplayValue.FromDouble(dblAreaValue, objShapeEditor.DisplayArea.MapController.State.GroupSeparator, objShapeEditor.DisplayArea.MapController.State.DecimalSeparator, objAreaUnit.DecimalPlaces);

                // Add the area unit abbreviation ...
                strArea += ' ' + objAreaUnit.Abbreviation;

                // Set the part area ...
                objShapeEditor.CalculatedPartAreaSpan.text(strArea);

                // Set to show the part area ...
                blnShowPartArea = true;
            }
        }

        // Determine wheteher or not the selected part is an exterior part ...
        var blnIsExteriorPart = objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart)

        // Set to not show the area when the selected part is an not exterior part ...
        if (!blnIsExteriorPart) { blnShowPartArea = false; }

        // Show or hide the part area div ...
        if (blnShowPartArea) {

            // Show the calculated area div ...
            objShapeEditor.CalculatedPartAreaDiv.show();

        } else {

            // Hide the calculated part area div ...
            objShapeEditor.CalculatedPartAreaDiv.hide();
        }
    }
}

// **************************************************************************
// FUNCTION: UpdateLengthDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateLengthDisplay = function UpdateLengthDisplay() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the shape's geometry type is a polyline and the shape has parts ...
    if ((objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYLINE) &&
        objShapeEditor.Shape.HasParts() && objShapeEditor.Options.ShowPartsInListAndMap &&
        (!objShapeEditor.Shape.IsDynamic || !objShapeEditor.Editable)) {
        // Get the edited coordinates to replace ...
        var dicCoordinatesToReplace = objShapeEditor.GetEditedCoordinatesToReplace();

        //// Activate the calculation in progress indicator on the main area drop down ...
        objShapeEditor.DisplayLength.ActivateCalculationInProgressIndicator();

        //// Activate the calculation in progress indicator for the part area ...
        objShapeEditor.ActivatePartLengthCalculationInProgressIndicator();

        // Perform the length calculation and update asynchronously ... 
        setTimeout(function () {

            // Perform the length calculation and update ... 
            objShapeEditor.Shape.CalculateDistanceKm(objShapeEditor.MapController, dicCoordinatesToReplace).then(TrimbleMap.Controller.Shared.TrapException(function (objDistance) {

                // Update the distance ...
                objShapeEditor.DisplayLength.UpdateDistance(objDistance);

                // Update the selected part distance display ...
                objShapeEditor.UpdateSelectedPartLengthDisplay();

                // De-Activate the calculation in progress indicator ...
                objShapeEditor.DisplayLength.DeActivateCalculationInProgressIndicator();

                // De-Activate the calculation in progress indicator for the part area ...
                objShapeEditor.DeActivatePartLengthCalculationInProgressIndicator();
            }));
        }, 0);

        // Show the length display ...
        objShapeEditor.DisplayLength.Show();
        objShapeEditor.CalculatedLengthDiv.show();

    } else {

        // Hide the length display ...
        objShapeEditor.DisplayLength.Hide();
        objShapeEditor.CalculatedLengthDiv.hide();
    }
}

// **************************************************************************
// FUNCTION: UpdateSelectedPartLengthDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateSelectedPartLengthDisplay = function UpdateSelectedPartLengthDisplay() {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have a selected part ...
    if (objShapeEditor.SelectedPart != null) {

        // Start with not showing the part Length ...
        var blnShowPartLength = false;

        // When we have a calculated Length ...
        if (objShapeEditor.DisplayLength.Distance != null) {

            // Get the selected distance unit ...
            var objDistanceUnit = objShapeEditor.DisplayLength.DistanceUnits[objShapeEditor.DisplayLength.DistanceUnit];

            // Get the part Length if we have any ...
            var dblPartLengthInKm = objShapeEditor.DisplayLength.Distance.DistanceByPartID[objShapeEditor.SelectedPart.ID];

            // When we have a calculated Length for the part  ...
            if (typeof dblPartLengthInKm != 'undefined') {

                // Convert the Length value to the unit ...
                var dblLengthValue = dblPartLengthInKm / objDistanceUnit.ConversionFactorToKm;

                // Convert the Length value to a string ...
                var strLength = SD.DisplayValue.FromDouble(dblLengthValue, objShapeEditor.DisplayLength.MapController.State.GroupSeparator, objShapeEditor.DisplayLength.MapController.State.DecimalSeparator, objDistanceUnit.DecimalPlaces);

                // Add the Length unit abbreviation ...
                strLength += ' ' + objDistanceUnit.Abbreviation;

                // Set the part Length ...
                objShapeEditor.CalculatedPartLengthSpan.text(strLength);

                // Set to show the part Length ...
                blnShowPartLength = true;
            }
        }

        // Show or hide the part Length div ...
        if (blnShowPartLength) {

            // Show the calculated Length div ...
            objShapeEditor.CalculatedPartLengthDiv.show();

        } else {

            // Hide the calculated part Length div ...
            objShapeEditor.CalculatedPartLengthDiv.hide();
        }
    }
}

// **************************************************************************
// FUNCTION: ActivatePartAreaCalculationInProgressIndicator
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivatePartLengthCalculationInProgressIndicator = function ActivatePartLengthCalculationInProgressIndicator() {

    // Get the instance ...
    var objShapeEditor = this;

    // When not active ...
    if (!objShapeEditor.PartLengthCalculationInProgressActive) {

        // Set to be active ...
        objShapeEditor.PartLengthCalculationInProgressActive = true;

        // Set a timer that will display the calculation in progress indicator ... 
        objShapeEditor.PartLengthCalculationInProgressIndicatorTimer = setTimeout(function () {

            // Clear the timer handle ...
            objShapeEditor.PartLengthCalculationInProgressIndicatorTimer = null;

            // Hide the area span and show the calculation in progress indicator ...
            objShapeEditor.CalculatedPartLengthSpan.hide();
            objShapeEditor.PartLengthCalculationInProgressIndicator.show();

        }, TrimbleMap.ShapeEditor.Shared.CALCULATION_IN_PROGRESS_TIME_MS);
    }
}

// **************************************************************************
// FUNCTION: DeActivatePartLengthCalculationInProgressIndicator
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivatePartLengthCalculationInProgressIndicator = function DeActivatePartLengthCalculationInProgressIndicator() {

    // Get the instance ...
    var objShapeEditor = this;

    // When active ...
    if (objShapeEditor.PartLengthCalculationInProgressActive) {

        // Set to not be active ...
        objShapeEditor.PartLengthCalculationInProgressActive = false;

        // When the timer is active ...
        if (objShapeEditor.PartLengthCalculationInProgressIndicatorTimer != null) {

            // Stop the timer when active ...
            clearTimeout(objShapeEditor.PartLengthCalculationInProgressIndicatorTimer);
            objShapeEditor.PartLengthCalculationInProgressIndicatorTimer = null;
        }

        // Show the Length span and hide the calculation in progress indicator ...
        objShapeEditor.CalculatedPartLengthSpan.show();
        objShapeEditor.PartLengthCalculationInProgressIndicator.hide();
    }
}

// **************************************************************************
// FUNCTION: CalculatedAreaUnitChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CalculatedAreaUnitChanged = function CalculatedAreaUnitChanged() {

    // Get the instance ...
    var objShapeEditor = this;

    // Update the selected part's area display ...
    objShapeEditor.UpdateSelectedPartAreaDisplay();
}

TrimbleMap.ShapeEditor.CalculatedLengthUnitChanged = function CalculatedLengthUnitChanged() {

    // Get the instance ...
    var objShapeEditor = this;

    // Update the selected part's area display ...
    objShapeEditor.UpdateSelectedPartLengthDisplay();
}

TrimbleMap.ShapeEditor.GetShapeIDFromShapePartDropDown = function GetShapeIDFromShapePartDropDown() {

    //Get the instance
    var objShapeEditor = this;

    //Get the selected shape part option
    var objSelectedShapePartOption = objShapeEditor.ShapePartDropDown.find(':selected');

    //Get the shape part ID
    return objSelectedShapePartOption.val();

}

TrimbleMap.ShapeEditor.ShapePartZoomClicked = function ShapePartZoomClicked(event) {

    //Get the instance
    var objShapeEditor = this;

    // Get the part to zoom to ...
    var objPartToZoomTo = objShapeEditor.Shape.GetPartByID(objShapeEditor.GetShapeIDFromShapePartDropDown());

    if (objPartToZoomTo != null) {
        // Zoom to the shape part ...
        objShapeEditor.ZoomToShapePart(objPartToZoomTo);
    }

}

TrimbleMap.ShapeEditor.ShapePartRenameClicked = function ShapePartRenameClicked(event) {

    //Get the instance
    var objShapeEditor = this;

    var objSelectedShapePartOption = objShapeEditor.ShapePartDropDown.find(':selected');

    if (objSelectedShapePartOption.length > 0) {
        // Show the print dialog ...
        objShapeEditor.ShowRenameShapePartDialog();
    }

}

TrimbleMap.ShapeEditor.ShapePartAddExclusionClicked = function ShapePartAddExclusionClicked(event) {

    //Get the instance
    var objShapeEditor = this;

    objShapeEditor.AddNewShapePart(true, objShapeEditor.GetShapeIDFromShapePartDropDown());
}


TrimbleMap.ShapeEditor.ShapePartDeleteClicked = function ShapePartDeleteClicked(event) {

    //Get the instance
    var objShapeEditor = this;

    var objPartToDelete = objShapeEditor.Shape.GetPartByID(objShapeEditor.GetShapeIDFromShapePartDropDown());

    objShapeEditor.RemoveShapePart(objPartToDelete, true, true);

    objShapeEditor.ToggleEditFocus(false);
    objShapeEditor.UpdateForShapeChange();
    objShapeEditor.SelectFirstPartOrAddPart(false);

    objShapeEditor.ToggleAddExclusionMenuItem();

}

TrimbleMap.ShapeEditor.ShapePartDropDownUpdate = function ShapePartDropDownUpdate() {

    //Get the instance
    var objShapeEditor = this;

    let strShapePartID = objShapeEditor.GetShapeIDFromShapePartDropDown();
    let objPartToSelect = objShapeEditor.Shape.GetPartByID(strShapePartID);

    objShapeEditor.AcceptChanges();
    objShapeEditor.SelectShapePart(objPartToSelect, objShapeEditor.EditingCoordinateMode, true);
}

// **************************************************************************
// FUNCTION: ActivatePartAreaCalculationInProgressIndicator
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivatePartAreaCalculationInProgressIndicator = function ActivatePartAreaCalculationInProgressIndicator() {

    // Get the instance ...
    var objShapeEditor = this;

    // When not active ...
    if (!objShapeEditor.PartAreaCalculationInProgressActive) {

        // Set to be active ...
        objShapeEditor.PartAreaCalculationInProgressActive = true;

        // Set a timer that will display the calculation in progress indicator ... 
        objShapeEditor.PartAreaCalculationInProgressIndicatorTimer = setTimeout(function () {

            // Clear the timer handle ...
            objShapeEditor.PartAreaCalculationInProgressIndicatorTimer = null;

            // Hide the area span and show the calculation in progress indicator ...
            objShapeEditor.CalculatedPartAreaSpan.hide();
            objShapeEditor.PartAreaCalculationInProgressIndicator.show();

        }, TrimbleMap.ShapeEditor.Shared.CALCULATION_IN_PROGRESS_TIME_MS);
    }
}

// **************************************************************************
// FUNCTION: DeActivatePartAreaCalculationInProgressIndicator
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivatePartAreaCalculationInProgressIndicator = function DeActivatePartAreaCalculationInProgressIndicator() {

    // Get the instance ...
    var objShapeEditor = this;

    // When active ...
    if (objShapeEditor.PartAreaCalculationInProgressActive) {

        // Set to not be active ...
        objShapeEditor.PartAreaCalculationInProgressActive = false;

        // When the timer is active ...
        if (objShapeEditor.PartAreaCalculationInProgressIndicatorTimer != null) {

            // Stop the timer when active ...
            clearTimeout(objShapeEditor.PartAreaCalculationInProgressIndicatorTimer);
            objShapeEditor.PartAreaCalculationInProgressIndicatorTimer = null;
        }

        // Show the area span and hide the calculation in progress indicator ...
        objShapeEditor.CalculatedPartAreaSpan.show();
        objShapeEditor.PartAreaCalculationInProgressIndicator.hide();
    }
}

// **************************************************************************
// FUNCTION: UpdateShapeHasCoordinatesCss
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateShapeHasCoordinatesCss = function UpdateShapeHasCoordinatesCss() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the shape has coordinates ...
    if (objShapeEditor.Shape.HasCoordinates()) {

        // Remove the 'no coordinates' class ..
        objShapeEditor.ShapeEditorDiv.removeClass('shape_no_coordinates');

    } else {

        // Add the 'no coordinates' class ..
        objShapeEditor.ShapeEditorDiv.addClass('shape_no_coordinates');

    }
}

// **************************************************************************
// FUNCTION: UpdateForShapeChange
// USAGE:    blnFirstTime is optional and defaults to false
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateForShapeChange = function UpdateForShapeChange(blnFirstTime) {

    // Get the instance ...
    var objShapeEditor = this;

    // Default blnFirstTime to false when not set ...
    if ((typeof blnFirstTime == 'undefined') || (blnFirstTime == null)) { blnFirstTime = false; }

    // Update the functionality disabled message ...
    objShapeEditor.UpdateFunctionalityDisabledMessageDisplay();

    // Start with the area display not being updated ...
    var blnMeasurementDisplayUpdated = false;

    // When called for the first time and not editable or when we are to calculate the coordinates on the fly ...
    if ((blnFirstTime && (!objShapeEditor.Editable)) || objShapeEditor.CalculateMeasurementOnTheFly) {

        // Update the measurement display ...
        objShapeEditor.UpdateMeasurementDisplay();

        // Set to have updated the area display ...
        blnMeasurementDisplayUpdated = true;
    }

    // When the length display has been updated ...
    if (blnMeasurementDisplayUpdated) {

        // Hide the calculate area and length icons ...
        if (objShapeEditor.CalculateAreaIconDiv) { objShapeEditor.CalculateAreaIconDiv.hide(); }
        if (objShapeEditor.CalculateLengthIconDiv) { objShapeEditor.CalculateLengthIconDiv.hide(); }

    } else {

        // Show the calculate area and length icons ...
        if (objShapeEditor.CalculateAreaIconDiv) { objShapeEditor.CalculateAreaIconDiv.show(); }
        if (objShapeEditor.CalculateLengthIconDiv) { objShapeEditor.CalculateLengthIconDiv.show(); }
    }

    objShapeEditor.ToggleAddIcons(true);

    if (objShapeEditor.ValidateCurrentlyEditedDetails().Valid) {
        objShapeEditor.ToggleEditFocus(false);
        objShapeEditor.UpdateCalculatedReferencePoints();
        objShapeEditor.UpdateReferencePointsDisplay();
    }

    // Update the 'no coordinates' css class ...
    objShapeEditor.UpdateShapeHasCoordinatesCss();
}

// **************************************************************************
// FUNCTION: UpdateFunctionalityDisabledMessageDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateFunctionalityDisabledMessageDisplay = function UpdateFunctionalityDisabledMessageDisplay() {

    // Get the instance ...
    var objShapeEditor = this;

    // Count the number of coordinates on the shape ...
    var intCoordinateCount = objShapeEditor.Shape.CountCoordinates();

    // Determine whether or not we should update the area or length on the fly ...
    objShapeEditor.CalculateMeasurementOnTheFly = (intCoordinateCount <= TrimbleMap.ShapeEditor.Shared.MAX_ON_THE_FLY_MEASUREMENT_CALCULATION_COORDINATES) || objShapeEditor.AreaCalculationOnLargeShapesActivated;

    // Determine whether or not we should allow to edit coordinates in the map ...
    objShapeEditor.AllowCoordinateEditingInMap = (intCoordinateCount <= TrimbleMap.ShapeEditor.Shared.MAX_COORDINATES_TO_ALLOW_EDITING_IN_MAP);

    // Determine whether or not we should draw the coordinates in the map ...
    objShapeEditor.DrawCoordinatesInMap = (intCoordinateCount <= TrimbleMap.ShapeEditor.Shared.MAX_COORDINATES_TO_DRAW_IN_MAP);

    // Determine whether or not the functionality disabled message should be visible ...
    objShapeEditor.FunctionalityDisabledMessageVisible = (objShapeEditor.Editable && (!objShapeEditor.CalculateMeasurementOnTheFly)) || (!objShapeEditor.AllowCoordinateEditingInMap) || (!objShapeEditor.DrawCoordinatesInMap);

    // When the functionality disabled message should be visible ...
    if (objShapeEditor.FunctionalityDisabledMessageVisible) {

        // Show the functionality disabled div (the one in the tool icons div) ...
        if (objShapeEditor.FunctionalityDisabledDiv) { objShapeEditor.FunctionalityDisabledDiv.show(); }

    } else {

        // Hide the functionality disabled div (the one in the tool icons div) ...
        if (objShapeEditor.FunctionalityDisabledDiv) { objShapeEditor.FunctionalityDisabledDiv.hide(); }
    }

    // When coordinates are allowed to be edited in the map ...
    if (objShapeEditor.AllowCoordinateEditingInMap) {

        // Reove the shape_editing_in_map_not_allowed class to the ShapeDiv if not already there ...
        if (objShapeEditor.ShapeDiv.hasClass('shape_editing_in_map_not_allowed')) { objShapeEditor.ShapeDiv.removeClass('shape_editing_in_map_not_allowed'); }

    } else {

        // Add the shape_editing_in_map_not_allowed class to the ShapeDiv if not already there ...
        if (!objShapeEditor.ShapeDiv.hasClass('shape_editing_in_map_not_allowed')) { objShapeEditor.ShapeDiv.addClass('shape_editing_in_map_not_allowed'); }
    }
}

// **************************************************************************
// FUNCTION: CreateReProjectPopup
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateReProjectPopup = function CreateReProjectPopup(objTarget) {

    // Get the instance ...
    var objShapeEditor = this;

    objShapeEditor.CreateReProjectPopupDiv();

    //Display a list of coordinates systems to project to in a message box
    TrimbleMap.MessageBox.Shared.ShowMessage(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ReprojectCoordinates'), "", objShapeEditor.ReprojectOkClickedProxy, null, objShapeEditor.ReProjectPopupDiv, true, objShapeEditor.ReProjectPopupClickedProxy, true, objShapeEditor.ReProjectPopupOpenedProxy);
}

// **************************************************************************
// FUNCTION: ActivateReProjectPopup
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateReProjectPopup = function ActivateReProjectPopup(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the re-projection popup div ...
    objShapeEditor.CreateReProjectPopupDiv();

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objShapeEditor.ReProjectPopupDiv);
}

// **************************************************************************
// FUNCTION: DeActivateReProjectPopup
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateReProjectPopup = function DeActivateReProjectPopup(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    // Detach a click event handler to the popup div ...
    objShapeEditor.ReProjectPopupDiv.off('click', objShapeEditor.ReProjectPopupClickedProxy);

    // De-activate the nice-scrollbar on the coordinate system list ...
    objShapeEditor.ReProjectCoordinateSystemNiceScroll.hide();
    objShapeEditor.ReProjectCoordinateSystemNiceScroll.remove();
}

// **************************************************************************
// FUNCTION: ReProjectPopupOpened
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ReProjectPopupOpened = function ReProjectPopupOpened(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    // Attach a click event handler to the popup div ...
    objShapeEditor.ReProjectPopupDiv.on('click', (objShapeEditor.ReProjectPopupClickedProxy));

    // Activate the nice scroll bar on the coordinate system list ...
    objShapeEditor.ReProjectCoordinateSystemNiceScroll = objShapeEditor.ReProjectCoordinateSystemListDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });
}

// **************************************************************************
// FUNCTION: CreateReProjectPopupDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateReProjectPopupDiv = function CreateReProjectPopupDiv(blnResetOptions) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the popup does not exist yet or is to be reset...
    if (blnResetOptions || !objShapeEditor.ReProjectPopupDiv) {

        // Create the reproject popup div ...
        objShapeEditor.ReProjectPopupDiv = $('<div></div>');

        // Create the coordinate system list ...
        objShapeEditor.ReProjectCoordinateSystemListDiv = $('<div class="reprojection-list"></div>');

        // Add it to the div ...
        objShapeEditor.ReProjectPopupDiv.append(objShapeEditor.ReProjectCoordinateSystemListDiv);

        // Loop through all the coordinate systems
        for (var intSpatialReference = 0; intSpatialReference < objShapeEditor.MapController.State.SpatialReferences.length; intSpatialReference++) {

            // Get the coordinate system at the index ...
            var objSpatialReference = objShapeEditor.MapController.State.SpatialReferences[intSpatialReference];

            // Filter out null entries and spatial reference on shape from list ...
            if (objSpatialReference.SpatialReferenceID != SD.Guid.Shared.Empty()) {

                // Create a div for the list item ...
                var objItemDiv = $('<div class="reprojection-item" SpatialReferenceID="' + objSpatialReference.SpatialReferenceID + '"></div>');

                if (objSpatialReference.SpatialReferenceID == objShapeEditor.Shape.SpatialReferenceID) {
                    objItemDiv.addClass("disabled");
                }

                // Add it to the list div ...
                objShapeEditor.ReProjectCoordinateSystemListDiv.append(objItemDiv);

                // Create a div for the item text ...
                var objItemTextDiv = $('<span>' + objSpatialReference.Name + '</span>');

                // Add the item text ...
                objItemDiv.append(objItemTextDiv);
            }
        }
    }
}

// **************************************************************************
// FUNCTION: ReProjectPopupClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ReProjectPopupClicked = function ReProjectPopupClicked(e) {

    // Get the instance ...
    var objShapeEditor = this;

    objShapeEditor.ReprojectCoordinatesToSpatialReference = null;

    e.stopImmediatePropagation();

    //remove the selected class from all element in the popup
    $('.reprojection-item').each(function (intElement, objElement) {

        $(objElement).removeClass("selected");
    });

    // Get the spatial reference list item that the user clicked on if any ...
    var objSpatialReferenceListItem = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'SpatialReferenceID');

    // When the user clicked on a spatial reference item ...
    if (objSpatialReferenceListItem && !objSpatialReferenceListItem.hasClass("disabled")) {

        // Get the spatial reference id that the user clicked on ...
        var guidSpatialReference = objSpatialReferenceListItem.attr('SpatialReferenceID');

        //add selected class to element
        objSpatialReferenceListItem.addClass("selected");

        // Save the selected spatial reference ID to the object ...
        objShapeEditor.ReprojectCoordinatesToSpatialReference = guidSpatialReference;
    }
}

TrimbleMap.ShapeEditor.ReprojectOkClicked = function ReprojectOkClicked(e) {
    // Get the instance ...
    var objShapeEditor = this;

    //remove the selected class from all element in the popup
    $('.reprojection-item').each(function (intElement, objElement) {

        $(objElement).removeClass("selected");
    });

    //when we have a coordinate system selected
    if (objShapeEditor.ReprojectCoordinatesToSpatialReference != null) {

        // Reproject to the selected spatial reference ...
        objShapeEditor.ReProject(objShapeEditor.ReprojectCoordinatesToSpatialReference, true).then(function () {

            // reset the re-projection popup div ...
            objShapeEditor.CreateReProjectPopupDiv(true);
        });

        //set property to null
        objShapeEditor.ReprojectCoordinatesToSpatialReference = null;
    }

    objShapeEditor.DeActivateReProjectPopupProxy();
}

// **************************************************************************
// FUNCTION: ReProject
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ReProject = function ReProject(guidToSpatialReference, blnZoomToShape) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When not already on the target coordinate system ...
    if (objShapeEditor.Shape.SpatialReferenceID != guidToSpatialReference) {

        // When the shape has coordinates or reference points with values (do not take calculated reference points into account) ...
        if (objShapeEditor.Shape.HasCoordinates(objShapeEditor.MapController) || objShapeEditor.Shape.HasReferencePointWithValues(true)) {

            // When the shape has no coordinate system set ...
            if (objShapeEditor.Shape.SpatialReferenceID != SD.Guid.Shared.Empty()) {

                // When we have valid geotransformation configuration to project the shape to the spatial reference ...
                if (objShapeEditor.Shape.HaveValidGeotransformationConfigurationTo(objShapeEditor.MapController, guidToSpatialReference)) {

                    // Detach all the event handlers ...
                    objShapeEditor.DetachEventHandlers();

                    // Project to the spatial reference ...
                    let objProjectShapeDeferred = objShapeEditor.Shape.Project(objShapeEditor.MapController, guidToSpatialReference, false);

                    // When the projection completes ...
                    objProjectShapeDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {

                        // Select the coordinate system in the drop down ...
                        objShapeEditor.CoordinateSystemDropDown.val(objShapeEditor.Shape.SpatialReferenceID);

                        // Set the selected coordinate system name ...
                        objShapeEditor.CoordinateSystemSpan.text(objShapeEditor.CoordinateSystemDropDown.find(':selected').text());

                        // Loop through al the shape parts ...
                        objShapeEditor.Shape.ForEachPart(function (objPart, blnIsInterior, objExteriorPart) {

                            // Update the part's coordinates ...
                            objShapeEditor.UpdateShapePart(objPart, objPart.Coordinates, objExteriorPart);
                        });

                        // Get the non-calculated reference points with values ...
                        var arrReferencePointsWithValues = objShapeEditor.Shape.ReferencePointsWithValues(false);

                        // When the shape has non-calculated reference points with values ...
                        if (arrReferencePointsWithValues.length > 0) {

                            // Loop through the reference points with values ... 
                            $.each(arrReferencePointsWithValues, function (intReferencePoint, objReferencePoint) {

                                // Update the interface ...
                                objShapeEditor.UpdateReferencePoint(objReferencePoint);
                            });
                        }

                        // Update the inteface for the shape change ...
                        objShapeEditor.UpdateForShapeChange();

                        // When we are to zoom to the shape ...
                        if (blnZoomToShape) {

                            // Zoom to the shape ...
                            objShapeEditor.ZoomToShape();
                        }

                        // Attach all the event handlers ...
                        objShapeEditor.AttachEventHandlers();

                        // Perform additional operations needed when the coordinate system changed ...
                        objShapeEditor.CoordinateSystemChanged();

                        objShapeEditor.EnableCheckMenuItem();

                        // Resolve the deferred ...
                        objDeferred.resolve();

                    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                        // Revert the spatial reference selection ...
                        objShapeEditor.CoordinateSystemDropDown.val(objShapeEditor.Shape.SpatialReferenceID);

                        // Set the selected coordinate system name ...
                        objShapeEditor.CoordinateSystemSpan.text(objShapeEditor.CoordinateSystemDropDown.find(':selected').text());

                        // Get the spatial reference of the shape ...
                        var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(guidToSpatialReference);

                        // When it's a measures out of bounds exception ...
                        if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

                            // Set the translations ...

                            // Not valid in selected coordinate system
                            var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'SelectedCoordinateSystemNotValidTitle');

                            // The coordinates cannot be reprojected. The coordinates are not valid in 
                            var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'SelectedCoordinateSystemNotValidMessage') + ' ' + objSpatialReference.Name;

                            // Notify the user ...
                            TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
                        }

                        // Attach all the event handlers ...
                        objShapeEditor.AttachEventHandlers();

                        // Reject the deferred ...
                        objDeferred.reject(objError);
                    }));

                } else {

                    // Revert the spatial reference selection ...
                    objShapeEditor.CoordinateSystemDropDown.val(objShapeEditor.Shape.SpatialReferenceID);

                    // Set the selected coordinate system name ...
                    objShapeEditor.CoordinateSystemSpan.text(objShapeEditor.CoordinateSystemDropDown.find(':selected').text());

                    // Get the spatial reference of the shape ...
                    var objFromSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);
                    var objToSpatialReference = objShapeEditor.MapController.GetSpatialReference(guidToSpatialReference);

                    // Get the geographic spatial reference IDs for the "from " and "to" spatial references ...
                    var guidGeographicFromSpatialReference = (objFromSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) ? objFromSpatialReference.GeographicSpatialReferenceID : objFromSpatialReference.SpatialReferenceID;
                    var guidGeographicToSpatialReference = (objToSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) ? objToSpatialReference.GeographicSpatialReferenceID : objToSpatialReference.SpatialReferenceID;

                    // Get the spatial reference of the shape ...
                    var objGeographicFromSpatialReference = objShapeEditor.MapController.GetSpatialReference(guidGeographicFromSpatialReference);
                    var objGeographicToSpatialReference = objShapeEditor.MapController.GetSpatialReference(guidGeographicToSpatialReference);

                    // Set the translations ...

                    // No geotransformation
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NoGeotransformationTitle');

                    // Unable to project from '%1' to '%2' .<br />No geotransformation defined between '%3' and '%4'
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NoGeotransformationMessage', objFromSpatialReference.Name, objToSpatialReference.Name, objGeographicFromSpatialReference.Name, objGeographicToSpatialReference.Name) + '.';

                    // Notify the user ...
                    TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

                    // Reject the deferred ...
                    objDeferred.reject(strMessage);
                }

            } else {

                // Unable to project shape
                var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'UnableToProjectShape');;

                // The shape has no coordinate system set
                var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'TheShapeHasNoCoordinateSystemSet');

                // Notify the user ...
                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

                // Reject the deferred ...
                objDeferred.reject(strMessage);
            }

        } else {

            // Change the spatial reference of the shape ...
            objShapeEditor.ChangeSpatialReferenceOfShapeWithNoCoordinates(guidToSpatialReference);
        }

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: ActivateDrawOnMapSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateDrawOnMapSubMenu = function ActivateDrawOnMapSubMenu(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    objShapeEditor.ResetShapeEditorMode();

    // Create the draw mode popup div ...
    objShapeEditor.CreateDrawModePopupDiv();

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objShapeEditor.DrawModePopupDiv);

    objShapeEditor.DrawOnMapSubMenuOpened(objPopupContainerDiv);

}

// **************************************************************************
// FUNCTION: ActivateImportCoordinateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateImportCoordinateSubMenu = function ActivateImportCoordinateSubMenu(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    objShapeEditor.ResetShapeEditorMode();

    var objImportCoordinateIcon = objShapeEditor.Options.Icons.filter(function (objIcon) {
        return objIcon.Name == "Import";
    })[0];

    // Create the div ...
    var objContainer = $('<div id="menu_wrapper"></div>');

    if (objImportCoordinateIcon) {
        // Loop through all the menu items ...
        for (var intMenu = 0; intMenu < objImportCoordinateIcon.MenuItems.length; intMenu++) {

            // Get the menu item ...
            var objMenuItem = objImportCoordinateIcon.MenuItems[intMenu];

            // Create a div for the operation item ...
            var objMenuItemDiv = $('<div class="menu-item" MenuItemID="' + objMenuItem.ItemID + '"></div>');

            // Create a div for the item text ...
            var objItemTextDiv = $('<div class="menu-item"><span>' + objMenuItem.ItemDescription + '</span></div>');

            // Add the checkbox and item text ...
            objMenuItemDiv.append(objItemTextDiv);

            // Add the item div to the popup div ...
            objContainer.append(objMenuItemDiv);
        }

        objShapeEditor.ImportCoordinateSubMenuOpened(objPopupContainerDiv, objImportCoordinateIcon.MenuItemClickedFunction);
    }

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objContainer);

    objShapeEditor.ShapeImporter.CreateElements(objPopupContainerDiv);
}

TrimbleMap.ShapeEditor.ImportCoordinateSubMenuClickHandler = function ImportCoordinateSubMenuClickHandler(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the target ...
    var objTarget = $(e.target);

    // Get the menu item element if any in which we clicked ...
    var objMenuItemElement = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'MenuItemID');

    // When found ...
    if (objMenuItemElement) {

        // Get the MenuItemID ...
        var strMenuItemID = objMenuItemElement.attr('MenuItemID');

        // Call the menu item clicked function with strMenuItemID as parameter ...
        objShapeEditor.MenuItemClickedFunction(strMenuItemID);
    }
}

// **************************************************************************
// FUNCTION: ActivateChooseExistingShapeSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateChooseExistingShapeSubMenu = function ActivateChooseExistingShapeSubMenu(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    objShapeEditor.ResetShapeEditorMode();

    // Create the draw mode popup div ...
    objShapeEditor.CreateChooseExistingShapePopupDiv();

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objShapeEditor.ChooseExistingShapePopupDiv);

    objShapeEditor.ChooseExistingShapeSubMenuOpened(objPopupContainerDiv);
}

// **************************************************************************
// FUNCTION: AdvancedToolsSubMenuClickHandler
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AdvancedToolsSubMenuClickHandler = function AdvancedToolsSubMenuClickHandler(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the target ...
    var objTarget = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'isreprojectpopupicon');

    //when the clicked item is reprojection
    if (objTarget) {

        if (!objShapeEditor.Shape.Parts || !objShapeEditor.Shape.Parts.length) {

            var strTitle = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'NoShapeSystemTitle');
            var strMessage = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'NoShapeSystemMessage');

            TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

        } else {

            //open the messagebox
            objShapeEditor.CreateReProjectPopup(objTarget);

        }
    } else {
        //prevent all other event handlers from executing.
        e.stopImmediatePropagation();

        //fire the click handler on the shape editor
        objShapeEditor.ClickedHandler(e);
    }
}

// **************************************************************************
// FUNCTION: ActivateTypeCoordinateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateTypeCoordinateSubMenu = function ActivateTypeCoordinateSubMenu(objPopupContainerDiv) {
    let objShapeEditor = this;

    objShapeEditor.ResetShapeEditorMode();

    // Use the coordinate list below to enter or modify shape
    var objContainer = $('<div class="description">' + SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'EnterCoordinatesInstructions') + '</div>');

    objPopupContainerDiv.append(objContainer);

    objShapeEditor.EditingCoordinateMode = true;
    objShapeEditor.EditingReferencePoint = true;

    objShapeEditor.SelectFirstPartOrAddPart(true);
}

// **************************************************************************
// FUNCTION: ActivateAdvancedToolSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateAdvancedToolSubMenu = function ActivateAdvancedToolSubMenu(objPopupContainerDiv) {

    var intIcon = 0, objAdvancedIcon, objReprojectIcon, objShapeEditor = this;

    objShapeEditor.ResetShapeEditorMode();

    var arrReprojectIcons = objShapeEditor.Options.Icons.filter(function (objIcon) {
        return objIcon.PredefinedIcon == TrimbleMap.ShapeEditor.enumPredefinedIcon.ReProject;
    });

    var arrAdvancedIcons = objShapeEditor.Options.Icons.filter(function (objIcon) {
        return objIcon.IsAdvanced == true;
    });

    if (arrReprojectIcons && arrReprojectIcons.length > 0) {

        //Get the first one. Will almost always return 1 element anyway. 
        objReprojectIcon = arrReprojectIcons[0];

        // Add it to the popup container div ...
        objPopupContainerDiv.append(objShapeEditor.CreateIconElement(objReprojectIcon, 0, objShapeEditor.Shape.GeometryType));
    }

    for (; intIcon < arrAdvancedIcons.length; intIcon++) {

        objAdvancedIcon = arrAdvancedIcons[intIcon];

        objPopupContainerDiv.append(objShapeEditor.CreateIconElement(objAdvancedIcon, intIcon, objShapeEditor.Shape.GeometryType));
    }

    objPopupContainerDiv.on('click', (objShapeEditor.AdvancedToolsSubMenuClickHandlerProxy));

}

// **************************************************************************
// FUNCTION: DeActivateDrawOnMapSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateDrawOnMapSubMenu = function DeActivateDrawOnMapSubMenu(objPopupContainerDiv, fnSubMenuItemClickedFunction) {

    // Get the instance ...
    var objShapeEditor = this;

    // Detach a click event handler to the popup div ...
    objPopupContainerDiv.off('click', objShapeEditor.DrawOnMapClickedProxy);
}

// **************************************************************************
// FUNCTION: DeActivateChooseExistingShapeSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateChooseExistingShapeSubMenu = function DeActivateChooseExistingShapeSubMenu(objPopupContainerDiv, fnSubMenuItemClickedFunction) {

    // Get the instance ...
    var objShapeEditor = this;

    // Detach a click event handler to for tool mode ...
    objShapeEditor.ChooseExistingShapeToolDropDown.off('change', objShapeEditor.ChooseExistingShapeToolModeClickedProxy);

    // Detach a click event handler to for draw mode ...
    objPopupContainerDiv.find(".choose_existing_shape_draw_mode_control").off('click', objShapeEditor.ChooseExistingShapeDrawModeClickedProxy);
}

// **************************************************************************
// FUNCTION: ImportCoordinateSubMenuOpened
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ImportCoordinateSubMenuOpened = function ImportCoordinateSubMenuOpened(objPopupContainerDiv, fnMenuItemClickedFunction) {

    // Get the instance ...
    var objShapeEditor = this;

    //Save callback function on container element
    objShapeEditor.MenuItemClickedFunction = fnMenuItemClickedFunction;

    // Attach a click event handler to the popup div ...
    objPopupContainerDiv.on('click', (objShapeEditor.ImportCoordinateSubMenuClickHandlerProxy));

}

// **************************************************************************
// FUNCTION: DrawOnMapSubMenuOpened
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DrawOnMapSubMenuOpened = function DrawOnMapSubMenuOpened(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the draw mode ...
    objShapeEditor.SelectTool(TrimbleMap.ShapeEditor.enumToolMode.DrawGeometry);

    // Attach a click event handler to the popup div ...
    objPopupContainerDiv.on('click', (objShapeEditor.DrawOnMapClickedProxy));
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeSubMenuOpened
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeSubMenuOpened = function ChooseExistingShapeSubMenuOpened(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set to not perform the selection ...
    objShapeEditor.ChoosingExistingShape = false;

    // Get the mode button by name ...
    var objButtonToActivate = objShapeEditor.ModeButtons.GetButtonByName(TrimbleMap.ShapeEditor.Shared.MODE_BUTTON_NAME);

    // Activate the button ...
    objShapeEditor.ModeButtons.ActivateButton(objButtonToActivate);

    objShapeEditor.DeActivateMode();

    // Select the tool ...
    objShapeEditor.ChooseExistingShapeSelectTool(objShapeEditor.ChooseExistingShapeToolMode);

    // Attach a change event handler to the tool mode ...
    objShapeEditor.ChooseExistingShapeToolDropDown.change(objShapeEditor.ChooseExistingShapeToolModeClickedProxy);

    // Attach a click event handler to the draw mode ...
    objPopupContainerDiv.find(".choose_existing_shape_draw_mode_control").on('click', objShapeEditor.ChooseExistingShapeDrawModeClickedProxy);
}

// **************************************************************************
// FUNCTION: DrawModePopupClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DrawModePopupClicked = function DrawModePopupClicked(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the element clicked on ...
    var objTarget = $(e.target);

    // Find the element or parent element with the draw mode attribute ...
    var objDrawMode = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'DrawMode');

    // When found ...
    if (objDrawMode) {

        //prevent all other events from firing
        e.stopImmediatePropagation();

        // Get the draw mode ...
        var enDrawMode = objDrawMode.attr('DrawMode');

        // Set the draw mode ...
        objShapeEditor.DrawMode = enDrawMode;

        // Update the draw mode icon ...
        objShapeEditor.UpdateDrawModeSelectedItem();

    }
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeDrawModeClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeDrawModeClicked = function ChooseExistingShapeDrawModeClicked(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the element clicked on ...
    var objTarget = $(e.target);

    // Find the element or parent element with the draw mode attribute ...
    var objDrawMode = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'DrawMode');

    // When found ...
    if (objDrawMode) {

        //prevent all other events from firing
        e.stopImmediatePropagation();
        e.preventDefault();

        // Get the draw mode ...
        var enDrawMode = objDrawMode.attr('DrawMode');

        // Set the draw mode ...
        objShapeEditor.ChooseExistingShapeDrawMode = enDrawMode;

        // Update the draw mode icon ...
        objShapeEditor.UpdateChooseExistingShapeDrawModeSelectedItem();

    }
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeToolModeClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeToolModeClicked = function ChooseExistingShapeToolModeClicked(e) {

    // Get the instance ...
    var objShapeEditor = this;

    var objToolMode = objShapeEditor.ChooseExistingShapeToolDropDown;

    // When found ...
    if (objToolMode) {

        objShapeEditor.ChooseExistingShapeDeActivateTool();

        //prevent all other events from firing
        e.stopImmediatePropagation();
        e.preventDefault();
        // Get the tool mode ...
        var enToolMode = objToolMode.val();

        // Set the tool mode ...
        objShapeEditor.ChooseExistingShapeToolMode = enToolMode;

        // Select the tool ...
        objShapeEditor.ChooseExistingShapeSelectTool(enToolMode);
    }
}

// **************************************************************************
// FUNCTION: UpdateDrawModeSelectedItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateDrawModeSelectedItem = function UpdateDrawModeSelectedItem() {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the icon element ...
    var arrDrawModeElements = objShapeEditor.IconsDiv.find('.draw-item');

    arrDrawModeElements.each(function (intDrawModeElement, objDrawModeElement) {

        objDrawModeElement = $(objDrawModeElement);

        var enDrawMode = objDrawModeElement.attr('DrawMode');
        var objCheckBoxElement = (objDrawModeElement.find('.checked').length > 0) ? objDrawModeElement.find('.checked') : objDrawModeElement.find('.unchecked');

        if (enDrawMode == objShapeEditor.DrawMode) {

            objCheckBoxElement.addClass('checked');
            objCheckBoxElement.removeClass('unchecked');

        } else if (objCheckBoxElement.hasClass('checked')) {

            objCheckBoxElement.addClass('unchecked');
            objCheckBoxElement.removeClass('checked');
        }
    });
}

// **************************************************************************
// FUNCTION: UpdateChooseExistingShapeDrawModeSelectedItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateChooseExistingShapeDrawModeSelectedItem = function UpdateChooseExistingShapeDrawModeSelectedItem() {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the icon element ...
    var arrDrawModeElements = objShapeEditor.IconsDiv.find('.draw-item');

    arrDrawModeElements.each(function (intDrawModeElement, objDrawModeElement) {

        objDrawModeElement = $(objDrawModeElement);

        var enDrawMode = objDrawModeElement.attr('DrawMode');
        var objCheckBoxElement = (objDrawModeElement.find('.checked').length > 0) ? objDrawModeElement.find('.checked') : objDrawModeElement.find('.unchecked');

        if (enDrawMode == objShapeEditor.ChooseExistingShapeDrawMode) {

            objCheckBoxElement.addClass('checked');
            objCheckBoxElement.removeClass('unchecked');

        } else if (objCheckBoxElement.hasClass('checked')) {

            objCheckBoxElement.addClass('unchecked');
            objCheckBoxElement.removeClass('checked');
        }
    });
}

// **************************************************************************
// FUNCTION: CreateDrawModePopupDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateDrawModePopupDiv = function CreateDrawModePopupDiv() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the popup does not exist yet ...
    if (!objShapeEditor.DrawModePopupDiv) {

        // Create the draw mode popup div ...
        objShapeEditor.DrawModePopupDiv = $('<div class="draw-shape"></div>');

        var objToolModeIcon = objShapeEditor.Options.Icons.filter(function (objIcon) {
            return objIcon.PredefinedIcon == TrimbleMap.ShapeEditor.enumPredefinedIcon.DrawPolygon;
        })[0];

        objShapeEditor.DrawModePopupDiv.append(objShapeEditor.CreateIconElement(objToolModeIcon, 0, objShapeEditor.Shape.GeometryType));

        // Get the translations ...
        var objDrawModeTranslations = {
            Add: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DrawToAdd'), // 'Draw to Add'
            Remove: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DrawToRemove') // 'Draw to Remove'
        };

        // Loop through all the draw modes to popuplate ...
        $.each(objDrawModeTranslations, function (enDrawMode, strOptionsTranslation) {

            // Create a div for the draw mode item ...
            var objDrawModeItemDiv = $('<div class="draw-item" DrawMode="' + enDrawMode + '"></div>');

            // Choose the css class depending on whether or not the draw mode should be checked or not ...
            var strCssClass = (enDrawMode == objShapeEditor.DrawMode) ? 'checked' : 'unchecked';

            // Create a div for the checkbox ...
            var objCheckBoxDiv = $('<div class="' + strCssClass + '"></div>');

            // Create a div for the icon ...
            var objIconDiv = $('<div class="draw-mode-icon ' + TrimbleMap.ShapeEditor.Shared.DrawModeIconCssClass(enDrawMode) + '"></div>');

            // Create a div for the item text ...
            var objItemTextDiv = $('<span>' + strOptionsTranslation + '</span></div>');

            // Add the checkbox, icon and item text ...
            objDrawModeItemDiv.append(objCheckBoxDiv);
            objDrawModeItemDiv.append(objIconDiv);
            objDrawModeItemDiv.append(objItemTextDiv);

            // Add the item div to the draw mode popup div ...
            objShapeEditor.DrawModePopupDiv.append(objDrawModeItemDiv);
        });
    }
}

// **************************************************************************
// FUNCTION: CreateChooseExistingShapePopupDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateChooseExistingShapePopupDiv = function CreateChooseExistingShapePopupDiv() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the popup does not exist yet ...
    if (!objShapeEditor.ChooseExistingShapePopupDiv) {
        // Create the draw mode popup div ...
        objShapeEditor.ChooseExistingShapePopupDiv = $('<div></div>');

        //=======================================================//
        //                  Layers Control setup                 //
        //=======================================================//

        // Create row element for layer
        var objLayerRowElement = $('<div class="pick-from-map-item"></div>');

        // Create mode text element 'Mode'
        var objLayerTextElement = $('<div class="pick-from-map-item-span">' + SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'SelectShapesFrom') + ':</div>');

        // Create dropdown for layers
        objShapeEditor.ChooseExistingShapeSelectShapesFromDropDown = $('<select class="pick-from-map-dropdown"></select>');

        // Populates the layer dropdown with layers that are selectable and are of the same geometry type as the asset
        objShapeEditor.PopulateSelectShapesFromDropDown(true);

        // Create a div and append layers dropdown
        var objLayerControlElement = $('<div></div>');
        objLayerControlElement.append(objShapeEditor.ChooseExistingShapeSelectShapesFromDropDown);

        // Add layer text element to row element
        objLayerRowElement.append(objLayerTextElement);

        // Add layer control element to row element
        objLayerRowElement.append(objLayerControlElement);

        //=======================================================//
        //              Tool Types Control setup                 //
        //=======================================================//

        // Create row element for tool
        var objToolRowElement = $('<div class="pick-from-map-item"></div>');

        // Create tool text element 'Mode'
        var objToolTextElement = $('<div class="pick-from-map-item-span">' + SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Tools') + ':</div>');

        // Create dropdown for tool types
        objShapeEditor.ChooseExistingShapeToolDropDown = $('<select class="pick-from-map-dropdown"></select>');

        // Populates the tool dropdown with different tools
        objShapeEditor.PopulateToolsDropDown();

        // Create a div and append tool types dropdown
        var objToolControlElement = $('<div></div>');
        objToolControlElement.append(objShapeEditor.ChooseExistingShapeToolDropDown);

        // Add tool text element to row element
        objToolRowElement.append(objToolTextElement);

        // Add tool control element to row element
        objToolRowElement.append(objToolControlElement);

        //=======================================================//
        //                    Mode Control setup                 //
        //=======================================================//

        // Create row element for mode
        var objModeRowElement = $('<div class="pick-from-map-item"></div>');

        // Create mode text element 'Mode'
        var objModeTextElement = $('<div class="pick-from-map-item-span">' + SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ChooseExistingShapeMode') + ':</div>');

        // Add mode text element to row element
        objModeRowElement.append(objModeTextElement);

        // Get the translations used for modes ...
        var objDrawModeTranslations = {
            ChooseExistingShapeAdd: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ChooseExistingShapeAdd'),
            ChooseExistingShapeRemove: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ChooseExistingShapeRemove')
        };

        // Create a mode types container element
        var objModeTypesElement = $('<div class="choose_existing_shape_draw_mode_control"></div>');

        // Loop through all the draw modes to popuplate ...
        $.each(objDrawModeTranslations, function (enDrawMode, strOptionsTranslation) {

            // Create a div for the draw mode item ...
            var objDrawModeItemDiv = $('<div class="draw-item" DrawMode="' + enDrawMode + '"></div>');

            // Set Draw mode back to default
            objShapeEditor.ChooseExistingShapeDrawMode = TrimbleMap.ShapeEditor.enumChooseExistingShapeOperation.ChooseExistingShapeAdd;

            // Choose the css class depending on whether or not the draw mode should be checked or not ...
            var strCssClass = (enDrawMode == objShapeEditor.ChooseExistingShapeDrawMode) ? 'checked' : 'unchecked';

            // Create a div for the checkbox ...
            var objCheckBoxDiv = $('<div class="' + strCssClass + '"></div>');

            // Create a div for the icon ...
            var objIconDiv = $('<div class="draw-mode-icon ' + TrimbleMap.ShapeEditor.Shared.ChooseExistingShapeDrawModeIconCssClass(enDrawMode) + '"></div>');

            // Create a div for the item text ...
            var objItemTextDiv = $('<span>' + strOptionsTranslation + '</span></div>');

            // Add the checkbox, icon and item text ...
            objDrawModeItemDiv.append(objCheckBoxDiv);
            objDrawModeItemDiv.append(objIconDiv);
            objDrawModeItemDiv.append(objItemTextDiv);

            // Add mode to mode types container element
            objModeTypesElement.append(objDrawModeItemDiv);
        });

        // Add mode types container element to row element
        objModeRowElement.append(objModeTypesElement);

        // Add the layer row element to the draw mode popup div ...
        objShapeEditor.ChooseExistingShapePopupDiv.append(objLayerRowElement);

        // Add the tool row element to the draw mode popup div ...
        objShapeEditor.ChooseExistingShapePopupDiv.append(objToolRowElement);

        // Add the mode row element to the draw mode popup div ...
        objShapeEditor.ChooseExistingShapePopupDiv.append(objModeRowElement);
    }
}

//=======================================================//
//              Choose Existing Shape setup              //
//=======================================================//


// **************************************************************************
// FUNCTION: ChooseExistingShapeSelectTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeSelectTool = function ChooseExistingShapeSelectTool(enSelectionTool) {

    // Get the instance ...
    var objShapeEditor = this;

    // When not already selected ...
    if (enSelectionTool != objShapeEditor.ChooseExistingShapeMode) {

        // When we are not performing the selection ...
        if (!objShapeEditor.ChoosingExistingShape) {

            // De-Activate the tool ...
            objShapeEditor.ChooseExistingShapeDeActivateTool();
        }

        // Set the tool mode ...
        objShapeEditor.ChooseExistingShapeToolMode = enSelectionTool;

        // When we are not performing the selection ...
        if (!objShapeEditor.ChoosingExistingShape) {

            // Activate the tool ...
            objShapeEditor.ChooseExistingShapeActivateTool();
        }
    }
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeActivateTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeActivateTool = function ChooseExistingShapeActivateTool() {

    // Get the instance ...
    var objShapeEditor = this;

    // Activate the tool based on the ChooseExistingShapeToolMode ...
    switch (objShapeEditor.ChooseExistingShapeToolMode) {

        case TrimbleMap.ShapeEditor.enumChooseExistingShapeToolMode.ChooseShapeByPoint:
            objShapeEditor.ChooseExistingShapeActivateSelectByPoint();
            break;

        case TrimbleMap.ShapeEditor.enumChooseExistingShapeToolMode.ChooseShapeByPolygon:
            objShapeEditor.ChooseExistingShapeActivateSelectByPolygon();
            break;

    }
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeDeActivateTool
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeDeActivateTool = function ChooseExistingShapeDeActivateTool() {

    // Get the instance ...
    var objShapeEditor = this;

    // De-Activate the tool based on the ChooseExistingShapeToolMode ...
    switch (objShapeEditor.ChooseExistingShapeToolMode) {

        case TrimbleMap.ShapeEditor.enumChooseExistingShapeToolMode.ChooseShapeByPoint:
            objShapeEditor.ChooseExistingShapeDeActivateSelectByPoint();
            break;

        case TrimbleMap.ShapeEditor.enumChooseExistingShapeToolMode.ChooseShapeByPolygon:
            objShapeEditor.ChooseExistingShapeDeActivateSelectByPolygon();
            break;

    }
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeActivateSelectByPoint
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeActivateSelectByPoint = function ChooseExistingShapeActivateSelectByPoint() {

    // Get the instance ...
    var objShapeEditor = this;

    // Attach a click event handler to the map ...
    objShapeEditor.ChooseExistingShapeClickHandlerInstance = objShapeEditor.MapController.EsriMap.on('click', objShapeEditor.ChooseExistingShapeMapClickedHandlerProxy);
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeDeActivateSelectByPoint
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeDeActivateSelectByPoint = function ChooseExistingShapeDeActivateSelectByPoint() {

    // Get the instance ...
    var objShapeEditor = this;

    // Detach a click event handler from the map ...
    if (objShapeEditor.ChooseExistingShapeClickHandlerInstance) {
        objShapeEditor.ChooseExistingShapeClickHandlerInstance.remove();
    }

}

// **************************************************************************
// FUNCTION: ChooseExistingShapeActivateSelectByPolygon
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeActivateSelectByPolygon = function ChooseExistingShapeActivateSelectByPolygon() {

    // Get the instance ...
    var objShapeEditor = this;

    // De-activate the drawing toolbar when active ...
    objShapeEditor.ChooseExistingShapeDeActivateSelectByPolygon();

    // When the map has been loaded successfully ...
    if (objShapeEditor.MapController.EsriMap.loaded) {

        // Create a new drawing toolbar for the map ...
        objShapeEditor.EsriDrawingToolbar = new esri.toolbars.Draw(objShapeEditor.MapController.EsriMap);

        // Connect to the onDrawEnd event ...
        objShapeEditor.EndPolygonDrawingHandle = dojo.connect(objShapeEditor.EsriDrawingToolbar, "onDrawEnd", objShapeEditor.ChooseExistingShapePolygonDrawEndHandlerProxy);

        // Activate the drawing toolbar ...
        objShapeEditor.EsriDrawingToolbar.activate(esri.toolbars.Draw.POLYGON);
    }
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeDeActivateSelectByPolygon
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeDeActivateSelectByPolygon = function ChooseExistingShapeDeActivateSelectByPolygon() {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have a drawing toolbar ...
    if (objShapeEditor.EsriDrawingToolbar) {

        // Deactivate it ...
        objShapeEditor.EsriDrawingToolbar.deactivate();

        // Set it to be null ...
        objShapeEditor.EsriDrawingToolbar = null;

        // Detach the poylgon drawing end event handler ...
        dojo.disconnect(objShapeEditor.EndPolygonDrawingHandle);
    }
}


// **************************************************************************
// FUNCTION: ChooseExistingShapeMapClickedHandler
// USAGE:    
// **************************************************************************

TrimbleMap.ShapeEditor.ChooseExistingShapeMapClickedHandler = function ChooseExistingShapeMapClickedHandler(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the map has been loaded successfully ...
    if (objShapeEditor.MapController.EsriMap.loaded) {

        // Get html element in which the map live's offset relative to the page ...
        var objMapElementOffset = objShapeEditor.MapController.MapElement.offset();

        // Build a screen point ...
        var objScreenPoint = new esri.geometry.ScreenPoint(e.pageX - objMapElementOffset.left, e.pageY - objMapElementOffset.top);

        // Convert to map units ...
        var objMapPoint = objShapeEditor.MapController.EsriMap.toMap(objScreenPoint);


        // Create a point to the right of the point that are TrimbleMap.Selection.Shared.TOLERANCE_IN_PIXELS away ...    
        var objToleranceScreenPoint = new esri.geometry.ScreenPoint(objScreenPoint.x + TrimbleMap.Selection.Shared.TOLERANCE_IN_PIXELS, objScreenPoint.y);

        // Convert the tolerance point to map units ... 
        var objToleranceMapPoint = objShapeEditor.MapController.EsriMap.toMap(objToleranceScreenPoint);

        // Compute the tolerance distance in map units ...
        var intToleranceInMapUnits = Math.abs(objMapPoint.x - objToleranceMapPoint.x);

        // Create an extent that have intToleranceInMapUnits width and height centered on the clicked point ...
        var objSelectionGeometry = new esri.geometry.Extent(objMapPoint.x - intToleranceInMapUnits,
            objMapPoint.y + intToleranceInMapUnits,
            objMapPoint.x + intToleranceInMapUnits,
            objMapPoint.y - intToleranceInMapUnits,
            objShapeEditor.MapController.EsriMap.spatialReference);


        // Perform the selection ...
        objShapeEditor.ChooseExistingShape(objSelectionGeometry, null, true, null, null, null);
    }
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeIsValidPolygonForPolygonSelection
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapeIsValidPolygonForPolygonSelection = function ChooseExistingShapeIsValidPolygonForPolygonSelection(objGeometry) {

    // Start with not being valid ...
    var blnValid = false;

    // When it's a polygon with a ring ...
    if ((objGeometry.type == 'polygon') && (objGeometry.rings.length > 0)) {

        // Get the ring ...
        var arrRing = objGeometry.rings[0];

        // Only perform the check when we have at least 2 coordinates ...
        if (arrRing.length >= 2) {

            // Get the first and last coordinate ...
            var objFirstCoordinate = arrRing[0];
            var objLastCoordinate = arrRing[arrRing.length - 1];

            // When the first and last coordinates matches ...
            var blnFirstAndLastEqual = (objFirstCoordinate[0] == objLastCoordinate[0]) && (objFirstCoordinate[1] == objLastCoordinate[1]);

            // We need at least 4 coordinates when the first and last are the same, otherwise 3 ...
            var intMinCoords = (blnFirstAndLastEqual) ? 4 : 3;

            // Determine whether or not we have the minimum number of coordinates ...
            blnValid = (arrRing.length >= intMinCoords);
        }
    }

    return blnValid;
}
// **************************************************************************
// FUNCTION: ChooseExistingShapePolygonDrawEndHandler
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShapePolygonDrawEndHandler = function ChooseExistingShapePolygonDrawEndHandler(objGeometry) {

    // Get the instance ...
    var objShapeEditor = this;

    // WHen the geometry is valid for polygon selection (have at least 3 distinct coordinates) ...
    if (objShapeEditor.ChooseExistingShapeIsValidPolygonForPolygonSelection(objGeometry)) {

        // Perform the selection ...
        objShapeEditor.ChooseExistingShape(objGeometry, null, true);

    } else {

        // Unable to perform selection
        var strTitle = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'UnableToPerformSelectionTitle');

        // Draw a polygon with at least 3 coordinates.
        var strMessage = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'UnableToPerformSelectionMessage');

        // Show the message ...
        TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
    }
}

// **************************************************************************
// FUNCTION: ChooseExistingShape
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ChooseExistingShape = function ChooseExistingShape(objGeometry, fnWhereClauseForMapLayer, blnOnlyOnVisibleSelectableMapServices, fnSelectOnMapLayer, fnIsActiveLayer, enOperationOverride) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set performing selection to true ...
    objShapeEditor.ChoosingExistingShape = true;

    // Create a deferred to return ...
    var objDeferred = new dojo.Deferred();

    objShapeEditor.ChooseExistingShapeDeActivateTool();

    // Set the wait cursor on the map ...
    objShapeEditor.MapController.SetMapCursor('wait');


    // Determine the selection mod ebased on the operation ... 
    var enSelectionMode = esri.layers.FeatureLayer.SELECTION_NEW;// TrimbleMap.Selection.Shared.SelectionMethodForOperation(enOperation);

    // Declare a variable for the for each map service function ... 
    var fnForEachMapService;

    // When we are only to perform selection on visible selectable map services ...
    if (blnOnlyOnVisibleSelectableMapServices) {

        var strCurrentSelectedMapLayer = objShapeEditor.ChooseExistingShapeSelectShapesFromDropDown;

        // Set fnSelectOnMapLayer to a function that will select on the selectable layers that are active ...
        fnSelectOnMapLayer = function (objMapLayer, objMapServiceDisplay) {

            // Get the esri layer ID for the map layer ID ...
            var strEsriLayerID = objShapeEditor.MapController.GetEsriLayerIDForMapLayerID(objMapLayer.MapLayerID);

            // Only perform the selection on active selectable layers ...
            return objMapLayer.MapLayerID == strCurrentSelectedMapLayer.val();
        }

        // Create a function that will call fnForMapService for 
        // each visible selectable map service in the current map ...

        if (strCurrentSelectedMapLayer) {
            var strMapLayerID = strCurrentSelectedMapLayer.val();

            fnForEachMapService = function (fnForMapService) {
                objShapeEditor.MapController.ForCurrentMapServiceInCurrentMap(fnForMapService, strMapLayerID);
            }
        }

    }

    // Add it to the selection in the map ...
    var objSelectInMapDeferred = objShapeEditor.MapController.SelectInMap(objGeometry, fnWhereClauseForMapLayer, enSelectionMode, fnForEachMapService, fnSelectOnMapLayer, false);

    // Get the current map index for which the selection will be performed ...
    var intMapIndexForCurrentSelection = objShapeEditor.MapController.State.CurrentMapIndex;

    // When SelectInMap completes ...
    objSelectInMapDeferred.promise.then(TrimbleMap.Controller.Shared.TrapException(function (arrMapServiceQueryResults) {

        // When the map for which the selection has been performed are still the active map ...
        if (intMapIndexForCurrentSelection == objShapeEditor.MapController.State.CurrentMapIndex) {

            // Create a new hash table for the query results display data ...
            var dicQueryResultsDisplayData = {};

            // Loop through all the query results ...
            $.each(arrMapServiceQueryResults, function (intMapServiceQueryResult, objMapServiceQueryResult) {

                // Get the queried map layer for the query result ...
                var objQueriedMapLayer = objShapeEditor.MapController.GetMapLayer(objMapServiceQueryResult.MapLayerID);

                // Loop through all the map layer query results ...
                $.each(objMapServiceQueryResult.Data, function (intMapLayerQueryResult, objMapLayerQueryResult) {

                    // If we do not have any results for the map layer yet ...
                    if (typeof dicQueryResultsDisplayData[objMapServiceQueryResult.MapLayerID] == 'undefined') {

                        // Create a new query results display data and add it to the dictionary ...
                        dicQueryResultsDisplayData[objMapServiceQueryResult.MapLayerID] = TrimbleMap.QueryResultsDisplay.Shared.CreateQueryResultsDisplayData([], objMapServiceQueryResult.MapLayerID, 0);
                    }
                    // Get the query results display data ...
                    var objQueryResultsDisplayData = dicQueryResultsDisplayData[objMapServiceQueryResult.MapLayerID];

                    // Add the attributes to the data array ...
                    objQueryResultsDisplayData.Data.push(objMapLayerQueryResult);
                });
            });

            // Create a new array for the query results display data ...
            var arrQueryResultsDisplayData = [];

            // Loop through all the query results display datas ...
            $.each(dicQueryResultsDisplayData, function (strMapLayerID, objQueryResultsDisplayData) {

                // Add it to the array ...
                arrQueryResultsDisplayData.push(objQueryResultsDisplayData);
            });

            var objUpdateShapeDeferred = objShapeEditor.UpdateShape(arrQueryResultsDisplayData);

            objUpdateShapeDeferred.then(TrimbleMap.Controller.Shared.TrapException(function () {
                // Revert back to the default cursor ...
                objShapeEditor.MapController.SetMapCursor('default');

                // Set to not perform the selection ...
                objShapeEditor.ChoosingExistingShape = false;


                // Activate the tool ...
                objShapeEditor.ChooseExistingShapeActivateTool();
                //}

                // Resolve the deferred ...
                objDeferred.resolve();
            }), function () {
                objDeferred.reject();
            });
        }
        else {

            // Reject the deferred ...
            objDeferred.reject();
        }
    }));

    return objDeferred;
}
// **************************************************************************
// FUNCTION: UpdateShape
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateShape = function UpdateShape(arrLayerData) {

    // Get the instance ...
    var objShapeEditor = this;

    var objDeferred = new dojo.Deferred();

    var arrDeferreds = [];

    $.each(arrLayerData, function (intLayerData, objQueryResultsByLayer) {

        var objQueriedMapLayer = objShapeEditor.MapController.GetMapLayer(objQueryResultsByLayer.MapLayerID);

        // Get the map layer ID field name ...
        var strIDFieldName = objShapeEditor.MapController.GetMapLayerIDFieldName(objQueriedMapLayer);

        // Loop through all the query results ...
        $.each(objQueryResultsByLayer.Data, function (intQueryResult, objQueryResult) {


            switch (objShapeEditor.ChooseExistingShapeDrawMode) {
                case TrimbleMap.ShapeEditor.enumChooseExistingShapeOperation.ChooseExistingShapeAdd:

                    //when  selected shape is a polygon and the ShapeEditor shape is of 'MIXED' type or both shapes have the same type
                    if ((objQueryResult.Geometry.type == "polygon" && objShapeEditor.Shape.GeometryType == "MIXED") || (objQueryResult.Geometry.type.toUpperCase() == objShapeEditor.Shape.GeometryType.toUpperCase())) {

                        // Draw to add the selected geometry ...
                        arrDeferreds.push(objShapeEditor.DrawToAddMultiPart(objQueryResult.Geometry, objQueryResult.SpatialReferenceID, true, false));
                    }
                    else {

                        // Unable to add the selection to the shape        
                        var strTitle = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'UnableToAddSelection');

                        // The geometry type of the selection does not match the geometry type of the shape        
                        var strMessage = SD.Translation.Shared.GetTranslation('Map.Selection.js', 'GeometryTypeMismatch');

                        //Show the dialog
                        TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
                    }
                    break;
                case TrimbleMap.ShapeEditor.enumChooseExistingShapeOperation.ChooseExistingShapeRemove:
                    // Draw to remove the selected geometry ...
                    arrDeferreds.push(objShapeEditor.DrawToRemoveMultiPart(objQueryResult.Geometry, objQueryResult.SpatialReferenceID, false));

                    // Get the id ...
                    var strID = objQueryResult.Attributes[strIDFieldName];

                    // Remove the item from the selection on the map ...
                    objShapeEditor.MapController.RemoveFromSelection(objQueriedMapLayer, strID);

                    break;
            }

        });

    });

    // Removes left over graphics that were drawn on the map that is not part of the final shape
    if (arrDeferreds.length > 0) {
        new dojo.promise.all(arrDeferreds).then(TrimbleMap.Controller.Shared.TrapException(function () {
            // Removes coordinates along a straight line
            // We only call this method now as calling it in DrawToAddMultiPart or DrawToRemoveMultiPart causes slight changes in shapes which in turn causes shapes 
            // that were contiguous and suppose to be unioned to no more be contiguous thus not unioning.
            if (objShapeEditor.RemoveVerticesAlongStraightLine === true) {
                objShapeEditor.Shape.RemoveCoordinatesAlongStraightLine(objShapeEditor.MapController);
            }

            if (objShapeEditor.EsriGraphicByPartID) {
                $.each(objShapeEditor.EsriGraphicByPartID, function (intPartID, objGraphicPart) {
                    if (objShapeEditor.Shape.Parts) {
                        $.each(objShapeEditor.Shape.Parts, function (intExteriorPart, objExteriorPart) {
                            var blnDeletedGraphic = false;

                            var arrExteriorParts = $.grep(objShapeEditor.Shape.Parts, function (objValue) {
                                return objValue.ID == intPartID;
                            });

                            if (arrExteriorParts.length == 0) {
                                objShapeEditor.RemovePartGraphics(intPartID);
                                blnDeletedGraphic = true;
                            }

                            if (!blnDeletedGraphic && objExteriorPart.InteriorParts) {
                                $.each(objExteriorPart.InteriorParts, function (intInteriorPart, objInteriorPart) {
                                    var arrInteriorParts = $.grep(objExteriorPart.InteriorParts, function (objValue) {
                                        return objValue.ID == intPartID;
                                    });

                                    if (arrInteriorParts.length == 0) {
                                        objShapeEditor.RemovePartGraphics(intPartID);
                                    }

                                    if (objInteriorPart.Coordinates.length < 3) {
                                        objShapeEditor.RemoveShapePart(objInteriorPart);
                                    }
                                });
                            }


                            if (objExteriorPart.Coordinates.length < 3) {
                                objShapeEditor.RemoveShapePart(objExteriorPart);
                            }
                        });
                    }
                });
            }

            // Redraw shape so that updated shaped (Removed vertices along a straight line removed) is shown on map
            objShapeEditor.DisplayShape().then(function () {

                // Get the cordinate format of the coordinate list editor ...
                var enCoordinateFormat = objShapeEditor.CoordinateListEditor.CoordinateFormat;

                // Loop through al the shape parts
                objShapeEditor.Shape.ForEachPart(function (objPart) {
                    // Set the editable property on the coordinate list editor
                    objShapeEditor.CoordinateListEditor.ChangeCoordinates(enCoordinateFormat, objPart.Coordinates, false,
                        TrimbleMap.Shape.Shared.DecimalPlacesForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID), false);
                });

                objDeferred.resolve();
            }, function () {
                objDeferred.reject();
            });
        }), function () {
            objDeferred.reject();
        });
    } else {
        objDeferred.resolve();
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: ClipShapeOverlap
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ClipShapeOverlap = function ClipShapeOverlap(arrOverlapsToClip, blnMapReferenceOverlapsArePrecalculatedIntersectionShapes) {

    let objShapeEditor = this;

    let objDeferred = new dojo.Deferred;

    let objShape = objShapeEditor.Shape.Clone();

    // Default to treating the map reference overlap shape as a full map reference shape rather than a precalculated intersection of the map reference shape and the target shape ...
    if ((typeof blnMapReferenceOverlapsArePrecalculatedIntersectionShapes == 'undefined') || (blnMapReferenceOverlapsArePrecalculatedIntersectionShapes == null)) { blnMapReferenceOverlapsArePrecalculatedIntersectionShapes = false; }

    if (arrOverlapsToClip && arrOverlapsToClip.length > 0) {

        let objProjectionDeferred = new dojo.Deferred;

        if (objShape.SpatialReferenceID != arrOverlapsToClip[0].Shape.SpatialReferenceID) {

            objShape.Project(objShapeEditor.MapController, arrOverlapsToClip[0].Shape.SpatialReferenceID, false).then(TrimbleMap.Controller.Shared.TrapException(function (objProjectionResultShape) {

                objProjectionDeferred.resolve(objProjectionResultShape);

            }), TrimbleMap.Controller.Shared.TrapException(function () {

                // Reprojection failed
                let strTitle = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FailedReprojectionTitle');

                // Problem reprojecting the geometry. Coordinate measures out of bounds (Result returned as not a number)
                let strMessage = SD.Translation.Shared.GetTranslation('Map.Controller.js', 'FailedReprojectionEndUserMessage');

                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

                objProjectionDeferred.reject();
            }));

        } else {

            objProjectionDeferred.resolve(objShape);
        }

        objProjectionDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedShape) {

            let objClippedShapeGeometry = objProjectedShape.GetGeometry(objShapeEditor.MapController);

            arrOverlapsToClip.forEach(function (objOverlapToClip, intOverlapToClipIndex) {

                let objOverlapShape = objOverlapToClip.Shape;
                let objOverlapShapeGeometry = objOverlapShape.GetGeometry(objShapeEditor.MapController);

                if (objOverlapToClip.MapReferenceCheckTopology && !blnMapReferenceOverlapsArePrecalculatedIntersectionShapes) {

                    switch (objOverlapToClip.MapReferenceCheckTopology) {

                        case TrimbleMap.ShapeEditor.enumMapReferenceOverlapTopology.ShapeEntirelyOutsideMapReference:
                            // The valid area is that outside of the map reference
                            if (objClippedShapeGeometry && objOverlapShapeGeometry) {
                                objClippedShapeGeometry = esri.geometry.geometryEngine.difference(objClippedShapeGeometry, objOverlapShapeGeometry);
                            }
                            break;

                        case TrimbleMap.ShapeEditor.enumMapReferenceOverlapTopology.ShapeEntirelyWithinMapReference:
                            // The valid area is that inside the map reference
                            if (objClippedShapeGeometry && objOverlapShapeGeometry) {
                                objClippedShapeGeometry = esri.geometry.geometryEngine.intersect(objClippedShapeGeometry, objOverlapShapeGeometry);
                            }
                            else {
                                objClippedShapeGeometry = null;
                            }
                            break;

                        case TrimbleMap.ShapeEditor.enumMapReferenceOverlapTopology.ShapePartiallyWithinMapReference:
                        case TrimbleMap.ShapeEditor.enumMapReferenceOverlapTopology.ShapeDoesNotPartiallyOverlapAnyMapReferences:
                            // Clipping is not supported on these map reference overlap topologies
                            break;
                    }

                } else {

                    if (objClippedShapeGeometry && objOverlapShapeGeometry) {
                        objClippedShapeGeometry = esri.geometry.geometryEngine.difference(objClippedShapeGeometry, objOverlapShapeGeometry);
                    }
                }
            });

            objShapeEditor.RemoveShape(true);

            if (objClippedShapeGeometry && objClippedShapeGeometry.rings.length > 0) {
                objClippedShapeGeometry = TrimbleMap.Shape.Shared.RemoveSliverParts(objClippedShapeGeometry, TrimbleMap.Shape.Shared.ToleranceForSliverRemoval(objShapeEditor.MapController, objShape.SpatialReferenceID));

                if (objClippedShapeGeometry && objClippedShapeGeometry.rings.length > 0) {

                    objShapeEditor.DrawToAddMultiPart(objClippedShapeGeometry, objProjectedShape.SpatialReferenceID, false, false).then(TrimbleMap.Controller.Shared.TrapException(function () {

                        if (objShapeEditor.Shape.Parts.length > 0) {

                            objShapeEditor.Shape.RoundCoordinates(objShapeEditor.MapController);
                            objShapeEditor.Shape.RemoveCoordinatesAlongStraightLine(objShapeEditor.MapController);
                            objShapeEditor.ZoomToShape();
                        }

                        objDeferred.resolve();

                    }), TrimbleMap.Controller.Shared.TrapException(function () {

                        objDeferred.reject();
                    }));

                } else {

                    objDeferred.resolve();
                }

            } else {

                objDeferred.resolve();
            }

        }), TrimbleMap.Controller.Shared.TrapException(function () {

            objDeferred.reject();
        }));

    } else {

        objDeferred.resolve();
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: CreateShapeDetailsDivElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateShapeDetailsDivElements = function CreateShapeDetailsDivElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the div for the coordinate system ...
    objShapeEditor.ShapeDetailsDiv = $('<div class="shape-container coordinate-selection"></div>');

    // Create a div for the official area and coordinate system ...
    objShapeEditor.OfficialMeasurementAndCoordinateSystemDiv = $('<div><div class="shape-coordinates"></div></div>');

    // Add it to the shape details div ..
    objShapeEditor.ShapeDetailsDiv.append(objShapeEditor.OfficialMeasurementAndCoordinateSystemDiv);

    //****** Coordinate system ******

    // Coordinate system
    var strCoordinateSystem = SD.Translation.Shared.GetTranslation('Map.Shape.js', 'CoordinateSystem');

    // Create the coordinate system div ... 
    objShapeEditor.CoordinateSystemDiv = $('<div class="header"><span>' + strCoordinateSystem + '</span></div>');

    // Add it to the div ...
    objShapeEditor.OfficialMeasurementAndCoordinateSystemDiv.find('.shape-coordinates').append(objShapeEditor.CoordinateSystemDiv);

    // Create the coordinate system div ... 
    let objCoordinateSystemValueDiv = $('<div class="' + ((objShapeEditor.Editable) ? '' : '') + '"></div>');

    // Add it to the div ...
    objShapeEditor.OfficialMeasurementAndCoordinateSystemDiv.find('.shape-coordinates').append(objCoordinateSystemValueDiv);

    // Create the coordinate system drop down ...
    objShapeEditor.CoordinateSystemDropDown = $('<select class="coordinate-dropdown"></select>');
    // Add it to the div ...
    objCoordinateSystemValueDiv.append(objShapeEditor.CoordinateSystemDropDown);

    // Create the coordinate system span ...
    objShapeEditor.CoordinateSystemSpan = $('<span class="coordinate-system"></span>');

    // Add it to the div ...
    objCoordinateSystemValueDiv.append(objShapeEditor.CoordinateSystemSpan);

    // Populate the coordinate system drop down ...
    objShapeEditor.PopulateCoordinateSystemDropDown(objShapeEditor.CoordinateSystemDropDown);

    //****** Official area or length ******

    // Create the official area elements ...
    objShapeEditor.CreateOfficialAreaElements();

    // Create the official length elements ...
    objShapeEditor.CreateOfficialLengthElements();

    //****** Calculated Area ******

    // Create the calculated area elements ...
    objShapeEditor.CreateCalculatedAreaElements();

    // Create the calculated length elements ...
    objShapeEditor.CreateCalculatedLengthElements();

    //****** Dynamic shape ******

    objShapeEditor.CreateDynamicShapeElements();

    //****** Legal description ******

    // When the legal description is to be shown ... 
    if (objShapeEditor.Options.ShowLegalDescription) {

        // Create the legal description div ...
        objShapeEditor.LegalDescriptionDiv = $('<div><div class="shape-legal"></div></div>');

        // Add it to the div ...
        objShapeEditor.ShapeDetailsDiv.append(objShapeEditor.LegalDescriptionDiv);

        // Legal Description
        var strLegalDescription = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'LegalDescription');

        // Create and add the 'Legal Description' span ...
        objShapeEditor.LegalDescriptionDiv.find('.shape-legal').append('<div class="header"><span>' + strLegalDescription + ':</span></div>');

        // When we have validation messages for the legal description ...
        if (objShapeEditor.HasValidationMessagesFor(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.LegalDescription)) {

            // Create and add a validation message icon ...
            objShapeEditor.LegalDescriptionDiv.find('.shape-legal').append(TrimbleMap.ShapeEditor.Shared.CreateValidationMessageIcon(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.LegalDescription));
        }

        // Add a container for the textarea element ...
        objShapeEditor.LegalDescriptionTextAreaDiv = $('<div></div>');

        objShapeEditor.LegalDescriptionDiv.find('.shape-legal').append(objShapeEditor.LegalDescriptionTextAreaDiv);

        // Determine whether or not to make it readonly ...
        var strReadOnly = (objShapeEditor.Editable && objShapeEditor.Options.LegalDescriptionEditable) ? '' : ' readonly="true"';

        // Create the text area ...
        objShapeEditor.LegalDescriptionTextArea = $('<textarea rows="2"' + strReadOnly + '></textarea>');

        // Add it to the div ...
        objShapeEditor.LegalDescriptionTextAreaDiv.append(objShapeEditor.LegalDescriptionTextArea);
    }

    // Return the created div ...
    return objShapeEditor.ShapeDetailsDiv;
}

// **************************************************************************
// FUNCTION: CreateOfficialAreaElements
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.CreateOfficialAreaElements = function CreateOfficialAreaElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the official area is to be shown ...
    if (objShapeEditor.Options.ShowOfficialArea) {

        // Official Area
        var strOfficialArea = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'OfficialArea') + ':';

        // Create a div for the official area and coordinate system ...
        objShapeEditor.OfficialAreaMeasurementDiv = $('<div><div class="shape-coordinates m-t-5"></div></div>');

        // Add it to the shape details div ..
        objShapeEditor.ShapeDetailsDiv.append(objShapeEditor.OfficialAreaMeasurementDiv);

        // Create a div for the official area controls with the 'Official Area:' span ...
        objShapeEditor.OfficialAreaDiv = $('<div class="header"><span>' + strOfficialArea + '</span></div>');

        // When editable and the official area is required ...
        if (objShapeEditor.Editable && objShapeEditor.Options.OfficialAreaEditable && objShapeEditor.Options.OfficialAreaRequired) {

            // Create and add the asterisk to indicate that it's required ...
            objShapeEditor.OfficialAreaDiv.find('span').prepend(TrimbleMap.ShapeEditor.Shared.CreateRequiredAsterisk());
        }

        // Add it to the div ...
        objShapeEditor.OfficialAreaMeasurementDiv.find('.shape-coordinates').append(objShapeEditor.OfficialAreaDiv);

        // Create a div that will contain the official area values (when editable use fixed width so that 'copy calculated area' can align with the right) ...
        objShapeEditor.OfficialAreaValuesDiv = $('<div class="' + ((objShapeEditor.Editable && objShapeEditor.Options.OfficialAreaEditable) ? '' : '') + '"></div>');

        // Add it to the official area div ...
        objShapeEditor.OfficialAreaMeasurementDiv.find('.shape-coordinates').append(objShapeEditor.OfficialAreaValuesDiv);

        // When we have validation messages for the official area ...
        if (objShapeEditor.HasValidationMessagesFor(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.OfficialAreaAndUnit)) {

            // Create and add a validation message icon ...
            objShapeEditor.OfficialAreaMeasurementDiv.find('.shape-coordinates').append(TrimbleMap.ShapeEditor.Shared.CreateValidationMessageIcon(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.OfficialAreaAndUnit));
        }

        // Create the official area text box ...
        objShapeEditor.OfficialAreaTextBox = $('<input type="textbox" class="area-textbox"></input>');

        // Add it to the official area values div ...
        objShapeEditor.OfficialAreaValuesDiv.append(objShapeEditor.OfficialAreaTextBox);

        // Create the official area units dropdown ...
        objShapeEditor.OfficialAreaUnitsDropDown = $('<select class="area-dropdown"></select>');

        // Add it to the official area values div ...
        objShapeEditor.OfficialAreaValuesDiv.append(objShapeEditor.OfficialAreaUnitsDropDown);

        // Populate the official area units drop down ...
        objShapeEditor.PopulateOfficialAreaUnitsDropDown();

        // Only show Copy Calculated Area for Polygon geometries
        if (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON && objShapeEditor.Options.OfficialAreaEditable) {

            // Copy Calculated Area
            var strGetCalculatedArea = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CopyCalculatedArea');

            // Create the official area units dropdown ...
            objShapeEditor.UseCalculatedAreaLink = $('<span IsUseCalculatedAreaLink="true" class="calculated-area-link">' + strGetCalculatedArea + '</span>');

            // Add it to the official area values div ...
            objShapeEditor.OfficialAreaValuesDiv.append(objShapeEditor.UseCalculatedAreaLink);
        }

        // Create the official area value and units span ...
        objShapeEditor.OfficialAreaValueAndUnitSpan = $('<span class="area-value"></span>');

        // Add it to the official area values div ...
        objShapeEditor.OfficialAreaValuesDiv.append(objShapeEditor.OfficialAreaValueAndUnitSpan);

    }
}

// **************************************************************************
// FUNCTION: CreateOfficialLengthElements
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.CreateOfficialLengthElements = function CreateOfficialLengthElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the official length is to be shown ...
    if (objShapeEditor.Options.ShowOfficialLength) {

        // Official Length: 
        var strOfficialLength = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'OfficialLength') + ':';

        // Create a div for the official area and coordinate system ...
        objShapeEditor.OfficialLengthMeasurementDiv = $('<div><div class="shape-coordinates m-t-5"></div></div>');

        // Add it to the shape details div ..
        objShapeEditor.ShapeDetailsDiv.append(objShapeEditor.OfficialLengthMeasurementDiv);

        // Create a div for the official length controls with the 'Official Length:' span ...
        objShapeEditor.OfficialLengthDiv = $('<div class="header"><span>' + strOfficialLength + '</span></div>');

        // When editable and the official length is required ...
        if (objShapeEditor.Editable && objShapeEditor.Options.OfficialLengthEditable && objShapeEditor.Options.OfficialLengthRequired) {

            // Create and add the asterisk to indicate that it's required ...
            objShapeEditor.OfficialLengthDiv.find('span').prepend(TrimbleMap.ShapeEditor.Shared.CreateRequiredAsterisk());
        }

        // Add it to the div ...
        objShapeEditor.OfficialLengthMeasurementDiv.find('.shape-coordinates').append(objShapeEditor.OfficialLengthDiv);

        // Create a div that will contain the official length values (when editable use fixed width so that 'copy calculated length' can align with the right) ...
        objShapeEditor.OfficialLengthValuesDiv = $('<div class="' + ((objShapeEditor.Editable && objShapeEditor.Options.OfficialLengthEditable) ? '' : '') + '"></div>');

        // Add it to the official length div ...
        objShapeEditor.OfficialLengthMeasurementDiv.find('.shape-coordinates').append(objShapeEditor.OfficialLengthValuesDiv);

        // When we have validation messages for the official length ...
        if (objShapeEditor.HasValidationMessagesFor(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.OfficialLengthAndUnit)) {

            // Create and add a validation message icon ...
            objShapeEditor.OfficialLengthMeasurementDiv.find('.shape-coordinates').append(TrimbleMap.ShapeEditor.Shared.CreateValidationMessageIcon(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.OfficialLengthAndUnit));
        }

        // Create the official length text box ...
        objShapeEditor.OfficialLengthTextBox = $('<input type="textbox" class="length-textbox"></input>');

        // Add it to the official length values div ...
        objShapeEditor.OfficialLengthValuesDiv.append(objShapeEditor.OfficialLengthTextBox);

        // Create the official length units dropdown ...
        objShapeEditor.OfficialLengthUnitsDropDown = $('<select class="length-dropdown"></select>');

        // Add it to the official length values div ...
        objShapeEditor.OfficialLengthValuesDiv.append(objShapeEditor.OfficialLengthUnitsDropDown);

        // Populate the official length units drop down ...
        objShapeEditor.PopulateOfficialLengthUnitsDropDown();

        // Only show Copy Calculated Length for Polyline geometries
        if (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYLINE && objShapeEditor.Options.OfficialLengthEditable) {

            // Copy Calculated Length
            var strGetCalculatedLength = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CopyCalculatedLength');

            // Create the official length units dropdown ...
            objShapeEditor.UseCalculatedLengthLink = $('<span IsUseCalculatedLengthLink="true" class="calculated-length-link">' + strGetCalculatedLength + '</span>');

            // Add it to the official length values div ...
            objShapeEditor.OfficialLengthValuesDiv.append(objShapeEditor.UseCalculatedLengthLink);
        }

        // Create the official length value and units span ...
        objShapeEditor.OfficialLengthValueAndUnitSpan = $('<span class="length-value"></span>');

        // Add it to the official length values div ...
        objShapeEditor.OfficialLengthValuesDiv.append(objShapeEditor.OfficialLengthValueAndUnitSpan);
    }
}

// **************************************************************************
// FUNCTION: CreateCalculatedAreaElements
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.CreateCalculatedAreaElements = function CreateCalculatedAreaElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a div to hold the calculated area elements ...
    objShapeEditor.CalculatedAreaDiv = $('<div><div class="shape-measurements"></div></div>');

    // Add it to the shape details div ...
    objShapeEditor.ShapeDetailsDiv.append(objShapeEditor.CalculatedAreaDiv);

    // Calculated Area
    var strCalculatedArea = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatedArea');

    // Create the left column div ...
    var objCalculatedAreaLeftColumnDiv = $('<div class="header"><span>' + strCalculatedArea + ':</span></div>');

    // Create the right column div ...
    var objCalculatedAreaRightColumnDiv = $('<div></div>');

    // Add the left column div ...
    objShapeEditor.CalculatedAreaDiv.find('.shape-measurements').append(objCalculatedAreaLeftColumnDiv);

    // Add the right column div ...
    objShapeEditor.CalculatedAreaDiv.find('.shape-measurements').append(objCalculatedAreaRightColumnDiv);

    // Calculate the label column's width ...
    objShapeEditor.CalculatedAreaLabelColumnWidth = SD.HtmlFunctions.Shared.MeasureElement(objCalculatedAreaLeftColumnDiv).width;

    // Enable Area Calculation
    var strCalculateArea = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'EnableAreaCalculation');

    // Create the "Enable Area Calculation" outer div ...
    var objCalculateAreaIconOuterDiv = $('<div class="shape-measurement-enable"></div>');

    // Create the calculate area div ...
    objShapeEditor.CalculateAreaIconDiv = $('<div class="shape-measurement-container" IsAreaCalculationActivationIcon="true"><div class="measurement-value"><span class="bold">' + strCalculateArea + '<span></div></div>');

    // Hide it ...
    objShapeEditor.CalculateAreaIconDiv.hide();

    // Add it to the outer div ...
    objCalculateAreaIconOuterDiv.append(objShapeEditor.CalculateAreaIconDiv);

    // Add the calculate area div ...
    objCalculatedAreaRightColumnDiv.append(objCalculateAreaIconOuterDiv);

    // Create the area display div inside the right column ...
    objShapeEditor.CreateAreaDisplayDiv(objCalculatedAreaRightColumnDiv);
}

// **************************************************************************
// FUNCTION: CreateCalculatedLengthElements
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.CreateCalculatedLengthElements = function CreateCalculatedLengthElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a div to hold the calculated length elements ...
    objShapeEditor.CalculatedLengthDiv = $('<div><div class="shape-measurements"></div></div>');

    // Add it to the shape details div ...
    objShapeEditor.ShapeDetailsDiv.append(objShapeEditor.CalculatedLengthDiv);

    // Calculated Length
    var strCalculatedLength = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatedLength');

    // Create the left column div ...
    var objCalculatedLengthLeftColumnDiv = $('<div class="header"><span>' + strCalculatedLength + ':</span></div>');

    // Create the right column div ...
    var objCalculatedLengthRightColumnDiv = $('<div></div>');

    // Add the left column div ...
    objShapeEditor.CalculatedLengthDiv.find('.shape-measurements').append(objCalculatedLengthLeftColumnDiv);

    // Add the right column div ...
    objShapeEditor.CalculatedLengthDiv.find('.shape-measurements').append(objCalculatedLengthRightColumnDiv);

    // Calculate the label column's width ...
    objShapeEditor.CalculatedLengthLabelColumnWidth = SD.HtmlFunctions.Shared.MeasureElement(objCalculatedLengthLeftColumnDiv).width;

    // When not in edit mode ...
    if (!objShapeEditor.Editable) {

        // Create the spacing div ...
        var objCalculatedLengthRightColumnSpacingDiv = $('<div class="shape_calculated_measurement_spacing_div"></div>');

        // Add a spacing div to align with the coordinate system text ...
        objCalculatedLengthRightColumnDiv.append(objCalculatedLengthRightColumnSpacingDiv);

        // Calculate the spacing div's width ...
        objShapeEditor.CalculatedLengthSpacingWidth = SD.HtmlFunctions.Shared.MeasureElement(objCalculatedLengthRightColumnSpacingDiv).width;
    }

    // Enable Length Calculation
    var strCalculateLength = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'EnableLengthCalculation');

    // Create the "Enable Length Calculation" outer div ...
    var objCalculateLengthIconOuterDiv = $('<div class="shape-measurement-container"></div>');

    // Create the calculate length div ...
    objShapeEditor.CalculateLengthIconDiv = $('<div class="shape-measurement-container" IsLengthCalculationActivationIcon="true"><div class="measurement-value"><span class="bold">' + strCalculateLength + '<span></div></div>');

    // Hide it ...
    objShapeEditor.CalculateLengthIconDiv.hide();

    // Add it to the outer div ...
    objCalculateLengthIconOuterDiv.append(objShapeEditor.CalculateLengthIconDiv);

    // Add the calculate length div ...
    objCalculatedLengthRightColumnDiv.append(objCalculateLengthIconOuterDiv);

    // Create the length display div inside the right column ...
    objShapeEditor.CreateLengthDisplayDiv(objCalculatedLengthRightColumnDiv);
}

// **************************************************************************
// FUNCTION: CreateDynamicShapeElements
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.CreateDynamicShapeElements = function CreateDynamicShapeElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the dynamic shape option is to be shown ...
    if (objShapeEditor.Options.ShowDynamicShape) {

        // Get translations ...

        // Derived Shape
        var strDerivedShape = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DerivedShape');

        // Define derived shape options
        var strDefineDerivedShapeOptions = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DefinedDerivedShape');

        // "Derived shape options"
        var strDerivedShapeOptions = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DerivedShapeOptions');

        // "Not a derived shape"
        var strNotDerivedShape = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NotDerivedShape');

        // View derived shape options
        var strViewDerivedShapeOptions = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ViewDerivedShape');

        // Create a div for the dynamic shape controls with the 'Derived:' span ...
        objShapeEditor.DynamicShapeDiv = $('<div class="shape-derived"><div class="header"><span>' + strDerivedShape + ':</span></div></div>');

        // When we have validation messages for the dynamic shape options ...
        if (objShapeEditor.HasValidationMessagesFor(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.DynamicShapeOptions)) {

            // Create and add a validation message icon ...
            objShapeEditor.DynamicShapeDiv.find('.header').append(TrimbleMap.ShapeEditor.Shared.CreateValidationMessageIcon(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.DynamicShapeOptions));
        }

        // Add it to the div ...
        objShapeEditor.ShapeDetailsDiv.append(objShapeEditor.DynamicShapeDiv);

        // Create a div that will contain the dynamic shape values ...
        var objDynamicShapeValuesDiv = $('<div></div>');

        // Add it to the shape details div ...
        objShapeEditor.DynamicShapeDiv.append(objDynamicShapeValuesDiv);

        // When the shape editor is editable ...
        if (objShapeEditor.CoordinatesEditable) {

            // Create the define dynamic shape options link ...
            if (objShapeEditor.Shape.IsDynamic) { strDefineDerivedShapeOptions = strDerivedShapeOptions; } else { strDefineDerivedShapeOptions = strNotDerivedShape; }

            objShapeEditor.DefineDynamicShapeOptions = $('<span class="link dynamic-define-span">' + strDefineDerivedShapeOptions + '</span>');

            // Add it to the div ...
            objDynamicShapeValuesDiv.append(objShapeEditor.DefineDynamicShapeOptions);

        }
        else {

            // Create the view dynamic shape options link ...
            if (objShapeEditor.Shape.IsDynamic) {

                objShapeEditor.ViewDynamicShapeOptions = $('<span class="link dynamic-view-span">' + strViewDerivedShapeOptions + '</span>');
            }
            else {

                objShapeEditor.ViewDynamicShapeOptions = $('<span class="link-inactive dynamic-view-span">' + strNotDerivedShape + '</span>');
            }

            // Add it to the div ...
            objDynamicShapeValuesDiv.append(objShapeEditor.ViewDynamicShapeOptions);
        }
    }
}

// **************************************************************************
// FUNCTION: IsCommonlyUsedSpatialReference
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.IsCommonlyUsedSpatialReference = function IsCommonlyUsedSpatialReference(strSpatialReferenceID) {

    // Get the instance ...
    var objShapeEditor = this;

    // Determine whether or not the spatial reference is commonly used ...
    var blnIsCommonlyUsedSpatialReference = ((typeof objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs != 'undefined') &&
        (objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs) &&
        ($.inArray(strSpatialReferenceID, objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs) > -1));

    return blnIsCommonlyUsedSpatialReference;
}

// **************************************************************************
// FUNCTION: PopulateShapePartDropDown
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateShapePartDropDown = function PopulateShapePartDropDown(objShapePart, objExclusionPart, blnUpdateNoPartsDisplayVisibilityAndDivSizes) {

    //Get the instance

    var objShapeEditor = this;

    // Add it to the shape part divs hash table ...

    if ((typeof objExclusionPart == 'undefined') || (!objExclusionPart)) {
        objShapeEditor.ShapePartDropDown.append($('<option value="' + objShapePart.ID + '">' + objShapePart.PartName + '</option>'));
    } else {
        var objSelectedShapePartOption = objShapeEditor.ShapePartDropDown.find("option[value='" + objExclusionPart.ID + "']");

        objSelectedShapePartOption.after($('<option IsExclusion="true" value="' + objShapePart.ID + '">' + '&nbsp;&nbsp;&nbsp;' + objShapePart.PartName + '</option>'));
    }

    // When we are to update the no parts display visibility and div sizes ...
    if (blnUpdateNoPartsDisplayVisibilityAndDivSizes) {

        // Update the no parts display visiblity ...
        objShapeEditor.UpdateNoPartsDisplayVisibility();

        // Resize the elements ...
        objShapeEditor.ResizeElements();
    }
}

// **************************************************************************
// FUNCTION: PopulateCoordinateSystemDropDown
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateCoordinateSystemDropDown = function PopulateCoordinateSystemDropDown(objCoordinateSystemDropDown) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the empty item and add it to the list ...
    objCoordinateSystemDropDown.append($('<option value="' + SD.Guid.Shared.Empty() + '"></option>'));

    // When we have any commomnly used spatial references ...
    if ((typeof objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs != 'undefined') &&
        (objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs) &&
        (objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs.length > 0)) {

        // Loop through all the spatial reference ...
        $.each(objShapeEditor.MapController.State.SpatialReferences, function (intSpatialReference, objSpatialReference) {

            // When not a null entry and is commonly used ...
            if ((objSpatialReference.SpatialReferenceID != SD.Guid.Shared.Empty()) && objShapeEditor.IsCommonlyUsedSpatialReference(objSpatialReference.SpatialReferenceID)) {

                // Create the option list item and add it to the list ...
                objCoordinateSystemDropDown.append('<option value="' + objSpatialReference.SpatialReferenceID + '">' + objSpatialReference.Name + '</option>');
            }
        });

        // When there are some non-commonly used spatial references ...
        if (objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs.length < objShapeEditor.MapController.State.SpatialReferences.length) {

            // Add a spacer ...
            objCoordinateSystemDropDown.append($('<option value="' + TrimbleMap.ShapeEditor.Shared.COMMONLY_USED_GUID + '">' + TrimbleMap.ShapeEditor.Shared.COMMONLY_USED_TEXT + '</option>'));
        }
    }

    // Loop through all the spatial reference ...
    $.each(objShapeEditor.MapController.State.SpatialReferences, function (intSpatialReference, objSpatialReference) {

        // When not a null entry and not commonly used ...
        if ((objSpatialReference.SpatialReferenceID != SD.Guid.Shared.Empty()) && (!objShapeEditor.IsCommonlyUsedSpatialReference(objSpatialReference.SpatialReferenceID))) {

            // Create the option list item and add it to the list ...
            objCoordinateSystemDropDown.append('<option value="' + objSpatialReference.SpatialReferenceID + '">' + objSpatialReference.Name + '</option>');
        }
    });
}

// **************************************************************************
// FUNCTION: PopulateSelectShapesFromDropDown
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateSelectShapesFromDropDown = function PopulateSelectShapesFromDropDown(blnReloaded) {

    // Get the instance ...
    var objShapeEditor = this;

    // Check that the choose existing shape div has been populated with it's controls already
    if (objShapeEditor.ChooseExistingShapePopupDiv) {

        // Empty the select shapes from dropdown
        objShapeEditor.ChooseExistingShapeSelectShapesFromDropDown.empty();

        // Loop through all layers in current map
        objShapeEditor.MapController.ForEachLayerInCurrentMap(function (objMapLayer, objMapServiceDisplay) {

            // Gets the map service
            var objMapService = objShapeEditor.MapController.GetMapService(objMapServiceDisplay.MapServiceID);

            // Gets the map layer data which contains the geometry type of the layer
            objShapeEditor.MapController.GetMapLayerDataFromService(objMapLayer, objMapService).then(TrimbleMap.Controller.Shared.TrapException(function (objMapLayerDataFromService) {

                // When we we are to successfully get the data from the service ...
                if (objMapLayerDataFromService != null) {

                    // Converts the esri geometry type to landfolio geometry type
                    var enumLandfolioGeometryType = TrimbleMap.Shape.Shared.EsriGeometrTypeToGeometryType(objMapLayerDataFromService.GeometryType);

                    // If map layer is selectable and is the same geometry type as the asset type
                    if (objShapeEditor.Shape.GeometryType == enumLandfolioGeometryType && objMapLayer.Selectable) {
                        // Add it to the select shapes from dropdown
                        objShapeEditor.ChooseExistingShapeSelectShapesFromDropDown.append('<option value="' + objMapLayer.MapLayerID + '">' + objMapLayer.MapLayerName + '</option>');
                    }
                }
            }));
        });
    }
}

// **************************************************************************
// FUNCTION: PopulateToolsDropDown
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateToolsDropDown = function PopulateToolsDropDown() {

    // Get the instance ...
    var objShapeEditor = this;

    // Get Tool type translations
    var strClickOnShapeToolText = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ClickOnShape');
    var strDrawPolygonToolText = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DrawPolygon');

    // Add Tool types to dropdown
    objShapeEditor.ChooseExistingShapeToolDropDown.append('<option value="ChooseShapeByPoint">' + strClickOnShapeToolText + '</option>');
    objShapeEditor.ChooseExistingShapeToolDropDown.append('<option value="ChooseShapeByPolygon">' + strDrawPolygonToolText + '</option>');
}

// **************************************************************************
// FUNCTION: PopulateOfficialAreaUnitsDropDown
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateOfficialAreaUnitsDropDown = function PopulateOfficialAreaUnitsDropDown() {

    // Get the instance ...
    var objShapeEditor = this;

    // Add the an empty value ...
    objShapeEditor.OfficialAreaUnitsDropDown.append('<option value="' + SD.Guid.Shared.Empty() + '"></option>');

    // Determine whether or not we have an area unit id filter ...
    var blnHaveAreaUnitIDFilter = (typeof objShapeEditor.Options.AreaUnitIDs != 'undefined') && (objShapeEditor.Options.AreaUnitIDs != null);

    // Loop through all the area units ...
    $.each(objShapeEditor.MapController.State.AreaUnits, function (intAreaUnit, objAreaUnit) {

        // When we have no list to filter by or when it is in the filter list ...
        if ((!blnHaveAreaUnitIDFilter) || ($.inArray(objAreaUnit.ID, objShapeEditor.Options.AreaUnitIDs) > -1)) {

            // Add the unit to the drop down ...
            objShapeEditor.OfficialAreaUnitsDropDown.append('<option value="' + objAreaUnit.ID + '">' + objAreaUnit.Unit + '</option>');
        }
    });
}

// **************************************************************************
// FUNCTION: PopulateOfficialAreaUnitsDropDown
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateOfficialLengthUnitsDropDown = function PopulateOfficialLengthUnitsDropDown() {

    // Get the instance ...
    var objShapeEditor = this;

    // Add the an empty value ...
    objShapeEditor.OfficialLengthUnitsDropDown.append('<option value="' + SD.Guid.Shared.Empty() + '"></option>');

    // Determine whether or not we have a distance unit id filter ...
    var blnHaveDistanceUnitIDFilter = (typeof objShapeEditor.Options.DistanceUnitIDs != 'undefined') && (objShapeEditor.Options.DistanceUnitIDs != null);

    // Loop through all the area units ...
    $.each(objShapeEditor.MapController.State.DistanceUnits, function (intDistanceUnit, objDistanceUnit) {

        // When we have no list to filter by or when it is in the filter list ...
        if ((!blnHaveDistanceUnitIDFilter) || ($.inArray(objDistanceUnit.ID, objShapeEditor.Options.DistanceUnitIDs) > -1)) {

            // Add the unit to the drop down ...
            objShapeEditor.OfficialLengthUnitsDropDown.append('<option value="' + objDistanceUnit.ID + '">' + objDistanceUnit.Unit + '</option>');
        }
    });
}


// **************************************************************************
// FUNCTION: PopulateOfficialLength
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateOfficialLength = function PopulateOfficialLength() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the official length is to be shown ...
    if (objShapeEditor.Options.ShowOfficialLength && (objShapeEditor.OfficialLengthDiv != null)) {

        // Set the value in the textbox ...
        objShapeEditor.OfficialLengthTextBox.val(objShapeEditor.Shape.OfficialLengthText);

        // Set the unit in the drop down ...
        objShapeEditor.OfficialLengthUnitsDropDown.val(objShapeEditor.Shape.OfficialLengthUnitID);

        // Remove the shape_calculating_official_area class from the offcial length text box ...
        objShapeEditor.OfficialLengthTextBox.removeClass('shape_calculating_official_measurement');
        objShapeEditor.OfficialLengthTextBox.removeAttr('readonly');

        // Get the unit when set ...
        var objOfficialLengthUnit = (objShapeEditor.Shape.OfficialLengthUnitID != SD.Guid.Shared.Empty()) ? objShapeEditor.MapController.GetDistanceUnit(objShapeEditor.Shape.OfficialLengthUnitID) : null;

        // Set the value and unit ...
        objShapeEditor.OfficialLengthValueAndUnitSpan.text(objShapeEditor.Shape.OfficialLengthText + ' ' + ((objOfficialLengthUnit) ? objOfficialLengthUnit.Unit : ''));
    }
}

// **************************************************************************
// FUNCTION: OfficialLengthChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.OfficialLengthChanged = function OfficialLengthChanged() {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the value from the official length text box ...
    objShapeEditor.Shape.OfficialLengthText = objShapeEditor.OfficialLengthTextBox.val();

    // When it is a valid number ...
    if (SD.Number.ValidateIsNumber(objShapeEditor.Shape.OfficialLengthText, objShapeEditor.MapController.State.GroupSeparator, objShapeEditor.MapController.State.DecimalSeparator, false)) {

        // Set the official are of the shape (set to NULL_NUMBER when no value) ...
        objShapeEditor.Shape.OfficialLength = ((objShapeEditor.Shape.OfficialLengthText).trim() == '') ? SD.Number.NULL_NUMBER : SD.Number.ToNumber(objShapeEditor.Shape.OfficialLengthText, objShapeEditor.MapController.State.GroupSeparator, objShapeEditor.MapController.State.DecimalSeparator);

    } else {

        // Set to number ...
        objShapeEditor.Shape.OfficialLength = SD.Number.NULL_NUMBER;
    }

    // Populate the official length to update OfficialLengthValueAndUnitSpan as well ...
    objShapeEditor.PopulateOfficialLength();
}

// **************************************************************************
// FUNCTION: OfficialLengthUnitChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.OfficialLengthUnitChanged = function OfficialLengthUnitChanged() {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the official length unit ID on the shape ...
    objShapeEditor.Shape.OfficialLengthUnitID = objShapeEditor.GetSelectedOfficialLengthUnit();

    // Populate the official length to update OfficialLengthValueAndUnitSpan as well ...
    objShapeEditor.PopulateOfficialLength();
}

// **************************************************************************
// FUNCTION: GetSelectedOfficialLengthUnit
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetSelectedOfficialLengthUnit = function GetSelectedOfficialLengthUnit() {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the selected official length unit value ...
    var strSelectedOfficialLengthUnitID = objShapeEditor.OfficialLengthUnitsDropDown.val();

    // Return it ...
    return strSelectedOfficialLengthUnitID;
}

// **************************************************************************
// FUNCTION: SetOfficialLengthToCalculatedLength
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.SetOfficialLengthToCalculatedLength = function SetOfficialLengthToCalculatedLength() {

    // Get the instance ...
    var objShapeEditor = this;

    // Calculating Length
    var strCalculationInProgress = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatingLength') + ' ...';

    // Display "Calculating Length ..." in the offcial Length textbox ...
    objShapeEditor.OfficialLengthTextBox.val(strCalculationInProgress);

    // Add the shape_calculating_official_Length class to the offcial Length text box ...
    objShapeEditor.OfficialLengthTextBox.addClass('shape_calculating_official_measurement');
    objShapeEditor.OfficialLengthTextBox.attr('readonly', 'readonly');

    // Get the selected official Length unit id ...
    var strLengthUnitID = objShapeEditor.GetSelectedOfficialLengthUnit();

    // When not set ...
    if (strLengthUnitID == SD.Guid.Shared.Empty()) {

        // Get the selected calculated Length unit id ...
        strLengthUnitID = objShapeEditor.DisplayLength.DistanceUnits[objShapeEditor.DisplayLength.DistanceUnit].ID;

        // Determine whether or not we have the unit in the drop down list ...
        var blnHaveUnitInDropdownList = objShapeEditor.HasUnitInOfficialLengthUnitDropDown(strLengthUnitID);

        // If we do not have it in the drop down list ...
        if (!blnHaveUnitInDropdownList) {

            // Determine whether or not we have the default Length unit in the drop down list, if we do ...
            if (objShapeEditor.HasUnitInOfficialLengthUnitDropDown(objShapeEditor.Options.DefaultLengthUnitID)) {

                // Set to use it ...
                strLengthUnitID = objShapeEditor.Options.DefaultLengthUnitID;

            } else {

                // Set to use the first unit that is in the drop down ...
                strLengthUnitID = $(objShapeEditor.OfficialLengthUnitsDropDown.find('option')[1]).val();
            }
        }
    }

    // Set the official Length unit ID on the shape ...
    objShapeEditor.Shape.OfficialLengthUnitID = strLengthUnitID;

    // Get the official Length unit object ...
    var objLengthUnit = objShapeEditor.MapController.GetDistanceUnit(objShapeEditor.Shape.OfficialLengthUnitID);

    // Get the edited coordinates to replace ...
    var dicCoordinatesToReplace = objShapeEditor.GetEditedCoordinatesToReplace();

    // Perform the Length calculation and update ... 
    objShapeEditor.Shape.CalculateDistanceKm(objShapeEditor.MapController, dicCoordinatesToReplace).then(TrimbleMap.Controller.Shared.TrapException(function (objLength) {

        // Get the calculated Length, use 0 when the Length could not be calculated ...
        var decLengthInKm = (objLength != null) ? objLength.DistanceInKm : 0;

        // Convert the Length value to the unit and round it to the number of decimal places and set it on the shape ...
        objShapeEditor.Shape.OfficialLength = SD.Number.RoundTo(decLengthInKm / objLengthUnit.ConversionFactorToKm, objLengthUnit.DecimalPlaces);

        // Set the text ...
        objShapeEditor.Shape.OfficialLengthText = SD.DisplayValue.FromDouble(objShapeEditor.Shape.OfficialLength,
            objShapeEditor.MapController.State.GroupSeparator,
            objShapeEditor.MapController.State.DecimalSeparator,
            objLengthUnit.DecimalPlaces);

        // Populate the official Length ...
        objShapeEditor.PopulateOfficialLength();
    }));
}

// **************************************************************************
// FUNCTION: HasUnitInOfficialLengthUnitDropDown
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.HasUnitInOfficialLengthUnitDropDown = function HasUnitInOfficialLengthUnitDropDown(strLengthUnitID) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the instance ...
    var blnHasUnitInOfficialLengthUnitDropDown = (objShapeEditor.OfficialLengthUnitsDropDown.find('option[value=' + strLengthUnitID + ']').length > 0);

    // Return it ...
    return blnHasUnitInOfficialLengthUnitDropDown;
}

// **************************************************************************
// FUNCTION: PopulateOfficialArea
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.PopulateOfficialArea = function PopulateOfficialArea() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the official area is to be shown ...
    if (objShapeEditor.Options.ShowOfficialArea && (objShapeEditor.OfficialAreaDiv != null)) {

        // Set the value in the textbox ...
        objShapeEditor.OfficialAreaTextBox.val(objShapeEditor.Shape.OfficialAreaText);

        // Set the unit in the drop down ...
        objShapeEditor.OfficialAreaUnitsDropDown.val(objShapeEditor.Shape.OfficialAreaUnitID);

        // Remove the shape_calculating_official_area class from the offcial area text box ...
        objShapeEditor.OfficialAreaTextBox.removeClass('shape_calculating_official_measurement');
        objShapeEditor.OfficialAreaTextBox.removeAttr('readonly');

        // Get the unit when set ...
        var objOfficialAreaUnit = (objShapeEditor.Shape.OfficialAreaUnitID != SD.Guid.Shared.Empty()) ? objShapeEditor.MapController.GetAreaUnit(objShapeEditor.Shape.OfficialAreaUnitID) : null;

        // Set the value and unit ...
        if (objShapeEditor.Shape.OfficialAreaText.length > 0) {
            objShapeEditor.OfficialAreaValueAndUnitSpan.text(objShapeEditor.Shape.OfficialAreaText + ' ' + ((objOfficialAreaUnit) ? objOfficialAreaUnit.Unit : ''));
        }

    }
}

// **************************************************************************
// FUNCTION: OfficialAreaChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.OfficialAreaChanged = function OfficialAreaChanged() {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the value from the official area text box ...
    objShapeEditor.Shape.OfficialAreaText = objShapeEditor.OfficialAreaTextBox.val();

    // When it is a valid number ...
    if (SD.Number.ValidateIsNumber(objShapeEditor.Shape.OfficialAreaText, objShapeEditor.MapController.State.GroupSeparator, objShapeEditor.MapController.State.DecimalSeparator, false)) {

        // Set the official are of the shape (set to NULL_NUMBER when no value) ...
        objShapeEditor.Shape.OfficialArea = ((objShapeEditor.Shape.OfficialAreaText).trim() == '') ? SD.Number.NULL_NUMBER : SD.Number.ToNumber(objShapeEditor.Shape.OfficialAreaText, objShapeEditor.MapController.State.GroupSeparator, objShapeEditor.MapController.State.DecimalSeparator);

    } else {

        // Set to number ...
        objShapeEditor.Shape.OfficialArea = SD.Number.NULL_NUMBER;
    }

    // Populate the official area to update OfficialAreaValueAndUnitSpan as well ...
    objShapeEditor.PopulateOfficialArea();
}

// **************************************************************************
// FUNCTION: OfficialAreaUnitChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.OfficialAreaUnitChanged = function OfficialAreaUnitChanged() {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the official area unit ID on the shape ...
    objShapeEditor.Shape.OfficialAreaUnitID = objShapeEditor.GetSelectedOfficialAreaUnit();

    // Populate the official area to update OfficialAreaValueAndUnitSpan as well ...
    objShapeEditor.PopulateOfficialArea();
}

// **************************************************************************
// FUNCTION: SetOfficialAreaToCalculatedArea
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.SetOfficialAreaToCalculatedArea = function SetOfficialAreaToCalculatedArea() {

    // Get the instance ...
    var objShapeEditor = this;

    // Calculating Area
    var strCalculationInProgress = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatingArea') + ' ...';

    // Display "Calculating Area ..." in the offcial area textbox ...
    objShapeEditor.OfficialAreaTextBox.val(strCalculationInProgress);

    // Add the shape_calculating_official_area class to the offcial area text box ...
    objShapeEditor.OfficialAreaTextBox.addClass('shape_calculating_official_measurement');
    objShapeEditor.OfficialAreaTextBox.attr('readonly', 'readonly');

    // Get the selected official area unit id ...
    var strAreaUnitID = objShapeEditor.GetSelectedOfficialAreaUnit();

    // When not set ...
    if (strAreaUnitID == SD.Guid.Shared.Empty()) {

        // Get the selected calculated area unit id ...
        strAreaUnitID = objShapeEditor.DisplayArea.AreaUnits[objShapeEditor.DisplayArea.AreaUnit].ID;

        // Determine whether or not we have the unit in the drop down list ...
        var blnHaveUnitInDropdownList = objShapeEditor.HasUnitInOfficialAreaUnitDropDown(strAreaUnitID);

        // If we do not have it in the drop down list ...
        if (!blnHaveUnitInDropdownList) {

            // Determine whether or not we have the default area unit in the drop down list, if we do ...
            if (objShapeEditor.HasUnitInOfficialAreaUnitDropDown(objShapeEditor.Options.DefaultAreaUnitID)) {

                // Set to use it ...
                strAreaUnitID = objShapeEditor.Options.DefaultAreaUnitID;

            } else {

                // Set to use the first unit that is in the drop down ...
                strAreaUnitID = $(objShapeEditor.OfficialAreaUnitsDropDown.find('option')[1]).val();
            }
        }
    }

    // Set the official area unit ID on the shape ...
    objShapeEditor.Shape.OfficialAreaUnitID = strAreaUnitID;

    // Get the official area unit object ...
    var objAreaUnit = objShapeEditor.MapController.GetAreaUnit(objShapeEditor.Shape.OfficialAreaUnitID);

    // Get the edited coordinates to replace ...
    var dicCoordinatesToReplace = objShapeEditor.GetEditedCoordinatesToReplace();

    // Perform the area calculation and update ... 
    objShapeEditor.Shape.CalculateAreaSquareKm(objShapeEditor.MapController, dicCoordinatesToReplace).then(TrimbleMap.Controller.Shared.TrapException(function (objArea) {

        // Get the calculated area, use 0 when the area could not be calculated ...
        var dblAreaValue = (objArea != null && objAreaUnit.SpatialReferenceType.toUpperCase() == TrimbleMap.enumSpatialReferenceType.PROJECTED) ? objArea.AreaInKm2 / objAreaUnit.ConversionFactorToKm2 : (objArea != null ? objArea.AreaInDegrees2 / objAreaUnit.ConversionFactorToSquareDegrees : 0);

        // Convert the area value to the unit and round it to the number of decimal places and set it on the shape ...
        objShapeEditor.Shape.OfficialArea = SD.Number.RoundTo(dblAreaValue, objAreaUnit.DecimalPlaces);

        // Set the text ...
        objShapeEditor.Shape.OfficialAreaText = SD.DisplayValue.FromDouble(objShapeEditor.Shape.OfficialArea,
            objShapeEditor.MapController.State.GroupSeparator,
            objShapeEditor.MapController.State.DecimalSeparator,
            objAreaUnit.DecimalPlaces);

        // Populate the official area ...
        objShapeEditor.PopulateOfficialArea();
    }));
}

// **************************************************************************
// FUNCTION: GetSelectedOfficialAreaUnit
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetSelectedOfficialAreaUnit = function GetSelectedOfficialAreaUnit() {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the selected official area unit value ...
    var strSelectedOfficialAreaUnitID = objShapeEditor.OfficialAreaUnitsDropDown.val();

    // Return it ...
    return strSelectedOfficialAreaUnitID;
}

// **************************************************************************
// FUNCTION: HasUnitInOfficialAreaUnitDropDown
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.HasUnitInOfficialAreaUnitDropDown = function HasUnitInOfficialAreaUnitDropDown(strAreaUnitID) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the instance ...
    var blnHasUnitInOfficialAreaUnitDropDown = (objShapeEditor.OfficialAreaUnitsDropDown.find('option[value=' + strAreaUnitID + ']').length > 0);

    // Return it ...
    return blnHasUnitInOfficialAreaUnitDropDown;
}

// **************************************************************************
// FUNCTION: CreateShapePartsDivElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateShapePartsDivElements = function CreateShapePartsDivElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the div for the parts list ...
    objShapeEditor.ShapePartsDiv = $('<div class="shape-container"></div>');

    // Create the heading and icon span ...
    var objHeadingAndIconDiv = $('<div class="shape-part">');

    // Add it to the parts div ...
    objShapeEditor.ShapePartsDiv.append(objHeadingAndIconDiv);

    // When editable and the parts are required ...
    if (objShapeEditor.CoordinatesEditable && objShapeEditor.Options.PartsRequired) {

        // Create and add the asterisk to indicate that it's required ...
        objHeadingAndIconDiv.append(TrimbleMap.ShapeEditor.Shared.CreateRequiredAsterisk());
    }

    objShapeEditor.ShapePartDropDown = $('<select class="part-dropdown"></select>');

    // Get the heading, either "Parts" or "Points" translation ...

    //Points
    var strPartsHeading = (objShapeEditor.Shape.GeometryType === TrimbleMap.Shape.enumGeometryType.POINT) ? SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Points') : SD.Translation.Shared.GetTranslation('Map.Shape.js', 'ShapePartsSubHeader');

    // Create and add the "Parts" span ...
    objHeadingAndIconDiv.append('<span>' + strPartsHeading + '</span>');

    //append the part dropdown
    objHeadingAndIconDiv.append(objShapeEditor.ShapePartDropDown);

    // Get the add part translation (either "Add new part" or "Add new point") ...
    // Add new point
    var strAddPartText = (objShapeEditor.Shape.GeometryType === TrimbleMap.Shape.enumGeometryType.POINT) ? SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddNewPoint') : SD.Translation.Shared.GetTranslation('Map.Shape.js', 'AddNewPart');

    objHeadingAndIconDiv.append('<span class="add-icon" AddPartIcon="true" title="' + strAddPartText + '"></span>');

    // Creates the Hamburger menu that allows various functionality to be done on a shape part
    objShapeEditor.CreateShapePartsHamburgerMenu(objHeadingAndIconDiv);

    // When we have validation messages for the parts ...
    if (objShapeEditor.HasValidationMessagesFor(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.ShapeCoordinates)) {

        // Create and add a validation message icon ...
        objHeadingAndIconDiv.append(TrimbleMap.ShapeEditor.Shared.CreateValidationMessageIcon(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.ShapeCoordinates));
    }

    // Get the translation for the no parts message ...

    // The shape has no points
    // The shape has no parts 
    var strNoPartsMessageLine1 = (objShapeEditor.Shape.GeometryType === TrimbleMap.Shape.enumGeometryType.POINT) ? SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ShapeHasNoPoints') + '.' : SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ShapeHasNoParts');

    // Click the add new point icon to add a point
    // Click the add part icon or use the tools above to define the shape
    var strNoPartsMessageLine2 = (objShapeEditor.Shape.GeometryType === TrimbleMap.Shape.enumGeometryType.POINT) ? SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddNewPointText') : SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddNewPartText');

    // Create the no parts message div ...
    objShapeEditor.NoPartsMessageDiv = $('<div class="no-message"><span>' + strNoPartsMessageLine1 + '</span></div>');

    // When editable ...
    if (objShapeEditor.CoordinatesEditable) {

        // Add instructions on how to add a part ...
        objShapeEditor.NoPartsMessageDiv.append('<br / ><span>' + strNoPartsMessageLine2 + '</span>')
    }

    // Add it to the shape parts div ...
    objShapeEditor.ShapePartsDiv.append(objShapeEditor.NoPartsMessageDiv);

    // Create a div to in which the parts list will scroll (if needed) ...
    objShapeEditor.PartsItemsScrollDiv = $('<div class="part-items-scroll"></div>');

    // Add it to the shape parts div ...
    objShapeEditor.ShapePartsDiv.append(objShapeEditor.PartsItemsScrollDiv);

    // Create a div to contain the parts ...
    objShapeEditor.PartsItemsDiv = $('<div></div>');

    // Add it to the parts scroll div ...
    objShapeEditor.PartsItemsScrollDiv.append(objShapeEditor.PartsItemsDiv);

    // Create an empty marker div 
    objShapeEditor.ShapePartDetailsTopMarkerDiv = $('<div>');

    // Add it to ShapePartsDiv ...
    objShapeEditor.ShapePartsDiv.append(objShapeEditor.ShapePartDetailsTopMarkerDiv);

    // Create and add the shape part coordinates div ...
    objShapeEditor.ShapePartsDiv.append(objShapeEditor.CreateShapePartDetailsDivElements());

    // Update the "no parts" display visiblity ...
    objShapeEditor.UpdateNoPartsDisplayVisibility();

    // Return the created div ...
    return objShapeEditor.ShapePartsDiv;
}

// **************************************************************************
// FUNCTION: CreateShapePartsHamburgerMenu
// USAGE:    Creates the Hamburger menu which gives a user functionality such as renaming, deleting and zooming to a part etc.
// **************************************************************************
TrimbleMap.ShapeEditor.CreateShapePartsHamburgerMenu = function CreateShapePartsHamburgerMenu(objHeadingAndIconDiv) {
    // Get the instance
    var objShapeEditor = this;

    // Create the hamburger menu icon ...
    objShapeEditor.EditPartHamburgerMenuIcon = $('<div class="part-menu"></div>');

    // Append the hamburger menu icon to the heading div
    objHeadingAndIconDiv.append(objShapeEditor.EditPartHamburgerMenuIcon);

    // Create the hamburger popup menu
    objShapeEditor.EditPartHamburgerMenu = SD.PopupMenu.CreateInstance(objShapeEditor.EditPartHamburgerMenuIcon,
        'popup-downwards',
        'popup-upwards',
        'popup-downwards-open',
        'popup-upwards-open',
        5,
        true,
        SD.Popup.enumPopupBehaviour.DownOrUpBasedOnSpaceAvailable,
        function () { });

    var blnReadOnly = !objShapeEditor.CoordinatesEditable;

    // Menu Items to be displayed when hovering over burger menu
    // null is added as a value to the list in order to add a group separator (line) between the top menu items and the bottom menu items in the list
    var arrMenuItems = [
        { Type: 'Normal', Text: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'RenamePart'), ReadOnly: blnReadOnly, Handler: objShapeEditor.ShapePartRenameClickedProxy, ToolTipWhenDisabled: SD.Translation.Shared.GetTranslation("SD.PopupMenu.js", "MenuItemDisabled") },
        { Type: 'Normal', Text: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DeletePart'), ReadOnly: blnReadOnly, Handler: objShapeEditor.ShapePartDeleteClickedProxy, ToolTipWhenDisabled: SD.Translation.Shared.GetTranslation("SD.PopupMenu.js", "MenuItemDisabled") },
        { Type: 'Normal', Text: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddExclusion'), ReadOnly: true, Handler: objShapeEditor.ShapePartAddExclusionClickedProxy, ToolTipWhenDisabled: SD.Translation.Shared.GetTranslation("SD.PopupMenu.js", "MenuItemCoordinateModeDisabled") },
        { Type: 'Normal', Text: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ZoomToPart'), ReadOnly: false, Handler: objShapeEditor.ShapePartZoomClickedProxy, ToolTipWhenDisabled: SD.Translation.Shared.GetTranslation("SD.PopupMenu.js", "MenuItemDisabled") },
        { Type: 'GroupSeparator' }
    ];

    // Get the spatial reference information of the shape ...
    var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);
    var blnGeographicSpatialReferenceType = objSpatialReference.SpatialReferenceType === TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC;

    var enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID);

    arrMenuItems.push({ Type: 'Check', Text: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DegMinSec'), ReadOnly: !blnGeographicSpatialReferenceType, Handler: objShapeEditor.GeographicFormatSelectorClickedProxy, ToolTipWhenDisabled: SD.Translation.Shared.GetTranslation("Map.ShapeEditor.js", "DisabledDMSAndDD"), Checked: objShapeEditor.GetCheckedStatus(enCoordinateFormat, TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) });
    arrMenuItems.push({ Type: 'Check', Text: SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DecimalDeg'), ReadOnly: !blnGeographicSpatialReferenceType, Handler: objShapeEditor.GeographicFormatSelectorClickedProxy, ToolTipWhenDisabled: SD.Translation.Shared.GetTranslation("Map.ShapeEditor.js", "DisabledDMSAndDD"), Checked: objShapeEditor.GetCheckedStatus(enCoordinateFormat, TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD) });

    // Add the menu items

    for (var intMenuItemIndex = 0; intMenuItemIndex < arrMenuItems.length; intMenuItemIndex++) {
        var objMenuItem = arrMenuItems[intMenuItemIndex];

        // Create menu item if set, otherwise create a group separator
        if (objMenuItem.Type === 'Normal') {
            objShapeEditor.EditPartHamburgerMenu.AddMenuItem(SD.PopupMenu.Shared.CreateMenuItem(objMenuItem.Text, objMenuItem.Text, objMenuItem.Handler, objMenuItem.ReadOnly, objMenuItem.ToolTipWhenDisabled));
        } else if (objMenuItem.Type === 'GroupSeparator') {
            objShapeEditor.EditPartHamburgerMenu.AddMenuItem(SD.PopupMenu.Shared.CreateGroupSeparator());
        } else if (objMenuItem.Type === 'Check') {
            objShapeEditor.EditPartHamburgerMenu.AddMenuItem(SD.PopupMenu.Shared.CreateCheckMenuItem(objMenuItem.Text, objMenuItem.Text, objMenuItem.Handler, objMenuItem.ReadOnly, objMenuItem.ToolTipWhenDisabled, objMenuItem.Checked));
        }
    }

}

// **************************************************************************
// FUNCTION: GetCheckedStatus
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetCheckedStatus = function GetCheckedStatus(enCoordinateFormat, strGeographicType) {

    var blnChecked = false;

    if (enCoordinateFormat === strGeographicType) {
        blnChecked = true;
    }

    return blnChecked;
}

// **************************************************************************
// FUNCTION: ToggleAddExclusionMenuItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ToggleAddExclusionMenuItem = function ToggleAddExclusionMenuItem() {

    // Get the instance
    var objShapeEditor = this;

    if (objShapeEditor.EditingCoordinateMode) {

        if ((!objShapeEditor.AddingExclusion) && (objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart)) && (objShapeEditor.Shape.Parts.length > 0) && (objShapeEditor.Shape.GeometryType === TrimbleMap.Shape.enumGeometryType.POLYGON || objShapeEditor.Shape.GeometryType === TrimbleMap.Shape.enumGeometryType.MIXED)) {
            objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddExclusion'), true);
        } else {
            objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddExclusion'), false);
        }

    } else {
        objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddExclusion'), false);
    }

}

// **************************************************************************
// FUNCTION: EnableCheckMenuItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.EnableCheckMenuItem = function EnableCheckMenuItem() {
    // Get the instance
    var objShapeEditor = this;

    if (objShapeEditor.CoordinateListEditor !== null) {

        if (objShapeEditor.CoordinateListEditor.CoordinateFormat === TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DD) {
            objShapeEditor.EditPartHamburgerMenu.EnableMenuItemChecked(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DecimalDeg'), true);
            objShapeEditor.EditPartHamburgerMenu.EnableMenuItemChecked(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DegMinSec'), false);
        } else if (objShapeEditor.CoordinateListEditor.CoordinateFormat === TrimbleMap.CoordinateListEditor.enumCoordinateFormat.GEOGRAPHIC_DMS) {
            objShapeEditor.EditPartHamburgerMenu.EnableMenuItemChecked(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DegMinSec'), true);
            objShapeEditor.EditPartHamburgerMenu.EnableMenuItemChecked(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DecimalDeg'), false);
        } else {
            objShapeEditor.EditPartHamburgerMenu.EnableMenuItemChecked(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DegMinSec'), false);
            objShapeEditor.EditPartHamburgerMenu.EnableMenuItemChecked(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DecimalDeg'), false);
        }
    }

}


// **************************************************************************
// FUNCTION: ShapePartDetailsDivFocusOut
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GeographicFormatSelectorClicked = function GeographicFormatSelectorClicked(event) {
    // Get the instance
    var objShapeEditor = this;

    objShapeEditor.CoordinateListEditor.GeographicFormatSelectorClicked(event);

    objShapeEditor.EnableCheckMenuItem();

}

// **************************************************************************
// FUNCTION: CreateRenameDialog
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateRenameDialog = function CreateRenameDialog() {

    // Get the instance
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    if (objShapeEditor.RenameShapePartDialogDiv === null) {

        objShapeEditor.RenameShapePartDialogDiv = $('<div style="width: 330px; height: 70px;"></div>');

        var strShapePartTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ShapePart');

        var strOK = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Ok');

        var strCancel = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Cancel');

        // Create the content table ...
        var objContentTable = $('<table cellspacing="0" cellpadding="0" border="0" style="width: 100%;height: 100%;"></table>');

        // Add a row ...
        objContentTable.append('<tr><td><span>' + strShapePartTranslation + ':</span></td><td RenamePartTextboxCell></td></tr>');

        objContentTable.append('<tr><td colspan="2" ValidationCell></td></tr><tr><td ButtonCell colspan="2"></td></tr>');

        // Add the button to the dialog ...
        var strCancelButton = '<button CancelButton="true" type="button" class="Button pull-right" style="margin-inline-start:5px;margin-block-end:5px">' + strCancel + '</button>';
        var strOkButton = '<button OKButton="true" type="button" class="Button pull-right" style="margin-inline-start:10px;">' + strOK + '</button>';

        // Add it to the div ...
        objShapeEditor.RenameShapePartDialogDiv.append(objContentTable);

        // Create the rename part text box ...
        if (objShapeEditor.RenameShapePartTextBox === null) {
            objShapeEditor.RenameShapePartTextBox = $('<input type="text" class="shape_editing_part_name_textbox"></input>');
        }

        // Add it to the Rename Part Textbox Cell ...
        objContentTable.find('[RenamePartTextboxCell]').append(objShapeEditor.RenameShapePartTextBox);

        objContentTable.find('[ButtonCell]').append(strCancelButton + strOkButton);

        // Resolve the deferred ...
        objDeferred.resolve();

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    return objDeferred;
}


// **************************************************************************
// FUNCTION: ShowRenameShapePartDialog
// USAGE:    
// **************************************************************************

TrimbleMap.ShapeEditor.ShowRenameShapePartDialog = function ShowRenameShapePartDialog(fnOkClicked, fnCancelClicked) {

    // Get the instance
    var objShapeEditor = this;

    // Create the dialog when it does not exist ...
    var objCreateDialogDeferred = objShapeEditor.CreateRenameDialog();

    // When the dialog has been created ...
    objCreateDialogDeferred.then(function () {

        var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'RenameShapePart');

        // Get the next dialog id ...
        var objDialogID = TrimbleMap.ModalDialog.Shared.NextDialogID();

        objShapeEditor.RenameShapePartTextBox.val(objShapeEditor.SelectedPart.PartName);

        // Clear any validation
        objShapeEditor.RenameShapePartDialogDiv.find('[ValidationCell]').find('span').remove();

        // Show the dialog ...
        TrimbleMap.ModalDialog.Shared.OpenDialog(objShapeEditor.RenameShapePartDialogDiv, strTitle, true, objDialogID);

        // Create the close dialog function ...
        var fnCloseDialog = function () {

            // Remove the click handler ...
            objShapeEditor.RenameShapePartDialogDiv.off('click', fnDialogClicked);

            // Close the modal dialog ...
            TrimbleMap.ModalDialog.Shared.CloseDialog(objDialogID);
        }

        // Create the dialog clicked function ...
        var fnDialogClicked = function (e) {

            // Get the target that the user clicked on ...
            var objTarget = $(e.target);

            // Determine if the user clciked on the OK or cancel button ...
            var objOKButton = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'OKButton');
            var objCancelButton = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'CancelButton');

            let objReturn = {
                Valid: true,
                InvalidReason: ''
            };

            // Depending on the button clicked on (if any) ...
            switch (true) {
                case (objOKButton !== null):

                    objReturn = objShapeEditor.ValidatePartDetails();

                    if (objReturn.Valid) {
                        objShapeEditor.SelectedPart.PartName = objShapeEditor.RenameShapePartTextBox.val();
                        objShapeEditor.UpdatePartNameOnInterface(objShapeEditor.SelectedPart);
                        fnCloseDialog();
                    } else {
                        objShapeEditor.RenameShapePartDialogDiv.find('[ValidationCell]').find('span').remove();
                        objShapeEditor.RenameShapePartDialogDiv.find('[ValidationCell]').append('<span class="ValidationMessageList">' + objReturn.InvalidReason + '</span>');
                        objShapeEditor.SelectedPartOrReferencePointValid = true;
                    }
                    break;
                case (objCancelButton !== null):
                    // Close the dialog ...
                    fnCloseDialog();
                    break;
            }
        }

        // Attach a click event handler to the dialog button ... 
        objShapeEditor.RenameShapePartDialogDiv.on('click', (fnDialogClicked));
    });
}

// **************************************************************************
// FUNCTION: ShapePartDetailsDivFocusOut
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ShapePartDetailsDivFocusOut = function ShapePartDetailsDivFocusOut() {
    let objShapeEditor = this;

    if (objShapeEditor.EditingCoordinateMode) {
        objShapeEditor.AcceptChanges();

        let blnValidationResult = objShapeEditor.ValidatePartDetails();

        if (blnValidationResult.Valid) {
            if (objShapeEditor.AddingNewPart) {
                objShapeEditor.AddingNewPart = false;
            }

            objShapeEditor.ToggleEditFocus(false);
        }
        else {
            objShapeEditor.ToggleEditFocus(true);
        }
    }
}

// **************************************************************************
// FUNCTION: ShapePartDetailsDivFocusOut
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ReferencePointDivFocusOut = function ReferencePointDivFocusOut() {
    let objShapeEditor = this;

    if (objShapeEditor.EditingReferencePoint) {
        objShapeEditor.AcceptChanges();

        let blnValidationResult = objShapeEditor.ValidateReferencePointDetails();

        if (blnValidationResult.Valid) {
            objShapeEditor.ToggleEditFocus(false);
        }
        else {
            objShapeEditor.ToggleEditFocus(true);
        }
    }
}
// **************************************************************************
// FUNCTION: CreateDynamicShapeNotShownMessageDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateDynamicShapeNotShownMessageDiv = function CreateDynamicShapeNotShownMessageDiv() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the dynamic shape option is to be shown ...
    if (objShapeEditor.Options.ShowDynamicShape) {

        // Get the translation for the shape not shown message ...

        // Derived shapes can only be viewed when not in edit mode.<br />Configure the derived shape options and click save to view the shape
        var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ViewDerivedShapeEditMode') + '.';

        // Create the div for the message ...
        objShapeEditor.DynamicShapeNotShownMessageDiv = $('<div class="shape-container p-10"><span class="message-text">' + strMessage + '</span></div>');
    }

    // Return the created div ...
    return objShapeEditor.DynamicShapeNotShownMessageDiv;
}

// **************************************************************************
// FUNCTION: UpdateNoPartsDisplayVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateNoPartsDisplayVisibility = function UpdateNoPartsDisplayVisibility() {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have parts ...
    if (objShapeEditor.Shape.Parts.length > 0) {

        // Show the parts item div and hide the "no parts" message ...
        objShapeEditor.PartsItemsDiv.show();
        objShapeEditor.NoPartsMessageDiv.hide();

    } else {

        // Hide the parts item div and show the "no parts" message ...
        objShapeEditor.PartsItemsDiv.hide();
        objShapeEditor.NoPartsMessageDiv.show();
    }
}

// **************************************************************************
// FUNCTION: CreateReferencePointsDivElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateReferencePointsDivElements = function CreateReferencePointsDivElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the reference points div ...
    objShapeEditor.ReferencePointsDiv = $('<div class="shape-container"></div>');

    // Create the heading and icon div ...
    var objHeadingAndIconDiv = $('<div class="shape-references p-10"></div>');

    // Add it to the reference points parts div ...
    objShapeEditor.ReferencePointsDiv.append(objHeadingAndIconDiv);

    // Get the translations ...

    // Reference Points
    var strReferencePoints = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ReferencePoints') + ':';

    // Add Reference Point
    var strAddReferencePointToolTip = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddReferencePoints');

    // Create and add the "Parts" span ...
    objHeadingAndIconDiv.append('<span>' + strReferencePoints + '</span>');

    // Create the validation message icon ...
    objShapeEditor.ReferencePointValidationMessagesIcon = TrimbleMap.ShapeEditor.Shared.CreateValidationMessageIcon(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.ReferencePoints);

    // Add the validation message icon ...
    objHeadingAndIconDiv.append(objShapeEditor.ReferencePointValidationMessageIcon);

    // Create the reference point icon div ...
    objShapeEditor.NewReferencePointIconDiv = $('<div class="add-icon" AddReferencePointIcon="true" title="' + strAddReferencePointToolTip + '"></div>');

    let objAddIconDiv = $('<div>').attr({
        'AddReferencePointIcon': 'true',
        'title': strAddReferencePointToolTip
    });

    if (objShapeEditor.EditingReferencePoint) {
        objAddIconDiv.addClass('add-icon-edit');
    } else {
        objAddIconDiv.addClass('add-icon');
    }

    objShapeEditor.NewReferencePointIconDiv = objAddIconDiv;

    // Add it to the heading ...
    objHeadingAndIconDiv.append(objShapeEditor.NewReferencePointIconDiv);

    // Create the new reference point popup div ...
    objShapeEditor.CreateNewReferencePointPopup();

    // Get the translation for the no parts message ....

    // This shape has no reference points
    var strNoRefencePointsMessageLine1 = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ShapeHasNoReferencePoints') + '.';

    // Click the add reference points icon to add a reference point
    var strNoRefencePointsMessageLine2 = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'AddReferencePointIcon') + '.';

    // Create the no reference points message div ...
    objShapeEditor.NoReferencePointsMessageDiv = $('<div class="no-message"><span>' + strNoRefencePointsMessageLine1 + '</span></div>');

    if (objShapeEditor.CoordinatesEditable) {

        objShapeEditor.NoReferencePointsMessageDiv.append('<br / ><span>' + strNoRefencePointsMessageLine2 + '</span>')
    }

    // Create a div to contain the reference point items ...
    objShapeEditor.ReferencePointsItemsDiv = $('<div class="reference-point-items"></div>');

    // Add it to the reference points div ...
    objShapeEditor.ReferencePointsDiv.append(objShapeEditor.NoReferencePointsMessageDiv);

    objShapeEditor.ReferencePointsDiv.append(objShapeEditor.ReferencePointsItemsDiv);

    // Create and add the reference point coordinate div elements ...
    objShapeEditor.ReferencePointsDiv.append(objShapeEditor.CreateReferencePointCoordinateDivElements());

    return objShapeEditor.ReferencePointsDiv;
}

// **************************************************************************
// FUNCTION: CreateNewReferencePointPopup
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateNewReferencePointPopup = function CreateNewReferencePointPopup() {

    // Get the instance ...
    var objShapeEditor = this;

    // When editable ...
    if (objShapeEditor.CoordinatesEditable) {

        // Create the operation popup control ...
        objShapeEditor.NewReferencePointPopup = SD.Popup.CreateInstance(objShapeEditor.NewReferencePointIconDiv,
            'popup-downwards',
            'popup-upwards',
            'popup-downwards-open',
            'popup-upwards-open',
            5,
            false,
            SD.Popup.enumPopupBehaviour.AlwaysDown,
            objShapeEditor.ActivateNewReferencePointPopupProxy,
            objShapeEditor.DeActivateNewReferencePointPopupProxy);
    }
}

// **************************************************************************
// FUNCTION: ActivateNewReferencePointPopup
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateNewReferencePointPopup = function ActivateNewReferencePointPopup(objPopupContainerDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the re-projection popup div ...
    objShapeEditor.CreateNewReferencePointPopupDiv();

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objShapeEditor.NewReferencePointPopupDiv);

    // Attach the click event handler ...
    objShapeEditor.NewReferencePointPopupDiv.on('click', (objShapeEditor.NewReferencePointPopupClickedProxy));
}

// **************************************************************************
// FUNCTION: DeActivateNewReferencePointPopup
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateNewReferencePointPopup = function DeActivateNewReferencePointPopup() {

    // Get the instance ...
    var objShapeEditor = this;

    // Detach the click event handler ...
    objShapeEditor.NewReferencePointPopupDiv.off('click', objShapeEditor.NewReferencePointPopupClickedProxy);
}

// **************************************************************************
// FUNCTION: CreateNewReferencePointPopupDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateNewReferencePointPopupDiv = function CreateNewReferencePointPopupDiv() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the div to popup ...
    objShapeEditor.NewReferencePointPopupDiv = $('<div class="popup-references"></div>');

    // Add the span ...
    objShapeEditor.NewReferencePointPopupDiv.append('<div class="bold"><span>Reference Point Type:</span></div>');

    // Create the reference point type list div ...
    objShapeEditor.NewReferencePointTypeListDiv = $('<div class="reprojection-list"></div>');

    // Add it to the div ...
    objShapeEditor.NewReferencePointPopupDiv.append(objShapeEditor.NewReferencePointTypeListDiv);

    // Get the reference points that has no values ...
    var arrReferencePointsWithoutValues = objShapeEditor.Shape.ReferencePointsWithoutValues();

    // Loop through all the reference points without values ...
    $.each(arrReferencePointsWithoutValues, function (intReferencePoint, objReferencePoint) {

        // Create a div for the list item ...
        var objItemDiv = $('<div class="reprojection-item" ReferencePointID="' + objReferencePoint.ID + '"></div>');

        // Add it to the list div ...
        objShapeEditor.NewReferencePointTypeListDiv.append(objItemDiv);

        // Create a div for the item text ...
        var objItemTextDiv = $('<span>' + objReferencePoint.ReferencePointTypeName + '</span>');

        // Add the item text ...
        objItemDiv.append(objItemTextDiv);
    });
}

// **************************************************************************
// FUNCTION: NewReferencePointPopupClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.NewReferencePointPopupClicked = function NewReferencePointPopupClicked(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the reference point list item that the user clicked on if any ...
    var objReferencePointListItem = SD.DOM.GetElementOrParentWithAttribute($(e.target), 'ReferencePointID');

    // When the user clicked on a reference point item ...
    if (objReferencePointListItem) {

        // Get the reference point id that the user clicked on ...
        var strReferencePointID = objReferencePointListItem.attr('ReferencePointID');

        // Close the popup ...
        objShapeEditor.NewReferencePointPopup.ClosePopup();

        // When the spatial reference is set ...
        if (objShapeEditor.Shape.SpatialReferenceID != SD.Guid.Shared.Empty()) {

            // Get the reference point to add ...
            var objReferencePointToAdd = objShapeEditor.Shape.GetReferencePointByID(strReferencePointID);

            // Add the reference point ...
            objShapeEditor.AddReferencePoint(objReferencePointToAdd, true);

        } else {

            // Get the translations ...

            // Cannot add reference point without coordinate system
            var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotAddReferencePointTitle');

            // You cannot add a new reference point when the coordinate system is not set. <br />You need to first set the coordinate system and then add the reference point.
            var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CannotAddReferencePointMessage');

            // Show a message to the user ...
            TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
        }
    }
}

// **************************************************************************
// FUNCTION: CreateReferencePointCoordinateDivElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateReferencePointCoordinateDivElements = function CreateReferencePointCoordinateDivElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the div ...
    objShapeEditor.ReferencePointCoordinateDiv = $('<div class="shape-reference-coordinates"></div>');

    // Hide it ...
    objShapeEditor.ReferencePointCoordinateDiv.hide();

    // Get translations ...

    // Viewing Reference Point
    var strViewingReferencePoint = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ViewingReferencePoint') + ':';

    // Editing Reference Point
    var strEditingReferencePoint = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'EditingReferencePoint') + ':';

    // Create the "Viewing reference point" span ...
    objShapeEditor.ViewingReferencePointSpan = $('<span class="view-reference">' + strViewingReferencePoint + '</span>');

    // Add it to the div ...        
    objShapeEditor.ReferencePointCoordinateDiv.append(objShapeEditor.ViewingReferencePointSpan);

    // Create the "Editing reference point" span ...
    objShapeEditor.EditingReferencePointSpan = $('<span class="edit-reference">' + strEditingReferencePoint + '</span>');

    // Add it to the div ...        
    objShapeEditor.ReferencePointCoordinateDiv.append(objShapeEditor.EditingReferencePointSpan);

    // Add a space ...
    objShapeEditor.ReferencePointCoordinateDiv.append('&nbsp;');

    // Create the name span ...
    objShapeEditor.ReferencePointNameSpan = $('<span class="view-reference-name"></span>');

    // Add it to the div ...
    objShapeEditor.ReferencePointCoordinateDiv.append(objShapeEditor.ReferencePointNameSpan);

    // Create the coordinate list editor div ...
    objShapeEditor.ReferencePointCoordinateListEditorDiv = $('<div class="shape_referencepoint_coordinatelist_editor_div"></div>');

    // Add it to the div ...
    objShapeEditor.ReferencePointCoordinateDiv.append(objShapeEditor.ReferencePointCoordinateListEditorDiv);

    // Create the coordinate list editor ...
    objShapeEditor.ReferencePointCoordinateListEditor = TrimbleMap.CoordinateListEditor.CreateInstance(objShapeEditor.ReferencePointCoordinateListEditorDiv,
        objShapeEditor.MapController.State.GroupSeparator,
        objShapeEditor.MapController.State.DecimalSeparator,
        TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID),
        objShapeEditor.MapController.State.GeographicSecondsDecimalPlaces, true, false, TrimbleMap.Shape.enumGeometryType.POINT,
        objShapeEditor.MapController.State.DefaultLongitudeDirection, objShapeEditor.MapController.State.DefaultLatitudeDirection,
        objShapeEditor.MapController.State.ProjectedFormatLongitudeThenLatitude, { top: -28, left: 0 }, null, true);

    // Add the coordinate list editor "CoordinatesChanged" and hovered callbacks ...
    objShapeEditor.ReferencePointCoordinateListEditor.AddOnCoordinateChangedCallback(objShapeEditor.ReferencePointCoordinateListEditorCoordinateChangedProxy);
    objShapeEditor.ReferencePointCoordinateListEditor.AddOnCoordinateHoveredCallback(objShapeEditor.ReferencePointCoordinateListEditorOnCoordinateHoveredProxy);

    // Return the new div ...
    return objShapeEditor.ReferencePointCoordinateDiv;
}

// **************************************************************************
// FUNCTION: UpdateNoReferencePointsDisplayVisibility
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateNoReferencePointsDisplayVisibility = function UpdateNoReferencePointsDisplayVisibility() {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have reference points with values ...
    if (objShapeEditor.Shape.HasReferencePointWithValues(false) || (objShapeEditor.EditingReferencePoint)) {

        // Show the reference points item div and hide the "no parts" message ...
        if (objShapeEditor.ReferencePointsItemsDiv) { objShapeEditor.ReferencePointsItemsDiv.show(); }
        if (objShapeEditor.NoReferencePointsMessageDiv) { objShapeEditor.NoReferencePointsMessageDiv.hide(); }

    } else {

        // Hide the reference points item div and show the "no parts" message ...
        if (objShapeEditor.ReferencePointsItemsDiv) { objShapeEditor.ReferencePointsItemsDiv.hide(); }
        if (objShapeEditor.NoReferencePointsMessageDiv) { objShapeEditor.NoReferencePointsMessageDiv.show(); }
    }
}

// **************************************************************************
// FUNCTION: UpdateReferencePointsDisplay
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateReferencePointsDisplay = function UpdateReferencePointsDisplay() {

    // Get the instance ...
    var objShapeEditor = this;

    // Update the no reference point display visiblity ...
    objShapeEditor.UpdateNoReferencePointsDisplayVisibility();

    // Show or hide the add reference points icon ...
    objShapeEditor.ShowOrHideNewReferencePointIconDiv();

    // Update the view and edit reference point coordinate div visibility ...
    objShapeEditor.UpdateViewAndEditReferencePointVisibility();

    // When the shape has reference points and is either in edit
    // mode or when we do have reference points with values ...
    if (objShapeEditor.Shape.HasReferencePoints() && (objShapeEditor.CoordinatesEditable || objShapeEditor.Shape.HasReferencePointWithValues(false) || objShapeEditor.Shape.HasCalculatedReferencePoints())) {

        // Show the reference points div ...
        objShapeEditor.ReferencePointsDiv.show();

        // When we have validation messages for the reference points ...
        if (objShapeEditor.HasValidationMessagesFor(TrimbleMap.ShapeEditor.enumEditorInterfaceFields.ReferencePoints)) {

            // Show the validation messages icon ...
            objShapeEditor.ReferencePointValidationMessagesIcon.show();

        } else {

            // Hide the validation messages icon ...
            objShapeEditor.ReferencePointValidationMessagesIcon.hide();
        }

    } else {

        // Hide the reference points div ...
        objShapeEditor.ReferencePointsDiv.hide();
    }
}

// **************************************************************************
// FUNCTION: ShowOrHideNewReferencePointIconDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ShowOrHideNewReferencePointIconDiv = function ShowOrHideNewReferencePointIconDiv() {

    // Get the instance ...
    var objShapeEditor = this;

    // When editable ...
    if (objShapeEditor.CoordinatesEditable) {

        // When the shape has reference points ...
        if (objShapeEditor.Shape.HasReferencePoints()) {

            // When the shape has any reference points without values ...
            if (objShapeEditor.Shape.ReferencePointsWithoutValues().length > 0) {

                // Show the add reference point icon ...
                objShapeEditor.NewReferencePointIconDiv.show();

            } else {

                // Hide the add reference point icon ...
                objShapeEditor.NewReferencePointIconDiv.hide();
            }
        }
    }
}

// **************************************************************************
// FUNCTION: CreateShapePartDetailsDivElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateShapePartDetailsDivElements = function CreateShapePartDetailsDivElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the shape part coordinates div ...
    objShapeEditor.ShapePartDetailsDiv = $('<div class="shape-part-coordinates"></div>');

    // Create the shape part coordinates inner div ...
    objShapeEditor.ShapePartDetailsInnerDiv = $('<div></div>');

    // Add it to the ShapePartDetailsDiv ...
    objShapeEditor.ShapePartDetailsDiv.append(objShapeEditor.ShapePartDetailsInnerDiv);

    // Get the translation for 'Viewing coordinates of:' ...

    // Create the editing part upper div ...
    objShapeEditor.EditingCoordinateModeUpperDiv = $('<div class="shape_editing_part_upper_div"></div>');

    // Add it to the shape part coordinates div ...
    objShapeEditor.ShapePartDetailsInnerDiv.append(objShapeEditor.EditingCoordinateModeUpperDiv);

    // Create the part name span ...
    if (objShapeEditor.RenameShapePartTextBox === null) {
        objShapeEditor.RenameShapePartTextBox = $('<input type="text" class="shape_editing_part_name_textbox"></input>');
    }

    // Get the translations for OK and cancel ...

    // Create a div for the calculated part area ...
    objShapeEditor.CalculatedPartAreaDiv = $('<div class="calculated-area"></div>');

    // Add it to the shape part details div ... 
    objShapeEditor.ShapePartDetailsInnerDiv.append(objShapeEditor.CalculatedPartAreaDiv);

    // Create a div for the calculated part length ...
    objShapeEditor.CalculatedPartLengthDiv = $('<div class="calculated-length"></div>');

    // Add it to the shape part details div ... 
    objShapeEditor.ShapePartDetailsInnerDiv.append(objShapeEditor.CalculatedPartLengthDiv);

    // 'Area'
    var strCalculatedPartArea = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Area');

    // 'Calculating Area'
    var strAreaCalculationInProgress = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatingArea') + ' ...';

    // 'Length'
    var strCalculatedPartLength = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'Length');

    // 'Calculating Length'
    var strLengthCalculationInProgress = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'CalculatingLength') + ' ...';

    // Add a span for the label ...
    objShapeEditor.CalculatedPartAreaDiv.append('<span class="bold">' + strCalculatedPartArea + ':</span>&nbsp;');

    // Add a span for the label ...
    objShapeEditor.CalculatedPartLengthDiv.append('<span class="bold">' + strCalculatedPartLength + ':</span>&nbsp;');

    // Create a span for the part area ...
    objShapeEditor.CalculatedPartAreaSpan = $('<span></span>');

    // Add it to the part area div ...
    objShapeEditor.CalculatedPartAreaDiv.append(objShapeEditor.CalculatedPartAreaSpan);

    // Create a span for the part length ...
    objShapeEditor.CalculatedPartLengthSpan = $('<span></span>');

    // Add it to the part area div ...
    objShapeEditor.CalculatedPartLengthDiv.append(objShapeEditor.CalculatedPartLengthSpan);

    // Create a span to indicate that a calculation is in progress ...
    objShapeEditor.PartAreaCalculationInProgressIndicator = $('<span>' + strAreaCalculationInProgress + '</span>');

    // Add it to the part area div ...
    objShapeEditor.CalculatedPartAreaDiv.append(objShapeEditor.PartAreaCalculationInProgressIndicator);

    // Create a span to indicate that a calculation is in progress ...
    objShapeEditor.PartLengthCalculationInProgressIndicator = $('<span>' + strLengthCalculationInProgress + '</span>');

    // Add it to the part length div ...
    objShapeEditor.CalculatedPartLengthDiv.append(objShapeEditor.PartLengthCalculationInProgressIndicator);

    // Hide the area calculation in progress indicator ...
    objShapeEditor.PartAreaCalculationInProgressIndicator.hide();

    // Hide the length calculation in progress indicator ...
    objShapeEditor.PartLengthCalculationInProgressIndicator.hide();

    // Hide the calculated part area div ...
    objShapeEditor.CalculatedPartAreaDiv.hide();

    // Hide the calculated part area div ...
    objShapeEditor.CalculatedPartLengthDiv.hide();

    // Create the coordinate list editor div ...
    objShapeEditor.CoordinateListEditorDiv = $('<div class="coordinate-list-container"></div>');

    // Add it to the shape part coordinates div ...
    objShapeEditor.ShapePartDetailsDiv.append(objShapeEditor.CoordinateListEditorDiv);

    // Create the coordinate list editor ...
    objShapeEditor.CoordinateListEditor = TrimbleMap.CoordinateListEditor.CreateInstance(objShapeEditor.CoordinateListEditorDiv,
        objShapeEditor.MapController.State.GroupSeparator,
        objShapeEditor.MapController.State.DecimalSeparator,
        TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID),
        objShapeEditor.MapController.State.GeographicSecondsDecimalPlaces, true, false, objShapeEditor.Shape.GeometryType,
        objShapeEditor.MapController.State.DefaultLongitudeDirection, objShapeEditor.MapController.State.DefaultLatitudeDirection,
        objShapeEditor.MapController.State.ProjectedFormatLongitudeThenLatitude, { top: -25, left: 0 }, null, false);

    // Add the coordinate list editor "CoordinatesChanged" callback ...
    objShapeEditor.CoordinateListEditor.AddOnCoordinateChangedCallback(objShapeEditor.CoordinateListEditorCoordinateChangedProxy);
    objShapeEditor.CoordinateListEditor.AddOnCoordinatesChangedCallback(objShapeEditor.CoordinateListEditorCoordinatesChangedProxy);
    objShapeEditor.CoordinateListEditor.AddOnCoordinateHoveredCallback(objShapeEditor.CoordinateListEditorOnCoordinateHoveredProxy);

    // Return the created div ...
    return objShapeEditor.ShapePartDetailsDiv;
}

// **************************************************************************
// FUNCTION: UpdateViewAndEditPartVisibility
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateViewAndEditPartVisibility = function UpdateViewAndEditPartVisibility() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the part is to be edited ...
    if (objShapeEditor.EditingCoordinateMode) {

        // Show the editing part div and hide the viewing part div ...
        objShapeEditor.EditingCoordinateModeUpperDiv.show();
    } else {

        // Show the viewing part div and hide the editing part div ...
        objShapeEditor.EditingCoordinateModeUpperDiv.hide();
    }
}

// **************************************************************************
// FUNCTION: UpdateViewAndEditReferencePointVisibility
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateViewAndEditReferencePointVisibility = function UpdateViewAndEditReferencePointVisibility() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the part is to be edited ...
    if (objShapeEditor.EditingReferencePoint) {

        // Show the editing reference point span and hide the viewing span ...
        if (objShapeEditor.EditingReferencePointSpan) { objShapeEditor.EditingReferencePointSpan.show(); }
        if (objShapeEditor.ViewingReferencePointSpan) { objShapeEditor.ViewingReferencePointSpan.hide(); }

    } else {

        // Show the viewing reference point span and hide the editing span ...
        if (objShapeEditor.EditingReferencePointSpan) { objShapeEditor.EditingReferencePointSpan.hide(); }
        if (objShapeEditor.ViewingReferencePointSpan) { objShapeEditor.ViewingReferencePointSpan.show(); }
    }
}

// **************************************************************************
// FUNCTION: CreateCoordinateDisplayDiv
// USAGE:
// **************************************************************************
TrimbleMap.ShapeEditor.CreateCoordinateDisplayDiv = function CreateCoordinateDisplayDiv() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the map contents are loaded ..
    if (objShapeEditor.MapController.LoadMapContents) {

        // Create the coordinate display div ...
        objShapeEditor.CoordinateDisplayDiv = $('<div class="coordinates"></div>');

        // Create the coordinate display in the div ...
        objShapeEditor.CoordinateDisplay = TrimbleMap.CoordinateDisplay.CreateInstance(objShapeEditor.MapController, objShapeEditor.CoordinateDisplayDiv);
    }

    // Return the created div ...
    return objShapeEditor.CoordinateDisplayDiv;
}

// **************************************************************************
// FUNCTION: ActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateTab = function ActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objShapeEditor = this;

    // Add the shape div to the tab container element
    objTabContainerElement.append(objShapeEditor.ShapeEditorDiv);

    // Attach the event hanlders ...
    objShapeEditor.AttachEventHandlers();

    if (objShapeEditor.ShapePartDetailsVisible) {

        // Ensure the ShapPartDetailsDiv is visible when it's supposed to be shown
        objShapeEditor.ShapePartDetailsDiv.show();
    }
}

// **************************************************************************
// FUNCTION: DeActivateTab
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeActivateTab = function DeActivateTab(objTabContainerElement, enTabActivationMethod) {

    // Get the instance ...
    var objShapeEditor = this;

    // Detach the event handlers
    objShapeEditor.DetachEventHandlers();

    // Remove the shape div from the tab container element
    objShapeEditor.ShapeEditorDiv.remove();
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AttachEventHandlers = function AttachEventHandlers() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the event handlers are not attached ...
    if (!objShapeEditor.EventHandlersAttached) {

        // Attach the click event handler proxy ...
        objShapeEditor.ShapeDiv.on('click', (objShapeEditor.ClickedHandlerProxy));

        // Attach Shape Editor Options event handlers 
        if (objShapeEditor.ShapeEditorOptions.Visible) {

            objShapeEditor.ShapeEditorOptions.AttachPopupEventHandlers();
        }

        // Attach the change event handler to the coordinate system drop down ...
        objShapeEditor.CoordinateSystemDropDown.on('change', (objShapeEditor.CoordinateSystemDropDownChangedProxy));

        //Attach the change event handler to the shape part dropdown 
        objShapeEditor.ShapePartDropDown.on('change', (objShapeEditor.ShapePartDropDownChangedProxy));

        // Attach the change event handlers to the official area and unit textbox and drop down ...
        if (objShapeEditor.OfficialAreaTextBox) { objShapeEditor.OfficialAreaTextBox.change(objShapeEditor.OfficialAreaChangedProxy); }
        if (objShapeEditor.OfficialAreaUnitsDropDown) { objShapeEditor.OfficialAreaUnitsDropDown.change(objShapeEditor.OfficialAreaUnitChangedProxy); }

        // Attach the change event handlers to the official length and unit textbox and drop down ...
        if (objShapeEditor.OfficialLengthTextBox) { objShapeEditor.OfficialLengthTextBox.change(objShapeEditor.OfficialLengthChangedProxy); }
        if (objShapeEditor.OfficialLengthUnitsDropDown) { objShapeEditor.OfficialLengthUnitsDropDown.change(objShapeEditor.OfficialLengthUnitChangedProxy); }

        // Attach the event handlers for the coordinate list editor ...
        objShapeEditor.CoordinateListEditor.AttachEventHandlers();

        // Attach the event handlers for the reference point coordinate list editor ... 
        if (objShapeEditor.ReferencePointCoordinateListEditor) { objShapeEditor.ReferencePointCoordinateListEditor.AttachEventHandlers(); }

        // When the display area control exists ...
        if (objShapeEditor.DisplayArea) {

            // Attach the display area event handlers ...
            objShapeEditor.DisplayArea.AttachEventHandlers();

            // Attach the unit changed event hanlder ...
            objShapeEditor.DisplayArea.AddOnUnitChanged(objShapeEditor.CalculatedAreaUnitChangedProxy);
        }

        // When the display length control exists ...
        if (objShapeEditor.DisplayLength) {

            // Attach the display area event handlers ...
            objShapeEditor.DisplayLength.AttachEventHandlers();

            // Attach the unit changed event hanlder ...
            objShapeEditor.DisplayLength.AddOnUnitChanged(objShapeEditor.CalculatedLengthUnitChangedProxy);
        }

        if (objShapeEditor.Editable) {
            objShapeEditor.ShapePartDetailsDiv.on('focusout', (objShapeEditor.ShapePartDetailsDivFocusOutProxy));
            objShapeEditor.ReferencePointsDiv.on('focusout', (objShapeEditor.ReferencePointDivFocusOutProxy));
        }

        // Attach the event handlers to the functionality disabled popup when we have the icon ...
        if (objShapeEditor.FunctionalityDisabledPopup) { objShapeEditor.FunctionalityDisabledPopup.AttachEventHandlers(); }

        // Attach the event handlers to the re-project popup when we have the icon ...
        if (objShapeEditor.ReProjectPopup) { objShapeEditor.ReProjectPopup.AttachEventHandlers(); }

        // Attach the event handlers to the draw mode popup when we have the icon ...
        if (objShapeEditor.DrawModePopup) { objShapeEditor.DrawModePopup.AttachEventHandlers(); }

        // Attach the event handlers to the new reference point popup when we have the icon ...
        if (objShapeEditor.NewReferencePointPopup) { objShapeEditor.NewReferencePointPopup.AttachEventHandlers(); }

        // Attach the legal description changed event handler when visible ...
        if (objShapeEditor.Options.ShowLegalDescription) { objShapeEditor.LegalDescriptionTextArea.change(objShapeEditor.LegalDescriptionChangedProxy); }

        // Attach a click event handler to the ViewDynamicShapeOptions link ...
        if (objShapeEditor.ViewDynamicShapeOptions) { objShapeEditor.ViewDynamicShapeOptions.on('click', (objShapeEditor.ViewDynamicShapeOptionsClickedProxy)); }

        // Attach a click event handler to the DefineDynamicShapeOptions link ...
        if (objShapeEditor.DefineDynamicShapeOptions) { objShapeEditor.DefineDynamicShapeOptions.on('click', (objShapeEditor.DefineDynamicShapeOptionsClickedProxy)); }

        // Attach mouse over event handler to the EditHamburgerMenu
        if (objShapeEditor.EditPartHamburgerMenu) { objShapeEditor.EditPartHamburgerMenu.AttachEventHandlers(); }

        // Get all the validation icons ...
        var arrValidationIcons = objShapeEditor.ShapeEditorDiv.find('[ValidationEditorInterfaceField]');

        // Attach event handlers for the mouse enter and leave event handlers ...
        $(arrValidationIcons).on('mouseenter', (objShapeEditor.ValidationMessageIconMouseEnterProxy));
        $(arrValidationIcons).on('mouseleave', (objShapeEditor.ValidationMessageIconMouseLeaveProxy));

        // Attach the map event handlers ...
        objShapeEditor.AttachMapEventHandlers();

        // Update the parts list scrollbar ...
        objShapeEditor.UpdatePartsListScrollbar(true);

        // Attach event handlers to all the icon popups ...
        $.each(objShapeEditor.IconPopups, function (intIconPopup, objIconPopup) { objIconPopup.AttachEventHandlers(); });

        // Attach event handlers to all the icon popup menus ...
        $.each(objShapeEditor.IconPopupMenus, function (intIconPopupMenu, objIconPopupMenu) { objIconPopupMenu.AttachEventHandlers(); });

        // Set to have attached the event handlers ...
        objShapeEditor.EventHandlersAttached = true;
    }
}

// **************************************************************************
// FUNCTION: AttachMapEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AttachMapEventHandlers = function AttachMapEventHandlers() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the map has been loaded successfully ...
    if (objShapeEditor.MapController.EsriMap.loaded) {

        // Attach the coordinate display handler ... 
        if (objShapeEditor.CoordinateDisplay) { objShapeEditor.CoordinateDisplay.AttachHandler() };

        // Attach the graphics layer mouse-over event handler ...
        objShapeEditor.GraphicsLayerMouseOverHandle = objShapeEditor.MapController.EsriMap.graphics.on('mouse-over', objShapeEditor.GraphicsLayerMouseOverProxy);

        // Attach the graphics layer mouse-out event handler ...
        objShapeEditor.GraphicsLayerMouseOutHandle = objShapeEditor.MapController.EsriMap.graphics.on('mouse-out', objShapeEditor.GraphicsLayerMouseOutProxy);
    }
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DetachEventHandlers = function DetachEventHandlers() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the event handlers are attached ...
    if (objShapeEditor.EventHandlersAttached) {

        // Detach the click event handler proxy ...
        objShapeEditor.ShapeDiv.off('click', objShapeEditor.ClickedHandlerProxy);

        if (objShapeEditor.ShapeEditorOptions.Visible) {

            objShapeEditor.ShapeEditorOptions.DetachPopupEventHandlers();
            //Reset Sub Menu
            objShapeEditor.ShapeEditorOptions.ResetSubMenu();
        }

        // Detach the change event handler to the coordinate system drop down ...
        objShapeEditor.CoordinateSystemDropDown.off('change', objShapeEditor.CoordinateSystemDropDownChangedProxy);

        // Detach the change event handlers to the official area and unit textbox and drop down ...
        if (objShapeEditor.OfficialAreaTextBox) { objShapeEditor.OfficialAreaTextBox.off('change', objShapeEditor.OfficialAreaChangedProxy); }
        if (objShapeEditor.OfficialAreaUnitsDropDown) { objShapeEditor.OfficialAreaUnitsDropDown.off('change', objShapeEditor.OfficialAreaUnitChangedProxy); }

        // Detach the change event handlers to the official length and unit textbox and drop down ...
        if (objShapeEditor.OfficialLengthTextBox) { objShapeEditor.OfficialLengthTextBox.off('change', objShapeEditor.OfficialLengthChangedProxy); }
        if (objShapeEditor.OfficialLengthUnitsDropDown) { objShapeEditor.OfficialLengthUnitsDropDown.off('change', objShapeEditor.OfficialLengthUnitChangedProxy); }

        // Detach the event handlers for the coordinate list editor ... 
        objShapeEditor.CoordinateListEditor.DetachEventHandlers();

        // Detach the event handlers for the reference point coordinate list editor ... 
        if (objShapeEditor.ReferencePointCoordinateListEditor) { objShapeEditor.ReferencePointCoordinateListEditor.DetachEventHandlers(); }

        // When the display area control exists ...
        if (objShapeEditor.DisplayArea) {

            // Detach the display area event handlers ...
            objShapeEditor.DisplayArea.DetachEventHandlers();

            // Detach the unit changed event handler ...
            objShapeEditor.DisplayArea.RemoveOnUnitChanged(objShapeEditor.CalculatedAreaUnitChangedProxy);
        }

        if (objShapeEditor.Editable) {
            objShapeEditor.ShapePartDetailsDiv.off('focusout', objShapeEditor.ShapePartDetailsDivFocusOutProxy);
            objShapeEditor.ReferencePointsDiv.off('focusout', objShapeEditor.ReferencePointDivFocusOutProxy);
        }

        // When the display length control exists ...
        if (objShapeEditor.DisplayLength) {

            // Detach the display area event handlers ...
            objShapeEditor.DisplayLength.DetachEventHandlers();

            // Detach the unit changed event handler ...
            objShapeEditor.DisplayLength.RemoveOnUnitChanged(objShapeEditor.CalculatedLengthUnitChangedProxy);
        }

        // Detach the event handlers from the re-project popup ...
        if (objShapeEditor.ReProjectPopup) { objShapeEditor.ReProjectPopup.DetachEventHandlers(); }

        // Detach the event handlers from the draw mode popup ...
        if (objShapeEditor.DrawModePopup) { objShapeEditor.DrawModePopup.DetachEventHandlers(); }

        // Detach the event handlers from the functionality disabled popup ...
        if (objShapeEditor.FunctionalityDisabledPopup) { objShapeEditor.FunctionalityDisabledPopup.DetachEventHandlers(); }

        // Detach the event handlers to the new reference point popup when we have the icon ...
        if (objShapeEditor.NewReferencePointPopup) { objShapeEditor.NewReferencePointPopup.DetachEventHandlers(); }

        // Detach the legal description changed event handler when visible ...
        if (objShapeEditor.Options.ShowLegalDescription) { objShapeEditor.LegalDescriptionTextArea.off('change', objShapeEditor.LegalDescriptionChangedProxy); }

        // Attach a click event handler to the DefineDynamicShapeOptions link ...
        if (objShapeEditor.DefineDynamicShapeOptions) { objShapeEditor.DefineDynamicShapeOptions.off('click', objShapeEditor.DefineDynamicShapeOptionsClickedProxy); }

        // Attach a click event handler to the ViewDynamicShapeOptions link ...
        if (objShapeEditor.ViewDynamicShapeOptions) { objShapeEditor.ViewDynamicShapeOptions.off('change', objShapeEditor.ViewDynamicShapeOptionsClickedProxy); }

        // Get all the validation icons ...
        var arrValidationIcons = objShapeEditor.ShapeEditorDiv.find('[ValidationEditorInterfaceField]');

        // Detach the event handlers for the mouse enter and leave event handlers ...
        $(arrValidationIcons).off('mouseenter', objShapeEditor.ValidationMessageIconMouseEnterProxy);
        $(arrValidationIcons).off('mouseleave', objShapeEditor.ValidationMessageIconMouseLeaveProxy);

        // Detach the map event handlers ...
        objShapeEditor.DetachMapEventHandlers();

        // Update the parts list scrollbar ...
        objShapeEditor.UpdatePartsListScrollbar(false);

        // Detach the event handlers from all the icon popups ...
        $.each(objShapeEditor.IconPopups, function (intIconPopup, objIconPopup) { objIconPopup.DetachEventHandlers(); });

        // Detach event handlers to all the icon popup menus ...
        $.each(objShapeEditor.IconPopupMenus, function (intIconPopupMenu, objIconPopupMenu) { objIconPopupMenu.DetachEventHandlers(); });

        // Set to have detached the event handlers ...
        objShapeEditor.EventHandlersAttached = false;
    }
}

// **************************************************************************
// FUNCTION: DetachMapEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DetachMapEventHandlers = function DetachMapEventHandlers() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the map has been loaded successfully ...
    if (objShapeEditor.MapController.EsriMap.loaded) {

        // Detach the coordinate display handler ... 
        if (objShapeEditor.CoordinateDisplay) { objShapeEditor.CoordinateDisplay.DetachHandler(); }

        // Detach the graphics layer mouse-over event handler ...
        if (objShapeEditor.GraphicsLayerMouseOverHandle) { objShapeEditor.GraphicsLayerMouseOverHandle.remove(); }

        // Detach the graphics layer mouse-out event handler ...
        if (objShapeEditor.GraphicsLayerMouseOutHandle) { objShapeEditor.GraphicsLayerMouseOutHandle.remove(); }
    }
}

// **************************************************************************
// FUNCTION: ResizeTab
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ResizeTab = function ResizeTab(objTabContainerElement) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the tab container in the instance ...
    objShapeEditor.TabContainerElement = objTabContainerElement;

    // Resize the elements ...
    objShapeEditor.ResizeElements();
}

// **************************************************************************
// FUNCTION: ResizeElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ResizeElements = function ResizeElements() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the shape editor tab is visible ...
    if ((objShapeEditor.Sidebar.CurrentTab == objShapeEditor.ShapeEditorTabItem) && (objShapeEditor.TabContainerElement != null)) {

        // Compute the available width ...
        var intAvailableWidth = TrimbleMap.ShapeEditor.Shared.INNER_WIDTH - (TrimbleMap.ShapeEditor.Shared.CONTAINER_PADDING * 2);

        // Compute the max width for the area display ...
        var intAreaDispalyMaxWidth = intAvailableWidth - objShapeEditor.CalculatedAreaLabelColumnWidth;

        // Remove the right column spacing when not in edit mode ...
        if (!objShapeEditor.Editable) { intAreaDispalyMaxWidth -= objShapeEditor.CalculatedAreaSpacingWidth; }

        // Set the max width available to the area display ...
        objShapeEditor.DisplayArea.SetMaxWidth(intAreaDispalyMaxWidth);

        // Update the parts list scrollbar ...
        objShapeEditor.UpdatePartsListScrollbar(null, true);

        // Get the tab height ...
        var intTabHeight = parseInt(objShapeEditor.TabContainerElement.height());

        // Get the top of the shape part details div ...
        var intShapePartDetailsDivTop = objShapeEditor.ShapePartDetailsTopMarkerDiv.position().top + 10 - (((!objShapeEditor.SelectedReferencePoint) && objShapeEditor.ReferencePointCoordinateDiv && objShapeEditor.ReferencePointCoordinateDiv.is(':visible')) ? objShapeEditor.ReferencePointCoordinateDiv.outerHeight(true) : 0);

        // Get the coordinate display height ...
        var intCoordinateDisplayHeight = (objShapeEditor.CoordinateDisplayDiv) ? parseInt(objShapeEditor.CoordinateDisplayDiv.outerHeight(true)) : 0;

        // Set the shape editor div to fill the entire tab ...
        objShapeEditor.ShapeDiv.height((intTabHeight - intCoordinateDisplayHeight - 30) + 'px');

        // When we have a selected part ...
        if (objShapeEditor.SelectedPart != null) {

            //When geometry type is Polyline
            if (objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYLINE) {

                // Get the height that the calculated part length div contributes to the shape part div ...
                var intCalculatedPartMeasurementContribution = (objShapeEditor.CalculatedPartLengthDiv.is(':visible')) ? parseInt(objShapeEditor.CalculatedPartLengthDiv.outerHeight()) + 5 : -5;
            }
            else {
                // Get the height that the calculated part area div contributes to the shape part div ...
                var intCalculatedPartMeasurementContribution = (objShapeEditor.CalculatedPartAreaDiv.is(':visible')) ? parseInt(objShapeEditor.CalculatedPartAreaDiv.outerHeight()) + 5 : -5;
            }

            // Compute the remaining height for the shape part details div ...
            var intShapePartDetailsHeight = intTabHeight - intShapePartDetailsDivTop - intCoordinateDisplayHeight - 8;

            // Get the height of the div that contains the part name and OK and CANCEL buttons when in edit mode ...
            var intShapePartDetailsInnerDiv = (objShapeEditor.EditingCoordinateMode) ? 30 : 23;

            // Compute and set the height for the coordinate list editor ...
            objShapeEditor.CoordinateListEditor.SetHeight(intShapePartDetailsHeight - intShapePartDetailsInnerDiv - 10 - intCalculatedPartMeasurementContribution);
        }
    }
}

// **************************************************************************
// FUNCTION: UpdatePartsListScrollbar
// USAGE:    blnEventHandlersAttachedOverride is optional, it overrides the value obtained from 
//           objCoordinateListEditor.EventHandlersAttached when set
//           blnResizing is optional, defaults to false
// **************************************************************************
TrimbleMap.ShapeEditor.UpdatePartsListScrollbar = function UpdatePartsListScrollbar(blnEventHandlersAttachedOverride, blnResizing) {

    // Get the instance ...
    var objShapeEditor = this;

    // Compute the part items div's height ...
    var intPartItemsDivHeight = objShapeEditor.PartsItemsDiv.outerHeight(true);

    // Determine whether or not a scrollbar will be required on the parts list ...
    var blnScrollbarRequired = (intPartItemsDivHeight > TrimbleMap.ShapeEditor.Shared.PARTS_LIST_MAX_HEIGHT);

    // When more than the max height allowed ...
    if (blnScrollbarRequired) {

        // Set it to the height for the div in which the parts list will scroll ...
        objShapeEditor.PartsItemsScrollDiv.css('height', TrimbleMap.ShapeEditor.Shared.PARTS_LIST_MAX_HEIGHT + 'px');

    } else {

        // Remove it to the height from the div in which the parts list will scroll ...
        objShapeEditor.PartsItemsScrollDiv.css('height', '');
    }

    // Override EventHandlersAttached with blnEventHandlersAttachedOverride when specified ...
    var blnEventHandlersAttached = ((typeof blnEventHandlersAttachedOverride != 'undefined') && (blnEventHandlersAttachedOverride != null)) ? blnEventHandlersAttachedOverride : objShapeEditor.EventHandlersAttached;

    // When the event handlers should be attached and a scrollbar is required ...
    if (blnEventHandlersAttached && blnScrollbarRequired) {

        // When the parts list are not scrollable ...
        if (!objShapeEditor.PartsItemsDivNiceScroll) {

            // Make the parts list scrollable ...
            objShapeEditor.PartsItemsDivNiceScroll = objShapeEditor.PartsItemsScrollDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });
        }

    } else {

        // When we are not busy resizing ...
        if ((typeof blnResizing == 'undefined') || !blnResizing) {

            // When the parts list are scrollable ...
            if (objShapeEditor.PartsItemsDivNiceScroll) {

                // Remove the scrollbar ...
                objShapeEditor.PartsItemsDivNiceScroll.remove();
                objShapeEditor.PartsItemsDivNiceScroll = null;
            }
        }
    }
}

// **************************************************************************
// FUNCTION: ValidationMessageIconMouseEnter
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ValidationMessageIconMouseEnter = function ValidationMessageIconMouseEnter(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the icon in which the mouse entered ...
    var objTarget = $(e.target);

    // Get the field for which the validation messages should be shown ... 
    var enEditorInterfaceField = objTarget.attr('ValidationEditorInterfaceField')

    // Get the validation messages to display ...
    var arrValidationMessage = objShapeEditor.Options.ValidationMessages[enEditorInterfaceField];

    // Create the validation message div ...
    objShapeEditor.ValidationMessagesDiv = $('<div class="validation-popup"></div>');

    // Loop through the validation messages ...
    $.each(arrValidationMessage, function (intValidationMessage, strValidationMessage) {

        // Add a span with a message to the div ...
        objShapeEditor.ValidationMessagesDiv.append('<span>' + strValidationMessage + '</span><br />');
    });

    // Add the validation message div after the icon ... 
    //objTarget.insertAfter(objShapeEditor.ValidationMessagesDiv);
    objTarget.append(objShapeEditor.ValidationMessagesDiv);

    // Bring the div to the top ...
    SD.DOM.BringToFront(objShapeEditor.ValidationMessagesDiv);
}

// **************************************************************************
// FUNCTION: ValidationMessageIconMouseLeave
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ValidationMessageIconMouseLeave = function ValidationMessageIconMouseLeave(e) {

    // Get the instance ...
    var objShapeEditor = this;

    // Remove the validation message div from the interface ...
    if (objShapeEditor.ValidationMessagesDiv) { objShapeEditor.ValidationMessagesDiv.remove(); }

    // Set to null ...
    objShapeEditor.ValidationMessagesDiv = null;
}

// **************************************************************************
// FUNCTION: HasValidationMessagesFor
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.HasValidationMessagesFor = function HasValidationMessagesFor(enEditorInterfaceFields) {

    // Get the instance ...
    var objShapeEditor = this;

    // Test if we have validation messages for the field ...
    var blnHasValidationMessages = (objShapeEditor.Editable &&
        (typeof objShapeEditor.Options.ValidationMessages != 'undefined') &&
        objShapeEditor.Options.ValidationMessages &&
        (typeof objShapeEditor.Options.ValidationMessages[enEditorInterfaceFields] != 'undefined') &&
        objShapeEditor.Options.ValidationMessages[enEditorInterfaceFields] &&
        (objShapeEditor.Options.ValidationMessages[enEditorInterfaceFields].length > 0));

    return blnHasValidationMessages;
}

// **************************************************************************
// FUNCTION: CreateValidationMessageIcon
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateValidationMessageIcon = function CreateValidationMessageIcon(enEditorInterfaceFields) {

    // Create the validation message icon ...
    var objValidationMessageIcon = $('<div ValidationEditorInterfaceField="' + enEditorInterfaceFields + '" class="validation-icon"></div>');

    return objValidationMessageIcon;
}

// **************************************************************************
// FUNCTION: CreateRequiredAsterisk
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateRequiredAsterisk = function CreateRequiredAsterisk() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the elements for the asterisk ...
    var objAsterisk = $('<div class="shape_required_asterisk_outer_div"><div class="shape_required_asterisk_div"><span class="shape_required_asterisk_span">*</span></div></div>');

    // Return the elements ...
    return objAsterisk;
}

// **************************************************************************
// FUNCTION: SetDefaultCoordinateSystemWhenNotSet
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.SetDefaultCoordinateSystemWhenNotSet = function SetDefaultCoordinateSystemWhenNotSet() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the shape has no spatial reference ...
    if (objShapeEditor.Shape.SpatialReferenceID == SD.Guid.Shared.Empty()) {

        // When we have any commonly used spatial references ...
        if ((typeof objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs != 'undefined') &&
            (objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs != null) &&
            (objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs.length > 0)) {

            // Set to the first commonly used spatial reference ...
            objShapeEditor.Shape.SpatialReferenceID = objShapeEditor.Options.CommonlyUsedSpatialReferenceIDs[0];

        } else {

            // Set the spatial reference ID on the shape to the spatial reference of the map ...
            objShapeEditor.Shape.SpatialReferenceID = objShapeEditor.MapController.CurrentMap.SpatialReferenceID;
        }

        // Change the coordinate system drop down ...
        objShapeEditor.CoordinateSystemDropDown.val(objShapeEditor.Shape.SpatialReferenceID);

        // Set the selected coordinate system name ...
        objShapeEditor.CoordinateSystemSpan.text(objShapeEditor.CoordinateSystemDropDown.find(':selected').text());

        // Get the default coordinate format for the spatial reference ...
        var enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID);

        // Change the coordinate formats on the coordinate list editors ...
        objShapeEditor.CoordinateListEditor.CoordinateFormat = enCoordinateFormat;
        if (objShapeEditor.ReferencePointCoordinateListEditor) { objShapeEditor.ReferencePointCoordinateListEditor.CoordinateFormat = enCoordinateFormat; }

        // Perform additional operations needed when the coordinate system changed ...
        objShapeEditor.CoordinateSystemChanged();
    }
}

// **************************************************************************
// FUNCTION: MergeParts
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.MergeParts = function MergeParts() {

    // Get the instance ...
    var objShapeEditor = this;

    // When not a point geometry ...
    if (objShapeEditor.Shape.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT) {

        // Merge the parts of the shape ...
        objShapeEditor.Shape.MergeParts(objShapeEditor.MapController, objShapeEditor.RemoveVerticesAlongStraightLine);

        // Replace the shape on the shape editor with the merged shape ...
        objShapeEditor.ReplaceShape(objShapeEditor.Shape);
    }
}

// **************************************************************************
// FUNCTION: DrawToAdd
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DrawToAdd = function DrawToAdd(objGeometryToAdd, guidGeometryToAddSpatialReference, arrExteriorPartIDsToIgnore, blnMergeToTouchingParts, blnRemoveCoordinatesFromStraightLine) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();
    var objAddShapePartDeferred = null;

    // Default blnRemoveCoordinatesFromStraightLine to true when not set ...
    if ((typeof blnRemoveCoordinatesFromStraightLine == 'undefined') || (blnRemoveCoordinatesFromStraightLine == null)) { blnRemoveCoordinatesFromStraightLine = true; }


    // Default arrExteriorPartIDsToIgnore to an empty array when not set ...
    if ((typeof arrExteriorPartIDsToIgnore == 'undefined') || (arrExteriorPartIDsToIgnore == null)) { arrExteriorPartIDsToIgnore = []; }

    // Default blnMergeToTouchingParts to false when not set ...
    if ((typeof blnMergeToTouchingParts == 'undefined') || (blnMergeToTouchingParts == null)) { blnMergeToTouchingParts = false; }

    // Set a default coordinate system when not set ...
    objShapeEditor.SetDefaultCoordinateSystemWhenNotSet();

    // Get the tolerance value to be used for the spatial reference of the shape ...
    var decOrdinateTolerance = TrimbleMap.Shape.Shared.ToleranceForStraighLineRemoval(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID);

    // Project to the spatial reference of the shape ...
    var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objGeometryToAdd,
        guidGeometryToAddSpatialReference,
        objShapeEditor.Shape.SpatialReferenceID,
        false);

    // When the projection completes ...
    objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objGeometry) {

        // When the geometry to add is a polygon ...
        if (objGeometryToAdd.type == 'polygon') {

            // Get the parts' geometries ...
            var dicPartGeometries = objShapeEditor.Shape.GetExteriorPartsGeometries(objShapeEditor.MapController);

            // Loop through all the exterior part IDs to ignore ...
            $.each(arrExteriorPartIDsToIgnore, function (intExteriorPartIDToIgnore, strExteriorPartIDToIgnore) {

                // When we have an exterior part geometry with the part id ...
                if (typeof dicPartGeometries[strExteriorPartIDToIgnore] != 'undefined') {

                    // Remove the part geometry from dicPartGeometries ...
                    delete dicPartGeometries[strExteriorPartIDToIgnore];
                }
            });

            // Create the esri spatial reference for the spatial reference id of the shape ...
            var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

            // Set the spatial reference of the input geometry (to avoid wkid - wkt mismatch problem) ...
            objGeometry.setSpatialReference(objEsriSpatialReference);

            // Get the ID's of the parts that overlaps, contains or are within the drawn geometry ...
            var arrPartIDsThatOverlaps = TrimbleMap.Shape.Shared.PartsThatOverlaps(dicPartGeometries, objGeometry);
            var arrPartIDsThatContains = TrimbleMap.Shape.Shared.PartsThatContains(dicPartGeometries, objGeometry);
            var arrPartIDsWithin = TrimbleMap.Shape.Shared.PartsWithin(dicPartGeometries, objGeometry);

            // Create an array for the part IDs that are equal ...
            var arrPartsIDsThatAreEqual = [];

            // Loop through all the part IDs that contains ...
            $.each(arrPartIDsThatContains, function (intPart, strPartID) {

                // Add it to the list of equal parts when also within ...
                if ($.inArray(strPartID, arrPartIDsWithin) > -1) { arrPartsIDsThatAreEqual.push(strPartID); }
            });

            // Remove all the part IDs for the parts that are equal to the drawn geometry from the arrays for part IDs that contain and are within ...
            arrPartIDsThatContains = $.grep(arrPartIDsThatContains, function (strPartID, intPart) { return ($.inArray(strPartID, arrPartsIDsThatAreEqual) < 0); });
            arrPartIDsWithin = $.grep(arrPartIDsWithin, function (strPartID, intPart) { return ($.inArray(strPartID, arrPartsIDsThatAreEqual) < 0); });

            // Add IDs of the parts to join to a single array ...
            var arrPartIDsToJoinTo = arrPartIDsThatOverlaps.concat(arrPartIDsThatContains).concat(arrPartIDsWithin);

            // When we are to the merge to touching parts ...
            if (blnMergeToTouchingParts) {

                // Get the part ids that touches ...
                var arrPartIDsThatTouches = TrimbleMap.Shape.Shared.PartsThatTouchesAsLines(dicPartGeometries, objGeometry);

                // Remove all the part IDs for the parts that are equal to the drawn geometry from the arrays ...
                arrPartIDsThatTouches = $.grep(arrPartIDsThatTouches, function (strPartID, intPart) { return ($.inArray(strPartID, arrPartsIDsThatAreEqual) < 0); });
                arrPartIDsThatTouches = $.grep(arrPartIDsThatTouches, function (strPartID, intPart) { return ($.inArray(strPartID, arrPartIDsToJoinTo) < 0); });

                // Add IDs to the arra of part IDs to join to ...
                arrPartIDsToJoinTo = arrPartIDsToJoinTo.concat(arrPartIDsThatTouches);
            }

            // When we have parts to join to ...
            if (arrPartIDsToJoinTo.length > 0) {

                // Get the Parts for the part IDs to join to ...
                var arrPartsToJoin = $.map(arrPartIDsToJoinTo, function (strPartIDToJoinTo, intPartIDToJoinTo) { return objShapeEditor.Shape.GetPartByID(strPartIDToJoinTo); });

                // Create a new empty hashtable for all the interior parts ...
                var dicInteriorPartGeometries = [];

                // Loop through all the part to join ...
                $.each(arrPartsToJoin, function (intPartToJoinTo, objPartToJoinTo) {

                    // Get the interior part geometries and add it to dicInteriorPartGeometries ...
                    dicInteriorPartGeometries = $.extend({}, dicInteriorPartGeometries, objShapeEditor.Shape.GetInteriorPartsGeometries(objShapeEditor.MapController, objPartToJoinTo));
                });

                // Get the ID's of the interior parts that overlaps, contains or are within the drawn geometry ...
                var arrInteriorPartIDsThatOverlaps = TrimbleMap.Shape.Shared.PartsThatOverlaps(dicInteriorPartGeometries, objGeometry);
                var arrInteriorPartIDsThatContains = TrimbleMap.Shape.Shared.PartsThatContains(dicInteriorPartGeometries, objGeometry);
                var arrInteriorPartIDsWithin = TrimbleMap.Shape.Shared.PartsWithin(dicInteriorPartGeometries, objGeometry);

                // When we are to merge to touching parts ...
                if (blnMergeToTouchingParts) {

                    // Get the interior part ids that touches ...
                    var arrInteriorPartIDsThatTouches = TrimbleMap.Shape.Shared.PartsThatTouchesAsLines(dicInteriorPartGeometries, objGeometry);

                    // Remove all the part ids for the parts that touches from the array of part ids for the parts that contains the drawn geometry ... 
                    arrInteriorPartIDsThatContains = $.grep(arrInteriorPartIDsThatContains, function (strPartID, intPart) { return ($.inArray(strPartID, arrInteriorPartIDsThatTouches) < 0); });

                    // Add the part ids for the parts that touches to the array of id that overlaps the drawn geometries ...
                    arrInteriorPartIDsThatOverlaps = arrInteriorPartIDsThatOverlaps.concat(arrInteriorPartIDsThatTouches);
                }

                // When the drawn geometry is completely contained within an interior part ...
                if (arrInteriorPartIDsThatContains.length > 0) {

                    // Map the interior part IDs to their exterior part IDs ...
                    var arrMoreExteriorPartIDsToIgnore = $.map(arrInteriorPartIDsThatContains, function (strInteriorPartID, intInteriorPartID) {

                        // Get the exerior part for the interior part ...
                        var objExteriorPart = objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapeEditor.Shape.GetPartByID(strInteriorPartID));

                        // Return the part ID to be included in the array ...
                        return objExteriorPart.ID;
                    });

                    // Add the exterior part IDs to igonre that we already have ...
                    arrMoreExteriorPartIDsToIgnore = arrMoreExteriorPartIDsToIgnore.concat(arrExteriorPartIDsToIgnore);

                    // Perform the draw to add operation again with the additional exterior part IDs to ignore ...
                    objShapeEditor.DrawToAdd(objGeometry, objShapeEditor.Shape.SpatialReferenceID, arrMoreExteriorPartIDsToIgnore, blnMergeToTouchingParts);

                } else {

                    // Create a geometry to contain all the parts to join to ...
                    var objPartsToJoinGeometry = new esri.geometry.Polygon(objGeometry.spatialReference);

                    // Loop through the parts to join too ...
                    $.each(arrPartsToJoin, function (intPart, objPart) {

                        // Loop through all the rings (add one at a time) ...
                        $.each(dicPartGeometries[objPart.ID].rings, function (intRing, arrRingPoints) { objPartsToJoinGeometry.addRing(arrRingPoints); });
                    });

                    // Split the interior and exterior rings ...
                    var objSplitRings = TrimbleMap.Geometry.Shared.SplitExteriorAndInteriorRings(objPartsToJoinGeometry);

                    // Set an exterior when we have one as the part to join to, otherwise just join to the first one ...
                    var intPartToJoinTo = (objSplitRings.ExteriorRingIndexes.length > 0) ? objSplitRings.ExteriorRingIndexes[0] : 0;

                    // Create a new object to hold the exterior parts that overlaps ...
                    var objOverlappingExteriorPartGeometries = {};

                    // Loop through the parts to join too ...
                    $.each(arrPartsToJoin, function (intPart, objPart) {

                        // Add the part's geometry to objOverlappingExteriorPartGeometries (when not the part to join to) ...
                        if (intPart != intPartToJoinTo) { objOverlappingExteriorPartGeometries[objPart.ID] = dicPartGeometries[objPart.ID]; }
                    });

                    // Set to join to the first part ...
                    var objPartToJoinTo = arrPartsToJoin[intPartToJoinTo];

                    // Convert the parts to join to to esri geometries ...
                    var arrGeometriesToUnion = $.map(arrPartsToJoin, function (objPartToJoin, intPartsToJoin) { return TrimbleMap.ShapePart.Shared.EsriGeometryFromCoordinates(objPartToJoin.Coordinates, objGeometry.spatialReference, objShapeEditor.Shape.GeometryType); });

                    // Add the drawn geometry to the array of geometries to join to ...
                    arrGeometriesToUnion.push(objGeometry);

                    // Union all the geometries ...
                    var objUnionedEsriGeometry = esri.geometry.geometryEngine.union(arrGeometriesToUnion);

                    // Create a new array for the removed parts to join ...
                    var arrRemovedPartIDsToJoin = [];

                    // Cut the drawn geometry from all the interior parts that the drawn geometry overlaps with ...
                    $.each(arrInteriorPartIDsThatOverlaps, function (intInteriorPartID, strInteriorPartID) {

                        // Get the interior part ...
                        var objInteriorPart = objShapeEditor.Shape.GetPartByID(strInteriorPartID);

                        // Get the interior part's geometry ...
                        var objInteriorPartEsriGeometry = TrimbleMap.ShapePart.Shared.EsriGeometryFromCoordinates(objInteriorPart.Coordinates, objGeometry.spatialReference, objShapeEditor.Shape.GeometryType);

                        // Find all the overlapping exterior part geometries inside the interior part ...
                        var arrExteriorPartIDsInsideInteriorPart = TrimbleMap.Shape.Shared.PartsWithin(objOverlappingExteriorPartGeometries, objInteriorPartEsriGeometry);

                        // Create an array with the geometry to draw to add ...
                        var arrInteriorExteriorEsriGeometriesToUnion = [objGeometry];

                        // Loop through the overlapping exterior part geometries inside the interior part ...
                        $.each(arrExteriorPartIDsInsideInteriorPart, function (intExteriorPartIDInsideInteriorPart, strExteriorPartIDInsideInteriorPart) {

                            // Add to the array of geometries to union ...
                            arrInteriorExteriorEsriGeometriesToUnion.push(objOverlappingExteriorPartGeometries[strExteriorPartIDInsideInteriorPart]);

                            // When not already removed ...
                            if ($.inArray(strExteriorPartIDInsideInteriorPart, arrRemovedPartIDsToJoin) < 0) {

                                // Get the exterior part ...
                                var objExteriorPartIDInsideInteriorPart = objShapeEditor.Shape.GetPartByID(strExteriorPartIDInsideInteriorPart);

                                // Remove the shape part completely ...
                                objShapeEditor.RemoveShapePart(objExteriorPartIDInsideInteriorPart, true, false);

                                // Add to the array of removed parts ...
                                arrRemovedPartIDsToJoin.push(strExteriorPartIDInsideInteriorPart);

                                // When we have interior parts ...
                                if ((typeof objExteriorPartIDInsideInteriorPart.InteriorParts != 'undefined') && (objExteriorPartIDInsideInteriorPart.InteriorParts != null)) {

                                    // Loop through the interior parts ...
                                    $.each(objExteriorPartIDInsideInteriorPart.InteriorParts, function (intInteriorPart, objInteriorPart) {

                                        // Add as interior part to the part that we joined too ...
                                        objAddShapePartDeferred = objShapeEditor.AddShapePart(objInteriorPart.Coordinates, objPartToJoinTo, objInteriorPart.ID, objInteriorPart.PartName);
                                    });
                                }
                            }
                        });

                        // Union all the geometries ...
                        var objUnionedInteriorExteriorEsriGeometry = esri.geometry.geometryEngine.union(arrInteriorExteriorEsriGeometriesToUnion);

                        // Substract the drawn geometry from the interior part's geometry ...
                        objInteriorPartEsriGeometry = esri.geometry.geometryEngine.difference(objInteriorPartEsriGeometry, objUnionedInteriorExteriorEsriGeometry);

                        // When the interior part geometry has not been clipped away completely ...
                        if (objInteriorPartEsriGeometry != null) {

                            // Update the coordinates of the interior part ...
                            objShapeEditor.UpdateShapePart(objInteriorPart, TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objInteriorPartEsriGeometry, 0, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance));

                            // Loop through all the other rings ...
                            for (var intRing = 1; intRing < objInteriorPartEsriGeometry.rings.length; intRing++) {

                                // Get the ring's coordinates and add a new interior part with it ...
                                objAddShapePartDeferred = objShapeEditor.AddShapePart(TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objInteriorPartEsriGeometry, intRing, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance), objPartToJoinTo);
                            }

                        } else {

                            // Remove the interior part completely ...
                            objShapeEditor.RemoveShapePart(objInteriorPart, true, true);
                        }
                    });

                    // Remove all the interior parts that are completely within the drawn geometry ...
                    $.each(arrInteriorPartIDsWithin, function (intInteriorPartID, strInteriorPartID) {

                        // Get the part (might return null when the part has already been removed - in the scenario where the drawn part is equal to an interior part) ...
                        var objPartToRemove = objShapeEditor.Shape.GetPartByID(strInteriorPartID);

                        // Remove the part when found ...
                        if (objPartToRemove != null) { objShapeEditor.RemoveShapePart(objPartToRemove, true, false); }
                    });

                    // Create a new array for the interior parts to add to the joined to exterior part ...
                    var arrInteriorPartsToAddToJoinedToPart = [];

                    // Loop through the exterior parts that we did not join to ...
                    $.each(arrPartsToJoin, function (intPartToJoin, objPartToJoin) {

                        // When not the part we joined to and when we've not removed the part already ...
                        if ((intPartToJoin != intPartToJoinTo) && ($.inArray(objPartToJoin.ID, arrRemovedPartIDsToJoin) < 0)) {

                            // Add the interior parts to arrInteriorPartsToAddToJoinedToPart so that we can add it back later on ...
                            if ((typeof objPartToJoin.InteriorParts != 'undefined') && objPartToJoin.InteriorParts) { arrInteriorPartsToAddToJoinedToPart = arrInteriorPartsToAddToJoinedToPart.concat(objPartToJoin.InteriorParts); }

                            // Remove the part that we joined to ...
                            objShapeEditor.RemoveShapePart(objPartToJoin, true, false);
                        }
                    });

                    // Find the exterior ring index ...
                    var intExteriorRingIndex = TrimbleMap.ShapeEditor.Shared.FindSingleExteriorRingIndex(objUnionedEsriGeometry);

                    // Update the coordinates of the part to join to from the unioned geometry ...
                    objShapeEditor.UpdateShapePart(objPartToJoinTo, TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objUnionedEsriGeometry, intExteriorRingIndex, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance));

                    // Loop through all the other rings ...
                    for (var intRing = 0; intRing < objUnionedEsriGeometry.rings.length; intRing++) {

                        // When not the exterior ring ...
                        if (intRing != intExteriorRingIndex) {
                            var arrInteriorCoordinates = TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objUnionedEsriGeometry, intRing, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance);

                            if (arrInteriorCoordinates && arrInteriorCoordinates.length > 2) {
                                // Add the coordinates as a new interior part with it ...
                                objAddShapePartDeferred = objShapeEditor.AddShapePart(arrInteriorCoordinates, objPartToJoinTo);
                            }
                        }
                    }

                    // Add the remaining interior parts to the exterior part that has been joined to ...
                    $.each(arrInteriorPartsToAddToJoinedToPart, function (strInteriorPartID, objInteriorPart) { objAddShapePartDeferred = objShapeEditor.AddShapePart(objInteriorPart.Coordinates, objPartToJoinTo); });
                }

            } else {

                // Add a new part with the coordinates from the drawn geometry ...
                objAddShapePartDeferred = objShapeEditor.AddShapePart(TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objGeometry, 0, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance));
            }


        } else {

            // Get the path or point's coordinates and add a new part with it ...
            objAddShapePartDeferred = objShapeEditor.AddShapePart(TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objGeometry, 0, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance), null);
        }

        // Update the inteface for the shape change ...
        objShapeEditor.UpdateForShapeChange();

        if (objAddShapePartDeferred) {
            objAddShapePartDeferred.then(function () {
                objDeferred.resolve();
            }, function () {
                objDeferred.reject();
            });
        } else {
            // Resolve the deferred 
            objDeferred.resolve();
        }

    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

        // When it's a measures out of bounds exception ...
        if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

            // Get the spatial reference of the shape ...
            var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

            // Set the translations ...

            // Not valid in selected coordinate system
            var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NotValidInCoordinateSystemTitle');

            // The polygon you have drawn is not valid in %1
            var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NotValidInCoordinateSystemMessage', objSpatialReference.Name);

            // Notify the user tha the part has no coordinates ...
            TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

            // Reject the deferred ...
            objDeferred.reject();
        }
    }));

    return objDeferred;
}

// **************************************************************************
// FUNCTION: PartsThatTouchesFromInside
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.PartsThatTouchesFromInside = function PartsThatTouchesFromInside(arrPartIDs, objGeometry, dicPartGeometries) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new array to return ...
    var arrPartIDsThatTouchesFromInside = [];

    // Loop though all the parts that are contained within the geometry ...
    $.each(arrPartIDs, function (intPart, strPartID) {

        // Get the part geometry ...
        var objPartGeometry = dicPartGeometries[strPartID];

        // Substract the drawn geometry from the part's geometry ...
        var objDifferenceGeometry = esri.geometry.geometryEngine.difference(objPartGeometry, objGeometry);

        // Start with no equal part found ...
        var blnHoleFound = false;

        // When we have rings ...
        if ((typeof objDifferenceGeometry != 'undefined') && (objDifferenceGeometry != null) && (typeof objDifferenceGeometry.rings != 'undefined') && (objDifferenceGeometry.rings != null)) {

            // Loop through all the rings ...
            $.each(objDifferenceGeometry.rings, function (intRing, objRing) {

                // Create a polygon ...
                var objPolygon = new esri.geometry.Polygon(objGeometry.spatialReference);

                // Add the ring to the polygon ...
                objPolygon.addRing(objRing);

                // When the ring does not equal the clipped geometry ...
                if (esri.geometry.geometryEngine.planarArea(objPolygon) < 0) {

                    // Set to have found an equal part ...
                    blnHoleFound = true;

                    // Stop checking when a hole were found ...
                    if (blnHoleFound) { return false; }
                }
            });

            // When no hole were found ...
            if (!blnHoleFound) {

                // Add the part ID to the return array ...
                arrPartIDsThatTouchesFromInside.push(strPartID);
            }

        } else {

            // Add the part ID to the return array ...
            arrPartIDsThatTouchesFromInside.push(strPartID);
        }
    });

    return arrPartIDsThatTouchesFromInside;
}

// **************************************************************************
// FUNCTION: DrawToRemove
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DrawToRemove = function DrawToRemove(objGeometryToRemove, guidGeometryToRemoveSpatialReference, blnRemoveCoordinatesFromStraightLine) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();
    var arrAddShapePartDeferred = [];

    // Default blnRemoveCoordinatesFromStraightLine to true when not set ...
    if ((typeof blnRemoveCoordinatesFromStraightLine == 'undefined') || (blnRemoveCoordinatesFromStraightLine == null)) { blnRemoveCoordinatesFromStraightLine = true; }

    // When the geometry to remove is a polygon ...
    if (objGeometryToRemove.type == 'polygon') {

        // Set a default coordinate system when not set ...
        objShapeEditor.SetDefaultCoordinateSystemWhenNotSet();

        // Get the tolerance value to be used for the spatial reference of the shape ...
        var decOrdinateTolerance = TrimbleMap.Shape.Shared.ToleranceForStraighLineRemoval(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID);

        // Project to the spatial reference of the shape ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objGeometryToRemove,
            guidGeometryToRemoveSpatialReference,
            objShapeEditor.Shape.SpatialReferenceID,
            false);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objGeometry) {

            // Get the parts' geometries ...
            var dicPartGeometries = objShapeEditor.Shape.GetExteriorPartsGeometries(objShapeEditor.MapController);

            // Create the esri spatial reference for the spatial reference id of the shape ...
            var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

            // Set the spatial reference of the input geometry (to avoid wkid - wkt mismatch problem) ...
            objGeometry.setSpatialReference(objEsriSpatialReference);

            // Get the ID's of the parts that overlaps, contains or are within the drawn geometry ...
            var arrPartIDsThatOverlaps = TrimbleMap.Shape.Shared.PartsThatOverlaps(dicPartGeometries, objGeometry);
            var arrPartIDsThatContains = TrimbleMap.Shape.Shared.PartsThatContains(dicPartGeometries, objGeometry);
            var arrPartIDsWithin = TrimbleMap.Shape.Shared.PartsWithin(dicPartGeometries, objGeometry);

            // Get the id of the parts that are contained but touches from the inside ...
            var arrPartIDsThatTouchesFromInside = objShapeEditor.PartsThatTouchesFromInside(arrPartIDsThatContains, objGeometry, dicPartGeometries);

            // Loop though all the parts that touches from the inside ...
            $.each(arrPartIDsThatTouchesFromInside, function (intPartIDThatOverlaps, strPartIDThatTouchesFromInside) {

                // Find the index of the part id in the arrPartIDsThatContains array ...
                var intPartIDsThatContains = $.inArray(strPartIDThatTouchesFromInside, arrPartIDsThatContains);

                // When found, remove it from the array ...
                if (intPartIDsThatContains > -1) { arrPartIDsThatContains.splice(intPartIDsThatContains, 1); }

                // Add the part id to the parts that overlap ...
                arrPartIDsThatOverlaps.push(strPartIDThatTouchesFromInside);
            });

            // Loop through all the part IDs of the parts that overlaps the drawn geometry ...
            $.each(arrPartIDsThatOverlaps, function (intPartIDThatOverlaps, strPartIDThatOverlaps) {

                // Get the part that overlaps ...
                var objPartThatOverlaps = objShapeEditor.Shape.GetPartByID(strPartIDThatOverlaps);

                // Get the interior part geometries of the exterior part ...
                var dicInteriorPartGeometries = objShapeEditor.Shape.GetInteriorPartsGeometries(objShapeEditor.MapController, objPartThatOverlaps);

                // Get the geometry of the part that overlaps ...
                var objPartThatOverlapsGeometry = objShapeEditor.Shape.GetPartGeometry(objShapeEditor.MapController, objPartThatOverlaps);

                // Substract the drawn geometry from the part's geometry ...
                objPartThatOverlapsGeometry = esri.geometry.geometryEngine.difference(objPartThatOverlapsGeometry, objGeometry);

                // Get all the part IDs of the interior parts that overlaps or are within the drawn geometry ...
                var arrInteriorPartIDsThatOverlaps = TrimbleMap.Shape.Shared.PartsThatOverlaps(dicInteriorPartGeometries, objGeometry);
                var arrInteriorPartIDsWithin = TrimbleMap.Shape.Shared.PartsWithin(dicInteriorPartGeometries, objGeometry);

                // Get the interior part IDs that touches ...
                var arrPartIDsThatTouches = TrimbleMap.Shape.Shared.PartsThatTouchesAsLines(dicInteriorPartGeometries, objGeometry);

                // Add IDs to the array of part IDs that overlaps ...
                arrInteriorPartIDsThatOverlaps = arrInteriorPartIDsThatOverlaps.concat(arrPartIDsThatTouches);

                // Loop through all the interior parts that overlap the drawn geometry ...
                $.each(arrInteriorPartIDsThatOverlaps, function (intInteriorPartID, strInteriorPartID) {

                    // Get the interior part's geometry ...
                    var objInteriorPartGeometry = dicInteriorPartGeometries[strInteriorPartID];

                    // Substract the interior part geometry from the part's geometry ...
                    objPartThatOverlapsGeometry = esri.geometry.geometryEngine.difference(objPartThatOverlapsGeometry, objInteriorPartGeometry);

                    // Remove the interior part ...
                    objShapeEditor.RemoveShapePart(objShapeEditor.Shape.GetPartByID(strInteriorPartID), true, false);
                });

                // Remove all the interior parts that are within the drawn geometry ...
                $.each(arrInteriorPartIDsWithin, function (intInteriorPartID, strInteriorPartID) { objShapeEditor.RemoveShapePart(objShapeEditor.Shape.GetPartByID(strInteriorPartID), true, false); });

                // When the difference was not an empty geometry ...
                if (objPartThatOverlapsGeometry != null) {

                    // Get the coordinates ...
                    var arrExteriorCoordinates = TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objPartThatOverlapsGeometry, 0, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance);

                    // When split into multiple parts and we have interior parts ...
                    if ((objPartThatOverlapsGeometry.rings.length > 1) && (typeof objPartThatOverlaps.InteriorParts != 'undefined') && (typeof objPartThatOverlaps.InteriorParts != null)) {

                        // Start with no arrInteriorPartsToAddBack ...
                        var arrInteriorPartsToAddBack = null;

                        // When the shape has interior parts ...
                        if ((typeof objPartThatOverlaps.InteriorParts != 'undefined') && (objPartThatOverlaps.InteriorParts != null)) {

                            // Clone the interior parts array ...
                            var arrInteriorPartsToAddBack = [].concat(objPartThatOverlaps.InteriorParts);

                            // Loop though all the interior parts ...
                            $.each(arrInteriorPartsToAddBack, function (intInteriorPart, objInteriorPart) {

                                // Remove the interior part ...
                                objShapeEditor.RemoveShapePart(objInteriorPart, true, false);
                            });
                        }

                        // Update the part's geometry with the first ring ...
                        objShapeEditor.UpdateShapePart(objPartThatOverlaps, arrExteriorCoordinates);

                        // Create a new array for the exterior parts to check (with the updated part) ...
                        var arrExteriorPartsToCheckDeferred = [];

                        // Loop through all the other rings ...
                        for (var intRing = 1; intRing < objPartThatOverlapsGeometry.rings.length; intRing++) {
                            let arrExteriorCoordinates = TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objPartThatOverlapsGeometry, intRing, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance);

                            if (arrExteriorCoordinates && arrExteriorCoordinates.length > 2) {
                                // Get the ring's coordinates and add a new part with it ...
                                arrExteriorPartsToCheckDeferred.push(objShapeEditor.AddShapePart(arrExteriorCoordinates));
                            }
                        }

                        // Create a hash table to hold the exterior parts geometries ...
                        var objExteriorPartGeometriesToCheck = {};

                        // Loop through all the exterior parts to check ...
                        new dojo.promise.all(arrExteriorPartsToCheckDeferred).then(TrimbleMap.Controller.Shared.TrapException(function (arrExteriorPartsToCheck) {

                            arrExteriorPartsToCheck.unshift(objPartThatOverlaps);
                            // Loop through all the exterior parts to check ...
                            $.each(arrExteriorPartsToCheck, function (intExteriorPartToCheck, objExteriorPartToCheck) {

                                // Get the part geometry and add it into the cache ...
                                objExteriorPartGeometriesToCheck[objExteriorPartToCheck.ID] = objShapeEditor.Shape.GetPartGeometry(objShapeEditor.MapController, objExteriorPartToCheck);
                            });
                        }));

                        // When the shape has interior parts ...
                        if (arrInteriorPartsToAddBack != null) {

                            // Loop through all the interior parts to add back ...
                            $.each(arrInteriorPartsToAddBack, function (intInteriorPartToAddBack, objInteriorPartToAddBack) {

                                // Get the geometry for the interior part to add back ...
                                var objInteriorPartToAddBackGeometry = objShapeEditor.Shape.GetPartGeometry(objShapeEditor.MapController, objInteriorPartToAddBack);

                                // Get the ID of the exterrior parts that contains the interiro part ...
                                var arrExteriorPartIDsThatContains = TrimbleMap.Shape.Shared.PartsThatContains(objExteriorPartGeometriesToCheck, objInteriorPartToAddBackGeometry);

                                // Get the exterior part ID to add too ...
                                var strExteriorPartIDToAddTo = arrExteriorPartIDsThatContains[0];

                                // Add it to the exterior part ...
                                arrAddShapePartDeferred.push(objShapeEditor.AddShapePart(objInteriorPartToAddBack.Coordinates, objShapeEditor.Shape.GetPartByID(strExteriorPartIDToAddTo), objInteriorPartToAddBack.ID, objInteriorPartToAddBack.PartName));
                            });
                        }

                    } else {

                        // Update the part's geometry with the ring ...
                        objShapeEditor.UpdateShapePart(objPartThatOverlaps, arrExteriorCoordinates);
                    }

                } else {

                    // Remove the shape part completely ...
                    objShapeEditor.RemoveShapePart(objPartThatOverlaps, true, false);
                }
            });

            // Loop through all the part IDs of the parts that are within the drawn geometry ...
            $.each(arrPartIDsWithin, function (intPartIDWithin, strPartIDWithin) {

                // Get the part to remove ...
                var objPartToRemove = objShapeEditor.Shape.GetPartByID(strPartIDWithin);

                // Remove the shape part completely when it still exists ...
                if (objPartToRemove != null) { objShapeEditor.RemoveShapePart(objPartToRemove, true, false); }
            });

            // Loop through all the part IDs of the parts that contains the drawn geometry ...
            $.each(arrPartIDsThatContains, function (intPartIDThatContains, strPartIDThatContains) {

                // When the part is not also within the drawn geometry (which would mean that the part
                // is exactly the same as the drawn geometry and already removed in previous step) ...
                if ($.inArray(strPartIDThatContains, arrPartIDsWithin) < 0) {

                    // Get the part that contains the drawn geometry ...
                    var objPartThatContains = objShapeEditor.Shape.GetPartByID(strPartIDThatContains);

                    // Get the interior part geometries of the exterior part ...
                    var dicInteriorPartGeometries = objShapeEditor.Shape.GetInteriorPartsGeometries(objShapeEditor.MapController, objPartThatContains);

                    // Get all the part IDs of the interior parts that overlaps the drawn geometry ...
                    var arrInteriorPartIDsThatOverlaps = TrimbleMap.Shape.Shared.PartsThatOverlaps(dicInteriorPartGeometries, objGeometry);
                    var arrInteriorPartIDsThatContains = TrimbleMap.Shape.Shared.PartsThatContains(dicInteriorPartGeometries, objGeometry);
                    var arrInteriorPartIDsWithin = TrimbleMap.Shape.Shared.PartsWithin(dicInteriorPartGeometries, objGeometry);

                    // Get the part ids that touches ...
                    var arrInteriorPartIDsThatTouches = TrimbleMap.Shape.Shared.PartsThatTouchesAsLinesFromTheOutside(dicInteriorPartGeometries, objGeometry);

                    // Add IDs to the arra of part IDs to join to ...
                    arrInteriorPartIDsThatOverlaps = arrInteriorPartIDsThatOverlaps.concat(arrInteriorPartIDsThatTouches);

                    // Create an array with the interior parts to join to ...
                    var arrInteriorPartsIDsToJoinTo = arrInteriorPartIDsThatOverlaps.concat(arrInteriorPartIDsWithin);

                    // When any interior parts overlaps or are within the drawn geometry ...
                    if (arrInteriorPartsIDsToJoinTo.length > 0) {

                        // Get all the parts for the part IDs ...
                        var arrInteriorPartsToJoinTo = $.map(arrInteriorPartsIDsToJoinTo, function (strInteriorPartID, intInteriorPartID) { return objShapeEditor.Shape.GetPartByID(strInteriorPartID); });

                        // Set to join to the first part ...
                        var objInteriorPartToJoinTo = arrInteriorPartsToJoinTo[0];

                        // Convert the interior parts to join to to esri geoemtries ...
                        var arrGeometriesToUnion = $.map(arrInteriorPartsToJoinTo, function (objInteriorPart, strInteriorPartID) { return TrimbleMap.ShapePart.Shared.EsriGeometryFromCoordinates(objInteriorPart.Coordinates, objGeometry.spatialReference, objShapeEditor.Shape.GeometryType); });

                        // Add the drawn geometry to the array of geometries to join to ...
                        arrGeometriesToUnion.push(objGeometry);

                        // Union all the geometries ...
                        var objUnionedEsriGeometry = esri.geometry.geometryEngine.union(arrGeometriesToUnion);

                        // Remove the parts that has been joined in ...
                        $.each(arrInteriorPartsToJoinTo, function (intInteriorPartToJoin, objInteriorPartToJoin) { if (intInteriorPartToJoin > 0) { objShapeEditor.RemoveShapePart(objInteriorPartToJoin, true, false); } });

                        // Update the coordinates of the part to join to from the unioned geometry ...
                        objShapeEditor.UpdateShapePart(objInteriorPartToJoinTo, TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objUnionedEsriGeometry, 0, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance), objPartThatContains);

                        // Loop through all the other rings ...
                        for (var intRing = 1; intRing < objUnionedEsriGeometry.rings.length; intRing++) {
                            let arrInteriorCoordinates = TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objUnionedEsriGeometry, intRing, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance);

                            if (arrInteriorCoordinates && arrInteriorCoordinates.length > 2) {
                                // Get the ring's coordinates and add a new part with it ...
                                arrAddShapePartDeferred.push(objShapeEditor.AddShapePart(arrInteriorCoordinates));
                            }
                        }

                        // Otherwise when none of the interior parts contains the drawn geometry ...
                    } else if (arrInteriorPartIDsThatContains.length == 0) {
                        let arrInteriorCoordinates = TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry(objGeometry, 0, blnRemoveCoordinatesFromStraightLine, decOrdinateTolerance);

                        if (arrInteriorCoordinates && arrInteriorCoordinates.length > 2) {
                            // Add a new interior part with the coordinates from the drawn geometry ...
                            arrAddShapePartDeferred.push(objShapeEditor.AddShapePart(arrInteriorCoordinates, objPartThatContains));
                        }
                    }
                }
            });

            // Update the inteface for the shape change ...
            objShapeEditor.UpdateForShapeChange();

            if (arrAddShapePartDeferred.length > 0) {
                new dojo.promise.all(arrAddShapePartDeferred).then(function () {
                    objDeferred.resolve();
                }, function () {
                    objDeferred.reject();
                });
            } else {
                // Resolve the deferred 
                objDeferred.resolve();
            }

        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

            // When it's a measures out of bounds exception ...
            if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

                // Get the spatial reference of the shape ...
                var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

                // Set the translations ...

                // Not valid in selected coordinate system
                var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NotValidInCoordinateSystemTitle');

                // The polygon you have drawn is not valid in %1
                var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NotValidInCoordinateSystemMessage', objSpatialReference.Name);

                // Notify the user tha the part has no coordinates ...
                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);

                // Reject the deferred ...
                objDeferred.reject();
            }
        }));

    } else { objDeferred.resolve(); }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: DrawToAddMultiPart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DrawToAddMultiPart = function DrawToAddMultiPart(objGeometryToAdd, guidGeometryToAddSpatialReference, blnMergeToTouchingParts, blnRemoveCoordinatesFromStraightLine) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // Default blnMergeToTouchingParts to false when not set ...
    if ((typeof blnMergeToTouchingParts == 'undefined') || (blnMergeToTouchingParts == null)) { blnMergeToTouchingParts = false; }

    // When a polygon with more than one ring ...
    if ((objGeometryToAdd.type == 'polygon') && (objGeometryToAdd.rings.length > 1)) {

        // Set a default coordinate system on the shape editor when not set ...
        objShapeEditor.SetDefaultCoordinateSystemWhenNotSet();

        // Project to the spatial reference of the shape on the shape editor ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objGeometryToAdd,
            guidGeometryToAddSpatialReference,
            objShapeEditor.Shape.SpatialReferenceID,
            false);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedGeometry) {

            // Build an esri polygon for the shape ...
            var objShapeGeometry = objShapeEditor.Shape.ToEsriPolygon(objShapeEditor.MapController);

            // Split the the interior and exterior rings ...
            var objSplitRings = TrimbleMap.Geometry.Shared.SplitExteriorAndInteriorRings(objProjectedGeometry);

            // Map the rings to polygons containing the rings (remove the shape from each of the interior rings) ...
            objSplitRings.ExteriorRings = $.map(objSplitRings.ExteriorRings, function (arrRingPoints, intRing) { return TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objProjectedGeometry.spatialReference); });
            objSplitRings.InteriorRings = $.map(objSplitRings.InteriorRings, function (arrRingPoints, intRing) { return esri.geometry.geometryEngine.difference(TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objProjectedGeometry.spatialReference), objShapeGeometry); });

            // Create an array for the pieces of the exterior rings to add back ...
            var arrExteriorRingsToAddBack = [];

            // Move the holes in interior rings to be exterior rings ...
            $.each(objSplitRings.InteriorRings, function (intInteriorRing, objInteriorRingGeometry) {

                // When more than one ring ...
                if (objInteriorRingGeometry.rings.length > 1) {

                    // Split the exterior and interior rings ...
                    var objSplitRingsForInteriorPart = TrimbleMap.Geometry.Shared.SplitExteriorAndInteriorRings(objInteriorRingGeometry);

                    // Create a new exterior ring for each interior ring of the interior geometry ...
                    $.each(objSplitRingsForInteriorPart.InteriorRings, function (intRing, arrRingPoints) { arrExteriorRingsToAddBack.push(TrimbleMap.Geometry.Shared.PolygonFromRing(TrimbleMap.Geometry.Shared.FixRingOrientation(arrRingPoints, TrimbleMap.Shape.enumInteriorOrExterior.Exterior), objProjectedGeometry.spatialReference)); });

                    // Create an array for the interior ring geometry's rings ...
                    var arrInteriorRingGeometryRings = [];

                    // Add each exterior ring to the interior ring geometry ...
                    $.each(objSplitRingsForInteriorPart.ExteriorRings, function (intRing, arrRingPoints) { arrInteriorRingGeometryRings.push(arrRingPoints); });

                    // Set the rings on the interior geometry ...
                    objInteriorRingGeometry.rings = arrInteriorRingGeometryRings;
                }
            });

            // Create a new array to hold functions that will update the shape ...
            var arrUpdateFunctions = [];

            // Add each of the exterior rings to the shape in the shape editor ...
            $.each(objSplitRings.ExteriorRings, function (intExteriorRing, objExteriorRingGeometry) {

                // When we have only 1 ring ...
                if (objExteriorRingGeometry.rings.length == 1) {

                    // Draw to add the geometry on the shape editor ...
                    arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToAddCall(objShapeEditor, objExteriorRingGeometry, objShapeEditor.Shape.SpatialReferenceID, blnMergeToTouchingParts, blnRemoveCoordinatesFromStraightLine));

                } else {

                    // Loop through all the rings ...
                    $.each(objExteriorRingGeometry.rings, function (intRing, arrRingPoints) {

                        // Draw to add the ring from the geometry on the shape editor ...
                        arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToAddCall(objShapeEditor, TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objExteriorRingGeometry.spatialReference), objShapeEditor.Shape.SpatialReferenceID, blnMergeToTouchingParts, blnRemoveCoordinatesFromStraightLine));
                    });
                }
            });

            // Remove each of the interior rings from the shape in the shape editor ...
            $.each(objSplitRings.InteriorRings, function (intInteriorRing, objInteriorRingGeometry) {

                // When we have only 1 ring ...
                if (objInteriorRingGeometry.rings.length == 1) {

                    // Draw to remove the geometry on the shape editor ...
                    arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToRemoveCall(objShapeEditor, objInteriorRingGeometry, objShapeEditor.Shape.SpatialReferenceID, blnRemoveCoordinatesFromStraightLine));

                } else {

                    // Loop through all the rings ...
                    $.each(objInteriorRingGeometry.rings, function (intRing, arrRingPoints) {

                        // Draw to add the ring from the geometry on the shape editor ...
                        arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToRemoveCall(objShapeEditor, TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objInteriorRingGeometry.spatialReference), objShapeEditor.Shape.SpatialReferenceID, blnRemoveCoordinatesFromStraightLine));
                    });
                }
            });

            // Add each of the exterior rings to the shape in the shape editor ...
            $.each(arrExteriorRingsToAddBack, function (intExteriorRing, objExteriorRingGeometry) {

                // When we have only 1 ring ...
                if (objExteriorRingGeometry.rings.length == 1) {

                    // Draw to add the geometry on the shape editor ...
                    arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToAddCall(objShapeEditor, objExteriorRingGeometry, objShapeEditor.Shape.SpatialReferenceID, blnMergeToTouchingParts, blnRemoveCoordinatesFromStraightLine));

                } else {

                    // Loop through all the rings ...
                    $.each(objExteriorRingGeometry.rings, function (intRing, arrRingPoints) {

                        // Draw to add the ring from the geometry on the shape editor ...
                        arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToAddCall(objShapeEditor, TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objExteriorRingGeometry.spatialReference), objShapeEditor.Shape.SpatialReferenceID, blnMergeToTouchingParts, blnRemoveCoordinatesFromStraightLine));
                    });
                }
            });

            // Call the update functions sequentially ...
            TrimbleMap.Controller.Shared.CallDeferredFunctionSequentially(arrUpdateFunctions);

            // Resolve the deferred 
            objDeferred.resolve();
        }));
    } else {

        // Ensure correct the ring orientation when a polygon ...
        var objFixedGeometry = (objGeometryToAdd.type == 'polygon') ?
            TrimbleMap.Geometry.Shared.FixPolygonRingOrientation(objGeometryToAdd, 0, TrimbleMap.Shape.enumInteriorOrExterior.Exterior) :
            objGeometryToAdd;

        // Add the shape to the shape in the shape editor ...
        var objDrawToAddDeferred = objShapeEditor.DrawToAdd(objFixedGeometry, guidGeometryToAddSpatialReference, null, blnMergeToTouchingParts, blnRemoveCoordinatesFromStraightLine);

        objDrawToAddDeferred.then(function () {
            // Resolve the deferred 
            objDeferred.resolve();
        }, function () {
            objDeferred.reject();
        });
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: DrawToRemoveMultiPart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DrawToRemoveMultiPart = function DrawToRemoveMultiPart(objGeometryToRemove, guidGeometryToRemoveSpatialReference, blnRemoveCoordinatesFromStraightLine) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When a polygon with more than one ring ...
    if ((objGeometryToRemove.type == 'polygon') && (objGeometryToRemove.rings.length > 1)) {

        // Set a default coordinate system on the shape editor when not set ...
        objShapeEditor.SetDefaultCoordinateSystemWhenNotSet();

        // Project to the spatial reference of the shape on the shape editor ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objGeometryToRemove,
            guidGeometryToRemoveSpatialReference,
            objShapeEditor.Shape.SpatialReferenceID,
            false);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedGeometry) {

            // Build an esri polygon for the shape ...
            var objShapeGeometry = objShapeEditor.Shape.ToEsriPolygon(objShapeEditor.MapController);

            // Split the the interior and exterior rings ...
            var objSplitRings = TrimbleMap.Geometry.Shared.SplitExteriorAndInteriorRings(objProjectedGeometry);

            // Map the rings to polygons containing the rings (remove the shape from each of the interior rings) ...
            objSplitRings.ExteriorRings = $.map(objSplitRings.ExteriorRings, function (arrRingPoints, intRing) { return TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objProjectedGeometry.spatialReference); });
            objSplitRings.InteriorRings = $.map(objSplitRings.InteriorRings, function (arrRingPoints, intRing) { return esri.geometry.geometryEngine.intersect(TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objProjectedGeometry.spatialReference), objShapeGeometry); });

            // Create an array for the pieces of the exterior rings to add back ...
            var arrInteriorRingsToRemoveAfterwards = [];

            // Move the holes in interior rings to be exterior rings ...
            $.each(objSplitRings.InteriorRings, function (intInteriorRing, objInteriorRingGeometry) {

                // When more than one ring ...
                if (objInteriorRingGeometry.rings.length > 1) {

                    // Split the exterior and interior rings ...
                    var objSplitRingsForInteriorPart = TrimbleMap.Geometry.Shared.SplitExteriorAndInteriorRings(objInteriorRingGeometry);

                    // Create a new exterior ring for each interior ring of the interior geometry ...
                    $.each(objSplitRingsForInteriorPart.InteriorRings, function (intRing, arrRingPoints) { arrInteriorRingsToRemoveAfterwards.push(TrimbleMap.Geometry.Shared.PolygonFromRing(TrimbleMap.Geometry.Shared.FixRingOrientation(arrRingPoints, TrimbleMap.Shape.enumInteriorOrExterior.Exterior), objProjectedGeometry.spatialReference)); });

                    // Create an array for the interior ring geometry's rings ...
                    var arrInteriorRingGeometryRings = [];

                    // Add each exterior ring to the interior ring geometry ...
                    $.each(objSplitRingsForInteriorPart.ExteriorRings, function (intRing, arrRingPoints) { arrInteriorRingGeometryRings.push(arrRingPoints); });

                    // Set the rings on the interior geometry ...
                    objInteriorRingGeometry.rings = arrInteriorRingGeometryRings;
                }
            });

            // Create a new array to hold functions that will update the shape ...
            var arrUpdateFunctions = [];

            // Add each of the exterior rings to the shape in the shape editor ...
            $.each(objSplitRings.ExteriorRings, function (intExteriorRing, objExteriorRingGeometry) {

                // When we have only 1 ring ...
                if (objExteriorRingGeometry.rings.length == 1) {

                    // Draw to add the geometry on the shape editor ...
                    arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToRemoveCall(objShapeEditor, objExteriorRingGeometry, objShapeEditor.Shape.SpatialReferenceID, blnRemoveCoordinatesFromStraightLine));

                } else {

                    // Loop through all the rings ...
                    $.each(objExteriorRingGeometry.rings, function (intRing, arrRingPoints) {

                        // Draw to add the ring from the geometry on the shape editor ...
                        arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToRemoveCall(objShapeEditor, TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objExteriorRingGeometry.spatialReference), objShapeEditor.Shape.SpatialReferenceID, blnRemoveCoordinatesFromStraightLine));
                    });
                }
            });

            // Remove each of the interior rings from the shape in the shape editor ...
            $.each(objSplitRings.InteriorRings, function (intInteriorRing, objInteriorRingGeometry) {

                // When we have only 1 ring ...
                if (objInteriorRingGeometry.rings.length == 1) {

                    // Draw to add the geometry on the shape editor ...
                    arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToAddCall(objShapeEditor, objInteriorRingGeometry, objShapeEditor.Shape.SpatialReferenceID, null, blnRemoveCoordinatesFromStraightLine));

                } else {

                    // Loop through all the rings ...
                    $.each(objInteriorRingGeometry.rings, function (intRing, arrRingPoints) {

                        // Draw to add the ring from the geometry on the shape editor ...
                        arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToAddCall(objShapeEditor, TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objInteriorRingGeometry.spatialReference), objShapeEditor.Shape.SpatialReferenceID, null, blnRemoveCoordinatesFromStraightLine));
                    });
                }
            });

            // Add each of the exterior rings to the shape in the shape editor ...
            $.each(arrInteriorRingsToRemoveAfterwards, function (intExteriorRing, objExteriorRingGeometry) {

                // When we have only 1 ring ...
                if (objExteriorRingGeometry.rings.length == 1) {

                    // Draw to remove the geometry on the shape editor ...
                    arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToRemoveCall(objShapeEditor, objExteriorRingGeometry, objShapeEditor.Shape.SpatialReferenceID, blnRemoveCoordinatesFromStraightLine));

                } else {

                    // Loop through all the rings ...
                    $.each(objExteriorRingGeometry.rings, function (intRing, arrRingPoints) {

                        // Draw to remove the ring from the geometry on the shape editor ...
                        arrUpdateFunctions.push(TrimbleMap.ShapeEditor.Shared.CreateDrawToRemoveCall(objShapeEditor, TrimbleMap.Geometry.Shared.PolygonFromRing(arrRingPoints, objExteriorRingGeometry.spatialReference), objShapeEditor.Shape.SpatialReferenceID, blnRemoveCoordinatesFromStraightLine));
                    });
                }
            });

            // Call the update functions sequentially ...
            TrimbleMap.Controller.Shared.CallDeferredFunctionSequentially(arrUpdateFunctions);
        }));

        objDeferred.resolve();
    } else {

        // Ensure correct the ring orientation when a polygon ...
        var objFixedGeometry = (objGeometryToRemove.type == 'polygon') ?
            TrimbleMap.Geometry.Shared.FixPolygonRingOrientation(objGeometryToRemove, 0, TrimbleMap.Shape.enumInteriorOrExterior.Exterior) :
            objGeometryToRemove;

        // Remove the geometry from the shape on the shape editor ...
        var objDrawToRemoveDeferred = objShapeEditor.DrawToRemove(objFixedGeometry, guidGeometryToRemoveSpatialReference);

        objDrawToRemoveDeferred.then(function () {
            // Resolve the deferred 
            objDeferred.resolve();
        }, function () {
            objDeferred.reject();
        });
    }

    return objDeferred;
}

// **************************************************************************
// FUNCTION: AddReferencePoint
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AddReferencePoint = function AddReferencePoint(objReferencePoint, blnSelectReferencePoint) {
    let objShapeEditor = this;

    var objReferencePointDiv = objShapeEditor.CreateReferencePointDiv(objReferencePoint, objShapeEditor.CoordinatesEditable);

    objShapeEditor.AddReferencePointDiv(objReferencePointDiv, objReferencePoint, true);

    if (blnSelectReferencePoint) {

        objShapeEditor.SelectReferencePoint(objReferencePoint, true);
        objShapeEditor.ReferencePointCoordinateListEditor.ActivateCoordinate(0);
        objShapeEditor.ToggleEditFocus(true);

    } else {

        objShapeEditor.DisplayReferencePointGraphic(objReferencePoint);
    }
}

// **************************************************************************
// FUNCTION: RemoveReferencePoint
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.RemoveReferencePoint = function RemoveReferencePoint(objReferencePoinToDelete, objReferencePointDiv) {

    // Get the instance ...
    var objShapeEditor = this;

    // When it is the selected reference point ...
    if (objShapeEditor.SelectedReferencePoint == objReferencePoinToDelete) {

        // Un-select it ...
        objShapeEditor.UnSelectReferencePoint(false);
    }

    // Set to not have values for the reference point ...
    objReferencePoinToDelete.X = SD.Number.NULL_NUMBER;
    objReferencePoinToDelete.Y = SD.Number.NULL_NUMBER;
    objReferencePoinToDelete.HasValues = false;

    // Remove it from the reference point divs hash table ...
    delete objShapeEditor.ReferencePointDivs[objReferencePoinToDelete.ID];

    // remove it from the it to the reference point items div ...
    objReferencePointDiv.remove();

    // Remove the reference point ...
    objShapeEditor.RemoveReferencePointGraphic(objReferencePoinToDelete);

    // Update the reference points display ...
    objShapeEditor.UpdateReferencePointsDisplay();

    // Resize the elements ...
    objShapeEditor.ResizeElements();
}

// **************************************************************************
// FUNCTION: AddShapePart
// USAGE:    strPartName is optional
// **************************************************************************
TrimbleMap.ShapeEditor.AddShapePart = function AddShapePart(arrCoordinates, objExteriorPartToAddTo, strPartID, strPartName) {

    // Get the instance ...
    var objShapeEditor = this;

    var objDeferred = new dojo.Deferred();

    // Set to use a default part name when not specified ...
    if ((typeof strPartName == 'undefined') || (strPartName == null)) { strPartName = objShapeEditor.Shape.DefaultNewPartName(objExteriorPartToAddTo); }

    // Set to use a new part ID when not specified ...
    if ((typeof strPartID == 'undefined') || (strPartID == null)) { strPartID = SD.Guid.Shared.NewID(); }

    // Create a new part ...
    var objShapePart = TrimbleMap.ShapePart.CreateInstance(strPartName, strPartID);

    // Set the coordinates ...
    objShapePart.Coordinates = arrCoordinates;

    // Add the part to the polygon ...
    objShapeEditor.Shape.AddPart(objShapePart, objExteriorPartToAddTo);

    // Determine wheteher or not we are adding an interior part ...
    var blnIsInteriroPart = ((typeof objExteriorPartToAddTo != 'undefined') && objExteriorPartToAddTo);

    objShapeEditor.PopulateShapePartDropDown(objShapePart, blnIsInteriroPart, true);

    // Display the part on the map ...
    var objDefferredDisplayPartGraphics = objShapeEditor.DisplayPartGraphics(objShapePart);

    objDefferredDisplayPartGraphics.then(TrimbleMap.Controller.Shared.TrapException(function () {
        // When an interior part ...
        if ((typeof objExteriorPartToAddTo != 'undefined') && (objExteriorPartToAddTo != null)) {

            // Update the exterior part on the map ...
            objShapeEditor.DisplayPartGraphics(objExteriorPartToAddTo);
        }

        // Select the newly added shape part ...
        objShapeEditor.SelectShapePart(objShapePart, false);

        // Return the shape part that we created ...
        objDeferred.resolve(objShapePart);
    }), function () {
        objDeferred.reject();
    });

    return objDeferred;
}

// **************************************************************************
// FUNCTION: RemoveShape
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.RemoveShape = function RemoveShape(blnRemovePartFromShape) {

    // Get the instance ...
    var objShapeEditor = this;

    let arrParts = [];

    if (objShapeEditor.Shape.Parts) {
        arrParts = objShapeEditor.Shape.Parts.slice(0);
    }

    // Remove all the interior parts of the shape ...
    $.each(arrParts, function (intExteriorPart, objExteriorPart) { objShapeEditor.RemoveShapePart(objExteriorPart, blnRemovePartFromShape, false); });
}

// **************************************************************************
// FUNCTION: RemoveShapePart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.RemoveShapePart = function RemoveShapePart(objShapePart, blnRemovePartFromShape, blnUpdateExteriorPartGraphic) {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have a shape part to remove ...
    if ((typeof objShapePart != 'undefined') && (objShapePart != null)) {

        // Start with no exterior part to update ...
        var objExteriorPartToUpdate = null;

        // When we are to update the exterior part graphic ...
        if (blnUpdateExteriorPartGraphic) {

            // When the part that we removed is an interior part ...
            if (!objShapeEditor.Shape.IsExteriorPart(objShapePart)) {

                // Get the part's exterior part ...
                objExteriorPartToUpdate = objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapePart);
            }
        }

        // When the part have interior parts ..
        if ((typeof objShapePart.InteriorParts != 'undefined') && objShapePart.InteriorParts) {

            // Remove all the interior parts of the shape ...
            $.each(objShapePart.InteriorParts, function (intInteriorPart, objInteriorPart) { objShapeEditor.RemoveShapePart(objInteriorPart, false, false); });
        }

        // When the part to remove is the selected part ...
        if (objShapePart == objShapeEditor.SelectedPart) {

            // Set to have no selected part ...
            objShapeEditor.SelectedPart = null;

            // Hide the shape part details ...
            objShapeEditor.HideShapePartDetails();

            if (objShapeEditor.AddingNewPart) {
                objShapeEditor.AddingNewPart = false;
                objShapeEditor.ToggleEditFocus(false);
            }
        }

        // Remove the part from the shape when blnRemovePartFromShape is true ...
        if (blnRemovePartFromShape) { objShapeEditor.Shape.RemovePart(objShapePart); }

        //Remove from Shape Part DropDown
        objShapeEditor.RemoveShapePartDropDownItem(objShapePart);

        // Remove the part's graphics from the map ...
        objShapeEditor.RemovePartGraphics(objShapePart.ID);

        // Update the exterior part's graphics when we have one ...
        if (objExteriorPartToUpdate) { objShapeEditor.DisplayPartGraphics(objExteriorPartToUpdate); }

        if (objShapeEditor.EditingCoordinateMode) {
            objShapeEditor.DeactivateMapCoordinateEditor();
        }
    }
}

// **************************************************************************
// FUNCTION: UpdateShapePart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateShapePart = function UpdateShapePart(objShapePart, arrCoordinates, objExteriorPart) {

    // Get the instance ...
    var objShapeEditor = this;

    // Set the coordinates of the shape part ...
    objShapePart.Coordinates = arrCoordinates;

    // When the part is selected ...
    if (objShapeEditor.SelectedPart && objShapeEditor.SelectedPart.ID == objShapePart.ID) {

        // Get the cordinate format of the coordinate list editor ...
        var enCoordinateFormat = objShapeEditor.CoordinateListEditor.CoordinateFormat;

        // Get the spatial reference information of the shape ...
        var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // When the spatial reference changed from a projected to geographic or from geographic to projected ...
        if ((objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) != (enCoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED)) {

            // Get the default coordinate format to use fo the shape's spatial reference ...
            enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID);
        }

        // Set the editable property on the coordinate list editor ...
        objShapeEditor.CoordinateListEditor.ChangeCoordinates(enCoordinateFormat, arrCoordinates, false,
            TrimbleMap.Shape.Shared.DecimalPlacesForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID), false);

        // Update the part graphics ...
        objShapeEditor.DisplayPartGraphics(objShapePart);

    } else {

        // Update the part graphics ...
        objShapeEditor.DisplayPartGraphics(objShapePart);

        // Select the newly added shape part ...
        objShapeEditor.SelectShapePart(objShapePart, false);
    }

    // When an interior part ...
    if ((typeof objExteriorPart != 'undefined') && objExteriorPart) {

        // Update the exterior part on the map ...
        objShapeEditor.DisplayPartGraphics(objExteriorPart);
    }
}

// **************************************************************************
// FUNCTION: UpdateReferencePoint
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.UpdateReferencePoint = function UpdateReferencePoint(objReferencePoint) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the part is selected ...
    if (objReferencePoint) {

        // Get the spatial reference ...
        var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // Get the coordiante format set on the coordinate list editor ...
        var enCoordinateFormat = objShapeEditor.ReferencePointCoordinateListEditor.CoordinateFormat;

        // When the spatial reference changed from a projected to geographic or from geographic to projected ...
        if ((objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.PROJECTED) != (enCoordinateFormat == TrimbleMap.CoordinateListEditor.enumCoordinateFormat.PROJECTED)) {

            // Get the default coordinate format to use fo the shape's spatial reference ...
            enCoordinateFormat = TrimbleMap.CoordinateListEditor.Shared.DefaultCoordinateFormatForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID);
        }

        // Create a coordinates array with the reference point ...
        var arrCoordinates = [{ X: objReferencePoint.X, Y: objReferencePoint.Y }];

        // Set the editable property on the coordinate list editor ...
        objShapeEditor.ReferencePointCoordinateListEditor.ChangeCoordinates(enCoordinateFormat, arrCoordinates, false,
            TrimbleMap.Shape.Shared.DecimalPlacesForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID),
            false);

        // Update the reference point graphics ...
        objShapeEditor.DisplayReferencePointGraphic(objReferencePoint);
    } else {

        // Update the reference point's graphic when the map has been loaded ...
        if (objShapeEditor.MapController.LoadingCompleted) { objShapeEditor.DisplayReferencePointGraphic(objReferencePoint); }
    }
}

// **************************************************************************
// FUNCTION: ActivateMapCoordinateEditor
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ActivateMapCoordinateEditor = function ActivateMapCoordinateEditor() {

    // Get the instance ...
    var objShapeEditor = this;

    // When the map has been loaded successfully ...
    if (objShapeEditor.MapController.EsriMap.loaded) {

        // When the selected part has less than MAX_COORDINATES_TO_ALLOW_EDITING_IN_MAP coordinates ...
        if ((objShapeEditor.SelectedPart != null) && (objShapeEditor.SelectedPart.Coordinates.length < TrimbleMap.ShapeEditor.Shared.MAX_COORDINATES_TO_ALLOW_EDITING_IN_MAP)) {

            // When not activated ...
            if (!objShapeEditor.EsriEditActivated) {

                // When we are editing a part ...
                if (objShapeEditor.EditingCoordinateMode) {

                    // Get the current graphic ...
                    var objEsriGraphic = objShapeEditor.EsriGraphicByPartID[objShapeEditor.SelectedPart.ID];

                    // When we have a graphic to edit ...
                    if ((typeof objEsriGraphic != 'undefined') && objEsriGraphic) {

                        // Set to allow adding vertices when the geometry type of the shape is not point ...
                        var bnlAllowAddVertices = (objShapeEditor.Shape.GeometryType != TrimbleMap.Shape.enumGeometryType.POINT);

                        // Get the valid coordiates from the coordinate list editor ...
                        var arrCoordiantes = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

                        // Set to activate editing of vertices ...
                        var intTool = esri.toolbars.Edit.EDIT_VERTICES;

                        // When a point shape or only one valid point ...
                        if ((objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POINT) || (arrCoordiantes.length == 1)) {

                            // Set to also allow moving the graphic ...
                            intTool = intTool | esri.toolbars.Edit.MOVE;
                        }

                        // When the map has been loaded successfully ...
                        if (objShapeEditor.MapController.EsriMap.loaded) {

                            // Activate the editing toolbar ...
                            objShapeEditor.EsriEdit.activate(intTool, objEsriGraphic, { allowAddVertices: bnlAllowAddVertices, allowDeleteVertices: false, ghostVertexSymbol: objShapeEditor.GhostVertexSymbol, vertexSymbol: objShapeEditor.VertexSymbol });
                        }

                        // Set to be activated ...
                        objShapeEditor.EsriEditActivated = true;
                    }

                    // When we are editing a reference point ...
                } else if (objShapeEditor.EditingReferencePoint) {

                    // Get the current graphic ...
                    var objEsriGraphic = objShapeEditor.EsriGraphicByReferencePointID[objShapeEditor.SelectedReferencePoint.ID];

                    // When we have a graphic to edit ...
                    if ((typeof objEsriGraphic != 'undefined') && objEsriGraphic) {


                        // Activate the editing toolbar ...
                        objShapeEditor.EsriEdit.activate(esri.toolbars.Edit.EDIT_VERTICES | esri.toolbars.Edit.MOVE, objEsriGraphic, { allowAddVertices: false, allowDeleteVertices: false, ghostVertexSymbol: objShapeEditor.GhostVertexSymbol, vertexSymbol: objShapeEditor.VertexSymbol });

                        // Set to be activated ...
                        objShapeEditor.EsriEditActivated = true;
                    }
                }
            }
        }
    }
}

// **************************************************************************
// FUNCTION: DeactivateMapCoordinateEditor
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.DeactivateMapCoordinateEditor = function DeactivateMapCoordinateEditor() {

    // Get the instance ...
    var objShapeEditor = this;

    // When activated ...
    if (objShapeEditor.EsriEditActivated) {

        // De-activate the editing toolbar ...
        objShapeEditor.EsriEdit.deactivate();

        // Set to not be activated ...
        objShapeEditor.EsriEditActivated = false;
    }
}

// **************************************************************************
// FUNCTION: CoordinateListEditorOnCoordinateHovered
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CoordinateListEditorOnCoordinateHovered = function CoordinateListEditorOnCoordinateHovered(intHoveredCoordinate, objHoveredCoordinate, blnIsValidAndComplete) {

    // Get the instance ...
    var objShapeEditor = this;

    // Increment the number of times this function has been called ...
    objShapeEditor.CoordinateListEditorOnCoordinateHoveredCount++;

    // Get the number of times this function has been called ...
    var intCoordinateListEditorOnCoordinateHoveredCount = objShapeEditor.CoordinateListEditorOnCoordinateHoveredCount;

    // Set the hovered coordinate index to null when the coordinate is not valid or incomplete ....
    intHoveredCoordinate = (blnIsValidAndComplete) ? intHoveredCoordinate : null;

    // When the hovered coordinate index changed ...
    if (objShapeEditor.CoordinateListHoveredCoordinateIndex != intHoveredCoordinate) {

        // Set the hovered coordinate index ...
        objShapeEditor.CoordinateListHoveredCoordinateIndex = intHoveredCoordinate;

        // When the mouse is hovering on a coordinate in the coordinate list editor ...
        if (objHoveredCoordinate) {

            // Create the esri spatial reference for the spatial reference id of the shape ...
            var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

            // Create an esri point from the hovered coordinate ...
            var objEsriPoint = new esri.geometry.Point(objHoveredCoordinate.X, objHoveredCoordinate.Y, objEsriSpatialReference);

            // Project to the spatial reference of the map ...
            var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objEsriPoint,
                objShapeEditor.Shape.SpatialReferenceID,
                objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
                true, TrimbleMap.enumProjectionLevel.RELAXED);

            // When the projection completes ...
            objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedPoint) {

                // When the CoordinateListEditorOnCoordinateHovered callback has not been fired 
                // again after the call when this ProjectGoemetry call has been started ...
                if (intCoordinateListEditorOnCoordinateHoveredCount == objShapeEditor.CoordinateListEditorOnCoordinateHoveredCount) {

                    // Remove the current hovered coordinate graphic ...
                    if (objShapeEditor.CoordinateListHoveredCoordinateGraphic) {

                        // Set the hovered graphic geometry to the projected point ...
                        objShapeEditor.CoordinateListHoveredCoordinateGraphic.setGeometry(objProjectedPoint);

                    } else {

                        // Get the symbol to use ...
                        var objSymbol = ((objShapeEditor.EditingCoordinateMode) ? objShapeEditor.SelectedVertexSymbol : objShapeEditor.HoveredPointSymbol);

                        // Create a point graphic to display on the map ...
                        objShapeEditor.CoordinateListHoveredCoordinateGraphic = new esri.Graphic(objProjectedPoint, objSymbol)

                        // Add the point to the map ...
                        objShapeEditor.MapController.AddGraphic(objShapeEditor.CoordinateListHoveredCoordinateGraphic);
                    }
                }
            }));

        } else {

            // Remove the current hovered coordinate graphic ...
            if (objShapeEditor.CoordinateListHoveredCoordinateGraphic) { objShapeEditor.MapController.RemoveGraphic(objShapeEditor.CoordinateListHoveredCoordinateGraphic); }

            // Set the hovered coordiante to null ...
            objShapeEditor.CoordinateListHoveredCoordinateGraphic = null;
        }
    }
}

// **************************************************************************
// FUNCTION: ReferencePointCoordinateListEditorCoordinateChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ReferencePointCoordinateListEditorCoordinateChanged = function ReferencePointCoordinateListEditorCoordinateChanged(intCoordinate, objCoordinate, blnCoordinateCompleted, blnCoordinateValid) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the coordinate has been completed and is valid ...
    if (blnCoordinateCompleted && blnCoordinateValid) {

        // Display the reference point graphic ...
        objShapeEditor.DisplayReferencePointGraphic(objShapeEditor.SelectedReferencePoint, objCoordinate, true);

        // Create the esri spatial reference for the spatial reference id of the shape ...
        var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // Create an esri point from the hovered coordinate ...
        var objEsriPoint = new esri.geometry.Point(objCoordinate.X, objCoordinate.Y, objEsriSpatialReference);

        // Project to the spatial reference of the map ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objEsriPoint,
            objShapeEditor.Shape.SpatialReferenceID,
            objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
            true);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedPoint) {

            // When the point is not inside the current map ...
            if (!objShapeEditor.MapController.GetVisibleMapExtent().contains(objProjectedPoint)) {

                // Compute an extent that will center the map at the point ...
                objShapeEditor.MapController.ComputeZoomToExtent(objProjectedPoint, 1, 0).then(TrimbleMap.Controller.Shared.TrapException(function (objEsriExtent) {

                    // Set the extent on the map ...
                    objShapeEditor.MapController.SetMapExtent(objEsriExtent);
                }));
            }

            // When we have a hovered graphic ...
            if (objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic) {

                // When it was the hovered coordinate that changed ...
                if (intCoordinate == objShapeEditor.ReferencePointCoordinateListHoveredCoordinateIndex) {

                    // Create a point graphic to display on the map ...
                    objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic.setGeometry(objProjectedPoint);

                    // Bring the dojo shape to the front ...
                    var objDojoShape = objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic.getDojoShape();
                    if (objDojoShape) { objDojoShape.moveToFront(); }
                }
            }
        }));

        // When we have a hovered graphic ...
        if (objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic) {

            // When it was the hovered coordinate that changed ...
            if (intCoordinate != objShapeEditor.ReferencePointCoordinateListHoveredCoordinateIndex) {

                // Bring the hovered coordinate graphic's dojo shape to the front ...
                var objDojoShape = objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic.getDojoShape();
                if (objDojoShape) { objDojoShape.moveToFront(); }
            }
        }

    } else {

        // When we have a hoverd coordinate graphic for the changed coordinate (that is invalid or incomplete) ...
        if (objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic && (objShapeEditor.ReferencePointCoordinateListHoveredCoordinateIndex == intCoordinate)) {

            // Remove the current hovered coordinate graphic ...
            objShapeEditor.MapController.RemoveGraphic(objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic);
            objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic = null;

            // Set to have no hovered coordinate ...
            objShapeEditor.ReferencePointCoordinateListHoveredCoordinateIndex = -1
        }
    }
}

// **************************************************************************
// FUNCTION: ReferencePointCoordinateListEditorOnCoordinateHovered
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ReferencePointCoordinateListEditorOnCoordinateHovered = function ReferencePointCoordinateListEditorOnCoordinateHovered(intHoveredCoordinate, objHoveredCoordinate, blnIsValidAndComplete) {

    // Get the instance ...
    var objShapeEditor = this;

    // Increment the number of times this function has been called ...
    objShapeEditor.ReferencePointCoordinateListEditorOnCoordinateHoveredCount++;

    // Get the number of times this function has been called ...
    var intReferencePointCoordinateListEditorOnCoordinateHoveredCount = objShapeEditor.ReferencePointCoordinateListEditorOnCoordinateHoveredCount;

    // Set the hovered coordinate index to null when the coordinate is not valid or incomplete ....
    intHoveredCoordinate = (blnIsValidAndComplete) ? intHoveredCoordinate : null;

    // When the hovered coordinate index changed ...
    if (objShapeEditor.ReferencePointCoordinateListHoveredCoordinateIndex != intHoveredCoordinate) {

        // Set the hovered coordinate index ...
        objShapeEditor.ReferencePointCoordinateListHoveredCoordinateIndex = intHoveredCoordinate;

        // When the mouse is hovering on a coordinate in the coordinate list editor ...
        if (objHoveredCoordinate) {

            // Create the esri spatial reference for the spatial reference id of the shape ...
            var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

            // Create an esri point from the hovered coordinate ...
            var objEsriPoint = new esri.geometry.Point(objHoveredCoordinate.X, objHoveredCoordinate.Y, objEsriSpatialReference);

            // Project to the spatial reference of the map ...
            var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objEsriPoint,
                objShapeEditor.Shape.SpatialReferenceID,
                objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
                true);

            // When the projection completes ...
            objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedPoint) {

                // When the CoordinateListEditorOnCoordinateHovered callback has not been fired 
                // again after the call when this ProjectGoemetry call has been started ...
                if (intReferencePointCoordinateListEditorOnCoordinateHoveredCount == objShapeEditor.ReferencePointCoordinateListEditorOnCoordinateHoveredCount) {

                    // Remove the current hovered coordinate graphic ...
                    if (objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic) {

                        // Set the hovered graphic geometry to the projected point ...
                        objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic.setGeometry(objProjectedPoint);

                    } else {

                        // Get the symbol to use ...
                        var objSymbol = ((objShapeEditor.EditingReferencePoint) ? objShapeEditor.SelectedVertexSymbol : objShapeEditor.HoveredPointSymbol);

                        // Create a point graphic to display on the map ...
                        objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic = new esri.Graphic(objProjectedPoint, objSymbol)

                        // Add the point to the map ...
                        objShapeEditor.MapController.AddGraphic(objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic);
                    }
                }
            }));

        } else {

            // Remove the current hovered coordinate graphic ...
            if (objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic) { objShapeEditor.MapController.RemoveGraphic(objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic); }

            // Set the hovered coordiante to null ...
            objShapeEditor.ReferencePointCoordinateListHoveredCoordinateGraphic = null;
        }
    }
}

// **************************************************************************
// FUNCTION: CoordinateListEditorCoordinateChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CoordinateListEditorCoordinateChanged = function CoordinateListEditorCoordinateChanged(intCoordinate, objCoordinate, blnCoordinateCompleted, blnCoordinateValid) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the coordinate is completed and is valid ...
    if (blnCoordinateCompleted && blnCoordinateValid) {

        // Create the esri spatial reference for the spatial reference id of the shape ...
        var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // Create an esri point from the hovered coordinate ...
        var objEsriPoint = new esri.geometry.Point(objCoordinate.X, objCoordinate.Y, objEsriSpatialReference);

        // Project to the spatial reference of the map ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objEsriPoint,
            objShapeEditor.Shape.SpatialReferenceID,
            objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
            true, TrimbleMap.enumProjectionLevel.RELAXED);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedPoint) {

            // When the point is not inside the current map ...
            if (!objShapeEditor.MapController.GetVisibleMapExtent().contains(objProjectedPoint)) {

                // Compute an extent that will center the map at the point ...
                objShapeEditor.MapController.ComputeZoomToExtent(objProjectedPoint, 1, 0).then(TrimbleMap.Controller.Shared.TrapException(function (objEsriExtent) {

                    // Set the extent on the map ...
                    objShapeEditor.MapController.SetMapExtent(objEsriExtent);
                }));
            }

            // When we have a hovered graphic ...
            if (objShapeEditor.CoordinateListHoveredCoordinateGraphic) {

                // When it was the hovered coordinate that changed ...
                if (intCoordinate == objShapeEditor.CoordinateListHoveredCoordinateIndex) {

                    // Create a point graphic to display on the map ...
                    objShapeEditor.CoordinateListHoveredCoordinateGraphic.setGeometry(objProjectedPoint);

                    // Bring the dojo shape to the front ...
                    var objDojoShape = objShapeEditor.CoordinateListHoveredCoordinateGraphic.getDojoShape();
                    if (objDojoShape) { objDojoShape.moveToFront(); }
                }
            }
        }));

        // When we have a hovered graphic and it was not the hovered coordinate that changed ...
        if ((objShapeEditor.CoordinateListHoveredCoordinateGraphic) && (intCoordinate != objShapeEditor.CoordinateListHoveredCoordinateIndex)) {

            // Bring the hovered coordinate graphic's dojo shape to the front ...
            var objDojoShape = objShapeEditor.CoordinateListHoveredCoordinateGraphic.getDojoShape();
            if (objDojoShape) { objDojoShape.moveToFront(); }
        }

    } else {

        // When we have a hoverd coordinate graphic for the changed coordinate (that is invalid or incomplete) ...
        if (objShapeEditor.CoordinateListHoveredCoordinateGraphic && (objShapeEditor.CoordinateListHoveredCoordinateIndex == intCoordinate)) {

            // Remove the current hovered coordinate graphic ...
            objShapeEditor.MapController.RemoveGraphic(objShapeEditor.CoordinateListHoveredCoordinateGraphic);
            objShapeEditor.CoordinateListHoveredCoordinateGraphic = null;

            // Set to have no hovered coordinate ...
            objShapeEditor.CoordinateListHoveredCoordinateIndex = -1
        }
    }
}


// **************************************************************************
// FUNCTION: CoordinateListEditorCoordinatesChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CoordinateListEditorCoordinatesChanged = function CoordinateListEditorCoordinatesChanged(blnCoordinatesValid) {

    // Get the instance ...
    var objShapeEditor = this;

    // When we have a selected part ...
    if (objShapeEditor.SelectedPart) {

        // Get the current graphic ...
        var objCurrentGraphic = objShapeEditor.EsriGraphicByPartID[objShapeEditor.SelectedPart.ID];

        // Create a hash table for the coordinates to replace ...
        var dicCoordinatesToReplace = {};

        // Set to replace the coordinates with the coordinates from the coordinate list editor ...
        dicCoordinatesToReplace[objShapeEditor.SelectedPart.ID] = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

        // Update the part graphics ...
        objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart, dicCoordinatesToReplace, true);

        // When the selected part is an interior part ...
        if (!objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart)) {

            // Get the exterior part for the selected interior part ...
            var objExteriorPart = objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapeEditor.SelectedPart);

            // Update the exterior part's graphics onm the map ...
            objShapeEditor.DisplayPartGraphics(objExteriorPart, dicCoordinatesToReplace, true);
        }

        // Update the inteface for the shape change ...
        objShapeEditor.UpdateForShapeChange();

        // Get the spatial reference information of the shape ...
        let objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);
        let blnGeographicSpatialReferenceType = objSpatialReference.SpatialReferenceType == TrimbleMap.enumSpatialReferenceType.GEOGRAPHIC;
        // Only enable DMS and DD menu items when coordinates are valid and are in a geographic spatial reference
        let enableDMSandDDMenuItems = blnGeographicSpatialReferenceType && blnCoordinatesValid;

        // Set DMS and DD menu items clickability based on if the coordinates are valid and are in a geographic spatial reference
        objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DegMinSec'), enableDMSandDDMenuItems);
        objShapeEditor.EditPartHamburgerMenu.EnableMenuItem(SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DecimalDeg'), enableDMSandDDMenuItems);
    }
}

// **************************************************************************
// FUNCTION: CoordinateAddedOnMap
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CoordinateAddedOnMap = function CoordinateAddedOnMap(objData) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the dojo shape of the vertex graphic ...
    var objDojoShape = objData.vertexinfo.graphic.getDojoShape();

    // Set the fill to be red ...
    objDojoShape.setFill(new dojo.Color([255, 0, 0, 1]));

    // Get the coordinate index ...
    var intCoordinate = objData.vertexinfo.pointIndex;

    // Get the point with the location for the new the coordinate ...
    var objNewEsriPoint = objData.vertexinfo.graphic.geometry;

    // Project to the spatial reference of the shape ...
    var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objNewEsriPoint,
        objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
        objShapeEditor.Shape.SpatialReferenceID, true, TrimbleMap.enumProjectionLevel.RELAXED);

    // When the projection completes ...
    objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedPoint) {

        // Create the new coordinate ...
        var objNewCoordinate = {
            X: objProjectedPoint.x,
            Y: objProjectedPoint.y
        };

        // When a vertex from the first ring has been moved (this will be the exterior part when the selected part 
        // is an exterior part with interior parts since we add the exterior part as the first ring when creating
        // the geometry or it will be the interior part when the selected part is an interior part) ...
        if (objData.vertexinfo.segmentIndex == 0) {

            // Adjust the coordinate index for invalid and incomplete rows ...
            intCoordinate = objShapeEditor.CoordinateListEditor.AdjustCoordinateIndexForInvalidOrInCompleteRows(intCoordinate);

            // Insert the coordinate in the coordinate list editor ...
            objShapeEditor.CoordinateListEditor.InsertCoordinate(objNewCoordinate, intCoordinate);

            // When the selected part is an interior part ...
            if (!objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart)) {

                // Get the exterior part for the selected interior part ...
                var objExteriorPart = objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapeEditor.SelectedPart);

                // Create a hash table for the coordinates to replace ...
                var dicCoordinatesToReplace = {};

                // Set to replace the coordinates with the coordinates from the coordinate list editor ...
                dicCoordinatesToReplace[objShapeEditor.SelectedPart.ID] = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

                // Update the exterior part's graphics on the map ...
                objShapeEditor.DisplayPartGraphics(objExteriorPart, dicCoordinatesToReplace);

                // Otherwise when it is a polyline that now has more than 2 vertices ...
            } else if ((objData.graphic.geometry.type == 'polyline') && (objData.graphic.geometry.paths[objData.vertexinfo.segmentIndex].length > 2)) {

                // Create a hash table for the coordinates to replace ...
                var dicCoordinatesToReplace = {};

                // Set to replace the coordinates with the coordinates from the coordinate list editor ...
                dicCoordinatesToReplace[objShapeEditor.SelectedPart.ID] = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

                // Update the selected part's graphics on the map ...
                objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart, dicCoordinatesToReplace, true);
            }

            // Highlight the coordinate in the coordinate list editor ...
            objShapeEditor.CoordinateListEditor.HighlightCoordinate(intCoordinate, true);

        } else {

            // Add the new coorinate in the modified coordinates copy for the interior part ...
            objShapeEditor.ModifiedInteriorPartCoordinates[objData.vertexinfo.segmentIndex - 1].splice(intCoordinate, 0, objNewCoordinate);
        }

        // Update the inteface for the shape change ...
        objShapeEditor.UpdateForShapeChange();

    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

        // Update the selected part's graphics on the map ...
        objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart, objShapeEditor.GetEditedCoordinatesToReplace(), true);

        // When it's a measures out of bounds exception ...
        if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

            // Get the spatial reference of the shape ...
            var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

            // Set the translations ...

            // Not valid in selected coordinate system
            var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NotValidInCoordinateSystemTitle');

            // The coordinate you added is not valid in %1
            var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'NotValidInCoordinateSystemMessage', objSpatialReference.Name);

            // Notify the user tha the part has no coordinates ...
            TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
        }
    }));
}

// **************************************************************************
// FUNCTION: CoordinateMovedOnMap
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CoordinateMovedOnMap = function CoordinateMovedOnMap(objData) {

    // Get the instance ...
    var objShapeEditor = this;

    // When not adding a vertex to the map ...
    if (!objData.vertexinfo.isGhost) {

        // Get the dojo shape of the vertex graphic ...
        var objDojoShape = objData.vertexinfo.graphic.getDojoShape();

        // Set the fill to be red ...
        objDojoShape.setFill(new dojo.Color([255, 0, 0, 1]));

        // Get the coordinate index ...
        var intCoordinate = objData.vertexinfo.pointIndex;

        // When the last coordinte used to close the ring set to update the first coordinate ...
        intCoordinate = ((objData.graphic.geometry.type == 'polygon') && (intCoordinate < objData.graphic.geometry.rings[objData.vertexinfo.segmentIndex].length - 1) ||
            (objData.graphic.geometry.type == 'polyline') || (objData.graphic.geometry.type == 'point')) ? intCoordinate : 0;

        // Get the point with the new location for the coordinate ...
        var objNewEsriPoint = objData.vertexinfo.graphic.geometry;

        // Project to the spatial reference of the shape ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objNewEsriPoint,
            objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
            objShapeEditor.Shape.SpatialReferenceID, true, TrimbleMap.enumProjectionLevel.RELAXED);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedPoint) {

            // When a vertex from the first ring has been moved (this will be the exterior part when the selected part 
            // is an exterior part with interior parts since we add the exterior part as the first ring when creating
            // the geometry or it will be the interior part when the selected part is an interior part) ...
            if (objData.vertexinfo.segmentIndex == 0) {

                // Set the coordinate value ...
                objShapeEditor.CoordinateListEditor.ChangeCoordinate({ X: objProjectedPoint.x, Y: objProjectedPoint.y },
                    objShapeEditor.CoordinateListEditor.AdjustCoordinateIndexForInvalidOrInCompleteRows(intCoordinate));

                // When the selected part is an interior part ...
                if (!objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart)) {

                    // Get the exterior part for the selected interior part ...
                    var objExteriorPart = objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapeEditor.SelectedPart);

                    // Create a hash table for the coordinates to replace ...
                    var dicCoordinatesToReplace = {};

                    // Set to replace the coordinates with the coordinates from the coordinate list editor ...
                    dicCoordinatesToReplace[objShapeEditor.SelectedPart.ID] = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

                    // Update the exterior part's graphics onm the map ...
                    objShapeEditor.DisplayPartGraphics(objExteriorPart, dicCoordinatesToReplace, false, true);
                }

            } else {

                // Set the new coorinate in the modified coordinates copy for the interior part ...
                objShapeEditor.ModifiedInteriorPartCoordinates[objData.vertexinfo.segmentIndex - 1][intCoordinate] = { X: objProjectedPoint.x, Y: objProjectedPoint.y };
            }

            // Update the inteface for the shape change ...
            objShapeEditor.UpdateForShapeChange();

        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

            // Update the selected part's graphics on the map ...
            objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart, objShapeEditor.GetEditedCoordinatesToReplace(), true);

            // When it's a measures out of bounds exception ...
            if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

                // Get the spatial reference of the shape ...
                var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

                // Set the translations ...

                // Not valid in selected coordinate system
                var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'MovedCoordinateSystemTitle');

                // You moved the coordinate to a location that is not valid in %1
                var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'MovedCoordinateSystemMessage', objSpatialReference.Name);

                // Notify the user tha the part has no coordinates ...
                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
            }
        }));

        // When the ring for the selected part changed (not the interior part when the exterior part is selected) ...
        if (objData.vertexinfo.segmentIndex == 0) {

            // Convert the vertex point to a screen point ...
            var objCurrentScreenPoint = objShapeEditor.MapController.EsriMap.toScreen(objData.vertexinfo.graphic.geometry);

            // When the vertex were not actually moved ...
            if (objShapeEditor.VertexEsriPointAtStartMove && ((objShapeEditor.VertexEsriPointAtStartMove.x == objCurrentScreenPoint.x) && (objShapeEditor.VertexEsriPointAtStartMove.x == objCurrentScreenPoint.x))) {

                // Activate the cooridnate on the coordinate list editor ...
                objShapeEditor.CoordinateListEditor.ActivateCoordinate(objShapeEditor.CoordinateListEditor.AdjustCoordinateIndexForInvalidOrInCompleteRows(intCoordinate));
            }
        }

        // Set the vertex esri point back to null ...
        objShapeEditor.VertexEsriPointAtStartMove = null;
    }
}

// **************************************************************************
// FUNCTION: CoordinateStartMovingOnMap
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CoordinateStartMovingOnMap = function CoordinateStartMovingOnMap(objData) {

    // Get the instance ...
    var objShapeEditor = this;

    // When not a ghost vertex (vertex for adding) ...
    if (!objData.vertexinfo.isGhost) {

        // Set the vertex esri point ...
        objShapeEditor.VertexEsriPointAtStartMove = objShapeEditor.MapController.EsriMap.toScreen(objData.vertexinfo.graphic.geometry);
    }
}

// **************************************************************************
// FUNCTION: GraphicMovedOnMap
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GraphicMovedOnMap = function GraphicMovedOnMap(objData) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the new geometry ...
    var objNewEsriGeometry = objData.graphic.geometry;

    // Project to the spatial reference of the shape ...
    var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objNewEsriGeometry,
        objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
        objShapeEditor.Shape.SpatialReferenceID,
        objShapeEditor.MapController.EsriMap.spatialReference,
        false);

    // When the projection completes ...
    objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedGeometry) {

        // When we are editing a part ...
        if (objShapeEditor.EditingCoordinateMode) {

            // Get the coordinates in the coordinate list editor ...
            var arrCoordinates = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

            // Loop through all the coordinates ...
            for (var intCoordinate = 0; intCoordinate < arrCoordinates.length; intCoordinate++) {

                // When it's a point geometry ...
                if (objProjectedGeometry.type == 'point') {

                    // Set the coordinate ...
                    arrCoordinates[0] = { X: objProjectedGeometry.x, Y: objProjectedGeometry.y };

                } else {

                    // Get the projected point at the index ...
                    var objProjectedPoint = (objProjectedGeometry.type == 'polygon') ? objProjectedGeometry.rings[objData.vertexinfo.segmentIndex][intCoordinate]
                        : objProjectedGeometry.paths[objData.vertexinfo.segmentIndex][intCoordinate];
                    // Set the coordinate ...
                    arrCoordinates[intCoordinate] = { X: objProjectedPoint[0], Y: objProjectedPoint[1] };
                }
            }

            // Set the editable property on the coordinate list editor ...
            objShapeEditor.CoordinateListEditor.ChangeCoordinates(objShapeEditor.CoordinateListEditor.CoordinateFormat, arrCoordinates, true,
                objShapeEditor.CoordinateListEditor.DecimalPlaces, true);

            // When the selected part is an interior part ...
            if (!objShapeEditor.Shape.IsExteriorPart(objShapeEditor.SelectedPart)) {

                // Create a hash table for the coordinates to replace ...
                var dicCoordinatesToReplace = {};

                // Set to replace the coordinates with teh changed coordinates ...
                dicCoordinatesToReplace[objShapeEditor.SelectedPart.ID] = arrCoordinates;

                // Get the exterior part for the selected interior part ...
                var objExteriorPart = objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapeEditor.SelectedPart);

                // Update the exterior part's graphics onm the map ...
                objShapeEditor.DisplayPartGraphics(objExteriorPart, dicCoordinatesToReplace);

            } else {

                // When the moved graphic has more than one ring (which will then be the interior rings) ...
                if ((typeof objProjectedGeometry.rings != 'undefined') && (objProjectedGeometry.rings.length > 1)) {

                    // Loop through all the interior rings ...
                    for (var intInteriorRing = 0; intInteriorRing < objProjectedGeometry.rings.length - 1; intInteriorRing++) {

                        // Get the interior ring's points ...
                        var arrInteriorRingPoints = objProjectedGeometry.rings[intInteriorRing + 1];

                        // Get the modified copy of the coordinates of the interior part ...
                        var arrModifiedInteriorCoordinateCopy = objShapeEditor.ModifiedInteriorPartCoordinates[intInteriorRing];

                        // Update all the coordinates of the modified copy of the for the interior part's coordinates ...
                        $.each(arrInteriorRingPoints, function (intInteriorRingPoint, objInteriorRingPoint) { if (intInteriorRingPoint < arrModifiedInteriorCoordinateCopy.length) { arrModifiedInteriorCoordinateCopy[intInteriorRingPoint] = { X: objInteriorRingPoint[0], Y: objInteriorRingPoint[1] }; } });
                    }
                }
            }

            // When we are editing a reference point ...
        } else if (objShapeEditor.EditingReferencePoint) {

            // Set the editable property on the coordinate list editor ...
            objShapeEditor.ReferencePointCoordinateListEditor.ChangeCoordinates(objShapeEditor.ReferencePointCoordinateListEditor.CoordinateFormat,
                [{ X: objProjectedGeometry.x, Y: objProjectedGeometry.y }], true,
                objShapeEditor.ReferencePointCoordinateListEditor.DecimalPlaces, true);
        }

    }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

        // Update the selected part's graphics on the map ...
        objShapeEditor.DisplayPartGraphics(objShapeEditor.SelectedPart, objShapeEditor.GetEditedCoordinatesToReplace(), true);

        // When it's a measures out of bounds exception ...
        if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

            // Get the spatial reference of the shape ...
            var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

            // Set the translations ...

            // Not valid in selected coordinate system
            var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'MovedCoordinateSystemTitle');

            // You moved the coordinate to a location that is not valid in %1
            var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'MovedCoordinateSystemMessage', objSpatialReference.Name);

            // Notify the user tha the part has no coordinates ...
            TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
        }
    }));
}

// **************************************************************************
// FUNCTION: MouseOverCoordinateOnMap
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.MouseOverCoordinateOnMap = function MouseOverCoordinateOnMap(objData) {

    // Get the instance ...
    var objShapeEditor = this;

    // When not a ghost vertex (vertex for adding) ...
    if (!objData.vertexinfo.isGhost) {

        // Get the dojo shape of the vertex graphic ...
        var objDojoShape = objData.vertexinfo.graphic.getDojoShape();

        // Set the fill to be red ...
        objDojoShape.setFill(new dojo.Color([255, 0, 0, 1]));

        // When we are editing a part ...
        if (objShapeEditor.EditingCoordinateMode) {

            // When on the selected part (the exterior ring or the interior ring being edited) ...
            if (objData.vertexinfo.segmentIndex == 0) {

                // Highlight the coordinate in the coordinate list editor ...
                objShapeEditor.CoordinateListEditor.HighlightCoordinate(objShapeEditor.CoordinateListEditor.AdjustCoordinateIndexForInvalidOrInCompleteRows(objData.vertexinfo.pointIndex), true);
            }
        }
    }
}

// **************************************************************************
// FUNCTION: MouseOutCoordinateOnMap
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.MouseOutCoordinateOnMap = function MouseOutCoordinateOnMap(objData) {

    // Get the instance ...
    var objShapeEditor = this;

    // When not a ghost vertex (vertex for adding) ...
    if (!objData.vertexinfo.isGhost) {

        // Get the dojo shape of the vertex graphic ...
        var objDojoShape = objData.vertexinfo.graphic.getDojoShape();

        // Set the fill to be white ...
        objDojoShape.setFill(new dojo.Color([255, 255, 255, 1]));

        // When we are editing a part ...
        if (objShapeEditor.EditingCoordinateMode) {

            // Clear the coordinate Highlight in the coordinate list editor ...
            objShapeEditor.CoordinateListEditor.ClearCoordinateHighlight();
        }
    }
}

// **************************************************************************
// FUNCTION: GetSelectedPartCoordinateIndexForGraphic
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetSelectedPartCoordinateIndexForGraphic = function GetSelectedPartCoordinateIndexForGraphic(objGraphic) {

    // Get the instance ...
    var objShapeEditor = this;

    // Start with not found ...
    var intHoveredCoordinate = -1;

    // When we have a selected part ...
    if (objShapeEditor.SelectedPart) {

        // Get the point graphic created for the first point ...
        var objPartGraphic = objShapeEditor.EsriGraphicByPartID[objShapeEditor.SelectedPart.ID];

        // When found ...
        if ((typeof objPartGraphic != 'undefined') && objPartGraphic) {

            // When the part graphic is a point ...
            if (objPartGraphic.geometry.type == 'point') {

                // When the graphic we are looking for ...
                if (objPartGraphic == objGraphic) {

                    // Set to be hovering over the first point ...
                    intHoveredCoordinate = 0;
                }

            } else {

                // Get the array of point graphics created for the esri selected part ...
                var arrSelectedPartEsriPointGraphics = objShapeEditor.EsriPointGraphicsByPartID[objShapeEditor.SelectedPart.ID];

                // When we have point graphics for the selected part ...
                if ((typeof arrSelectedPartEsriPointGraphics != 'undefined') && arrSelectedPartEsriPointGraphics) {

                    // Get the hovered point index ...
                    intHoveredCoordinate = $.inArray(objGraphic, arrSelectedPartEsriPointGraphics);

                    // Wrap the last coordinate back to the first ...
                    intHoveredCoordinate = (intHoveredCoordinate == arrSelectedPartEsriPointGraphics.length - 1) ? 0 : intHoveredCoordinate;
                }
            }
        }
    }

    // Return the hovered coordinate index ...
    return intHoveredCoordinate;
}

// **************************************************************************
// FUNCTION: GraphicsLayerMouseOver
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GraphicsLayerMouseOver = function GraphicsLayerMouseOver(objMouseEvent) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the coordinate index from the selected part that the mouse entered if any ...
    var intHoveredCoordinate = objShapeEditor.GetSelectedPartCoordinateIndexForGraphic(objMouseEvent.graphic);

    // When we are hovering over a coordinate from the selected part ...
    if (intHoveredCoordinate > -1) {

        // Get the dojo shape of the vertex graphic ...
        var objDojoShape = objMouseEvent.graphic.getDojoShape();

        // Set the fill to be red ...
        objDojoShape.setFill(new dojo.Color([255, 0, 0, 1]));

        // Set the pointer cursor on the map ...
        objShapeEditor.MapController.EsriMap.setMapCursor('pointer');

        // When we have a selected part ...
        if (objShapeEditor.SelectedPart) {

            // Highlight the coordinate in the coordinate list editor ...
            objShapeEditor.CoordinateListEditor.HighlightCoordinate(intHoveredCoordinate, true);
        }

    } else {

        // When we have a selected reference point ...
        if (objShapeEditor.SelectedReferencePoint) {

            // Get the graphic for the selected reference point ...
            var objReferencePointGraphic = objShapeEditor.EsriGraphicByReferencePointID[objShapeEditor.SelectedReferencePoint.ID];

            // When the graphic that the mouse is hovering over ...
            if (objReferencePointGraphic == objMouseEvent.graphic) {

                // Get the dojo shape of the vertex graphic ...
                var objDojoShape = objMouseEvent.graphic.getDojoShape();

                // Set the fill to be red ...
                objDojoShape.setFill(new dojo.Color([255, 0, 0, 1]));

                // Set the pointer cursor on the map ...
                objShapeEditor.MapController.EsriMap.setMapCursor('pointer');

                // Highlight the coordinate in the coordinate list editor ...
                objShapeEditor.ReferencePointCoordinateListEditor.HighlightCoordinate(0, true);
            }
        }
    }
}

// **************************************************************************
// FUNCTION: GraphicsLayerMouseOut
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GraphicsLayerMouseOut = function GraphicsLayerMouseOut(objMouseEvent) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the coordinate index from the selected part that the mouse entered if any ...
    var intHoveredCoordinate = objShapeEditor.GetSelectedPartCoordinateIndexForGraphic(objMouseEvent.graphic);

    // When we are hovering over a coordinate from the selected patr ...
    if (intHoveredCoordinate > -1) {

        // Get the dojo shape of the vertex graphic ...
        var objDojoShape = objMouseEvent.graphic.getDojoShape();

        // Set the fill to be white ...
        objDojoShape.setFill(new dojo.Color([255, 255, 255, 1]));

        // Set the default cursor on the map ...
        objShapeEditor.MapController.EsriMap.setMapCursor('default');

        // When we have a selected part ...
        if (objShapeEditor.SelectedPart) {

            // Clear the coordinate highlight ...
            objShapeEditor.CoordinateListEditor.ClearCoordinateHighlight();
        }

    } else {

        // When we have a selected reference point ...
        if (objShapeEditor.SelectedReferencePoint) {

            // Get the graphic for the selected reference point ...
            var objReferencePointGraphic = objShapeEditor.EsriGraphicByReferencePointID[objShapeEditor.SelectedReferencePoint.ID];

            // When the graphic that the mouse is hovering over ...
            if (objReferencePointGraphic == objMouseEvent.graphic) {

                // Get the dojo shape of the vertex graphic ...
                var objDojoShape = objMouseEvent.graphic.getDojoShape();

                // Set the fill to be white ...
                objDojoShape.setFill(new dojo.Color([255, 255, 255, 1]));

                // Set the default cursor on the map ...
                objShapeEditor.MapController.EsriMap.setMapCursor('default');

                // Clear the coordinate highlight ...
                objShapeEditor.ReferencePointCoordinateListEditor.ClearCoordinateHighlight();
            }
        }
    }
}

// **************************************************************************
// FUNCTION: DisplayPartGraphics
// USAGE:    blnActivateMapCoordinateEditor is optional and defaults to false ...
// **************************************************************************
TrimbleMap.ShapeEditor.DisplayPartGraphics = function DisplayPartGraphics(objShapePart, dicCoordinatesToReplace, blnActivateMapCoordinateEditor, blnExcludeCoordinatesToReplacePart) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the esri map has been loaded and we are to show the parts ...
    if (objShapeEditor.MapController.IsEsriMapLoaded() && objShapeEditor.Options.ShowPartsInListAndMap) {

        // Get the coordinates to replace for the ID if any ...
        var arrCoordinatesToReplace = ((typeof dicCoordinatesToReplace != 'undefined') && dicCoordinatesToReplace) ? dicCoordinatesToReplace[objShapePart.ID] : null;

        // Get the cooridantes to display, use the replacement coordinates when we have otherwise use the coordintes from the shape part ...
        var arrCoordinates = ((typeof arrCoordinatesToReplace != 'undefined') && arrCoordinatesToReplace) ? arrCoordinatesToReplace : objShapePart.Coordinates;

        // Determine whether or not the part that we will be drawing is the selected part ...
        var blnIsSelectedPart = objShapeEditor.SelectedPart && (objShapePart.ID == objShapeEditor.SelectedPart.ID);

        // Determine whether or not the part is an exterior part ...
        var blnIsExteriorPart = objShapeEditor.Shape.IsExteriorPart(objShapePart);

        // Create the esri spatial reference for the spatial reference ID of the shape ...
        var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // Create an esri geometry from the coordinates and spatial reference ...
        var objGeometry = TrimbleMap.ShapePart.Shared.EsriGeometryFromCoordinates(arrCoordinates, objEsriSpatialReference, objShapeEditor.Shape.GeometryType);

        // Add the interior rings if any ...
        let arrExcludeCoordinatesToReplacePartIndex = TrimbleMap.ShapePart.Shared.AddInteriorRingsToEsriGeometry(objShapePart, objGeometry, objEsriSpatialReference, dicCoordinatesToReplace, false, blnExcludeCoordinatesToReplacePart);

        // Project to the spatial reference of the map ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objGeometry,
            objShapeEditor.Shape.SpatialReferenceID,
            objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
            false, TrimbleMap.enumProjectionLevel.RELAXED);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedGeometry) {

            // Create an esri graphic for the projected symbol ...
            var objEsriGraphic = (objProjectedGeometry) ? new esri.Graphic(objProjectedGeometry, objShapeEditor.GetSymbolToUse(arrCoordinates.length, blnIsExteriorPart, blnIsSelectedPart, objShapeEditor.EditingCoordinateMode)) : null;

            // Get the current graphic ...
            var objCurrentGraphic = objShapeEditor.EsriGraphicByPartID[objShapePart.ID];

            // Test if we have a current graphic ...
            var blnHaveCurrentGraphic = (typeof objCurrentGraphic != 'undefined') && objCurrentGraphic;

            // We should update the graphic when we have a current graphic and a changed graphic and their geometry types are the same ...
            var blnUpdateGraphic = blnHaveCurrentGraphic && objEsriGraphic && (objEsriGraphic.geometry.type == objCurrentGraphic.geometry.type);

            // Get the point graphics for the part ...
            var arrEsriPointGraphics = objShapeEditor.EsriPointGraphicsByPartID[objShapePart.ID];

            // When we have point graphics for the selected part ...
            if ((typeof arrEsriPointGraphics != 'undefined') && (arrEsriPointGraphics)) {

                // Remove the point graphic from the map ...
                $.each(arrEsriPointGraphics, function (intPoint, objEsriPointGraphic) { objShapeEditor.MapController.RemoveGraphic(objEsriPointGraphic); });
            }

            //Search the exterior parts
            var intIndex = $.inArray(objShapePart, objShapeEditor.Shape.Parts);

            if (intIndex == -1) {

                //Search the interior parts
                $.each(objShapeEditor.Shape.Parts, function (intInteriorPart, objExteriorPart) {
                    intIndex = $.inArray(objShapePart, objExteriorPart.InteriorParts);
                    //Exit if found
                    if (intIndex > -1) { return false };
                });
            }

            // When we are to update the graphic ...
            if (blnUpdateGraphic) {

                // Set the geometry and symbology of the current graphic ...
                objCurrentGraphic.setGeometry(objEsriGraphic.geometry);
                objCurrentGraphic.setSymbol(objEsriGraphic.symbol);

                // When the editing toolbar is activated ...
                if (objShapeEditor.EsriEditActivated) {

                    // Refresh the editing toolbar to reflect the changes to the geometry ...
                    objShapeEditor.EsriEdit.refresh();
                }

            } else {

                // When we have a current graphic ...
                if (blnHaveCurrentGraphic) {

                    // Deactivate the map coordinate editor ...
                    objShapeEditor.DeactivateMapCoordinateEditor();

                    // Remove the graphic from the map ...
                    objShapeEditor.MapController.RemoveGraphic(objCurrentGraphic);
                }

                // When we have graphic to add ...
                if (objEsriGraphic) {

                    if (intIndex > -1) {
                        // Add the graphic to the hash table ...
                        objShapeEditor.EsriGraphicByPartID[objShapePart.ID] = objEsriGraphic;

                        // When the map has been loaded successfully ...
                        if (objShapeEditor.MapController.EsriMap.loaded) {

                            // Add the point to the map ...
                            objShapeEditor.MapController.AddGraphic(objEsriGraphic, true);
                        }
                    }

                    // When we are to activate the map coordinate list editor ...
                    if ((typeof blnActivateMapCoordinateEditor != 'undefined') && blnActivateMapCoordinateEditor) {

                        // Activate the map coordinate editor ...
                        objShapeEditor.ActivateMapCoordinateEditor();
                    }

                } else {

                    // Delete the graphic from the hash table ...
                    delete objShapeEditor.EsriGraphicByPartID[objShapePart.ID];
                }
            }

            // When we are to draw the coordinates in the map ...
            if (objShapeEditor.DrawCoordinatesInMap && intIndex > -1) {

                // When we have more than one coordinates and we are not editing the part that we are drawing ...
                if (objProjectedGeometry &&
                    (((objProjectedGeometry.type == 'polygon') && (objProjectedGeometry.rings.length > 0) && (objProjectedGeometry.rings[0].length > 1)) ||
                        ((objProjectedGeometry.type == 'polyline') && (objProjectedGeometry.paths.length > 0) && (objProjectedGeometry.paths[0].length > 1))) &&
                    ((!blnIsSelectedPart) || (!objShapeEditor.EditingCoordinateMode))) {

                    // Create a new array for the point graphics of the part ...
                    var arrEsriPointGraphics = [];

                    // Get the points from the geometry ...
                    let arrRings = (objProjectedGeometry.type == 'polygon') ? objProjectedGeometry.rings : objProjectedGeometry.paths;

                    // Loop through all the coordinates ...
                    $.each(arrRings, function (intRing, arrRing) {
                        if (!arrExcludeCoordinatesToReplacePartIndex || (arrExcludeCoordinatesToReplacePartIndex && $.inArray(intRing, arrExcludeCoordinatesToReplacePartIndex) == -1)) {
                            $.each(arrRing, function (intPoint, objPoint) {
                                // Create the esri point graphic ...
                                let objEsriPointGraphic = new esri.Graphic(new esri.geometry.Point(objPoint[0], objPoint[1], objProjectedGeometry.spatialReference), (blnIsSelectedPart && intRing === 0) ? objShapeEditor.SelectedPointSymbol : objShapeEditor.PointSymbol);

                                // When the map has been loaded successfully ...
                                if (objShapeEditor.MapController.EsriMap.loaded) {

                                    // Add the point to the map ...
                                    objShapeEditor.MapController.AddGraphic(objEsriPointGraphic);
                                }

                                // Add the point graphic to the map ...
                                arrEsriPointGraphics.push(objEsriPointGraphic);
                            });
                        }
                    });

                    // Set the array on the dictionary of point graphics for all the parts ...
                    objShapeEditor.EsriPointGraphicsByPartID[objShapePart.ID] = arrEsriPointGraphics;
                }
            }

            // Resolve the deferred ...
            objDeferred.resolve();

        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

            // Remove the part's graphics form the map ...
            objShapeEditor.RemovePartGraphics(objShapePart.ID);

            // Resolve the deferred ...
            objDeferred.resolve();
        }));

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    // Return the deferred ...
    return objDeferred;
}

// **************************************************************************
// FUNCTION: RemovePartGraphics
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.RemovePartGraphics = function RemovePartGraphics(strShapePartID) {

    // Get the instance ...
    var objShapeEditor = this;

    // When we are to remove the selected part's graphcs and we are editing the part ...
    if (objShapeEditor.SelectedPart && (objShapeEditor.SelectedPart.ID == strShapePartID) && objShapeEditor.EditingCoordinateMode) {

        // De-activate the map coordinate editor ...
        objShapeEditor.DeactivateMapCoordinateEditor();
    }

    // Get the point graphics for the part ...
    var arrEsriPointGraphics = objShapeEditor.EsriPointGraphicsByPartID[strShapePartID];

    // When we have point graphics for the selected part ...
    if ((typeof arrEsriPointGraphics != 'undefined') && (arrEsriPointGraphics)) {

        // Remove the point graphic from the map ...
        $.each(arrEsriPointGraphics, function (intPoint, objEsriPointGraphic) { objShapeEditor.MapController.RemoveGraphic(objEsriPointGraphic); });

        // Remove it from the dictionary of part graphics ...
        delete objShapeEditor.EsriPointGraphicsByPartID[strShapePartID];
    }

    // Get the current graphic ...
    var objCurrentGraphic = objShapeEditor.EsriGraphicByPartID[strShapePartID];

    // When we have a current graphic ...
    if ((typeof objCurrentGraphic != 'undefined') && objCurrentGraphic) {

        // Remove the graphic from the map ...
        objShapeEditor.MapController.RemoveGraphic(objCurrentGraphic);

        // Remove it from the dictionary of part graphics ...
        delete objShapeEditor.EsriGraphicByPartID[strShapePartID];
    }
}

// **************************************************************************
// FUNCTION: DisplayReferencePointGraphic
// USAGE:    blnActivateMapCoordinateEditor is optional and defaults to false.
//           objCoordinateToReplace is optional, does not replace the 
//           coordinate when not set ...
// **************************************************************************
TrimbleMap.ShapeEditor.DisplayReferencePointGraphic = function DisplayReferencePointGraphic(objReferencePoint, objCoordinateToReplace, blnActivateMapCoordinateEditor) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the esri map has been loaded and we are to show the parts ...
    if (objShapeEditor.MapController.IsEsriMapLoaded() && objShapeEditor.Options.ShowPartsInListAndMap) {

        // Determine whether or not the reference point that we will be drawing is the selected reference point ...
        var blnIsSelectedReferencePoint = objShapeEditor.SelectedReferencePoint && (objReferencePoint.ID == objShapeEditor.SelectedReferencePoint.ID);

        // Create the esri spatial reference for the spatial reference ID of the shape ...
        var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // Test if we have aa coordinates to replace ...
        var blnHasCoordinateToReplace = ((typeof objCoordinateToReplace != 'undefined') && objCoordinateToReplace);

        // Create an esri geometry from the reference point ...
        var objGeometry = (blnHasCoordinateToReplace) ? (new esri.geometry.Point(objCoordinateToReplace.X, objCoordinateToReplace.Y, objEsriSpatialReference)) :
            (objReferencePoint.HasValues) ? (new esri.geometry.Point(objReferencePoint.X, objReferencePoint.Y, objEsriSpatialReference)) : null;

        // Project to the spatial reference of the map ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objGeometry,
            objShapeEditor.Shape.SpatialReferenceID,
            objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
            true);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedGeometry) {

            let blnCalculatedReferencePoint = (objReferencePoint.CalculationMethod == TrimbleMap.Shape.enumReferencePointCalculationMethod.Centroid);
            let blnAllowEditing = objShapeEditor.EditingReferencePoint && !blnCalculatedReferencePoint;

            // Create an esri graphic for the projected symbol ...
            var objEsriGraphic = (objProjectedGeometry) ? new esri.Graphic(objProjectedGeometry, objShapeEditor.GetReferencePointSymbolToUse(blnIsSelectedReferencePoint, blnAllowEditing)) : null;

            // Get the current graphic ...
            var objCurrentGraphic = objShapeEditor.EsriGraphicByReferencePointID[objReferencePoint.ID];

            // Test if we have a current graphic ...
            var blnHaveCurrentGraphic = (typeof objCurrentGraphic != 'undefined') && objCurrentGraphic;

            // We should update the graphic when we have a current graphic and a changed graphic ...
            var blnUpdateGraphic = blnHaveCurrentGraphic && objEsriGraphic;

            // When we are to update the graphic ...
            if (blnUpdateGraphic) {

                // Set the geometry and symbology of the current graphic ...
                objCurrentGraphic.setGeometry(objEsriGraphic.geometry);
                objCurrentGraphic.setSymbol(objEsriGraphic.symbol);

                // When the editing toolbar is activated ...
                if (objShapeEditor.EsriEditActivated) {

                    // Refresh the editing toolbar to reflect the changes to the geometry ...
                    objShapeEditor.EsriEdit.refresh();
                }

            } else {

                // When we have a current graphic ...
                if (blnHaveCurrentGraphic) {

                    // Deactivate the map coordinate editor ...
                    objShapeEditor.DeactivateMapCoordinateEditor();

                    // Remove the graphic from the map ...
                    objShapeEditor.MapController.RemoveGraphic(objCurrentGraphic);
                }

                // When we have graphic to add ...
                if (objEsriGraphic) {

                    // Add the graphic to the hash table ...
                    objShapeEditor.EsriGraphicByReferencePointID[objReferencePoint.ID] = objEsriGraphic;

                    // Add the graphic to the map ...
                    objShapeEditor.MapController.AddGraphic(objEsriGraphic);

                    // When we are to activate the map coordinate list editor ...
                    if ((typeof blnActivateMapCoordinateEditor != 'undefined') && blnActivateMapCoordinateEditor) {

                        // Activate the map coordinate editor ...
                        objShapeEditor.ActivateMapCoordinateEditor();
                    }

                } else {

                    // Delete the graphic from the hash table ...
                    delete objShapeEditor.EsriGraphicByReferencePointID[objReferencePoint.ID];
                }
            }

            // Resolve the deferred ...
            objDeferred.resolve();

        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

            // Remove the reference point's graphic form the map ...
            objShapeEditor.RemoveReferencePointGraphic(objReferencePoint);

            // Resolve the deferred ...
            objDeferred.resolve();
        }));

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }

    // Return the deferred ...
    return objDeferred;
}

// **************************************************************************
// FUNCTION: RemoveReferencePointGraphic
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.RemoveReferencePointGraphic = function RemoveReferencePointGraphic(objReferencePoint) {

    // Get the instance ...
    var objShapeEditor = this;

    // When we are to remove the selected reference point's graphics and we are editing the reference point ...
    if (objShapeEditor.SelectedReferencePoint && (objShapeEditor.SelectedReferencePoint == objReferencePoint) && objShapeEditor.EditingReferencePoint) {

        // De-activate the map coordinate editor ...
        objShapeEditor.DeactivateMapCoordinateEditor();
    }

    // Get the current graphic ...
    var objCurrentGraphic = objShapeEditor.EsriGraphicByReferencePointID[objReferencePoint.ID];

    // When we have a current graphic ...
    if ((typeof objCurrentGraphic != 'undefined') && objCurrentGraphic) {

        // Remove the graphic from the map ...
        objShapeEditor.MapController.RemoveGraphic(objCurrentGraphic);

        // Remove it from the hash table of part graphics ...
        delete objShapeEditor.EsriGraphicByReferencePointID[objReferencePoint.ID];
    }
}

// **************************************************************************
// FUNCTION: RemoveAllGraphics
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.RemoveAllGraphics = function RemoveAllGraphics() {

    // Get the instance ...
    var objShapeEditor = this;

    // Loop through all the part graphics ...
    $.each(objShapeEditor.EsriGraphicByPartID, function (strPartID, objEsriGraphic) {

        // When we have a graphics ...
        if (objEsriGraphic) {

            // Remove the graphic from the map ...
            objShapeEditor.MapController.RemoveGraphic(objEsriGraphic);
        }
    });

    // Loop through all the point graphics ...
    $.each(objShapeEditor.EsriPointGraphicsByPartID, function (strEsriPointGraphicsByPartID, arrEsriPointGraphics) {

        // When we have point graphics ...
        if (arrEsriPointGraphics) {

            // Remove the point graphics from the map ...
            $.each(arrEsriPointGraphics, function (intPoint, objEsriPointGraphic) { objShapeEditor.MapController.RemoveGraphic(objEsriPointGraphic); });
        }
    });

    // Loop through all the reference point graphics ...
    $.each(objShapeEditor.EsriGraphicByReferencePointID, function (strReferencePointID, objEsriGraphic) {

        // When we have a graphic ...
        if (objEsriGraphic) {

            // Remove the graphic from the map ...
            objShapeEditor.MapController.RemoveGraphic(objEsriGraphic);
        }
    });

    // Set to have no graphics ...
    objShapeEditor.EsriGraphicByPartID = {};
    objShapeEditor.EsriPointGraphicsByPartID = {};
    objShapeEditor.EsriGraphicByReferencePointID = {};
}

// **************************************************************************
// FUNCTION: GetModifiedPartCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetModifiedPartCoordinates = function GetModifiedPartCoordinates(objShapePart) {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the coordinates from the part ...
    var arrCoordinates = objShapePart.Coordinates;

    // When we are editing a part ...
    if (objShapeEditor.EditingCoordinateMode) {

        // When the part is selected ...
        if (objShapeEditor.SelectedPart.ID == objShapePart.ID) {

            // Get the coordinates from the coordinate list editor
            arrCoordinates = objShapeEditor.CoordinateListEditor.GetCoordinates(false);

        } else {

            // When the part is an interior part ...
            if (!objShapeEditor.Shape.IsExteriorPart(objShapePart)) {

                // Get the part's exterior part ...
                let objExteriorPart = objShapeEditor.Shape.GetExteriorPartForInteriorPart(objShapePart);

                // When the part's exterior part is selected ...
                if (objShapeEditor.SelectedPart.ID == objExteriorPart.ID) {

                    // Get the modified interior part coordinates ...
                    arrCoordinates = ModifiedInteriorPartCoordinates[$.inArray(objShapePart, objExteriorPart.Parts)];
                }
            }
        }
    }

    return arrCoordinates;
}

// **************************************************************************
// FUNCTION: ZoomToShapePart
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ZoomToShapePart = function ZoomToShapePart(objShapePart) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the esri map has been loaded and we are to show the parts ...
    if (objShapeEditor.MapController.IsEsriMapLoaded() && objShapeEditor.Options.ShowPartsInListAndMap) {

        // Create the esri spatial reference for the spatial reference ID of the shape ...
        var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // Get the coordinates from the part ...
        var arrCoordinates = objShapeEditor.GetModifiedPartCoordinates(objShapePart);

        // Create an esri geometry from the part's coordinates and spatial reference ...
        var objGeometry = TrimbleMap.ShapePart.Shared.EsriGeometryFromCoordinates(arrCoordinates, objEsriSpatialReference, objShapeEditor.Shape.GeometryType);

        // Project to the spatial reference of the map ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objGeometry,
            objShapeEditor.Shape.SpatialReferenceID,
            objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
            true, TrimbleMap.enumProjectionLevel.RELAXED);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedGeometry) {

            // When we have a projected geometry ...
            if (objProjectedGeometry) {

                // Compute an extent to zoom to the geometry ...
                objShapeEditor.MapController.ComputeZoomToExtent(objProjectedGeometry, 2, 0).then(TrimbleMap.Controller.Shared.TrapException(function (objEsriExtent) {

                    // Set the extent on the map ...
                    objShapeEditor.MapController.SetMapExtent(objEsriExtent);
                }));

            } else {

                // Notify the user tha the part has no coordinets ...
                TrimbleMap.MessageBox.Shared.ShowMessage('Unable to zoom to part', 'The part has no coordinates');
            }

        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

            // When it's a measures out of bounds exception ...
            if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

                // Get the spatial reference of the map ...
                var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.MapController.CurrentMap.SpatialReferenceID);

                // Set the translations ...

                // Not valid in the coordinate system of the map
                var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'UnableToZoomToPartTitle');

                // Unable to zoom to the part. The coordinates of the part is not<br />valid in the coordinate system of the map
                var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'UnableToZoomToPartMessage') + ': ' + objSpatialReference.Name;

                // Notify the user ...
                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
            }
        }));
    }
}

// **************************************************************************
// FUNCTION: ZoomToReferencePoint
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.ZoomToReferencePoint = function ZoomToReferencePoint(objReferencePoint) {

    // Get the instance ...
    var objShapeEditor = this;

    // When the esri map has been loaded and we are to show the parts ...
    if (objShapeEditor.MapController.IsEsriMapLoaded() && objShapeEditor.Options.ShowPartsInListAndMap) {

        // Create the esri spatial reference for the spatial reference ID of the shape ...
        var objEsriSpatialReference = objShapeEditor.MapController.CreateEsriSpatialReference(objShapeEditor.Shape.SpatialReferenceID);

        // Start with no gemetry ...
        var objGeometry = null;

        // When we are editing the reference point and the reference point to zoom to is selected ...
        if (objShapeEditor.EditingReferencePoint && (objShapeEditor.SelectedReferencePoint == objReferencePoint)) {

            // Get the completed coordinates ...
            var arrCoordinates = objShapeEditor.ReferencePointCoordinateListEditor.GetCoordinates(false);

            // When we have reference point coordinate ..
            if (arrCoordinates.length > 0) {

                // Create a point with the coordinate ...
                objGeometry = new esri.geometry.Point(arrCoordinates[0].X, arrCoordinates[0].Y, objEsriSpatialReference);
            }

        } else {

            // When the reference point has values ...
            if (objReferencePoint.HasValues) {

                // Create a point with the reference point ... ...
                objGeometry = new esri.geometry.Point(objReferencePoint.X, objReferencePoint.Y, objEsriSpatialReference);
            }
        }

        // Project to the spatial reference of the map ...
        var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objGeometry,
            objShapeEditor.Shape.SpatialReferenceID,
            objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
            true);

        // When the projection completes ...
        objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedGeometry) {

            // When we have a projected geometry ...
            if (objProjectedGeometry) {

                // Compute the extent to zoom to and expand by a factor of 2 ...
                objShapeEditor.MapController.ComputeZoomToExtent(objProjectedGeometry, 2, 0).then(TrimbleMap.Controller.Shared.TrapException(function (objEsriExtent) {

                    // Set the extent on the map when we have an extent to set ...
                    objShapeEditor.MapController.SetMapExtent(objEsriExtent);
                }));

            } else {

                // Notify the user tha the part has no coordinates ...
                TrimbleMap.MessageBox.Shared.ShowMessage('Unable to zoom to reference point', 'The reference point does not have a coordinate');
            }

        }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

            // When it's a measures out of bounds exception ...
            if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

                // Get the spatial reference of the map ...
                var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.MapController.CurrentMap.SpatialReferenceID);

                // Set the translations ...

                // Not valid in the coordinate system of the map
                var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'UnableToZoomToPartTitle');

                // Unable to zoom to the reference point. The reference point is not<br />valid in the coordinate system of the map
                var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'UnableToZoomToPartMessage') + ': ' + objSpatialReference.Name;

                // Notify the user ...
                TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
            }
        }));
    }
}

// **************************************************************************
// FUNCTION: ZoomToShape
// USAGE:    blnNotifyWhenProblems is optional, defaults to false ...
// **************************************************************************
TrimbleMap.ShapeEditor.ZoomToShape = function ZoomToShape(blnNotifyWhenProblems) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a new deferred to return ...
    var objDeferred = new dojo.Deferred();

    // When the esri map has been loaded and we are to show the parts ...
    if (objShapeEditor.MapController.IsEsriMapLoaded() && objShapeEditor.Options.ShowPartsInListAndMap) {

        // Convert the shape to an esri polygon ...
        var objEsriPolygon = objShapeEditor.Shape.GetExtentEsriGeometry(objShapeEditor.MapController);

        // Create a function that will notify the user that the shape has no coordinates when blnNotifyWhenProblems is true ...
        var fnNotify = function () { if ((typeof blnNotifyWhenProblems != 'undefined') && (blnNotifyWhenProblems)) { TrimbleMap.MessageBox.Shared.ShowMessage('Unable to zoom to shape', 'The shape has no coordinates'); } }

        // When we have a geometry ...
        if (objEsriPolygon) {

            // Project to the spatial reference of the map ...
            var objProjectGeometryDeferred = objShapeEditor.MapController.ProjectGeometry(objEsriPolygon,
                objShapeEditor.Shape.SpatialReferenceID,
                objShapeEditor.MapController.CurrentMap.SpatialReferenceID,
                true, TrimbleMap.enumProjectionLevel.RELAXED);

            // When the projection completes ...
            objProjectGeometryDeferred.then(TrimbleMap.Controller.Shared.TrapException(function (objProjectedGeometry) {

                // When we have a projected geometry ...
                if (objProjectedGeometry) {

                    // Compute the extent to zoom to and expand by a factor of 2 ...
                    objShapeEditor.MapController.ComputeZoomToExtent(objProjectedGeometry, 2, 0).then(TrimbleMap.Controller.Shared.TrapException(function (objEsriExtent) {

                        // Set the extent on the map when we have an extent to set ...
                        objShapeEditor.MapController.SetMapExtent(objEsriExtent).then(TrimbleMap.Controller.Shared.TrapException(function () {

                            // Resolve the deferred to indicate completion ...
                            objDeferred.resolve();
                        }));
                    }));

                } else {

                    // Notify the user that the shape has no coordinates when blnNotifyWhenProblems is true ...
                    fnNotify();

                    // Reject the deferred to indicate failure ...
                    objDeferred.reject();
                }

            }), TrimbleMap.Controller.Shared.TrapException(function (objError) {

                // When it's a measures out of bounds exception ...
                if ((typeof objError.IsMeasuresOutOfBoundsException != 'undefined') && objError.IsMeasuresOutOfBoundsException) {

                    // Get the spatial reference of the shape ...
                    var objSpatialReference = objShapeEditor.MapController.GetSpatialReference(objShapeEditor.MapController.CurrentMap.SpatialReferenceID);

                    // Set the translations ...

                    // Not valid in the coordinate system of the map
                    var strTitle = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'UnableToZoomToPartTitle');

                    // Unable to zoom to the shape. The coordinates is not<br />valid in the coordinate system of the map
                    var strMessage = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'UnableToZoomToPartMessage') + ': ' + objSpatialReference.Name;

                    // Notify the user ...
                    TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, strMessage);
                }

                // Reject the deferred to indicate failure ...
                objDeferred.reject(objError);
            }));

        } else {

            // Notify the user that the shape has no coordinates when blnNotifyWhenProblems is true ...
            fnNotify();

            // Reject the deferred to indicate failure ...
            objDeferred.resolve();
        }

    } else {

        // Resolve the deferred ...
        objDeferred.resolve();
    }


    return objDeferred;
}

// **************************************************************************
// FUNCTION: CreateSymbols
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateSymbols = function CreateSymbols() {

    // Get the instance ...
    var objShapeEditor = this;

    // Create the point symbol ...
    objShapeEditor.PointSymbol = new esri.symbol.SimpleMarkerSymbol(esri.symbol.SimpleMarkerSymbol.STYLE_CIRCLE, 7,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 1),
        new dojo.Color([255, 255, 255, 1]));

    // Create the line symbol ...
    objShapeEditor.LineSymbol = new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 1);

    // Create the polygon symbol ...
    objShapeEditor.FilledPolygonSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 1),
        new dojo.Color([255, 0, 0, 0.1]));

    // Create the a hollow polygon symbol ...
    objShapeEditor.HollowPolygonSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 1),
        new dojo.Color([255, 0, 0, 0]));

    // Create the point symbol ...
    objShapeEditor.SelectedPointSymbol = new esri.symbol.SimpleMarkerSymbol(esri.symbol.SimpleMarkerSymbol.STYLE_CIRCLE, 7,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 2),
        new dojo.Color([255, 255, 255, 1]));

    // Create the line symbol ...
    objShapeEditor.SelectedLineSymbol = new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 2);

    // Create the polygon symbol ...
    objShapeEditor.SelectedFilledPolygonSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 2),
        new dojo.Color([255, 0, 0, 0.2]));

    // Create the a hollow polygon symbol ...
    objShapeEditor.SelectedHollowPolygonSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 2),
        new dojo.Color([255, 0, 0, 0]));

    // Create the a hollow polygon symbol ...
    objShapeEditor.SelectedHollowPolygonSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 2),
        new dojo.Color([255, 0, 0, 0]));

    // Create the hovered point symbol ...
    objShapeEditor.HoveredPointSymbol = new esri.symbol.SimpleMarkerSymbol(esri.symbol.SimpleMarkerSymbol.STYLE_CIRCLE, 7,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 2),
        new dojo.Color([255, 0, 0, 1]));


    // Create the a edit vertex symbol ...
    objShapeEditor.VertexSymbol = new esri.symbol.SimpleMarkerSymbol(esri.symbol.SimpleMarkerSymbol.STYLE_CIRCLE, 12,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 2),
        new dojo.Color([255, 255, 255, 1]));

    // Create the a edit vertex symbol ...
    objShapeEditor.SelectedVertexSymbol = new esri.symbol.SimpleMarkerSymbol(esri.symbol.SimpleMarkerSymbol.STYLE_CIRCLE, 12,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 2),
        new dojo.Color([255, 0, 0, 1]));

    // Create the a add vertex symbol ...
    objShapeEditor.GhostVertexSymbol = new esri.symbol.SimpleMarkerSymbol(esri.symbol.SimpleMarkerSymbol.STYLE_CIRCLE, 10,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([0, 0, 0, 0.5]), 1),
        new dojo.Color([255, 255, 255, 0.75]));

    // Create the symbol to draw the block selection hovered block with ...
    objShapeEditor.BlockSelectionHoveredBlockSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0]), 1, 0.2),
        new dojo.Color([255, 0, 0, 0.4]));

}

// **************************************************************************
// FUNCTION: GetSymbolToUse
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetSymbolToUse = function GetSymbolToUse(intNumberOfVertices, blnIsExteriorPart, blnSelected, blnEditing) {

    // Get the instance ...
    var objShapeEditor = this;

    // Declare a variable for the symbol to use ...
    var objSymbol;

    if (blnSelected) {

        // Set the symbol to use based on the number of coordinates ...
        switch (true) {
            case (intNumberOfVertices == 1):
                objSymbol = (blnEditing) ? objShapeEditor.VertexSymbol : objShapeEditor.SelectedPointSymbol; break;
            case ((objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYLINE) || (intNumberOfVertices == 2)):
                objSymbol = objShapeEditor.SelectedLineSymbol; break;
            case (intNumberOfVertices >= 3):
                objSymbol = (blnIsExteriorPart) ? objShapeEditor.SelectedFilledPolygonSymbol : objShapeEditor.SelectedHollowPolygonSymbol; break;
        }

    } else {

        // Set the symbol to use based on the number of coordinates ...
        switch (true) {
            case (intNumberOfVertices == 1):
                objSymbol = objShapeEditor.PointSymbol; break;
            case ((objShapeEditor.Shape.GeometryType == TrimbleMap.Shape.enumGeometryType.POLYLINE) || (intNumberOfVertices == 2)):
                objSymbol = objShapeEditor.LineSymbol; break;
            case (intNumberOfVertices >= 3):
                objSymbol = (blnIsExteriorPart) ? objShapeEditor.FilledPolygonSymbol : objShapeEditor.HollowPolygonSymbol; break;
        }
    }

    return objSymbol;
}

// **************************************************************************
// FUNCTION: GetReferencePointSymbolToUse
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetReferencePointSymbolToUse = function GetReferencePointSymbolToUse(blnSelected, blnEditing) {

    // Get the instance ...
    var objShapeEditor = this;

    // Determine the symbol to use ...
    var objSymbol = (blnEditing) ? objShapeEditor.VertexSymbol : (blnSelected) ? objShapeEditor.SelectedPointSymbol : objShapeEditor.PointSymbol;

    // Return the symbol ...
    return objSymbol;
}

// **************************************************************************
// FUNCTION: GetDecimalPlacesForSpatialReferenceOfShape
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.GetDecimalPlacesForSpatialReferenceOfShape = function GetDecimalPlacesForSpatialReferenceOfShape() {

    // Get the instance ...
    var objShapeEditor = this;

    // Get the number of decimal places for the spatial reference ...
    var intDecimalPlaces = TrimbleMap.Shape.Shared.DecimalPlacesForSpatialReference(objShapeEditor.MapController, objShapeEditor.Shape.SpatialReferenceID);

    // Return the number of decimal places ...
    return intDecimalPlaces;
}

// **************************************************************************
// FUNCTION: AddOnShowFunction
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AddOnShowFunction = function AddOnShowFunction(fnOnShow) {

    // Get the instance ...
    var objShapeEditor = this;

    // Add the function to the list of on show functions ...
    objShapeEditor.OnShowFunctions.push(fnOnShow);
}

// **************************************************************************
// FUNCTION: AddOnHideFunction
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.AddOnHideFunction = function AddOnHideFunction(fnOnHide) {

    // Get the instance ...
    var objShapeEditor = this;

    // Add the function to the list of on hide functions ...
    objShapeEditor.OnHideFunctions.push(fnOnHide);
}

// **************************************************************************
// FUNCTION: TriggerOnShowFunctions
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.TriggerOnShowFunctions = function TriggerOnShowFunctions() {

    // Get the instance ...
    var objShapeEditor = this;

    // Loop through all the on show functions ...
    $.each(objShapeEditor.OnShowFunctions, function (intOnShow, fnOnShow) {

        // Call the on show function ...
        fnOnShow();
    });
}

// **************************************************************************
// FUNCTION: TriggerOnHideFunctions
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.TriggerOnHideFunctions = function TriggerOnHideFunctions() {

    // Get the instance ...
    var objShapeEditor = this;

    // Loop through all the on hide functions ...
    $.each(objShapeEditor.OnHideFunctions, function (intOnHide, fnOnHide) {

        // Call the on hide function ...
        fnOnHide();
    });
}

// **************************************************************************
// FUNCTION: CreateIconElement
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.CreateIconElement = function CreateIconElement(objIcon, intIcon, enGeometryType) {

    // Get the instance ...
    var objShapeEditor = this;

    // Create a variable for the element to return ...
    var objElement;

    // When the icon is a separator ...
    if (objIcon.IsSeparator) {

        // Create a separator div ...
        objElement = $('<div class="shape_button_separator_div FloatLeft"></div>');

    } else {

        // When the icon is a predefined icon ...
        if (objIcon.IsPredefined) {

            // Create the predefined icon element ...
            objElement = TrimbleMap.ShapeEditor.Shared.CreatePredefinedIconElement(objIcon, enGeometryType);

        } else {

            // Create the icon div ...
            objElement = $('<div class="menu-item" IconIndex="' + intIcon + '"><span class="description">' + objIcon.Name + '...</span></div>');
        }
    }

    return objElement;
}

// **************************************************************************
// FUNCTION: DrawModeIconCssClass
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.DrawModeIconCssClass = function DrawModeIconCssClass(enDrawMode) {

    // Depending on the draw mode ...
    switch (enDrawMode) {
        case TrimbleMap.ShapeEditor.enumDrawMode.Add: return "draw-add-icon"; break;
        case TrimbleMap.ShapeEditor.enumDrawMode.Remove: return "draw-remove-icon"; break;
    }
}

// **************************************************************************
// FUNCTION: ChooseExistingShapeDrawModeIconCssClass
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.ChooseExistingShapeDrawModeIconCssClass = function ChooseExistingShapeDrawModeIconCssClass(enDrawMode) {

    // Depending on the draw mode ...
    switch (enDrawMode) {
        case TrimbleMap.ShapeEditor.enumChooseExistingShapeOperation.ChooseExistingShapeAdd: return "draw-add-icon"; break;
        case TrimbleMap.ShapeEditor.enumChooseExistingShapeOperation.ChooseExistingShapeRemove: return "draw-remove-icon"; break;
    }
}

// **************************************************************************
// FUNCTION: CreateDrawToAddCall
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateDrawToAddCall = function CreateDrawToAddCall(objShapeEditor, objGeometry, guidSpatialReference, blnMergeToTouchingParts, blnRemoveCoordinatesFromStraightLine) {

    // Create and return a function that will call DrawToAdd on the shape editor ...
    return function () { return objShapeEditor.DrawToAdd(objGeometry, guidSpatialReference, null, blnMergeToTouchingParts, blnRemoveCoordinatesFromStraightLine); }
}

// **************************************************************************
// FUNCTION: CreateDrawToRemoveCall
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateDrawToRemoveCall = function CreateDrawToRemoveCall(objShapeEditor, objGeometry, guidSpatialReference, blnRemoveCoordinatesFromStraightLine) {

    // Create and return a function that will call DrawToRemove on the shape editor ...
    return function () { return objShapeEditor.DrawToRemove(objGeometry, guidSpatialReference, blnRemoveCoordinatesFromStraightLine); }
}

// **************************************************************************
// FUNCTION: FindSingleExteriorRingIndex
// USAGE:    Asumes input polygon has only one exterior ring, this function finds it and return it's index ...
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.FindSingleExteriorRingIndex = function FindSingleExteriorRingIndex(objEsriPolygon) {

    // Start with the first ring being the exterior ring ...
    var intExteriorRing = 0;

    // When more than one ring present ...
    if (objEsriPolygon.rings.length > 1) {

        // Loop through all the rings ...
        $.each(objEsriPolygon.rings, function (intRing, objRing) {

            // Start with not being found ...
            var blnFound = false;

            // When the rings winding order is clockwise  ...
            if (objEsriPolygon.isClockwise(objRing)) {

                // Set the exterior ring index ...
                intExteriorRing = intRing;

                // Set to be found ...
                blnFound = true;
            }

            // Stop checking when found ...
            return !blnFound;
        });
    }

    return intExteriorRing;
}

// **************************************************************************
// FUNCTION: CreatePredefinedIconElement
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreatePredefinedIconElement = function CreatePredefinedIconElement(objIcon, enGeometryType) {

    // Create a variable for the element to return ...
    var objElement = null;

    switch (objIcon.PredefinedIcon) {
        case TrimbleMap.ShapeEditor.enumPredefinedIcon.DrawPolygon:

            // Determine the translation to use based on the geometry type ...
            var strDrawOnMapTranslation = '';

            switch (enGeometryType) {
                case TrimbleMap.Shape.enumGeometryType.POINT:
                    strDrawOnMapTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ClickOnMapToAddPoint');
                    break;
                case TrimbleMap.Shape.enumGeometryType.POLYLINE:
                    strDrawOnMapTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ClickOnMapToAddPolyline');
                    strDrawOnMapTranslation += " " + SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DoubleClickToFinish');
                    break;
                case TrimbleMap.Shape.enumGeometryType.POLYGON:
                case TrimbleMap.Shape.enumGeometryType.MIXED:
                    strDrawOnMapTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ClickOnMapToAddPolygon');
                    strDrawOnMapTranslation += " " + SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DoubleClickToFinish');
                    break;
            }

            // Add the Draw to Add span ...
            objElement = $('<div ShapeTool="' + TrimbleMap.ShapeEditor.enumToolMode.DrawGeometry + '"><span class="description">' + strDrawOnMapTranslation + '</span></div>');
            break;

        case TrimbleMap.ShapeEditor.enumPredefinedIcon.BlockSelectionByPoint:

            // When a polygon shape ...
            if (enGeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) {

                // 'Click to select block'
                var strBlockSelectionByPointToolTip = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ClickToSelectBlock');

                // Add the Draw to Remove icon ...
                objElement = $('<div class="menu-item" ShapeTool="' + TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPoint + '"><span>' + strBlockSelectionByPointToolTip + '</span></div>');
            }
            break;

        case TrimbleMap.ShapeEditor.enumPredefinedIcon.BlockSelectionByPolygon:

            // When a polygon shape ...
            if (enGeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) {

                // 'Draw polygon to select blocks'
                var strBlockSelectionByPolygonToolTip = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'DrawPolygonToSelectBlocks');

                // Add the Draw to Remove icon ...
                objElement = $('<div class="menu-item" ShapeTool="' + TrimbleMap.ShapeEditor.enumToolMode.BlockSelectionByPolygon + '"><span>' + strBlockSelectionByPolygonToolTip + '</span></div>');
            }
            break;

        case TrimbleMap.ShapeEditor.enumPredefinedIcon.DrawMode:

            // When a polygon shape ...
            if ((enGeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) && (TrimbleMap.Shape.enumGeometryType.MIXED)) {

                // Add the Draw to Remove icon ...
                objElement = $('<div class="shape_draw_mode_icon_div FloatLeft" IsDrawModePopupIcon="true"><div><div class="draw-mode-icon draw-add-icon"></div><div class="draw-arrow-icon"></div></div></div>');
            }
            break;

        case TrimbleMap.ShapeEditor.enumPredefinedIcon.ReProject:

            // Get the translation for the tool tip ...
            var strReprojectCoordinatesTranslation = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ReprojectCoordinates');

            // Add the Reproject icon ...
            objElement = $('<div class="menu-item" IsReProjectPopupIcon="true"><span>' + strReprojectCoordinatesTranslation + '...</span></div>');
            break;

        case TrimbleMap.ShapeEditor.enumPredefinedIcon.ZoomToShape:

            // Zoom To Shape
            var strZoomToShapeToolTip = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'ZoomToShape');

            // Add the Reproject icon ...
            objElement = $('<div class="menu-item" ZoomToShapeIcon="true"><span>' + strZoomToShapeToolTip + '</span></div>');
            break;

        case TrimbleMap.ShapeEditor.enumPredefinedIcon.MergeParts:

            // When a polygon shape ...
            if (enGeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) {

                // Merge touching or overlapping parts
                var strMergePartsToolTip = SD.Translation.Shared.GetTranslation('Map.ShapeEditor.js', 'MergeTouchingOrOverlappingParts');

                // Add the Reproject icon ...
                objElement = $('<div class="menu-item" MergePartsIcon="true"><span>' + strMergePartsToolTip + '<span></div>');
            }
            break;

        case TrimbleMap.ShapeEditor.enumPredefinedIcon.ConstructShapeFromCentroid:

            // When a polygon shape ...
            if (enGeometryType == TrimbleMap.Shape.enumGeometryType.POLYGON) {
                // Add the construct shape from centroid icon ...
                objElement = $('<div class="menu-item" ConstructShapeFromCentroid="true"><span>' + objIcon.ToolTipTitle + '<span></div>');
            }
            break;
    }

    return objElement;
}

// **************************************************************************
// FUNCTION: CreatePredefinedIcon
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreatePredefinedIcon = function CreatePredefinedIcon(enPredefinedIcon, blnAdvancedMenu) {

    // Create and return the predefined icon instance ...
    return TrimbleMap.ShapeEditor.Shared.CreateIcon(null, null, null, true, enPredefinedIcon, false, false, blnAdvancedMenu, null, null, null, false, null, null);
}

// **************************************************************************
// FUNCTION: CreateCustomIcon
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateCustomIcon = function CreateCustomIcon(strCSSClassName, strToolTipTitle, fnClick) {

    // Create and return the custom button instance ...
    return TrimbleMap.ShapeEditor.Shared.CreateIcon(strCSSClassName, strToolTipTitle, fnClick, false, null, false, false, true, null, null, null, false, null, null);
}

// **************************************************************************
// FUNCTION: CreateCustomDropDownIcon
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateCustomDropDownIcon = function CreateCustomDropDownIcon(strCSSClassName, strToolTipTitle, fnActivatePopup, fnDeActivatePopup, fnPopupOpened) {

    // Create and return the custom button instance ...
    return TrimbleMap.ShapeEditor.Shared.CreateIcon(strCSSClassName, strToolTipTitle, null, false, null, false, true, false, fnActivatePopup, fnDeActivatePopup, fnPopupOpened, false, null, null);
}

// **************************************************************************
// FUNCTION: CreateCustomDropDownMenuIcon
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateCustomDropDownMenuIcon = function CreateCustomDropDownMenuIcon(strCSSClassName, strToolTipTitle, arrMenuItems, fnMenuItemClicked) {

    // Create and return the custom button instance ...
    return TrimbleMap.ShapeEditor.Shared.CreateIcon(strCSSClassName, strToolTipTitle, null, false, null, false, false, false, null, null, null, true, arrMenuItems, fnMenuItemClicked);
}

// **************************************************************************
// FUNCTION: CreateIconSeparator
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateIconSeparator = function CreateIconSeparator() {

    // Create and return the custom button instance ...
    return TrimbleMap.ShapeEditor.Shared.CreateIcon(null, null, null, null, null, true, false, false, null, null, null, false, null, null);
}

// **************************************************************************
// FUNCTION: CreateIcon
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateIcon = function CreateIcon(strCSSClassName,
    strToolTipTitle,
    fnClick,
    blnIsPredefined,
    enPredefinedIcon,
    blnIsSeparator,
    blnIsPopup,
    blnIsAdvanced,
    fnActivatePopup,
    fnDeActivatePopup,
    fnPopupOpened,
    blnIsMenu,
    arrMenuItems,
    fnMenuItemClicked) {

    // Create and return the button instance ...
    return {
        CSSClass: strCSSClassName,
        ToolTipTitle: strToolTipTitle,
        Name: strToolTipTitle,
        ClickFunction: fnClick,
        IsPredefined: blnIsPredefined,
        PredefinedIcon: enPredefinedIcon,
        IsSeparator: blnIsSeparator,
        IsPopup: blnIsPopup,
        IsAdvanced: blnIsAdvanced,
        ActivatePopupFunction: fnActivatePopup,
        DeActivatePopupFunction: fnDeActivatePopup,
        PopupOpenedFunction: fnPopupOpened,
        IsMenu: blnIsMenu,
        MenuItems: arrMenuItems,
        MenuItemClickedFunction: fnMenuItemClicked,
        HorizontalAlignment: TrimbleMap.ShapeEditor.enumHorizontalAlignment.Left
    };
}

// **************************************************************************
// FUNCTION: CreateShapeEditorOptions
// USAGE:    objGridOptions appplies to the following tools:
//              Polygon to block
//              Draw polygon to select blocks
//              Select blocks
//           objGridOptions should be an object with the following properties:
//              SpatialReferenceID
//              GridBlockSideLengthMultiplier
//              GridBlockSideLengthDivider
//              GridColorRed
//              GridColorGreen
//              GridColorBlue
// **************************************************************************
TrimbleMap.ShapeEditor.Shared.CreateShapeEditorOptions = function CreateShapeEditorOptions(objShape,
    arrIcons,
    arrClientSideImporters,
    blnShowOfficialArea,
    blnShowOfficialLength,
    blnShowDynamicShape,
    blnShowLegalDescription,
    blnLegalDescriptionEditable,
    blnShowPartsInListAndMap,
    blnAllowEditingOfOfficialAreaOnly,
    blnOfficialAreaEditable,
    blnOfficialLengthEditable,
    guidDefaultAreaUnit,
    arrAreaUnitIDs,
    guidDefaultDistanceUnit,
    arrDistanceUnitIDs,
    arrCommonlyUsedSpatialReferenceIDs,
    objGridOptions,
    blnPartsRequired,
    blnOfficialAreaRequired,
    blnOfficialLengthRequired,
    objValidationMessages,
    fnOpenDynamicShapeOptionsDialog,
    objTcpfConfiguration,
    blnShowDrawOnMap,
    blnShowEditCoordinates,
    blnShowAdvancedTools,
    blnShowPickFromMap,
    blnShowImportCoordinates,
    strDefaultSelectedEditor) {

    // Create and return the shape editor options ...
    return {
        Shape: objShape,
        Icons: arrIcons,
        ClientSideImporters: arrClientSideImporters,
        ShowOfficialArea: blnShowOfficialArea,
        ShowOfficialLength: blnShowOfficialLength,
        ShowDynamicShape: blnShowDynamicShape,
        ShowLegalDescription: blnShowLegalDescription,
        LegalDescriptionEditable: blnLegalDescriptionEditable,
        ShowPartsInListAndMap: blnShowPartsInListAndMap,
        AllowEditingOfOfficialAreaOnly: blnAllowEditingOfOfficialAreaOnly,
        OfficialAreaEditable: blnOfficialAreaEditable,
        OfficialLengthEditable: blnOfficialLengthEditable,
        OpenDynamicShapeOptionsDialogFunction: fnOpenDynamicShapeOptionsDialog,
        DefaultAreaUnitID: guidDefaultAreaUnit,
        AreaUnitIDs: arrAreaUnitIDs,
        DefaultDistanceUnitID: guidDefaultDistanceUnit,
        DistanceUnitIDs: arrDistanceUnitIDs,
        CommonlyUsedSpatialReferenceIDs: arrCommonlyUsedSpatialReferenceIDs,
        GridOptions: objGridOptions,
        PartsRequired: blnPartsRequired,
        OfficialAreaRequired: blnOfficialAreaRequired,
        OfficialLengthRequired: blnOfficialLengthRequired,
        ValidationMessages: objValidationMessages,
        TcpfConfiguration: objTcpfConfiguration,
        ShowDrawOnMap: (blnShowDrawOnMap == 'undefined' || blnShowDrawOnMap == null) ? true : blnShowDrawOnMap,
        ShowEditCoordinates: (blnShowEditCoordinates == 'undefined' || blnShowEditCoordinates == null) ? true : blnShowEditCoordinates,
        ShowAdvancedTools: (blnShowAdvancedTools == 'undefined' || blnShowAdvancedTools == null) ? true : blnShowAdvancedTools,
        ShowPickFromMap: (blnShowPickFromMap == 'undefined' || blnShowPickFromMap == null) ? true : blnShowPickFromMap,
        ShowImportCoordinates: (blnShowImportCoordinates == 'undefined' || blnShowImportCoordinates == null) ? true : blnShowImportCoordinates,
        DefaultSelectedEditor: strDefaultSelectedEditor
    };
}
/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ShapeEditorOptions = {};
TrimbleMap.ShapeEditorOptions.Shared = {};

TrimbleMap.ShapeEditorOptions.enumTool = {};
TrimbleMap.ShapeEditorOptions.enumTool.DrawOnMap = 'DrawOnMap';
TrimbleMap.ShapeEditorOptions.enumTool.ChooseExistingShape = 'ChooseExistingShape';
TrimbleMap.ShapeEditorOptions.enumTool.ImportCoordinates = 'ImportCoordinates';
TrimbleMap.ShapeEditorOptions.enumTool.TypeCoordinates = 'TypeCoordinates';
TrimbleMap.ShapeEditorOptions.enumTool.AdvancedTools = 'AdvancedTools';

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.CreateInstance = function CreateInstance(objShapeEditor) {

    // Create the object that will hold the instance properties ...
    var objShapeEditorOptions = {
        ShapeEditor: objShapeEditor,
        Visible: false,
        MenuElement: null,
        MenuItemContainerElement: null,
        SubMenuContainerElement: null,
        MenuMouseLeaveTimer: null,
        MenuItems: [],
        VisibleSubMenuItem: null,
        VisibleSubMenuDiv: null,
        OnSubMenuOpenedFunctions: [],

        MenuElementClickedProxy: function (e) { objShapeEditorOptions.MenuElementClicked(e) },

        CreateAndShowElements: TrimbleMap.ShapeEditorOptions.CreateAndShowElements,
        CreateMenuItemElements: TrimbleMap.ShapeEditorOptions.CreateMenuItemElements,
        GetMenuItemDiv: TrimbleMap.ShapeEditorOptions.GetMenuItemDiv,
        Hide: TrimbleMap.ShapeEditorOptions.Hide,
        AddMenuItem: TrimbleMap.ShapeEditorOptions.AddMenuItem,
        RemoveMenuItem: TrimbleMap.ShapeEditorOptions.RemoveMenuItem,
        GetMenuItemIndex: TrimbleMap.ShapeEditorOptions.GetMenuItemIndex,
        ShowSubMenu: TrimbleMap.ShapeEditorOptions.ShowSubMenu,
        HideSubMenu: TrimbleMap.ShapeEditorOptions.HideSubMenu,
        SubMenuHeightChanged: TrimbleMap.ShapeEditorOptions.SubMenuHeightChanged,
        UpdateVerticalDivider: TrimbleMap.ShapeEditorOptions.UpdateVerticalDivider,
        UpdateMenuElements: TrimbleMap.ShapeEditorOptions.UpdateMenuElements,
        MenuElementClicked: TrimbleMap.ShapeEditorOptions.MenuElementClicked,
        MenuItemClicked: TrimbleMap.ShapeEditorOptions.MenuItemClicked,
        AddOnSubMenuOpenedCallback: TrimbleMap.ShapeEditorOptions.AddOnSubMenuOpenedCallback,
        TriggerOnSubMenuOpened: TrimbleMap.ShapeEditorOptions.TriggerOnSubMenuOpened,
        AttachPopupEventHandlers: TrimbleMap.ShapeEditorOptions.AttachPopupEventHandlers,
        DetachPopupEventHandlers: TrimbleMap.ShapeEditorOptions.DetachPopupEventHandlers,
        ResetSubMenu: TrimbleMap.ShapeEditorOptions.ResetSubMenu,
        CreatePredefinedMenuItems: TrimbleMap.ShapeEditorOptions.CreatePredefinedMenuItems
    };

    //show items
    objShapeEditorOptions.CreatePredefinedMenuItems();

    // Add the onloaded event handler to the map controller ...
    objShapeEditorOptions.ShapeEditor.MapController.AddOnLoadedCallback(objShapeEditorOptions.ShapeEditor.PopulateSelectShapesFromDropDownProxy);

    return objShapeEditorOptions;
}


// **************************************************************************
// FUNCTION: CreateAndShowElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.CreateAndShowElements = function CreateAndShowElements() {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // When we've not created the menu yet ...
    if (objShapeEditorOptions.MenuElement == null) {

        // Create the menu div and the container elements for the menu items and the sub menu ...
        objShapeEditorOptions.MenuElement = $('<div id="menu_wrapper"></div>');
        objShapeEditorOptions.MenuItemContainerElement = $('<div class="shape-menu"></div>');
        objShapeEditorOptions.SubMenuContainerElement = $('<div class="shape-menu-contents"></div>');

        // Add the containers to the menu element ...
        objShapeEditorOptions.MenuElement.append(objShapeEditorOptions.MenuItemContainerElement);
        objShapeEditorOptions.MenuElement.append(objShapeEditorOptions.SubMenuContainerElement);

        // Create the item elemnts ...
        objShapeEditorOptions.CreateMenuItemElements();

        // Add to the document ...
        objShapeEditorOptions.ShapeEditor.IconsDiv.append(objShapeEditorOptions.MenuElement);

        // Attach the mouse leave and enter event handler to the menu and extended menu icon ...
        objShapeEditorOptions.AttachPopupEventHandlers();

    } else {

        // Show the menu ...
        objShapeEditorOptions.MenuElement.show();
    }

    // Set to be visible ...hehehe          
    objShapeEditorOptions.Visible = true;
}

// **************************************************************************
// FUNCTION: CreateMenuItemElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.CreateMenuItemElements = function CreateMenuItemElements() {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Clear the item container ...
    objShapeEditorOptions.MenuItemContainerElement.empty();

    // Sort the menu items according to order ...
    var arrSortedMenuItems = objShapeEditorOptions.MenuItems.sort(function (objShapeEditorOptionsItemA, objShapeEditorOptionsItemB) { return objShapeEditorOptionsItemA.Order - objShapeEditorOptionsItemB.Order; });

    // Loop through all the menu items ...
    for (var intMenuItem = 0; intMenuItem < arrSortedMenuItems.length; intMenuItem++) {

        // Get the menu item ...
        var objShapeEditorOptionsItem = arrSortedMenuItems[intMenuItem];

        // When not a separator ...
        if (!objShapeEditorOptionsItem.IsSeparator) {

            // Create the item div ...
            var objItemDiv = $('<div class="menu-item" MenuItemName="' + objShapeEditorOptionsItem.Name + '"></div>');

            // Create the span ...
            var objItemSpan = $('<span></span>');

            // Set the item text ...
            objItemSpan.text(objShapeEditorOptionsItem.DisplayText);

            // Add the span to the div ...
            objItemDiv.append(objItemSpan);

            // When this is to be a visibility switch ...
            if (objShapeEditorOptionsItem.HasSubMenu) {

                // Add the check box item ...
                objItemDiv.append('<div class="menu-arrow-icon"></div>');
            }

            // Add the div to the menu ...
            objShapeEditorOptions.MenuItemContainerElement.append(objItemDiv);

        } else {

            // Add a separator div ...
            objShapeEditorOptions.MenuItemContainerElement.append('<div class="menu_separator"></div>');
        }
    }
}
// **************************************************************************
// FUNCTION: ResetSubmenu
// USAGE:    Used to reset the state on the submenu
// **************************************************************************
TrimbleMap.ShapeEditorOptions.ResetSubMenu = function ResetSubMenu() {

    // Get the instance ...
    var objShapeEditorOptions = this;

    if (objShapeEditorOptions.VisibleSubMenuItem) {

        // Remove it from the dom ...
        objShapeEditorOptions.VisibleSubMenuDiv.remove();

        // Get the menu item div ...
        var objShapeEditorOptionsItemDiv = objShapeEditorOptions.GetMenuItemDiv(objShapeEditorOptions.VisibleSubMenuItem);

        // Remove the selected class to it ...
        objShapeEditorOptionsItemDiv.removeClass('menu-item-selected');

        // Clear the visible sub menu item and div ...
        objShapeEditorOptions.VisibleSubMenuItem = null;
        objShapeEditorOptions.VisibleSubMenuDiv = null;

        // Update the vertical divider ...
        objShapeEditorOptions.UpdateVerticalDivider();

    }

}
// **************************************************************************
// FUNCTION: GetMenuItemDiv
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.GetMenuItemDiv = function GetMenuItemDiv(objShapeEditorOptionsItem) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Get the div ...
    var objShapeEditorOptionsItemDiv = objShapeEditorOptions.MenuItemContainerElement.find('[MenuItemName="' + objShapeEditorOptionsItem.Name + '"]');

    // Return it ...
    return objShapeEditorOptionsItemDiv;
}

// **************************************************************************
// FUNCTION: AttachPopupEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.AttachPopupEventHandlers = function AttachPopupEventHandlers() {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Attach a click event handler ...
    objShapeEditorOptions.ShapeEditor.IconsDiv.on('click',(objShapeEditorOptions.MenuElementClickedProxy));
}

// **************************************************************************
// FUNCTION: DetachPopupEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.DetachPopupEventHandlers = function DetachPopupEventHandlers() {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Attach a click event handler ...
    objShapeEditorOptions.MenuElement.off('click', objShapeEditorOptions.MenuElementClickedProxy);
}

// **************************************************************************
// FUNCTION: MenuElementClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.MenuElementClicked = function MenuElementClicked(e) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Find the first element up the dom tree that have the 'menu_item_div' class ...
    var objShapeEditorOptionsItemDiv = $(e.target).closest('.menu-item, .menu-item-disabled');

    // When found ...
    if (objShapeEditorOptionsItemDiv.length > 0) {

        // Get the menu item name ...
        var strMenuItemName = objShapeEditorOptionsItemDiv.attr('MenuItemName');

        // Get the menu item ...
        var objShapeEditorOptionsItem = $.grep(objShapeEditorOptions.MenuItems, function (objTestMenuItem, intTestMenuItem) {
            return objTestMenuItem.Name == strMenuItemName;
        })[0];

        if (objShapeEditorOptionsItem) {
            // Fire the menu item clicked callback ...
            objShapeEditorOptions.MenuItemClicked(objShapeEditorOptionsItem);
        }
    }
}

// **************************************************************************
// FUNCTION: MenuItemClicked
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.MenuItemClicked = function MenuItemClicked(objShapeEditorOptionsItem) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    if (objShapeEditorOptions.ShapeEditor.AllowNavigationFromPartEditing()) {

        // Call the clicked function ...
        if ((typeof objShapeEditorOptionsItem.Clicked != undefined) && (objShapeEditorOptionsItem.Clicked != null)) { objShapeEditorOptionsItem.Clicked(objShapeEditorOptionsItem); }

        // When the item has a sub menu ...
        if (objShapeEditorOptionsItem.HasSubMenu) {

            // When not already visible ...
            if ((!objShapeEditorOptions.VisibleSubMenuItem) || (objShapeEditorOptions.VisibleSubMenuItem.Name != objShapeEditorOptionsItem.Name)) {

                // Show the sub menu ...
                objShapeEditorOptions.ShowSubMenu(objShapeEditorOptionsItem);
            }

        } else {

            // Hide the menu ...
            objShapeEditorOptions.Hide();
        }
    }
}

// **************************************************************************
// FUNCTION: CreateMenuItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.Shared.CreateMenuItem = function CreateMenuItem(strName, strDisplayText, intOrder, blnHasSubMenu, fnClicked, fnActivateSubMenu, fnDeActivateSubMenu) {

    // Create a new menu item object ...
    return {
        Name: strName,
        DisplayText: strDisplayText,
        Order: intOrder,
        HasSubMenu: blnHasSubMenu,
        IsSeparator: false,
        Clicked: fnClicked,
        ActivateSubMenu: fnActivateSubMenu,
        DeActivateSubMenu: fnDeActivateSubMenu
    };
}

// **************************************************************************
// FUNCTION: CreateSeparator
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.Shared.CreateSeparator = function CreateSeparator(intOrder) {

    // Create a new menu item object ...
    return {
        IsSeparator: true,
        Name: '',
        DisplayText: '',
        Order: intOrder,
        HasSubMenu: false,
        Clicked: null,
        ActivateSubMenu: null,
        DeActivateSubMenu: null,
        MenuItemEnabled: null
    };
}

// **************************************************************************
// FUNCTION: AddMenuItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.AddMenuItem = function AddMenuItem(objShapeEditorOptionsItem) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Add it to the array of menu items ...
    objShapeEditorOptions.MenuItems.push(objShapeEditorOptionsItem);

    // Update the menu elements ...
    objShapeEditorOptions.UpdateMenuElements();
}

// **************************************************************************
// FUNCTION: RemoveMenuItem
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.RemoveMenuItem = function RemoveMenuItem(objShapeEditorOptionsItem) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Get the menu item index ...
    var intMenuItem = objShapeEditorOptions.GetMenuItemIndex(objShapeEditorOptionsItem);

    // Remove it from the array of menu items ...
    objShapeEditorOptions.MenuItems.splice(intMenuItem, 1);

    // Update the menu elements ...
    objShapeEditorOptions.UpdateMenuElements();
}

// **************************************************************************
// FUNCTION: GetMenuItemIndex
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.GetMenuItemIndex = function GetMenuItemIndex(objShapeEditorOptionsItem) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Get the menu item index ...
    var intMenuItem = $.inArray(objShapeEditorOptionsItem, objShapeEditorOptions.MenuItems);

    return intMenuItem;
}

// **************************************************************************
// FUNCTION: UpdateMenuElements
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.UpdateMenuElements = function UpdateMenuElements() {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // When the menu is visble ...
    if (objShapeEditorOptions.Visible) {

        // Update the menu item elements ...
        objShapeEditorOptions.CreateMenuItemElements();

    } else {

        // When we have a menu element (already built) ...
        if (objShapeEditorOptions.MenuElement) {

            // Detach the popup event handlers ...
            objShapeEditorOptions.DetachPopupEventHandlers();

            // Set the menu element to null so that it would be re-created when the menu are opened ...
            objShapeEditorOptions.MenuElement = null;
        }
    }
}

// **************************************************************************
// FUNCTION: HideSubMenu 
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.HideSubMenu = function HideSubMenu(fnDone, intDurationMilliSeconds) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Animate the sub menu to full width ...
    objShapeEditorOptions.SubMenuContainerElement.animate({
        width: '0px'
    }, {
        duration: intDurationMilliSeconds,
        done: function () {

            if (typeof objShapeEditorOptions.DeActivateSubMenu === "function") {
                // De-Activate the sub menu ...
                objShapeEditorOptions.VisibleSubMenuItem.DeActivateSubMenu(objShapeEditorOptions.VisibleSubMenuItem, objShapeEditorOptions.VisibleSubMenuDiv);
            }

            // Remove it from the dom ...
            objShapeEditorOptions.VisibleSubMenuDiv.remove();

            // Get the menu item div ...
            var objShapeEditorOptionsItemDiv = objShapeEditorOptions.GetMenuItemDiv(objShapeEditorOptions.VisibleSubMenuItem);

            // Remove the selected class to it ...
            objShapeEditorOptionsItemDiv.removeClass('menu-item-selected');

            // Clear the visible sub menu item and div ...
            objShapeEditorOptions.VisibleSubMenuItem = null;
            objShapeEditorOptions.VisibleSubMenuDiv = null;

            // Update the vertical divider ...
            objShapeEditorOptions.UpdateVerticalDivider();

            // Call the done callback when given one ...
            if (typeof fnDone != 'undefined') { fnDone(); }
        }
    });
}

// **************************************************************************
// FUNCTION: SubMenuHeightChanged
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.SubMenuHeightChanged = function SubMenuHeightChanged(objShapeEditorOptionsItem) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Update the vertical divider ...
    objShapeEditorOptions.UpdateVerticalDivider();
}

// **************************************************************************
// FUNCTION: UpdateVerticalDivider
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.UpdateVerticalDivider = function UpdateVerticalDivider(objShapeEditorOptionsItem) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // When the sub menu is visible ... 
    if (objShapeEditorOptions.VisibleSubMenuItem) {

        // Measure the size of the menu item container and sub menu containers ...
        var objShapeEditorOptionsItemContainerSize = SD.HtmlFunctions.Shared.MeasureElement(objShapeEditorOptions.MenuItemContainerElement);
        var objSubMenuContainerSize = SD.HtmlFunctions.Shared.MeasureElement(objShapeEditorOptions.VisibleSubMenuDiv);

        // When menu item container is taller than the sub menu container ...
        if (objShapeEditorOptionsItemContainerSize.height > objSubMenuContainerSize.height) {

            // Add the divider to the left and remove from the right ...
            objShapeEditorOptions.MenuItemContainerElement.addClass('menu-divider-start');
            objShapeEditorOptions.SubMenuContainerElement.removeClass('menu-divider-end');

        } else {
            // Add the divider to the right and remove from the left ...
            objShapeEditorOptions.MenuItemContainerElement.removeClass('menu-divider-start');
            objShapeEditorOptions.SubMenuContainerElement.addClass('menu-divider-end');
        }

    } else {

        // Remove the divider classes ...
        objShapeEditorOptions.MenuItemContainerElement.removeClass('menu-divider-start');
        objShapeEditorOptions.SubMenuContainerElement.removeClass('menu-divider-end');
    }
}

// **************************************************************************
// FUNCTION: ShowSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.ShowSubMenu = function ShowSubMenu(objShapeEditorOptionsItem) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Create a new div in which to display the sub menu ...
    var objSubMenuDiv = $('<div></div>');

    // Activate the sub menu to be displayed ...
    objShapeEditorOptionsItem.ActivateSubMenu(objSubMenuDiv);

    // Create a function that will show the sub menu ...
    var fnShowSubMenu = function () {

        // Measure the sub menu element ...
        let objSubMenuSize = SD.HtmlFunctions.Shared.MeasureElement(objSubMenuDiv);

        // Set the sub menu width to start at 0px ...
        objShapeEditorOptions.SubMenuContainerElement.css('width', '0px');

        // Add the sub menu to the container ...
        objShapeEditorOptions.SubMenuContainerElement.append(objSubMenuDiv);

        // Animate the sub menu to full width ...
        objShapeEditorOptions.SubMenuContainerElement.animate({ width: objSubMenuSize.width }, 100, function () {

            // Remove the width so that the element could naturally define it's width ...
            objShapeEditorOptions.SubMenuContainerElement.css('width', 'auto');

            // Trigger the on sub menu opened event handlers ...
            objShapeEditorOptions.TriggerOnSubMenuOpened(objShapeEditorOptionsItem.Name);
        });

        // Set the visible sub menu item and div ...
        objShapeEditorOptions.VisibleSubMenuItem = objShapeEditorOptionsItem;
        objShapeEditorOptions.VisibleSubMenuDiv = objSubMenuDiv;

        // Update the vertical divider ...
        objShapeEditorOptions.UpdateVerticalDivider();

        // Get the menu item div ...
        var objShapeEditorOptionsItemDiv = objShapeEditorOptions.GetMenuItemDiv(objShapeEditorOptionsItem);

        // Add the selected class to it ...
        objShapeEditorOptionsItemDiv.addClass('menu-item-selected');
    };

    // When we have an already visible sub menu ...
    if (objShapeEditorOptions.VisibleSubMenuItem) {

        // Hide the sub menu that is currently visible ...
        objShapeEditorOptions.HideSubMenu(function () {

            // Show the sub menu ...
            fnShowSubMenu();
        }, 100);

    } else {

        // Show the sub menu ...
        fnShowSubMenu();
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
TrimbleMap.ShapeEditorOptions.Hide = function Hide() {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Create the hide function ...
    var fnHide = function () {

        // Hide the menu ...
        objShapeEditorOptions.MenuElement.hide();
    }

    // When we have an already visible sub menu ...
    if (objShapeEditorOptions.VisibleSubMenuItem) {

        // Hide the sub menu that is currently visible ...
        objShapeEditorOptions.HideSubMenu(function () {

            // Hide the menu ...
            fnHide();
        }, 0);

    } else {

        // Hide the menu ...
        fnHide();
    }

    // Set to not be visible ...
    objShapeEditorOptions.Visible = false;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION AddOnSubMenuOpenedCallback
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.ShapeEditorOptions.AddOnSubMenuOpenedCallback = function AddOnSubMenuOpenedCallback(fnAddOnSubMenuOpenedCallback) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Add it to the callback list ...
    objShapeEditorOptions.OnSubMenuOpenedFunctions.push(fnAddOnSubMenuOpenedCallback);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION TriggerOnSubMenuOpened
// USAGE    
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.ShapeEditorOptions.TriggerOnSubMenuOpened = function TriggerOnSubMenuOpened(strSubMenuName) {

    // Get the instance ...
    var objShapeEditorOptions = this;

    // Loop through all the on sub menu opened functions ...
    $.each(objShapeEditorOptions.OnSubMenuOpenedFunctions, function (intOnSubMenuOpenedFunctions, fnOnSubMenuOpenedFunctions) {

        // Call the callback ...
        fnOnSubMenuOpenedFunctions(strSubMenuName);
    });
}

TrimbleMap.ShapeEditorOptions.CreatePredefinedMenuItems = function CreatePredefinedMenuItems(strSubMenuName) {
    // Get the instance ...
    var objShapeEditorOptions = this;
    var menuPositionIndex = 1;

    if (objShapeEditorOptions.ShapeEditor.Options.ShowDrawOnMap) {
        objShapeEditorOptions.AddMenuItem(TrimbleMap.ShapeEditorOptions.Shared.CreateMenuItem(TrimbleMap.ShapeEditorOptions.enumTool.DrawOnMap, SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'DrawOnMap'), menuPositionIndex++, true, null, objShapeEditorOptions.ShapeEditor.ActivateDrawOnMapSubMenuProxy, objShapeEditorOptions.ShapeEditor.DeActivateDrawOnMapSubMenuProxy));
    }

    if (objShapeEditorOptions.ShapeEditor.Options.ShowPickFromMap && $.inArray(TrimbleMap.StandardMap.Shared.enumModule.ChooseExistingShape, objShapeEditorOptions.ShapeEditor.Modules) > -1) {
        objShapeEditorOptions.AddMenuItem(TrimbleMap.ShapeEditorOptions.Shared.CreateMenuItem(TrimbleMap.ShapeEditorOptions.enumTool.ChooseExistingShape, SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'ChooseExistingShape'), menuPositionIndex++, true, null, objShapeEditorOptions.ShapeEditor.ActivateChooseExistingShapeSubMenuProxy, objShapeEditorOptions.ShapeEditor.DeActivateChooseExistingShapeSubMenuProxy));
    }

    if (objShapeEditorOptions.ShapeEditor.Options.ShowImportCoordinates) {
        // Add the import coordinates Menu Section
        objShapeEditorOptions.AddMenuItem(TrimbleMap.ShapeEditorOptions.Shared.CreateMenuItem(TrimbleMap.ShapeEditorOptions.enumTool.ImportCoordinates, SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'ImportCoordinates'), menuPositionIndex++, true, null, objShapeEditorOptions.ShapeEditor.ActivateImportCoordinateSubMenuProxy, null));
    }

    if (objShapeEditorOptions.ShapeEditor.Options.ShowEditCoordinates) {
        // Add the Type Coordinates Menu Section
        objShapeEditorOptions.AddMenuItem(TrimbleMap.ShapeEditorOptions.Shared.CreateMenuItem(TrimbleMap.ShapeEditorOptions.enumTool.TypeCoordinates, SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'EditCoordinates'), menuPositionIndex++, true, null, objShapeEditorOptions.ShapeEditor.ActivateTypeCoordinateSubMenuProxy, null));
    }

    if (objShapeEditorOptions.ShapeEditor.Options.ShowAdvancedTools) {
        //Add the Advanced Tools Menu Section
        objShapeEditorOptions.AddMenuItem(TrimbleMap.ShapeEditorOptions.Shared.CreateMenuItem(TrimbleMap.ShapeEditorOptions.enumTool.AdvancedTools, SD.Translation.Shared.GetTranslation('Map.ShapeEditorOptions.js', 'AdvancedTools'), menuPositionIndex++, true, null, objShapeEditorOptions.ShapeEditor.ActivateAdvancedToolSubMenuProxy, null));
    }
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.ShapePart = {};
TrimbleMap.ShapePart.Shared = {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.CreateInstance = function CreateInstance(strPartName, strPartID) {

    // Create the object that will hold the instance properties ...
    var objShapePart = {
        PartName: strPartName,
        ID: strPartID,
        Coordinates: [],
        InteriorParts: []
    }

    return objShapePart;
}

// **************************************************************************
// FUNCTION: EsriGeometryFromCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Shared.EsriGeometryFromCoordinates = function EsriGeometryFromCoordinates(arrCoordinates, objEsriSpatialReference, enGeometryType) {

    // Declare a variable for the geometry ...
    var objGeometry = null;

    // When we have one coordinate ...
    if (arrCoordinates.length == 1) {

        // Create an esri point for the coordinate ...
        var objEsriPoint = new esri.geometry.Point(arrCoordinates[0].X, arrCoordinates[0].Y, objEsriSpatialReference);

        // Set the geometry to re-project to be the point ...
        objGeometry = objEsriPoint;

    } else if ((enGeometryType == TrimbleMap.Shape.enumGeometryType.POLYLINE) || (arrCoordinates.length == 2)) {

        // Create a polyline ...
        var objPolyline = new esri.geometry.Polyline(objEsriSpatialReference);

        // Create a new array for the path ...
        var arrPath = [];

        // Add the coordinates tro the path array ...
        $.each(arrCoordinates, function (intCoordinate, objCoordinate) { arrPath.push([objCoordinate.X, objCoordinate.Y]) });

        // Convert the coordinates to a path and add it as a path to the polyline ...
        objPolyline.paths.push(arrPath);

        // Set the geometry to re-project to be the Polyline ...
        objGeometry = objPolyline;

    } else if (arrCoordinates.length > 2) {

        // Create a polygon ...
        var objPolygon = new esri.geometry.Polygon(objEsriSpatialReference);

        // Create a new array for the ring ...
        var arrRing = [];

        // Add the coordinates to the ring array ...
        $.each(arrCoordinates, function (intCoordinate, objCoordinate) { arrRing.push([objCoordinate.X, objCoordinate.Y]); });

        // Close the ring ...
        arrRing.push([arrCoordinates[0].X, arrCoordinates[0].Y]);

        // Convert the coordinates to a ring and add it as a ring to the polygon ...
        objPolygon.rings.push(arrRing);

        // Set the geometry to re-project to be the polygon ...
        objGeometry = objPolygon;
    }

    // Return the geometry ...
    return objGeometry;
}

// **************************************************************************
// FUNCTION: AddInteriorRingsToEsriGeometry
// USAGE:    dicCoordinatesToReplace and blnFixRingOrientation is optional
//           blnFixRingOrientation defaults to false
// **************************************************************************
TrimbleMap.ShapePart.Shared.AddInteriorRingsToEsriGeometry = function AddInteriorRingsToEsriGeometry(objShapePart, objEsriGeometry, objEsriSpatialReference, dicCoordinatesToReplace, blnFixRingOrientation, blnExcludeCoordinatesToReplacePart) {

    // Default blnFixRingOrientation to false when not set ...
    if ((typeof blnFixRingOrientation == 'undefined') || (blnFixRingOrientation == null)) { blnFixRingOrientation = false; }

    let arrExcludeCoordinatesToReplacePartIndex = [];

    // When we have a geometry and the geometry is a polygon and the part has interior parts ...
    if (objEsriGeometry && (objEsriGeometry.type == 'polygon') && (typeof objShapePart.InteriorParts != 'undefined') && objShapePart.InteriorParts) {

        let arrCoordinatesToReplaceIDs = null;

        if (dicCoordinatesToReplace) {
            arrCoordinatesToReplaceIDs = Object.keys(dicCoordinatesToReplace);
        }

        // Loop through the interior parts ...
        $.each(objShapePart.InteriorParts, function (intInteriorPart, objInteriorPart) {

            // Get the coordinates to replace for the ID if any ...
            var arrCoordinatesToReplace = ((typeof dicCoordinatesToReplace != 'undefined') && dicCoordinatesToReplace) ? dicCoordinatesToReplace[objInteriorPart.ID] : null;

            // Get the cooridantes to display, use the replacement coordintes when we have otherwise use the coordintes from the interior part ...
            var arrCoordinates = ((typeof arrCoordinatesToReplace != 'undefined') && arrCoordinatesToReplace) ? arrCoordinatesToReplace : objInteriorPart.Coordinates;

            // When the part has at least 3 coordinates ...
            if (arrCoordinates.length > 2) {

                // Create a ring from the coordinates ...
                var arrRing = TrimbleMap.ShapePart.Shared.RingFromCoordinates(arrCoordinates);

                // Ensure that the ring orientatin is correct for interior parts ...
                if (blnFixRingOrientation) { arrRing = TrimbleMap.Geometry.Shared.FixRingOrientation(arrRing, TrimbleMap.Shape.enumInteriorOrExterior.Interior); }

                // Add the ring to the polygon ...
                objEsriGeometry.rings.push(arrRing);
            }

            if (blnExcludeCoordinatesToReplacePart && arrCoordinatesToReplaceIDs && $.inArray(objInteriorPart.ID, arrCoordinatesToReplaceIDs) > -1) {
                arrExcludeCoordinatesToReplacePartIndex.push(intInteriorPart + 1);
            }
        });
    }

    return arrExcludeCoordinatesToReplacePartIndex;
}

// **************************************************************************
// FUNCTION: RingFromCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Shared.RingFromCoordinates = function RingFromCoordinates(arrCoordinates) {

    // Create a new array for the ring ...
    var arrRing = [];

    // Add the coordinates to the ring array ...
    $.each(arrCoordinates, function (intCoordinate, objCoordinate) { arrRing.push([objCoordinate.X, objCoordinate.Y]); });

    // Close the ring ...
    arrRing.push([arrCoordinates[0].X, arrCoordinates[0].Y]);

    // Return the ring ...
    return arrRing;
}

// **************************************************************************
// FUNCTION: CoordinatesFromEsriGeometry
// USAGE:    intRingOrPath is optional, defaults to 0
// **************************************************************************
TrimbleMap.ShapePart.Shared.CoordinatesFromEsriGeometry = function CoordinatesFromEsriGeometry(objEsriGeometry, intRingOrPath, blnRemoveCoordinatesAlongAStraightLine, decOrdinateTolerance) {

    // Create an array for the coordinates to return ...
    var arrCoordinates = [];

    // When we got a geometry ...
    if ((typeof objEsriGeometry != 'undefined') && (objEsriGeometry != null)) {

        // Default intRingOrPath to 0 when not specified  ...
        if ((typeof intRingOrPath == 'undefined') || (!intRingOrPath)) { intRingOrPath = 0; }

        // Default blnRemoveCoordinatesAlongAStraightLine to false when not set ...
        if ((typeof blnRemoveCoordinatesAlongAStraightLine == 'undefined') || (blnRemoveCoordinatesAlongAStraightLine == null)) { blnRemoveCoordinatesAlongAStraightLine = false; }

        // When we have one coordinate ...
        if (objEsriGeometry.type == 'point') {

            // Add the point to the array ...
            arrCoordinates.push({ X: objEsriGeometry.x, Y: objEsriGeometry.y });

        } else if (objEsriGeometry.type == 'polyline') {

            // When we have at least one path ...
            if (objEsriGeometry.paths.length > intRingOrPath) {

                // Get the points in the path ...
                var arrPoints = objEsriGeometry.paths[intRingOrPath];

                // Loop through all the points ...
                for (var intPoint = 0; intPoint < arrPoints.length; intPoint++) {

                    // Get the current and next point's ...
                    var objPoint = arrPoints[intPoint];
                    var objNextPoint = arrPoints[(intPoint + 1) % arrPoints.length];

                    // Add the point when the current point is not the same as the next point ...
                    if ((objPoint[0] != objNextPoint[0]) || (objPoint[1] != objNextPoint[1])) { arrCoordinates.push({ X: objPoint[0], Y: objPoint[1] }); }
                }
            }

        } else if (objEsriGeometry.type == 'polygon') {

            // When we have at least one ring ...
            if (objEsriGeometry.rings.length > intRingOrPath) {

                // Get the points in the path ...
                var arrPoints = objEsriGeometry.rings[intRingOrPath];

                // Loop through all the points ...
                for (var intPoint = 0; intPoint < arrPoints.length; intPoint++) {

                    // Get the current and next point's ...
                    var objPoint = arrPoints[intPoint];
                    var objNextPoint = arrPoints[(intPoint + 1) % arrPoints.length];

                    // Add the point when the current point is not the same as the next point ...
                    if ((objPoint[0] != objNextPoint[0]) || (objPoint[1] != objNextPoint[1])) { arrCoordinates.push({ X: objPoint[0], Y: objPoint[1] }); }
                }
            }
        }

        // When we are to remove the coordinates along a straight line ...
        if (blnRemoveCoordinatesAlongAStraightLine) {

            // Remove the coordinates along a straight line ...
            arrCoordinates = TrimbleMap.ShapePart.Shared.RemoveCoordinatesAlongStraightLineFromCoordinatesArray(arrCoordinates, decOrdinateTolerance);
        }
    }

    // Return the coordinates ...
    return arrCoordinates;
}

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Clone = function Clone(objShapePart) {

    // Create a new part with the same name and ID ... 
    var objClonedShapePart = TrimbleMap.ShapePart.CreateInstance(objShapePart.PartName, objShapePart.ID);

    // Loop through all the coordinates ...
    $.each(objShapePart.Coordinates, function (intCoordinate, objCoordinate) {

        // Clone and add the coordinate ...
        objClonedShapePart.Coordinates.push({ X: objCoordinate.X, Y: objCoordinate.Y });
    });

    // When we have interior parts ...
    if ((typeof objShapePart.InteriorParts != 'undefined') && objShapePart.InteriorParts) {

        // Loop through all the interior parts ...
        $.each(objShapePart.InteriorParts, function (intInteriorPart, objInteriorPart) {

            // Clone and add the interiro part ...
            objClonedShapePart.InteriorParts.push(TrimbleMap.ShapePart.Clone(objInteriorPart));
        });
    }

    return objShapePart;
}

// **************************************************************************
// FUNCTION: RoundCoordinates
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Shared.RoundCoordinates = function RoundCoordinates(objPart, intDecimalPlaces) {

    // Loop through all the coordinates ....
    $.each(objPart.Coordinates, function (intCoordinate, objCoordinate) {

        // Round the X and Y values ...
        objCoordinate.X = SD.Number.RoundTo(objCoordinate.X, intDecimalPlaces);
        objCoordinate.Y = SD.Number.RoundTo(objCoordinate.Y, intDecimalPlaces);
    });
}

// **************************************************************************
// FUNCTION: RemoveCoordinatesAlongStraightLine
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Shared.RemoveCoordinatesAlongStraightLine = function RemoveCoordinatesAlongStraightLine(objPart, decOrdinateTolerance) {

    // Start with no coordiantes removed ...
    var blnAnyCoordinatesRemoved = false;

    // When the shape have at least 4 coordinates (excluding the last duplicate) ...
    if (objPart.Coordinates.length > 2) {

        // Temporary array which holds coordinates that were consecutively removed between the current coordinate and the last coordinate which was not removed.
        // Before removing any coordinate from 'arrCoordinates' the below array is checked to see that the tolerance for these coordinates do not exceed the ordinate tolerance.
        // If the tolerance is exceeded the current coordinate will not be removed.
        var arrConsecutivelyRemovedCoordinates = [];
        var blnRemoveCoordinate = true;

        // Close the ring (if not already closed) ...
        var blnCoordinateAdded = TrimbleMap.ShapePart.Shared.CloseRing(objPart.Coordinates);

        // Copy original coordinates of part into array
        // This array will hold the final coordinates
        var arrCoordinates = objPart.Coordinates;

        TrimbleMap.CoordinateListEditor.Shared.AddCoordinateNumberFieldToCoordinates(arrCoordinates);

        // Loop through all the coordinates from the second last to the first ...
        for (var intCoordinate = objPart.Coordinates.length - 2; intCoordinate >= 0; intCoordinate--) {

            // Get the coordiante and the coordinate before and after it ...
            var objCoordinate = arrCoordinates[intCoordinate];
            var objPreviousCoordinate = (intCoordinate == 0) ? arrCoordinates[arrCoordinates.length - 2] : arrCoordinates[intCoordinate - 1];
            var objNextCoordinate = arrCoordinates[intCoordinate + 1];

            // When the coordinates form a horizontal straight line ...
            if ((Math.abs(objPreviousCoordinate.Y - objCoordinate.Y) < decOrdinateTolerance) &&
                (Math.abs(objCoordinate.Y - objNextCoordinate.Y) < decOrdinateTolerance)) {

                // Check if there are any coordinates that were removed from the consecutive coordinate array
                if (arrConsecutivelyRemovedCoordinates.length > 0) {
                    // By default the coordinate is set to be removed
                    blnRemoveCoordinate = true;

                    // Loop through all the consecutive coordinates that were removed
                    $.each(arrConsecutivelyRemovedCoordinates, function (intRemovedCoordinate, objRemovedCoordinate) {
                        // When the ordinate tolerance for any of the consecutive coordinates that were removed is exceeded, do not remove the current coordinate
                        if ((Math.abs(objPreviousCoordinate.Y - objRemovedCoordinate.Y) > decOrdinateTolerance) &&
                            (Math.abs(objRemovedCoordinate.Y - objNextCoordinate.Y) > decOrdinateTolerance)) {
                            blnRemoveCoordinate = false;
                            // Reset the consecutive coordinates array because the current coordinate is not to be removed
                            arrConsecutivelyRemovedCoordinates = [];
                            return false;
                        }
                    });

                    // If the coordinate is to be removed
                    if (blnRemoveCoordinate) {
                        // Remove the current coordinate
                        arrCoordinates = $.grep(arrCoordinates, function (objRemoveCoordinate) {
                            return objRemoveCoordinate.COORDINATE_NUMBER != objCoordinate.COORDINATE_NUMBER
                        });

                        arrConsecutivelyRemovedCoordinates.push(objCoordinate);
                        blnAnyCoordinatesRemoved = true;
                    }

                } else {
                    arrCoordinates = $.grep(arrCoordinates, function (objRemoveCoordinate) {
                        return objRemoveCoordinate.COORDINATE_NUMBER != objCoordinate.COORDINATE_NUMBER
                    });

                    arrConsecutivelyRemovedCoordinates.push(objCoordinate);
                    blnAnyCoordinatesRemoved = true;
                }
                // When the coordinates form a vertical straight line ...
            } else if ((Math.abs(objPreviousCoordinate.X - objCoordinate.X) < decOrdinateTolerance) &&
                (Math.abs(objCoordinate.X - objNextCoordinate.X) < decOrdinateTolerance)) {

                // Check if there are any coordinates that were removed from the consecutive coordinate array
                if (arrConsecutivelyRemovedCoordinates.length > 0) {
                    // By default the coordinate is set to be removed
                    blnRemoveCoordinate = true;

                    // Loop through all the consecutive coordinates that were removed
                    $.each(arrConsecutivelyRemovedCoordinates, function (intRemovedCoordinate, objRemovedCoordinate) {
                        // When the ordinate tolerance for any of the consecutive coordinates that were removed is exceeded, do not remove the current coordinate
                        if ((Math.abs(objPreviousCoordinate.X - objRemovedCoordinate.X) > decOrdinateTolerance) &&
                            (Math.abs(objRemovedCoordinate.X - objNextCoordinate.X) > decOrdinateTolerance)) {
                            blnRemoveCoordinate = false;
                            // Reset the consecutive coordinates array because the current coordinate is not to be removed
                            arrConsecutivelyRemovedCoordinates = [];
                            return false;
                        }
                    });

                    // If the coordinate is to be removed
                    if (blnRemoveCoordinate) {
                        // Remove the current coordinate
                        arrCoordinates = $.grep(arrCoordinates, function (objRemoveCoordinate) {
                            return objRemoveCoordinate.COORDINATE_NUMBER != objCoordinate.COORDINATE_NUMBER
                        });

                        arrConsecutivelyRemovedCoordinates.push(objCoordinate);
                        blnAnyCoordinatesRemoved = true;
                    }

                } else {
                    arrCoordinates = $.grep(arrCoordinates, function (objRemoveCoordinate) {
                        return objRemoveCoordinate.COORDINATE_NUMBER != objCoordinate.COORDINATE_NUMBER
                    });

                    arrConsecutivelyRemovedCoordinates.push(objCoordinate);
                    blnAnyCoordinatesRemoved = true;
                }
            } else {

                // Calculate perpendicular distance from the coordinate to the line that joins the previous and next coordinates ...
                var decPerpendicularDistance = TrimbleMap.ShapePart.Shared.PerpendicularDistanceFromStraightLine(objPreviousCoordinate, objNextCoordinate, objCoordinate);

                // When the perpendicular distance is less than the tolerance, 
                // add the array index to the array of coordinates to be removed ...
                if (decPerpendicularDistance < decOrdinateTolerance) {

                    // Check if there are any coordinates that were removed from the consecutive coordinate array
                    if (arrConsecutivelyRemovedCoordinates.length > 0) {
                        // By default the coordinate is set to be removed
                        blnRemoveCoordinate = true;

                        // Loop through all the consecutive coordinates that were removed
                        $.each(arrConsecutivelyRemovedCoordinates, function (intRemovedCoordinate, objRemovedCoordinate) {
                            decPerpendicularDistance = TrimbleMap.ShapePart.Shared.PerpendicularDistanceFromStraightLine(objPreviousCoordinate, objNextCoordinate, objRemovedCoordinate);
                            // When the ordinate tolerance for any of the consecutive coordinates that were removed is exceeded, do not remove the current coordinate
                            if (decPerpendicularDistance > decOrdinateTolerance) {
                                blnRemoveCoordinate = false;
                                // Reset the consecutive coordinates array because the current coordinate is not to be removed
                                arrConsecutivelyRemovedCoordinates = [];
                                return false;
                            }
                        });

                        // If the coordinate is to be removed
                        if (blnRemoveCoordinate) {
                            // Remove the current coordinate
                            arrCoordinates = $.grep(arrCoordinates, function (objRemoveCoordinate) {
                                return objRemoveCoordinate.COORDINATE_NUMBER != objCoordinate.COORDINATE_NUMBER
                            });

                            arrConsecutivelyRemovedCoordinates.push(objCoordinate);
                            blnAnyCoordinatesRemoved = true;
                        }

                    } else {
                        arrCoordinates = $.grep(arrCoordinates, function (objRemoveCoordinate) {
                            return objRemoveCoordinate.COORDINATE_NUMBER != objCoordinate.COORDINATE_NUMBER
                        });

                        arrConsecutivelyRemovedCoordinates.push(objCoordinate);
                        blnAnyCoordinatesRemoved = true;
                    }
                }
            }
        }

        // Remove the last coordinate when we've added a coordinate ...
        if (blnCoordinateAdded) {
            arrCoordinates.pop();
        }

        // When any coordinates were removed ...
        if (blnAnyCoordinatesRemoved) {
            // Set the coordinates of the part ...
            objPart.Coordinates = arrCoordinates;
        }
    }

    return blnAnyCoordinatesRemoved;
}

// **************************************************************************
// FUNCTION: RemoveCoordinatesAlongStraightLineFromCoordinatesArray
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Shared.RemoveCoordinatesAlongStraightLineFromCoordinatesArray = function RemoveCoordinatesAlongStraightLineFromCoordinatesArray(arrCoordinates, decOrdinateTolerance) {

    // Create a new part to hold the coordinates ...
    var objPart = TrimbleMap.ShapePart.CreateInstance('Part 1', SD.Guid.Shared.NewID());

    // Set the coordinates on the part ...
    objPart.Coordinates = arrCoordinates;

    // Remove the coordinates along a straight line ...
    TrimbleMap.ShapePart.Shared.RemoveCoordinatesAlongStraightLine(objPart, decOrdinateTolerance);

    // Return the part coordinates ...
    return objPart.Coordinates;
}

// **************************************************************************
// FUNCTION: PerpendicularDistanceFromStraightLine
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Shared.PerpendicularDistanceFromStraightLine = function PerpendicularDistanceFromStraightLine(objLineCoordinateFrom, objLineCoordinateTo, objCoordinate) {

    // Construct a vector for the line ...
    var objLineVector = TrimbleMap.ShapePart.Shared.CreatePolarCoordinateFromPoints(objLineCoordinateFrom, objLineCoordinateTo);

    // Construct a vector from the from coordinaet to the coordinate ...
    var objToCoordinate = TrimbleMap.ShapePart.Shared.CreatePolarCoordinateFromPoints(objLineCoordinateFrom, objCoordinate);

    // Rotate the Vector to the Coordinate by the angle of the Line Vector, 
    // so as to derive a theoretically zero-value X coordinate for a point along a straight line ...
    objToCoordinate.Direction -= objLineVector.Direction;

    // Convert the vector to a cartesian coordinate (from 0, 0) ...
    var objCartesianCoordinate = objToCoordinate.ToCartesianCoordinate();

    // The distance between 0 and X will be the perpendicular distance ...
    var decPerpendicularDistanceFromStraightLine = Math.abs(objCartesianCoordinate.X);

    return decPerpendicularDistanceFromStraightLine;
}

// **************************************************************************
// FUNCTION: CreatePolarCoordinateFromPoints
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Shared.CreatePolarCoordinateFromPoints = function CreatePolarCoordinateFromPoints(objFromPoint, objToPoint) {

    // Calculate the horizonatl and vertical offsets ... 
    var decOffsetX = objToPoint.X - objFromPoint.X;
    var decOffsetY = objToPoint.Y - objFromPoint.Y;

    // Compute the distance ...
    var decDistance = Math.sqrt((decOffsetX * decOffsetX) + (decOffsetY * decOffsetY));

    // Start with a directin of 0 ...
    var decDirection = 0;

    // When a vertical line ...
    if (decOffsetX == 0) {

        // Set Direction to 0 when going up and 180 when going down ...
        if (decOffsetY >= 0) { decDirection = 0; } else { decDirection = 180; }

        // When a horizontal line ...
    } else if (decOffsetY == 0) {

        // Set Direction to 90 when going right and 270 when going left ...
        if (decOffsetX >= 0) { decDirection = 90; } else { decDirection = 270; }

    } else {

        // Calculate offset direction ...
        decDirection = Math.atan(decOffsetY / decOffsetX) * 180.0 / Math.PI

        // Special condition, add 180 when going down ...
        if (decOffsetY < 0) { decDirection += 180; }

        // Ensure that the direction is greater than 0 ...
        if (decDirection < 0) { decDirection += 360; }
    }

    return TrimbleMap.ShapePart.Shared.CreatePolarCoordinate(decDistance, decDirection);
}

// **************************************************************************
// FUNCTION: CreatePolarCoordinate
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Shared.CreatePolarCoordinate = function CreatePolarCoordinate(decDistance, decDirection) {
    return {
        Distance: decDistance,
        Direction: decDirection,
        ToCartesianCoordinate: function () {
            return {
                X: this.Distance * Math.sin((this.Direction) * Math.PI / 180.0),
                Y: this.Distance * Math.cos((this.Direction) * Math.PI / 180.0)
            }
        }
    };
}

// **************************************************************************
// FUNCTION: FixRingOrientation
// USAGE:    
// **************************************************************************
TrimbleMap.ShapePart.Shared.FixRingOrientation = function FixRingOrientation(arrCoordinates, enInteriorOrExterior) {

    // Calculate the area of the ring to determine the ring orientation ...
    var decPartArea = TrimbleMap.Shape.Shared.CalculatePartArea(arrCoordinates);

    // When to be exterior but negative area or when interior but positive area ...
    if (((enInteriorOrExterior == TrimbleMap.Shape.enumInteriorOrExterior.Exterior) && (decPartArea > 0)) ||
        ((enInteriorOrExterior == TrimbleMap.Shape.enumInteriorOrExterior.Interior) && (decPartArea < 0))) {

        // Reverse the coordinates ...
        arrCoordinates = TrimbleMap.ShapePart.Shared.RevereseCoordinateOrder(arrCoordinates);
    }

    return arrCoordinates;
}

// **************************************************************************
// FUNCTION: RevereseCoordinateOrder
// USAGE:    Returns a new coordinate array in the opposite direction ...
// **************************************************************************
TrimbleMap.ShapePart.Shared.RevereseCoordinateOrder = function RevereseCoordinateOrder(arrCoordinates) {

    // Create a new array to return ...
    var arrReversedCoordinates = [];

    // Loop though all the coorduinates from last to first ...
    for (var intCoordinate = arrCoordinates.length - 1; intCoordinate >= 0; intCoordinate--) {

        // Add the coordinate to the ring ...
        arrReversedCoordinates.push(arrCoordinates[intCoordinate]);
    }

    return arrReversedCoordinates;
}

// **************************************************************************
// FUNCTION: CloseRing
// USAGE:    Returns true when a coordinate is added to close the ring ...
// **************************************************************************
TrimbleMap.ShapePart.Shared.CloseRing = function CloseRing(arrCoordinates) {

    // When we have at least 2 coordinates ...
    if (arrCoordinates.length > 1) {

        // Get the first and last coordinates ...
        var objFirstCoordinate = arrCoordinates[0];
        var objLastCoordinate = arrCoordinates[arrCoordinates.length - 1];

        // When the first and last coordinates do not match ...
        if ((objFirstCoordinate.X != objLastCoordinate.X) || (objFirstCoordinate.Y != objLastCoordinate.Y)) {

            // Add a clone of the first coordinate at the end ...
            arrCoordinates.push({ X: objFirstCoordinate.X, Y: objFirstCoordinate.Y });

            // Return true to indicate that a coordinate has been added ...
            return true;
        }
    }

    // No coordinate added ...
    return false;
}

// **************************************************************************
// FUNCTION: CoordinatesFromRing
// USAGE:    Returns true when a coordinate is added to close the ring ...
// **************************************************************************
TrimbleMap.ShapePart.Shared.CoordinatesFromRing = function CoordinatesFromRing(arrRingCoordinates, blnRemoveClosingCoordinate) {

    // Create a new array ...
    var arrCoordinates = [];

    // Loop through all the ring coordinates ...
    $.each(arrRingCoordinates, function (intRingCoordinate, objRingCoordinate) {

        // Build and add a coordinate ...
        arrCoordinates.push({ X: objRingCoordinate[0], Y: objRingCoordinate[1] });
    });

    // When we are to remove the closing coordinate and we have at least 2 coordinates ...
    if (blnRemoveClosingCoordinate && (arrCoordinates.length >= 2)) {

        // Get the first and last coordinates ...
        var objFirstCoordinate = arrCoordinates[0];
        var objLastCoordinate = arrCoordinates[arrCoordinates.length - 1];

        // Remove the last coordinate when the first and last coordinates matches ...
        if ((objFirstCoordinate.X == objLastCoordinate.X) && (objFirstCoordinate.Y == objLastCoordinate.Y)) { arrCoordinates.pop(); }
    }

    return arrCoordinates;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the TrimbleMap namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.StandardMap = {};
TrimbleMap.StandardMap.Shared = {};

// **************************************************************************
// FUNCTION: enumMenuOrder
// USAGE:    Defines the order in which the menu items will appear in ...
// **************************************************************************
TrimbleMap.StandardMap.Shared.enumMenuOrder = {};
TrimbleMap.StandardMap.Shared.enumMenuOrder.MAPS = 0;
TrimbleMap.StandardMap.Shared.enumMenuOrder.ZOOM = 1;
TrimbleMap.StandardMap.Shared.enumMenuOrder.BOOKMARKS = 2;
TrimbleMap.StandardMap.Shared.enumMenuOrder.TABS = 3;
TrimbleMap.StandardMap.Shared.enumMenuOrder.PREFERENCES = 4;
TrimbleMap.StandardMap.Shared.enumMenuOrder.PRINT = 5;

// **************************************************************************
// FUNCTION: enumModeButtonOrder
// USAGE:    Defines the order in which the mode buttons will appear in ...
// **************************************************************************
TrimbleMap.StandardMap.Shared.enumModeButtonOrder = {};
TrimbleMap.StandardMap.Shared.enumModeButtonOrder.IDENTIFY = 0;
TrimbleMap.StandardMap.Shared.enumModeButtonOrder.SELECT = 1;
TrimbleMap.StandardMap.Shared.enumModeButtonOrder.MEASURE = 2;
TrimbleMap.StandardMap.Shared.enumModeButtonOrder.DRAW = 3;

// **************************************************************************
// FUNCTION: enumTabOrder
// USAGE:    Defines the order in which the mode buttons will appear in ...
// **************************************************************************
TrimbleMap.StandardMap.Shared.enumTabOrder = {};
TrimbleMap.StandardMap.Shared.enumTabOrder.LEGEND = 0;
TrimbleMap.StandardMap.Shared.enumTabOrder.SEARCH = 1;
TrimbleMap.StandardMap.Shared.enumTabOrder.SELECT = 2;
TrimbleMap.StandardMap.Shared.enumTabOrder.MEASURE = 3;
TrimbleMap.StandardMap.Shared.enumTabOrder.FIXINVALIDSHAPES = 4;
TrimbleMap.StandardMap.Shared.enumTabOrder.SHAPE = 5;
TrimbleMap.StandardMap.Shared.enumTabOrder.DIAGNOSTICS = 6;

// **************************************************************************
// FUNCTION: enumTabOrder
// USAGE:    Defines the order in which the mode buttons will appear in ...
// **************************************************************************
TrimbleMap.StandardMap.Shared.enumTabName = {};
TrimbleMap.StandardMap.Shared.enumTabName.LEGEND = 'LEGEND';
TrimbleMap.StandardMap.Shared.enumTabName.SEARCH = 'SEARCH';
TrimbleMap.StandardMap.Shared.enumTabName.SELECT = 'SELECT';
TrimbleMap.StandardMap.Shared.enumTabName.MEASURE = 'MEASURE';
TrimbleMap.StandardMap.Shared.enumTabName.SHAPE = 'SHAPE';
TrimbleMap.StandardMap.Shared.enumTabName.DIAGNOSTICS = 'DIAGNOSTICS';
TrimbleMap.StandardMap.Shared.enumTabName.INSTRUCTIONS = 'INSTRUCTIONS';

// **************************************************************************
// FUNCTION: enumModule
// USAGE:    
// **************************************************************************
TrimbleMap.StandardMap.Shared.enumModule = {};
TrimbleMap.StandardMap.Shared.enumModule.MapSwitcher = 'MapSwitcher';
TrimbleMap.StandardMap.Shared.enumModule.Zoom = 'Zoom';
TrimbleMap.StandardMap.Shared.enumModule.Bookmarks = 'Bookmarks';
TrimbleMap.StandardMap.Shared.enumModule.Print = 'Print';
TrimbleMap.StandardMap.Shared.enumModule.Identify = 'Identify';
TrimbleMap.StandardMap.Shared.enumModule.Selection = 'Selection';
TrimbleMap.StandardMap.Shared.enumModule.Measure = 'Measure';
TrimbleMap.StandardMap.Shared.enumModule.ShapeEditor = 'ShapeEditor';
TrimbleMap.StandardMap.Shared.enumModule.Search = 'Search';
TrimbleMap.StandardMap.Shared.enumModule.Legend = 'Legend';
TrimbleMap.StandardMap.Shared.enumModule.Configuration = 'Configuration';
TrimbleMap.StandardMap.Shared.enumModule.ModuleVisibilitySwitcher = 'ModuleVisibilitySwitcher';
TrimbleMap.StandardMap.Shared.enumModule.Diagnostics = 'Diagnostics';
TrimbleMap.StandardMap.Shared.enumModule.Preferences = 'Preferences';
TrimbleMap.StandardMap.Shared.enumModule.ExpandMap = 'ExpandMap';
TrimbleMap.StandardMap.Shared.enumModule.ChooseExistingShape = 'ChooseExistingShape';
TrimbleMap.StandardMap.Shared.enumModule.Instructions = 'Instructions';

// **************************************************************************
// Initialization code ...
// **************************************************************************

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    * arrModulesToSwitchVisibility and arrModulesVisibleOnStartUp
//             only required when ModuleVisibilitySwitcher is present
// **************************************************************************
TrimbleMap.StandardMap.CreateInstance = function CreateInstance(objStandardMapState,
    strMapContainerElementID,
    objCurrentMapIDHiddenElement,
    blnAllowPageScrolling,
    blnShowSidebarAutomatically,
    blnLoadMapContents,
    arrModules,
    strInitialTabName,
    blnEditable,
    arrModulesToSwitchVisibility,
    arrModulesVisibleOnStartUp,
    objModuleOptions,
    fnOpenPopup,
    fnModifyMapControllerBeforeLoadingMap,
    fnComputeMapSize,
    fnLoaded,
    strShapesToSelectExtent,
    blnRemoveVerticesAlongStraightLine,
    blnIgnoreClientSideExtent,
    blnOverrideModuleVisibilityInDefaultView) {

    // Create the object that will hold the instance properties ...
    var objStandardMap = {
        StandardMapState: objStandardMapState,
        LoadMapContents: blnLoadMapContents,
        AllowPageScrolling: blnAllowPageScrolling,
        ModulesToSwitchVisibility: arrModulesToSwitchVisibility,
        ModulesVisibleOnStartUp: arrModulesVisibleOnStartUp,
        ModuleOptions: objModuleOptions,
        Modules: arrModules,
        InitialTabName: strInitialTabName,
        Editable: blnEditable,
        MapContainerElementID: strMapContainerElementID,
        CurrentMapIDHiddenElement: objCurrentMapIDHiddenElement,
        Map: null,
        MapController: null,
        UserSettings: null,
        ModuleVisibilitySwitcher: null,
        MapContainerElement: null,
        MapElement: null,
        MapContainerInner: null,
        MapBusyLoadingElement: null,
        MapLegendInstance: null,
        MapSelectorInstance: null,
        ZoomInstance: null,
        BookmarksInstance: null,
        DiagnosticsInstance: null,
        InstructionsInstance: null,
        PreferencesInstance: null,
        PrintInstance: null,
        ShapeEditor: null,
        MapSearch: null,
        MapSelection: null,
        MapIdentify: null,
        MapMenu: null,
        Sidebar: null,
        ModeButtons: null,
        ModifyMapControllerBeforeLoadingMapFunction: fnModifyMapControllerBeforeLoadingMap,
        ComputeMapSize: fnComputeMapSize,
        LoadedFunction: fnLoaded,
        ShowSidebarAutomatically: blnShowSidebarAutomatically,
        SpinnerElements: null,
        HasModeButtons: null,
        HasMenu: false,
        DiagnosticMessagesDiv: null,
        ShapesToSelectExtent: null,
        Preferences: null,

        OpenPopup: fnOpenPopup,

        MapLoadedProxy: function (blnReloaded, blnAllowExtentChangePostMapLoad) { objStandardMap.MapLoaded(blnReloaded, blnAllowExtentChangePostMapLoad); },
        MapPreReLoadedProxy: function () { objStandardMap.MapPreReLoaded(); },
        SetModuleVisiblityProxy: function (enModule, blnVisible) { objStandardMap.SetModuleVisiblity(enModule, blnVisible); },
        HandleDiagnosticMessageLoggedProxy: function (objDiagnosticMessage) { objStandardMap.HandleDiagnosticMessageLogged(objDiagnosticMessage); },

        Init: TrimbleMap.StandardMap.Init,
        ResizeMap: TrimbleMap.StandardMap.ResizeMap,
        ApplyUserSettings: TrimbleMap.StandardMap.ApplyUserSettings,
        ApplyUserMapSettings: TrimbleMap.StandardMap.ApplyUserMapSettings,
        ApplyUserMapSettingsProxy: function (strMapID) { objStandardMap.ApplyUserMapSettings(strMapID); },
        MouseLeftMap: TrimbleMap.StandardMap.MouseLeftMap,
        MouseLeftMapProxy: function (e) { objStandardMap.MouseLeftMap(e); },
        MenuItemClicked: TrimbleMap.StandardMap.MenuItemClicked,
        CreateMapElements: TrimbleMap.StandardMap.CreateMapElements,
        PositionMapBusyLoadingElement: TrimbleMap.StandardMap.PositionMapBusyLoadingElement,
        BuildMenu: TrimbleMap.StandardMap.BuildMenu,
        ModuleIncluded: TrimbleMap.StandardMap.ModuleIncluded,
        AnyModuleIncluded: TrimbleMap.StandardMap.AnyModuleIncluded,
        ModuleVisibleOnStartUp: TrimbleMap.StandardMap.ModuleVisibleOnStartUp,
        SetModuleVisiblity: TrimbleMap.StandardMap.SetModuleVisiblity,
        MapLoaded: TrimbleMap.StandardMap.MapLoaded,
        HandleDiagnosticMessageLogged: TrimbleMap.StandardMap.HandleDiagnosticMessageLogged,
        CreateDiagnosticMessageDisplayDiv: TrimbleMap.StandardMap.CreateDiagnosticMessageDisplayDiv,
        MapPreReLoaded: TrimbleMap.StandardMap.MapPreReLoaded,
        GetModuleOptions: TrimbleMap.StandardMap.GetModuleOptions,
        TimeoutExceptionCallback: null,
        RemoveVerticesAlongStraightLine: blnRemoveVerticesAlongStraightLine,
        IgnoreClientSideExtent: blnIgnoreClientSideExtent,
        OverrideModuleVisibilityInDefaultView: (blnOverrideModuleVisibilityInDefaultView) ? true : false
    };

    // Initialize the map ...
    objStandardMap.Init(strShapesToSelectExtent);

    Date.prototype.ToUTCString = function (dateFormat) {
        let utcDate = '';

        if (this != 'Invalid Date') {
            utcDate = String.__Format(dateFormat, new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds(), this.getUTCMilliseconds()));
        }

        return utcDate;
    };

    let existingErrorFunction = window.onerror;

    let wrapperErrorFunction = function (strErrorMessage, strUrl, intLineNumber, intColumnNumber, objError) {
        let functionSignature = "Object._popTile";
        let fileName = "init.js";
        let timeoutException = "TimeoutException";
        if (strUrl.indexOf(fileName) !== -1 && objError.stack.indexOf(functionSignature) !== -1) {
            console.log("An esri.js error has been ignored:" +
                "\nmessage: " + strErrorMessage +
                "\nlocation: " + strUrl);
        } else if (typeof objStandardMap.TimeoutExceptionCallback === "function" && strErrorMessage.indexOf(timeoutException) !== -1) {
            objStandardMap.TimeoutExceptionCallback();
            objStandardMap.TimeoutExceptionCallback = null;
        } else {
            if (existingErrorFunction !== null && existingErrorFunction !== undefined)
                existingErrorFunction(strErrorMessage, strUrl, intLineNumber, intColumnNumber, objError);
        }
    };

    window.onerror = wrapperErrorFunction;

    return objStandardMap;
}

// **************************************************************************
// FUNCTION: ModuleIncluded
// USAGE:    Returns true when the module is to be included ...
// **************************************************************************
TrimbleMap.StandardMap.ModuleIncluded = function ModuleIncluded(enModule) {

    // Get the instance ...
    var objStandardMap = this;

    // When the module is to be included ...
    var blnInclude = $.inArray(enModule, objStandardMap.Modules) > -1;

    // Return the module ...
    return blnInclude;
}

// **************************************************************************
// FUNCTION: AnyModuleIncluded
// USAGE:    Returns true when a module from arrModules is to be included ...
// **************************************************************************
TrimbleMap.StandardMap.AnyModuleIncluded = function AnyModuleIncluded(arrModules) {

    // Get the instance ...
    var objStandardMap = this;

    // Start with no modules included ...
    var blnInclude = false;

    // Loop through all the modules to check for ...
    $.each(arrModules, function (intModule, enModule) {

        // When the module is to be included ...
        if ($.inArray(enModule, objStandardMap.Modules) > -1) {

            // Set that we've found that a module is to be included ...
            blnInclude = true;

            // Stop checking ...
            return false;
        }
    });

    // Return the module ...
    return blnInclude;
}

// **************************************************************************
// FUNCTION: ModuleVisibleOnStartUp
// USAGE:    Returns true when the module is to be visible on startup ...
// **************************************************************************
TrimbleMap.StandardMap.ModuleVisibleOnStartUp = function ModuleVisibleOnStartUp(enModule) {

    // Get the instance ...
    var objStandardMap = this;

    // Start with the module being visible on startup ...
    var blnModuleVisibleOnStartUp = true;

    // When the ModuleVisibilitySwitcher module is to be included ...
    if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.ModuleVisibilitySwitcher)) {

        // When the module is to be switched by the tab switcher ...
        if ($.inArray(enModule, objStandardMap.ModulesToSwitchVisibility) > -1) {

            // Determine whether or not the module is to be visible on startup ...
            blnModuleVisibleOnStartUp = ($.inArray(enModule, objStandardMap.ModulesVisibleOnStartUp) > -1);
        }
    }

    return blnModuleVisibleOnStartUp;
}

// **************************************************************************
// FUNCTION: SetModuleVisiblity
// USAGE:    
// **************************************************************************
TrimbleMap.StandardMap.SetModuleVisiblity = function SetModuleVisiblity(enModule, blnVisible) {

    // Get the instance ...
    var objStandardMap = this;

    // Declare a variable for the module ...
    var objModule;

    // Show the module ...
    switch (enModule) {
        case TrimbleMap.StandardMap.Shared.enumModule.Identify: objModule = objStandardMap.MapIdentify; break;
        case TrimbleMap.StandardMap.Shared.enumModule.Selection: objModule = objStandardMap.MapSelection; break;
        case TrimbleMap.StandardMap.Shared.enumModule.Search: objModule = objStandardMap.MapSearch; break;
        case TrimbleMap.StandardMap.Shared.enumModule.Measure: objModule = objStandardMap.MapMeasure; break;
        case TrimbleMap.StandardMap.Shared.enumModule.ShapeEditor: objModule = objStandardMap.ShapeEditor; break;
        case TrimbleMap.StandardMap.Shared.enumModule.Legend: objModule = objStandardMap.MapLegend; break;
        case TrimbleMap.StandardMap.Shared.enumModule.Zoom: objModule = objStandardMap.ZoomInstance; break;
        case TrimbleMap.StandardMap.Shared.enumModule.MapSwitcher: objModule = objStandardMap.MapSelectorInstance; break;
        case TrimbleMap.StandardMap.Shared.enumModule.Bookmarks: objModule = objStandardMap.BookmarksInstance; break;
        case TrimbleMap.StandardMap.Shared.enumModule.Print: objModule = objStandardMap.PrintInstance; break;
        case TrimbleMap.StandardMap.Shared.enumModule.Diagnostics: objModule = objStandardMap.DiagnosticsInstance; break;
        case TrimbleMap.StandardMap.Shared.enumModule.Instructions: objModule = objStandardMap.InstructionsInstance; break;
    }

    // Show or hide the module ...
    if (blnVisible) { objModule.Show(false); } else { objModule.Hide(false); }
}

// **************************************************************************
// FUNCTION: Init
// USAGE:    Initialize the map ...
// **************************************************************************
TrimbleMap.StandardMap.Init = function Init(strShapesToSelectExtent) {

    // Place this in a local variable ...
    var objStandardMap = this;

    // When page scrolling should not be allowed ...
    if (!objStandardMap.AllowPageScrolling) {

        // Set to hide page scrolling ...
        $('body').css('overflow', 'hidden');
    }

    // Determine if any module that will add a mode button is to be included ...
    objStandardMap.HasModeButtons = objStandardMap.AnyModuleIncluded([TrimbleMap.StandardMap.Shared.enumModule.Identify,
    TrimbleMap.StandardMap.Shared.enumModule.Selection,
    TrimbleMap.StandardMap.Shared.enumModule.Measure,
    TrimbleMap.StandardMap.Shared.enumModule.ShapeEditor]);

    // Determine if any module that will add a menu item is to be included ...
    objStandardMap.HasMenu = objStandardMap.AnyModuleIncluded([TrimbleMap.StandardMap.Shared.enumModule.MapSwitcher,
    TrimbleMap.StandardMap.Shared.enumModule.Zoom,
    TrimbleMap.StandardMap.Shared.enumModule.Bookmarks,
    TrimbleMap.StandardMap.Shared.enumModule.ModuleVisibilitySwitcher,
    TrimbleMap.StandardMap.Shared.enumModule.Print]);

    // Create the map elements ...
    objStandardMap.CreateMapElements();

    // Position the map busy loading element ...
    objStandardMap.PositionMapBusyLoadingElement();

    // Resize the map ...
    objStandardMap.ResizeMap();

    objStandardMap.StandardMapState.MapControllerState.ApplyMapSettingsOnMapChange = false;

    objStandardMap.StandardMapState.MapControllerState.ApplyClientSideUserMapSettings = objStandardMap.StandardMapState.MapControllerState.ApplyClientSideUserMapSettings &&
        objStandardMap.StandardMapState.MapControllerState.PersistClientSideUserMapSettings;

    objStandardMap.StandardMapState.MapControllerState.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings = objStandardMap.StandardMapState.MapControllerState.ApplyClientSideUserMapSettings ||
        objStandardMap.StandardMapState.MapControllerState.ApplyMapSettingsOnMapChange;

    // Get or create default preferences ...
    objStandardMap.Preferences = ((typeof objPreferencesModuleOptions != 'undefined') && (objPreferencesModuleOptions != null)) ? objPreferencesModuleOptions.Preferences : TrimbleMap.Preferences.Shared.CreatePreferences(false, false);

    objStandardMap.UserSettings = TrimbleMap.UserSettings.CreateInstance(objStandardMap.MapContainerElementID, objStandardMap.ModulesVisibleOnStartUp, objStandardMap.Preferences);

    // Instantiate Client-side Map Settings
    objStandardMap.StandardMapState.MapControllerState.AllowExtentChangePostMapLoad = true;
    objStandardMap.StandardMapState.MapControllerState.ClientStoredInitialExtentBookmark = null;
    objStandardMap.StandardMapState.MapControllerState.ClientStoredVisibleLayerIDsByMapServiceDisplayID = null;
    objStandardMap.StandardMapState.MapControllerState.ClientStoredVisibleMapServiceDisplayIDs = null;
    objStandardMap.StandardMapState.MapControllerState.ClientStoredSelectionState = null;

    objStandardMap.ApplyUserSettings();

    // Create the sidebar instance ...
    objStandardMap.Sidebar = SD.Sidebar.CreateInstance(objStandardMap.MapContainerElement, objStandardMap.MapContainerElement.attr('id'), objStandardMap.InitialTabName);

    // When the mode buttons is to be created ...
    if (objStandardMap.HasModeButtons) {

        // Create the ModeButtons instance ...
        objStandardMap.ModeButtons = SD.ModeButtons.CreateInstance(objStandardMap.MapContainerElement.attr('id'), (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Identify) ? 'IDENTIFY' : null));
    }

    // When the window is resized ...
    $(window).on('resize', (function () {

        // Resize the map ...
        objStandardMap.ResizeMap();
    }));

    // Load the mapping prerequisites ...
    TrimbleMap.Controller.Shared.LoadPrerequisites(false, objStandardMap.StandardMapState.MapControllerState.ArcGISProxyServiceUrl, function () {

        // Get the translations for the tab names ...


        // Legend
        var strLegendTabCaption = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Legend');

        // Search
        var strSearchTabCaption = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Search');

        // Select
        var strSelectTabCaption = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Select');

        // Measure
        var strMeasureTabCaption = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Measure');

        // Shape
        var strShapeEditorTabCaption = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Shape');

        // Diagnostics
        var strDiagnosticsTabCaption = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Diagnostics');

        // Get the preferences module options ...
        var objPreferencesModuleOptions = objStandardMap.GetModuleOptions(TrimbleMap.StandardMap.Shared.enumModule.Preferences);

        if (strShapesToSelectExtent) {

            let objShapesToSelectExtent = JSON.parse(strShapesToSelectExtent);

            if (objShapesToSelectExtent) {
                let objSpatialReference = (objShapesToSelectExtent.spatialReference.latestWkid) ?
                    new esri.SpatialReference(objShapesToSelectExtent.spatialReference.latestWkid) :
                    new esri.SpatialReference(objShapesToSelectExtent.spatialReference.wkid);

                objStandardMap.ShapesToSelectExtent = new esri.geometry.Extent(objShapesToSelectExtent.xmin, objShapesToSelectExtent.ymin,
                    objShapesToSelectExtent.xmax, objShapesToSelectExtent.ymax,
                    objSpatialReference);
            }
        }

        // Create the map loader instance ...
        objStandardMap.MapController = TrimbleMap.Controller.CreateInstance(objStandardMap.StandardMapState.MapControllerState, objStandardMap.Preferences, objStandardMap.CurrentMapIDHiddenElement, objStandardMap.MapElement, objStandardMap.LoadMapContents, objStandardMap.OpenPopup, function () {

            // Get the sidebar width ...
            var intSidebarWidth = (objStandardMap.Sidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) ? objStandardMap.Sidebar.GetWidth() : 0;

            // Compute a rectangle with the top left corner on the top left corner 
            // of the map but with the side bar section removed from the right ...
            return {
                "inset-block-start": objStandardMap.MapElement.offset().top,
                "inset-inline-start": objStandardMap.MapElement.offset().left,
                width: parseInt(objStandardMap.MapElement.innerWidth(), 10) - intSidebarWidth,
                height: parseInt(objStandardMap.MapElement.innerHeight(), 10)
            };
        }, objStandardMap.ShapesToSelectExtent, objStandardMap.MouseLeftMapProxy, objStandardMap.ApplyUserMapSettingsProxy, objStandardMap.UserSettings);

        // When we have a function to call after creating the map controller and before loading the map ...
        if ((typeof objStandardMap.ModifyMapControllerBeforeLoadingMapFunction != 'undefined') && (objStandardMap.ModifyMapControllerBeforeLoadingMapFunction != null)) {

            // Call the function to modify the map controller ...
            objStandardMap.ModifyMapControllerBeforeLoadingMapFunction(objStandardMap.MapController);
        }

        // Add an on loaded callback to the map controller ...
        objStandardMap.MapController.AddOnLoadedCallback(objStandardMap.MapLoadedProxy);

        // Add an on pre reloaded callback to the map controller ...
        objStandardMap.MapController.AddPreReloadedCallback(objStandardMap.MapPreReLoadedProxy);

        //When ExpandMap Module is to be included
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.ExpandMap)) {

            // Create the ExpandMap instance ...
            objStandardMap.Expander = TrimbleMap.Expander.CreateInstance(objStandardMap.Sidebar, objStandardMap.MapContainerElement, objStandardMap.MapElement, true, objStandardMap);

        }

        // When the Instructions module is to be included ...
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Instructions)) {

            // Create the Instructions instance ...
            objStandardMap.InstructionsInstance = TrimbleMap.Instructions.CreateInstance(objStandardMap.MapController, objStandardMap.Sidebar, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Instructions), TrimbleMap.StandardMap.Shared.enumTabName.INSTRUCTIONS);

        }

        // When the diagnostics module is to be included ...
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Diagnostics)) {

            // Create the diagnostics instance ...
            objStandardMap.DiagnosticsInstance = TrimbleMap.Diagnostics.CreateInstance(objStandardMap.MapController, objStandardMap.Sidebar, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Diagnostics), TrimbleMap.StandardMap.Shared.enumTabName.DIAGNOSTICS, strDiagnosticsTabCaption);

        } else {

            // Attach the diagnostic message logged callback to 
            // get notification when diagnostic messages are logged ...
            objStandardMap.MapController.AddNotifyDiagnosticMessageLogged(objStandardMap.HandleDiagnosticMessageLoggedProxy);
        }

        // Trigger notifications for all the diagnostic messsages logged ...
        objStandardMap.MapController.TriggerNotifyDiagnosticMessageLoggedForAllDiagnosticMessages();

        // Create the map callout ...
        objStandardMap.MapCallout = TrimbleMap.Callout.CreateInstance(objStandardMap.MapController);

        // When the shape editor module is to be included ...
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.ShapeEditor)) {

            // Create the map shape instance ...
            objStandardMap.ShapeEditor = TrimbleMap.ShapeEditor.CreateInstance(objStandardMap.MapController, objStandardMap.Sidebar, objStandardMap.ModeButtons, TrimbleMap.StandardMap.Shared.enumTabName.SHAPE, strShapeEditorTabCaption, objStandardMap.GetModuleOptions(TrimbleMap.StandardMap.Shared.enumModule.ShapeEditor), objStandardMap.Editable, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.ShapeEditor), objStandardMap.Modules, objStandardMap.RemoveVerticesAlongStraightLine);
        }

        // When the selection module is to be included ..
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Selection)) {

            // Create the selection instance ...
            objStandardMap.MapSelection = TrimbleMap.Selection.CreateInstance(objStandardMap.MapController, objStandardMap.Sidebar, objStandardMap.ModeButtons, objStandardMap.MapCallout, objStandardMap.ShapeEditor, TrimbleMap.StandardMap.Shared.enumTabName.SELECT, strSelectTabCaption, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Selection), objStandardMap.GetModuleOptions(TrimbleMap.StandardMap.Shared.enumModule.Selection));
        }

        // When the search module is to be included ...
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Search)) {

            // Create the search instance ...
            objStandardMap.MapSearch = TrimbleMap.Search.CreateInstance(objStandardMap.MapController, objStandardMap.MapCallout, objStandardMap.Sidebar, objStandardMap.MapSelection, TrimbleMap.StandardMap.Shared.enumTabName.SEARCH, strSearchTabCaption, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Search), objStandardMap.GetModuleOptions(TrimbleMap.StandardMap.Shared.enumModule.Search));
        }

        // When the legend module is to be included ...
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Legend)) {

            // Create the map instance ...
            objStandardMap.MapLegend = TrimbleMap.Legend.CreateInstance(objStandardMap.MapController, objStandardMap.Sidebar, TrimbleMap.StandardMap.Shared.enumTabName.LEGEND, strLegendTabCaption, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Legend), objStandardMap.UserSettings.UpdateUserSettingsProxy);
        }

        // When the measure module is to be included ...
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Measure)) {

            // Create the measure tab ...
            objStandardMap.MapMeasure = TrimbleMap.Measure.CreateInstance(objStandardMap.MapController, objStandardMap.Sidebar, objStandardMap.ModeButtons, TrimbleMap.StandardMap.Shared.enumTabName.MEASURE, strMeasureTabCaption, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Measure));
        }

        // When the configuration module is to be included ...
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Configuration)) {

            // Create the map configuration ...
            objStandardMap.MapConfiguration = TrimbleMap.Configuration.CreateInstance(objStandardMap.MapController, objStandardMap.Sidebar, objStandardMap.Editable);
        }

        // When the menu is to be created ...
        if (objStandardMap.HasMenu) {

            // Build the menu ...
            TrimbleMap.c_objMapMenuInstance = objStandardMap.BuildMenu();
        }

        // Load the map ...
        objStandardMap.MapController.LoadMap();
    });
}

// **************************************************************************
// FUNCTION: GetModuleOptions
// USAGE:    enModule - member of TrimbleMap.StandardMap.Shared.enumModule
// **************************************************************************
TrimbleMap.StandardMap.GetModuleOptions = function GetModuleOptions(enModule) {

    // Get instance ...
    var objStandardMap = this;

    // Get the options for the module ...
    var objModuleOptions = objStandardMap.ModuleOptions[enModule];

    // Set to null when not defined ...
    if (typeof objModuleOptions == 'undefined') { objModuleOptions = null; }

    // Rerurn the module options ...
    return objModuleOptions;
}

// **************************************************************************
// FUNCTION: MapLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.StandardMap.MapLoaded = function MapLoaded(blnReloaded, blnAllowExtentChangePostMapLoad) {

    // Get instance ...
    var objStandardMap = this;

    // Hide the map busy loading element ...
    objStandardMap.MapBusyLoadingElement.hide();

    // The first time the map loads ...
    if (!blnReloaded) {

        // When the side bar are to be shown automatically ...
        if (objStandardMap.ShowSidebarAutomatically && !objStandardMap.OverrideModuleVisibilityInDefaultView) {

            // Show the sidebar ...
            objStandardMap.Sidebar.Show(SD.Sidebar.enumDisplayMethod.NoFadeOrSlide);
        }

        // When we are to add the standard tabs and mode buttons ...
        if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Identify)) {

            // Create the map identify instance ...
            objStandardMap.MapIdentify = TrimbleMap.Identify.CreateInstance(objStandardMap.MapController, objStandardMap.MapCallout, objStandardMap.ModeButtons, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Identify));
        }

        // When we created mode buttons ..
        if (objStandardMap.HasModeButtons) {

            // Initialize the mode buttons ...
            objStandardMap.ModeButtons.Init(objStandardMap.MapController.MapElement);

            // Hide Mode Buttons
            if (objStandardMap.OverrideModuleVisibilityInDefaultView) { objStandardMap.ModeButtons.Hide(); }
        }

        // Hide Menu
        if (objStandardMap.HasMenu && objStandardMap.OverrideModuleVisibilityInDefaultView) { TrimbleMap.c_objMapMenuInstance.Hide(); }
    }

    // Call the loaded function when defined ...
    if ((typeof objStandardMap.LoadedFunction != 'undefined') && (objStandardMap.LoadedFunction != null)) { objStandardMap.LoadedFunction(blnReloaded, blnAllowExtentChangePostMapLoad); }
}

// **************************************************************************
// FUNCTION: MapPreReLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.StandardMap.MapPreReLoaded = function MapPreReLoaded() {

    // Get instance ...
    var objStandardMap = this;

    // Hide the map callout when visible ...
    objStandardMap.MapCallout.Hide();

    // Show the map busy loading element ...
    objStandardMap.MapBusyLoadingElement.show();
}

// **************************************************************************
// FUNCTION: BuildMenu
// USAGE:    
// **************************************************************************
TrimbleMap.StandardMap.BuildMenu = function BuildMenu() {

    // Get the standard map instance ...
    var objStandardMap = this;

    // Create the menu instance ...
    var objMapMenuInstance = TrimbleMap.Menu.CreateInstance(objStandardMap.MapController);

    // When the tab switcher is to be included ..
    if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.ModuleVisibilitySwitcher)) {

        // Create the atb switcher instance ...
        objStandardMap.ModuleVisibilitySwitcher = TrimbleMap.ModuleVisibilitySwitcher.CreateInstance(objStandardMap.MapController, objMapMenuInstance, TrimbleMap.StandardMap.Shared.enumMenuOrder.TABS,
            objStandardMap.ModulesToSwitchVisibility, objStandardMap.ModulesVisibleOnStartUp,
            objStandardMap.SetModuleVisiblityProxy, TrimbleMap.StandardMap.Shared.TabDisplayName,
            objStandardMap.UserSettings.UpdateUserSettingsProxy);

    }

    // When the map switcher module is to be included ..
    if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.MapSwitcher)) {

        // Create the map selector instance that will hook into the menu ...
        objStandardMap.MapSelectorInstance = TrimbleMap.MapSelector.CreateInstance(objStandardMap.MapController, objMapMenuInstance, TrimbleMap.StandardMap.Shared.enumMenuOrder.MAPS,
            objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.MapSwitcher),
            objStandardMap.UserSettings.UpdateUserSettingsProxy);
    }

    // When the zoom module is to be included ..
    if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Zoom)) {

        // Create the zoom controller instance that will hook into the menu ...
        objStandardMap.ZoomInstance = TrimbleMap.Zoom.CreateInstance(objStandardMap.MapController, objMapMenuInstance, TrimbleMap.StandardMap.Shared.enumMenuOrder.ZOOM, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Zoom));
    }

    // When the bookmarks module is to be included ...
    if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Bookmarks)) {

        // Create the bookmarks instance that will hook into the menu ...
        objStandardMap.BookmarksInstance = TrimbleMap.Bookmarks.CreateInstance(objStandardMap.MapController, objMapMenuInstance, TrimbleMap.StandardMap.Shared.enumMenuOrder.BOOKMARKS, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Bookmarks));
    }

    // When the preferences module is to be included ...
    if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Preferences)) {

        // Create the preferences instance that will hook into the menu ...
        objStandardMap.PreferencesInstance = TrimbleMap.Preferences.CreateInstance(objStandardMap.MapController, objMapMenuInstance, TrimbleMap.StandardMap.Shared.enumMenuOrder.PREFERENCES, objStandardMap.UserSettings);
    }

    // When the print module is to be included ...
    if (objStandardMap.ModuleIncluded(TrimbleMap.StandardMap.Shared.enumModule.Print)) {

        // Create the print instance that will hook into the menu ...
        objStandardMap.PrintInstance = TrimbleMap.Print.CreateInstance(objStandardMap.MapController, objMapMenuInstance, TrimbleMap.StandardMap.Shared.enumMenuOrder.PRINT, objStandardMap.ModuleVisibleOnStartUp(TrimbleMap.StandardMap.Shared.enumModule.Print));
    }

    return objMapMenuInstance;
}

// **************************************************************************
// FUNCTION CreateMapElements
// **************************************************************************
TrimbleMap.StandardMap.CreateMapElements = function CreateMapElements() {

    // Get the standard map instance ...
    var objStandardMap = this;

    // Create an object containing the ids for the newly created elements ...
    var strMapElementID = objStandardMap.MapContainerElementID + '_Map';
    var strMapContainerInnerID = objStandardMap.MapContainerElementID + '_Inner';
    var strMapBusyLoadingElementID = objStandardMap.MapContainerElementID + '_MapBusyLoading';

    // Get the map container element IDs ...
    objStandardMap.MapContainerElement = $('#' + objStandardMap.MapContainerElementID);

    // Compute the map size ...
    var objSize = objStandardMap.ComputeMapSize();

    // * MapContainerInner will contain the shadow divs and the 
    //   div (called MapElement) in which the map will be built ...

    // Create the map container inner element ...
    objStandardMap.MapContainerInner = $('<div id = "' + strMapContainerInnerID + '"></div>');

    // Add to the container ...
    objStandardMap.MapContainerElement.append(objStandardMap.MapContainerInner);

    // Create the map element ...
    objStandardMap.MapElement = $('<div runat="server" id="' + strMapElementID + '" class="map"></div>');

    // Set the width and height of the map element  ...
    objStandardMap.MapElement.css('width', objSize.Width);
    objStandardMap.MapElement.css('height', objSize.Height);

    // Add to the inner container ...
    objStandardMap.MapContainerInner.append(objStandardMap.MapElement);

    // Create the map busy loading element ...
    objStandardMap.MapBusyLoadingElement = $('<div runat="server" id="' + strMapBusyLoadingElementID + '" class="map-loading"></div>');


    // Add to the inner container ...
    objStandardMap.MapContainerInner.append(objStandardMap.MapBusyLoadingElement);

    // Add to the inner container ...
    objStandardMap.MapContainerInner.append('<div class="title_box_shadow_top"></div>');
    objStandardMap.MapContainerInner.append('<div class="title_box_shadow_left"></div>');

    // Create the spinner element within the map busy loading element ...
    objStandardMap.SpinnerElements = SD.SpinnerFunctions.Shared.CreateSpinnerInContainerElement($('#' + strMapBusyLoadingElementID), 12, 22, 18, 3, '#C8C8C8', 'Loading Map', 'map-loading-text', 'loading-content');
}

// **************************************************************************
// FUNCTION ResizeMap
// **************************************************************************
TrimbleMap.StandardMap.ResizeMap = function ResizeMap() {

    // Get the map instance ...
    var objStandardMap = this;

    // Compute the map size ...
    var objSize = objStandardMap.ComputeMapSize();

    // Set the width and height of the container element to fit the page ...
    objStandardMap.MapElement.css('width', objSize.Width);
    objStandardMap.MapElement.css('height', objSize.Height);

    objStandardMap.MapContainerElement.css('width', objSize.Width);
    objStandardMap.MapContainerElement.css('height', objSize.Height);

    // When the map has been initialized ...
    if ((typeof objStandardMap.MapController != 'undefined') && (objStandardMap.MapController != null) && (typeof objStandardMap.MapController.EsriMap != 'undefined') && (objStandardMap.MapController.EsriMap != null)) {

        // Resize and reposition the map ...
        objStandardMap.MapController.EsriMap.resize();
        objStandardMap.MapController.EsriMap.reposition();
    }

    // Position the map busy loading element ...
    objStandardMap.PositionMapBusyLoadingElement();

    // When we have a side bar ...
    if ((typeof objStandardMap.Sidebar != 'undefined') && (objStandardMap.Sidebar)) {

        // Notify the sidebar that the container element resized ...
        objStandardMap.Sidebar.ContainerElementResized();
    }

    // Position the spinner inside the container element ...
    SD.SpinnerFunctions.Shared.PositionSpinnerInContainerElement(objStandardMap.SpinnerElements);
}

// **************************************************************************
// FUNCTION PositionMapBusyLoadingElement: Position the map busy loading element on top of the map ...
// **************************************************************************
TrimbleMap.StandardMap.PositionMapBusyLoadingElement = function PositionMapBusyLoadingElement() {

    // Get the map instance ...
    var objStandardMap = this;

    // When there is a busy loading element ...
    if ((objStandardMap.MapBusyLoadingElement != null) && (objStandardMap.MapBusyLoadingElement.is(":visible"))) {

    }
}

// **************************************************************************
// FUNCTION: HandleDiagnosticMessageLogged
// USAGE:    
// **************************************************************************
TrimbleMap.StandardMap.HandleDiagnosticMessageLogged = function HandleDiagnosticMessageLogged(objDiagnosticMessage) {

    // Get the instance ...
    var objStandardMap = this;

    // When the message is at a critical level ...
    if ((objDiagnosticMessage.MessageLevel == TrimbleMap.enumDiagnosticMessageLevel.CRITICAL)) {

        // When not already displayed ...
        if (!objStandardMap.DiagnosticMessagesDiv) {

            // Create a div for the dialog content ... 
            var objDialogContentDiv = $('<div></div>');

            // Create the div to contain the messages on the dialog ...
            objStandardMap.DiagnosticMessagesDiv = $('<div class="diagnostics_end_user_messages"><ul></ul></div>');

            // Add it to the dialog div ...
            objDialogContentDiv.append(objStandardMap.DiagnosticMessagesDiv);

            // Get the translations ... 

            // OK
            var strOK = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Ok');

            // This might be due to a configuration issue on the server
            var strConfigIssue = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'ConfigurationIssue') + '.';

            // Please contact the sytem administrator
            var strContactSystemAdminstrator = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'ContactSystemAdministrator');

            // Unexpected Problem(s) encountered
            var strTitle = SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'UnexpectedProblemsEncountered');

            // Create and add a div for the end user message ...
            $(objStandardMap.DiagnosticMessagesDiv.find('ul')).append(objStandardMap.CreateDiagnosticMessageDisplayDiv(objDiagnosticMessage.EndUserMessage));

            // Add the explanation at the bottom ...
            objDialogContentDiv.append('<br />' + strConfigIssue + '<br />' + strContactSystemAdminstrator);

            // Show the message ...
            TrimbleMap.MessageBox.Shared.ShowMessage(strTitle, null, function () { objStandardMap.DiagnosticMessagesDiv = null; }, 500, objDialogContentDiv);

        } else {

            // Create and add a div for the end user message ...
            $(objStandardMap.DiagnosticMessagesDiv.find('ul')).append(objStandardMap.CreateDiagnosticMessageDisplayDiv(objDiagnosticMessage.EndUserMessage));
        }
    }
}

// **************************************************************************
// FUNCTION: CreateDiagnosticMessageDisplayDiv
// USAGE:    
// **************************************************************************
TrimbleMap.StandardMap.CreateDiagnosticMessageDisplayDiv = function CreateDiagnosticMessageDisplayDiv(strMessage) {

    // Get the instance ...
    var objStandardMap = this;

    // Create the div ...
    var objDiagnosticMessageDiv = $('<li>' + strMessage + '</li>');

    return objDiagnosticMessageDiv;
}

// **************************************************************************
// FUNCTION: TabDisplayName
// USAGE:    
// **************************************************************************
TrimbleMap.StandardMap.Shared.TabDisplayName = function TabDisplayName(enModule) {

    // Return the  module display name that are to be displayed in the sub menu  (Translations) ...

    switch (enModule) {

        // Selection tools
        case TrimbleMap.StandardMap.Shared.enumModule.Selection: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'SelectionTools'); break;

        // Search tools
        case TrimbleMap.StandardMap.Shared.enumModule.Search: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'SearchTools'); break;

        // Measure tools
        case TrimbleMap.StandardMap.Shared.enumModule.Measure: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'MeasureTools'); break;

        // Shape tools
        case TrimbleMap.StandardMap.Shared.enumModule.ShapeEditor: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'ShapeTools'); break;

        // Legend
        case TrimbleMap.StandardMap.Shared.enumModule.Legend: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Legend'); break;

        // Identify
        case TrimbleMap.StandardMap.Shared.enumModule.Identify: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Identify'); break;

        // Zoom tools
        case TrimbleMap.StandardMap.Shared.enumModule.Zoom: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'ZoomTools'); break;

        // Map selector
        case TrimbleMap.StandardMap.Shared.enumModule.MapSwitcher: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'MapSelector'); break;

        // Bookmarks
        case TrimbleMap.StandardMap.Shared.enumModule.Bookmarks: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Bookmarks'); break;

        // Printing tools
        case TrimbleMap.StandardMap.Shared.enumModule.Print: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'PrintingTools'); break;

        // Diagnostics
        case TrimbleMap.StandardMap.Shared.enumModule.Diagnostics: return SD.Translation.Shared.GetTranslation('Map.StandardMap.js', 'Diagnostics'); break;
    }

    // Not supported ...
    return null;
}

// **************************************************************************
// FUNCTION MouseLeftMap
// USAGE    
// **************************************************************************
TrimbleMap.StandardMap.MouseLeftMap = function MouseLeftMap(e) {

    // Get the standard map instance ...
    var objStandardMap = this;

    let objSelectedFeatures = null;
    let objPreferences = null;
    let objSelectionState = null;
    let objSelectionModeAndOperation = null;

    // Get the last extent viewed bookmark if any ...
    var objLastExtentViewedBookmark = objStandardMap.MapController.GetLastExtentViewedBookmark();

    if (objStandardMap.MapSelection) {
        objSelectionState = {
            'ActiveLayerIDs': objStandardMap.MapSelection.ActiveLayerIDs,
            'SelectByLocationActiveSourceLayerIDs': objStandardMap.MapSelection.SelectByLocationActiveSourceLayerIDs,
            'SelectByLocationActiveTargetLayerIDs': objStandardMap.MapSelection.SelectByLocationActiveTargetLayerIDs,
            'ApplyBuffer': objStandardMap.MapSelection.ApplyBuffer,
            'BufferValue': objStandardMap.MapSelection.BufferValue,
            'BufferUnit': objStandardMap.MapSelection.BufferUnit
        };

        objSelectionModeAndOperation = {
            'SelectionToolMode': objStandardMap.MapSelection.ToolMode,
            'SelectionOperation': objStandardMap.MapSelection.Operation
        };
    }

    if (objStandardMap.MapController.Preferences) {
        objPreferences = {
            'DisplaySeparateParts': objStandardMap.MapController.Preferences.DisplaySeparateParts,
            'KeepSearchAndSelectResults': objStandardMap.MapController.Preferences.KeepSearchAndSelectResults,
            'InitialExtentBookmarkIDByMapID': objStandardMap.MapController.Preferences.InitialExtentBookmarkIDByMapID,
            'InitialExtentIDForAllMaps': objStandardMap.MapController.Preferences.InitialExtentIDForAllMaps,
            'InitialExtentType': objStandardMap.MapController.Preferences.InitialExtentType
        };
    }

    // Update UserSettings
    objStandardMap.UserSettings.UpdateUserSettings(TrimbleMap.UserSettings.Shared.enumSetting.MapProperties, { 'MapExtent': objLastExtentViewedBookmark, 'SelectionState': objSelectionState, 'SelectionModeAndOperation': objSelectionModeAndOperation });
    objStandardMap.UserSettings.UpdateUserSettings(TrimbleMap.UserSettings.Shared.enumSetting.Preferences, objPreferences);
}

TrimbleMap.StandardMap.ApplyUserSettings = function ApplyUserSettings() {
    let objStandardMap = this;

    let objCurrentMap = null;
    let strCurrentMapID = null;

    // Apply Module Visibility Settings
    if (objStandardMap.UserSettings.ModulesVisible.length > 0) {

        let modulesVisibleOnStartUp = objStandardMap.ModulesVisibleOnStartUp.slice(0);

        objStandardMap.ModulesVisibleOnStartUp = objStandardMap.UserSettings.ModulesVisible.slice(0);

        if ($.inArray(TrimbleMap.StandardMap.Shared.enumModule.Instructions, modulesVisibleOnStartUp) > -1) {

            objStandardMap.ModulesVisibleOnStartUp.push(TrimbleMap.StandardMap.Shared.enumModule.Instructions);
        }
    }

    // Apply Preferences Settings
    objStandardMap.Preferences.DisplaySeparateParts = objStandardMap.UserSettings.Preferences.DisplaySeparateParts;
    objStandardMap.Preferences.KeepSearchAndSelectResults = objStandardMap.UserSettings.Preferences.KeepSearchAndSelectResults;
    objStandardMap.Preferences.InitialExtentBookmarkIDByMapID = objStandardMap.UserSettings.Preferences.InitialExtentBookmarkIDByMapID;
    objStandardMap.Preferences.InitialExtentIDForAllMaps = objStandardMap.UserSettings.Preferences.InitialExtentIDForAllMaps;
    objStandardMap.Preferences.InitialExtentType = objStandardMap.UserSettings.Preferences.InitialExtentType;

    // Apply Map settings
    objCurrentMap = objStandardMap.StandardMapState.MapControllerState.Maps[objStandardMap.StandardMapState.MapControllerState.CurrentMapIndex];

    if (objStandardMap.StandardMapState.MapControllerState.ApplyClientSideUserMapSettings) {

        // Set the current map index in map state from local storage user settings
        for (let intCurrentMapIndex = 0; intCurrentMapIndex < objStandardMap.StandardMapState.MapControllerState.Maps.length; intCurrentMapIndex++) {

            let objMap = objStandardMap.StandardMapState.MapControllerState.Maps[intCurrentMapIndex];

            if (objMap.MapID == objStandardMap.UserSettings.MapProperties.CurrentMapID) {

                objStandardMap.StandardMapState.MapControllerState.CurrentMapIndex = intCurrentMapIndex;
                objCurrentMap = objMap;
                break;
            }
        }

    } else {
        // Set the current map in local storage user settings from the incoming map state
        // Clear MapProperties first
        objStandardMap.UserSettings.ClearMapProperties();
    }

    if (objCurrentMap) {
        strCurrentMapID = objCurrentMap.MapID;
    }

    objStandardMap.ApplyUserMapSettings(strCurrentMapID);
}

TrimbleMap.StandardMap.ApplyUserMapSettings = function ApplyUserMapSettings(strMapID) {
    let objStandardMap = this;

    // Ensure the current map id in local storage user settings matches that in map state
    if (objStandardMap.UserSettings.MapProperties.CurrentMapID != strMapID) {

        objStandardMap.UserSettings.UpdateUserSettings(TrimbleMap.UserSettings.Shared.enumSetting.MapProperties,
            {
                'MapID': strMapID,
                'VisibleMapServiceDisplayIDs': null,
                'VisibleLayerIDsByMapServiceDisplayID': null
            });
    }

    objStandardMap.StandardMapState.MapControllerState.ApplyMapSettingsOnMapChange = objStandardMap.StandardMapState.MapControllerState.ApplyMapSettingsOnMapChange &&
        objStandardMap.StandardMapState.MapControllerState.PersistClientSideUserMapSettings;

    objStandardMap.StandardMapState.MapControllerState.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings = objStandardMap.StandardMapState.MapControllerState.ApplyClientSideUserMapSettings ||
        objStandardMap.StandardMapState.MapControllerState.ApplyMapSettingsOnMapChange;

    objStandardMap.StandardMapState.MapControllerState.ClientStoredSelectionToolMode = objStandardMap.UserSettings.MapProperties.SelectionToolMode;
    objStandardMap.StandardMapState.MapControllerState.ClientStoredSelectionOperation = objStandardMap.UserSettings.MapProperties.SelectionOperation;

    if (objStandardMap.StandardMapState.MapControllerState.ApplyMapSettingsOnMapChangeOrApplyClientSideUserMapSettings) {

        objStandardMap.UserSettings.WhereMapID(strMapID, function (objMap) {
            let blnAllowExtentChangePostMapLoad = true;

            if (!objStandardMap.IgnoreClientSideExtent) {
                blnAllowExtentChangePostMapLoad = objMap.MapExtent ? false : true
            }

            objStandardMap.StandardMapState.MapControllerState.AllowExtentChangePostMapLoad = blnAllowExtentChangePostMapLoad;
            objStandardMap.StandardMapState.MapControllerState.ClientStoredInitialExtentBookmark = objMap.MapExtent;
            objStandardMap.StandardMapState.MapControllerState.ClientStoredVisibleLayerIDsByMapServiceDisplayID = objMap.VisibleLayerIDsByMapServiceDisplayID;
            objStandardMap.StandardMapState.MapControllerState.ClientStoredVisibleMapServiceDisplayIDs = objMap.VisibleMapServiceDisplayIDs;
            objStandardMap.StandardMapState.MapControllerState.ClientStoredSelectionState = objMap.SelectionState;
        });
    }

}


var TrimbleMap = TrimbleMap || {};

TrimbleMap.Symbols = {};

TrimbleMap.Symbols.SelectedFilledPolygon = function SelectedFilledPolygon() {
    var objSymbol = new esri.symbol.SimpleFillSymbol(esri.symbol.SimpleFillSymbol.STYLE_SOLID,
        new esri.symbol.SimpleLineSymbol(esri.symbol.SimpleLineSymbol.STYLE_SOLID, new dojo.Color([255, 0, 0, 1]), 2),
        new dojo.Color([255, 0, 0, 0.2]));

    return objSymbol;
}


// Create the TrimbleMap namespace object (if it does not exist already) ...
var TrimbleMap = TrimbleMap || {};

// Create the name space ...
TrimbleMap.TranslationHandler = {};
TrimbleMap.TranslationHandler.Shared = {};

// **************************************************************************
// Constructor
// **************************************************************************
TrimbleMap.TranslationHandler.CreateInstance = function CreateInstance() {

    // Create the instance ...
    var objTranslationHandler = {
        GetTranslationProxy: function (strJSFilename, strInterfaceResource) { return objTranslationHandler.GetTranslation(strJSFilename, strInterfaceResource); },
        GetTranslation: TrimbleMap.TranslationHandler.GetTranslation
    };

    return objTranslationHandler;
}

// **************************************************************************
// FUNCTION GetTranslation
//
// ********************* Non of these translation is used in Landfolio and is designed for use in the Portal or any third party applications **********************
//
// **************************************************************************
TrimbleMap.TranslationHandler.GetTranslation = function GetTranslation(strJSFilename, strInterfaceResource) {

    switch (strJSFilename) {
        case 'CoordinateListEditor.js':
            switch (strInterfaceResource) {
                case 'DD': return 'DD';
                case 'DMS': return 'DMS';
                case 'East': return 'East (x)';
                case 'EastAbbreviation': return 'E';
                case 'EastWestDirection': return 'East / West Direction';
                case 'InvalidCoordinate': return 'Invalid Coordinate';
                case 'Latitude': return 'Latitude';
                case 'LatitudeDegrees': return 'Latitude Degrees';
                case 'LatitudeMinutes': return 'Latitude Minutes';
                case 'LatitudeSeconds': return 'Latitude Seconds';
                case 'Longitude': return 'Longitude';
                case 'LongitudeDegrees': return 'Longitude Degrees';
                case 'LongitudeMinutes': return 'Longitude Minutes';
                case 'LongitudeSeconds': return 'Longitude Seconds';
                case 'MaximumDecimalPlaces': return '%1 can only have %2 decimal places';
                case 'MustBeBetween': return '%1 must be between %2 and %3';
                case 'MustBePositiveNumber': return '%1 must be a positive number';
                case 'MustBeWholeNumber': return '%1 must be a whole number';
                case 'North': return 'North (y)';
                case 'NorthAbbreviation': return 'N';
                case 'NotSpecified': return '%1 not specified';
                case 'NotValidNumber': return '%1 is not a valid number';
                case 'SouthAbbreviation': return 'S';
                case 'WestAbbreviation': return 'W';
                case 'ADD': return 'ADD';
            }
            break;

        case 'ShapeCoordinateList.js':
            switch (strInterfaceResource) {
                case 'Latitude': return 'Latitude';
                case 'Longitude': return 'Longitude';
                case 'X': return 'East (x)';
                case 'Y': return 'North (y)';
                case 'LatitudeText': return 'Latitude';
                case 'LongitudeText': return 'Longitude';
            }
            break;

        case 'Map.Bookmarks.js':
            switch (strInterfaceResource) {
                case 'ButtonTextOK': return 'OK';
                case 'Cancel': return 'CANCEL';
                case 'CannotDeleteBookmark': return 'Cannot delete bookmark';
                case 'CannotDeleteBookmarkMessage': return 'This bookmark is currently set to be used as the initial extent for this map. You need to first set another initial extent in your preferences.';
                case 'CannotDeleteBookmarkTitle': return 'Cannot delete bookmark';
                case 'ChangeInitialExtent': return 'Change initial extent';
                case 'DefaultOfMap': return 'Default of map';
                case 'InitialExtentBookmark': return 'Initial extent (bookmark)';
                case 'MenuItemName': return 'Bookmarks';
                case 'NotValidInCoordinateSystemMessage': return 'The selected bookmark is not valid in';
                case 'NotValidInCoordinateSystemTitle': return 'Not valid in the coordinate system of the map';
                case 'SaveCurrentView': return 'Save current view as';
            }
            break;

        case 'Map.Callout.js':
            switch (strInterfaceResource) {
                case 'MultipleResults': return 'Multiple Results';
                case 'NoResults': return 'No Results';
                case 'UnableToHighlightShape': return 'Unable to highlight the  shape';
                case 'UnableToHighlightShapeDiagnosticMessage': return 'The record has no shape. This is most likely because the map layer does not expose the shape field, ensure that the shape field is included in the list of fields returned by the map layer';
                case 'UnableToHighlightShapeEndUserMessage': return 'Unable to highlight the shape. The record has no shape.';
            }
            break;

        case 'Map.Configuration.js':
            switch (strInterfaceResource) {
                case 'CannotAddMapServiceMessage': return 'The coordinate system of the map service do not match the <br />coordinate system of the map services already in the map';
                case 'CannotAddMapServiceTitle': return 'Cannot add map service';
                case 'InvalidMapExtent': return 'The extent coordinates specified on the Map Service are invalid, if you believe them to be correct, contact system administrator.';
                case 'UnableToReproject': return 'The configured geotransformation between the two selected coordinate systems is not supported by this functionality';
            }
            break;

        case 'Map.CoordinateDisplay.js':
            switch (strInterfaceResource) {
                case 'CoordinateSystemDisplay': return 'Coordinates are displayed using the %1 coordinate system';
                case 'OutOfBounds': return 'Unable to project coordinates to the configured coordinate system';
            }
            break;

        case 'Map.ConstructShapeFromCentroid.js':
            switch (strInterfaceResource) {
                case 'ConstructShapeFromCentroidTitle': return 'Construct a Shape from a Reference Point';
                case 'ConstructShapeFromCentroidInstructions': return 'This tool allows you to construct a shape using a Reference Point as the centre of the shape. Select the Reference Point and Shape Type below.';
                case 'ReferencePoint': return 'Reference Point';
                case 'ShapeType': return 'Shape Type';
                case 'Circle': return 'Circle';
                case 'Square': return 'Square';
                case 'Radius': return 'Radius';
                case 'LengthOfSide': return 'Length of side';
                case 'Unit': return 'unit';
                case 'Ok': return 'OK';
                case 'Cancel': return 'CANCEL';
                case 'ParameterNotSpecified': return '%1 not specified';
                case 'InvalidParameter': return 'Invalid %1 specified';
                case 'ErrorBufferingShape': return 'Error buffering shape';
                case 'ErrorDensifyingShape': return 'Error densifying shape';
            }
            break;

        case 'Map.Controller.js':
            switch (strInterfaceResource) {
                case 'AutomaticReprojectionFailedEndUserMessage': return 'Reprojection failed';
                case 'AutomaticReprojectionFailedMessage': return 'Geometry Json:<br>%1<br><br>From Spatial Reference:<br>%2<br><br>To Spatial Reference:<br>%3';
                case 'AutomaticReprojectionFailedTitle': return 'Reprojection (with automatic geotransformation) failed';
                case 'BookmarkReprojectionFailedEndUserMessage': return 'Unable to zoom to bookmark';
                case 'BookmarkReprojectionFailedMessage': return 'Attempting to reproject the bookmark extent to the extent of the map failed';
                case 'BookmarkReprojectionFailedTitle': return 'Reprojection of bookmark extent failed';
                case 'CoordinateSystemMismatchEndUserMessage': return 'Unable to load map. The coordinate systems of the map services in this map are not all the same';
                case 'CoordinateSystemMismatchMessage': return 'Not all of the map services in the map have the same coordinate system. Spatial references detected in map: %1';
                case 'CoordinateSystemMismatchTitle': return 'Mismatching coordinate systems';
                case 'CountOnMapServiceFailedEndUserMessage': return 'Unable to retrieve the number of records from map  %1 map layer %2. The number of results for this layer will be reflected incorrectly.';
                case 'CountOnMapServiceFailedMessage': return 'Query to get the count on map service %1 map layer %2 failed. ';
                case 'CountOnMapServiceFailedTitle': return 'Query to get the count on map service failed';
                case 'FailedReprojectionEndUserMessage': return 'Problem reprojecting the geometry. Coordinate measures out of bounds (Result returned as not a number)';
                case 'FailedReprojectionMessage': return 'Measures out of bounds (Result returned as NaN)';
                case 'FailedReprojectionTitle': return 'Reprojection failed';
                case 'FeatureServiceFailedEndUserMessages': return 'Unable to load map service %1. The data for this map service will not be displayed in the map and any interaction with this map service will not return any results.';
                case 'FeatureServiceFailedMessage': return 'Query to retrieve information from feature service %1 failed. The layer might not show in the map and search, identify and selection will not return any results.';
                case 'FeatureServiceFailedTitle': return 'Query to retrieve information from feature service failed';
                case 'LayerNotConfiguredMessage': return 'Layer with id %1 on Map service %2 has not been configured in FlexiCadastre. ';
                case 'LayerNotConfiguredTitle': return 'Layer not configured';
                case 'LayerWithId': return 'layer with id %1';
                case 'MapLayerInformationNotFoundEndUserMessage': return 'Unable to retrieve the information for map layer %1 on map service %2.';
                case 'MapLayerInformationNotFoundMessage': return 'Attempting to retrieve the information for map layer %1 on map service %2 failed.';
                case 'MapLayerInformationNotFoundTitle': return 'Unable to retrieve information from map layer';
                case 'MapServiceGeomteriesNotFoundEndUserMessage': return 'Unable to retrieve the spatial data from map service %1.';
                case 'MapServiceGeomteriesNotFoundMessage': return 'Attempting to get geometries from map service %1 failed. ';
                case 'MapServiceGeomteriesNotFoundTitle': return 'Unable to get geometries from map service';
                case 'MapServiceQueryFailedEndUserMessage': return 'Unable to retrieve data from map service %1 map layer %2. The results for the layer will not be displayed.';
                case 'MapServiceQueryFailedMessage': return 'Query on map service %1 map layer %2 failed. ';
                case 'MapServiceQueryFailedTitle': return 'Query on map service failed';
                case 'MaxMapServiceRecordCountNotFoundEndUserMessage': return 'Unable to get max record count for map service %1. The total number of records might be displayed incorrectly.';
                case 'MaxMapServiceRecordCountNotFoundMessage': return 'Unable to get max record count for map service %1.';
                case 'MaxMapServiceRecordCountNotFoundTitle': return 'Unable to get max record count for map service';
                case 'NoMapsToDisplayEndUserMessage': return 'No authorized maps available for display. The map will not be displayed';
                case 'NoMapsToDisplayMessage': return 'No authorized maps available for display. Ensure that there are maps configured and that the current user has authorization to view at least one map';
                case 'NoMapsToDisplayTitle': return 'No maps to display';
                case 'ProjectGeometriesFailedEndUserMessages': return 'Reprojection from coordinate system \'%1\'<br> to coordinate system \'%2\'<br> failed';
                case 'ProjectGeometriesFailedMessages': return 'From Spatial Reference Name: \'%1\'<br>To Spatial Reference Name: \'%2\'<br>Geotransformation name: \'%3\'<br><br>Geotransformation wkt:<br>%4<br><br>From Spatial Reference Json:<br>%5<br><br>To Spatial Reference Json:<br>%6<br><br>Geometries:<br>%7<br>';
                case 'ProjectGeometriesFailedTitle': return 'Reprojection failed';
                case 'ReprojectionFailedEndUserMessage': return 'Problem reprojecting the geometry.';
                case 'ReprojectionFailedMessage': return 'Unable to project geometry from \'%1 \' to \'%2 \' because there are no geotransformation defined between \'%3\' and \'%4\'';
                case 'ReprojectionFailedTitle': return 'Reprojection failed';
                case 'ReprojectionMeasuresOutOfBoundsEndUserMessage': return 'Problem reprojecting the geometry. Coordinate measures out of bounds (Result returned as not a number)';
                case 'ReprojectionMeasuresOutOfBoundsMessage': return 'Measures out of bounds (Result returned as NaN)';
                case 'ReprojectionMeasuresOutOfBoundsTitle': return 'Reprojection failed';
                case 'UnableToCreateSelectionFeatureLayerEndUserMessage': return 'Unable to initialize the selection functionality for map service %1 map layer %2. You will not be able to select features from this layer.';
                case 'UnableToCreateSelectionFeatureLayerMessage': return 'Unable to create selection feature layer for map service %1 map layer %2.';
                case 'UnableToCreateSelectionFeatureLayerTitle': return 'Unable to create selection feature layer';
                case 'UnableToLoadLegendDataEndUserMessage': return 'Unable to load legend data';
                case 'UnableToLoadLegendDataError': return 'Error:';
                case 'UnableToLoadLegendDataMessage': return 'Unable to load legend data for map service %1.';
                case 'UnableToLoadLegendDataTitle': return 'Unable to load legend data';
                case 'UnableToLoadMapServiceEndUserMessage': return 'Unable to load map service %1. The data for this map service will not be displayed in the map and any interaction with this map service will not return any results.';
                case 'UnableToLoadWebFeatureServiceEndUserMessage': return 'Unable to load companion web feature service of %1 map service. The data for this map service will be displayed in the map but any interaction with this map service will not return any results.';
                case 'UnableToLoadMapServiceMessage': return 'Unable to load map service %1. The layer might not show in the map and search, identify and selection will not return any results.';
                case 'UnableToLoadWebFeatureServiceMessage': return 'Unable to load the companion web feature service of %1 map service. The map service will show in the map but search, identify and selection will not return any results.';
                case 'UnableToLoadMapServiceTitle': return 'Unable to load map service';
                case 'UnableToQueryMapServiceLayerEndUserMessage': return 'Unable to query a layer on map service %1 because no configuration were found for a layer with the layer\'s name. No results will be included for the layer.';
                case 'UnableToQueryMapServiceLayerMessage': return 'Unable to query layer with id %1 on map service %2 because no configuration were found for a layer with the layer\'s name. ';
                case 'UnableToQueryMapServiceLayerTitle': return 'Unable to query layer';
                case 'UnexpectedFieldsReturnedEndUserMessage': return 'Unable to display data from map service %1 map layer %2. The results for this layer will not be displayed.';
                case 'UnexpectedFieldsReturnedMessage': return 'Querying map service %1 map layer %2 did not return the following expected fields: %3 ';
                case 'UnexpectedFieldsReturnedTitle': return 'Query returned unexpected fields';
                case 'MapServiceTokenExpiredEndUserMessage': return 'The authentication token associated with map service \'%1\' has expired. Map layers from this service cannot be displayed or searched at this time.';
                case 'MapServiceTokenExpiredMessage': return 'The authentication token associated with map service \'%1\' has expired. Map layers from this service cannot be displayed or searched at this time.';
                case 'MapServiceTokenExpiredTitle': return 'Map service token expired';
                case 'FailedToGetMapServiceLayerIDTitle': return 'Query to get the map service layer ID failed';
                case 'FailedToGetMapServiceLayerIDMessage': return 'Query to get the layer ID on map service %1 map layer %2 failed.';
                case 'FailedToGetMapServiceLayerIDEndUserMessage': return 'Unable to retrieve the layer ID from map service %1 map layer %2. The results for the layer will not be displayed.';
            }
            break;

        case 'Map.Diagnostics.js':
            switch (strInterfaceResource) {
                case 'DiagnosticMessageOk': return 'OK';
                case 'DiagnosticMessagesTitle': return 'Diagnostic Messages';
                case 'DiagnosticMessageTitle': return 'Diagnostic Message';
                case 'NoMessagesToDisplay': return 'No messages to display';
                case 'RecreateRequest': return 'Recreate Request ';
            }
            break;

        case 'Map.DisplayArea.js':
            switch (strInterfaceResource) {
                case 'AreaLabel': return 'Area';
                case 'CalculatedIn': return 'Calculated in';
                case 'CalculationMightBeInaccurate': return 'The calculation might be inaccurate due to the fact that the shape spans multiple UTM Zones';
            }
            break;

        case 'Map.DisplayDistance.js':
            switch (strInterfaceResource) {
                case 'CalculatedIn': return 'Calculated in';
                case 'CalculationMightBeInaccurate': return 'The calculation might be inaccurate due to the fact that the shape spans multiple UTM Zones';
                case 'DistanceLabel': return 'Distance';
            }
            break;

        case 'Map.DynamicShapeOptions.js':
            switch (strInterfaceResource) {
                case 'AgreementSearchToFilterByNotSet': return 'Agreement search to filter by not set';
                case 'Buffer': return 'Buffer';
                case 'BufferDistanceNotSpecified': return 'Buffer distance not specified';
                case 'BufferDistanceUnitNotSpecified': return 'Buffer distance unit not specified';
                case 'BufferingCannotBeEnabledWithSumOfComponentShapeOfficialAreas': return 'Buffering cannot be enabled when "Sum of component shape official areas" is selected for official area';
                case 'By': return 'by';
                case 'Cancel': return 'CANCEL';
                case 'ConstructShapeFrom': return 'Construct shape from';
                case 'DerivedShapeOptionsTitle': return 'Derived shape options';
                case 'FilterBy': return 'filter by';
                case 'GroupSearchToFilterByNotSet': return 'Group search to filter by not set';
                case 'InvalidBufferDistance': return 'Invalid buffer distance';
                case 'LicenseSearchToFilterByNotSet': return 'License search to filter by not set';
                case 'OfficialArea': return 'Official area';
                case 'OfficialAreaOptionNotSpecified': return 'Official area option not specified';
                case 'Ok': return 'OK';
                case 'OnlyPolygonShapesMessage': return 'Only shapes of type polygon will be merged when calculating the dynamic shape';
                case 'BufferOption': return 'Buffer Option';
                case 'NoBuffer': return 'No Buffer';
                case 'BufferNotSupported': return 'Not supported as this shape is not a Polygon';
                case 'NoBufferNotSupported': return 'Not supported as the parent object geometry type (%1) does not match this shape\'s geometry type (%2)';
                case 'NoBufferSameGeometryTypes': return 'Only shapes with the same geometry type will be used';
                case 'BufferOptionNotSpecified': return 'Buffer option not specified';
                case 'GeometryTypeNotSpecified': return 'Geometry type not specified';
                case 'InvalidBufferOptionSelected': return 'Invalid buffer option selected';
                case 'OnlyBufferShapesMessage': return 'Only buffer shapes with geometry type';
                case 'BufferDistance': return 'Buffer distance';
            }
            break;

        case 'Map.FixInvalidShapes.js':
            switch (strInterfaceResource) {
                case 'GeometryErrorTitle': return 'Geometry Errors';
                case 'NoInvalidShapes': return 'No invalid shapes';
            }
            break;

        case 'Map.Legend.js':
            switch (strInterfaceResource) {
                case 'ProblemsLoadingMapService': return 'Problems loading map service. The data might not be displayed in the map and any interaction with the map might not return any results for this map service';
                case 'ProblemsLoadingWebMapServiceDependencies': return 'Problems loading companion web feature service. The data will displayed in the map but any interaction with the map will not return any results for this map service';
                case 'MapServiceDescription': return 'Map Service Description';
                case 'MapLayerDescription': return 'Map Layer Description';
            }
            break;

        case 'Map.MapSelector.js':
            switch (strInterfaceResource) {
                case 'MenuItemName': return 'Maps';
            }
            break;

        case 'Map.Measure.js':
            switch (strInterfaceResource) {
                case 'AreaToolInstruction': return 'Click on the map and draw a polygon. Double-click to complete the polygon.';
                case 'ClearResults': return 'Clear Results';
                case 'DistanceToolInstruction': return 'Click on the map and draw a line. Double-click to end the line.';
                case 'MeasureArea': return 'Measure Area';
                case 'MeasureDistance': return 'Measure Distance';
                case 'MeasureTabName': return 'MEASURE';
                case 'NoAreaUnitsMessage': return 'The system has no area units specified';
                case 'NoAreaUnitsTitle': return 'No Area Units ';
                case 'MeasureToolsLabel': return 'Tools'; break;
                case 'NoDistanceUnitsEndUserMessage': return 'The system has no distance units specified';
                case 'TabInstructions': return 'Use the distance and area tools below to measure features on the map.';
                case 'ToolResult': return 'Result';
                case "LengthLabel": return "Length";
                case "MeasureLength": return "Measure Length";
                case "strCoordinateSystemHelpLine1": return "Selecting a different Coordinate System will affect the calculation result.";
                case "strCoordinateSystemHelpLine2": return "Results may vary due to distortion caused by the different projection parameters.";
            }
            break;

        case 'Map.Preferences.js':
            switch (strInterfaceResource) {
                case 'ApplyToAllMaps': return 'Apply to all maps';
                case 'Cancel': return 'CANCEL';
                case 'ChangeInitialExtent': return 'Change';
                case 'DefaultOfMap': return 'Default of map';
                case 'InitialExtentBookmark': return 'Initial extent';
                case 'InitialExtentOfMap': return 'Initial extent of map';
                case 'KeepPreviousSearchAndSelectResults': return 'Keep previous search and select results while signed in';
                case 'MenuItemName': return 'Preferences';
                case 'OK': return 'OK';
                case 'SelectBookmarkForIntialExtent': return 'Select the bookmark to be used as the initial extent for this map';
                case 'SimultaneouslySelectAllParts': return 'Simultaneously select all parts of a multi-part shape';
                case 'TheIntialExtentIs': return 'The intial extent is';
            }
            break;

        case 'Map.Print.js':
            switch (strInterfaceResource) {
                case 'CurrentExtent': return 'Current Extent';
                case 'CurrentScale': return 'Current Scale';
                case 'Export': return 'EXPORT';
                case 'ExportForPrintingTitle': return 'Export for Printing';
                case 'Format': return 'Format';
                case 'InvalidScaleMessage': return 'Please enter a valid scale, only<br /> whole numbers are allowed';
                case 'InvalidScaleTitle': return 'Invalid Scale';
                case 'MapExportFailedEndUserMessage': return 'Unable to export the map. A problem occurred with the print service';
                case 'MapExportFailedMessage': return 'Call to the print service failed';
                case 'MapExportFailedTitle': return 'Unable to export map';
                case 'MenuItemName': return 'Print...';
                case 'NoScaleMessage': return 'Please enter a valid scale, only<br /> whole numbers are allowed';
                case 'NoScaleTitle': return 'No Scale';
                case 'PrintOutput': return 'Print Output';
                case 'Scale': return 'Scale';
                case 'ScaleTooLargeMessage': return 'The scale value that you entered is too large<br />(The maximum allowed is 1: %1)';
                case 'ScaleTooLargeTitle': return 'Invalid Scale';
                case 'ScaleTooSmallMessage': return 'The scale value that you entered is too small<br />(The minimum allowed is 1: %1)';
                case 'ScaleTooSmallTitle': return 'Invalid Scale ';
                case 'SpecificScale': return 'Specific Scale';
                case 'Template': return 'Template';
                case 'TemplatesRetrievalFailedEndUserMessage': return 'Unable to retrieve information about the available templates';
                case 'TemplatesRetrievalFailedMessage': return 'Unable to retrieve information about the available templates';
                case 'TemplatesRetrievalFailedTitle': return 'Unable retrieve template list';
                case 'TemplatesRetrievalUrlFailedEndUserMessage': return 'Unable to retrieve information about the available templates';
                case 'TemplatesRetrievalUrlFailedMessage': return 'Print service url is not configured';
                case 'TemplatesRetrievalUrlFailedTitle': return 'Unable retrieve template list, the print service url is not configured';
                case 'UnableToRetrieveTemplatesEndUserMessage': return 'Unable to retrieve information about the available templates';
                case 'UnableToRetrieveTemplatesMessage': return 'Unable to parse the json reponse from the print service';
                case 'UnableToRetrieveTemplatesTitle': return 'Unable retrieve template list';
                case 'Resolution': return 'Resolution';
                case 'Standard': return 'Standard';
                case 'High': return 'High';
                case 'VeryHigh': return 'Very High';
                case 'DPI': return 'dpi';
            }
            break;

        case 'Map.QueryResultsDisplay.js':
            switch (strInterfaceResource) {
                case 'ItemNotInMapMessage': return 'Item not found in the map';
                case 'ItemNotInMapTitle': return 'Item not in map';
                case 'NoResultsFound': return '0 Results Found';
                case 'SaveCurrentView': return 'Save current view as';
                case 'MapServiceLayerResultsNotUniqueTitle': return 'Multiple features with the same Id';
                case 'MapServiceLayerResultsNotUniqueMessage': return 'Multiple features with the same Id %1 were found in map service %2 map layer %3.';
                case 'MapServiceLayerResultsNotUniqueEndUserMessage': return 'Multiple features with the same Id %1 were found in map service %2 map layer %3. Search and Select functions cannot display results correctly for the layer. Please ensure the Id field contains unique values only.';
            }
            break;

        case 'Map.Search.js':
            switch (strInterfaceResource) {
                case 'AddToSelection': return 'Add to selection ';
            }
            break;

        case 'Map.Selection.js':
            switch (strInterfaceResource) {
                case 'AddFeatures': return 'Add features to selection';
                case 'ApplyBuffer': return 'Apply buffer';
                case 'Buffer': return 'Buffer';
                case 'BufferSelectedShape': return 'Apply a buffer to the selected shapes';
                case 'Cancel': return 'CANCEL';
                case 'ClearSelectionToolTip': return 'Clear selection';
                case 'FilterCurrentSelection': return 'Select from current selection';
                case 'InvalidBufferDistance': return 'Invalid buffer distance. The buffer distance is not a valid ';
                case 'LayersContainingSelectedShape': return 'Choose the layers containing the selected shapes to use as the location';
                case 'LayersToSelectFrom': return 'Choose the layers from which you would like to select';
                case 'NoBufferDistanceUnitSelected': return 'No buffer distance unit selected';
                case 'OfLayers': return 'of %1 layers ';
                case 'OverlapWithSelectedShapeMessage': return 'I want to apply a buffer to the selected shapes';
                case 'OverlapWithSelectedShapeTitle': return 'that overlap with selected shapes in';
                case 'RemoveFeatures': return 'Remove features from selection';
                case 'RemoveFromSelection': return 'Remove from selection';
                case 'Select': return 'Select';
                case 'SelectByLocation': return 'Select by location';
                case 'SelectByPointToolTip': return 'Select using a point';
                case 'SelectByPolygonToolTip': return 'Select using a polygon';
                case 'SelectByPolylineToolTip': return 'Select using a polyline';
                case 'SelectFeatures': return 'Select Features';
                case 'SelectionByLocationDescription': return 'Select features that overlap with the currently selected features in the following layers';
                case 'SelectionDescription': return 'Use the Point or Polygon tool for selecting map objects, you can specify the method and layers to use for the selection operation';
                case 'SelectionSelect': return 'SELECT';
                case 'SelectShapesFrom': return 'I want to select shapes from';
                case 'UnableToPerformSelectionMessage': return 'Draw a polygon with at least 3 coordinates.';
                case 'UnableToPerformSelectionTitle': return 'Unable to perform selection';
                case "UnableToAddSelection": return "Unable to add the selection to the shape";
                case "GeometryTypeMismatch": return "The geometry type of the selection does not match the geometry type of the shape";
                case 'AddToShape': return 'Add to shape';
                case 'RemoveFromShape': return 'Remove from shape';
            }
            break;

        case 'Map.Shape.js':
            switch (strInterfaceResource) {
                case 'AddNewPart': return 'Add new part';
                case 'ClickIconToAddParts': return 'Click the add parts icon or use the tools above to define the shape.';
                case 'ConvertPolygonToBlocks': return 'Convert Polygon To Blocks';
                case 'CoordinateSystem': return 'Coordinate System:';
                case 'DrawToAddToolTip': return 'Draw to add';
                case 'DrawToRemoveToolTip': return 'Draw to remove';
                case 'GridSplitterTool': return 'Grid Splitter Tool';
                case 'ImportFromObject': return 'Import from Shape on existing object';
                case 'ImportFromShapeFile': return 'Import from Shape file';
                case 'ModeButtonName': return 'Shape';
                case 'Reproject': return 'Reproject Coordinates to selected System';
                case 'ShapePartsNone': return 'This shape has no parts yet.';
                case 'ShapePartsSubHeader': return 'Parts:';
                case 'TabName': return 'SHAPE';
                case 'UnableToCalculateArea': return 'Unable to calculate area';
                case 'UnableToCalculateDistance': return 'Unable to calculate distance';
                case 'UnableToProjectTheCoordinatesCannotCalculateArea': return 'Unable to project the coordinates to %1 and hence the area cannot be calculated.';
                case 'UnableToProjectTheCoordinatesCannotCalculateDistance': return 'Unable to project the coordinates to %1 and hence the distance cannot be calculated.';
                case 'UnableToTestOverlapsEndUserMessage': return 'Unable to connect to the Spatial Dataset used for exclusions from the Area Calculation';
                case 'UnableToTestOverlapsMessage': return 'The query to find overlapping area exclusion polygons failed';
                case 'UnableToTestOverlapsTitle': return 'Unable to test for overlaps with the area exclusion polygons';
                case 'NoShapeSystemMessage': return 'This tool requires a shape with coordinates';
                case 'NoShapeSystemTitle': return 'No Shape';
            }
            break;

        case 'Map.ShapeEditor.js':
            switch (strInterfaceResource) {
                case 'AddExclusion': return 'Add Exclusion';
                case 'AddNewPartText': return 'Click the add part option or use the tools above to define the shape';
                case 'AddNewPoint': return 'Add new point';
                case 'AddNewPointText': return 'Click the add new point option to add a point';
                case 'AddReferencePointIcon': return 'Click the add reference points icon to add a reference point';
                case 'AddReferencePoints': return 'Add Reference Point';
                case 'Area': return 'Area';
                case 'BlockSelectionByPointToolDisabled': return 'The "Block selection by point" tool is disabled';
                case 'BlockSelectionByPointToolDisabledDueToLargeShape': return 'The "Block selection by point" tool is disabled due to the large number of coordinates on the shape';
                case 'BlockSelectionByPolygonToolDisabled': return 'The "Block selection by point" tool is disabled';
                case 'BlockSelectionByPolygonToolDisabledDueToLargeShape': return 'The "Block selection by polygon" tool is disabled due to the large number of coordinates on the shape';
                case 'BlockSelectionChangeCoordinateSystem': return 'Change the coordinate system to %1 in order to use the tool';
                case 'BlockSelectionNotInGridCoordinateSystem': return 'The coordinate system of the shape differs from the coordinate system of the grid.';
                case 'CalculatedArea': return 'Calculated Area';
                case 'CalculatedAreaNotShown': return 'The calculated area is not shown.';
                case 'CalculatedLength': return 'Calculated Length';
                case 'CalculatedLengthNotShown': return 'The calculated length is not shown.';
                case 'CalculatingArea': return 'Calculating Area';
                case 'CalculatingLength': return 'Calculating Length';
                case 'Cancel': return 'CANCEL';
                case 'CannotAddPartMessage': return 'You cannot add a new part when the coordinate system is not set. <br />You need to first set the coordinate system and then add the part.';
                case 'CannotAddPartTitle': return 'Cannot add part without coordinate system';
                case 'CannotAddPointMessage': return 'You cannot add a new point when the coordinate system is not set. <br />You need to first set the coordinate system and then add the point.';
                case 'CannotAddPointTitle': return 'Cannot add point without coordinate system';
                case 'CannotAddReferencePointMessage': return 'You cannot add a new reference point when the coordinate system is not set. <br />You need to first set the coordinate system and then add the reference point.';
                case 'CannotAddReferencePointTitle': return 'Cannot add reference point without coordinate system';
                case 'CannotChangeMode': return 'Cannot change mode';
                case 'CannotChangeModePartMessage': return 'You cannot change the mode while editing a part.';
                case 'CannotChangeModePointMessage': return 'You cannot change the mode while editing a reference point.';
                case 'CannotEditShapeByDraggingPointsInMap': return 'You are not able to edit parts with large number of coordinates by dragging the points in the map. However you are still able to edit the coordinates manually.';
                case 'ChangeCoordinateSystemPartMessage': return 'You cannot change the coordinate system to none while <br />you have parts with coordinates or reference points';
                case 'ChangeCoordinateSystemPointMessage': return 'You cannot change the coordinate system to none while you have points';
                case 'ChangeCoordinateSystemTitle': return 'Changing the coordinate system';
                case 'ChangeWithoutTransformation': return 'Change without transformation';
                case 'ChangingCoordinateSystemMessage': return 'Operation to be performed on coordinates';
                case 'ChangingCoordinateSystemTitle': return 'Changing the coordinate system';
                case 'ClickOnMapToAddPoint': return 'Click on a map to add a point.';
                case 'ClickOnMapToAddPolygon': return 'Double click on a map to add a polygon shape.';
                case 'ClickOnMapToAddPolyline': return 'Double click on a map to add a polyline.';
                case 'ClickToSelectBlock': return 'Click to select block';
                case 'CompleteLastCoordinate': return 'Complete the last coordinate.';
                case 'CompleteReferencePoint': return 'Complete the reference point.';
                case 'CoordinateInvalid': return 'The coordinate is invalid.';
                case 'CoordinatesInvalid': return 'The coordinates are invalid.';
                case 'CoordinatesOfPartIsSelfIntersecting': return 'The coordinates of the part is self intersecting.';
                case 'CoordinatesOfPartIsSelfIntersecting.': return 'The coordinates of the part is self intersecting.';
                case 'CoordinatesOfPartOverlappingWithOtherParts': return 'The coordinates of the part is overlapping with the other parts of the shape.';
                case 'CopyCalculatedArea': return 'Copy Calculated Area';
                case 'CopyCalculatedLength': return 'Copy Calculated Length';
                case 'CurrentLocationOutsideGrid.': return 'The current location is outside of the grid.';
                case 'DecimalDeg': return 'Decimal Deg';
                case 'DefinedDerivedShape': return 'Define derived shape options';
                case 'DegMinSec': return 'Deg Min Sec';
                case 'DeleteExclusion': return 'Delete exclusion';
                case 'DeletePart': return 'Delete part';
                case 'DerivedShape': return 'Derived Shape';
                case 'DisabledDMSAndDD': return 'Only available in Geographic coordinate systems';
                case 'DoubleClickToFinish': return 'Double-click when finished.';
                case 'DrawPoint': return 'Draw point';
                case 'DrawPolygon': return 'Draw polygon';
                case 'DrawPolygonDisabled': return 'The "Draw Polygon" tool is disabled';
                case 'DrawPolygonToolDisabledDueToLargeShape': return 'The "Draw Polygon" tool is disabled due to the large number of coordinates on the shape';
                case 'DrawPolygonToSelectBlocks': return 'Draw polygon to select blocks';
                case 'DrawPolyline': return 'Draw polyline';
                case 'DrawToAdd': return 'Draw to Add';
                case 'EnterCoordinatesInstructions': return 'Use the coordinate list below to enter or modify shape'; break;
                case 'DrawToAddAndRemoveToolDisabledDueToLargeShape': return 'The "Draw to Add" and "Draw to Remove" tools are disabled.';
                case 'DrawToAddMode': return 'Draw to Add';
                case 'DrawToAddToolDisabled': return 'The "Draw to Add" tool is disabled';
                case 'DrawToAddToolDisabledDueToLargeShape': return 'The "Draw to Add" tool is disabled due to the large number of coordinates on the shape';
                case 'DrawToRemove': return 'Draw to Remove';
                case 'DrawToRemoveMode': return 'Draw to Remove';
                case 'DrawToRemoveToolDisabled': return 'The "Draw to Remove" tool is disabled';
                case 'DrawToRemoveToolDisabledDueToLargeShape': return 'The "Draw to Remove" tool is disabled due to the large number of coordinates on the shape';
                case 'EditingPart': return 'Editing Part';
                case 'EditingPoint': return 'Editing Point';
                case 'EditingReferencePoint': return 'Editing Reference Point';
                case 'EnableAreaCalculation': return 'Enable Area Calculation';
                case 'EnableLengthCalculation': return 'Enable Length Calculation';
                case 'Exclusion': return 'Exclusion';
                case 'GridSplitterTimeoutTitle': return 'Grid Splitter Error';
                case 'GridSplitterTimeoutMessage': return 'The operation timed out. Please refine your criteria and try again.';
                case 'InteriorPartsOfPartNotInsidePart': return 'One or more interior parts of the part are not inside the part.';
                case 'InvalidCoordinatesTitle': return 'Invalid Coordinates';
                case 'LegalDescription': return 'Legal Description';
                case 'MapCoordinateHighlightingDisabled': return 'Map coordinate highlighting is disabled.';
                case 'MergeTouchingOrOverlappingParts': return 'Merge touching or overlapping parts';
                case 'MovedCoordinateSystemMessage': return 'You moved the coordinate to a location that is not valid in %1';
                case 'MovedCoordinateSystemTitle': return 'Not valid in selected coordinate system';
                case 'MoveToLocationInsideGrid': return 'Move to a location inside the grid to see the grid and use the tool.';
                case 'NoCoordinateTransformationOption': return 'Change the coordinate system without any coordinate transformation';
                case 'NoGeotransformationMessage': return 'Unable to project from \'%1\' to \'%2\' .<br />No geotransformation defined between \'%3\' and \'%4\'';
                case 'NoGeotransformationTitle': return 'No geotransformation';
                case 'NotValidInCoordinateSystemMessage': return 'The polygon you have drawn is not valid in %1';
                case 'NotValidInCoordinateSystemTitle': return 'Not valid in selected coordinate system';
                case 'OfficialArea': return 'Official Area';
                case 'OfficialLength': return 'Official Length';
                case 'Ok': return 'OK';
                case 'Part': return 'Part';
                case 'PartMustHaveAtLeast3Coordinates': return 'The part must have at least 3 coordinates.';
                case 'PartMustHaveName': return 'The part must have a name';
                case 'PartNameMustBeUnique': return 'The part name must be unique';
                case 'Point': return 'Point';
                case 'Points': return 'Points';
                case 'ReferencePoints': return 'Reference Points';
                case 'RenameExclusion': return 'Rename exclusion';
                case 'RenamePart': return 'Rename Part';
                case 'ReprojectCoordinates': return 'Reproject Coordinates';
                case 'SelectedCoordinateSystemNotValidMessage': return 'The coordinates cannot be reprojected. The coordinates are not valid in ';
                case 'SelectedCoordinateSystemNotValidTitle': return 'Not valid in selected coordinate system';
                case 'ShapeCoordinateCount': return 'This shape has %1 coordinates in total';
                case 'ShapeHasNoParts': return 'The shape has no parts';
                case 'ShapeHasNoPoints': return 'The shape has no points';
                case 'ShapeHasNoReferencePoints': return 'This shape has no reference points';
                case 'SomeFunctionalityDisabled': return 'Some functionality has been disabled due to the large number of coordinates';
                case 'TheShapeHasNoCoordinateSystemSet': return 'The shape has no coordinate system set';
                case 'TransformCoordinates': return 'Transform coordinates';
                case 'TransformCoordinatesOption': return 'Transform the coordinates to the selected coordinate system';
                case 'UnableToProjectShape': return 'Unable to project shape';
                case 'UnableToZoomToPartMessage': return 'Unable to zoom to the part. The coordinates of the part is not<br />valid in the coordinate system of the map';
                case 'UnableToZoomToPartTitle': return 'Not valid in the coordinate system of the map';
                case 'ViewDerivedShape': return 'View derived shape options';
                case 'ViewDerivedShapeEditMode': return 'Derived shapes can only be viewed when not in edit mode.<br />Configure the derived shape options and click save to view the shape';
                case 'ViewingCoordinatesOf': return 'Viewing Coordinates of';
                case 'ViewingPoint': return 'Viewing point';
                case 'ViewingReferencePoint': return 'Viewing Reference Point';
                case 'ZoomedOutTooFarToSeeGrid': return 'You are zoomed out too far to see the grid.';
                case 'ZoomedOutTooFarToSeeTheGrid': return 'You are zoomed out too far to see the grid.';
                case 'ZoomedOutTooFarToUseBlockSelectionTool': return 'You are zoomed out too far to use the block selection tool.';
                case 'ZoomInCloserToSeeGrid': return 'Zoom in closer to see the grid.';
                case 'ZoomInCloserToSeeTheGridAndActivateTool': return 'Zoom in closer to see the grid and activate the tool.';
                case 'ZoomToShape': return 'Zoom To Shape';
                case "OfficialMeasurementInvalid": return "Official %1 should be a valid number";
                case "Length": return "Length";
                case "OfficialMeasurementFractionsExceeded": return "The official %1 can only have a maximum of %2 digits after the decimal point";
                case "MaximumOfficialMeasurementExceeded": return "Maximum official %1 value exceeded";
                case "MaximumNormalisedMeasurementExceeded": return "Maximum normalised official %1 value exceeded";
                case "OfficialMeasurementMissingUnit": return "Official %1 is specified with no unit selected";
                case "OfficialMeasurementRequired": return "Official %1 and unit required";
                case "ChooseExistingShapeAdd": return "Add";
                case "ChooseExistingShapeRemove": return "Remove";
                case "ChooseExistingShapeMode": return "Mode";
                case "SelectShapesFrom": return "Select Shapes From";
                case "Tools": return "Tool";
                case "ClickOnShape": return "Click on Shape";
                case "DrawPolygon": return "Draw Polygon";
                case 'ZoomToPart': return 'Zoom to part';
                case 'ShapePart': return 'Shape Part';
                case 'RenameShapePart': return 'Rename shape part';
                case 'HasDerivedShape': return 'Has derived shape (click to change)';
                case 'NoDerivedShape': return 'No derived shape (click to change)';
            }
            break;

        case 'Map.ShapeEditorOptions.js':
            switch (strInterfaceResource) {
                case 'ChooseExistingShape': return 'Pick From Map';
                case 'AdvancedTools': return 'Advanced Tools';
                case 'DrawOnMap': return 'Draw On Map';
                case 'ImportCoordinates': return 'Import Coordinates';
                case 'ImportCoordinatesCSV': return 'Import from CSV';
                case 'ImportCoordinatesShapeFile': return 'Import from Shapefile';
                case 'ImportCoordinatesExcel': return 'Import from Excel';
                case 'ImportCoordinatesMapInfo': return 'Import from MapInfo';
                case 'ImportCoordinatesFileGeodatabase': return 'Import from File Geodatabase';
                case 'EditCoordinates': return 'Edit Coordinates';
            }
            break;

        case 'Map.ShapeImporter.js':
            switch (strInterfaceResource) {
                case 'CSVStep1Title':
                    return 'Import Coordinates from CSV File';
                case 'CSVAddedFileName':
                    return 'File';
                case 'CSVAddedFileSize':
                    return 'Size';
                case 'CSVImportButton':
                    return 'IMPORT';
                case 'CSVNextButton':
                    return 'NEXT';
                case 'CSVPreviousButton':
                    return 'PREVIOUS';
                case 'CSVCancelButton':
                    return 'CANCEL';
                case 'CSVTemplate':
                    return 'CSV Template';
                case 'CSVUploadInstructions':
                    return 'Select the CSV file (.csv) that you wish to import.<br/><br/>Click the download link below to view a template of various compatible CSV formats.';
                case 'CSVStep3Title':
                    return 'Import Options';
                case 'CSVSelectedAddReplaceShape':
                    return 'Select how the imported features should be integrated with the existing shape';
                case 'CSVAddShapeOption':
                    return 'Add to the existing shape';
                case 'CSVReplaceShapeOption':
                    return 'Replace the existing shape';
                case 'CSVSelectedCoordinateSystem':
                    return 'Select the input coordinate system';
                case 'CSVValidationErrorsTitle':
                    return 'Import Validation Errors';
                case 'CSVInvalidFile':
                    return 'Invalid File selected';
                case 'CSVNoFiles':
                    return 'No Files Added';
                case 'CSVRequiredFilesMissingTooltip':
                    return 'Add required files';
                case 'CSVValidationErrorsDescription':
                    return 'The selected file is not valid. The following problems were found:';
                case 'SFStep2Title':
                    return 'Select features to import';
                case 'SFStep1Title':
                    return 'Shape File Upload';
                case 'MIStep1Title':
                    return 'Map Info Upload';
                case 'SFCurrentSpatialReference':
                    return 'The Spatial Reference obtained from the input is: ';
                case 'SFSelectFeaturesInstructions':
                    return 'Select by examining attribute data below:';
                case 'SFAddedFileName':
                    return 'File';
                case 'SFAddedFileSize':
                    return 'Size';
                case 'SFImportButton':
                    return 'IMPORT';
                case 'SFNextButton':
                    return 'NEXT';
                case 'SFPreviousButton':
                    return 'PREVIOUS';
                case 'SFCancelButton':
                    return 'CANCEL';
                case 'SFTemplate':
                    return 'Shape File Template';
                case 'SFUploadInstructions':
                    return 'Select the Shape file that you wish to import (.zip). The zip file must contain the necessary files with extensions: .DBF, .SHP, .SHX and (optionally) .PRJ.';
                case 'MIUploadInstructions':
                    return 'Select the Map Info file that you wish to import (.zip). The zip file must contain the necessary files with extensions: .DAT, .ID , .MAP, .TAB and (optionally) .IND';
                case 'SFStep3Title':
                    return 'Import Options';
                case 'SFSelectedAddReplaceShape':
                    return 'How should the imported features be integrated?';
                case 'SFFilterRecordsLabel':
                    return 'Filter records';
                case 'SFAddShapeOption':
                    return 'Add to the existing shape';
                case 'SFReplaceShapeOption':
                    return 'Replace the existing shape';
                case 'SFSelectedCoordinateSystem':
                    return 'Select the input coordinate system';
                case 'SFValidationErrorsTitle':
                    return 'Validation Errors';
                case 'SFInvalidFile':
                    return 'Invalid file type selected';
                case 'SFNoFiles':
                    return 'No Files Added';
                case 'SFRequiredFilesMissingTooltip':
                    return 'Add required files';
                case 'SFValidationErrorsDescription':
                    return 'The following problems were found:';
                case 'SFClear':
                    return 'Clear';
                case 'SFSelectFeaturesValidator':
                    return 'Select at least one feature to import';
                case 'TcpfResultsDownloadFailed': 
                    return 'Unable to download results file from server';
                case 'TcpfWKTDownloadFailed': 
                    return 'Unable to download WKT file from server';
                case 'TcpfGetFileMetaDataFailed':
                    return 'Unable to get file metadata from server';
                case 'TcpfExecuteProcedureFailure':
                    return 'Unable to execute procedure';
                case 'TcpfProcedureResultFailure':
                    return 'Unable to get procedure result';
                case 'TcpfPrepareFileUploadFailure':
                    return 'Unable to prepare file upload';
                case 'TcpfUploadFileFailure':
                    return 'Unable to upload file';
                case 'GeometryTypeMismatch':
                    return 'Geometry type mismatch, expected geometry of type %1';
                case 'All':
                    return 'All';
            }
            break;

        case 'Map.StandardMap.js':
            switch (strInterfaceResource) {
                case 'Bookmarks': return 'Bookmarks';
                case 'ConfigurationIssue': return 'This might be due to a configuration issue on the server';
                case 'ContactSystemAdministrator': return 'Please contact the system administrator';
                case 'Diagnostics': return 'Diagnostics';
                case 'Identify': return 'Identify';
                case 'Legend': return 'Legend';
                case 'MapSelector': return 'Map selector';
                case 'Measure': return 'Measure';
                case 'MeasureTools': return 'Measure tools';
                case 'Ok': return 'OK';
                case 'PrintingTools': return 'Printing tools';
                case 'Search': return 'Search';
                case 'SearchTools': return 'Search tools';
                case 'Select': return 'Select';
                case 'SelectionTools': return 'Selection tools';
                case 'Shape': return 'Shape';
                case 'ShapeTools': return 'Shape tools';
                case 'UnexpectedProblemsEncountered': return 'Unexpected Problem(s) encountered';
                case 'ZoomTools': return 'Zoom tools';
                case 'Instructions': return 'Instructions';
            }
            break;

        case 'Map.Zoom.js':
            switch (strInterfaceResource) {
                case 'AvailableLevelsBaseMap': return 'Available levels defined by base map';
                case 'CurrentScale': return 'Current Scale';
                case 'GoToScaleOK': return 'OK';
                case 'MenuItemName': return 'Zoom';
                case 'NotSupportedByBaseMap': return 'Not supported by base map';
                case 'ZoomMapExtent': return 'Zoom To Map Extent';
                case 'ZoomPredefinedScale': return 'Zoom To Predefined Scale';
                case 'ZoomToScale': return 'Zoom To Scale';
            }
            break;
    }
}

// **************************************************************************
// FUNCTION Register
// **************************************************************************
TrimbleMap.TranslationHandler.Shared.Register = function Register() {

    // Create a map traslation handler and register it ...
    SD.Translation.Shared.RegisterSecondaryTranslationHandler(TrimbleMap.TranslationHandler.CreateInstance().GetTranslationProxy);
}

// **************************************************************************
// FUNCTION Register this TranslationHandler ...
// **************************************************************************
TrimbleMap.TranslationHandler.Shared.Register();


var TrimbleMap = TrimbleMap || {};
TrimbleMap.UserSettings = {};
TrimbleMap.UserSettings.Shared = {};

// **************************************************************************
// ENUM: enumSetting
// USAGE:    
// **************************************************************************
TrimbleMap.UserSettings.Shared.enumSetting = {};
TrimbleMap.UserSettings.Shared.enumSetting.MapProperties = 'MapProperties';
TrimbleMap.UserSettings.Shared.enumSetting.ModulesVisible = 'ModulesVisible';
TrimbleMap.UserSettings.Shared.enumSetting.Preferences = 'Preferences';

/* 
 * Take note when creating UserSettings using this function
 * A new instance is returned each time and may quickly differ from the existing one/s if user settings change
 * The actual persisted value of user settings will be the value of the last instance to be persisted
 */
TrimbleMap.UserSettings.CreateInstance = function CreateInstance(mapContainerID, defaultModulesVisible, preferences) {
    let userSettings = {
        MapContainerID: mapContainerID,
        DefaultModulesVisible: defaultModulesVisible,
        DefaultPreferences: {
            'DisplaySeparateParts': (typeof preferences.DisplaySeparateParts == 'undefined' || preferences.DisplaySeparateParts == null) ? false : preferences.DisplaySeparateParts,
            'KeepSearchAndSelectResults': (typeof preferences.KeepSearchAndSelectResults == 'undefined' || preferences.KeepSearchAndSelectResults == null) ? false : preferences.KeepSearchAndSelectResults,
            'InitialExtentBookmarkIDByMapID': (typeof preferences.InitialExtentBookmarkIDByMapID == 'undefined' || preferences.InitialExtentBookmarkIDByMapID == null) ? {} : preferences.InitialExtentBookmarkIDByMapID,
            'InitialExtentIDForAllMaps': (typeof preferences.InitialExtentIDForAllMaps == 'undefined' || preferences.InitialExtentIDForAllMaps == null) ? SD.Guid.Shared.Empty() : preferences.InitialExtentIDForAllMaps,
            'InitialExtentType': (typeof preferences.InitialExtentType == 'undefined' || preferences.InitialExtentType == null) ? TrimbleMap.Preferences.enumUserInitialExtentType.EachMapHaveOwnInitialExtent : preferences.InitialExtentType
        },

        MapProperties: null,
        ModulesVisible: null,
        Preferences: null,
        
        Init: TrimbleMap.UserSettings.Init,
        InstantiateSettings: TrimbleMap.UserSettings.InstantiateSettings,
        SaveSettings: TrimbleMap.UserSettings.SaveSettings,
        CreateMapSettings: TrimbleMap.UserSettings.CreateMapSettings,
        WhereMapID: TrimbleMap.UserSettings.WhereMapID,
        ClearMapProperties: TrimbleMap.UserSettings.ClearMapProperties,
        ClearSelectionQueries: TrimbleMap.UserSettings.ClearSelectionQueries,

        UpdateUserSettings: TrimbleMap.UserSettings.UpdateUserSettings,
        UpdateMapPropertiesSettings: TrimbleMap.UserSettings.UpdateMapPropertiesSettings,
        UpdateModuleVisibilitySettings: TrimbleMap.UserSettings.UpdateModuleVisibilitySettings,
        UpdatePreferencesSettings: TrimbleMap.UserSettings.UpdatePreferencesSettings,

        UpdateUserSettingsProxy: function (settingType, newSetting) { userSettings.UpdateUserSettings(settingType, newSetting); },

        Shared: {
            JsonIsValid: TrimbleMap.UserSettings.Shared.JsonIsValid
        }
    };

    userSettings.Init();

    return userSettings;
}

TrimbleMap.UserSettings.Init = function () {
    let userSettings = this;

    userSettings.MapContainerID = userSettings.MapContainerID.indexOf('DynamicControl') !== -1
        ? 'DynamicControl_MapContainer'
        : userSettings.MapContainerID;

    let storage = localStorage.getItem(userSettings.MapContainerID);
    let settings = (storage !== null && storage !== undefined) ? JSON.parse(storage) : null;

    if (settings && TrimbleMap.UserSettings.Shared.JsonIsValid(settings)) {

        userSettings.MapProperties = settings.MapProperties || {};
        userSettings.ModulesVisible = settings.ModulesVisible || [];

        if (settings.Preferences) {
            userSettings.Preferences = settings.Preferences;

            // Need to set all properties individually because previously only 'DisplaySeparateParts' was supported and it's state maintained.
            // This meant that if state was saved previously where 'DisplaySeparateParts' was only maintained then the 'Preferences' object only contained a property 'DisplaySeparateParts' when setting it above.
            // This then caused a crash when accessing 'InitialExtentBookmarkIDByMapID' in other places as it expects it to be instantiated.
            userSettings.Preferences.DisplaySeparateParts = settings.Preferences.DisplaySeparateParts || false;
            userSettings.Preferences.KeepSearchAndSelectResults = settings.Preferences.KeepSearchAndSelectResults || false;
            userSettings.Preferences.InitialExtentBookmarkIDByMapID = settings.Preferences.InitialExtentBookmarkIDByMapID || {};
            userSettings.Preferences.InitialExtentIDForAllMaps = settings.Preferences.InitialExtentIDForAllMaps || SD.Guid.Shared.Empty();
            userSettings.Preferences.InitialExtentType = settings.Preferences.InitialExtentType || TrimbleMap.Preferences.enumUserInitialExtentType.EachMapHaveOwnInitialExtent;
        }
        else {
            userSettings.Preferences = {};
        }
    } else {

        if (userSettings.DefaultModulesVisible && userSettings.DefaultModulesVisible.length > 0) {

            userSettings.DefaultModulesVisible = userSettings.DefaultModulesVisible.filter(function (module) {
                return module != TrimbleMap.StandardMap.Shared.enumModule.Instructions;
            });
        }

        localStorage.removeItem(userSettings.MapContainerID);
        userSettings.InstantiateSettings();
    }
}

TrimbleMap.UserSettings.InstantiateSettings = function () {
    let userSettings = this;

    userSettings.ModulesVisible = userSettings.DefaultModulesVisible;
    userSettings.Preferences = userSettings.DefaultPreferences;

    userSettings.ClearMapProperties();
}

TrimbleMap.UserSettings.CreateMapSettings = function (VisibleMapServiceDisplayIDs, VisibleLayerIDsByMapServiceDisplayID) {

    if (!VisibleMapServiceDisplayIDs) { VisibleMapServiceDisplayIDs = null; }
    if (!VisibleLayerIDsByMapServiceDisplayID) { VisibleLayerIDsByMapServiceDisplayID = null; }

    return {
        "ID": null,
        "VisibleMapServiceDisplayIDs": VisibleMapServiceDisplayIDs,
        "VisibleLayerIDsByMapServiceDisplayID": VisibleLayerIDsByMapServiceDisplayID,
        "MapExtent": null,
        "SelectionState": {
            "SelectionQueries": [],
            "ActiveLayerIDs": null,
            'SelectByLocationActiveSourceLayerIDs': null,
            'SelectByLocationActiveTargetLayerIDs': null,
            'ApplyBuffer': false,
            'BufferValue': null,
            'BufferUnit': null
        }
    };
}

TrimbleMap.UserSettings.SaveSettings = function () {
    let userSettings = this;

    userSettings.ModulesVisible = userSettings.ModulesVisible.filter(function (module) {
        return module != TrimbleMap.StandardMap.Shared.enumModule.Instructions;
    });

    let settings = {
        'MapProperties': userSettings.MapProperties,
        'ModulesVisible': userSettings.ModulesVisible,
        'Preferences': userSettings.Preferences
    }

    localStorage.setItem(userSettings.MapContainerID, JSON.stringify(settings));
}

TrimbleMap.UserSettings.UpdateUserSettings = function (settingType, newSetting) {
    let userSettings = this;
    
    switch (settingType) {
        case TrimbleMap.UserSettings.Shared.enumSetting.MapProperties:
            userSettings.UpdateMapPropertiesSettings(newSetting);
            break;
        case TrimbleMap.UserSettings.Shared.enumSetting.ModulesVisible:
            userSettings.UpdateModuleVisibilitySettings(newSetting);
            break;
        case TrimbleMap.UserSettings.Shared.enumSetting.Preferences:
            userSettings.UpdatePreferencesSettings(newSetting);
            break;
    }

    userSettings.SaveSettings();
}

TrimbleMap.UserSettings.UpdateMapPropertiesSettings = function (newSetting) {
    let userSettings = this;

    // Update map choice
    if (newSetting.MapID) {

        userSettings.WhereMapID(newSetting.MapID, function (objMap) {

            // Do nothing, settings will be applied when the map is created or loaded

        }, function () {

                // Create a new map settings object
                let map = userSettings.CreateMapSettings(newSetting.VisibleMapServiceDisplayIDs, newSetting.VisibleLayerIDsByMapServiceDisplayID);
                map.ID = newSetting.MapID;

                // Add the new map settings object to the array of map settings objects
                userSettings.MapProperties.Maps.push(map);
        });

        userSettings.MapProperties.CurrentMapID = newSetting.MapID;
    }

    // Update visible map layers
    if (newSetting.LayerVisibility) {

        userSettings.WhereMapID(userSettings.MapProperties.CurrentMapID, function (objMap) {

            // Update visible Map Layers by Map Service Display ID
            objMap.VisibleLayerIDsByMapServiceDisplayID = newSetting.LayerVisibility.VisibleLayerIDsByMapServiceDisplayID;

            // Update visible Map Service Display IDs
            objMap.VisibleMapServiceDisplayIDs = newSetting.LayerVisibility.VisibleMapServiceDisplayIDs;
        });
    }

    // Update map extent
    if (newSetting.MapExtent) {

        userSettings.WhereMapID(userSettings.MapProperties.CurrentMapID, function (objMap) {

            // Create new truncated map extent bookmark object
            objMap.MapExtent = {
                'GeographicSpatialReferenceID': newSetting.MapExtent.GeographicSpatialReferenceID,
                'ExtentMinX': newSetting.MapExtent.ExtentMinX,
                'ExtentMinY': newSetting.MapExtent.ExtentMinY,
                'ExtentMaxX': newSetting.MapExtent.ExtentMaxX,
                'ExtentMaxY': newSetting.MapExtent.ExtentMaxY
            };
        });
    }

    // Update selection state 
    if (newSetting.SelectionState) {

        userSettings.WhereMapID(userSettings.MapProperties.CurrentMapID, function (objMap) {

            // Update Selection state properties 
            objMap.SelectionState.ActiveLayerIDs = newSetting.SelectionState.ActiveLayerIDs;
            objMap.SelectionState.SelectByLocationActiveSourceLayerIDs = newSetting.SelectionState.SelectByLocationActiveSourceLayerIDs;
            objMap.SelectionState.SelectByLocationActiveTargetLayerIDs = newSetting.SelectionState.SelectByLocationActiveTargetLayerIDs;
            objMap.SelectionState.ApplyBuffer = newSetting.SelectionState.ApplyBuffer;
            objMap.SelectionState.BufferValue = newSetting.SelectionState.BufferValue;
            objMap.SelectionState.BufferUnit = newSetting.SelectionState.BufferUnit;
        });
    }

    // Update selection queries
    if (newSetting.SelectionQueries) {

        userSettings.WhereMapID(userSettings.MapProperties.CurrentMapID, function (objMap) {
            
            if (newSetting.SelectionQueries.SelectionMethod == esri.layers.FeatureLayer.SELECTION_NEW) {

                // Clear previous queries
                objMap.SelectionState.SelectionQueries = [];
            } 

            // Add to the selection queries array
            objMap.SelectionState.SelectionQueries.push(newSetting.SelectionQueries);
        });
    }

    if (newSetting.SelectionModeAndOperation) {

        // Update Selection ToolMode and Operation
        userSettings.MapProperties.SelectionToolMode = newSetting.SelectionModeAndOperation.SelectionToolMode;
        userSettings.MapProperties.SelectionOperation = newSetting.SelectionModeAndOperation.SelectionOperation;
    }
}

TrimbleMap.UserSettings.UpdatePreferencesSettings = function (newSetting) {
    let userSettings = this;

    userSettings.Preferences.DisplaySeparateParts = newSetting.DisplaySeparateParts;
    userSettings.Preferences.KeepSearchAndSelectResults = newSetting.KeepSearchAndSelectResults;
    userSettings.Preferences.InitialExtentBookmarkIDByMapID = newSetting.InitialExtentBookmarkIDByMapID;
    userSettings.Preferences.InitialExtentIDForAllMaps = newSetting.InitialExtentIDForAllMaps;
    userSettings.Preferences.InitialExtentType = newSetting.InitialExtentType;
}

TrimbleMap.UserSettings.UpdateModuleVisibilitySettings = function (newSetting) {
    let userSettings = this;

    if (newSetting.enabled) {

        userSettings.ModulesVisible.push(newSetting.module);
    } else {

        userSettings.ModulesVisible = userSettings.ModulesVisible.filter(function (moduleToRemove) {
            return moduleToRemove != newSetting.module;
        });
    }
}

TrimbleMap.UserSettings.WhereMapID = function (mapID, fnCallbackIfExists, fnCallbackIfNotExists) {
    let userSettings = this;

    let exists = false;

    for (let intMap = 0; intMap < userSettings.MapProperties.Maps.length; intMap++) {

        if (userSettings.MapProperties.Maps[intMap].ID == mapID) {

            fnCallbackIfExists(userSettings.MapProperties.Maps[intMap]);
            exists = true;
            break;
        }
    }

    if (!exists && fnCallbackIfNotExists) { fnCallbackIfNotExists(); }
}

TrimbleMap.UserSettings.ClearMapProperties = function () {
    let userSettings = this;

    userSettings.MapProperties = {
        'CurrentMapID': null,
        "SelectionToolMode": null,
        "SelectionOperation": null,
        'Maps': []
    };
}

TrimbleMap.UserSettings.ClearSelectionQueries = function (blnClearForAllMaps) {
    let userSettings = this;

    if (blnClearForAllMaps) {
        $.each(userSettings.MapProperties.Maps, function (intMap, objMap) {
            objMap.SelectionState.SelectionQueries = [];
        });
    }
    else {
        userSettings.WhereMapID(userSettings.MapProperties.CurrentMapID, function (objMap) {
            objMap.SelectionState.SelectionQueries = [];
        });
    }
}

TrimbleMap.UserSettings.Shared.JsonIsValid = function (jsonToValidate) {
    let ajv = new Ajv({ allErrors: true });
    let schema = $.getJSON(SD.Url.Shared.CurrentMappingLibraryURL + '/schemas/UserSettingsSchema.json');

    ajv.compile(schema);

    return ajv.validate(jsonToValidate);
}


// Create the TrimbleMap namespace object (if it does not exist already) ...
var TrimbleMap = TrimbleMap || {};

// Create the UTM namespace object ...
TrimbleMap.UTM = {};

// Create the projectiosn hash table ...
TrimbleMap.UTM.Projections = {};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetUTMCoordinateSystem : Picks a utm coordinate system in which the area is to be calculated ...
// USAGE    arrRingsOrPaths should be a 3 dimensional array with rings or paths with coordinates with an 
//          array with two entries for each coordinate with x and y as the values ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.UTM.GetUTMCoordinateSystem = function GetUTMCoordinateSystem(objGeometry) {

    // * Pick the utm zone based on the geographic location ...

    // Get the first point ...
    var objFirstPoint = TrimbleMap.Geometry.Shared.GetFirstPoint(objGeometry);
    
    // Compute the utm zone number in which the point lie, every 6 degrees from -180, where 1 is on the far left ...
    var intUTMZone = (Math.floor((objFirstPoint.x + 180) / 6) % 60) + 1;

    // Start building the utm zone name ...
    var strUTMZoneName = 'WGS_1984_UTM_Zone_' + intUTMZone;

    // When North ...
    if (objFirstPoint.y >= 0) {

        // Add 'N' to pick the North utm zone ...
        strUTMZoneName += 'N';

    } else {

        // Add 'S' to pick the North utm zone ...
        strUTMZoneName += 'S';
    }

    // Get the utm zone wkt definition ...
    var strUTMZoneWKTDefinition = TrimbleMap.UTM.Projections[strUTMZoneName];

    // Return an object with the utm zone name and the wkt ...
    return TrimbleMap.UTM.CreateCoordinateSystemResult(strUTMZoneName.replace(/_/g, ' '),
                                                strUTMZoneWKTDefinition,
                                                TrimbleMap.UTM.CalculationsLikelyAccurate(objGeometry, intUTMZone));
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION CreateCoordinateSystemResult
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.UTM.CreateCoordinateSystemResult = function CreateCoordinateSystemResult(strName, strWkt, blnLikelyAccurate) {
    return {
        Name: strName,
        wkt: strWkt,
        LikelyAccurate: blnLikelyAccurate
    };
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION LikelyAccurate: Determines whether or not there are any points more than 
//                          one and a half utm zones from the center of the chosen utm zone ...
// USAGE    arrRings should be a 3 dimensional array with rings with coordinates with an array with two 
//          entries for each coordinate with x and y as the values ...
//          This function attempts to evaluate whether or not the utm zone 
//          will yield accurate area and distance calculations
//          More info on utms zones can be found here: 
//                  https://en.wikipedia.org/wiki/Universal_Transverse_Mercator_coordinate_system
//          In short a utm zone is 6 degreees wide starting at 1 at -180 to -174 degrees and 
//          ending at 60 at 174 to 180 degrees
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
TrimbleMap.UTM.CalculationsLikelyAccurate = function CalculationsLikelyAccurate(objGeomtry, intUTMZone) {

    // Start with the calculation likely being accurate ...
    var blnCalculationsLikelyAccurate = true;

    // Compute the center for the utm zone ...
    var decUTMZoneCenter = ((intUTMZone - 31) * 6) + 3;
    
    // Loop through all the points ...
    TrimbleMap.Geometry.Shared.ForEachPointFromGeometry(objGeomtry, function (objPoint) {

        // Get the X value ...
        var decX = objPoint.x;

        // Compute the distance of the point to the center ...
        var decDistance = Math.abs(decUTMZoneCenter - decX);

        // When more than one and a half utm zones from the center of the utm zone ...
        if (decDistance > 9) {

            // Set to not likely be accurate ...
            blnCalculationsLikelyAccurate = false;

            // Stop checking ...
            return false;
        }
    });

    return blnCalculationsLikelyAccurate;
}

// Add all the utm projections' wkt to the hash table ...
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_1N'] = 'PROJCS["WGS_1984_UTM_Zone_1N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-177.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32601]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_2N'] = 'PROJCS["WGS_1984_UTM_Zone_2N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-171.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32602]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_3N'] = 'PROJCS["WGS_1984_UTM_Zone_3N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-165.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32603]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_4N'] = 'PROJCS["WGS_1984_UTM_Zone_4N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-159.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32604]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_5N'] = 'PROJCS["WGS_1984_UTM_Zone_5N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-153.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32605]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_6N'] = 'PROJCS["WGS_1984_UTM_Zone_6N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-147.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32606]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_7N'] = 'PROJCS["WGS_1984_UTM_Zone_7N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-141.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32607]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_8N'] = 'PROJCS["WGS_1984_UTM_Zone_8N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-135.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32608]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_9N'] = 'PROJCS["WGS_1984_UTM_Zone_9N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-129.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32609]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_10N'] = 'PROJCS["WGS_1984_UTM_Zone_10N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-123.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32610]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_11N'] = 'PROJCS["WGS_1984_UTM_Zone_11N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-117.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32611]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_12N'] = 'PROJCS["WGS_1984_UTM_Zone_12N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-111.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32612]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_13N'] = 'PROJCS["WGS_1984_UTM_Zone_13N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-105.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32613]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_14N'] = 'PROJCS["WGS_1984_UTM_Zone_14N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-99.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32614]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_15N'] = 'PROJCS["WGS_1984_UTM_Zone_15N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-93.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32615]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_16N'] = 'PROJCS["WGS_1984_UTM_Zone_16N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-87.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32616]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_17N'] = 'PROJCS["WGS_1984_UTM_Zone_17N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-81.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32617]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_18N'] = 'PROJCS["WGS_1984_UTM_Zone_18N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-75.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32618]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_19N'] = 'PROJCS["WGS_1984_UTM_Zone_19N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-69.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32619]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_20N'] = 'PROJCS["WGS_1984_UTM_Zone_20N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-63.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32620]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_21N'] = 'PROJCS["WGS_1984_UTM_Zone_21N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-57.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32621]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_22N'] = 'PROJCS["WGS_1984_UTM_Zone_22N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-51.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32622]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_23N'] = 'PROJCS["WGS_1984_UTM_Zone_23N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-45.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32623]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_24N'] = 'PROJCS["WGS_1984_UTM_Zone_24N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-39.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32624]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_25N'] = 'PROJCS["WGS_1984_UTM_Zone_25N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-33.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32625]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_26N'] = 'PROJCS["WGS_1984_UTM_Zone_26N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-27.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32626]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_27N'] = 'PROJCS["WGS_1984_UTM_Zone_27N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-21.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32627]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_28N'] = 'PROJCS["WGS_1984_UTM_Zone_28N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-15.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32628]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_29N'] = 'PROJCS["WGS_1984_UTM_Zone_29N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-9.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32629]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_30N'] = 'PROJCS["WGS_1984_UTM_Zone_30N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-3.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32630]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_31N'] = 'PROJCS["WGS_1984_UTM_Zone_31N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",3.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32631]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_32N'] = 'PROJCS["WGS_1984_UTM_Zone_32N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",9.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32632]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_33N'] = 'PROJCS["WGS_1984_UTM_Zone_33N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",15.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32633]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_34N'] = 'PROJCS["WGS_1984_UTM_Zone_34N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",21.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32634]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_35N'] = 'PROJCS["WGS_1984_UTM_Zone_35N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",27.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32635]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_36N'] = 'PROJCS["WGS_1984_UTM_Zone_36N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",33.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32636]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_37N'] = 'PROJCS["WGS_1984_UTM_Zone_37N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",39.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32637]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_38N'] = 'PROJCS["WGS_1984_UTM_Zone_38N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",45.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32638]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_39N'] = 'PROJCS["WGS_1984_UTM_Zone_39N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",51.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32639]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_40N'] = 'PROJCS["WGS_1984_UTM_Zone_40N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",57.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32640]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_41N'] = 'PROJCS["WGS_1984_UTM_Zone_41N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",63.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32641]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_42N'] = 'PROJCS["WGS_1984_UTM_Zone_42N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",69.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32642]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_43N'] = 'PROJCS["WGS_1984_UTM_Zone_43N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",75.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32643]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_44N'] = 'PROJCS["WGS_1984_UTM_Zone_44N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",81.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32644]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_45N'] = 'PROJCS["WGS_1984_UTM_Zone_45N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",87.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32645]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_46N'] = 'PROJCS["WGS_1984_UTM_Zone_46N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",93.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32646]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_47N'] = 'PROJCS["WGS_1984_UTM_Zone_47N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",99.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32647]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_48N'] = 'PROJCS["WGS_1984_UTM_Zone_48N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",105.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32648]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_49N'] = 'PROJCS["WGS_1984_UTM_Zone_49N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",111.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32649]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_50N'] = 'PROJCS["WGS_1984_UTM_Zone_50N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",117.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32650]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_51N'] = 'PROJCS["WGS_1984_UTM_Zone_51N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",123.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32651]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_52N'] = 'PROJCS["WGS_1984_UTM_Zone_52N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",129.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32652]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_53N'] = 'PROJCS["WGS_1984_UTM_Zone_53N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",135.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32653]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_54N'] = 'PROJCS["WGS_1984_UTM_Zone_54N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",141.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32654]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_55N'] = 'PROJCS["WGS_1984_UTM_Zone_55N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",147.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32655]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_56N'] = 'PROJCS["WGS_1984_UTM_Zone_56N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",153.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32656]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_57N'] = 'PROJCS["WGS_1984_UTM_Zone_57N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",159.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32657]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_58N'] = 'PROJCS["WGS_1984_UTM_Zone_58N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",165.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32658]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_59N'] = 'PROJCS["WGS_1984_UTM_Zone_59N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",171.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32659]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_60N'] = 'PROJCS["WGS_1984_UTM_Zone_60N",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",177.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32660]]';

TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_1S'] = 'PROJCS["WGS_1984_UTM_Zone_1S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-177.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32701]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_2S'] = 'PROJCS["WGS_1984_UTM_Zone_2S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-171.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32702]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_3S'] = 'PROJCS["WGS_1984_UTM_Zone_3S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-165.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32703]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_4S'] = 'PROJCS["WGS_1984_UTM_Zone_4S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-159.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32704]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_5S'] = 'PROJCS["WGS_1984_UTM_Zone_5S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-153.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32705]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_6S'] = 'PROJCS["WGS_1984_UTM_Zone_6S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-147.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32706]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_7S'] = 'PROJCS["WGS_1984_UTM_Zone_7S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-141.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32707]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_8S'] = 'PROJCS["WGS_1984_UTM_Zone_8S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-135.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32708]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_9S'] = 'PROJCS["WGS_1984_UTM_Zone_9S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-129.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32709]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_10S'] = 'PROJCS["WGS_1984_UTM_Zone_10S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-123.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32710]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_11S'] = 'PROJCS["WGS_1984_UTM_Zone_11S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-117.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32711]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_12S'] = 'PROJCS["WGS_1984_UTM_Zone_12S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-111.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32712]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_13S'] = 'PROJCS["WGS_1984_UTM_Zone_13S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-105.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32713]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_14S'] = 'PROJCS["WGS_1984_UTM_Zone_14S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-99.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32714]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_15S'] = 'PROJCS["WGS_1984_UTM_Zone_15S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-93.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32715]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_16S'] = 'PROJCS["WGS_1984_UTM_Zone_16S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-87.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32716]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_17S'] = 'PROJCS["WGS_1984_UTM_Zone_17S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-81.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32717]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_18S'] = 'PROJCS["WGS_1984_UTM_Zone_18S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-75.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32718]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_19S'] = 'PROJCS["WGS_1984_UTM_Zone_19S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-69.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32719]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_20S'] = 'PROJCS["WGS_1984_UTM_Zone_20S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-63.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32720]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_21S'] = 'PROJCS["WGS_1984_UTM_Zone_21S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-57.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32721]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_22S'] = 'PROJCS["WGS_1984_UTM_Zone_22S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-51.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32722]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_23S'] = 'PROJCS["WGS_1984_UTM_Zone_23S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-45.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32723]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_24S'] = 'PROJCS["WGS_1984_UTM_Zone_24S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-39.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32724]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_25S'] = 'PROJCS["WGS_1984_UTM_Zone_25S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-33.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32725]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_26S'] = 'PROJCS["WGS_1984_UTM_Zone_26S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-27.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32726]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_27S'] = 'PROJCS["WGS_1984_UTM_Zone_27S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-21.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32727]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_28S'] = 'PROJCS["WGS_1984_UTM_Zone_28S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-15.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32728]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_29S'] = 'PROJCS["WGS_1984_UTM_Zone_29S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-9.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32729]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_30S'] = 'PROJCS["WGS_1984_UTM_Zone_30S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",-3.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32730]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_31S'] = 'PROJCS["WGS_1984_UTM_Zone_31S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",3.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32731]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_32S'] = 'PROJCS["WGS_1984_UTM_Zone_32S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",9.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32732]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_33S'] = 'PROJCS["WGS_1984_UTM_Zone_33S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",15.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32733]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_34S'] = 'PROJCS["WGS_1984_UTM_Zone_34S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",21.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32734]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_35S'] = 'PROJCS["WGS_1984_UTM_Zone_35S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",27.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32735]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_36S'] = 'PROJCS["WGS_1984_UTM_Zone_36S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",33.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32736]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_37S'] = 'PROJCS["WGS_1984_UTM_Zone_37S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",39.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32737]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_38S'] = 'PROJCS["WGS_1984_UTM_Zone_38S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",45.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32738]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_39S'] = 'PROJCS["WGS_1984_UTM_Zone_39S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",51.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32739]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_40S'] = 'PROJCS["WGS_1984_UTM_Zone_40S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",57.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32740]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_41S'] = 'PROJCS["WGS_1984_UTM_Zone_41S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",63.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32741]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_42S'] = 'PROJCS["WGS_1984_UTM_Zone_42S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",69.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32742]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_43S'] = 'PROJCS["WGS_1984_UTM_Zone_43S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",75.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32743]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_44S'] = 'PROJCS["WGS_1984_UTM_Zone_44S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",81.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32744]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_45S'] = 'PROJCS["WGS_1984_UTM_Zone_45S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",87.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32745]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_46S'] = 'PROJCS["WGS_1984_UTM_Zone_46S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",93.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32746]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_47S'] = 'PROJCS["WGS_1984_UTM_Zone_47S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",99.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32747]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_48S'] = 'PROJCS["WGS_1984_UTM_Zone_48S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",105.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32748]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_49S'] = 'PROJCS["WGS_1984_UTM_Zone_49S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",111.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32749]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_50S'] = 'PROJCS["WGS_1984_UTM_Zone_50S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",117.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32750]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_51S'] = 'PROJCS["WGS_1984_UTM_Zone_51S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",123.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32751]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_52S'] = 'PROJCS["WGS_1984_UTM_Zone_52S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",129.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32752]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_53S'] = 'PROJCS["WGS_1984_UTM_Zone_53S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",135.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32753]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_54S'] = 'PROJCS["WGS_1984_UTM_Zone_54S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",141.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32754]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_55S'] = 'PROJCS["WGS_1984_UTM_Zone_55S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",147.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32755]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_56S'] = 'PROJCS["WGS_1984_UTM_Zone_56S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",153.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32756]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_57S'] = 'PROJCS["WGS_1984_UTM_Zone_57S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",159.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32757]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_58S'] = 'PROJCS["WGS_1984_UTM_Zone_58S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",165.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32758]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_59S'] = 'PROJCS["WGS_1984_UTM_Zone_59S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",171.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32759]]';
TrimbleMap.UTM.Projections['WGS_1984_UTM_Zone_60S'] = 'PROJCS["WGS_1984_UTM_Zone_60S",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",177.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0],AUTHORITY["EPSG",32760]]';


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.Zoom = {};
TrimbleMap.Zoom.Shared = {};

TrimbleMap.Zoom.Shared.MENU_ITEM_NAME = 'ZOOM';
TrimbleMap.Zoom.Shared.MIN_SCALE = 1000;
TrimbleMap.Zoom.Shared.MAX_SCALE = 100000000;

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.CreateInstance = function CreateInstance(objMapController, objMenuInstance, intMenuItemOrder, blnVisible) {

    // Create the object that will hold the instance properties ...
    var objZoomInstance = {
        MapController: objMapController,
        MenuInstance: objMenuInstance,
        Visible: false,
        ContainerDiv: null,
        ZoomToMapExtentDiv: null,
        PredefinedScales: [1000, 10000, 100000, 500000, 1000000, 10000000, 100000000],
        MapScales: null,
        GotoScaleTextboxElement: null,
        GotoScaleButton: null,
        RecentlyAccessedScales: [],
        RecentlyAccessedScalesDiv: null,
        RecentlyAccessedScalesItemContainerDiv: null,
        ZoomMenuItem: null,
        ScalesDiv: null,
        ScalesDivNiceScroll: null,

        ActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objZoomInstance.ActivateSubMenu(objMenuItem, objSubMenuDiv) },
        DeActivateSubMenuProxy: function (objMenuItem, objSubMenuDiv) { objZoomInstance.DeActivateSubMenu(objMenuItem, objSubMenuDiv) },

        SubMenuClickedProxy: function (e) { objZoomInstance.SubMenuClicked(e) },
        GotoScaleTextboxElementKeyPressedProxy: function (e) { objZoomInstance.GotoScaleTextboxElementKeyPressed(e) },
        MapLoadedProxy: function (blnMapLoadedOnce) { objZoomInstance.MapLoaded(blnMapLoadedOnce) },
        SubMenuOpenedProxy: function (strSubMenuName) { objZoomInstance.SubMenuOpened(strSubMenuName) },

        MapLoaded: TrimbleMap.Zoom.MapLoaded,
        ZoomToScale: TrimbleMap.Zoom.ZoomToScale,
        CreateSubMenuElements: TrimbleMap.Zoom.CreateSubMenuElements,
        ActivateSubMenu: TrimbleMap.Zoom.ActivateSubMenu,
        DeActivateSubMenu: TrimbleMap.Zoom.DeActivateSubMenu,
        AttachEventHandlers: TrimbleMap.Zoom.AttachEventHandlers,
        DetachEventHandlers: TrimbleMap.Zoom.DetachEventHandlers,
        SubMenuClicked: TrimbleMap.Zoom.SubMenuClicked,
        GotoScaleTextboxElementKeyPressed: TrimbleMap.Zoom.GotoScaleTextboxElementKeyPressed,
        GotoTypedInScale: TrimbleMap.Zoom.GotoTypedInScale,
        SubMenuOpened: TrimbleMap.Zoom.SubMenuOpened,
        Show: TrimbleMap.Zoom.Show,
        Hide: TrimbleMap.Zoom.Hide
    };

    // Create the menu item ...
    objZoomInstance.ZoomMenuItem = TrimbleMap.Menu.Shared.CreateMenuItem(TrimbleMap.Zoom.Shared.MENU_ITEM_NAME, SD.Translation.Shared.GetTranslation('Map.Zoom.js', 'MenuItemName'), intMenuItemOrder, true, null, objZoomInstance.ActivateSubMenuProxy, objZoomInstance.DeActivateSubMenuProxy);

    // Add the onloaded callback ...
    objMapController.AddOnLoadedCallback(objZoomInstance.MapLoadedProxy);

    // Add the on sub menu opened callback ...
    objMenuInstance.AddOnSubMenuOpenedCallback(objZoomInstance.SubMenuOpenedProxy);

    // Show the menu buttonwhen its to be visible at startup ...
    if (blnVisible) { objZoomInstance.Show(false); }

    return objZoomInstance;
}

// **************************************************************************
// FUNCTION: MapLoaded
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.MapLoaded = function MapLoaded(blnMapLoadedOnce) {

    // Get the instance ...
    var objZoomInstance = this;

    // Get the map scales ...
    objZoomInstance.MapScales = objZoomInstance.MapController.GetCurrentMapScales();
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Zoom.Show = function Show(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objZoomInstance = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When not visible ...
    if (!objZoomInstance.Visible) {

        // Add the menu item ...
        objZoomInstance.MenuInstance.AddMenuItem(objZoomInstance.ZoomMenuItem);

        // Set to be visible ...
        objZoomInstance.Visible = true;

        // Notify that the module visibility changed to true ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objZoomInstance.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Zoom, true); }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    blnTriggerNotifyModuleVisibilityChanged is optional, defaults to true
// **************************************************************************
TrimbleMap.Zoom.Hide = function Hide(blnTriggerNotifyModuleVisibilityChanged) {

    // Get the instance ...
    var objZoomInstance = this;

    // Default blnTriggerNotifyModuleVisibilityChanged to true ...
    if ((typeof blnTriggerNotifyModuleVisibilityChanged == 'undefined') || (blnTriggerNotifyModuleVisibilityChanged == null)) { blnTriggerNotifyModuleVisibilityChanged = true; }

    // When visible ...
    if (objZoomInstance.Visible) {

        // Remove the menu item ...
        objZoomInstance.MenuInstance.RemoveMenuItem(objZoomInstance.ZoomMenuItem);

        // Set to not be visible ...
        objZoomInstance.Visible = false;

        // Notify that the module visibility changed to false ...
        if (blnTriggerNotifyModuleVisibilityChanged) { objZoomInstance.MapController.TriggerNotifyModuleVisibilityChanged(TrimbleMap.StandardMap.Shared.enumModule.Zoom, false); }
    }
}

// **************************************************************************
// FUNCTION: CreateSubMenuElements
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.CreateSubMenuElements = function CreateSubMenuElements(objSubMenuDiv) {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // Determine whether or not the map has any scale levels ...
    var blnMapHasScaleLevels = (objZoomInstance.MapScales != null);

    // Create the div that will hold the zoom Controls ...
    objZoomInstance.ContainerDiv = $('<div class="current-scale"></div>');

    // Get translation ...

    // Current Scale
    var strCurrentScale = SD.Translation.Shared.GetTranslation('Map.Zoom.js', 'CurrentScale');

    // Create the current scale container div ...
    var objCurrentScaleContainerDiv = $('<div><span class="bold">' + strCurrentScale + ':</span></div>');

    // Add it to the container ...
    objZoomInstance.ContainerDiv.append(objCurrentScaleContainerDiv);

    // Create the current scale value span ...
    objZoomInstance.CurrentScaleValueSpan = $('<span></span>');

    // Add it to the container ...
    objCurrentScaleContainerDiv.append(objZoomInstance.CurrentScaleValueSpan);

    // Convert the current scale to text ...
    var strCurrentScale = SD.DisplayValue.FromDouble(objZoomInstance.MapController.EsriMap.getScale(), objZoomInstance.MapController.State.GroupSeparator, objZoomInstance.MapController.State.DecimalSeparator, 0)

    // Set the current scale ...
    objZoomInstance.CurrentScaleValueSpan.text('1 : ' + strCurrentScale);

    // Get translation ...
    var strZoomMapExtent = SD.Translation.Shared.GetTranslation('Map.Zoom.js', 'ZoomMapExtent');

    // Create the zoom to map extent div ...
    objZoomInstance.ZoomToMapExtentDiv = $('<div class="zoom-item" ZoomToMapExtent><span>' + strZoomMapExtent + '</span></div>');

    // Add it to the container ...
    objZoomInstance.ContainerDiv.append(objZoomInstance.ZoomToMapExtentDiv);

    //get translation
    var strZoomPredefinedScale = SD.Translation.Shared.GetTranslation('Map.Zoom.js', 'ZoomPredefinedScale');

    // Add the 'Zoom To Predefined Scale' label ...
    objZoomInstance.ContainerDiv.append('<div><span class="bold">' + strZoomPredefinedScale + ':</span></div>');

    // When the map has scale levels ...
    if (blnMapHasScaleLevels) {

        // Get the translation ...

        // Available levels defined by base map
        var strLevelsMessage = SD.Translation.Shared.GetTranslation('Map.Zoom.js', 'AvailableLevelsBaseMap');

        // Add the info label ...
        objZoomInstance.ContainerDiv.append('<div><span class="info-text">(' + strLevelsMessage + ')</span></div>');
    }

    // Create a div to contain the scales ...
    objZoomInstance.ScalesDiv = $('<div class="scales-list"></div>');

    // Add it to the container div ...
    objZoomInstance.ContainerDiv.append(objZoomInstance.ScalesDiv);

    // Use the scales from the map it has scales, otherwise use the predefined list ...
    var arrScales = (blnMapHasScaleLevels) ? objZoomInstance.MapScales : objZoomInstance.PredefinedScales;

    // Loop through the predefined scales ...
    for (var intScale = 0; intScale < arrScales.length; intScale++) {

        // Get the scale ...
        var decScale = arrScales[intScale];

        // Convert the area value to a string ...
        var strScale = SD.DisplayValue.FromDouble(decScale, objZoomInstance.MapController.State.GroupSeparator, objZoomInstance.MapController.State.DecimalSeparator, 0);

        // Create a div for the scale ...
        var objPredefinedScaleDiv = $('<div class="zoom-item zoom-to-scale" ScaleToZoomTo="' + decScale + '"><span>1 : ' + strScale + '</span></div>');

        // Add it to the scales div ...
        objZoomInstance.ScalesDiv.append(objPredefinedScaleDiv);
    }

    //get translation
    var strZoomToScale = SD.Translation.Shared.GetTranslation('Map.Zoom.js', 'ZoomToScale');

    // Add the 'Zoom To Scale' label ...
    objZoomInstance.ContainerDiv.append('<div><span class="bold">' + strZoomToScale + ':</span></div>');

    //get translation
    var strGoToScaleOK = SD.Translation.Shared.GetTranslation('Map.Zoom.js', 'GoToScaleOK');

    // Create the zoom to scale text box and button ...
    objZoomInstance.GotoScaleTextboxElement = $('<input type="text"/>');
    objZoomInstance.GotoScaleButton = $('<button class="Button" GotoScaleButton>' + strGoToScaleOK + '</button>');

    // Create the goto div ...
    var objGotoDiv = $('<div class="zoom-to-scale"></div>');

    // Add the goto element to the goto div ...
    objGotoDiv.append('<span>1 : </span>');
    objGotoDiv.append(objZoomInstance.GotoScaleTextboxElement);
    objGotoDiv.append(objZoomInstance.GotoScaleButton);

    // Set the enabled state of the goto section ...
    objZoomInstance.GotoScaleTextboxElement.prop('readonly', blnMapHasScaleLevels);
    objZoomInstance.GotoScaleButton.prop('disabled', blnMapHasScaleLevels);

    // Add it to the container ...
    objZoomInstance.ContainerDiv.append(objGotoDiv);

    // When the map has scale levels ...
    if (blnMapHasScaleLevels) {

        // Get the translation ...

        // Not supported by base map
        var strNoGotoMessage = SD.Translation.Shared.GetTranslation('Map.Zoom.js', 'NotSupportedByBaseMap');

        // Add the info label ...
        objZoomInstance.ContainerDiv.append('<div><span class="info-text info-text-goto">(' + strNoGotoMessage + ')</span></div>');
    }

    // When we have recently accessed scales ...
    if ((!blnMapHasScaleLevels) && (objZoomInstance.RecentlyAccessedScales.length > 0)) {

        // Create the recently accessed scales div ...
        objZoomInstance.RecentlyAccessedScalesDiv = $('<div><span class="bold">Recent:</span><br /></div>');

        // Create the recently accessed scales item container div ...
        objZoomInstance.RecentlyAccessedScalesItemContainerDiv = $('<div class="recently-accessed"></div>');

        // Add it to the container div ...
        objZoomInstance.ContainerDiv.append(objZoomInstance.RecentlyAccessedScalesDiv);

        // Loop through all the recently accessed scales ...
        for (var intRecentlyAccessed = objZoomInstance.RecentlyAccessedScales.length - 1; (intRecentlyAccessed >= 0) && (objZoomInstance.RecentlyAccessedScales.length - 1 - intRecentlyAccessed < 3); intRecentlyAccessed--) {

            // Get the scale ...
            var intRecentlyAccessedScale = objZoomInstance.RecentlyAccessedScales[intRecentlyAccessed];

            // Convert the area value to a string ...
            var strScale = SD.DisplayValue.FromDouble(intRecentlyAccessedScale, objZoomInstance.MapController.State.GroupSeparator, objZoomInstance.MapController.State.DecimalSeparator, 0);

            // Create a div for the scale ...
            var objRecentlyAccessedScaleDiv = $('<div class="zoom-item zoom-to-scale" ScaleToZoomTo="' + intRecentlyAccessedScale + '"><span>1 : ' + strScale + '</span></div>');

            // Add it to the container ...
            objZoomInstance.ContainerDiv.append(objRecentlyAccessedScaleDiv);
        }
    }
}

// **************************************************************************
// FUNCTION: GotoTypedInScale
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.GotoTypedInScale = function GotoTypedInScale() {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // Get the scale text ...
    var strScale = objZoomInstance.GotoScaleTextboxElement.val();

    // Test if the scale entered is a valid number ...
    if (SD.Number.ValidateIsNumber(strScale, objZoomInstance.MapController.State.GroupSeparator, objZoomInstance.MapController.State.DecimalSeparator, false)) {

        // Get the scale value as a number ...
        var intScale = SD.Number.ToNumber(strScale, objZoomInstance.MapController.State.GroupSeparator, objZoomInstance.MapController.State.DecimalSeparator);

        // When smaller than MIN_SCALE ...
        if (intScale < TrimbleMap.Zoom.Shared.MIN_SCALE) {

            // Convert the min scale to text ...
            var strMinScale = SD.DisplayValue.FromDouble(TrimbleMap.Zoom.Shared.MIN_SCALE, objZoomInstance.MapController.State.GroupSeparator, objZoomInstance.MapController.State.DecimalSeparator, 0);

            // Hide the menu instance ...
            objZoomInstance.MenuInstance.Hide();

            // Notify the user of the problem ...
            TrimbleMap.MessageBox.Shared.ShowMessage('Invalid Scale', 'The scale value that you entered is too small<br />(The minimum allowed is 1:' + strMinScale + ')');

            // When a very large number ...
        } else if (intScale > TrimbleMap.Zoom.Shared.MAX_SCALE) {

            // Convert the max scale to text ...
            var strMaxScale = SD.DisplayValue.FromDouble(TrimbleMap.Zoom.Shared.MAX_SCALE, objZoomInstance.MapController.State.GroupSeparator, objZoomInstance.MapController.State.DecimalSeparator, 0);

            // Hide the menu instance ...
            objZoomInstance.MenuInstance.Hide();

            // Notify the user of the problem ...
            TrimbleMap.MessageBox.Shared.ShowMessage('Invalid Scale', 'The scale value that you entered is too large<br />(The maximum allowed is 1:' + strMaxScale + ')');

        } else {

            // Zoom to the scale ...
            objZoomInstance.ZoomToScale(intScale, true);
        }

    } else {

        // Hide the menu instance ...
        objZoomInstance.MenuInstance.Hide();

        // Notify the user of the problem ...
        TrimbleMap.MessageBox.Shared.ShowMessage('Invalid Scale', 'Please enter a valid scale, only<br /> whole numbers are allowed');
    }
}

// **************************************************************************
// FUNCTION: SubMenuClicked
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.SubMenuClicked = function SubMenuClicked(e) {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // Prevent the default action ...
    e.preventDefault();

    // Get the clicked target ...
    var objTarget = $(e.target);

    if (SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ZoomToMapExtent') != null) {

        // Zoom to the full extent of the current map ...
        objZoomInstance.MapController.ZoomToInitialExtentOfCurrentMap();

        // Hide the menu instance ...
        objZoomInstance.MenuInstance.Hide();

    } else if (SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ScaleToZoomTo') != null) {

        // Get the scal eto zoom to ...
        var intScaleToZoomTo = Number(SD.DOM.GetElementOrParentWithAttribute(objTarget, 'ScaleToZoomTo').attr('ScaleToZoomTo'));

        // Zoom to the scale ...
        objZoomInstance.ZoomToScale(intScaleToZoomTo, false);

    } else if (SD.DOM.GetElementOrParentWithAttribute(objTarget, 'GotoScaleButton') != null) {

        // Go to the scale typed into the text box ...
        objZoomInstance.GotoTypedInScale();
    }
}

// **************************************************************************
// FUNCTION: GotoScaleTextboxElementKeyPressed
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.GotoScaleTextboxElementKeyPressed = function GotoScaleTextboxElementKeyPressed(e) {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // When the enter key has been pressed ...
    if (e.which == 13) {

        // Prevent the default action (submit) for the button ...
        e.preventDefault();

        // Go to the scale typed into the text box ...
        objZoomInstance.GotoTypedInScale();
    }
}

// **************************************************************************
// FUNCTION: ZoomToScale
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.ZoomToScale = function ZoomToScale(intScaleToZoomTo, blnAddToRecentlyAccessed) {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // Zoom the map to the scale ...
    objZoomInstance.MapController.ZoomToScale(intScaleToZoomTo);

    // When we are to add it to the recently accessed list ...
    if (blnAddToRecentlyAccessed) {

        // Test if the scale is in the predefined list ...
        var blnInPredefinedList = ($.inArray(intScaleToZoomTo, objZoomInstance.PredefinedScales) > -1);

        // When not in the predefined list ...
        if (!blnInPredefinedList) {

            // Test if the scale is already in the list ...
            var blnAlreadyInList = ($.inArray(intScaleToZoomTo, objZoomInstance.RecentlyAccessedScales) > -1);

            // Add it to the list when not already there ...
            if (!blnAlreadyInList) { objZoomInstance.RecentlyAccessedScales.push(intScaleToZoomTo); }
        }
    }

    // Hide the menu instance ...
    objZoomInstance.MenuInstance.Hide();
}

// **************************************************************************
// FUNCTION: ActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.ActivateSubMenu = function ActivateSubMenu(objMenuItem, objSubMenuDiv) {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // Set the sub menu div on the instance ...
    objZoomInstance.SubMenuDiv = objSubMenuDiv;

    // Create the sub menu elements ...
    objZoomInstance.CreateSubMenuElements(objSubMenuDiv);

    // Add it to the sub menu div ...
    objSubMenuDiv.append(objZoomInstance.ContainerDiv);

    // Attach the event handlers ...
    objZoomInstance.AttachEventHandlers();
}

// **************************************************************************
// FUNCTION: DeActivateSubMenu
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.DeActivateSubMenu = function DeActivateSubMenu(objMenuItem, objSubMenuDiv) {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // Remove the div from the container ...
    objZoomInstance.ContainerDiv.remove();

    // Detach the event handlers ...
    objZoomInstance.DetachEventHandlers();
}

// **************************************************************************
// FUNCTION: SubMenuOpened
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.SubMenuOpened = function SubMenuOpened(strSubMenuName) {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // When the zoom menu were opened ...
    if (strSubMenuName == TrimbleMap.Zoom.Shared.MENU_ITEM_NAME) {

        // Focus on the text box ...
        objZoomInstance.GotoScaleTextboxElement.focus();

        // Activate the nice scroll bar on the scales list ...
        objZoomInstance.ScalesDivNiceScroll = objZoomInstance.ScalesDiv.niceScroll({ horizrailenabled: false, cursorwidth: "7px" });
    }
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.AttachEventHandlers = function AttachEventHandlers() {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // Attach the click event handler to the sub menu ...
    objZoomInstance.SubMenuDiv.click(objZoomInstance.SubMenuClickedProxy);

    // Attach the keypress event handler ...
    objZoomInstance.GotoScaleTextboxElement.keypress(objZoomInstance.GotoScaleTextboxElementKeyPressedProxy);
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
TrimbleMap.Zoom.DetachEventHandlers = function DetachEventHandlers() {

    // Get the map zoom instance ...
    var objZoomInstance = this;

    // Attach the click event handler to the sub menu ...
    objZoomInstance.SubMenuDiv.off('click', objZoomInstance.SubMenuClickedProxy);

    // Attach the keypress event handler ...
    objZoomInstance.GotoScaleTextboxElement.off('keypress', objZoomInstance.GotoScaleTextboxElementKeyPressedProxy);

    // De-activate the nice-scrollbar on the scales list ...
    objZoomInstance.ScalesDivNiceScroll.hide();
    objZoomInstance.ScalesDivNiceScroll.remove();
}


export var trimblemap = TrimbleMap;
/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var TrimbleMap = TrimbleMap || {};
TrimbleMap.DefaultModalDialogHandler = {};
TrimbleMap.DefaultModalDialogHandler.Shared = {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.CreateInstance = function CreateInstance() {

    // Create the instance ...
    var objDefaultModalDialogHandler = {
        DialogID: 0,
        OnCloseHandlers: [],

        NextDialogID: TrimbleMap.DefaultModalDialogHandler.NextDialogID,
        OpenDialog: TrimbleMap.DefaultModalDialogHandler.OpenDialog,
        CloseDialog: TrimbleMap.DefaultModalDialogHandler.CloseDialog,
        RepositionDialog: TrimbleMap.DefaultModalDialogHandler.RepositionDialog,
        AddOnClosedHandler: TrimbleMap.DefaultModalDialogHandler.AddOnClosedHandler,
        RemoveOnClosedHandler: TrimbleMap.DefaultModalDialogHandler.RemoveOnClosedHandler
    };

    return objDefaultModalDialogHandler;
}

// **************************************************************************
// FUNCTION: NextDialogID
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.NextDialogID = function NextDialogID() {

    // Get the instance ...
    var objDefaultModalDialogHandler = this;

    // Get the next dialog id ...
    var intNextDialogID = objDefaultModalDialogHandler.DialogID;

    // Increment the dialog id ...
    objDefaultModalDialogHandler.DialogID++;

    // Return the next dialog id ...
    return intNextDialogID;
}

// **************************************************************************
// FUNCTION: OpenDialog
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.OpenDialog = function OpenDialog(objDialogContent, strTitle, blnShowCloseButton, objDialogID) {

    // Get the instance ...
    var objDefaultModalDialogHandler = this;

    // * Background overlay ...

    // Create the background overlay div ...
    var objOverlayDiv = $('<div OverlayDialogID="DefaultDialog_' + objDialogID + '" class="default_modal_dialog_handler_overlay_div"></div>');

    // Set to stretch the entire page width ..
    TrimbleMap.DefaultModalDialogHandler.Shared.ResizeOverlay(objOverlayDiv);

    // Resized the overlay every 250 milliseconds
    $(window).resize(function () {
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function () {
            // Set to stretch the entire page width ..
            TrimbleMap.DefaultModalDialogHandler.Shared.ResizeOverlay(objOverlayDiv);
        }, 250);
    });

    // Add the div to the page ...
    $('body').append(objOverlayDiv);

    // Bring it to the front ...
    SD.DOM.BringToFront(objOverlayDiv);

    // * Dialog ...

    // Create the dialog div ...
    var objDialogDiv = $('<div DialogID="DefaultDialog_' + objDialogID + '" class="default_modal_dialog_handler_dialog_div"></div>');

    // Show the dialog content ...
    objDialogContent.show();

    // When the dialog a title ...
    if ((strTitle != null) && (strTitle != 'undefined') && ((strTitle).trim().length > 0)) {

        // Create the title bar div ...
        var objTitleBarDiv = $('<div class="default_modal_dialog_handler_titlebar_div "></div>');

        // Add the title bar to the dialog div ...
        objDialogDiv.append(objTitleBarDiv);

        // Add a title span ...
        objTitleBarDiv.append($('<span class="default_modal_dialog_handler_title_span">' + strTitle + '</span>'));

        // Create a spacer div ...
        var objSpacerDiv = $('<div class="default_modal_dialog_handler_spacer_div"></div>');

        // Add a spacer div ...
        objDialogDiv.append(objSpacerDiv);
    }

    // Add the content to the dialog ...
    objDialogDiv.append(objDialogContent);

    // Set the positon to be fixed ...
    objDialogDiv.css('position', 'Fixed');

    // Add the div to the page ...
    $('body').append(objDialogDiv);

    // Bring it to the front ...
    SD.DOM.BringToFront(objDialogDiv);

    // When we need a close button ...
    if (blnShowCloseButton) {

        // Create the close icon ...
        var objCloseIcon = $('<div class="default_modal_dialog_handler_close_icon"></div>');

        // Add it to the title bar ... 
        objTitleBarDiv.append(objCloseIcon);

        // Attach an click event hanlder ...
        objCloseIcon.on('click',(function () {

            // Close the dialog ...
            objDefaultModalDialogHandler.CloseDialog(objDialogID);
        }));
    }

    //Position the element in the centre
    TrimbleMap.DefaultModalDialogHandler.Shared.CenterDialog(objDialogDiv);
}

// **************************************************************************
// FUNCTION: CloseDialog
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.CloseDialog = function CloseDialog(objDialogID) {

    // Get the instance ...
    var objDefaultModalDialogHandler = this;

    // Loop through all the on close handlers ...
    $.each(objDefaultModalDialogHandler.OnCloseHandlers, function (intOnClosedHandler, fnOnClosedHandler) {

        // Call the on close handler with the dialog id ...
        fnOnClosedHandler(objDialogID);
    });

    // Get the dialog div based on the ID ...
    var objDialog = TrimbleMap.DefaultModalDialogHandler.Shared.GetDialogDivByID(objDialogID);

    // Find the close icon ...
    var objCloseIcon = objDialog.find('.default_modal_dialog_handler_close_icon');

    // Remove all the event handlers from the close icon ... 
    objCloseIcon.off();

    // Remove the dialog from the dom ...
    objDialog.remove();

    // Get the overlay div ...
    var objOverlayDiv = TrimbleMap.DefaultModalDialogHandler.Shared.GetDialogOverlayDivByID(objDialogID);

    // Remove it from the dom ...
    objOverlayDiv.remove();
}

// **************************************************************************
// FUNCTION: RepositionDialog
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.RepositionDialog = function RepositionDialog(objDialogID) {

    // Get the dialog div based on the ID ...
    var objDialog = TrimbleMap.DefaultModalDialogHandler.Shared.GetDialogDivByID(objDialogID);

    // Center the dialog ...
    TrimbleMap.DefaultModalDialogHandler.Shared.CenterDialog(objDialog);
}

// **************************************************************************
// FUNCTION: AddOnClosedHandler
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.AddOnClosedHandler = function AddOnClosedHandler(fnOnClosedHandler) {

    // Get the instance ...
    var objDefaultModalDialogHandler = this;

    // Add the handler to OnCloseHandlers ...
    objDefaultModalDialogHandler.OnCloseHandlers.push(fnOnClosedHandler);
}

// **************************************************************************
// FUNCTION: RemoveOnClosedHandler
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.RemoveOnClosedHandler = function RemoveOnClosedHandler(fnOnClosedHandler) {

    // Get the instance ...
    var objDefaultModalDialogHandler = this;

    // Find the index of the function in objDefaultModalDialogHandler.OnCloseHandlers ...
    var intIndex = $.inArray(fnOnClosedHandler, objDefaultModalDialogHandler.OnCloseHandlers);

    // When found ..
    if (intIndex > -1) {

        // Remove the handler from OnCloseHandlers ...
        objDefaultModalDialogHandler.OnCloseHandlers.splice(intIndex, 1);
    }
}

// **************************************************************************
// FUNCTION: GetDialogDivByID
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.Shared.GetDialogDivByID = function GetDialogDivByID(objDialogID) {

    // Get the dialog based on the ID ...
    var objDialog = $('[DialogID="DefaultDialog_' + objDialogID + '"]');

    return objDialog;
}

// **************************************************************************
// FUNCTION: GetDialogOverlayDivByID
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.Shared.GetDialogOverlayDivByID = function GetDialogOverlayDivByID(objDialogID) {

    // Get the overlay based on the ID ...
    var objOverlay = $('[OverlayDialogID="DefaultDialog_' + objDialogID + '"]');

    return objOverlay;
}

// **************************************************************************
// FUNCTION: CenterDialog
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.Shared.CenterDialog = function CenterDialog(objDialog) {

    // Center the dialog on in the window ...
    let intBlockStart = (parseInt($(window).height(), 10) / 2) - (parseInt(objDialog.outerHeight(), 10) / 2);
    let intInlineStart = (parseInt($(window).width(), 10) / 2) - (parseInt(objDialog.outerWidth(), 10) / 2);
    objDialog.css('inset-block-start', intBlockStart + 'px');
    objDialog.css('inset-inline-start', intInlineStart + 'px');
}

// **************************************************************************
// FUNCTION: ResizeOverlay
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.Shared.ResizeOverlay = function ResizeOverlay(objOverlayDiv) {

    // Set the size of the ovelay div to fit the window ...
    objOverlayDiv.css('width', $(window).width() + 'px');
    objOverlayDiv.css('height', $(window).height() + 'px');
}

// **************************************************************************
// FUNCTION: SetAsHandler
// USAGE:    
// **************************************************************************
TrimbleMap.DefaultModalDialogHandler.Shared.SetAsHandler = function SetAsHandler() {

    // Create a default modal dialog handler ....
    var objDefaultModalDialogHandler = TrimbleMap.DefaultModalDialogHandler.CreateInstance();

    // Set it as the handler ...
    TrimbleMap.ModalDialog.Shared.SetHandler(objDefaultModalDialogHandler);
}

// Set this hanlder as the modal dialog handler ...
TrimbleMap.DefaultModalDialogHandler.Shared.SetAsHandler();

